// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"kczXu":[function(require,module,exports,__globalThis) {
module.bundle.extendImportMap({
    "2EFLa": "ripe-ncc.ca2133a1.svg"
});

},{}],"joCWR":[function(require,module,exports,__globalThis) {
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("react-dom/client");
var _app = require("./App");
function main() {
    const container = document.getElementById("app");
    const root = (0, _client.createRoot)(container);
    root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _app.App), {}));
}
function bootstrap(main) {
    if (document.readyState === "loading") {
        const done = ()=>{
            document.removeEventListener("DOMContentLoaded", done);
            main();
        };
        document.addEventListener("DOMContentLoaded", done);
    } else setTimeout(main);
}
bootstrap(main);

},{"react/jsx-runtime":"85GGX","react-dom/client":"hCIxW","./App":"fh3rg"}],"85GGX":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("75e31b526e250c6f");

},{"75e31b526e250c6f":"foR6h"}],"foR6h":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.jsx = jsxProd;
exports.jsxs = jsxProd;

},{}],"hCIxW":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9e932721f217f9f6");

},{"9e932721f217f9f6":"98PMf"}],"98PMf":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var Scheduler = require("934b50a50c275743"), React = require("56d30b16d84cc622"), ReactDOM = require("d42dbe4aacaa6df4");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function assertIsMounted(fiber) {
    if (getNearestMountedFiber(fiber) !== fiber) throw Error(formatProdErrorMessage(188));
}
function findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = getNearestMountedFiber(fiber);
        if (null === alternate) throw Error(formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return assertIsMounted(parentA), fiber;
                if (parentB === b) return assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error(formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error(formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error(formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error(formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error(formatProdErrorMessage(559));
    }
}
var searchTarget = null, searchBoundary = null;
function isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? (searchTarget = child, !0) : !1;
}
function isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? (searchBoundary = child, !1) : child === target ? (null !== searchBoundary && (searchTarget = child), !0) : !1;
}
function getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var assign = Object.assign, REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case REACT_FRAGMENT_TYPE:
            return "Fragment";
        case REACT_PROFILER_TYPE:
            return "Profiler";
        case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case REACT_SUSPENSE_TYPE:
            return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case REACT_ACTIVITY_TYPE:
            return "Activity";
        case REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case REACT_PORTAL_TYPE:
            return "Portal";
        case REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
        case REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var isArrayImpl = Array.isArray, ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, valueStack = [], index = -1;
function createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function pop(cursor) {
    0 > index || (cursor.current = valueStack[index], valueStack[index] = null, index--);
}
function push(cursor, value) {
    index++;
    valueStack[index] = cursor.current;
    cursor.current = value;
}
var contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null);
function pushHostContainer(fiber, nextRootInstance) {
    push(rootInstanceStackCursor, nextRootInstance);
    push(contextFiberStackCursor, fiber);
    push(contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = getOwnHostContext(nextRootInstance), fiber = getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    pop(contextStackCursor);
    push(contextStackCursor, fiber);
}
function popHostContainer() {
    pop(contextStackCursor);
    pop(contextFiberStackCursor);
    pop(rootInstanceStackCursor);
}
function pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && (HostTransitionContext._currentValue = stateHook.memoizedState, push(hostTransitionProviderCursor, fiber));
    stateHook = contextStackCursor.current;
    var JSCompiler_inline_result = getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && (push(contextFiberStackCursor, fiber), push(contextStackCursor, JSCompiler_inline_result));
}
function popHostContext(fiber) {
    contextFiberStackCursor.current === fiber && (pop(contextStackCursor), pop(contextFiberStackCursor));
    hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor), HostTransitionContext._currentValue = sharedNotPendingObject);
}
var prefix, suffix;
function describeBuiltInComponentFrame(name) {
    if (void 0 === prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || "";
        suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + prefix + name + suffix;
}
var reentry = !1;
function describeNativeComponentFrame(fn, construct) {
    if (!fn || reentry) return "";
    reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return describeBuiltInComponentFrame(fiber.type);
        case 16:
            return describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? describeBuiltInComponentFrame("Suspense Fallback") : describeBuiltInComponentFrame("Suspense");
        case 19:
            return describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return describeBuiltInComponentFrame("Activity");
        case 30:
            return describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var hasOwnProperty = Object.prototype.hasOwnProperty, scheduleCallback$3 = Scheduler.unstable_scheduleCallback, cancelCallback$1 = Scheduler.unstable_cancelCallback, shouldYield = Scheduler.unstable_shouldYield, requestPaint = Scheduler.unstable_requestPaint, now = Scheduler.unstable_now, getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, ImmediatePriority = Scheduler.unstable_ImmediatePriority, UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler.unstable_NormalPriority, LowPriority = Scheduler.unstable_LowPriority, IdlePriority = Scheduler.unstable_IdlePriority, log$1 = Scheduler.log, unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue, rendererID = null, injectedHook = null;
function setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof log$1 && unstable_setDisableYieldValue(newIsStrictMode);
    if (injectedHook && "function" === typeof injectedHook.setStrictMode) try {
        injectedHook.setStrictMode(rendererID, newIsStrictMode);
    } catch (err) {}
}
var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log = Math.log, LN2 = Math.LN2;
function clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - (log(x) / LN2 | 0) | 0;
}
var nextTransitionUpdateLane = 256, nextTransitionDeferredLane = 262144, nextRetryLane = 4194304;
function getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function claimNextRetryLane() {
    var lane = nextRetryLane;
    nextRetryLane <<= 1;
    0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
    return lane;
}
function createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function resolveUpdatePriority() {
    var updatePriority = ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : getEventPriority(updatePriority.type);
}
function runWithPriority(priority, fn) {
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        return ReactDOMSharedInternals.p = priority, fn();
    } finally{
        ReactDOMSharedInternals.p = previousPriority;
    }
}
var randomKey = Math.random().toString(36).slice(2), internalInstanceKey = "__reactFiber$" + randomKey, internalPropsKey = "__reactProps$" + randomKey, internalContainerInstanceKey = "__reactContainer$" + randomKey, internalEventHandlersKey = "__reactEvents$" + randomKey, internalEventHandlerListenersKey = "__reactListeners$" + randomKey, internalEventHandlesSetKey = "__reactHandles$" + randomKey, internalRootNodeResourcesKey = "__reactResources$" + randomKey, internalHoistableMarker = "__reactMarker$" + randomKey, internalLoadPendingKey = "__reactLoad$" + randomKey;
function detachDeletedInstance(node) {
    delete node[internalInstanceKey];
    delete node[internalPropsKey];
    delete node[internalEventHandlerListenersKey];
    delete node[internalEventHandlesSetKey];
}
function getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[internalInstanceKey]) return parentNode;
                targetNode = getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function getInstanceFromNode(node) {
    if (node = node[internalInstanceKey] || node[internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error(formatProdErrorMessage(33));
}
function getResourcesFromRoot(root) {
    var resources = root[internalRootNodeResourcesKey];
    resources || (resources = root[internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function markNodeAsHoistable(node) {
    node[internalHoistableMarker] = !0;
}
function clearPendingLoadOnNode(node) {
    node[internalLoadPendingKey] = void 0;
}
var allNativeEvents = new Set(), registrationNameDependencies = {};
function registerTwoPhaseEvent(registrationName, dependencies) {
    registerDirectEvent(registrationName, dependencies);
    registerDirectEvent(registrationName + "Capture", dependencies);
}
function registerDirectEvent(registrationName, dependencies) {
    registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)allNativeEvents.add(dependencies[registrationName]);
}
var VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), illegalAttributeNameCache = {}, validatedAttributeNameCache = {};
function isAttributeNameSafe(attributeName) {
    if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return !0;
    if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return !1;
    if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return validatedAttributeNameCache[attributeName] = !0;
    illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var viewTransitionMutationContext = !1;
function pushMutationContext() {
    var prev = viewTransitionMutationContext;
    viewTransitionMutationContext = !1;
    return prev;
}
function setValueForAttribute(node, name, value) {
    if (isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function track(node) {
    if (!node._valueTracker) {
        var valueField = isCheckable(node) ? "checked" : "value";
        node._valueTracker = trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace(escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + getToStringValue(value);
        } else element.value !== "" + getToStringValue(value) && (element.value = "" + getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? setDefaultValue(element, getToStringValue(element.value)) : setDefaultValue(element, getToStringValue(value)) : null != defaultValue ? setDefaultValue(element, getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + getToStringValue(name) : element.removeAttribute("name");
}
function initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
        value = null != value ? "" + getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    track(element);
}
function setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
}
function initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error(formatProdErrorMessage(92));
            if (isArrayImpl(children)) {
                if (1 < children.length) throw Error(formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    track(element);
}
function setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error(formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && (setValueForStyle(node, styleName$16, styleName), viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function sanitizeURL(url) {
    return isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function noop$1() {}
var currentReplayingEvent = null;
function getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var restoreTarget = null, restoreQueue = null;
function restoreStateOfTarget(target) {
    var internalInstance = getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[internalPropsKey] || null;
                            if (!otherProps) throw Error(formatProdErrorMessage(90));
                            updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var isInsideEventHandler = !1;
function batchedUpdates$1(fn, a, b) {
    if (isInsideEventHandler) return fn(a, b);
    isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if (isInsideEventHandler = !1, null !== restoreTarget || null !== restoreQueue) {
            if (flushSyncWork$1(), restoreTarget && (a = restoreTarget, fn = restoreQueue, restoreQueue = restoreTarget = null, restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)restoreStateOfTarget(fn[a]);
        }
    }
}
function getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error(formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), passiveBrowserEventsSupported = !1;
if (canUseDOM) try {
    var options = {};
    Object.defineProperty(options, "passive", {
        get: function() {
            passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, options);
} catch (e) {
    passiveBrowserEventsSupported = !1;
}
var root = null, startText = null, fallbackText = null;
function getData() {
    if (fallbackText) return fallbackText;
    var start, startValue = startText, startLength = startValue.length, end, endValue = "value" in root ? root.value : root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function functionThatReturnsTrue() {
    return !0;
}
function functionThatReturnsFalse() {
    return !1;
}
function createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? functionThatReturnsTrue : functionThatReturnsFalse;
        this.isPropagationStopped = functionThatReturnsFalse;
        return this;
    }
    assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, SyntheticEvent = createSyntheticEvent(EventInterface), UIEventInterface = assign({}, EventInterface, {
    view: 0,
    detail: 0
}), SyntheticUIEvent = createSyntheticEvent(UIEventInterface), lastMovementX, lastMovementY, lastMouseEvent, MouseEventInterface = assign({}, UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== lastMouseEvent && (lastMouseEvent && "mousemove" === event.type ? (lastMovementX = event.screenX - lastMouseEvent.screenX, lastMovementY = event.screenY - lastMouseEvent.screenY) : lastMovementY = lastMovementX = 0, lastMouseEvent = event);
        return lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : lastMovementY;
    }
}), SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface), DragEventInterface = assign({}, MouseEventInterface, {
    dataTransfer: 0
}), SyntheticDragEvent = createSyntheticEvent(DragEventInterface), FocusEventInterface = assign({}, UIEventInterface, {
    relatedTarget: 0
}), SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface), AnimationEventInterface = assign({}, EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface), ClipboardEventInterface = assign({}, EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface), CompositionEventInterface = assign({}, EventInterface, {
    data: 0
}), SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface), normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function getEventModifierState() {
    return modifierStateGetter;
}
var KeyboardEventInterface = assign({}, UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface), PointerEventInterface = assign({}, MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface), SubmitEventInterface = assign({}, EventInterface, {
    submitter: 0
}), SyntheticSubmitEvent = createSyntheticEvent(SubmitEventInterface), TouchEventInterface = assign({}, UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: getEventModifierState
}), SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface), TransitionEventInterface = assign({}, EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface), WheelEventInterface = assign({}, MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface), ToggleEventInterface = assign({}, EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface), END_KEYCODES = [
    9,
    13,
    27,
    32
], canUseCompositionEvent = canUseDOM && "CompositionEvent" in window, documentMode = null;
canUseDOM && "documentMode" in document && (documentMode = document.documentMode);
var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode, useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && 8 < documentMode && 11 >= documentMode), SPACEBAR_CHAR = String.fromCharCode(32), hasSpaceKeypress = !1;
function isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var isComposing = !1;
function getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            hasSpaceKeypress = !0;
            return SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if (isComposing) return "compositionend" === domEventName || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = getData(), fallbackText = startText = root = null, isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    restoreTarget ? restoreQueue ? restoreQueue.push(target) : restoreQueue = [
        target
    ] : restoreTarget = target;
    inst = accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var activeElement$1 = null, activeElementInst$1 = null;
function runEventInBatch(dispatchQueue) {
    processDispatchQueue(dispatchQueue, 0);
}
function getInstIfValueChanged(targetInst) {
    var targetNode = getNodeFromInstance(targetInst);
    if (updateValueIfChanged(targetNode)) return targetInst;
}
function getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var isInputEventSupported = !1;
if (canUseDOM) {
    var JSCompiler_inline_result$jscomp$318;
    if (canUseDOM) {
        var isSupported$jscomp$inline_474 = "oninput" in document;
        if (!isSupported$jscomp$inline_474) {
            var element$jscomp$inline_475 = document.createElement("div");
            element$jscomp$inline_475.setAttribute("oninput", "return;");
            isSupported$jscomp$inline_474 = "function" === typeof element$jscomp$inline_475.oninput;
        }
        JSCompiler_inline_result$jscomp$318 = isSupported$jscomp$inline_474;
    } else JSCompiler_inline_result$jscomp$318 = !1;
    isInputEventSupported = JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function stopWatchingForValueChange() {
    activeElement$1 && (activeElement$1.detachEvent("onpropertychange", handlePropertyChange), activeElementInst$1 = activeElement$1 = null);
}
function handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && getInstIfValueChanged(activeElementInst$1)) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst$1, nativeEvent, getEventTarget(nativeEvent));
        batchedUpdates$1(runEventInBatch, dispatchQueue);
    }
}
function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? (stopWatchingForValueChange(), activeElement$1 = target, activeElementInst$1 = targetInst, activeElement$1.attachEvent("onpropertychange", handlePropertyChange)) : "focusout" === domEventName && stopWatchingForValueChange();
}
function getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return getInstIfValueChanged(activeElementInst$1);
}
function getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return getInstIfValueChanged(targetInst);
}
function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return getInstIfValueChanged(targetInst);
}
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is;
function shallowEqual(objA, objB) {
    if (objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function getNodeForCharacterOffset(root, offset) {
    var node = getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = getLeafNode(node);
    }
}
function containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = getActiveElement(containerInfo.document);
    }
    return element;
}
function hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && 11 >= document.documentMode, activeElement = null, activeElementInst = null, lastSelection = null, mouseDown = !1;
function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    mouseDown || null == activeElement || activeElement !== getActiveElement(doc) || (doc = activeElement, "selectionStart" in doc && hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), lastSelection && shallowEqual(lastSelection, doc) || (lastSelection = doc, doc = accumulateTwoPhaseListeners(activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = activeElement)));
}
function makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var vendorPrefixes = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: makePrefixMap("Animation", "AnimationIteration"),
    animationstart: makePrefixMap("Animation", "AnimationStart"),
    transitionrun: makePrefixMap("Transition", "TransitionRun"),
    transitionstart: makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: makePrefixMap("Transition", "TransitionCancel"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
}, prefixedEventNames = {}, style = {};
canUseDOM && (style = document.createElement("div").style, "AnimationEvent" in window || (delete vendorPrefixes.animationend.animation, delete vendorPrefixes.animationiteration.animation, delete vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete vendorPrefixes.transitionend.transition);
function getVendorPrefixedEventName(eventName) {
    if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
    if (!vendorPrefixes[eventName]) return eventName;
    var prefixMap = vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var ANIMATION_END = getVendorPrefixedEventName("animationend"), ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration"), ANIMATION_START = getVendorPrefixedEventName("animationstart"), TRANSITION_RUN = getVendorPrefixedEventName("transitionrun"), TRANSITION_START = getVendorPrefixedEventName("transitionstart"), TRANSITION_CANCEL = getVendorPrefixedEventName("transitioncancel"), TRANSITION_END = getVendorPrefixedEventName("transitionend"), topLevelEventsToReactNames = new Map(), simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
simpleEventPluginEvents.push("scrollEnd");
function registerSimpleEvent(domEventName, reactName) {
    topLevelEventsToReactNames.set(domEventName, reactName);
    registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var globalClientIdCounter$1 = 0;
function getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = pendingEffectsRoot.identifierPrefix;
    var globalClientId = globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = getClassNameByType(defaultClass);
    eventClass = getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0;
function finishQueueingConcurrentUpdates() {
    for(var endIndex = concurrentQueuesIndex, i = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var queue = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var update = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var lane = concurrentQueues[i];
        concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function enqueueUpdate$1(fiber, queue, update, lane) {
    concurrentQueues[concurrentQueuesIndex++] = fiber;
    concurrentQueues[concurrentQueuesIndex++] = queue;
    concurrentQueues[concurrentQueuesIndex++] = update;
    concurrentQueues[concurrentQueuesIndex++] = lane;
    concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    enqueueUpdate$1(fiber, queue, update, lane);
    return getRootForUpdatedFiber(fiber);
}
function enqueueConcurrentRenderForLane(fiber, lane) {
    enqueueUpdate$1(fiber, null, null, lane);
    return getRootForUpdatedFiber(fiber);
}
function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function getRootForUpdatedFiber(sourceFiber) {
    if (50 < nestedUpdateCount) throw nestedUpdateCount = 0, rootWithNestedUpdates = null, Error(formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var emptyContextObject = {};
function FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function createFiberImplClass(tag, pendingProps, key, mode) {
    return new FiberNode(tag, pendingProps, key, mode);
}
function shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = isHostHoistableType(type, pendingProps, contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case REACT_ACTIVITY_TYPE:
            return type = createFiberImplClass(31, pendingProps, key, mode), type.elementType = REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case REACT_FRAGMENT_TYPE:
            return createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case REACT_PROFILER_TYPE:
            return type = createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_TYPE:
            return type = createFiberImplClass(13, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_LIST_TYPE:
            return type = createFiberImplClass(19, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case REACT_LEGACY_HIDDEN_TYPE:
        case REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = createFiberImplClass(30, pendingProps, key, type), type.elementType = REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error(formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function createFiberFromFragment(elements, mode, lanes, key) {
    elements = createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function createFiberFromText(content, mode, lanes) {
    content = createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function createFiberFromPortal(portal, mode, lanes) {
    mode = createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var CapturedStacks = new WeakMap();
function createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
        CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: getStackByFiberInDevAndProd(source)
    };
}
var forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "";
function pushTreeFork(workInProgress, totalChildren) {
    forkStack[forkStackIndex++] = treeForkCount;
    forkStack[forkStackIndex++] = treeForkProvider;
    treeForkProvider = workInProgress;
    treeForkCount = totalChildren;
}
function pushTreeId(workInProgress, totalChildren, index) {
    idStack[idStackIndex++] = treeContextId;
    idStack[idStackIndex++] = treeContextOverflow;
    idStack[idStackIndex++] = treeContextProvider;
    treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = treeContextId;
    workInProgress = treeContextOverflow;
    var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        treeContextOverflow = length + workInProgress;
    } else treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress;
}
function pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && (pushTreeFork(workInProgress, 1), pushTreeId(workInProgress, 1, 0));
}
function popTreeContext(workInProgress) {
    for(; workInProgress === treeForkProvider;)treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
    for(; workInProgress === treeContextProvider;)treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
}
function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    idStack[idStackIndex++] = treeContextId;
    idStack[idStackIndex++] = treeContextOverflow;
    idStack[idStackIndex++] = treeContextProvider;
    treeContextId = suspendedContext.id;
    treeContextOverflow = suspendedContext.overflow;
    treeContextProvider = workInProgress;
}
var hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = !1, hydrationErrors = null, rootOrSingletonContext = !1, HydrationMismatchException = Error(formatProdErrorMessage(519));
function throwOnHydrationMismatch(fiber) {
    var error = Error(formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    queueHydrationError(createCapturedValueAtFiber(error, fiber));
    throw HydrationMismatchException;
}
function prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[internalInstanceKey] = fiber;
    instance[internalPropsKey] = props;
    switch(type){
        case "dialog":
            listenToNonDelegatedEvent("cancel", instance);
            listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < mediaEventTypes.length; type++)listenToNonDelegatedEvent(mediaEventTypes[type], instance);
            break;
        case "source":
            listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            listenToNonDelegatedEvent("error", instance);
            listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            listenToNonDelegatedEvent("invalid", instance);
            initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            listenToNonDelegatedEvent("invalid", instance), initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && (listenToNonDelegatedEvent("beforetoggle", instance), listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = noop$1), instance = !0) : instance = !1;
    instance || throwOnHydrationMismatch(fiber, !0);
}
function popToNextHostParent(fiber) {
    for(hydrationParentFiber = fiber.return; hydrationParentFiber;)switch(hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            rootOrSingletonContext = !0;
            return;
        default:
            hydrationParentFiber = hydrationParentFiber.return;
    }
}
function popHydrationState(fiber) {
    if (fiber !== hydrationParentFiber) return !1;
    if (!isHydrating) return popToNextHostParent(fiber), isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && nextHydratableInstance && throwOnHydrationMismatch(fiber);
    popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error(formatProdErrorMessage(317));
        nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error(formatProdErrorMessage(317));
        nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = nextHydratableInstance, isSingletonScope(fiber.type) ? (fiber = previousHydratableOnEnteringScopedSingleton, previousHydratableOnEnteringScopedSingleton = null, nextHydratableInstance = fiber) : nextHydratableInstance = tag) : nextHydratableInstance = hydrationParentFiber ? getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function resetHydrationState() {
    nextHydratableInstance = hydrationParentFiber = null;
    isHydrating = !1;
}
function upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = hydrationErrors;
    null !== queuedErrors && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = queuedErrors : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, queuedErrors), hydrationErrors = null);
    return queuedErrors;
}
function queueHydrationError(error) {
    null === hydrationErrors ? hydrationErrors = [
        error
    ] : hydrationErrors.push(error);
}
var valueCursor = createCursor(null), currentlyRenderingFiber$1 = null, lastContextDependency = null;
function pushProvider(providerFiber, context, nextValue) {
    push(valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function popProvider(context) {
    context._currentValue = valueCursor.current;
    pop(valueCursor);
}
function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error(formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error(formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error(formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push(HostTransitionContext) : current = [
                HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function prepareToReadContext(workInProgress) {
    currentlyRenderingFiber$1 = workInProgress;
    lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function readContext(context) {
    return readContextForConsumer(currentlyRenderingFiber$1, context);
}
function readContextDuringReconciliation(consumer, context) {
    null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
    return readContextForConsumer(consumer, context);
}
function readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === lastContextDependency) {
        if (null === consumer) throw Error(formatProdErrorMessage(308));
        lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else lastContextDependency = lastContextDependency.next = context;
    return value;
}
var AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, scheduleCallback$2 = Scheduler.unstable_scheduleCallback, NormalPriority = Scheduler.unstable_NormalPriority, CacheContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function createCache() {
    return {
        controller: new AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && scheduleCallback$2(NormalPriority, function() {
        cache.controller.abort();
    });
}
function queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var entangledTransitionTypes = null;
function claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null;
function entangleAsyncAction(transition, thenable) {
    if (null === currentEntangledListeners) {
        var entangledListeners = currentEntangledListeners = [];
        currentEntangledPendingCount = 0;
        currentEntangledLane = requestTransitionLane();
        currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    currentEntangledPendingCount++;
    thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
    return thenable;
}
function pingEngtangledActionScope() {
    if (0 === --currentEntangledPendingCount && (entangledTransitionTypes = null, null !== currentEntangledListeners)) {
        null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
        var listeners = currentEntangledListeners;
        currentEntangledListeners = null;
        currentEntangledLane = 0;
        currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var prevOnStartTransitionFinish = ReactSharedInternals.S;
ReactSharedInternals.S = function(transition, returnValue) {
    globalMostRecentTransitionTime = now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && entangleAsyncAction(transition, returnValue);
    if (null !== entangledTransitionTypes) for(var root$28 = firstScheduledRoot; null !== root$28;)queueTransitionTypes(root$28, entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = firstScheduledRoot; null !== root$29;)queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== currentEntangledLane) {
            root$29 = entangledTransitionTypes;
            null === root$29 && (root$29 = entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
};
var resumedCache = createCursor(null);
function peekCacheFromPool() {
    var cacheResumedFromPreviousRender = resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
}
function pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? push(resumedCache, resumedCache.current) : push(resumedCache, prevCachePool.pool);
}
function getSuspendedCache() {
    var cacheFromPool = peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var SuspenseException = Error(formatProdErrorMessage(460)), SuspenseyCommitException = Error(formatProdErrorMessage(474)), SuspenseActionException = Error(formatProdErrorMessage(542)), noopSuspenseyCommitThenable = {
    then: function() {}
};
function isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then(noop$1, noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error(formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then(noop$1, noop$1);
            else {
                thenableState = workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error(formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            suspendedThenable = thenable;
            throw SuspenseException;
    }
}
function resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw suspendedThenable = x, SuspenseException;
        throw x;
    }
}
var suspendedThenable = null;
function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error(formatProdErrorMessage(459));
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
}
function checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === SuspenseException || rejectedReason === SuspenseActionException) throw Error(formatProdErrorMessage(483));
}
var thenableState$1 = null, thenableIndexCounter$1 = 0;
function unwrapThenable(thenable) {
    var index = thenableIndexCounter$1;
    thenableIndexCounter$1 += 1;
    null === thenableState$1 && (thenableState$1 = []);
    return trackUsedThenable(thenableState$1, thenable, index);
}
function coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE) throw Error(formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error(formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), coerceRef(current, element), current.return = returnFiber, current;
        current = createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case REACT_PORTAL_TYPE:
                    return newChild = createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case REACT_LAZY_TYPE:
                    return newChild = resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return newChild = createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return createChild(returnFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case REACT_LAZY_TYPE:
                    return newChild = resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case REACT_LAZY_TYPE:
                    return newChild = resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error(formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === REACT_FRAGMENT_TYPE ? (lanes = createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case REACT_LAZY_TYPE:
                    return newChild = resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if (isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if (getIteratorFn(newChild)) {
                key = getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error(formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === SuspenseException || x === SuspenseActionException) throw x;
            var fiber = createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var reconcileChildFibers = createChildReconciler(!0), mountChildFibers = createChildReconciler(!1), hasForceUpdate = !1;
function initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== (executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = getRootForUpdatedFiber(fiber);
        markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    enqueueUpdate$1(fiber, updateQueue, update, lane);
    return getRootForUpdatedFiber(fiber);
}
function entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        markRootEntangled(root, lane);
    }
}
function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var didReadFromEntangledAsyncAction = !1;
function suspendIfUpdateReadFromEntangledAsyncAction() {
    if (didReadFromEntangledAsyncAction) {
        var entangledActionThenable = currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = assign({}, newState, updateLane);
                            break a;
                        case 2:
                            hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error(formatProdErrorMessage(191, callback));
    callback.call(context);
}
function commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)callCallback(callbacks[updateQueue], context);
}
var currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0);
function pushHiddenContext(fiber, context) {
    fiber = entangledRenderLanes;
    push(prevEntangledRenderLanesCursor, fiber);
    push(currentTreeHiddenStackCursor, context);
    entangledRenderLanes = fiber | context.baseLanes;
}
function reuseHiddenContextOnStack() {
    push(prevEntangledRenderLanesCursor, entangledRenderLanes);
    push(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current);
}
function popHiddenContext() {
    entangledRenderLanes = prevEntangledRenderLanesCursor.current;
    pop(currentTreeHiddenStackCursor);
    pop(prevEntangledRenderLanesCursor);
}
var suspenseHandlerStackCursor = createCursor(null), shellBoundary = null;
function pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    push(suspenseStackCursor, suspenseStackCursor.current & 1);
    push(suspenseHandlerStackCursor, handler);
    null === shellBoundary && (null === current || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current.memoizedState && (shellBoundary = handler));
}
function pushDehydratedActivitySuspenseHandler(fiber) {
    push(suspenseStackCursor, suspenseStackCursor.current);
    push(suspenseHandlerStackCursor, fiber);
    null === shellBoundary && (shellBoundary = fiber);
}
function pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? (push(suspenseStackCursor, suspenseStackCursor.current), push(suspenseHandlerStackCursor, fiber), null === shellBoundary && (shellBoundary = fiber)) : reuseSuspenseHandlerOnStack();
}
function reuseSuspenseHandlerOnStack() {
    push(suspenseStackCursor, suspenseStackCursor.current);
    push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current);
}
function popSuspenseHandler(fiber) {
    pop(suspenseHandlerStackCursor);
    shellBoundary === fiber && (shellBoundary = null);
    pop(suspenseStackCursor);
}
var suspenseStackCursor = createCursor(0);
function pushSuspenseListContext(fiber, newContext) {
    push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current);
    push(suspenseStackCursor, newContext);
}
function popSuspenseListContext(fiber) {
    pop(suspenseStackCursor);
    pop(suspenseHandlerStackCursor);
    shellBoundary === fiber && (shellBoundary = null);
}
function findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || isSuspenseInstancePending(state) || isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var renderLanes = 0, currentlyRenderingFiber = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = !1, didScheduleRenderPhaseUpdateDuringThisPass = !1, shouldDoubleInvokeUserFnsInHooksDEV = !1, localIdCounter = 0, thenableIndexCounter = 0, thenableState = null, globalClientIdCounter = 0;
function throwInvalidHookError() {
    throw Error(formatProdErrorMessage(321));
}
function areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    renderLanes = nextRenderLanes;
    currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    ReactSharedInternals.H = null === current || null === current.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate;
    shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    shouldDoubleInvokeUserFnsInHooksDEV = !1;
    didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = renderWithHooksAgain(workInProgress, Component, props, secondArg));
    finishRenderingHooks(current);
    return nextRenderLanes;
}
function finishRenderingHooks(current) {
    ReactSharedInternals.H = ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdate = !1;
    thenableIndexCounter = 0;
    thenableState = null;
    if (didRenderTooFewHooks) throw Error(formatProdErrorMessage(300));
    null === current || didReceiveUpdate || (current = current.dependencies, null !== current && checkIfContextChanged(current) && (didReceiveUpdate = !0));
}
function renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        didScheduleRenderPhaseUpdateDuringThisPass && (thenableState = null);
        thenableIndexCounter = 0;
        didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error(formatProdErrorMessage(301));
        numberOfReRenders += 1;
        workInProgressHook = currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        ReactSharedInternals.H = HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while (didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function TransitionAwareHostComponent() {
    var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== localIdCounter;
    localIdCounter = 0;
    return didRenderIdHook;
}
function bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function resetHooksOnUnwind(workInProgress) {
    if (didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        didScheduleRenderPhaseUpdate = !1;
    }
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdateDuringThisPass = !1;
    thenableIndexCounter = localIdCounter = 0;
    thenableState = null;
}
function mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
    return workInProgressHook;
}
function updateWorkInProgressHook() {
    if (null === currentHook) {
        var nextCurrentHook = currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = currentHook.next;
    var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber.memoizedState : workInProgressHook.next;
    if (null !== nextWorkInProgressHook) workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === currentlyRenderingFiber.alternate) throw Error(formatProdErrorMessage(467));
            throw Error(formatProdErrorMessage(310));
        }
        currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: currentHook.memoizedState,
            baseState: currentHook.baseState,
            baseQueue: currentHook.baseQueue,
            queue: currentHook.queue,
            next: null
        };
        null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
    }
    return workInProgressHook;
}
function createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function useThenable(thenable) {
    var index = thenableIndexCounter;
    thenableIndexCounter += 1;
    null === thenableState && (thenableState = []);
    thenable = trackUsedThenable(thenableState, thenable, index);
    index = currentlyRenderingFiber;
    null === (null === workInProgressHook ? index.memoizedState : workInProgressHook.next) && (index = index.alternate, ReactSharedInternals.H = null === index || null === index.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate);
    return thenable;
}
function use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return useThenable(usable);
        if (usable.$$typeof === REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
    }
    throw Error(formatProdErrorMessage(438, String(usable)));
}
function useMemoCache(size) {
    var memoCache = null, updateQueue = currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function updateReducer(reducer) {
    var hook = updateWorkInProgressHook();
    return updateReducerImpl(hook, currentHook, reducer);
}
function updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if ((renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function rerenderReducer(reducer) {
    var hook = updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        objectIs(newState, hook.memoizedState) || (didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = currentlyRenderingFiber, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !objectIs((currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, didReceiveUpdate = !0);
    hook = hook.queue;
    updateEffect(subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== workInProgressHook && 0 !== (workInProgressHook.memoizedState.tag & 1);
    pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== (renderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
}
function subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    });
}
function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function forceStoreRerender(fiber) {
    var root = enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && scheduleUpdateOnFiber(root, fiber, 2);
}
function mountStateImpl(initialState) {
    var hook = mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return updateReducerImpl(hook, currentHook, "function" === typeof reducer ? reducer : basicStateReducer);
}
function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if (isRenderPhaseUpdate(fiber)) throw Error(formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        onActionError(actionQueue, node, error$70);
    }
}
function handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return onActionError(actionQueue, node, error);
    }) : onActionSuccess(actionQueue, node, returnValue);
}
function onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
}
function onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function actionStateReducer(oldState, newState) {
    return newState;
}
function mountActionState(action, initialStateProp) {
    if (isHydrating) {
        var ssrFormState = workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = currentlyRenderingFiber;
                if (isHydrating) {
                    if (nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = nextHydratableInstance;
                            for(var inRootOrSingleton = rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            nextHydratableInstance = getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = dispatchSetState.bind(null, currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = mountStateImpl(!1);
    inRootOrSingleton = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = dispatchActionState.bind(null, currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function updateActionState(action) {
    var stateHook = updateWorkInProgressHook();
    return updateActionStateImpl(stateHook, currentHook, action);
}
function updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = updateReducerImpl(stateHook, currentStateHook, actionStateReducer)[0];
    stateHook = updateReducer(basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = useThenable(currentStateHook);
    } catch (x) {
        if (x === SuspenseException) throw SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && (currentlyRenderingFiber.flags |= 2048, pushSimpleEffect(9, {
        destroy: void 0
    }, actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function rerenderActionState(action) {
    var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
    if (null !== currentStateHook) return updateActionStateImpl(stateHook, currentStateHook, action);
    updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = currentlyRenderingFiber.updateQueue;
    null === inst && (inst = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function updateRef() {
    return updateWorkInProgressHook().memoizedState;
}
function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = mountWorkInProgressHook();
    currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushSimpleEffect(hookFlags, inst, create, deps) : (currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function mountEffect(create, deps) {
    mountEffectImpl(8390656, 8, create, deps);
}
function updateEffect(create, deps) {
    updateEffectImpl(2048, 8, create, deps);
}
function useEffectEventImpl(payload) {
    currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function updateEvent(callback) {
    var ref = updateWorkInProgressHook().memoizedState;
    useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== (executionContext & 2)) throw Error(formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function updateInsertionEffect(create, deps) {
    return updateEffectImpl(4, 2, create, deps);
}
function updateLayoutEffect(create, deps) {
    return updateEffectImpl(4, 4, create, deps);
}
function imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    updateEffectImpl(4, 4, imperativeHandleEffect.bind(null, create, ref), deps);
}
function mountDebugValue() {}
function updateCallback(callback, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function updateMemo(nextCreate, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if (objectIs(value, prevValue)) return value;
    if (null !== currentTreeHiddenStackCursor.current) return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = !0), hook;
    if (0 === (renderLanes & 106) || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930)) return didReceiveUpdate = !0, hook.memoizedState = value;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = ReactDOMSharedInternals.p;
    ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    ReactSharedInternals.T = currentTransition;
    dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = chainThenableValue(returnValue, finishedState);
            dispatchSetStateInternal(fiber, queue, thenableForFinishedState, requestUpdateLane(fiber));
        } else dispatchSetStateInternal(fiber, queue, finishedState, requestUpdateLane(fiber));
    } catch (error) {
        dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, requestUpdateLane());
    } finally{
        ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
    }
}
function noop() {}
function startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error(formatProdErrorMessage(476));
    var queue = ensureFormComponentIsStateful(formFiber).queue;
    startTransition(formFiber, queue, pendingState, sharedNotPendingObject, null === action ? noop : function() {
        requestFormReset$1(formFiber);
        return action(formData);
    });
}
function ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: sharedNotPendingObject,
        baseState: sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function requestFormReset$1(formFiber) {
    var stateHook = ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, requestUpdateLane());
}
function useHostTransitionStatus() {
    return readContext(HostTransitionContext);
}
function updateId() {
    return updateWorkInProgressHook().memoizedState;
}
function updateRefresh() {
    return updateWorkInProgressHook().memoizedState;
}
function refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = requestUpdateLane();
                fiber = createUpdate(lane);
                var root$73 = enqueueUpdate(provider, fiber, lane);
                null !== root$73 && (scheduleUpdateOnFiber(root$73, provider, lane), entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function dispatchReducerAction(fiber, queue, action) {
    var lane = requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue, action) : (action = enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && (scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane)));
}
function dispatchSetState(fiber, queue, action) {
    var lane = requestUpdateLane();
    dispatchSetStateInternal(fiber, queue, action, lane);
}
function dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if (objectIs(eagerState, currentState)) return enqueueUpdate$1(fiber, queue, update, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error(formatProdErrorMessage(479));
    } else throwIfDuringRender = enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === currentlyRenderingFiber || null !== alternate && alternate === currentlyRenderingFiber;
}
function enqueueRenderPhaseUpdate(queue, update) {
    didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        markRootEntangled(root, lane);
    }
}
var ContextOnlyDispatcher = {
    readContext: readContext,
    use: use,
    useCallback: throwInvalidHookError,
    useContext: throwInvalidHookError,
    useEffect: throwInvalidHookError,
    useImperativeHandle: throwInvalidHookError,
    useLayoutEffect: throwInvalidHookError,
    useInsertionEffect: throwInvalidHookError,
    useMemo: throwInvalidHookError,
    useReducer: throwInvalidHookError,
    useRef: throwInvalidHookError,
    useState: throwInvalidHookError,
    useDebugValue: throwInvalidHookError,
    useDeferredValue: throwInvalidHookError,
    useTransition: throwInvalidHookError,
    useSyncExternalStore: throwInvalidHookError,
    useId: throwInvalidHookError,
    useHostTransitionStatus: throwInvalidHookError,
    useFormState: throwInvalidHookError,
    useActionState: throwInvalidHookError,
    useOptimistic: throwInvalidHookError,
    useMemoCache: throwInvalidHookError,
    useCacheRefresh: throwInvalidHookError,
    useEffectEvent: throwInvalidHookError
}, HooksDispatcherOnMount = {
    readContext: readContext,
    use: use,
    useCallback: function(callback, deps) {
        mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: readContext,
    useEffect: mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        mountEffectImpl(4194308, 4, imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = mountWorkInProgressHook();
        return mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = mountStateImpl(!1);
        stateHook = startTransition.bind(null, currentlyRenderingFiber, stateHook.queue, !0, !1);
        mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber, hook = mountWorkInProgressHook();
        if (isHydrating) {
            if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
            0 !== (workInProgressRootRenderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        pushSimpleEffect(9, {
            destroy: void 0
        }, updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
        if (isHydrating) {
            var JSCompiler_inline_result = treeContextOverflow;
            var idWithLeadingBit = treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: mountActionState,
    useActionState: mountActionState,
    useOptimistic: function(passthrough) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: function() {
        return mountWorkInProgressHook().memoizedState = refreshCache.bind(null, currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== (executionContext & 2)) throw Error(formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, HooksDispatcherOnUpdate = {
    readContext: readContext,
    use: use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: updateReducer,
    useRef: updateRef,
    useState: function() {
        return updateReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = updateReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: updateActionState,
    useActionState: updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: updateRefresh,
    useEffectEvent: updateEvent
}, HooksDispatcherOnRerender = {
    readContext: readContext,
    use: use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: rerenderReducer,
    useRef: updateRef,
    useState: function() {
        return rerenderReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: rerenderActionState,
    useActionState: rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        if (null !== currentHook) return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: updateRefresh,
    useEffectEvent: updateEvent
};
function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = enqueueUpdate(inst, update, lane);
        null !== callback && (scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
    }
};
function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState) : !0;
}
function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function defaultOnUncaughtError(error) {
    reportGlobalError(error);
}
function defaultOnCaughtError(error) {
    console.error(error);
}
function defaultOnRecoverableError(error) {
    reportGlobalError(error);
}
function logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function createRootErrorUpdate(root, errorInfo, lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        logUncaughtError(root, errorInfo);
    };
    return lane;
}
function createClassErrorUpdate(lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error(formatProdErrorMessage(435, sourceFiber.tag));
        }
        attachPingListener(root, value, rootRenderLanes);
        renderDidSuspendDelayIfPossible();
        return !1;
    }
    if (isHydrating) return returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && (root = Error(formatProdErrorMessage(422), {
        cause: value
    }), queueHydrationError(createCapturedValueAtFiber(root, sourceFiber)))) : (value !== HydrationMismatchException && (returnFiber = Error(formatProdErrorMessage(423), {
        cause: value
    }), queueHydrationError(createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(root.stateNode, value, rootRenderLanes), enqueueCapturedUpdate(root, rootRenderLanes), 4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error(formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [
        wrapperError
    ] : workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = createRootErrorUpdate(sourceFiber.stateNode, value, root), enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var SelectiveHydrationException = Error(formatProdErrorMessage(461)), didReceiveUpdate = !1;
function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? mountChildFibers(workInProgress, null, nextChildren, renderLanes) : reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    prepareToReadContext(workInProgress);
    nextProps = renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && key && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if (didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && (didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? pushHiddenContext(workInProgress, prevState) : reuseHiddenContextOnStack(), pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? (pushTransition(workInProgress, prevState.cachePool), pushHiddenContext(workInProgress, prevState), reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && pushTransition(workInProgress, null), reuseHiddenContextOnStack(), reuseSuspenseHandlerOnStack());
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && pushTransition(workInProgress, null);
    reuseHiddenContextOnStack();
    pushOffscreenSuspenseHandler(workInProgress);
    null !== current && propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function mountActivityChildren(workInProgress, nextProps) {
    nextProps = mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if (isHydrating) {
            if ("hidden" === nextProps.mode) return current = mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, bailoutOffscreenComponent(null, current);
            pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = nextHydratableInstance) ? (current = canHydrateHydrationBoundary(current, rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== treeContextProvider ? {
                    id: treeContextId,
                    overflow: treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null)) : current = null;
            if (null === current) throw throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error(formatProdErrorMessage(558));
        } else if (didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || didSuspend) {
            if (null === currentTreeHiddenStackCursor.current) {
                nextProps = workInProgressRoot;
                if (null !== nextProps && (dehydrated = getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, enqueueConcurrentRenderForLane(current, dehydrated), scheduleUpdateOnFiber(nextProps, current, dehydrated), SelectiveHydrationException;
                renderDidSuspendDelayIfPossible();
            }
            workInProgress = retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, nextHydratableInstance = getNextHydratable(dehydrated.nextSibling), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, rootOrSingletonContext = !1, null !== current && restoreSuspendedTreeContext(workInProgress, current), workInProgress = mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error(formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    prepareToReadContext(workInProgress);
    Component = renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && nextProps && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    finishRenderingHooks(current);
    Component = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && Component && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? readContext(contextType) : emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && (applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && classComponentUpdater.enqueueReplaceState(context, context.state, null), processUpdateQueue(workInProgress, nextProps, context, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && (applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || hasForceUpdate || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = reconcileChildFibers(workInProgress, null, Component, renderLanes)) : reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    resetHydrationState();
    workInProgress.flags |= 256;
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: getSuspendedCache()
    };
}
function getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= workInProgressDeferredLane);
    return current;
}
function updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== (suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if (isHydrating) {
            showFallback ? pushPrimaryTreeSuspenseHandler(workInProgress) : reuseSuspenseHandlerOnStack();
            (current = nextHydratableInstance) ? (current = canHydrateHydrationBoundary(current, rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== treeContextProvider ? {
                    id: treeContextId,
                    overflow: treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null)) : current = null;
            if (null === current) throw throwOnHydrationMismatch(workInProgress);
            isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(null, nextProps);
        pushPrimaryTreeSuspenseHandler(workInProgress);
        return mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = createWorkInProgress(dehydrated$96, showFallback) : (showFallback = createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(current.child, nextProps);
    pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = SUSPENDED_MARKER;
        return bailoutOffscreenComponent(null, nextProps);
    }
    pushPrimaryTreeSuspenseHandler(workInProgress);
    if (isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error(formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if (didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== currentTreeHiddenStackCursor.current) return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, enqueueConcurrentRenderForLane(current, nextProps), scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), SelectiveHydrationException;
        isSuspenseInstancePending(suspenseInstance) || renderDidSuspendDelayIfPossible();
        return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if (isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    nextHydratableInstance = getNextHydratable(suspenseInstance.nextSibling);
    hydrationParentFiber = workInProgress;
    isHydrating = !0;
    hydrationErrors = null;
    rootOrSingletonContext = !1;
    null !== current && restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = suspenseStackCursor.current;
    if (workInProgress.flags & 128) return pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? (reverseChildren(current), reconcileChildren(current, workInProgress, nextProps, renderLanes), reverseChildren(current)) : reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = isHydrating ? treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, reverseChildren(workInProgress));
            initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    pushProvider(workInProgress, workInProgress.type, newProps.value);
    reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if (propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error(formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && checkIfContextChanged(current) ? !0 : !1;
}
function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
            resetHydrationState();
            break;
        case 27:
        case 5:
            pushHostContext(workInProgress);
            break;
        case 4:
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return updateSuspenseComponent(current, workInProgress, renderLanes);
                pushPrimaryTreeSuspenseHandler(workInProgress);
                current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || (propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            pushSuspenseListContext(workInProgress, suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
    }
    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) didReceiveUpdate = !0;
        else {
            if (!checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return didReceiveUpdate = !1, attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else didReceiveUpdate = !1, isHydrating && 0 !== (workInProgress.flags & 1048576) && pushTreeId(workInProgress, treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) shouldConstruct(current) ? (props = resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = getComponentNameFromType(current) || current;
                    throw Error(formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = resolveClassComponentProps(props, workInProgress.pendingProps), updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error(formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                cloneUpdateQueue(current, workInProgress);
                processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                pushProvider(workInProgress, CacheContext, props);
                props !== prevState.cache && propagateContextChanges(workInProgress, [
                    CacheContext
                ], renderLanes, !0);
                suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = createCapturedValueAtFiber(Error(formatProdErrorMessage(424)), workInProgress);
                        queueHydrationError($$typeof);
                        workInProgress = mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        nextHydratableInstance = getNextHydratable(current.firstChild);
                        hydrationParentFiber = workInProgress;
                        isHydrating = !0;
                        hydrationErrors = null;
                        rootOrSingletonContext = !0;
                        renderLanes = mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return markRef(current, workInProgress), null === current ? (renderLanes = getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : isHydrating || (workInProgress.stateNode = createHoistableInstance(workInProgress.type, workInProgress.pendingProps, rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return pushHostContext(workInProgress), null === current && isHydrating && (props = workInProgress.stateNode = resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, rootInstanceStackCursor.current), hydrationParentFiber = workInProgress, rootOrSingletonContext = !0, $$typeof = nextHydratableInstance, isSingletonScope(workInProgress.type) ? (previousHydratableOnEnteringScopedSingleton = $$typeof, nextHydratableInstance = getNextHydratable(props.firstChild)) : nextHydratableInstance = $$typeof), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && isHydrating) {
                if ($$typeof = props = nextHydratableInstance) props = canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, hydrationParentFiber = workInProgress, nextHydratableInstance = getNextHydratable(props.firstChild), rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || throwOnHydrationMismatch(workInProgress);
            }
            pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = renderWithHooks(current, workInProgress, TransitionAwareHostComponent, null, null, renderLanes), HostTransitionContext._currentValue = $$typeof);
            markRef(current, workInProgress);
            reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && isHydrating) {
                if (current = renderLanes = nextHydratableInstance) renderLanes = canHydrateTextInstance(renderLanes, workInProgress.pendingProps, rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null, current = !0) : current = !1;
                current || throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = reconcileChildFibers(workInProgress, null, props, renderLanes) : reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, markRef(current, workInProgress), reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, prepareToReadContext(workInProgress), $$typeof = readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return prepareToReadContext(workInProgress), props = readContext(CacheContext), null === current ? ($$typeof = peekCacheFromPool(), null === $$typeof && ($$typeof = workInProgressRoot, prevState = createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, initializeUpdateQueue(workInProgress), pushProvider(workInProgress, CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && (cloneUpdateQueue(current, workInProgress), processUpdateQueue(workInProgress, null, null, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), pushProvider(workInProgress, CacheContext, props)) : (props = prevState.cache, pushProvider(workInProgress, CacheContext, props), props !== $$typeof.cache && propagateContextChanges(workInProgress, [
                CacheContext
            ], renderLanes, !0))), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : isHydrating && pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : markRef(current, workInProgress), reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error(formatProdErrorMessage(156, workInProgress.tag));
}
function markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? maySuspendCommit(type, newProps) : maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !preloadResource(resource)) {
        if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
    }
}
function scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
}
function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return bubbleProperties(workInProgress), null;
        case 1:
            return bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            popProvider(CacheContext);
            popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) popHydrationState(workInProgress) ? markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, upgradeHydrationErrorsToRecoverable());
            bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? (markUpdate(workInProgress), null !== nextResource ? (bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? (markUpdate(workInProgress), bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && markUpdate(workInProgress), bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            popHostContext(workInProgress);
            renderLanes = rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                    bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = contextStackCursor.current;
                popHydrationState(workInProgress) ? prepareToHydrateHostInstance(workInProgress, current) : (current = resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, markUpdate(workInProgress));
            }
            bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                    bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = contextStackCursor.current;
                if (popHydrationState(workInProgress)) prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = getOwnerDocumentFromRootContainer(rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[internalInstanceKey] = workInProgress;
                    nextResource[internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch(setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && markUpdate(workInProgress);
                }
            }
            bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                current = rootInstanceStackCursor.current;
                if (popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || throwOnHydrationMismatch(workInProgress, !0);
                } else current = getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error(formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error(formatProdErrorMessage(557));
                        current[internalInstanceKey] = workInProgress;
                    } else resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                    popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error(formatProdErrorMessage(558));
            }
            bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error(formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error(formatProdErrorMessage(317));
                        type[internalInstanceKey] = workInProgress;
                    } else resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    bubbleProperties(workInProgress);
                    type = !1;
                } else type = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                    popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            bubbleProperties(workInProgress);
            return null;
        case 4:
            return popHostContainer(), null === current && listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, bubbleProperties(workInProgress), null;
        case 10:
            return popProvider(workInProgress.type), bubbleProperties(workInProgress), null;
        case 19:
            popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            pushSuspenseListContext(workInProgress, suspenseStackCursor.current & 1 | 2);
                            isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && now() > workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, scheduleRetryEffect(workInProgress, current), cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !isHydrating) return bubbleProperties(workInProgress), null;
                    } else 2 * now() - newProps.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = now();
                current.sibling = null;
                nextResource = suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || isHydrating ? pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, push(suspenseHandlerStackCursor, workInProgress), push(suspenseStackCursor, renderLanes), null === shellBoundary && (shellBoundary = workInProgress));
                isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return popSuspenseHandler(workInProgress), popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && (bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && pop(resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), popProvider(CacheContext), bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, bubbleProperties(workInProgress), null;
    }
    throw Error(formatProdErrorMessage(156, workInProgress.tag));
}
function unwindWork(current, workInProgress) {
    popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return popProvider(CacheContext), popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error(formatProdErrorMessage(340));
                resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error(formatProdErrorMessage(340));
                resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return popHostContainer(), null;
        case 10:
            return popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return popSuspenseHandler(workInProgress), popHiddenContext(), null !== current && pop(resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return popProvider(CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function unwindInterruptedWork(current, interruptedWork) {
    popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            popProvider(CacheContext);
            popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            popHostContext(interruptedWork);
            break;
        case 4:
            popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && popSuspenseHandler(interruptedWork);
            break;
        case 13:
            popSuspenseHandler(interruptedWork);
            break;
        case 19:
            popSuspenseListContext(interruptedWork);
            break;
        case 10:
            popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            popSuspenseHandler(interruptedWork);
            popHiddenContext();
            null !== current && pop(resumedCache);
            break;
        case 24:
            popProvider(CacheContext);
    }
}
function commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            commitCallbacks(updateQueue, instance);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new FragmentInstance(current);
                        traverseVisibleInstancesAndTextInstances(current.child, !1, addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        isFragmentInstanceParent(parent) && commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if (isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        isFragmentInstanceParent(parent) && deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if (isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[internalPropsKey] = newProps;
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = noop$1)), commitNewChildToFragmentInstances(node, parentFragmentInstances), viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && (commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for(insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), commitNewChildToFragmentInstances(node, parentFragmentInstances), viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && (commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for(insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        setInitialProperties(singleton, type, props);
        singleton[internalInstanceKey] = finishedWork;
        singleton[internalPropsKey] = props;
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var shouldStartViewTransition = !1, appearingViewTransitions = null;
function trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) shouldStartViewTransition = !0;
}
var viewTransitionCancelableChildren = null;
function pushViewTransitionCancelableScope() {
    var prevChildren = viewTransitionCancelableChildren;
    viewTransitionCancelableChildren = null;
    return prevChildren;
}
var viewTransitionHostInstanceIdx = 0;
function applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    viewTransitionHostInstanceIdx = 0;
    return applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || measureInstance(instance).view && (inViewport = !0);
            shouldStartViewTransition = !0;
            applyViewTransitionName(instance, 0 === viewTransitionHostInstanceIdx ? name : name + "_" + viewTransitionHostInstanceIdx, className);
            viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if (commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error(formatProdErrorMessage(544));
                var name = props.name;
                props = getViewTransitionClassName(props.default, props.share);
                "none" !== props && (applyViewTransitionToHostInstances(placement, name, props, null, !1) || restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = getViewTransitionName(props, state), className = getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? applyViewTransitionToHostInstances(placement, name, className, null, !1) ? (commitAppearingPairViewTransitions(placement), state.paired || gesture || scheduleViewTransitionEvent(placement, props.onEnter)) : restoreViewTransitionOnHostInstances(placement.child, !1) : commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else commitAppearingPairViewTransitions(placement);
}
function commitDeletedPairViewTransitions(deletion) {
    if (null !== appearingViewTransitions && 0 !== appearingViewTransitions.size) {
        var pairs = appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = getViewTransitionClassName(props.default, props.share);
                            "none" !== className && (applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, scheduleViewTransitionEvent(deletion, props.onShare)) : restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = getViewTransitionName(props, deletion.stateNode), pair = null !== appearingViewTransitions ? appearingViewTransitions.get(name) : void 0, className = getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && (applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, appearingViewTransitions.delete(name), scheduleViewTransitionEvent(deletion, props.onShare)) : scheduleViewTransitionEvent(deletion, props.onExit) : restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== appearingViewTransitions && commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== appearingViewTransitions && commitDeletedPairViewTransitions(deletion);
}
function commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = getViewTransitionName(props, changedParent.stateNode);
            props = getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, restoreViewTransitionOnHostInstances(fiber.child, !1), restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else restorePairedViewTransitions(fiber);
}
function restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[viewTransitionHostInstanceIdx], nextMeasurement = measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && applyViewTransitionName(instance, 0 === viewTransitionHostInstanceIdx ? newName : newName + "_" + viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === viewTransitionCancelableChildren && (viewTransitionCancelableChildren = []), viewTransitionCancelableChildren.push(instance, 0 === viewTransitionHostInstanceIdx ? oldName : oldName + "_" + viewTransitionHostInstanceIdx, child.memoizedProps));
            viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = getViewTransitionName(props, state), className = getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map(measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            viewTransitionHostInstanceIdx = 0;
            name = measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var offscreenSubtreeIsHidden = !1, offscreenSubtreeWasHidden = !1, offscreenDirectParentIsHidden = !1, needsFormReset = !1, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null, viewTransitionContextChanged = !1, inUpdateViewTransition = !1, rootViewTransitionAffected = !1, rootViewTransitionNameCanceled = !1;
function commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    eventsEnabled = _enabled;
    root = getActiveElementDeep(root);
    if (hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    _enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== nextEffect;){
        root = nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && trackEnterViewTransitions(root), commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && commitExitViewTransitions(JSCompiler_temp);
                    commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && trackEnterViewTransitions(root);
                    commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, nextEffect = JSCompiler_temp) : (committedLanes && commitNestedViewTransitions(root), commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    appearingViewTransitions = null;
}
function commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== nextEffect;){
        var fiber = nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = getViewTransitionClassName(flags.default, flags.update), "none" !== flags && applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error(formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            nextEffect = current;
            break;
        }
        nextEffect = fiber.return;
    }
}
function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && commitClassCallbacks(finishedWork);
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    commitCallbacks(finishedRoot, current);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && commitHostMount(finishedWork);
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = retryDehydratedSuspenseBoundary.bind(null, finishedWork), registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || offscreenSubtreeWasHidden;
                current = offscreenSubtreeIsHidden;
                prevProps = offscreenSubtreeWasHidden;
                offscreenSubtreeIsHidden = flags;
                (offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                offscreenSubtreeIsHidden = current;
                offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
        default:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, viewTransitionMutationContext = !0;
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var hostParent = null, hostParentIsContainer = !1;
function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount) try {
        injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
            isSingletonScope(deletedFiber.type) && (hostParent = deletedFiber.stateNode, hostParentIsContainer = !1);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor), commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = hostParent;
            prevHostParentIsContainer = hostParentIsContainer;
            hostParent = null;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            if (null !== hostParent) {
                if (hostParentIsContainer) try {
                    (9 === hostParent.nodeType ? hostParent.body : "HTML" === hostParent.nodeName ? hostParent.ownerDocument.body : hostParent).removeChild(deletedFiber.stateNode), viewTransitionMutationContext = !0;
                } catch (error) {
                    captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    hostParent.removeChild(deletedFiber.stateNode), viewTransitionMutationContext = !0;
                } catch (error) {
                    captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== hostParent && (hostParentIsContainer ? (finishedRoot = hostParent, clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), retryIfBlockedOn(finishedRoot)) : clearHydrationBoundary(hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = hostParent;
            prevHostParentIsContainer = hostParentIsContainer;
            hostParent = deletedFiber.stateNode.containerInfo;
            hostParentIsContainer = !0;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            offscreenSubtreeWasHidden || commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            safelyDetachRef(deletedFiber, nearestMountedAncestor);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            retryIfBlockedOn(finishedRoot);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        retryIfBlockedOn(finishedRoot);
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
        default:
            throw Error(formatProdErrorMessage(435, finishedWork.tag));
    }
}
function attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if (isSingletonScope(parent.type)) {
                        hostParent = parent.stateNode;
                        hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === hostParent) throw Error(formatProdErrorMessage(160));
        commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        hostParent = null;
        hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var currentHoistableRoot = null;
function commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (commitHookEffectListUnmount(3, finishedWork, finishedWork.return), commitHookEffectListMount(3, finishedWork), commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            flags & 64 && offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = currentHoistableRoot;
            recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if (offscreenSubtreeIsHidden) finishedWork.stateNode = createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[internalHoistableMarker] || current[internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            setInitialProperties(current, root, lanes);
                                            current[internalInstanceKey] = finishedWork;
                                            markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error(formatProdErrorMessage(468, root));
                                    }
                                    current[internalInstanceKey] = finishedWork;
                                    markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else offscreenSubtreeIsHidden || mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? offscreenSubtreeIsHidden || mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            null !== current && flags & 4 && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = offscreenDirectParentIsHidden;
            offscreenDirectParentIsHidden = !1;
            recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            offscreenDirectParentIsHidden = ii;
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    setTextContent(root, ""), viewTransitionMutationContext = !0;
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && (needsFormReset = !0);
            break;
        case 6:
            recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error(formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, viewTransitionMutationContext = !0;
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            viewTransitionMutationContext = !1;
            tagCaches = null;
            ii = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(root.containerInfo);
            recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            currentHoistableRoot = ii;
            commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            needsFormReset && (needsFormReset = !1, recursivelyResetForms(finishedWork));
            viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = offscreenDirectParentIsHidden;
            offscreenDirectParentIsHidden = offscreenSubtreeIsHidden;
            current = pushMutationContext();
            ii = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(finishedWork.stateNode.containerInfo);
            recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            commitReconciliationEffects(finishedWork);
            currentHoistableRoot = ii;
            viewTransitionMutationContext && inUpdateViewTransition && (rootViewTransitionAffected = !0);
            viewTransitionMutationContext = current;
            offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            commitReconciliationEffects(finishedWork);
            break;
        case 31:
            recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && (globalMostRecentFallbackTime = now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = offscreenDirectParentIsHidden;
            offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || offscreenSubtreeIsHidden || offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || offscreenSubtreeWasHidden, lanes = offscreenSubtreeIsHidden, current = offscreenSubtreeWasHidden, offscreenSubtreeIsHidden = ii || offscreenSubtreeIsHidden, offscreenSubtreeWasHidden = root, recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), offscreenSubtreeIsHidden = lanes, offscreenSubtreeWasHidden = current), !ii && offscreenDirectParentIsHidden || hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            flags = pushMutationContext();
            ii = inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            inUpdateViewTransition = _eventPayloads$ii2 && "none" !== getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && viewTransitionMutationContext && (finishedWork.flags |= 4);
            inUpdateViewTransition = ii;
            viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            recursivelyTraverseMutationEffects(root, finishedWork, lanes), commitReconciliationEffects(finishedWork);
    }
}
function commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if (isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if (isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if (isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error(formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = getHostSibling(finishedWork);
                    insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && (setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = getHostSibling(finishedWork);
                    insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = getHostSibling(finishedWork);
                    insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error(formatProdErrorMessage(161));
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, _enabled = !0, fiber.reset(), _enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else measureNestedViewTransitions(parentFiber, !1);
}
function commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            rootViewTransitionNameCanceled = viewTransitionContextChanged = !1;
            pushViewTransitionCancelableScope();
            recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!viewTransitionContextChanged && !rootViewTransitionAffected) {
                finishedWork = viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                rootViewTransitionNameCanceled = !0;
            }
            viewTransitionCancelableChildren = null;
            break;
        case 5:
            recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = viewTransitionContextChanged;
            viewTransitionContextChanged = !1;
            recursivelyTraverseAfterMutationEffects(root, finishedWork);
            viewTransitionContextChanged && (rootViewTransitionAffected = !0);
            viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? commitEnterViewTransitions(finishedWork, !1) : recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = viewTransitionContextChanged;
            oldName = pushViewTransitionCancelableScope();
            viewTransitionContextChanged = !1;
            recursivelyTraverseAfterMutationEffects(root, finishedWork);
            viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = getViewTransitionName(props, state);
            state = getViewTransitionName(current.memoizedProps, state);
            var className = getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, viewTransitionHostInstanceIdx = 0, root = measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? (scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, viewTransitionCancelableChildren), viewTransitionCancelableChildren = oldName);
            viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || commitFragmentInstanceDeletionEffects(finishedWork);
                recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                safelyDetachRef(finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                safelyDetachRef(finishedWork, finishedWork.return);
            default:
                recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && commitClassCallbacks(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || commitFragmentInstanceInsertionEffects(finishedWork);
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && commitHostMount(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || offscreenSubtreeIsHidden || mountHoistable(getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && commitHostMount(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                safelyAttachRef(finishedWork, finishedWork.return);
            default:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && releaseCache(previousCache));
}
function commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && releaseCache(current));
}
function recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && restoreNestedViewTransitions(parentFiber);
}
function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && (restoreViewTransitionOnHostInstances(flags.child, !0), restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var suspenseyCommitFlag = 8192;
function recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & suspenseyCommitFlag && (null !== fiber.memoizedState ? suspendResource(suspendedState, currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(fiber.stateNode.containerInfo);
            recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === appearingViewTransitions && (appearingViewTransitions = new Map());
                appearingViewTransitions.set(previousHoistableRoot, state);
            }
            recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                commitHookEffectListUnmount(8, deletions, deletions.return);
                recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== nextEffect;){
        var fiber = nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== nextEffect;){
            cache = nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            detachFiberAfterEffects(cache);
            if (cache === fiber) {
                nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                break a;
            }
            nextEffect = returnFiber;
        }
    }
}
var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = readContext(CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return readContext(CacheContext).controller.signal;
    }
}, PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, executionContext = 0, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = !1, workInProgressRootIsPrerendering = !1, workInProgressRootDidAttachPingListener = !1, entangledRenderLanes = 0, workInProgressRootExitStatus = 0, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = !1, globalMostRecentFallbackTime = 0, globalMostRecentTransitionTime = 0, workInProgressRootRenderTargetTime = Infinity, workInProgressTransitions = null, legacyErrorBoundariesThatAlreadyFailed = null, pendingEffectsStatus = 0, pendingEffectsRoot = null, pendingFinishedWork = null, pendingEffectsLanes = 0, pendingEffectsRemainingLanes = 0, pendingPassiveTransitions = null, pendingRecoverableErrors = null, pendingViewTransition = null, pendingViewTransitionEvents = null, pendingTransitionTypes = null, nestedUpdateCount = 0, rootWithNestedUpdates = null;
function requestUpdateLane() {
    return 0 !== (executionContext & 2) && 0 !== workInProgressRootRenderLanes ? workInProgressRootRenderLanes & -workInProgressRootRenderLanes : null !== ReactSharedInternals.T ? requestTransitionLane() : resolveUpdatePriority();
}
function requestDeferredLane() {
    if (0 === workInProgressDeferredLane) {
        if (0 === (workInProgressRootRenderLanes & 536870912) || isHydrating) {
            var lane = nextTransitionDeferredLane;
            nextTransitionDeferredLane <<= 1;
            0 === (nextTransitionDeferredLane & 3932160) && (nextTransitionDeferredLane = 262144);
            workInProgressDeferredLane = lane;
        } else workInProgressDeferredLane = 536870912;
    }
    lane = suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return workInProgressDeferredLane;
}
function scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = createViewTransitionInstance(getViewTransitionName(fiber.memoizedProps, state)));
        null === pendingViewTransitionEvents && (pendingViewTransitionEvents = []);
        pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === workInProgressRoot && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root.cancelPendingCommit) prepareFreshStack(root, 0), markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
    markRootUpdated$1(root, lane);
    if (0 === (executionContext & 2) || root !== workInProgressRoot) root === workInProgressRoot && (0 === (executionContext & 2) && (workInProgressRootInterleavedUpdatedLanes |= lane), 4 === workInProgressRootExitStatus && markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1)), ensureRootIsScheduled(root);
}
function performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? renderRootConcurrent(root$jscomp$0, lanes) : renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            workInProgressRootIsPrerendering && !shouldTimeSlice && markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && (prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = workInProgressRootRecoverableErrors;
                            workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = renderWasConcurrent : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                prepareFreshStack(root$jscomp$0, 0);
                markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error(formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error(formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = globalMostRecentFallbackTime + 300 - now(), 10 < exitStatus)) {
                    markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = scheduleTimeout(completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                completeRootWhenReady(shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    ensureRootIsScheduled(root$jscomp$0);
}
function completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: noop$1
        }, appearingViewTransitions = null, accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? globalMostRecentFallbackTime - now() : (lanes & 4194048) === lanes ? globalMostRecentTransitionTime - now() : 0, subtreeFlags = waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags(completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~workInProgressRootPingedLanes;
    suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function flushSyncWork$1() {
    return 0 === (executionContext & 6) ? (flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function resetWorkInProgressStack() {
    if (null !== workInProgress) {
        if (0 === workInProgressSuspendedReason) var interruptedWork = workInProgress.return;
        else interruptedWork = workInProgress, lastContextDependency = currentlyRenderingFiber$1 = null, resetHooksOnUnwind(interruptedWork), thenableState$1 = null, thenableIndexCounter$1 = 0, interruptedWork = workInProgress;
        for(; null !== interruptedWork;)unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        workInProgress = null;
    }
}
function prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    pendingEffectsLanes = 0;
    resetWorkInProgressStack();
    workInProgressRoot = root;
    workInProgress = timeoutHandle = createWorkInProgress(root.current, null);
    workInProgressRootRenderLanes = lanes;
    workInProgressSuspendedReason = 0;
    workInProgressThrownValue = null;
    workInProgressRootDidSkipSuspendedSiblings = !1;
    workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
    workInProgressRootDidAttachPingListener = !1;
    workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = workInProgressRootExitStatus = 0;
    workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
    workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    entangledRenderLanes = getEntangledLanes(root, lanes);
    finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function handleThrow(root, thrownValue) {
    currentlyRenderingFiber = null;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    thrownValue === SuspenseException || thrownValue === SuspenseActionException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 3) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 4) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    workInProgressThrownValue = thrownValue;
    null === workInProgress && (workInProgressRootExitStatus = 1, logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current)));
}
function shouldRemainOnPreviousScreen() {
    var handler = suspenseHandlerStackCursor.current;
    return null === handler ? !0 : (workInProgressRootRenderLanes & 4194048) === workInProgressRootRenderLanes ? null === shellBoundary ? !0 : !1 : (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes || 0 !== (workInProgressRootRenderLanes & 536870912) ? handler === shellBoundary : !1;
}
function pushDispatcher() {
    var prevDispatcher = ReactSharedInternals.H;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
}
function pushAsyncDispatcher() {
    var prevAsyncDispatcher = ReactSharedInternals.A;
    ReactSharedInternals.A = DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function renderDidSuspendDelayIfPossible() {
    workInProgressRootExitStatus = 4;
    workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194048) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = !0);
    0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(workInProgressRoot, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
}
function renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) workInProgressTransitions = null, prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = workInProgressRootExitStatus;
    a: do try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
            var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
            switch(workInProgressSuspendedReason){
                case 8:
                    resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = workInProgressSuspendedReason;
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = workInProgressSuspendedReason, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        workLoopSync();
        exitStatus = workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    lastContextDependency = currentlyRenderingFiber$1 = null;
    executionContext = prevExecutionContext;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
    return exitStatus;
}
function workLoopSync() {
    for(; null !== workInProgress;)performUnitOfWork(workInProgress);
}
function renderRootConcurrent(root, lanes) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes ? (workInProgressTransitions = null, workInProgressRootRenderTargetTime = now() + 500, prepareFreshStack(root, lanes)) : workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
            lanes = workInProgress;
            var thrownValue = workInProgressThrownValue;
            b: switch(workInProgressSuspendedReason){
                case 1:
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if (isThenableResolved(thrownValue)) {
                        workInProgressSuspendedReason = 0;
                        workInProgressThrownValue = null;
                        replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== workInProgressSuspendedReason && 9 !== workInProgressSuspendedReason || workInProgressRoot !== root || (workInProgressSuspendedReason = 7);
                        ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    isThenableResolved(thrownValue) ? (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch(workInProgress.tag){
                        case 26:
                            resource = workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = workInProgress;
                            if (resource ? preloadResource(resource) : hostFiber.stateNode.complete) {
                                workInProgressSuspendedReason = 0;
                                workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                                }
                                break b;
                            }
                    }
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    resetWorkInProgressStack();
                    workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error(formatProdErrorMessage(462));
            }
        }
        workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        handleThrow(root, thrownValue$186);
    }
    while (1);
    lastContextDependency = currentlyRenderingFiber$1 = null;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    executionContext = prevExecutionContext;
    if (null !== workInProgress) return 0;
    workInProgressRoot = null;
    workInProgressRootRenderLanes = 0;
    finishQueueingConcurrentUpdates();
    return workInProgressRootExitStatus;
}
function workLoopConcurrentByScheduler() {
    for(; null !== workInProgress && !shouldYield();)performUnitOfWork(workInProgress);
}
function performUnitOfWork(unitOfWork) {
    var next = beginWork(unitOfWork.alternate, unitOfWork, entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
}
function replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, workInProgressRootRenderLanes);
            break;
        case 11:
            next = replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, workInProgressRootRenderLanes);
            break;
        case 5:
            resetHooksOnUnwind(next);
            var fiber = next;
            fiber === hydrationParentFiber && (isHydrating ? (popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && (nextHydratableInstance = fiber.stateNode)) : (popToNextHostParent(fiber), isHydrating = !0));
        default:
            unwindInterruptedWork(current, next), next = workInProgress = resetWorkInProgress(next, entangledRenderLanes), next = beginWork(current, next, entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
}
function throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    lastContextDependency = currentlyRenderingFiber$1 = null;
    resetHooksOnUnwind(unitOfWork);
    thenableState$1 = null;
    thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if (throwException(root, returnFiber, unitOfWork, thrownValue, workInProgressRootRenderLanes)) {
            workInProgressRootExitStatus = 1;
            logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
            workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw workInProgress = returnFiber, error;
        workInProgressRootExitStatus = 1;
        logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
        workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if (isHydrating || 1 === suspendedReason) root = !0;
        else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912)) root = !1;
        else if (workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        unwindUnitOfWork(unitOfWork, root);
    } else completeUnitOfWork(unitOfWork);
}
function completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            unwindUnitOfWork(completedWork, workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = completeWork(completedWork.alternate, completedWork, entangledRenderLanes);
        if (null !== next) {
            workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            workInProgress = completedWork;
            return;
        }
        workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 5);
}
function unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            workInProgress = unitOfWork;
            return;
        }
        workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    workInProgressRootExitStatus = 6;
    workInProgress = null;
}
function completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do flushPendingEffects();
    while (0 !== pendingEffectsStatus);
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error(formatProdErrorMessage(177));
        root === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
        pendingFinishedWork = finishedWork;
        pendingEffectsRoot = root;
        pendingEffectsLanes = lanes;
        pendingPassiveTransitions = transitions;
        pendingRecoverableErrors = recoverableErrors;
        commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= concurrentlyUpdatedLanes;
    markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? (pendingTransitionTypes = claimQueuedTransitionTypes(root), spawnedLane = 10262) : (pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, scheduleCallback$1(NormalPriority$1, function() {
        flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        updatedLanes = ReactDOMSharedInternals.p;
        ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = executionContext;
        executionContext |= 4;
        try {
            commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            executionContext = suspendedRetryLanes, ReactDOMSharedInternals.p = updatedLanes, ReactSharedInternals.T = spawnedLane;
        }
    }
    pendingEffectsStatus = 1;
    shouldStartViewTransition ? pendingViewTransition = startViewTransition(suspendedState, root.containerInfo, pendingTransitionTypes, flushMutationEffects, flushLayoutEffects, flushAfterMutationEffects, flushSpawnedWork, flushPassiveEffects, reportViewTransitionError, null, null) : (flushMutationEffects(), flushLayoutEffects(), flushSpawnedWork());
}
function reportViewTransitionError(error) {
    if (0 !== pendingEffectsStatus) {
        var onRecoverableError = pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function flushAfterMutationEffects() {
    3 === pendingEffectsStatus && (pendingEffectsStatus = 0, commitAfterMutationEffectsOnFiber(pendingFinishedWork, pendingEffectsRoot), pendingEffectsStatus = 4);
}
function flushMutationEffects() {
    if (1 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            var previousPriority = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = executionContext;
            executionContext |= 4;
            try {
                inUpdateViewTransition = rootViewTransitionAffected = !1;
                commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = selectionInformation;
                var curFocusedElem = getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                _enabled = !!eventsEnabled;
                selectionInformation = eventsEnabled = null;
            } finally{
                executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        pendingEffectsStatus = 2;
    }
}
function flushLayoutEffects() {
    if (2 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            var previousPriority = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = executionContext;
            executionContext |= 4;
            try {
                commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        pendingEffectsStatus = 3;
    }
}
function flushSpawnedWork() {
    if (4 === pendingEffectsStatus || 3 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        var committedViewTransition = pendingViewTransition;
        pendingViewTransition = null;
        requestPaint();
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, recoverableErrors = pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? pendingEffectsStatus = 5 : (pendingEffectsStatus = 0, pendingFinishedWork = pendingEffectsRoot = null, releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && (legacyErrorBoundariesThatAlreadyFailed = null);
        lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot) try {
            injectedHook.onCommitFiberRoot(rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = ReactSharedInternals.T;
            passiveSubtreeMask = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                ReactSharedInternals.T = finishedWork, ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = pendingViewTransitionEvents;
        onRecoverableError = pendingTransitionTypes;
        pendingTransitionTypes = null;
        if (null !== recoverableErrors && (pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
        ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = root) : (nestedUpdateCount = 0, rootWithNestedUpdates = null);
        flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, releaseCache(remainingLanes)));
}
function flushPendingEffects() {
    null !== pendingViewTransition && (pendingViewTransition.skipTransition(), pendingViewTransition = null);
    flushMutationEffects();
    flushLayoutEffects();
    flushSpawnedWork();
    return flushPassiveEffects();
}
function flushPassiveEffects() {
    if (5 !== pendingEffectsStatus) return !1;
    var root = pendingEffectsRoot, remainingLanes = pendingEffectsRemainingLanes;
    pendingEffectsRemainingLanes = 0;
    var renderPriority = lanesToEventPriority(pendingEffectsLanes), prevTransition = ReactSharedInternals.T, previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        ReactSharedInternals.T = null;
        renderPriority = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root$jscomp$0 = pendingEffectsRoot, lanes = pendingEffectsLanes;
        pendingEffectsStatus = 0;
        pendingFinishedWork = pendingEffectsRoot = null;
        pendingEffectsLanes = 0;
        if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(331));
        var prevExecutionContext = executionContext;
        executionContext |= 4;
        commitPassiveUnmountOnFiber(root$jscomp$0.current);
        commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        executionContext = prevExecutionContext;
        flushSyncWorkAcrossRoots_impl(0, !1);
        if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot) try {
            injectedHook.onPostCommitFiberRoot(rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition, releaseRootPooledCache(root, remainingLanes);
    }
}
function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
}
function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
                error = createClassErrorUpdate(2);
                instance = enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && (initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    workInProgressRoot === root && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === workInProgressRootExitStatus || 3 === workInProgressRootExitStatus && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && 300 > now() - globalMostRecentFallbackTime ? 0 === (executionContext & 2) ? prepareFreshStack(root, 0) : workInProgressRootPingedLanes |= pingedLanes : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
    ensureRootIsScheduled(root);
}
function retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = claimNextRetryLane());
    boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
}
function retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    retryTimedOutBoundary(boundaryFiber, retryLane);
}
function resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error(formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    retryTimedOutBoundary(boundaryFiber, retryLane);
}
function scheduleCallback$1(priorityLevel, callback) {
    return scheduleCallback$3(priorityLevel, callback);
}
var firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = !1, mightHavePendingSyncWork = !1, isFlushingWork = !1, currentEventTransitionLane = 0;
function ensureRootIsScheduled(root) {
    root !== lastScheduledRoot && null === root.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root : lastScheduledRoot = lastScheduledRoot.next = root);
    mightHavePendingSyncWork = !0;
    didScheduleMicrotask || (didScheduleMicrotask = !0, scheduleImmediateRootScheduleTask());
}
function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!isFlushingWork && mightHavePendingSyncWork) {
        isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = workInProgressRootRenderLanes, JSCompiler_inline_result = getNextLanes(root$190, root$190 === workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        isFlushingWork = !1;
    }
}
function processRootScheduleInImmediateTask() {
    processRootScheduleInMicrotask();
}
function processRootScheduleInMicrotask() {
    mightHavePendingSyncWork = didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== currentEventTransitionLane && shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane);
    for(var currentTime = now(), prev = null, root = firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? firstScheduledRoot = next : prev.next = next, null === next && (lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus || flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== currentEventTransitionLane && (currentEventTransitionLane = 0);
}
function scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = workInProgressRoot;
    suspendedLanes = workInProgressRootRenderLanes;
    suspendedLanes = getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && cancelCallback$1(pingedLanes);
        switch(lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = IdlePriority;
                break;
            default:
                suspendedLanes = NormalPriority$1;
        }
        pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if (flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    scheduleTaskForRootDuringMicrotask(root, now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function performSyncWorkOnRoot(root, lanes) {
    if (flushPendingEffects()) return null;
    performWorkOnRoot(root, lanes, !0);
}
function scheduleImmediateRootScheduleTask() {
    scheduleMicrotask(function() {
        0 !== (executionContext & 6) ? scheduleCallback$3(ImmediatePriority, processRootScheduleInImmediateTask) : processRootScheduleInMicrotask();
    });
}
function requestTransitionLane() {
    if (0 === currentEventTransitionLane) {
        var actionScopeLane = currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = nextTransitionUpdateLane, nextTransitionUpdateLane <<= 1, 0 === (nextTransitionUpdateLane & 261888) && (nextTransitionUpdateLane = 256));
        currentEventTransitionLane = actionScopeLane;
    }
    return currentEventTransitionLane;
}
function coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : sanitizeURL(actionProp);
}
function extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = coerceFormActionProp((nativeEventTarget[internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[internalPropsKey] || null) ? coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var i$jscomp$inline_1667 = 0; i$jscomp$inline_1667 < simpleEventPluginEvents.length; i$jscomp$inline_1667++){
    var eventName$jscomp$inline_1668 = simpleEventPluginEvents[i$jscomp$inline_1667], domEventName$jscomp$inline_1669 = eventName$jscomp$inline_1668.toLowerCase(), capitalizedEvent$jscomp$inline_1670 = eventName$jscomp$inline_1668[0].toUpperCase() + eventName$jscomp$inline_1668.slice(1);
    registerSimpleEvent(domEventName$jscomp$inline_1669, "on" + capitalizedEvent$jscomp$inline_1670);
}
registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
registerSimpleEvent(ANIMATION_START, "onAnimationStart");
registerSimpleEvent("dblclick", "onDoubleClick");
registerSimpleEvent("focusin", "onFocus");
registerSimpleEvent("focusout", "onBlur");
registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
registerSimpleEvent(TRANSITION_START, "onTransitionStart");
registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(mediaEventTypes));
function processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || (addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[listeningMarker]) {
        rootContainerElement[listeningMarker] = !0;
        allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && (nonDelegatedEvents.has(domEventName) || listenToNativeEvent(domEventName, !1, rootContainerElement), listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[listeningMarker] || (ownerDocument[listeningMarker] = !0, listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch(getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = SyntheticTouchEvent;
                        break;
                    case ANIMATION_END:
                    case ANIMATION_ITERATION:
                    case ANIMATION_START:
                        SyntheticEventCtor = SyntheticAnimationEvent;
                        break;
                    case TRANSITION_END:
                        SyntheticEventCtor = SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = getListener(instance, reactEventName), null != _instance && inCapturePhase.push(createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && (getClosestInstanceFromNode(reactEventType) || reactEventType[internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? getLowestCommonAncestor(reactName, SyntheticEventCtor, getParent) : null;
                        null !== reactName && accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = getTargetInstForChangeEvent;
                else if (isTextInputElement(reactName)) {
                    if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = getTargetInstForInputEventPolyfill;
                        var handleEventFunc = handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && isCustomElement(targetInst.elementType) && (getTargetInstFunc = getTargetInstForChangeEvent) : getTargetInstFunc = getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if (isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) activeElement = handleEventFunc, activeElementInst = targetInst, lastSelection = null;
                    break;
                case "focusout":
                    lastSelection = activeElementInst = activeElement = null;
                    break;
                case "mousedown":
                    mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    mouseDown = !1;
                    constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if (skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if (canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else isComposing ? isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && (useFallbackCompositionData && "ko" !== nativeEvent.locale && (isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && isComposing && (fallbackData = getData()) : (root = nativeEventTarget, startText = "value" in root ? root.value : root.textContent, isComposing = !0)), handleEventFunc = accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = canUseTextInputEvent ? getNativeBeforeInputChars(domEventName, nativeEvent) : getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = getListener(targetFiber, captureName), null != _instance2 && listeners.unshift(createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = getListener(targetFiber, reactName), null != _instance2 && listeners.push(createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = getListener(target, registrationName), null != stateNode && listeners.unshift(createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = getListener(target, registrationName), null != stateNode && listeners.push(createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var NORMALIZE_NEWLINES_REGEX = /\r\n?/g, NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function checkForUnmatchedText(serverText, clientText) {
    clientText = normalizeMarkupForTextOrAttribute(clientText);
    return normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && setProp(domElement, tag, "name", props.name, props, null), setProp(domElement, tag, "formEncType", props.formEncType, props, null), setProp(domElement, tag, "formMethod", props.formMethod, props, null), setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : (setProp(domElement, tag, "encType", props.encType, props, null), setProp(domElement, tag, "method", props.method, props, null), setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = noop$1);
            return;
        case "onScroll":
            null != value && listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error(formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error(formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            listenToNonDelegatedEvent("beforetoggle", domElement);
            listenToNonDelegatedEvent("toggle", domElement);
            setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = aliases.get(key) || key, setValueForAttribute(domElement, key, value);
            else return;
    }
    viewTransitionMutationContext = !0;
}
function setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error(formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error(formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : setValueForAttribute(domElement, key, value);
            }
            return;
    }
    viewTransitionMutationContext = !0;
}
function setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            listenToNonDelegatedEvent("error", domElement);
            listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error(formatProdErrorMessage(137, tag));
                    default:
                        setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error(formatProdErrorMessage(137, tag));
                        break;
                    default:
                        setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? updateOptions(domElement, !!hasSrc, tag, !1) : null != props && updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error(formatProdErrorMessage(91));
                    break;
                default:
                    setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            listenToNonDelegatedEvent("beforetoggle", domElement);
            listenToNonDelegatedEvent("toggle", domElement);
            listenToNonDelegatedEvent("cancel", domElement);
            listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            listenToNonDelegatedEvent("error", domElement);
            listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            listenToNonDelegatedEvent("error", domElement), listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error(formatProdErrorMessage(137, tag));
                default:
                    setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if (isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var emptyProps = {};
function updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && (viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && (viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && (viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && (viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && (viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && (viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error(formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && (viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && (viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && (viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? updateOptions(domElement, !!lastProps, tag, !0) : updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && (viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && (viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error(formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && setProp(domElement, tag, value, name, nextProps, type);
            }
            updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && (viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error(formatProdErrorMessage(137, tag));
                    break;
                default:
                    setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if (isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var eventsEnabled = null, selectionInformation = null;
function getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[internalPropsKey] = props;
    setInitialProperties(rootContainerInstance, type, props);
    markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var currentPopstateTransitionEvent = null;
function shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === currentPopstateTransitionEvent) return !1;
        currentPopstateTransitionEvent = event;
        return !0;
    }
    currentPopstateTransitionEvent = null;
    return !1;
}
var scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, localPromise = "function" === typeof Promise ? Promise : void 0, localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : scheduleTimeout, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof localPromise ? function(callback) {
    return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
} : scheduleTimeout;
function handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function isSingletonScope(type) {
    return "head" === type;
}
function clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    retryIfBlockedOn(hydrationInstance);
}
function hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return createMeasurement(rect, computedStyle, instance);
}
function measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return createMeasurement(measuredRect, computedStyle, instance);
}
function forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && (forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += estimateImageBytes(suspenseyImage);
                            if (imgBytes > estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise(waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function createViewTransitionInstance(name) {
    return {
        name: name,
        group: new ViewTransitionPseudoElement("group", name),
        imagePair: new ViewTransitionPseudoElement("image-pair", name),
        old: new ViewTransitionPseudoElement("old", name),
        new: new ViewTransitionPseudoElement("new", name)
    };
}
function FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = getAttachOptions(_listeners$index.optionsOrUseCapture);
        traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
FragmentInstance.prototype.focus = function(focusOptions) {
    traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = getInstanceFromHostFiber(fiber);
    return setFocusIfFocusable(fiber, focusOptions);
}
FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
FragmentInstance.prototype.blur = function() {
    var parentHostFiber = getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = getInstanceFromHostFiber(parentHostFiber), parentHostFiber = getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, observeChild, observer, void 0, void 0);
};
function observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < pendingIntersectionUnobserves.length; i++){
            var pending = pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : pendingIntersectionUnobserves[observers++] = pending;
        }
        pendingIntersectionUnobserves.length = observers;
    }
};
function unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var pendingIntersectionUnobserves = [], intersectionUnobserveScheduled = !1;
function schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    intersectionUnobserveScheduled || (intersectionUnobserveScheduled = !0, requestPostPaintCallback(function() {
        intersectionUnobserveScheduled = !1;
        var pending = pendingIntersectionUnobserves;
        pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, collectClientRects, rects, void 0, void 0);
    return rects;
};
function collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, collectChildren, children, void 0, void 0);
    var parentHostInstance = getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if (fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = getInstanceFromHostFiber(children[0]);
    result = getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : (traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = searchTarget, searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = getLowestCommonAncestor(followingBoundaryFiber, otherFiber, getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : (traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = searchTarget, searchBoundary = searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error(formatProdErrorMessage(566));
    var children = [];
    traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = getInstanceFromHostFiber(hostSiblings);
            scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = getInstanceFromHostFiber(child), scrollTextNodeIntoView(child, resolvedAlignToTop)) : getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function addFragmentHandleToFiber(child, fragmentInstance) {
    child = getInstanceFromHostFiber(child);
    addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < pendingIntersectionUnobserves.length; i++){
            var pending = pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                clearContainerSparingly(node);
                detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var previousHydratableOnEnteringScopedSingleton = null;
function getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function requestPostPaintCallback(callback) {
    localRequestAnimationFrame(function() {
        localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function resolveSingletonInstance(type, props, rootContainerInstance) {
    props = getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error(formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error(formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error(formatProdErrorMessage(454));
            return type;
        default:
            throw Error(formatProdErrorMessage(451));
    }
}
function releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && setProp(instance, type, propKey, null, emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === noop$1 && (instance.onclick = null);
    detachDeletedInstance(instance);
}
function clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    detachDeletedInstance(instance);
}
var preloadPropsMap = new Map(), preconnectsSet = new Set();
function getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var previousDispatcher = ReactDOMSharedInternals.d;
ReactDOMSharedInternals.d = {
    f: flushSyncWork,
    r: requestFormReset,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
};
function flushSyncWork() {
    var previousWasRendering = previousDispatcher.f(), wasRendering = flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function requestFormReset(form) {
    var formInst = getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? requestFormReset$1(formInst) : previousDispatcher.r(form);
}
var globalDocument = "undefined" === typeof document ? null : document;
function preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        preconnectsSet.has(limitedEscapedHref) || (preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), setInitialProperties(href, "link", rel), markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function prefetchDNS(href) {
    previousDispatcher.D(href);
    preconnectAs("dns-prefetch", href, null);
}
function preconnect(href, crossOrigin) {
    previousDispatcher.C(href, crossOrigin);
    preconnectAs("preconnect", href, crossOrigin);
}
function preload(href, as, options) {
    previousDispatcher.L(href, as, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = getStyleKey(href);
                break;
            case "script":
                key = getScriptKey(href);
        }
        if (!(preloadPropsMap.has(key) || (href = assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector(getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector(getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            setInitialProperties(instance, "link", href);
            "style" === as && (instance[internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                clearPendingLoadOnNode(instance);
            });
            markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function preloadModule(href, options) {
    previousDispatcher.m(href, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = getScriptKey(href);
        }
        if (!preloadPropsMap.has(key) && (href = assign({
            rel: "modulepreload",
            href: href
        }, options), preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector(getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            setInitialProperties(as, "link", href);
            markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function preinitStyle(href, precedence, options) {
    previousDispatcher.S(href, precedence, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
        var styles = getResourcesFromRoot(ownerDocument).hoistableStyles, key = getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector(getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                markNodeAsHoistable(link);
                setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function preinitScript(src, options) {
    previousDispatcher.X(src, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
        var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
            src: src,
            async: !0
        }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function preinitModuleScript(src, options) {
    previousDispatcher.M(src, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
        var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = rootInstanceStackCursor.current) ? getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error(formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = getStyleKey(pendingProps.href), currentProps = getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = getStyleKey(pendingProps.href);
                var styles$268 = getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector(getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, preloadPropsMap.set(type, styles$268)), preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error(formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error(formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = getScriptKey(pendingProps), currentProps = getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error(formatProdErrorMessage(444, type));
    }
}
function getStyleKey(href) {
    return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function stylesheetPropsFromRawProps(rawProps) {
    return assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[internalLoadPendingKey] = !0, key.onload = key.onerror = clearPendingLoadOnNode.bind(null, key), setInitialProperties(key, "link", preloadProps), markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function getScriptKey(src) {
    return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, markNodeAsHoistable(instance), instance;
            var styleProps = assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            markNodeAsHoistable(instance);
            setInitialProperties(instance, "style", styleProps);
            insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector(getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, markNodeAsHoistable(instance$274), instance$274;
            instance = stylesheetPropsFromRawProps(props);
            (styleProps = preloadPropsMap.get(styleProps)) && adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector(getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = preloadPropsMap.get(instance$274)) instance = assign({}, props), adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            markNodeAsHoistable(styleProps);
            setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error(formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var tagCaches = null;
function getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === tagCaches) {
        var cache = new Map();
        var caches = tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[internalHoistableMarker] || node[internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = getStyleKey(props.href), instance = hoistableRoot.querySelector(getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = stylesheetPropsFromRawProps(props);
            (key = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var estimatedBytesWithinLimit = 0;
function waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === estimatedBytesWithinLimit && (estimatedBytesWithinLimit = 62500 * estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function onUnsuspend() {
    this.count--;
    checkIfFullyUnsuspended(this);
}
function onUnsuspendImg() {
    this.imgCount--;
    checkIfFullyUnsuspended(this);
}
var precedencesByRoot = null;
function insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, precedencesByRoot = new Map(), resources.forEach(insertStylesheetIntoRoot, state), precedencesByRoot = null, onUnsuspend.call(state));
}
function insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var HostTransitionContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: sharedNotPendingObject,
    _currentValue2: sharedNotPendingObject,
    _threadCount: 0
};
function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = createLaneMap(0);
    this.hiddenUpdates = createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function getContextForSubtree(parentComponent) {
    if (!parentComponent) return emptyContextObject;
    parentComponent = emptyContextObject;
    return parentComponent;
}
function updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = enqueueUpdate(rootFiber, container, lane);
    null !== element && (scheduleUpdateOnFiber(element, rootFiber, lane), entangleTransitions(element, rootFiber, lane));
}
function markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function markRetryLaneIfNotHydrated(fiber, retryLane) {
    markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
}
function attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && scheduleUpdateOnFiber(root, fiber, 67108864);
        markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = requestUpdateLane();
        lane = getBumpedLaneForHydrationByLane(lane);
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && scheduleUpdateOnFiber(root, fiber, lane);
        markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var _enabled = !0;
function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 2, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 8, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (_enabled) {
        var blockedOn = findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer), clearIfContinuousEvent(domEventName, nativeEvent);
        else if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if (clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                ensureRootIsScheduled(fiber);
                                0 === (executionContext & 6) && (workInProgressRootRenderTargetTime = now() + 500, flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = enqueueConcurrentRenderForLane(fiber, 2), null !== root && scheduleUpdateOnFiber(root, fiber, 2), flushSyncWork$1(), markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = findInstanceBlockingEvent(nativeEvent);
                null === fiber && dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = getEventTarget(nativeEvent);
    return findInstanceBlockingTarget(nativeEvent);
}
var return_targetInst = null;
function findInstanceBlockingTarget(targetNode) {
    return_targetInst = null;
    targetNode = getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    return_targetInst = targetNode;
    return null;
}
function getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch(getCurrentPriorityLevel()){
                case ImmediatePriority:
                    return 2;
                case UserBlockingPriority:
                    return 8;
                case NormalPriority$1:
                case LowPriority:
                    return 32;
                case IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var hasScheduledReplayAttempt = !1, queuedFocus = null, queuedDrag = null, queuedMouse = null, queuedPointers = new Map(), queuedPointerCaptures = new Map(), queuedExplicitHydrationTargets = [], discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = getInstanceFromNode(blockedOn), null !== blockedOn && attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, queuedPointerCaptures.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    runWithPriority(queuedTarget.priority, function() {
                        attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    runWithPriority(queuedTarget.priority, function() {
                        attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            currentReplayingEvent = null;
        } else return targetContainers = getInstanceFromNode(nextBlockedOn), null !== targetContainers && attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function replayUnblockedEvents() {
    hasScheduledReplayAttempt = !1;
    null !== queuedFocus && attemptReplayContinuousQueuedEvent(queuedFocus) && (queuedFocus = null);
    null !== queuedDrag && attemptReplayContinuousQueuedEvent(queuedDrag) && (queuedDrag = null);
    null !== queuedMouse && attemptReplayContinuousQueuedEvent(queuedMouse) && (queuedMouse = null);
    queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
    queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
}
function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, hasScheduledReplayAttempt || (hasScheduledReplayAttempt = !0, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents)));
}
var lastScheduledReplayQueue = null;
function scheduleReplayQueueIfNeeded(formReplayingQueue) {
    lastScheduledReplayQueue !== formReplayingQueue && (lastScheduledReplayQueue = formReplayingQueue, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, function() {
        lastScheduledReplayQueue === formReplayingQueue && (lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
    null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
    null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
    queuedPointers.forEach(unblock);
    queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < queuedExplicitHydrationTargets.length && (i = queuedExplicitHydrationTargets[0], null === i.blockedOn);)attemptExplicitHydrationTarget(i), null === i.blockedOn && queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            scheduleReplayQueueIfNeeded(i);
        }
    }
}
function defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error(formatProdErrorMessage(409));
    var current = root.current, lane = requestUpdateLane();
    updateContainerImpl(current, lane, children, root, null, null);
};
ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        updateContainerImpl(root.current, 2, null, root, null, null);
        flushSyncWork$1();
        container[internalContainerInstanceKey] = null;
    }
};
function ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < queuedExplicitHydrationTargets[i].priority; i++);
        queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && attemptExplicitHydrationTarget(target);
    }
};
var isomorphicReactPackageVersion$jscomp$inline_2043 = React.version;
if ("19.3.1" !== isomorphicReactPackageVersion$jscomp$inline_2043) throw Error(formatProdErrorMessage(527, isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.1"));
ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error(formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error(formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: ReactSharedInternals,
    reconcilerVersion: "19.3.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!hook$jscomp$inline_2587.isDisabled && hook$jscomp$inline_2587.supportsFiber) try {
        rendererID = hook$jscomp$inline_2587.inject(internals$jscomp$inline_2586), injectedHook = hook$jscomp$inline_2587;
    } catch (err) {}
}
exports.createRoot = function(container, options) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, defaultOnDefaultTransitionIndicator);
    container[internalContainerInstanceKey] = options.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMRoot(options);
};
exports.hydrateRoot = function(container, initialChildren, options) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, defaultOnDefaultTransitionIndicator);
    initialChildren.context = getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = requestUpdateLane();
    isStrictMode = getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    markRootUpdated$1(initialChildren, options);
    ensureRootIsScheduled(initialChildren);
    container[internalContainerInstanceKey] = initialChildren.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMHydrationRoot(initialChildren);
};
exports.version = "19.3.1";

},{"934b50a50c275743":"kR9ca","56d30b16d84cc622":"fiCYj","d42dbe4aacaa6df4":"iix0C"}],"kR9ca":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("c2333c22ee790411");

},{"c2333c22ee790411":"bfR1F"}],"bfR1F":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > compare(left, last)) rightIndex < length && 0 > compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
exports.unstable_now = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var localPerformance = performance;
    exports.unstable_now = function() {
        return localPerformance.now();
    };
} else {
    var localDate = Date, initialTime = localDate.now();
    exports.unstable_now = function() {
        return localDate.now() - initialTime;
    };
}
var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = !1, isHostCallbackScheduled = !1, isHostTimeoutScheduled = !1, needsPaint = !1, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function advanceTimers(currentTime) {
    for(var timer = peek(timerQueue); null !== timer;){
        if (null === timer.callback) pop(timerQueue);
        else if (timer.startTime <= currentTime) pop(timerQueue), timer.sortIndex = timer.expirationTime, push(taskQueue, timer);
        else break;
        timer = peek(timerQueue);
    }
}
function handleTimeout(currentTime) {
    isHostTimeoutScheduled = !1;
    advanceTimers(currentTime);
    if (!isHostCallbackScheduled) {
        if (null !== peek(taskQueue)) isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = peek(timerQueue);
            null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var isMessageLoopRunning = !1, taskTimeoutID = -1, frameInterval = 5, startTime = -1;
function shouldYieldToHost() {
    return needsPaint ? !0 : exports.unstable_now() - startTime < frameInterval ? !1 : !0;
}
function performWorkUntilDeadline() {
    needsPaint = !1;
    if (isMessageLoopRunning) {
        var currentTime = exports.unstable_now();
        startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                isHostCallbackScheduled = !1;
                isHostTimeoutScheduled && (isHostTimeoutScheduled = !1, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
                isPerformingWork = !0;
                var previousPriorityLevel = currentPriorityLevel;
                try {
                    b: {
                        advanceTimers(currentTime);
                        for(currentTask = peek(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost());){
                            var callback = currentTask.callback;
                            if ("function" === typeof callback) {
                                currentTask.callback = null;
                                currentPriorityLevel = currentTask.priorityLevel;
                                var continuationCallback = callback(currentTask.expirationTime <= currentTime);
                                currentTime = exports.unstable_now();
                                if ("function" === typeof continuationCallback) {
                                    currentTask.callback = continuationCallback;
                                    advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                currentTask === peek(taskQueue) && pop(taskQueue);
                                advanceTimers(currentTime);
                            } else pop(taskQueue);
                            currentTask = peek(taskQueue);
                        }
                        if (null !== currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = peek(timerQueue);
                            null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = !1;
        }
    }
}
var schedulePerformWorkUntilDeadline;
if ("function" === typeof localSetImmediate) schedulePerformWorkUntilDeadline = function() {
    localSetImmediate(performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var channel = new MessageChannel(), port = channel.port2;
    channel.port1.onmessage = performWorkUntilDeadline;
    schedulePerformWorkUntilDeadline = function() {
        port.postMessage(null);
    };
} else schedulePerformWorkUntilDeadline = function() {
    localSetTimeout(performWorkUntilDeadline, 0);
};
function requestHostTimeout(callback, ms) {
    taskTimeoutID = localSetTimeout(function() {
        callback(exports.unstable_now());
    }, ms);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(task) {
    task.callback = null;
};
exports.unstable_forceFrameRate = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return currentPriorityLevel;
};
exports.unstable_next = function(eventHandler) {
    switch(currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = currentPriorityLevel;
    }
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        currentPriorityLevel = previousPriorityLevel;
    }
};
exports.unstable_requestPaint = function() {
    needsPaint = !0;
};
exports.unstable_runWithPriority = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        currentPriorityLevel = previousPriorityLevel;
    }
};
exports.unstable_scheduleCallback = function(priorityLevel, callback, options) {
    var currentTime = exports.unstable_now();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, push(timerQueue, priorityLevel), null === peek(taskQueue) && priorityLevel === peek(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = !0, requestHostTimeout(handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, push(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
exports.unstable_shouldYield = shouldYieldToHost;
exports.unstable_wrapCallback = function(callback) {
    var parentPriorityLevel = currentPriorityLevel;
    return function() {
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    };
};

},{}],"fiCYj":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("1803ac46c34b822c");

},{"1803ac46c34b822c":"2VMVL"}],"2VMVL":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, assign = Object.assign, emptyObject = {};
function Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
Component.prototype.isReactComponent = {};
Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function ComponentDummy() {}
ComponentDummy.prototype = Component.prototype;
function PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent;
assign(pureComponentPrototype, Component.prototype);
pureComponentPrototype.isPureReactComponent = !0;
var isArrayImpl = Array.isArray;
function noop() {}
var ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, hasOwnProperty = Object.prototype.hasOwnProperty;
function ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function cloneAndReplaceKey(oldElement, newKey) {
    return ReactElement(oldElement.type, newKey, oldElement.props);
}
function isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
}
function escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var userProvidedKeyEscapeRegex = /\/+/g;
function getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? escape("" + element.key) : index.toString(36);
}
function resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then(noop, noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case REACT_LAZY_TYPE:
                    return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar, isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && (isValidElement(callback) && (callback = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function startTransition(scope) {
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then(noop, reportGlobalError);
    } catch (error) {
        reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
    }
}
function addTransitionType(type) {
    var transition = ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else startTransition(addTransitionType.bind(null, type));
}
var Children = {
    map: mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
exports.Activity = REACT_ACTIVITY_TYPE;
exports.Children = Children;
exports.Component = Component;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.PureComponent = PureComponent;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.ViewTransition = REACT_VIEW_TRANSITION_TYPE;
exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
exports.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(size) {
        return ReactSharedInternals.H.useMemoCache(size);
    }
};
exports.addTransitionType = addTransitionType;
exports.cache = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
exports.cacheSignal = function() {
    return null;
};
exports.cloneElement = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return ReactElement(element.type, key, props);
};
exports.createContext = function(defaultValue) {
    defaultValue = {
        $$typeof: REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
exports.createElement = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return ReactElement(type, key, props);
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(render) {
    return {
        $$typeof: REACT_FORWARD_REF_TYPE,
        render: render
    };
};
exports.isValidElement = isValidElement;
exports.lazy = function(ctor) {
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: lazyInitializer
    };
};
exports.memo = function(type, compare) {
    return {
        $$typeof: REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
exports.startTransition = startTransition;
exports.unstable_useCacheRefresh = function() {
    return ReactSharedInternals.H.useCacheRefresh();
};
exports.use = function(usable) {
    return ReactSharedInternals.H.use(usable);
};
exports.useActionState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
exports.useCallback = function(callback, deps) {
    return ReactSharedInternals.H.useCallback(callback, deps);
};
exports.useContext = function(Context) {
    return ReactSharedInternals.H.useContext(Context);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(value, initialValue) {
    return ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
exports.useEffect = function(create, deps) {
    return ReactSharedInternals.H.useEffect(create, deps);
};
exports.useEffectEvent = function(callback) {
    return ReactSharedInternals.H.useEffectEvent(callback);
};
exports.useId = function() {
    return ReactSharedInternals.H.useId();
};
exports.useImperativeHandle = function(ref, create, deps) {
    return ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
exports.useInsertionEffect = function(create, deps) {
    return ReactSharedInternals.H.useInsertionEffect(create, deps);
};
exports.useLayoutEffect = function(create, deps) {
    return ReactSharedInternals.H.useLayoutEffect(create, deps);
};
exports.useMemo = function(create, deps) {
    return ReactSharedInternals.H.useMemo(create, deps);
};
exports.useOptimistic = function(passthrough, reducer) {
    return ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
exports.useReducer = function(reducer, initialArg, init) {
    return ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
exports.useRef = function(initialValue) {
    return ReactSharedInternals.H.useRef(initialValue);
};
exports.useState = function(initialState) {
    return ReactSharedInternals.H.useState(initialState);
};
exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
    return ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
exports.useTransition = function() {
    return ReactSharedInternals.H.useTransition();
};
exports.version = "19.3.1";

},{}],"iix0C":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("b657abac8afb5bb8");

},{"b657abac8afb5bb8":"l8vtO"}],"l8vtO":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("6a05e75e64e4f862");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function noop() {}
var Internals = {
    d: {
        f: noop,
        r: function() {
            throw Error(formatProdErrorMessage(522));
        },
        D: noop,
        C: noop,
        L: noop,
        m: noop,
        X: noop,
        S: noop,
        M: noop
    },
    p: 0,
    findDOMNode: null
}, REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: REACT_PORTAL_TYPE,
        key: null == key ? null : key === REACT_OPTIMISTIC_KEY ? REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
exports.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
exports.browser = function(reason) {
    return {
        $$typeof: REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
exports.createPortal = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error(formatProdErrorMessage(299));
    return createPortal$1(children, container, null, key);
};
exports.flushSync = function(fn) {
    var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
    try {
        if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
    } finally{
        ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f();
    }
};
exports.preconnect = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
};
exports.prefetchDNS = function(href) {
    "string" === typeof href && Internals.d.D(href);
};
exports.preinit = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
exports.preinitModule = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
                Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && Internals.d.M(href);
    }
};
exports.preload = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin);
        Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
exports.preloadModule = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
            Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else Internals.d.m(href);
    }
};
exports.requestFormReset = function(form) {
    Internals.d.r(form);
};
exports.unstable_batchedUpdates = function(fn, a) {
    return fn(a);
};
exports.useFormState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
exports.useFormStatus = function() {
    return ReactSharedInternals.H.useHostTransitionStatus();
};
exports.version = "19.3.1";

},{"6a05e75e64e4f862":"fiCYj"}],"fh3rg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "App", ()=>App);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _checkbox = require("./Checkbox");
var _dateInput = require("./DateInput");
var _graph = require("./Graph");
var _source = require("./source");
var _state = require("./state");
var _support = require("./support");
var _ripeNccSvg = require("../images/ripe-ncc.svg");
var _ripeNccSvgDefault = parcelHelpers.interopDefault(_ripeNccSvg);
const App = ()=>{
    const [state, dispatch] = (0, _react.useReducer)((0, _state.reduce), (0, _state.initState));
    (0, _react.useEffect)(()=>{
        (async ()=>{
            dispatch((0, _state.Actions).loading);
            try {
                const sourceData = (await Promise.all(Object.entries(state.sources).map(async ([name, source])=>({
                        [name]: await (0, _source.loadSource)(name, source.url)
                    })))).reduce((0, _support.merge));
                dispatch((0, _state.Actions).sourceDataLoaded(sourceData));
            } catch (e) {
                dispatch((0, _state.Actions).reportError(e));
            }
        })();
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("article", {
        role: "page",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "logo",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "#",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: (0, _ripeNccSvgDefault.default),
                                alt: "RIPE NCC"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "application",
                        children: "Resource Certification Stats"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "content-wrapper",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("aside", {
                        role: "filter",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("nav", {
                                className: "card",
                                children: Object.entries(state.sources).map(([name, source])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                                        label: name,
                                        checked: source.enabled,
                                        onChange: ()=>dispatch((0, _state.Actions).toggleSource(name, !source.enabled))
                                    }, name))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("nav", {
                                className: "card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateInput.DateInput), {
                                        label: "From",
                                        value: state.period.from,
                                        onChange: (d)=>dispatch((0, _state.Actions).filterFrom(d))
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateInput.DateInput), {
                                        label: "Until",
                                        value: state.period.until,
                                        onChange: (d)=>dispatch((0, _state.Actions).filterUntil(d))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("main", {
                        children: [
                            state.error != null && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "card danger",
                                children: state.error
                            }),
                            state.loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "overlay",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "loading",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "circle"
                                    })
                                })
                            }),
                            !(0, _support.isEmpty)(state.data) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _graph.Graph), {
                                        title: "Number of Certificates",
                                        attr: "certs",
                                        attrFriendly: "Certificates",
                                        data: state.data
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _graph.Graph), {
                                        title: "Number of ROAs",
                                        attr: "roas",
                                        attrFriendly: "ROAs",
                                        data: state.data
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _graph.Graph), {
                                        title: "ASNs in ROAs",
                                        attr: "roa-asn",
                                        attrFriendly: "ASNs",
                                        data: state.data
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _graph.Graph), {
                                        title: "IPv4 prefixes in ROAs",
                                        attr: "roa-v4",
                                        attrFriendly: "IPv4 Prefixes",
                                        data: state.data
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _graph.Graph), {
                                        title: "IPv4 address space in ROAs (/24s)",
                                        attr: "roa-v4u",
                                        attrFriendly: "IPv4 /24",
                                        data: state.data
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _graph.Graph), {
                                        title: "IPv6 prefixes in ROAs",
                                        attr: "roa-v6",
                                        attrFriendly: "IPv6 prefixes",
                                        data: state.data
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _graph.Graph), {
                                        title: "IPv6 address space in ROAs (/48s)",
                                        attr: "roa-v6u",
                                        attrFriendly: "IPv6 /48",
                                        data: state.data
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("footer", {
                children: [
                    "These graphs are rendered from statistics collected daily by the RIPE NCC. This service runs on a best-effort basis. If you would like to get in touch, please contact ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: "mailto:rpki@ripe.net",
                        children: "rpki@ripe.net"
                    }),
                    "."
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"85GGX","react":"fiCYj","./Checkbox":"4Hpx5","./DateInput":"Xvckh","./Graph":"ceZVp","./source":"hCcdg","./state":"27PUe","./support":"baiVm","../images/ripe-ncc.svg":"iQcr7","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4Hpx5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkbox", ()=>Checkbox);
var _jsxRuntime = require("react/jsx-runtime");
const Checkbox = ({ label, checked, onChange })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
        className: "checkbox",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "checkbox",
                checked: checked,
                onChange: onChange
            }),
            label
        ]
    });

},{"react/jsx-runtime":"85GGX","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"31Xmp":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"Xvckh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateInput", ()=>DateInput);
var _jsxRuntime = require("react/jsx-runtime");
const DateInput = ({ label, value, onChange })=>{
    const pad = (n)=>String(n).padStart(2, "0");
    const val = value != null ? `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}` : "";
    const change = (e)=>onChange(new Date(e.target.value));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
        className: "date-input",
        children: [
            label,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "date",
                value: val,
                onChange: change
            })
        ]
    });
};

},{"react/jsx-runtime":"85GGX","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"ceZVp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Graph", ()=>Graph);
var _jsxRuntime = require("react/jsx-runtime");
var _reactVega = require("react-vega");
const Graph = ({ title, attr, attrFriendly, data })=>{
    const spec = {
        "$schema": "https://vega.github.io/schema/vega-lite/v5.json",
        description: title,
        width: 1024,
        data: {
            name: "records"
        },
        transform: [
            {
                window: [
                    {
                        field: attr,
                        op: "mean",
                        as: `mean_${attr}`
                    }
                ],
                // 30 day moving average
                frame: [
                    -30,
                    0
                ],
                groupby: [
                    "source"
                ]
            }
        ],
        encoding: {
            x: {
                field: "date",
                type: "temporal",
                title: "Date"
            },
            color: {
                field: "source",
                type: "nominal",
                title: "Trust Anchor"
            },
            y: {
                field: `mean_${attr}`,
                type: "quantitative",
                title: attrFriendly
            }
        },
        mark: "line"
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
        className: "card graph",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactVega.VegaLite), {
                data: {
                    records: data
                },
                spec: spec,
                actions: {
                    export: true,
                    source: false,
                    compiled: false,
                    editor: false
                },
                renderer: "svg"
            })
        ]
    });
};

},{"react/jsx-runtime":"85GGX","react-vega":[["VegaLite","djBKc","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"djBKc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>VegaLite);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _vega = require("./Vega");
var _vegaDefault = parcelHelpers.interopDefault(_vega);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function VegaLite(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _vegaDefault.default), _extends({}, props, {
        mode: "vega-lite"
    }));
}

},{"react":"fiCYj","./Vega":"jXCOJ","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"jXCOJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _shallowEqual = require("./utils/shallowEqual");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);
var _updateMultipleDatasetsInView = require("./utils/updateMultipleDatasetsInView");
var _updateMultipleDatasetsInViewDefault = parcelHelpers.interopDefault(_updateMultipleDatasetsInView);
var _vegaEmbed = require("./VegaEmbed");
var _vegaEmbedDefault = parcelHelpers.interopDefault(_vegaEmbed);
var _constants = require("./constants");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const EMPTY = {};
class Vega extends (0, _reactDefault.default).PureComponent {
    constructor(){
        super(...arguments);
        _defineProperty(this, "vegaEmbed", /*#__PURE__*/ (0, _reactDefault.default).createRef());
        _defineProperty(this, "handleNewView", (view)=>{
            this.update();
            const { onNewView = (0, _constants.NOOP) } = this.props;
            onNewView(view);
        });
    }
    componentDidMount() {
        this.update();
    }
    componentDidUpdate(prevProps) {
        if (!(0, _shallowEqualDefault.default)(this.props.data, prevProps.data)) this.update();
    }
    update() {
        const { data } = this.props;
        if (this.vegaEmbed.current && data && Object.keys(data).length > 0) this.vegaEmbed.current.modifyView((view)=>{
            (0, _updateMultipleDatasetsInViewDefault.default)(view, data);
            view.resize().run();
        });
    }
    render() {
        const { data, ...restProps } = this.props;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _vegaEmbedDefault.default), _extends({
            ref: this.vegaEmbed
        }, restProps, {
            onNewView: this.handleNewView
        }));
    }
}
exports.default = Vega;
_defineProperty(Vega, "defaultProps", {
    data: EMPTY
});

},{"prop-types":"a6MND","react":"fiCYj","./utils/shallowEqual":"3mYvm","./utils/updateMultipleDatasetsInView":"hhPiL","./VegaEmbed":"hdxFq","./constants":"f1inr","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"a6MND":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"4hE7I"}],"4hE7I":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"4gT0C"}],"4gT0C":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"3mYvm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>shallowEqual);
const EMPTY = {};
function shallowEqual(a, b) {
    if (a === void 0) a = EMPTY;
    if (b === void 0) b = EMPTY;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    return a === b || aKeys.length === bKeys.length && aKeys.every((key)=>a[key] === b[key]);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hhPiL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>updateMultipleDatasetsInView);
var _updateSingleDatasetInView = require("./updateSingleDatasetInView");
var _updateSingleDatasetInViewDefault = parcelHelpers.interopDefault(_updateSingleDatasetInView);
function updateMultipleDatasetsInView(view, data) {
    Object.keys(data).forEach((name)=>{
        (0, _updateSingleDatasetInViewDefault.default)(view, name, data[name]);
    });
}

},{"./updateSingleDatasetInView":"1hYMr","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"1hYMr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>updateSingleDatasetInView);
var _vegaEmbed = require("vega-embed");
var _isFunction = require("./isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
function updateSingleDatasetInView(view, name, value) {
    if (value) {
        if ((0, _isFunctionDefault.default)(value)) value(view.data(name));
        else view.change(name, (0, _vegaEmbed.vega).changeset().remove(()=>true).insert(value));
    }
}

},{"vega-embed":"8VkRm","./isFunction":"hdxEG","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8VkRm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "vega", ()=>vega);
parcelHelpers.export(exports, "vegaLite", ()=>vegaLite);
parcelHelpers.export(exports, "DEFAULT_ACTIONS", ()=>DEFAULT_ACTIONS);
/**
 * Try to guess the type of spec.
 *
 * @param spec Vega or Vega-Lite spec.
 */ parcelHelpers.export(exports, "guessMode", ()=>guessMode);
parcelHelpers.export(exports, "default", ()=>embed);
var _tslib = require("tslib");
var _fastJsonPatch = require("fast-json-patch");
var _jsonStringifyPrettyCompact = require("json-stringify-pretty-compact");
var _jsonStringifyPrettyCompactDefault = parcelHelpers.interopDefault(_jsonStringifyPrettyCompact);
var _semver = require("semver");
var _vega = require("vega");
var _vegaLite = require("vega-lite");
var _vegaSchemaUrlParser = require("vega-schema-url-parser");
var _vegaSchemaUrlParserDefault = parcelHelpers.interopDefault(_vegaSchemaUrlParser);
var _vegaThemes = require("vega-themes");
var _vegaTooltip = require("vega-tooltip");
var _vegaUtil = require("vega-util");
var _post = require("./post");
var _postDefault = parcelHelpers.interopDefault(_post);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _util = require("./util");
var _a;
const vega = _vega;
let vegaLite = _vegaLite;
// For backwards compatibility with Vega-Lite before v4.
const w = typeof window !== 'undefined' ? window : undefined;
if (vegaLite === undefined && ((_a = w === null || w === void 0 ? void 0 : w['vl']) === null || _a === void 0 ? void 0 : _a.compile)) vegaLite = w['vl'];
const DEFAULT_ACTIONS = {
    export: {
        svg: true,
        png: true
    },
    source: true,
    compiled: true,
    editor: true
};
const I18N = {
    CLICK_TO_VIEW_ACTIONS: 'Click to view actions',
    COMPILED_ACTION: 'View Compiled Vega',
    EDITOR_ACTION: 'Open in Vega Editor',
    PNG_ACTION: 'Save as PNG',
    SOURCE_ACTION: 'View Source',
    SVG_ACTION: 'Save as SVG'
};
const NAMES = {
    vega: 'Vega',
    'vega-lite': 'Vega-Lite'
};
const VERSION = {
    vega: vega.version,
    'vega-lite': vegaLite ? vegaLite.version : 'not available'
};
const PREPROCESSOR = {
    vega: (vgSpec)=>vgSpec,
    'vega-lite': (vlSpec, config)=>vegaLite.compile(vlSpec, {
            config: config
        }).spec
};
const SVG_CIRCLES = `
<svg viewBox="0 0 16 16" fill="currentColor" stroke="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
  <circle r="2" cy="8" cx="2"></circle>
  <circle r="2" cy="8" cx="8"></circle>
  <circle r="2" cy="8" cx="14"></circle>
</svg>`;
function isTooltipHandler(h) {
    return typeof h === 'function';
}
function viewSource(source, sourceHeader, sourceFooter, mode) {
    const header = `<html><head>${sourceHeader}</head><body><pre><code class="json">`;
    const footer = `</code></pre>${sourceFooter}</body></html>`;
    const win = window.open('');
    win.document.write(header + source + footer);
    win.document.title = `${NAMES[mode]} JSON Source`;
}
function guessMode(spec, providedMode) {
    var _a;
    // Decide mode
    if (spec.$schema) {
        const parsed = (0, _vegaSchemaUrlParserDefault.default)(spec.$schema);
        if (providedMode && providedMode !== parsed.library) console.warn(`The given visualization spec is written in ${NAMES[parsed.library]}, but mode argument sets ${(_a = NAMES[providedMode]) !== null && _a !== void 0 ? _a : providedMode}.`);
        const mode = parsed.library;
        if (!(0, _semver.satisfies)(VERSION[mode], `^${parsed.version.slice(1)}`)) console.warn(`The input spec uses ${NAMES[mode]} ${parsed.version}, but the current version of ${NAMES[mode]} is v${VERSION[mode]}.`);
        return mode;
    }
    // try to guess from the provided spec
    if ('mark' in spec || 'encoding' in spec || 'layer' in spec || 'hconcat' in spec || 'vconcat' in spec || 'facet' in spec || 'repeat' in spec) return 'vega-lite';
    if ('marks' in spec || 'signals' in spec || 'scales' in spec || 'axes' in spec) return 'vega';
    return providedMode !== null && providedMode !== void 0 ? providedMode : 'vega';
}
function isLoader(o) {
    return !!(o && 'load' in o);
}
function embed(el, spec, opts = {}) {
    var _a, _b, _c;
    return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
        const loader = isLoader(opts.loader) ? opts.loader : vega.loader(opts.loader);
        // load spec, config, and patch that are references by URLs
        const parsedSpec = (0, _vegaUtil.isString)(spec) ? JSON.parse((yield loader.load(spec))) : spec;
        const usermetaOpts = yield loadOpts((_a = parsedSpec.usermeta && parsedSpec.usermeta['embedOptions']) !== null && _a !== void 0 ? _a : {}, loader);
        const parsedOpts = yield loadOpts(opts, loader);
        const mergedOpts = Object.assign(Object.assign({}, (0, _util.mergeDeep)(parsedOpts, usermetaOpts)), {
            config: (0, _vegaUtil.mergeConfig)((_b = parsedOpts.config) !== null && _b !== void 0 ? _b : {}, (_c = usermetaOpts.config) !== null && _c !== void 0 ? _c : {})
        });
        return yield _embed(el, parsedSpec, mergedOpts, loader);
    });
}
function loadOpts(opt, loader) {
    var _a;
    return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
        const config = (0, _vegaUtil.isString)(opt.config) ? JSON.parse((yield loader.load(opt.config))) : (_a = opt.config) !== null && _a !== void 0 ? _a : {};
        const patch = (0, _vegaUtil.isString)(opt.patch) ? JSON.parse((yield loader.load(opt.patch))) : opt.patch;
        return Object.assign(Object.assign(Object.assign({}, opt), patch ? {
            patch
        } : {}), config ? {
            config
        } : {});
    });
}
function _embed(el, spec, opts = {}, loader) {
    var _a, _b, _c, _d, _e, _f;
    return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
        const config = opts.theme ? (0, _vegaUtil.mergeConfig)(_vegaThemes[opts.theme], (_a = opts.config) !== null && _a !== void 0 ? _a : {}) : opts.config;
        const actions = (0, _vegaUtil.isBoolean)(opts.actions) ? opts.actions : (0, _util.mergeDeep)({}, DEFAULT_ACTIONS, (_b = opts.actions) !== null && _b !== void 0 ? _b : {});
        const i18n = Object.assign(Object.assign({}, I18N), opts.i18n);
        const renderer = (_c = opts.renderer) !== null && _c !== void 0 ? _c : 'canvas';
        const logLevel = (_d = opts.logLevel) !== null && _d !== void 0 ? _d : vega.Warn;
        const downloadFileName = (_e = opts.downloadFileName) !== null && _e !== void 0 ? _e : 'visualization';
        if (opts.defaultStyle !== false) {
            // Add a default stylesheet to the head of the document.
            const ID = 'vega-embed-style';
            if (!document.getElementById(ID)) {
                const style = document.createElement('style');
                style.id = ID;
                style.innerText = opts.defaultStyle === undefined || opts.defaultStyle === true ? ((0, _styleDefault.default) !== null && (0, _styleDefault.default) !== void 0 ? (0, _styleDefault.default) : '').toString() : opts.defaultStyle;
                document.head.appendChild(style);
            }
        }
        const mode = guessMode(spec, opts.mode);
        let vgSpec = PREPROCESSOR[mode](spec, config);
        if (mode === 'vega-lite') {
            if (vgSpec.$schema) {
                const parsed = (0, _vegaSchemaUrlParserDefault.default)(vgSpec.$schema);
                if (!(0, _semver.satisfies)(VERSION.vega, `^${parsed.version.slice(1)}`)) console.warn(`The compiled spec uses Vega ${parsed.version}, but current version is v${VERSION.vega}.`);
            }
        }
        const div = typeof el === 'string' ? document.querySelector(el) : el;
        if (!div) throw Error(`${el} does not exist`);
        div.classList.add('vega-embed');
        if (actions) div.classList.add('has-actions');
        div.innerHTML = ''; // clear container
        const patch = opts.patch;
        if (patch) {
            if (patch instanceof Function) vgSpec = patch(vgSpec);
            else vgSpec = (0, _fastJsonPatch.applyPatch)(vgSpec, patch, true, false).newDocument;
        }
        // Set locale. Note that this is a global setting.
        if (opts.formatLocale) vega.formatLocale(opts.formatLocale);
        if (opts.timeFormatLocale) vega.timeFormatLocale(opts.timeFormatLocale);
        // Do not apply the config to Vega when we have already applied it to Vega-Lite.
        // This call may throw an Error if parsing fails.
        const runtime = vega.parse(vgSpec, mode === 'vega-lite' ? {} : config);
        const view = new vega.View(runtime, {
            loader,
            logLevel,
            renderer
        });
        if (opts.tooltip !== false) {
            let handler;
            if (isTooltipHandler(opts.tooltip)) handler = opts.tooltip;
            else // user provided boolean true or tooltip options
            handler = new (0, _vegaTooltip.Handler)(opts.tooltip === true ? {} : opts.tooltip).call;
            view.tooltip(handler);
        }
        let { hover } = opts;
        if (hover === undefined) hover = mode === 'vega';
        if (hover) {
            const { hoverSet, updateSet } = typeof hover === 'boolean' ? {} : hover;
            view.hover(hoverSet, updateSet);
        }
        if (opts) {
            if (opts.width != null) view.width(opts.width);
            if (opts.height != null) view.height(opts.height);
            if (opts.padding != null) view.padding(opts.padding);
        }
        yield view.initialize(el).runAsync();
        let documentClickHandler;
        if (actions !== false) {
            let wrapper = div;
            if (opts.defaultStyle !== false) {
                const details = document.createElement('details');
                details.title = i18n.CLICK_TO_VIEW_ACTIONS;
                div.append(details);
                wrapper = details;
                const summary = document.createElement('summary');
                summary.innerHTML = SVG_CIRCLES;
                details.append(summary);
                documentClickHandler = (ev)=>{
                    if (!details.contains(ev.target)) details.removeAttribute('open');
                };
                document.addEventListener('click', documentClickHandler);
            }
            const ctrl = document.createElement('div');
            wrapper.append(ctrl);
            ctrl.classList.add('vega-actions');
            // add 'Export' action
            if (actions === true || actions.export !== false) {
                for (const ext of [
                    'svg',
                    'png'
                ])if (actions === true || actions.export === true || actions.export[ext]) {
                    const i18nExportAction = i18n[`${ext.toUpperCase()}_ACTION`];
                    const exportLink = document.createElement('a');
                    exportLink.text = i18nExportAction;
                    exportLink.href = '#';
                    exportLink.target = '_blank';
                    exportLink.download = `${downloadFileName}.${ext}`;
                    exportLink.addEventListener('mousedown', function(e) {
                        return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
                            e.preventDefault();
                            const url = yield view.toImageURL(ext, opts.scaleFactor);
                            this.href = url;
                        });
                    });
                    ctrl.append(exportLink);
                }
            }
            // add 'View Source' action
            if (actions === true || actions.source !== false) {
                const viewSourceLink = document.createElement('a');
                viewSourceLink.text = i18n.SOURCE_ACTION;
                viewSourceLink.href = '#';
                viewSourceLink.addEventListener('mousedown', function(e) {
                    var _a, _b;
                    viewSource((0, _jsonStringifyPrettyCompactDefault.default)(spec), (_a = opts.sourceHeader) !== null && _a !== void 0 ? _a : '', (_b = opts.sourceFooter) !== null && _b !== void 0 ? _b : '', mode);
                    e.preventDefault();
                });
                ctrl.append(viewSourceLink);
            }
            // add 'View Compiled' action
            if (mode === 'vega-lite' && (actions === true || actions.compiled !== false)) {
                const compileLink = document.createElement('a');
                compileLink.text = i18n.COMPILED_ACTION;
                compileLink.href = '#';
                compileLink.addEventListener('mousedown', function(e) {
                    var _a, _b;
                    viewSource((0, _jsonStringifyPrettyCompactDefault.default)(vgSpec), (_a = opts.sourceHeader) !== null && _a !== void 0 ? _a : '', (_b = opts.sourceFooter) !== null && _b !== void 0 ? _b : '', 'vega');
                    e.preventDefault();
                });
                ctrl.append(compileLink);
            }
            // add 'Open in Vega Editor' action
            if (actions === true || actions.editor !== false) {
                const editorUrl = (_f = opts.editorUrl) !== null && _f !== void 0 ? _f : 'https://vega.github.io/editor/';
                const editorLink = document.createElement('a');
                editorLink.text = i18n.EDITOR_ACTION;
                editorLink.href = '#';
                editorLink.addEventListener('mousedown', function(e) {
                    (0, _postDefault.default)(window, editorUrl, {
                        config: config,
                        mode,
                        renderer,
                        spec: (0, _jsonStringifyPrettyCompactDefault.default)(spec)
                    });
                    e.preventDefault();
                });
                ctrl.append(editorLink);
            }
        }
        function finalize() {
            if (documentClickHandler) document.removeEventListener('click', documentClickHandler);
            view.finalize();
        }
        return {
            view,
            spec,
            vgSpec,
            finalize
        };
    });
}

},{"tslib":"cqu50","fast-json-patch":"fc7GR","json-stringify-pretty-compact":"cxkZr","semver":"kfzMN","vega":"2Jj1D","vega-lite":"6yTPM","vega-schema-url-parser":"9X7he","vega-themes":"4U23m","vega-tooltip":"3nTGd","vega-util":"7f6sQ","./post":"iJ7ZF","./style":"6TpVF","./util":"bVMGP","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cqu50":[function(require,module,exports,__globalThis) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
parcelHelpers.export(exports, "__rewriteRelativeImportExtension", ()=>__rewriteRelativeImportExtension);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var ownKeys = function(o) {
    ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return ownKeys(o);
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function __rewriteRelativeImportExtension(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __esDecorate: __esDecorate,
    __runInitializers: __runInitializers,
    __propKey: __propKey,
    __setFunctionName: __setFunctionName,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources,
    __rewriteRelativeImportExtension: __rewriteRelativeImportExtension
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"fc7GR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JsonPatchError", ()=>(0, _helpersMjs.PatchError));
parcelHelpers.export(exports, "deepClone", ()=>(0, _helpersMjs._deepClone));
parcelHelpers.export(exports, "escapePathComponent", ()=>(0, _helpersMjs.escapePathComponent));
parcelHelpers.export(exports, "unescapePathComponent", ()=>(0, _helpersMjs.unescapePathComponent));
var _coreMjs = require("./module/core.mjs");
parcelHelpers.exportAll(_coreMjs, exports);
var _duplexMjs = require("./module/duplex.mjs");
parcelHelpers.exportAll(_duplexMjs, exports);
var _helpersMjs = require("./module/helpers.mjs");
exports.default = Object.assign({}, _coreMjs, _duplexMjs, {
    JsonPatchError: (0, _helpersMjs.PatchError),
    deepClone: (0, _helpersMjs._deepClone),
    escapePathComponent: (0, _helpersMjs.escapePathComponent),
    unescapePathComponent: (0, _helpersMjs.unescapePathComponent)
});

},{"./module/core.mjs":"3fXbK","./module/duplex.mjs":"e5ykQ","./module/helpers.mjs":"1Ea7V","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3fXbK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JsonPatchError", ()=>JsonPatchError);
parcelHelpers.export(exports, "deepClone", ()=>deepClone);
/**
 * Retrieves a value from a JSON document by a JSON pointer.
 * Returns the value.
 *
 * @param document The document to get the value from
 * @param pointer an escaped JSON pointer
 * @return The retrieved value
 */ parcelHelpers.export(exports, "getValueByPointer", ()=>getValueByPointer);
/**
 * Apply a single JSON Patch Operation on a JSON document.
 * Returns the {newDocument, result} of the operation.
 * It modifies the `document` and `operation` objects - it gets the values by reference.
 * If you would like to avoid touching your values, clone them:
 * `jsonpatch.applyOperation(document, jsonpatch._deepClone(operation))`.
 *
 * @param document The document to patch
 * @param operation The operation to apply
 * @param validateOperation `false` is without validation, `true` to use default jsonpatch's validation, or you can pass a `validateOperation` callback to be used for validation.
 * @param mutateDocument Whether to mutate the original document or clone it before applying
 * @param banPrototypeModifications Whether to ban modifications to `__proto__`, defaults to `true`.
 * @return `{newDocument, result}` after the operation
 */ parcelHelpers.export(exports, "applyOperation", ()=>applyOperation);
/**
 * Apply a full JSON Patch array on a JSON document.
 * Returns the {newDocument, result} of the patch.
 * It modifies the `document` object and `patch` - it gets the values by reference.
 * If you would like to avoid touching your values, clone them:
 * `jsonpatch.applyPatch(document, jsonpatch._deepClone(patch))`.
 *
 * @param document The document to patch
 * @param patch The patch to apply
 * @param validateOperation `false` is without validation, `true` to use default jsonpatch's validation, or you can pass a `validateOperation` callback to be used for validation.
 * @param mutateDocument Whether to mutate the original document or clone it before applying
 * @param banPrototypeModifications Whether to ban modifications to `__proto__`, defaults to `true`.
 * @return An array of `{newDocument, result}` after the patch
 */ parcelHelpers.export(exports, "applyPatch", ()=>applyPatch);
/**
 * Apply a single JSON Patch Operation on a JSON document.
 * Returns the updated document.
 * Suitable as a reducer.
 *
 * @param document The document to patch
 * @param operation The operation to apply
 * @return The updated document
 */ parcelHelpers.export(exports, "applyReducer", ()=>applyReducer);
/**
 * Validates a single operation. Called from `jsonpatch.validate`. Throws `JsonPatchError` in case of an error.
 * @param {object} operation - operation object (patch)
 * @param {number} index - index of operation in the sequence
 * @param {object} [document] - object where the operation is supposed to be applied
 * @param {string} [existingPathFragment] - comes along with `document`
 */ parcelHelpers.export(exports, "validator", ()=>validator);
/**
 * Validates a sequence of operations. If `document` parameter is provided, the sequence is additionally validated against the object document.
 * If error is encountered, returns a JsonPatchError object
 * @param sequence
 * @param document
 * @returns {JsonPatchError|undefined}
 */ parcelHelpers.export(exports, "validate", ()=>validate);
// based on https://github.com/epoberezkin/fast-deep-equal
// MIT License
// Copyright (c) 2017 Evgeny Poberezkin
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
parcelHelpers.export(exports, "_areEquals", ()=>_areEquals);
var _helpersMjs = require("./helpers.mjs");
var JsonPatchError = (0, _helpersMjs.PatchError);
var deepClone = (0, _helpersMjs._deepClone);
/* We use a Javascript hash to store each
 function. Each hash entry (property) uses
 the operation identifiers specified in rfc6902.
 In this way, we can map each patch operation
 to its dedicated function in efficient way.
 */ /* The operations applicable to an object */ var objOps = {
    add: function(obj, key, document) {
        obj[key] = this.value;
        return {
            newDocument: document
        };
    },
    remove: function(obj, key, document) {
        var removed = obj[key];
        delete obj[key];
        return {
            newDocument: document,
            removed: removed
        };
    },
    replace: function(obj, key, document) {
        var removed = obj[key];
        obj[key] = this.value;
        return {
            newDocument: document,
            removed: removed
        };
    },
    move: function(obj, key, document) {
        /* in case move target overwrites an existing value,
        return the removed value, this can be taxing performance-wise,
        and is potentially unneeded */ var removed = getValueByPointer(document, this.path);
        if (removed) removed = (0, _helpersMjs._deepClone)(removed);
        var originalValue = applyOperation(document, {
            op: "remove",
            path: this.from
        }).removed;
        applyOperation(document, {
            op: "add",
            path: this.path,
            value: originalValue
        });
        return {
            newDocument: document,
            removed: removed
        };
    },
    copy: function(obj, key, document) {
        var valueToCopy = getValueByPointer(document, this.from);
        // enforce copy by value so further operations don't affect source (see issue #177)
        applyOperation(document, {
            op: "add",
            path: this.path,
            value: (0, _helpersMjs._deepClone)(valueToCopy)
        });
        return {
            newDocument: document
        };
    },
    test: function(obj, key, document) {
        return {
            newDocument: document,
            test: _areEquals(obj[key], this.value)
        };
    },
    _get: function(obj, key, document) {
        this.value = obj[key];
        return {
            newDocument: document
        };
    }
};
/* The operations applicable to an array. Many are the same as for the object */ var arrOps = {
    add: function(arr, i, document) {
        if ((0, _helpersMjs.isInteger)(i)) arr.splice(i, 0, this.value);
        else arr[i] = this.value;
        // this may be needed when using '-' in an array
        return {
            newDocument: document,
            index: i
        };
    },
    remove: function(arr, i, document) {
        var removedList = arr.splice(i, 1);
        return {
            newDocument: document,
            removed: removedList[0]
        };
    },
    replace: function(arr, i, document) {
        var removed = arr[i];
        arr[i] = this.value;
        return {
            newDocument: document,
            removed: removed
        };
    },
    move: objOps.move,
    copy: objOps.copy,
    test: objOps.test,
    _get: objOps._get
};
function getValueByPointer(document, pointer) {
    if (pointer == '') return document;
    var getOriginalDestination = {
        op: "_get",
        path: pointer
    };
    applyOperation(document, getOriginalDestination);
    return getOriginalDestination.value;
}
function applyOperation(document, operation, validateOperation, mutateDocument, banPrototypeModifications, index) {
    if (validateOperation === void 0) validateOperation = false;
    if (mutateDocument === void 0) mutateDocument = true;
    if (banPrototypeModifications === void 0) banPrototypeModifications = true;
    if (index === void 0) index = 0;
    if (validateOperation) {
        if (typeof validateOperation == 'function') validateOperation(operation, 0, document, operation.path);
        else validator(operation, 0);
    }
    /* ROOT OPERATIONS */ if (operation.path === "") {
        var returnValue = {
            newDocument: document
        };
        if (operation.op === 'add') {
            returnValue.newDocument = operation.value;
            return returnValue;
        } else if (operation.op === 'replace') {
            returnValue.newDocument = operation.value;
            returnValue.removed = document; //document we removed
            return returnValue;
        } else if (operation.op === 'move' || operation.op === 'copy') {
            returnValue.newDocument = getValueByPointer(document, operation.from); // get the value by json-pointer in `from` field
            if (operation.op === 'move') returnValue.removed = document;
            return returnValue;
        } else if (operation.op === 'test') {
            returnValue.test = _areEquals(document, operation.value);
            if (returnValue.test === false) throw new JsonPatchError("Test operation failed", 'TEST_OPERATION_FAILED', index, operation, document);
            returnValue.newDocument = document;
            return returnValue;
        } else if (operation.op === 'remove') {
            returnValue.removed = document;
            returnValue.newDocument = null;
            return returnValue;
        } else if (operation.op === '_get') {
            operation.value = document;
            return returnValue;
        } else {
            if (validateOperation) throw new JsonPatchError('Operation `op` property is not one of operations defined in RFC-6902', 'OPERATION_OP_INVALID', index, operation, document);
            else return returnValue;
        }
    } else {
        if (!mutateDocument) document = (0, _helpersMjs._deepClone)(document);
        var path = operation.path || "";
        var keys = path.split('/');
        var obj = document;
        var t = 1; //skip empty element - http://jsperf.com/to-shift-or-not-to-shift
        var len = keys.length;
        var existingPathFragment = undefined;
        var key = void 0;
        var validateFunction = void 0;
        if (typeof validateOperation == 'function') validateFunction = validateOperation;
        else validateFunction = validator;
        while(true){
            key = keys[t];
            if (key && key.indexOf('~') != -1) key = (0, _helpersMjs.unescapePathComponent)(key);
            if (banPrototypeModifications && (key == '__proto__' || key == 'prototype' && t > 0 && keys[t - 1] == 'constructor')) throw new TypeError('JSON-Patch: modifying `__proto__` or `constructor/prototype` prop is banned for security reasons, if this was on purpose, please set `banPrototypeModifications` flag false and pass it to this function. More info in fast-json-patch README');
            if (validateOperation) {
                if (existingPathFragment === undefined) {
                    if (obj[key] === undefined) existingPathFragment = keys.slice(0, t).join('/');
                    else if (t == len - 1) existingPathFragment = operation.path;
                    if (existingPathFragment !== undefined) validateFunction(operation, 0, document, existingPathFragment);
                }
            }
            t++;
            if (Array.isArray(obj)) {
                if (key === '-') key = obj.length;
                else {
                    if (validateOperation && !(0, _helpersMjs.isInteger)(key)) throw new JsonPatchError("Expected an unsigned base-10 integer value, making the new referenced value the array element with the zero-based index", "OPERATION_PATH_ILLEGAL_ARRAY_INDEX", index, operation, document);
                    else if ((0, _helpersMjs.isInteger)(key)) key = ~~key;
                }
                if (t >= len) {
                    if (validateOperation && operation.op === "add" && key > obj.length) throw new JsonPatchError("The specified index MUST NOT be greater than the number of elements in the array", "OPERATION_VALUE_OUT_OF_BOUNDS", index, operation, document);
                    var returnValue = arrOps[operation.op].call(operation, obj, key, document); // Apply patch
                    if (returnValue.test === false) throw new JsonPatchError("Test operation failed", 'TEST_OPERATION_FAILED', index, operation, document);
                    return returnValue;
                }
            } else if (t >= len) {
                var returnValue = objOps[operation.op].call(operation, obj, key, document); // Apply patch
                if (returnValue.test === false) throw new JsonPatchError("Test operation failed", 'TEST_OPERATION_FAILED', index, operation, document);
                return returnValue;
            }
            obj = obj[key];
            // If we have more keys in the path, but the next value isn't a non-null object,
            // throw an OPERATION_PATH_UNRESOLVABLE error instead of iterating again.
            if (validateOperation && t < len && (!obj || typeof obj !== "object")) throw new JsonPatchError('Cannot perform operation at the desired path', 'OPERATION_PATH_UNRESOLVABLE', index, operation, document);
        }
    }
}
function applyPatch(document, patch, validateOperation, mutateDocument, banPrototypeModifications) {
    if (mutateDocument === void 0) mutateDocument = true;
    if (banPrototypeModifications === void 0) banPrototypeModifications = true;
    if (validateOperation) {
        if (!Array.isArray(patch)) throw new JsonPatchError('Patch sequence must be an array', 'SEQUENCE_NOT_AN_ARRAY');
    }
    if (!mutateDocument) document = (0, _helpersMjs._deepClone)(document);
    var results = new Array(patch.length);
    for(var i = 0, length_1 = patch.length; i < length_1; i++){
        // we don't need to pass mutateDocument argument because if it was true, we already deep cloned the object, we'll just pass `true`
        results[i] = applyOperation(document, patch[i], validateOperation, true, banPrototypeModifications, i);
        document = results[i].newDocument; // in case root was replaced
    }
    results.newDocument = document;
    return results;
}
function applyReducer(document, operation, index) {
    var operationResult = applyOperation(document, operation);
    if (operationResult.test === false) throw new JsonPatchError("Test operation failed", 'TEST_OPERATION_FAILED', index, operation, document);
    return operationResult.newDocument;
}
function validator(operation, index, document, existingPathFragment) {
    if (typeof operation !== 'object' || operation === null || Array.isArray(operation)) throw new JsonPatchError('Operation is not an object', 'OPERATION_NOT_AN_OBJECT', index, operation, document);
    else if (!objOps[operation.op]) throw new JsonPatchError('Operation `op` property is not one of operations defined in RFC-6902', 'OPERATION_OP_INVALID', index, operation, document);
    else if (typeof operation.path !== 'string') throw new JsonPatchError('Operation `path` property is not a string', 'OPERATION_PATH_INVALID', index, operation, document);
    else if (operation.path.indexOf('/') !== 0 && operation.path.length > 0) // paths that aren't empty string should start with "/"
    throw new JsonPatchError('Operation `path` property must start with "/"', 'OPERATION_PATH_INVALID', index, operation, document);
    else if ((operation.op === 'move' || operation.op === 'copy') && typeof operation.from !== 'string') throw new JsonPatchError('Operation `from` property is not present (applicable in `move` and `copy` operations)', 'OPERATION_FROM_REQUIRED', index, operation, document);
    else if ((operation.op === 'add' || operation.op === 'replace' || operation.op === 'test') && operation.value === undefined) throw new JsonPatchError('Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)', 'OPERATION_VALUE_REQUIRED', index, operation, document);
    else if ((operation.op === 'add' || operation.op === 'replace' || operation.op === 'test') && (0, _helpersMjs.hasUndefined)(operation.value)) throw new JsonPatchError('Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)', 'OPERATION_VALUE_CANNOT_CONTAIN_UNDEFINED', index, operation, document);
    else if (document) {
        if (operation.op == "add") {
            var pathLen = operation.path.split("/").length;
            var existingPathLen = existingPathFragment.split("/").length;
            if (pathLen !== existingPathLen + 1 && pathLen !== existingPathLen) throw new JsonPatchError('Cannot perform an `add` operation at the desired path', 'OPERATION_PATH_CANNOT_ADD', index, operation, document);
        } else if (operation.op === 'replace' || operation.op === 'remove' || operation.op === '_get') {
            if (operation.path !== existingPathFragment) throw new JsonPatchError('Cannot perform the operation at a path that does not exist', 'OPERATION_PATH_UNRESOLVABLE', index, operation, document);
        } else if (operation.op === 'move' || operation.op === 'copy') {
            var existingValue = {
                op: "_get",
                path: operation.from,
                value: undefined
            };
            var error = validate([
                existingValue
            ], document);
            if (error && error.name === 'OPERATION_PATH_UNRESOLVABLE') throw new JsonPatchError('Cannot perform the operation from a path that does not exist', 'OPERATION_FROM_UNRESOLVABLE', index, operation, document);
        }
    }
}
function validate(sequence, document, externalValidator) {
    try {
        if (!Array.isArray(sequence)) throw new JsonPatchError('Patch sequence must be an array', 'SEQUENCE_NOT_AN_ARRAY');
        if (document) //clone document and sequence so that we can safely try applying operations
        applyPatch((0, _helpersMjs._deepClone)(document), (0, _helpersMjs._deepClone)(sequence), externalValidator || true);
        else {
            externalValidator = externalValidator || validator;
            for(var i = 0; i < sequence.length; i++)externalValidator(sequence[i], i, document, undefined);
        }
    } catch (e) {
        if (e instanceof JsonPatchError) return e;
        else throw e;
    }
}
function _areEquals(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = Array.isArray(a), arrB = Array.isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!_areEquals(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!b.hasOwnProperty(keys[i])) return false;
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (!_areEquals(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}

},{"./helpers.mjs":"1Ea7V","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"1Ea7V":[function(require,module,exports,__globalThis) {
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017-2022 Joachim Wester
 * MIT licensed
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasOwnProperty", ()=>hasOwnProperty);
parcelHelpers.export(exports, "_objectKeys", ()=>_objectKeys);
/**
* Deeply clone the object.
* https://jsperf.com/deep-copy-vs-json-stringify-json-parse/25 (recursiveDeepCopy)
* @param  {any} obj value to clone
* @return {any} cloned obj
*/ parcelHelpers.export(exports, "_deepClone", ()=>_deepClone);
//3x faster than cached /^\d+$/.test(str)
parcelHelpers.export(exports, "isInteger", ()=>isInteger);
/**
* Escapes a json pointer path
* @param path The raw pointer
* @return the Escaped path
*/ parcelHelpers.export(exports, "escapePathComponent", ()=>escapePathComponent);
/**
 * Unescapes a json pointer path
 * @param path The escaped pointer
 * @return The unescaped path
 */ parcelHelpers.export(exports, "unescapePathComponent", ()=>unescapePathComponent);
parcelHelpers.export(exports, "_getPathRecursive", ()=>_getPathRecursive);
parcelHelpers.export(exports, "getPath", ()=>getPath);
/**
* Recursively checks whether an object has any undefined values inside.
*/ parcelHelpers.export(exports, "hasUndefined", ()=>hasUndefined);
parcelHelpers.export(exports, "PatchError", ()=>PatchError);
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var _hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwnProperty(obj, key) {
    return _hasOwnProperty.call(obj, key);
}
function _objectKeys(obj) {
    if (Array.isArray(obj)) {
        var keys_1 = new Array(obj.length);
        for(var k = 0; k < keys_1.length; k++)keys_1[k] = "" + k;
        return keys_1;
    }
    if (Object.keys) return Object.keys(obj);
    var keys = [];
    for(var i in obj)if (hasOwnProperty(obj, i)) keys.push(i);
    return keys;
}
function _deepClone(obj) {
    switch(typeof obj){
        case "object":
            return JSON.parse(JSON.stringify(obj)); //Faster than ES5 clone - http://jsperf.com/deep-cloning-of-objects/5
        case "undefined":
            return null; //this is how JSON.stringify behaves for array items
        default:
            return obj; //no need to clone primitives
    }
}
function isInteger(str) {
    var i = 0;
    var len = str.length;
    var charCode;
    while(i < len){
        charCode = str.charCodeAt(i);
        if (charCode >= 48 && charCode <= 57) {
            i++;
            continue;
        }
        return false;
    }
    return true;
}
function escapePathComponent(path) {
    if (path.indexOf('/') === -1 && path.indexOf('~') === -1) return path;
    return path.replace(/~/g, '~0').replace(/\//g, '~1');
}
function unescapePathComponent(path) {
    return path.replace(/~1/g, '/').replace(/~0/g, '~');
}
function _getPathRecursive(root, obj) {
    var found;
    for(var key in root)if (hasOwnProperty(root, key)) {
        if (root[key] === obj) return escapePathComponent(key) + '/';
        else if (typeof root[key] === 'object') {
            found = _getPathRecursive(root[key], obj);
            if (found != '') return escapePathComponent(key) + '/' + found;
        }
    }
    return '';
}
function getPath(root, obj) {
    if (root === obj) return '/';
    var path = _getPathRecursive(root, obj);
    if (path === '') throw new Error("Object not found in root");
    return "/" + path;
}
function hasUndefined(obj) {
    if (obj === undefined) return true;
    if (obj) {
        if (Array.isArray(obj)) for(var i_1 = 0, len = obj.length; i_1 < len; i_1++){
            if (hasUndefined(obj[i_1])) return true;
        }
        else if (typeof obj === "object") {
            var objKeys = _objectKeys(obj);
            var objKeysLength = objKeys.length;
            for(var i = 0; i < objKeysLength; i++){
                if (hasUndefined(obj[objKeys[i]])) return true;
            }
        }
    }
    return false;
}
function patchErrorMessageFormatter(message, args) {
    var messageParts = [
        message
    ];
    for(var key in args){
        var value = typeof args[key] === 'object' ? JSON.stringify(args[key], null, 2) : args[key]; // pretty print
        if (typeof value !== 'undefined') messageParts.push(key + ": " + value);
    }
    return messageParts.join('\n');
}
var PatchError = /** @class */ function(_super) {
    __extends(PatchError, _super);
    function PatchError(message, name, index, operation, tree) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, patchErrorMessageFormatter(message, {
            name: name,
            index: index,
            operation: operation,
            tree: tree
        })) || this;
        _this.name = name;
        _this.index = index;
        _this.operation = operation;
        _this.tree = tree;
        Object.setPrototypeOf(_this, _newTarget.prototype); // restore prototype chain, see https://stackoverflow.com/a/48342359
        _this.message = patchErrorMessageFormatter(message, {
            name: name,
            index: index,
            operation: operation,
            tree: tree
        });
        return _this;
    }
    return PatchError;
}(Error);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"e5ykQ":[function(require,module,exports,__globalThis) {
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017-2021 Joachim Wester
 * MIT license
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Detach an observer from an object
 */ parcelHelpers.export(exports, "unobserve", ()=>unobserve);
/**
 * Observes changes made to an object, which can then be retrieved using generate
 */ parcelHelpers.export(exports, "observe", ()=>observe);
/**
 * Generate an array of patches from an observer
 */ parcelHelpers.export(exports, "generate", ()=>generate);
/**
 * Create an array of patches from the differences in two objects
 */ parcelHelpers.export(exports, "compare", ()=>compare);
var _helpersMjs = require("./helpers.mjs");
var _coreMjs = require("./core.mjs");
var beforeDict = new WeakMap();
var Mirror = /** @class */ function() {
    function Mirror(obj) {
        this.observers = new Map();
        this.obj = obj;
    }
    return Mirror;
}();
var ObserverInfo = /** @class */ function() {
    function ObserverInfo(callback, observer) {
        this.callback = callback;
        this.observer = observer;
    }
    return ObserverInfo;
}();
function getMirror(obj) {
    return beforeDict.get(obj);
}
function getObserverFromMirror(mirror, callback) {
    return mirror.observers.get(callback);
}
function removeObserverFromMirror(mirror, observer) {
    mirror.observers.delete(observer.callback);
}
function unobserve(root, observer) {
    observer.unobserve();
}
function observe(obj, callback) {
    var patches = [];
    var observer;
    var mirror = getMirror(obj);
    if (!mirror) {
        mirror = new Mirror(obj);
        beforeDict.set(obj, mirror);
    } else {
        var observerInfo = getObserverFromMirror(mirror, callback);
        observer = observerInfo && observerInfo.observer;
    }
    if (observer) return observer;
    observer = {};
    mirror.value = (0, _helpersMjs._deepClone)(obj);
    if (callback) {
        observer.callback = callback;
        observer.next = null;
        var dirtyCheck = function() {
            generate(observer);
        };
        var fastCheck = function() {
            clearTimeout(observer.next);
            observer.next = setTimeout(dirtyCheck);
        };
        if (typeof window !== 'undefined') {
            window.addEventListener('mouseup', fastCheck);
            window.addEventListener('keyup', fastCheck);
            window.addEventListener('mousedown', fastCheck);
            window.addEventListener('keydown', fastCheck);
            window.addEventListener('change', fastCheck);
        }
    }
    observer.patches = patches;
    observer.object = obj;
    observer.unobserve = function() {
        generate(observer);
        clearTimeout(observer.next);
        removeObserverFromMirror(mirror, observer);
        if (typeof window !== 'undefined') {
            window.removeEventListener('mouseup', fastCheck);
            window.removeEventListener('keyup', fastCheck);
            window.removeEventListener('mousedown', fastCheck);
            window.removeEventListener('keydown', fastCheck);
            window.removeEventListener('change', fastCheck);
        }
    };
    mirror.observers.set(callback, new ObserverInfo(callback, observer));
    return observer;
}
function generate(observer, invertible) {
    if (invertible === void 0) invertible = false;
    var mirror = beforeDict.get(observer.object);
    _generate(mirror.value, observer.object, observer.patches, "", invertible);
    if (observer.patches.length) (0, _coreMjs.applyPatch)(mirror.value, observer.patches);
    var temp = observer.patches;
    if (temp.length > 0) {
        observer.patches = [];
        if (observer.callback) observer.callback(temp);
    }
    return temp;
}
// Dirty check if obj is different from mirror, generate patches and update mirror
function _generate(mirror, obj, patches, path, invertible) {
    if (obj === mirror) return;
    if (typeof obj.toJSON === "function") obj = obj.toJSON();
    var newKeys = (0, _helpersMjs._objectKeys)(obj);
    var oldKeys = (0, _helpersMjs._objectKeys)(mirror);
    var changed = false;
    var deleted = false;
    //if ever "move" operation is implemented here, make sure this test runs OK: "should not generate the same patch twice (move)"
    for(var t = oldKeys.length - 1; t >= 0; t--){
        var key = oldKeys[t];
        var oldVal = mirror[key];
        if ((0, _helpersMjs.hasOwnProperty)(obj, key) && !(obj[key] === undefined && oldVal !== undefined && Array.isArray(obj) === false)) {
            var newVal = obj[key];
            if (typeof oldVal == "object" && oldVal != null && typeof newVal == "object" && newVal != null && Array.isArray(oldVal) === Array.isArray(newVal)) _generate(oldVal, newVal, patches, path + "/" + (0, _helpersMjs.escapePathComponent)(key), invertible);
            else if (oldVal !== newVal) {
                changed = true;
                if (invertible) patches.push({
                    op: "test",
                    path: path + "/" + (0, _helpersMjs.escapePathComponent)(key),
                    value: (0, _helpersMjs._deepClone)(oldVal)
                });
                patches.push({
                    op: "replace",
                    path: path + "/" + (0, _helpersMjs.escapePathComponent)(key),
                    value: (0, _helpersMjs._deepClone)(newVal)
                });
            }
        } else if (Array.isArray(mirror) === Array.isArray(obj)) {
            if (invertible) patches.push({
                op: "test",
                path: path + "/" + (0, _helpersMjs.escapePathComponent)(key),
                value: (0, _helpersMjs._deepClone)(oldVal)
            });
            patches.push({
                op: "remove",
                path: path + "/" + (0, _helpersMjs.escapePathComponent)(key)
            });
            deleted = true; // property has been deleted
        } else {
            if (invertible) patches.push({
                op: "test",
                path: path,
                value: mirror
            });
            patches.push({
                op: "replace",
                path: path,
                value: obj
            });
            changed = true;
        }
    }
    if (!deleted && newKeys.length == oldKeys.length) return;
    for(var t = 0; t < newKeys.length; t++){
        var key = newKeys[t];
        if (!(0, _helpersMjs.hasOwnProperty)(mirror, key) && obj[key] !== undefined) patches.push({
            op: "add",
            path: path + "/" + (0, _helpersMjs.escapePathComponent)(key),
            value: (0, _helpersMjs._deepClone)(obj[key])
        });
    }
}
function compare(tree1, tree2, invertible) {
    if (invertible === void 0) invertible = false;
    var patches = [];
    _generate(tree1, tree2, patches, '', invertible);
    return patches;
}

},{"./helpers.mjs":"1Ea7V","./core.mjs":"3fXbK","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cxkZr":[function(require,module,exports,__globalThis) {
"use strict";
// Note: This regex matches even invalid JSON strings, but since we’re
// working on the output of `JSON.stringify` we know that only valid strings
// are present (unless the user supplied a weird `options.indent` but in
// that case we don’t care since the output would be invalid anyway).
var stringOrChar = /("(?:[^\\"]|\\.)*")|[:,]/g;
module.exports = function stringify(passedObj, options) {
    var indent, maxLength, replacer;
    options = options || {};
    indent = JSON.stringify([
        1
    ], undefined, options.indent === undefined ? 2 : options.indent).slice(2, -3);
    maxLength = indent === "" ? Infinity : options.maxLength === undefined ? 80 : options.maxLength;
    replacer = options.replacer;
    return function _stringify(obj, currentIndent, reserved) {
        // prettier-ignore
        var end, index, items, key, keyPart, keys, length, nextIndent, prettified, start, string, value;
        if (obj && typeof obj.toJSON === "function") obj = obj.toJSON();
        string = JSON.stringify(obj, replacer);
        if (string === undefined) return string;
        length = maxLength - currentIndent.length - reserved;
        if (string.length <= length) {
            prettified = string.replace(stringOrChar, function(match, stringLiteral) {
                return stringLiteral || match + " ";
            });
            if (prettified.length <= length) return prettified;
        }
        if (replacer != null) {
            obj = JSON.parse(string);
            replacer = undefined;
        }
        if (typeof obj === "object" && obj !== null) {
            nextIndent = currentIndent + indent;
            items = [];
            index = 0;
            if (Array.isArray(obj)) {
                start = "[";
                end = "]";
                length = obj.length;
                for(; index < length; index++)items.push(_stringify(obj[index], nextIndent, index === length - 1 ? 0 : 1) || "null");
            } else {
                start = "{";
                end = "}";
                keys = Object.keys(obj);
                length = keys.length;
                for(; index < length; index++){
                    key = keys[index];
                    keyPart = JSON.stringify(key) + ": ";
                    value = _stringify(obj[key], nextIndent, keyPart.length + (index === length - 1 ? 0 : 1));
                    if (value !== undefined) items.push(keyPart + value);
                }
            }
            if (items.length > 0) return [
                start,
                indent + items.join(",\n" + nextIndent),
                end
            ].join("\n" + currentIndent);
        }
        return string;
    }(passedObj, "", 0);
};

},{}],"kfzMN":[function(require,module,exports,__globalThis) {
// just pre-load all the stuff that index.js lazily exports
const internalRe = require("2ef367e729437dbf");
const constants = require("15796d6f714ec7ac");
const SemVer = require("784948b06600d9b2");
const identifiers = require("70f963db887a798c");
const parse = require("3f445ade66470b21");
const valid = require("f44378b7de87a0b4");
const clean = require("7742c78cf22bae39");
const inc = require("a751dd1df28d6bbb");
const diff = require("e000803318fe9f2f");
const major = require("d290038a9a954b0a");
const minor = require("c5e4bbab325a5aae");
const patch = require("5c0bb8d32de60bb3");
const prerelease = require("323f12e5af5ebd1e");
const compare = require("29cf114a56181e64");
const rcompare = require("827db0815bb2f2cd");
const compareLoose = require("b644f26560ec8124");
const compareBuild = require("606d0e43dd66a24c");
const sort = require("1560ed361cfa42e6");
const rsort = require("f9e1f00918a8cfd7");
const gt = require("3694a9720f15d6ac");
const lt = require("4559dbda8a777185");
const eq = require("14a4b88a0b1fd3a5");
const neq = require("416d9b63c3df2ead");
const gte = require("d39630b19344a843");
const lte = require("3fb74c9a41c1cef6");
const cmp = require("3435ca1bbec7b99");
const coerce = require("d67409238c8fc031");
const Comparator = require("1d07035d00450bca");
const Range = require("b280ab3e26924ac1");
const satisfies = require("ba9d0d2a3e49b569");
const toComparators = require("e6b2802b2233287d");
const maxSatisfying = require("2bfdfb0adcbcb71b");
const minSatisfying = require("264df1ba0d261fad");
const minVersion = require("cd4980125683761f");
const validRange = require("a0319a4a98954087");
const outside = require("fc457e2bda4345b2");
const gtr = require("c885d2b556186a1a");
const ltr = require("58740c779f187b15");
const intersects = require("22421cf146448c92");
const simplifyRange = require("439ddbc649d6486");
const subset = require("f1e57a2c808f532d");
module.exports = {
    parse,
    valid,
    clean,
    inc,
    diff,
    major,
    minor,
    patch,
    prerelease,
    compare,
    rcompare,
    compareLoose,
    compareBuild,
    sort,
    rsort,
    gt,
    lt,
    eq,
    neq,
    gte,
    lte,
    cmp,
    coerce,
    Comparator,
    Range,
    satisfies,
    toComparators,
    maxSatisfying,
    minSatisfying,
    minVersion,
    validRange,
    outside,
    gtr,
    ltr,
    intersects,
    simplifyRange,
    subset,
    SemVer,
    re: internalRe.re,
    src: internalRe.src,
    tokens: internalRe.t,
    SEMVER_SPEC_VERSION: constants.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: constants.RELEASE_TYPES,
    compareIdentifiers: identifiers.compareIdentifiers,
    rcompareIdentifiers: identifiers.rcompareIdentifiers
};

},{"2ef367e729437dbf":"5cdBQ","15796d6f714ec7ac":"gdL3I","784948b06600d9b2":"9kWj6","70f963db887a798c":"7hQ6o","3f445ade66470b21":"dilqz","f44378b7de87a0b4":"XOnko","7742c78cf22bae39":"1KnMU","a751dd1df28d6bbb":"kCAqf","e000803318fe9f2f":"az7y0","d290038a9a954b0a":"iU7gm","c5e4bbab325a5aae":"6EoW2","5c0bb8d32de60bb3":"1DYv7","323f12e5af5ebd1e":"6GSxu","29cf114a56181e64":"c97Kn","827db0815bb2f2cd":"k8mNn","b644f26560ec8124":"9EmJA","606d0e43dd66a24c":"5fLPS","1560ed361cfa42e6":"8WP8k","f9e1f00918a8cfd7":"013SK","3694a9720f15d6ac":"ilwzq","4559dbda8a777185":"82FFh","14a4b88a0b1fd3a5":"jsdf8","416d9b63c3df2ead":"dcpha","d39630b19344a843":"7vvSp","3fb74c9a41c1cef6":"66IjO","3435ca1bbec7b99":"gnqYr","d67409238c8fc031":"kAGTW","1d07035d00450bca":"c8PQa","b280ab3e26924ac1":"ayUW4","ba9d0d2a3e49b569":"7PGRl","e6b2802b2233287d":"mBrxP","2bfdfb0adcbcb71b":"epzu3","264df1ba0d261fad":"6yskI","cd4980125683761f":"74MHi","a0319a4a98954087":"g62Od","fc457e2bda4345b2":"ciquJ","c885d2b556186a1a":"9oyAI","58740c779f187b15":"gI1Ss","22421cf146448c92":"hbv8W","439ddbc649d6486":"kmLkM","f1e57a2c808f532d":"dCUUu"}],"5cdBQ":[function(require,module,exports,__globalThis) {
const { MAX_SAFE_COMPONENT_LENGTH, MAX_SAFE_BUILD_LENGTH, MAX_LENGTH } = require("9328c2484f003df4");
const debug = require("9075cfb365332427");
exports = module.exports = {};
// The actual regexps go on exports.re
const re = exports.re = [];
const safeRe = exports.safeRe = [];
const src = exports.src = [];
const safeSrc = exports.safeSrc = [];
const t = exports.t = {};
let R = 0;
const LETTERDASHNUMBER = '[a-zA-Z0-9-]';
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
const safeRegexReplacements = [
    [
        '\\s',
        1
    ],
    [
        '\\d',
        MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        MAX_SAFE_BUILD_LENGTH
    ]
];
const makeSafeRegex = (value)=>{
    for (const [token, max] of safeRegexReplacements)value = value.split(`${token}*`).join(`${token}{0,${max}}`).split(`${token}+`).join(`${token}{1,${max}}`);
    return value;
};
const createToken = (name, value, isGlobal)=>{
    const safe = makeSafeRegex(value);
    const index = R++;
    debug(name, index, value);
    t[name] = index;
    src[index] = value;
    safeSrc[index] = safe;
    re[index] = new RegExp(value, isGlobal ? 'g' : undefined);
    safeRe[index] = new RegExp(safe, isGlobal ? 'g' : undefined);
};
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
createToken('NUMERICIDENTIFIER', '0|[1-9]\\d*');
createToken('NUMERICIDENTIFIERLOOSE', '\\d+');
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
createToken('NONNUMERICIDENTIFIER', `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);
// ## Main Version
// Three dot-separated numeric identifiers.
createToken('MAINVERSION', `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})`);
createToken('MAINVERSIONLOOSE', `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
createToken('PRERELEASEIDENTIFIER', `(?:${src[t.NUMERICIDENTIFIER]}|${src[t.NONNUMERICIDENTIFIER]})`);
createToken('PRERELEASEIDENTIFIERLOOSE', `(?:${src[t.NUMERICIDENTIFIERLOOSE]}|${src[t.NONNUMERICIDENTIFIER]})`);
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
createToken('PRERELEASE', `(?:-(${src[t.PRERELEASEIDENTIFIER]}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);
createToken('PRERELEASELOOSE', `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
createToken('BUILDIDENTIFIER', `${LETTERDASHNUMBER}+`);
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
createToken('BUILD', `(?:\\+(${src[t.BUILDIDENTIFIER]}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
createToken('FULLPLAIN', `v?${src[t.MAINVERSION]}${src[t.PRERELEASE]}?${src[t.BUILD]}?`);
createToken('FULL', `^${src[t.FULLPLAIN]}$`);
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
createToken('LOOSEPLAIN', `[v=\\s]*${src[t.MAINVERSIONLOOSE]}${src[t.PRERELEASELOOSE]}?${src[t.BUILD]}?`);
createToken('LOOSE', `^${src[t.LOOSEPLAIN]}$`);
createToken('GTLT', '((?:<|>)?=?)');
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
createToken('XRANGEIDENTIFIERLOOSE', `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
createToken('XRANGEIDENTIFIER', `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);
createToken('XRANGEPLAIN', `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:${src[t.PRERELEASE]})?${src[t.BUILD]}?` + `)?)?`);
createToken('XRANGEPLAINLOOSE', `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:${src[t.PRERELEASELOOSE]})?${src[t.BUILD]}?` + `)?)?`);
createToken('XRANGE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
createToken('XRANGELOOSE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
createToken('COERCEPLAIN', `${"(^|[^\\d])(\\d{1,"}${MAX_SAFE_COMPONENT_LENGTH}})` + `(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?`);
createToken('COERCE', `${src[t.COERCEPLAIN]}(?:$|[^\\d])`);
createToken('COERCEFULL', src[t.COERCEPLAIN] + `(?:${src[t.PRERELEASE]})?` + `(?:${src[t.BUILD]})?` + `(?:$|[^\\d])`);
createToken('COERCERTL', src[t.COERCE], true);
createToken('COERCERTLFULL', src[t.COERCEFULL], true);
// Tilde ranges.
// Meaning is "reasonably at or greater than"
createToken('LONETILDE', '(?:~>?)');
createToken('TILDETRIM', `(\\s*)${src[t.LONETILDE]}\\s+`, true);
exports.tildeTrimReplace = '$1~';
createToken('TILDE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
createToken('TILDELOOSE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);
// Caret ranges.
// Meaning is "at least and backwards compatible with"
createToken('LONECARET', '(?:\\^)');
createToken('CARETTRIM', `(\\s*)${src[t.LONECARET]}\\s+`, true);
exports.caretTrimReplace = '$1^';
createToken('CARET', `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
createToken('CARETLOOSE', `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);
// A simple gt/lt/eq thing, or just "" to indicate "any version"
createToken('COMPARATORLOOSE', `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
createToken('COMPARATOR', `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
createToken('COMPARATORTRIM', `(\\s*)${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, true);
exports.comparatorTrimReplace = '$1$2$3';
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
createToken('HYPHENRANGE', `^\\s*(${src[t.XRANGEPLAIN]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAIN]})` + `\\s*$`);
createToken('HYPHENRANGELOOSE', `^\\s*(${src[t.XRANGEPLAINLOOSE]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAINLOOSE]})` + `\\s*$`);
// Star ranges basically just allow anything at all.
createToken('STAR', '(<|>)?=?\\s*\\*');
// >=0.0.0 is like a star
createToken('GTE0', '^\\s*>=\\s*0\\.0\\.0\\s*$');
createToken('GTE0PRE', '^\\s*>=\\s*0\\.0\\.0-0\\s*$');

},{"9328c2484f003df4":"gdL3I","9075cfb365332427":"lKIrJ"}],"gdL3I":[function(require,module,exports,__globalThis) {
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
const SEMVER_SPEC_VERSION = '2.0.0';
const MAX_LENGTH = 256;
const MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
const MAX_SAFE_COMPONENT_LENGTH = 16;
// Max safe length for a build identifier. The max length minus 6 characters for
// the shortest version with a build 0.0.0+BUILD.
const MAX_SAFE_BUILD_LENGTH = MAX_LENGTH - 6;
const RELEASE_TYPES = [
    'major',
    'premajor',
    'minor',
    'preminor',
    'patch',
    'prepatch',
    'prerelease'
];
module.exports = {
    MAX_LENGTH,
    MAX_SAFE_COMPONENT_LENGTH,
    MAX_SAFE_BUILD_LENGTH,
    MAX_SAFE_INTEGER,
    RELEASE_TYPES,
    SEMVER_SPEC_VERSION,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
};

},{}],"lKIrJ":[function(require,module,exports,__globalThis) {
const debug = ()=>{};
module.exports = debug;

},{}],"9kWj6":[function(require,module,exports,__globalThis) {
const debug = require("595c172e7d863d06");
const { MAX_LENGTH, MAX_SAFE_INTEGER } = require("bd8d57fbca62978a");
const { safeRe: re, safeSrc: src, t } = require("2b364a26e67d9817");
const parseOptions = require("f1a723539d6cc9b5");
const { compareIdentifiers } = require("2451a15946a38fcd");
class SemVer {
    constructor(version, options){
        options = parseOptions(options);
        if (version instanceof SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== 'string') throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version}".`);
        if (version.length > MAX_LENGTH) throw new TypeError(`version is longer than ${MAX_LENGTH} characters`);
        debug('SemVer', version, options);
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        const m = version.trim().match(options.loose ? re[t.LOOSE] : re[t.FULL]);
        if (!m) throw new TypeError(`Invalid Version: ${version}`);
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > MAX_SAFE_INTEGER || this.major < 0) throw new TypeError('Invalid major version');
        if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError('Invalid minor version');
        if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError('Invalid patch version');
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split('.').map((id)=>{
            if (/^[0-9]+$/.test(id)) {
                const num = +id;
                if (num >= 0 && num < MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split('.') : [];
        this.format();
    }
    format() {
        this.version = `${this.major}.${this.minor}.${this.patch}`;
        if (this.prerelease.length) this.version += `-${this.prerelease.join('.')}`;
        return this.version;
    }
    toString() {
        return this.version;
    }
    compare(other) {
        debug('SemVer.compare', this.version, this.options, other);
        if (!(other instanceof SemVer)) {
            if (typeof other === 'string' && other === this.version) return 0;
            other = new SemVer(other, this.options);
        }
        if (other.version === this.version) return 0;
        return this.compareMain(other) || this.comparePre(other);
    }
    compareMain(other) {
        if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
        return compareIdentifiers(this.major, other.major) || compareIdentifiers(this.minor, other.minor) || compareIdentifiers(this.patch, other.patch);
    }
    comparePre(other) {
        if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
        // NOT having a prerelease is > having one
        if (this.prerelease.length && !other.prerelease.length) return -1;
        else if (!this.prerelease.length && other.prerelease.length) return 1;
        else if (!this.prerelease.length && !other.prerelease.length) return 0;
        let i = 0;
        do {
            const a = this.prerelease[i];
            const b = other.prerelease[i];
            debug('prerelease compare', i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return compareIdentifiers(a, b);
        }while (++i);
    }
    compareBuild(other) {
        if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
        let i = 0;
        do {
            const a = this.build[i];
            const b = other.build[i];
            debug('build compare', i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return compareIdentifiers(a, b);
        }while (++i);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(release, identifier, identifierBase) {
        if (release.startsWith('pre')) {
            if (!identifier && identifierBase === false) throw new Error('invalid increment argument: identifier is empty');
            // Avoid an invalid semver results
            if (identifier) {
                const r = new RegExp(`^${this.options.loose ? src[t.PRERELEASELOOSE] : src[t.PRERELEASE]}$`);
                const match = `-${identifier}`.match(r);
                if (!match || match[1] !== identifier) throw new Error(`invalid identifier: ${identifier}`);
            }
        }
        switch(release){
            case 'premajor':
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor = 0;
                this.major++;
                this.inc('pre', identifier, identifierBase);
                break;
            case 'preminor':
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor++;
                this.inc('pre', identifier, identifierBase);
                break;
            case 'prepatch':
                // If this is already a prerelease, it will bump to the next version
                // drop any prereleases that might already exist, since they are not
                // relevant at this point.
                this.prerelease.length = 0;
                this.inc('patch', identifier, identifierBase);
                this.inc('pre', identifier, identifierBase);
                break;
            // If the input is a non-prerelease version, this acts the same as
            // prepatch.
            case 'prerelease':
                if (this.prerelease.length === 0) this.inc('patch', identifier, identifierBase);
                this.inc('pre', identifier, identifierBase);
                break;
            case 'release':
                if (this.prerelease.length === 0) throw new Error(`version ${this.raw} is not a prerelease`);
                this.prerelease.length = 0;
                break;
            case 'major':
                // If this is a pre-major version, bump up to the same major version.
                // Otherwise increment major.
                // 1.0.0-5 bumps to 1.0.0
                // 1.1.0 bumps to 2.0.0
                if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                this.minor = 0;
                this.patch = 0;
                this.prerelease = [];
                break;
            case 'minor':
                // If this is a pre-minor version, bump up to the same minor version.
                // Otherwise increment minor.
                // 1.2.0-5 bumps to 1.2.0
                // 1.2.1 bumps to 1.3.0
                if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                this.patch = 0;
                this.prerelease = [];
                break;
            case 'patch':
                // If this is not a pre-release version, it will increment the patch.
                // If it is a pre-release it will bump up to the same patch version.
                // 1.2.0-5 patches to 1.2.0
                // 1.2.0 patches to 1.2.1
                if (this.prerelease.length === 0) this.patch++;
                this.prerelease = [];
                break;
            // This probably shouldn't be used publicly.
            // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
            case 'pre':
                {
                    const base = Number(identifierBase) ? 1 : 0;
                    if (this.prerelease.length === 0) this.prerelease = [
                        base
                    ];
                    else {
                        let i = this.prerelease.length;
                        while(--i >= 0)if (typeof this.prerelease[i] === 'number') {
                            this.prerelease[i]++;
                            i = -2;
                        }
                        if (i === -1) {
                            // didn't increment anything
                            if (identifier === this.prerelease.join('.') && identifierBase === false) throw new Error('invalid increment argument: identifier already exists');
                            this.prerelease.push(base);
                        }
                    }
                    if (identifier) {
                        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                        let prerelease = [
                            identifier,
                            base
                        ];
                        if (identifierBase === false) prerelease = [
                            identifier
                        ];
                        if (compareIdentifiers(this.prerelease[0], identifier) === 0) {
                            if (isNaN(this.prerelease[1])) this.prerelease = prerelease;
                        } else this.prerelease = prerelease;
                    }
                    break;
                }
            default:
                throw new Error(`invalid increment argument: ${release}`);
        }
        this.raw = this.format();
        if (this.build.length) this.raw += `+${this.build.join('.')}`;
        return this;
    }
}
module.exports = SemVer;

},{"595c172e7d863d06":"lKIrJ","bd8d57fbca62978a":"gdL3I","2b364a26e67d9817":"5cdBQ","f1a723539d6cc9b5":"BsaT6","2451a15946a38fcd":"7hQ6o"}],"BsaT6":[function(require,module,exports,__globalThis) {
// parse out just the options we care about
const looseOption = Object.freeze({
    loose: true
});
const emptyOpts = Object.freeze({});
const parseOptions = (options)=>{
    if (!options) return emptyOpts;
    if (typeof options !== 'object') return looseOption;
    return options;
};
module.exports = parseOptions;

},{}],"7hQ6o":[function(require,module,exports,__globalThis) {
const numeric = /^[0-9]+$/;
const compareIdentifiers = (a, b)=>{
    const anum = numeric.test(a);
    const bnum = numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
const rcompareIdentifiers = (a, b)=>compareIdentifiers(b, a);
module.exports = {
    compareIdentifiers,
    rcompareIdentifiers
};

},{}],"dilqz":[function(require,module,exports,__globalThis) {
const SemVer = require("575e97778d3944c0");
const parse = (version, options, throwErrors = false)=>{
    if (version instanceof SemVer) return version;
    try {
        return new SemVer(version, options);
    } catch (er) {
        if (!throwErrors) return null;
        throw er;
    }
};
module.exports = parse;

},{"575e97778d3944c0":"9kWj6"}],"XOnko":[function(require,module,exports,__globalThis) {
const parse = require("6a6e19c11f3ced24");
const valid = (version, options)=>{
    const v = parse(version, options);
    return v ? v.version : null;
};
module.exports = valid;

},{"6a6e19c11f3ced24":"dilqz"}],"1KnMU":[function(require,module,exports,__globalThis) {
const parse = require("661ff2c6ff41830b");
const clean = (version, options)=>{
    const s = parse(version.trim().replace(/^[=v]+/, ''), options);
    return s ? s.version : null;
};
module.exports = clean;

},{"661ff2c6ff41830b":"dilqz"}],"kCAqf":[function(require,module,exports,__globalThis) {
const SemVer = require("9a4ed023da196604");
const inc = (version, release, options, identifier, identifierBase)=>{
    if (typeof options === 'string') {
        identifierBase = identifier;
        identifier = options;
        options = undefined;
    }
    try {
        return new SemVer(version instanceof SemVer ? version.version : version, options).inc(release, identifier, identifierBase).version;
    } catch (er) {
        return null;
    }
};
module.exports = inc;

},{"9a4ed023da196604":"9kWj6"}],"az7y0":[function(require,module,exports,__globalThis) {
const parse = require("3b6d0e3ec696b30a");
const diff = (version1, version2)=>{
    const v1 = parse(version1, null, true);
    const v2 = parse(version2, null, true);
    const comparison = v1.compare(v2);
    if (comparison === 0) return null;
    const v1Higher = comparison > 0;
    const highVersion = v1Higher ? v1 : v2;
    const lowVersion = v1Higher ? v2 : v1;
    const highHasPre = !!highVersion.prerelease.length;
    const lowHasPre = !!lowVersion.prerelease.length;
    if (lowHasPre && !highHasPre) {
        // Going from prerelease -> no prerelease requires some special casing
        // If the low version has only a major, then it will always be a major
        // Some examples:
        // 1.0.0-1 -> 1.0.0
        // 1.0.0-1 -> 1.1.1
        // 1.0.0-1 -> 2.0.0
        if (!lowVersion.patch && !lowVersion.minor) return 'major';
        // If the main part has no difference
        if (lowVersion.compareMain(highVersion) === 0) {
            if (lowVersion.minor && !lowVersion.patch) return 'minor';
            return 'patch';
        }
    }
    // add the `pre` prefix if we are going to a prerelease version
    const prefix = highHasPre ? 'pre' : '';
    if (v1.major !== v2.major) return prefix + 'major';
    if (v1.minor !== v2.minor) return prefix + 'minor';
    if (v1.patch !== v2.patch) return prefix + 'patch';
    // high and low are preleases
    return 'prerelease';
};
module.exports = diff;

},{"3b6d0e3ec696b30a":"dilqz"}],"iU7gm":[function(require,module,exports,__globalThis) {
const SemVer = require("53a097ab5c27a647");
const major = (a, loose)=>new SemVer(a, loose).major;
module.exports = major;

},{"53a097ab5c27a647":"9kWj6"}],"6EoW2":[function(require,module,exports,__globalThis) {
const SemVer = require("f130a90acb01ac10");
const minor = (a, loose)=>new SemVer(a, loose).minor;
module.exports = minor;

},{"f130a90acb01ac10":"9kWj6"}],"1DYv7":[function(require,module,exports,__globalThis) {
const SemVer = require("54b9ac3bbdf83b31");
const patch = (a, loose)=>new SemVer(a, loose).patch;
module.exports = patch;

},{"54b9ac3bbdf83b31":"9kWj6"}],"6GSxu":[function(require,module,exports,__globalThis) {
const parse = require("ff5ab55da1933db3");
const prerelease = (version, options)=>{
    const parsed = parse(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
};
module.exports = prerelease;

},{"ff5ab55da1933db3":"dilqz"}],"c97Kn":[function(require,module,exports,__globalThis) {
const SemVer = require("f16c9f4397244ee0");
const compare = (a, b, loose)=>new SemVer(a, loose).compare(new SemVer(b, loose));
module.exports = compare;

},{"f16c9f4397244ee0":"9kWj6"}],"k8mNn":[function(require,module,exports,__globalThis) {
const compare = require("4bfcc14a9711a47b");
const rcompare = (a, b, loose)=>compare(b, a, loose);
module.exports = rcompare;

},{"4bfcc14a9711a47b":"c97Kn"}],"9EmJA":[function(require,module,exports,__globalThis) {
const compare = require("95c8404dc369c13b");
const compareLoose = (a, b)=>compare(a, b, true);
module.exports = compareLoose;

},{"95c8404dc369c13b":"c97Kn"}],"5fLPS":[function(require,module,exports,__globalThis) {
const SemVer = require("3659675d95d38f3");
const compareBuild = (a, b, loose)=>{
    const versionA = new SemVer(a, loose);
    const versionB = new SemVer(b, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
};
module.exports = compareBuild;

},{"3659675d95d38f3":"9kWj6"}],"8WP8k":[function(require,module,exports,__globalThis) {
const compareBuild = require("7c22e552e691e157");
const sort = (list, loose)=>list.sort((a, b)=>compareBuild(a, b, loose));
module.exports = sort;

},{"7c22e552e691e157":"5fLPS"}],"013SK":[function(require,module,exports,__globalThis) {
const compareBuild = require("468f4992c854a69a");
const rsort = (list, loose)=>list.sort((a, b)=>compareBuild(b, a, loose));
module.exports = rsort;

},{"468f4992c854a69a":"5fLPS"}],"ilwzq":[function(require,module,exports,__globalThis) {
const compare = require("85515ef2889f4f89");
const gt = (a, b, loose)=>compare(a, b, loose) > 0;
module.exports = gt;

},{"85515ef2889f4f89":"c97Kn"}],"82FFh":[function(require,module,exports,__globalThis) {
const compare = require("9d2d7734c37f90e6");
const lt = (a, b, loose)=>compare(a, b, loose) < 0;
module.exports = lt;

},{"9d2d7734c37f90e6":"c97Kn"}],"jsdf8":[function(require,module,exports,__globalThis) {
const compare = require("d6abf8ed12ec38c1");
const eq = (a, b, loose)=>compare(a, b, loose) === 0;
module.exports = eq;

},{"d6abf8ed12ec38c1":"c97Kn"}],"dcpha":[function(require,module,exports,__globalThis) {
const compare = require("5232df27c4c4faa9");
const neq = (a, b, loose)=>compare(a, b, loose) !== 0;
module.exports = neq;

},{"5232df27c4c4faa9":"c97Kn"}],"7vvSp":[function(require,module,exports,__globalThis) {
const compare = require("9183f7fbecba58ae");
const gte = (a, b, loose)=>compare(a, b, loose) >= 0;
module.exports = gte;

},{"9183f7fbecba58ae":"c97Kn"}],"66IjO":[function(require,module,exports,__globalThis) {
const compare = require("e55eadc974580af5");
const lte = (a, b, loose)=>compare(a, b, loose) <= 0;
module.exports = lte;

},{"e55eadc974580af5":"c97Kn"}],"gnqYr":[function(require,module,exports,__globalThis) {
const eq = require("bff7f16298b8dbaa");
const neq = require("6a1bb69c2d499261");
const gt = require("dca4b9c05150a919");
const gte = require("7b5dc70556970d6c");
const lt = require("a3a3bcc6e4d6bbdf");
const lte = require("5f1835ee4d0596f3");
const cmp = (a, op, b, loose)=>{
    switch(op){
        case '===':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a === b;
        case '!==':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a !== b;
        case '':
        case '=':
        case '==':
            return eq(a, b, loose);
        case '!=':
            return neq(a, b, loose);
        case '>':
            return gt(a, b, loose);
        case '>=':
            return gte(a, b, loose);
        case '<':
            return lt(a, b, loose);
        case '<=':
            return lte(a, b, loose);
        default:
            throw new TypeError(`Invalid operator: ${op}`);
    }
};
module.exports = cmp;

},{"bff7f16298b8dbaa":"jsdf8","6a1bb69c2d499261":"dcpha","dca4b9c05150a919":"ilwzq","7b5dc70556970d6c":"7vvSp","a3a3bcc6e4d6bbdf":"82FFh","5f1835ee4d0596f3":"66IjO"}],"kAGTW":[function(require,module,exports,__globalThis) {
const SemVer = require("25529d97ade3ccdf");
const parse = require("90724e3140f56906");
const { safeRe: re, t } = require("49971e907f1359e9");
const coerce = (version, options)=>{
    if (version instanceof SemVer) return version;
    if (typeof version === 'number') version = String(version);
    if (typeof version !== 'string') return null;
    options = options || {};
    let match = null;
    if (!options.rtl) match = version.match(options.includePrerelease ? re[t.COERCEFULL] : re[t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        // With includePrerelease option set, '1.2.3.4-rc' wants to coerce '2.3.4-rc', not '2.3.4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        const coerceRtlRegex = options.includePrerelease ? re[t.COERCERTLFULL] : re[t.COERCERTL];
        let next;
        while((next = coerceRtlRegex.exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            coerceRtlRegex.lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        coerceRtlRegex.lastIndex = -1;
    }
    if (match === null) return null;
    const major = match[2];
    const minor = match[3] || '0';
    const patch = match[4] || '0';
    const prerelease = options.includePrerelease && match[5] ? `-${match[5]}` : '';
    const build = options.includePrerelease && match[6] ? `+${match[6]}` : '';
    return parse(`${major}.${minor}.${patch}${prerelease}${build}`, options);
};
module.exports = coerce;

},{"25529d97ade3ccdf":"9kWj6","90724e3140f56906":"dilqz","49971e907f1359e9":"5cdBQ"}],"c8PQa":[function(require,module,exports,__globalThis) {
const ANY = Symbol('SemVer ANY');
// hoisted class for cyclic dependency
class Comparator {
    static get ANY() {
        return ANY;
    }
    constructor(comp, options){
        options = parseOptions(options);
        if (comp instanceof Comparator) {
            if (comp.loose === !!options.loose) return comp;
            else comp = comp.value;
        }
        comp = comp.trim().split(/\s+/).join(' ');
        debug('comparator', comp, options);
        this.options = options;
        this.loose = !!options.loose;
        this.parse(comp);
        if (this.semver === ANY) this.value = '';
        else this.value = this.operator + this.semver.version;
        debug('comp', this);
    }
    parse(comp) {
        const r = this.options.loose ? re[t.COMPARATORLOOSE] : re[t.COMPARATOR];
        const m = comp.match(r);
        if (!m) throw new TypeError(`Invalid comparator: ${comp}`);
        this.operator = m[1] !== undefined ? m[1] : '';
        if (this.operator === '=') this.operator = '';
        // if it literally is just '>' or '' then allow anything.
        if (!m[2]) this.semver = ANY;
        else this.semver = new SemVer(m[2], this.options.loose);
    }
    toString() {
        return this.value;
    }
    test(version) {
        debug('Comparator.test', version, this.options.loose);
        if (this.semver === ANY || version === ANY) return true;
        if (typeof version === 'string') try {
            version = new SemVer(version, this.options);
        } catch (er) {
            return false;
        }
        return cmp(version, this.operator, this.semver, this.options);
    }
    intersects(comp, options) {
        if (!(comp instanceof Comparator)) throw new TypeError('a Comparator is required');
        if (this.operator === '') {
            if (this.value === '') return true;
            return new Range(comp.value, options).test(this.value);
        } else if (comp.operator === '') {
            if (comp.value === '') return true;
            return new Range(this.value, options).test(comp.semver);
        }
        options = parseOptions(options);
        // Special cases where nothing can possibly be lower
        if (options.includePrerelease && (this.value === '<0.0.0-0' || comp.value === '<0.0.0-0')) return false;
        if (!options.includePrerelease && (this.value.startsWith('<0.0.0') || comp.value.startsWith('<0.0.0'))) return false;
        // Same direction increasing (> or >=)
        if (this.operator.startsWith('>') && comp.operator.startsWith('>')) return true;
        // Same direction decreasing (< or <=)
        if (this.operator.startsWith('<') && comp.operator.startsWith('<')) return true;
        // same SemVer and both sides are inclusive (<= or >=)
        if (this.semver.version === comp.semver.version && this.operator.includes('=') && comp.operator.includes('=')) return true;
        // opposite directions less than
        if (cmp(this.semver, '<', comp.semver, options) && this.operator.startsWith('>') && comp.operator.startsWith('<')) return true;
        // opposite directions greater than
        if (cmp(this.semver, '>', comp.semver, options) && this.operator.startsWith('<') && comp.operator.startsWith('>')) return true;
        return false;
    }
}
module.exports = Comparator;
const parseOptions = require("b6563e9809bd921f");
const { safeRe: re, t } = require("f844ee6695e23038");
const cmp = require("e62b495d112b67cb");
const debug = require("13b490d953a8241f");
const SemVer = require("f688b7fbae163ad8");
const Range = require("b8839ba12a91a5c9");

},{"b6563e9809bd921f":"BsaT6","f844ee6695e23038":"5cdBQ","e62b495d112b67cb":"gnqYr","13b490d953a8241f":"lKIrJ","f688b7fbae163ad8":"9kWj6","b8839ba12a91a5c9":"ayUW4"}],"ayUW4":[function(require,module,exports,__globalThis) {
const SPACE_CHARACTERS = /\s+/g;
// hoisted class for cyclic dependency
class Range {
    constructor(range, options){
        options = parseOptions(options);
        if (range instanceof Range) {
            if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
            else return new Range(range.raw, options);
        }
        if (range instanceof Comparator) {
            // just put it in the set and return
            this.raw = range.value;
            this.set = [
                [
                    range
                ]
            ];
            this.formatted = undefined;
            return this;
        }
        this.options = options;
        this.loose = !!options.loose;
        this.includePrerelease = !!options.includePrerelease;
        // First reduce all whitespace as much as possible so we do not have to rely
        // on potentially slow regexes like \s*. This is then stored and used for
        // future error messages as well.
        this.raw = range.trim().replace(SPACE_CHARACTERS, ' ');
        // First, split on ||
        this.set = this.raw.split('||')// map the range to a 2d array of comparators
        .map((r)=>this.parseRange(r.trim()))// throw out any comparator lists that are empty
        // this generally means that it was not a valid range, which is allowed
        // in loose mode, but will still throw if the WHOLE range is invalid.
        .filter((c)=>c.length);
        if (!this.set.length) throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
        // if we have any that are not the null set, throw out null sets.
        if (this.set.length > 1) {
            // keep the first one, in case they're all null sets
            const first = this.set[0];
            this.set = this.set.filter((c)=>!isNullSet(c[0]));
            if (this.set.length === 0) this.set = [
                first
            ];
            else if (this.set.length > 1) {
                // if we have any that are *, then the range is just *
                for (const c of this.set)if (c.length === 1 && isAny(c[0])) {
                    this.set = [
                        c
                    ];
                    break;
                }
            }
        }
        this.formatted = undefined;
    }
    get range() {
        if (this.formatted === undefined) {
            this.formatted = '';
            for(let i = 0; i < this.set.length; i++){
                if (i > 0) this.formatted += '||';
                const comps = this.set[i];
                for(let k = 0; k < comps.length; k++){
                    if (k > 0) this.formatted += ' ';
                    this.formatted += comps[k].toString().trim();
                }
            }
        }
        return this.formatted;
    }
    format() {
        return this.range;
    }
    toString() {
        return this.range;
    }
    parseRange(range) {
        // memoize range parsing for performance.
        // this is a very hot path, and fully deterministic.
        const memoOpts = (this.options.includePrerelease && FLAG_INCLUDE_PRERELEASE) | (this.options.loose && FLAG_LOOSE);
        const memoKey = memoOpts + ':' + range;
        const cached = cache.get(memoKey);
        if (cached) return cached;
        const loose = this.options.loose;
        // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
        const hr = loose ? re[t.HYPHENRANGELOOSE] : re[t.HYPHENRANGE];
        range = range.replace(hr, hyphenReplace(this.options.includePrerelease));
        debug('hyphen replace', range);
        // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
        range = range.replace(re[t.COMPARATORTRIM], comparatorTrimReplace);
        debug('comparator trim', range);
        // `~ 1.2.3` => `~1.2.3`
        range = range.replace(re[t.TILDETRIM], tildeTrimReplace);
        debug('tilde trim', range);
        // `^ 1.2.3` => `^1.2.3`
        range = range.replace(re[t.CARETTRIM], caretTrimReplace);
        debug('caret trim', range);
        // At this point, the range is completely trimmed and
        // ready to be split into comparators.
        let rangeList = range.split(' ').map((comp)=>parseComparator(comp, this.options)).join(' ').split(/\s+/)// >=0.0.0 is equivalent to *
        .map((comp)=>replaceGTE0(comp, this.options));
        if (loose) // in loose mode, throw out any that are not valid comparators
        rangeList = rangeList.filter((comp)=>{
            debug('loose invalid filter', comp, this.options);
            return !!comp.match(re[t.COMPARATORLOOSE]);
        });
        debug('range list', rangeList);
        // if any comparators are the null set, then replace with JUST null set
        // if more than one comparator, remove any * comparators
        // also, don't include the same comparator more than once
        const rangeMap = new Map();
        const comparators = rangeList.map((comp)=>new Comparator(comp, this.options));
        for (const comp of comparators){
            if (isNullSet(comp)) return [
                comp
            ];
            rangeMap.set(comp.value, comp);
        }
        if (rangeMap.size > 1 && rangeMap.has('')) rangeMap.delete('');
        const result = [
            ...rangeMap.values()
        ];
        cache.set(memoKey, result);
        return result;
    }
    intersects(range, options) {
        if (!(range instanceof Range)) throw new TypeError('a Range is required');
        return this.set.some((thisComparators)=>{
            return isSatisfiable(thisComparators, options) && range.set.some((rangeComparators)=>{
                return isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator)=>{
                    return rangeComparators.every((rangeComparator)=>{
                        return thisComparator.intersects(rangeComparator, options);
                    });
                });
            });
        });
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(version) {
        if (!version) return false;
        if (typeof version === 'string') try {
            version = new SemVer(version, this.options);
        } catch (er) {
            return false;
        }
        for(let i = 0; i < this.set.length; i++){
            if (testSet(this.set[i], version, this.options)) return true;
        }
        return false;
    }
}
module.exports = Range;
const LRU = require("96f33215aad25ada");
const cache = new LRU();
const parseOptions = require("17bb122b9b0740d9");
const Comparator = require("df9131adcc191f91");
const debug = require("1c7c6c8abfe9bd3b");
const SemVer = require("d77fd978650b507f");
const { safeRe: re, t, comparatorTrimReplace, tildeTrimReplace, caretTrimReplace } = require("9bd5ca5276add1c4");
const { FLAG_INCLUDE_PRERELEASE, FLAG_LOOSE } = require("8c8074dc7fc46964");
const isNullSet = (c)=>c.value === '<0.0.0-0';
const isAny = (c)=>c.value === '';
// take a set of comparators and determine whether there
// exists a version which can satisfy it
const isSatisfiable = (comparators, options)=>{
    let result = true;
    const remainingComparators = comparators.slice();
    let testComparator = remainingComparators.pop();
    while(result && remainingComparators.length){
        result = remainingComparators.every((otherComparator)=>{
            return testComparator.intersects(otherComparator, options);
        });
        testComparator = remainingComparators.pop();
    }
    return result;
};
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
const parseComparator = (comp, options)=>{
    debug('comp', comp, options);
    comp = replaceCarets(comp, options);
    debug('caret', comp);
    comp = replaceTildes(comp, options);
    debug('tildes', comp);
    comp = replaceXRanges(comp, options);
    debug('xrange', comp);
    comp = replaceStars(comp, options);
    debug('stars', comp);
    return comp;
};
const isX = (id)=>!id || id.toLowerCase() === 'x' || id === '*';
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
// ~0.0.1 --> >=0.0.1 <0.1.0-0
const replaceTildes = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>replaceTilde(c, options)).join(' ');
};
const replaceTilde = (comp, options)=>{
    const r = options.loose ? re[t.TILDELOOSE] : re[t.TILDE];
    return comp.replace(r, (_, M, m, p, pr)=>{
        debug('tilde', comp, _, M, m, p, pr);
        let ret;
        if (isX(M)) ret = '';
        else if (isX(m)) ret = `>=${M}.0.0 <${+M + 1}.0.0-0`;
        else if (isX(p)) // ~1.2 == >=1.2.0 <1.3.0-0
        ret = `>=${M}.${m}.0 <${M}.${+m + 1}.0-0`;
        else if (pr) {
            debug('replaceTilde pr', pr);
            ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
        } else // ~1.2.3 == >=1.2.3 <1.3.0-0
        ret = `>=${M}.${m}.${p} <${M}.${+m + 1}.0-0`;
        debug('tilde return', ret);
        return ret;
    });
};
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
// ^1.2.3 --> >=1.2.3 <2.0.0-0
// ^1.2.0 --> >=1.2.0 <2.0.0-0
// ^0.0.1 --> >=0.0.1 <0.0.2-0
// ^0.1.0 --> >=0.1.0 <0.2.0-0
const replaceCarets = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>replaceCaret(c, options)).join(' ');
};
const replaceCaret = (comp, options)=>{
    debug('caret', comp, options);
    const r = options.loose ? re[t.CARETLOOSE] : re[t.CARET];
    const z = options.includePrerelease ? '-0' : '';
    return comp.replace(r, (_, M, m, p, pr)=>{
        debug('caret', comp, _, M, m, p, pr);
        let ret;
        if (isX(M)) ret = '';
        else if (isX(m)) ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
        else if (isX(p)) {
            if (M === '0') ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
            else ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0`;
        } else if (pr) {
            debug('replaceCaret pr', pr);
            if (M === '0') {
                if (m === '0') ret = `>=${M}.${m}.${p}-${pr} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p}-${pr} <${+M + 1}.0.0-0`;
        } else {
            debug('no pr');
            if (M === '0') {
                if (m === '0') ret = `>=${M}.${m}.${p}${z} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}${z} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p} <${+M + 1}.0.0-0`;
        }
        debug('caret return', ret);
        return ret;
    });
};
const replaceXRanges = (comp, options)=>{
    debug('replaceXRanges', comp, options);
    return comp.split(/\s+/).map((c)=>replaceXRange(c, options)).join(' ');
};
const replaceXRange = (comp, options)=>{
    comp = comp.trim();
    const r = options.loose ? re[t.XRANGELOOSE] : re[t.XRANGE];
    return comp.replace(r, (ret, gtlt, M, m, p, pr)=>{
        debug('xRange', comp, ret, gtlt, M, m, p, pr);
        const xM = isX(M);
        const xm = xM || isX(m);
        const xp = xm || isX(p);
        const anyX = xp;
        if (gtlt === '=' && anyX) gtlt = '';
        // if we're including prereleases in the match, then we need
        // to fix this to -0, the lowest possible prerelease value
        pr = options.includePrerelease ? '-0' : '';
        if (xM) {
            if (gtlt === '>' || gtlt === '<') // nothing is allowed
            ret = '<0.0.0-0';
            else // nothing is forbidden
            ret = '*';
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === '>') {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                gtlt = '>=';
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === '<=') {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = '<';
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            if (gtlt === '<') pr = '-0';
            ret = `${gtlt + M}.${m}.${p}${pr}`;
        } else if (xm) ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0`;
        else if (xp) ret = `>=${M}.${m}.0${pr} <${M}.${+m + 1}.0-0`;
        debug('xRange return', ret);
        return ret;
    });
};
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
const replaceStars = (comp, options)=>{
    debug('replaceStars', comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace(re[t.STAR], '');
};
const replaceGTE0 = (comp, options)=>{
    debug('replaceGTE0', comp, options);
    return comp.trim().replace(re[options.includePrerelease ? t.GTE0PRE : t.GTE0], '');
};
// This function is passed to string.replace(re[t.HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0-0
// TODO build?
const hyphenReplace = (incPr)=>($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr)=>{
        if (isX(fM)) from = '';
        else if (isX(fm)) from = `>=${fM}.0.0${incPr ? '-0' : ''}`;
        else if (isX(fp)) from = `>=${fM}.${fm}.0${incPr ? '-0' : ''}`;
        else if (fpr) from = `>=${from}`;
        else from = `>=${from}${incPr ? '-0' : ''}`;
        if (isX(tM)) to = '';
        else if (isX(tm)) to = `<${+tM + 1}.0.0-0`;
        else if (isX(tp)) to = `<${tM}.${+tm + 1}.0-0`;
        else if (tpr) to = `<=${tM}.${tm}.${tp}-${tpr}`;
        else if (incPr) to = `<${tM}.${tm}.${+tp + 1}-0`;
        else to = `<=${to}`;
        return `${from} ${to}`.trim();
    };
const testSet = (set, version, options)=>{
    for(let i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(let i = 0; i < set.length; i++){
            debug(set[i].semver);
            if (set[i].semver === Comparator.ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                const allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
};

},{"96f33215aad25ada":"5T4nU","17bb122b9b0740d9":"BsaT6","df9131adcc191f91":"c8PQa","1c7c6c8abfe9bd3b":"lKIrJ","d77fd978650b507f":"9kWj6","9bd5ca5276add1c4":"5cdBQ","8c8074dc7fc46964":"gdL3I"}],"5T4nU":[function(require,module,exports,__globalThis) {
class LRUCache {
    constructor(){
        this.max = 1000;
        this.map = new Map();
    }
    get(key) {
        const value = this.map.get(key);
        if (value === undefined) return undefined;
        else {
            // Remove the key from the map and add it to the end
            this.map.delete(key);
            this.map.set(key, value);
            return value;
        }
    }
    delete(key) {
        return this.map.delete(key);
    }
    set(key, value) {
        const deleted = this.delete(key);
        if (!deleted && value !== undefined) {
            // If cache is full, delete the least recently used item
            if (this.map.size >= this.max) {
                const firstKey = this.map.keys().next().value;
                this.delete(firstKey);
            }
            this.map.set(key, value);
        }
        return this;
    }
}
module.exports = LRUCache;

},{}],"7PGRl":[function(require,module,exports,__globalThis) {
const Range = require("b60a47303a13d107");
const satisfies = (version, range, options)=>{
    try {
        range = new Range(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
};
module.exports = satisfies;

},{"b60a47303a13d107":"ayUW4"}],"mBrxP":[function(require,module,exports,__globalThis) {
const Range = require("f497be9904aac7c0");
// Mostly just for testing and legacy API reasons
const toComparators = (range, options)=>new Range(range, options).set.map((comp)=>comp.map((c)=>c.value).join(' ').trim().split(' '));
module.exports = toComparators;

},{"f497be9904aac7c0":"ayUW4"}],"epzu3":[function(require,module,exports,__globalThis) {
const SemVer = require("96d622a81d57358d");
const Range = require("f2865e94142488ab");
const maxSatisfying = (versions, range, options)=>{
    let max = null;
    let maxSV = null;
    let rangeObj = null;
    try {
        rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new SemVer(max, options);
            }
        }
    });
    return max;
};
module.exports = maxSatisfying;

},{"96d622a81d57358d":"9kWj6","f2865e94142488ab":"ayUW4"}],"6yskI":[function(require,module,exports,__globalThis) {
const SemVer = require("fea3851ba09d8834");
const Range = require("9d2799b098b5c4c7");
const minSatisfying = (versions, range, options)=>{
    let min = null;
    let minSV = null;
    let rangeObj = null;
    try {
        rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new SemVer(min, options);
            }
        }
    });
    return min;
};
module.exports = minSatisfying;

},{"fea3851ba09d8834":"9kWj6","9d2799b098b5c4c7":"ayUW4"}],"74MHi":[function(require,module,exports,__globalThis) {
const SemVer = require("4c531b1d555da497");
const Range = require("76327127dc36ed58");
const gt = require("a5ac47b45ae8684c");
const minVersion = (range, loose)=>{
    range = new Range(range, loose);
    let minver = new SemVer('0.0.0');
    if (range.test(minver)) return minver;
    minver = new SemVer('0.0.0-0');
    if (range.test(minver)) return minver;
    minver = null;
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let setMin = null;
        comparators.forEach((comparator)=>{
            // Clone to avoid manipulating the comparator's semver object.
            const compver = new SemVer(comparator.semver.version);
            switch(comparator.operator){
                case '>':
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case '':
                case '>=':
                    if (!setMin || gt(compver, setMin)) setMin = compver;
                    break;
                case '<':
                case '<=':
                    break;
                /* istanbul ignore next */ default:
                    throw new Error(`Unexpected operation: ${comparator.operator}`);
            }
        });
        if (setMin && (!minver || gt(minver, setMin))) minver = setMin;
    }
    if (minver && range.test(minver)) return minver;
    return null;
};
module.exports = minVersion;

},{"4c531b1d555da497":"9kWj6","76327127dc36ed58":"ayUW4","a5ac47b45ae8684c":"ilwzq"}],"g62Od":[function(require,module,exports,__globalThis) {
const Range = require("fd2c35053245b1fd");
const validRange = (range, options)=>{
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new Range(range, options).range || '*';
    } catch (er) {
        return null;
    }
};
module.exports = validRange;

},{"fd2c35053245b1fd":"ayUW4"}],"ciquJ":[function(require,module,exports,__globalThis) {
const SemVer = require("65977c6c7fab41e0");
const Comparator = require("8b0890ac7a0294ed");
const { ANY } = Comparator;
const Range = require("9baad77301d611e2");
const satisfies = require("1a3d276234841886");
const gt = require("8f784c6ef2cd1972");
const lt = require("3c234e2ddd9db68a");
const lte = require("88893a74cd9f934");
const gte = require("6cccfcce37ef6329");
const outside = (version, range, hilo, options)=>{
    version = new SemVer(version, options);
    range = new Range(range, options);
    let gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case '>':
            gtfn = gt;
            ltefn = lte;
            ltfn = lt;
            comp = '>';
            ecomp = '>=';
            break;
        case '<':
            gtfn = lt;
            ltefn = gte;
            ltfn = gt;
            comp = '<';
            ecomp = '<=';
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisfies the range it is not outside
    if (satisfies(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let high = null;
        let low = null;
        comparators.forEach((comparator)=>{
            if (comparator.semver === ANY) comparator = new Comparator('>=0.0.0');
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
};
module.exports = outside;

},{"65977c6c7fab41e0":"9kWj6","8b0890ac7a0294ed":"c8PQa","9baad77301d611e2":"ayUW4","1a3d276234841886":"7PGRl","8f784c6ef2cd1972":"ilwzq","3c234e2ddd9db68a":"82FFh","88893a74cd9f934":"66IjO","6cccfcce37ef6329":"7vvSp"}],"9oyAI":[function(require,module,exports,__globalThis) {
// Determine if version is greater than all the versions possible in the range.
const outside = require("be5e984e16e512b9");
const gtr = (version, range, options)=>outside(version, range, '>', options);
module.exports = gtr;

},{"be5e984e16e512b9":"ciquJ"}],"gI1Ss":[function(require,module,exports,__globalThis) {
const outside = require("b7f00e21a32b75a5");
// Determine if version is less than all the versions possible in the range
const ltr = (version, range, options)=>outside(version, range, '<', options);
module.exports = ltr;

},{"b7f00e21a32b75a5":"ciquJ"}],"hbv8W":[function(require,module,exports,__globalThis) {
const Range = require("5205f80872e81710");
const intersects = (r1, r2, options)=>{
    r1 = new Range(r1, options);
    r2 = new Range(r2, options);
    return r1.intersects(r2, options);
};
module.exports = intersects;

},{"5205f80872e81710":"ayUW4"}],"kmLkM":[function(require,module,exports,__globalThis) {
// given a set of versions and a range, create a "simplified" range
// that includes the same versions that the original range does
// If the original range is shorter than the simplified one, return that.
const satisfies = require("e72123f17434788");
const compare = require("3eb9817061c82995");
module.exports = (versions, range, options)=>{
    const set = [];
    let first = null;
    let prev = null;
    const v = versions.sort((a, b)=>compare(a, b, options));
    for (const version of v){
        const included = satisfies(version, range, options);
        if (included) {
            prev = version;
            if (!first) first = version;
        } else {
            if (prev) set.push([
                first,
                prev
            ]);
            prev = null;
            first = null;
        }
    }
    if (first) set.push([
        first,
        null
    ]);
    const ranges = [];
    for (const [min, max] of set){
        if (min === max) ranges.push(min);
        else if (!max && min === v[0]) ranges.push('*');
        else if (!max) ranges.push(`>=${min}`);
        else if (min === v[0]) ranges.push(`<=${max}`);
        else ranges.push(`${min} - ${max}`);
    }
    const simplified = ranges.join(' || ');
    const original = typeof range.raw === 'string' ? range.raw : String(range);
    return simplified.length < original.length ? simplified : range;
};

},{"e72123f17434788":"7PGRl","3eb9817061c82995":"c97Kn"}],"dCUUu":[function(require,module,exports,__globalThis) {
const Range = require("c141b0432e6ae71b");
const Comparator = require("94bed966a1054073");
const { ANY } = Comparator;
const satisfies = require("acfaf6445a9794b");
const compare = require("d9ed82a69c119cf4");
// Complex range `r1 || r2 || ...` is a subset of `R1 || R2 || ...` iff:
// - Every simple range `r1, r2, ...` is a null set, OR
// - Every simple range `r1, r2, ...` which is not a null set is a subset of
//   some `R1, R2, ...`
//
// Simple range `c1 c2 ...` is a subset of simple range `C1 C2 ...` iff:
// - If c is only the ANY comparator
//   - If C is only the ANY comparator, return true
//   - Else if in prerelease mode, return false
//   - else replace c with `[>=0.0.0]`
// - If C is only the ANY comparator
//   - if in prerelease mode, return true
//   - else replace C with `[>=0.0.0]`
// - Let EQ be the set of = comparators in c
// - If EQ is more than one, return true (null set)
// - Let GT be the highest > or >= comparator in c
// - Let LT be the lowest < or <= comparator in c
// - If GT and LT, and GT.semver > LT.semver, return true (null set)
// - If any C is a = range, and GT or LT are set, return false
// - If EQ
//   - If GT, and EQ does not satisfy GT, return true (null set)
//   - If LT, and EQ does not satisfy LT, return true (null set)
//   - If EQ satisfies every C, return true
//   - Else return false
// - If GT
//   - If GT.semver is lower than any > or >= comp in C, return false
//   - If GT is >=, and GT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the GT.semver tuple, return false
// - If LT
//   - If LT.semver is greater than any < or <= comp in C, return false
//   - If LT is <=, and LT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the LT.semver tuple, return false
// - Else return true
const subset = (sub, dom, options = {})=>{
    if (sub === dom) return true;
    sub = new Range(sub, options);
    dom = new Range(dom, options);
    let sawNonNull = false;
    OUTER: for (const simpleSub of sub.set){
        for (const simpleDom of dom.set){
            const isSub = simpleSubset(simpleSub, simpleDom, options);
            sawNonNull = sawNonNull || isSub !== null;
            if (isSub) continue OUTER;
        }
        // the null set is a subset of everything, but null simple ranges in
        // a complex range should be ignored.  so if we saw a non-null range,
        // then we know this isn't a subset, but if EVERY simple range was null,
        // then it is a subset.
        if (sawNonNull) return false;
    }
    return true;
};
const minimumVersionWithPreRelease = [
    new Comparator('>=0.0.0-0')
];
const minimumVersion = [
    new Comparator('>=0.0.0')
];
const simpleSubset = (sub, dom, options)=>{
    if (sub === dom) return true;
    if (sub.length === 1 && sub[0].semver === ANY) {
        if (dom.length === 1 && dom[0].semver === ANY) return true;
        else if (options.includePrerelease) sub = minimumVersionWithPreRelease;
        else sub = minimumVersion;
    }
    if (dom.length === 1 && dom[0].semver === ANY) {
        if (options.includePrerelease) return true;
        else dom = minimumVersion;
    }
    const eqSet = new Set();
    let gt, lt;
    for (const c of sub){
        if (c.operator === '>' || c.operator === '>=') gt = higherGT(gt, c, options);
        else if (c.operator === '<' || c.operator === '<=') lt = lowerLT(lt, c, options);
        else eqSet.add(c.semver);
    }
    if (eqSet.size > 1) return null;
    let gtltComp;
    if (gt && lt) {
        gtltComp = compare(gt.semver, lt.semver, options);
        if (gtltComp > 0) return null;
        else if (gtltComp === 0 && (gt.operator !== '>=' || lt.operator !== '<=')) return null;
    }
    // will iterate one or zero times
    for (const eq of eqSet){
        if (gt && !satisfies(eq, String(gt), options)) return null;
        if (lt && !satisfies(eq, String(lt), options)) return null;
        for (const c of dom){
            if (!satisfies(eq, String(c), options)) return false;
        }
        return true;
    }
    let higher, lower;
    let hasDomLT, hasDomGT;
    // if the subset has a prerelease, we need a comparator in the superset
    // with the same tuple and a prerelease, or it's not a subset
    let needDomLTPre = lt && !options.includePrerelease && lt.semver.prerelease.length ? lt.semver : false;
    let needDomGTPre = gt && !options.includePrerelease && gt.semver.prerelease.length ? gt.semver : false;
    // exception: <1.2.3-0 is the same as <1.2.3
    if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt.operator === '<' && needDomLTPre.prerelease[0] === 0) needDomLTPre = false;
    for (const c of dom){
        hasDomGT = hasDomGT || c.operator === '>' || c.operator === '>=';
        hasDomLT = hasDomLT || c.operator === '<' || c.operator === '<=';
        if (gt) {
            if (needDomGTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomGTPre.major && c.semver.minor === needDomGTPre.minor && c.semver.patch === needDomGTPre.patch) needDomGTPre = false;
            }
            if (c.operator === '>' || c.operator === '>=') {
                higher = higherGT(gt, c, options);
                if (higher === c && higher !== gt) return false;
            } else if (gt.operator === '>=' && !satisfies(gt.semver, String(c), options)) return false;
        }
        if (lt) {
            if (needDomLTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomLTPre.major && c.semver.minor === needDomLTPre.minor && c.semver.patch === needDomLTPre.patch) needDomLTPre = false;
            }
            if (c.operator === '<' || c.operator === '<=') {
                lower = lowerLT(lt, c, options);
                if (lower === c && lower !== lt) return false;
            } else if (lt.operator === '<=' && !satisfies(lt.semver, String(c), options)) return false;
        }
        if (!c.operator && (lt || gt) && gtltComp !== 0) return false;
    }
    // if there was a < or >, and nothing in the dom, then must be false
    // UNLESS it was limited by another range in the other direction.
    // Eg, >1.0.0 <1.0.1 is still a subset of <2.0.0
    if (gt && hasDomLT && !lt && gtltComp !== 0) return false;
    if (lt && hasDomGT && !gt && gtltComp !== 0) return false;
    // we needed a prerelease range in a specific tuple, but didn't get one
    // then this isn't a subset.  eg >=1.2.3-pre is not a subset of >=1.0.0,
    // because it includes prereleases in the 1.2.3 tuple
    if (needDomGTPre || needDomLTPre) return false;
    return true;
};
// >=1.2.3 is lower than >1.2.3
const higherGT = (a, b, options)=>{
    if (!a) return b;
    const comp = compare(a.semver, b.semver, options);
    return comp > 0 ? a : comp < 0 ? b : b.operator === '>' && a.operator === '>=' ? b : a;
};
// <=1.2.3 is higher than <1.2.3
const lowerLT = (a, b, options)=>{
    if (!a) return b;
    const comp = compare(a.semver, b.semver, options);
    return comp < 0 ? a : comp > 0 ? b : b.operator === '<' && a.operator === '<=' ? b : a;
};
module.exports = subset;

},{"c141b0432e6ae71b":"ayUW4","94bed966a1054073":"c8PQa","acfaf6445a9794b":"7PGRl","d9ed82a69c119cf4":"c97Kn"}],"2Jj1D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dataflow", ()=>(0, _vegaDataflow.Dataflow));
parcelHelpers.export(exports, "EventStream", ()=>(0, _vegaDataflow.EventStream));
parcelHelpers.export(exports, "MultiPulse", ()=>(0, _vegaDataflow.MultiPulse));
parcelHelpers.export(exports, "Operator", ()=>(0, _vegaDataflow.Operator));
parcelHelpers.export(exports, "Parameters", ()=>(0, _vegaDataflow.Parameters));
parcelHelpers.export(exports, "Pulse", ()=>(0, _vegaDataflow.Pulse));
parcelHelpers.export(exports, "Transform", ()=>(0, _vegaDataflow.Transform));
parcelHelpers.export(exports, "changeset", ()=>(0, _vegaDataflow.changeset));
parcelHelpers.export(exports, "definition", ()=>(0, _vegaDataflow.definition));
parcelHelpers.export(exports, "ingest", ()=>(0, _vegaDataflow.ingest));
parcelHelpers.export(exports, "isTuple", ()=>(0, _vegaDataflow.isTuple));
parcelHelpers.export(exports, "transform", ()=>(0, _vegaDataflow.transform));
parcelHelpers.export(exports, "transforms", ()=>(0, _vegaDataflow.transforms));
parcelHelpers.export(exports, "tupleid", ()=>(0, _vegaDataflow.tupleid));
parcelHelpers.export(exports, "interpolate", ()=>(0, _vegaScale.interpolate));
parcelHelpers.export(exports, "interpolateColors", ()=>(0, _vegaScale.interpolateColors));
parcelHelpers.export(exports, "interpolateRange", ()=>(0, _vegaScale.interpolateRange));
parcelHelpers.export(exports, "quantizeInterpolator", ()=>(0, _vegaScale.quantizeInterpolator));
parcelHelpers.export(exports, "scale", ()=>(0, _vegaScale.scale));
parcelHelpers.export(exports, "scheme", ()=>(0, _vegaScale.scheme));
parcelHelpers.export(exports, "projection", ()=>(0, _vegaProjection.projection));
parcelHelpers.export(exports, "View", ()=>(0, _vegaView.View));
parcelHelpers.export(exports, "defaultLocale", ()=>(0, _vegaFormat.defaultLocale));
parcelHelpers.export(exports, "formatLocale", ()=>(0, _vegaFormat.numberFormatDefaultLocale));
parcelHelpers.export(exports, "locale", ()=>(0, _vegaFormat.locale));
parcelHelpers.export(exports, "resetDefaultLocale", ()=>(0, _vegaFormat.resetDefaultLocale));
parcelHelpers.export(exports, "timeFormatLocale", ()=>(0, _vegaFormat.timeFormatDefaultLocale));
parcelHelpers.export(exports, "expressionFunction", ()=>(0, _vegaFunctions.expressionFunction));
parcelHelpers.export(exports, "parse", ()=>(0, _vegaParser.parse));
parcelHelpers.export(exports, "runtimeContext", ()=>(0, _vegaRuntime.context));
parcelHelpers.export(exports, "codegenExpression", ()=>(0, _vegaExpression.codegenExpression));
parcelHelpers.export(exports, "parseExpression", ()=>(0, _vegaExpression.parseExpression));
parcelHelpers.export(exports, "parseSelector", ()=>(0, _vegaEventSelector.parseSelector));
parcelHelpers.export(exports, "version", ()=>version);
var _vegaUtil = require("vega-util");
parcelHelpers.exportAll(_vegaUtil, exports);
var _vegaDataflow = require("vega-dataflow");
var _vegaTransforms = require("vega-transforms");
var _vegaViewTransforms = require("vega-view-transforms");
var _vegaEncode = require("vega-encode");
var _vegaGeo = require("vega-geo");
var _vegaForce = require("vega-force");
var _vegaHierarchy = require("vega-hierarchy");
var _vegaLabel = require("vega-label");
var _vegaRegression = require("vega-regression");
var _vegaVoronoi = require("vega-voronoi");
var _vegaWordcloud = require("vega-wordcloud");
var _vegaCrossfilter = require("vega-crossfilter");
var _vegaStatistics = require("vega-statistics");
parcelHelpers.exportAll(_vegaStatistics, exports);
var _vegaTime = require("vega-time");
parcelHelpers.exportAll(_vegaTime, exports);
var _vegaLoader = require("vega-loader");
parcelHelpers.exportAll(_vegaLoader, exports);
var _vegaScenegraph = require("vega-scenegraph");
parcelHelpers.exportAll(_vegaScenegraph, exports);
var _vegaScale = require("vega-scale");
var _vegaProjection = require("vega-projection");
var _vegaView = require("vega-view");
var _vegaFormat = require("vega-format");
var _vegaFunctions = require("vega-functions");
var _vegaParser = require("vega-parser");
var _vegaRuntime = require("vega-runtime");
var _vegaExpression = require("vega-expression");
var _vegaEventSelector = require("vega-event-selector");
var version = "5.33.0";
// -- Transforms -----
(0, _vegaUtil.extend)((0, _vegaDataflow.transforms), _vegaTransforms, _vegaViewTransforms, _vegaEncode, _vegaGeo, _vegaForce, _vegaLabel, _vegaHierarchy, _vegaRegression, _vegaVoronoi, _vegaWordcloud, _vegaCrossfilter);

},{"vega-util":"7f6sQ","vega-dataflow":"4An7U","vega-transforms":"5I5cd","vega-view-transforms":"5k8qQ","vega-encode":"c2Nqb","vega-geo":"dcuPv","vega-force":"bjPWi","vega-hierarchy":"68WRu","vega-label":"aIpKT","vega-regression":"8OJCr","vega-voronoi":"6mtJw","vega-wordcloud":"avVAf","vega-crossfilter":"3mSgx","vega-statistics":"lNUxJ","vega-time":"4oydN","vega-loader":"mXgcA","vega-scenegraph":"823vy","vega-scale":"13gXz","vega-projection":"ijSgT","vega-view":"6aPCc","vega-format":"kHjpR","vega-functions":"8ACB6","vega-parser":"2ZEi7","vega-runtime":"hNLpK","vega-expression":"clSwj","vega-event-selector":"ijmxJ","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"7f6sQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Debug", ()=>Debug);
parcelHelpers.export(exports, "Error", ()=>Error$1);
parcelHelpers.export(exports, "Info", ()=>Info);
parcelHelpers.export(exports, "None", ()=>None);
parcelHelpers.export(exports, "Warn", ()=>Warn);
parcelHelpers.export(exports, "accessor", ()=>accessor);
parcelHelpers.export(exports, "accessorFields", ()=>accessorFields);
parcelHelpers.export(exports, "accessorName", ()=>accessorName);
parcelHelpers.export(exports, "array", ()=>array);
parcelHelpers.export(exports, "ascending", ()=>ascending);
parcelHelpers.export(exports, "clampRange", ()=>clampRange);
parcelHelpers.export(exports, "compare", ()=>compare);
parcelHelpers.export(exports, "constant", ()=>constant);
parcelHelpers.export(exports, "debounce", ()=>debounce);
parcelHelpers.export(exports, "error", ()=>error);
parcelHelpers.export(exports, "extend", ()=>extend);
parcelHelpers.export(exports, "extent", ()=>extent);
parcelHelpers.export(exports, "extentIndex", ()=>extentIndex);
parcelHelpers.export(exports, "falsy", ()=>falsy);
parcelHelpers.export(exports, "fastmap", ()=>fastmap);
parcelHelpers.export(exports, "field", ()=>field);
parcelHelpers.export(exports, "flush", ()=>flush);
parcelHelpers.export(exports, "hasOwnProperty", ()=>has);
parcelHelpers.export(exports, "id", ()=>id);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "inherits", ()=>inherits);
parcelHelpers.export(exports, "inrange", ()=>inrange);
parcelHelpers.export(exports, "isArray", ()=>isArray);
parcelHelpers.export(exports, "isBoolean", ()=>isBoolean);
parcelHelpers.export(exports, "isDate", ()=>isDate);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
parcelHelpers.export(exports, "isIterable", ()=>isIterable);
parcelHelpers.export(exports, "isNumber", ()=>isNumber);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "isRegExp", ()=>isRegExp);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "key", ()=>key);
parcelHelpers.export(exports, "lerp", ()=>lerp);
parcelHelpers.export(exports, "logger", ()=>logger);
parcelHelpers.export(exports, "lruCache", ()=>lruCache);
parcelHelpers.export(exports, "merge", ()=>merge);
parcelHelpers.export(exports, "mergeConfig", ()=>mergeConfig);
parcelHelpers.export(exports, "one", ()=>one);
parcelHelpers.export(exports, "pad", ()=>pad);
parcelHelpers.export(exports, "panLinear", ()=>panLinear);
parcelHelpers.export(exports, "panLog", ()=>panLog);
parcelHelpers.export(exports, "panPow", ()=>panPow);
parcelHelpers.export(exports, "panSymlog", ()=>panSymlog);
parcelHelpers.export(exports, "peek", ()=>peek);
parcelHelpers.export(exports, "quarter", ()=>quarter);
parcelHelpers.export(exports, "repeat", ()=>repeat);
parcelHelpers.export(exports, "span", ()=>span);
parcelHelpers.export(exports, "splitAccessPath", ()=>splitAccessPath);
parcelHelpers.export(exports, "stringValue", ()=>$);
parcelHelpers.export(exports, "toBoolean", ()=>toBoolean);
parcelHelpers.export(exports, "toDate", ()=>toDate);
parcelHelpers.export(exports, "toNumber", ()=>toNumber);
parcelHelpers.export(exports, "toSet", ()=>toSet);
parcelHelpers.export(exports, "toString", ()=>toString);
parcelHelpers.export(exports, "truncate", ()=>truncate);
parcelHelpers.export(exports, "truthy", ()=>truthy);
parcelHelpers.export(exports, "utcquarter", ()=>utcquarter);
parcelHelpers.export(exports, "visitArray", ()=>visitArray);
parcelHelpers.export(exports, "writeConfig", ()=>writeConfig);
parcelHelpers.export(exports, "zero", ()=>zero);
parcelHelpers.export(exports, "zoomLinear", ()=>zoomLinear);
parcelHelpers.export(exports, "zoomLog", ()=>zoomLog);
parcelHelpers.export(exports, "zoomPow", ()=>zoomPow);
parcelHelpers.export(exports, "zoomSymlog", ()=>zoomSymlog);
function accessor(fn, fields, name) {
    fn.fields = fields || [];
    fn.fname = name;
    return fn;
}
function accessorName(fn) {
    return fn == null ? null : fn.fname;
}
function accessorFields(fn) {
    return fn == null ? null : fn.fields;
}
function getter(path) {
    return path.length === 1 ? get1(path[0]) : getN(path);
}
const get1 = (field)=>function(obj) {
        return obj[field];
    };
const getN = (path)=>{
    const len = path.length;
    return function(obj) {
        for(let i = 0; i < len; ++i)obj = obj[path[i]];
        return obj;
    };
};
function error(message) {
    throw Error(message);
}
function splitAccessPath(p) {
    const path = [], n = p.length;
    let q = null, b = 0, s = '', i, j, c;
    p = p + '';
    function push() {
        path.push(s + p.substring(i, j));
        s = '';
        i = j + 1;
    }
    for(i = j = 0; j < n; ++j){
        c = p[j];
        if (c === '\\') {
            s += p.substring(i, j++);
            i = j;
        } else if (c === q) {
            push();
            q = null;
            b = -1;
        } else if (q) continue;
        else if (i === b && c === '"') {
            i = j + 1;
            q = c;
        } else if (i === b && c === "'") {
            i = j + 1;
            q = c;
        } else if (c === '.' && !b) {
            if (j > i) push();
            else i = j + 1;
        } else if (c === '[') {
            if (j > i) push();
            b = i = j + 1;
        } else if (c === ']') {
            if (!b) error('Access path missing open bracket: ' + p);
            if (b > 0) push();
            b = 0;
            i = j + 1;
        }
    }
    if (b) error('Access path missing closing bracket: ' + p);
    if (q) error('Access path missing closing quote: ' + p);
    if (j > i) {
        j++;
        push();
    }
    return path;
}
function field(field, name, opt) {
    const path = splitAccessPath(field);
    field = path.length === 1 ? path[0] : field;
    return accessor((opt && opt.get || getter)(path), [
        field
    ], name || field);
}
const id = field('id');
const identity = accessor((_)=>_, [], 'identity');
const zero = accessor(()=>0, [], 'zero');
const one = accessor(()=>1, [], 'one');
const truthy = accessor(()=>true, [], 'true');
const falsy = accessor(()=>false, [], 'false');
function log$1(method, level, input) {
    const args = [
        level
    ].concat([].slice.call(input));
    console[method].apply(console, args); // eslint-disable-line no-console
}
const None = 0;
const Error$1 = 1;
const Warn = 2;
const Info = 3;
const Debug = 4;
function logger(_, method) {
    let handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : log$1;
    let level = _ || None;
    return {
        level (_) {
            if (arguments.length) {
                level = +_;
                return this;
            } else return level;
        },
        error () {
            if (level >= Error$1) handler(method || 'error', 'ERROR', arguments);
            return this;
        },
        warn () {
            if (level >= Warn) handler(method || 'warn', 'WARN', arguments);
            return this;
        },
        info () {
            if (level >= Info) handler(method || 'log', 'INFO', arguments);
            return this;
        },
        debug () {
            if (level >= Debug) handler(method || 'log', 'DEBUG', arguments);
            return this;
        }
    };
}
var isArray = Array.isArray;
function isObject(_) {
    return _ === Object(_);
}
const isLegalKey = (key)=>key !== '__proto__';
function mergeConfig() {
    for(var _len = arguments.length, configs = new Array(_len), _key = 0; _key < _len; _key++)configs[_key] = arguments[_key];
    return configs.reduce((out, source)=>{
        for(const key in source)if (key === 'signals') // for signals, we merge the signals arrays
        // source signals take precedence over
        // existing signals with the same name
        out.signals = mergeNamed(out.signals, source.signals);
        else {
            // otherwise, merge objects subject to recursion constraints
            // for legend block, recurse for the layout entry only
            // for style block, recurse for all properties
            // otherwise, no recursion: objects overwrite, no merging
            const r = key === 'legend' ? {
                layout: 1
            } : key === 'style' ? true : null;
            writeConfig(out, key, source[key], r);
        }
        return out;
    }, {});
}
function writeConfig(output, key, value, recurse) {
    if (!isLegalKey(key)) return;
    let k, o;
    if (isObject(value) && !isArray(value)) {
        o = isObject(output[key]) ? output[key] : output[key] = {};
        for(k in value){
            if (recurse && (recurse === true || recurse[k])) writeConfig(o, k, value[k]);
            else if (isLegalKey(k)) o[k] = value[k];
        }
    } else output[key] = value;
}
function mergeNamed(a, b) {
    if (a == null) return b;
    const map = {}, out = [];
    function add(_) {
        if (!map[_.name]) {
            map[_.name] = 1;
            out.push(_);
        }
    }
    b.forEach(add);
    a.forEach(add);
    return out;
}
function peek(array) {
    return array[array.length - 1];
}
function toNumber(_) {
    return _ == null || _ === '' ? null : +_;
}
const exp = (sign)=>(x)=>sign * Math.exp(x);
const log = (sign)=>(x)=>Math.log(sign * x);
const symlog = (c)=>(x)=>Math.sign(x) * Math.log1p(Math.abs(x / c));
const symexp = (c)=>(x)=>Math.sign(x) * Math.expm1(Math.abs(x)) * c;
const pow = (exponent)=>(x)=>x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
function pan(domain, delta, lift, ground) {
    const d0 = lift(domain[0]), d1 = lift(peek(domain)), dd = (d1 - d0) * delta;
    return [
        ground(d0 - dd),
        ground(d1 - dd)
    ];
}
function panLinear(domain, delta) {
    return pan(domain, delta, toNumber, identity);
}
function panLog(domain, delta) {
    var sign = Math.sign(domain[0]);
    return pan(domain, delta, log(sign), exp(sign));
}
function panPow(domain, delta, exponent) {
    return pan(domain, delta, pow(exponent), pow(1 / exponent));
}
function panSymlog(domain, delta, constant) {
    return pan(domain, delta, symlog(constant), symexp(constant));
}
function zoom(domain, anchor, scale, lift, ground) {
    const d0 = lift(domain[0]), d1 = lift(peek(domain)), da = anchor != null ? lift(anchor) : (d0 + d1) / 2;
    return [
        ground(da + (d0 - da) * scale),
        ground(da + (d1 - da) * scale)
    ];
}
function zoomLinear(domain, anchor, scale) {
    return zoom(domain, anchor, scale, toNumber, identity);
}
function zoomLog(domain, anchor, scale) {
    const sign = Math.sign(domain[0]);
    return zoom(domain, anchor, scale, log(sign), exp(sign));
}
function zoomPow(domain, anchor, scale, exponent) {
    return zoom(domain, anchor, scale, pow(exponent), pow(1 / exponent));
}
function zoomSymlog(domain, anchor, scale, constant) {
    return zoom(domain, anchor, scale, symlog(constant), symexp(constant));
}
function quarter(date) {
    return 1 + ~~(new Date(date).getMonth() / 3);
}
function utcquarter(date) {
    return 1 + ~~(new Date(date).getUTCMonth() / 3);
}
function array(_) {
    return _ != null ? isArray(_) ? _ : [
        _
    ] : [];
}
/**
 * Span-preserving range clamp. If the span of the input range is less
 * than (max - min) and an endpoint exceeds either the min or max value,
 * the range is translated such that the span is preserved and one
 * endpoint touches the boundary of the min/max range.
 * If the span exceeds (max - min), the range [min, max] is returned.
 */ function clampRange(range, min, max) {
    let lo = range[0], hi = range[1], span;
    if (hi < lo) {
        span = hi;
        hi = lo;
        lo = span;
    }
    span = hi - lo;
    return span >= max - min ? [
        min,
        max
    ] : [
        lo = Math.min(Math.max(lo, min), max - span),
        lo + span
    ];
}
function isFunction(_) {
    return typeof _ === 'function';
}
const DESCENDING = 'descending';
function compare(fields, orders, opt) {
    opt = opt || {};
    orders = array(orders) || [];
    const ord = [], get = [], fmap = {}, gen = opt.comparator || comparator;
    array(fields).forEach((f, i)=>{
        if (f == null) return;
        ord.push(orders[i] === DESCENDING ? -1 : 1);
        get.push(f = isFunction(f) ? f : field(f, null, opt));
        (accessorFields(f) || []).forEach((_)=>fmap[_] = 1);
    });
    return get.length === 0 ? null : accessor(gen(get, ord), Object.keys(fmap));
}
const ascending = (u, v)=>(u < v || u == null) && v != null ? -1 : (u > v || v == null) && u != null ? 1 : (v = v instanceof Date ? +v : v, u = u instanceof Date ? +u : u) !== u && v === v ? -1 : v !== v && u === u ? 1 : 0;
const comparator = (fields, orders)=>fields.length === 1 ? compare1(fields[0], orders[0]) : compareN(fields, orders, fields.length);
const compare1 = (field, order)=>function(a, b) {
        return ascending(field(a), field(b)) * order;
    };
const compareN = (fields, orders, n)=>{
    orders.push(0); // pad zero for convenient lookup
    return function(a, b) {
        let f, c = 0, i = -1;
        while(c === 0 && ++i < n){
            f = fields[i];
            c = ascending(f(a), f(b));
        }
        return c * orders[i];
    };
};
function constant(_) {
    return isFunction(_) ? _ : ()=>_;
}
function debounce(delay, handler) {
    let tid;
    return (e)=>{
        if (tid) clearTimeout(tid);
        tid = setTimeout(()=>(handler(e), tid = null), delay);
    };
}
function extend(_) {
    for(let x, k, i = 1, len = arguments.length; i < len; ++i){
        x = arguments[i];
        for(k in x)_[k] = x[k];
    }
    return _;
}
/**
 * Return an array with minimum and maximum values, in the
 * form [min, max]. Ignores null, undefined, and NaN values.
 */ function extent(array, f) {
    let i = 0, n, v, min, max;
    if (array && (n = array.length)) {
        if (f == null) {
            // find first valid value
            for(v = array[i]; i < n && (v == null || v !== v); v = array[++i]);
            min = max = v;
            // visit all other values
            for(; i < n; ++i){
                v = array[i];
                // skip null/undefined; NaN will fail all comparisons
                if (v != null) {
                    if (v < min) min = v;
                    if (v > max) max = v;
                }
            }
        } else {
            // find first valid value
            for(v = f(array[i]); i < n && (v == null || v !== v); v = f(array[++i]));
            min = max = v;
            // visit all other values
            for(; i < n; ++i){
                v = f(array[i]);
                // skip null/undefined; NaN will fail all comparisons
                if (v != null) {
                    if (v < min) min = v;
                    if (v > max) max = v;
                }
            }
        }
    }
    return [
        min,
        max
    ];
}
function extentIndex(array, f) {
    const n = array.length;
    let i = -1, a, b, c, u, v;
    if (f == null) {
        while(++i < n){
            b = array[i];
            if (b != null && b >= b) {
                a = c = b;
                break;
            }
        }
        if (i === n) return [
            -1,
            -1
        ];
        u = v = i;
        while(++i < n){
            b = array[i];
            if (b != null) {
                if (a > b) {
                    a = b;
                    u = i;
                }
                if (c < b) {
                    c = b;
                    v = i;
                }
            }
        }
    } else {
        while(++i < n){
            b = f(array[i], i, array);
            if (b != null && b >= b) {
                a = c = b;
                break;
            }
        }
        if (i === n) return [
            -1,
            -1
        ];
        u = v = i;
        while(++i < n){
            b = f(array[i], i, array);
            if (b != null) {
                if (a > b) {
                    a = b;
                    u = i;
                }
                if (c < b) {
                    c = b;
                    v = i;
                }
            }
        }
    }
    return [
        u,
        v
    ];
}
function has(object, property) {
    return Object.hasOwn(object, property);
}
const NULL = {};
function fastmap(input) {
    let obj = {}, test;
    function has$1(key) {
        return has(obj, key) && obj[key] !== NULL;
    }
    const map = {
        size: 0,
        empty: 0,
        object: obj,
        has: has$1,
        get (key) {
            return has$1(key) ? obj[key] : undefined;
        },
        set (key, value) {
            if (!has$1(key)) {
                ++map.size;
                if (obj[key] === NULL) --map.empty;
            }
            obj[key] = value;
            return this;
        },
        delete (key) {
            if (has$1(key)) {
                --map.size;
                ++map.empty;
                obj[key] = NULL;
            }
            return this;
        },
        clear () {
            map.size = map.empty = 0;
            map.object = obj = {};
        },
        test (_) {
            if (arguments.length) {
                test = _;
                return map;
            } else return test;
        },
        clean () {
            const next = {};
            let size = 0;
            for(const key in obj){
                const value = obj[key];
                if (value !== NULL && (!test || !test(value))) {
                    next[key] = value;
                    ++size;
                }
            }
            map.size = size;
            map.empty = 0;
            map.object = obj = next;
        }
    };
    if (input) Object.keys(input).forEach((key)=>{
        map.set(key, input[key]);
    });
    return map;
}
function flush(range, value, threshold, left, right, center) {
    if (!threshold && threshold !== 0) return center;
    const t = +threshold;
    let a = range[0], b = peek(range), l;
    // swap endpoints if range is reversed
    if (b < a) {
        l = a;
        a = b;
        b = l;
    }
    // compare value to endpoints
    l = Math.abs(value - a);
    const r = Math.abs(b - value);
    // adjust if value is within threshold distance of endpoint
    return l < r && l <= t ? left : r <= t ? right : center;
}
function inherits(child, parent, members) {
    const proto = child.prototype = Object.create(parent.prototype);
    Object.defineProperty(proto, 'constructor', {
        value: child,
        writable: true,
        enumerable: true,
        configurable: true
    });
    return extend(proto, members);
}
/**
 * Predicate that returns true if the value lies within the span
 * of the given range. The left and right flags control the use
 * of inclusive (true) or exclusive (false) comparisons.
 */ function inrange(value, range, left, right) {
    let r0 = range[0], r1 = range[range.length - 1], t;
    if (r0 > r1) {
        t = r0;
        r0 = r1;
        r1 = t;
    }
    left = left === undefined || left;
    right = right === undefined || right;
    return (left ? r0 <= value : r0 < value) && (right ? value <= r1 : value < r1);
}
function isBoolean(_) {
    return typeof _ === 'boolean';
}
function isDate(_) {
    return Object.prototype.toString.call(_) === '[object Date]';
}
function isIterable(_) {
    return _ && isFunction(_[Symbol.iterator]);
}
function isNumber(_) {
    return typeof _ === 'number';
}
function isRegExp(_) {
    return Object.prototype.toString.call(_) === '[object RegExp]';
}
function isString(_) {
    return typeof _ === 'string';
}
function key(fields, flat, opt) {
    if (fields) fields = flat ? array(fields).map((f)=>f.replace(/\\(.)/g, '$1')) : array(fields);
    const len = fields && fields.length, gen = opt && opt.get || getter, map = (f)=>gen(flat ? [
            f
        ] : splitAccessPath(f));
    let fn;
    if (!len) fn = function() {
        return '';
    };
    else if (len === 1) {
        const get = map(fields[0]);
        fn = function(_) {
            return '' + get(_);
        };
    } else {
        const get = fields.map(map);
        fn = function(_) {
            let s = '' + get[0](_), i = 0;
            while(++i < len)s += '|' + get[i](_);
            return s;
        };
    }
    return accessor(fn, fields, 'key');
}
function lerp(array, frac) {
    const lo = array[0], hi = peek(array), f = +frac;
    return !f ? lo : f === 1 ? hi : lo + f * (hi - lo);
}
const DEFAULT_MAX_SIZE = 10000;
// adapted from https://github.com/dominictarr/hashlru/ (MIT License)
function lruCache(maxsize) {
    maxsize = +maxsize || DEFAULT_MAX_SIZE;
    let curr, prev, size;
    const clear = ()=>{
        curr = {};
        prev = {};
        size = 0;
    };
    const update = (key, value)=>{
        if (++size > maxsize) {
            prev = curr;
            curr = {};
            size = 1;
        }
        return curr[key] = value;
    };
    clear();
    return {
        clear,
        has: (key)=>has(curr, key) || has(prev, key),
        get: (key)=>has(curr, key) ? curr[key] : has(prev, key) ? update(key, prev[key]) : undefined,
        set: (key, value)=>has(curr, key) ? curr[key] = value : update(key, value)
    };
}
function merge(compare, array0, array1, output) {
    const n0 = array0.length, n1 = array1.length;
    if (!n1) return array0;
    if (!n0) return array1;
    const merged = output || new array0.constructor(n0 + n1);
    let i0 = 0, i1 = 0, i = 0;
    for(; i0 < n0 && i1 < n1; ++i)merged[i] = compare(array0[i0], array1[i1]) > 0 ? array1[i1++] : array0[i0++];
    for(; i0 < n0; ++i0, ++i)merged[i] = array0[i0];
    for(; i1 < n1; ++i1, ++i)merged[i] = array1[i1];
    return merged;
}
function repeat(str, reps) {
    let s = '';
    while(--reps >= 0)s += str;
    return s;
}
function pad(str, length, padchar, align) {
    const c = padchar || ' ', s = str + '', n = length - s.length;
    return n <= 0 ? s : align === 'left' ? repeat(c, n) + s : align === 'center' ? repeat(c, ~~(n / 2)) + s + repeat(c, Math.ceil(n / 2)) : s + repeat(c, n);
}
/**
 * Return the numerical span of an array: the difference between
 * the last and first values.
 */ function span(array) {
    return array && peek(array) - array[0] || 0;
}
function $(x) {
    return isArray(x) ? '[' + x.map($) + ']' : isObject(x) || isString(x) ? // Output valid JSON and JS source strings.
    // See http://timelessrepo.com/json-isnt-a-javascript-subset
    JSON.stringify(x).replace('\u2028', '\\u2028').replace('\u2029', '\\u2029') : x;
}
function toBoolean(_) {
    return _ == null || _ === '' ? null : !_ || _ === 'false' || _ === '0' ? false : !!_;
}
const defaultParser = (_)=>isNumber(_) ? _ : isDate(_) ? _ : Date.parse(_);
function toDate(_, parser) {
    parser = parser || defaultParser;
    return _ == null || _ === '' ? null : parser(_);
}
function toString(_) {
    return _ == null || _ === '' ? null : _ + '';
}
function toSet(_) {
    const s = {}, n = _.length;
    for(let i = 0; i < n; ++i)s[_[i]] = true;
    return s;
}
function truncate(str, length, align, ellipsis) {
    const e = ellipsis != null ? ellipsis : '\u2026', s = str + '', n = s.length, l = Math.max(0, length - e.length);
    return n <= length ? s : align === 'left' ? e + s.slice(n - l) : align === 'center' ? s.slice(0, Math.ceil(l / 2)) + e + s.slice(n - ~~(l / 2)) : s.slice(0, l) + e;
}
function visitArray(array, filter, visitor) {
    if (array) {
        if (filter) {
            const n = array.length;
            for(let i = 0; i < n; ++i){
                const t = filter(array[i]);
                if (t) visitor(t, i, array);
            }
        } else array.forEach(visitor);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4An7U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dataflow", ()=>Dataflow);
parcelHelpers.export(exports, "EventStream", ()=>EventStream);
parcelHelpers.export(exports, "MultiPulse", ()=>MultiPulse);
parcelHelpers.export(exports, "Operator", ()=>Operator);
parcelHelpers.export(exports, "Parameters", ()=>Parameters);
parcelHelpers.export(exports, "Pulse", ()=>Pulse);
parcelHelpers.export(exports, "Transform", ()=>Transform);
parcelHelpers.export(exports, "UniqueList", ()=>UniqueList);
parcelHelpers.export(exports, "asyncCallback", ()=>asyncCallback);
parcelHelpers.export(exports, "changeset", ()=>changeset);
parcelHelpers.export(exports, "definition", ()=>definition);
parcelHelpers.export(exports, "derive", ()=>derive);
parcelHelpers.export(exports, "ingest", ()=>ingest$1);
parcelHelpers.export(exports, "isChangeSet", ()=>isChangeSet);
parcelHelpers.export(exports, "isTuple", ()=>isTuple);
parcelHelpers.export(exports, "rederive", ()=>rederive);
parcelHelpers.export(exports, "replace", ()=>replace);
parcelHelpers.export(exports, "stableCompare", ()=>stableCompare);
parcelHelpers.export(exports, "transform", ()=>transform);
parcelHelpers.export(exports, "transforms", ()=>transforms);
parcelHelpers.export(exports, "tupleid", ()=>tupleid);
var _vegaUtil = require("vega-util");
var _vegaLoader = require("vega-loader");
var _vegaFormat = require("vega-format");
function UniqueList(idFunc) {
    const $ = idFunc || (0, _vegaUtil.identity), list = [], ids = {};
    list.add = (_)=>{
        const id = $(_);
        if (!ids[id]) {
            ids[id] = 1;
            list.push(_);
        }
        return list;
    };
    list.remove = (_)=>{
        const id = $(_);
        if (ids[id]) {
            ids[id] = 0;
            const idx = list.indexOf(_);
            if (idx >= 0) list.splice(idx, 1);
        }
        return list;
    };
    return list;
}
/**
 * Invoke and await a potentially async callback function. If
 * an error occurs, trap it and route to Dataflow.error.
 * @param {Dataflow} df - The dataflow instance
 * @param {function} callback - A callback function to invoke
 *   and then await. The dataflow will be passed as the single
 *   argument to the function.
 */ async function asyncCallback(df, callback) {
    try {
        await callback(df);
    } catch (err) {
        df.error(err);
    }
}
const TUPLE_ID_KEY = Symbol('vega_id');
let TUPLE_ID = 1;
/**
 * Checks if an input value is a registered tuple.
 * @param {*} t - The value to check.
 * @return {boolean} True if the input is a tuple, false otherwise.
 */ function isTuple(t) {
    return !!(t && tupleid(t));
}
/**
 * Returns the id of a tuple.
 * @param {object} t - The input tuple.
 * @return {*} the tuple id.
 */ function tupleid(t) {
    return t[TUPLE_ID_KEY];
}
/**
 * Sets the id of a tuple.
 * @param {object} t - The input tuple.
 * @param {*} id - The id value to set.
 * @return {object} the input tuple.
 */ function setid(t, id) {
    t[TUPLE_ID_KEY] = id;
    return t;
}
/**
 * Ingest an object or value as a data tuple.
 * If the input value is an object, an id field will be added to it. For
 * efficiency, the input object is modified directly. A copy is not made.
 * If the input value is a literal, it will be wrapped in a new object
 * instance, with the value accessible as the 'data' property.
 * @param datum - The value to ingest.
 * @return {object} The ingested data tuple.
 */ function ingest$1(datum) {
    const t = datum === Object(datum) ? datum : {
        data: datum
    };
    return tupleid(t) ? t : setid(t, TUPLE_ID++);
}
/**
 * Given a source tuple, return a derived copy.
 * @param {object} t - The source tuple.
 * @return {object} The derived tuple.
 */ function derive(t) {
    return rederive(t, ingest$1({}));
}
/**
 * Rederive a derived tuple by copying values from the source tuple.
 * @param {object} t - The source tuple.
 * @param {object} d - The derived tuple.
 * @return {object} The derived tuple.
 */ function rederive(t, d) {
    for(const k in t)d[k] = t[k];
    return d;
}
/**
 * Replace an existing tuple with a new tuple.
 * @param {object} t - The existing data tuple.
 * @param {object} d - The new tuple that replaces the old.
 * @return {object} The new tuple.
 */ function replace(t, d) {
    return setid(d, tupleid(t));
}
/**
 * Generate an augmented comparator function that provides stable
 * sorting by tuple id when the given comparator produces ties.
 * @param {function} cmp - The comparator to augment.
 * @param {function} [f] - Optional tuple accessor function.
 * @return {function} An augmented comparator function.
 */ function stableCompare(cmp, f) {
    return !cmp ? null : f ? (a, b)=>cmp(a, b) || tupleid(f(a)) - tupleid(f(b)) : (a, b)=>cmp(a, b) || tupleid(a) - tupleid(b);
}
function isChangeSet(v) {
    return v && v.constructor === changeset;
}
function changeset() {
    const add = [], // insert tuples
    rem = [], // remove tuples
    mod = [], // modify tuples
    remp = [], // remove by predicate
    modp = []; // modify by predicate
    let clean = null, reflow = false;
    return {
        constructor: changeset,
        insert (t) {
            const d = (0, _vegaUtil.array)(t), n = d.length;
            for(let i = 0; i < n; ++i)add.push(d[i]);
            return this;
        },
        remove (t) {
            const a = (0, _vegaUtil.isFunction)(t) ? remp : rem, d = (0, _vegaUtil.array)(t), n = d.length;
            for(let i = 0; i < n; ++i)a.push(d[i]);
            return this;
        },
        modify (t, field, value) {
            const m = {
                field: field,
                value: (0, _vegaUtil.constant)(value)
            };
            if ((0, _vegaUtil.isFunction)(t)) {
                m.filter = t;
                modp.push(m);
            } else {
                m.tuple = t;
                mod.push(m);
            }
            return this;
        },
        encode (t, set) {
            if ((0, _vegaUtil.isFunction)(t)) modp.push({
                filter: t,
                field: set
            });
            else mod.push({
                tuple: t,
                field: set
            });
            return this;
        },
        clean (value) {
            clean = value;
            return this;
        },
        reflow () {
            reflow = true;
            return this;
        },
        pulse (pulse, tuples) {
            const cur = {}, out = {};
            let i, n, m, f, t, id;
            // build lookup table of current tuples
            for(i = 0, n = tuples.length; i < n; ++i)cur[tupleid(tuples[i])] = 1;
            // process individual tuples to remove
            for(i = 0, n = rem.length; i < n; ++i){
                t = rem[i];
                cur[tupleid(t)] = -1;
            }
            // process predicate-based removals
            for(i = 0, n = remp.length; i < n; ++i){
                f = remp[i];
                tuples.forEach((t)=>{
                    if (f(t)) cur[tupleid(t)] = -1;
                });
            }
            // process all add tuples
            for(i = 0, n = add.length; i < n; ++i){
                t = add[i];
                id = tupleid(t);
                if (cur[id]) // tuple already resides in dataset
                // if flagged for both add and remove, cancel
                cur[id] = 1;
                else // tuple does not reside in dataset, add
                pulse.add.push(ingest$1(add[i]));
            }
            // populate pulse rem list
            for(i = 0, n = tuples.length; i < n; ++i){
                t = tuples[i];
                if (cur[tupleid(t)] < 0) pulse.rem.push(t);
            }
            // modify helper method
            function modify(t, f, v) {
                if (v) t[f] = v(t);
                else pulse.encode = f;
                if (!reflow) out[tupleid(t)] = t;
            }
            // process individual tuples to modify
            for(i = 0, n = mod.length; i < n; ++i){
                m = mod[i];
                t = m.tuple;
                f = m.field;
                id = cur[tupleid(t)];
                if (id > 0) {
                    modify(t, f, m.value);
                    pulse.modifies(f);
                }
            }
            // process predicate-based modifications
            for(i = 0, n = modp.length; i < n; ++i){
                m = modp[i];
                f = m.filter;
                tuples.forEach((t)=>{
                    if (f(t) && cur[tupleid(t)] > 0) modify(t, m.field, m.value);
                });
                pulse.modifies(m.field);
            }
            // upon reflow request, populate mod with all non-removed tuples
            // otherwise, populate mod with modified tuples only
            if (reflow) pulse.mod = rem.length || remp.length ? tuples.filter((t)=>cur[tupleid(t)] > 0) : tuples.slice();
            else for(id in out)pulse.mod.push(out[id]);
            // set pulse garbage collection request
            if (clean || clean == null && (rem.length || remp.length)) pulse.clean(true);
            return pulse;
        }
    };
}
const CACHE = '_:mod:_';
/**
 * Hash that tracks modifications to assigned values.
 * Callers *must* use the set method to update values.
 */ function Parameters() {
    Object.defineProperty(this, CACHE, {
        writable: true,
        value: {}
    });
}
Parameters.prototype = {
    /**
   * Set a parameter value. If the parameter value changes, the parameter
   * will be recorded as modified.
   * @param {string} name - The parameter name.
   * @param {number} index - The index into an array-value parameter. Ignored if
   *   the argument is undefined, null or less than zero.
   * @param {*} value - The parameter value to set.
   * @param {boolean} [force=false] - If true, records the parameter as modified
   *   even if the value is unchanged.
   * @return {Parameters} - This parameter object.
   */ set (name, index, value, force) {
        const o = this, v = o[name], mod = o[CACHE];
        if (index != null && index >= 0) {
            if (v[index] !== value || force) {
                v[index] = value;
                mod[index + ':' + name] = -1;
                mod[name] = -1;
            }
        } else if (v !== value || force) {
            o[name] = value;
            mod[name] = (0, _vegaUtil.isArray)(value) ? 1 + value.length : -1;
        }
        return o;
    },
    /**
   * Tests if one or more parameters has been modified. If invoked with no
   * arguments, returns true if any parameter value has changed. If the first
   * argument is array, returns trues if any parameter name in the array has
   * changed. Otherwise, tests if the given name and optional array index has
   * changed.
   * @param {string} name - The parameter name to test.
   * @param {number} [index=undefined] - The parameter array index to test.
   * @return {boolean} - Returns true if a queried parameter was modified.
   */ modified (name, index) {
        const mod = this[CACHE];
        if (!arguments.length) {
            for(const k in mod){
                if (mod[k]) return true;
            }
            return false;
        } else if ((0, _vegaUtil.isArray)(name)) {
            for(let k = 0; k < name.length; ++k){
                if (mod[name[k]]) return true;
            }
            return false;
        }
        return index != null && index >= 0 ? index + 1 < mod[name] || !!mod[index + ':' + name] : !!mod[name];
    },
    /**
   * Clears the modification records. After calling this method,
   * all parameters are considered unmodified.
   */ clear () {
        this[CACHE] = {};
        return this;
    }
};
let OP_ID = 0;
const PULSE = 'pulse', NO_PARAMS = new Parameters();
// Boolean Flags
const SKIP$1 = 1, MODIFIED = 2;
/**
 * An Operator is a processing node in a dataflow graph.
 * Each operator stores a value and an optional value update function.
 * Operators can accept a hash of named parameters. Parameter values can
 * either be direct (JavaScript literals, arrays, objects) or indirect
 * (other operators whose values will be pulled dynamically). Operators
 * included as parameters will have this operator added as a dependency.
 * @constructor
 * @param {*} [init] - The initial value for this operator.
 * @param {function(object, Pulse)} [update] - An update function. Upon
 *   evaluation of this operator, the update function will be invoked and the
 *   return value will be used as the new value of this operator.
 * @param {object} [params] - The parameters for this operator.
 * @param {boolean} [react=true] - Flag indicating if this operator should
 *   listen for changes to upstream operators included as parameters.
 * @see parameters
 */ function Operator(init, update, params, react) {
    this.id = ++OP_ID;
    this.value = init;
    this.stamp = -1;
    this.rank = -1;
    this.qrank = -1;
    this.flags = 0;
    if (update) this._update = update;
    if (params) this.parameters(params, react);
}
function flag(bit) {
    return function(state) {
        const f = this.flags;
        if (arguments.length === 0) return !!(f & bit);
        this.flags = state ? f | bit : f & ~bit;
        return this;
    };
}
Operator.prototype = {
    /**
   * Returns a list of target operators dependent on this operator.
   * If this list does not exist, it is created and then returned.
   * @return {UniqueList}
   */ targets () {
        return this._targets || (this._targets = UniqueList((0, _vegaUtil.id)));
    },
    /**
   * Sets the value of this operator.
   * @param {*} value - the value to set.
   * @return {Number} Returns 1 if the operator value has changed
   *   according to strict equality, returns 0 otherwise.
   */ set (value) {
        if (this.value !== value) {
            this.value = value;
            return 1;
        } else return 0;
    },
    /**
   * Indicates that operator evaluation should be skipped on the next pulse.
   * This operator will still propagate incoming pulses, but its update function
   * will not be invoked. The skip flag is reset after every pulse, so calling
   * this method will affect processing of the next pulse only.
   */ skip: flag(SKIP$1),
    /**
   * Indicates that this operator's value has been modified on its most recent
   * pulse. Normally modification is checked via strict equality; however, in
   * some cases it is more efficient to update the internal state of an object.
   * In those cases, the modified flag can be used to trigger propagation. Once
   * set, the modification flag persists across pulses until unset. The flag can
   * be used with the last timestamp to test if a modification is recent.
   */ modified: flag(MODIFIED),
    /**
   * Sets the parameters for this operator. The parameter values are analyzed for
   * operator instances. If found, this operator will be added as a dependency
   * of the parameterizing operator. Operator values are dynamically marshalled
   * from each operator parameter prior to evaluation. If a parameter value is
   * an array, the array will also be searched for Operator instances. However,
   * the search does not recurse into sub-arrays or object properties.
   * @param {object} params - A hash of operator parameters.
   * @param {boolean} [react=true] - A flag indicating if this operator should
   *   automatically update (react) when parameter values change. In other words,
   *   this flag determines if the operator registers itself as a listener on
   *   any upstream operators included in the parameters.
   * @param {boolean} [initonly=false] - A flag indicating if this operator
   *   should calculate an update only upon its initial evaluation, then
   *   deregister dependencies and suppress all future update invocations.
   * @return {Operator[]} - An array of upstream dependencies.
   */ parameters (params, react, initonly) {
        react = react !== false;
        const argval = this._argval = this._argval || new Parameters(), argops = this._argops = this._argops || [], deps = [];
        let name, value, n, i;
        const add = (name, index, value)=>{
            if (value instanceof Operator) {
                if (value !== this) {
                    if (react) value.targets().add(this);
                    deps.push(value);
                }
                argops.push({
                    op: value,
                    name: name,
                    index: index
                });
            } else argval.set(name, index, value);
        };
        for(name in params){
            value = params[name];
            if (name === PULSE) {
                (0, _vegaUtil.array)(value).forEach((op)=>{
                    if (!(op instanceof Operator)) (0, _vegaUtil.error)('Pulse parameters must be operator instances.');
                    else if (op !== this) {
                        op.targets().add(this);
                        deps.push(op);
                    }
                });
                this.source = value;
            } else if ((0, _vegaUtil.isArray)(value)) {
                argval.set(name, -1, Array(n = value.length));
                for(i = 0; i < n; ++i)add(name, i, value[i]);
            } else add(name, -1, value);
        }
        this.marshall().clear(); // initialize values
        if (initonly) argops.initonly = true;
        return deps;
    },
    /**
   * Internal method for marshalling parameter values.
   * Visits each operator dependency to pull the latest value.
   * @return {Parameters} A Parameters object to pass to the update function.
   */ marshall (stamp) {
        const argval = this._argval || NO_PARAMS, argops = this._argops;
        let item, i, op, mod;
        if (argops) {
            const n = argops.length;
            for(i = 0; i < n; ++i){
                item = argops[i];
                op = item.op;
                mod = op.modified() && op.stamp === stamp;
                argval.set(item.name, item.index, op.value, mod);
            }
            if (argops.initonly) {
                for(i = 0; i < n; ++i){
                    item = argops[i];
                    item.op.targets().remove(this);
                }
                this._argops = null;
                this._update = null;
            }
        }
        return argval;
    },
    /**
   * Detach this operator from the dataflow.
   * Unregisters listeners on upstream dependencies.
   */ detach () {
        const argops = this._argops;
        let i, n, item, op;
        if (argops) for(i = 0, n = argops.length; i < n; ++i){
            item = argops[i];
            op = item.op;
            if (op._targets) op._targets.remove(this);
        }
        // remove references to the source and pulse object,
        // if present, to prevent memory leaks of old data.
        this.pulse = null;
        this.source = null;
    },
    /**
   * Delegate method to perform operator processing.
   * Subclasses can override this method to perform custom processing.
   * By default, it marshalls parameters and calls the update function
   * if that function is defined. If the update function does not
   * change the operator value then StopPropagation is returned.
   * If no update function is defined, this method does nothing.
   * @param {Pulse} pulse - the current dataflow pulse.
   * @return The output pulse or StopPropagation. A falsy return value
   *   (including undefined) will let the input pulse pass through.
   */ evaluate (pulse) {
        const update = this._update;
        if (update) {
            const params = this.marshall(pulse.stamp), v = update.call(this, params, pulse);
            params.clear();
            if (v !== this.value) this.value = v;
            else if (!this.modified()) return pulse.StopPropagation;
        }
    },
    /**
   * Run this operator for the current pulse. If this operator has already
   * been run at (or after) the pulse timestamp, returns StopPropagation.
   * Internally, this method calls {@link evaluate} to perform processing.
   * If {@link evaluate} returns a falsy value, the input pulse is returned.
   * This method should NOT be overridden, instead overrride {@link evaluate}.
   * @param {Pulse} pulse - the current dataflow pulse.
   * @return the output pulse for this operator (or StopPropagation)
   */ run (pulse) {
        if (pulse.stamp < this.stamp) return pulse.StopPropagation;
        let rv;
        if (this.skip()) {
            this.skip(false);
            rv = 0;
        } else rv = this.evaluate(pulse);
        return this.pulse = rv || pulse;
    }
};
/**
 * Add an operator to the dataflow graph. This function accepts a
 * variety of input argument types. The basic signature supports an
 * initial value, update function and parameters. If the first parameter
 * is an Operator instance, it will be added directly. If it is a
 * constructor for an Operator subclass, a new instance will be instantiated.
 * Otherwise, if the first parameter is a function instance, it will be used
 * as the update function and a null initial value is assumed.
 * @param {*} init - One of: the operator to add, the initial value of
 *   the operator, an operator class to instantiate, or an update function.
 * @param {function} [update] - The operator update function.
 * @param {object} [params] - The operator parameters.
 * @param {boolean} [react=true] - Flag indicating if this operator should
 *   listen for changes to upstream operators included as parameters.
 * @return {Operator} - The added operator.
 */ function add(init, update, params, react) {
    let shift = 1, op;
    if (init instanceof Operator) op = init;
    else if (init && init.prototype instanceof Operator) op = new init();
    else if ((0, _vegaUtil.isFunction)(init)) op = new Operator(null, init);
    else {
        shift = 0;
        op = new Operator(init, update);
    }
    this.rank(op);
    if (shift) {
        react = params;
        params = update;
    }
    if (params) this.connect(op, op.parameters(params, react));
    this.touch(op);
    return op;
}
/**
 * Connect a target operator as a dependent of source operators.
 * If necessary, this method will rerank the target operator and its
 * dependents to ensure propagation proceeds in a topologically sorted order.
 * @param {Operator} target - The target operator.
 * @param {Array<Operator>} - The source operators that should propagate
 *   to the target operator.
 */ function connect(target, sources) {
    const targetRank = target.rank, n = sources.length;
    for(let i = 0; i < n; ++i)if (targetRank < sources[i].rank) {
        this.rerank(target);
        return;
    }
}
let STREAM_ID = 0;
/**
 * Models an event stream.
 * @constructor
 * @param {function(Object, number): boolean} [filter] - Filter predicate.
 *   Events pass through when truthy, events are suppressed when falsy.
 * @param {function(Object): *} [apply] - Applied to input events to produce
 *   new event values.
 * @param {function(Object)} [receive] - Event callback function to invoke
 *   upon receipt of a new event. Use to override standard event processing.
 */ function EventStream(filter, apply, receive) {
    this.id = ++STREAM_ID;
    this.value = null;
    if (receive) this.receive = receive;
    if (filter) this._filter = filter;
    if (apply) this._apply = apply;
}
/**
 * Creates a new event stream instance with the provided
 * (optional) filter, apply and receive functions.
 * @param {function(Object, number): boolean} [filter] - Filter predicate.
 *   Events pass through when truthy, events are suppressed when falsy.
 * @param {function(Object): *} [apply] - Applied to input events to produce
 *   new event values.
 * @see EventStream
 */ function stream(filter, apply, receive) {
    return new EventStream(filter, apply, receive);
}
EventStream.prototype = {
    _filter: (0, _vegaUtil.truthy),
    _apply: (0, _vegaUtil.identity),
    targets () {
        return this._targets || (this._targets = UniqueList((0, _vegaUtil.id)));
    },
    consume (_) {
        if (!arguments.length) return !!this._consume;
        this._consume = !!_;
        return this;
    },
    receive (evt) {
        if (this._filter(evt)) {
            const val = this.value = this._apply(evt), trg = this._targets, n = trg ? trg.length : 0;
            for(let i = 0; i < n; ++i)trg[i].receive(val);
            if (this._consume) {
                evt.preventDefault();
                evt.stopPropagation();
            }
        }
    },
    filter (filter) {
        const s = stream(filter);
        this.targets().add(s);
        return s;
    },
    apply (apply) {
        const s = stream(null, apply);
        this.targets().add(s);
        return s;
    },
    merge () {
        const s = stream();
        this.targets().add(s);
        for(let i = 0, n = arguments.length; i < n; ++i)arguments[i].targets().add(s);
        return s;
    },
    throttle (pause) {
        let t = -1;
        return this.filter(()=>{
            const now = Date.now();
            if (now - t > pause) {
                t = now;
                return 1;
            } else return 0;
        });
    },
    debounce (delay) {
        const s = stream();
        this.targets().add(stream(null, null, (0, _vegaUtil.debounce)(delay, (e)=>{
            const df = e.dataflow;
            s.receive(e);
            if (df && df.run) df.run();
        })));
        return s;
    },
    between (a, b) {
        let active = false;
        a.targets().add(stream(null, null, ()=>active = true));
        b.targets().add(stream(null, null, ()=>active = false));
        return this.filter(()=>active);
    },
    detach () {
        // ensures compatibility with operators (#2753)
        // remove references to other streams and filter functions that may
        // be bound to subcontexts that need to be garbage collected.
        this._filter = (0, _vegaUtil.truthy);
        this._targets = null;
    }
};
/**
 * Create a new event stream from an event source.
 * @param {object} source - The event source to monitor. The input must
 *  support the addEventListener method.
 * @param {string} type - The event type.
 * @param {function(object): boolean} [filter] - Event filter function.
 * @param {function(object): *} [apply] - Event application function.
 *   If provided, this function will be invoked and the result will be
 *   used as the downstream event value.
 * @return {EventStream}
 */ function events(source, type, filter, apply) {
    const df = this, s = stream(filter, apply), send = function(e) {
        e.dataflow = df;
        try {
            s.receive(e);
        } catch (error) {
            df.error(error);
        } finally{
            df.run();
        }
    };
    let sources;
    if (typeof source === 'string' && typeof document !== 'undefined') sources = document.querySelectorAll(source);
    else sources = (0, _vegaUtil.array)(source);
    const n = sources.length;
    for(let i = 0; i < n; ++i)sources[i].addEventListener(type, send);
    return s;
}
function parse(data, format) {
    const locale = this.locale();
    return (0, _vegaLoader.read)(data, format, locale.timeParse, locale.utcParse);
}
/**
 * Ingests new data into the dataflow. First parses the data using the
 * vega-loader read method, then pulses a changeset to the target operator.
 * @param {Operator} target - The Operator to target with ingested data,
 *   typically a Collect transform instance.
 * @param {*} data - The input data, prior to parsing. For JSON this may
 *   be a string or an object. For CSV, TSV, etc should be a string.
 * @param {object} format - The data format description for parsing
 *   loaded data. This object is passed to the vega-loader read method.
 * @returns {Dataflow}
 */ function ingest(target, data, format) {
    data = this.parse(data, format);
    return this.pulse(target, this.changeset().insert(data));
}
/**
 * Request data from an external source, parse it, and return a Promise.
 * @param {string} url - The URL from which to load the data. This string
 *   is passed to the vega-loader load method.
 * @param {object} [format] - The data format description for parsing
 *   loaded data. This object is passed to the vega-loader read method.
 * @return {Promise} A Promise that resolves upon completion of the request.
 *   The resolved object contains the following properties:
 *   - data: an array of parsed data (or null upon error)
 *   - status: a code for success (0), load fail (-1), or parse fail (-2)
 */ async function request(url, format) {
    const df = this;
    let status = 0, data;
    try {
        data = await df.loader().load(url, {
            context: 'dataflow',
            response: (0, _vegaLoader.responseType)(format && format.type)
        });
        try {
            data = df.parse(data, format);
        } catch (err) {
            status = -2;
            df.warn('Data ingestion failed', url, err);
        }
    } catch (err) {
        status = -1;
        df.warn('Loading failed', url, err);
    }
    return {
        data,
        status
    };
}
async function preload(target, url, format) {
    const df = this, pending = df._pending || loadPending(df);
    pending.requests += 1;
    const res = await df.request(url, format);
    df.pulse(target, df.changeset().remove((0, _vegaUtil.truthy)).insert(res.data || []));
    pending.done();
    return res;
}
function loadPending(df) {
    let accept;
    const pending = new Promise((a)=>accept = a);
    pending.requests = 0;
    pending.done = ()=>{
        if (--pending.requests === 0) {
            df._pending = null;
            accept(df);
        }
    };
    return df._pending = pending;
}
const SKIP = {
    skip: true
};
/**
 * Perform operator updates in response to events. Applies an
 * update function to compute a new operator value. If the update function
 * returns a {@link ChangeSet}, the operator will be pulsed with those tuple
 * changes. Otherwise, the operator value will be updated to the return value.
 * @param {EventStream|Operator} source - The event source to react to.
 *   This argument can be either an EventStream or an Operator.
 * @param {Operator|function(object):Operator} target - The operator to update.
 *   This argument can either be an Operator instance or (if the source
 *   argument is an EventStream), a function that accepts an event object as
 *   input and returns an Operator to target.
 * @param {function(Parameters,Event): *} [update] - Optional update function
 *   to compute the new operator value, or a literal value to set. Update
 *   functions expect to receive a parameter object and event as arguments.
 *   This function can either return a new operator value or (if the source
 *   argument is an EventStream) a {@link ChangeSet} instance to pulse
 *   the target operator with tuple changes.
 * @param {object} [params] - The update function parameters.
 * @param {object} [options] - Additional options hash. If not overridden,
 *   updated operators will be skipped by default.
 * @param {boolean} [options.skip] - If true, the operator will
 *  be skipped: it will not be evaluated, but its dependents will be.
 * @param {boolean} [options.force] - If true, the operator will
 *   be re-evaluated even if its value has not changed.
 * @return {Dataflow}
 */ function on(source, target, update, params, options) {
    const fn = source instanceof Operator ? onOperator : onStream;
    fn(this, source, target, update, params, options);
    return this;
}
function onStream(df, stream, target, update, params, options) {
    const opt = (0, _vegaUtil.extend)({}, options, SKIP);
    let func, op;
    if (!(0, _vegaUtil.isFunction)(target)) target = (0, _vegaUtil.constant)(target);
    if (update === undefined) func = (e)=>df.touch(target(e));
    else if ((0, _vegaUtil.isFunction)(update)) {
        op = new Operator(null, update, params, false);
        func = (e)=>{
            op.evaluate(e);
            const t = target(e), v = op.value;
            isChangeSet(v) ? df.pulse(t, v, options) : df.update(t, v, opt);
        };
    } else func = (e)=>df.update(target(e), update, opt);
    stream.apply(func);
}
function onOperator(df, source, target, update, params, options) {
    if (update === undefined) source.targets().add(target);
    else {
        const opt = options || {}, op = new Operator(null, updater(target, update), params, false);
        op.modified(opt.force);
        op.rank = source.rank; // immediately follow source
        source.targets().add(op); // add dependency
        if (target) {
            op.skip(true); // skip first invocation
            op.value = target.value; // initialize value
            op.targets().add(target); // chain dependencies
            df.connect(target, [
                op
            ]); // rerank as needed, #1672
        }
    }
}
function updater(target, update) {
    update = (0, _vegaUtil.isFunction)(update) ? update : (0, _vegaUtil.constant)(update);
    return target ? function(_, pulse) {
        const value = update(_, pulse);
        if (!target.skip()) target.skip(value !== this.value).value = value;
        return value;
    } : update;
}
/**
 * Assigns a rank to an operator. Ranks are assigned in increasing order
 * by incrementing an internal rank counter.
 * @param {Operator} op - The operator to assign a rank.
 */ function rank(op) {
    op.rank = ++this._rank;
}
/**
 * Re-ranks an operator and all downstream target dependencies. This
 * is necessary when upstream dependencies of higher rank are added to
 * a target operator.
 * @param {Operator} op - The operator to re-rank.
 */ function rerank(op) {
    const queue = [
        op
    ];
    let cur, list, i;
    while(queue.length){
        this.rank(cur = queue.pop());
        if (list = cur._targets) for(i = list.length; --i >= 0;){
            queue.push(cur = list[i]);
            if (cur === op) (0, _vegaUtil.error)('Cycle detected in dataflow graph.');
        }
    }
}
/**
 * Sentinel value indicating pulse propagation should stop.
 */ const StopPropagation = {};
// Pulse visit type flags
const ADD = 1, REM = 2, MOD = 4, ADD_REM = ADD | REM, ADD_MOD = ADD | MOD, ALL = ADD | REM | MOD, REFLOW = 8, SOURCE = 16, NO_SOURCE = 32, NO_FIELDS = 64;
/**
 * A Pulse enables inter-operator communication during a run of the
 * dataflow graph. In addition to the current timestamp, a pulse may also
 * contain a change-set of added, removed or modified data tuples, as well as
 * a pointer to a full backing data source. Tuple change sets may not
 * be fully materialized; for example, to prevent needless array creation
 * a change set may include larger arrays and corresponding filter functions.
 * The pulse provides a {@link visit} method to enable proper and efficient
 * iteration over requested data tuples.
 *
 * In addition, each pulse can track modification flags for data tuple fields.
 * Responsible transform operators should call the {@link modifies} method to
 * indicate changes to data fields. The {@link modified} method enables
 * querying of this modification state.
 *
 * @constructor
 * @param {Dataflow} dataflow - The backing dataflow instance.
 * @param {number} stamp - The current propagation timestamp.
 * @param {string} [encode] - An optional encoding set name, which is then
 *   accessible as Pulse.encode. Operators can respond to (or ignore) this
 *   setting as appropriate. This parameter can be used in conjunction with
 *   the Encode transform in the vega-encode module.
 */ function Pulse(dataflow, stamp, encode) {
    this.dataflow = dataflow;
    this.stamp = stamp == null ? -1 : stamp;
    this.add = [];
    this.rem = [];
    this.mod = [];
    this.fields = null;
    this.encode = encode || null;
}
function materialize(data, filter) {
    const out = [];
    (0, _vegaUtil.visitArray)(data, filter, (_)=>out.push(_));
    return out;
}
function filter(pulse, flags) {
    const map = {};
    pulse.visit(flags, (t)=>{
        map[tupleid(t)] = 1;
    });
    return (t)=>map[tupleid(t)] ? null : t;
}
function addFilter(a, b) {
    return a ? (t, i)=>a(t, i) && b(t, i) : b;
}
Pulse.prototype = {
    /**
   * Sentinel value indicating pulse propagation should stop.
   */ StopPropagation,
    /**
   * Boolean flag indicating ADD (added) tuples.
   */ ADD,
    /**
   * Boolean flag indicating REM (removed) tuples.
   */ REM,
    /**
   * Boolean flag indicating MOD (modified) tuples.
   */ MOD,
    /**
   * Boolean flag indicating ADD (added) and REM (removed) tuples.
   */ ADD_REM,
    /**
   * Boolean flag indicating ADD (added) and MOD (modified) tuples.
   */ ADD_MOD,
    /**
   * Boolean flag indicating ADD, REM and MOD tuples.
   */ ALL,
    /**
   * Boolean flag indicating all tuples in a data source
   * except for the ADD, REM and MOD tuples.
   */ REFLOW,
    /**
   * Boolean flag indicating a 'pass-through' to a
   * backing data source, ignoring ADD, REM and MOD tuples.
   */ SOURCE,
    /**
   * Boolean flag indicating that source data should be
   * suppressed when creating a forked pulse.
   */ NO_SOURCE,
    /**
   * Boolean flag indicating that field modifications should be
   * suppressed when creating a forked pulse.
   */ NO_FIELDS,
    /**
   * Creates a new pulse based on the values of this pulse.
   * The dataflow, time stamp and field modification values are copied over.
   * By default, new empty ADD, REM and MOD arrays are created.
   * @param {number} flags - Integer of boolean flags indicating which (if any)
   *   tuple arrays should be copied to the new pulse. The supported flag values
   *   are ADD, REM and MOD. Array references are copied directly: new array
   *   instances are not created.
   * @return {Pulse} - The forked pulse instance.
   * @see init
   */ fork (flags) {
        return new Pulse(this.dataflow).init(this, flags);
    },
    /**
   * Creates a copy of this pulse with new materialized array
   * instances for the ADD, REM, MOD, and SOURCE arrays.
   * The dataflow, time stamp and field modification values are copied over.
   * @return {Pulse} - The cloned pulse instance.
   * @see init
   */ clone () {
        const p = this.fork(ALL);
        p.add = p.add.slice();
        p.rem = p.rem.slice();
        p.mod = p.mod.slice();
        if (p.source) p.source = p.source.slice();
        return p.materialize(ALL | SOURCE);
    },
    /**
   * Returns a pulse that adds all tuples from a backing source. This is
   * useful for cases where operators are added to a dataflow after an
   * upstream data pipeline has already been processed, ensuring that
   * new operators can observe all tuples within a stream.
   * @return {Pulse} - A pulse instance with all source tuples included
   *   in the add array. If the current pulse already has all source
   *   tuples in its add array, it is returned directly. If the current
   *   pulse does not have a backing source, it is returned directly.
   */ addAll () {
        let p = this;
        const reuse = !p.source || p.add === p.rem // special case for indexed set (e.g., crossfilter)
         || !p.rem.length && p.source.length === p.add.length;
        if (reuse) return p;
        else {
            p = new Pulse(this.dataflow).init(this);
            p.add = p.source;
            p.rem = []; // new operators can ignore rem #2769
            return p;
        }
    },
    /**
   * Initialize this pulse based on the values of another pulse. This method
   * is used internally by {@link fork} to initialize a new forked tuple.
   * The dataflow, time stamp and field modification values are copied over.
   * By default, new empty ADD, REM and MOD arrays are created.
   * @param {Pulse} src - The source pulse to copy from.
   * @param {number} flags - Integer of boolean flags indicating which (if any)
   *   tuple arrays should be copied to the new pulse. The supported flag values
   *   are ADD, REM and MOD. Array references are copied directly: new array
   *   instances are not created. By default, source data arrays are copied
   *   to the new pulse. Use the NO_SOURCE flag to enforce a null source.
   * @return {Pulse} - Returns this Pulse instance.
   */ init (src, flags) {
        const p = this;
        p.stamp = src.stamp;
        p.encode = src.encode;
        if (src.fields && !(flags & NO_FIELDS)) p.fields = src.fields;
        if (flags & ADD) {
            p.addF = src.addF;
            p.add = src.add;
        } else {
            p.addF = null;
            p.add = [];
        }
        if (flags & REM) {
            p.remF = src.remF;
            p.rem = src.rem;
        } else {
            p.remF = null;
            p.rem = [];
        }
        if (flags & MOD) {
            p.modF = src.modF;
            p.mod = src.mod;
        } else {
            p.modF = null;
            p.mod = [];
        }
        if (flags & NO_SOURCE) {
            p.srcF = null;
            p.source = null;
        } else {
            p.srcF = src.srcF;
            p.source = src.source;
            if (src.cleans) p.cleans = src.cleans;
        }
        return p;
    },
    /**
   * Schedules a function to run after pulse propagation completes.
   * @param {function} func - The function to run.
   */ runAfter (func) {
        this.dataflow.runAfter(func);
    },
    /**
   * Indicates if tuples have been added, removed or modified.
   * @param {number} [flags] - The tuple types (ADD, REM or MOD) to query.
   *   Defaults to ALL, returning true if any tuple type has changed.
   * @return {boolean} - Returns true if one or more queried tuple types have
   *   changed, false otherwise.
   */ changed (flags) {
        const f = flags || ALL;
        return f & ADD && this.add.length || f & REM && this.rem.length || f & MOD && this.mod.length;
    },
    /**
   * Forces a "reflow" of tuple values, such that all tuples in the backing
   * source are added to the MOD set, unless already present in the ADD set.
   * @param {boolean} [fork=false] - If true, returns a forked copy of this
   *   pulse, and invokes reflow on that derived pulse.
   * @return {Pulse} - The reflowed pulse instance.
   */ reflow (fork) {
        if (fork) return this.fork(ALL).reflow();
        const len = this.add.length, src = this.source && this.source.length;
        if (src && src !== len) {
            this.mod = this.source;
            if (len) this.filter(MOD, filter(this, ADD));
        }
        return this;
    },
    /**
   * Get/set metadata to pulse requesting garbage collection
   * to reclaim currently unused resources.
   */ clean (value) {
        if (arguments.length) {
            this.cleans = !!value;
            return this;
        } else return this.cleans;
    },
    /**
   * Marks one or more data field names as modified to assist dependency
   * tracking and incremental processing by transform operators.
   * @param {string|Array<string>} _ - The field(s) to mark as modified.
   * @return {Pulse} - This pulse instance.
   */ modifies (_) {
        const hash = this.fields || (this.fields = {});
        if ((0, _vegaUtil.isArray)(_)) _.forEach((f)=>hash[f] = true);
        else hash[_] = true;
        return this;
    },
    /**
   * Checks if one or more data fields have been modified during this pulse
   * propagation timestamp.
   * @param {string|Array<string>} _ - The field(s) to check for modified.
   * @param {boolean} nomod - If true, will check the modified flag even if
   *   no mod tuples exist. If false (default), mod tuples must be present.
   * @return {boolean} - Returns true if any of the provided fields has been
   *   marked as modified, false otherwise.
   */ modified (_, nomod) {
        const fields = this.fields;
        return !((nomod || this.mod.length) && fields) ? false : !arguments.length ? !!fields : (0, _vegaUtil.isArray)(_) ? _.some((f)=>fields[f]) : fields[_];
    },
    /**
   * Adds a filter function to one more tuple sets. Filters are applied to
   * backing tuple arrays, to determine the actual set of tuples considered
   * added, removed or modified. They can be used to delay materialization of
   * a tuple set in order to avoid expensive array copies. In addition, the
   * filter functions can serve as value transformers: unlike standard predicate
   * function (which return boolean values), Pulse filters should return the
   * actual tuple value to process. If a tuple set is already filtered, the
   * new filter function will be appended into a conjuntive ('and') query.
   * @param {number} flags - Flags indicating the tuple set(s) to filter.
   * @param {function(*):object} filter - Filter function that will be applied
   *   to the tuple set array, and should return a data tuple if the value
   *   should be included in the tuple set, and falsy (or null) otherwise.
   * @return {Pulse} - Returns this pulse instance.
   */ filter (flags, filter) {
        const p = this;
        if (flags & ADD) p.addF = addFilter(p.addF, filter);
        if (flags & REM) p.remF = addFilter(p.remF, filter);
        if (flags & MOD) p.modF = addFilter(p.modF, filter);
        if (flags & SOURCE) p.srcF = addFilter(p.srcF, filter);
        return p;
    },
    /**
   * Materialize one or more tuple sets in this pulse. If the tuple set(s) have
   * a registered filter function, it will be applied and the tuple set(s) will
   * be replaced with materialized tuple arrays.
   * @param {number} flags - Flags indicating the tuple set(s) to materialize.
   * @return {Pulse} - Returns this pulse instance.
   */ materialize (flags) {
        flags = flags || ALL;
        const p = this;
        if (flags & ADD && p.addF) {
            p.add = materialize(p.add, p.addF);
            p.addF = null;
        }
        if (flags & REM && p.remF) {
            p.rem = materialize(p.rem, p.remF);
            p.remF = null;
        }
        if (flags & MOD && p.modF) {
            p.mod = materialize(p.mod, p.modF);
            p.modF = null;
        }
        if (flags & SOURCE && p.srcF) {
            p.source = p.source.filter(p.srcF);
            p.srcF = null;
        }
        return p;
    },
    /**
   * Visit one or more tuple sets in this pulse.
   * @param {number} flags - Flags indicating the tuple set(s) to visit.
   *   Legal values are ADD, REM, MOD and SOURCE (if a backing data source
   *   has been set).
   * @param {function(object):*} - Visitor function invoked per-tuple.
   * @return {Pulse} - Returns this pulse instance.
   */ visit (flags, visitor) {
        const p = this, v = visitor;
        if (flags & SOURCE) {
            (0, _vegaUtil.visitArray)(p.source, p.srcF, v);
            return p;
        }
        if (flags & ADD) (0, _vegaUtil.visitArray)(p.add, p.addF, v);
        if (flags & REM) (0, _vegaUtil.visitArray)(p.rem, p.remF, v);
        if (flags & MOD) (0, _vegaUtil.visitArray)(p.mod, p.modF, v);
        const src = p.source;
        if (flags & REFLOW && src) {
            const sum = p.add.length + p.mod.length;
            if (sum === src.length) ;
            else if (sum) (0, _vegaUtil.visitArray)(src, filter(p, ADD_MOD), v);
            else // if no add/rem/mod tuples, visit source
            (0, _vegaUtil.visitArray)(src, p.srcF, v);
        }
        return p;
    }
};
/**
 * Represents a set of multiple pulses. Used as input for operators
 * that accept multiple pulses at a time. Contained pulses are
 * accessible via the public "pulses" array property. This pulse doe
 * not carry added, removed or modified tuples directly. However,
 * the visit method can be used to traverse all such tuples contained
 * in sub-pulses with a timestamp matching this parent multi-pulse.
 * @constructor
 * @param {Dataflow} dataflow - The backing dataflow instance.
 * @param {number} stamp - The timestamp.
 * @param {Array<Pulse>} pulses - The sub-pulses for this multi-pulse.
 */ function MultiPulse(dataflow, stamp, pulses, encode) {
    const p = this;
    let c = 0;
    this.dataflow = dataflow;
    this.stamp = stamp;
    this.fields = null;
    this.encode = encode || null;
    this.pulses = pulses;
    for (const pulse of pulses){
        if (pulse.stamp !== stamp) continue;
        if (pulse.fields) {
            const hash = p.fields || (p.fields = {});
            for(const f in pulse.fields)hash[f] = 1;
        }
        if (pulse.changed(p.ADD)) c |= p.ADD;
        if (pulse.changed(p.REM)) c |= p.REM;
        if (pulse.changed(p.MOD)) c |= p.MOD;
    }
    this.changes = c;
}
(0, _vegaUtil.inherits)(MultiPulse, Pulse, {
    /**
   * Creates a new pulse based on the values of this pulse.
   * The dataflow, time stamp and field modification values are copied over.
   * @return {Pulse}
   */ fork (flags) {
        const p = new Pulse(this.dataflow).init(this, flags & this.NO_FIELDS);
        if (flags !== undefined) {
            if (flags & p.ADD) this.visit(p.ADD, (t)=>p.add.push(t));
            if (flags & p.REM) this.visit(p.REM, (t)=>p.rem.push(t));
            if (flags & p.MOD) this.visit(p.MOD, (t)=>p.mod.push(t));
        }
        return p;
    },
    changed (flags) {
        return this.changes & flags;
    },
    modified (_) {
        const p = this, fields = p.fields;
        return !(fields && p.changes & p.MOD) ? 0 : (0, _vegaUtil.isArray)(_) ? _.some((f)=>fields[f]) : fields[_];
    },
    filter () {
        (0, _vegaUtil.error)('MultiPulse does not support filtering.');
    },
    materialize () {
        (0, _vegaUtil.error)('MultiPulse does not support materialization.');
    },
    visit (flags, visitor) {
        const p = this, pulses = p.pulses, n = pulses.length;
        let i = 0;
        if (flags & p.SOURCE) for(; i < n; ++i)pulses[i].visit(flags, visitor);
        else {
            for(; i < n; ++i)if (pulses[i].stamp === p.stamp) pulses[i].visit(flags, visitor);
        }
        return p;
    }
});
/* eslint-disable require-atomic-updates */ /**
 * Evaluates the dataflow and returns a Promise that resolves when pulse
 * propagation completes. This method will increment the current timestamp
 * and process all updated, pulsed and touched operators. When invoked for
 * the first time, all registered operators will be processed. This method
 * should not be invoked by third-party clients, use {@link runAsync} or
 * {@link run} instead.
 * @param {string} [encode] - The name of an encoding set to invoke during
 *   propagation. This value is added to generated Pulse instances;
 *   operators can then respond to (or ignore) this setting as appropriate.
 *   This parameter can be used in conjunction with the Encode transform in
 *   the vega-encode package.
 * @param {function} [prerun] - An optional callback function to invoke
 *   immediately before dataflow evaluation commences.
 * @param {function} [postrun] - An optional callback function to invoke
 *   after dataflow evaluation completes. The callback will be invoked
 *   after those registered via {@link runAfter}.
 * @return {Promise} - A promise that resolves to this dataflow after
 *   evaluation completes.
 */ async function evaluate(encode, prerun, postrun) {
    const df = this, async = [];
    // if the pulse value is set, this is a re-entrant call
    if (df._pulse) return reentrant(df);
    // wait for pending datasets to load
    if (df._pending) await df._pending;
    // invoke prerun function, if provided
    if (prerun) await asyncCallback(df, prerun);
    // exit early if there are no updates
    if (!df._touched.length) {
        df.debug('Dataflow invoked, but nothing to do.');
        return df;
    }
    // increment timestamp clock
    const stamp = ++df._clock;
    // set the current pulse
    df._pulse = new Pulse(df, stamp, encode);
    // initialize priority queue, reset touched operators
    df._touched.forEach((op)=>df._enqueue(op, true));
    df._touched = UniqueList((0, _vegaUtil.id));
    let count = 0, op, next, error;
    try {
        while(df._heap.size() > 0){
            // dequeue operator with highest priority
            op = df._heap.pop();
            // re-queue if rank changed
            if (op.rank !== op.qrank) {
                df._enqueue(op, true);
                continue;
            }
            // otherwise, evaluate the operator
            next = op.run(df._getPulse(op, encode));
            if (next.then) // await if operator returns a promise directly
            next = await next;
            else if (next.async) {
                // queue parallel asynchronous execution
                async.push(next.async);
                next = StopPropagation;
            }
            // propagate evaluation, enqueue dependent operators
            if (next !== StopPropagation) {
                if (op._targets) op._targets.forEach((op)=>df._enqueue(op));
            }
            // increment visit counter
            ++count;
        }
    } catch (err) {
        df._heap.clear();
        error = err;
    }
    // reset pulse map
    df._input = {};
    df._pulse = null;
    df.debug(`Pulse ${stamp}: ${count} operators`);
    if (error) {
        df._postrun = [];
        df.error(error);
    }
    // invoke callbacks queued via runAfter
    if (df._postrun.length) {
        const pr = df._postrun.sort((a, b)=>b.priority - a.priority);
        df._postrun = [];
        for(let i = 0; i < pr.length; ++i)await asyncCallback(df, pr[i].callback);
    }
    // invoke postrun function, if provided
    if (postrun) await asyncCallback(df, postrun);
    // handle non-blocking asynchronous callbacks
    if (async.length) Promise.all(async).then((cb)=>df.runAsync(null, ()=>{
            cb.forEach((f)=>{
                try {
                    f(df);
                } catch (err) {
                    df.error(err);
                }
            });
        }));
    return df;
}
/**
 * Queues dataflow evaluation to run once any other queued evaluations have
 * completed and returns a Promise that resolves when the queued pulse
 * propagation completes. If provided, a callback function will be invoked
 * immediately before evaluation commences. This method will ensure a
 * separate evaluation is invoked for each time it is called.
 * @param {string} [encode] - The name of an encoding set to invoke during
 *   propagation. This value is added to generated Pulse instances;
 *   operators can then respond to (or ignore) this setting as appropriate.
 *   This parameter can be used in conjunction with the Encode transform in
 *   the vega-encode package.
 * @param {function} [prerun] - An optional callback function to invoke
 *   immediately before dataflow evaluation commences.
 * @param {function} [postrun] - An optional callback function to invoke
 *   after dataflow evaluation completes. The callback will be invoked
 *   after those registered via {@link runAfter}.
 * @return {Promise} - A promise that resolves to this dataflow after
 *   evaluation completes.
 */ async function runAsync(encode, prerun, postrun) {
    // await previously queued functions
    while(this._running)await this._running;
    // run dataflow, manage running promise
    const clear = ()=>this._running = null;
    (this._running = this.evaluate(encode, prerun, postrun)).then(clear, clear);
    return this._running;
}
/**
 * Requests dataflow evaluation and the immediately returns this dataflow
 * instance. If there are pending data loading or other asynchronous
 * operations, the dataflow will evaluate asynchronously after this method
 * has been invoked. To track when dataflow evaluation completes, use the
 * {@link runAsync} method instead. This method will raise an error if
 * invoked while the dataflow is already in the midst of evaluation.
 * @param {string} [encode] - The name of an encoding set to invoke during
 *   propagation. This value is added to generated Pulse instances;
 *   operators can then respond to (or ignore) this setting as appropriate.
 *   This parameter can be used in conjunction with the Encode transform in
 *   the vega-encode module.
 * @param {function} [prerun] - An optional callback function to invoke
 *   immediately before dataflow evaluation commences.
 * @param {function} [postrun] - An optional callback function to invoke
 *   after dataflow evaluation completes. The callback will be invoked
 *   after those registered via {@link runAfter}.
 * @return {Dataflow} - This dataflow instance.
 */ function run(encode, prerun, postrun) {
    return this._pulse ? reentrant(this) : (this.evaluate(encode, prerun, postrun), this);
}
/**
 * Schedules a callback function to be invoked after the current pulse
 * propagation completes. If no propagation is currently occurring,
 * the function is invoked immediately. Callbacks scheduled via runAfter
 * are invoked immediately upon completion of the current cycle, before
 * any request queued via runAsync. This method is primarily intended for
 * internal use. Third-party callers using runAfter to schedule a callback
 * that invokes {@link run} or {@link runAsync} should not use this method,
 * but instead use {@link runAsync} with prerun or postrun arguments.
 * @param {function(Dataflow)} callback - The callback function to run.
 *   The callback will be invoked with this Dataflow instance as its
 *   sole argument.
 * @param {boolean} enqueue - A boolean flag indicating that the
 *   callback should be queued up to run after the next propagation
 *   cycle, suppressing immediate invocation when propagation is not
 *   currently occurring.
 * @param {number} [priority] - A priority value used to sort registered
 *   callbacks to determine execution order. This argument is intended
 *   for internal Vega use only.
 */ function runAfter(callback, enqueue, priority) {
    if (this._pulse || enqueue) // pulse propagation is currently running, queue to run after
    this._postrun.push({
        priority: priority || 0,
        callback: callback
    });
    else // pulse propagation already complete, invoke immediately
    try {
        callback(this);
    } catch (err) {
        this.error(err);
    }
}
/**
 * Raise an error for re-entrant dataflow evaluation.
 */ function reentrant(df) {
    df.error('Dataflow already running. Use runAsync() to chain invocations.');
    return df;
}
/**
 * Enqueue an operator into the priority queue for evaluation. The operator
 * will be enqueued if it has no registered pulse for the current cycle, or if
 * the force argument is true. Upon enqueue, this method also sets the
 * operator's qrank to the current rank value.
 * @param {Operator} op - The operator to enqueue.
 * @param {boolean} [force] - A flag indicating if the operator should be
 *   forceably added to the queue, even if it has already been previously
 *   enqueued during the current pulse propagation. This is useful when the
 *   dataflow graph is dynamically modified and the operator rank changes.
 */ function enqueue(op, force) {
    const q = op.stamp < this._clock;
    if (q) op.stamp = this._clock;
    if (q || force) {
        op.qrank = op.rank;
        this._heap.push(op);
    }
}
/**
 * Provide a correct pulse for evaluating an operator. If the operator has an
 * explicit source operator, we will try to pull the pulse(s) from it.
 * If there is an array of source operators, we build a multi-pulse.
 * Otherwise, we return a current pulse with correct source data.
 * If the pulse is the pulse map has an explicit target set, we use that.
 * Else if the pulse on the upstream source operator is current, we use that.
 * Else we use the pulse from the pulse map, but copy the source tuple array.
 * @param {Operator} op - The operator for which to get an input pulse.
 * @param {string} [encode] - An (optional) encoding set name with which to
 *   annotate the returned pulse. See {@link run} for more information.
 */ function getPulse(op, encode) {
    const s = op.source, stamp = this._clock;
    return s && (0, _vegaUtil.isArray)(s) ? new MultiPulse(this, stamp, s.map((_)=>_.pulse), encode) : this._input[op.id] || singlePulse(this._pulse, s && s.pulse);
}
function singlePulse(p, s) {
    if (s && s.stamp === p.stamp) return s;
    p = p.fork();
    if (s && s !== StopPropagation) p.source = s.source;
    return p;
}
const NO_OPT = {
    skip: false,
    force: false
};
/**
 * Touches an operator, scheduling it to be evaluated. If invoked outside of
 * a pulse propagation, the operator will be evaluated the next time this
 * dataflow is run. If invoked in the midst of pulse propagation, the operator
 * will be queued for evaluation if and only if the operator has not yet been
 * evaluated on the current propagation timestamp.
 * @param {Operator} op - The operator to touch.
 * @param {object} [options] - Additional options hash.
 * @param {boolean} [options.skip] - If true, the operator will
 *   be skipped: it will not be evaluated, but its dependents will be.
 * @return {Dataflow}
 */ function touch(op, options) {
    const opt = options || NO_OPT;
    if (this._pulse) // if in midst of propagation, add to priority queue
    this._enqueue(op);
    else // otherwise, queue for next propagation
    this._touched.add(op);
    if (opt.skip) op.skip(true);
    return this;
}
/**
 * Updates the value of the given operator.
 * @param {Operator} op - The operator to update.
 * @param {*} value - The value to set.
 * @param {object} [options] - Additional options hash.
 * @param {boolean} [options.force] - If true, the operator will
 *   be re-evaluated even if its value has not changed.
 * @param {boolean} [options.skip] - If true, the operator will
 *   be skipped: it will not be evaluated, but its dependents will be.
 * @return {Dataflow}
 */ function update(op, value, options) {
    const opt = options || NO_OPT;
    if (op.set(value) || opt.force) this.touch(op, opt);
    return this;
}
/**
 * Pulses an operator with a changeset of tuples. If invoked outside of
 * a pulse propagation, the pulse will be applied the next time this
 * dataflow is run. If invoked in the midst of pulse propagation, the pulse
 * will be added to the set of active pulses and will be applied if and
 * only if the target operator has not yet been evaluated on the current
 * propagation timestamp.
 * @param {Operator} op - The operator to pulse.
 * @param {ChangeSet} value - The tuple changeset to apply.
 * @param {object} [options] - Additional options hash.
 * @param {boolean} [options.skip] - If true, the operator will
 *   be skipped: it will not be evaluated, but its dependents will be.
 * @return {Dataflow}
 */ function pulse(op, changeset, options) {
    this.touch(op, options || NO_OPT);
    const p = new Pulse(this, this._clock + (this._pulse ? 0 : 1)), t = op.pulse && op.pulse.source || [];
    p.target = op;
    this._input[op.id] = changeset.pulse(p, t);
    return this;
}
function Heap(cmp) {
    let nodes = [];
    return {
        clear: ()=>nodes = [],
        size: ()=>nodes.length,
        peek: ()=>nodes[0],
        push: (x)=>{
            nodes.push(x);
            return siftdown(nodes, 0, nodes.length - 1, cmp);
        },
        pop: ()=>{
            const last = nodes.pop();
            let item;
            if (nodes.length) {
                item = nodes[0];
                nodes[0] = last;
                siftup(nodes, 0, cmp);
            } else item = last;
            return item;
        }
    };
}
function siftdown(array, start, idx, cmp) {
    let parent, pidx;
    const item = array[idx];
    while(idx > start){
        pidx = idx - 1 >> 1;
        parent = array[pidx];
        if (cmp(item, parent) < 0) {
            array[idx] = parent;
            idx = pidx;
            continue;
        }
        break;
    }
    return array[idx] = item;
}
function siftup(array, idx, cmp) {
    const start = idx, end = array.length, item = array[idx];
    let cidx = (idx << 1) + 1, ridx;
    while(cidx < end){
        ridx = cidx + 1;
        if (ridx < end && cmp(array[cidx], array[ridx]) >= 0) cidx = ridx;
        array[idx] = array[cidx];
        idx = cidx;
        cidx = (idx << 1) + 1;
    }
    array[idx] = item;
    return siftdown(array, start, idx, cmp);
}
/**
 * A dataflow graph for reactive processing of data streams.
 * @constructor
 */ function Dataflow() {
    this.logger((0, _vegaUtil.logger)());
    this.logLevel((0, _vegaUtil.Error));
    this._clock = 0;
    this._rank = 0;
    this._locale = (0, _vegaFormat.defaultLocale)();
    try {
        this._loader = (0, _vegaLoader.loader)();
    } catch (e) {
    // do nothing if loader module is unavailable
    }
    this._touched = UniqueList((0, _vegaUtil.id));
    this._input = {};
    this._pulse = null;
    this._heap = Heap((a, b)=>a.qrank - b.qrank);
    this._postrun = [];
}
function logMethod(method) {
    return function() {
        return this._log[method].apply(this, arguments);
    };
}
Dataflow.prototype = {
    /**
   * The current timestamp of this dataflow. This value reflects the
   * timestamp of the previous dataflow run. The dataflow is initialized
   * with a stamp value of 0. The initial run of the dataflow will have
   * a timestap of 1, and so on. This value will match the
   * {@link Pulse.stamp} property.
   * @return {number} - The current timestamp value.
   */ stamp () {
        return this._clock;
    },
    /**
   * Gets or sets the loader instance to use for data file loading. A
   * loader object must provide a "load" method for loading files and a
   * "sanitize" method for checking URL/filename validity. Both methods
   * should accept a URI and options hash as arguments, and return a Promise
   * that resolves to the loaded file contents (load) or a hash containing
   * sanitized URI data with the sanitized url assigned to the "href" property
   * (sanitize).
   * @param {object} _ - The loader instance to use.
   * @return {object|Dataflow} - If no arguments are provided, returns
   *   the current loader instance. Otherwise returns this Dataflow instance.
   */ loader (_) {
        if (arguments.length) {
            this._loader = _;
            return this;
        } else return this._loader;
    },
    /**
   * Gets or sets the locale instance to use for formatting and parsing
   * string values. The locale object should be provided by the
   * vega-format library, and include methods such as format, timeFormat,
   * utcFormat, timeParse, and utcParse.
   * @param {object} _ - The locale instance to use.
   * @return {object|Dataflow} - If no arguments are provided, returns
   *   the current locale instance. Otherwise returns this Dataflow instance.
   */ locale (_) {
        if (arguments.length) {
            this._locale = _;
            return this;
        } else return this._locale;
    },
    /**
   * Get or set the logger instance used to log messages. If no arguments are
   * provided, returns the current logger instance. Otherwise, sets the logger
   * and return this Dataflow instance. Provided loggers must support the full
   * API of logger objects generated by the vega-util logger method. Note that
   * by default the log level of the new logger will be used; use the logLevel
   * method to adjust the log level as needed.
   */ logger (logger) {
        if (arguments.length) {
            this._log = logger;
            return this;
        } else return this._log;
    },
    /**
   * Logs an error message. By default, logged messages are written to console
   * output. The message will only be logged if the current log level is high
   * enough to permit error messages.
   */ error: logMethod('error'),
    /**
   * Logs a warning message. By default, logged messages are written to console
   * output. The message will only be logged if the current log level is high
   * enough to permit warning messages.
   */ warn: logMethod('warn'),
    /**
   * Logs a information message. By default, logged messages are written to
   * console output. The message will only be logged if the current log level is
   * high enough to permit information messages.
   */ info: logMethod('info'),
    /**
   * Logs a debug message. By default, logged messages are written to console
   * output. The message will only be logged if the current log level is high
   * enough to permit debug messages.
   */ debug: logMethod('debug'),
    /**
   * Get or set the current log level. If an argument is provided, it
   * will be used as the new log level.
   * @param {number} [level] - Should be one of None, Warn, Info
   * @return {number} - The current log level.
   */ logLevel: logMethod('level'),
    /**
   * Empty entry threshold for garbage cleaning. Map data structures will
   * perform cleaning once the number of empty entries exceeds this value.
   */ cleanThreshold: 1e4,
    // OPERATOR REGISTRATION
    add,
    connect,
    rank,
    rerank,
    // OPERATOR UPDATES
    pulse,
    touch,
    update,
    changeset,
    // DATA LOADING
    ingest,
    parse,
    preload,
    request,
    // EVENT HANDLING
    events,
    on,
    // PULSE PROPAGATION
    evaluate,
    run,
    runAsync,
    runAfter,
    _enqueue: enqueue,
    _getPulse: getPulse
};
/**
 * Abstract class for operators that process data tuples.
 * Subclasses must provide a {@link transform} method for operator processing.
 * @constructor
 * @param {*} [init] - The initial value for this operator.
 * @param {object} [params] - The parameters for this operator.
 * @param {Operator} [source] - The operator from which to receive pulses.
 */ function Transform(init, params) {
    Operator.call(this, init, null, params);
}
(0, _vegaUtil.inherits)(Transform, Operator, {
    /**
   * Overrides {@link Operator.evaluate} for transform operators.
   * Internally, this method calls {@link evaluate} to perform processing.
   * If {@link evaluate} returns a falsy value, the input pulse is returned.
   * This method should NOT be overridden, instead overrride {@link evaluate}.
   * @param {Pulse} pulse - the current dataflow pulse.
   * @return the output pulse for this operator (or StopPropagation)
   */ run (pulse) {
        if (pulse.stamp < this.stamp) return pulse.StopPropagation;
        let rv;
        if (this.skip()) this.skip(false);
        else rv = this.evaluate(pulse);
        rv = rv || pulse;
        if (rv.then) rv = rv.then((_)=>this.pulse = _);
        else if (rv !== pulse.StopPropagation) this.pulse = rv;
        return rv;
    },
    /**
   * Overrides {@link Operator.evaluate} for transform operators.
   * Marshalls parameter values and then invokes {@link transform}.
   * @param {Pulse} pulse - the current dataflow pulse.
   * @return {Pulse} The output pulse (or StopPropagation). A falsy return
       value (including undefined) will let the input pulse pass through.
  */ evaluate (pulse) {
        const params = this.marshall(pulse.stamp), out = this.transform(params, pulse);
        params.clear();
        return out;
    },
    /**
   * Process incoming pulses.
   * Subclasses should override this method to implement transforms.
   * @param {Parameters} _ - The operator parameter values.
   * @param {Pulse} pulse - The current dataflow pulse.
   * @return {Pulse} The output pulse (or StopPropagation). A falsy return
   *   value (including undefined) will let the input pulse pass through.
   */ transform () {}
});
const transforms = {};
function definition(type) {
    const t = transform(type);
    return t && t.Definition || null;
}
function transform(type) {
    type = type && type.toLowerCase();
    return (0, _vegaUtil.hasOwnProperty)(transforms, type) ? transforms[type] : null;
}

},{"vega-util":"7f6sQ","vega-loader":"mXgcA","vega-format":"kHjpR","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"mXgcA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", ()=>format);
parcelHelpers.export(exports, "formats", ()=>formats);
parcelHelpers.export(exports, "inferType", ()=>inferType);
parcelHelpers.export(exports, "inferTypes", ()=>inferTypes);
parcelHelpers.export(exports, "loader", ()=>loader);
parcelHelpers.export(exports, "read", ()=>read);
parcelHelpers.export(exports, "responseType", ()=>responseType);
parcelHelpers.export(exports, "typeParsers", ()=>typeParsers);
var _vegaUtil = require("vega-util");
var _d3Dsv = require("d3-dsv");
var _topojsonClient = require("topojson-client");
var _vegaFormat = require("vega-format");
var Buffer = require("d2bd1b4e1a5e867b").Buffer;
// Matches absolute URLs with optional protocol
//   https://...    file://...    //...
const protocol_re = /^(data:|([A-Za-z]+:)?\/\/)/;
// Matches allowed URIs. From https://github.com/cure53/DOMPurify/blob/master/src/regexp.js with added file://
const allowed_re = /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp|file|data):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i; // eslint-disable-line no-useless-escape
const whitespace_re = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g; // eslint-disable-line no-control-regex
// Special treatment in node.js for the file: protocol
const fileProtocol = 'file://';
/**
 * Factory for a loader constructor that provides methods for requesting
 * files from either the network or disk, and for sanitizing request URIs.
 * @param {function} fetch - The Fetch API for HTTP network requests.
 *   If null or undefined, HTTP loading will be disabled.
 * @param {object} fs - The file system interface for file loading.
 *   If null or undefined, local file loading will be disabled.
 * @return {function} A loader constructor with the following signature:
 *   param {object} [options] - Optional default loading options to use.
 *   return {object} - A new loader instance.
 */ function loaderFactory(fetch1, fs) {
    return (options)=>({
            options: options || {},
            sanitize: sanitize,
            load: load,
            fileAccess: false,
            file: fileLoader(fs),
            http: httpLoader(fetch1)
        });
}
/**
 * Load an external resource, typically either from the web or from the local
 * filesystem. This function uses {@link sanitize} to first sanitize the uri,
 * then calls either {@link http} (for web requests) or {@link file} (for
 * filesystem loading).
 * @param {string} uri - The resource indicator (e.g., URL or filename).
 * @param {object} [options] - Optional loading options. These options will
 *   override any existing default options.
 * @return {Promise} - A promise that resolves to the loaded content.
 */ async function load(uri, options) {
    const opt = await this.sanitize(uri, options), url = opt.href;
    return opt.localFile ? this.file(url) : this.http(url, options);
}
/**
 * URI sanitizer function.
 * @param {string} uri - The uri (url or filename) to check.
 * @param {object} options - An options hash.
 * @return {Promise} - A promise that resolves to an object containing
 *  sanitized uri data, or rejects it the input uri is deemed invalid.
 *  The properties of the resolved object are assumed to be
 *  valid attributes for an HTML 'a' tag. The sanitized uri *must* be
 *  provided by the 'href' property of the returned object.
 */ async function sanitize(uri, options) {
    options = (0, _vegaUtil.extend)({}, this.options, options);
    const fileAccess = this.fileAccess, result = {
        href: null
    };
    let isFile, loadFile, base;
    const isAllowed = allowed_re.test(uri.replace(whitespace_re, ''));
    if (uri == null || typeof uri !== 'string' || !isAllowed) (0, _vegaUtil.error)('Sanitize failure, invalid URI: ' + (0, _vegaUtil.stringValue)(uri));
    const hasProtocol = protocol_re.test(uri);
    // if relative url (no protocol/host), prepend baseURL
    if ((base = options.baseURL) && !hasProtocol) {
        // Ensure that there is a slash between the baseURL (e.g. hostname) and url
        if (!uri.startsWith('/') && !base.endsWith('/')) uri = '/' + uri;
        uri = base + uri;
    }
    // should we load from file system?
    loadFile = (isFile = uri.startsWith(fileProtocol)) || options.mode === 'file' || options.mode !== 'http' && !hasProtocol && fileAccess;
    if (isFile) // strip file protocol
    uri = uri.slice(fileProtocol.length);
    else if (uri.startsWith('//')) {
        if (options.defaultProtocol === 'file') {
            // if is file, strip protocol and set loadFile flag
            uri = uri.slice(2);
            loadFile = true;
        } else // if relative protocol (starts with '//'), prepend default protocol
        uri = (options.defaultProtocol || 'http') + ':' + uri;
    }
    // set non-enumerable mode flag to indicate local file load
    Object.defineProperty(result, 'localFile', {
        value: !!loadFile
    });
    // set uri
    result.href = uri;
    // set default result target, if specified
    if (options.target) result.target = options.target + '';
    // set default result rel, if specified (#1542)
    if (options.rel) result.rel = options.rel + '';
    // provide control over cross-origin image handling (#2238)
    // https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image
    if (options.context === 'image' && options.crossOrigin) result.crossOrigin = options.crossOrigin + '';
    // return
    return result;
}
/**
 * File system loader factory.
 * @param {object} fs - The file system interface.
 * @return {function} - A file loader with the following signature:
 *   param {string} filename - The file system path to load.
 *   param {string} filename - The file system path to load.
 *   return {Promise} A promise that resolves to the file contents.
 */ function fileLoader(fs) {
    return fs ? (filename)=>new Promise((accept, reject)=>{
            fs.readFile(filename, (error, data)=>{
                if (error) reject(error);
                else accept(data);
            });
        }) : fileReject;
}
/**
 * Default file system loader that simply rejects.
 */ async function fileReject() {
    (0, _vegaUtil.error)('No file system access.');
}
/**
 * HTTP request handler factory.
 * @param {function} fetch - The Fetch API method.
 * @return {function} - An http loader with the following signature:
 *   param {string} url - The url to request.
 *   param {object} options - An options hash.
 *   return {Promise} - A promise that resolves to the file contents.
 */ function httpLoader(fetch1) {
    return fetch1 ? async function(url, options) {
        const opt = (0, _vegaUtil.extend)({}, this.options.http, options), type = options && options.response, response = await fetch1(url, opt);
        return !response.ok ? (0, _vegaUtil.error)(response.status + '' + response.statusText) : (0, _vegaUtil.isFunction)(response[type]) ? response[type]() : response.text();
    } : httpReject;
}
/**
 * Default http request handler that simply rejects.
 */ async function httpReject() {
    (0, _vegaUtil.error)('No HTTP fetch method available.');
}
const isValid = (_)=>_ != null && _ === _;
const isBoolean = (_)=>_ === 'true' || _ === 'false' || _ === true || _ === false;
const isDate = (_)=>!Number.isNaN(Date.parse(_));
const isNumber = (_)=>!Number.isNaN(+_) && !(_ instanceof Date);
const isInteger = (_)=>isNumber(_) && Number.isInteger(+_);
const typeParsers = {
    boolean: (0, _vegaUtil.toBoolean),
    integer: (0, _vegaUtil.toNumber),
    number: (0, _vegaUtil.toNumber),
    date: (0, _vegaUtil.toDate),
    string: (0, _vegaUtil.toString),
    unknown: (0, _vegaUtil.identity)
};
const typeTests = [
    isBoolean,
    isInteger,
    isNumber,
    isDate
];
const typeList = [
    'boolean',
    'integer',
    'number',
    'date'
];
function inferType(values, field) {
    if (!values || !values.length) return 'unknown';
    const n = values.length, m = typeTests.length, a = typeTests.map((_, i)=>i + 1);
    for(let i = 0, t = 0, j, value; i < n; ++i){
        value = field ? values[i][field] : values[i];
        for(j = 0; j < m; ++j)if (a[j] && isValid(value) && !typeTests[j](value)) {
            a[j] = 0;
            ++t;
            if (t === typeTests.length) return 'string';
        }
    }
    return typeList[a.reduce((u, v)=>u === 0 ? v : u, 0) - 1];
}
function inferTypes(data, fields) {
    return fields.reduce((types, field)=>{
        types[field] = inferType(data, field);
        return types;
    }, {});
}
function delimitedFormat(delimiter) {
    const parse = function(data, format) {
        const delim = {
            delimiter: delimiter
        };
        return dsv(data, format ? (0, _vegaUtil.extend)(format, delim) : delim);
    };
    parse.responseType = 'text';
    return parse;
}
function dsv(data, format) {
    if (format.header) data = format.header.map((0, _vegaUtil.stringValue)).join(format.delimiter) + '\n' + data;
    return (0, _d3Dsv.dsvFormat)(format.delimiter).parse(data + '');
}
dsv.responseType = 'text';
function isBuffer(_) {
    return typeof Buffer === 'function' && (0, _vegaUtil.isFunction)(Buffer.isBuffer) ? Buffer.isBuffer(_) : false;
}
function json(data, format) {
    const prop = format && format.property ? (0, _vegaUtil.field)(format.property) : (0, _vegaUtil.identity);
    return (0, _vegaUtil.isObject)(data) && !isBuffer(data) ? parseJSON(prop(data), format) : prop(JSON.parse(data));
}
json.responseType = 'json';
function parseJSON(data, format) {
    if (!(0, _vegaUtil.isArray)(data) && (0, _vegaUtil.isIterable)(data)) data = [
        ...data
    ];
    return format && format.copy ? JSON.parse(JSON.stringify(data)) : data;
}
const filters = {
    interior: (a, b)=>a !== b,
    exterior: (a, b)=>a === b
};
function topojson(data, format) {
    let method, object, property, filter;
    data = json(data, format);
    if (format && format.feature) {
        method = (0, _topojsonClient.feature);
        property = format.feature;
    } else if (format && format.mesh) {
        method = (0, _topojsonClient.mesh);
        property = format.mesh;
        filter = filters[format.filter];
    } else (0, _vegaUtil.error)('Missing TopoJSON feature or mesh parameter.');
    object = (object = data.objects[property]) ? method(data, object, filter) : (0, _vegaUtil.error)('Invalid TopoJSON object: ' + property);
    return object && object.features || [
        object
    ];
}
topojson.responseType = 'json';
const format = {
    dsv: dsv,
    csv: delimitedFormat(','),
    tsv: delimitedFormat('\t'),
    json: json,
    topojson: topojson
};
function formats(name, reader) {
    if (arguments.length > 1) {
        format[name] = reader;
        return this;
    } else return (0, _vegaUtil.hasOwnProperty)(format, name) ? format[name] : null;
}
function responseType(type) {
    const f = formats(type);
    return f && f.responseType || 'text';
}
function read(data, schema, timeParser, utcParser) {
    schema = schema || {};
    const reader = formats(schema.type || 'json');
    if (!reader) (0, _vegaUtil.error)('Unknown data format type: ' + schema.type);
    data = reader(data, schema);
    if (schema.parse) parse(data, schema.parse, timeParser, utcParser);
    if ((0, _vegaUtil.hasOwnProperty)(data, 'columns')) delete data.columns;
    return data;
}
function parse(data, types, timeParser, utcParser) {
    if (!data.length) return; // early exit for empty data
    const locale = (0, _vegaFormat.timeFormatDefaultLocale)();
    timeParser = timeParser || locale.timeParse;
    utcParser = utcParser || locale.utcParse;
    let fields = data.columns || Object.keys(data[0]), datum, field, i, j, n, m;
    if (types === 'auto') types = inferTypes(data, fields);
    fields = Object.keys(types);
    const parsers = fields.map((field)=>{
        const type = types[field];
        let parts, pattern;
        if (type && (type.startsWith('date:') || type.startsWith('utc:'))) {
            parts = type.split(/:(.+)?/, 2); // split on first :
            pattern = parts[1];
            if (pattern[0] === '\'' && pattern[pattern.length - 1] === '\'' || pattern[0] === '"' && pattern[pattern.length - 1] === '"') pattern = pattern.slice(1, -1);
            const parse = parts[0] === 'utc' ? utcParser : timeParser;
            return parse(pattern);
        }
        if (!typeParsers[type]) throw Error('Illegal format pattern: ' + field + ':' + type);
        return typeParsers[type];
    });
    for(i = 0, n = data.length, m = fields.length; i < n; ++i){
        datum = data[i];
        for(j = 0; j < m; ++j){
            field = fields[j];
            datum[field] = parsers[j](datum[field]);
        }
    }
}
const loader = loaderFactory(typeof fetch !== 'undefined' && fetch, // use built-in fetch API
null // no file system access
);

},{"d2bd1b4e1a5e867b":"67CwE","vega-util":"7f6sQ","d3-dsv":[["dsvFormat","cgT6J","default"]],"topojson-client":"lCPjz","vega-format":"kHjpR","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"67CwE":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
const base64 = require("9c62938f1dccc73c");
const ieee754 = require("aceacb6a4531a9d2");
const customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
const K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    const b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = byteLength(string, encoding) | 0;
    let buf = createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    const length = array.length < 0 ? 0 : checked(array.length) | 0;
    const buf = createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const errors = {};
function E(sym, getMessage, Base) {
    errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function checkBounds(buf, offset, byteLength) {
    validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
}
function checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    checkBounds(buf, offset, byteLength);
}
function validateNumber(value, name) {
    if (typeof value !== 'number') throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn;
}
function BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

},{"9c62938f1dccc73c":"dxhUl","aceacb6a4531a9d2":"8Mmcq"}],"dxhUl":[function(require,module,exports,__globalThis) {
'use strict';
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

},{}],"8Mmcq":[function(require,module,exports,__globalThis) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"cgT6J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(delimiter) {
        var reFormat = new RegExp("[\"" + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
        function parse(text, f) {
            var convert, columns, rows = parseRows(text, function(row, i) {
                if (convert) return convert(row, i - 1);
                columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
            });
            rows.columns = columns || [];
            return rows;
        }
        function parseRows(text, f) {
            var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false; // current token followed by EOL?
            // Strip the trailing newline.
            if (text.charCodeAt(N - 1) === NEWLINE) --N;
            if (text.charCodeAt(N - 1) === RETURN) --N;
            function token() {
                if (eof) return EOF;
                if (eol) return eol = false, EOL;
                // Unescape quotes.
                var i, j = I, c;
                if (text.charCodeAt(j) === QUOTE) {
                    while(I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
                    if ((i = I) >= N) eof = true;
                    else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;
                    else if (c === RETURN) {
                        eol = true;
                        if (text.charCodeAt(I) === NEWLINE) ++I;
                    }
                    return text.slice(j + 1, i - 1).replace(/""/g, "\"");
                }
                // Find next delimiter or newline.
                while(I < N){
                    if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
                    else if (c === RETURN) {
                        eol = true;
                        if (text.charCodeAt(I) === NEWLINE) ++I;
                    } else if (c !== DELIMITER) continue;
                    return text.slice(j, i);
                }
                // Return last token before EOF.
                return eof = true, text.slice(j, N);
            }
            while((t = token()) !== EOF){
                var row = [];
                while(t !== EOL && t !== EOF)row.push(t), t = token();
                if (f && (row = f(row, n++)) == null) continue;
                rows.push(row);
            }
            return rows;
        }
        function preformatBody(rows, columns) {
            return rows.map(function(row) {
                return columns.map(function(column) {
                    return formatValue(row[column]);
                }).join(delimiter);
            });
        }
        function format(rows, columns) {
            if (columns == null) columns = inferColumns(rows);
            return [
                columns.map(formatValue).join(delimiter)
            ].concat(preformatBody(rows, columns)).join("\n");
        }
        function formatBody(rows, columns) {
            if (columns == null) columns = inferColumns(rows);
            return preformatBody(rows, columns).join("\n");
        }
        function formatRows(rows) {
            return rows.map(formatRow).join("\n");
        }
        function formatRow(row) {
            return row.map(formatValue).join(delimiter);
        }
        function formatValue(value) {
            return value == null ? "" : value instanceof Date ? formatDate(value) : reFormat.test(value += "") ? "\"" + value.replace(/"/g, "\"\"") + "\"" : value;
        }
        return {
            parse: parse,
            parseRows: parseRows,
            format: format,
            formatBody: formatBody,
            formatRows: formatRows,
            formatRow: formatRow,
            formatValue: formatValue
        };
    });
var EOL = {}, EOF = {}, QUOTE = 34, NEWLINE = 10, RETURN = 13;
function objectConverter(columns) {
    return new Function("d", "return {" + columns.map(function(name, i) {
        return JSON.stringify(name) + ": d[" + i + "] || \"\"";
    }).join(",") + "}");
}
function customConverter(columns, f) {
    var object = objectConverter(columns);
    return function(row, i) {
        return f(object(row), i, columns);
    };
}
// Compute unique columns in order of discovery.
function inferColumns(rows) {
    var columnSet = Object.create(null), columns = [];
    rows.forEach(function(row) {
        for(var column in row)if (!(column in columnSet)) columns.push(columnSet[column] = column);
    });
    return columns;
}
function pad(value, width) {
    var s = value + "", length = s.length;
    return length < width ? new Array(width - length + 1).join(0) + s : s;
}
function formatYear(year) {
    return year < 0 ? "-" + pad(-year, 6) : year > 9999 ? "+" + pad(year, 6) : pad(year, 4);
}
function formatDate(date) {
    var hours = date.getUTCHours(), minutes = date.getUTCMinutes(), seconds = date.getUTCSeconds(), milliseconds = date.getUTCMilliseconds();
    return isNaN(date) ? "Invalid Date" : formatYear(date.getUTCFullYear(), 4) + "-" + pad(date.getUTCMonth() + 1, 2) + "-" + pad(date.getUTCDate(), 2) + (milliseconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "." + pad(milliseconds, 3) + "Z" : seconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "Z" : minutes || hours ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + "Z" : "");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"lCPjz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bbox", ()=>(0, _bboxJsDefault.default));
parcelHelpers.export(exports, "feature", ()=>(0, _featureJsDefault.default));
parcelHelpers.export(exports, "mesh", ()=>(0, _meshJsDefault.default));
parcelHelpers.export(exports, "meshArcs", ()=>(0, _meshJs.meshArcs));
parcelHelpers.export(exports, "merge", ()=>(0, _mergeJsDefault.default));
parcelHelpers.export(exports, "mergeArcs", ()=>(0, _mergeJs.mergeArcs));
parcelHelpers.export(exports, "neighbors", ()=>(0, _neighborsJsDefault.default));
parcelHelpers.export(exports, "quantize", ()=>(0, _quantizeJsDefault.default));
parcelHelpers.export(exports, "transform", ()=>(0, _transformJsDefault.default));
parcelHelpers.export(exports, "untransform", ()=>(0, _untransformJsDefault.default));
var _bboxJs = require("./bbox.js");
var _bboxJsDefault = parcelHelpers.interopDefault(_bboxJs);
var _featureJs = require("./feature.js");
var _featureJsDefault = parcelHelpers.interopDefault(_featureJs);
var _meshJs = require("./mesh.js");
var _meshJsDefault = parcelHelpers.interopDefault(_meshJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _neighborsJs = require("./neighbors.js");
var _neighborsJsDefault = parcelHelpers.interopDefault(_neighborsJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);
var _transformJs = require("./transform.js");
var _transformJsDefault = parcelHelpers.interopDefault(_transformJs);
var _untransformJs = require("./untransform.js");
var _untransformJsDefault = parcelHelpers.interopDefault(_untransformJs);

},{"./bbox.js":"4TrDx","./feature.js":"gUa6P","./mesh.js":"c66Ss","./merge.js":"2aihB","./neighbors.js":"utBG3","./quantize.js":"35kg7","./transform.js":"bLph6","./untransform.js":"26Zpm","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4TrDx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(topology) {
        var t = (0, _transformJsDefault.default)(topology.transform), key, x0 = Infinity, y0 = x0, x1 = -x0, y1 = -x0;
        function bboxPoint(p) {
            p = t(p);
            if (p[0] < x0) x0 = p[0];
            if (p[0] > x1) x1 = p[0];
            if (p[1] < y0) y0 = p[1];
            if (p[1] > y1) y1 = p[1];
        }
        function bboxGeometry(o) {
            switch(o.type){
                case "GeometryCollection":
                    o.geometries.forEach(bboxGeometry);
                    break;
                case "Point":
                    bboxPoint(o.coordinates);
                    break;
                case "MultiPoint":
                    o.coordinates.forEach(bboxPoint);
                    break;
            }
        }
        topology.arcs.forEach(function(arc) {
            var i = -1, n = arc.length, p;
            while(++i < n){
                p = t(arc[i], i);
                if (p[0] < x0) x0 = p[0];
                if (p[0] > x1) x1 = p[0];
                if (p[1] < y0) y0 = p[1];
                if (p[1] > y1) y1 = p[1];
            }
        });
        for(key in topology.objects)bboxGeometry(topology.objects[key]);
        return [
            x0,
            y0,
            x1,
            y1
        ];
    });
var _transformJs = require("./transform.js");
var _transformJsDefault = parcelHelpers.interopDefault(_transformJs);

},{"./transform.js":"bLph6","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bLph6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(transform) {
        if (transform == null) return 0, _identityJsDefault.default;
        var x0, y0, kx = transform.scale[0], ky = transform.scale[1], dx = transform.translate[0], dy = transform.translate[1];
        return function(input, i) {
            if (!i) x0 = y0 = 0;
            var j = 2, n = input.length, output = new Array(n);
            output[0] = (x0 += input[0]) * kx + dx;
            output[1] = (y0 += input[1]) * ky + dy;
            while(j < n)output[j] = input[j], ++j;
            return output;
        };
    });
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);

},{"./identity.js":"caM6u","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"caM6u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"gUa6P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(topology, o) {
        if (typeof o === "string") o = topology.objects[o];
        return o.type === "GeometryCollection" ? {
            type: "FeatureCollection",
            features: o.geometries.map(function(o) {
                return feature(topology, o);
            })
        } : feature(topology, o);
    });
parcelHelpers.export(exports, "object", ()=>object);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
var _transformJs = require("./transform.js");
var _transformJsDefault = parcelHelpers.interopDefault(_transformJs);
function feature(topology, o) {
    var id = o.id, bbox = o.bbox, properties = o.properties == null ? {} : o.properties, geometry = object(topology, o);
    return id == null && bbox == null ? {
        type: "Feature",
        properties: properties,
        geometry: geometry
    } : bbox == null ? {
        type: "Feature",
        id: id,
        properties: properties,
        geometry: geometry
    } : {
        type: "Feature",
        id: id,
        bbox: bbox,
        properties: properties,
        geometry: geometry
    };
}
function object(topology, o) {
    var transformPoint = (0, _transformJsDefault.default)(topology.transform), arcs = topology.arcs;
    function arc(i, points) {
        if (points.length) points.pop();
        for(var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k)points.push(transformPoint(a[k], k));
        if (i < 0) (0, _reverseJsDefault.default)(points, n);
    }
    function point(p) {
        return transformPoint(p);
    }
    function line(arcs) {
        var points = [];
        for(var i = 0, n = arcs.length; i < n; ++i)arc(arcs[i], points);
        if (points.length < 2) points.push(points[0]); // This should never happen per the specification.
        return points;
    }
    function ring(arcs) {
        var points = line(arcs);
        while(points.length < 4)points.push(points[0]); // This may happen if an arc has only two points.
        return points;
    }
    function polygon(arcs) {
        return arcs.map(ring);
    }
    function geometry(o) {
        var type = o.type, coordinates;
        switch(type){
            case "GeometryCollection":
                return {
                    type: type,
                    geometries: o.geometries.map(geometry)
                };
            case "Point":
                coordinates = point(o.coordinates);
                break;
            case "MultiPoint":
                coordinates = o.coordinates.map(point);
                break;
            case "LineString":
                coordinates = line(o.arcs);
                break;
            case "MultiLineString":
                coordinates = o.arcs.map(line);
                break;
            case "Polygon":
                coordinates = polygon(o.arcs);
                break;
            case "MultiPolygon":
                coordinates = o.arcs.map(polygon);
                break;
            default:
                return null;
        }
        return {
            type: type,
            coordinates: coordinates
        };
    }
    return geometry(o);
}

},{"./reverse.js":"kyIQT","./transform.js":"bLph6","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"kyIQT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(array, n) {
        var t, j = array.length, i = j - n;
        while(i < --j)t = array[i], array[i++] = array[j], array[j] = t;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"c66Ss":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(topology) {
        return (0, _featureJs.object)(topology, meshArcs.apply(this, arguments));
    });
parcelHelpers.export(exports, "meshArcs", ()=>meshArcs);
var _featureJs = require("./feature.js");
var _stitchJs = require("./stitch.js");
var _stitchJsDefault = parcelHelpers.interopDefault(_stitchJs);
function meshArcs(topology, object, filter) {
    var arcs, i, n;
    if (arguments.length > 1) arcs = extractArcs(topology, object, filter);
    else for(i = 0, arcs = new Array(n = topology.arcs.length); i < n; ++i)arcs[i] = i;
    return {
        type: "MultiLineString",
        arcs: (0, _stitchJsDefault.default)(topology, arcs)
    };
}
function extractArcs(topology, object, filter) {
    var arcs = [], geomsByArc = [], geom;
    function extract0(i) {
        var j = i < 0 ? ~i : i;
        (geomsByArc[j] || (geomsByArc[j] = [])).push({
            i: i,
            g: geom
        });
    }
    function extract1(arcs) {
        arcs.forEach(extract0);
    }
    function extract2(arcs) {
        arcs.forEach(extract1);
    }
    function extract3(arcs) {
        arcs.forEach(extract2);
    }
    function geometry(o) {
        switch(geom = o, o.type){
            case "GeometryCollection":
                o.geometries.forEach(geometry);
                break;
            case "LineString":
                extract1(o.arcs);
                break;
            case "MultiLineString":
            case "Polygon":
                extract2(o.arcs);
                break;
            case "MultiPolygon":
                extract3(o.arcs);
                break;
        }
    }
    geometry(object);
    geomsByArc.forEach(filter == null ? function(geoms) {
        arcs.push(geoms[0].i);
    } : function(geoms) {
        if (filter(geoms[0].g, geoms[geoms.length - 1].g)) arcs.push(geoms[0].i);
    });
    return arcs;
}

},{"./feature.js":"gUa6P","./stitch.js":"kdOvp","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"kdOvp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(topology, arcs) {
        var stitchedArcs = {}, fragmentByStart = {}, fragmentByEnd = {}, fragments = [], emptyIndex = -1;
        // Stitch empty arcs first, since they may be subsumed by other arcs.
        arcs.forEach(function(i, j) {
            var arc = topology.arcs[i < 0 ? ~i : i], t;
            if (arc.length < 3 && !arc[1][0] && !arc[1][1]) t = arcs[++emptyIndex], arcs[emptyIndex] = i, arcs[j] = t;
        });
        arcs.forEach(function(i) {
            var e = ends(i), start = e[0], end = e[1], f, g;
            if (f = fragmentByEnd[start]) {
                delete fragmentByEnd[f.end];
                f.push(i);
                f.end = end;
                if (g = fragmentByStart[end]) {
                    delete fragmentByStart[g.start];
                    var fg = g === f ? f : f.concat(g);
                    fragmentByStart[fg.start = f.start] = fragmentByEnd[fg.end = g.end] = fg;
                } else fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
            } else if (f = fragmentByStart[end]) {
                delete fragmentByStart[f.start];
                f.unshift(i);
                f.start = start;
                if (g = fragmentByEnd[start]) {
                    delete fragmentByEnd[g.end];
                    var gf = g === f ? f : g.concat(f);
                    fragmentByStart[gf.start = g.start] = fragmentByEnd[gf.end = f.end] = gf;
                } else fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
            } else {
                f = [
                    i
                ];
                fragmentByStart[f.start = start] = fragmentByEnd[f.end = end] = f;
            }
        });
        function ends(i) {
            var arc = topology.arcs[i < 0 ? ~i : i], p0 = arc[0], p1;
            if (topology.transform) p1 = [
                0,
                0
            ], arc.forEach(function(dp) {
                p1[0] += dp[0], p1[1] += dp[1];
            });
            else p1 = arc[arc.length - 1];
            return i < 0 ? [
                p1,
                p0
            ] : [
                p0,
                p1
            ];
        }
        function flush(fragmentByEnd, fragmentByStart) {
            for(var k in fragmentByEnd){
                var f = fragmentByEnd[k];
                delete fragmentByStart[f.start];
                delete f.start;
                delete f.end;
                f.forEach(function(i) {
                    stitchedArcs[i < 0 ? ~i : i] = 1;
                });
                fragments.push(f);
            }
        }
        flush(fragmentByEnd, fragmentByStart);
        flush(fragmentByStart, fragmentByEnd);
        arcs.forEach(function(i) {
            if (!stitchedArcs[i < 0 ? ~i : i]) fragments.push([
                i
            ]);
        });
        return fragments;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"2aihB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(topology) {
        return (0, _featureJs.object)(topology, mergeArcs.apply(this, arguments));
    });
parcelHelpers.export(exports, "mergeArcs", ()=>mergeArcs);
var _featureJs = require("./feature.js");
var _stitchJs = require("./stitch.js");
var _stitchJsDefault = parcelHelpers.interopDefault(_stitchJs);
function planarRingArea(ring) {
    var i = -1, n = ring.length, a, b = ring[n - 1], area = 0;
    while(++i < n)a = b, b = ring[i], area += a[0] * b[1] - a[1] * b[0];
    return Math.abs(area); // Note: doubled area!
}
function mergeArcs(topology, objects) {
    var polygonsByArc = {}, polygons = [], groups = [];
    objects.forEach(geometry);
    function geometry(o) {
        switch(o.type){
            case "GeometryCollection":
                o.geometries.forEach(geometry);
                break;
            case "Polygon":
                extract(o.arcs);
                break;
            case "MultiPolygon":
                o.arcs.forEach(extract);
                break;
        }
    }
    function extract(polygon) {
        polygon.forEach(function(ring) {
            ring.forEach(function(arc) {
                (polygonsByArc[arc = arc < 0 ? ~arc : arc] || (polygonsByArc[arc] = [])).push(polygon);
            });
        });
        polygons.push(polygon);
    }
    function area(ring) {
        return planarRingArea((0, _featureJs.object)(topology, {
            type: "Polygon",
            arcs: [
                ring
            ]
        }).coordinates[0]);
    }
    polygons.forEach(function(polygon) {
        if (!polygon._) {
            var group = [], neighbors = [
                polygon
            ];
            polygon._ = 1;
            groups.push(group);
            while(polygon = neighbors.pop()){
                group.push(polygon);
                polygon.forEach(function(ring) {
                    ring.forEach(function(arc) {
                        polygonsByArc[arc < 0 ? ~arc : arc].forEach(function(polygon) {
                            if (!polygon._) {
                                polygon._ = 1;
                                neighbors.push(polygon);
                            }
                        });
                    });
                });
            }
        }
    });
    polygons.forEach(function(polygon) {
        delete polygon._;
    });
    return {
        type: "MultiPolygon",
        arcs: groups.map(function(polygons) {
            var arcs = [], n;
            // Extract the exterior (unique) arcs.
            polygons.forEach(function(polygon) {
                polygon.forEach(function(ring) {
                    ring.forEach(function(arc) {
                        if (polygonsByArc[arc < 0 ? ~arc : arc].length < 2) arcs.push(arc);
                    });
                });
            });
            // Stitch the arcs into one or more rings.
            arcs = (0, _stitchJsDefault.default)(topology, arcs);
            // If more than one ring is returned,
            // at most one of these rings can be the exterior;
            // choose the one with the greatest absolute area.
            if ((n = arcs.length) > 1) {
                for(var i = 1, k = area(arcs[0]), ki, t; i < n; ++i)if ((ki = area(arcs[i])) > k) t = arcs[0], arcs[0] = arcs[i], arcs[i] = t, k = ki;
            }
            return arcs;
        }).filter(function(arcs) {
            return arcs.length > 0;
        })
    };
}

},{"./feature.js":"gUa6P","./stitch.js":"kdOvp","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"utBG3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(objects) {
        var indexesByArc = {}, neighbors = objects.map(function() {
            return [];
        });
        function line(arcs, i) {
            arcs.forEach(function(a) {
                if (a < 0) a = ~a;
                var o = indexesByArc[a];
                if (o) o.push(i);
                else indexesByArc[a] = [
                    i
                ];
            });
        }
        function polygon(arcs, i) {
            arcs.forEach(function(arc) {
                line(arc, i);
            });
        }
        function geometry(o, i) {
            if (o.type === "GeometryCollection") o.geometries.forEach(function(o) {
                geometry(o, i);
            });
            else if (o.type in geometryType) geometryType[o.type](o.arcs, i);
        }
        var geometryType = {
            LineString: line,
            MultiLineString: polygon,
            Polygon: polygon,
            MultiPolygon: function(arcs, i) {
                arcs.forEach(function(arc) {
                    polygon(arc, i);
                });
            }
        };
        objects.forEach(geometry);
        for(var i in indexesByArc){
            for(var indexes = indexesByArc[i], m = indexes.length, j = 0; j < m; ++j)for(var k = j + 1; k < m; ++k){
                var ij = indexes[j], ik = indexes[k], n;
                if ((n = neighbors[ij])[i = (0, _bisectJsDefault.default)(n, ik)] !== ik) n.splice(i, 0, ik);
                if ((n = neighbors[ik])[i = (0, _bisectJsDefault.default)(n, ij)] !== ij) n.splice(i, 0, ij);
            }
        }
        return neighbors;
    });
var _bisectJs = require("./bisect.js");
var _bisectJsDefault = parcelHelpers.interopDefault(_bisectJs);

},{"./bisect.js":"dTI7P","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dTI7P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, x) {
        var lo = 0, hi = a.length;
        while(lo < hi){
            var mid = lo + hi >>> 1;
            if (a[mid] < x) lo = mid + 1;
            else hi = mid;
        }
        return lo;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"35kg7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(topology, transform) {
        if (topology.transform) throw new Error("already quantized");
        if (!transform || !transform.scale) {
            if (!((n = Math.floor(transform)) >= 2)) throw new Error("n must be \u22652");
            box = topology.bbox || (0, _bboxJsDefault.default)(topology);
            var x0 = box[0], y0 = box[1], x1 = box[2], y1 = box[3], n;
            transform = {
                scale: [
                    x1 - x0 ? (x1 - x0) / (n - 1) : 1,
                    y1 - y0 ? (y1 - y0) / (n - 1) : 1
                ],
                translate: [
                    x0,
                    y0
                ]
            };
        } else box = topology.bbox;
        var t = (0, _untransformJsDefault.default)(transform), box, key, inputs = topology.objects, outputs = {};
        function quantizePoint(point) {
            return t(point);
        }
        function quantizeGeometry(input) {
            var output;
            switch(input.type){
                case "GeometryCollection":
                    output = {
                        type: "GeometryCollection",
                        geometries: input.geometries.map(quantizeGeometry)
                    };
                    break;
                case "Point":
                    output = {
                        type: "Point",
                        coordinates: quantizePoint(input.coordinates)
                    };
                    break;
                case "MultiPoint":
                    output = {
                        type: "MultiPoint",
                        coordinates: input.coordinates.map(quantizePoint)
                    };
                    break;
                default:
                    return input;
            }
            if (input.id != null) output.id = input.id;
            if (input.bbox != null) output.bbox = input.bbox;
            if (input.properties != null) output.properties = input.properties;
            return output;
        }
        function quantizeArc(input) {
            var i = 0, j = 1, n = input.length, p, output = new Array(n); // pessimistic
            output[0] = t(input[0], 0);
            while(++i < n)if ((p = t(input[i], i))[0] || p[1]) output[j++] = p; // non-coincident points
            if (j === 1) output[j++] = [
                0,
                0
            ]; // an arc must have at least two points
            output.length = j;
            return output;
        }
        for(key in inputs)outputs[key] = quantizeGeometry(inputs[key]);
        return {
            type: "Topology",
            bbox: box,
            transform: transform,
            objects: outputs,
            arcs: topology.arcs.map(quantizeArc)
        };
    });
var _bboxJs = require("./bbox.js");
var _bboxJsDefault = parcelHelpers.interopDefault(_bboxJs);
var _untransformJs = require("./untransform.js");
var _untransformJsDefault = parcelHelpers.interopDefault(_untransformJs);

},{"./bbox.js":"4TrDx","./untransform.js":"26Zpm","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"26Zpm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(transform) {
        if (transform == null) return 0, _identityJsDefault.default;
        var x0, y0, kx = transform.scale[0], ky = transform.scale[1], dx = transform.translate[0], dy = transform.translate[1];
        return function(input, i) {
            if (!i) x0 = y0 = 0;
            var j = 2, n = input.length, output = new Array(n), x1 = Math.round((input[0] - dx) / kx), y1 = Math.round((input[1] - dy) / ky);
            output[0] = x1 - x0, x0 = x1;
            output[1] = y1 - y0, y0 = y1;
            while(j < n)output[j] = input[j], ++j;
            return output;
        };
    });
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);

},{"./identity.js":"caM6u","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"kHjpR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultLocale", ()=>defaultLocale);
parcelHelpers.export(exports, "locale", ()=>locale);
parcelHelpers.export(exports, "numberFormatDefaultLocale", ()=>numberFormatDefaultLocale);
parcelHelpers.export(exports, "numberFormatLocale", ()=>numberFormatLocale);
parcelHelpers.export(exports, "resetDefaultLocale", ()=>resetDefaultLocale);
parcelHelpers.export(exports, "resetNumberFormatDefaultLocale", ()=>resetNumberFormatDefaultLocale);
parcelHelpers.export(exports, "resetTimeFormatDefaultLocale", ()=>resetTimeFormatDefaultLocale);
parcelHelpers.export(exports, "timeFormatDefaultLocale", ()=>timeFormatDefaultLocale);
parcelHelpers.export(exports, "timeFormatLocale", ()=>timeFormatLocale);
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");
var _vegaTime = require("vega-time");
var _vegaUtil = require("vega-util");
var _d3TimeFormat = require("d3-time-format");
function memoize(method) {
    const cache = {};
    return (spec)=>cache[spec] || (cache[spec] = method(spec));
}
function trimZeroes(numberFormat, decimalChar) {
    return (x)=>{
        const str = numberFormat(x), dec = str.indexOf(decimalChar);
        if (dec < 0) return str;
        let idx = rightmostDigit(str, dec);
        const end = idx < str.length ? str.slice(idx) : '';
        while(--idx > dec)if (str[idx] !== '0') {
            ++idx;
            break;
        }
        return str.slice(0, idx) + end;
    };
}
function rightmostDigit(str, dec) {
    let i = str.lastIndexOf('e'), c;
    if (i > 0) return i;
    for(i = str.length; --i > dec;){
        c = str.charCodeAt(i);
        if (c >= 48 && c <= 57) return i + 1; // is digit
    }
}
function numberLocale(locale) {
    const format = memoize(locale.format), formatPrefix = locale.formatPrefix;
    return {
        format,
        formatPrefix,
        formatFloat (spec) {
            const s = (0, _d3Format.formatSpecifier)(spec || ',');
            if (s.precision == null) {
                s.precision = 12;
                switch(s.type){
                    case '%':
                        s.precision -= 2;
                        break;
                    case 'e':
                        s.precision -= 1;
                        break;
                }
                return trimZeroes(format(s), // number format
                format('.1f')(1)[1] // decimal point character
                );
            } else return format(s);
        },
        formatSpan (start, stop, count, specifier) {
            specifier = (0, _d3Format.formatSpecifier)(specifier == null ? ',f' : specifier);
            const step = (0, _d3Array.tickStep)(start, stop, count), value = Math.max(Math.abs(start), Math.abs(stop));
            let precision;
            if (specifier.precision == null) switch(specifier.type){
                case 's':
                    if (!isNaN(precision = (0, _d3Format.precisionPrefix)(step, value))) specifier.precision = precision;
                    return formatPrefix(specifier, value);
                case '':
                case 'e':
                case 'g':
                case 'p':
                case 'r':
                    if (!isNaN(precision = (0, _d3Format.precisionRound)(step, value))) specifier.precision = precision - (specifier.type === 'e');
                    break;
                case 'f':
                case '%':
                    if (!isNaN(precision = (0, _d3Format.precisionFixed)(step))) specifier.precision = precision - (specifier.type === '%') * 2;
                    break;
            }
            return format(specifier);
        }
    };
}
let defaultNumberLocale;
resetNumberFormatDefaultLocale();
function resetNumberFormatDefaultLocale() {
    return defaultNumberLocale = numberLocale({
        format: (0, _d3Format.format),
        formatPrefix: (0, _d3Format.formatPrefix)
    });
}
function numberFormatLocale(definition) {
    return numberLocale((0, _d3Format.formatLocale)(definition));
}
function numberFormatDefaultLocale(definition) {
    return arguments.length ? defaultNumberLocale = numberFormatLocale(definition) : defaultNumberLocale;
}
function timeMultiFormat(format, interval, spec) {
    spec = spec || {};
    if (!(0, _vegaUtil.isObject)(spec)) (0, _vegaUtil.error)(`Invalid time multi-format specifier: ${spec}`);
    const second = interval((0, _vegaTime.SECONDS)), minute = interval((0, _vegaTime.MINUTES)), hour = interval((0, _vegaTime.HOURS)), day = interval((0, _vegaTime.DATE)), week = interval((0, _vegaTime.WEEK)), month = interval((0, _vegaTime.MONTH)), quarter = interval((0, _vegaTime.QUARTER)), year = interval((0, _vegaTime.YEAR)), L = format(spec[0, _vegaTime.MILLISECONDS] || '.%L'), S = format(spec[0, _vegaTime.SECONDS] || ':%S'), M = format(spec[0, _vegaTime.MINUTES] || '%I:%M'), H = format(spec[0, _vegaTime.HOURS] || '%I %p'), d = format(spec[0, _vegaTime.DATE] || spec[0, _vegaTime.DAY] || '%a %d'), w = format(spec[0, _vegaTime.WEEK] || '%b %d'), m = format(spec[0, _vegaTime.MONTH] || '%B'), q = format(spec[0, _vegaTime.QUARTER] || '%B'), y = format(spec[0, _vegaTime.YEAR] || '%Y');
    return (date)=>(second(date) < date ? L : minute(date) < date ? S : hour(date) < date ? M : day(date) < date ? H : month(date) < date ? week(date) < date ? d : w : year(date) < date ? quarter(date) < date ? m : q : y)(date);
}
function timeLocale(locale) {
    const timeFormat = memoize(locale.format), utcFormat = memoize(locale.utcFormat);
    return {
        timeFormat: (spec)=>(0, _vegaUtil.isString)(spec) ? timeFormat(spec) : timeMultiFormat(timeFormat, (0, _vegaTime.timeInterval), spec),
        utcFormat: (spec)=>(0, _vegaUtil.isString)(spec) ? utcFormat(spec) : timeMultiFormat(utcFormat, (0, _vegaTime.utcInterval), spec),
        timeParse: memoize(locale.parse),
        utcParse: memoize(locale.utcParse)
    };
}
let defaultTimeLocale;
resetTimeFormatDefaultLocale();
function resetTimeFormatDefaultLocale() {
    return defaultTimeLocale = timeLocale({
        format: (0, _d3TimeFormat.timeFormat),
        parse: (0, _d3TimeFormat.timeParse),
        utcFormat: (0, _d3TimeFormat.utcFormat),
        utcParse: (0, _d3TimeFormat.utcParse)
    });
}
function timeFormatLocale(definition) {
    return timeLocale((0, _d3TimeFormat.timeFormatLocale)(definition));
}
function timeFormatDefaultLocale(definition) {
    return arguments.length ? defaultTimeLocale = timeFormatLocale(definition) : defaultTimeLocale;
}
const createLocale = (number, time)=>(0, _vegaUtil.extend)({}, number, time);
function locale(numberSpec, timeSpec) {
    const number = numberSpec ? numberFormatLocale(numberSpec) : numberFormatDefaultLocale();
    const time = timeSpec ? timeFormatLocale(timeSpec) : timeFormatDefaultLocale();
    return createLocale(number, time);
}
function defaultLocale(numberSpec, timeSpec) {
    const args = arguments.length;
    if (args && args !== 2) (0, _vegaUtil.error)('defaultLocale expects either zero or two arguments.');
    return args ? createLocale(numberFormatDefaultLocale(numberSpec), timeFormatDefaultLocale(timeSpec)) : createLocale(numberFormatDefaultLocale(), timeFormatDefaultLocale());
}
function resetDefaultLocale() {
    resetNumberFormatDefaultLocale();
    resetTimeFormatDefaultLocale();
    return defaultLocale();
}

},{"d3-array":"4kdy4","d3-format":[["format","4S7BV"],["formatPrefix","4S7BV"],["formatLocale","ecXLW","default"],["formatSpecifier","3qj60","default"],["precisionFixed","gjSQc","default"],["precisionPrefix","lOwiG","default"],["precisionRound","hY5kM","default"]],"vega-time":"4oydN","vega-util":"7f6sQ","d3-time-format":[["timeFormat","beqDu"],["timeParse","beqDu"],["utcFormat","beqDu"],["utcParse","beqDu"],["timeFormatLocale","8jcCt","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4kdy4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ticks);
parcelHelpers.export(exports, "tickIncrement", ()=>tickIncrement);
parcelHelpers.export(exports, "tickStep", ()=>tickStep);
const e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function ticks(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? tickSpec(stop, start, count) : tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function tickIncrement(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return tickSpec(start, stop, count)[2];
}
function tickStep(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? tickIncrement(stop, start, count) : tickIncrement(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4S7BV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", ()=>format);
parcelHelpers.export(exports, "formatPrefix", ()=>formatPrefix);
parcelHelpers.export(exports, "default", ()=>defaultLocale);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var format;
var formatPrefix;
defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    format = locale.format;
    formatPrefix = locale.formatPrefix;
    return locale;
}

},{"./locale.js":"ecXLW","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"ecXLW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(locale) {
        var group = locale.grouping === undefined || locale.thousands === undefined ? (0, _identityJsDefault.default) : (0, _formatGroupJsDefault.default)(map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, _identityJsDefault.default) : (0, _formatNumeralsJsDefault.default)(map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
        function newFormat(specifier) {
            specifier = (0, _formatSpecifierJsDefault.default)(specifier);
            var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
            // The "n" type is an alias for ",g".
            if (type === "n") comma = true, type = "g";
            else if (!(0, _formatTypesJsDefault.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
            // If zero fill is specified, padding goes after sign and before digits.
            if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
            // Compute the prefix and suffix.
            // For SI-prefix, the suffix is lazily computed.
            var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
            // What format function should we use?
            // Is this an integer type?
            // Can this type generate exponential notation?
            var formatType = (0, _formatTypesJsDefault.default)[type], maybeSuffix = /[defgprs%]/.test(type);
            // Set the default precision if not specified,
            // or clamp the specified precision to the supported range.
            // For significant precision, it must be in [1, 21].
            // For fixed precision, it must be in [0, 20].
            precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
            function format(value) {
                var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
                if (type === "c") {
                    valueSuffix = formatType(value) + valueSuffix;
                    value = "";
                } else {
                    value = +value;
                    // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                    var valueNegative = value < 0 || 1 / value < 0;
                    // Perform the initial formatting.
                    value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                    // Trim insignificant zeros.
                    if (trim) value = (0, _formatTrimJsDefault.default)(value);
                    // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                    if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                    // Compute the prefix and suffix.
                    valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                    valueSuffix = (type === "s" ? prefixes[8 + (0, _formatPrefixAutoJs.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                    // Break the formatted value into the integer “value” part that can be
                    // grouped, and fractional or exponential “suffix” part that is not.
                    if (maybeSuffix) {
                        i = -1, n = value.length;
                        while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                            valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                            value = value.slice(0, i);
                            break;
                        }
                    }
                }
                // If the fill character is not "0", grouping is applied before padding.
                if (comma && !zero) value = group(value, Infinity);
                // Compute the padding.
                var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
                // If the fill character is "0", grouping is applied after padding.
                if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
                // Reconstruct the final output based on the desired alignment.
                switch(align){
                    case "<":
                        value = valuePrefix + value + valueSuffix + padding;
                        break;
                    case "=":
                        value = valuePrefix + padding + value + valueSuffix;
                        break;
                    case "^":
                        value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                        break;
                    default:
                        value = padding + valuePrefix + value + valueSuffix;
                        break;
                }
                return numerals(value);
            }
            format.toString = function() {
                return specifier + "";
            };
            return format;
        }
        function formatPrefix(specifier, value) {
            var f = newFormat((specifier = (0, _formatSpecifierJsDefault.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
            return function(value) {
                return f(k * value) + prefix;
            };
        }
        return {
            format: newFormat,
            formatPrefix: formatPrefix
        };
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);
var _formatGroupJs = require("./formatGroup.js");
var _formatGroupJsDefault = parcelHelpers.interopDefault(_formatGroupJs);
var _formatNumeralsJs = require("./formatNumerals.js");
var _formatNumeralsJsDefault = parcelHelpers.interopDefault(_formatNumeralsJs);
var _formatSpecifierJs = require("./formatSpecifier.js");
var _formatSpecifierJsDefault = parcelHelpers.interopDefault(_formatSpecifierJs);
var _formatTrimJs = require("./formatTrim.js");
var _formatTrimJsDefault = parcelHelpers.interopDefault(_formatTrimJs);
var _formatTypesJs = require("./formatTypes.js");
var _formatTypesJsDefault = parcelHelpers.interopDefault(_formatTypesJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var map = Array.prototype.map, prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];

},{"./exponent.js":"fJf9w","./formatGroup.js":"bvZrb","./formatNumerals.js":"dcGnx","./formatSpecifier.js":"3qj60","./formatTrim.js":"9DMzq","./formatTypes.js":"dGa58","./formatPrefixAuto.js":"1cgxv","./identity.js":"1WA3h","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"fJf9w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x = (0, _formatDecimalJs.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
    });
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"3h4Vw","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3h4Vw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
    });
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
parcelHelpers.export(exports, "formatDecimalParts", ()=>formatDecimalParts);
function formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bvZrb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(grouping, thousands) {
        return function(value, width) {
            var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
            while(i > 0 && g > 0){
                if (length + g + 1 > width) g = Math.max(1, width - length);
                t.push(value.substring(i -= g, i + g));
                if ((length += g + 1) > width) break;
                g = grouping[j = (j + 1) % grouping.length];
            }
            return t.reverse().join(thousands);
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dcGnx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(numerals) {
        return function(value) {
            return value.replace(/[0-9]/g, function(i) {
                return numerals[+i];
            });
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3qj60":[function(require,module,exports,__globalThis) {
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatSpecifier);
parcelHelpers.export(exports, "FormatSpecifier", ()=>FormatSpecifier);
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
function FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"9DMzq":[function(require,module,exports,__globalThis) {
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(s) {
        out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
            case ".":
                i0 = i1 = i;
                break;
            case "0":
                if (i0 === 0) i0 = i;
                i1 = i;
                break;
            default:
                if (!+s[i]) break out;
                if (i0 > 0) i0 = 0;
                break;
        }
        return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dGa58":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formatDecimalJs = require("./formatDecimal.js");
var _formatDecimalJsDefault = parcelHelpers.interopDefault(_formatDecimalJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _formatPrefixAutoJsDefault = parcelHelpers.interopDefault(_formatPrefixAutoJs);
var _formatRoundedJs = require("./formatRounded.js");
var _formatRoundedJsDefault = parcelHelpers.interopDefault(_formatRoundedJs);
exports.default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, _formatDecimalJsDefault.default),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, _formatRoundedJsDefault.default)(x * 100, p),
    "r": (0, _formatRoundedJsDefault.default),
    "s": (0, _formatPrefixAutoJsDefault.default),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};

},{"./formatDecimal.js":"3h4Vw","./formatPrefixAuto.js":"1cgxv","./formatRounded.js":"3ri24","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"1cgxv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prefixExponent", ()=>prefixExponent);
parcelHelpers.export(exports, "default", ()=>function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1], i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
        return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, _formatDecimalJs.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
    });
var _formatDecimalJs = require("./formatDecimal.js");
var prefixExponent;

},{"./formatDecimal.js":"3h4Vw","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3ri24":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1];
        return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
    });
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"3h4Vw","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"1WA3h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"gjSQc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step) {
        return Math.max(0, -(0, _exponentJsDefault.default)(Math.abs(step)));
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"fJf9w","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"lOwiG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step, value) {
        return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3 - (0, _exponentJsDefault.default)(Math.abs(step)));
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"fJf9w","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hY5kM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step, max) {
        step = Math.abs(step), max = Math.abs(max) - step;
        return Math.max(0, (0, _exponentJsDefault.default)(max) - (0, _exponentJsDefault.default)(step)) + 1;
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"fJf9w","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4oydN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DATE", ()=>DATE);
parcelHelpers.export(exports, "DAY", ()=>DAY);
parcelHelpers.export(exports, "DAYOFYEAR", ()=>DAYOFYEAR);
parcelHelpers.export(exports, "HOURS", ()=>HOURS);
parcelHelpers.export(exports, "MILLISECONDS", ()=>MILLISECONDS);
parcelHelpers.export(exports, "MINUTES", ()=>MINUTES);
parcelHelpers.export(exports, "MONTH", ()=>MONTH);
parcelHelpers.export(exports, "QUARTER", ()=>QUARTER);
parcelHelpers.export(exports, "SECONDS", ()=>SECONDS);
parcelHelpers.export(exports, "TIME_UNITS", ()=>TIME_UNITS);
parcelHelpers.export(exports, "WEEK", ()=>WEEK);
parcelHelpers.export(exports, "YEAR", ()=>YEAR);
parcelHelpers.export(exports, "dayofyear", ()=>dayofyear);
parcelHelpers.export(exports, "timeBin", ()=>bin);
parcelHelpers.export(exports, "timeFloor", ()=>timeFloor);
parcelHelpers.export(exports, "timeInterval", ()=>timeInterval);
parcelHelpers.export(exports, "timeOffset", ()=>timeOffset);
parcelHelpers.export(exports, "timeSequence", ()=>timeSequence);
parcelHelpers.export(exports, "timeUnitSpecifier", ()=>timeUnitSpecifier);
parcelHelpers.export(exports, "timeUnits", ()=>timeUnits);
parcelHelpers.export(exports, "utcFloor", ()=>utcFloor);
parcelHelpers.export(exports, "utcInterval", ()=>utcInterval);
parcelHelpers.export(exports, "utcOffset", ()=>utcOffset);
parcelHelpers.export(exports, "utcSequence", ()=>utcSequence);
parcelHelpers.export(exports, "utcdayofyear", ()=>utcdayofyear);
parcelHelpers.export(exports, "utcweek", ()=>utcweek);
parcelHelpers.export(exports, "week", ()=>week);
var _vegaUtil = require("vega-util");
var _d3Time = require("d3-time");
var _d3Array = require("d3-array");
const YEAR = 'year';
const QUARTER = 'quarter';
const MONTH = 'month';
const WEEK = 'week';
const DATE = 'date';
const DAY = 'day';
const DAYOFYEAR = 'dayofyear';
const HOURS = 'hours';
const MINUTES = 'minutes';
const SECONDS = 'seconds';
const MILLISECONDS = 'milliseconds';
const TIME_UNITS = [
    YEAR,
    QUARTER,
    MONTH,
    WEEK,
    DATE,
    DAY,
    DAYOFYEAR,
    HOURS,
    MINUTES,
    SECONDS,
    MILLISECONDS
];
const UNITS = TIME_UNITS.reduce((o, u, i)=>(o[u] = 1 + i, o), {});
function timeUnits(units) {
    const u = (0, _vegaUtil.array)(units).slice(), m = {};
    // check validity
    if (!u.length) (0, _vegaUtil.error)('Missing time unit.');
    u.forEach((unit)=>{
        if ((0, _vegaUtil.hasOwnProperty)(UNITS, unit)) m[unit] = 1;
        else (0, _vegaUtil.error)(`Invalid time unit: ${unit}.`);
    });
    const numTypes = (m[WEEK] || m[DAY] ? 1 : 0) + (m[QUARTER] || m[MONTH] || m[DATE] ? 1 : 0) + (m[DAYOFYEAR] ? 1 : 0);
    if (numTypes > 1) (0, _vegaUtil.error)(`Incompatible time units: ${units}`);
    // ensure proper sort order
    u.sort((a, b)=>UNITS[a] - UNITS[b]);
    return u;
}
const defaultSpecifiers = {
    [YEAR]: '%Y ',
    [QUARTER]: 'Q%q ',
    [MONTH]: '%b ',
    [DATE]: '%d ',
    [WEEK]: 'W%U ',
    [DAY]: '%a ',
    [DAYOFYEAR]: '%j ',
    [HOURS]: '%H:00',
    [MINUTES]: '00:%M',
    [SECONDS]: ':%S',
    [MILLISECONDS]: '.%L',
    [`${YEAR}-${MONTH}`]: '%Y-%m ',
    [`${YEAR}-${MONTH}-${DATE}`]: '%Y-%m-%d ',
    [`${HOURS}-${MINUTES}`]: '%H:%M'
};
function timeUnitSpecifier(units, specifiers) {
    const s = (0, _vegaUtil.extend)({}, defaultSpecifiers, specifiers), u = timeUnits(units), n = u.length;
    let fmt = '', start = 0, end, key;
    for(start = 0; start < n;)for(end = u.length; end > start; --end){
        key = u.slice(start, end).join('-');
        if (s[key] != null) {
            fmt += s[key];
            start = end;
            break;
        }
    }
    return fmt.trim();
}
const t0 = new Date();
function localYear(y) {
    t0.setFullYear(y);
    t0.setMonth(0);
    t0.setDate(1);
    t0.setHours(0, 0, 0, 0);
    return t0;
}
function dayofyear(d) {
    return localDayOfYear(new Date(d));
}
function week(d) {
    return localWeekNum(new Date(d));
}
function localDayOfYear(d) {
    return (0, _d3Time.timeDay).count(localYear(d.getFullYear()) - 1, d);
}
function localWeekNum(d) {
    return (0, _d3Time.timeWeek).count(localYear(d.getFullYear()) - 1, d);
}
function localFirst(y) {
    return localYear(y).getDay();
}
function localDate(y, m, d, H, M, S, L) {
    if (0 <= y && y < 100) {
        const date = new Date(-1, m, d, H, M, S, L);
        date.setFullYear(y);
        return date;
    }
    return new Date(y, m, d, H, M, S, L);
}
function utcdayofyear(d) {
    return utcDayOfYear(new Date(d));
}
function utcweek(d) {
    return utcWeekNum(new Date(d));
}
function utcDayOfYear(d) {
    const y = Date.UTC(d.getUTCFullYear(), 0, 1);
    return (0, _d3Time.utcDay).count(y - 1, d);
}
function utcWeekNum(d) {
    const y = Date.UTC(d.getUTCFullYear(), 0, 1);
    return (0, _d3Time.utcWeek).count(y - 1, d);
}
function utcFirst(y) {
    t0.setTime(Date.UTC(y, 0, 1));
    return t0.getUTCDay();
}
function utcDate(y, m, d, H, M, S, L) {
    if (0 <= y && y < 100) {
        const date = new Date(Date.UTC(-1, m, d, H, M, S, L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(y, m, d, H, M, S, L));
}
function floor(units, step, get, inv, newDate) {
    const s = step || 1, b = (0, _vegaUtil.peek)(units), _ = (unit, p, key)=>{
        key = key || unit;
        return getUnit(get[key], inv[key], unit === b && s, p);
    };
    const t = new Date(), u = (0, _vegaUtil.toSet)(units), y = u[YEAR] ? _(YEAR) : (0, _vegaUtil.constant)(2012), m = u[MONTH] ? _(MONTH) : u[QUARTER] ? _(QUARTER) : (0, _vegaUtil.zero), d = u[WEEK] && u[DAY] ? _(DAY, 1, WEEK + DAY) : u[WEEK] ? _(WEEK, 1) : u[DAY] ? _(DAY, 1) : u[DATE] ? _(DATE, 1) : u[DAYOFYEAR] ? _(DAYOFYEAR, 1) : (0, _vegaUtil.one), H = u[HOURS] ? _(HOURS) : (0, _vegaUtil.zero), M = u[MINUTES] ? _(MINUTES) : (0, _vegaUtil.zero), S = u[SECONDS] ? _(SECONDS) : (0, _vegaUtil.zero), L = u[MILLISECONDS] ? _(MILLISECONDS) : (0, _vegaUtil.zero);
    return function(v) {
        t.setTime(+v);
        const year = y(t);
        return newDate(year, m(t), d(t, year), H(t), M(t), S(t), L(t));
    };
}
function getUnit(f, inv, step, phase) {
    const u = step <= 1 ? f : phase ? (d, y)=>phase + step * Math.floor((f(d, y) - phase) / step) : (d, y)=>step * Math.floor(f(d, y) / step);
    return inv ? (d, y)=>inv(u(d, y), y) : u;
}
// returns the day of the year based on week number, day of week,
// and the day of the week for the first day of the year
function weekday(week, day, firstDay) {
    return day + week * 7 - (firstDay + 6) % 7;
}
// -- LOCAL TIME --
const localGet = {
    [YEAR]: (d)=>d.getFullYear(),
    [QUARTER]: (d)=>Math.floor(d.getMonth() / 3),
    [MONTH]: (d)=>d.getMonth(),
    [DATE]: (d)=>d.getDate(),
    [HOURS]: (d)=>d.getHours(),
    [MINUTES]: (d)=>d.getMinutes(),
    [SECONDS]: (d)=>d.getSeconds(),
    [MILLISECONDS]: (d)=>d.getMilliseconds(),
    [DAYOFYEAR]: (d)=>localDayOfYear(d),
    [WEEK]: (d)=>localWeekNum(d),
    [WEEK + DAY]: (d, y)=>weekday(localWeekNum(d), d.getDay(), localFirst(y)),
    [DAY]: (d, y)=>weekday(1, d.getDay(), localFirst(y))
};
const localInv = {
    [QUARTER]: (q)=>3 * q,
    [WEEK]: (w, y)=>weekday(w, 0, localFirst(y))
};
function timeFloor(units, step) {
    return floor(units, step || 1, localGet, localInv, localDate);
}
// -- UTC TIME --
const utcGet = {
    [YEAR]: (d)=>d.getUTCFullYear(),
    [QUARTER]: (d)=>Math.floor(d.getUTCMonth() / 3),
    [MONTH]: (d)=>d.getUTCMonth(),
    [DATE]: (d)=>d.getUTCDate(),
    [HOURS]: (d)=>d.getUTCHours(),
    [MINUTES]: (d)=>d.getUTCMinutes(),
    [SECONDS]: (d)=>d.getUTCSeconds(),
    [MILLISECONDS]: (d)=>d.getUTCMilliseconds(),
    [DAYOFYEAR]: (d)=>utcDayOfYear(d),
    [WEEK]: (d)=>utcWeekNum(d),
    [DAY]: (d, y)=>weekday(1, d.getUTCDay(), utcFirst(y)),
    [WEEK + DAY]: (d, y)=>weekday(utcWeekNum(d), d.getUTCDay(), utcFirst(y))
};
const utcInv = {
    [QUARTER]: (q)=>3 * q,
    [WEEK]: (w, y)=>weekday(w, 0, utcFirst(y))
};
function utcFloor(units, step) {
    return floor(units, step || 1, utcGet, utcInv, utcDate);
}
const timeIntervals = {
    [YEAR]: (0, _d3Time.timeYear),
    [QUARTER]: (0, _d3Time.timeMonth).every(3),
    [MONTH]: (0, _d3Time.timeMonth),
    [WEEK]: (0, _d3Time.timeWeek),
    [DATE]: (0, _d3Time.timeDay),
    [DAY]: (0, _d3Time.timeDay),
    [DAYOFYEAR]: (0, _d3Time.timeDay),
    [HOURS]: (0, _d3Time.timeHour),
    [MINUTES]: (0, _d3Time.timeMinute),
    [SECONDS]: (0, _d3Time.timeSecond),
    [MILLISECONDS]: (0, _d3Time.timeMillisecond)
};
const utcIntervals = {
    [YEAR]: (0, _d3Time.utcYear),
    [QUARTER]: (0, _d3Time.utcMonth).every(3),
    [MONTH]: (0, _d3Time.utcMonth),
    [WEEK]: (0, _d3Time.utcWeek),
    [DATE]: (0, _d3Time.utcDay),
    [DAY]: (0, _d3Time.utcDay),
    [DAYOFYEAR]: (0, _d3Time.utcDay),
    [HOURS]: (0, _d3Time.utcHour),
    [MINUTES]: (0, _d3Time.utcMinute),
    [SECONDS]: (0, _d3Time.utcSecond),
    [MILLISECONDS]: (0, _d3Time.utcMillisecond)
};
function timeInterval(unit) {
    return timeIntervals[unit];
}
function utcInterval(unit) {
    return utcIntervals[unit];
}
function offset(ival, date, step) {
    return ival ? ival.offset(date, step) : undefined;
}
function timeOffset(unit, date, step) {
    return offset(timeInterval(unit), date, step);
}
function utcOffset(unit, date, step) {
    return offset(utcInterval(unit), date, step);
}
function sequence(ival, start, stop, step) {
    return ival ? ival.range(start, stop, step) : undefined;
}
function timeSequence(unit, start, stop, step) {
    return sequence(timeInterval(unit), start, stop, step);
}
function utcSequence(unit, start, stop, step) {
    return sequence(utcInterval(unit), start, stop, step);
}
const durationSecond = 1000, durationMinute = durationSecond * 60, durationHour = durationMinute * 60, durationDay = durationHour * 24, durationWeek = durationDay * 7, durationMonth = durationDay * 30, durationYear = durationDay * 365;
const Milli = [
    YEAR,
    MONTH,
    DATE,
    HOURS,
    MINUTES,
    SECONDS,
    MILLISECONDS
], Seconds = Milli.slice(0, -1), Minutes = Seconds.slice(0, -1), Hours = Minutes.slice(0, -1), Day = Hours.slice(0, -1), Week = [
    YEAR,
    WEEK
], Month = [
    YEAR,
    MONTH
], Year = [
    YEAR
];
const intervals = [
    [
        Seconds,
        1,
        durationSecond
    ],
    [
        Seconds,
        5,
        5 * durationSecond
    ],
    [
        Seconds,
        15,
        15 * durationSecond
    ],
    [
        Seconds,
        30,
        30 * durationSecond
    ],
    [
        Minutes,
        1,
        durationMinute
    ],
    [
        Minutes,
        5,
        5 * durationMinute
    ],
    [
        Minutes,
        15,
        15 * durationMinute
    ],
    [
        Minutes,
        30,
        30 * durationMinute
    ],
    [
        Hours,
        1,
        durationHour
    ],
    [
        Hours,
        3,
        3 * durationHour
    ],
    [
        Hours,
        6,
        6 * durationHour
    ],
    [
        Hours,
        12,
        12 * durationHour
    ],
    [
        Day,
        1,
        durationDay
    ],
    [
        Week,
        1,
        durationWeek
    ],
    [
        Month,
        1,
        durationMonth
    ],
    [
        Month,
        3,
        3 * durationMonth
    ],
    [
        Year,
        1,
        durationYear
    ]
];
function bin(opt) {
    const ext = opt.extent, max = opt.maxbins || 40, target = Math.abs((0, _vegaUtil.span)(ext)) / max;
    let i = (0, _d3Array.bisector)((i)=>i[2]).right(intervals, target), units, step;
    if (i === intervals.length) units = Year, step = (0, _d3Array.tickStep)(ext[0] / durationYear, ext[1] / durationYear, max);
    else if (i) {
        i = intervals[target / intervals[i - 1][2] < intervals[i][2] / target ? i - 1 : i];
        units = i[0];
        step = i[1];
    } else {
        units = Milli;
        step = Math.max((0, _d3Array.tickStep)(ext[0], ext[1], max), 1);
    }
    return {
        units,
        step
    };
}

},{"vega-util":"7f6sQ","d3-time":"9ROPD","d3-array":[["bisector","iWiWc","default"],["tickStep","4kdy4"]],"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"9ROPD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", ()=>(0, _intervalJs.timeInterval));
parcelHelpers.export(exports, "utcMillisecond", ()=>(0, _millisecondJs.millisecond));
parcelHelpers.export(exports, "utcMilliseconds", ()=>(0, _millisecondJs.milliseconds));
parcelHelpers.export(exports, "timeMillisecond", ()=>(0, _millisecondJs.millisecond));
parcelHelpers.export(exports, "timeMilliseconds", ()=>(0, _millisecondJs.milliseconds));
parcelHelpers.export(exports, "utcSecond", ()=>(0, _secondJs.second));
parcelHelpers.export(exports, "utcSeconds", ()=>(0, _secondJs.seconds));
parcelHelpers.export(exports, "timeSecond", ()=>(0, _secondJs.second));
parcelHelpers.export(exports, "timeSeconds", ()=>(0, _secondJs.seconds));
parcelHelpers.export(exports, "timeMinute", ()=>(0, _minuteJs.timeMinute));
parcelHelpers.export(exports, "timeMinutes", ()=>(0, _minuteJs.timeMinutes));
parcelHelpers.export(exports, "utcMinute", ()=>(0, _minuteJs.utcMinute));
parcelHelpers.export(exports, "utcMinutes", ()=>(0, _minuteJs.utcMinutes));
parcelHelpers.export(exports, "timeHour", ()=>(0, _hourJs.timeHour));
parcelHelpers.export(exports, "timeHours", ()=>(0, _hourJs.timeHours));
parcelHelpers.export(exports, "utcHour", ()=>(0, _hourJs.utcHour));
parcelHelpers.export(exports, "utcHours", ()=>(0, _hourJs.utcHours));
parcelHelpers.export(exports, "timeDay", ()=>(0, _dayJs.timeDay));
parcelHelpers.export(exports, "timeDays", ()=>(0, _dayJs.timeDays));
parcelHelpers.export(exports, "utcDay", ()=>(0, _dayJs.utcDay));
parcelHelpers.export(exports, "utcDays", ()=>(0, _dayJs.utcDays));
parcelHelpers.export(exports, "unixDay", ()=>(0, _dayJs.unixDay));
parcelHelpers.export(exports, "unixDays", ()=>(0, _dayJs.unixDays));
parcelHelpers.export(exports, "timeWeek", ()=>(0, _weekJs.timeSunday));
parcelHelpers.export(exports, "timeWeeks", ()=>(0, _weekJs.timeSundays));
parcelHelpers.export(exports, "timeSunday", ()=>(0, _weekJs.timeSunday));
parcelHelpers.export(exports, "timeSundays", ()=>(0, _weekJs.timeSundays));
parcelHelpers.export(exports, "timeMonday", ()=>(0, _weekJs.timeMonday));
parcelHelpers.export(exports, "timeMondays", ()=>(0, _weekJs.timeMondays));
parcelHelpers.export(exports, "timeTuesday", ()=>(0, _weekJs.timeTuesday));
parcelHelpers.export(exports, "timeTuesdays", ()=>(0, _weekJs.timeTuesdays));
parcelHelpers.export(exports, "timeWednesday", ()=>(0, _weekJs.timeWednesday));
parcelHelpers.export(exports, "timeWednesdays", ()=>(0, _weekJs.timeWednesdays));
parcelHelpers.export(exports, "timeThursday", ()=>(0, _weekJs.timeThursday));
parcelHelpers.export(exports, "timeThursdays", ()=>(0, _weekJs.timeThursdays));
parcelHelpers.export(exports, "timeFriday", ()=>(0, _weekJs.timeFriday));
parcelHelpers.export(exports, "timeFridays", ()=>(0, _weekJs.timeFridays));
parcelHelpers.export(exports, "timeSaturday", ()=>(0, _weekJs.timeSaturday));
parcelHelpers.export(exports, "timeSaturdays", ()=>(0, _weekJs.timeSaturdays));
parcelHelpers.export(exports, "utcWeek", ()=>(0, _weekJs.utcSunday));
parcelHelpers.export(exports, "utcWeeks", ()=>(0, _weekJs.utcSundays));
parcelHelpers.export(exports, "utcSunday", ()=>(0, _weekJs.utcSunday));
parcelHelpers.export(exports, "utcSundays", ()=>(0, _weekJs.utcSundays));
parcelHelpers.export(exports, "utcMonday", ()=>(0, _weekJs.utcMonday));
parcelHelpers.export(exports, "utcMondays", ()=>(0, _weekJs.utcMondays));
parcelHelpers.export(exports, "utcTuesday", ()=>(0, _weekJs.utcTuesday));
parcelHelpers.export(exports, "utcTuesdays", ()=>(0, _weekJs.utcTuesdays));
parcelHelpers.export(exports, "utcWednesday", ()=>(0, _weekJs.utcWednesday));
parcelHelpers.export(exports, "utcWednesdays", ()=>(0, _weekJs.utcWednesdays));
parcelHelpers.export(exports, "utcThursday", ()=>(0, _weekJs.utcThursday));
parcelHelpers.export(exports, "utcThursdays", ()=>(0, _weekJs.utcThursdays));
parcelHelpers.export(exports, "utcFriday", ()=>(0, _weekJs.utcFriday));
parcelHelpers.export(exports, "utcFridays", ()=>(0, _weekJs.utcFridays));
parcelHelpers.export(exports, "utcSaturday", ()=>(0, _weekJs.utcSaturday));
parcelHelpers.export(exports, "utcSaturdays", ()=>(0, _weekJs.utcSaturdays));
parcelHelpers.export(exports, "timeMonth", ()=>(0, _monthJs.timeMonth));
parcelHelpers.export(exports, "timeMonths", ()=>(0, _monthJs.timeMonths));
parcelHelpers.export(exports, "utcMonth", ()=>(0, _monthJs.utcMonth));
parcelHelpers.export(exports, "utcMonths", ()=>(0, _monthJs.utcMonths));
parcelHelpers.export(exports, "timeYear", ()=>(0, _yearJs.timeYear));
parcelHelpers.export(exports, "timeYears", ()=>(0, _yearJs.timeYears));
parcelHelpers.export(exports, "utcYear", ()=>(0, _yearJs.utcYear));
parcelHelpers.export(exports, "utcYears", ()=>(0, _yearJs.utcYears));
parcelHelpers.export(exports, "utcTicks", ()=>(0, _ticksJs.utcTicks));
parcelHelpers.export(exports, "utcTickInterval", ()=>(0, _ticksJs.utcTickInterval));
parcelHelpers.export(exports, "timeTicks", ()=>(0, _ticksJs.timeTicks));
parcelHelpers.export(exports, "timeTickInterval", ()=>(0, _ticksJs.timeTickInterval));
var _intervalJs = require("./interval.js");
var _millisecondJs = require("./millisecond.js");
var _secondJs = require("./second.js");
var _minuteJs = require("./minute.js");
var _hourJs = require("./hour.js");
var _dayJs = require("./day.js");
var _weekJs = require("./week.js");
var _monthJs = require("./month.js");
var _yearJs = require("./year.js");
var _ticksJs = require("./ticks.js");

},{"./interval.js":false,"./millisecond.js":"96mAf","./second.js":"XB3bI","./minute.js":"bqyaU","./hour.js":"4qZO3","./day.js":"70mfq","./week.js":"fqawv","./month.js":"bhkgy","./year.js":"inl21","./ticks.js":"ff5J3","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cB4gK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", ()=>timeInterval);
const t0 = new Date, t1 = new Date;
function timeInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = (date)=>{
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = (date)=>{
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = (date)=>{
        const d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = (date, step)=>{
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = (start, stop, step)=>{
        const range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        let previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = (test)=>{
        return timeInterval((date)=>{
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, (date, step)=>{
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = (start, end)=>{
            t0.setTime(+start), t1.setTime(+end);
            floori(t0), floori(t1);
            return Math.floor(count(t0, t1));
        };
        interval.every = (step)=>{
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
        };
    }
    return interval;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"96mAf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "millisecond", ()=>millisecond);
parcelHelpers.export(exports, "milliseconds", ()=>milliseconds);
var _intervalJs = require("./interval.js");
const millisecond = (0, _intervalJs.timeInterval)(()=>{
// noop
}, (date, step)=>{
    date.setTime(+date + step);
}, (start, end)=>{
    return end - start;
});
// An optimized implementation for this simple case.
millisecond.every = (k)=>{
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return millisecond;
    return (0, _intervalJs.timeInterval)((date)=>{
        date.setTime(Math.floor(date / k) * k);
    }, (date, step)=>{
        date.setTime(+date + step * k);
    }, (start, end)=>{
        return (end - start) / k;
    });
};
const milliseconds = millisecond.range;

},{"./interval.js":"cB4gK","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"XB3bI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "second", ()=>second);
parcelHelpers.export(exports, "seconds", ()=>seconds);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
const second = (0, _intervalJs.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds());
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationSecond));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationSecond);
}, (date)=>{
    return date.getUTCSeconds();
});
const seconds = second.range;

},{"./interval.js":"cB4gK","./duration.js":"vOgrf","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"vOgrf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "durationSecond", ()=>durationSecond);
parcelHelpers.export(exports, "durationMinute", ()=>durationMinute);
parcelHelpers.export(exports, "durationHour", ()=>durationHour);
parcelHelpers.export(exports, "durationDay", ()=>durationDay);
parcelHelpers.export(exports, "durationWeek", ()=>durationWeek);
parcelHelpers.export(exports, "durationMonth", ()=>durationMonth);
parcelHelpers.export(exports, "durationYear", ()=>durationYear);
const durationSecond = 1000;
const durationMinute = durationSecond * 60;
const durationHour = durationMinute * 60;
const durationDay = durationHour * 24;
const durationWeek = durationDay * 7;
const durationMonth = durationDay * 30;
const durationYear = durationDay * 365;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bqyaU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeMinute", ()=>timeMinute);
parcelHelpers.export(exports, "timeMinutes", ()=>timeMinutes);
parcelHelpers.export(exports, "utcMinute", ()=>utcMinute);
parcelHelpers.export(exports, "utcMinutes", ()=>utcMinutes);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
const timeMinute = (0, _intervalJs.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond));
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationMinute);
}, (date)=>{
    return date.getMinutes();
});
const timeMinutes = timeMinute.range;
const utcMinute = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCSeconds(0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationMinute);
}, (date)=>{
    return date.getUTCMinutes();
});
const utcMinutes = utcMinute.range;

},{"./interval.js":"cB4gK","./duration.js":"vOgrf","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4qZO3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeHour", ()=>timeHour);
parcelHelpers.export(exports, "timeHours", ()=>timeHours);
parcelHelpers.export(exports, "utcHour", ()=>utcHour);
parcelHelpers.export(exports, "utcHours", ()=>utcHours);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
const timeHour = (0, _intervalJs.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond) - date.getMinutes() * (0, _durationJs.durationMinute));
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationHour);
}, (date)=>{
    return date.getHours();
});
const timeHours = timeHour.range;
const utcHour = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCMinutes(0, 0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationHour);
}, (date)=>{
    return date.getUTCHours();
});
const utcHours = utcHour.range;

},{"./interval.js":"cB4gK","./duration.js":"vOgrf","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"70mfq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeDay", ()=>timeDay);
parcelHelpers.export(exports, "timeDays", ()=>timeDays);
parcelHelpers.export(exports, "utcDay", ()=>utcDay);
parcelHelpers.export(exports, "utcDays", ()=>utcDays);
parcelHelpers.export(exports, "unixDay", ()=>unixDay);
parcelHelpers.export(exports, "unixDays", ()=>unixDays);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
const timeDay = (0, _intervalJs.timeInterval)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationDay), (date)=>date.getDate() - 1);
const timeDays = timeDay.range;
const utcDay = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationDay);
}, (date)=>{
    return date.getUTCDate() - 1;
});
const utcDays = utcDay.range;
const unixDay = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationDay);
}, (date)=>{
    return Math.floor(date / (0, _durationJs.durationDay));
});
const unixDays = unixDay.range;

},{"./interval.js":"cB4gK","./duration.js":"vOgrf","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"fqawv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeSunday", ()=>timeSunday);
parcelHelpers.export(exports, "timeMonday", ()=>timeMonday);
parcelHelpers.export(exports, "timeTuesday", ()=>timeTuesday);
parcelHelpers.export(exports, "timeWednesday", ()=>timeWednesday);
parcelHelpers.export(exports, "timeThursday", ()=>timeThursday);
parcelHelpers.export(exports, "timeFriday", ()=>timeFriday);
parcelHelpers.export(exports, "timeSaturday", ()=>timeSaturday);
parcelHelpers.export(exports, "timeSundays", ()=>timeSundays);
parcelHelpers.export(exports, "timeMondays", ()=>timeMondays);
parcelHelpers.export(exports, "timeTuesdays", ()=>timeTuesdays);
parcelHelpers.export(exports, "timeWednesdays", ()=>timeWednesdays);
parcelHelpers.export(exports, "timeThursdays", ()=>timeThursdays);
parcelHelpers.export(exports, "timeFridays", ()=>timeFridays);
parcelHelpers.export(exports, "timeSaturdays", ()=>timeSaturdays);
parcelHelpers.export(exports, "utcSunday", ()=>utcSunday);
parcelHelpers.export(exports, "utcMonday", ()=>utcMonday);
parcelHelpers.export(exports, "utcTuesday", ()=>utcTuesday);
parcelHelpers.export(exports, "utcWednesday", ()=>utcWednesday);
parcelHelpers.export(exports, "utcThursday", ()=>utcThursday);
parcelHelpers.export(exports, "utcFriday", ()=>utcFriday);
parcelHelpers.export(exports, "utcSaturday", ()=>utcSaturday);
parcelHelpers.export(exports, "utcSundays", ()=>utcSundays);
parcelHelpers.export(exports, "utcMondays", ()=>utcMondays);
parcelHelpers.export(exports, "utcTuesdays", ()=>utcTuesdays);
parcelHelpers.export(exports, "utcWednesdays", ()=>utcWednesdays);
parcelHelpers.export(exports, "utcThursdays", ()=>utcThursdays);
parcelHelpers.export(exports, "utcFridays", ()=>utcFridays);
parcelHelpers.export(exports, "utcSaturdays", ()=>utcSaturdays);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
function timeWeekday(i) {
    return (0, _intervalJs.timeInterval)((date)=>{
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setDate(date.getDate() + step * 7);
    }, (start, end)=>{
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationWeek);
    });
}
const timeSunday = timeWeekday(0);
const timeMonday = timeWeekday(1);
const timeTuesday = timeWeekday(2);
const timeWednesday = timeWeekday(3);
const timeThursday = timeWeekday(4);
const timeFriday = timeWeekday(5);
const timeSaturday = timeWeekday(6);
const timeSundays = timeSunday.range;
const timeMondays = timeMonday.range;
const timeTuesdays = timeTuesday.range;
const timeWednesdays = timeWednesday.range;
const timeThursdays = timeThursday.range;
const timeFridays = timeFriday.range;
const timeSaturdays = timeSaturday.range;
function utcWeekday(i) {
    return (0, _intervalJs.timeInterval)((date)=>{
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, (start, end)=>{
        return (end - start) / (0, _durationJs.durationWeek);
    });
}
const utcSunday = utcWeekday(0);
const utcMonday = utcWeekday(1);
const utcTuesday = utcWeekday(2);
const utcWednesday = utcWeekday(3);
const utcThursday = utcWeekday(4);
const utcFriday = utcWeekday(5);
const utcSaturday = utcWeekday(6);
const utcSundays = utcSunday.range;
const utcMondays = utcMonday.range;
const utcTuesdays = utcTuesday.range;
const utcWednesdays = utcWednesday.range;
const utcThursdays = utcThursday.range;
const utcFridays = utcFriday.range;
const utcSaturdays = utcSaturday.range;

},{"./interval.js":"cB4gK","./duration.js":"vOgrf","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bhkgy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeMonth", ()=>timeMonth);
parcelHelpers.export(exports, "timeMonths", ()=>timeMonths);
parcelHelpers.export(exports, "utcMonth", ()=>utcMonth);
parcelHelpers.export(exports, "utcMonths", ()=>utcMonths);
var _intervalJs = require("./interval.js");
const timeMonth = (0, _intervalJs.timeInterval)((date)=>{
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setMonth(date.getMonth() + step);
}, (start, end)=>{
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date)=>{
    return date.getMonth();
});
const timeMonths = timeMonth.range;
const utcMonth = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end)=>{
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date)=>{
    return date.getUTCMonth();
});
const utcMonths = utcMonth.range;

},{"./interval.js":"cB4gK","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"inl21":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeYear", ()=>timeYear);
parcelHelpers.export(exports, "timeYears", ()=>timeYears);
parcelHelpers.export(exports, "utcYear", ()=>utcYear);
parcelHelpers.export(exports, "utcYears", ()=>utcYears);
var _intervalJs = require("./interval.js");
const timeYear = (0, _intervalJs.timeInterval)((date)=>{
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setFullYear(date.getFullYear() + step);
}, (start, end)=>{
    return end.getFullYear() - start.getFullYear();
}, (date)=>{
    return date.getFullYear();
});
// An optimized implementation for this simple case.
timeYear.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJs.timeInterval)((date)=>{
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step * k);
    });
};
const timeYears = timeYear.range;
const utcYear = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end)=>{
    return end.getUTCFullYear() - start.getUTCFullYear();
}, (date)=>{
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
utcYear.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJs.timeInterval)((date)=>{
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
const utcYears = utcYear.range;

},{"./interval.js":"cB4gK","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"ff5J3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcTicks", ()=>utcTicks);
parcelHelpers.export(exports, "utcTickInterval", ()=>utcTickInterval);
parcelHelpers.export(exports, "timeTicks", ()=>timeTicks);
parcelHelpers.export(exports, "timeTickInterval", ()=>timeTickInterval);
var _d3Array = require("d3-array");
var _durationJs = require("./duration.js");
var _millisecondJs = require("./millisecond.js");
var _secondJs = require("./second.js");
var _minuteJs = require("./minute.js");
var _hourJs = require("./hour.js");
var _dayJs = require("./day.js");
var _weekJs = require("./week.js");
var _monthJs = require("./month.js");
var _yearJs = require("./year.js");
function ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, _secondJs.second),
            1,
            (0, _durationJs.durationSecond)
        ],
        [
            (0, _secondJs.second),
            5,
            5 * (0, _durationJs.durationSecond)
        ],
        [
            (0, _secondJs.second),
            15,
            15 * (0, _durationJs.durationSecond)
        ],
        [
            (0, _secondJs.second),
            30,
            30 * (0, _durationJs.durationSecond)
        ],
        [
            minute,
            1,
            (0, _durationJs.durationMinute)
        ],
        [
            minute,
            5,
            5 * (0, _durationJs.durationMinute)
        ],
        [
            minute,
            15,
            15 * (0, _durationJs.durationMinute)
        ],
        [
            minute,
            30,
            30 * (0, _durationJs.durationMinute)
        ],
        [
            hour,
            1,
            (0, _durationJs.durationHour)
        ],
        [
            hour,
            3,
            3 * (0, _durationJs.durationHour)
        ],
        [
            hour,
            6,
            6 * (0, _durationJs.durationHour)
        ],
        [
            hour,
            12,
            12 * (0, _durationJs.durationHour)
        ],
        [
            day,
            1,
            (0, _durationJs.durationDay)
        ],
        [
            day,
            2,
            2 * (0, _durationJs.durationDay)
        ],
        [
            week,
            1,
            (0, _durationJs.durationWeek)
        ],
        [
            month,
            1,
            (0, _durationJs.durationMonth)
        ],
        [
            month,
            3,
            3 * (0, _durationJs.durationMonth)
        ],
        [
            year,
            1,
            (0, _durationJs.durationYear)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, _d3Array.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, _d3Array.tickStep)(start / (0, _durationJs.durationYear), stop / (0, _durationJs.durationYear), count));
        if (i === 0) return (0, _millisecondJs.millisecond).every(Math.max((0, _d3Array.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [utcTicks, utcTickInterval] = ticker((0, _yearJs.utcYear), (0, _monthJs.utcMonth), (0, _weekJs.utcSunday), (0, _dayJs.unixDay), (0, _hourJs.utcHour), (0, _minuteJs.utcMinute));
const [timeTicks, timeTickInterval] = ticker((0, _yearJs.timeYear), (0, _monthJs.timeMonth), (0, _weekJs.timeSunday), (0, _dayJs.timeDay), (0, _hourJs.timeHour), (0, _minuteJs.timeMinute));

},{"d3-array":[["bisector","iWiWc","default"],["tickStep","4kdy4"]],"./duration.js":"vOgrf","./millisecond.js":"96mAf","./second.js":"XB3bI","./minute.js":"bqyaU","./hour.js":"4qZO3","./day.js":"70mfq","./week.js":"fqawv","./month.js":"bhkgy","./year.js":"inl21","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"iWiWc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bisector);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
function bisector(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, _ascendingJsDefault.default);
        compare2 = (d, x)=>(0, _ascendingJsDefault.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, _ascendingJsDefault.default) || f === (0, _descendingJsDefault.default) ? f : zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left,
        center,
        right
    };
}
function zero() {
    return 0;
}

},{"./ascending.js":"5oHFB","./descending.js":"b5z4b","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5oHFB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ascending);
function ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"b5z4b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>descending);
function descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"beqDu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeFormat", ()=>timeFormat);
parcelHelpers.export(exports, "timeParse", ()=>timeParse);
parcelHelpers.export(exports, "utcFormat", ()=>utcFormat);
parcelHelpers.export(exports, "utcParse", ()=>utcParse);
parcelHelpers.export(exports, "default", ()=>defaultLocale);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;
defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    timeFormat = locale.format;
    timeParse = locale.parse;
    utcFormat = locale.utcFormat;
    utcParse = locale.utcParse;
    return locale;
}

},{"./locale.js":"8jcCt","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8jcCt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatLocale);
var _d3Time = require("d3-time");
function localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": formatDayOfMonth,
        "e": formatDayOfMonth,
        "f": formatMicroseconds,
        "g": formatYearISO,
        "G": formatFullYearISO,
        "H": formatHour24,
        "I": formatHour12,
        "j": formatDayOfYear,
        "L": formatMilliseconds,
        "m": formatMonthNumber,
        "M": formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatSeconds,
        "u": formatWeekdayNumberMonday,
        "U": formatWeekNumberSunday,
        "V": formatWeekNumberISO,
        "w": formatWeekdayNumberSunday,
        "W": formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatYear,
        "Y": formatFullYear,
        "Z": formatZone,
        "%": formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": formatUTCDayOfMonth,
        "e": formatUTCDayOfMonth,
        "f": formatUTCMicroseconds,
        "g": formatUTCYearISO,
        "G": formatUTCFullYearISO,
        "H": formatUTCHour24,
        "I": formatUTCHour12,
        "j": formatUTCDayOfYear,
        "L": formatUTCMilliseconds,
        "m": formatUTCMonthNumber,
        "M": formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatUTCSeconds,
        "u": formatUTCWeekdayNumberMonday,
        "U": formatUTCWeekNumberSunday,
        "V": formatUTCWeekNumberISO,
        "w": formatUTCWeekdayNumberSunday,
        "W": formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatUTCYear,
        "Y": formatUTCFullYear,
        "Z": formatUTCZone,
        "%": formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": parseDayOfMonth,
        "e": parseDayOfMonth,
        "f": parseMicroseconds,
        "g": parseYear,
        "G": parseFullYear,
        "H": parseHour24,
        "I": parseHour24,
        "j": parseDayOfYear,
        "L": parseMilliseconds,
        "m": parseMonthNumber,
        "M": parseMinutes,
        "p": parsePeriod,
        "q": parseQuarter,
        "Q": parseUnixTimestamp,
        "s": parseUnixTimestampSeconds,
        "S": parseSeconds,
        "u": parseWeekdayNumberMonday,
        "U": parseWeekNumberSunday,
        "V": parseWeekNumberISO,
        "w": parseWeekdayNumberSunday,
        "W": parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": parseYear,
        "Y": parseFullYear,
        "Z": parseZone,
        "%": parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, _d3Time.utcMonday).ceil(week) : (0, _d3Time.utcMonday)(week);
                    week = (0, _d3Time.utcDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, _d3Time.timeMonday).ceil(week) : (0, _d3Time.timeMonday)(week);
                    week = (0, _d3Time.timeDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function requote(s) {
    return s.replace(requoteRe, "\\$&");
}
function formatRe(names) {
    return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function parseWeekdayNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
    var n = percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
    return pad(d.getDate(), p, 2);
}
function formatHour24(d, p) {
    return pad(d.getHours(), p, 2);
}
function formatHour12(d, p) {
    return pad(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
    return pad(1 + (0, _d3Time.timeDay).count((0, _d3Time.timeYear)(d), d), p, 3);
}
function formatMilliseconds(d, p) {
    return pad(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
    return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
    return pad(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
    return pad(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
    return pad(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
    return pad((0, _d3Time.timeSunday).count((0, _d3Time.timeYear)(d) - 1, d), p, 2);
}
function dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : (0, _d3Time.timeThursday).ceil(d);
}
function formatWeekNumberISO(d, p) {
    d = dISO(d);
    return pad((0, _d3Time.timeThursday).count((0, _d3Time.timeYear)(d), d) + ((0, _d3Time.timeYear)(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function formatWeekNumberMonday(d, p) {
    return pad((0, _d3Time.timeMonday).count((0, _d3Time.timeYear)(d) - 1, d), p, 2);
}
function formatYear(d, p) {
    return pad(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
    d = dISO(d);
    return pad(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : (0, _d3Time.timeThursday).ceil(d);
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
    return pad(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
    return pad(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
    return pad(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
    return pad(1 + (0, _d3Time.utcDay).count((0, _d3Time.utcYear)(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
    return pad(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
    return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
    return pad(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
    return pad(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
    return pad(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
    return pad((0, _d3Time.utcSunday).count((0, _d3Time.utcYear)(d) - 1, d), p, 2);
}
function UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : (0, _d3Time.utcThursday).ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
    d = UTCdISO(d);
    return pad((0, _d3Time.utcThursday).count((0, _d3Time.utcYear)(d), d) + ((0, _d3Time.utcYear)(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
    return pad((0, _d3Time.utcMonday).count((0, _d3Time.utcYear)(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
    d = UTCdISO(d);
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : (0, _d3Time.utcThursday).ceil(d);
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCZone() {
    return "+0000";
}
function formatLiteralPercent() {
    return "%";
}
function formatUnixTimestamp(d) {
    return +d;
}
function formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

},{"d3-time":[["timeDay","70mfq"],["utcDay","70mfq"],["timeMonday","fqawv"],["timeSunday","fqawv"],["timeThursday","fqawv"],["utcMonday","fqawv"],["utcSunday","fqawv"],["utcThursday","fqawv"],["timeYear","inl21"],["utcYear","inl21"]],"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5I5cd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "aggregate", ()=>Aggregate);
parcelHelpers.export(exports, "bin", ()=>Bin);
parcelHelpers.export(exports, "collect", ()=>Collect);
parcelHelpers.export(exports, "compare", ()=>Compare);
parcelHelpers.export(exports, "countpattern", ()=>CountPattern);
parcelHelpers.export(exports, "cross", ()=>Cross);
parcelHelpers.export(exports, "density", ()=>Density);
parcelHelpers.export(exports, "dotbin", ()=>DotBin);
parcelHelpers.export(exports, "expression", ()=>Expression);
parcelHelpers.export(exports, "extent", ()=>Extent);
parcelHelpers.export(exports, "facet", ()=>Facet);
parcelHelpers.export(exports, "field", ()=>Field);
parcelHelpers.export(exports, "filter", ()=>Filter);
parcelHelpers.export(exports, "flatten", ()=>Flatten);
parcelHelpers.export(exports, "fold", ()=>Fold);
parcelHelpers.export(exports, "formula", ()=>Formula);
parcelHelpers.export(exports, "generate", ()=>Generate);
parcelHelpers.export(exports, "impute", ()=>Impute);
parcelHelpers.export(exports, "joinaggregate", ()=>JoinAggregate);
parcelHelpers.export(exports, "kde", ()=>KDE);
parcelHelpers.export(exports, "key", ()=>Key);
parcelHelpers.export(exports, "load", ()=>Load);
parcelHelpers.export(exports, "lookup", ()=>Lookup);
parcelHelpers.export(exports, "multiextent", ()=>MultiExtent);
parcelHelpers.export(exports, "multivalues", ()=>MultiValues);
parcelHelpers.export(exports, "params", ()=>Params);
parcelHelpers.export(exports, "pivot", ()=>Pivot);
parcelHelpers.export(exports, "prefacet", ()=>PreFacet);
parcelHelpers.export(exports, "project", ()=>Project);
parcelHelpers.export(exports, "proxy", ()=>Proxy);
parcelHelpers.export(exports, "quantile", ()=>Quantile);
parcelHelpers.export(exports, "relay", ()=>Relay);
parcelHelpers.export(exports, "sample", ()=>Sample);
parcelHelpers.export(exports, "sequence", ()=>Sequence);
parcelHelpers.export(exports, "sieve", ()=>Sieve);
parcelHelpers.export(exports, "subflow", ()=>Subflow);
parcelHelpers.export(exports, "timeunit", ()=>TimeUnit);
parcelHelpers.export(exports, "tupleindex", ()=>TupleIndex);
parcelHelpers.export(exports, "values", ()=>Values);
parcelHelpers.export(exports, "window", ()=>Window);
var _vegaUtil = require("vega-util");
var _vegaDataflow = require("vega-dataflow");
var _vegaStatistics = require("vega-statistics");
var _d3Array = require("d3-array");
var _vegaTime = require("vega-time");
function multikey(f) {
    return (x)=>{
        const n = f.length;
        let i = 1, k = String(f[0](x));
        for(; i < n; ++i)k += '|' + f[i](x);
        return k;
    };
}
function groupkey(fields) {
    return !fields || !fields.length ? function() {
        return '';
    } : fields.length === 1 ? fields[0] : multikey(fields);
}
function measureName(op, field, as) {
    return as || op + (!field ? '' : '_' + field);
}
const noop = ()=>{};
const base_op = {
    init: noop,
    add: noop,
    rem: noop,
    idx: 0
};
const AggregateOps = {
    values: {
        init: (m)=>m.cell.store = true,
        value: (m)=>m.cell.data.values(),
        idx: -1
    },
    count: {
        value: (m)=>m.cell.num
    },
    __count__: {
        value: (m)=>m.missing + m.valid
    },
    missing: {
        value: (m)=>m.missing
    },
    valid: {
        value: (m)=>m.valid
    },
    sum: {
        init: (m)=>m.sum = 0,
        value: (m)=>m.valid ? m.sum : undefined,
        add: (m, v)=>m.sum += +v,
        rem: (m, v)=>m.sum -= v
    },
    product: {
        init: (m)=>m.product = 1,
        value: (m)=>m.valid ? m.product : undefined,
        add: (m, v)=>m.product *= v,
        rem: (m, v)=>m.product /= v
    },
    mean: {
        init: (m)=>m.mean = 0,
        value: (m)=>m.valid ? m.mean : undefined,
        add: (m, v)=>(m.mean_d = v - m.mean, m.mean += m.mean_d / m.valid),
        rem: (m, v)=>(m.mean_d = v - m.mean, m.mean -= m.valid ? m.mean_d / m.valid : m.mean)
    },
    average: {
        value: (m)=>m.valid ? m.mean : undefined,
        req: [
            'mean'
        ],
        idx: 1
    },
    variance: {
        init: (m)=>m.dev = 0,
        value: (m)=>m.valid > 1 ? m.dev / (m.valid - 1) : undefined,
        add: (m, v)=>m.dev += m.mean_d * (v - m.mean),
        rem: (m, v)=>m.dev -= m.mean_d * (v - m.mean),
        req: [
            'mean'
        ],
        idx: 1
    },
    variancep: {
        value: (m)=>m.valid > 1 ? m.dev / m.valid : undefined,
        req: [
            'variance'
        ],
        idx: 2
    },
    stdev: {
        value: (m)=>m.valid > 1 ? Math.sqrt(m.dev / (m.valid - 1)) : undefined,
        req: [
            'variance'
        ],
        idx: 2
    },
    stdevp: {
        value: (m)=>m.valid > 1 ? Math.sqrt(m.dev / m.valid) : undefined,
        req: [
            'variance'
        ],
        idx: 2
    },
    stderr: {
        value: (m)=>m.valid > 1 ? Math.sqrt(m.dev / (m.valid * (m.valid - 1))) : undefined,
        req: [
            'variance'
        ],
        idx: 2
    },
    distinct: {
        value: (m)=>m.cell.data.distinct(m.get),
        req: [
            'values'
        ],
        idx: 3
    },
    ci0: {
        value: (m)=>m.cell.data.ci0(m.get),
        req: [
            'values'
        ],
        idx: 3
    },
    ci1: {
        value: (m)=>m.cell.data.ci1(m.get),
        req: [
            'values'
        ],
        idx: 3
    },
    median: {
        value: (m)=>m.cell.data.q2(m.get),
        req: [
            'values'
        ],
        idx: 3
    },
    q1: {
        value: (m)=>m.cell.data.q1(m.get),
        req: [
            'values'
        ],
        idx: 3
    },
    q3: {
        value: (m)=>m.cell.data.q3(m.get),
        req: [
            'values'
        ],
        idx: 3
    },
    min: {
        init: (m)=>m.min = undefined,
        value: (m)=>m.min = Number.isNaN(m.min) ? m.cell.data.min(m.get) : m.min,
        add: (m, v)=>{
            if (v < m.min || m.min === undefined) m.min = v;
        },
        rem: (m, v)=>{
            if (v <= m.min) m.min = NaN;
        },
        req: [
            'values'
        ],
        idx: 4
    },
    max: {
        init: (m)=>m.max = undefined,
        value: (m)=>m.max = Number.isNaN(m.max) ? m.cell.data.max(m.get) : m.max,
        add: (m, v)=>{
            if (v > m.max || m.max === undefined) m.max = v;
        },
        rem: (m, v)=>{
            if (v >= m.max) m.max = NaN;
        },
        req: [
            'values'
        ],
        idx: 4
    },
    argmin: {
        init: (m)=>m.argmin = undefined,
        value: (m)=>m.argmin || m.cell.data.argmin(m.get),
        add: (m, v, t)=>{
            if (v < m.min) m.argmin = t;
        },
        rem: (m, v)=>{
            if (v <= m.min) m.argmin = undefined;
        },
        req: [
            'min',
            'values'
        ],
        idx: 3
    },
    argmax: {
        init: (m)=>m.argmax = undefined,
        value: (m)=>m.argmax || m.cell.data.argmax(m.get),
        add: (m, v, t)=>{
            if (v > m.max) m.argmax = t;
        },
        rem: (m, v)=>{
            if (v >= m.max) m.argmax = undefined;
        },
        req: [
            'max',
            'values'
        ],
        idx: 3
    },
    exponential: {
        init: (m, r)=>{
            m.exp = 0;
            m.exp_r = r;
        },
        value: (m)=>m.valid ? m.exp * (1 - m.exp_r) / (1 - m.exp_r ** m.valid) : undefined,
        add: (m, v)=>m.exp = m.exp_r * m.exp + v,
        rem: (m, v)=>m.exp = (m.exp - v / m.exp_r ** (m.valid - 1)) / m.exp_r
    },
    exponentialb: {
        value: (m)=>m.valid ? m.exp * (1 - m.exp_r) : undefined,
        req: [
            'exponential'
        ],
        idx: 1
    }
};
const ValidAggregateOps = Object.keys(AggregateOps).filter((d)=>d !== '__count__');
function measure(key, value) {
    return (out, aggregate_param)=>(0, _vegaUtil.extend)({
            name: key,
            aggregate_param: aggregate_param,
            out: out || key
        }, base_op, value);
}
[
    ...ValidAggregateOps,
    '__count__'
].forEach((key)=>{
    AggregateOps[key] = measure(key, AggregateOps[key]);
});
function createMeasure(op, param, name) {
    return AggregateOps[op](name, param);
}
function compareIndex(a, b) {
    return a.idx - b.idx;
}
function resolve(agg) {
    const map = {};
    agg.forEach((a)=>map[a.name] = a);
    const getreqs = (a)=>{
        if (!a.req) return;
        a.req.forEach((key)=>{
            if (!map[key]) getreqs(map[key] = AggregateOps[key]());
        });
    };
    agg.forEach(getreqs);
    return Object.values(map).sort(compareIndex);
}
function init() {
    this.valid = 0;
    this.missing = 0;
    this._ops.forEach((op)=>op.aggregate_param == null ? op.init(this) : op.init(this, op.aggregate_param));
}
function add(v, t) {
    if (v == null || v === '') {
        ++this.missing;
        return;
    }
    if (v !== v) return;
    ++this.valid;
    this._ops.forEach((op)=>op.add(this, v, t));
}
function rem(v, t) {
    if (v == null || v === '') {
        --this.missing;
        return;
    }
    if (v !== v) return;
    --this.valid;
    this._ops.forEach((op)=>op.rem(this, v, t));
}
function set(t) {
    this._out.forEach((op)=>t[op.out] = op.value(this));
    return t;
}
function compileMeasures(agg, field) {
    const get = field || (0, _vegaUtil.identity), ops = resolve(agg), out = agg.slice().sort(compareIndex);
    function ctr(cell) {
        this._ops = ops;
        this._out = out;
        this.cell = cell;
        this.init();
    }
    ctr.prototype.init = init;
    ctr.prototype.add = add;
    ctr.prototype.rem = rem;
    ctr.prototype.set = set;
    ctr.prototype.get = get;
    ctr.fields = agg.map((op)=>op.out);
    return ctr;
}
function TupleStore(key) {
    this._key = key ? (0, _vegaUtil.field)(key) : (0, _vegaDataflow.tupleid);
    this.reset();
}
const prototype$1 = TupleStore.prototype;
prototype$1.reset = function() {
    this._add = [];
    this._rem = [];
    this._ext = null;
    this._get = null;
    this._q = null;
};
prototype$1.add = function(v) {
    this._add.push(v);
};
prototype$1.rem = function(v) {
    this._rem.push(v);
};
prototype$1.values = function() {
    this._get = null;
    if (this._rem.length === 0) return this._add;
    const a = this._add, r = this._rem, k = this._key, n = a.length, m = r.length, x = Array(n - m), map = {};
    let i, j, v;
    // use unique key field to clear removed values
    for(i = 0; i < m; ++i)map[k(r[i])] = 1;
    for(i = 0, j = 0; i < n; ++i)if (map[k(v = a[i])]) map[k(v)] = 0;
    else x[j++] = v;
    this._rem = [];
    return this._add = x;
};
// memoizing statistics methods
prototype$1.distinct = function(get) {
    const v = this.values(), map = {};
    let n = v.length, count = 0, s;
    while(--n >= 0){
        s = get(v[n]) + '';
        if (!(0, _vegaUtil.hasOwnProperty)(map, s)) {
            map[s] = 1;
            ++count;
        }
    }
    return count;
};
prototype$1.extent = function(get) {
    if (this._get !== get || !this._ext) {
        const v = this.values(), i = (0, _vegaUtil.extentIndex)(v, get);
        this._ext = [
            v[i[0]],
            v[i[1]]
        ];
        this._get = get;
    }
    return this._ext;
};
prototype$1.argmin = function(get) {
    return this.extent(get)[0] || {};
};
prototype$1.argmax = function(get) {
    return this.extent(get)[1] || {};
};
prototype$1.min = function(get) {
    const m = this.extent(get)[0];
    return m != null ? get(m) : undefined;
};
prototype$1.max = function(get) {
    const m = this.extent(get)[1];
    return m != null ? get(m) : undefined;
};
prototype$1.quartile = function(get) {
    if (this._get !== get || !this._q) {
        this._q = (0, _vegaStatistics.quartiles)(this.values(), get);
        this._get = get;
    }
    return this._q;
};
prototype$1.q1 = function(get) {
    return this.quartile(get)[0];
};
prototype$1.q2 = function(get) {
    return this.quartile(get)[1];
};
prototype$1.q3 = function(get) {
    return this.quartile(get)[2];
};
prototype$1.ci = function(get) {
    if (this._get !== get || !this._ci) {
        this._ci = (0, _vegaStatistics.bootstrapCI)(this.values(), 1000, 0.05, get);
        this._get = get;
    }
    return this._ci;
};
prototype$1.ci0 = function(get) {
    return this.ci(get)[0];
};
prototype$1.ci1 = function(get) {
    return this.ci(get)[1];
};
/**
 * Group-by aggregation operator.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors to groupby.
 * @param {Array<function(object): *>} [params.fields] - An array of accessors to aggregate.
 * @param {Array<string>} [params.ops] - An array of strings indicating aggregation operations.
 * @param {Array<number>} [params.aggregate_params] - An optional array of parameters for aggregation operations.
 * @param {Array<string>} [params.as] - An array of output field names for aggregated values.
 * @param {boolean} [params.cross=false] - A flag indicating that the full
 *   cross-product of groupby values should be generated, including empty cells.
 *   If true, the drop parameter is ignored and empty cells are retained.
 * @param {boolean} [params.drop=true] - A flag indicating if empty cells should be removed.
 */ function Aggregate(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
    this._adds = []; // array of added output tuples
    this._mods = []; // array of modified output tuples
    this._alen = 0; // number of active added tuples
    this._mlen = 0; // number of active modified tuples
    this._drop = true; // should empty aggregation cells be removed
    this._cross = false; // produce full cross-product of group-by values
    this._dims = []; // group-by dimension accessors
    this._dnames = []; // group-by dimension names
    this._measures = []; // collection of aggregation monoids
    this._countOnly = false; // flag indicating only count aggregation
    this._counts = null; // collection of count fields
    this._prev = null; // previous aggregation cells
    this._inputs = null; // array of dependent input tuple field names
    this._outputs = null; // array of output tuple field names
}
Aggregate.Definition = {
    'type': 'Aggregate',
    'metadata': {
        'generates': true,
        'changes': true
    },
    'params': [
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'ops',
            'type': 'enum',
            'array': true,
            'values': ValidAggregateOps
        },
        {
            'name': 'aggregate_params',
            'type': 'number',
            'null': true,
            'array': true
        },
        {
            'name': 'fields',
            'type': 'field',
            'null': true,
            'array': true
        },
        {
            'name': 'as',
            'type': 'string',
            'null': true,
            'array': true
        },
        {
            'name': 'drop',
            'type': 'boolean',
            'default': true
        },
        {
            'name': 'cross',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'key',
            'type': 'field'
        }
    ]
};
(0, _vegaUtil.inherits)(Aggregate, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const aggr = this, out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS), mod = _.modified();
        aggr.stamp = out.stamp;
        if (aggr.value && (mod || pulse.modified(aggr._inputs, true))) {
            aggr._prev = aggr.value;
            aggr.value = mod ? aggr.init(_) : Object.create(null);
            pulse.visit(pulse.SOURCE, (t)=>aggr.add(t));
        } else {
            aggr.value = aggr.value || aggr.init(_);
            pulse.visit(pulse.REM, (t)=>aggr.rem(t));
            pulse.visit(pulse.ADD, (t)=>aggr.add(t));
        }
        // Indicate output fields and return aggregate tuples.
        out.modifies(aggr._outputs);
        // Should empty cells be dropped?
        aggr._drop = _.drop !== false;
        // If domain cross-product requested, generate empty cells as needed
        // and ensure that empty cells are not dropped
        if (_.cross && aggr._dims.length > 1) {
            aggr._drop = false;
            aggr.cross();
        }
        if (pulse.clean() && aggr._drop) out.clean(true).runAfter(()=>this.clean());
        return aggr.changes(out);
    },
    cross () {
        const aggr = this, curr = aggr.value, dims = aggr._dnames, vals = dims.map(()=>({})), n = dims.length;
        // collect all group-by domain values
        function collect(cells) {
            let key, i, t, v;
            for(key in cells){
                t = cells[key].tuple;
                for(i = 0; i < n; ++i)vals[i][v = t[dims[i]]] = v;
            }
        }
        collect(aggr._prev);
        collect(curr);
        // iterate over key cross-product, create cells as needed
        function generate(base, tuple, index) {
            const name = dims[index], v = vals[index++];
            for(const k in v){
                const key = base ? base + '|' + k : k;
                tuple[name] = v[k];
                if (index < n) generate(key, tuple, index);
                else if (!curr[key]) aggr.cell(key, tuple);
            }
        }
        generate('', {}, 0);
    },
    init (_) {
        // initialize input and output fields
        const inputs = this._inputs = [], outputs = this._outputs = [], inputMap = {};
        function inputVisit(get) {
            const fields = (0, _vegaUtil.array)((0, _vegaUtil.accessorFields)(get)), n = fields.length;
            let i = 0, f;
            for(; i < n; ++i)if (!inputMap[f = fields[i]]) {
                inputMap[f] = 1;
                inputs.push(f);
            }
        }
        // initialize group-by dimensions
        this._dims = (0, _vegaUtil.array)(_.groupby);
        this._dnames = this._dims.map((d)=>{
            const dname = (0, _vegaUtil.accessorName)(d);
            inputVisit(d);
            outputs.push(dname);
            return dname;
        });
        this.cellkey = _.key ? _.key : groupkey(this._dims);
        // initialize aggregate measures
        this._countOnly = true;
        this._counts = [];
        this._measures = [];
        const fields = _.fields || [
            null
        ], ops = _.ops || [
            'count'
        ], aggregate_params = _.aggregate_params || [
            null
        ], as = _.as || [], n = fields.length, map = {};
        let field, op, aggregate_param, m, mname, outname, i;
        if (n !== ops.length) (0, _vegaUtil.error)('Unmatched number of fields and aggregate ops.');
        for(i = 0; i < n; ++i){
            field = fields[i];
            op = ops[i];
            aggregate_param = aggregate_params[i] || null;
            if (field == null && op !== 'count') (0, _vegaUtil.error)('Null aggregate field specified.');
            mname = (0, _vegaUtil.accessorName)(field);
            outname = measureName(op, mname, as[i]);
            outputs.push(outname);
            if (op === 'count') {
                this._counts.push(outname);
                continue;
            }
            m = map[mname];
            if (!m) {
                inputVisit(field);
                m = map[mname] = [];
                m.field = field;
                this._measures.push(m);
            }
            if (op !== 'count') this._countOnly = false;
            m.push(createMeasure(op, aggregate_param, outname));
        }
        this._measures = this._measures.map((m)=>compileMeasures(m, m.field));
        return Object.create(null); // aggregation cells (this.value)
    },
    // -- Cell Management -----
    cellkey: groupkey(),
    cell (key, t) {
        let cell = this.value[key];
        if (!cell) {
            cell = this.value[key] = this.newcell(key, t);
            this._adds[this._alen++] = cell;
        } else if (cell.num === 0 && this._drop && cell.stamp < this.stamp) {
            cell.stamp = this.stamp;
            this._adds[this._alen++] = cell;
        } else if (cell.stamp < this.stamp) {
            cell.stamp = this.stamp;
            this._mods[this._mlen++] = cell;
        }
        return cell;
    },
    newcell (key, t) {
        const cell = {
            key: key,
            num: 0,
            agg: null,
            tuple: this.newtuple(t, this._prev && this._prev[key]),
            stamp: this.stamp,
            store: false
        };
        if (!this._countOnly) {
            const measures = this._measures, n = measures.length;
            cell.agg = Array(n);
            for(let i = 0; i < n; ++i)cell.agg[i] = new measures[i](cell);
        }
        if (cell.store) cell.data = new TupleStore();
        return cell;
    },
    newtuple (t, p) {
        const names = this._dnames, dims = this._dims, n = dims.length, x = {};
        for(let i = 0; i < n; ++i)x[names[i]] = dims[i](t);
        return p ? (0, _vegaDataflow.replace)(p.tuple, x) : (0, _vegaDataflow.ingest)(x);
    },
    clean () {
        const cells = this.value;
        for(const key in cells)if (cells[key].num === 0) delete cells[key];
    },
    // -- Process Tuples -----
    add (t) {
        const key = this.cellkey(t), cell = this.cell(key, t);
        cell.num += 1;
        if (this._countOnly) return;
        if (cell.store) cell.data.add(t);
        const agg = cell.agg;
        for(let i = 0, n = agg.length; i < n; ++i)agg[i].add(agg[i].get(t), t);
    },
    rem (t) {
        const key = this.cellkey(t), cell = this.cell(key, t);
        cell.num -= 1;
        if (this._countOnly) return;
        if (cell.store) cell.data.rem(t);
        const agg = cell.agg;
        for(let i = 0, n = agg.length; i < n; ++i)agg[i].rem(agg[i].get(t), t);
    },
    celltuple (cell) {
        const tuple = cell.tuple, counts = this._counts;
        // consolidate stored values
        if (cell.store) cell.data.values();
        // update tuple properties
        for(let i = 0, n = counts.length; i < n; ++i)tuple[counts[i]] = cell.num;
        if (!this._countOnly) {
            const agg = cell.agg;
            for(let i = 0, n = agg.length; i < n; ++i)agg[i].set(tuple);
        }
        return tuple;
    },
    changes (out) {
        const adds = this._adds, mods = this._mods, prev = this._prev, drop = this._drop, add = out.add, rem = out.rem, mod = out.mod;
        let cell, key, i, n;
        if (prev) for(key in prev){
            cell = prev[key];
            if (!drop || cell.num) rem.push(cell.tuple);
        }
        for(i = 0, n = this._alen; i < n; ++i){
            add.push(this.celltuple(adds[i]));
            adds[i] = null; // for garbage collection
        }
        for(i = 0, n = this._mlen; i < n; ++i){
            cell = mods[i];
            (cell.num === 0 && drop ? rem : mod).push(this.celltuple(cell));
            mods[i] = null; // for garbage collection
        }
        this._alen = this._mlen = 0; // reset list of active cells
        this._prev = null;
        return out;
    }
});
// epsilon bias to offset floating point error (#1737)
const EPSILON$1 = 1e-14;
/**
 * Generates a binning function for discretizing data.
 * @constructor
 * @param {object} params - The parameters for this operator. The
 *   provided values should be valid options for the {@link bin} function.
 * @param {function(object): *} params.field - The data field to bin.
 */ function Bin(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Bin.Definition = {
    'type': 'Bin',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field',
            'required': true
        },
        {
            'name': 'interval',
            'type': 'boolean',
            'default': true
        },
        {
            'name': 'anchor',
            'type': 'number'
        },
        {
            'name': 'maxbins',
            'type': 'number',
            'default': 20
        },
        {
            'name': 'base',
            'type': 'number',
            'default': 10
        },
        {
            'name': 'divide',
            'type': 'number',
            'array': true,
            'default': [
                5,
                2
            ]
        },
        {
            'name': 'extent',
            'type': 'number',
            'array': true,
            'length': 2,
            'required': true
        },
        {
            'name': 'span',
            'type': 'number'
        },
        {
            'name': 'step',
            'type': 'number'
        },
        {
            'name': 'steps',
            'type': 'number',
            'array': true
        },
        {
            'name': 'minstep',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'nice',
            'type': 'boolean',
            'default': true
        },
        {
            'name': 'name',
            'type': 'string'
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': 2,
            'default': [
                'bin0',
                'bin1'
            ]
        }
    ]
};
(0, _vegaUtil.inherits)(Bin, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const band = _.interval !== false, bins = this._bins(_), start = bins.start, step = bins.step, as = _.as || [
            'bin0',
            'bin1'
        ], b0 = as[0], b1 = as[1];
        let flag;
        if (_.modified()) {
            pulse = pulse.reflow(true);
            flag = pulse.SOURCE;
        } else flag = pulse.modified((0, _vegaUtil.accessorFields)(_.field)) ? pulse.ADD_MOD : pulse.ADD;
        pulse.visit(flag, band ? (t)=>{
            const v = bins(t);
            // minimum bin value (inclusive)
            t[b0] = v;
            // maximum bin value (exclusive)
            // use convoluted math for better floating point agreement
            // see https://github.com/vega/vega/issues/830
            // infinite values propagate through this formula! #2227
            t[b1] = v == null ? null : start + step * (1 + (v - start) / step);
        } : (t)=>t[b0] = bins(t));
        return pulse.modifies(band ? as : b0);
    },
    _bins (_) {
        if (this.value && !_.modified()) return this.value;
        const field = _.field, bins = (0, _vegaStatistics.bin)(_), step = bins.step;
        let start = bins.start, stop = start + Math.ceil((bins.stop - start) / step) * step, a, d;
        if ((a = _.anchor) != null) {
            d = a - (start + step * Math.floor((a - start) / step));
            start += d;
            stop += d;
        }
        const f = function(t) {
            let v = (0, _vegaUtil.toNumber)(field(t));
            return v == null ? null : v < start ? -Infinity : v > stop ? Infinity : (v = Math.max(start, Math.min(v, stop - step)), start + step * Math.floor(EPSILON$1 + (v - start) / step));
        };
        f.start = start;
        f.stop = bins.stop;
        f.step = step;
        return this.value = (0, _vegaUtil.accessor)(f, (0, _vegaUtil.accessorFields)(field), _.name || 'bin_' + (0, _vegaUtil.accessorName)(field));
    }
});
function SortedList(idFunc, source, input) {
    const $ = idFunc;
    let data = source || [], add = input || [], rem = {}, cnt = 0;
    return {
        add: (t)=>add.push(t),
        remove: (t)=>rem[$(t)] = ++cnt,
        size: ()=>data.length,
        data: (compare, resort)=>{
            if (cnt) {
                data = data.filter((t)=>!rem[$(t)]);
                rem = {};
                cnt = 0;
            }
            if (resort && compare) data.sort(compare);
            if (add.length) {
                data = compare ? (0, _vegaUtil.merge)(compare, data, add.sort(compare)) : data.concat(add);
                add = [];
            }
            return data;
        }
    };
}
/**
 * Collects all data tuples that pass through this operator.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(*,*): number} [params.sort] - An optional
 *   comparator function for additionally sorting the collected tuples.
 */ function Collect(params) {
    (0, _vegaDataflow.Transform).call(this, [], params);
}
Collect.Definition = {
    'type': 'Collect',
    'metadata': {
        'source': true
    },
    'params': [
        {
            'name': 'sort',
            'type': 'compare'
        }
    ]
};
(0, _vegaUtil.inherits)(Collect, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.ALL), list = SortedList((0, _vegaDataflow.tupleid), this.value, out.materialize(out.ADD).add), sort = _.sort, mod = pulse.changed() || sort && (_.modified('sort') || pulse.modified(sort.fields));
        out.visit(out.REM, list.remove);
        this.modified(mod);
        this.value = out.source = list.data((0, _vegaDataflow.stableCompare)(sort), mod);
        // propagate tree root if defined
        if (pulse.source && pulse.source.root) this.value.root = pulse.source.root;
        return out;
    }
});
/**
 * Generates a comparator function.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<string|function>} params.fields - The fields to compare.
 * @param {Array<string>} [params.orders] - The sort orders.
 *   Each entry should be one of "ascending" (default) or "descending".
 */ function Compare(params) {
    (0, _vegaDataflow.Operator).call(this, null, update$5, params);
}
(0, _vegaUtil.inherits)(Compare, (0, _vegaDataflow.Operator));
function update$5(_) {
    return this.value && !_.modified() ? this.value : (0, _vegaUtil.compare)(_.fields, _.orders);
}
/**
 * Count regexp-defined pattern occurrences in a text field.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - An accessor for the text field.
 * @param {string} [params.pattern] - RegExp string defining the text pattern.
 * @param {string} [params.case] - One of 'lower', 'upper' or null (mixed) case.
 * @param {string} [params.stopwords] - RegExp string of words to ignore.
 */ function CountPattern(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
CountPattern.Definition = {
    'type': 'CountPattern',
    'metadata': {
        'generates': true,
        'changes': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field',
            'required': true
        },
        {
            'name': 'case',
            'type': 'enum',
            'values': [
                'upper',
                'lower',
                'mixed'
            ],
            'default': 'mixed'
        },
        {
            'name': 'pattern',
            'type': 'string',
            'default': '[\\w"]+'
        },
        {
            'name': 'stopwords',
            'type': 'string',
            'default': ''
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': 2,
            'default': [
                'text',
                'count'
            ]
        }
    ]
};
function tokenize(text, tcase, match) {
    switch(tcase){
        case 'upper':
            text = text.toUpperCase();
            break;
        case 'lower':
            text = text.toLowerCase();
            break;
    }
    return text.match(match);
}
(0, _vegaUtil.inherits)(CountPattern, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const process = (update)=>(tuple)=>{
                var tokens = tokenize(get(tuple), _.case, match) || [], t;
                for(var i = 0, n = tokens.length; i < n; ++i)if (!stop.test(t = tokens[i])) update(t);
            };
        const init = this._parameterCheck(_, pulse), counts = this._counts, match = this._match, stop = this._stop, get = _.field, as = _.as || [
            'text',
            'count'
        ], add = process((t)=>counts[t] = 1 + (counts[t] || 0)), rem = process((t)=>counts[t] -= 1);
        if (init) pulse.visit(pulse.SOURCE, add);
        else {
            pulse.visit(pulse.ADD, add);
            pulse.visit(pulse.REM, rem);
        }
        return this._finish(pulse, as); // generate output tuples
    },
    _parameterCheck (_, pulse) {
        let init = false;
        if (_.modified('stopwords') || !this._stop) {
            this._stop = new RegExp('^' + (_.stopwords || '') + '$', 'i');
            init = true;
        }
        if (_.modified('pattern') || !this._match) {
            this._match = new RegExp(_.pattern || '[\\w\']+', 'g');
            init = true;
        }
        if (_.modified('field') || pulse.modified(_.field.fields)) init = true;
        if (init) this._counts = {};
        return init;
    },
    _finish (pulse, as) {
        const counts = this._counts, tuples = this._tuples || (this._tuples = {}), text = as[0], count = as[1], out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
        let w, t, c;
        for(w in counts){
            t = tuples[w];
            c = counts[w] || 0;
            if (!t && c) {
                tuples[w] = t = (0, _vegaDataflow.ingest)({});
                t[text] = w;
                t[count] = c;
                out.add.push(t);
            } else if (c === 0) {
                if (t) out.rem.push(t);
                counts[w] = null;
                tuples[w] = null;
            } else if (t[count] !== c) {
                t[count] = c;
                out.mod.push(t);
            }
        }
        return out.modifies(as);
    }
});
/**
 * Perform a cross-product of a tuple stream with itself.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object):boolean} [params.filter] - An optional filter
 *   function for selectively including tuples in the cross product.
 * @param {Array<string>} [params.as] - The names of the output fields.
 */ function Cross(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Cross.Definition = {
    'type': 'Cross',
    'metadata': {
        'generates': true
    },
    'params': [
        {
            'name': 'filter',
            'type': 'expr'
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': 2,
            'default': [
                'a',
                'b'
            ]
        }
    ]
};
(0, _vegaUtil.inherits)(Cross, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.NO_SOURCE), as = _.as || [
            'a',
            'b'
        ], a = as[0], b = as[1], reset = !this.value || pulse.changed(pulse.ADD_REM) || _.modified('as') || _.modified('filter');
        let data = this.value;
        if (reset) {
            if (data) out.rem = data;
            data = pulse.materialize(pulse.SOURCE).source;
            out.add = this.value = cross(data, a, b, _.filter || (0, _vegaUtil.truthy));
        } else out.mod = data;
        out.source = this.value;
        return out.modifies(as);
    }
});
function cross(input, a, b, filter) {
    var data = [], t = {}, n = input.length, i = 0, j, left;
    for(; i < n; ++i){
        t[a] = left = input[i];
        for(j = 0; j < n; ++j){
            t[b] = input[j];
            if (filter(t)) {
                data.push((0, _vegaDataflow.ingest)(t));
                t = {};
                t[a] = left;
            }
        }
    }
    return data;
}
const Distributions = {
    kde: (0, _vegaStatistics.randomKDE),
    mixture: (0, _vegaStatistics.randomMixture),
    normal: (0, _vegaStatistics.randomNormal),
    lognormal: (0, _vegaStatistics.randomLogNormal),
    uniform: (0, _vegaStatistics.randomUniform)
};
const DISTRIBUTIONS = 'distributions', FUNCTION = 'function', FIELD = 'field';
/**
 * Parse a parameter object for a probability distribution.
 * @param {object} def - The distribution parameter object.
 * @param {function():Array<object>} - A method for requesting
 *   source data. Used for distributions (such as KDE) that
 *   require sample data points. This method will only be
 *   invoked if the 'from' parameter for a target data source
 *   is not provided. Typically this method returns backing
 *   source data for a Pulse object.
 * @return {object} - The output distribution object.
 */ function parse(def, data) {
    const func = def[FUNCTION];
    if (!(0, _vegaUtil.hasOwnProperty)(Distributions, func)) (0, _vegaUtil.error)('Unknown distribution function: ' + func);
    const d = Distributions[func]();
    for(const name in def){
        // if data field, extract values
        if (name === FIELD) d.data((def.from || data()).map(def[name]));
        else if (name === DISTRIBUTIONS) d[name](def[name].map((_)=>parse(_, data)));
        else if (typeof d[name] === FUNCTION) d[name](def[name]);
    }
    return d;
}
/**
 * Grid sample points for a probability density. Given a distribution and
 * a sampling extent, will generate points suitable for plotting either
 * PDF (probability density function) or CDF (cumulative distribution
 * function) curves.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {object} params.distribution - The probability distribution. This
 *   is an object parameter dependent on the distribution type.
 * @param {string} [params.method='pdf'] - The distribution method to sample.
 *   One of 'pdf' or 'cdf'.
 * @param {Array<number>} [params.extent] - The [min, max] extent over which
 *   to sample the distribution. This argument is required in most cases, but
 *   can be omitted if the distribution (e.g., 'kde') supports a 'data' method
 *   that returns numerical sample points from which the extent can be deduced.
 * @param {number} [params.minsteps=25] - The minimum number of curve samples
 *   for plotting the density.
 * @param {number} [params.maxsteps=200] - The maximum number of curve samples
 *   for plotting the density.
 * @param {number} [params.steps] - The exact number of curve samples for
 *   plotting the density. If specified, overrides both minsteps and maxsteps
 *   to set an exact number of uniform samples. Useful in conjunction with
 *   a fixed extent to ensure consistent sample points for stacked densities.
 */ function Density(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
const distributions = [
    {
        'key': {
            'function': 'normal'
        },
        'params': [
            {
                'name': 'mean',
                'type': 'number',
                'default': 0
            },
            {
                'name': 'stdev',
                'type': 'number',
                'default': 1
            }
        ]
    },
    {
        'key': {
            'function': 'lognormal'
        },
        'params': [
            {
                'name': 'mean',
                'type': 'number',
                'default': 0
            },
            {
                'name': 'stdev',
                'type': 'number',
                'default': 1
            }
        ]
    },
    {
        'key': {
            'function': 'uniform'
        },
        'params': [
            {
                'name': 'min',
                'type': 'number',
                'default': 0
            },
            {
                'name': 'max',
                'type': 'number',
                'default': 1
            }
        ]
    },
    {
        'key': {
            'function': 'kde'
        },
        'params': [
            {
                'name': 'field',
                'type': 'field',
                'required': true
            },
            {
                'name': 'from',
                'type': 'data'
            },
            {
                'name': 'bandwidth',
                'type': 'number',
                'default': 0
            }
        ]
    }
];
const mixture = {
    'key': {
        'function': 'mixture'
    },
    'params': [
        {
            'name': 'distributions',
            'type': 'param',
            'array': true,
            'params': distributions
        },
        {
            'name': 'weights',
            'type': 'number',
            'array': true
        }
    ]
};
Density.Definition = {
    'type': 'Density',
    'metadata': {
        'generates': true
    },
    'params': [
        {
            'name': 'extent',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'steps',
            'type': 'number'
        },
        {
            'name': 'minsteps',
            'type': 'number',
            'default': 25
        },
        {
            'name': 'maxsteps',
            'type': 'number',
            'default': 200
        },
        {
            'name': 'method',
            'type': 'string',
            'default': 'pdf',
            'values': [
                'pdf',
                'cdf'
            ]
        },
        {
            'name': 'distribution',
            'type': 'param',
            'params': distributions.concat(mixture)
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'default': [
                'value',
                'density'
            ]
        }
    ]
};
(0, _vegaUtil.inherits)(Density, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
        if (!this.value || pulse.changed() || _.modified()) {
            const dist = parse(_.distribution, source(pulse)), minsteps = _.steps || _.minsteps || 25, maxsteps = _.steps || _.maxsteps || 200;
            let method = _.method || 'pdf';
            if (method !== 'pdf' && method !== 'cdf') (0, _vegaUtil.error)('Invalid density method: ' + method);
            if (!_.extent && !dist.data) (0, _vegaUtil.error)('Missing density extent parameter.');
            method = dist[method];
            const as = _.as || [
                'value',
                'density'
            ], domain = _.extent || (0, _vegaUtil.extent)(dist.data()), values = (0, _vegaStatistics.sampleCurve)(method, domain, minsteps, maxsteps).map((v)=>{
                const tuple = {};
                tuple[as[0]] = v[0];
                tuple[as[1]] = v[1];
                return (0, _vegaDataflow.ingest)(tuple);
            });
            if (this.value) out.rem = this.value;
            this.value = out.add = out.source = values;
        }
        return out;
    }
});
function source(pulse) {
    return ()=>pulse.materialize(pulse.SOURCE).source;
}
// use either provided alias or accessor field name
function fieldNames(fields, as) {
    if (!fields) return null;
    return fields.map((f, i)=>as[i] || (0, _vegaUtil.accessorName)(f));
}
function partition$1(data, groupby, field) {
    const groups = [], get = (f)=>f(t);
    let map, i, n, t, k, g;
    // partition data points into groups
    if (groupby == null) groups.push(data.map(field));
    else for(map = {}, i = 0, n = data.length; i < n; ++i){
        t = data[i];
        k = groupby.map(get);
        g = map[k];
        if (!g) {
            map[k] = g = [];
            g.dims = k;
            groups.push(g);
        }
        g.push(field(t));
    }
    return groups;
}
const Output = 'bin';
/**
 * Dot density binning for dot plot construction.
 * Based on Leland Wilkinson, Dot Plots, The American Statistician, 1999.
 * https://www.cs.uic.edu/~wilkinson/Publications/dotplots.pdf
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The value field to bin.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors to groupby.
 * @param {number} [params.step] - The step size (bin width) within which dots should be
 *   stacked. Defaults to 1/30 of the extent of the data *field*.
 * @param {boolean} [params.smooth=false] - A boolean flag indicating if dot density
 *   stacks should be smoothed to reduce variance.
 */ function DotBin(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
DotBin.Definition = {
    'type': 'DotBin',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field',
            'required': true
        },
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'step',
            'type': 'number'
        },
        {
            'name': 'smooth',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'as',
            'type': 'string',
            'default': Output
        }
    ]
};
const autostep = (data, field)=>(0, _vegaUtil.span)((0, _vegaUtil.extent)(data, field)) / 30;
(0, _vegaUtil.inherits)(DotBin, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (this.value && !(_.modified() || pulse.changed())) return pulse; // early exit
        const source = pulse.materialize(pulse.SOURCE).source, groups = partition$1(pulse.source, _.groupby, (0, _vegaUtil.identity)), smooth = _.smooth || false, field = _.field, step = _.step || autostep(source, field), sort = (0, _vegaDataflow.stableCompare)((a, b)=>field(a) - field(b)), as = _.as || Output, n = groups.length;
        // compute dotplot bins per group
        let min = Infinity, max = -Infinity, i = 0, j;
        for(; i < n; ++i){
            const g = groups[i].sort(sort);
            j = -1;
            for (const v of (0, _vegaStatistics.dotbin)(g, step, smooth, field)){
                if (v < min) min = v;
                if (v > max) max = v;
                g[++j][as] = v;
            }
        }
        this.value = {
            start: min,
            stop: max,
            step: step
        };
        return pulse.reflow(true).modifies(as);
    }
});
/**
 * Wraps an expression function with access to external parameters.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function} params.expr - The expression function. The
 *  function should accept both a datum and a parameter object.
 *  This operator's value will be a new function that wraps the
 *  expression function with access to this operator's parameters.
 */ function Expression(params) {
    (0, _vegaDataflow.Operator).call(this, null, update$4, params);
    this.modified(true);
}
(0, _vegaUtil.inherits)(Expression, (0, _vegaDataflow.Operator));
function update$4(_) {
    const expr = _.expr;
    return this.value && !_.modified('expr') ? this.value : (0, _vegaUtil.accessor)((datum)=>expr(datum, _), (0, _vegaUtil.accessorFields)(expr), (0, _vegaUtil.accessorName)(expr));
}
/**
 * Computes extents (min/max) for a data field.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The field over which to compute extends.
 */ function Extent(params) {
    (0, _vegaDataflow.Transform).call(this, [
        undefined,
        undefined
    ], params);
}
Extent.Definition = {
    'type': 'Extent',
    'metadata': {},
    'params': [
        {
            'name': 'field',
            'type': 'field',
            'required': true
        }
    ]
};
(0, _vegaUtil.inherits)(Extent, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const extent = this.value, field = _.field, mod = pulse.changed() || pulse.modified(field.fields) || _.modified('field');
        let min = extent[0], max = extent[1];
        if (mod || min == null) {
            min = Infinity;
            max = -Infinity;
        }
        pulse.visit(mod ? pulse.SOURCE : pulse.ADD, (t)=>{
            const v = (0, _vegaUtil.toNumber)(field(t));
            if (v != null) {
                // NaNs will fail all comparisons!
                if (v < min) min = v;
                if (v > max) max = v;
            }
        });
        if (!Number.isFinite(min) || !Number.isFinite(max)) {
            let name = (0, _vegaUtil.accessorName)(field);
            if (name) name = ` for field "${name}"`;
            pulse.dataflow.warn(`Infinite extent${name}: [${min}, ${max}]`);
            min = max = undefined;
        }
        this.value = [
            min,
            max
        ];
    }
});
/**
 * Provides a bridge between a parent transform and a target subflow that
 * consumes only a subset of the tuples that pass through the parent.
 * @constructor
 * @param {Pulse} pulse - A pulse to use as the value of this operator.
 * @param {Transform} parent - The parent transform (typically a Facet instance).
 */ function Subflow(pulse, parent) {
    (0, _vegaDataflow.Operator).call(this, pulse);
    this.parent = parent;
    this.count = 0;
}
(0, _vegaUtil.inherits)(Subflow, (0, _vegaDataflow.Operator), {
    /**
   * Routes pulses from this subflow to a target transform.
   * @param {Transform} target - A transform that receives the subflow of tuples.
   */ connect (target) {
        this.detachSubflow = target.detachSubflow;
        this.targets().add(target);
        return target.source = this;
    },
    /**
   * Add an 'add' tuple to the subflow pulse.
   * @param {Tuple} t - The tuple being added.
   */ add (t) {
        this.count += 1;
        this.value.add.push(t);
    },
    /**
   * Add a 'rem' tuple to the subflow pulse.
   * @param {Tuple} t - The tuple being removed.
   */ rem (t) {
        this.count -= 1;
        this.value.rem.push(t);
    },
    /**
   * Add a 'mod' tuple to the subflow pulse.
   * @param {Tuple} t - The tuple being modified.
   */ mod (t) {
        this.value.mod.push(t);
    },
    /**
   * Re-initialize this operator's pulse value.
   * @param {Pulse} pulse - The pulse to copy from.
   * @see Pulse.init
   */ init (pulse) {
        this.value.init(pulse, pulse.NO_SOURCE);
    },
    /**
   * Evaluate this operator. This method overrides the
   * default behavior to simply return the contained pulse value.
   * @return {Pulse}
   */ evaluate () {
        // assert: this.value.stamp === pulse.stamp
        return this.value;
    }
});
/**
 * Facets a dataflow into a set of subflows based on a key.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(Dataflow, string): Operator} params.subflow - A function
 *   that generates a subflow of operators and returns its root operator.
 * @param {function(object): *} params.key - The key field to facet by.
 */ function Facet(params) {
    (0, _vegaDataflow.Transform).call(this, {}, params);
    this._keys = (0, _vegaUtil.fastmap)(); // cache previously calculated key values
    // keep track of active subflows, use as targets array for listeners
    // this allows us to limit propagation to only updated subflows
    const a = this._targets = [];
    a.active = 0;
    a.forEach = (f)=>{
        for(let i = 0, n = a.active; i < n; ++i)f(a[i], i, a);
    };
}
(0, _vegaUtil.inherits)(Facet, (0, _vegaDataflow.Transform), {
    activate (flow) {
        this._targets[this._targets.active++] = flow;
    },
    // parent argument provided by PreFacet subclass
    subflow (key, flow, pulse, parent) {
        const flows = this.value;
        let sf = (0, _vegaUtil.hasOwnProperty)(flows, key) && flows[key], df, p;
        if (!sf) {
            p = parent || (p = this._group[key]) && p.tuple;
            df = pulse.dataflow;
            sf = new Subflow(pulse.fork(pulse.NO_SOURCE), this);
            df.add(sf).connect(flow(df, key, p));
            flows[key] = sf;
            this.activate(sf);
        } else if (sf.value.stamp < pulse.stamp) {
            sf.init(pulse);
            this.activate(sf);
        }
        return sf;
    },
    clean () {
        const flows = this.value;
        let detached = 0;
        for(const key in flows)if (flows[key].count === 0) {
            const detach = flows[key].detachSubflow;
            if (detach) detach();
            delete flows[key];
            ++detached;
        }
        // remove inactive targets from the active targets array
        if (detached) {
            const active = this._targets.filter((sf)=>sf && sf.count > 0);
            this.initTargets(active);
        }
    },
    initTargets (act) {
        const a = this._targets, n = a.length, m = act ? act.length : 0;
        let i = 0;
        for(; i < m; ++i)a[i] = act[i];
        for(; i < n && a[i] != null; ++i)a[i] = null; // ensure old flows can be garbage collected
        a.active = m;
    },
    transform (_, pulse) {
        const df = pulse.dataflow, key = _.key, flow = _.subflow, cache = this._keys, rekey = _.modified('key'), subflow = (key)=>this.subflow(key, flow, pulse);
        this._group = _.group || {};
        this.initTargets(); // reset list of active subflows
        pulse.visit(pulse.REM, (t)=>{
            const id = (0, _vegaDataflow.tupleid)(t), k = cache.get(id);
            if (k !== undefined) {
                cache.delete(id);
                subflow(k).rem(t);
            }
        });
        pulse.visit(pulse.ADD, (t)=>{
            const k = key(t);
            cache.set((0, _vegaDataflow.tupleid)(t), k);
            subflow(k).add(t);
        });
        if (rekey || pulse.modified(key.fields)) pulse.visit(pulse.MOD, (t)=>{
            const id = (0, _vegaDataflow.tupleid)(t), k0 = cache.get(id), k1 = key(t);
            if (k0 === k1) subflow(k1).mod(t);
            else {
                cache.set(id, k1);
                subflow(k0).rem(t);
                subflow(k1).add(t);
            }
        });
        else if (pulse.changed(pulse.MOD)) pulse.visit(pulse.MOD, (t)=>{
            subflow(cache.get((0, _vegaDataflow.tupleid)(t))).mod(t);
        });
        if (rekey) pulse.visit(pulse.REFLOW, (t)=>{
            const id = (0, _vegaDataflow.tupleid)(t), k0 = cache.get(id), k1 = key(t);
            if (k0 !== k1) {
                cache.set(id, k1);
                subflow(k0).rem(t);
                subflow(k1).add(t);
            }
        });
        if (pulse.clean()) df.runAfter(()=>{
            this.clean();
            cache.clean();
        });
        else if (cache.empty > df.cleanThreshold) df.runAfter(cache.clean);
        return pulse;
    }
});
/**
 * Generates one or more field accessor functions.
 * If the 'name' parameter is an array, an array of field accessors
 * will be created and the 'as' parameter will be ignored.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {string} params.name - The field name(s) to access.
 * @param {string} params.as - The accessor function name.
 */ function Field(params) {
    (0, _vegaDataflow.Operator).call(this, null, update$3, params);
}
(0, _vegaUtil.inherits)(Field, (0, _vegaDataflow.Operator));
function update$3(_) {
    return this.value && !_.modified() ? this.value : (0, _vegaUtil.isArray)(_.name) ? (0, _vegaUtil.array)(_.name).map((f)=>(0, _vegaUtil.field)(f)) : (0, _vegaUtil.field)(_.name, _.as);
}
/**
 * Filters data tuples according to a predicate function.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.expr - The predicate expression function
 *   that determines a tuple's filter status. Truthy values pass the filter.
 */ function Filter(params) {
    (0, _vegaDataflow.Transform).call(this, (0, _vegaUtil.fastmap)(), params);
}
Filter.Definition = {
    'type': 'Filter',
    'metadata': {
        'changes': true
    },
    'params': [
        {
            'name': 'expr',
            'type': 'expr',
            'required': true
        }
    ]
};
(0, _vegaUtil.inherits)(Filter, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const df = pulse.dataflow, cache = this.value, // cache ids of filtered tuples
        output = pulse.fork(), add = output.add, rem = output.rem, mod = output.mod, test = _.expr;
        let isMod = true;
        pulse.visit(pulse.REM, (t)=>{
            const id = (0, _vegaDataflow.tupleid)(t);
            if (!cache.has(id)) rem.push(t);
            else cache.delete(id);
        });
        pulse.visit(pulse.ADD, (t)=>{
            if (test(t, _)) add.push(t);
            else cache.set((0, _vegaDataflow.tupleid)(t), 1);
        });
        function revisit(t) {
            const id = (0, _vegaDataflow.tupleid)(t), b = test(t, _), s = cache.get(id);
            if (b && s) {
                cache.delete(id);
                add.push(t);
            } else if (!b && !s) {
                cache.set(id, 1);
                rem.push(t);
            } else if (isMod && b && !s) mod.push(t);
        }
        pulse.visit(pulse.MOD, revisit);
        if (_.modified()) {
            isMod = false;
            pulse.visit(pulse.REFLOW, revisit);
        }
        if (cache.empty > df.cleanThreshold) df.runAfter(cache.clean);
        return output;
    }
});
/**
 * Flattens array-typed field values into new data objects.
 * If multiple fields are specified, they are treated as parallel arrays,
 * with output values included for each matching index (or null if missing).
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<function(object): *>} params.fields - An array of field
 *   accessors for the tuple fields that should be flattened.
 * @param {string} [params.index] - Optional output field name for index
 *   value. If unspecified, no index field is included in the output.
 * @param {Array<string>} [params.as] - Output field names for flattened
 *   array fields. Any unspecified fields will use the field name provided
 *   by the fields accessors.
 */ function Flatten(params) {
    (0, _vegaDataflow.Transform).call(this, [], params);
}
Flatten.Definition = {
    'type': 'Flatten',
    'metadata': {
        'generates': true
    },
    'params': [
        {
            'name': 'fields',
            'type': 'field',
            'array': true,
            'required': true
        },
        {
            'name': 'index',
            'type': 'string'
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true
        }
    ]
};
(0, _vegaUtil.inherits)(Flatten, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.NO_SOURCE), fields = _.fields, as = fieldNames(fields, _.as || []), index = _.index || null, m = as.length;
        // remove any previous results
        out.rem = this.value;
        // generate flattened tuples
        pulse.visit(pulse.SOURCE, (t)=>{
            const arrays = fields.map((f)=>f(t)), maxlen = arrays.reduce((l, a)=>Math.max(l, a.length), 0);
            let i = 0, j, d, v;
            for(; i < maxlen; ++i){
                d = (0, _vegaDataflow.derive)(t);
                for(j = 0; j < m; ++j)d[as[j]] = (v = arrays[j][i]) == null ? null : v;
                if (index) d[index] = i;
                out.add.push(d);
            }
        });
        this.value = out.source = out.add;
        if (index) out.modifies(index);
        return out.modifies(as);
    }
});
/**
 * Folds one more tuple fields into multiple tuples in which the field
 * name and values are available under new 'key' and 'value' fields.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.fields - An array of field accessors
 *   for the tuple fields that should be folded.
 * @param {Array<string>} [params.as] - Output field names for folded key
 *   and value fields, defaults to ['key', 'value'].
 */ function Fold(params) {
    (0, _vegaDataflow.Transform).call(this, [], params);
}
Fold.Definition = {
    'type': 'Fold',
    'metadata': {
        'generates': true
    },
    'params': [
        {
            'name': 'fields',
            'type': 'field',
            'array': true,
            'required': true
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': 2,
            'default': [
                'key',
                'value'
            ]
        }
    ]
};
(0, _vegaUtil.inherits)(Fold, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.NO_SOURCE), fields = _.fields, fnames = fields.map((0, _vegaUtil.accessorName)), as = _.as || [
            'key',
            'value'
        ], k = as[0], v = as[1], n = fields.length;
        out.rem = this.value;
        pulse.visit(pulse.SOURCE, (t)=>{
            for(let i = 0, d; i < n; ++i){
                d = (0, _vegaDataflow.derive)(t);
                d[k] = fnames[i];
                d[v] = fields[i](t);
                out.add.push(d);
            }
        });
        this.value = out.source = out.add;
        return out.modifies(as);
    }
});
/**
 * Invokes a function for each data tuple and saves the results as a new field.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.expr - The formula function to invoke for each tuple.
 * @param {string} params.as - The field name under which to save the result.
 * @param {boolean} [params.initonly=false] - If true, the formula is applied to
 *   added tuples only, and does not update in response to modifications.
 */ function Formula(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Formula.Definition = {
    'type': 'Formula',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'expr',
            'type': 'expr',
            'required': true
        },
        {
            'name': 'as',
            'type': 'string',
            'required': true
        },
        {
            'name': 'initonly',
            'type': 'boolean'
        }
    ]
};
(0, _vegaUtil.inherits)(Formula, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const func = _.expr, as = _.as, mod = _.modified(), flag = _.initonly ? pulse.ADD : mod ? pulse.SOURCE : pulse.modified(func.fields) || pulse.modified(as) ? pulse.ADD_MOD : pulse.ADD;
        if (mod) // parameters updated, need to reflow
        pulse = pulse.materialize().reflow(true);
        if (!_.initonly) pulse.modifies(as);
        return pulse.visit(flag, (t)=>t[as] = func(t, _));
    }
});
/**
 * Generates data tuples using a provided generator function.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(Parameters): object} params.generator - A tuple generator
 *   function. This function is given the operator parameters as input.
 *   Changes to any additional parameters will not trigger re-calculation
 *   of previously generated tuples. Only future tuples are affected.
 * @param {number} params.size - The number of tuples to produce.
 */ function Generate(params) {
    (0, _vegaDataflow.Transform).call(this, [], params);
}
(0, _vegaUtil.inherits)(Generate, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.ALL), gen = _.generator;
        let data = this.value, num = _.size - data.length, add, rem, t;
        if (num > 0) {
            // need more tuples, generate and add
            for(add = []; --num >= 0;){
                add.push(t = (0, _vegaDataflow.ingest)(gen(_)));
                data.push(t);
            }
            out.add = out.add.length ? out.materialize(out.ADD).add.concat(add) : add;
        } else {
            // need fewer tuples, remove
            rem = data.slice(0, -num);
            out.rem = out.rem.length ? out.materialize(out.REM).rem.concat(rem) : rem;
            data = data.slice(-num);
        }
        out.source = this.value = data;
        return out;
    }
});
const Methods = {
    value: 'value',
    median: (0, _d3Array.median),
    mean: (0, _d3Array.mean),
    min: (0, _d3Array.min),
    max: (0, _d3Array.max)
};
const Empty = [];
/**
 * Impute missing values.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The value field to impute.
 * @param {Array<function(object): *>} [params.groupby] - An array of
 *   accessors to determine series within which to perform imputation.
 * @param {function(object): *} params.key - An accessor for a key value.
 *   Each key value should be unique within a group. New tuples will be
 *   imputed for any key values that are not found within a group.
 * @param {Array<*>} [params.keyvals] - Optional array of required key
 *   values. New tuples will be imputed for any key values that are not
 *   found within a group. In addition, these values will be automatically
 *   augmented with the key values observed in the input data.
 * @param {string} [method='value'] - The imputation method to use. One of
 *   'value', 'mean', 'median', 'max', 'min'.
 * @param {*} [value=0] - The constant value to use for imputation
 *   when using method 'value'.
 */ function Impute(params) {
    (0, _vegaDataflow.Transform).call(this, [], params);
}
Impute.Definition = {
    'type': 'Impute',
    'metadata': {
        'changes': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field',
            'required': true
        },
        {
            'name': 'key',
            'type': 'field',
            'required': true
        },
        {
            'name': 'keyvals',
            'array': true
        },
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'method',
            'type': 'enum',
            'default': 'value',
            'values': [
                'value',
                'mean',
                'median',
                'max',
                'min'
            ]
        },
        {
            'name': 'value',
            'default': 0
        }
    ]
};
function getValue(_) {
    var m = _.method || Methods.value, v;
    if (Methods[m] == null) (0, _vegaUtil.error)('Unrecognized imputation method: ' + m);
    else if (m === Methods.value) {
        v = _.value !== undefined ? _.value : 0;
        return ()=>v;
    } else return Methods[m];
}
function getField(_) {
    const f = _.field;
    return (t)=>t ? f(t) : NaN;
}
(0, _vegaUtil.inherits)(Impute, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var out = pulse.fork(pulse.ALL), impute = getValue(_), field = getField(_), fName = (0, _vegaUtil.accessorName)(_.field), kName = (0, _vegaUtil.accessorName)(_.key), gNames = (_.groupby || []).map((0, _vegaUtil.accessorName)), groups = partition(pulse.source, _.groupby, _.key, _.keyvals), curr = [], prev = this.value, m = groups.domain.length, group, value, gVals, kVal, g, i, j, l, n, t;
        for(g = 0, l = groups.length; g < l; ++g){
            group = groups[g];
            gVals = group.values;
            value = NaN;
            // add tuples for missing values
            for(j = 0; j < m; ++j){
                if (group[j] != null) continue;
                kVal = groups.domain[j];
                t = {
                    _impute: true
                };
                for(i = 0, n = gVals.length; i < n; ++i)t[gNames[i]] = gVals[i];
                t[kName] = kVal;
                t[fName] = Number.isNaN(value) ? value = impute(group, field) : value;
                curr.push((0, _vegaDataflow.ingest)(t));
            }
        }
        // update pulse with imputed tuples
        if (curr.length) out.add = out.materialize(out.ADD).add.concat(curr);
        if (prev.length) out.rem = out.materialize(out.REM).rem.concat(prev);
        this.value = curr;
        return out;
    }
});
function partition(data, groupby, key, keyvals) {
    var get = (f)=>f(t), groups = [], domain = keyvals ? keyvals.slice() : [], kMap = {}, gMap = {}, gVals, gKey, group, i, j, k, n, t;
    domain.forEach((k, i)=>kMap[k] = i + 1);
    for(i = 0, n = data.length; i < n; ++i){
        t = data[i];
        k = key(t);
        j = kMap[k] || (kMap[k] = domain.push(k));
        gKey = (gVals = groupby ? groupby.map(get) : Empty) + '';
        if (!(group = gMap[gKey])) {
            group = gMap[gKey] = [];
            groups.push(group);
            group.values = gVals;
        }
        group[j - 1] = t;
    }
    groups.domain = domain;
    return groups;
}
/**
 * Extend input tuples with aggregate values.
 * Calcuates aggregate values and joins them with the input stream.
 * @constructor
 */ function JoinAggregate(params) {
    Aggregate.call(this, params);
}
JoinAggregate.Definition = {
    'type': 'JoinAggregate',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'fields',
            'type': 'field',
            'null': true,
            'array': true
        },
        {
            'name': 'ops',
            'type': 'enum',
            'array': true,
            'values': ValidAggregateOps
        },
        {
            'name': 'as',
            'type': 'string',
            'null': true,
            'array': true
        },
        {
            'name': 'key',
            'type': 'field'
        }
    ]
};
(0, _vegaUtil.inherits)(JoinAggregate, Aggregate, {
    transform (_, pulse) {
        const aggr = this, mod = _.modified();
        let cells;
        // process all input tuples to calculate aggregates
        if (aggr.value && (mod || pulse.modified(aggr._inputs, true))) {
            cells = aggr.value = mod ? aggr.init(_) : {};
            pulse.visit(pulse.SOURCE, (t)=>aggr.add(t));
        } else {
            cells = aggr.value = aggr.value || this.init(_);
            pulse.visit(pulse.REM, (t)=>aggr.rem(t));
            pulse.visit(pulse.ADD, (t)=>aggr.add(t));
        }
        // update aggregation cells
        aggr.changes();
        // write aggregate values to input tuples
        pulse.visit(pulse.SOURCE, (t)=>{
            (0, _vegaUtil.extend)(t, cells[aggr.cellkey(t)].tuple);
        });
        return pulse.reflow(mod).modifies(this._outputs);
    },
    changes () {
        const adds = this._adds, mods = this._mods;
        let i, n;
        for(i = 0, n = this._alen; i < n; ++i){
            this.celltuple(adds[i]);
            adds[i] = null; // for garbage collection
        }
        for(i = 0, n = this._mlen; i < n; ++i){
            this.celltuple(mods[i]);
            mods[i] = null; // for garbage collection
        }
        this._alen = this._mlen = 0; // reset list of active cells
    }
});
/**
 * Compute kernel density estimates (KDE) for one or more data groups.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors
 *   to groupby.
 * @param {function(object): *} params.field - An accessor for the data field
 *   to estimate.
 * @param {number} [params.bandwidth=0] - The KDE kernel bandwidth.
 *   If zero or unspecified, the bandwidth is automatically determined.
 * @param {boolean} [params.counts=false] - A boolean flag indicating if the
 *   output values should be probability estimates (false, default) or
 *   smoothed counts (true).
 * @param {string} [params.cumulative=false] - A boolean flag indicating if a
 *   density (false) or cumulative distribution (true) should be generated.
 * @param {Array<number>} [params.extent] - The domain extent over which to
 *   plot the density. If unspecified, the [min, max] data extent is used.
 * @param {string} [params.resolve='independent'] - Indicates how parameters for
 *   multiple densities should be resolved. If "independent" (the default), each
 *   density may have its own domain extent and dynamic number of curve sample
 *   steps. If "shared", the KDE transform will ensure that all densities are
 *   defined over a shared domain and curve steps, enabling stacking.
 * @param {number} [params.minsteps=25] - The minimum number of curve samples
 *   for plotting the density.
 * @param {number} [params.maxsteps=200] - The maximum number of curve samples
 *   for plotting the density.
 * @param {number} [params.steps] - The exact number of curve samples for
 *   plotting the density. If specified, overrides both minsteps and maxsteps
 *   to set an exact number of uniform samples. Useful in conjunction with
 *   a fixed extent to ensure consistent sample points for stacked densities.
 */ function KDE(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
KDE.Definition = {
    'type': 'KDE',
    'metadata': {
        'generates': true
    },
    'params': [
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'field',
            'type': 'field',
            'required': true
        },
        {
            'name': 'cumulative',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'counts',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'bandwidth',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'extent',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'resolve',
            'type': 'enum',
            'values': [
                'shared',
                'independent'
            ],
            'default': 'independent'
        },
        {
            'name': 'steps',
            'type': 'number'
        },
        {
            'name': 'minsteps',
            'type': 'number',
            'default': 25
        },
        {
            'name': 'maxsteps',
            'type': 'number',
            'default': 200
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'default': [
                'value',
                'density'
            ]
        }
    ]
};
(0, _vegaUtil.inherits)(KDE, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
        if (!this.value || pulse.changed() || _.modified()) {
            const source = pulse.materialize(pulse.SOURCE).source, groups = partition$1(source, _.groupby, _.field), names = (_.groupby || []).map((0, _vegaUtil.accessorName)), bandwidth = _.bandwidth, method = _.cumulative ? 'cdf' : 'pdf', as = _.as || [
                'value',
                'density'
            ], values = [];
            let domain = _.extent, minsteps = _.steps || _.minsteps || 25, maxsteps = _.steps || _.maxsteps || 200;
            if (method !== 'pdf' && method !== 'cdf') (0, _vegaUtil.error)('Invalid density method: ' + method);
            if (_.resolve === 'shared') {
                if (!domain) domain = (0, _vegaUtil.extent)(source, _.field);
                minsteps = maxsteps = _.steps || maxsteps;
            }
            groups.forEach((g)=>{
                const density = (0, _vegaStatistics.randomKDE)(g, bandwidth)[method], scale = _.counts ? g.length : 1, local = domain || (0, _vegaUtil.extent)(g);
                (0, _vegaStatistics.sampleCurve)(density, local, minsteps, maxsteps).forEach((v)=>{
                    const t = {};
                    for(let i = 0; i < names.length; ++i)t[names[i]] = g.dims[i];
                    t[as[0]] = v[0];
                    t[as[1]] = v[1] * scale;
                    values.push((0, _vegaDataflow.ingest)(t));
                });
            });
            if (this.value) out.rem = this.value;
            this.value = out.add = out.source = values;
        }
        return out;
    }
});
/**
 * Generates a key function.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<string>} params.fields - The field name(s) for the key function.
 * @param {boolean} params.flat - A boolean flag indicating if the field names
 *  should be treated as flat property names, side-stepping nested field
 *  lookups normally indicated by dot or bracket notation.
 */ function Key(params) {
    (0, _vegaDataflow.Operator).call(this, null, update$2, params);
}
(0, _vegaUtil.inherits)(Key, (0, _vegaDataflow.Operator));
function update$2(_) {
    return this.value && !_.modified() ? this.value : (0, _vegaUtil.key)(_.fields, _.flat);
}
/**
 * Load and parse data from an external source. Marshalls parameter
 * values and then invokes the Dataflow request method.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {string} params.url - The URL to load from.
 * @param {object} params.format - The data format options.
 */ function Load(params) {
    (0, _vegaDataflow.Transform).call(this, [], params);
    this._pending = null;
}
(0, _vegaUtil.inherits)(Load, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const df = pulse.dataflow;
        if (this._pending) // update state and return pulse
        return output(this, pulse, this._pending);
        if (stop(_)) return pulse.StopPropagation;
        if (_.values) // parse and ingest values, return output pulse
        return output(this, pulse, df.parse(_.values, _.format));
        else if (_.async) {
            // return promise for non-blocking async loading
            const p = df.request(_.url, _.format).then((res)=>{
                this._pending = (0, _vegaUtil.array)(res.data);
                return (df)=>df.touch(this);
            });
            return {
                async: p
            };
        } else // return promise for synchronous loading
        return df.request(_.url, _.format).then((res)=>output(this, pulse, (0, _vegaUtil.array)(res.data)));
    }
});
function stop(_) {
    return _.modified('async') && !(_.modified('values') || _.modified('url') || _.modified('format'));
}
function output(op, pulse, data) {
    data.forEach((0, _vegaDataflow.ingest));
    const out = pulse.fork(pulse.NO_FIELDS & pulse.NO_SOURCE);
    out.rem = op.value;
    op.value = out.source = out.add = data;
    op._pending = null;
    if (out.rem.length) out.clean(true);
    return out;
}
/**
 * Extend tuples by joining them with values from a lookup table.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Map} params.index - The lookup table map.
 * @param {Array<function(object): *} params.fields - The fields to lookup.
 * @param {Array<string>} params.as - Output field names for each lookup value.
 * @param {*} [params.default] - A default value to use if lookup fails.
 */ function Lookup(params) {
    (0, _vegaDataflow.Transform).call(this, {}, params);
}
Lookup.Definition = {
    'type': 'Lookup',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'index',
            'type': 'index',
            'params': [
                {
                    'name': 'from',
                    'type': 'data',
                    'required': true
                },
                {
                    'name': 'key',
                    'type': 'field',
                    'required': true
                }
            ]
        },
        {
            'name': 'values',
            'type': 'field',
            'array': true
        },
        {
            'name': 'fields',
            'type': 'field',
            'array': true,
            'required': true
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true
        },
        {
            'name': 'default',
            'default': null
        }
    ]
};
(0, _vegaUtil.inherits)(Lookup, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const keys = _.fields, index = _.index, values = _.values, defaultValue = _.default == null ? null : _.default, reset = _.modified(), n = keys.length;
        let flag = reset ? pulse.SOURCE : pulse.ADD, out = pulse, as = _.as, set, m, mods;
        if (values) {
            m = values.length;
            if (n > 1 && !as) (0, _vegaUtil.error)('Multi-field lookup requires explicit "as" parameter.');
            if (as && as.length !== n * m) (0, _vegaUtil.error)('The "as" parameter has too few output field names.');
            as = as || values.map((0, _vegaUtil.accessorName));
            set = function(t) {
                for(var i = 0, k = 0, j, v; i < n; ++i){
                    v = index.get(keys[i](t));
                    if (v == null) for(j = 0; j < m; ++j, ++k)t[as[k]] = defaultValue;
                    else for(j = 0; j < m; ++j, ++k)t[as[k]] = values[j](v);
                }
            };
        } else {
            if (!as) (0, _vegaUtil.error)('Missing output field names.');
            set = function(t) {
                for(var i = 0, v; i < n; ++i){
                    v = index.get(keys[i](t));
                    t[as[i]] = v == null ? defaultValue : v;
                }
            };
        }
        if (reset) out = pulse.reflow(true);
        else {
            mods = keys.some((k)=>pulse.modified(k.fields));
            flag |= mods ? pulse.MOD : 0;
        }
        pulse.visit(flag, set);
        return out.modifies(as);
    }
});
/**
 * Computes global min/max extents over a collection of extents.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<Array<number>>} params.extents - The input extents.
 */ function MultiExtent(params) {
    (0, _vegaDataflow.Operator).call(this, null, update$1, params);
}
(0, _vegaUtil.inherits)(MultiExtent, (0, _vegaDataflow.Operator));
function update$1(_) {
    if (this.value && !_.modified()) return this.value;
    const ext = _.extents, n = ext.length;
    let min = Infinity, max = -Infinity, i, e;
    for(i = 0; i < n; ++i){
        e = ext[i];
        if (e[0] < min) min = e[0];
        if (e[1] > max) max = e[1];
    }
    return [
        min,
        max
    ];
}
/**
 * Merge a collection of value arrays.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<Array<*>>} params.values - The input value arrrays.
 */ function MultiValues(params) {
    (0, _vegaDataflow.Operator).call(this, null, update, params);
}
(0, _vegaUtil.inherits)(MultiValues, (0, _vegaDataflow.Operator));
function update(_) {
    return this.value && !_.modified() ? this.value : _.values.reduce((data, _)=>data.concat(_), []);
}
/**
 * Operator whose value is simply its parameter hash. This operator is
 * useful for enabling reactive updates to values of nested objects.
 * @constructor
 * @param {object} params - The parameters for this operator.
 */ function Params(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
(0, _vegaUtil.inherits)(Params, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        this.modified(_.modified());
        this.value = _;
        return pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS); // do not pass tuples
    }
});
/**
 * Aggregate and pivot selected field values to become new fields.
 * This operator is useful to construction cross-tabulations.
 * @constructor
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors
 *  to groupby. These fields act just like groupby fields of an Aggregate transform.
 * @param {function(object): *} params.field - The field to pivot on. The unique
 *  values of this field become new field names in the output stream.
 * @param {function(object): *} params.value - The field to populate pivoted fields.
 *  The aggregate values of this field become the values of the new pivoted fields.
 * @param {string} [params.op] - The aggregation operation for the value field,
 *  applied per cell in the output stream. The default is "sum".
 * @param {number} [params.limit] - An optional parameter indicating the maximum
 *  number of pivoted fields to generate. The pivoted field names are sorted in
 *  ascending order prior to enforcing the limit.
 */ function Pivot(params) {
    Aggregate.call(this, params);
}
Pivot.Definition = {
    'type': 'Pivot',
    'metadata': {
        'generates': true,
        'changes': true
    },
    'params': [
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'field',
            'type': 'field',
            'required': true
        },
        {
            'name': 'value',
            'type': 'field',
            'required': true
        },
        {
            'name': 'op',
            'type': 'enum',
            'values': ValidAggregateOps,
            'default': 'sum'
        },
        {
            'name': 'limit',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'key',
            'type': 'field'
        }
    ]
};
(0, _vegaUtil.inherits)(Pivot, Aggregate, {
    _transform: Aggregate.prototype.transform,
    transform (_, pulse) {
        return this._transform(aggregateParams(_, pulse), pulse);
    }
});
// Shoehorn a pivot transform into an aggregate transform!
// First collect all unique pivot field values.
// Then generate aggregate fields for each output pivot field.
function aggregateParams(_, pulse) {
    const key = _.field, value = _.value, op = (_.op === 'count' ? '__count__' : _.op) || 'sum', fields = (0, _vegaUtil.accessorFields)(key).concat((0, _vegaUtil.accessorFields)(value)), keys = pivotKeys(key, _.limit || 0, pulse);
    // if data stream content changes, pivot fields may change
    // flag parameter modification to ensure re-initialization
    if (pulse.changed()) _.set('__pivot__', null, null, true);
    return {
        key: _.key,
        groupby: _.groupby,
        ops: keys.map(()=>op),
        fields: keys.map((k)=>get(k, key, value, fields)),
        as: keys.map((k)=>k + ''),
        modified: _.modified.bind(_)
    };
}
// Generate aggregate field accessor.
// Output NaN for non-existent values; aggregator will ignore!
function get(k, key, value, fields) {
    return (0, _vegaUtil.accessor)((d)=>key(d) === k ? value(d) : NaN, fields, k + '');
}
// Collect (and optionally limit) all unique pivot values.
function pivotKeys(key, limit, pulse) {
    const map = {}, list = [];
    pulse.visit(pulse.SOURCE, (t)=>{
        const k = key(t);
        if (!map[k]) {
            map[k] = 1;
            list.push(k);
        }
    });
    list.sort((0, _vegaUtil.ascending));
    return limit ? list.slice(0, limit) : list;
}
/**
 * Partitions pre-faceted data into tuple subflows.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(Dataflow, string): Operator} params.subflow - A function
 *   that generates a subflow of operators and returns its root operator.
 * @param {function(object): Array<object>} params.field - The field
 *   accessor for an array of subflow tuple objects.
 */ function PreFacet(params) {
    Facet.call(this, params);
}
(0, _vegaUtil.inherits)(PreFacet, Facet, {
    transform (_, pulse) {
        const flow = _.subflow, field = _.field, subflow = (t)=>this.subflow((0, _vegaDataflow.tupleid)(t), flow, pulse, t);
        if (_.modified('field') || field && pulse.modified((0, _vegaUtil.accessorFields)(field))) (0, _vegaUtil.error)('PreFacet does not support field modification.');
        this.initTargets(); // reset list of active subflows
        if (field) {
            pulse.visit(pulse.MOD, (t)=>{
                const sf = subflow(t);
                field(t).forEach((_)=>sf.mod(_));
            });
            pulse.visit(pulse.ADD, (t)=>{
                const sf = subflow(t);
                field(t).forEach((_)=>sf.add((0, _vegaDataflow.ingest)(_)));
            });
            pulse.visit(pulse.REM, (t)=>{
                const sf = subflow(t);
                field(t).forEach((_)=>sf.rem(_));
            });
        } else {
            pulse.visit(pulse.MOD, (t)=>subflow(t).mod(t));
            pulse.visit(pulse.ADD, (t)=>subflow(t).add(t));
            pulse.visit(pulse.REM, (t)=>subflow(t).rem(t));
        }
        if (pulse.clean()) pulse.runAfter(()=>this.clean());
        return pulse;
    }
});
/**
 * Performs a relational projection, copying selected fields from source
 * tuples to a new set of derived tuples.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<function(object): *} params.fields - The fields to project,
 *   as an array of field accessors. If unspecified, all fields will be
 *   copied with names unchanged.
 * @param {Array<string>} [params.as] - Output field names for each projected
 *   field. Any unspecified fields will use the field name provided by
 *   the field accessor.
 */ function Project(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Project.Definition = {
    'type': 'Project',
    'metadata': {
        'generates': true,
        'changes': true
    },
    'params': [
        {
            'name': 'fields',
            'type': 'field',
            'array': true
        },
        {
            'name': 'as',
            'type': 'string',
            'null': true,
            'array': true
        }
    ]
};
(0, _vegaUtil.inherits)(Project, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.NO_SOURCE), fields = _.fields, as = fieldNames(_.fields, _.as || []), derive = fields ? (s, t)=>project(s, t, fields, as) : (0, _vegaDataflow.rederive);
        let lut;
        if (this.value) lut = this.value;
        else {
            pulse = pulse.addAll();
            lut = this.value = {};
        }
        pulse.visit(pulse.REM, (t)=>{
            const id = (0, _vegaDataflow.tupleid)(t);
            out.rem.push(lut[id]);
            lut[id] = null;
        });
        pulse.visit(pulse.ADD, (t)=>{
            const dt = derive(t, (0, _vegaDataflow.ingest)({}));
            lut[(0, _vegaDataflow.tupleid)(t)] = dt;
            out.add.push(dt);
        });
        pulse.visit(pulse.MOD, (t)=>{
            out.mod.push(derive(t, lut[(0, _vegaDataflow.tupleid)(t)]));
        });
        return out;
    }
});
function project(s, t, fields, as) {
    for(let i = 0, n = fields.length; i < n; ++i)t[as[i]] = fields[i](s);
    return t;
}
/**
 * Proxy the value of another operator as a pure signal value.
 * Ensures no tuples are propagated.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {*} params.value - The value to proxy, becomes the value of this operator.
 */ function Proxy(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
(0, _vegaUtil.inherits)(Proxy, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        this.value = _.value;
        return _.modified('value') ? pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS) : pulse.StopPropagation;
    }
});
/**
 * Generates sample quantile values from an input data stream.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - An accessor for the data field
 *   over which to calculate quantile values.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors
 *   to groupby.
 * @param {Array<number>} [params.probs] - An array of probabilities in
 *   the range (0, 1) for which to compute quantile values. If not specified,
 *   the *step* parameter will be used.
 * @param {Array<number>} [params.step=0.01] - A probability step size for
 *   sampling quantile values. All values from one-half the step size up to
 *   1 (exclusive) will be sampled. This parameter is only used if the
 *   *quantiles* parameter is not provided.
 */ function Quantile(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Quantile.Definition = {
    'type': 'Quantile',
    'metadata': {
        'generates': true,
        'changes': true
    },
    'params': [
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'field',
            'type': 'field',
            'required': true
        },
        {
            'name': 'probs',
            'type': 'number',
            'array': true
        },
        {
            'name': 'step',
            'type': 'number',
            'default': 0.01
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'default': [
                'prob',
                'value'
            ]
        }
    ]
};
const EPSILON = 1e-14;
(0, _vegaUtil.inherits)(Quantile, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS), as = _.as || [
            'prob',
            'value'
        ];
        if (this.value && !_.modified() && !pulse.changed()) {
            out.source = this.value;
            return out;
        }
        const source = pulse.materialize(pulse.SOURCE).source, groups = partition$1(source, _.groupby, _.field), names = (_.groupby || []).map((0, _vegaUtil.accessorName)), values = [], step = _.step || 0.01, p = _.probs || (0, _d3Array.range)(step / 2, 1 - EPSILON, step), n = p.length;
        groups.forEach((g)=>{
            const q = (0, _vegaStatistics.quantiles)(g, p);
            for(let i = 0; i < n; ++i){
                const t = {};
                for(let i = 0; i < names.length; ++i)t[names[i]] = g.dims[i];
                t[as[0]] = p[i];
                t[as[1]] = q[i];
                values.push((0, _vegaDataflow.ingest)(t));
            }
        });
        if (this.value) out.rem = this.value;
        this.value = out.add = out.source = values;
        return out;
    }
});
/**
 * Relays a data stream between data processing pipelines.
 * If the derive parameter is set, this transform will create derived
 * copies of observed tuples. This provides derived data streams in which
 * modifications to the tuples do not pollute an upstream data source.
 * @param {object} params - The parameters for this operator.
 * @param {number} [params.derive=false] - Boolean flag indicating if
 *   the transform should make derived copies of incoming tuples.
 * @constructor
 */ function Relay(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
(0, _vegaUtil.inherits)(Relay, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        let out, lut;
        if (this.value) lut = this.value;
        else {
            out = pulse = pulse.addAll();
            lut = this.value = {};
        }
        if (_.derive) {
            out = pulse.fork(pulse.NO_SOURCE);
            pulse.visit(pulse.REM, (t)=>{
                const id = (0, _vegaDataflow.tupleid)(t);
                out.rem.push(lut[id]);
                lut[id] = null;
            });
            pulse.visit(pulse.ADD, (t)=>{
                const dt = (0, _vegaDataflow.derive)(t);
                lut[(0, _vegaDataflow.tupleid)(t)] = dt;
                out.add.push(dt);
            });
            pulse.visit(pulse.MOD, (t)=>{
                const dt = lut[(0, _vegaDataflow.tupleid)(t)];
                for(const k in t){
                    dt[k] = t[k];
                    // down stream writes may overwrite re-derived tuples
                    // conservatively mark all source fields as modified
                    out.modifies(k);
                }
                out.mod.push(dt);
            });
        }
        return out;
    }
});
/**
 * Samples tuples passing through this operator.
 * Uses reservoir sampling to maintain a representative sample.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {number} [params.size=1000] - The maximum number of samples.
 */ function Sample(params) {
    (0, _vegaDataflow.Transform).call(this, [], params);
    this.count = 0;
}
Sample.Definition = {
    'type': 'Sample',
    'metadata': {},
    'params': [
        {
            'name': 'size',
            'type': 'number',
            'default': 1000
        }
    ]
};
(0, _vegaUtil.inherits)(Sample, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.NO_SOURCE), mod = _.modified('size'), num = _.size, map = this.value.reduce((m, t)=>(m[(0, _vegaDataflow.tupleid)(t)] = 1, m), {});
        let res = this.value, cnt = this.count, cap = 0;
        // sample reservoir update function
        function update(t) {
            let p, idx;
            if (res.length < num) res.push(t);
            else {
                idx = ~~((cnt + 1) * (0, _vegaStatistics.random)());
                if (idx < res.length && idx >= cap) {
                    p = res[idx];
                    if (map[(0, _vegaDataflow.tupleid)(p)]) out.rem.push(p); // eviction
                    res[idx] = t;
                }
            }
            ++cnt;
        }
        if (pulse.rem.length) {
            // find all tuples that should be removed, add to output
            pulse.visit(pulse.REM, (t)=>{
                const id = (0, _vegaDataflow.tupleid)(t);
                if (map[id]) {
                    map[id] = -1;
                    out.rem.push(t);
                }
                --cnt;
            });
            // filter removed tuples out of the sample reservoir
            res = res.filter((t)=>map[(0, _vegaDataflow.tupleid)(t)] !== -1);
        }
        if ((pulse.rem.length || mod) && res.length < num && pulse.source) {
            // replenish sample if backing data source is available
            cap = cnt = res.length;
            pulse.visit(pulse.SOURCE, (t)=>{
                // update, but skip previously sampled tuples
                if (!map[(0, _vegaDataflow.tupleid)(t)]) update(t);
            });
            cap = -1;
        }
        if (mod && res.length > num) {
            const n = res.length - num;
            for(let i = 0; i < n; ++i){
                map[(0, _vegaDataflow.tupleid)(res[i])] = -1;
                out.rem.push(res[i]);
            }
            res = res.slice(n);
        }
        if (pulse.mod.length) // propagate modified tuples in the sample reservoir
        pulse.visit(pulse.MOD, (t)=>{
            if (map[(0, _vegaDataflow.tupleid)(t)]) out.mod.push(t);
        });
        if (pulse.add.length) // update sample reservoir
        pulse.visit(pulse.ADD, update);
        if (pulse.add.length || cap < 0) // output newly added tuples
        out.add = res.filter((t)=>!map[(0, _vegaDataflow.tupleid)(t)]);
        this.count = cnt;
        this.value = out.source = res;
        return out;
    }
});
/**
 * Generates data tuples for a specified sequence range of numbers.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {number} params.start - The first number in the sequence.
 * @param {number} params.stop - The last number (exclusive) in the sequence.
 * @param {number} [params.step=1] - The step size between numbers in the sequence.
 */ function Sequence(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Sequence.Definition = {
    'type': 'Sequence',
    'metadata': {
        'generates': true,
        'changes': true
    },
    'params': [
        {
            'name': 'start',
            'type': 'number',
            'required': true
        },
        {
            'name': 'stop',
            'type': 'number',
            'required': true
        },
        {
            'name': 'step',
            'type': 'number',
            'default': 1
        },
        {
            'name': 'as',
            'type': 'string',
            'default': 'data'
        }
    ]
};
(0, _vegaUtil.inherits)(Sequence, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (this.value && !_.modified()) return;
        const out = pulse.materialize().fork(pulse.MOD), as = _.as || 'data';
        out.rem = this.value ? pulse.rem.concat(this.value) : pulse.rem;
        this.value = (0, _d3Array.range)(_.start, _.stop, _.step || 1).map((v)=>{
            const t = {};
            t[as] = v;
            return (0, _vegaDataflow.ingest)(t);
        });
        out.add = pulse.add.concat(this.value);
        return out;
    }
});
/**
 * Propagates a new pulse without any tuples so long as the input
 * pulse contains some added, removed or modified tuples.
 * @param {object} params - The parameters for this operator.
 * @constructor
 */ function Sieve(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
    this.modified(true); // always treat as modified
}
(0, _vegaUtil.inherits)(Sieve, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        this.value = pulse.source;
        return pulse.changed() ? pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS) : pulse.StopPropagation;
    }
});
/**
 * Discretize dates to specific time units.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The data field containing date/time values.
 */ function TimeUnit(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
const OUTPUT = [
    'unit0',
    'unit1'
];
TimeUnit.Definition = {
    'type': 'TimeUnit',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field',
            'required': true
        },
        {
            'name': 'interval',
            'type': 'boolean',
            'default': true
        },
        {
            'name': 'units',
            'type': 'enum',
            'values': (0, _vegaTime.TIME_UNITS),
            'array': true
        },
        {
            'name': 'step',
            'type': 'number',
            'default': 1
        },
        {
            'name': 'maxbins',
            'type': 'number',
            'default': 40
        },
        {
            'name': 'extent',
            'type': 'date',
            'array': true
        },
        {
            'name': 'timezone',
            'type': 'enum',
            'default': 'local',
            'values': [
                'local',
                'utc'
            ]
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': 2,
            'default': OUTPUT
        }
    ]
};
(0, _vegaUtil.inherits)(TimeUnit, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const field = _.field, band = _.interval !== false, utc = _.timezone === 'utc', floor = this._floor(_, pulse), offset = (utc ? (0, _vegaTime.utcInterval) : (0, _vegaTime.timeInterval))(floor.unit).offset, as = _.as || OUTPUT, u0 = as[0], u1 = as[1], step = floor.step;
        let min = floor.start || Infinity, max = floor.stop || -Infinity, flag = pulse.ADD;
        if (_.modified() || pulse.changed(pulse.REM) || pulse.modified((0, _vegaUtil.accessorFields)(field))) {
            pulse = pulse.reflow(true);
            flag = pulse.SOURCE;
            min = Infinity;
            max = -Infinity;
        }
        pulse.visit(flag, (t)=>{
            const v = field(t);
            let a, b;
            if (v == null) {
                t[u0] = null;
                if (band) t[u1] = null;
            } else {
                t[u0] = a = b = floor(v);
                if (band) t[u1] = b = offset(a, step);
                if (a < min) min = a;
                if (b > max) max = b;
            }
        });
        floor.start = min;
        floor.stop = max;
        return pulse.modifies(band ? as : u0);
    },
    _floor (_, pulse) {
        const utc = _.timezone === 'utc';
        // get parameters
        const { units, step } = _.units ? {
            units: _.units,
            step: _.step || 1
        } : (0, _vegaTime.timeBin)({
            extent: _.extent || (0, _vegaUtil.extent)(pulse.materialize(pulse.SOURCE).source, _.field),
            maxbins: _.maxbins
        });
        // check / standardize time units
        const tunits = (0, _vegaTime.timeUnits)(units), prev = this.value || {}, floor = (utc ? (0, _vegaTime.utcFloor) : (0, _vegaTime.timeFloor))(tunits, step);
        floor.unit = (0, _vegaUtil.peek)(tunits);
        floor.units = tunits;
        floor.step = step;
        floor.start = prev.start;
        floor.stop = prev.stop;
        return this.value = floor;
    }
});
/**
 * An index that maps from unique, string-coerced, field values to tuples.
 * Assumes that the field serves as a unique key with no duplicate values.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The field accessor to index.
 */ function TupleIndex(params) {
    (0, _vegaDataflow.Transform).call(this, (0, _vegaUtil.fastmap)(), params);
}
(0, _vegaUtil.inherits)(TupleIndex, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const df = pulse.dataflow, field = _.field, index = this.value, set = (t)=>index.set(field(t), t);
        let mod = true;
        if (_.modified('field') || pulse.modified(field.fields)) {
            index.clear();
            pulse.visit(pulse.SOURCE, set);
        } else if (pulse.changed()) {
            pulse.visit(pulse.REM, (t)=>index.delete(field(t)));
            pulse.visit(pulse.ADD, set);
        } else mod = false;
        this.modified(mod);
        if (index.empty > df.cleanThreshold) df.runAfter(index.clean);
        return pulse.fork();
    }
});
/**
 * Extracts an array of values. Assumes the source data has already been
 * reduced as needed (e.g., by an upstream Aggregate transform).
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The domain field to extract.
 * @param {function(*,*): number} [params.sort] - An optional
 *   comparator function for sorting the values. The comparator will be
 *   applied to backing tuples prior to value extraction.
 */ function Values(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
(0, _vegaUtil.inherits)(Values, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const run = !this.value || _.modified('field') || _.modified('sort') || pulse.changed() || _.sort && pulse.modified(_.sort.fields);
        if (run) this.value = (_.sort ? pulse.source.slice().sort((0, _vegaDataflow.stableCompare)(_.sort)) : pulse.source).map(_.field);
    }
});
function WindowOp(op, field, param, as) {
    const fn = WindowOps[op](field, param);
    return {
        init: fn.init || (0, _vegaUtil.zero),
        update: function(w, t) {
            t[as] = fn.next(w);
        }
    };
}
const WindowOps = {
    row_number: function() {
        return {
            next: (w)=>w.index + 1
        };
    },
    rank: function() {
        let rank;
        return {
            init: ()=>rank = 1,
            next: (w)=>{
                const i = w.index, data = w.data;
                return i && w.compare(data[i - 1], data[i]) ? rank = i + 1 : rank;
            }
        };
    },
    dense_rank: function() {
        let drank;
        return {
            init: ()=>drank = 1,
            next: (w)=>{
                const i = w.index, d = w.data;
                return i && w.compare(d[i - 1], d[i]) ? ++drank : drank;
            }
        };
    },
    percent_rank: function() {
        const rank = WindowOps.rank(), next = rank.next;
        return {
            init: rank.init,
            next: (w)=>(next(w) - 1) / (w.data.length - 1)
        };
    },
    cume_dist: function() {
        let cume;
        return {
            init: ()=>cume = 0,
            next: (w)=>{
                const d = w.data, c = w.compare;
                let i = w.index;
                if (cume < i) {
                    while(i + 1 < d.length && !c(d[i], d[i + 1]))++i;
                    cume = i;
                }
                return (1 + cume) / d.length;
            }
        };
    },
    ntile: function(field, num) {
        num = +num;
        if (!(num > 0)) (0, _vegaUtil.error)('ntile num must be greater than zero.');
        const cume = WindowOps.cume_dist(), next = cume.next;
        return {
            init: cume.init,
            next: (w)=>Math.ceil(num * next(w))
        };
    },
    lag: function(field, offset) {
        offset = +offset || 1;
        return {
            next: (w)=>{
                const i = w.index - offset;
                return i >= 0 ? field(w.data[i]) : null;
            }
        };
    },
    lead: function(field, offset) {
        offset = +offset || 1;
        return {
            next: (w)=>{
                const i = w.index + offset, d = w.data;
                return i < d.length ? field(d[i]) : null;
            }
        };
    },
    first_value: function(field) {
        return {
            next: (w)=>field(w.data[w.i0])
        };
    },
    last_value: function(field) {
        return {
            next: (w)=>field(w.data[w.i1 - 1])
        };
    },
    nth_value: function(field, nth) {
        nth = +nth;
        if (!(nth > 0)) (0, _vegaUtil.error)('nth_value nth must be greater than zero.');
        return {
            next: (w)=>{
                const i = w.i0 + (nth - 1);
                return i < w.i1 ? field(w.data[i]) : null;
            }
        };
    },
    prev_value: function(field) {
        let prev;
        return {
            init: ()=>prev = null,
            next: (w)=>{
                const v = field(w.data[w.index]);
                return v != null ? prev = v : prev;
            }
        };
    },
    next_value: function(field) {
        let v, i;
        return {
            init: ()=>(v = null, i = -1),
            next: (w)=>{
                const d = w.data;
                return w.index <= i ? v : (i = find(field, d, w.index)) < 0 ? (i = d.length, v = null) : v = field(d[i]);
            }
        };
    }
};
function find(field, data, index) {
    for(let n = data.length; index < n; ++index){
        const v = field(data[index]);
        if (v != null) return index;
    }
    return -1;
}
const ValidWindowOps = Object.keys(WindowOps);
function WindowState(_) {
    const ops = (0, _vegaUtil.array)(_.ops), fields = (0, _vegaUtil.array)(_.fields), params = (0, _vegaUtil.array)(_.params), aggregate_params = (0, _vegaUtil.array)(_.aggregate_params), as = (0, _vegaUtil.array)(_.as), outputs = this.outputs = [], windows = this.windows = [], inputs = {}, map = {}, counts = [], measures = [];
    let countOnly = true;
    function visitInputs(f) {
        (0, _vegaUtil.array)((0, _vegaUtil.accessorFields)(f)).forEach((_)=>inputs[_] = 1);
    }
    visitInputs(_.sort);
    ops.forEach((op, i)=>{
        const field = fields[i], param = params[i], aggregate_param = aggregate_params[i] || null, mname = (0, _vegaUtil.accessorName)(field), name = measureName(op, mname, as[i]);
        visitInputs(field);
        outputs.push(name);
        // Window operation
        if ((0, _vegaUtil.hasOwnProperty)(WindowOps, op)) windows.push(WindowOp(op, field, param, name));
        else {
            if (field == null && op !== 'count') (0, _vegaUtil.error)('Null aggregate field specified.');
            if (op === 'count') {
                counts.push(name);
                return;
            }
            countOnly = false;
            let m = map[mname];
            if (!m) {
                m = map[mname] = [];
                m.field = field;
                measures.push(m);
            }
            m.push(createMeasure(op, aggregate_param, name));
        }
    });
    if (counts.length || measures.length) this.cell = cell(measures, counts, countOnly);
    this.inputs = Object.keys(inputs);
}
const prototype = WindowState.prototype;
prototype.init = function() {
    this.windows.forEach((_)=>_.init());
    if (this.cell) this.cell.init();
};
prototype.update = function(w, t) {
    const cell = this.cell, wind = this.windows, data = w.data, m = wind && wind.length;
    let j;
    if (cell) {
        for(j = w.p0; j < w.i0; ++j)cell.rem(data[j]);
        for(j = w.p1; j < w.i1; ++j)cell.add(data[j]);
        cell.set(t);
    }
    for(j = 0; j < m; ++j)wind[j].update(w, t);
};
function cell(measures, counts, countOnly) {
    measures = measures.map((m)=>compileMeasures(m, m.field));
    const cell = {
        num: 0,
        agg: null,
        store: false,
        count: counts
    };
    if (!countOnly) {
        var n = measures.length, a = cell.agg = Array(n), i = 0;
        for(; i < n; ++i)a[i] = new measures[i](cell);
    }
    if (cell.store) var store = cell.data = new TupleStore();
    cell.add = function(t) {
        cell.num += 1;
        if (countOnly) return;
        if (store) store.add(t);
        for(let i = 0; i < n; ++i)a[i].add(a[i].get(t), t);
    };
    cell.rem = function(t) {
        cell.num -= 1;
        if (countOnly) return;
        if (store) store.rem(t);
        for(let i = 0; i < n; ++i)a[i].rem(a[i].get(t), t);
    };
    cell.set = function(t) {
        let i, n;
        // consolidate stored values
        if (store) store.values();
        // update tuple properties
        for(i = 0, n = counts.length; i < n; ++i)t[counts[i]] = cell.num;
        if (!countOnly) for(i = 0, n = a.length; i < n; ++i)a[i].set(t);
    };
    cell.init = function() {
        cell.num = 0;
        if (store) store.reset();
        for(let i = 0; i < n; ++i)a[i].init();
    };
    return cell;
}
/**
 * Perform window calculations and write results to the input stream.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(*,*): number} [params.sort] - A comparator function for sorting tuples within a window.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors by which to partition tuples into separate windows.
 * @param {Array<string>} params.ops - An array of strings indicating window operations to perform.
 * @param {Array<function(object): *>} [params.fields] - An array of accessors
 *   for data fields to use as inputs to window operations.
 * @param {Array<*>} [params.params] - An array of parameter values for window operations.
 * @param {Array<number>} [params.aggregate_params] - An optional array of parameter values for aggregation operations.
 * @param {Array<string>} [params.as] - An array of output field names for window operations.
 * @param {Array<number>} [params.frame] - Window frame definition as two-element array.
 * @param {boolean} [params.ignorePeers=false] - If true, base window frame boundaries on row
 *   number alone, ignoring peers with identical sort values. If false (default),
 *   the window boundaries will be adjusted to include peer values.
 */ function Window(params) {
    (0, _vegaDataflow.Transform).call(this, {}, params);
    this._mlen = 0;
    this._mods = [];
}
Window.Definition = {
    'type': 'Window',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'sort',
            'type': 'compare'
        },
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'ops',
            'type': 'enum',
            'array': true,
            'values': ValidWindowOps.concat(ValidAggregateOps)
        },
        {
            'name': 'params',
            'type': 'number',
            'null': true,
            'array': true
        },
        {
            'name': 'aggregate_params',
            'type': 'number',
            'null': true,
            'array': true
        },
        {
            'name': 'fields',
            'type': 'field',
            'null': true,
            'array': true
        },
        {
            'name': 'as',
            'type': 'string',
            'null': true,
            'array': true
        },
        {
            'name': 'frame',
            'type': 'number',
            'null': true,
            'array': true,
            'length': 2,
            'default': [
                null,
                0
            ]
        },
        {
            'name': 'ignorePeers',
            'type': 'boolean',
            'default': false
        }
    ]
};
(0, _vegaUtil.inherits)(Window, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        this.stamp = pulse.stamp;
        const mod = _.modified(), cmp = (0, _vegaDataflow.stableCompare)(_.sort), key = groupkey(_.groupby), group = (t)=>this.group(key(t));
        // initialize window state
        let state = this.state;
        if (!state || mod) state = this.state = new WindowState(_);
        // partition input tuples
        if (mod || pulse.modified(state.inputs)) {
            this.value = {};
            pulse.visit(pulse.SOURCE, (t)=>group(t).add(t));
        } else {
            pulse.visit(pulse.REM, (t)=>group(t).remove(t));
            pulse.visit(pulse.ADD, (t)=>group(t).add(t));
        }
        // perform window calculations for each modified partition
        for(let i = 0, n = this._mlen; i < n; ++i)processPartition(this._mods[i], state, cmp, _);
        this._mlen = 0;
        this._mods = [];
        // TODO don't reflow everything?
        return pulse.reflow(mod).modifies(state.outputs);
    },
    group (key) {
        let group = this.value[key];
        if (!group) {
            group = this.value[key] = SortedList((0, _vegaDataflow.tupleid));
            group.stamp = -1;
        }
        if (group.stamp < this.stamp) {
            group.stamp = this.stamp;
            this._mods[this._mlen++] = group;
        }
        return group;
    }
});
function processPartition(list, state, cmp, _) {
    const sort = _.sort, range = sort && !_.ignorePeers, frame = _.frame || [
        null,
        0
    ], data = list.data(cmp), // use cmp for stable sort
    n = data.length, b = range ? (0, _d3Array.bisector)(sort) : null, w = {
        i0: 0,
        i1: 0,
        p0: 0,
        p1: 0,
        index: 0,
        data: data,
        compare: sort || (0, _vegaUtil.constant)(-1)
    };
    state.init();
    for(let i = 0; i < n; ++i){
        setWindow(w, frame, i, n);
        if (range) adjustRange(w, b);
        state.update(w, data[i]);
    }
}
function setWindow(w, f, i, n) {
    w.p0 = w.i0;
    w.p1 = w.i1;
    w.i0 = f[0] == null ? 0 : Math.max(0, i - Math.abs(f[0]));
    w.i1 = f[1] == null ? n : Math.min(n, i + Math.abs(f[1]) + 1);
    w.index = i;
}
// if frame type is 'range', adjust window for peer values
function adjustRange(w, bisect) {
    const r0 = w.i0, r1 = w.i1 - 1, c = w.compare, d = w.data, n = d.length - 1;
    if (r0 > 0 && !c(d[r0], d[r0 - 1])) w.i0 = bisect.left(d, d[r0]);
    if (r1 < n && !c(d[r1], d[r1 + 1])) w.i1 = bisect.right(d, d[r1]);
}

},{"vega-util":"7f6sQ","vega-dataflow":"4An7U","vega-statistics":"lNUxJ","d3-array":"ktdME","vega-time":"4oydN","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"lNUxJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bandwidthNRD", ()=>estimateBandwidth);
parcelHelpers.export(exports, "bin", ()=>bin);
parcelHelpers.export(exports, "bootstrapCI", ()=>bootstrapCI);
parcelHelpers.export(exports, "cumulativeLogNormal", ()=>cumulativeLogNormal);
parcelHelpers.export(exports, "cumulativeNormal", ()=>cumulativeNormal);
parcelHelpers.export(exports, "cumulativeUniform", ()=>cumulativeUniform);
parcelHelpers.export(exports, "densityLogNormal", ()=>densityLogNormal);
parcelHelpers.export(exports, "densityNormal", ()=>densityNormal);
parcelHelpers.export(exports, "densityUniform", ()=>densityUniform);
parcelHelpers.export(exports, "dotbin", ()=>dotbin);
parcelHelpers.export(exports, "quantileLogNormal", ()=>quantileLogNormal);
parcelHelpers.export(exports, "quantileNormal", ()=>quantileNormal);
parcelHelpers.export(exports, "quantileUniform", ()=>quantileUniform);
parcelHelpers.export(exports, "quantiles", ()=>quantiles);
parcelHelpers.export(exports, "quartiles", ()=>quartiles);
parcelHelpers.export(exports, "random", ()=>random);
parcelHelpers.export(exports, "randomInteger", ()=>integer);
parcelHelpers.export(exports, "randomKDE", ()=>kde);
parcelHelpers.export(exports, "randomLCG", ()=>lcg);
parcelHelpers.export(exports, "randomLogNormal", ()=>lognormal);
parcelHelpers.export(exports, "randomMixture", ()=>mixture);
parcelHelpers.export(exports, "randomNormal", ()=>gaussian);
parcelHelpers.export(exports, "randomUniform", ()=>uniform);
parcelHelpers.export(exports, "regressionConstant", ()=>constant);
parcelHelpers.export(exports, "regressionExp", ()=>exp);
parcelHelpers.export(exports, "regressionLinear", ()=>linear);
parcelHelpers.export(exports, "regressionLoess", ()=>loess);
parcelHelpers.export(exports, "regressionLog", ()=>log);
parcelHelpers.export(exports, "regressionPoly", ()=>poly);
parcelHelpers.export(exports, "regressionPow", ()=>pow);
parcelHelpers.export(exports, "regressionQuad", ()=>quad);
parcelHelpers.export(exports, "sampleCurve", ()=>sampleCurve);
parcelHelpers.export(exports, "sampleLogNormal", ()=>sampleLogNormal);
parcelHelpers.export(exports, "sampleNormal", ()=>sampleNormal);
parcelHelpers.export(exports, "sampleUniform", ()=>sampleUniform);
parcelHelpers.export(exports, "setRandom", ()=>setRandom);
var _d3Array = require("d3-array");
function* numbers(values, valueof) {
    if (valueof == null) {
        for (let value of values)if (value != null && value !== '' && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values){
            value = valueof(value, ++index, values);
            if (value != null && value !== '' && (value = +value) >= value) yield value;
        }
    }
}
function quantiles(array, p, f) {
    const values = Float64Array.from(numbers(array, f));
    // don't depend on return value from typed array sort call
    // protects against undefined sort results in Safari (vega/vega-lite#4964)
    values.sort((0, _d3Array.ascending));
    return p.map((_)=>(0, _d3Array.quantileSorted)(values, _));
}
function quartiles(array, f) {
    return quantiles(array, [
        0.25,
        0.50,
        0.75
    ], f);
}
// Scott, D. W. (1992) Multivariate Density Estimation:
// Theory, Practice, and Visualization. Wiley.
function estimateBandwidth(array, f) {
    const n = array.length, d = (0, _d3Array.deviation)(array, f), q = quartiles(array, f), h = (q[2] - q[0]) / 1.34, v = Math.min(d, h) || d || Math.abs(q[0]) || 1;
    return 1.06 * v * Math.pow(n, -0.2);
}
function bin(_) {
    // determine range
    const maxb = _.maxbins || 20, base = _.base || 10, logb = Math.log(base), div = _.divide || [
        5,
        2
    ];
    let min = _.extent[0], max = _.extent[1], step, level, minstep, v, i, n;
    const span = _.span || max - min || Math.abs(min) || 1;
    if (_.step) // if step size is explicitly given, use that
    step = _.step;
    else if (_.steps) {
        // if provided, limit choice to acceptable step sizes
        v = span / maxb;
        for(i = 0, n = _.steps.length; i < n && _.steps[i] < v; ++i);
        step = _.steps[Math.max(0, i - 1)];
    } else {
        // else use span to determine step size
        level = Math.ceil(Math.log(maxb) / logb);
        minstep = _.minstep || 0;
        step = Math.max(minstep, Math.pow(base, Math.round(Math.log(span) / logb) - level));
        // increase step size if too many bins
        while(Math.ceil(span / step) > maxb)step *= base;
        // decrease step size if allowed
        for(i = 0, n = div.length; i < n; ++i){
            v = step / div[i];
            if (v >= minstep && span / v <= maxb) step = v;
        }
    }
    // update precision, min and max
    v = Math.log(step);
    const precision = v >= 0 ? 0 : ~~(-v / logb) + 1, eps = Math.pow(base, -precision - 1);
    if (_.nice || _.nice === undefined) {
        v = Math.floor(min / step + eps) * step;
        min = min < v ? v - step : v;
        max = Math.ceil(max / step) * step;
    }
    return {
        start: min,
        stop: max === min ? min + step : max,
        step: step
    };
}
var random = Math.random;
function setRandom(r) {
    random = r;
}
function bootstrapCI(array, samples, alpha, f) {
    if (!array.length) return [
        undefined,
        undefined
    ];
    const values = Float64Array.from(numbers(array, f)), n = values.length, m = samples;
    let a, i, j, mu;
    for(j = 0, mu = Array(m); j < m; ++j){
        for(a = 0, i = 0; i < n; ++i)a += values[~~(random() * n)];
        mu[j] = a / n;
    }
    mu.sort((0, _d3Array.ascending));
    return [
        (0, _d3Array.quantile)(mu, alpha / 2),
        (0, _d3Array.quantile)(mu, 1 - alpha / 2)
    ];
}
// Dot density binning for dot plot construction.
// Based on Leland Wilkinson, Dot Plots, The American Statistician, 1999.
// https://www.cs.uic.edu/~wilkinson/Publications/dotplots.pdf
function dotbin(array, step, smooth, f) {
    f = f || ((_)=>_);
    const n = array.length, v = new Float64Array(n);
    let i = 0, j = 1, a = f(array[0]), b = a, w = a + step, x;
    for(; j < n; ++j){
        x = f(array[j]);
        if (x >= w) {
            b = (a + b) / 2;
            for(; i < j; ++i)v[i] = b;
            w = x + step;
            a = x;
        }
        b = x;
    }
    b = (a + b) / 2;
    for(; i < j; ++i)v[i] = b;
    return smooth ? smoothing(v, step + step / 4) : v;
}
// perform smoothing to reduce variance
// swap points between "adjacent" stacks
// Wilkinson defines adjacent as within step/4 units
function smoothing(v, thresh) {
    const n = v.length;
    let a = 0, b = 1, c, d;
    // get left stack
    while(v[a] === v[b])++b;
    while(b < n){
        // get right stack
        c = b + 1;
        while(v[b] === v[c])++c;
        // are stacks adjacent?
        // if so, compare sizes and swap as needed
        if (v[b] - v[b - 1] < thresh) {
            d = b + (a + c - b - b >> 1);
            while(d < b)v[d++] = v[b];
            while(d > b)v[d--] = v[a];
        }
        // update left stack indices
        a = b;
        b = c;
    }
    return v;
}
function lcg(seed) {
    // Random numbers using a Linear Congruential Generator with seed value
    // Uses glibc values from https://en.wikipedia.org/wiki/Linear_congruential_generator
    return function() {
        seed = (1103515245 * seed + 12345) % 2147483647;
        return seed / 2147483647;
    };
}
function integer(min, max) {
    if (max == null) {
        max = min;
        min = 0;
    }
    let a, b, d;
    const dist = {
        min (_) {
            if (arguments.length) {
                a = _ || 0;
                d = b - a;
                return dist;
            } else return a;
        },
        max (_) {
            if (arguments.length) {
                b = _ || 0;
                d = b - a;
                return dist;
            } else return b;
        },
        sample () {
            return a + Math.floor(d * random());
        },
        pdf (x) {
            return x === Math.floor(x) && x >= a && x < b ? 1 / d : 0;
        },
        cdf (x) {
            const v = Math.floor(x);
            return v < a ? 0 : v >= b ? 1 : (v - a + 1) / d;
        },
        icdf (p) {
            return p >= 0 && p <= 1 ? a - 1 + Math.floor(p * d) : NaN;
        }
    };
    return dist.min(min).max(max);
}
const SQRT2PI = Math.sqrt(2 * Math.PI);
const SQRT2 = Math.SQRT2;
let nextSample = NaN;
function sampleNormal(mean, stdev) {
    mean = mean || 0;
    stdev = stdev == null ? 1 : stdev;
    let x = 0, y = 0, rds, c;
    if (nextSample === nextSample) {
        x = nextSample;
        nextSample = NaN;
    } else {
        do {
            x = random() * 2 - 1;
            y = random() * 2 - 1;
            rds = x * x + y * y;
        }while (rds === 0 || rds > 1);
        c = Math.sqrt(-2 * Math.log(rds) / rds); // Box-Muller transform
        x *= c;
        nextSample = y * c;
    }
    return mean + x * stdev;
}
function densityNormal(value, mean, stdev) {
    stdev = stdev == null ? 1 : stdev;
    const z = (value - (mean || 0)) / stdev;
    return Math.exp(-0.5 * z * z) / (stdev * SQRT2PI);
}
// Approximation from West (2009)
// Better Approximations to Cumulative Normal Functions
function cumulativeNormal(value, mean, stdev) {
    mean = mean || 0;
    stdev = stdev == null ? 1 : stdev;
    const z = (value - mean) / stdev, Z = Math.abs(z);
    let cd;
    if (Z > 37) cd = 0;
    else {
        const exp = Math.exp(-Z * Z / 2);
        let sum;
        if (Z < 7.07106781186547) {
            sum = 3.52624965998911e-02 * Z + 0.700383064443688;
            sum = sum * Z + 6.37396220353165;
            sum = sum * Z + 33.912866078383;
            sum = sum * Z + 112.079291497871;
            sum = sum * Z + 221.213596169931;
            sum = sum * Z + 220.206867912376;
            cd = exp * sum;
            sum = 8.83883476483184e-02 * Z + 1.75566716318264;
            sum = sum * Z + 16.064177579207;
            sum = sum * Z + 86.7807322029461;
            sum = sum * Z + 296.564248779674;
            sum = sum * Z + 637.333633378831;
            sum = sum * Z + 793.826512519948;
            sum = sum * Z + 440.413735824752;
            cd = cd / sum;
        } else {
            sum = Z + 0.65;
            sum = Z + 4 / sum;
            sum = Z + 3 / sum;
            sum = Z + 2 / sum;
            sum = Z + 1 / sum;
            cd = exp / sum / 2.506628274631;
        }
    }
    return z > 0 ? 1 - cd : cd;
}
// Approximation of Probit function using inverse error function.
function quantileNormal(p, mean, stdev) {
    if (p < 0 || p > 1) return NaN;
    return (mean || 0) + (stdev == null ? 1 : stdev) * SQRT2 * erfinv(2 * p - 1);
}
// Approximate inverse error function. Implementation from "Approximating
// the erfinv function" by Mike Giles, GPU Computing Gems, volume 2, 2010.
// Ported from Apache Commons Math, http://www.apache.org/licenses/LICENSE-2.0
function erfinv(x) {
    // beware that the logarithm argument must be
    // commputed as (1.0 - x) * (1.0 + x),
    // it must NOT be simplified as 1.0 - x * x as this
    // would induce rounding errors near the boundaries +/-1
    let w = -Math.log((1 - x) * (1 + x)), p;
    if (w < 6.25) {
        w -= 3.125;
        p = -0.00000000000000000000364441206401782;
        p = -0.00000000000000000016850591381820166 + p * w;
        p = 1.2858480715256400167e-18 + p * w;
        p = 1.115787767802518096e-17 + p * w;
        p = -0.0000000000000001333171662854621 + p * w;
        p = 2.0972767875968561637e-17 + p * w;
        p = 6.6376381343583238325e-15 + p * w;
        p = -0.00000000000004054566272975207 + p * w;
        p = -0.00000000000008151934197605472 + p * w;
        p = 2.6335093153082322977e-12 + p * w;
        p = -0.000000000012975133253453532 + p * w;
        p = -0.00000000005415412054294628 + p * w;
        p = 1.051212273321532285e-09 + p * w;
        p = -0.000000004112633980346984 + p * w;
        p = -0.000000029070369957882005 + p * w;
        p = 4.2347877827932403518e-07 + p * w;
        p = -0.0000013654692000834679 + p * w;
        p = -0.000013882523362786469 + p * w;
        p = 0.0001867342080340571352 + p * w;
        p = -0.000740702534166267 + p * w;
        p = -0.006033670871430149 + p * w;
        p = 0.24015818242558961693 + p * w;
        p = 1.6536545626831027356 + p * w;
    } else if (w < 16.0) {
        w = Math.sqrt(w) - 3.25;
        p = 2.2137376921775787049e-09;
        p = 9.0756561938885390979e-08 + p * w;
        p = -0.00000027517406297064545 + p * w;
        p = 1.8239629214389227755e-08 + p * w;
        p = 1.5027403968909827627e-06 + p * w;
        p = -0.000004013867526981546 + p * w;
        p = 2.9234449089955446044e-06 + p * w;
        p = 1.2475304481671778723e-05 + p * w;
        p = -0.000047318229009055734 + p * w;
        p = 6.8284851459573175448e-05 + p * w;
        p = 2.4031110387097893999e-05 + p * w;
        p = -0.0003550375203628475 + p * w;
        p = 0.00095328937973738049703 + p * w;
        p = -0.0016882755560235047 + p * w;
        p = 0.0024914420961078508066 + p * w;
        p = -0.003751208507569241 + p * w;
        p = 0.005370914553590063617 + p * w;
        p = 1.0052589676941592334 + p * w;
        p = 3.0838856104922207635 + p * w;
    } else if (Number.isFinite(w)) {
        w = Math.sqrt(w) - 5.0;
        p = -0.000000000027109920616438573;
        p = -0.0000000002555641816996525 + p * w;
        p = 1.5076572693500548083e-09 + p * w;
        p = -0.000000003789465440126737 + p * w;
        p = 7.6157012080783393804e-09 + p * w;
        p = -0.00000001496002662714924 + p * w;
        p = 2.9147953450901080826e-08 + p * w;
        p = -0.00000006771199775845234 + p * w;
        p = 2.2900482228026654717e-07 + p * w;
        p = -0.00000099298272942317 + p * w;
        p = 4.5260625972231537039e-06 + p * w;
        p = -0.00001968177810553167 + p * w;
        p = 7.5995277030017761139e-05 + p * w;
        p = -0.00021503011930044477 + p * w;
        p = -0.00013871931833623122 + p * w;
        p = 1.0103004648645343977 + p * w;
        p = 4.8499064014085844221 + p * w;
    } else p = Infinity;
    return p * x;
}
function gaussian(mean, stdev) {
    let mu, sigma;
    const dist = {
        mean (_) {
            if (arguments.length) {
                mu = _ || 0;
                return dist;
            } else return mu;
        },
        stdev (_) {
            if (arguments.length) {
                sigma = _ == null ? 1 : _;
                return dist;
            } else return sigma;
        },
        sample: ()=>sampleNormal(mu, sigma),
        pdf: (value)=>densityNormal(value, mu, sigma),
        cdf: (value)=>cumulativeNormal(value, mu, sigma),
        icdf: (p)=>quantileNormal(p, mu, sigma)
    };
    return dist.mean(mean).stdev(stdev);
}
function kde(support, bandwidth) {
    const kernel = gaussian();
    let n = 0;
    const dist = {
        data (_) {
            if (arguments.length) {
                support = _;
                n = _ ? _.length : 0;
                return dist.bandwidth(bandwidth);
            } else return support;
        },
        bandwidth (_) {
            if (!arguments.length) return bandwidth;
            bandwidth = _;
            if (!bandwidth && support) bandwidth = estimateBandwidth(support);
            return dist;
        },
        sample () {
            return support[~~(random() * n)] + bandwidth * kernel.sample();
        },
        pdf (x) {
            let y = 0, i = 0;
            for(; i < n; ++i)y += kernel.pdf((x - support[i]) / bandwidth);
            return y / bandwidth / n;
        },
        cdf (x) {
            let y = 0, i = 0;
            for(; i < n; ++i)y += kernel.cdf((x - support[i]) / bandwidth);
            return y / n;
        },
        icdf () {
            throw Error('KDE icdf not supported.');
        }
    };
    return dist.data(support);
}
function sampleLogNormal(mean, stdev) {
    mean = mean || 0;
    stdev = stdev == null ? 1 : stdev;
    return Math.exp(mean + sampleNormal() * stdev);
}
function densityLogNormal(value, mean, stdev) {
    if (value <= 0) return 0;
    mean = mean || 0;
    stdev = stdev == null ? 1 : stdev;
    const z = (Math.log(value) - mean) / stdev;
    return Math.exp(-0.5 * z * z) / (stdev * SQRT2PI * value);
}
function cumulativeLogNormal(value, mean, stdev) {
    return cumulativeNormal(Math.log(value), mean, stdev);
}
function quantileLogNormal(p, mean, stdev) {
    return Math.exp(quantileNormal(p, mean, stdev));
}
function lognormal(mean, stdev) {
    let mu, sigma;
    const dist = {
        mean (_) {
            if (arguments.length) {
                mu = _ || 0;
                return dist;
            } else return mu;
        },
        stdev (_) {
            if (arguments.length) {
                sigma = _ == null ? 1 : _;
                return dist;
            } else return sigma;
        },
        sample: ()=>sampleLogNormal(mu, sigma),
        pdf: (value)=>densityLogNormal(value, mu, sigma),
        cdf: (value)=>cumulativeLogNormal(value, mu, sigma),
        icdf: (p)=>quantileLogNormal(p, mu, sigma)
    };
    return dist.mean(mean).stdev(stdev);
}
function mixture(dists, weights) {
    let m = 0, w;
    function normalize(x) {
        const w = [];
        let sum = 0, i;
        for(i = 0; i < m; ++i)sum += w[i] = x[i] == null ? 1 : +x[i];
        for(i = 0; i < m; ++i)w[i] /= sum;
        return w;
    }
    const dist = {
        weights (_) {
            if (arguments.length) {
                w = normalize(weights = _ || []);
                return dist;
            }
            return weights;
        },
        distributions (_) {
            if (arguments.length) {
                if (_) {
                    m = _.length;
                    dists = _;
                } else {
                    m = 0;
                    dists = [];
                }
                return dist.weights(weights);
            }
            return dists;
        },
        sample () {
            const r = random();
            let d = dists[m - 1], v = w[0], i = 0;
            // first select distribution
            for(; i < m - 1; v += w[++i])if (r < v) {
                d = dists[i];
                break;
            }
            // then sample from it
            return d.sample();
        },
        pdf (x) {
            let p = 0, i = 0;
            for(; i < m; ++i)p += w[i] * dists[i].pdf(x);
            return p;
        },
        cdf (x) {
            let p = 0, i = 0;
            for(; i < m; ++i)p += w[i] * dists[i].cdf(x);
            return p;
        },
        icdf () {
            throw Error('Mixture icdf not supported.');
        }
    };
    return dist.distributions(dists).weights(weights);
}
function sampleUniform(min, max) {
    if (max == null) {
        max = min == null ? 1 : min;
        min = 0;
    }
    return min + (max - min) * random();
}
function densityUniform(value, min, max) {
    if (max == null) {
        max = min == null ? 1 : min;
        min = 0;
    }
    return value >= min && value <= max ? 1 / (max - min) : 0;
}
function cumulativeUniform(value, min, max) {
    if (max == null) {
        max = min == null ? 1 : min;
        min = 0;
    }
    return value < min ? 0 : value > max ? 1 : (value - min) / (max - min);
}
function quantileUniform(p, min, max) {
    if (max == null) {
        max = min == null ? 1 : min;
        min = 0;
    }
    return p >= 0 && p <= 1 ? min + p * (max - min) : NaN;
}
function uniform(min, max) {
    let a, b;
    const dist = {
        min (_) {
            if (arguments.length) {
                a = _ || 0;
                return dist;
            } else return a;
        },
        max (_) {
            if (arguments.length) {
                b = _ == null ? 1 : _;
                return dist;
            } else return b;
        },
        sample: ()=>sampleUniform(a, b),
        pdf: (value)=>densityUniform(value, a, b),
        cdf: (value)=>cumulativeUniform(value, a, b),
        icdf: (p)=>quantileUniform(p, a, b)
    };
    if (max == null) {
        max = min == null ? 1 : min;
        min = 0;
    }
    return dist.min(min).max(max);
}
function constant(data, x, y) {
    let mean = 0, n = 0;
    for (const d of data){
        const val = y(d);
        if (x(d) == null || val == null || isNaN(val)) continue;
        mean += (val - mean) / ++n;
    }
    return {
        coef: [
            mean
        ],
        predict: ()=>mean,
        rSquared: 0
    };
}
// Ordinary Least Squares
function ols(uX, uY, uXY, uX2) {
    const delta = uX2 - uX * uX, slope = Math.abs(delta) < 1e-24 ? 0 : (uXY - uX * uY) / delta, intercept = uY - slope * uX;
    return [
        intercept,
        slope
    ];
}
function points(data, x, y, sort) {
    data = data.filter((d)=>{
        let u = x(d), v = y(d);
        return u != null && (u = +u) >= u && v != null && (v = +v) >= v;
    });
    if (sort) data.sort((a, b)=>x(a) - x(b));
    const n = data.length, X = new Float64Array(n), Y = new Float64Array(n);
    // extract values, calculate means
    let i = 0, ux = 0, uy = 0, xv, yv, d;
    for (d of data){
        X[i] = xv = +x(d);
        Y[i] = yv = +y(d);
        ++i;
        ux += (xv - ux) / i;
        uy += (yv - uy) / i;
    }
    // mean center the data
    for(i = 0; i < n; ++i){
        X[i] -= ux;
        Y[i] -= uy;
    }
    return [
        X,
        Y,
        ux,
        uy
    ];
}
function visitPoints(data, x, y, callback) {
    let i = -1, u, v;
    for (const d of data){
        u = x(d);
        v = y(d);
        if (u != null && (u = +u) >= u && v != null && (v = +v) >= v) callback(u, v, ++i);
    }
}
// Adapted from d3-regression by Harry Stevens
// License: https://github.com/HarryStevens/d3-regression/blob/master/LICENSE
function rSquared(data, x, y, uY, predict) {
    let SSE = 0, SST = 0;
    visitPoints(data, x, y, (dx, dy)=>{
        const sse = dy - predict(dx), sst = dy - uY;
        SSE += sse * sse;
        SST += sst * sst;
    });
    return 1 - SSE / SST;
}
// Adapted from d3-regression by Harry Stevens
// License: https://github.com/HarryStevens/d3-regression/blob/master/LICENSE
function linear(data, x, y) {
    let X = 0, Y = 0, XY = 0, X2 = 0, n = 0;
    visitPoints(data, x, y, (dx, dy)=>{
        ++n;
        X += (dx - X) / n;
        Y += (dy - Y) / n;
        XY += (dx * dy - XY) / n;
        X2 += (dx * dx - X2) / n;
    });
    const coef = ols(X, Y, XY, X2), predict = (x)=>coef[0] + coef[1] * x;
    return {
        coef: coef,
        predict: predict,
        rSquared: rSquared(data, x, y, Y, predict)
    };
}
// Adapted from d3-regression by Harry Stevens
// License: https://github.com/HarryStevens/d3-regression/blob/master/LICENSE
function log(data, x, y) {
    let X = 0, Y = 0, XY = 0, X2 = 0, n = 0;
    visitPoints(data, x, y, (dx, dy)=>{
        ++n;
        dx = Math.log(dx);
        X += (dx - X) / n;
        Y += (dy - Y) / n;
        XY += (dx * dy - XY) / n;
        X2 += (dx * dx - X2) / n;
    });
    const coef = ols(X, Y, XY, X2), predict = (x)=>coef[0] + coef[1] * Math.log(x);
    return {
        coef: coef,
        predict: predict,
        rSquared: rSquared(data, x, y, Y, predict)
    };
}
function exp(data, x, y) {
    // eslint-disable-next-line no-unused-vars
    const [xv, yv, ux, uy] = points(data, x, y);
    let YL = 0, XY = 0, XYL = 0, X2Y = 0, n = 0, dx, ly, xy;
    visitPoints(data, x, y, (_, dy)=>{
        dx = xv[n++];
        ly = Math.log(dy);
        xy = dx * dy;
        YL += (dy * ly - YL) / n;
        XY += (xy - XY) / n;
        XYL += (xy * ly - XYL) / n;
        X2Y += (dx * xy - X2Y) / n;
    });
    const [c0, c1] = ols(XY / uy, YL / uy, XYL / uy, X2Y / uy), predict = (x)=>Math.exp(c0 + c1 * (x - ux));
    return {
        coef: [
            Math.exp(c0 - c1 * ux),
            c1
        ],
        predict: predict,
        rSquared: rSquared(data, x, y, uy, predict)
    };
}
// Adapted from d3-regression by Harry Stevens
// License: https://github.com/HarryStevens/d3-regression/blob/master/LICENSE
function pow(data, x, y) {
    let X = 0, Y = 0, XY = 0, X2 = 0, YS = 0, n = 0;
    visitPoints(data, x, y, (dx, dy)=>{
        const lx = Math.log(dx), ly = Math.log(dy);
        ++n;
        X += (lx - X) / n;
        Y += (ly - Y) / n;
        XY += (lx * ly - XY) / n;
        X2 += (lx * lx - X2) / n;
        YS += (dy - YS) / n;
    });
    const coef = ols(X, Y, XY, X2), predict = (x)=>coef[0] * Math.pow(x, coef[1]);
    coef[0] = Math.exp(coef[0]);
    return {
        coef: coef,
        predict: predict,
        rSquared: rSquared(data, x, y, YS, predict)
    };
}
function quad(data, x, y) {
    const [xv, yv, ux, uy] = points(data, x, y), n = xv.length;
    let X2 = 0, X3 = 0, X4 = 0, XY = 0, X2Y = 0, i, dx, dy, x2;
    for(i = 0; i < n;){
        dx = xv[i];
        dy = yv[i++];
        x2 = dx * dx;
        X2 += (x2 - X2) / i;
        X3 += (x2 * dx - X3) / i;
        X4 += (x2 * x2 - X4) / i;
        XY += (dx * dy - XY) / i;
        X2Y += (x2 * dy - X2Y) / i;
    }
    const X2X2 = X4 - X2 * X2, d = X2 * X2X2 - X3 * X3, a = (X2Y * X2 - XY * X3) / d, b = (XY * X2X2 - X2Y * X3) / d, c = -a * X2, predict = (x)=>{
        x = x - ux;
        return a * x * x + b * x + c + uy;
    };
    // transform coefficients back from mean-centered space
    return {
        coef: [
            c - b * ux + a * ux * ux + uy,
            b - 2 * a * ux,
            a
        ],
        predict: predict,
        rSquared: rSquared(data, x, y, uy, predict)
    };
}
// Adapted from d3-regression by Harry Stevens
// License: https://github.com/HarryStevens/d3-regression/blob/master/LICENSE
// ... which was adapted from regression-js by Tom Alexander
// Source: https://github.com/Tom-Alexander/regression-js/blob/master/src/regression.js#L246
// License: https://github.com/Tom-Alexander/regression-js/blob/master/LICENSE
function poly(data, x, y, order) {
    // use more efficient methods for lower orders
    if (order === 0) return constant(data, x, y);
    if (order === 1) return linear(data, x, y);
    if (order === 2) return quad(data, x, y);
    const [xv, yv, ux, uy] = points(data, x, y), n = xv.length, lhs = [], rhs = [], k = order + 1;
    let i, j, l, v, c;
    for(i = 0; i < k; ++i){
        for(l = 0, v = 0; l < n; ++l)v += Math.pow(xv[l], i) * yv[l];
        lhs.push(v);
        c = new Float64Array(k);
        for(j = 0; j < k; ++j){
            for(l = 0, v = 0; l < n; ++l)v += Math.pow(xv[l], i + j);
            c[j] = v;
        }
        rhs.push(c);
    }
    rhs.push(lhs);
    const coef = gaussianElimination(rhs), predict = (x)=>{
        x -= ux;
        let y = uy + coef[0] + coef[1] * x + coef[2] * x * x;
        for(i = 3; i < k; ++i)y += coef[i] * Math.pow(x, i);
        return y;
    };
    return {
        coef: uncenter(k, coef, -ux, uy),
        predict: predict,
        rSquared: rSquared(data, x, y, uy, predict)
    };
}
function uncenter(k, a, x, y) {
    const z = Array(k);
    let i, j, v, c;
    // initialize to zero
    for(i = 0; i < k; ++i)z[i] = 0;
    // polynomial expansion
    for(i = k - 1; i >= 0; --i){
        v = a[i];
        c = 1;
        z[i] += v;
        for(j = 1; j <= i; ++j){
            c *= (i + 1 - j) / j; // binomial coefficent
            z[i - j] += v * Math.pow(x, j) * c;
        }
    }
    // bias term
    z[0] += y;
    return z;
}
// Given an array for a two-dimensional matrix and the polynomial order,
// solve A * x = b using Gaussian elimination.
function gaussianElimination(matrix) {
    const n = matrix.length - 1, coef = [];
    let i, j, k, r, t;
    for(i = 0; i < n; ++i){
        r = i; // max row
        for(j = i + 1; j < n; ++j)if (Math.abs(matrix[i][j]) > Math.abs(matrix[i][r])) r = j;
        for(k = i; k < n + 1; ++k){
            t = matrix[k][i];
            matrix[k][i] = matrix[k][r];
            matrix[k][r] = t;
        }
        for(j = i + 1; j < n; ++j)for(k = n; k >= i; k--)matrix[k][j] -= matrix[k][i] * matrix[i][j] / matrix[i][i];
    }
    for(j = n - 1; j >= 0; --j){
        t = 0;
        for(k = j + 1; k < n; ++k)t += matrix[k][j] * coef[k];
        coef[j] = (matrix[n][j] - t) / matrix[j][j];
    }
    return coef;
}
const maxiters = 2, epsilon = 1e-12;
// Adapted from science.js by Jason Davies
// Source: https://github.com/jasondavies/science.js/blob/master/src/stats/loess.js
// License: https://github.com/jasondavies/science.js/blob/master/LICENSE
function loess(data, x, y, bandwidth) {
    const [xv, yv, ux, uy] = points(data, x, y, true), n = xv.length, bw = Math.max(2, ~~(bandwidth * n)), // # nearest neighbors
    yhat = new Float64Array(n), residuals = new Float64Array(n), robustWeights = new Float64Array(n).fill(1);
    for(let iter = -1; ++iter <= maxiters;){
        const interval = [
            0,
            bw - 1
        ];
        for(let i = 0; i < n; ++i){
            const dx = xv[i], i0 = interval[0], i1 = interval[1], edge = dx - xv[i0] > xv[i1] - dx ? i0 : i1;
            let W = 0, X = 0, Y = 0, XY = 0, X2 = 0;
            const denom = 1 / Math.abs(xv[edge] - dx || 1); // avoid singularity!
            for(let k = i0; k <= i1; ++k){
                const xk = xv[k], yk = yv[k], w = tricube(Math.abs(dx - xk) * denom) * robustWeights[k], xkw = xk * w;
                W += w;
                X += xkw;
                Y += yk * w;
                XY += yk * xkw;
                X2 += xk * xkw;
            }
            // linear regression fit
            const [a, b] = ols(X / W, Y / W, XY / W, X2 / W);
            yhat[i] = a + b * dx;
            residuals[i] = Math.abs(yv[i] - yhat[i]);
            updateInterval(xv, i + 1, interval);
        }
        if (iter === maxiters) break;
        const medianResidual = (0, _d3Array.median)(residuals);
        if (Math.abs(medianResidual) < epsilon) break;
        for(let i = 0, arg, w; i < n; ++i){
            arg = residuals[i] / (6 * medianResidual);
            // default to epsilon (rather than zero) for large deviations
            // keeping weights tiny but non-zero prevents singularites
            robustWeights[i] = arg >= 1 ? epsilon : (w = 1 - arg * arg) * w;
        }
    }
    return output(xv, yhat, ux, uy);
}
// weighting kernel for local regression
function tricube(x) {
    return (x = 1 - x * x * x) * x * x;
}
// advance sliding window interval of nearest neighbors
function updateInterval(xv, i, interval) {
    const val = xv[i];
    let left = interval[0], right = interval[1] + 1;
    if (right >= xv.length) return;
    // step right if distance to new right edge is <= distance to old left edge
    // step when distance is equal to ensure movement over duplicate x values
    while(i > left && xv[right] - val <= val - xv[left]){
        interval[0] = ++left;
        interval[1] = right;
        ++right;
    }
}
// generate smoothed output points
// average points with repeated x values
function output(xv, yhat, ux, uy) {
    const n = xv.length, out = [];
    let i = 0, cnt = 0, prev = [], v;
    for(; i < n; ++i){
        v = xv[i] + ux;
        if (prev[0] === v) // average output values via online update
        prev[1] += (yhat[i] - prev[1]) / ++cnt;
        else {
            // add new output point
            cnt = 0;
            prev[1] += uy;
            prev = [
                v,
                yhat[i]
            ];
            out.push(prev);
        }
    }
    prev[1] += uy;
    return out;
}
// subdivide up to accuracy of 0.5 degrees
const MIN_RADIANS = 0.5 * Math.PI / 180;
// Adaptively sample an interpolated function over a domain extent
function sampleCurve(f, extent, minSteps, maxSteps) {
    minSteps = minSteps || 25;
    maxSteps = Math.max(minSteps, maxSteps || 200);
    const point = (x)=>[
            x,
            f(x)
        ], minX = extent[0], maxX = extent[1], span = maxX - minX, stop = span / maxSteps, prev = [
        point(minX)
    ], next = [];
    if (minSteps === maxSteps) {
        // no adaptation, sample uniform grid directly and return
        for(let i = 1; i < maxSteps; ++i)prev.push(point(minX + i / minSteps * span));
        prev.push(point(maxX));
        return prev;
    } else {
        // sample minimum points on uniform grid
        // then move on to perform adaptive refinement
        next.push(point(maxX));
        for(let i = minSteps; --i > 0;)next.push(point(minX + i / minSteps * span));
    }
    let p0 = prev[0];
    let p1 = next[next.length - 1];
    const sx = 1 / span;
    const sy = scaleY(p0[1], next);
    while(p1){
        // midpoint for potential curve subdivision
        const pm = point((p0[0] + p1[0]) / 2);
        const dx = pm[0] - p0[0] >= stop;
        if (dx && angleDelta(p0, pm, p1, sx, sy) > MIN_RADIANS) // maximum resolution has not yet been met, and
        // subdivision midpoint is sufficiently different from endpoint
        // save subdivision, push midpoint onto the visitation stack
        next.push(pm);
        else {
            // subdivision midpoint sufficiently similar to endpoint
            // skip subdivision, store endpoint, move to next point on the stack
            p0 = p1;
            prev.push(p1);
            next.pop();
        }
        p1 = next[next.length - 1];
    }
    return prev;
}
function scaleY(init, points) {
    let ymin = init;
    let ymax = init;
    const n = points.length;
    for(let i = 0; i < n; ++i){
        const y = points[i][1];
        if (y < ymin) ymin = y;
        if (y > ymax) ymax = y;
    }
    return 1 / (ymax - ymin);
}
function angleDelta(p, q, r, sx, sy) {
    const a0 = Math.atan2(sy * (r[1] - p[1]), sx * (r[0] - p[0])), a1 = Math.atan2(sy * (q[1] - p[1]), sx * (q[0] - p[0]));
    return Math.abs(a0 - a1);
}

},{"d3-array":[["ascending","5oHFB","default"],["deviation","bQRNb","default"],["median","6LRay","default"],["quantile","8eCyE","default"],["quantileSorted","8eCyE"]],"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bQRNb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>deviation);
var _varianceJs = require("./variance.js");
var _varianceJsDefault = parcelHelpers.interopDefault(_varianceJs);
function deviation(values, valueof) {
    const v = (0, _varianceJsDefault.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

},{"./variance.js":"gLZ5G","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"gLZ5G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>variance);
function variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"6LRay":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>median);
parcelHelpers.export(exports, "medianIndex", ()=>medianIndex);
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
function median(values, valueof) {
    return (0, _quantileJsDefault.default)(values, 0.5, valueof);
}
function medianIndex(values, valueof) {
    return (0, _quantileJs.quantileIndex)(values, 0.5, valueof);
}

},{"./quantile.js":"8eCyE","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8eCyE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantile);
parcelHelpers.export(exports, "quantileSorted", ()=>quantileSorted);
parcelHelpers.export(exports, "quantileIndex", ()=>quantileIndex);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _maxIndexJs = require("./maxIndex.js");
var _maxIndexJsDefault = parcelHelpers.interopDefault(_maxIndexJs);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
var _minIndexJs = require("./minIndex.js");
var _minIndexJsDefault = parcelHelpers.interopDefault(_minIndexJs);
var _quickselectJs = require("./quickselect.js");
var _quickselectJsDefault = parcelHelpers.interopDefault(_quickselectJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _sortJs = require("./sort.js");
var _greatestJs = require("./greatest.js");
var _greatestJsDefault = parcelHelpers.interopDefault(_greatestJs);
function quantile(values, p, valueof) {
    values = Float64Array.from((0, _numberJs.numbers)(values, valueof));
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return (0, _minJsDefault.default)(values);
    if (p >= 1) return (0, _maxJsDefault.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, _maxJsDefault.default)((0, _quickselectJsDefault.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, _minJsDefault.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function quantileSorted(values, p, valueof = (0, _numberJsDefault.default)) {
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}
function quantileIndex(values, p, valueof = (0, _numberJsDefault.default)) {
    if (isNaN(p = +p)) return;
    numbers = Float64Array.from(values, (_, i)=>(0, _numberJsDefault.default)(valueof(values[i], i, values)));
    if (p <= 0) return (0, _minIndexJsDefault.default)(numbers);
    if (p >= 1) return (0, _maxIndexJsDefault.default)(numbers);
    var numbers, index = Uint32Array.from(values, (_, i)=>i), j = numbers.length - 1, i = Math.floor(j * p);
    (0, _quickselectJsDefault.default)(index, i, 0, j, (i, j)=>(0, _sortJs.ascendingDefined)(numbers[i], numbers[j]));
    i = (0, _greatestJsDefault.default)(index.subarray(0, i + 1), (i)=>numbers[i]);
    return i >= 0 ? i : -1;
}

},{"./max.js":"cV45R","./maxIndex.js":"aQNPD","./min.js":"h7wqP","./minIndex.js":"lPZBV","./quickselect.js":"3wJSJ","./number.js":"2plWJ","./sort.js":"ias4a","./greatest.js":"7GqVA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cV45R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>max);
function max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"aQNPD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>maxIndex);
function maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"h7wqP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>min);
function min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"lPZBV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>minIndex);
function minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3wJSJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quickselect);
var _sortJs = require("./sort.js");
function quickselect(array, k, left = 0, right = Infinity, compare) {
    k = Math.floor(k);
    left = Math.floor(Math.max(0, left));
    right = Math.floor(Math.min(array.length - 1, right));
    if (!(left <= k && k <= right)) return array;
    compare = compare === undefined ? (0, _sortJs.ascendingDefined) : (0, _sortJs.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        swap(array, left, k);
        if (compare(array[right], t) > 0) swap(array, left, right);
        while(i < j){
            swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) swap(array, left, j);
        else ++j, swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

},{"./sort.js":"ias4a","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"ias4a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sort);
parcelHelpers.export(exports, "compareDefined", ()=>compareDefined);
parcelHelpers.export(exports, "ascendingDefined", ()=>ascendingDefined);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _permuteJs = require("./permute.js");
var _permuteJsDefault = parcelHelpers.interopDefault(_permuteJs);
function sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>ascendingDefined(f[i], f[j]));
        }
        return (0, _permuteJsDefault.default)(values, index);
    }
    return values.sort(compareDefined(f));
}
function compareDefined(compare = (0, _ascendingJsDefault.default)) {
    if (compare === (0, _ascendingJsDefault.default)) return ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

},{"./ascending.js":"5oHFB","./permute.js":"bvoXq","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bvoXq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>permute);
function permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"2plWJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>number);
parcelHelpers.export(exports, "numbers", ()=>numbers);
function number(x) {
    return x === null ? NaN : +x;
}
function* numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"7GqVA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>greatest);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
function greatest(values, compare = (0, _ascendingJsDefault.default)) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, _ascendingJsDefault.default)(value, maxValue) > 0 : (0, _ascendingJsDefault.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

},{"./ascending.js":"5oHFB","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"ktdME":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisect", ()=>(0, _bisectJsDefault.default));
parcelHelpers.export(exports, "bisectRight", ()=>(0, _bisectJs.bisectRight));
parcelHelpers.export(exports, "bisectLeft", ()=>(0, _bisectJs.bisectLeft));
parcelHelpers.export(exports, "bisectCenter", ()=>(0, _bisectJs.bisectCenter));
parcelHelpers.export(exports, "ascending", ()=>(0, _ascendingJsDefault.default));
parcelHelpers.export(exports, "bisector", ()=>(0, _bisectorJsDefault.default));
parcelHelpers.export(exports, "blur", ()=>(0, _blurJs.blur));
parcelHelpers.export(exports, "blur2", ()=>(0, _blurJs.blur2));
parcelHelpers.export(exports, "blurImage", ()=>(0, _blurJs.blurImage));
parcelHelpers.export(exports, "count", ()=>(0, _countJsDefault.default));
parcelHelpers.export(exports, "cross", ()=>(0, _crossJsDefault.default));
parcelHelpers.export(exports, "cumsum", ()=>(0, _cumsumJsDefault.default));
parcelHelpers.export(exports, "descending", ()=>(0, _descendingJsDefault.default));
parcelHelpers.export(exports, "deviation", ()=>(0, _deviationJsDefault.default));
parcelHelpers.export(exports, "extent", ()=>(0, _extentJsDefault.default));
parcelHelpers.export(exports, "Adder", ()=>(0, _fsumJs.Adder));
parcelHelpers.export(exports, "fsum", ()=>(0, _fsumJs.fsum));
parcelHelpers.export(exports, "fcumsum", ()=>(0, _fsumJs.fcumsum));
parcelHelpers.export(exports, "group", ()=>(0, _groupJsDefault.default));
parcelHelpers.export(exports, "flatGroup", ()=>(0, _groupJs.flatGroup));
parcelHelpers.export(exports, "flatRollup", ()=>(0, _groupJs.flatRollup));
parcelHelpers.export(exports, "groups", ()=>(0, _groupJs.groups));
parcelHelpers.export(exports, "index", ()=>(0, _groupJs.index));
parcelHelpers.export(exports, "indexes", ()=>(0, _groupJs.indexes));
parcelHelpers.export(exports, "rollup", ()=>(0, _groupJs.rollup));
parcelHelpers.export(exports, "rollups", ()=>(0, _groupJs.rollups));
parcelHelpers.export(exports, "groupSort", ()=>(0, _groupSortJsDefault.default));
parcelHelpers.export(exports, "bin", ()=>(0, _binJsDefault.default)) // Deprecated; use bin.
;
parcelHelpers.export(exports, "histogram", ()=>(0, _binJsDefault.default));
parcelHelpers.export(exports, "thresholdFreedmanDiaconis", ()=>(0, _freedmanDiaconisJsDefault.default));
parcelHelpers.export(exports, "thresholdScott", ()=>(0, _scottJsDefault.default));
parcelHelpers.export(exports, "thresholdSturges", ()=>(0, _sturgesJsDefault.default));
parcelHelpers.export(exports, "max", ()=>(0, _maxJsDefault.default));
parcelHelpers.export(exports, "maxIndex", ()=>(0, _maxIndexJsDefault.default));
parcelHelpers.export(exports, "mean", ()=>(0, _meanJsDefault.default));
parcelHelpers.export(exports, "median", ()=>(0, _medianJsDefault.default));
parcelHelpers.export(exports, "medianIndex", ()=>(0, _medianJs.medianIndex));
parcelHelpers.export(exports, "merge", ()=>(0, _mergeJsDefault.default));
parcelHelpers.export(exports, "min", ()=>(0, _minJsDefault.default));
parcelHelpers.export(exports, "minIndex", ()=>(0, _minIndexJsDefault.default));
parcelHelpers.export(exports, "mode", ()=>(0, _modeJsDefault.default));
parcelHelpers.export(exports, "nice", ()=>(0, _niceJsDefault.default));
parcelHelpers.export(exports, "pairs", ()=>(0, _pairsJsDefault.default));
parcelHelpers.export(exports, "permute", ()=>(0, _permuteJsDefault.default));
parcelHelpers.export(exports, "quantile", ()=>(0, _quantileJsDefault.default));
parcelHelpers.export(exports, "quantileIndex", ()=>(0, _quantileJs.quantileIndex));
parcelHelpers.export(exports, "quantileSorted", ()=>(0, _quantileJs.quantileSorted));
parcelHelpers.export(exports, "quickselect", ()=>(0, _quickselectJsDefault.default));
parcelHelpers.export(exports, "range", ()=>(0, _rangeJsDefault.default));
parcelHelpers.export(exports, "rank", ()=>(0, _rankJsDefault.default));
parcelHelpers.export(exports, "least", ()=>(0, _leastJsDefault.default));
parcelHelpers.export(exports, "leastIndex", ()=>(0, _leastIndexJsDefault.default));
parcelHelpers.export(exports, "greatest", ()=>(0, _greatestJsDefault.default));
parcelHelpers.export(exports, "greatestIndex", ()=>(0, _greatestIndexJsDefault.default));
parcelHelpers.export(exports, "scan", ()=>(0, _scanJsDefault.default)) // Deprecated; use leastIndex.
;
parcelHelpers.export(exports, "shuffle", ()=>(0, _shuffleJsDefault.default));
parcelHelpers.export(exports, "shuffler", ()=>(0, _shuffleJs.shuffler));
parcelHelpers.export(exports, "sum", ()=>(0, _sumJsDefault.default));
parcelHelpers.export(exports, "ticks", ()=>(0, _ticksJsDefault.default));
parcelHelpers.export(exports, "tickIncrement", ()=>(0, _ticksJs.tickIncrement));
parcelHelpers.export(exports, "tickStep", ()=>(0, _ticksJs.tickStep));
parcelHelpers.export(exports, "transpose", ()=>(0, _transposeJsDefault.default));
parcelHelpers.export(exports, "variance", ()=>(0, _varianceJsDefault.default));
parcelHelpers.export(exports, "zip", ()=>(0, _zipJsDefault.default));
parcelHelpers.export(exports, "every", ()=>(0, _everyJsDefault.default));
parcelHelpers.export(exports, "some", ()=>(0, _someJsDefault.default));
parcelHelpers.export(exports, "filter", ()=>(0, _filterJsDefault.default));
parcelHelpers.export(exports, "map", ()=>(0, _mapJsDefault.default));
parcelHelpers.export(exports, "reduce", ()=>(0, _reduceJsDefault.default));
parcelHelpers.export(exports, "reverse", ()=>(0, _reverseJsDefault.default));
parcelHelpers.export(exports, "sort", ()=>(0, _sortJsDefault.default));
parcelHelpers.export(exports, "difference", ()=>(0, _differenceJsDefault.default));
parcelHelpers.export(exports, "disjoint", ()=>(0, _disjointJsDefault.default));
parcelHelpers.export(exports, "intersection", ()=>(0, _intersectionJsDefault.default));
parcelHelpers.export(exports, "subset", ()=>(0, _subsetJsDefault.default));
parcelHelpers.export(exports, "superset", ()=>(0, _supersetJsDefault.default));
parcelHelpers.export(exports, "union", ()=>(0, _unionJsDefault.default));
parcelHelpers.export(exports, "InternMap", ()=>(0, _internmap.InternMap));
parcelHelpers.export(exports, "InternSet", ()=>(0, _internmap.InternSet));
var _bisectJs = require("./bisect.js");
var _bisectJsDefault = parcelHelpers.interopDefault(_bisectJs);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _bisectorJs = require("./bisector.js");
var _bisectorJsDefault = parcelHelpers.interopDefault(_bisectorJs);
var _blurJs = require("./blur.js");
var _countJs = require("./count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _crossJs = require("./cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _cumsumJs = require("./cumsum.js");
var _cumsumJsDefault = parcelHelpers.interopDefault(_cumsumJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _deviationJs = require("./deviation.js");
var _deviationJsDefault = parcelHelpers.interopDefault(_deviationJs);
var _extentJs = require("./extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _fsumJs = require("./fsum.js");
var _groupJs = require("./group.js");
var _groupJsDefault = parcelHelpers.interopDefault(_groupJs);
var _groupSortJs = require("./groupSort.js");
var _groupSortJsDefault = parcelHelpers.interopDefault(_groupSortJs);
var _binJs = require("./bin.js");
var _binJsDefault = parcelHelpers.interopDefault(_binJs);
var _freedmanDiaconisJs = require("./threshold/freedmanDiaconis.js");
var _freedmanDiaconisJsDefault = parcelHelpers.interopDefault(_freedmanDiaconisJs);
var _scottJs = require("./threshold/scott.js");
var _scottJsDefault = parcelHelpers.interopDefault(_scottJs);
var _sturgesJs = require("./threshold/sturges.js");
var _sturgesJsDefault = parcelHelpers.interopDefault(_sturgesJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _maxIndexJs = require("./maxIndex.js");
var _maxIndexJsDefault = parcelHelpers.interopDefault(_maxIndexJs);
var _meanJs = require("./mean.js");
var _meanJsDefault = parcelHelpers.interopDefault(_meanJs);
var _medianJs = require("./median.js");
var _medianJsDefault = parcelHelpers.interopDefault(_medianJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
var _minIndexJs = require("./minIndex.js");
var _minIndexJsDefault = parcelHelpers.interopDefault(_minIndexJs);
var _modeJs = require("./mode.js");
var _modeJsDefault = parcelHelpers.interopDefault(_modeJs);
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _pairsJs = require("./pairs.js");
var _pairsJsDefault = parcelHelpers.interopDefault(_pairsJs);
var _permuteJs = require("./permute.js");
var _permuteJsDefault = parcelHelpers.interopDefault(_permuteJs);
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
var _quickselectJs = require("./quickselect.js");
var _quickselectJsDefault = parcelHelpers.interopDefault(_quickselectJs);
var _rangeJs = require("./range.js");
var _rangeJsDefault = parcelHelpers.interopDefault(_rangeJs);
var _rankJs = require("./rank.js");
var _rankJsDefault = parcelHelpers.interopDefault(_rankJs);
var _leastJs = require("./least.js");
var _leastJsDefault = parcelHelpers.interopDefault(_leastJs);
var _leastIndexJs = require("./leastIndex.js");
var _leastIndexJsDefault = parcelHelpers.interopDefault(_leastIndexJs);
var _greatestJs = require("./greatest.js");
var _greatestJsDefault = parcelHelpers.interopDefault(_greatestJs);
var _greatestIndexJs = require("./greatestIndex.js");
var _greatestIndexJsDefault = parcelHelpers.interopDefault(_greatestIndexJs);
var _scanJs = require("./scan.js");
var _scanJsDefault = parcelHelpers.interopDefault(_scanJs);
var _shuffleJs = require("./shuffle.js");
var _shuffleJsDefault = parcelHelpers.interopDefault(_shuffleJs);
var _sumJs = require("./sum.js");
var _sumJsDefault = parcelHelpers.interopDefault(_sumJs);
var _ticksJs = require("./ticks.js");
var _ticksJsDefault = parcelHelpers.interopDefault(_ticksJs);
var _transposeJs = require("./transpose.js");
var _transposeJsDefault = parcelHelpers.interopDefault(_transposeJs);
var _varianceJs = require("./variance.js");
var _varianceJsDefault = parcelHelpers.interopDefault(_varianceJs);
var _zipJs = require("./zip.js");
var _zipJsDefault = parcelHelpers.interopDefault(_zipJs);
var _everyJs = require("./every.js");
var _everyJsDefault = parcelHelpers.interopDefault(_everyJs);
var _someJs = require("./some.js");
var _someJsDefault = parcelHelpers.interopDefault(_someJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _differenceJs = require("./difference.js");
var _differenceJsDefault = parcelHelpers.interopDefault(_differenceJs);
var _disjointJs = require("./disjoint.js");
var _disjointJsDefault = parcelHelpers.interopDefault(_disjointJs);
var _intersectionJs = require("./intersection.js");
var _intersectionJsDefault = parcelHelpers.interopDefault(_intersectionJs);
var _subsetJs = require("./subset.js");
var _subsetJsDefault = parcelHelpers.interopDefault(_subsetJs);
var _supersetJs = require("./superset.js");
var _supersetJsDefault = parcelHelpers.interopDefault(_supersetJs);
var _unionJs = require("./union.js");
var _unionJsDefault = parcelHelpers.interopDefault(_unionJs);
var _internmap = require("internmap");

},{"./bisect.js":"8oF0X","./ascending.js":"5oHFB","./bisector.js":"iWiWc","./blur.js":"d0sCI","./count.js":"czIvW","./cross.js":"a4ekl","./cumsum.js":"e1Sxv","./descending.js":"b5z4b","./deviation.js":"bQRNb","./extent.js":"49ZXb","./fsum.js":"aPoQh","./group.js":"7C3MB","./groupSort.js":"4cn39","./bin.js":"cpOMI","./threshold/freedmanDiaconis.js":"cyv81","./threshold/scott.js":"hXHz6","./threshold/sturges.js":"81Iww","./max.js":"cV45R","./maxIndex.js":"aQNPD","./mean.js":"l2RxB","./median.js":"6LRay","./merge.js":"8UWhT","./min.js":"h7wqP","./minIndex.js":"lPZBV","./mode.js":"3kfTS","./nice.js":"2pwW2","./pairs.js":"5aUC0","./permute.js":"bvoXq","./quantile.js":"8eCyE","./quickselect.js":"3wJSJ","./range.js":"2Qa4a","./rank.js":"5n6MW","./least.js":"4j6hM","./leastIndex.js":"ay1Yt","./greatest.js":"7GqVA","./greatestIndex.js":"kl676","./scan.js":"9WetR","./shuffle.js":"e2ePE","./sum.js":"l8cYr","./ticks.js":"4kdy4","./transpose.js":"4CYvd","./variance.js":"gLZ5G","./zip.js":"6IFvY","./every.js":"c3ux9","./some.js":"hj6mC","./filter.js":"3vkur","./map.js":"6lOcv","./reduce.js":"loxTK","./reverse.js":"8Ykum","./sort.js":"ias4a","./difference.js":"4WPNr","./disjoint.js":"0K7OT","./intersection.js":"77dMh","./subset.js":"5E6i1","./superset.js":"ejV6u","./union.js":"6iv1Q","internmap":"5EkCg","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8oF0X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisectRight", ()=>bisectRight);
parcelHelpers.export(exports, "bisectLeft", ()=>bisectLeft);
parcelHelpers.export(exports, "bisectCenter", ()=>bisectCenter);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _bisectorJs = require("./bisector.js");
var _bisectorJsDefault = parcelHelpers.interopDefault(_bisectorJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
const ascendingBisect = (0, _bisectorJsDefault.default)((0, _ascendingJsDefault.default));
const bisectRight = ascendingBisect.right;
const bisectLeft = ascendingBisect.left;
const bisectCenter = (0, _bisectorJsDefault.default)((0, _numberJsDefault.default)).center;
exports.default = bisectRight;

},{"./ascending.js":"5oHFB","./bisector.js":"iWiWc","./number.js":"2plWJ","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"d0sCI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "blur", ()=>blur);
parcelHelpers.export(exports, "blur2", ()=>blur2);
parcelHelpers.export(exports, "blurImage", ()=>blurImage);
function blur(values, r) {
    if (!((r = +r) >= 0)) throw new RangeError("invalid r");
    let length = values.length;
    if (!((length = Math.floor(length)) >= 0)) throw new RangeError("invalid length");
    if (!length || !r) return values;
    const blur = blurf(r);
    const temp = values.slice();
    blur(values, temp, 0, length, 1);
    blur(temp, values, 0, length, 1);
    blur(values, temp, 0, length, 1);
    return values;
}
const blur2 = Blur2(blurf);
const blurImage = Blur2(blurfImage);
function Blur2(blur) {
    return function(data, rx, ry = rx) {
        if (!((rx = +rx) >= 0)) throw new RangeError("invalid rx");
        if (!((ry = +ry) >= 0)) throw new RangeError("invalid ry");
        let { data: values, width, height } = data;
        if (!((width = Math.floor(width)) >= 0)) throw new RangeError("invalid width");
        if (!((height = Math.floor(height !== undefined ? height : values.length / width)) >= 0)) throw new RangeError("invalid height");
        if (!width || !height || !rx && !ry) return data;
        const blurx = rx && blur(rx);
        const blury = ry && blur(ry);
        const temp = values.slice();
        if (blurx && blury) {
            blurh(blurx, temp, values, width, height);
            blurh(blurx, values, temp, width, height);
            blurh(blurx, temp, values, width, height);
            blurv(blury, values, temp, width, height);
            blurv(blury, temp, values, width, height);
            blurv(blury, values, temp, width, height);
        } else if (blurx) {
            blurh(blurx, values, temp, width, height);
            blurh(blurx, temp, values, width, height);
            blurh(blurx, values, temp, width, height);
        } else if (blury) {
            blurv(blury, values, temp, width, height);
            blurv(blury, temp, values, width, height);
            blurv(blury, values, temp, width, height);
        }
        return data;
    };
}
function blurh(blur, T, S, w, h) {
    for(let y = 0, n = w * h; y < n;)blur(T, S, y, y += w, 1);
}
function blurv(blur, T, S, w, h) {
    for(let x = 0, n = w * h; x < w; ++x)blur(T, S, x, x + n, w);
}
function blurfImage(radius) {
    const blur = blurf(radius);
    return (T, S, start, stop, step)=>{
        start <<= 2, stop <<= 2, step <<= 2;
        blur(T, S, start + 0, stop + 0, step);
        blur(T, S, start + 1, stop + 1, step);
        blur(T, S, start + 2, stop + 2, step);
        blur(T, S, start + 3, stop + 3, step);
    };
}
// Given a target array T, a source array S, sets each value T[i] to the average
// of {S[i - r], …, S[i], …, S[i + r]}, where r = ⌊radius⌋, start <= i < stop,
// for each i, i + step, i + 2 * step, etc., and where S[j] is clamped between
// S[start] (inclusive) and S[stop] (exclusive). If the given radius is not an
// integer, S[i - r - 1] and S[i + r + 1] are added to the sum, each weighted
// according to r - ⌊radius⌋.
function blurf(radius) {
    const radius0 = Math.floor(radius);
    if (radius0 === radius) return bluri(radius);
    const t = radius - radius0;
    const w = 2 * radius + 1;
    return (T, S, start, stop, step)=>{
        if (!((stop -= step) >= start)) return; // inclusive stop
        let sum = radius0 * S[start];
        const s0 = step * radius0;
        const s1 = s0 + step;
        for(let i = start, j = start + s0; i < j; i += step)sum += S[Math.min(stop, i)];
        for(let i = start, j = stop; i <= j; i += step){
            sum += S[Math.min(stop, i + s0)];
            T[i] = (sum + t * (S[Math.max(start, i - s1)] + S[Math.min(stop, i + s1)])) / w;
            sum -= S[Math.max(start, i - s0)];
        }
    };
}
// Like blurf, but optimized for integer radius.
function bluri(radius) {
    const w = 2 * radius + 1;
    return (T, S, start, stop, step)=>{
        if (!((stop -= step) >= start)) return; // inclusive stop
        let sum = radius * S[start];
        const s = step * radius;
        for(let i = start, j = start + s; i < j; i += step)sum += S[Math.min(stop, i)];
        for(let i = start, j = stop; i <= j; i += step){
            sum += S[Math.min(stop, i + s)];
            T[i] = sum / w;
            sum -= S[Math.max(start, i - s)];
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"czIvW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>count);
function count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"a4ekl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cross);
function length(array) {
    return array.length | 0;
}
function empty(length) {
    return !(length > 0);
}
function arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function reducer(reduce) {
    return (values)=>reduce(...values);
}
function cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && reducer(values.pop());
    values = values.map(arrayify);
    const lengths = values.map(length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some(empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"e1Sxv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cumsum);
function cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"49ZXb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>extent);
function extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"aPoQh":[function(require,module,exports,__globalThis) {
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Adder", ()=>Adder);
parcelHelpers.export(exports, "fsum", ()=>fsum);
parcelHelpers.export(exports, "fcumsum", ()=>fcumsum);
class Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
function fsum(values, valueof) {
    const adder = new Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function fcumsum(values, valueof) {
    const adder = new Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"7C3MB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>group);
parcelHelpers.export(exports, "groups", ()=>groups);
parcelHelpers.export(exports, "flatGroup", ()=>flatGroup);
parcelHelpers.export(exports, "flatRollup", ()=>flatRollup);
parcelHelpers.export(exports, "rollup", ()=>rollup);
parcelHelpers.export(exports, "rollups", ()=>rollups);
parcelHelpers.export(exports, "index", ()=>index);
parcelHelpers.export(exports, "indexes", ()=>indexes);
var _internmap = require("internmap");
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
function group(values, ...keys) {
    return nest(values, (0, _identityJsDefault.default), (0, _identityJsDefault.default), keys);
}
function groups(values, ...keys) {
    return nest(values, Array.from, (0, _identityJsDefault.default), keys);
}
function flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function flatGroup(values, ...keys) {
    return flatten(groups(values, ...keys), keys);
}
function flatRollup(values, reduce, ...keys) {
    return flatten(rollups(values, reduce, ...keys), keys);
}
function rollup(values, reduce, ...keys) {
    return nest(values, (0, _identityJsDefault.default), reduce, keys);
}
function rollups(values, reduce, ...keys) {
    return nest(values, Array.from, reduce, keys);
}
function index(values, ...keys) {
    return nest(values, (0, _identityJsDefault.default), unique, keys);
}
function indexes(values, ...keys) {
    return nest(values, Array.from, unique, keys);
}
function unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new (0, _internmap.InternMap)();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

},{"internmap":"5EkCg","./identity.js":"iqR4R","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5EkCg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternMap", ()=>InternMap);
parcelHelpers.export(exports, "InternSet", ()=>InternSet);
class InternMap extends Map {
    constructor(entries, key = keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get(intern_get(this, key));
    }
    has(key) {
        return super.has(intern_get(this, key));
    }
    set(key, value) {
        return super.set(intern_set(this, key), value);
    }
    delete(key) {
        return super.delete(intern_delete(this, key));
    }
}
class InternSet extends Set {
    constructor(values, key = keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has(intern_get(this, value));
    }
    add(value) {
        return super.add(intern_set(this, value));
    }
    delete(value) {
        return super.delete(intern_delete(this, value));
    }
}
function intern_get({ _intern, _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set({ _intern, _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function intern_delete({ _intern, _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"iqR4R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>identity);
function identity(x) {
    return x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4cn39":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>groupSort);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _groupJs = require("./group.js");
var _groupJsDefault = parcelHelpers.interopDefault(_groupJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
function groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, _sortJsDefault.default)((0, _groupJs.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, _ascendingJsDefault.default)(av, bv) || (0, _ascendingJsDefault.default)(ak, bk)) : (0, _sortJsDefault.default)((0, _groupJsDefault.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, _ascendingJsDefault.default)(ak, bk))).map(([key])=>key);
}

},{"./ascending.js":"5oHFB","./group.js":"7C3MB","./sort.js":"ias4a","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cpOMI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bin);
var _arrayJs = require("./array.js");
var _bisectJs = require("./bisect.js");
var _bisectJsDefault = parcelHelpers.interopDefault(_bisectJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _extentJs = require("./extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _ticksJs = require("./ticks.js");
var _ticksJsDefault = parcelHelpers.interopDefault(_ticksJs);
var _sturgesJs = require("./threshold/sturges.js");
var _sturgesJsDefault = parcelHelpers.interopDefault(_sturgesJs);
function bin() {
    var value = (0, _identityJsDefault.default), domain = (0, _extentJsDefault.default), threshold = (0, _sturgesJsDefault.default);
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === (0, _extentJsDefault.default)) [x0, x1] = (0, _niceJsDefault.default)(x0, x1, tn);
            tz = (0, _ticksJsDefault.default)(x0, x1, tn);
            // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, _ticksJs.tickIncrement)(x0, x1, tn);
            // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === (0, _extentJsDefault.default)) {
                    const step = (0, _ticksJs.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        }
        // Remove any thresholds outside the domain.
        // Be careful not to mutate an array owned by the user!
        var m = tz.length, a = 0, b = m;
        while(tz[a] <= x0)++a;
        while(tz[b - 1] > x1)--b;
        if (a || b < m) tz = tz.slice(a, b), m = b - a;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, _bisectJsDefault.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, _constantJsDefault.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(Array.isArray(_) ? (0, _arrayJs.slice).call(_) : _), histogram) : threshold;
    };
    return histogram;
}

},{"./array.js":"8079U","./bisect.js":"8oF0X","./constant.js":"eQpNt","./extent.js":"49ZXb","./identity.js":"iqR4R","./nice.js":"2pwW2","./ticks.js":"4kdy4","./threshold/sturges.js":"81Iww","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8079U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
parcelHelpers.export(exports, "map", ()=>map);
var array = Array.prototype;
var slice = array.slice;
var map = array.map;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"eQpNt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>constant);
function constant(x) {
    return ()=>x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"2pwW2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>nice);
var _ticksJs = require("./ticks.js");
function nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, _ticksJs.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

},{"./ticks.js":"4kdy4","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"81Iww":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>thresholdSturges);
var _countJs = require("../count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
function thresholdSturges(values) {
    return Math.max(1, Math.ceil(Math.log((0, _countJsDefault.default)(values)) / Math.LN2) + 1);
}

},{"../count.js":"czIvW","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cyv81":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>thresholdFreedmanDiaconis);
var _countJs = require("../count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _quantileJs = require("../quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
function thresholdFreedmanDiaconis(values, min, max) {
    const c = (0, _countJsDefault.default)(values), d = (0, _quantileJsDefault.default)(values, 0.75) - (0, _quantileJsDefault.default)(values, 0.25);
    return c && d ? Math.ceil((max - min) / (2 * d * Math.pow(c, -1 / 3))) : 1;
}

},{"../count.js":"czIvW","../quantile.js":"8eCyE","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hXHz6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>thresholdScott);
var _countJs = require("../count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _deviationJs = require("../deviation.js");
var _deviationJsDefault = parcelHelpers.interopDefault(_deviationJs);
function thresholdScott(values, min, max) {
    const c = (0, _countJsDefault.default)(values), d = (0, _deviationJsDefault.default)(values);
    return c && d ? Math.ceil((max - min) * Math.cbrt(c) / (3.49 * d)) : 1;
}

},{"../count.js":"czIvW","../deviation.js":"bQRNb","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"l2RxB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mean);
function mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8UWhT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>merge);
function* flatten(arrays) {
    for (const array of arrays)yield* array;
}
function merge(arrays) {
    return Array.from(flatten(arrays));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3kfTS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mode);
var _internmap = require("internmap");
function mode(values, valueof) {
    const counts = new (0, _internmap.InternMap)();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

},{"internmap":"5EkCg","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5aUC0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>pairs);
parcelHelpers.export(exports, "pair", ()=>pair);
function pairs(values, pairof = pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function pair(a, b) {
    return [
        a,
        b
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"2Qa4a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>range);
function range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5n6MW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rank);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _sortJs = require("./sort.js");
function rank(values, valueof = (0, _ascendingJsDefault.default)) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = (0, _ascendingJsDefault.default);
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    values = Uint32Array.from(V, (_, i)=>i);
    // Risky chaining due to Safari 14 https://github.com/d3/d3-array/issues/123
    values.sort(valueof === (0, _ascendingJsDefault.default) ? (i, j)=>(0, _sortJs.ascendingDefined)(V[i], V[j]) : (0, _sortJs.compareDefined)(compareIndex));
    values.forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

},{"./ascending.js":"5oHFB","./sort.js":"ias4a","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4j6hM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>least);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
function least(values, compare = (0, _ascendingJsDefault.default)) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, _ascendingJsDefault.default)(value, minValue) < 0 : (0, _ascendingJsDefault.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

},{"./ascending.js":"5oHFB","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"ay1Yt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>leastIndex);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _minIndexJs = require("./minIndex.js");
var _minIndexJsDefault = parcelHelpers.interopDefault(_minIndexJs);
function leastIndex(values, compare = (0, _ascendingJsDefault.default)) {
    if (compare.length === 1) return (0, _minIndexJsDefault.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

},{"./ascending.js":"5oHFB","./minIndex.js":"lPZBV","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"kl676":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>greatestIndex);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _maxIndexJs = require("./maxIndex.js");
var _maxIndexJsDefault = parcelHelpers.interopDefault(_maxIndexJs);
function greatestIndex(values, compare = (0, _ascendingJsDefault.default)) {
    if (compare.length === 1) return (0, _maxIndexJsDefault.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

},{"./ascending.js":"5oHFB","./maxIndex.js":"aQNPD","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"9WetR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>scan);
var _leastIndexJs = require("./leastIndex.js");
var _leastIndexJsDefault = parcelHelpers.interopDefault(_leastIndexJs);
function scan(values, compare) {
    const index = (0, _leastIndexJsDefault.default)(values, compare);
    return index < 0 ? undefined : index;
}

},{"./leastIndex.js":"ay1Yt","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"e2ePE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shuffler", ()=>shuffler);
exports.default = shuffler(Math.random);
function shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"l8cYr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sum);
function sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4CYvd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transpose);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
function transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, _minJsDefault.default)(matrix, length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function length(d) {
    return d.length;
}

},{"./min.js":"h7wqP","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"6IFvY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>zip);
var _transposeJs = require("./transpose.js");
var _transposeJsDefault = parcelHelpers.interopDefault(_transposeJs);
function zip() {
    return (0, _transposeJsDefault.default)(arguments);
}

},{"./transpose.js":"4CYvd","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"c3ux9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>every);
function every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hj6mC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>some);
function some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3vkur":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>filter);
function filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"6lOcv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>map);
function map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"loxTK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>reduce);
function reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done, value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8Ykum":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>reverse);
function reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4WPNr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>difference);
var _internmap = require("internmap");
function difference(values, ...others) {
    values = new (0, _internmap.InternSet)(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

},{"internmap":"5EkCg","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"0K7OT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>disjoint);
var _internmap = require("internmap");
function disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new (0, _internmap.InternSet)();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value, done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

},{"internmap":"5EkCg","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"77dMh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>intersection);
var _internmap = require("internmap");
function intersection(values, ...others) {
    values = new (0, _internmap.InternSet)(values);
    others = others.map(set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function set(values) {
    return values instanceof (0, _internmap.InternSet) ? values : new (0, _internmap.InternSet)(values);
}

},{"internmap":"5EkCg","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5E6i1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subset);
var _supersetJs = require("./superset.js");
var _supersetJsDefault = parcelHelpers.interopDefault(_supersetJs);
function subset(values, other) {
    return (0, _supersetJsDefault.default)(other, values);
}

},{"./superset.js":"ejV6u","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"ejV6u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>superset);
function superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value, done } = iterator.next()){
            if (done) return false;
            const ivalue = intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"6iv1Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>union);
var _internmap = require("internmap");
function union(...others) {
    const set = new (0, _internmap.InternSet)();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

},{"internmap":"5EkCg","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5k8qQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bound", ()=>Bound);
parcelHelpers.export(exports, "identifier", ()=>Identifier);
parcelHelpers.export(exports, "mark", ()=>Mark);
parcelHelpers.export(exports, "overlap", ()=>Overlap);
parcelHelpers.export(exports, "render", ()=>Render);
parcelHelpers.export(exports, "viewlayout", ()=>ViewLayout);
var _vegaDataflow = require("vega-dataflow");
var _vegaScenegraph = require("vega-scenegraph");
var _vegaUtil = require("vega-util");
const Top = 'top';
const Left = 'left';
const Right = 'right';
const Bottom = 'bottom';
const TopLeft = 'top-left';
const TopRight = 'top-right';
const BottomLeft = 'bottom-left';
const BottomRight = 'bottom-right';
const Start = 'start';
const Middle = 'middle';
const End = 'end';
const X = 'x';
const Y = 'y';
const Group = 'group';
const AxisRole = 'axis';
const TitleRole = 'title';
const FrameRole = 'frame';
const ScopeRole = 'scope';
const LegendRole = 'legend';
const RowHeader = 'row-header';
const RowFooter = 'row-footer';
const RowTitle = 'row-title';
const ColHeader = 'column-header';
const ColFooter = 'column-footer';
const ColTitle = 'column-title';
const Padding = 'padding';
const Symbols = 'symbol';
const Fit = 'fit';
const FitX = 'fit-x';
const FitY = 'fit-y';
const Pad = 'pad';
const None = 'none';
const All = 'all';
const Each = 'each';
const Flush = 'flush';
const Column = 'column';
const Row = 'row';
/**
 * Calculate bounding boxes for scenegraph items.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {object} params.mark - The scenegraph mark instance to bound.
 */ function Bound(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
(0, _vegaUtil.inherits)(Bound, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const view = pulse.dataflow, mark = _.mark, type = mark.marktype, entry = (0, _vegaScenegraph.Marks)[type], bound = entry.bound;
        let markBounds = mark.bounds, rebound;
        if (entry.nested) {
            // multi-item marks have a single bounds instance
            if (mark.items.length) view.dirty(mark.items[0]);
            markBounds = boundItem(mark, bound);
            mark.items.forEach((item)=>{
                item.bounds.clear().union(markBounds);
            });
        } else if (type === Group || _.modified()) {
            // operator parameters modified -> re-bound all items
            // updates group bounds in response to modified group content
            pulse.visit(pulse.MOD, (item)=>view.dirty(item));
            markBounds.clear();
            mark.items.forEach((item)=>markBounds.union(boundItem(item, bound)));
            // force reflow for axes/legends/titles to propagate any layout changes
            switch(mark.role){
                case AxisRole:
                case LegendRole:
                case TitleRole:
                    pulse.reflow();
            }
        } else {
            // incrementally update bounds, re-bound mark as needed
            rebound = pulse.changed(pulse.REM);
            pulse.visit(pulse.ADD, (item)=>{
                markBounds.union(boundItem(item, bound));
            });
            pulse.visit(pulse.MOD, (item)=>{
                rebound = rebound || markBounds.alignsWith(item.bounds);
                view.dirty(item);
                markBounds.union(boundItem(item, bound));
            });
            if (rebound) {
                markBounds.clear();
                mark.items.forEach((item)=>markBounds.union(item.bounds));
            }
        }
        // ensure mark bounds do not exceed any clipping region
        (0, _vegaScenegraph.boundClip)(mark);
        return pulse.modifies('bounds');
    }
});
function boundItem(item, bound, opt) {
    return bound(item.bounds.clear(), item, opt);
}
const COUNTER_NAME = ':vega_identifier:';
/**
 * Adds a unique identifier to all added tuples.
 * This transform creates a new signal that serves as an id counter.
 * As a result, the id counter is shared across all instances of this
 * transform, generating unique ids across multiple data streams. In
 * addition, this signal value can be included in a snapshot of the
 * dataflow state, enabling correct resumption of id allocation.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {string} params.as - The field name for the generated identifier.
 */ function Identifier(params) {
    (0, _vegaDataflow.Transform).call(this, 0, params);
}
Identifier.Definition = {
    'type': 'Identifier',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'as',
            'type': 'string',
            'required': true
        }
    ]
};
(0, _vegaUtil.inherits)(Identifier, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const counter = getCounter(pulse.dataflow), as = _.as;
        let id = counter.value;
        pulse.visit(pulse.ADD, (t)=>t[as] = t[as] || ++id);
        counter.set(this.value = id);
        return pulse;
    }
});
function getCounter(view) {
    return view._signals[COUNTER_NAME] || (view._signals[COUNTER_NAME] = view.add(0));
}
/**
 * Bind scenegraph items to a scenegraph mark instance.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {object} params.markdef - The mark definition for creating the mark.
 *   This is an object of legal scenegraph mark properties which *must* include
 *   the 'marktype' property.
 */ function Mark(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
(0, _vegaUtil.inherits)(Mark, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        let mark = this.value;
        // acquire mark on first invocation, bind context and group
        if (!mark) {
            mark = pulse.dataflow.scenegraph().mark(_.markdef, lookup$1(_), _.index);
            mark.group.context = _.context;
            if (!_.context.group) _.context.group = mark.group;
            mark.source = this.source; // point to upstream collector
            mark.clip = _.clip;
            mark.interactive = _.interactive;
            this.value = mark;
        }
        // initialize entering items
        const Init = mark.marktype === Group ? (0, _vegaScenegraph.GroupItem) : (0, _vegaScenegraph.Item);
        pulse.visit(pulse.ADD, (item)=>Init.call(item, mark));
        // update clipping and/or interactive status
        if (_.modified('clip') || _.modified('interactive')) {
            mark.clip = _.clip;
            mark.interactive = !!_.interactive;
            mark.zdirty = true; // force scenegraph re-eval
            pulse.reflow();
        }
        // bind items array to scenegraph mark
        mark.items = pulse.source;
        return pulse;
    }
});
function lookup$1(_) {
    const g = _.groups, p = _.parent;
    return g && g.size === 1 ? g.get(Object.keys(g.object)[0]) : g && p ? g.lookup(p) : null;
}
/**
 * Analyze items for overlap, changing opacity to hide items with
 * overlapping bounding boxes. This transform will preserve at least
 * two items (e.g., first and last) even if overlap persists.
 * @param {object} params - The parameters for this operator.
 * @param {function(*,*): number} [params.sort] - A comparator
 *   function for sorting items.
 * @param {object} [params.method] - The overlap removal method to apply.
 *   One of 'parity' (default, hide every other item until there is no
 *   more overlap) or 'greedy' (sequentially scan and hide and items that
 *   overlap with the last visible item).
 * @param {object} [params.boundScale] - A scale whose range should be used
 *   to bound the items. Items exceeding the bounds of the scale range
 *   will be treated as overlapping. If null or undefined, no bounds check
 *   will be applied.
 * @param {object} [params.boundOrient] - The orientation of the scale
 *   (top, bottom, left, or right) used to bound items. This parameter is
 *   ignored if boundScale is null or undefined.
 * @param {object} [params.boundTolerance] - The tolerance in pixels for
 *   bound inclusion testing (default 1). This specifies by how many pixels
 *   an item's bounds may exceed the scale range bounds and not be culled.
 * @constructor
 */ function Overlap(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
const methods = {
    parity: (items)=>items.filter((item, i)=>i % 2 ? item.opacity = 0 : 1),
    greedy: (items, sep)=>{
        let a;
        return items.filter((b, i)=>!i || !intersect(a.bounds, b.bounds, sep) ? (a = b, 1) : b.opacity = 0);
    }
};
// compute bounding box intersection
// including padding pixels of separation
const intersect = (a, b, sep)=>sep > Math.max(b.x1 - a.x2, a.x1 - b.x2, b.y1 - a.y2, a.y1 - b.y2);
const hasOverlap = (items, pad)=>{
    for(var i = 1, n = items.length, a = items[0].bounds, b; i < n; a = b, ++i){
        if (intersect(a, b = items[i].bounds, pad)) return true;
    }
};
const hasBounds = (item)=>{
    const b = item.bounds;
    return b.width() > 1 && b.height() > 1;
};
const boundTest = (scale, orient, tolerance)=>{
    var range = scale.range(), b = new (0, _vegaScenegraph.Bounds)();
    if (orient === Top || orient === Bottom) b.set(range[0], -Infinity, range[1], Infinity);
    else b.set(-Infinity, range[0], Infinity, range[1]);
    b.expand(tolerance || 1);
    return (item)=>b.encloses(item.bounds);
};
// reset all items to be fully opaque
const reset = (source)=>{
    source.forEach((item)=>item.opacity = 1);
    return source;
};
// add all tuples to mod, fork pulse if parameters were modified
// fork prevents cross-stream tuple pollution (e.g., pulse from scale)
const reflow = (pulse, _)=>pulse.reflow(_.modified()).modifies('opacity');
(0, _vegaUtil.inherits)(Overlap, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const reduce = methods[_.method] || methods.parity, sep = _.separation || 0;
        let source = pulse.materialize(pulse.SOURCE).source, items, test;
        if (!source || !source.length) return;
        if (!_.method) {
            // early exit if method is falsy
            if (_.modified('method')) {
                reset(source);
                pulse = reflow(pulse, _);
            }
            return pulse;
        }
        // skip labels with no content
        source = source.filter(hasBounds);
        // early exit, nothing to do
        if (!source.length) return;
        if (_.sort) source = source.slice().sort(_.sort);
        items = reset(source);
        pulse = reflow(pulse, _);
        if (items.length >= 3 && hasOverlap(items, sep)) {
            do items = reduce(items, sep);
            while (items.length >= 3 && hasOverlap(items, sep));
            if (items.length < 3 && !(0, _vegaUtil.peek)(source).opacity) {
                if (items.length > 1) (0, _vegaUtil.peek)(items).opacity = 0;
                (0, _vegaUtil.peek)(source).opacity = 1;
            }
        }
        if (_.boundScale && _.boundTolerance >= 0) {
            test = boundTest(_.boundScale, _.boundOrient, +_.boundTolerance);
            source.forEach((item)=>{
                if (!test(item)) item.opacity = 0;
            });
        }
        // re-calculate mark bounds
        const bounds = items[0].mark.bounds.clear();
        source.forEach((item)=>{
            if (item.opacity) bounds.union(item.bounds);
        });
        return pulse;
    }
});
/**
 * Queue modified scenegraph items for rendering.
 * @constructor
 */ function Render(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
(0, _vegaUtil.inherits)(Render, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const view = pulse.dataflow;
        pulse.visit(pulse.ALL, (item)=>view.dirty(item));
        // set z-index dirty flag as needed
        if (pulse.fields && pulse.fields['zindex']) {
            const item = pulse.source && pulse.source[0];
            if (item) item.mark.zdirty = true;
        }
    }
});
const tempBounds = new (0, _vegaScenegraph.Bounds)();
function set(item, property, value) {
    return item[property] === value ? 0 : (item[property] = value, 1);
}
function isYAxis(mark) {
    var orient = mark.items[0].orient;
    return orient === Left || orient === Right;
}
function axisIndices(datum) {
    let index = +datum.grid;
    return [
        datum.ticks ? index++ : -1,
        // ticks index
        datum.labels ? index++ : -1,
        // labels index
        index + +datum.domain // title index
    ];
}
function axisLayout(view, axis, width, height) {
    var item = axis.items[0], datum = item.datum, delta = item.translate != null ? item.translate : 0.5, orient = item.orient, indices = axisIndices(datum), range = item.range, offset = item.offset, position = item.position, minExtent = item.minExtent, maxExtent = item.maxExtent, title = datum.title && item.items[indices[2]].items[0], titlePadding = item.titlePadding, bounds = item.bounds, dl = title && (0, _vegaScenegraph.multiLineOffset)(title), x = 0, y = 0, i, s;
    tempBounds.clear().union(bounds);
    bounds.clear();
    if ((i = indices[0]) > -1) bounds.union(item.items[i].bounds);
    if ((i = indices[1]) > -1) bounds.union(item.items[i].bounds);
    // position axis group and title
    switch(orient){
        case Top:
            x = position || 0;
            y = -offset;
            s = Math.max(minExtent, Math.min(maxExtent, -bounds.y1));
            bounds.add(0, -s).add(range, 0);
            if (title) axisTitleLayout(view, title, s, titlePadding, dl, 0, -1, bounds);
            break;
        case Left:
            x = -offset;
            y = position || 0;
            s = Math.max(minExtent, Math.min(maxExtent, -bounds.x1));
            bounds.add(-s, 0).add(0, range);
            if (title) axisTitleLayout(view, title, s, titlePadding, dl, 1, -1, bounds);
            break;
        case Right:
            x = width + offset;
            y = position || 0;
            s = Math.max(minExtent, Math.min(maxExtent, bounds.x2));
            bounds.add(0, 0).add(s, range);
            if (title) axisTitleLayout(view, title, s, titlePadding, dl, 1, 1, bounds);
            break;
        case Bottom:
            x = position || 0;
            y = height + offset;
            s = Math.max(minExtent, Math.min(maxExtent, bounds.y2));
            bounds.add(0, 0).add(range, s);
            if (title) axisTitleLayout(view, title, s, titlePadding, 0, 0, 1, bounds);
            break;
        default:
            x = item.x;
            y = item.y;
    }
    // update bounds
    (0, _vegaScenegraph.boundStroke)(bounds.translate(x, y), item);
    if (set(item, 'x', x + delta) | set(item, 'y', y + delta)) {
        item.bounds = tempBounds;
        view.dirty(item);
        item.bounds = bounds;
        view.dirty(item);
    }
    return item.mark.bounds.clear().union(bounds);
}
function axisTitleLayout(view, title, offset, pad, dl, isYAxis, sign, bounds) {
    const b = title.bounds;
    if (title.auto) {
        const v = sign * (offset + dl + pad);
        let dx = 0, dy = 0;
        view.dirty(title);
        isYAxis ? dx = (title.x || 0) - (title.x = v) : dy = (title.y || 0) - (title.y = v);
        title.mark.bounds.clear().union(b.translate(-dx, -dy));
        view.dirty(title);
    }
    bounds.union(b);
}
// aggregation functions for grid margin determination
const min = (a, b)=>Math.floor(Math.min(a, b));
const max = (a, b)=>Math.ceil(Math.max(a, b));
function gridLayoutGroups(group) {
    var groups = group.items, n = groups.length, i = 0, mark, items;
    const views = {
        marks: [],
        rowheaders: [],
        rowfooters: [],
        colheaders: [],
        colfooters: [],
        rowtitle: null,
        coltitle: null
    };
    // layout axes, gather legends, collect bounds
    for(; i < n; ++i){
        mark = groups[i];
        items = mark.items;
        if (mark.marktype === Group) switch(mark.role){
            case AxisRole:
            case LegendRole:
            case TitleRole:
                break;
            case RowHeader:
                views.rowheaders.push(...items);
                break;
            case RowFooter:
                views.rowfooters.push(...items);
                break;
            case ColHeader:
                views.colheaders.push(...items);
                break;
            case ColFooter:
                views.colfooters.push(...items);
                break;
            case RowTitle:
                views.rowtitle = items[0];
                break;
            case ColTitle:
                views.coltitle = items[0];
                break;
            default:
                views.marks.push(...items);
        }
    }
    return views;
}
function bboxFlush(item) {
    return new (0, _vegaScenegraph.Bounds)().set(0, 0, item.width || 0, item.height || 0);
}
function bboxFull(item) {
    const b = item.bounds.clone();
    return b.empty() ? b.set(0, 0, 0, 0) : b.translate(-(item.x || 0), -(item.y || 0));
}
function get(opt, key, d) {
    const v = (0, _vegaUtil.isObject)(opt) ? opt[key] : opt;
    return v != null ? v : d !== undefined ? d : 0;
}
function offsetValue(v) {
    return v < 0 ? Math.ceil(-v) : 0;
}
function gridLayout(view, groups, opt) {
    var dirty = !opt.nodirty, bbox = opt.bounds === Flush ? bboxFlush : bboxFull, bounds = tempBounds.set(0, 0, 0, 0), alignCol = get(opt.align, Column), alignRow = get(opt.align, Row), padCol = get(opt.padding, Column), padRow = get(opt.padding, Row), ncols = opt.columns || groups.length, nrows = ncols <= 0 ? 1 : Math.ceil(groups.length / ncols), n = groups.length, xOffset = Array(n), xExtent = Array(ncols), xMax = 0, yOffset = Array(n), yExtent = Array(nrows), yMax = 0, dx = Array(n), dy = Array(n), boxes = Array(n), m, i, c, r, b, g, px, py, x, y, offset;
    for(i = 0; i < ncols; ++i)xExtent[i] = 0;
    for(i = 0; i < nrows; ++i)yExtent[i] = 0;
    // determine offsets for each group
    for(i = 0; i < n; ++i){
        g = groups[i];
        b = boxes[i] = bbox(g);
        g.x = g.x || 0;
        dx[i] = 0;
        g.y = g.y || 0;
        dy[i] = 0;
        c = i % ncols;
        r = ~~(i / ncols);
        xMax = Math.max(xMax, px = Math.ceil(b.x2));
        yMax = Math.max(yMax, py = Math.ceil(b.y2));
        xExtent[c] = Math.max(xExtent[c], px);
        yExtent[r] = Math.max(yExtent[r], py);
        xOffset[i] = padCol + offsetValue(b.x1);
        yOffset[i] = padRow + offsetValue(b.y1);
        if (dirty) view.dirty(groups[i]);
    }
    // set initial alignment offsets
    for(i = 0; i < n; ++i){
        if (i % ncols === 0) xOffset[i] = 0;
        if (i < ncols) yOffset[i] = 0;
    }
    // enforce column alignment constraints
    if (alignCol === Each) for(c = 1; c < ncols; ++c){
        for(offset = 0, i = c; i < n; i += ncols)if (offset < xOffset[i]) offset = xOffset[i];
        for(i = c; i < n; i += ncols)xOffset[i] = offset + xExtent[c - 1];
    }
    else if (alignCol === All) {
        for(offset = 0, i = 0; i < n; ++i)if (i % ncols && offset < xOffset[i]) offset = xOffset[i];
        for(i = 0; i < n; ++i)if (i % ncols) xOffset[i] = offset + xMax;
    } else {
        for(alignCol = false, c = 1; c < ncols; ++c)for(i = c; i < n; i += ncols)xOffset[i] += xExtent[c - 1];
    }
    // enforce row alignment constraints
    if (alignRow === Each) for(r = 1; r < nrows; ++r){
        for(offset = 0, i = r * ncols, m = i + ncols; i < m; ++i)if (offset < yOffset[i]) offset = yOffset[i];
        for(i = r * ncols; i < m; ++i)yOffset[i] = offset + yExtent[r - 1];
    }
    else if (alignRow === All) {
        for(offset = 0, i = ncols; i < n; ++i)if (offset < yOffset[i]) offset = yOffset[i];
        for(i = ncols; i < n; ++i)yOffset[i] = offset + yMax;
    } else {
        for(alignRow = false, r = 1; r < nrows; ++r)for(i = r * ncols, m = i + ncols; i < m; ++i)yOffset[i] += yExtent[r - 1];
    }
    // perform horizontal grid layout
    for(x = 0, i = 0; i < n; ++i){
        x = xOffset[i] + (i % ncols ? x : 0);
        dx[i] += x - groups[i].x;
    }
    // perform vertical grid layout
    for(c = 0; c < ncols; ++c)for(y = 0, i = c; i < n; i += ncols){
        y += yOffset[i];
        dy[i] += y - groups[i].y;
    }
    // perform horizontal centering
    if (alignCol && get(opt.center, Column) && nrows > 1) for(i = 0; i < n; ++i){
        b = alignCol === All ? xMax : xExtent[i % ncols];
        x = b - boxes[i].x2 - groups[i].x - dx[i];
        if (x > 0) dx[i] += x / 2;
    }
    // perform vertical centering
    if (alignRow && get(opt.center, Row) && ncols !== 1) for(i = 0; i < n; ++i){
        b = alignRow === All ? yMax : yExtent[~~(i / ncols)];
        y = b - boxes[i].y2 - groups[i].y - dy[i];
        if (y > 0) dy[i] += y / 2;
    }
    // position grid relative to anchor
    for(i = 0; i < n; ++i)bounds.union(boxes[i].translate(dx[i], dy[i]));
    x = get(opt.anchor, X);
    y = get(opt.anchor, Y);
    switch(get(opt.anchor, Column)){
        case End:
            x -= bounds.width();
            break;
        case Middle:
            x -= bounds.width() / 2;
    }
    switch(get(opt.anchor, Row)){
        case End:
            y -= bounds.height();
            break;
        case Middle:
            y -= bounds.height() / 2;
    }
    x = Math.round(x);
    y = Math.round(y);
    // update mark positions, bounds, dirty
    bounds.clear();
    for(i = 0; i < n; ++i)groups[i].mark.bounds.clear();
    for(i = 0; i < n; ++i){
        g = groups[i];
        g.x += dx[i] += x;
        g.y += dy[i] += y;
        bounds.union(g.mark.bounds.union(g.bounds.translate(dx[i], dy[i])));
        if (dirty) view.dirty(g);
    }
    return bounds;
}
function trellisLayout(view, group, opt) {
    var views = gridLayoutGroups(group), groups = views.marks, bbox = opt.bounds === Flush ? boundFlush : boundFull, off = opt.offset, ncols = opt.columns || groups.length, nrows = ncols <= 0 ? 1 : Math.ceil(groups.length / ncols), cells = nrows * ncols, x, y, x2, y2, anchor, band, offset;
    // -- initial grid layout
    const bounds = gridLayout(view, groups, opt);
    if (bounds.empty()) bounds.set(0, 0, 0, 0); // empty grid
    // -- layout grid headers and footers --
    // perform row header layout
    if (views.rowheaders) {
        band = get(opt.headerBand, Row, null);
        x = layoutHeaders(view, views.rowheaders, groups, ncols, nrows, -get(off, 'rowHeader'), min, 0, bbox, 'x1', 0, ncols, 1, band);
    }
    // perform column header layout
    if (views.colheaders) {
        band = get(opt.headerBand, Column, null);
        y = layoutHeaders(view, views.colheaders, groups, ncols, ncols, -get(off, 'columnHeader'), min, 1, bbox, 'y1', 0, 1, ncols, band);
    }
    // perform row footer layout
    if (views.rowfooters) {
        band = get(opt.footerBand, Row, null);
        x2 = layoutHeaders(view, views.rowfooters, groups, ncols, nrows, get(off, 'rowFooter'), max, 0, bbox, 'x2', ncols - 1, ncols, 1, band);
    }
    // perform column footer layout
    if (views.colfooters) {
        band = get(opt.footerBand, Column, null);
        y2 = layoutHeaders(view, views.colfooters, groups, ncols, ncols, get(off, 'columnFooter'), max, 1, bbox, 'y2', cells - ncols, 1, ncols, band);
    }
    // perform row title layout
    if (views.rowtitle) {
        anchor = get(opt.titleAnchor, Row);
        offset = get(off, 'rowTitle');
        offset = anchor === End ? x2 + offset : x - offset;
        band = get(opt.titleBand, Row, 0.5);
        layoutTitle(view, views.rowtitle, offset, 0, bounds, band);
    }
    // perform column title layout
    if (views.coltitle) {
        anchor = get(opt.titleAnchor, Column);
        offset = get(off, 'columnTitle');
        offset = anchor === End ? y2 + offset : y - offset;
        band = get(opt.titleBand, Column, 0.5);
        layoutTitle(view, views.coltitle, offset, 1, bounds, band);
    }
}
function boundFlush(item, field) {
    return field === 'x1' ? item.x || 0 : field === 'y1' ? item.y || 0 : field === 'x2' ? (item.x || 0) + (item.width || 0) : field === 'y2' ? (item.y || 0) + (item.height || 0) : undefined;
}
function boundFull(item, field) {
    return item.bounds[field];
}
function layoutHeaders(view, headers, groups, ncols, limit, offset, agg, isX, bound, bf, start, stride, back, band) {
    var n = groups.length, init = 0, edge = 0, i, j, k, m, b, h, g, x, y;
    // if no groups, early exit and return 0
    if (!n) return init;
    // compute margin
    for(i = start; i < n; i += stride)if (groups[i]) init = agg(init, bound(groups[i], bf));
    // if no headers, return margin calculation
    if (!headers.length) return init;
    // check if number of headers exceeds number of rows or columns
    if (headers.length > limit) {
        view.warn('Grid headers exceed limit: ' + limit);
        headers = headers.slice(0, limit);
    }
    // apply offset
    init += offset;
    // clear mark bounds for all headers
    for(j = 0, m = headers.length; j < m; ++j){
        view.dirty(headers[j]);
        headers[j].mark.bounds.clear();
    }
    // layout each header
    for(i = start, j = 0, m = headers.length; j < m; ++j, i += stride){
        h = headers[j];
        b = h.mark.bounds;
        // search for nearest group to align to
        // necessary if table has empty cells
        for(k = i; k >= 0 && (g = groups[k]) == null; k -= back);
        // assign coordinates and update bounds
        if (isX) {
            x = band == null ? g.x : Math.round(g.bounds.x1 + band * g.bounds.width());
            y = init;
        } else {
            x = init;
            y = band == null ? g.y : Math.round(g.bounds.y1 + band * g.bounds.height());
        }
        b.union(h.bounds.translate(x - (h.x || 0), y - (h.y || 0)));
        h.x = x;
        h.y = y;
        view.dirty(h);
        // update current edge of layout bounds
        edge = agg(edge, b[bf]);
    }
    return edge;
}
function layoutTitle(view, g, offset, isX, bounds, band) {
    if (!g) return;
    view.dirty(g);
    // compute title coordinates
    var x = offset, y = offset;
    isX ? x = Math.round(bounds.x1 + band * bounds.width()) : y = Math.round(bounds.y1 + band * bounds.height());
    // assign coordinates and update bounds
    g.bounds.translate(x - (g.x || 0), y - (g.y || 0));
    g.mark.bounds.clear().union(g.bounds);
    g.x = x;
    g.y = y;
    // queue title for redraw
    view.dirty(g);
}
// utility for looking up legend layout configuration
function lookup(config, orient) {
    const opt = config[orient] || {};
    return (key, d)=>opt[key] != null ? opt[key] : config[key] != null ? config[key] : d;
}
// if legends specify offset directly, use the maximum specified value
function offsets(legends, value) {
    let max = -Infinity;
    legends.forEach((item)=>{
        if (item.offset != null) max = Math.max(max, item.offset);
    });
    return max > -Infinity ? max : value;
}
function legendParams(g, orient, config, xb, yb, w, h) {
    const _ = lookup(config, orient), offset = offsets(g, _('offset', 0)), anchor = _('anchor', Start), mult = anchor === End ? 1 : anchor === Middle ? 0.5 : 0;
    const p = {
        align: Each,
        bounds: _('bounds', Flush),
        columns: _('direction') === 'vertical' ? 1 : g.length,
        padding: _('margin', 8),
        center: _('center'),
        nodirty: true
    };
    switch(orient){
        case Left:
            p.anchor = {
                x: Math.floor(xb.x1) - offset,
                column: End,
                y: mult * (h || xb.height() + 2 * xb.y1),
                row: anchor
            };
            break;
        case Right:
            p.anchor = {
                x: Math.ceil(xb.x2) + offset,
                y: mult * (h || xb.height() + 2 * xb.y1),
                row: anchor
            };
            break;
        case Top:
            p.anchor = {
                y: Math.floor(yb.y1) - offset,
                row: End,
                x: mult * (w || yb.width() + 2 * yb.x1),
                column: anchor
            };
            break;
        case Bottom:
            p.anchor = {
                y: Math.ceil(yb.y2) + offset,
                x: mult * (w || yb.width() + 2 * yb.x1),
                column: anchor
            };
            break;
        case TopLeft:
            p.anchor = {
                x: offset,
                y: offset
            };
            break;
        case TopRight:
            p.anchor = {
                x: w - offset,
                y: offset,
                column: End
            };
            break;
        case BottomLeft:
            p.anchor = {
                x: offset,
                y: h - offset,
                row: End
            };
            break;
        case BottomRight:
            p.anchor = {
                x: w - offset,
                y: h - offset,
                column: End,
                row: End
            };
            break;
    }
    return p;
}
function legendLayout(view, legend) {
    var item = legend.items[0], datum = item.datum, orient = item.orient, bounds = item.bounds, x = item.x, y = item.y, w, h;
    // cache current bounds for later comparison
    item._bounds ? item._bounds.clear().union(bounds) : item._bounds = bounds.clone();
    bounds.clear();
    // adjust legend to accommodate padding and title
    legendGroupLayout(view, item, item.items[0].items[0]);
    // aggregate bounds to determine size, and include origin
    bounds = legendBounds(item, bounds);
    w = 2 * item.padding;
    h = 2 * item.padding;
    if (!bounds.empty()) {
        w = Math.ceil(bounds.width() + w);
        h = Math.ceil(bounds.height() + h);
    }
    if (datum.type === Symbols) legendEntryLayout(item.items[0].items[0].items[0].items);
    if (orient !== None) {
        item.x = x = 0;
        item.y = y = 0;
    }
    item.width = w;
    item.height = h;
    (0, _vegaScenegraph.boundStroke)(bounds.set(x, y, x + w, y + h), item);
    item.mark.bounds.clear().union(bounds);
    return item;
}
function legendBounds(item, b) {
    // aggregate item bounds
    item.items.forEach((_)=>b.union(_.bounds));
    // anchor to legend origin
    b.x1 = item.padding;
    b.y1 = item.padding;
    return b;
}
function legendGroupLayout(view, item, entry) {
    var pad = item.padding, ex = pad - entry.x, ey = pad - entry.y;
    if (!item.datum.title) {
        if (ex || ey) translate(view, entry, ex, ey);
    } else {
        var title = item.items[1].items[0], anchor = title.anchor, tpad = item.titlePadding || 0, tx = pad - title.x, ty = pad - title.y;
        switch(title.orient){
            case Left:
                ex += Math.ceil(title.bounds.width()) + tpad;
                break;
            case Right:
            case Bottom:
                break;
            default:
                ey += title.bounds.height() + tpad;
        }
        if (ex || ey) translate(view, entry, ex, ey);
        switch(title.orient){
            case Left:
                ty += legendTitleOffset(item, entry, title, anchor, 1, 1);
                break;
            case Right:
                tx += legendTitleOffset(item, entry, title, End, 0, 0) + tpad;
                ty += legendTitleOffset(item, entry, title, anchor, 1, 1);
                break;
            case Bottom:
                tx += legendTitleOffset(item, entry, title, anchor, 0, 0);
                ty += legendTitleOffset(item, entry, title, End, -1, 0, 1) + tpad;
                break;
            default:
                tx += legendTitleOffset(item, entry, title, anchor, 0, 0);
        }
        if (tx || ty) translate(view, title, tx, ty);
        // translate legend if title pushes into negative coordinates
        if ((tx = Math.round(title.bounds.x1 - pad)) < 0) {
            translate(view, entry, -tx, 0);
            translate(view, title, -tx, 0);
        }
    }
}
function legendTitleOffset(item, entry, title, anchor, y, lr, noBar) {
    const grad = item.datum.type !== 'symbol', vgrad = title.datum.vgrad, e = grad && (lr || !vgrad) && !noBar ? entry.items[0] : entry, s = e.bounds[y ? 'y2' : 'x2'] - item.padding, u = vgrad && lr ? s : 0, v = vgrad && lr ? 0 : s, o = y <= 0 ? 0 : (0, _vegaScenegraph.multiLineOffset)(title);
    return Math.round(anchor === Start ? u : anchor === End ? v - o : 0.5 * (s - o));
}
function translate(view, item, dx, dy) {
    item.x += dx;
    item.y += dy;
    item.bounds.translate(dx, dy);
    item.mark.bounds.translate(dx, dy);
    view.dirty(item);
}
function legendEntryLayout(entries) {
    // get max widths for each column
    const widths = entries.reduce((w, g)=>{
        w[g.column] = Math.max(g.bounds.x2 - g.x, w[g.column] || 0);
        return w;
    }, {});
    // set dimensions of legend entry groups
    entries.forEach((g)=>{
        g.width = widths[g.column];
        g.height = g.bounds.y2 - g.y;
    });
}
function titleLayout(view, mark, width, height, viewBounds) {
    var group = mark.items[0], frame = group.frame, orient = group.orient, anchor = group.anchor, offset = group.offset, padding = group.padding, title = group.items[0].items[0], subtitle = group.items[1] && group.items[1].items[0], end = orient === Left || orient === Right ? height : width, start = 0, x = 0, y = 0, sx = 0, sy = 0, pos;
    if (frame !== Group) orient === Left ? (start = viewBounds.y2, end = viewBounds.y1) : orient === Right ? (start = viewBounds.y1, end = viewBounds.y2) : (start = viewBounds.x1, end = viewBounds.x2);
    else if (orient === Left) start = height, end = 0;
    pos = anchor === Start ? start : anchor === End ? end : (start + end) / 2;
    if (subtitle && subtitle.text) {
        // position subtitle
        switch(orient){
            case Top:
            case Bottom:
                sy = title.bounds.height() + padding;
                break;
            case Left:
                sx = title.bounds.width() + padding;
                break;
            case Right:
                sx = -title.bounds.width() - padding;
                break;
        }
        tempBounds.clear().union(subtitle.bounds);
        tempBounds.translate(sx - (subtitle.x || 0), sy - (subtitle.y || 0));
        if (set(subtitle, 'x', sx) | set(subtitle, 'y', sy)) {
            view.dirty(subtitle);
            subtitle.bounds.clear().union(tempBounds);
            subtitle.mark.bounds.clear().union(tempBounds);
            view.dirty(subtitle);
        }
        tempBounds.clear().union(subtitle.bounds);
    } else tempBounds.clear();
    tempBounds.union(title.bounds);
    // position title group
    switch(orient){
        case Top:
            x = pos;
            y = viewBounds.y1 - tempBounds.height() - offset;
            break;
        case Left:
            x = viewBounds.x1 - tempBounds.width() - offset;
            y = pos;
            break;
        case Right:
            x = viewBounds.x2 + tempBounds.width() + offset;
            y = pos;
            break;
        case Bottom:
            x = pos;
            y = viewBounds.y2 + offset;
            break;
        default:
            x = group.x;
            y = group.y;
    }
    if (set(group, 'x', x) | set(group, 'y', y)) {
        tempBounds.translate(x, y);
        view.dirty(group);
        group.bounds.clear().union(tempBounds);
        mark.bounds.clear().union(tempBounds);
        view.dirty(group);
    }
    return group.bounds;
}
/**
 * Layout view elements such as axes and legends.
 * Also performs size adjustments.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {object} params.mark - Scenegraph mark of groups to layout.
 */ function ViewLayout(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
(0, _vegaUtil.inherits)(ViewLayout, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const view = pulse.dataflow;
        _.mark.items.forEach((group)=>{
            if (_.layout) trellisLayout(view, group, _.layout);
            layoutGroup(view, group, _);
        });
        return shouldReflow(_.mark.group) ? pulse.reflow() : pulse;
    }
});
function shouldReflow(group) {
    // We typically should reflow if layout is invoked (#2568), as child items
    // may have resized and reflow ensures group bounds are re-calculated.
    // However, legend entries have a special exception to avoid instability.
    // For example, if a selected legend symbol gains a stroke on hover,
    // we don't want to re-position subsequent elements in the legend.
    return group && group.mark.role !== 'legend-entry';
}
function layoutGroup(view, group, _) {
    var items = group.items, width = Math.max(0, group.width || 0), height = Math.max(0, group.height || 0), viewBounds = new (0, _vegaScenegraph.Bounds)().set(0, 0, width, height), xBounds = viewBounds.clone(), yBounds = viewBounds.clone(), legends = [], title, mark, orient, b, i, n;
    // layout axes, gather legends, collect bounds
    for(i = 0, n = items.length; i < n; ++i){
        mark = items[i];
        switch(mark.role){
            case AxisRole:
                b = isYAxis(mark) ? xBounds : yBounds;
                b.union(axisLayout(view, mark, width, height));
                break;
            case TitleRole:
                title = mark;
                break;
            case LegendRole:
                legends.push(legendLayout(view, mark));
                break;
            case FrameRole:
            case ScopeRole:
            case RowHeader:
            case RowFooter:
            case RowTitle:
            case ColHeader:
            case ColFooter:
            case ColTitle:
                xBounds.union(mark.bounds);
                yBounds.union(mark.bounds);
                break;
            default:
                viewBounds.union(mark.bounds);
        }
    }
    // layout legends, adjust viewBounds
    if (legends.length) {
        // group legends by orient
        const l = {};
        legends.forEach((item)=>{
            orient = item.orient || Right;
            if (orient !== None) (l[orient] || (l[orient] = [])).push(item);
        });
        // perform grid layout for each orient group
        for(const orient in l){
            const g = l[orient];
            gridLayout(view, g, legendParams(g, orient, _.legends, xBounds, yBounds, width, height));
        }
        // update view bounds
        legends.forEach((item)=>{
            const b = item.bounds;
            if (!b.equals(item._bounds)) {
                item.bounds = item._bounds;
                view.dirty(item); // dirty previous location
                item.bounds = b;
                view.dirty(item);
            }
            if (_.autosize && (_.autosize.type === Fit || _.autosize.type === FitX || _.autosize.type === FitY)) // For autosize fit, incorporate the orthogonal dimension only.
            // Legends that overrun the chart area will then be clipped;
            // otherwise the chart area gets reduced to nothing!
            switch(item.orient){
                case Left:
                case Right:
                    viewBounds.add(b.x1, 0).add(b.x2, 0);
                    break;
                case Top:
                case Bottom:
                    viewBounds.add(0, b.y1).add(0, b.y2);
            }
            else viewBounds.union(b);
        });
    }
    // combine bounding boxes
    viewBounds.union(xBounds).union(yBounds);
    // layout title, adjust bounds
    if (title) viewBounds.union(titleLayout(view, title, width, height, viewBounds));
    // override aggregated view bounds if content is clipped
    if (group.clip) viewBounds.set(0, 0, group.width || 0, group.height || 0);
    // perform size adjustment
    viewSizeLayout(view, group, viewBounds, _);
}
function viewSizeLayout(view, group, viewBounds, _) {
    const auto = _.autosize || {}, type = auto.type;
    if (view._autosize < 1 || !type) return;
    let viewWidth = view._width, viewHeight = view._height, width = Math.max(0, group.width || 0), left = Math.max(0, Math.ceil(-viewBounds.x1)), height = Math.max(0, group.height || 0), top = Math.max(0, Math.ceil(-viewBounds.y1));
    const right = Math.max(0, Math.ceil(viewBounds.x2 - width)), bottom = Math.max(0, Math.ceil(viewBounds.y2 - height));
    if (auto.contains === Padding) {
        const padding = view.padding();
        viewWidth -= padding.left + padding.right;
        viewHeight -= padding.top + padding.bottom;
    }
    if (type === None) {
        left = 0;
        top = 0;
        width = viewWidth;
        height = viewHeight;
    } else if (type === Fit) {
        width = Math.max(0, viewWidth - left - right);
        height = Math.max(0, viewHeight - top - bottom);
    } else if (type === FitX) {
        width = Math.max(0, viewWidth - left - right);
        viewHeight = height + top + bottom;
    } else if (type === FitY) {
        viewWidth = width + left + right;
        height = Math.max(0, viewHeight - top - bottom);
    } else if (type === Pad) {
        viewWidth = width + left + right;
        viewHeight = height + top + bottom;
    }
    view._resizeView(viewWidth, viewHeight, width, height, [
        left,
        top
    ], auto.resize);
}

},{"vega-dataflow":"4An7U","vega-scenegraph":"823vy","vega-util":"7f6sQ","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"823vy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "path", ()=>(0, _d3Path.path));
parcelHelpers.export(exports, "Bounds", ()=>Bounds);
parcelHelpers.export(exports, "CanvasHandler", ()=>CanvasHandler);
parcelHelpers.export(exports, "CanvasRenderer", ()=>CanvasRenderer);
parcelHelpers.export(exports, "Gradient", ()=>Gradient);
parcelHelpers.export(exports, "GroupItem", ()=>GroupItem);
parcelHelpers.export(exports, "Handler", ()=>Handler);
parcelHelpers.export(exports, "HybridHandler", ()=>HybridHandler);
parcelHelpers.export(exports, "HybridRenderer", ()=>HybridRenderer);
parcelHelpers.export(exports, "Item", ()=>Item);
parcelHelpers.export(exports, "Marks", ()=>Marks);
parcelHelpers.export(exports, "RenderType", ()=>RenderType);
parcelHelpers.export(exports, "Renderer", ()=>Renderer);
parcelHelpers.export(exports, "ResourceLoader", ()=>ResourceLoader);
parcelHelpers.export(exports, "SVGHandler", ()=>SVGHandler);
parcelHelpers.export(exports, "SVGRenderer", ()=>SVGRenderer);
parcelHelpers.export(exports, "SVGStringRenderer", ()=>SVGStringRenderer);
parcelHelpers.export(exports, "Scenegraph", ()=>Scenegraph);
parcelHelpers.export(exports, "boundClip", ()=>boundClip);
parcelHelpers.export(exports, "boundContext", ()=>boundContext);
parcelHelpers.export(exports, "boundItem", ()=>boundItem);
parcelHelpers.export(exports, "boundMark", ()=>boundMark);
parcelHelpers.export(exports, "boundStroke", ()=>boundStroke);
parcelHelpers.export(exports, "domChild", ()=>domChild);
parcelHelpers.export(exports, "domClear", ()=>domClear);
parcelHelpers.export(exports, "domCreate", ()=>domCreate);
parcelHelpers.export(exports, "domFind", ()=>domFind);
parcelHelpers.export(exports, "font", ()=>font);
parcelHelpers.export(exports, "fontFamily", ()=>fontFamily);
parcelHelpers.export(exports, "fontSize", ()=>fontSize);
parcelHelpers.export(exports, "intersect", ()=>intersect);
parcelHelpers.export(exports, "intersectBoxLine", ()=>intersectBoxLine);
parcelHelpers.export(exports, "intersectPath", ()=>intersectPath);
parcelHelpers.export(exports, "intersectPoint", ()=>intersectPoint);
parcelHelpers.export(exports, "intersectRule", ()=>intersectRule);
parcelHelpers.export(exports, "lineHeight", ()=>lineHeight);
parcelHelpers.export(exports, "markup", ()=>markup);
parcelHelpers.export(exports, "multiLineOffset", ()=>multiLineOffset);
parcelHelpers.export(exports, "pathCurves", ()=>curves);
parcelHelpers.export(exports, "pathEqual", ()=>pathEqual);
parcelHelpers.export(exports, "pathParse", ()=>parse);
parcelHelpers.export(exports, "pathRectangle", ()=>vg_rect);
parcelHelpers.export(exports, "pathRender", ()=>pathRender);
parcelHelpers.export(exports, "pathSymbols", ()=>symbols);
parcelHelpers.export(exports, "pathTrail", ()=>vg_trail);
parcelHelpers.export(exports, "point", ()=>point);
parcelHelpers.export(exports, "renderModule", ()=>renderModule);
parcelHelpers.export(exports, "resetSVGClipId", ()=>resetSVGClipId);
parcelHelpers.export(exports, "resetSVGDefIds", ()=>resetSVGDefIds);
parcelHelpers.export(exports, "sceneEqual", ()=>sceneEqual);
parcelHelpers.export(exports, "sceneFromJSON", ()=>sceneFromJSON);
parcelHelpers.export(exports, "scenePickVisit", ()=>pickVisit);
parcelHelpers.export(exports, "sceneToJSON", ()=>sceneToJSON);
parcelHelpers.export(exports, "sceneVisit", ()=>visit);
parcelHelpers.export(exports, "sceneZOrder", ()=>zorder);
parcelHelpers.export(exports, "serializeXML", ()=>serializeXML);
parcelHelpers.export(exports, "setHybridRendererOptions", ()=>setHybridRendererOptions);
parcelHelpers.export(exports, "textMetrics", ()=>textMetrics);
var _vegaUtil = require("vega-util");
var _d3Shape = require("d3-shape");
var _d3Path = require("d3-path");
var _vegaCanvas = require("vega-canvas");
var _vegaLoader = require("vega-loader");
var _vegaScale = require("vega-scale");
let gradient_id = 0;
function resetSVGGradientId() {
    gradient_id = 0;
}
const patternPrefix = 'p_';
function isGradient(value) {
    return value && value.gradient;
}
function gradientRef(g, defs, base) {
    const type = g.gradient;
    let id = g.id, prefix = type === 'radial' ? patternPrefix : '';
    // check id, assign default values as needed
    if (!id) {
        id = g.id = 'gradient_' + gradient_id++;
        if (type === 'radial') {
            g.x1 = get(g.x1, 0.5);
            g.y1 = get(g.y1, 0.5);
            g.r1 = get(g.r1, 0);
            g.x2 = get(g.x2, 0.5);
            g.y2 = get(g.y2, 0.5);
            g.r2 = get(g.r2, 0.5);
            prefix = patternPrefix;
        } else {
            g.x1 = get(g.x1, 0);
            g.y1 = get(g.y1, 0);
            g.x2 = get(g.x2, 1);
            g.y2 = get(g.y2, 0);
        }
    }
    // register definition
    defs[id] = g;
    // return url reference
    return 'url(' + (base || '') + '#' + prefix + id + ')';
}
function get(val, def) {
    return val != null ? val : def;
}
function Gradient(p0, p1) {
    var stops = [], gradient;
    return gradient = {
        gradient: 'linear',
        x1: p0 ? p0[0] : 0,
        y1: p0 ? p0[1] : 0,
        x2: p1 ? p1[0] : 1,
        y2: p1 ? p1[1] : 0,
        stops: stops,
        stop: function(offset, color) {
            stops.push({
                offset: offset,
                color: color
            });
            return gradient;
        }
    };
}
const lookup = {
    'basis': {
        curve: (0, _d3Shape.curveBasis)
    },
    'basis-closed': {
        curve: (0, _d3Shape.curveBasisClosed)
    },
    'basis-open': {
        curve: (0, _d3Shape.curveBasisOpen)
    },
    'bundle': {
        curve: (0, _d3Shape.curveBundle),
        tension: 'beta',
        value: 0.85
    },
    'cardinal': {
        curve: (0, _d3Shape.curveCardinal),
        tension: 'tension',
        value: 0
    },
    'cardinal-open': {
        curve: (0, _d3Shape.curveCardinalOpen),
        tension: 'tension',
        value: 0
    },
    'cardinal-closed': {
        curve: (0, _d3Shape.curveCardinalClosed),
        tension: 'tension',
        value: 0
    },
    'catmull-rom': {
        curve: (0, _d3Shape.curveCatmullRom),
        tension: 'alpha',
        value: 0.5
    },
    'catmull-rom-closed': {
        curve: (0, _d3Shape.curveCatmullRomClosed),
        tension: 'alpha',
        value: 0.5
    },
    'catmull-rom-open': {
        curve: (0, _d3Shape.curveCatmullRomOpen),
        tension: 'alpha',
        value: 0.5
    },
    'linear': {
        curve: (0, _d3Shape.curveLinear)
    },
    'linear-closed': {
        curve: (0, _d3Shape.curveLinearClosed)
    },
    'monotone': {
        horizontal: (0, _d3Shape.curveMonotoneY),
        vertical: (0, _d3Shape.curveMonotoneX)
    },
    'natural': {
        curve: (0, _d3Shape.curveNatural)
    },
    'step': {
        curve: (0, _d3Shape.curveStep)
    },
    'step-after': {
        curve: (0, _d3Shape.curveStepAfter)
    },
    'step-before': {
        curve: (0, _d3Shape.curveStepBefore)
    }
};
function curves(type, orientation, tension) {
    var entry = (0, _vegaUtil.hasOwnProperty)(lookup, type) && lookup[type], curve = null;
    if (entry) {
        curve = entry.curve || entry[orientation || 'vertical'];
        if (entry.tension && tension != null) curve = curve[entry.tension](tension);
    }
    return curve;
}
const paramCounts = {
    m: 2,
    l: 2,
    h: 1,
    v: 1,
    z: 0,
    c: 6,
    s: 4,
    q: 4,
    t: 2,
    a: 7
};
const commandPattern = /[mlhvzcsqta]([^mlhvzcsqta]+|$)/gi;
const numberPattern = /^[+-]?(([0-9]*\.[0-9]+)|([0-9]+\.)|([0-9]+))([eE][+-]?[0-9]+)?/;
const spacePattern = /^((\s+,?\s*)|(,\s*))/;
const flagPattern = /^[01]/;
function parse(path) {
    const commands = [];
    const matches = path.match(commandPattern) || [];
    matches.forEach((str)=>{
        let cmd = str[0];
        const type = cmd.toLowerCase();
        // parse parameters
        const paramCount = paramCounts[type];
        const params = parseParams(type, paramCount, str.slice(1).trim());
        const count = params.length;
        // error checking based on parameter count
        if (count < paramCount || count && count % paramCount !== 0) throw Error('Invalid SVG path, incorrect parameter count');
        // register the command
        commands.push([
            cmd,
            ...params.slice(0, paramCount)
        ]);
        // exit now if we're done, also handles zero-param 'z'
        if (count === paramCount) return;
        // handle implicit line-to
        if (type === 'm') cmd = cmd === 'M' ? 'L' : 'l';
        // repeat command when given extended param list
        for(let i = paramCount; i < count; i += paramCount)commands.push([
            cmd,
            ...params.slice(i, i + paramCount)
        ]);
    });
    return commands;
}
function parseParams(type, paramCount, segment) {
    const params = [];
    for(let index = 0; paramCount && index < segment.length;)for(let i = 0; i < paramCount; ++i){
        const pattern = type === 'a' && (i === 3 || i === 4) ? flagPattern : numberPattern;
        const match = segment.slice(index).match(pattern);
        if (match === null) throw Error('Invalid SVG path, incorrect parameter type');
        index += match[0].length;
        params.push(+match[0]);
        const ws = segment.slice(index).match(spacePattern);
        if (ws !== null) index += ws[0].length;
    }
    return params;
}
const DegToRad = Math.PI / 180;
const Epsilon = 1e-14;
const HalfPi = Math.PI / 2;
const Tau = Math.PI * 2;
const HalfSqrt3 = Math.sqrt(3) / 2;
var segmentCache = {};
var bezierCache = {};
var join = [].join;
// Copied from Inkscape svgtopdf, thanks!
function segments(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
    const key = join.call(arguments);
    if (segmentCache[key]) return segmentCache[key];
    const th = rotateX * DegToRad;
    const sin_th = Math.sin(th);
    const cos_th = Math.cos(th);
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    const px = cos_th * (ox - x) * 0.5 + sin_th * (oy - y) * 0.5;
    const py = cos_th * (oy - y) * 0.5 - sin_th * (ox - x) * 0.5;
    let pl = px * px / (rx * rx) + py * py / (ry * ry);
    if (pl > 1) {
        pl = Math.sqrt(pl);
        rx *= pl;
        ry *= pl;
    }
    const a00 = cos_th / rx;
    const a01 = sin_th / rx;
    const a10 = -sin_th / ry;
    const a11 = cos_th / ry;
    const x0 = a00 * ox + a01 * oy;
    const y0 = a10 * ox + a11 * oy;
    const x1 = a00 * x + a01 * y;
    const y1 = a10 * x + a11 * y;
    const d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
    let sfactor_sq = 1 / d - 0.25;
    if (sfactor_sq < 0) sfactor_sq = 0;
    let sfactor = Math.sqrt(sfactor_sq);
    if (sweep == large) sfactor = -sfactor;
    const xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
    const yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
    const th0 = Math.atan2(y0 - yc, x0 - xc);
    const th1 = Math.atan2(y1 - yc, x1 - xc);
    let th_arc = th1 - th0;
    if (th_arc < 0 && sweep === 1) th_arc += Tau;
    else if (th_arc > 0 && sweep === 0) th_arc -= Tau;
    const segs = Math.ceil(Math.abs(th_arc / (HalfPi + 0.001)));
    const result = [];
    for(let i = 0; i < segs; ++i){
        const th2 = th0 + i * th_arc / segs;
        const th3 = th0 + (i + 1) * th_arc / segs;
        result[i] = [
            xc,
            yc,
            th2,
            th3,
            rx,
            ry,
            sin_th,
            cos_th
        ];
    }
    return segmentCache[key] = result;
}
function bezier(params) {
    const key = join.call(params);
    if (bezierCache[key]) return bezierCache[key];
    var cx = params[0], cy = params[1], th0 = params[2], th1 = params[3], rx = params[4], ry = params[5], sin_th = params[6], cos_th = params[7];
    const a00 = cos_th * rx;
    const a01 = -sin_th * ry;
    const a10 = sin_th * rx;
    const a11 = cos_th * ry;
    const cos_th0 = Math.cos(th0);
    const sin_th0 = Math.sin(th0);
    const cos_th1 = Math.cos(th1);
    const sin_th1 = Math.sin(th1);
    const th_half = 0.5 * (th1 - th0);
    const sin_th_h2 = Math.sin(th_half * 0.5);
    const t = 8 / 3 * sin_th_h2 * sin_th_h2 / Math.sin(th_half);
    const x1 = cx + cos_th0 - t * sin_th0;
    const y1 = cy + sin_th0 + t * cos_th0;
    const x3 = cx + cos_th1;
    const y3 = cy + sin_th1;
    const x2 = x3 + t * sin_th1;
    const y2 = y3 - t * cos_th1;
    return bezierCache[key] = [
        a00 * x1 + a01 * y1,
        a10 * x1 + a11 * y1,
        a00 * x2 + a01 * y2,
        a10 * x2 + a11 * y2,
        a00 * x3 + a01 * y3,
        a10 * x3 + a11 * y3
    ];
}
const temp = [
    'l',
    0,
    0,
    0,
    0,
    0,
    0,
    0
];
function scale$1(current, sX, sY) {
    const c = temp[0] = current[0];
    if (c === 'a' || c === 'A') {
        temp[1] = sX * current[1];
        temp[2] = sY * current[2];
        temp[3] = current[3];
        temp[4] = current[4];
        temp[5] = current[5];
        temp[6] = sX * current[6];
        temp[7] = sY * current[7];
    } else if (c === 'h' || c === 'H') temp[1] = sX * current[1];
    else if (c === 'v' || c === 'V') temp[1] = sY * current[1];
    else for(var i = 1, n = current.length; i < n; ++i)temp[i] = (i % 2 == 1 ? sX : sY) * current[i];
    return temp;
}
function pathRender(context, path, l, t, sX, sY) {
    var current, // current instruction
    previous = null, x = 0, // current x
    y = 0, // current y
    controlX = 0, // current control point x
    controlY = 0, // current control point y
    tempX, tempY, tempControlX, tempControlY, anchorX = 0, anchorY = 0;
    if (l == null) l = 0;
    if (t == null) t = 0;
    if (sX == null) sX = 1;
    if (sY == null) sY = sX;
    if (context.beginPath) context.beginPath();
    for(var i = 0, len = path.length; i < len; ++i){
        current = path[i];
        if (sX !== 1 || sY !== 1) current = scale$1(current, sX, sY);
        switch(current[0]){
            // first letter
            case 'l':
                // lineto, relative
                x += current[1];
                y += current[2];
                context.lineTo(x + l, y + t);
                break;
            case 'L':
                // lineto, absolute
                x = current[1];
                y = current[2];
                context.lineTo(x + l, y + t);
                break;
            case 'h':
                // horizontal lineto, relative
                x += current[1];
                context.lineTo(x + l, y + t);
                break;
            case 'H':
                // horizontal lineto, absolute
                x = current[1];
                context.lineTo(x + l, y + t);
                break;
            case 'v':
                // vertical lineto, relative
                y += current[1];
                context.lineTo(x + l, y + t);
                break;
            case 'V':
                // verical lineto, absolute
                y = current[1];
                context.lineTo(x + l, y + t);
                break;
            case 'm':
                // moveTo, relative
                x += current[1];
                y += current[2];
                anchorX = x;
                anchorY = y;
                context.moveTo(x + l, y + t);
                break;
            case 'M':
                // moveTo, absolute
                x = current[1];
                y = current[2];
                anchorX = x;
                anchorY = y;
                context.moveTo(x + l, y + t);
                break;
            case 'c':
                // bezierCurveTo, relative
                tempX = x + current[5];
                tempY = y + current[6];
                controlX = x + current[3];
                controlY = y + current[4];
                context.bezierCurveTo(x + current[1] + l, // x1
                y + current[2] + t, // y1
                controlX + l, // x2
                controlY + t, // y2
                tempX + l, tempY + t);
                x = tempX;
                y = tempY;
                break;
            case 'C':
                // bezierCurveTo, absolute
                x = current[5];
                y = current[6];
                controlX = current[3];
                controlY = current[4];
                context.bezierCurveTo(current[1] + l, current[2] + t, controlX + l, controlY + t, x + l, y + t);
                break;
            case 's':
                // shorthand cubic bezierCurveTo, relative
                // transform to absolute x,y
                tempX = x + current[3];
                tempY = y + current[4];
                // calculate reflection of previous control points
                controlX = 2 * x - controlX;
                controlY = 2 * y - controlY;
                context.bezierCurveTo(controlX + l, controlY + t, x + current[1] + l, y + current[2] + t, tempX + l, tempY + t);
                // set control point to 2nd one of this command
                // the first control point is assumed to be the reflection of
                // the second control point on the previous command relative
                // to the current point.
                controlX = x + current[1];
                controlY = y + current[2];
                x = tempX;
                y = tempY;
                break;
            case 'S':
                // shorthand cubic bezierCurveTo, absolute
                tempX = current[3];
                tempY = current[4];
                // calculate reflection of previous control points
                controlX = 2 * x - controlX;
                controlY = 2 * y - controlY;
                context.bezierCurveTo(controlX + l, controlY + t, current[1] + l, current[2] + t, tempX + l, tempY + t);
                x = tempX;
                y = tempY;
                // set control point to 2nd one of this command
                // the first control point is assumed to be the reflection of
                // the second control point on the previous command relative
                // to the current point.
                controlX = current[1];
                controlY = current[2];
                break;
            case 'q':
                // quadraticCurveTo, relative
                // transform to absolute x,y
                tempX = x + current[3];
                tempY = y + current[4];
                controlX = x + current[1];
                controlY = y + current[2];
                context.quadraticCurveTo(controlX + l, controlY + t, tempX + l, tempY + t);
                x = tempX;
                y = tempY;
                break;
            case 'Q':
                // quadraticCurveTo, absolute
                tempX = current[3];
                tempY = current[4];
                context.quadraticCurveTo(current[1] + l, current[2] + t, tempX + l, tempY + t);
                x = tempX;
                y = tempY;
                controlX = current[1];
                controlY = current[2];
                break;
            case 't':
                // shorthand quadraticCurveTo, relative
                // transform to absolute x,y
                tempX = x + current[1];
                tempY = y + current[2];
                if (previous[0].match(/[QqTt]/) === null) {
                    // If there is no previous command or if the previous command was not a Q, q, T or t,
                    // assume the control point is coincident with the current point
                    controlX = x;
                    controlY = y;
                } else if (previous[0] === 't') {
                    // calculate reflection of previous control points for t
                    controlX = 2 * x - tempControlX;
                    controlY = 2 * y - tempControlY;
                } else if (previous[0] === 'q') {
                    // calculate reflection of previous control points for q
                    controlX = 2 * x - controlX;
                    controlY = 2 * y - controlY;
                }
                tempControlX = controlX;
                tempControlY = controlY;
                context.quadraticCurveTo(controlX + l, controlY + t, tempX + l, tempY + t);
                x = tempX;
                y = tempY;
                controlX = x + current[1];
                controlY = y + current[2];
                break;
            case 'T':
                tempX = current[1];
                tempY = current[2];
                // calculate reflection of previous control points
                controlX = 2 * x - controlX;
                controlY = 2 * y - controlY;
                context.quadraticCurveTo(controlX + l, controlY + t, tempX + l, tempY + t);
                x = tempX;
                y = tempY;
                break;
            case 'a':
                drawArc(context, x + l, y + t, [
                    current[1],
                    current[2],
                    current[3],
                    current[4],
                    current[5],
                    current[6] + x + l,
                    current[7] + y + t
                ]);
                x += current[6];
                y += current[7];
                break;
            case 'A':
                drawArc(context, x + l, y + t, [
                    current[1],
                    current[2],
                    current[3],
                    current[4],
                    current[5],
                    current[6] + l,
                    current[7] + t
                ]);
                x = current[6];
                y = current[7];
                break;
            case 'z':
            case 'Z':
                x = anchorX;
                y = anchorY;
                context.closePath();
                break;
        }
        previous = current;
    }
}
function drawArc(context, x, y, coords) {
    const seg = segments(coords[5], // end x
    coords[6], // end y
    coords[0], // radius x
    coords[1], // radius y
    coords[3], // large flag
    coords[4], // sweep flag
    coords[2], // rotation
    x, y);
    for(let i = 0; i < seg.length; ++i){
        const bez = bezier(seg[i]);
        context.bezierCurveTo(bez[0], bez[1], bez[2], bez[3], bez[4], bez[5]);
    }
}
const Tan30 = 0.5773502691896257;
const builtins = {
    'circle': {
        draw: function(context, size) {
            const r = Math.sqrt(size) / 2;
            context.moveTo(r, 0);
            context.arc(0, 0, r, 0, Tau);
        }
    },
    'cross': {
        draw: function(context, size) {
            var r = Math.sqrt(size) / 2, s = r / 2.5;
            context.moveTo(-r, -s);
            context.lineTo(-r, s);
            context.lineTo(-s, s);
            context.lineTo(-s, r);
            context.lineTo(s, r);
            context.lineTo(s, s);
            context.lineTo(r, s);
            context.lineTo(r, -s);
            context.lineTo(s, -s);
            context.lineTo(s, -r);
            context.lineTo(-s, -r);
            context.lineTo(-s, -s);
            context.closePath();
        }
    },
    'diamond': {
        draw: function(context, size) {
            const r = Math.sqrt(size) / 2;
            context.moveTo(-r, 0);
            context.lineTo(0, -r);
            context.lineTo(r, 0);
            context.lineTo(0, r);
            context.closePath();
        }
    },
    'square': {
        draw: function(context, size) {
            var w = Math.sqrt(size), x = -w / 2;
            context.rect(x, x, w, w);
        }
    },
    'arrow': {
        draw: function(context, size) {
            var r = Math.sqrt(size) / 2, s = r / 7, t = r / 2.5, v = r / 8;
            context.moveTo(-s, r);
            context.lineTo(s, r);
            context.lineTo(s, -v);
            context.lineTo(t, -v);
            context.lineTo(0, -r);
            context.lineTo(-t, -v);
            context.lineTo(-s, -v);
            context.closePath();
        }
    },
    'wedge': {
        draw: function(context, size) {
            var r = Math.sqrt(size) / 2, h = HalfSqrt3 * r, o = h - r * Tan30, b = r / 4;
            context.moveTo(0, -h - o);
            context.lineTo(-b, h - o);
            context.lineTo(b, h - o);
            context.closePath();
        }
    },
    'triangle': {
        draw: function(context, size) {
            var r = Math.sqrt(size) / 2, h = HalfSqrt3 * r, o = h - r * Tan30;
            context.moveTo(0, -h - o);
            context.lineTo(-r, h - o);
            context.lineTo(r, h - o);
            context.closePath();
        }
    },
    'triangle-up': {
        draw: function(context, size) {
            var r = Math.sqrt(size) / 2, h = HalfSqrt3 * r;
            context.moveTo(0, -h);
            context.lineTo(-r, h);
            context.lineTo(r, h);
            context.closePath();
        }
    },
    'triangle-down': {
        draw: function(context, size) {
            var r = Math.sqrt(size) / 2, h = HalfSqrt3 * r;
            context.moveTo(0, h);
            context.lineTo(-r, -h);
            context.lineTo(r, -h);
            context.closePath();
        }
    },
    'triangle-right': {
        draw: function(context, size) {
            var r = Math.sqrt(size) / 2, h = HalfSqrt3 * r;
            context.moveTo(h, 0);
            context.lineTo(-h, -r);
            context.lineTo(-h, r);
            context.closePath();
        }
    },
    'triangle-left': {
        draw: function(context, size) {
            var r = Math.sqrt(size) / 2, h = HalfSqrt3 * r;
            context.moveTo(-h, 0);
            context.lineTo(h, -r);
            context.lineTo(h, r);
            context.closePath();
        }
    },
    'stroke': {
        draw: function(context, size) {
            const r = Math.sqrt(size) / 2;
            context.moveTo(-r, 0);
            context.lineTo(r, 0);
        }
    }
};
function symbols(_) {
    return (0, _vegaUtil.hasOwnProperty)(builtins, _) ? builtins[_] : customSymbol(_);
}
var custom = {};
function customSymbol(path) {
    if (!(0, _vegaUtil.hasOwnProperty)(custom, path)) {
        const parsed = parse(path);
        custom[path] = {
            draw: function(context, size) {
                pathRender(context, parsed, 0, 0, Math.sqrt(size) / 2);
            }
        };
    }
    return custom[path];
}
// See http://spencermortensen.com/articles/bezier-circle/
const C = 0.448084975506; // C = 1 - c
function rectangleX(d) {
    return d.x;
}
function rectangleY(d) {
    return d.y;
}
function rectangleWidth(d) {
    return d.width;
}
function rectangleHeight(d) {
    return d.height;
}
function number(_) {
    return typeof _ === 'function' ? _ : ()=>+_;
}
function clamp(value, min, max) {
    return Math.max(min, Math.min(value, max));
}
function vg_rect() {
    var x = rectangleX, y = rectangleY, width = rectangleWidth, height = rectangleHeight, crTL = number(0), crTR = crTL, crBL = crTL, crBR = crTL, context = null;
    function rectangle(_, x0, y0) {
        var buffer, x1 = x0 != null ? x0 : +x.call(this, _), y1 = y0 != null ? y0 : +y.call(this, _), w = +width.call(this, _), h = +height.call(this, _), s = Math.min(w, h) / 2, tl = clamp(+crTL.call(this, _), 0, s), tr = clamp(+crTR.call(this, _), 0, s), bl = clamp(+crBL.call(this, _), 0, s), br = clamp(+crBR.call(this, _), 0, s);
        if (!context) context = buffer = (0, _d3Path.path)();
        if (tl <= 0 && tr <= 0 && bl <= 0 && br <= 0) context.rect(x1, y1, w, h);
        else {
            var x2 = x1 + w, y2 = y1 + h;
            context.moveTo(x1 + tl, y1);
            context.lineTo(x2 - tr, y1);
            context.bezierCurveTo(x2 - C * tr, y1, x2, y1 + C * tr, x2, y1 + tr);
            context.lineTo(x2, y2 - br);
            context.bezierCurveTo(x2, y2 - C * br, x2 - C * br, y2, x2 - br, y2);
            context.lineTo(x1 + bl, y2);
            context.bezierCurveTo(x1 + C * bl, y2, x1, y2 - C * bl, x1, y2 - bl);
            context.lineTo(x1, y1 + tl);
            context.bezierCurveTo(x1, y1 + C * tl, x1 + C * tl, y1, x1 + tl, y1);
            context.closePath();
        }
        if (buffer) {
            context = null;
            return buffer + '' || null;
        }
    }
    rectangle.x = function(_) {
        if (arguments.length) {
            x = number(_);
            return rectangle;
        } else return x;
    };
    rectangle.y = function(_) {
        if (arguments.length) {
            y = number(_);
            return rectangle;
        } else return y;
    };
    rectangle.width = function(_) {
        if (arguments.length) {
            width = number(_);
            return rectangle;
        } else return width;
    };
    rectangle.height = function(_) {
        if (arguments.length) {
            height = number(_);
            return rectangle;
        } else return height;
    };
    rectangle.cornerRadius = function(tl, tr, br, bl) {
        if (arguments.length) {
            crTL = number(tl);
            crTR = tr != null ? number(tr) : crTL;
            crBR = br != null ? number(br) : crTL;
            crBL = bl != null ? number(bl) : crTR;
            return rectangle;
        } else return crTL;
    };
    rectangle.context = function(_) {
        if (arguments.length) {
            context = _ == null ? null : _;
            return rectangle;
        } else return context;
    };
    return rectangle;
}
function vg_trail() {
    var x, y, size, defined, context = null, ready, x1, y1, r1;
    function point(x2, y2, w2) {
        const r2 = w2 / 2;
        if (ready) {
            var ux = y1 - y2, uy = x2 - x1;
            if (ux || uy) {
                // get normal vector
                var ud = Math.hypot(ux, uy), rx = (ux /= ud) * r1, ry = (uy /= ud) * r1, t = Math.atan2(uy, ux);
                // draw segment
                context.moveTo(x1 - rx, y1 - ry);
                context.lineTo(x2 - ux * r2, y2 - uy * r2);
                context.arc(x2, y2, r2, t - Math.PI, t);
                context.lineTo(x1 + rx, y1 + ry);
                context.arc(x1, y1, r1, t, t + Math.PI);
            } else context.arc(x2, y2, r2, 0, Tau);
            context.closePath();
        } else ready = 1;
        x1 = x2;
        y1 = y2;
        r1 = r2;
    }
    function trail(data) {
        var i, n = data.length, d, defined0 = false, buffer;
        if (context == null) context = buffer = (0, _d3Path.path)();
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) ready = 0;
            }
            if (defined0) point(+x(d, i, data), +y(d, i, data), +size(d, i, data));
        }
        if (buffer) {
            context = null;
            return buffer + '' || null;
        }
    }
    trail.x = function(_) {
        if (arguments.length) {
            x = _;
            return trail;
        } else return x;
    };
    trail.y = function(_) {
        if (arguments.length) {
            y = _;
            return trail;
        } else return y;
    };
    trail.size = function(_) {
        if (arguments.length) {
            size = _;
            return trail;
        } else return size;
    };
    trail.defined = function(_) {
        if (arguments.length) {
            defined = _;
            return trail;
        } else return defined;
    };
    trail.context = function(_) {
        if (arguments.length) {
            if (_ == null) context = null;
            else context = _;
            return trail;
        } else return context;
    };
    return trail;
}
function value$1(a, b) {
    return a != null ? a : b;
}
const x = (item)=>item.x || 0, y = (item)=>item.y || 0, w = (item)=>item.width || 0, h = (item)=>item.height || 0, xw = (item)=>(item.x || 0) + (item.width || 0), yh = (item)=>(item.y || 0) + (item.height || 0), sa = (item)=>item.startAngle || 0, ea = (item)=>item.endAngle || 0, pa = (item)=>item.padAngle || 0, ir = (item)=>item.innerRadius || 0, or = (item)=>item.outerRadius || 0, cr = (item)=>item.cornerRadius || 0, tl = (item)=>value$1(item.cornerRadiusTopLeft, item.cornerRadius) || 0, tr = (item)=>value$1(item.cornerRadiusTopRight, item.cornerRadius) || 0, br = (item)=>value$1(item.cornerRadiusBottomRight, item.cornerRadius) || 0, bl = (item)=>value$1(item.cornerRadiusBottomLeft, item.cornerRadius) || 0, sz = (item)=>value$1(item.size, 64), ts = (item)=>item.size || 1, def = (item)=>!(item.defined === false), type = (item)=>symbols(item.shape || 'circle');
const arcShape = (0, _d3Shape.arc)().startAngle(sa).endAngle(ea).padAngle(pa).innerRadius(ir).outerRadius(or).cornerRadius(cr), areavShape = (0, _d3Shape.area)().x(x).y1(y).y0(yh).defined(def), areahShape = (0, _d3Shape.area)().y(y).x1(x).x0(xw).defined(def), lineShape = (0, _d3Shape.line)().x(x).y(y).defined(def), rectShape = vg_rect().x(x).y(y).width(w).height(h).cornerRadius(tl, tr, br, bl), symbolShape = (0, _d3Shape.symbol)().type(type).size(sz), trailShape = vg_trail().x(x).y(y).defined(def).size(ts);
function hasCornerRadius(item) {
    return item.cornerRadius || item.cornerRadiusTopLeft || item.cornerRadiusTopRight || item.cornerRadiusBottomRight || item.cornerRadiusBottomLeft;
}
function arc$1(context, item) {
    return arcShape.context(context)(item);
}
function area$1(context, items) {
    const item = items[0], interp = item.interpolate || 'linear';
    return (item.orient === 'horizontal' ? areahShape : areavShape).curve(curves(interp, item.orient, item.tension)).context(context)(items);
}
function line$1(context, items) {
    const item = items[0], interp = item.interpolate || 'linear';
    return lineShape.curve(curves(interp, item.orient, item.tension)).context(context)(items);
}
function rectangle(context, item, x, y) {
    return rectShape.context(context)(item, x, y);
}
function shape$1(context, item) {
    return (item.mark.shape || item.shape).context(context)(item);
}
function symbol$1(context, item) {
    return symbolShape.context(context)(item);
}
function trail$1(context, items) {
    return trailShape.context(context)(items);
}
var clip_id = 1;
function resetSVGClipId() {
    clip_id = 1;
}
function clip$1(renderer, item, size) {
    var clip = item.clip, defs = renderer._defs, id = item.clip_id || (item.clip_id = 'clip' + clip_id++), c = defs.clipping[id] || (defs.clipping[id] = {
        id: id
    });
    if ((0, _vegaUtil.isFunction)(clip)) c.path = clip(null);
    else if (hasCornerRadius(size)) c.path = rectangle(null, size, 0, 0);
    else {
        c.width = size.width || 0;
        c.height = size.height || 0;
    }
    return 'url(#' + id + ')';
}
function Bounds(b) {
    this.clear();
    if (b) this.union(b);
}
Bounds.prototype = {
    clone () {
        return new Bounds(this);
    },
    clear () {
        this.x1 = +Number.MAX_VALUE;
        this.y1 = +Number.MAX_VALUE;
        this.x2 = -Number.MAX_VALUE;
        this.y2 = -Number.MAX_VALUE;
        return this;
    },
    empty () {
        return this.x1 === +Number.MAX_VALUE && this.y1 === +Number.MAX_VALUE && this.x2 === -Number.MAX_VALUE && this.y2 === -Number.MAX_VALUE;
    },
    equals (b) {
        return this.x1 === b.x1 && this.y1 === b.y1 && this.x2 === b.x2 && this.y2 === b.y2;
    },
    set (x1, y1, x2, y2) {
        if (x2 < x1) {
            this.x2 = x1;
            this.x1 = x2;
        } else {
            this.x1 = x1;
            this.x2 = x2;
        }
        if (y2 < y1) {
            this.y2 = y1;
            this.y1 = y2;
        } else {
            this.y1 = y1;
            this.y2 = y2;
        }
        return this;
    },
    add (x, y) {
        if (x < this.x1) this.x1 = x;
        if (y < this.y1) this.y1 = y;
        if (x > this.x2) this.x2 = x;
        if (y > this.y2) this.y2 = y;
        return this;
    },
    expand (d) {
        this.x1 -= d;
        this.y1 -= d;
        this.x2 += d;
        this.y2 += d;
        return this;
    },
    round () {
        this.x1 = Math.floor(this.x1);
        this.y1 = Math.floor(this.y1);
        this.x2 = Math.ceil(this.x2);
        this.y2 = Math.ceil(this.y2);
        return this;
    },
    scale (s) {
        this.x1 *= s;
        this.y1 *= s;
        this.x2 *= s;
        this.y2 *= s;
        return this;
    },
    translate (dx, dy) {
        this.x1 += dx;
        this.x2 += dx;
        this.y1 += dy;
        this.y2 += dy;
        return this;
    },
    rotate (angle, x, y) {
        const p = this.rotatedPoints(angle, x, y);
        return this.clear().add(p[0], p[1]).add(p[2], p[3]).add(p[4], p[5]).add(p[6], p[7]);
    },
    rotatedPoints (angle, x, y) {
        var { x1, y1, x2, y2 } = this, cos = Math.cos(angle), sin = Math.sin(angle), cx = x - x * cos + y * sin, cy = y - x * sin - y * cos;
        return [
            cos * x1 - sin * y1 + cx,
            sin * x1 + cos * y1 + cy,
            cos * x1 - sin * y2 + cx,
            sin * x1 + cos * y2 + cy,
            cos * x2 - sin * y1 + cx,
            sin * x2 + cos * y1 + cy,
            cos * x2 - sin * y2 + cx,
            sin * x2 + cos * y2 + cy
        ];
    },
    union (b) {
        if (b.x1 < this.x1) this.x1 = b.x1;
        if (b.y1 < this.y1) this.y1 = b.y1;
        if (b.x2 > this.x2) this.x2 = b.x2;
        if (b.y2 > this.y2) this.y2 = b.y2;
        return this;
    },
    intersect (b) {
        if (b.x1 > this.x1) this.x1 = b.x1;
        if (b.y1 > this.y1) this.y1 = b.y1;
        if (b.x2 < this.x2) this.x2 = b.x2;
        if (b.y2 < this.y2) this.y2 = b.y2;
        return this;
    },
    encloses (b) {
        return b && this.x1 <= b.x1 && this.x2 >= b.x2 && this.y1 <= b.y1 && this.y2 >= b.y2;
    },
    alignsWith (b) {
        return b && (this.x1 == b.x1 || this.x2 == b.x2 || this.y1 == b.y1 || this.y2 == b.y2);
    },
    intersects (b) {
        return b && !(this.x2 < b.x1 || this.x1 > b.x2 || this.y2 < b.y1 || this.y1 > b.y2);
    },
    contains (x, y) {
        return !(x < this.x1 || x > this.x2 || y < this.y1 || y > this.y2);
    },
    width () {
        return this.x2 - this.x1;
    },
    height () {
        return this.y2 - this.y1;
    }
};
function Item(mark) {
    this.mark = mark;
    this.bounds = this.bounds || new Bounds();
}
function GroupItem(mark) {
    Item.call(this, mark);
    this.items = this.items || [];
}
(0, _vegaUtil.inherits)(GroupItem, Item);
class ResourceLoader {
    constructor(customLoader){
        this._pending = 0;
        this._loader = customLoader || (0, _vegaLoader.loader)();
    }
    pending() {
        return this._pending;
    }
    sanitizeURL(uri) {
        const loader = this;
        increment(loader);
        return loader._loader.sanitize(uri, {
            context: 'href'
        }).then((opt)=>{
            decrement(loader);
            return opt;
        }).catch(()=>{
            decrement(loader);
            return null;
        });
    }
    loadImage(uri) {
        const loader = this, Image = (0, _vegaCanvas.image)();
        increment(loader);
        return loader._loader.sanitize(uri, {
            context: 'image'
        }).then((opt)=>{
            const url = opt.href;
            if (!url || !Image) throw {
                url: url
            };
            const img = new Image();
            // set crossOrigin only if cors is defined; empty string sets anonymous mode
            // https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/crossOrigin
            const cors = (0, _vegaUtil.hasOwnProperty)(opt, 'crossOrigin') ? opt.crossOrigin : 'anonymous';
            if (cors != null) img.crossOrigin = cors;
            // attempt to load image resource
            img.onload = ()=>decrement(loader);
            img.onerror = ()=>decrement(loader);
            img.src = url;
            return img;
        }).catch((e)=>{
            decrement(loader);
            return {
                complete: false,
                width: 0,
                height: 0,
                src: e && e.url || ''
            };
        });
    }
    ready() {
        const loader = this;
        return new Promise((accept)=>{
            function poll(value) {
                if (!loader.pending()) accept(value);
                else setTimeout(()=>{
                    poll(true);
                }, 10);
            }
            poll(false);
        });
    }
}
function increment(loader) {
    loader._pending += 1;
}
function decrement(loader) {
    loader._pending -= 1;
}
function boundStroke(bounds, item, miter) {
    if (item.stroke && item.opacity !== 0 && item.strokeOpacity !== 0) {
        const sw = item.strokeWidth != null ? +item.strokeWidth : 1;
        bounds.expand(sw + (miter ? miterAdjustment(item, sw) : 0));
    }
    return bounds;
}
function miterAdjustment(item, strokeWidth) {
    // TODO: more sophisticated adjustment? Or miter support in boundContext?
    return item.strokeJoin && item.strokeJoin !== 'miter' ? 0 : strokeWidth;
}
const circleThreshold = Tau - 1e-8;
let bounds, lx, ly, rot, ma, mb, mc, md;
const add = (x, y)=>bounds.add(x, y);
const addL = (x, y)=>add(lx = x, ly = y);
const addX = (x)=>add(x, bounds.y1);
const addY = (y)=>add(bounds.x1, y);
const px = (x, y)=>ma * x + mc * y;
const py = (x, y)=>mb * x + md * y;
const addp = (x, y)=>add(px(x, y), py(x, y));
const addpL = (x, y)=>addL(px(x, y), py(x, y));
function boundContext(_, deg) {
    bounds = _;
    if (deg) {
        rot = deg * DegToRad;
        ma = md = Math.cos(rot);
        mb = Math.sin(rot);
        mc = -mb;
    } else {
        ma = md = 1;
        rot = mb = mc = 0;
    }
    return context$1;
}
const context$1 = {
    beginPath () {},
    closePath () {},
    moveTo: addpL,
    lineTo: addpL,
    rect (x, y, w, h) {
        if (rot) {
            addp(x + w, y);
            addp(x + w, y + h);
            addp(x, y + h);
            addpL(x, y);
        } else {
            add(x + w, y + h);
            addL(x, y);
        }
    },
    quadraticCurveTo (x1, y1, x2, y2) {
        const px1 = px(x1, y1), py1 = py(x1, y1), px2 = px(x2, y2), py2 = py(x2, y2);
        quadExtrema(lx, px1, px2, addX);
        quadExtrema(ly, py1, py2, addY);
        addL(px2, py2);
    },
    bezierCurveTo (x1, y1, x2, y2, x3, y3) {
        const px1 = px(x1, y1), py1 = py(x1, y1), px2 = px(x2, y2), py2 = py(x2, y2), px3 = px(x3, y3), py3 = py(x3, y3);
        cubicExtrema(lx, px1, px2, px3, addX);
        cubicExtrema(ly, py1, py2, py3, addY);
        addL(px3, py3);
    },
    arc (cx, cy, r, sa, ea, ccw) {
        sa += rot;
        ea += rot;
        // store last point on path
        lx = r * Math.cos(ea) + cx;
        ly = r * Math.sin(ea) + cy;
        if (Math.abs(ea - sa) > circleThreshold) {
            // treat as full circle
            add(cx - r, cy - r);
            add(cx + r, cy + r);
        } else {
            const update = (a)=>add(r * Math.cos(a) + cx, r * Math.sin(a) + cy);
            let s, i;
            // sample end points
            update(sa);
            update(ea);
            // sample interior points aligned with 90 degrees
            if (ea !== sa) {
                sa = sa % Tau;
                if (sa < 0) sa += Tau;
                ea = ea % Tau;
                if (ea < 0) ea += Tau;
                if (ea < sa) {
                    ccw = !ccw; // flip direction
                    s = sa;
                    sa = ea;
                    ea = s; // swap end-points
                }
                if (ccw) {
                    ea -= Tau;
                    s = sa - sa % HalfPi;
                    for(i = 0; i < 4 && s > ea; ++i, s -= HalfPi)update(s);
                } else {
                    s = sa - sa % HalfPi + HalfPi;
                    for(i = 0; i < 4 && s < ea; ++i, s = s + HalfPi)update(s);
                }
            }
        }
    }
};
function quadExtrema(x0, x1, x2, cb) {
    const t = (x0 - x1) / (x0 + x2 - 2 * x1);
    if (0 < t && t < 1) cb(x0 + (x1 - x0) * t);
}
function cubicExtrema(x0, x1, x2, x3, cb) {
    const a = x3 - x0 + 3 * x1 - 3 * x2, b = x0 + x2 - 2 * x1, c = x0 - x1;
    let t0 = 0, t1 = 0, r;
    // solve for parameter t
    if (Math.abs(a) > Epsilon) {
        // quadratic equation
        r = b * b + c * a;
        if (r >= 0) {
            r = Math.sqrt(r);
            t0 = (-b + r) / a;
            t1 = (-b - r) / a;
        }
    } else // linear equation
    t0 = 0.5 * c / b;
    // calculate position
    if (0 < t0 && t0 < 1) cb(cubic(t0, x0, x1, x2, x3));
    if (0 < t1 && t1 < 1) cb(cubic(t1, x0, x1, x2, x3));
}
function cubic(t, x0, x1, x2, x3) {
    const s = 1 - t, s2 = s * s, t2 = t * t;
    return s2 * s * x0 + 3 * s2 * t * x1 + 3 * s * t2 * x2 + t2 * t * x3;
}
var context = (context = (0, _vegaCanvas.canvas)(1, 1)) ? context.getContext('2d') : null;
const b = new Bounds();
function intersectPath(draw) {
    return function(item, brush) {
        // rely on (inaccurate) bounds intersection if no context
        if (!context) return true;
        // add path to offscreen graphics context
        draw(context, item);
        // get bounds intersection region
        b.clear().union(item.bounds).intersect(brush).round();
        const { x1, y1, x2, y2 } = b;
        // iterate over intersection region
        // perform fine grained inclusion test
        for(let y = y1; y <= y2; ++y)for(let x = x1; x <= x2; ++x){
            if (context.isPointInPath(x, y)) return true;
        }
        // false if no hits in intersection region
        return false;
    };
}
function intersectPoint(item, box) {
    return box.contains(item.x || 0, item.y || 0);
}
function intersectRect(item, box) {
    const x = item.x || 0, y = item.y || 0, w = item.width || 0, h = item.height || 0;
    return box.intersects(b.set(x, y, x + w, y + h));
}
function intersectRule(item, box) {
    const x = item.x || 0, y = item.y || 0, x2 = item.x2 != null ? item.x2 : x, y2 = item.y2 != null ? item.y2 : y;
    return intersectBoxLine(box, x, y, x2, y2);
}
function intersectBoxLine(box, x, y, u, v) {
    const { x1, y1, x2, y2 } = box, dx = u - x, dy = v - y;
    let t0 = 0, t1 = 1, p, q, r, e;
    for(e = 0; e < 4; ++e){
        if (e === 0) {
            p = -dx;
            q = -(x1 - x);
        }
        if (e === 1) {
            p = dx;
            q = x2 - x;
        }
        if (e === 2) {
            p = -dy;
            q = -(y1 - y);
        }
        if (e === 3) {
            p = dy;
            q = y2 - y;
        }
        if (Math.abs(p) < 1e-10 && q < 0) return false;
        r = q / p;
        if (p < 0) {
            if (r > t1) return false;
            else if (r > t0) t0 = r;
        } else if (p > 0) {
            if (r < t0) return false;
            else if (r < t1) t1 = r;
        }
    }
    return true;
}
function blend(context, item) {
    context.globalCompositeOperation = item.blend || 'source-over';
}
function value(value, dflt) {
    return value == null ? dflt : value;
}
function addStops(gradient, stops) {
    const n = stops.length;
    for(let i = 0; i < n; ++i)gradient.addColorStop(stops[i].offset, stops[i].color);
    return gradient;
}
function gradient(context, spec, bounds) {
    const w = bounds.width(), h = bounds.height();
    let gradient;
    if (spec.gradient === 'radial') gradient = context.createRadialGradient(bounds.x1 + value(spec.x1, 0.5) * w, bounds.y1 + value(spec.y1, 0.5) * h, Math.max(w, h) * value(spec.r1, 0), bounds.x1 + value(spec.x2, 0.5) * w, bounds.y1 + value(spec.y2, 0.5) * h, Math.max(w, h) * value(spec.r2, 0.5));
    else {
        // linear gradient
        const x1 = value(spec.x1, 0), y1 = value(spec.y1, 0), x2 = value(spec.x2, 1), y2 = value(spec.y2, 0);
        if (x1 === x2 || y1 === y2 || w === h) // axis aligned: use normal gradient
        gradient = context.createLinearGradient(bounds.x1 + x1 * w, bounds.y1 + y1 * h, bounds.x1 + x2 * w, bounds.y1 + y2 * h);
        else {
            // not axis aligned: render gradient into a pattern (#2365)
            // this allows us to use normalized bounding box coordinates
            const image = (0, _vegaCanvas.canvas)(Math.ceil(w), Math.ceil(h)), ictx = image.getContext('2d');
            ictx.scale(w, h);
            ictx.fillStyle = addStops(ictx.createLinearGradient(x1, y1, x2, y2), spec.stops);
            ictx.fillRect(0, 0, w, h);
            return context.createPattern(image, 'no-repeat');
        }
    }
    return addStops(gradient, spec.stops);
}
function color(context, item, value) {
    return isGradient(value) ? gradient(context, value, item.bounds) : value;
}
function fill(context, item, opacity) {
    opacity *= item.fillOpacity == null ? 1 : item.fillOpacity;
    if (opacity > 0) {
        context.globalAlpha = opacity;
        context.fillStyle = color(context, item, item.fill);
        return true;
    } else return false;
}
var Empty = [];
function stroke(context, item, opacity) {
    var lw = (lw = item.strokeWidth) != null ? lw : 1;
    if (lw <= 0) return false;
    opacity *= item.strokeOpacity == null ? 1 : item.strokeOpacity;
    if (opacity > 0) {
        context.globalAlpha = opacity;
        context.strokeStyle = color(context, item, item.stroke);
        context.lineWidth = lw;
        context.lineCap = item.strokeCap || 'butt';
        context.lineJoin = item.strokeJoin || 'miter';
        context.miterLimit = item.strokeMiterLimit || 10;
        if (context.setLineDash) {
            context.setLineDash(item.strokeDash || Empty);
            context.lineDashOffset = item.strokeDashOffset || 0;
        }
        return true;
    } else return false;
}
function compare(a, b) {
    return a.zindex - b.zindex || a.index - b.index;
}
function zorder(scene) {
    if (!scene.zdirty) return scene.zitems;
    var items = scene.items, output = [], item, i, n;
    for(i = 0, n = items.length; i < n; ++i){
        item = items[i];
        item.index = i;
        if (item.zindex) output.push(item);
    }
    scene.zdirty = false;
    return scene.zitems = output.sort(compare);
}
function visit(scene, visitor) {
    var items = scene.items, i, n;
    if (!items || !items.length) return;
    const zitems = zorder(scene);
    if (zitems && zitems.length) {
        for(i = 0, n = items.length; i < n; ++i)if (!items[i].zindex) visitor(items[i]);
        items = zitems;
    }
    for(i = 0, n = items.length; i < n; ++i)visitor(items[i]);
}
function pickVisit(scene, visitor) {
    var items = scene.items, hit, i;
    if (!items || !items.length) return null;
    const zitems = zorder(scene);
    if (zitems && zitems.length) items = zitems;
    for(i = items.length; --i >= 0;){
        if (hit = visitor(items[i])) return hit;
    }
    if (items === zitems) {
        for(items = scene.items, i = items.length; --i >= 0;)if (!items[i].zindex) {
            if (hit = visitor(items[i])) return hit;
        }
    }
    return null;
}
function drawAll(path) {
    return function(context, scene, bounds) {
        visit(scene, (item)=>{
            if (!bounds || bounds.intersects(item.bounds)) drawPath(path, context, item, item);
        });
    };
}
function drawOne(path) {
    return function(context, scene, bounds) {
        if (scene.items.length && (!bounds || bounds.intersects(scene.bounds))) drawPath(path, context, scene.items[0], scene.items);
    };
}
function drawPath(path, context, item, items) {
    var opacity = item.opacity == null ? 1 : item.opacity;
    if (opacity === 0) return;
    if (path(context, items)) return;
    blend(context, item);
    if (item.fill && fill(context, item, opacity)) context.fill();
    if (item.stroke && stroke(context, item, opacity)) context.stroke();
}
function pick$1(test) {
    test = test || (0, _vegaUtil.truthy);
    return function(context, scene, x, y, gx, gy) {
        x *= context.pixelRatio;
        y *= context.pixelRatio;
        return pickVisit(scene, (item)=>{
            const b = item.bounds;
            // first hit test against bounding box
            if (b && !b.contains(gx, gy) || !b) return;
            // if in bounding box, perform more careful test
            if (test(context, item, x, y, gx, gy)) return item;
        });
    };
}
function hitPath(path, filled) {
    return function(context, o, x, y) {
        var item = Array.isArray(o) ? o[0] : o, fill = filled == null ? item.fill : filled, stroke = item.stroke && context.isPointInStroke, lw, lc;
        if (stroke) {
            lw = item.strokeWidth;
            lc = item.strokeCap;
            context.lineWidth = lw != null ? lw : 1;
            context.lineCap = lc != null ? lc : 'butt';
        }
        return path(context, o) ? false : fill && context.isPointInPath(x, y) || stroke && context.isPointInStroke(x, y);
    };
}
function pickPath(path) {
    return pick$1(hitPath(path));
}
function translate(x, y) {
    return 'translate(' + x + ',' + y + ')';
}
function rotate(a) {
    return 'rotate(' + a + ')';
}
function scale(scaleX, scaleY) {
    return 'scale(' + scaleX + ',' + scaleY + ')';
}
function translateItem(item) {
    return translate(item.x || 0, item.y || 0);
}
function rotateItem(item) {
    return translate(item.x || 0, item.y || 0) + (item.angle ? ' ' + rotate(item.angle) : '');
}
function transformItem(item) {
    return translate(item.x || 0, item.y || 0) + (item.angle ? ' ' + rotate(item.angle) : '') + (item.scaleX || item.scaleY ? ' ' + scale(item.scaleX || 1, item.scaleY || 1) : '');
}
function markItemPath(type, shape, isect) {
    function attr(emit, item) {
        emit('transform', rotateItem(item));
        emit('d', shape(null, item));
    }
    function bound(bounds, item) {
        shape(boundContext(bounds, item.angle), item);
        return boundStroke(bounds, item).translate(item.x || 0, item.y || 0);
    }
    function draw(context, item) {
        var x = item.x || 0, y = item.y || 0, a = item.angle || 0;
        context.translate(x, y);
        if (a) context.rotate(a *= DegToRad);
        context.beginPath();
        shape(context, item);
        if (a) context.rotate(-a);
        context.translate(-x, -y);
    }
    return {
        type: type,
        tag: 'path',
        nested: false,
        attr: attr,
        bound: bound,
        draw: drawAll(draw),
        pick: pickPath(draw),
        isect: isect || intersectPath(draw)
    };
}
var arc = markItemPath('arc', arc$1);
function pickArea(a, p) {
    var v = a[0].orient === 'horizontal' ? p[1] : p[0], z = a[0].orient === 'horizontal' ? 'y' : 'x', i = a.length, min = Infinity, hit, d;
    while(--i >= 0){
        if (a[i].defined === false) continue;
        d = Math.abs(a[i][z] - v);
        if (d < min) {
            min = d;
            hit = a[i];
        }
    }
    return hit;
}
function pickLine(a, p) {
    var t = Math.pow(a[0].strokeWidth || 1, 2), i = a.length, dx, dy, dd;
    while(--i >= 0){
        if (a[i].defined === false) continue;
        dx = a[i].x - p[0];
        dy = a[i].y - p[1];
        dd = dx * dx + dy * dy;
        if (dd < t) return a[i];
    }
    return null;
}
function pickTrail(a, p) {
    var i = a.length, dx, dy, dd;
    while(--i >= 0){
        if (a[i].defined === false) continue;
        dx = a[i].x - p[0];
        dy = a[i].y - p[1];
        dd = dx * dx + dy * dy;
        dx = a[i].size || 1;
        if (dd < dx * dx) return a[i];
    }
    return null;
}
function markMultiItemPath(type, shape, tip) {
    function attr(emit, item) {
        var items = item.mark.items;
        if (items.length) emit('d', shape(null, items));
    }
    function bound(bounds, mark) {
        var items = mark.items;
        if (items.length === 0) return bounds;
        else {
            shape(boundContext(bounds), items);
            return boundStroke(bounds, items[0]);
        }
    }
    function draw(context, items) {
        context.beginPath();
        shape(context, items);
    }
    const hit = hitPath(draw);
    function pick(context, scene, x, y, gx, gy) {
        var items = scene.items, b = scene.bounds;
        if (!items || !items.length || b && !b.contains(gx, gy)) return null;
        x *= context.pixelRatio;
        y *= context.pixelRatio;
        return hit(context, items, x, y) ? items[0] : null;
    }
    return {
        type: type,
        tag: 'path',
        nested: true,
        attr: attr,
        bound: bound,
        draw: drawOne(draw),
        pick: pick,
        isect: intersectPoint,
        tip: tip
    };
}
var area = markMultiItemPath('area', area$1, pickArea);
function clip(context, scene) {
    var clip = scene.clip;
    context.save();
    if ((0, _vegaUtil.isFunction)(clip)) {
        context.beginPath();
        clip(context);
        context.clip();
    } else clipGroup(context, scene.group);
}
function clipGroup(context, group) {
    context.beginPath();
    hasCornerRadius(group) ? rectangle(context, group, 0, 0) : context.rect(0, 0, group.width || 0, group.height || 0);
    context.clip();
}
function offset$1(item) {
    const sw = value(item.strokeWidth, 1);
    return item.strokeOffset != null ? item.strokeOffset : item.stroke && sw > 0.5 && sw < 1.5 ? 0.5 - Math.abs(sw - 1) : 0;
}
function attr$5(emit, item) {
    emit('transform', translateItem(item));
}
function emitRectangle(emit, item) {
    const off = offset$1(item);
    emit('d', rectangle(null, item, off, off));
}
function background(emit, item) {
    emit('class', 'background');
    emit('aria-hidden', true);
    emitRectangle(emit, item);
}
function foreground(emit, item) {
    emit('class', 'foreground');
    emit('aria-hidden', true);
    if (item.strokeForeground) emitRectangle(emit, item);
    else emit('d', '');
}
function content(emit, item, renderer) {
    const url = item.clip ? clip$1(renderer, item, item) : null;
    emit('clip-path', url);
}
function bound$5(bounds, group) {
    if (!group.clip && group.items) {
        const items = group.items, m = items.length;
        for(let j = 0; j < m; ++j)bounds.union(items[j].bounds);
    }
    if ((group.clip || group.width || group.height) && !group.noBound) bounds.add(0, 0).add(group.width || 0, group.height || 0);
    boundStroke(bounds, group);
    return bounds.translate(group.x || 0, group.y || 0);
}
function rectanglePath(context, group, x, y) {
    const off = offset$1(group);
    context.beginPath();
    rectangle(context, group, (x || 0) + off, (y || 0) + off);
}
const hitBackground = hitPath(rectanglePath);
const hitForeground = hitPath(rectanglePath, false);
const hitCorner = hitPath(rectanglePath, true);
function draw$4(context, scene, bounds, markTypes) {
    visit(scene, (group)=>{
        const gx = group.x || 0, gy = group.y || 0, fore = group.strokeForeground, opacity = group.opacity == null ? 1 : group.opacity;
        // draw group background
        if ((group.stroke || group.fill) && opacity) {
            rectanglePath(context, group, gx, gy);
            blend(context, group);
            if (group.fill && fill(context, group, opacity)) context.fill();
            if (group.stroke && !fore && stroke(context, group, opacity)) context.stroke();
        }
        // setup graphics context, set clip and bounds
        context.save();
        context.translate(gx, gy);
        if (group.clip) clipGroup(context, group);
        if (bounds) bounds.translate(-gx, -gy);
        // draw group contents
        visit(group, (item)=>{
            if (item.marktype === 'group' || markTypes == null || markTypes.includes(item.marktype)) this.draw(context, item, bounds, markTypes);
        });
        // restore graphics context
        if (bounds) bounds.translate(gx, gy);
        context.restore();
        // draw group foreground
        if (fore && group.stroke && opacity) {
            rectanglePath(context, group, gx, gy);
            blend(context, group);
            if (stroke(context, group, opacity)) context.stroke();
        }
    });
}
function pick(context, scene, x, y, gx, gy) {
    if (scene.bounds && !scene.bounds.contains(gx, gy) || !scene.items) return null;
    const cx = x * context.pixelRatio, cy = y * context.pixelRatio;
    return pickVisit(scene, (group)=>{
        let hit, dx, dy;
        // first hit test bounding box
        const b = group.bounds;
        if (b && !b.contains(gx, gy)) return;
        // passed bounds check, test rectangular clip
        dx = group.x || 0;
        dy = group.y || 0;
        const dw = dx + (group.width || 0), dh = dy + (group.height || 0), c = group.clip;
        if (c && (gx < dx || gx > dw || gy < dy || gy > dh)) return;
        // adjust coordinate system
        context.save();
        context.translate(dx, dy);
        dx = gx - dx;
        dy = gy - dy;
        // test background for rounded corner clip
        if (c && hasCornerRadius(group) && !hitCorner(context, group, cx, cy)) {
            context.restore();
            return null;
        }
        const fore = group.strokeForeground, ix = scene.interactive !== false;
        // hit test against group foreground
        if (ix && fore && group.stroke && hitForeground(context, group, cx, cy)) {
            context.restore();
            return group;
        }
        // hit test against contained marks
        hit = pickVisit(group, (mark)=>pickMark(mark, dx, dy) ? this.pick(mark, x, y, dx, dy) : null);
        // hit test against group background
        if (!hit && ix && (group.fill || !fore && group.stroke) && hitBackground(context, group, cx, cy)) hit = group;
        // restore state and return
        context.restore();
        return hit || null;
    });
}
function pickMark(mark, x, y) {
    return (mark.interactive !== false || mark.marktype === 'group') && mark.bounds && mark.bounds.contains(x, y);
}
var group = {
    type: 'group',
    tag: 'g',
    nested: false,
    attr: attr$5,
    bound: bound$5,
    draw: draw$4,
    pick: pick,
    isect: intersectRect,
    content: content,
    background: background,
    foreground: foreground
};
var metadata = {
    'xmlns': 'http://www.w3.org/2000/svg',
    'xmlns:xlink': 'http://www.w3.org/1999/xlink',
    'version': '1.1'
};
function getImage(item, renderer) {
    var image = item.image;
    if (!image || item.url && item.url !== image.url) {
        image = {
            complete: false,
            width: 0,
            height: 0
        };
        renderer.loadImage(item.url).then((image)=>{
            item.image = image;
            item.image.url = item.url;
        });
    }
    return image;
}
function imageWidth(item, image) {
    return item.width != null ? item.width : !image || !image.width ? 0 : item.aspect !== false && item.height ? item.height * image.width / image.height : image.width;
}
function imageHeight(item, image) {
    return item.height != null ? item.height : !image || !image.height ? 0 : item.aspect !== false && item.width ? item.width * image.height / image.width : image.height;
}
function imageXOffset(align, w) {
    return align === 'center' ? w / 2 : align === 'right' ? w : 0;
}
function imageYOffset(baseline, h) {
    return baseline === 'middle' ? h / 2 : baseline === 'bottom' ? h : 0;
}
function attr$4(emit, item, renderer) {
    const img = getImage(item, renderer), w = imageWidth(item, img), h = imageHeight(item, img), x = (item.x || 0) - imageXOffset(item.align, w), y = (item.y || 0) - imageYOffset(item.baseline, h), i = !img.src && img.toDataURL ? img.toDataURL() : img.src || '';
    emit('href', i, metadata['xmlns:xlink'], 'xlink:href');
    emit('transform', translate(x, y));
    emit('width', w);
    emit('height', h);
    emit('preserveAspectRatio', item.aspect === false ? 'none' : 'xMidYMid');
}
function bound$4(bounds, item) {
    const img = item.image, w = imageWidth(item, img), h = imageHeight(item, img), x = (item.x || 0) - imageXOffset(item.align, w), y = (item.y || 0) - imageYOffset(item.baseline, h);
    return bounds.set(x, y, x + w, y + h);
}
function draw$3(context, scene, bounds) {
    visit(scene, (item)=>{
        if (bounds && !bounds.intersects(item.bounds)) return; // bounds check
        const img = getImage(item, this);
        let w = imageWidth(item, img);
        let h = imageHeight(item, img);
        if (w === 0 || h === 0) return; // early exit
        let x = (item.x || 0) - imageXOffset(item.align, w), y = (item.y || 0) - imageYOffset(item.baseline, h), opacity, ar0, ar1, t;
        if (item.aspect !== false) {
            ar0 = img.width / img.height;
            ar1 = item.width / item.height;
            if (ar0 === ar0 && ar1 === ar1 && ar0 !== ar1) {
                if (ar1 < ar0) {
                    t = w / ar0;
                    y += (h - t) / 2;
                    h = t;
                } else {
                    t = h * ar0;
                    x += (w - t) / 2;
                    w = t;
                }
            }
        }
        if (img.complete || img.toDataURL) {
            blend(context, item);
            context.globalAlpha = (opacity = item.opacity) != null ? opacity : 1;
            context.imageSmoothingEnabled = item.smooth !== false;
            context.drawImage(img, x, y, w, h);
        }
    });
}
var image = {
    type: 'image',
    tag: 'image',
    nested: false,
    attr: attr$4,
    bound: bound$4,
    draw: draw$3,
    pick: pick$1(),
    isect: (0, _vegaUtil.truthy),
    // bounds check is sufficient
    get: getImage,
    xOffset: imageXOffset,
    yOffset: imageYOffset
};
var line = markMultiItemPath('line', line$1, pickLine);
function attr$3(emit, item) {
    var sx = item.scaleX || 1, sy = item.scaleY || 1;
    if (sx !== 1 || sy !== 1) emit('vector-effect', 'non-scaling-stroke');
    emit('transform', transformItem(item));
    emit('d', item.path);
}
function path$1(context, item) {
    var path = item.path;
    if (path == null) return true;
    var x = item.x || 0, y = item.y || 0, sx = item.scaleX || 1, sy = item.scaleY || 1, a = (item.angle || 0) * DegToRad, cache = item.pathCache;
    if (!cache || cache.path !== path) (item.pathCache = cache = parse(path)).path = path;
    if (a && context.rotate && context.translate) {
        context.translate(x, y);
        context.rotate(a);
        pathRender(context, cache, 0, 0, sx, sy);
        context.rotate(-a);
        context.translate(-x, -y);
    } else pathRender(context, cache, x, y, sx, sy);
}
function bound$3(bounds, item) {
    return path$1(boundContext(bounds, item.angle), item) ? bounds.set(0, 0, 0, 0) : boundStroke(bounds, item, true);
}
var path$2 = {
    type: 'path',
    tag: 'path',
    nested: false,
    attr: attr$3,
    bound: bound$3,
    draw: drawAll(path$1),
    pick: pickPath(path$1),
    isect: intersectPath(path$1)
};
function attr$2(emit, item) {
    emit('d', rectangle(null, item));
}
function bound$2(bounds, item) {
    var x, y;
    return boundStroke(bounds.set(x = item.x || 0, y = item.y || 0, x + item.width || 0, y + item.height || 0), item);
}
function draw$2(context, item) {
    context.beginPath();
    rectangle(context, item);
}
var rect = {
    type: 'rect',
    tag: 'path',
    nested: false,
    attr: attr$2,
    bound: bound$2,
    draw: drawAll(draw$2),
    pick: pickPath(draw$2),
    isect: intersectRect
};
function attr$1(emit, item) {
    emit('transform', translateItem(item));
    emit('x2', item.x2 != null ? item.x2 - (item.x || 0) : 0);
    emit('y2', item.y2 != null ? item.y2 - (item.y || 0) : 0);
}
function bound$1(bounds, item) {
    var x1, y1;
    return boundStroke(bounds.set(x1 = item.x || 0, y1 = item.y || 0, item.x2 != null ? item.x2 : x1, item.y2 != null ? item.y2 : y1), item);
}
function path(context, item, opacity) {
    var x1, y1, x2, y2;
    if (item.stroke && stroke(context, item, opacity)) {
        x1 = item.x || 0;
        y1 = item.y || 0;
        x2 = item.x2 != null ? item.x2 : x1;
        y2 = item.y2 != null ? item.y2 : y1;
        context.beginPath();
        context.moveTo(x1, y1);
        context.lineTo(x2, y2);
        return true;
    }
    return false;
}
function draw$1(context, scene, bounds) {
    visit(scene, (item)=>{
        if (bounds && !bounds.intersects(item.bounds)) return; // bounds check
        var opacity = item.opacity == null ? 1 : item.opacity;
        if (opacity && path(context, item, opacity)) {
            blend(context, item);
            context.stroke();
        }
    });
}
function hit$1(context, item, x, y) {
    if (!context.isPointInStroke) return false;
    return path(context, item, 1) && context.isPointInStroke(x, y);
}
var rule = {
    type: 'rule',
    tag: 'line',
    nested: false,
    attr: attr$1,
    bound: bound$1,
    draw: draw$1,
    pick: pick$1(hit$1),
    isect: intersectRule
};
var shape = markItemPath('shape', shape$1);
var symbol = markItemPath('symbol', symbol$1, intersectPoint);
// memoize text width measurement
const widthCache = (0, _vegaUtil.lruCache)();
var textMetrics = {
    height: fontSize,
    measureWidth: measureWidth,
    estimateWidth: estimateWidth,
    width: estimateWidth,
    canvas: useCanvas
};
useCanvas(true);
function useCanvas(use) {
    textMetrics.width = use && context ? measureWidth : estimateWidth;
}
// make simple estimate if no canvas is available
function estimateWidth(item, text) {
    return _estimateWidth(textValue(item, text), fontSize(item));
}
function _estimateWidth(text, currentFontHeight) {
    return ~~(0.8 * text.length * currentFontHeight);
}
// measure text width if canvas is available
function measureWidth(item, text) {
    return fontSize(item) <= 0 || !(text = textValue(item, text)) ? 0 : _measureWidth(text, font(item));
}
function _measureWidth(text, currentFont) {
    const key = `(${currentFont}) ${text}`;
    let width = widthCache.get(key);
    if (width === undefined) {
        context.font = currentFont;
        width = context.measureText(text).width;
        widthCache.set(key, width);
    }
    return width;
}
function fontSize(item) {
    return item.fontSize != null ? +item.fontSize || 0 : 11;
}
function lineHeight(item) {
    return item.lineHeight != null ? item.lineHeight : fontSize(item) + 2;
}
function lineArray(_) {
    return (0, _vegaUtil.isArray)(_) ? _.length > 1 ? _ : _[0] : _;
}
function textLines(item) {
    return lineArray(item.lineBreak && item.text && !(0, _vegaUtil.isArray)(item.text) ? item.text.split(item.lineBreak) : item.text);
}
function multiLineOffset(item) {
    const tl = textLines(item);
    return ((0, _vegaUtil.isArray)(tl) ? tl.length - 1 : 0) * lineHeight(item);
}
function textValue(item, line) {
    const text = line == null ? '' : (line + '').trim();
    return item.limit > 0 && text.length ? truncate(item, text) : text;
}
function widthGetter(item) {
    if (textMetrics.width === measureWidth) {
        // we are using canvas
        const currentFont = font(item);
        return (text)=>_measureWidth(text, currentFont);
    } else if (textMetrics.width === estimateWidth) {
        // we are relying on estimates
        const currentFontHeight = fontSize(item);
        return (text)=>_estimateWidth(text, currentFontHeight);
    } else // User defined textMetrics.width function in use (e.g. vl-convert)
    return (text)=>textMetrics.width(item, text);
}
function truncate(item, text) {
    var limit = +item.limit, width = widthGetter(item);
    if (width(text) < limit) return text;
    var ellipsis = item.ellipsis || '\u2026', rtl = item.dir === 'rtl', lo = 0, hi = text.length, mid;
    limit -= width(ellipsis);
    if (rtl) {
        while(lo < hi){
            mid = lo + hi >>> 1;
            if (width(text.slice(mid)) > limit) lo = mid + 1;
            else hi = mid;
        }
        return ellipsis + text.slice(lo);
    } else {
        while(lo < hi){
            mid = 1 + (lo + hi >>> 1);
            if (width(text.slice(0, mid)) < limit) lo = mid;
            else hi = mid - 1;
        }
        return text.slice(0, lo) + ellipsis;
    }
}
function fontFamily(item, quote) {
    var font = item.font;
    return (quote && font ? String(font).replace(/"/g, '\'') : font) || 'sans-serif';
}
function font(item, quote) {
    return '' + (item.fontStyle ? item.fontStyle + ' ' : '') + (item.fontVariant ? item.fontVariant + ' ' : '') + (item.fontWeight ? item.fontWeight + ' ' : '') + fontSize(item) + 'px ' + fontFamily(item, quote);
}
function offset(item) {
    // perform our own font baseline calculation
    // why? not all browsers support SVG 1.1 'alignment-baseline' :(
    // this also ensures consistent layout across renderers
    var baseline = item.baseline, h = fontSize(item);
    return Math.round(baseline === 'top' ? 0.79 * h : baseline === 'middle' ? 0.30 * h : baseline === 'bottom' ? -0.21 * h : baseline === 'line-top' ? 0.29 * h + 0.5 * lineHeight(item) : baseline === 'line-bottom' ? 0.29 * h - 0.5 * lineHeight(item) : 0);
}
const textAlign = {
    'left': 'start',
    'center': 'middle',
    'right': 'end'
};
const tempBounds = new Bounds();
function anchorPoint(item) {
    var x = item.x || 0, y = item.y || 0, r = item.radius || 0, t;
    if (r) {
        t = (item.theta || 0) - HalfPi;
        x += r * Math.cos(t);
        y += r * Math.sin(t);
    }
    tempBounds.x1 = x;
    tempBounds.y1 = y;
    return tempBounds;
}
function attr(emit, item) {
    var dx = item.dx || 0, dy = (item.dy || 0) + offset(item), p = anchorPoint(item), x = p.x1, y = p.y1, a = item.angle || 0, t;
    emit('text-anchor', textAlign[item.align] || 'start');
    if (a) {
        t = translate(x, y) + ' ' + rotate(a);
        if (dx || dy) t += ' ' + translate(dx, dy);
    } else t = translate(x + dx, y + dy);
    emit('transform', t);
}
function bound(bounds, item, mode) {
    var h = textMetrics.height(item), a = item.align, p = anchorPoint(item), x = p.x1, y = p.y1, dx = item.dx || 0, dy = (item.dy || 0) + offset(item) - Math.round(0.8 * h), // use 4/5 offset
    tl = textLines(item), w;
    // get dimensions
    if ((0, _vegaUtil.isArray)(tl)) {
        // multi-line text
        h += lineHeight(item) * (tl.length - 1);
        w = tl.reduce((w, t)=>Math.max(w, textMetrics.width(item, t)), 0);
    } else // single-line text
    w = textMetrics.width(item, tl);
    // horizontal alignment
    if (a === 'center') dx -= w / 2;
    else if (a === 'right') dx -= w;
    bounds.set(dx += x, dy += y, dx + w, dy + h);
    if (item.angle && !mode) bounds.rotate(item.angle * DegToRad, x, y);
    else if (mode === 2) return bounds.rotatedPoints(item.angle * DegToRad, x, y);
    return bounds;
}
function draw(context, scene, bounds) {
    visit(scene, (item)=>{
        var opacity = item.opacity == null ? 1 : item.opacity, p, x, y, i, lh, tl, str;
        if (bounds && !bounds.intersects(item.bounds) || // bounds check
        opacity === 0 || item.fontSize <= 0 || item.text == null || item.text.length === 0) return;
        context.font = font(item);
        context.textAlign = item.align || 'left';
        p = anchorPoint(item);
        x = p.x1, y = p.y1;
        if (item.angle) {
            context.save();
            context.translate(x, y);
            context.rotate(item.angle * DegToRad);
            x = y = 0; // reset x, y
        }
        x += item.dx || 0;
        y += (item.dy || 0) + offset(item);
        tl = textLines(item);
        blend(context, item);
        if ((0, _vegaUtil.isArray)(tl)) {
            lh = lineHeight(item);
            for(i = 0; i < tl.length; ++i){
                str = textValue(item, tl[i]);
                if (item.fill && fill(context, item, opacity)) context.fillText(str, x, y);
                if (item.stroke && stroke(context, item, opacity)) context.strokeText(str, x, y);
                y += lh;
            }
        } else {
            str = textValue(item, tl);
            if (item.fill && fill(context, item, opacity)) context.fillText(str, x, y);
            if (item.stroke && stroke(context, item, opacity)) context.strokeText(str, x, y);
        }
        if (item.angle) context.restore();
    });
}
function hit(context, item, x, y, gx, gy) {
    if (item.fontSize <= 0) return false;
    if (!item.angle) return true; // bounds sufficient if no rotation
    // project point into space of unrotated bounds
    var p = anchorPoint(item), ax = p.x1, ay = p.y1, b = bound(tempBounds, item, 1), a = -item.angle * DegToRad, cos = Math.cos(a), sin = Math.sin(a), px = cos * gx - sin * gy + (ax - cos * ax + sin * ay), py = sin * gx + cos * gy + (ay - sin * ax - cos * ay);
    return b.contains(px, py);
}
function intersectText(item, box) {
    const p = bound(tempBounds, item, 2);
    return intersectBoxLine(box, p[0], p[1], p[2], p[3]) || intersectBoxLine(box, p[0], p[1], p[4], p[5]) || intersectBoxLine(box, p[4], p[5], p[6], p[7]) || intersectBoxLine(box, p[2], p[3], p[6], p[7]);
}
var text = {
    type: 'text',
    tag: 'text',
    nested: false,
    attr: attr,
    bound: bound,
    draw: draw,
    pick: pick$1(hit),
    isect: intersectText
};
var trail = markMultiItemPath('trail', trail$1, pickTrail);
var Marks = {
    arc: arc,
    area: area,
    group: group,
    image: image,
    line: line,
    path: path$2,
    rect: rect,
    rule: rule,
    shape: shape,
    symbol: symbol,
    text: text,
    trail: trail
};
function boundItem(item, func, opt) {
    var type = Marks[item.mark.marktype], bound = func || type.bound;
    if (type.nested) item = item.mark;
    return bound(item.bounds || (item.bounds = new Bounds()), item, opt);
}
var DUMMY = {
    mark: null
};
function boundMark(mark, bounds, opt) {
    var type = Marks[mark.marktype], bound = type.bound, items = mark.items, hasItems = items && items.length, i, n, item, b;
    if (type.nested) {
        if (hasItems) item = items[0];
        else {
            // no items, fake it
            DUMMY.mark = mark;
            item = DUMMY;
        }
        b = boundItem(item, bound, opt);
        bounds = bounds && bounds.union(b) || b;
        return bounds;
    }
    bounds = bounds || mark.bounds && mark.bounds.clear() || new Bounds();
    if (hasItems) for(i = 0, n = items.length; i < n; ++i)bounds.union(boundItem(items[i], bound, opt));
    return mark.bounds = bounds;
}
const keys = [
    'marktype',
    'name',
    'role',
    'interactive',
    'clip',
    'items',
    'zindex',
    'x',
    'y',
    'width',
    'height',
    'align',
    'baseline',
    // layout
    'fill',
    'fillOpacity',
    'opacity',
    'blend',
    // fill
    'stroke',
    'strokeOpacity',
    'strokeWidth',
    'strokeCap',
    // stroke
    'strokeDash',
    'strokeDashOffset',
    // stroke dash
    'strokeForeground',
    'strokeOffset',
    // group
    'startAngle',
    'endAngle',
    'innerRadius',
    'outerRadius',
    // arc
    'cornerRadius',
    'padAngle',
    // arc, rect
    'cornerRadiusTopLeft',
    'cornerRadiusTopRight',
    // rect, group
    'cornerRadiusBottomLeft',
    'cornerRadiusBottomRight',
    'interpolate',
    'tension',
    'orient',
    'defined',
    // area, line
    'url',
    'aspect',
    'smooth',
    // image
    'path',
    'scaleX',
    'scaleY',
    // path
    'x2',
    'y2',
    // rule
    'size',
    'shape',
    // symbol
    'text',
    'angle',
    'theta',
    'radius',
    'dir',
    'dx',
    'dy',
    // text
    'ellipsis',
    'limit',
    'lineBreak',
    'lineHeight',
    'font',
    'fontSize',
    'fontWeight',
    'fontStyle',
    'fontVariant',
    // font
    'description',
    'aria',
    'ariaRole',
    'ariaRoleDescription' // aria
];
function sceneToJSON(scene, indent) {
    return JSON.stringify(scene, keys, indent);
}
function sceneFromJSON(json) {
    const scene = typeof json === 'string' ? JSON.parse(json) : json;
    return initialize(scene);
}
function initialize(scene) {
    var type = scene.marktype, items = scene.items, parent, i, n;
    if (items) for(i = 0, n = items.length; i < n; ++i){
        parent = type ? 'mark' : 'group';
        items[i][parent] = scene;
        if (items[i].zindex) items[i][parent].zdirty = true;
        if ('group' === (type || parent)) initialize(items[i]);
    }
    if (type) boundMark(scene);
    return scene;
}
class Scenegraph {
    constructor(scene){
        if (arguments.length) this.root = sceneFromJSON(scene);
        else {
            this.root = createMark({
                marktype: 'group',
                name: 'root',
                role: 'frame'
            });
            this.root.items = [
                new GroupItem(this.root)
            ];
        }
    }
    toJSON(indent) {
        return sceneToJSON(this.root, indent || 0);
    }
    mark(markdef, group, index) {
        group = group || this.root.items[0];
        const mark = createMark(markdef, group);
        group.items[index] = mark;
        if (mark.zindex) mark.group.zdirty = true;
        return mark;
    }
}
function createMark(def, group) {
    const mark = {
        bounds: new Bounds(),
        clip: !!def.clip,
        group: group,
        interactive: def.interactive === false ? false : true,
        items: [],
        marktype: def.marktype,
        name: def.name || undefined,
        role: def.role || undefined,
        zindex: def.zindex || 0
    };
    // add accessibility properties if defined
    if (def.aria != null) mark.aria = def.aria;
    if (def.description) mark.description = def.description;
    return mark;
}
// create a new DOM element
function domCreate(doc, tag, ns) {
    if (!doc && typeof document !== 'undefined' && document.createElement) doc = document;
    return doc ? ns ? doc.createElementNS(ns, tag) : doc.createElement(tag) : null;
}
// find first child element with matching tag
function domFind(el, tag) {
    tag = tag.toLowerCase();
    var nodes = el.childNodes, i = 0, n = nodes.length;
    for(; i < n; ++i)if (nodes[i].tagName.toLowerCase() === tag) return nodes[i];
}
// retrieve child element at given index
// create & insert if doesn't exist or if tags do not match
function domChild(el, index, tag, ns) {
    var a = el.childNodes[index], b;
    if (!a || a.tagName.toLowerCase() !== tag.toLowerCase()) {
        b = a || null;
        a = domCreate(el.ownerDocument, tag, ns);
        el.insertBefore(a, b);
    }
    return a;
}
// remove all child elements at or above the given index
function domClear(el, index) {
    var nodes = el.childNodes, curr = nodes.length;
    while(curr > index)el.removeChild(nodes[--curr]);
    return el;
}
// generate css class name for mark
function cssClass(mark) {
    return 'mark-' + mark.marktype + (mark.role ? ' role-' + mark.role : '') + (mark.name ? ' ' + mark.name : '');
}
function point(event, el) {
    const rect = el.getBoundingClientRect();
    return [
        event.clientX - rect.left - (el.clientLeft || 0),
        event.clientY - rect.top - (el.clientTop || 0)
    ];
}
function resolveItem(item, event, el, origin) {
    var mark = item && item.mark, mdef, p;
    if (mark && (mdef = Marks[mark.marktype]).tip) {
        p = point(event, el);
        p[0] -= origin[0];
        p[1] -= origin[1];
        while(item = item.mark.group){
            p[0] -= item.x || 0;
            p[1] -= item.y || 0;
        }
        item = mdef.tip(mark.items, p);
    }
    return item;
}
class Handler {
    /**
   * Create a new Handler instance.
   * @param {object} [customLoader] - Optional loader instance for
   *   href URL sanitization. If not specified, a standard loader
   *   instance will be generated.
   * @param {function} [customTooltip] - Optional tooltip handler
   *   function for custom tooltip display.
   * @constructor
   */ constructor(customLoader, customTooltip){
        this._active = null;
        this._handlers = {};
        this._loader = customLoader || (0, _vegaLoader.loader)();
        this._tooltip = customTooltip || defaultTooltip;
    }
    /**
   * Initialize a new Handler instance.
   * @param {DOMElement} el - The containing DOM element for the display.
   * @param {Array<number>} origin - The origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {object} [obj] - Optional context object that should serve as
   *   the "this" context for event callbacks.
   * @return {Handler} - This handler instance.
   */ initialize(el, origin, obj) {
        this._el = el;
        this._obj = obj || null;
        return this.origin(origin);
    }
    /**
   * Returns the parent container element for a visualization.
   * @return {DOMElement} - The containing DOM element.
   */ element() {
        return this._el;
    }
    /**
   * Returns the scene element (e.g., canvas or SVG) of the visualization
   * Subclasses must override if the first child is not the scene element.
   * @return {DOMElement} - The scene (e.g., canvas or SVG) element.
   */ canvas() {
        return this._el && this._el.firstChild;
    }
    /**
   * Get / set the origin coordinates of the visualization.
   */ origin(origin) {
        if (arguments.length) {
            this._origin = origin || [
                0,
                0
            ];
            return this;
        } else return this._origin.slice();
    }
    /**
   * Get / set the scenegraph root.
   */ scene(scene) {
        if (!arguments.length) return this._scene;
        this._scene = scene;
        return this;
    }
    /**
   * Add an event handler. Subclasses should override this method.
   */ on() {}
    /**
   * Remove an event handler. Subclasses should override this method.
   */ off() {}
    /**
   * Utility method for finding the array index of an event handler.
   * @param {Array} h - An array of registered event handlers.
   * @param {string} type - The event type.
   * @param {function} handler - The event handler instance to find.
   * @return {number} - The handler's array index or -1 if not registered.
   */ _handlerIndex(h, type, handler) {
        for(let i = h ? h.length : 0; --i >= 0;){
            if (h[i].type === type && (!handler || h[i].handler === handler)) return i;
        }
        return -1;
    }
    /**
   * Returns an array with registered event handlers.
   * @param {string} [type] - The event type to query. Any annotations
   *   are ignored; for example, for the argument "click.foo", ".foo" will
   *   be ignored and the method returns all "click" handlers. If type is
   *   null or unspecified, this method returns handlers for all types.
   * @return {Array} - A new array containing all registered event handlers.
   */ handlers(type) {
        const h = this._handlers, a = [];
        if (type) a.push(...h[this.eventName(type)]);
        else for(const k in h)a.push(...h[k]);
        return a;
    }
    /**
   * Parses an event name string to return the specific event type.
   * For example, given "click.foo" returns "click"
   * @param {string} name - The input event type string.
   * @return {string} - A string with the event type only.
   */ eventName(name) {
        const i = name.indexOf('.');
        return i < 0 ? name : name.slice(0, i);
    }
    /**
   * Handle hyperlink navigation in response to an item.href value.
   * @param {Event} event - The event triggering hyperlink navigation.
   * @param {Item} item - The scenegraph item.
   * @param {string} href - The URL to navigate to.
   */ handleHref(event, item, href) {
        this._loader.sanitize(href, {
            context: 'href'
        }).then((opt)=>{
            const e = new MouseEvent(event.type, event), a = domCreate(null, 'a');
            for(const name in opt)a.setAttribute(name, opt[name]);
            a.dispatchEvent(e);
        }).catch(()=>{});
    }
    /**
   * Handle tooltip display in response to an item.tooltip value.
   * @param {Event} event - The event triggering tooltip display.
   * @param {Item} item - The scenegraph item.
   * @param {boolean} show - A boolean flag indicating whether
   *   to show or hide a tooltip for the given item.
   */ handleTooltip(event, item, show) {
        if (item && item.tooltip != null) {
            item = resolveItem(item, event, this.canvas(), this._origin);
            const value = show && item && item.tooltip || null;
            this._tooltip.call(this._obj, this, event, item, value);
        }
    }
    /**
   * Returns the size of a scenegraph item and its position relative
   * to the viewport.
   * @param {Item} item - The scenegraph item.
   * @return {object} - A bounding box object (compatible with the
   *   DOMRect type) consisting of x, y, width, heigh, top, left,
   *   right, and bottom properties.
   */ getItemBoundingClientRect(item) {
        const el = this.canvas();
        if (!el) return;
        const rect = el.getBoundingClientRect(), origin = this._origin, bounds = item.bounds, width = bounds.width(), height = bounds.height();
        let x = bounds.x1 + origin[0] + rect.left, y = bounds.y1 + origin[1] + rect.top;
        // translate coordinate for each parent group
        while(item.mark && (item = item.mark.group)){
            x += item.x || 0;
            y += item.y || 0;
        }
        // return DOMRect-compatible bounding box
        return {
            x,
            y,
            width,
            height,
            left: x,
            top: y,
            right: x + width,
            bottom: y + height
        };
    }
}
// The default tooltip display handler.
// Sets the HTML title attribute on the visualization container.
function defaultTooltip(handler, event, item, value) {
    handler.element().setAttribute('title', value || '');
}
class Renderer {
    /**
   * Create a new Renderer instance.
   * @param {object} [loader] - Optional loader instance for
   *   image and href URL sanitization. If not specified, a
   *   standard loader instance will be generated.
   * @constructor
   */ constructor(loader){
        this._el = null;
        this._bgcolor = null;
        this._loader = new ResourceLoader(loader);
    }
    /**
   * Initialize a new Renderer instance.
   * @param {DOMElement} el - The containing DOM element for the display.
   * @param {number} width - The coordinate width of the display, in pixels.
   * @param {number} height - The coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {Renderer} - This renderer instance.
   */ initialize(el, width, height, origin, scaleFactor) {
        this._el = el;
        return this.resize(width, height, origin, scaleFactor);
    }
    /**
   * Returns the parent container element for a visualization.
   * @return {DOMElement} - The containing DOM element.
   */ element() {
        return this._el;
    }
    /**
   * Returns the scene element (e.g., canvas or SVG) of the visualization
   * Subclasses must override if the first child is not the scene element.
   * @return {DOMElement} - The scene (e.g., canvas or SVG) element.
   */ canvas() {
        return this._el && this._el.firstChild;
    }
    /**
   * Get / set the background color.
   */ background(bgcolor) {
        if (arguments.length === 0) return this._bgcolor;
        this._bgcolor = bgcolor;
        return this;
    }
    /**
   * Resize the display.
   * @param {number} width - The new coordinate width of the display, in pixels.
   * @param {number} height - The new coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The new origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {Renderer} - This renderer instance;
   */ resize(width, height, origin, scaleFactor) {
        this._width = width;
        this._height = height;
        this._origin = origin || [
            0,
            0
        ];
        this._scale = scaleFactor || 1;
        return this;
    }
    /**
   * Report a dirty item whose bounds should be redrawn.
   * This base class method does nothing. Subclasses that perform
   * incremental should implement this method.
   * @param {Item} item - The dirty item whose bounds should be redrawn.
   */ dirty() {}
    /**
   * Render an input scenegraph, potentially with a set of dirty items.
   * This method will perform an immediate rendering with available resources.
   * The renderer may also need to perform image loading to perform a complete
   * render. This process can lead to asynchronous re-rendering of the scene
   * after this method returns. To receive notification when rendering is
   * complete, use the renderAsync method instead.
   * @param {object} scene - The root mark of a scenegraph to render.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   * @return {Renderer} - This renderer instance.
   */ render(scene, markTypes) {
        const r = this;
        // bind arguments into a render call, and cache it
        // this function may be subsequently called for async redraw
        r._call = function() {
            r._render(scene, markTypes);
        };
        // invoke the renderer
        r._call();
        // clear the cached call for garbage collection
        // async redraws will stash their own copy
        r._call = null;
        return r;
    }
    /**
   * Internal rendering method. Renderer subclasses should override this
   * method to actually perform rendering.
   * @param {object} scene - The root mark of a scenegraph to render.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   */ _render() {
    // subclasses to override
    }
    /**
   * Asynchronous rendering method. Similar to render, but returns a Promise
   * that resolves when all rendering is completed. Sometimes a renderer must
   * perform image loading to get a complete rendering. The returned
   * Promise will not resolve until this process completes.
   * @param {object} scene - The root mark of a scenegraph to render.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   * @return {Promise} - A Promise that resolves when rendering is complete.
   */ renderAsync(scene, markTypes) {
        const r = this.render(scene, markTypes);
        return this._ready ? this._ready.then(()=>r) : Promise.resolve(r);
    }
    /**
   * Internal method for asynchronous resource loading.
   * Proxies method calls to the ImageLoader, and tracks loading
   * progress to invoke a re-render once complete.
   * @param {string} method - The method name to invoke on the ImageLoader.
   * @param {string} uri - The URI for the requested resource.
   * @return {Promise} - A Promise that resolves to the requested resource.
   */ _load(method, uri) {
        var r = this, p = r._loader[method](uri);
        if (!r._ready) {
            // re-render the scene when loading completes
            const call = r._call;
            r._ready = r._loader.ready().then((redraw)=>{
                if (redraw) call();
                r._ready = null;
            });
        }
        return p;
    }
    /**
   * Sanitize a URL to include as a hyperlink in the rendered scene.
   * This method proxies a call to ImageLoader.sanitizeURL, but also tracks
   * image loading progress and invokes a re-render once complete.
   * @param {string} uri - The URI string to sanitize.
   * @return {Promise} - A Promise that resolves to the sanitized URL.
   */ sanitizeURL(uri) {
        return this._load('sanitizeURL', uri);
    }
    /**
   * Requests an image to include in the rendered scene.
   * This method proxies a call to ImageLoader.loadImage, but also tracks
   * image loading progress and invokes a re-render once complete.
   * @param {string} uri - The URI string of the image.
   * @return {Promise} - A Promise that resolves to the loaded Image.
   */ loadImage(uri) {
        return this._load('loadImage', uri);
    }
}
const KeyDownEvent = 'keydown';
const KeyPressEvent = 'keypress';
const KeyUpEvent = 'keyup';
const DragEnterEvent = 'dragenter';
const DragLeaveEvent = 'dragleave';
const DragOverEvent = 'dragover';
const PointerDownEvent = 'pointerdown';
const PointerUpEvent = 'pointerup';
const PointerMoveEvent = 'pointermove';
const PointerOutEvent = 'pointerout';
const PointerOverEvent = 'pointerover';
const MouseDownEvent = 'mousedown';
const MouseUpEvent = 'mouseup';
const MouseMoveEvent = 'mousemove';
const MouseOutEvent = 'mouseout';
const MouseOverEvent = 'mouseover';
const ClickEvent = 'click';
const DoubleClickEvent = 'dblclick';
const WheelEvent = 'wheel';
const MouseWheelEvent = 'mousewheel';
const TouchStartEvent = 'touchstart';
const TouchMoveEvent = 'touchmove';
const TouchEndEvent = 'touchend';
const Events = [
    KeyDownEvent,
    KeyPressEvent,
    KeyUpEvent,
    DragEnterEvent,
    DragLeaveEvent,
    DragOverEvent,
    PointerDownEvent,
    PointerUpEvent,
    PointerMoveEvent,
    PointerOutEvent,
    PointerOverEvent,
    MouseDownEvent,
    MouseUpEvent,
    MouseMoveEvent,
    MouseOutEvent,
    MouseOverEvent,
    ClickEvent,
    DoubleClickEvent,
    WheelEvent,
    MouseWheelEvent,
    TouchStartEvent,
    TouchMoveEvent,
    TouchEndEvent
];
const TooltipShowEvent = PointerMoveEvent;
const TooltipHideEvent = MouseOutEvent;
const HrefEvent = ClickEvent;
class CanvasHandler extends Handler {
    constructor(loader, tooltip){
        super(loader, tooltip);
        this._down = null;
        this._touch = null;
        this._first = true;
        this._events = {};
        // supported events
        this.events = Events;
        this.pointermove = move([
            PointerMoveEvent,
            MouseMoveEvent
        ], [
            PointerOverEvent,
            MouseOverEvent
        ], [
            PointerOutEvent,
            MouseOutEvent
        ]);
        this.dragover = move([
            DragOverEvent
        ], [
            DragEnterEvent
        ], [
            DragLeaveEvent
        ]), this.pointerout = inactive([
            PointerOutEvent,
            MouseOutEvent
        ]);
        this.dragleave = inactive([
            DragLeaveEvent
        ]);
    }
    initialize(el, origin, obj) {
        this._canvas = el && domFind(el, 'canvas');
        // add minimal events required for proper state management
        [
            ClickEvent,
            MouseDownEvent,
            PointerDownEvent,
            PointerMoveEvent,
            PointerOutEvent,
            DragLeaveEvent
        ].forEach((type)=>eventListenerCheck(this, type));
        return super.initialize(el, origin, obj);
    }
    // return the backing canvas instance
    canvas() {
        return this._canvas;
    }
    // retrieve the current canvas context
    context() {
        return this._canvas.getContext('2d');
    }
    // to keep old versions of firefox happy
    DOMMouseScroll(evt) {
        this.fire(MouseWheelEvent, evt);
    }
    pointerdown(evt) {
        this._down = this._active;
        this.fire(PointerDownEvent, evt);
    }
    mousedown(evt) {
        this._down = this._active;
        this.fire(MouseDownEvent, evt);
    }
    click(evt) {
        if (this._down === this._active) {
            this.fire(ClickEvent, evt);
            this._down = null;
        }
    }
    touchstart(evt) {
        this._touch = this.pickEvent(evt.changedTouches[0]);
        if (this._first) {
            this._active = this._touch;
            this._first = false;
        }
        this.fire(TouchStartEvent, evt, true);
    }
    touchmove(evt) {
        this.fire(TouchMoveEvent, evt, true);
    }
    touchend(evt) {
        this.fire(TouchEndEvent, evt, true);
        this._touch = null;
    }
    // fire an event
    fire(type, evt, touch) {
        const a = touch ? this._touch : this._active, h = this._handlers[type];
        // set event type relative to scenegraph items
        evt.vegaType = type;
        // handle hyperlinks and tooltips first
        if (type === HrefEvent && a && a.href) this.handleHref(evt, a, a.href);
        else if (type === TooltipShowEvent || type === TooltipHideEvent) this.handleTooltip(evt, a, type !== TooltipHideEvent);
        // invoke all registered handlers
        if (h) for(let i = 0, len = h.length; i < len; ++i)h[i].handler.call(this._obj, evt, a);
    }
    // add an event handler
    on(type, handler) {
        const name = this.eventName(type), h = this._handlers, i = this._handlerIndex(h[name], type, handler);
        if (i < 0) {
            eventListenerCheck(this, type);
            (h[name] || (h[name] = [])).push({
                type: type,
                handler: handler
            });
        }
        return this;
    }
    // remove an event handler
    off(type, handler) {
        const name = this.eventName(type), h = this._handlers[name], i = this._handlerIndex(h, type, handler);
        if (i >= 0) h.splice(i, 1);
        return this;
    }
    pickEvent(evt) {
        const p = point(evt, this._canvas), o = this._origin;
        return this.pick(this._scene, p[0], p[1], p[0] - o[0], p[1] - o[1]);
    }
    // find the scenegraph item at the current pointer position
    // x, y -- the absolute x, y pointer coordinates on the canvas element
    // gx, gy -- the relative coordinates within the current group
    pick(scene, x, y, gx, gy) {
        const g = this.context(), mark = Marks[scene.marktype];
        return mark.pick.call(this, g, scene, x, y, gx, gy);
    }
}
const eventBundle = (type)=>type === TouchStartEvent || type === TouchMoveEvent || type === TouchEndEvent ? [
        TouchStartEvent,
        TouchMoveEvent,
        TouchEndEvent
    ] : [
        type
    ];
// lazily add listeners to the canvas as needed
function eventListenerCheck(handler, type) {
    eventBundle(type).forEach((_)=>addEventListener(handler, _));
}
function addEventListener(handler, type) {
    const canvas = handler.canvas();
    if (canvas && !handler._events[type]) {
        handler._events[type] = 1;
        canvas.addEventListener(type, handler[type] ? (evt)=>handler[type](evt) : (evt)=>handler.fire(type, evt));
    }
}
function fireAll(handler, types, event) {
    types.forEach((type)=>handler.fire(type, event));
}
function move(moveEvents, overEvents, outEvents) {
    return function(evt) {
        const a = this._active, p = this.pickEvent(evt);
        if (p === a) // active item and picked item are the same
        fireAll(this, moveEvents, evt); // fire move
        else {
            // active item and picked item are different
            if (!a || !a.exit) // fire out for prior active item
            // suppress if active item was removed from scene
            fireAll(this, outEvents, evt);
            this._active = p; // set new active item
            fireAll(this, overEvents, evt); // fire over for new active item
            fireAll(this, moveEvents, evt); // fire move for new active item
        }
    };
}
function inactive(types) {
    return function(evt) {
        fireAll(this, types, evt);
        this._active = null;
    };
}
function devicePixelRatio() {
    return typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1;
}
function resize(canvas, width, height, origin, scaleFactor, opt) {
    const inDOM = typeof HTMLElement !== 'undefined' && canvas instanceof HTMLElement && canvas.parentNode != null, context = canvas.getContext('2d'), ratio = inDOM ? devicePixelRatio() : scaleFactor;
    canvas.width = width * ratio;
    canvas.height = height * ratio;
    for(const key in opt)context[key] = opt[key];
    if (inDOM && ratio !== 1) {
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
    }
    context.pixelRatio = ratio;
    context.setTransform(ratio, 0, 0, ratio, ratio * origin[0], ratio * origin[1]);
    return canvas;
}
class CanvasRenderer extends Renderer {
    constructor(loader){
        super(loader);
        this._options = {};
        this._redraw = false;
        this._dirty = new Bounds();
        this._tempb = new Bounds();
    }
    initialize(el, width, height, origin, scaleFactor, options) {
        this._options = options || {};
        this._canvas = this._options.externalContext ? null : (0, _vegaCanvas.canvas)(1, 1, this._options.type); // instantiate a small canvas
        if (el && this._canvas) {
            domClear(el, 0).appendChild(this._canvas);
            this._canvas.setAttribute('class', 'marks');
        }
        // this method will invoke resize to size the canvas appropriately
        return super.initialize(el, width, height, origin, scaleFactor);
    }
    resize(width, height, origin, scaleFactor) {
        super.resize(width, height, origin, scaleFactor);
        if (this._canvas) // configure canvas size and transform
        resize(this._canvas, this._width, this._height, this._origin, this._scale, this._options.context);
        else {
            // external context needs to be scaled and positioned to origin
            const ctx = this._options.externalContext;
            if (!ctx) (0, _vegaUtil.error)('CanvasRenderer is missing a valid canvas or context');
            ctx.scale(this._scale, this._scale);
            ctx.translate(this._origin[0], this._origin[1]);
        }
        this._redraw = true;
        return this;
    }
    canvas() {
        return this._canvas;
    }
    context() {
        return this._options.externalContext || (this._canvas ? this._canvas.getContext('2d') : null);
    }
    dirty(item) {
        const b = this._tempb.clear().union(item.bounds);
        let g = item.mark.group;
        while(g){
            b.translate(g.x || 0, g.y || 0);
            g = g.mark.group;
        }
        this._dirty.union(b);
    }
    _render(scene, markTypes) {
        const g = this.context(), o = this._origin, w = this._width, h = this._height, db = this._dirty, vb = viewBounds(o, w, h);
        // setup
        g.save();
        const b = this._redraw || db.empty() ? (this._redraw = false, vb.expand(1)) : clipToBounds(g, vb.intersect(db), o);
        this.clear(-o[0], -o[1], w, h);
        // render
        this.draw(g, scene, b, markTypes);
        // takedown
        g.restore();
        db.clear();
        return this;
    }
    draw(ctx, scene, bounds, markTypes) {
        if (scene.marktype !== 'group' && markTypes != null && !markTypes.includes(scene.marktype)) return;
        const mark = Marks[scene.marktype];
        if (scene.clip) clip(ctx, scene);
        mark.draw.call(this, ctx, scene, bounds, markTypes);
        if (scene.clip) ctx.restore();
    }
    clear(x, y, w, h) {
        const opt = this._options, g = this.context();
        if (opt.type !== 'pdf' && !opt.externalContext) // calling clear rect voids vector output in pdf mode
        // and could remove external context content (#2615)
        g.clearRect(x, y, w, h);
        if (this._bgcolor != null) {
            g.fillStyle = this._bgcolor;
            g.fillRect(x, y, w, h);
        }
    }
}
const viewBounds = (origin, width, height)=>new Bounds().set(0, 0, width, height).translate(-origin[0], -origin[1]);
function clipToBounds(g, b, origin) {
    // expand bounds by 1 pixel, then round to pixel boundaries
    b.expand(1).round();
    // align to base pixel grid in case of non-integer scaling (#2425)
    if (g.pixelRatio % 1) b.scale(g.pixelRatio).round().scale(1 / g.pixelRatio);
    // to avoid artifacts translate if origin has fractional pixels
    b.translate(-(origin[0] % 1), -(origin[1] % 1));
    // set clip path
    g.beginPath();
    g.rect(b.x1, b.y1, b.width(), b.height());
    g.clip();
    return b;
}
class SVGHandler extends Handler {
    constructor(loader, tooltip){
        super(loader, tooltip);
        const h = this;
        h._hrefHandler = listener(h, (evt, item)=>{
            if (item && item.href) h.handleHref(evt, item, item.href);
        });
        h._tooltipHandler = listener(h, (evt, item)=>{
            h.handleTooltip(evt, item, evt.type !== TooltipHideEvent);
        });
    }
    initialize(el, origin, obj) {
        let svg = this._svg;
        if (svg) {
            svg.removeEventListener(HrefEvent, this._hrefHandler);
            svg.removeEventListener(TooltipShowEvent, this._tooltipHandler);
            svg.removeEventListener(TooltipHideEvent, this._tooltipHandler);
        }
        this._svg = svg = el && domFind(el, 'svg');
        if (svg) {
            svg.addEventListener(HrefEvent, this._hrefHandler);
            svg.addEventListener(TooltipShowEvent, this._tooltipHandler);
            svg.addEventListener(TooltipHideEvent, this._tooltipHandler);
        }
        return super.initialize(el, origin, obj);
    }
    canvas() {
        return this._svg;
    }
    // add an event handler
    on(type, handler) {
        const name = this.eventName(type), h = this._handlers, i = this._handlerIndex(h[name], type, handler);
        if (i < 0) {
            const x = {
                type,
                handler,
                listener: listener(this, handler)
            };
            (h[name] || (h[name] = [])).push(x);
            if (this._svg) this._svg.addEventListener(name, x.listener);
        }
        return this;
    }
    // remove an event handler
    off(type, handler) {
        const name = this.eventName(type), h = this._handlers[name], i = this._handlerIndex(h, type, handler);
        if (i >= 0) {
            if (this._svg) this._svg.removeEventListener(name, h[i].listener);
            h.splice(i, 1);
        }
        return this;
    }
}
// wrap an event listener for the SVG DOM
const listener = (context, handler)=>(evt)=>{
        let item = evt.target.__data__;
        item = Array.isArray(item) ? item[0] : item;
        evt.vegaType = evt.type;
        handler.call(context._obj, evt, item);
    };
const ARIA_HIDDEN = 'aria-hidden';
const ARIA_LABEL = 'aria-label';
const ARIA_ROLE = 'role';
const ARIA_ROLEDESCRIPTION = 'aria-roledescription';
const GRAPHICS_OBJECT = 'graphics-object';
const GRAPHICS_SYMBOL = 'graphics-symbol';
const bundle = (role, roledesc, label)=>({
        [ARIA_ROLE]: role,
        [ARIA_ROLEDESCRIPTION]: roledesc,
        [ARIA_LABEL]: label || undefined
    });
// these roles are covered by related roles
// we can ignore them, no need to generate attributes
const AriaIgnore = (0, _vegaUtil.toSet)([
    'axis-domain',
    'axis-grid',
    'axis-label',
    'axis-tick',
    'axis-title',
    'legend-band',
    'legend-entry',
    'legend-gradient',
    'legend-label',
    'legend-title',
    'legend-symbol',
    'title'
]);
// aria attribute generators for guide roles
const AriaGuides = {
    'axis': {
        desc: 'axis',
        caption: axisCaption
    },
    'legend': {
        desc: 'legend',
        caption: legendCaption
    },
    'title-text': {
        desc: 'title',
        caption: (item)=>`Title text '${titleCaption(item)}'`
    },
    'title-subtitle': {
        desc: 'subtitle',
        caption: (item)=>`Subtitle text '${titleCaption(item)}'`
    }
};
// aria properties generated for mark item encoding channels
const AriaEncode = {
    ariaRole: ARIA_ROLE,
    ariaRoleDescription: ARIA_ROLEDESCRIPTION,
    description: ARIA_LABEL
};
function ariaItemAttributes(emit, item) {
    const hide = item.aria === false;
    emit(ARIA_HIDDEN, hide || undefined);
    if (hide || item.description == null) for(const prop in AriaEncode)emit(AriaEncode[prop], undefined);
    else {
        const type = item.mark.marktype;
        emit(ARIA_LABEL, item.description);
        emit(ARIA_ROLE, item.ariaRole || (type === 'group' ? GRAPHICS_OBJECT : GRAPHICS_SYMBOL));
        emit(ARIA_ROLEDESCRIPTION, item.ariaRoleDescription || `${type} mark`);
    }
}
function ariaMarkAttributes(mark) {
    return mark.aria === false ? {
        [ARIA_HIDDEN]: true
    } : AriaIgnore[mark.role] ? null : AriaGuides[mark.role] ? ariaGuide(mark, AriaGuides[mark.role]) : ariaMark(mark);
}
function ariaMark(mark) {
    const type = mark.marktype;
    const recurse = type === 'group' || type === 'text' || mark.items.some((_)=>_.description != null && _.aria !== false);
    return bundle(recurse ? GRAPHICS_OBJECT : GRAPHICS_SYMBOL, `${type} mark container`, mark.description);
}
function ariaGuide(mark, opt) {
    try {
        const item = mark.items[0], caption = opt.caption || (()=>'');
        return bundle(opt.role || GRAPHICS_SYMBOL, opt.desc, item.description || caption(item));
    } catch (err) {
        return null;
    }
}
function titleCaption(item) {
    return (0, _vegaUtil.array)(item.text).join(' ');
}
function axisCaption(item) {
    const datum = item.datum, orient = item.orient, title = datum.title ? extractTitle(item) : null, ctx = item.context, scale = ctx.scales[datum.scale].value, locale = ctx.dataflow.locale(), type = scale.type, xy = orient === 'left' || orient === 'right' ? 'Y' : 'X';
    return `${xy}-axis` + (title ? ` titled '${title}'` : '') + ` for a ${(0, _vegaScale.isDiscrete)(type) ? 'discrete' : type} scale` + ` with ${(0, _vegaScale.domainCaption)(locale, scale, item)}`;
}
function legendCaption(item) {
    const datum = item.datum, title = datum.title ? extractTitle(item) : null, type = `${datum.type || ''} legend`.trim(), scales = datum.scales, props = Object.keys(scales), ctx = item.context, scale = ctx.scales[scales[props[0]]].value, locale = ctx.dataflow.locale();
    return capitalize(type) + (title ? ` titled '${title}'` : '') + ` for ${channelCaption(props)}` + ` with ${(0, _vegaScale.domainCaption)(locale, scale, item)}`;
}
function extractTitle(item) {
    try {
        return (0, _vegaUtil.array)((0, _vegaUtil.peek)(item.items).items[0].text).join(' ');
    } catch (err) {
        return null;
    }
}
function channelCaption(props) {
    props = props.map((p)=>p + (p === 'fill' || p === 'stroke' ? ' color' : ''));
    return props.length < 2 ? props[0] : props.slice(0, -1).join(', ') + ' and ' + (0, _vegaUtil.peek)(props);
}
function capitalize(s) {
    return s.length ? s[0].toUpperCase() + s.slice(1) : s;
}
const innerText = (val)=>(val + '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
const attrText = (val)=>innerText(val).replace(/"/g, '&quot;').replace(/\t/g, '&#x9;').replace(/\n/g, '&#xA;').replace(/\r/g, '&#xD;');
function markup() {
    let buf = '', outer = '', inner = '';
    const stack = [], clear = ()=>outer = inner = '', push = (tag)=>{
        if (outer) {
            buf += `${outer}>${inner}`;
            clear();
        }
        stack.push(tag);
    }, attr = (name, value)=>{
        if (value != null) outer += ` ${name}="${attrText(value)}"`;
        return m;
    }, m = {
        open (tag) {
            push(tag);
            outer = '<' + tag;
            for(var _len = arguments.length, attrs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)attrs[_key - 1] = arguments[_key];
            for (const set of attrs)for(const key in set)attr(key, set[key]);
            return m;
        },
        close () {
            const tag = stack.pop();
            if (outer) buf += outer + (inner ? `>${inner}</${tag}>` : '/>');
            else buf += `</${tag}>`;
            clear();
            return m;
        },
        attr,
        text: (t)=>(inner += innerText(t), m),
        toString: ()=>buf
    };
    return m;
}
const serializeXML = (node)=>_serialize(markup(), node) + '';
function _serialize(m, node) {
    m.open(node.tagName);
    if (node.hasAttributes()) {
        const attrs = node.attributes, n = attrs.length;
        for(let i = 0; i < n; ++i)m.attr(attrs[i].name, attrs[i].value);
    }
    if (node.hasChildNodes()) {
        const children = node.childNodes;
        for (const child of children)child.nodeType === 3 // text node
         ? m.text(child.nodeValue) : _serialize(m, child);
    }
    return m.close();
}
const stylesAttr = {
    fill: 'fill',
    fillOpacity: 'fill-opacity',
    stroke: 'stroke',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    strokeCap: 'stroke-linecap',
    strokeJoin: 'stroke-linejoin',
    strokeDash: 'stroke-dasharray',
    strokeDashOffset: 'stroke-dashoffset',
    strokeMiterLimit: 'stroke-miterlimit',
    opacity: 'opacity'
};
const stylesCss = {
    blend: 'mix-blend-mode'
};
// ensure miter limit default is consistent with canvas (#2498)
const rootAttributes = {
    'fill': 'none',
    'stroke-miterlimit': 10
};
const RootIndex = 0, xmlns = 'http://www.w3.org/2000/xmlns/', svgns = metadata.xmlns;
class SVGRenderer extends Renderer {
    constructor(loader){
        super(loader);
        this._dirtyID = 0;
        this._dirty = [];
        this._svg = null;
        this._root = null;
        this._defs = null;
    }
    /**
   * Initialize a new SVGRenderer instance.
   * @param {DOMElement} el - The containing DOM element for the display.
   * @param {number} width - The coordinate width of the display, in pixels.
   * @param {number} height - The coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {SVGRenderer} - This renderer instance.
   */ initialize(el, width, height, origin, scaleFactor) {
        // create the svg definitions cache
        this._defs = {};
        this._clearDefs();
        if (el) {
            this._svg = domChild(el, 0, 'svg', svgns);
            this._svg.setAttributeNS(xmlns, 'xmlns', svgns);
            this._svg.setAttributeNS(xmlns, 'xmlns:xlink', metadata['xmlns:xlink']);
            this._svg.setAttribute('version', metadata['version']);
            this._svg.setAttribute('class', 'marks');
            domClear(el, 1);
            // set the svg root group
            this._root = domChild(this._svg, RootIndex, 'g', svgns);
            setAttributes(this._root, rootAttributes);
            // ensure no additional child elements
            domClear(this._svg, RootIndex + 1);
        }
        // set background color if defined
        this.background(this._bgcolor);
        return super.initialize(el, width, height, origin, scaleFactor);
    }
    /**
   * Get / set the background color.
   */ background(bgcolor) {
        if (arguments.length && this._svg) this._svg.style.setProperty('background-color', bgcolor);
        return super.background(...arguments);
    }
    /**
   * Resize the display.
   * @param {number} width - The new coordinate width of the display, in pixels.
   * @param {number} height - The new coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The new origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {SVGRenderer} - This renderer instance;
   */ resize(width, height, origin, scaleFactor) {
        super.resize(width, height, origin, scaleFactor);
        if (this._svg) {
            setAttributes(this._svg, {
                width: this._width * this._scale,
                height: this._height * this._scale,
                viewBox: `0 0 ${this._width} ${this._height}`
            });
            this._root.setAttribute('transform', `translate(${this._origin})`);
        }
        this._dirty = [];
        return this;
    }
    /**
   * Returns the SVG element of the visualization.
   * @return {DOMElement} - The SVG element.
   */ canvas() {
        return this._svg;
    }
    /**
   * Returns an SVG text string for the rendered content,
   * or null if this renderer is currently headless.
   */ svg() {
        const svg = this._svg, bg = this._bgcolor;
        if (!svg) return null;
        let node;
        if (bg) {
            svg.removeAttribute('style');
            node = domChild(svg, RootIndex, 'rect', svgns);
            setAttributes(node, {
                width: this._width,
                height: this._height,
                fill: bg
            });
        }
        const text = serializeXML(svg);
        if (bg) {
            svg.removeChild(node);
            this._svg.style.setProperty('background-color', bg);
        }
        return text;
    }
    /**
   * Internal rendering method.
   * @param {object} scene - The root mark of a scenegraph to render.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   */ _render(scene, markTypes) {
        // perform spot updates and re-render markup
        if (this._dirtyCheck()) {
            if (this._dirtyAll) this._clearDefs();
            this.mark(this._root, scene, undefined, markTypes);
            domClear(this._root, 1);
        }
        this.defs();
        this._dirty = [];
        ++this._dirtyID;
        return this;
    }
    // -- Manage rendering of items marked as dirty --
    /**
   * Flag a mark item as dirty.
   * @param {Item} item - The mark item.
   */ dirty(item) {
        if (item.dirty !== this._dirtyID) {
            item.dirty = this._dirtyID;
            this._dirty.push(item);
        }
    }
    /**
   * Check if a mark item is considered dirty.
   * @param {Item} item - The mark item.
   */ isDirty(item) {
        return this._dirtyAll || !item._svg || !item._svg.ownerSVGElement || item.dirty === this._dirtyID;
    }
    /**
   * Internal method to check dirty status and, if possible,
   * make targetted updates without a full rendering pass.
   */ _dirtyCheck() {
        this._dirtyAll = true;
        const items = this._dirty;
        if (!items.length || !this._dirtyID) return true;
        const id = ++this._dirtyID;
        let item, mark, type, mdef, i, n, o;
        for(i = 0, n = items.length; i < n; ++i){
            item = items[i];
            mark = item.mark;
            if (mark.marktype !== type) {
                // memoize mark instance lookup
                type = mark.marktype;
                mdef = Marks[type];
            }
            if (mark.zdirty && mark.dirty !== id) {
                this._dirtyAll = false;
                dirtyParents(item, id);
                mark.items.forEach((i)=>{
                    i.dirty = id;
                });
            }
            if (mark.zdirty) continue; // handle in standard drawing pass
            if (item.exit) {
                // EXIT
                if (mdef.nested && mark.items.length) {
                    // if nested mark with remaining points, update instead
                    o = mark.items[0];
                    if (o._svg) this._update(mdef, o._svg, o);
                } else if (item._svg) {
                    // otherwise remove from DOM
                    o = item._svg.parentNode;
                    if (o) o.removeChild(item._svg);
                }
                item._svg = null;
                continue;
            }
            item = mdef.nested ? mark.items[0] : item;
            if (item._update === id) continue; // already visited
            if (!item._svg || !item._svg.ownerSVGElement) {
                // ENTER
                this._dirtyAll = false;
                dirtyParents(item, id);
            } else // IN-PLACE UPDATE
            this._update(mdef, item._svg, item);
            item._update = id;
        }
        return !this._dirtyAll;
    }
    // -- Construct & maintain scenegraph to SVG mapping ---
    /**
   * Render a set of mark items.
   * @param {SVGElement} el - The parent element in the SVG tree.
   * @param {object} scene - The mark parent to render.
   * @param {SVGElement} prev - The previous sibling in the SVG tree.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   */ mark(el, scene, prev, markTypes) {
        if (!this.isDirty(scene)) return scene._svg;
        const svg = this._svg, markType = scene.marktype, mdef = Marks[markType], events = scene.interactive === false ? 'none' : null, isGroup = mdef.tag === 'g';
        const parent = bind(scene, el, prev, 'g', svg);
        if (markType !== 'group' && markTypes != null && !markTypes.includes(markType)) {
            domClear(parent, 0);
            return scene._svg;
        }
        parent.setAttribute('class', cssClass(scene));
        // apply aria attributes to parent container element
        const aria = ariaMarkAttributes(scene);
        for(const key in aria)setAttribute(parent, key, aria[key]);
        if (!isGroup) setAttribute(parent, 'pointer-events', events);
        setAttribute(parent, 'clip-path', scene.clip ? clip$1(this, scene, scene.group) : null);
        let sibling = null, i = 0;
        const process = (item)=>{
            const dirty = this.isDirty(item), node = bind(item, parent, sibling, mdef.tag, svg);
            if (dirty) {
                this._update(mdef, node, item);
                if (isGroup) recurse(this, node, item, markTypes);
            }
            sibling = node;
            ++i;
        };
        if (mdef.nested) {
            if (scene.items.length) process(scene.items[0]);
        } else visit(scene, process);
        domClear(parent, i);
        return parent;
    }
    /**
   * Update the attributes of an SVG element for a mark item.
   * @param {object} mdef - The mark definition object
   * @param {SVGElement} el - The SVG element.
   * @param {Item} item - The mark item.
   */ _update(mdef, el, item) {
        // set dom element and values cache
        // provides access to emit method
        element = el;
        values = el.__values__;
        // apply aria-specific properties
        ariaItemAttributes(emit, item);
        // apply svg attributes
        mdef.attr(emit, item, this);
        // some marks need special treatment
        const extra = mark_extras[mdef.type];
        if (extra) extra.call(this, mdef, el, item);
        // apply svg style attributes
        // note: element state may have been modified by 'extra' method
        if (element) this.style(element, item);
    }
    /**
   * Update the presentation attributes of an SVG element for a mark item.
   * @param {SVGElement} el - The SVG element.
   * @param {Item} item - The mark item.
   */ style(el, item) {
        if (item == null) return;
        for(const prop in stylesAttr){
            let value = prop === 'font' ? fontFamily(item) : item[prop];
            if (value === values[prop]) continue;
            const name = stylesAttr[prop];
            if (value == null) el.removeAttribute(name);
            else {
                if (isGradient(value)) value = gradientRef(value, this._defs.gradient, href());
                el.setAttribute(name, value + '');
            }
            values[prop] = value;
        }
        for(const prop in stylesCss)setStyle(el, stylesCss[prop], item[prop]);
    }
    /**
   * Render SVG defs, as needed.
   * Must be called *after* marks have been processed to ensure the
   * collected state is current and accurate.
   */ defs() {
        const svg = this._svg, defs = this._defs;
        let el = defs.el, index = 0;
        for(const id in defs.gradient){
            if (!el) defs.el = el = domChild(svg, RootIndex + 1, 'defs', svgns);
            index = updateGradient(el, defs.gradient[id], index);
        }
        for(const id in defs.clipping){
            if (!el) defs.el = el = domChild(svg, RootIndex + 1, 'defs', svgns);
            index = updateClipping(el, defs.clipping[id], index);
        }
        // clean-up
        if (el) index === 0 ? (svg.removeChild(el), defs.el = null) : domClear(el, index);
    }
    /**
   * Clear defs caches.
   */ _clearDefs() {
        const def = this._defs;
        def.gradient = {};
        def.clipping = {};
    }
}
// mark ancestor chain with a dirty id
function dirtyParents(item, id) {
    for(; item && item.dirty !== id; item = item.mark.group){
        item.dirty = id;
        if (item.mark && item.mark.dirty !== id) item.mark.dirty = id;
        else return;
    }
}
// update gradient definitions
function updateGradient(el, grad, index) {
    let i, n, stop;
    if (grad.gradient === 'radial') {
        // SVG radial gradients automatically transform to normalized bbox
        // coordinates, in a way that is cumbersome to replicate in canvas.
        // We wrap the radial gradient in a pattern element, allowing us to
        // maintain a circular gradient that matches what canvas provides.
        let pt = domChild(el, index++, 'pattern', svgns);
        setAttributes(pt, {
            id: patternPrefix + grad.id,
            viewBox: '0,0,1,1',
            width: '100%',
            height: '100%',
            preserveAspectRatio: 'xMidYMid slice'
        });
        pt = domChild(pt, 0, 'rect', svgns);
        setAttributes(pt, {
            width: 1,
            height: 1,
            fill: `url(${href()}#${grad.id})`
        });
        el = domChild(el, index++, 'radialGradient', svgns);
        setAttributes(el, {
            id: grad.id,
            fx: grad.x1,
            fy: grad.y1,
            fr: grad.r1,
            cx: grad.x2,
            cy: grad.y2,
            r: grad.r2
        });
    } else {
        el = domChild(el, index++, 'linearGradient', svgns);
        setAttributes(el, {
            id: grad.id,
            x1: grad.x1,
            x2: grad.x2,
            y1: grad.y1,
            y2: grad.y2
        });
    }
    for(i = 0, n = grad.stops.length; i < n; ++i){
        stop = domChild(el, i, 'stop', svgns);
        stop.setAttribute('offset', grad.stops[i].offset);
        stop.setAttribute('stop-color', grad.stops[i].color);
    }
    domClear(el, i);
    return index;
}
// update clipping path definitions
function updateClipping(el, clip, index) {
    let mask;
    el = domChild(el, index, 'clipPath', svgns);
    el.setAttribute('id', clip.id);
    if (clip.path) {
        mask = domChild(el, 0, 'path', svgns);
        mask.setAttribute('d', clip.path);
    } else {
        mask = domChild(el, 0, 'rect', svgns);
        setAttributes(mask, {
            x: 0,
            y: 0,
            width: clip.width,
            height: clip.height
        });
    }
    domClear(el, 1);
    return index + 1;
}
// Recursively process group contents.
function recurse(renderer, el, group, markTypes) {
    // child 'g' element is second to last among children (path, g, path)
    // other children here are foreground and background path elements
    el = el.lastChild.previousSibling;
    let prev, idx = 0;
    visit(group, (item)=>{
        prev = renderer.mark(el, item, prev, markTypes);
        ++idx;
    });
    // remove any extraneous DOM elements
    domClear(el, 1 + idx);
}
// Bind a scenegraph item to an SVG DOM element.
// Create new SVG elements as needed.
function bind(item, el, sibling, tag, svg) {
    let node = item._svg, doc;
    // create a new dom node if needed
    if (!node) {
        doc = el.ownerDocument;
        node = domCreate(doc, tag, svgns);
        item._svg = node;
        if (item.mark) {
            node.__data__ = item;
            node.__values__ = {
                fill: 'default'
            };
            // if group, create background, content, and foreground elements
            if (tag === 'g') {
                const bg = domCreate(doc, 'path', svgns);
                node.appendChild(bg);
                bg.__data__ = item;
                const cg = domCreate(doc, 'g', svgns);
                node.appendChild(cg);
                cg.__data__ = item;
                const fg = domCreate(doc, 'path', svgns);
                node.appendChild(fg);
                fg.__data__ = item;
                fg.__values__ = {
                    fill: 'default'
                };
            }
        }
    }
    // (re-)insert if (a) not contained in SVG or (b) sibling order has changed
    if (node.ownerSVGElement !== svg || siblingCheck(node, sibling)) el.insertBefore(node, sibling ? sibling.nextSibling : el.firstChild);
    return node;
}
// check if two nodes are ordered siblings
function siblingCheck(node, sibling) {
    return node.parentNode && node.parentNode.childNodes.length > 1 && node.previousSibling != sibling; // treat null/undefined the same
}
// -- Set attributes & styles on SVG elements ---
let element = null, // temp var for current SVG element
values = null; // temp var for current values hash
// Extra configuration for certain mark types
const mark_extras = {
    group (mdef, el, item) {
        const fg = element = el.childNodes[2];
        values = fg.__values__;
        mdef.foreground(emit, item, this);
        values = el.__values__; // use parent's values hash
        element = el.childNodes[1];
        mdef.content(emit, item, this);
        const bg = element = el.childNodes[0];
        mdef.background(emit, item, this);
        const value = item.mark.interactive === false ? 'none' : null;
        if (value !== values.events) {
            setAttribute(fg, 'pointer-events', value);
            setAttribute(bg, 'pointer-events', value);
            values.events = value;
        }
        if (item.strokeForeground && item.stroke) {
            const fill = item.fill;
            setAttribute(fg, 'display', null);
            // set style of background
            this.style(bg, item);
            setAttribute(bg, 'stroke', null);
            // set style of foreground
            if (fill) item.fill = null;
            values = fg.__values__;
            this.style(fg, item);
            if (fill) item.fill = fill;
            // leave element null to prevent downstream styling
            element = null;
        } else // ensure foreground is ignored
        setAttribute(fg, 'display', 'none');
    },
    image (mdef, el, item) {
        if (item.smooth === false) {
            setStyle(el, 'image-rendering', 'optimizeSpeed');
            setStyle(el, 'image-rendering', 'pixelated');
        } else setStyle(el, 'image-rendering', null);
    },
    text (mdef, el, item) {
        const tl = textLines(item);
        let key, value, doc, lh;
        if ((0, _vegaUtil.isArray)(tl)) {
            // multi-line text
            value = tl.map((_)=>textValue(item, _));
            key = value.join('\n'); // content cache key
            if (key !== values.text) {
                domClear(el, 0);
                doc = el.ownerDocument;
                lh = lineHeight(item);
                value.forEach((t, i)=>{
                    const ts = domCreate(doc, 'tspan', svgns);
                    ts.__data__ = item; // data binding
                    ts.textContent = t;
                    if (i) {
                        ts.setAttribute('x', 0);
                        ts.setAttribute('dy', lh);
                    }
                    el.appendChild(ts);
                });
                values.text = key;
            }
        } else {
            // single-line text
            value = textValue(item, tl);
            if (value !== values.text) {
                el.textContent = value;
                values.text = value;
            }
        }
        setAttribute(el, 'font-family', fontFamily(item));
        setAttribute(el, 'font-size', fontSize(item) + 'px');
        setAttribute(el, 'font-style', item.fontStyle);
        setAttribute(el, 'font-variant', item.fontVariant);
        setAttribute(el, 'font-weight', item.fontWeight);
    }
};
function emit(name, value, ns) {
    // early exit if value is unchanged
    if (value === values[name]) return;
    // use appropriate method given namespace (ns)
    if (ns) setAttributeNS(element, name, value, ns);
    else setAttribute(element, name, value);
    // note current value for future comparison
    values[name] = value;
}
function setStyle(el, name, value) {
    if (value !== values[name]) {
        if (value == null) el.style.removeProperty(name);
        else el.style.setProperty(name, value + '');
        values[name] = value;
    }
}
function setAttributes(el, attrs) {
    for(const key in attrs)setAttribute(el, key, attrs[key]);
}
function setAttribute(el, name, value) {
    if (value != null) // if value is provided, update DOM attribute
    el.setAttribute(name, value);
    else // else remove DOM attribute
    el.removeAttribute(name);
}
function setAttributeNS(el, name, value, ns) {
    if (value != null) // if value is provided, update DOM attribute
    el.setAttributeNS(ns, name, value);
    else // else remove DOM attribute
    el.removeAttributeNS(ns, name);
}
function href() {
    let loc;
    return typeof window === 'undefined' ? '' : (loc = window.location).hash ? loc.href.slice(0, -loc.hash.length) : loc.href;
}
class SVGStringRenderer extends Renderer {
    constructor(loader){
        super(loader);
        this._text = null;
        this._defs = {
            gradient: {},
            clipping: {}
        };
    }
    /**
   * Returns the rendered SVG text string,
   * or null if rendering has not yet occurred.
   */ svg() {
        return this._text;
    }
    /**
   * Internal rendering method.
   * @param {object} scene - The root mark of a scenegraph to render.
   */ _render(scene) {
        const m = markup();
        // svg tag
        m.open('svg', (0, _vegaUtil.extend)({}, metadata, {
            class: 'marks',
            width: this._width * this._scale,
            height: this._height * this._scale,
            viewBox: `0 0 ${this._width} ${this._height}`
        }));
        // background, if defined
        const bg = this._bgcolor;
        if (bg && bg !== 'transparent' && bg !== 'none') m.open('rect', {
            width: this._width,
            height: this._height,
            fill: bg
        }).close();
        // root content group
        m.open('g', rootAttributes, {
            transform: 'translate(' + this._origin + ')'
        });
        this.mark(m, scene);
        m.close(); // </g>
        // defs
        this.defs(m);
        // get SVG text string
        this._text = m.close() + '';
        return this;
    }
    /**
   * Render a set of mark items.
   * @param {object} m - The markup context.
   * @param {object} scene - The mark parent to render.
   */ mark(m, scene) {
        const mdef = Marks[scene.marktype], tag = mdef.tag, attrList = [
            ariaItemAttributes,
            mdef.attr
        ];
        // render opening group tag
        m.open('g', {
            'class': cssClass(scene),
            'clip-path': scene.clip ? clip$1(this, scene, scene.group) : null
        }, ariaMarkAttributes(scene), {
            'pointer-events': tag !== 'g' && scene.interactive === false ? 'none' : null
        });
        // render contained elements
        const process = (item)=>{
            const href = this.href(item);
            if (href) m.open('a', href);
            m.open(tag, this.attr(scene, item, attrList, tag !== 'g' ? tag : null));
            if (tag === 'text') {
                const tl = textLines(item);
                if ((0, _vegaUtil.isArray)(tl)) {
                    // multi-line text
                    const attrs = {
                        x: 0,
                        dy: lineHeight(item)
                    };
                    for(let i = 0; i < tl.length; ++i)m.open('tspan', i ? attrs : null).text(textValue(item, tl[i])).close();
                } else // single-line text
                m.text(textValue(item, tl));
            } else if (tag === 'g') {
                const fore = item.strokeForeground, fill = item.fill, stroke = item.stroke;
                if (fore && stroke) item.stroke = null;
                m.open('path', this.attr(scene, item, mdef.background, 'bgrect')).close();
                // recurse for group content
                m.open('g', this.attr(scene, item, mdef.content));
                visit(item, (scene)=>this.mark(m, scene));
                m.close();
                if (fore && stroke) {
                    if (fill) item.fill = null;
                    item.stroke = stroke;
                    m.open('path', this.attr(scene, item, mdef.foreground, 'bgrect')).close();
                    if (fill) item.fill = fill;
                } else m.open('path', this.attr(scene, item, mdef.foreground, 'bgfore')).close();
            }
            m.close(); // </tag>
            if (href) m.close(); // </a>
        };
        if (mdef.nested) {
            if (scene.items && scene.items.length) process(scene.items[0]);
        } else visit(scene, process);
        // render closing group tag
        return m.close(); // </g>
    }
    /**
   * Get href attributes for a hyperlinked mark item.
   * @param {Item} item - The mark item.
   */ href(item) {
        const href = item.href;
        let attr;
        if (href) {
            if (attr = this._hrefs && this._hrefs[href]) return attr;
            else this.sanitizeURL(href).then((attr)=>{
                // rewrite to use xlink namespace
                attr['xlink:href'] = attr.href;
                attr.href = null;
                (this._hrefs || (this._hrefs = {}))[href] = attr;
            });
        }
        return null;
    }
    /**
   * Get an object of SVG attributes for a mark item.
   * @param {object} scene - The mark parent.
   * @param {Item} item - The mark item.
   * @param {array|function} attrs - One or more attribute emitters.
   * @param {string} tag - The tag being rendered.
   */ attr(scene, item, attrs, tag) {
        const object = {}, emit = (name, value, ns, prefixed)=>{
            object[prefixed || name] = value;
        };
        // apply mark specific attributes
        if (Array.isArray(attrs)) attrs.forEach((fn)=>fn(emit, item, this));
        else attrs(emit, item, this);
        // apply style attributes
        if (tag) style(object, item, scene, tag, this._defs);
        return object;
    }
    /**
   * Render SVG defs, as needed.
   * Must be called *after* marks have been processed to ensure the
   * collected state is current and accurate.
   * @param {object} m - The markup context.
   */ defs(m) {
        const gradient = this._defs.gradient, clipping = this._defs.clipping, count = Object.keys(gradient).length + Object.keys(clipping).length;
        if (count === 0) return; // nothing to do
        m.open('defs');
        for(const id in gradient){
            const def = gradient[id], stops = def.stops;
            if (def.gradient === 'radial') {
                // SVG radial gradients automatically transform to normalized bbox
                // coordinates, in a way that is cumbersome to replicate in canvas.
                // We wrap the radial gradient in a pattern element, allowing us to
                // maintain a circular gradient that matches what canvas provides.
                m.open('pattern', {
                    id: patternPrefix + id,
                    viewBox: '0,0,1,1',
                    width: '100%',
                    height: '100%',
                    preserveAspectRatio: 'xMidYMid slice'
                });
                m.open('rect', {
                    width: '1',
                    height: '1',
                    fill: 'url(#' + id + ')'
                }).close();
                m.close(); // </pattern>
                m.open('radialGradient', {
                    id: id,
                    fx: def.x1,
                    fy: def.y1,
                    fr: def.r1,
                    cx: def.x2,
                    cy: def.y2,
                    r: def.r2
                });
            } else m.open('linearGradient', {
                id: id,
                x1: def.x1,
                x2: def.x2,
                y1: def.y1,
                y2: def.y2
            });
            for(let i = 0; i < stops.length; ++i)m.open('stop', {
                offset: stops[i].offset,
                'stop-color': stops[i].color
            }).close();
            m.close();
        }
        for(const id in clipping){
            const def = clipping[id];
            m.open('clipPath', {
                id: id
            });
            if (def.path) m.open('path', {
                d: def.path
            }).close();
            else m.open('rect', {
                x: 0,
                y: 0,
                width: def.width,
                height: def.height
            }).close();
            m.close();
        }
        m.close();
    }
}
// Helper function for attr for style presentation attributes
function style(s, item, scene, tag, defs) {
    let styleList;
    if (item == null) return s;
    if (tag === 'bgrect' && scene.interactive === false) s['pointer-events'] = 'none';
    if (tag === 'bgfore') {
        if (scene.interactive === false) s['pointer-events'] = 'none';
        s.display = 'none';
        if (item.fill !== null) return s;
    }
    if (tag === 'image' && item.smooth === false) styleList = [
        'image-rendering: optimizeSpeed;',
        'image-rendering: pixelated;'
    ];
    if (tag === 'text') {
        s['font-family'] = fontFamily(item);
        s['font-size'] = fontSize(item) + 'px';
        s['font-style'] = item.fontStyle;
        s['font-variant'] = item.fontVariant;
        s['font-weight'] = item.fontWeight;
    }
    for(const prop in stylesAttr){
        let value = item[prop];
        const name = stylesAttr[prop];
        if (value === 'transparent' && (name === 'fill' || name === 'stroke')) ;
        else if (value != null) {
            if (isGradient(value)) value = gradientRef(value, defs.gradient, '');
            s[name] = value;
        }
    }
    for(const prop in stylesCss){
        const value = item[prop];
        if (value != null) {
            styleList = styleList || [];
            styleList.push(`${stylesCss[prop]}: ${value};`);
        }
    }
    if (styleList) s.style = styleList.join(' ');
    return s;
}
/**
 * @typedef {Object} HybridRendererOptions
 *
 * @property {string[]} [svgMarkTypes=['text']] - An array of SVG mark types to render
 *                                                in the SVG layer. All other mark types
 *                                                will be rendered in the Canvas layer.
 * @property {boolean} [svgOnTop=true] - Flag to determine if SVG should be rendered on top.
 * @property {boolean} [debug=false] - Flag to enable or disable debugging mode. When true,
 *                                     the top layer will be stacked below the bottom layer
 *                                     rather than overlaid on top.
 */ /** @type {HybridRendererOptions} */ const OPTS = {
    svgMarkTypes: [
        'text'
    ],
    svgOnTop: true,
    debug: false
};
/**
 * Configure the HybridRenderer
 *
 * @param {HybridRendererOptions} options - HybridRenderer configuration options.
 */ function setHybridRendererOptions(options) {
    OPTS['svgMarkTypes'] = options.svgMarkTypes ?? [
        'text'
    ];
    OPTS['svgOnTop'] = options.svgOnTop ?? true;
    OPTS['debug'] = options.debug ?? false;
}
class HybridRenderer extends Renderer {
    constructor(loader){
        super(loader);
        this._svgRenderer = new SVGRenderer(loader);
        this._canvasRenderer = new CanvasRenderer(loader);
    }
    /**
   * Initialize a new HybridRenderer instance.
   * @param {DOMElement} el - The containing DOM element for the display.
   * @param {number} width - The coordinate width of the display, in pixels.
   * @param {number} height - The coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {HybridRenderer} - This renderer instance.
   */ initialize(el, width, height, origin, scaleFactor) {
        this._root_el = domChild(el, 0, 'div');
        const bottomEl = domChild(this._root_el, 0, 'div');
        const topEl = domChild(this._root_el, 1, 'div');
        this._root_el.style.position = 'relative';
        // Set position absolute to overlay svg on top of canvas
        if (!OPTS.debug) {
            bottomEl.style.height = '100%';
            topEl.style.position = 'absolute';
            topEl.style.top = '0';
            topEl.style.left = '0';
            topEl.style.height = '100%';
            topEl.style.width = '100%';
        }
        this._svgEl = OPTS.svgOnTop ? topEl : bottomEl;
        this._canvasEl = OPTS.svgOnTop ? bottomEl : topEl;
        // pointer-events to none on SVG layer so that canvas gets all events
        this._svgEl.style.pointerEvents = 'none';
        this._canvasRenderer.initialize(this._canvasEl, width, height, origin, scaleFactor);
        this._svgRenderer.initialize(this._svgEl, width, height, origin, scaleFactor);
        return super.initialize(el, width, height, origin, scaleFactor);
    }
    /**
   * Flag a mark item as dirty.
   * @param {Item} item - The mark item.
   */ dirty(item) {
        if (OPTS.svgMarkTypes.includes(item.mark.marktype)) this._svgRenderer.dirty(item);
        else this._canvasRenderer.dirty(item);
        return this;
    }
    /**
   * Internal rendering method.
   * @param {object} scene - The root mark of a scenegraph to render.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   */ _render(scene, markTypes) {
        const allMarkTypes = markTypes ?? [
            'arc',
            'area',
            'image',
            'line',
            'path',
            'rect',
            'rule',
            'shape',
            'symbol',
            'text',
            'trail'
        ];
        const canvasMarkTypes = allMarkTypes.filter((m)=>!OPTS.svgMarkTypes.includes(m));
        this._svgRenderer.render(scene, OPTS.svgMarkTypes);
        this._canvasRenderer.render(scene, canvasMarkTypes);
    }
    /**
   * Resize the display.
   * @param {number} width - The new coordinate width of the display, in pixels.
   * @param {number} height - The new coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The new origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {SVGRenderer} - This renderer instance;
   */ resize(width, height, origin, scaleFactor) {
        super.resize(width, height, origin, scaleFactor);
        this._svgRenderer.resize(width, height, origin, scaleFactor);
        this._canvasRenderer.resize(width, height, origin, scaleFactor);
        return this;
    }
    background(bgcolor) {
        // Propagate background color to lower canvas renderer
        if (OPTS.svgOnTop) this._canvasRenderer.background(bgcolor);
        else this._svgRenderer.background(bgcolor);
        return this;
    }
}
class HybridHandler extends CanvasHandler {
    constructor(loader, tooltip){
        super(loader, tooltip);
    }
    initialize(el, origin, obj) {
        const canvas = domChild(domChild(el, 0, 'div'), OPTS.svgOnTop ? 0 : 1, 'div');
        return super.initialize(canvas, origin, obj);
    }
}
const Canvas = 'canvas';
const Hybrid = 'hybrid';
const PNG = 'png';
const SVG = 'svg';
const None = 'none';
const RenderType = {
    Canvas: Canvas,
    PNG: PNG,
    SVG: SVG,
    Hybrid: Hybrid,
    None: None
};
const modules = {};
modules[Canvas] = modules[PNG] = {
    renderer: CanvasRenderer,
    headless: CanvasRenderer,
    handler: CanvasHandler
};
modules[SVG] = {
    renderer: SVGRenderer,
    headless: SVGStringRenderer,
    handler: SVGHandler
};
modules[Hybrid] = {
    renderer: HybridRenderer,
    headless: HybridRenderer,
    handler: HybridHandler
};
modules[None] = {};
function renderModule(name, _) {
    name = String(name || '').toLowerCase();
    if (arguments.length > 1) {
        modules[name] = _;
        return this;
    } else return modules[name];
}
function intersect(scene, bounds, filter) {
    const hits = [], // intersection results
    box = new Bounds().union(bounds), // defensive copy
    type = scene.marktype;
    return type ? intersectMark(scene, box, filter, hits) : type === 'group' ? intersectGroup(scene, box, filter, hits) : (0, _vegaUtil.error)('Intersect scene must be mark node or group item.');
}
function intersectMark(mark, box, filter, hits) {
    if (visitMark(mark, box, filter)) {
        const items = mark.items, type = mark.marktype, n = items.length;
        let i = 0;
        if (type === 'group') for(; i < n; ++i)intersectGroup(items[i], box, filter, hits);
        else for(const test = Marks[type].isect; i < n; ++i){
            const item = items[i];
            if (intersectItem(item, box, test)) hits.push(item);
        }
    }
    return hits;
}
function visitMark(mark, box, filter) {
    // process if bounds intersect and if
    // (1) mark is a group mark (so we must recurse), or
    // (2) mark is interactive and passes filter
    return mark.bounds && box.intersects(mark.bounds) && (mark.marktype === 'group' || mark.interactive !== false && (!filter || filter(mark)));
}
function intersectGroup(group, box, filter, hits) {
    // test intersect against group
    // skip groups by default unless filter says otherwise
    if (filter && filter(group.mark) && intersectItem(group, box, Marks.group.isect)) hits.push(group);
    // recursively test children marks
    // translate box to group coordinate space
    const marks = group.items, n = marks && marks.length;
    if (n) {
        const x = group.x || 0, y = group.y || 0;
        box.translate(-x, -y);
        for(let i = 0; i < n; ++i)intersectMark(marks[i], box, filter, hits);
        box.translate(x, y);
    }
    return hits;
}
function intersectItem(item, box, test) {
    // test bounds enclosure, bounds intersection, then detailed test
    const bounds = item.bounds;
    return box.encloses(bounds) || box.intersects(bounds) && test(item, box);
}
const clipBounds = new Bounds();
function boundClip(mark) {
    const clip = mark.clip;
    if ((0, _vegaUtil.isFunction)(clip)) clip(boundContext(clipBounds.clear()));
    else if (clip) clipBounds.set(0, 0, mark.group.width, mark.group.height);
    else return;
    mark.bounds.intersect(clipBounds);
}
const TOLERANCE = 1e-9;
function sceneEqual(a, b, key) {
    return a === b ? true : key === 'path' ? pathEqual(a, b) : a instanceof Date && b instanceof Date ? +a === +b : (0, _vegaUtil.isNumber)(a) && (0, _vegaUtil.isNumber)(b) ? Math.abs(a - b) <= TOLERANCE : !a || !b || !(0, _vegaUtil.isObject)(a) && !(0, _vegaUtil.isObject)(b) ? a == b : objectEqual(a, b);
}
function pathEqual(a, b) {
    return sceneEqual(parse(a), parse(b));
}
function objectEqual(a, b) {
    var ka = Object.keys(a), kb = Object.keys(b), key, i;
    if (ka.length !== kb.length) return false;
    ka.sort();
    kb.sort();
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!sceneEqual(a[key], b[key], key)) return false;
    }
    return typeof a === typeof b;
}
function resetSVGDefIds() {
    resetSVGClipId();
    resetSVGGradientId();
}

},{"vega-util":"7f6sQ","d3-shape":[["arc","4GHDI","default"],["area","5KDw0","default"],["curveBasis","3h6fT","default"],["curveBasisClosed","brV5v","default"],["curveBasisOpen","9X5kS","default"],["curveBundle","jvFr5","default"],["curveCardinal","9m9Wy","default"],["curveCardinalClosed","17aml","default"],["curveCardinalOpen","6DIa2","default"],["curveCatmullRom","bAcX9","default"],["curveCatmullRomClosed","7pkNu","default"],["curveCatmullRomOpen","7CaAZ","default"],["curveLinear","5wrmn","default"],["curveLinearClosed","lfx6d","default"],["curveMonotoneX","jFtTO","monotoneX"],["curveMonotoneY","jFtTO","monotoneY"],["curveNatural","gqMWw","default"],["curveStep","hS1d8","default"],["curveStepAfter","hS1d8","stepAfter"],["curveStepBefore","hS1d8","stepBefore"],["line","Tkwqg","default"],["symbol","97zw2","default"]],"d3-path":"F09f7","vega-canvas":"duGNb","vega-loader":"mXgcA","vega-scale":"13gXz","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4GHDI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = (0, _constantJsDefault.default)(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null, path = (0, _pathJs.withPath)(arc);
        function arc() {
            var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, _mathJs.halfPi), a1 = endAngle.apply(this, arguments) - (0, _mathJs.halfPi), da = (0, _mathJs.abs)(a1 - a0), cw = a1 > a0;
            if (!context) context = buffer = path();
            // Ensure that the outer radius is always larger than the inner radius.
            if (r1 < r0) r = r1, r1 = r0, r0 = r;
            // Is it a point?
            if (!(r1 > (0, _mathJs.epsilon))) context.moveTo(0, 0);
            else if (da > (0, _mathJs.tau) - (0, _mathJs.epsilon)) {
                context.moveTo(r1 * (0, _mathJs.cos)(a0), r1 * (0, _mathJs.sin)(a0));
                context.arc(0, 0, r1, a0, a1, !cw);
                if (r0 > (0, _mathJs.epsilon)) {
                    context.moveTo(r0 * (0, _mathJs.cos)(a1), r0 * (0, _mathJs.sin)(a1));
                    context.arc(0, 0, r0, a1, a0, cw);
                }
            } else {
                var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, _mathJs.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, _mathJs.sqrt)(r0 * r0 + r1 * r1)), rc = (0, _mathJs.min)((0, _mathJs.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
                // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
                if (rp > (0, _mathJs.epsilon)) {
                    var p0 = (0, _mathJs.asin)(rp / r0 * (0, _mathJs.sin)(ap)), p1 = (0, _mathJs.asin)(rp / r1 * (0, _mathJs.sin)(ap));
                    if ((da0 -= p0 * 2) > (0, _mathJs.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                    else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                    if ((da1 -= p1 * 2) > (0, _mathJs.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                    else da1 = 0, a01 = a11 = (a0 + a1) / 2;
                }
                var x01 = r1 * (0, _mathJs.cos)(a01), y01 = r1 * (0, _mathJs.sin)(a01), x10 = r0 * (0, _mathJs.cos)(a10), y10 = r0 * (0, _mathJs.sin)(a10);
                // Apply rounded corners?
                if (rc > (0, _mathJs.epsilon)) {
                    var x11 = r1 * (0, _mathJs.cos)(a11), y11 = r1 * (0, _mathJs.sin)(a11), x00 = r0 * (0, _mathJs.cos)(a00), y00 = r0 * (0, _mathJs.sin)(a00), oc;
                    // Restrict the corner radius according to the sector angle. If this
                    // intersection fails, it’s probably because the arc is too small, so
                    // disable the corner radius entirely.
                    if (da < (0, _mathJs.pi)) {
                        if (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
                            var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, _mathJs.sin)((0, _mathJs.acos)((ax * bx + ay * by) / ((0, _mathJs.sqrt)(ax * ax + ay * ay) * (0, _mathJs.sqrt)(bx * bx + by * by))) / 2), lc = (0, _mathJs.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                            rc0 = (0, _mathJs.min)(rc, (r0 - lc) / (kc - 1));
                            rc1 = (0, _mathJs.min)(rc, (r1 - lc) / (kc + 1));
                        } else rc0 = rc1 = 0;
                    }
                }
                // Is the sector collapsed to a line?
                if (!(da1 > (0, _mathJs.epsilon))) context.moveTo(x01, y01);
                else if (rc1 > (0, _mathJs.epsilon)) {
                    t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                    t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                    context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc1, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r1, (0, _mathJs.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _mathJs.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                        context.arc(t1.cx, t1.cy, rc1, (0, _mathJs.atan2)(t1.y11, t1.x11), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    }
                } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
                // Is there no inner ring, and it’s a circular sector?
                // Or perhaps it’s an annular sector collapsed due to padding?
                if (!(r0 > (0, _mathJs.epsilon)) || !(da0 > (0, _mathJs.epsilon))) context.lineTo(x10, y10);
                else if (rc0 > (0, _mathJs.epsilon)) {
                    t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                    t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                    context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc0, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r0, (0, _mathJs.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _mathJs.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                        context.arc(t1.cx, t1.cy, rc0, (0, _mathJs.atan2)(t1.y11, t1.x11), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    }
                } else context.arc(0, 0, r0, a10, a00, cw);
            }
            context.closePath();
            if (buffer) return context = null, buffer + "" || null;
        }
        arc.centroid = function() {
            var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, _mathJs.pi) / 2;
            return [
                (0, _mathJs.cos)(a) * r,
                (0, _mathJs.sin)(a) * r
            ];
        };
        arc.innerRadius = function(_) {
            return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : innerRadius;
        };
        arc.outerRadius = function(_) {
            return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : outerRadius;
        };
        arc.cornerRadius = function(_) {
            return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : cornerRadius;
        };
        arc.padRadius = function(_) {
            return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : padRadius;
        };
        arc.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : startAngle;
        };
        arc.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : endAngle;
        };
        arc.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : padAngle;
        };
        arc.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, arc) : context;
        };
        return arc;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _mathJs = require("./math.js");
var _pathJs = require("./path.js");
function arcInnerRadius(d) {
    return d.innerRadius;
}
function arcOuterRadius(d) {
    return d.outerRadius;
}
function arcStartAngle(d) {
    return d.startAngle;
}
function arcEndAngle(d) {
    return d.endAngle;
}
function arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, _mathJs.epsilon)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, _mathJs.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, _mathJs.sqrt)((0, _mathJs.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}

},{"./constant.js":"bskbe","./math.js":"hQvp7","./path.js":"8XWfv","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bskbe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function constant() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hQvp7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abs", ()=>abs);
parcelHelpers.export(exports, "atan2", ()=>atan2);
parcelHelpers.export(exports, "cos", ()=>cos);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "sin", ()=>sin);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
parcelHelpers.export(exports, "pi", ()=>pi);
parcelHelpers.export(exports, "halfPi", ()=>halfPi);
parcelHelpers.export(exports, "tau", ()=>tau);
parcelHelpers.export(exports, "acos", ()=>acos);
parcelHelpers.export(exports, "asin", ()=>asin);
const abs = Math.abs;
const atan2 = Math.atan2;
const cos = Math.cos;
const max = Math.max;
const min = Math.min;
const sin = Math.sin;
const sqrt = Math.sqrt;
const epsilon = 1e-12;
const pi = Math.PI;
const halfPi = pi / 2;
const tau = 2 * pi;
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
    return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8XWfv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withPath", ()=>withPath);
var _d3Path = require("d3-path");
function withPath(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new (0, _d3Path.Path)(digits);
}

},{"d3-path":"F09f7","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"F09f7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Path", ()=>Path);
parcelHelpers.export(exports, "path", ()=>path);
parcelHelpers.export(exports, "pathRound", ()=>pathRound);
const pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class Path {
    constructor(digits){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? append : appendRound(digits);
    }
    moveTo(x, y) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append`Z`;
        }
    }
    lineTo(x, y) {
        this._append`L${this._x1 = +x},${this._y1 = +y}`;
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
        else if (!(l01_2 > epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > epsilon) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
            this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append`M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._append`L${x0},${y0}`;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % tau + tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
        else if (da > epsilon) this._append`A${r},${r},0,${+(da >= pi)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
    rect(x, y, w, h) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
    }
    toString() {
        return this._;
    }
}
function path() {
    return new Path;
}
// Allow instanceof d3.path
path.prototype = Path.prototype;
function pathRound(digits = 3) {
    return new Path(+digits);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5KDw0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x0, y0, y1) {
        var x1 = null, defined = (0, _constantJsDefault.default)(true), context = null, curve = (0, _linearJsDefault.default), output = null, path = (0, _pathJs.withPath)(area);
        x0 = typeof x0 === "function" ? x0 : x0 === undefined ? (0, _pointJs.x) : (0, _constantJsDefault.default)(+x0);
        y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, _constantJsDefault.default)(0) : (0, _constantJsDefault.default)(+y0);
        y1 = typeof y1 === "function" ? y1 : y1 === undefined ? (0, _pointJs.y) : (0, _constantJsDefault.default)(+y1);
        function area(data) {
            var i, j, k, n = (data = (0, _arrayJsDefault.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
            if (context == null) output = curve(buffer = path());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) {
                        j = i;
                        output.areaStart();
                        output.lineStart();
                    } else {
                        output.lineEnd();
                        output.lineStart();
                        for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                        output.lineEnd();
                        output.areaEnd();
                    }
                }
                if (defined0) {
                    x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                    output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
                }
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        function arealine() {
            return (0, _lineJsDefault.default)().defined(defined).curve(curve).context(context);
        }
        area.x = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), x1 = null, area) : x0;
        };
        area.x0 = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : x0;
        };
        area.x1 = function(_) {
            return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : x1;
        };
        area.y = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), y1 = null, area) : y0;
        };
        area.y0 = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : y0;
        };
        area.y1 = function(_) {
            return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : y1;
        };
        area.lineX0 = area.lineY0 = function() {
            return arealine().x(x0).y(y0);
        };
        area.lineY1 = function() {
            return arealine().x(x0).y(y1);
        };
        area.lineX1 = function() {
            return arealine().x(x1).y(y0);
        };
        area.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), area) : defined;
        };
        area.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
        };
        area.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
        };
        return area;
    });
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _pathJs = require("./path.js");
var _pointJs = require("./point.js");

},{"./array.js":"3IxBP","./constant.js":"bskbe","./curve/linear.js":"5wrmn","./line.js":"Tkwqg","./path.js":"8XWfv","./point.js":"jcmOb","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3IxBP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
         : Array.from(x); // Map, Set, iterable, string, or anything else
    });
var slice = Array.prototype.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5wrmn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Linear(context);
    });
function Linear(context) {
    this._context = context;
}
Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"Tkwqg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        var defined = (0, _constantJsDefault.default)(true), context = null, curve = (0, _linearJsDefault.default), output = null, path = (0, _pathJs.withPath)(line);
        x = typeof x === "function" ? x : x === undefined ? (0, _pointJs.x) : (0, _constantJsDefault.default)(x);
        y = typeof y === "function" ? y : y === undefined ? (0, _pointJs.y) : (0, _constantJsDefault.default)(y);
        function line(data) {
            var i, n = (data = (0, _arrayJsDefault.default)(data)).length, d, defined0 = false, buffer;
            if (context == null) output = curve(buffer = path());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) output.lineStart();
                    else output.lineEnd();
                }
                if (defined0) output.point(+x(d, i, data), +y(d, i, data));
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        line.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), line) : x;
        };
        line.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), line) : y;
        };
        line.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), line) : defined;
        };
        line.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
        };
        line.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
        };
        return line;
    });
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _pathJs = require("./path.js");
var _pointJs = require("./point.js");

},{"./array.js":"3IxBP","./constant.js":"bskbe","./curve/linear.js":"5wrmn","./path.js":"8XWfv","./point.js":"jcmOb","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"jcmOb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "x", ()=>x);
parcelHelpers.export(exports, "y", ()=>y);
function x(p) {
    return p[0];
}
function y(p) {
    return p[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3h6fT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
parcelHelpers.export(exports, "Basis", ()=>Basis);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Basis(context);
    });
function point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function Basis(context) {
    this._context = context;
}
Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                point(this, this._x1, this._y1); // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // falls through
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"brV5v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new BasisClosed(context);
    });
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _basisJs = require("./basis.js");
function BasisClosed(context) {
    this._context = context;
}
BasisClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, _basisJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"../noop.js":"5rLwB","./basis.js":"3h6fT","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5rLwB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"9X5kS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new BasisOpen(context);
    });
var _basisJs = require("./basis.js");
function BasisOpen(context) {
    this._context = context;
}
BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, _basisJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"./basis.js":"3h6fT","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"jvFr5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _basisJs = require("./basis.js");
function Bundle(context, beta) {
    this._basis = new (0, _basisJs.Basis)(context);
    this._beta = beta;
}
Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
exports.default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, _basisJs.Basis)(context) : new Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);

},{"./basis.js":"3h6fT","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"9m9Wy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
parcelHelpers.export(exports, "Cardinal", ()=>Cardinal);
function point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"17aml":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardinalClosed", ()=>CardinalClosed);
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _cardinalJs = require("./cardinal.js");
function CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _cardinalJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"../noop.js":"5rLwB","./cardinal.js":"9m9Wy","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"6DIa2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardinalOpen", ()=>CardinalOpen);
var _cardinalJs = require("./cardinal.js");
function CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, _cardinalJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"./cardinal.js":"9m9Wy","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bAcX9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
var _mathJs = require("../math.js");
var _cardinalJs = require("./cardinal.js");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, _mathJs.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, _mathJs.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, _cardinalJs.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"../math.js":"hQvp7","./cardinal.js":"9m9Wy","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"7pkNu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cardinalClosedJs = require("./cardinalClosed.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _catmullRomJs = require("./catmullRom.js");
function CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _catmullRomJs.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomClosed(context, alpha) : new (0, _cardinalClosedJs.CardinalClosed)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"./cardinalClosed.js":"17aml","../noop.js":"5rLwB","./catmullRom.js":"bAcX9","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"7CaAZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cardinalOpenJs = require("./cardinalOpen.js");
var _catmullRomJs = require("./catmullRom.js");
function CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, _catmullRomJs.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomOpen(context, alpha) : new (0, _cardinalOpenJs.CardinalOpen)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"./cardinalOpen.js":"6DIa2","./catmullRom.js":"bAcX9","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"lfx6d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new LinearClosed(context);
    });
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
function LinearClosed(context) {
    this._context = context;
}
LinearClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};

},{"../noop.js":"5rLwB","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"jFtTO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "monotoneX", ()=>monotoneX);
parcelHelpers.export(exports, "monotoneY", ()=>monotoneY);
function sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function MonotoneX(context) {
    this._context = context;
}
MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                point(this, this._t0, slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                point(this, slope2(this, t1 = slope3(this, x, y)), t1);
                break;
            default:
                point(this, this._t0, t1 = slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function MonotoneY(context) {
    this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
    MonotoneX.prototype.point.call(this, y, x);
};
function ReflectContext(context) {
    this._context = context;
}
ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function monotoneX(context) {
    return new MonotoneX(context);
}
function monotoneY(context) {
    return new MonotoneY(context);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"gqMWw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Natural(context);
    });
function Natural(context) {
    this._context = context;
}
Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = controlPoints(x), py = controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hS1d8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Step(context, 0.5);
    });
parcelHelpers.export(exports, "stepBefore", ()=>stepBefore);
parcelHelpers.export(exports, "stepAfter", ()=>stepAfter);
function Step(context, t) {
    this._context = context;
    this._t = t;
}
Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function stepBefore(context) {
    return new Step(context, 0);
}
function stepAfter(context) {
    return new Step(context, 1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"97zw2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "symbolsFill", ()=>symbolsFill);
parcelHelpers.export(exports, "symbolsStroke", ()=>symbolsStroke);
parcelHelpers.export(exports, "default", ()=>Symbol);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _pathJs = require("./path.js");
var _asteriskJs = require("./symbol/asterisk.js");
var _asteriskJsDefault = parcelHelpers.interopDefault(_asteriskJs);
var _circleJs = require("./symbol/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _crossJs = require("./symbol/cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _diamondJs = require("./symbol/diamond.js");
var _diamondJsDefault = parcelHelpers.interopDefault(_diamondJs);
var _diamond2Js = require("./symbol/diamond2.js");
var _diamond2JsDefault = parcelHelpers.interopDefault(_diamond2Js);
var _plusJs = require("./symbol/plus.js");
var _plusJsDefault = parcelHelpers.interopDefault(_plusJs);
var _squareJs = require("./symbol/square.js");
var _squareJsDefault = parcelHelpers.interopDefault(_squareJs);
var _square2Js = require("./symbol/square2.js");
var _square2JsDefault = parcelHelpers.interopDefault(_square2Js);
var _starJs = require("./symbol/star.js");
var _starJsDefault = parcelHelpers.interopDefault(_starJs);
var _triangleJs = require("./symbol/triangle.js");
var _triangleJsDefault = parcelHelpers.interopDefault(_triangleJs);
var _triangle2Js = require("./symbol/triangle2.js");
var _triangle2JsDefault = parcelHelpers.interopDefault(_triangle2Js);
var _wyeJs = require("./symbol/wye.js");
var _wyeJsDefault = parcelHelpers.interopDefault(_wyeJs);
var _timesJs = require("./symbol/times.js");
var _timesJsDefault = parcelHelpers.interopDefault(_timesJs);
const symbolsFill = [
    (0, _circleJsDefault.default),
    (0, _crossJsDefault.default),
    (0, _diamondJsDefault.default),
    (0, _squareJsDefault.default),
    (0, _starJsDefault.default),
    (0, _triangleJsDefault.default),
    (0, _wyeJsDefault.default)
];
const symbolsStroke = [
    (0, _circleJsDefault.default),
    (0, _plusJsDefault.default),
    (0, _timesJsDefault.default),
    (0, _triangle2JsDefault.default),
    (0, _asteriskJsDefault.default),
    (0, _square2JsDefault.default),
    (0, _diamond2JsDefault.default)
];
function Symbol(type, size) {
    let context = null, path = (0, _pathJs.withPath)(symbol);
    type = typeof type === "function" ? type : (0, _constantJsDefault.default)(type || (0, _circleJsDefault.default));
    size = typeof size === "function" ? size : (0, _constantJsDefault.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = path();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

},{"./constant.js":"bskbe","./path.js":"8XWfv","./symbol/asterisk.js":"iZIh6","./symbol/circle.js":"IANvO","./symbol/cross.js":"2Ida5","./symbol/diamond.js":"7IKNH","./symbol/diamond2.js":"fQiDS","./symbol/plus.js":"8G30l","./symbol/square.js":"7iRBo","./symbol/square2.js":"hMIsB","./symbol/star.js":"fcRtx","./symbol/triangle.js":"33kNa","./symbol/triangle2.js":"35fHM","./symbol/wye.js":"bMucN","./symbol/times.js":"8XjhB","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"iZIh6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const sqrt3 = (0, _mathJs.sqrt)(3);
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size + (0, _mathJs.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};

},{"../math.js":"hQvp7","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"IANvO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size / (0, _mathJs.pi));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, _mathJs.tau));
    }
};

},{"../math.js":"hQvp7","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"2Ida5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};

},{"../math.js":"hQvp7","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"7IKNH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const tan30 = (0, _mathJs.sqrt)(1 / 3);
const tan30_2 = tan30 * 2;
exports.default = {
    draw (context, size) {
        const y = (0, _mathJs.sqrt)(size / tan30_2);
        const x = y * tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};

},{"../math.js":"hQvp7","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"fQiDS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};

},{"../math.js":"hQvp7","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8G30l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size - (0, _mathJs.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};

},{"../math.js":"hQvp7","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"7iRBo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const w = (0, _mathJs.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};

},{"../math.js":"hQvp7","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hMIsB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};

},{"../math.js":"hQvp7","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"fcRtx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const ka = 0.89081309152928522810;
const kr = (0, _mathJs.sin)((0, _mathJs.pi) / 10) / (0, _mathJs.sin)(7 * (0, _mathJs.pi) / 10);
const kx = (0, _mathJs.sin)((0, _mathJs.tau) / 10) * kr;
const ky = -(0, _mathJs.cos)((0, _mathJs.tau) / 10) * kr;
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size * ka);
        const x = kx * r;
        const y = ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = (0, _mathJs.tau) * i / 5;
            const c = (0, _mathJs.cos)(a);
            const s = (0, _mathJs.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};

},{"../math.js":"hQvp7","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"33kNa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const sqrt3 = (0, _mathJs.sqrt)(3);
exports.default = {
    draw (context, size) {
        const y = -(0, _mathJs.sqrt)(size / (sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-sqrt3 * y, -y);
        context.lineTo(sqrt3 * y, -y);
        context.closePath();
    }
};

},{"../math.js":"hQvp7","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"35fHM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const sqrt3 = (0, _mathJs.sqrt)(3);
exports.default = {
    draw (context, size) {
        const s = (0, _mathJs.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};

},{"../math.js":"hQvp7","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bMucN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const c = -0.5;
const s = (0, _mathJs.sqrt)(3) / 2;
const k = 1 / (0, _mathJs.sqrt)(12);
const a = (k / 2 + 1) * 3;
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size / a);
        const x0 = r / 2, y0 = r * k;
        const x1 = x0, y1 = r * k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
        context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
        context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
        context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
        context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
        context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
        context.closePath();
    }
};

},{"../math.js":"hQvp7","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8XjhB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size - (0, _mathJs.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};

},{"../math.js":"hQvp7","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"duGNb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canvas", ()=>domCanvas);
parcelHelpers.export(exports, "domCanvas", ()=>domCanvas);
parcelHelpers.export(exports, "image", ()=>domImage);
function domCanvas(w, h) {
    if (typeof document !== 'undefined' && document.createElement) {
        const c = document.createElement('canvas');
        if (c && c.getContext) {
            c.width = w;
            c.height = h;
            return c;
        }
    }
    return null;
}
const domImage = ()=>typeof Image !== 'undefined' ? Image : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"13gXz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scaleImplicit", ()=>(0, _d3Scale.scaleImplicit));
parcelHelpers.export(exports, "Band", ()=>Band);
parcelHelpers.export(exports, "BinOrdinal", ()=>BinOrdinal);
parcelHelpers.export(exports, "DiscreteLegend", ()=>DiscreteLegend);
parcelHelpers.export(exports, "Diverging", ()=>Diverging);
parcelHelpers.export(exports, "GradientLegend", ()=>GradientLegend);
parcelHelpers.export(exports, "Identity", ()=>Identity);
parcelHelpers.export(exports, "Linear", ()=>Linear);
parcelHelpers.export(exports, "Log", ()=>Log);
parcelHelpers.export(exports, "Ordinal", ()=>Ordinal);
parcelHelpers.export(exports, "Point", ()=>Point);
parcelHelpers.export(exports, "Pow", ()=>Pow);
parcelHelpers.export(exports, "Quantile", ()=>Quantile);
parcelHelpers.export(exports, "Quantize", ()=>Quantize);
parcelHelpers.export(exports, "Sequential", ()=>Sequential);
parcelHelpers.export(exports, "Sqrt", ()=>Sqrt);
parcelHelpers.export(exports, "SymbolLegend", ()=>SymbolLegend);
parcelHelpers.export(exports, "Symlog", ()=>Symlog);
parcelHelpers.export(exports, "Threshold", ()=>Threshold);
parcelHelpers.export(exports, "Time", ()=>Time);
parcelHelpers.export(exports, "UTC", ()=>UTC);
parcelHelpers.export(exports, "bandSpace", ()=>bandSpace);
parcelHelpers.export(exports, "domainCaption", ()=>domainCaption);
parcelHelpers.export(exports, "interpolate", ()=>interpolate);
parcelHelpers.export(exports, "interpolateColors", ()=>interpolateColors);
parcelHelpers.export(exports, "interpolateRange", ()=>interpolateRange);
parcelHelpers.export(exports, "isContinuous", ()=>isContinuous);
parcelHelpers.export(exports, "isDiscrete", ()=>isDiscrete);
parcelHelpers.export(exports, "isDiscretizing", ()=>isDiscretizing);
parcelHelpers.export(exports, "isInterpolating", ()=>isInterpolating);
parcelHelpers.export(exports, "isLogarithmic", ()=>isLogarithmic);
parcelHelpers.export(exports, "isQuantile", ()=>isQuantile);
parcelHelpers.export(exports, "isRegisteredScale", ()=>isRegisteredScale);
parcelHelpers.export(exports, "isTemporal", ()=>isTemporal);
parcelHelpers.export(exports, "isValidScaleType", ()=>isValidScaleType);
parcelHelpers.export(exports, "labelFormat", ()=>labelFormat);
parcelHelpers.export(exports, "labelFraction", ()=>labelFraction);
parcelHelpers.export(exports, "labelValues", ()=>labelValues);
parcelHelpers.export(exports, "quantizeInterpolator", ()=>quantizeInterpolator);
parcelHelpers.export(exports, "registerScale", ()=>registerScale);
parcelHelpers.export(exports, "scale", ()=>scale);
parcelHelpers.export(exports, "scaleCopy", ()=>scaleCopy);
parcelHelpers.export(exports, "scaleFraction", ()=>scaleFraction);
parcelHelpers.export(exports, "scheme", ()=>scheme);
parcelHelpers.export(exports, "tickCount", ()=>tickCount);
parcelHelpers.export(exports, "tickFormat", ()=>tickFormat);
parcelHelpers.export(exports, "tickValues", ()=>tickValues);
parcelHelpers.export(exports, "validTicks", ()=>validTicks);
var _vegaUtil = require("vega-util");
var _d3Array = require("d3-array");
var _d3Scale = require("d3-scale");
var _d3Interpolate = require("d3-interpolate");
var _d3ScaleChromatic = require("d3-scale-chromatic");
var _vegaTime = require("vega-time");
function bandSpace(count, paddingInner, paddingOuter) {
    const space = count - paddingInner + paddingOuter * 2;
    return count ? space > 0 ? space : 1 : 0;
}
const Identity = 'identity';
const Linear = 'linear';
const Log = 'log';
const Pow = 'pow';
const Sqrt = 'sqrt';
const Symlog = 'symlog';
const Time = 'time';
const UTC = 'utc';
const Sequential = 'sequential';
const Diverging = 'diverging';
const Quantile = 'quantile';
const Quantize = 'quantize';
const Threshold = 'threshold';
const Ordinal = 'ordinal';
const Point = 'point';
const Band = 'band';
const BinOrdinal = 'bin-ordinal';
// categories
const Continuous = 'continuous';
const Discrete = 'discrete';
const Discretizing = 'discretizing';
const Interpolating = 'interpolating';
const Temporal = 'temporal';
function invertRange(scale) {
    return function(_) {
        let lo = _[0], hi = _[1], t;
        if (hi < lo) {
            t = lo;
            lo = hi;
            hi = t;
        }
        return [
            scale.invert(lo),
            scale.invert(hi)
        ];
    };
}
function invertRangeExtent(scale) {
    return function(_) {
        const range = scale.range();
        let lo = _[0], hi = _[1], min = -1, max, t, i, n;
        if (hi < lo) {
            t = lo;
            lo = hi;
            hi = t;
        }
        for(i = 0, n = range.length; i < n; ++i)if (range[i] >= lo && range[i] <= hi) {
            if (min < 0) min = i;
            max = i;
        }
        if (min < 0) return undefined;
        lo = scale.invertExtent(range[min]);
        hi = scale.invertExtent(range[max]);
        return [
            lo[0] === undefined ? lo[1] : lo[0],
            hi[1] === undefined ? hi[0] : hi[1]
        ];
    };
}
function band() {
    const scale = (0, _d3Scale.scaleOrdinal)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range;
    let range$1 = [
        0,
        1
    ], step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        const n = domain().length, reverse = range$1[1] < range$1[0], stop = range$1[1 - reverse], space = bandSpace(n, paddingInner, paddingOuter);
        let start = range$1[reverse - 0];
        step = (stop - start) / (space || 1);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) {
            start = Math.round(start);
            bandwidth = Math.round(bandwidth);
        }
        const values = (0, _d3Array.range)(n).map((i)=>start + step * i);
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        if (arguments.length) {
            domain(_);
            return rescale();
        } else return domain();
    };
    scale.range = function(_) {
        if (arguments.length) {
            range$1 = [
                +_[0],
                +_[1]
            ];
            return rescale();
        } else return range$1.slice();
    };
    scale.rangeRound = function(_) {
        range$1 = [
            +_[0],
            +_[1]
        ];
        round = true;
        return rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        if (arguments.length) {
            round = !!_;
            return rescale();
        } else return round;
    };
    scale.padding = function(_) {
        if (arguments.length) {
            paddingOuter = Math.max(0, Math.min(1, _));
            paddingInner = paddingOuter;
            return rescale();
        } else return paddingInner;
    };
    scale.paddingInner = function(_) {
        if (arguments.length) {
            paddingInner = Math.max(0, Math.min(1, _));
            return rescale();
        } else return paddingInner;
    };
    scale.paddingOuter = function(_) {
        if (arguments.length) {
            paddingOuter = Math.max(0, Math.min(1, _));
            return rescale();
        } else return paddingOuter;
    };
    scale.align = function(_) {
        if (arguments.length) {
            align = Math.max(0, Math.min(1, _));
            return rescale();
        } else return align;
    };
    scale.invertRange = function(_) {
        // bail if range has null or undefined values
        if (_[0] == null || _[1] == null) return;
        const reverse = range$1[1] < range$1[0], values = reverse ? ordinalRange().reverse() : ordinalRange(), n = values.length - 1;
        let lo = +_[0], hi = +_[1], a, b, t;
        // bail if either range endpoint is invalid
        if (lo !== lo || hi !== hi) return;
        // order range inputs, bail if outside of scale range
        if (hi < lo) {
            t = lo;
            lo = hi;
            hi = t;
        }
        if (hi < values[0] || lo > range$1[1 - reverse]) return;
        // binary search to index into scale range
        a = Math.max(0, (0, _d3Array.bisectRight)(values, lo) - 1);
        b = lo === hi ? a : (0, _d3Array.bisectRight)(values, hi) - 1;
        // increment index a if lo is within padding gap
        if (lo - values[a] > bandwidth + 1e-10) ++a;
        if (reverse) {
            // map + swap
            t = a;
            a = n - b;
            b = n - t;
        }
        return a > b ? undefined : domain().slice(a, b + 1);
    };
    scale.invert = function(_) {
        const value = scale.invertRange([
            _,
            _
        ]);
        return value ? value[0] : value;
    };
    scale.copy = function() {
        return band().domain(domain()).range(range$1).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return rescale();
}
function pointish(scale) {
    const copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    scale.copy = function() {
        return pointish(copy());
    };
    return scale;
}
function point() {
    return pointish(band().paddingInner(1));
}
var map = Array.prototype.map;
function numbers(_) {
    return map.call(_, (0, _vegaUtil.toNumber));
}
const slice = Array.prototype.slice;
function scaleBinOrdinal() {
    let domain = [], range = [];
    function scale(x) {
        return x == null || x !== x ? undefined : range[((0, _d3Array.bisect)(domain, x) - 1) % range.length];
    }
    scale.domain = function(_) {
        if (arguments.length) {
            domain = numbers(_);
            return scale;
        } else return domain.slice();
    };
    scale.range = function(_) {
        if (arguments.length) {
            range = slice.call(_);
            return scale;
        } else return range.slice();
    };
    scale.tickFormat = function(count, specifier) {
        return (0, _d3Scale.tickFormat)(domain[0], (0, _vegaUtil.peek)(domain), count == null ? 10 : count, specifier);
    };
    scale.copy = function() {
        return scaleBinOrdinal().domain(scale.domain()).range(scale.range());
    };
    return scale;
}
/** Private scale registry: should not be exported */ const scales = new Map();
const VEGA_SCALE = Symbol('vega_scale');
function registerScale(scale) {
    scale[VEGA_SCALE] = true;
    return scale;
}
/**
 * Return true if object was created by a constructor from the vega-scale `scale` function.
 */ function isRegisteredScale(scale) {
    return scale && scale[VEGA_SCALE] === true;
}
/**
 * Augment scales with their type and needed inverse methods.
 */ function create(type, constructor, metadata) {
    const ctr = function scale() {
        const s = constructor();
        if (!s.invertRange) s.invertRange = s.invert ? invertRange(s) : s.invertExtent ? invertRangeExtent(s) : undefined;
        s.type = type;
        return registerScale(s);
    };
    ctr.metadata = (0, _vegaUtil.toSet)((0, _vegaUtil.array)(metadata));
    return ctr;
}
/**
 * Registry function for adding and accessing scale constructor functions.
 * The *type* argument is a String indicating the name of the scale type.
 *
 * If the *scale* argument is not specified, this method returns the matching scale constructor in the registry, or `null` if not found.
 * If the *scale* argument is provided, it must be a scale constructor function to add to the registry under the given *type* name.
 * The *metadata* argument provides additional information to guide appropriate use of scales within Vega.
 *
 *  *metadata* can be either a string or string array. The valid string values are:
 * - `"continuous"` - the scale is defined over a continuous-valued domain.
 * - `"discrete"` - the scale is defined over a discrete domain and range.
 * - `"discretizing"` - the scale discretizes a continuous domain to a discrete range.
 * - `"interpolating"` - the scale range is defined using a color interpolator.
 * - `"log"` - the scale performs a logarithmic transform of the continuous domain.
 * - `"temporal"` - the scale domain is defined over date-time values.
 */ function scale(type, scale, metadata) {
    if (arguments.length > 1) {
        scales.set(type, create(type, scale, metadata));
        return this;
    } else return isValidScaleType(type) ? scales.get(type) : undefined;
}
// identity scale
scale(Identity, _d3Scale.scaleIdentity);
// continuous scales
scale(Linear, _d3Scale.scaleLinear, Continuous);
scale(Log, _d3Scale.scaleLog, [
    Continuous,
    Log
]);
scale(Pow, _d3Scale.scalePow, Continuous);
scale(Sqrt, _d3Scale.scaleSqrt, Continuous);
scale(Symlog, _d3Scale.scaleSymlog, Continuous);
scale(Time, _d3Scale.scaleTime, [
    Continuous,
    Temporal
]);
scale(UTC, _d3Scale.scaleUtc, [
    Continuous,
    Temporal
]);
// sequential scales
scale(Sequential, _d3Scale.scaleSequential, [
    Continuous,
    Interpolating
]); // backwards compat
scale(`${Sequential}-${Linear}`, _d3Scale.scaleSequential, [
    Continuous,
    Interpolating
]);
scale(`${Sequential}-${Log}`, _d3Scale.scaleSequentialLog, [
    Continuous,
    Interpolating,
    Log
]);
scale(`${Sequential}-${Pow}`, _d3Scale.scaleSequentialPow, [
    Continuous,
    Interpolating
]);
scale(`${Sequential}-${Sqrt}`, _d3Scale.scaleSequentialSqrt, [
    Continuous,
    Interpolating
]);
scale(`${Sequential}-${Symlog}`, _d3Scale.scaleSequentialSymlog, [
    Continuous,
    Interpolating
]);
// diverging scales
scale(`${Diverging}-${Linear}`, _d3Scale.scaleDiverging, [
    Continuous,
    Interpolating
]);
scale(`${Diverging}-${Log}`, _d3Scale.scaleDivergingLog, [
    Continuous,
    Interpolating,
    Log
]);
scale(`${Diverging}-${Pow}`, _d3Scale.scaleDivergingPow, [
    Continuous,
    Interpolating
]);
scale(`${Diverging}-${Sqrt}`, _d3Scale.scaleDivergingSqrt, [
    Continuous,
    Interpolating
]);
scale(`${Diverging}-${Symlog}`, _d3Scale.scaleDivergingSymlog, [
    Continuous,
    Interpolating
]);
// discretizing scales
scale(Quantile, _d3Scale.scaleQuantile, [
    Discretizing,
    Quantile
]);
scale(Quantize, _d3Scale.scaleQuantize, Discretizing);
scale(Threshold, _d3Scale.scaleThreshold, Discretizing);
// discrete scales
scale(BinOrdinal, scaleBinOrdinal, [
    Discrete,
    Discretizing
]);
scale(Ordinal, _d3Scale.scaleOrdinal, Discrete);
scale(Band, band, Discrete);
scale(Point, point, Discrete);
function isValidScaleType(type) {
    return scales.has(type);
}
function hasType(key, type) {
    const s = scales.get(key);
    return s && s.metadata[type];
}
function isContinuous(key) {
    return hasType(key, Continuous);
}
function isDiscrete(key) {
    return hasType(key, Discrete);
}
function isDiscretizing(key) {
    return hasType(key, Discretizing);
}
function isLogarithmic(key) {
    return hasType(key, Log);
}
function isTemporal(key) {
    return hasType(key, Temporal);
}
function isInterpolating(key) {
    return hasType(key, Interpolating);
}
function isQuantile(key) {
    return hasType(key, Quantile);
}
const scaleProps = [
    'clamp',
    'base',
    'constant',
    'exponent'
];
function interpolateRange(interpolator, range) {
    const start = range[0], span = (0, _vegaUtil.peek)(range) - start;
    return function(i) {
        return interpolator(start + i * span);
    };
}
function interpolateColors(colors, type, gamma) {
    return _d3Interpolate.piecewise(interpolate(type || 'rgb', gamma), colors);
}
function quantizeInterpolator(interpolator, count) {
    const samples = new Array(count), n = count + 1;
    for(let i = 0; i < count;)samples[i] = interpolator(++i / n);
    return samples;
}
function scaleCopy(scale) {
    const t = scale.type, s = scale.copy();
    s.type = t;
    return s;
}
function scaleFraction(scale$1, min, max) {
    const delta = max - min;
    let i, t, s;
    if (!delta || !Number.isFinite(delta)) return (0, _vegaUtil.constant)(0.5);
    else {
        i = (t = scale$1.type).indexOf('-');
        t = i < 0 ? t : t.slice(i + 1);
        s = scale(t)().domain([
            min,
            max
        ]).range([
            0,
            1
        ]);
        scaleProps.forEach((m)=>scale$1[m] ? s[m](scale$1[m]()) : 0);
        return s;
    }
}
function interpolate(type, gamma) {
    const interp = _d3Interpolate[method(type)];
    return gamma != null && interp && interp.gamma ? interp.gamma(gamma) : interp;
}
function method(type) {
    return 'interpolate' + type.toLowerCase().split('-').map((s)=>s[0].toUpperCase() + s.slice(1)).join('');
}
const continuous = {
    blues: 'cfe1f2bed8eca8cee58fc1de74b2d75ba3cf4592c63181bd206fb2125ca40a4a90',
    greens: 'd3eecdc0e6baabdda594d3917bc77d60ba6c46ab5e329a512089430e7735036429',
    greys: 'e2e2e2d4d4d4c4c4c4b1b1b19d9d9d8888887575756262624d4d4d3535351e1e1e',
    oranges: 'fdd8b3fdc998fdb87bfda55efc9244f87f2cf06b18e4580bd14904b93d029f3303',
    purples: 'e2e1efd4d4e8c4c5e0b4b3d6a3a0cc928ec3827cb97566ae684ea25c3696501f8c',
    reds: 'fdc9b4fcb49afc9e80fc8767fa7051f6573fec3f2fdc2a25c81b1db21218970b13',
    blueGreen: 'd5efedc1e8e0a7ddd18bd2be70c6a958ba9144ad77319c5d2089460e7736036429',
    bluePurple: 'ccddecbad0e4a8c2dd9ab0d4919cc98d85be8b6db28a55a6873c99822287730f71',
    greenBlue: 'd3eecec5e8c3b1e1bb9bd8bb82cec269c2ca51b2cd3c9fc7288abd1675b10b60a1',
    orangeRed: 'fddcaffdcf9bfdc18afdad77fb9562f67d53ee6545e24932d32d1ebf130da70403',
    purpleBlue: 'dbdaebc8cee4b1c3de97b7d87bacd15b9fc93a90c01e7fb70b70ab056199045281',
    purpleBlueGreen: 'dbd8eac8cee4b0c3de93b7d872acd1549fc83892bb1c88a3097f8702736b016353',
    purpleRed: 'dcc9e2d3b3d7ce9eccd186c0da6bb2e14da0e23189d91e6fc61159ab07498f023a',
    redPurple: 'fccfccfcbec0faa9b8f98faff571a5ec539ddb3695c41b8aa908808d0179700174',
    yellowGreen: 'e4f4acd1eca0b9e2949ed68880c97c62bb6e47aa5e3297502083440e723b036034',
    yellowOrangeBrown: 'feeaa1fedd84fecc63feb746fca031f68921eb7215db5e0bc54c05ab3d038f3204',
    yellowOrangeRed: 'fee087fed16ffebd59fea849fd903efc7335f9522bee3423de1b20ca0b22af0225',
    blueOrange: '134b852f78b35da2cb9dcae1d2e5eff2f0ebfce0bafbbf74e8932fc5690d994a07',
    brownBlueGreen: '704108a0651ac79548e3c78af3e6c6eef1eac9e9e48ed1c74da79e187a72025147',
    purpleGreen: '5b1667834792a67fb6c9aed3e6d6e8eff0efd9efd5aedda971bb75368e490e5e29',
    purpleOrange: '4114696647968f83b7b9b4d6dadbebf3eeeafce0bafbbf74e8932fc5690d994a07',
    redBlue: '8c0d25bf363adf745ef4ae91fbdbc9f2efeed2e5ef9dcae15da2cb2f78b3134b85',
    redGrey: '8c0d25bf363adf745ef4ae91fcdccbfaf4f1e2e2e2c0c0c0969696646464343434',
    yellowGreenBlue: 'eff9bddbf1b4bde5b594d5b969c5be45b4c22c9ec02182b82163aa23479c1c3185',
    redYellowBlue: 'a50026d4322cf16e43fcac64fedd90faf8c1dcf1ecabd6e875abd04a74b4313695',
    redYellowGreen: 'a50026d4322cf16e43fcac63fedd8df9f7aed7ee8ea4d86e64bc6122964f006837',
    pinkYellowGreen: '8e0152c0267edd72adf0b3d6faddedf5f3efe1f2cab6de8780bb474f9125276419',
    spectral: '9e0142d13c4bf0704afcac63fedd8dfbf8b0e0f3a1a9dda269bda94288b55e4fa2',
    viridis: '440154470e61481a6c482575472f7d443a834144873d4e8a39568c35608d31688e2d708e2a788e27818e23888e21918d1f988b1fa08822a8842ab07f35b77943bf7154c56866cc5d7ad1518fd744a5db36bcdf27d2e21be9e51afde725',
    magma: '0000040404130b0924150e3720114b2c11603b0f704a107957157e651a80721f817f24828c29819a2e80a8327db6377ac43c75d1426fde4968e95462f1605df76f5cfa7f5efc8f65fe9f6dfeaf78febf84fece91fddea0fcedaffcfdbf',
    inferno: '0000040403130c0826170c3b240c4f330a5f420a68500d6c5d126e6b176e781c6d86216b932667a12b62ae305cbb3755c73e4cd24644dd513ae65c30ed6925f3771af8850ffb9506fca50afcb519fac62df6d645f2e661f3f484fcffa4',
    plasma: '0d088723069033059742039d5002a25d01a66a00a87801a88405a7900da49c179ea72198b12a90ba3488c33d80cb4779d35171da5a69e16462e76e5bed7953f2834cf68f44fa9a3dfca636fdb32ffec029fcce25f9dc24f5ea27f0f921',
    cividis: '00205100235800265d002961012b65042e670831690d346b11366c16396d1c3c6e213f6e26426e2c456e31476e374a6e3c4d6e42506e47536d4c566d51586e555b6e5a5e6e5e616e62646f66676f6a6a706e6d717270717573727976737c79747f7c75827f758682768985778c8877908b78938e789691789a94789e9778a19b78a59e77a9a177aea575b2a874b6ab73bbaf71c0b26fc5b66dc9b96acebd68d3c065d8c462ddc85fe2cb5ce7cf58ebd355f0d652f3da4ff7de4cfae249fce647',
    rainbow: '6e40aa883eb1a43db3bf3cafd83fa4ee4395fe4b83ff576eff6659ff7847ff8c38f3a130e2b72fcfcc36bee044aff05b8ff4576ff65b52f6673af27828ea8d1ddfa319d0b81cbecb23abd82f96e03d82e14c6edb5a5dd0664dbf6e40aa',
    sinebow: 'ff4040fc582af47218e78d0bd5a703bfbf00a7d5038de70b72f41858fc2a40ff402afc5818f4720be78d03d5a700bfbf03a7d50b8de71872f42a58fc4040ff582afc7218f48d0be7a703d5bf00bfd503a7e70b8df41872fc2a58ff4040',
    turbo: '23171b32204a3e2a71453493493eae4b49c54a53d7485ee44569ee4074f53c7ff8378af93295f72e9ff42ba9ef28b3e926bce125c5d925cdcf27d5c629dcbc2de3b232e9a738ee9d3ff39347f68950f9805afc7765fd6e70fe667cfd5e88fc5795fb51a1f84badf545b9f140c5ec3cd0e637dae034e4d931ecd12ef4c92bfac029ffb626ffad24ffa223ff9821ff8d1fff821dff771cfd6c1af76118f05616e84b14df4111d5380fcb2f0dc0260ab61f07ac1805a313029b0f00950c00910b00',
    browns: 'eedbbdecca96e9b97ae4a865dc9856d18954c7784cc0673fb85536ad44339f3632',
    tealBlues: 'bce4d89dd3d181c3cb65b3c245a2b9368fae347da0306a932c5985',
    teals: 'bbdfdfa2d4d58ac9c975bcbb61b0af4da5a43799982b8b8c1e7f7f127273006667',
    warmGreys: 'dcd4d0cec5c1c0b8b4b3aaa7a59c9998908c8b827f7e7673726866665c5a59504e',
    goldGreen: 'f4d166d5ca60b6c35c98bb597cb25760a6564b9c533f8f4f33834a257740146c36',
    goldOrange: 'f4d166f8be5cf8aa4cf5983bf3852aef701be2621fd65322c54923b142239e3a26',
    goldRed: 'f4d166f6be59f9aa51fc964ef6834bee734ae56249db5247cf4244c43141b71d3e',
    lightGreyRed: 'efe9e6e1dad7d5cbc8c8bdb9bbaea9cd967ddc7b43e15f19df4011dc000b',
    lightGreyTeal: 'e4eaead6dcddc8ced2b7c2c7a6b4bc64b0bf22a6c32295c11f85be1876bc',
    lightMulti: 'e0f1f2c4e9d0b0de9fd0e181f6e072f6c053f3993ef77440ef4a3c',
    lightOrange: 'f2e7daf7d5baf9c499fab184fa9c73f68967ef7860e8645bde515bd43d5b',
    lightTealBlue: 'e3e9e0c0dccf9aceca7abfc859afc0389fb9328dad2f7ca0276b95255988',
    darkBlue: '3232322d46681a5c930074af008cbf05a7ce25c0dd38daed50f3faffffff',
    darkGold: '3c3c3c584b37725e348c7631ae8b2bcfa424ecc31ef9de30fff184ffffff',
    darkGreen: '3a3a3a215748006f4d048942489e4276b340a6c63dd2d836ffeb2cffffaa',
    darkMulti: '3737371f5287197d8c29a86995ce3fffe800ffffff',
    darkRed: '3434347036339e3c38cc4037e75d1eec8620eeab29f0ce32ffeb2c'
};
const discrete = {
    accent: (0, _d3ScaleChromatic.schemeAccent),
    category10: (0, _d3ScaleChromatic.schemeCategory10),
    category20: '1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5',
    category20b: '393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6',
    category20c: '3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9',
    dark2: (0, _d3ScaleChromatic.schemeDark2),
    observable10: (0, _d3ScaleChromatic.schemeObservable10),
    paired: (0, _d3ScaleChromatic.schemePaired),
    pastel1: (0, _d3ScaleChromatic.schemePastel1),
    pastel2: (0, _d3ScaleChromatic.schemePastel2),
    set1: (0, _d3ScaleChromatic.schemeSet1),
    set2: (0, _d3ScaleChromatic.schemeSet2),
    set3: (0, _d3ScaleChromatic.schemeSet3),
    tableau10: '4c78a8f58518e4575672b7b254a24beeca3bb279a2ff9da69d755dbab0ac',
    tableau20: '4c78a89ecae9f58518ffbf7954a24b88d27ab79a20f2cf5b43989483bcb6e45756ff9d9879706ebab0acd67195fcbfd2b279a2d6a5c99e765fd8b5a5'
};
function colors(palette) {
    if ((0, _vegaUtil.isArray)(palette)) return palette;
    const n = palette.length / 6 | 0, c = new Array(n);
    for(let i = 0; i < n;)c[i] = '#' + palette.slice(i * 6, ++i * 6);
    return c;
}
function apply(_, f) {
    for(const k in _)scheme(k, f(_[k]));
}
const schemes = {};
apply(discrete, colors);
apply(continuous, (_)=>interpolateColors(colors(_)));
function scheme(name, scheme) {
    name = name && name.toLowerCase();
    if (arguments.length > 1) {
        schemes[name] = scheme;
        return this;
    } else return schemes[name];
}
const SymbolLegend = 'symbol';
const DiscreteLegend = 'discrete';
const GradientLegend = 'gradient';
const defaultFormatter = (value)=>(0, _vegaUtil.isArray)(value) ? value.map((v)=>String(v)) : String(value);
const ascending = (a, b)=>a[1] - b[1];
const descending = (a, b)=>b[1] - a[1];
/**
 * Determine the tick count or interval function.
 * @param {Scale} scale - The scale for which to generate tick values.
 * @param {*} count - The desired tick count or interval specifier.
 * @param {number} minStep - The desired minimum step between tick values.
 * @return {*} - The tick count or interval function.
 */ function tickCount(scale, count, minStep) {
    let step;
    if ((0, _vegaUtil.isNumber)(count)) {
        if (scale.bins) count = Math.max(count, scale.bins.length);
        if (minStep != null) count = Math.min(count, Math.floor((0, _vegaUtil.span)(scale.domain()) / minStep || 1) + 1);
    }
    if ((0, _vegaUtil.isObject)(count)) {
        step = count.step;
        count = count.interval;
    }
    if ((0, _vegaUtil.isString)(count)) {
        count = scale.type === Time ? (0, _vegaTime.timeInterval)(count) : scale.type == UTC ? (0, _vegaTime.utcInterval)(count) : (0, _vegaUtil.error)('Only time and utc scales accept interval strings.');
        if (step) count = count.every(step);
    }
    return count;
}
/**
 * Filter a set of candidate tick values, ensuring that only tick values
 * that lie within the scale range are included.
 * @param {Scale} scale - The scale for which to generate tick values.
 * @param {Array<*>} ticks - The candidate tick values.
 * @param {*} count - The tick count or interval function.
 * @return {Array<*>} - The filtered tick values.
 */ function validTicks(scale, ticks, count) {
    let range = scale.range(), lo = range[0], hi = (0, _vegaUtil.peek)(range), cmp = ascending;
    if (lo > hi) {
        range = hi;
        hi = lo;
        lo = range;
        cmp = descending;
    }
    lo = Math.floor(lo);
    hi = Math.ceil(hi);
    // filter ticks to valid values within the range
    // additionally sort ticks in range order (#2579)
    ticks = ticks.map((v)=>[
            v,
            scale(v)
        ]).filter((_)=>lo <= _[1] && _[1] <= hi).sort(cmp).map((_)=>_[0]);
    if (count > 0 && ticks.length > 1) {
        const endpoints = [
            ticks[0],
            (0, _vegaUtil.peek)(ticks)
        ];
        while(ticks.length > count && ticks.length >= 3)ticks = ticks.filter((_, i)=>!(i % 2));
        if (ticks.length < 3) ticks = endpoints;
    }
    return ticks;
}
/**
 * Generate tick values for the given scale and approximate tick count or
 * interval value. If the scale has a 'ticks' method, it will be used to
 * generate the ticks, with the count argument passed as a parameter. If the
 * scale lacks a 'ticks' method, the full scale domain will be returned.
 * @param {Scale} scale - The scale for which to generate tick values.
 * @param {*} [count] - The approximate number of desired ticks.
 * @return {Array<*>} - The generated tick values.
 */ function tickValues(scale, count) {
    return scale.bins ? validTicks(scale, scale.bins, count) : scale.ticks ? scale.ticks(count) : scale.domain();
}
/**
 * Generate a label format function for a scale. If the scale has a
 * 'tickFormat' method, it will be used to generate the formatter, with the
 * count and specifier arguments passed as parameters. If the scale lacks a
 * 'tickFormat' method, the returned formatter performs simple string coercion.
 * If the input scale is a logarithmic scale and the format specifier does not
 * indicate a desired decimal precision, a special variable precision formatter
 * that automatically trims trailing zeroes will be generated.
 * @param {Scale} scale - The scale for which to generate the label formatter.
 * @param {*} [count] - The approximate number of desired ticks.
 * @param {string} [specifier] - The format specifier. Must be a legal d3
 *   specifier string (see https://github.com/d3/d3-format#formatSpecifier) or
 *   time multi-format specifier object.
 * @return {function(*):string} - The generated label formatter.
 */ function tickFormat(locale, scale, count, specifier, formatType, noSkip) {
    const type = scale.type;
    let format = defaultFormatter;
    if (type === Time || formatType === Time) format = locale.timeFormat(specifier);
    else if (type === UTC || formatType === UTC) format = locale.utcFormat(specifier);
    else if (isLogarithmic(type)) {
        const varfmt = locale.formatFloat(specifier);
        if (noSkip || scale.bins) format = varfmt;
        else {
            const test = tickLog(scale, count, false);
            format = (_)=>test(_) ? varfmt(_) : '';
        }
    } else if (scale.tickFormat) {
        // if d3 scale has tickFormat, it must be continuous
        const d = scale.domain();
        format = locale.formatSpan(d[0], d[d.length - 1], count, specifier);
    } else if (specifier) format = locale.format(specifier);
    return format;
}
function tickLog(scale, count, values) {
    const ticks = tickValues(scale, count), base = scale.base(), logb = Math.log(base), k = Math.max(1, base * count / ticks.length);
    // apply d3-scale's log format filter criteria
    const test = (d)=>{
        let i = d / Math.pow(base, Math.round(Math.log(d) / logb));
        if (i * base < base - 0.5) i *= base;
        return i <= k;
    };
    return values ? ticks.filter(test) : test;
}
const symbols = {
    [Quantile]: 'quantiles',
    [Quantize]: 'thresholds',
    [Threshold]: 'domain'
};
const formats = {
    [Quantile]: 'quantiles',
    [Quantize]: 'domain'
};
function labelValues(scale, count) {
    return scale.bins ? binValues(scale.bins) : scale.type === Log ? tickLog(scale, count, true) : symbols[scale.type] ? thresholdValues(scale[symbols[scale.type]]()) : tickValues(scale, count);
}
function thresholdFormat(locale, scale, specifier) {
    const _ = scale[formats[scale.type]](), n = _.length;
    let d = n > 1 ? _[1] - _[0] : _[0], i;
    for(i = 1; i < n; ++i)d = Math.min(d, _[i] - _[i - 1]);
    // tickCount = 3 ticks times 10 for increased resolution
    return locale.formatSpan(0, d, 30, specifier);
}
function thresholdValues(thresholds) {
    const values = [
        -Infinity
    ].concat(thresholds);
    values.max = Infinity;
    return values;
}
function binValues(bins) {
    const values = bins.slice(0, -1);
    values.max = (0, _vegaUtil.peek)(bins);
    return values;
}
const isDiscreteRange = (scale)=>symbols[scale.type] || scale.bins;
function labelFormat(locale, scale, count, type, specifier, formatType, noSkip) {
    const format = formats[scale.type] && formatType !== Time && formatType !== UTC ? thresholdFormat(locale, scale, specifier) : tickFormat(locale, scale, count, specifier, formatType, noSkip);
    return type === SymbolLegend && isDiscreteRange(scale) ? formatRange(format) : type === DiscreteLegend ? formatDiscrete(format) : formatPoint(format);
}
const formatRange = (format)=>(value, index, array)=>{
        const limit = get(array[index + 1], get(array.max, Infinity)), lo = formatValue(value, format), hi = formatValue(limit, format);
        return lo && hi ? lo + ' \u2013 ' + hi : hi ? '< ' + hi : '\u2265 ' + lo;
    };
const get = (value, dflt)=>value != null ? value : dflt;
const formatDiscrete = (format)=>(value, index)=>index ? format(value) : null;
const formatPoint = (format)=>(value)=>format(value);
const formatValue = (value, format)=>Number.isFinite(value) ? format(value) : null;
function labelFraction(scale) {
    const domain = scale.domain(), count = domain.length - 1;
    let lo = +domain[0], hi = +(0, _vegaUtil.peek)(domain), span = hi - lo;
    if (scale.type === Threshold) {
        const adjust = count ? span / count : 0.1;
        lo -= adjust;
        hi += adjust;
        span = hi - lo;
    }
    return (value)=>(value - lo) / span;
}
function format(locale, scale, specifier, formatType) {
    const type = formatType || scale.type;
    // replace abbreviated time specifiers to improve screen reader experience
    if ((0, _vegaUtil.isString)(specifier) && isTemporal(type)) specifier = specifier.replace(/%a/g, '%A').replace(/%b/g, '%B');
    return !specifier && type === Time ? locale.timeFormat('%A, %d %B %Y, %X') : !specifier && type === UTC ? locale.utcFormat('%A, %d %B %Y, %X UTC') : labelFormat(locale, scale, 5, null, specifier, formatType, true);
}
function domainCaption(locale, scale, opt) {
    opt = opt || {};
    const max = Math.max(3, opt.maxlen || 7), fmt = format(locale, scale, opt.format, opt.formatType);
    // if scale breaks domain into bins, describe boundaries
    if (isDiscretizing(scale.type)) {
        const v = labelValues(scale).slice(1).map(fmt), n = v.length;
        return `${n} boundar${n === 1 ? 'y' : 'ies'}: ${v.join(', ')}`;
    } else if (isDiscrete(scale.type)) {
        const d = scale.domain(), n = d.length, v = n > max ? d.slice(0, max - 2).map(fmt).join(', ') + ', ending with ' + d.slice(-1).map(fmt) : d.map(fmt).join(', ');
        return `${n} value${n === 1 ? '' : 's'}: ${v}`;
    } else {
        const d = scale.domain();
        return `values from ${fmt(d[0])} to ${fmt((0, _vegaUtil.peek)(d))}`;
    }
}

},{"vega-util":"7f6sQ","d3-array":[["bisectRight","8oF0X"],["range","2Qa4a","default"]],"d3-scale":"lVUyc","d3-interpolate":"ayVHH","d3-scale-chromatic":[["schemeAccent","fulOB","default"],["schemeCategory10","fSaTK","default"],["schemeDark2","gLzPP","default"],["schemeObservable10","fMku7","default"],["schemePaired","3MZIk","default"],["schemePastel1","hWPoY","default"],["schemePastel2","hItV9","default"],["schemeSet1","fAveY","default"],["schemeSet2","8JyVy","default"],["schemeSet3","jDkWD","default"]],"vega-time":"4oydN","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"lVUyc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scaleBand", ()=>(0, _bandJsDefault.default));
parcelHelpers.export(exports, "scalePoint", ()=>(0, _bandJs.point));
parcelHelpers.export(exports, "scaleIdentity", ()=>(0, _identityJsDefault.default));
parcelHelpers.export(exports, "scaleLinear", ()=>(0, _linearJsDefault.default));
parcelHelpers.export(exports, "scaleLog", ()=>(0, _logJsDefault.default));
parcelHelpers.export(exports, "scaleSymlog", ()=>(0, _symlogJsDefault.default));
parcelHelpers.export(exports, "scaleOrdinal", ()=>(0, _ordinalJsDefault.default));
parcelHelpers.export(exports, "scaleImplicit", ()=>(0, _ordinalJs.implicit));
parcelHelpers.export(exports, "scalePow", ()=>(0, _powJsDefault.default));
parcelHelpers.export(exports, "scaleSqrt", ()=>(0, _powJs.sqrt));
parcelHelpers.export(exports, "scaleRadial", ()=>(0, _radialJsDefault.default));
parcelHelpers.export(exports, "scaleQuantile", ()=>(0, _quantileJsDefault.default));
parcelHelpers.export(exports, "scaleQuantize", ()=>(0, _quantizeJsDefault.default));
parcelHelpers.export(exports, "scaleThreshold", ()=>(0, _thresholdJsDefault.default));
parcelHelpers.export(exports, "scaleTime", ()=>(0, _timeJsDefault.default));
parcelHelpers.export(exports, "scaleUtc", ()=>(0, _utcTimeJsDefault.default));
parcelHelpers.export(exports, "scaleSequential", ()=>(0, _sequentialJsDefault.default));
parcelHelpers.export(exports, "scaleSequentialLog", ()=>(0, _sequentialJs.sequentialLog));
parcelHelpers.export(exports, "scaleSequentialPow", ()=>(0, _sequentialJs.sequentialPow));
parcelHelpers.export(exports, "scaleSequentialSqrt", ()=>(0, _sequentialJs.sequentialSqrt));
parcelHelpers.export(exports, "scaleSequentialSymlog", ()=>(0, _sequentialJs.sequentialSymlog));
parcelHelpers.export(exports, "scaleSequentialQuantile", ()=>(0, _sequentialQuantileJsDefault.default));
parcelHelpers.export(exports, "scaleDiverging", ()=>(0, _divergingJsDefault.default));
parcelHelpers.export(exports, "scaleDivergingLog", ()=>(0, _divergingJs.divergingLog));
parcelHelpers.export(exports, "scaleDivergingPow", ()=>(0, _divergingJs.divergingPow));
parcelHelpers.export(exports, "scaleDivergingSqrt", ()=>(0, _divergingJs.divergingSqrt));
parcelHelpers.export(exports, "scaleDivergingSymlog", ()=>(0, _divergingJs.divergingSymlog));
parcelHelpers.export(exports, "tickFormat", ()=>(0, _tickFormatJsDefault.default));
var _bandJs = require("./band.js");
var _bandJsDefault = parcelHelpers.interopDefault(_bandJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _linearJs = require("./linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _logJs = require("./log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
var _symlogJs = require("./symlog.js");
var _symlogJsDefault = parcelHelpers.interopDefault(_symlogJs);
var _ordinalJs = require("./ordinal.js");
var _ordinalJsDefault = parcelHelpers.interopDefault(_ordinalJs);
var _powJs = require("./pow.js");
var _powJsDefault = parcelHelpers.interopDefault(_powJs);
var _radialJs = require("./radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);
var _thresholdJs = require("./threshold.js");
var _thresholdJsDefault = parcelHelpers.interopDefault(_thresholdJs);
var _timeJs = require("./time.js");
var _timeJsDefault = parcelHelpers.interopDefault(_timeJs);
var _utcTimeJs = require("./utcTime.js");
var _utcTimeJsDefault = parcelHelpers.interopDefault(_utcTimeJs);
var _sequentialJs = require("./sequential.js");
var _sequentialJsDefault = parcelHelpers.interopDefault(_sequentialJs);
var _sequentialQuantileJs = require("./sequentialQuantile.js");
var _sequentialQuantileJsDefault = parcelHelpers.interopDefault(_sequentialQuantileJs);
var _divergingJs = require("./diverging.js");
var _divergingJsDefault = parcelHelpers.interopDefault(_divergingJs);
var _tickFormatJs = require("./tickFormat.js");
var _tickFormatJsDefault = parcelHelpers.interopDefault(_tickFormatJs);

},{"./band.js":"8e24b","./identity.js":"h7tcO","./linear.js":"lNlik","./log.js":"8MtPs","./symlog.js":"jS0Zq","./ordinal.js":"8wT6n","./pow.js":"cTl9e","./radial.js":"eWcMR","./quantile.js":"gSH8c","./quantize.js":"9XmAJ","./threshold.js":"hpdK3","./time.js":"86824","./utcTime.js":"dMeBc","./sequential.js":"6s5Eb","./sequentialQuantile.js":"c09tc","./diverging.js":"1LwDi","./tickFormat.js":"dhK5o","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8e24b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>band);
parcelHelpers.export(exports, "point", ()=>point);
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
var _ordinalJs = require("./ordinal.js");
var _ordinalJsDefault = parcelHelpers.interopDefault(_ordinalJs);
function band() {
    var scale = (0, _ordinalJsDefault.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, _d3Array.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, _initJs.initRange).apply(rescale(), arguments);
}
function pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return pointish(copy());
    };
    return scale;
}
function point() {
    return pointish(band.apply(null, arguments).paddingInner(1));
}

},{"d3-array":[["range","2Qa4a","default"]],"./init.js":"56ApD","./ordinal.js":"8wT6n","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"56ApD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initRange", ()=>initRange);
parcelHelpers.export(exports, "initInterpolator", ()=>initInterpolator);
function initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8wT6n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "implicit", ()=>implicit);
parcelHelpers.export(exports, "default", ()=>ordinal);
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
const implicit = Symbol("implicit");
function ordinal() {
    var index = new (0, _d3Array.InternMap)(), domain = [], range = [], unknown = implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, _d3Array.InternMap)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return ordinal(domain, range).unknown(unknown);
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}

},{"d3-array":"5EkCg","./init.js":"56ApD","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"h7tcO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>identity);
var _linearJs = require("./linear.js");
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
function identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, _numberJsDefault.default)), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, (0, _numberJsDefault.default)) : [
        0,
        1
    ];
    return (0, _linearJs.linearish)(scale);
}

},{"./linear.js":"lNlik","./number.js":"dTlfA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"lNlik":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linearish", ()=>linearish);
parcelHelpers.export(exports, "default", ()=>linear);
var _d3Array = require("d3-array");
var _continuousJs = require("./continuous.js");
var _continuousJsDefault = parcelHelpers.interopDefault(_continuousJs);
var _initJs = require("./init.js");
var _tickFormatJs = require("./tickFormat.js");
var _tickFormatJsDefault = parcelHelpers.interopDefault(_tickFormatJs);
function linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, _d3Array.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, _tickFormatJsDefault.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, _d3Array.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function linear() {
    var scale = (0, _continuousJsDefault.default)();
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, linear());
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return linearish(scale);
}

},{"d3-array":[["tickIncrement","4kdy4"],["ticks","4kdy4","default"]],"./continuous.js":"3XDHY","./init.js":"56ApD","./tickFormat.js":"dhK5o","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3XDHY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "copy", ()=>copy);
parcelHelpers.export(exports, "transformer", ()=>transformer);
parcelHelpers.export(exports, "default", ()=>continuous);
var _d3Array = require("d3-array");
var _d3Interpolate = require("d3-interpolate");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var unit = [
    0,
    1
];
function identity(x) {
    return x;
}
function normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, _constantJsDefault.default)(isNaN(b) ? NaN : 0.5);
}
function clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, _d3Array.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer() {
    var domain = unit, range = unit, interpolate = (0, _d3Interpolate.interpolate), transform, untransform, unknown, clamp = identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== identity) clamp = clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? polymap : bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, _d3Interpolate.interpolateNumber))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, _numberJsDefault.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, _d3Interpolate.interpolateRound), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : identity, rescale()) : clamp !== identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function continuous() {
    return transformer()(identity, identity);
}

},{"d3-array":[["bisect","8oF0X","default"]],"d3-interpolate":[["interpolate","bmQNW","default"],["interpolateNumber","1WfY8","default"],["interpolateRound","jOLhU","default"]],"./constant.js":"eQU4c","./number.js":"dTlfA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bmQNW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var t = typeof b, c;
        return b == null || t === "boolean" ? (0, _constantJsDefault.default)(b) : (t === "number" ? (0, _numberJsDefault.default) : t === "string" ? (c = (0, _d3Color.color)(b)) ? (b = c, _rgbJsDefault.default) : (0, _stringJsDefault.default) : b instanceof (0, _d3Color.color) ? (0, _rgbJsDefault.default) : b instanceof Date ? (0, _dateJsDefault.default) : (0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : Array.isArray(b) ? (0, _arrayJs.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, _objectJsDefault.default) : (0, _numberJsDefault.default))(a, b);
    });
var _d3Color = require("d3-color");
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _arrayJs = require("./array.js");
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);

},{"d3-color":[["color","gqOvl","default"]],"./rgb.js":"8JklF","./array.js":"axXnp","./date.js":"2Aey1","./number.js":"1WfY8","./object.js":"hZiJR","./string.js":"fRinS","./constant.js":"g6c0O","./numberArray.js":"ldKqJ","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"gqOvl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", ()=>Color);
parcelHelpers.export(exports, "darker", ()=>darker);
parcelHelpers.export(exports, "brighter", ()=>brighter);
parcelHelpers.export(exports, "default", ()=>color);
parcelHelpers.export(exports, "rgbConvert", ()=>rgbConvert);
parcelHelpers.export(exports, "rgb", ()=>rgb);
parcelHelpers.export(exports, "Rgb", ()=>Rgb);
parcelHelpers.export(exports, "hslConvert", ()=>hslConvert);
parcelHelpers.export(exports, "hsl", ()=>hsl);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _defineJsDefault.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Rgb, rgb, (0, _defineJs.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Hsl, hsl, (0, _defineJs.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

},{"./define.js":"cOd61","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cOd61":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(constructor, factory, prototype) {
        constructor.prototype = factory.prototype = prototype;
        prototype.constructor = constructor;
    });
parcelHelpers.export(exports, "extend", ()=>extend);
function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8JklF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rgbBasis", ()=>rgbBasis);
parcelHelpers.export(exports, "rgbBasisClosed", ()=>rgbBasisClosed);
var _d3Color = require("d3-color");
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
exports.default = function rgbGamma(y) {
    var color = (0, _colorJs.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, _d3Color.rgb)(start)).r, (end = (0, _d3Color.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, _d3Color.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var rgbBasis = rgbSpline((0, _basisJsDefault.default));
var rgbBasisClosed = rgbSpline((0, _basisClosedJsDefault.default));

},{"d3-color":"gqOvl","./basis.js":"1Lui0","./basisClosed.js":"6eE79","./color.js":"5P5bR","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"1Lui0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basis", ()=>basis);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length - 1;
        return function(t) {
            var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
            return basis((t - i / n) * n, v0, v1, v2, v3);
        };
    });
function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"6eE79":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length;
        return function(t) {
            var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
            return (0, _basisJs.basis)((t - i / n) * n, v0, v1, v2, v3);
        };
    });
var _basisJs = require("./basis.js");

},{"./basis.js":"1Lui0","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5P5bR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hue", ()=>hue);
parcelHelpers.export(exports, "gamma", ()=>gamma);
parcelHelpers.export(exports, "default", ()=>nogamma);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}
function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
        return b - a ? exponential(a, b, y) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
    };
}
function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}

},{"./constant.js":"g6c0O","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"g6c0O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"axXnp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return ((0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : genericArray)(a, b);
    });
parcelHelpers.export(exports, "genericArray", ()=>genericArray);
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
function genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, _valueJsDefault.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

},{"./value.js":"bmQNW","./numberArray.js":"ldKqJ","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"ldKqJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        if (!b) b = [];
        var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
        return function(t) {
            for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
            return c;
        };
    });
parcelHelpers.export(exports, "isNumberArray", ()=>isNumberArray);
function isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"2Aey1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var d = new Date;
        return a = +a, b = +b, function(t) {
            return d.setTime(a * (1 - t) + b * t), d;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"1WfY8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return a * (1 - t) + b * t;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hZiJR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var i = {}, c = {}, k;
        if (a === null || typeof a !== "object") a = {};
        if (b === null || typeof b !== "object") b = {};
        for(k in b)if (k in a) i[k] = (0, _valueJsDefault.default)(a[k], b[k]);
        else c[k] = b[k];
        return function(t) {
            for(k in i)c[k] = i[k](t);
            return c;
        };
    });
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);

},{"./value.js":"bmQNW","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"fRinS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
        // Coerce inputs to strings.
        a = a + "", b = b + "";
        // Interpolate pairs of numbers in a & b.
        while((am = reA.exec(a)) && (bm = reB.exec(b))){
            if ((bs = bm.index) > bi) {
                bs = b.slice(bi, bs);
                if (s[i]) s[i] += bs; // coalesce with previous string
                else s[++i] = bs;
            }
            if ((am = am[0]) === (bm = bm[0])) {
                if (s[i]) s[i] += bm; // coalesce with previous string
                else s[++i] = bm;
            } else {
                s[++i] = null;
                q.push({
                    i: i,
                    x: (0, _numberJsDefault.default)(am, bm)
                });
            }
            bi = reB.lastIndex;
        }
        // Add remains of b.
        if (bi < b.length) {
            bs = b.slice(bi);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        // Special optimization for only a single match.
        // Otherwise, interpolate each of the numbers and rejoin the string.
        return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
            for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        });
    });
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
    return function() {
        return b;
    };
}
function one(b) {
    return function(t) {
        return b(t) + "";
    };
}

},{"./number.js":"1WfY8","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"jOLhU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return Math.round(a * (1 - t) + b * t);
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"eQU4c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>constants);
function constants(x) {
    return function() {
        return x;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dTlfA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>number);
function number(x) {
    return +x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dhK5o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>tickFormat);
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");
function tickFormat(start, stop, count, specifier) {
    var step = (0, _d3Array.tickStep)(start, stop, count), precision;
    specifier = (0, _d3Format.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, _d3Format.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, _d3Format.format)(specifier);
}

},{"d3-array":"4kdy4","d3-format":[["format","4S7BV"],["formatPrefix","4S7BV"],["formatSpecifier","3qj60","default"],["precisionFixed","gjSQc","default"],["precisionPrefix","lOwiG","default"],["precisionRound","hY5kM","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8MtPs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggish", ()=>loggish);
parcelHelpers.export(exports, "default", ()=>log);
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function transformLog(x) {
    return Math.log(x);
}
function transformExp(x) {
    return Math.exp(x);
}
function transformLogn(x) {
    return -Math.log(-x);
}
function transformExpn(x) {
    return -Math.exp(-x);
}
function pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function powp(base) {
    return base === 10 ? pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function reflect(f) {
    return (x, k)=>-f(-x, k);
}
function loggish(transform) {
    const scale = transform(transformLog, transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = logp(base), pows = powp(base);
        if (domain()[0] < 0) {
            logs = reflect(logs), pows = reflect(pows);
            transform(transformLogn, transformExpn);
        } else transform(transformLog, transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, _d3Array.ticks)(u, v, n);
        } else z = (0, _d3Array.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, _d3Format.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, _d3Format.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, _niceJsDefault.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function log() {
    const scale = loggish((0, _continuousJs.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, _continuousJs.copy)(scale, log()).base(scale.base());
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}

},{"d3-array":[["ticks","4kdy4","default"]],"d3-format":[["format","4S7BV"],["formatSpecifier","3qj60","default"]],"./nice.js":"g0QGc","./continuous.js":"3XDHY","./init.js":"56ApD","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"g0QGc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>nice);
function nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"jS0Zq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "symlogish", ()=>symlogish);
parcelHelpers.export(exports, "default", ()=>symlog);
var _linearJs = require("./linear.js");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function symlogish(transform) {
    var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
    };
    return (0, _linearJs.linearish)(scale);
}
function symlog() {
    var scale = symlogish((0, _continuousJs.transformer)());
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, symlog()).constant(scale.constant());
    };
    return (0, _initJs.initRange).apply(scale, arguments);
}

},{"./linear.js":"lNlik","./continuous.js":"3XDHY","./init.js":"56ApD","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cTl9e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "powish", ()=>powish);
parcelHelpers.export(exports, "default", ()=>pow);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
var _linearJs = require("./linear.js");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function powish(transform) {
    var scale = transform((0, _continuousJs.identity), (0, _continuousJs.identity)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, _continuousJs.identity), (0, _continuousJs.identity)) : exponent === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent), transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, _linearJs.linearish)(scale);
}
function pow() {
    var scale = powish((0, _continuousJs.transformer)());
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, pow()).exponent(scale.exponent());
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}
function sqrt() {
    return pow.apply(null, arguments).exponent(0.5);
}

},{"./linear.js":"lNlik","./continuous.js":"3XDHY","./init.js":"56ApD","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"eWcMR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>radial);
var _continuousJs = require("./continuous.js");
var _continuousJsDefault = parcelHelpers.interopDefault(_continuousJs);
var _initJs = require("./init.js");
var _linearJs = require("./linear.js");
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
function square(x) {
    return Math.sign(x) * x * x;
}
function unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function radial() {
    var squared = (0, _continuousJsDefault.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert(square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, (0, _numberJsDefault.default))).map(square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return (0, _linearJs.linearish)(scale);
}

},{"./continuous.js":"3XDHY","./init.js":"56ApD","./linear.js":"lNlik","./number.js":"dTlfA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"gSH8c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantile);
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
function quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, _d3Array.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, _d3Array.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, _d3Array.ascending));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return quantile().domain(domain).range(range).unknown(unknown);
    };
    return (0, _initJs.initRange).apply(scale, arguments);
}

},{"d3-array":[["ascending","5oHFB","default"],["quantileSorted","8eCyE"]],"./init.js":"56ApD","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"9XmAJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantize);
var _d3Array = require("d3-array");
var _linearJs = require("./linear.js");
var _initJs = require("./init.js");
function quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, _d3Array.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, _initJs.initRange).apply((0, _linearJs.linearish)(scale), arguments);
}

},{"d3-array":"ktdME","./linear.js":"lNlik","./init.js":"56ApD","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hpdK3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>threshold);
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
function threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, _d3Array.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return threshold().domain(domain).range(range).unknown(unknown);
    };
    return (0, _initJs.initRange).apply(scale, arguments);
}

},{"d3-array":"ktdME","./init.js":"56ApD","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"86824":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calendar", ()=>calendar);
parcelHelpers.export(exports, "default", ()=>time);
var _d3Time = require("d3-time");
var _d3TimeFormat = require("d3-time-format");
var _continuousJs = require("./continuous.js");
var _continuousJsDefault = parcelHelpers.interopDefault(_continuousJs);
var _initJs = require("./init.js");
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
function date(t) {
    return new Date(t);
}
function number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, _continuousJsDefault.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, _niceJsDefault.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function time() {
    return (0, _initJs.initRange).apply(calendar((0, _d3Time.timeTicks), (0, _d3Time.timeTickInterval), (0, _d3Time.timeYear), (0, _d3Time.timeMonth), (0, _d3Time.timeWeek), (0, _d3Time.timeDay), (0, _d3Time.timeHour), (0, _d3Time.timeMinute), (0, _d3Time.timeSecond), (0, _d3TimeFormat.timeFormat)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

},{"d3-time":[["timeDay","70mfq"],["timeHour","4qZO3"],["timeMinute","bqyaU"],["timeMonth","bhkgy"],["timeSecond","XB3bI","second"],["timeTickInterval","ff5J3"],["timeTicks","ff5J3"],["timeWeek","fqawv","timeSunday"],["timeYear","inl21"]],"d3-time-format":"beqDu","./continuous.js":"3XDHY","./init.js":"56ApD","./nice.js":"g0QGc","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dMeBc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>utcTime);
var _d3Time = require("d3-time");
var _d3TimeFormat = require("d3-time-format");
var _timeJs = require("./time.js");
var _initJs = require("./init.js");
function utcTime() {
    return (0, _initJs.initRange).apply((0, _timeJs.calendar)((0, _d3Time.utcTicks), (0, _d3Time.utcTickInterval), (0, _d3Time.utcYear), (0, _d3Time.utcMonth), (0, _d3Time.utcWeek), (0, _d3Time.utcDay), (0, _d3Time.utcHour), (0, _d3Time.utcMinute), (0, _d3Time.utcSecond), (0, _d3TimeFormat.utcFormat)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

},{"d3-time":[["utcDay","70mfq"],["utcHour","4qZO3"],["utcMinute","bqyaU"],["utcMonth","bhkgy"],["utcSecond","XB3bI","second"],["utcTickInterval","ff5J3"],["utcTicks","ff5J3"],["utcWeek","fqawv","utcSunday"],["utcYear","inl21"]],"d3-time-format":"beqDu","./time.js":"86824","./init.js":"56ApD","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"6s5Eb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copy", ()=>copy);
parcelHelpers.export(exports, "default", ()=>sequential);
parcelHelpers.export(exports, "sequentialLog", ()=>sequentialLog);
parcelHelpers.export(exports, "sequentialSymlog", ()=>sequentialSymlog);
parcelHelpers.export(exports, "sequentialPow", ()=>sequentialPow);
parcelHelpers.export(exports, "sequentialSqrt", ()=>sequentialSqrt);
var _d3Interpolate = require("d3-interpolate");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
var _linearJs = require("./linear.js");
var _logJs = require("./log.js");
var _symlogJs = require("./symlog.js");
var _powJs = require("./pow.js");
function transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, _continuousJs.identity), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, _d3Interpolate.interpolate));
    scale.rangeRound = range((0, _d3Interpolate.interpolateRound));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
    var scale = (0, _linearJs.linearish)(transformer()((0, _continuousJs.identity)));
    scale.copy = function() {
        return copy(scale, sequential());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialLog() {
    var scale = (0, _logJs.loggish)(transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return copy(scale, sequentialLog()).base(scale.base());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialSymlog() {
    var scale = (0, _symlogJs.symlogish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialSymlog()).constant(scale.constant());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialPow() {
    var scale = (0, _powJs.powish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialPow()).exponent(scale.exponent());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialSqrt() {
    return sequentialPow.apply(null, arguments).exponent(0.5);
}

},{"d3-interpolate":[["interpolate","bmQNW","default"],["interpolateRound","jOLhU","default"]],"./continuous.js":"3XDHY","./init.js":"56ApD","./linear.js":"lNlik","./log.js":"8MtPs","./symlog.js":"jS0Zq","./pow.js":"cTl9e","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"c09tc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sequentialQuantile);
var _d3Array = require("d3-array");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function sequentialQuantile() {
    var domain = [], interpolator = (0, _continuousJs.identity);
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, _d3Array.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, _d3Array.ascending));
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, _d3Array.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return sequentialQuantile(interpolator).domain(domain);
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}

},{"d3-array":[["ascending","5oHFB","default"],["bisect","8oF0X","default"],["quantile","8eCyE","default"]],"./continuous.js":"3XDHY","./init.js":"56ApD","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"1LwDi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>diverging);
parcelHelpers.export(exports, "divergingLog", ()=>divergingLog);
parcelHelpers.export(exports, "divergingSymlog", ()=>divergingSymlog);
parcelHelpers.export(exports, "divergingPow", ()=>divergingPow);
parcelHelpers.export(exports, "divergingSqrt", ()=>divergingSqrt);
var _d3Interpolate = require("d3-interpolate");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
var _linearJs = require("./linear.js");
var _logJs = require("./log.js");
var _sequentialJs = require("./sequential.js");
var _symlogJs = require("./symlog.js");
var _powJs = require("./pow.js");
function transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = (0, _continuousJs.identity), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, _d3Interpolate.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, _d3Interpolate.interpolate));
    scale.rangeRound = range((0, _d3Interpolate.interpolateRound));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function diverging() {
    var scale = (0, _linearJs.linearish)(transformer()((0, _continuousJs.identity)));
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, diverging());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingLog() {
    var scale = (0, _logJs.loggish)(transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, divergingLog()).base(scale.base());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingSymlog() {
    var scale = (0, _symlogJs.symlogish)(transformer());
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, divergingSymlog()).constant(scale.constant());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingPow() {
    var scale = (0, _powJs.powish)(transformer());
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, divergingPow()).exponent(scale.exponent());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingSqrt() {
    return divergingPow.apply(null, arguments).exponent(0.5);
}

},{"d3-interpolate":[["interpolate","bmQNW","default"],["interpolateRound","jOLhU","default"],["piecewise","2lIrJ","default"]],"./continuous.js":"3XDHY","./init.js":"56ApD","./linear.js":"lNlik","./log.js":"8MtPs","./sequential.js":"6s5Eb","./symlog.js":"jS0Zq","./pow.js":"cTl9e","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"2lIrJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>piecewise);
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
function piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = (0, _valueJsDefault.default);
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

},{"./value.js":"bmQNW","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"ayVHH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolate", ()=>(0, _valueJsDefault.default));
parcelHelpers.export(exports, "interpolateArray", ()=>(0, _arrayJsDefault.default));
parcelHelpers.export(exports, "interpolateBasis", ()=>(0, _basisJsDefault.default));
parcelHelpers.export(exports, "interpolateBasisClosed", ()=>(0, _basisClosedJsDefault.default));
parcelHelpers.export(exports, "interpolateDate", ()=>(0, _dateJsDefault.default));
parcelHelpers.export(exports, "interpolateDiscrete", ()=>(0, _discreteJsDefault.default));
parcelHelpers.export(exports, "interpolateHue", ()=>(0, _hueJsDefault.default));
parcelHelpers.export(exports, "interpolateNumber", ()=>(0, _numberJsDefault.default));
parcelHelpers.export(exports, "interpolateNumberArray", ()=>(0, _numberArrayJsDefault.default));
parcelHelpers.export(exports, "interpolateObject", ()=>(0, _objectJsDefault.default));
parcelHelpers.export(exports, "interpolateRound", ()=>(0, _roundJsDefault.default));
parcelHelpers.export(exports, "interpolateString", ()=>(0, _stringJsDefault.default));
parcelHelpers.export(exports, "interpolateTransformCss", ()=>(0, _indexJs.interpolateTransformCss));
parcelHelpers.export(exports, "interpolateTransformSvg", ()=>(0, _indexJs.interpolateTransformSvg));
parcelHelpers.export(exports, "interpolateZoom", ()=>(0, _zoomJsDefault.default));
parcelHelpers.export(exports, "interpolateRgb", ()=>(0, _rgbJsDefault.default));
parcelHelpers.export(exports, "interpolateRgbBasis", ()=>(0, _rgbJs.rgbBasis));
parcelHelpers.export(exports, "interpolateRgbBasisClosed", ()=>(0, _rgbJs.rgbBasisClosed));
parcelHelpers.export(exports, "interpolateHsl", ()=>(0, _hslJsDefault.default));
parcelHelpers.export(exports, "interpolateHslLong", ()=>(0, _hslJs.hslLong));
parcelHelpers.export(exports, "interpolateLab", ()=>(0, _labJsDefault.default));
parcelHelpers.export(exports, "interpolateHcl", ()=>(0, _hclJsDefault.default));
parcelHelpers.export(exports, "interpolateHclLong", ()=>(0, _hclJs.hclLong));
parcelHelpers.export(exports, "interpolateCubehelix", ()=>(0, _cubehelixJsDefault.default));
parcelHelpers.export(exports, "interpolateCubehelixLong", ()=>(0, _cubehelixJs.cubehelixLong));
parcelHelpers.export(exports, "piecewise", ()=>(0, _piecewiseJsDefault.default));
parcelHelpers.export(exports, "quantize", ()=>(0, _quantizeJsDefault.default));
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _discreteJs = require("./discrete.js");
var _discreteJsDefault = parcelHelpers.interopDefault(_discreteJs);
var _hueJs = require("./hue.js");
var _hueJsDefault = parcelHelpers.interopDefault(_hueJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _roundJs = require("./round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _indexJs = require("./transform/index.js");
var _zoomJs = require("./zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _hslJs = require("./hsl.js");
var _hslJsDefault = parcelHelpers.interopDefault(_hslJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _hclJs = require("./hcl.js");
var _hclJsDefault = parcelHelpers.interopDefault(_hclJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);
var _piecewiseJs = require("./piecewise.js");
var _piecewiseJsDefault = parcelHelpers.interopDefault(_piecewiseJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);

},{"./value.js":"bmQNW","./array.js":"axXnp","./basis.js":"1Lui0","./basisClosed.js":"6eE79","./date.js":"2Aey1","./discrete.js":"kY4zb","./hue.js":"3HpAJ","./number.js":"1WfY8","./numberArray.js":"ldKqJ","./object.js":"hZiJR","./round.js":"jOLhU","./string.js":"fRinS","./transform/index.js":"AaAOm","./zoom.js":"adb4H","./rgb.js":"8JklF","./hsl.js":"25fGO","./lab.js":"de8M0","./hcl.js":"cHyEC","./cubehelix.js":"kfWIE","./piecewise.js":"2lIrJ","./quantize.js":"cYceK","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"kY4zb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(range) {
        var n = range.length;
        return function(t) {
            return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3HpAJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var i = (0, _colorJs.hue)(+a, +b);
        return function(t) {
            var x = i(t);
            return x - 360 * Math.floor(x / 360);
        };
    });
var _colorJs = require("./color.js");

},{"./color.js":"5P5bR","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"AaAOm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolateTransformCss", ()=>interpolateTransformCss);
parcelHelpers.export(exports, "interpolateTransformSvg", ()=>interpolateTransformSvg);
var _numberJs = require("../number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _parseJs = require("./parse.js");
function interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, _numberJsDefault.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _numberJsDefault.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, _numberJsDefault.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, _numberJsDefault.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, _numberJsDefault.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _numberJsDefault.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var interpolateTransformCss = interpolateTransform((0, _parseJs.parseCss), "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform((0, _parseJs.parseSvg), ", ", ")", ")");

},{"../number.js":"1WfY8","./parse.js":"7VyRL","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"7VyRL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* eslint-disable no-undef */ parcelHelpers.export(exports, "parseCss", ()=>parseCss);
parcelHelpers.export(exports, "parseSvg", ()=>parseSvg);
var _decomposeJs = require("./decompose.js");
var _decomposeJsDefault = parcelHelpers.interopDefault(_decomposeJs);
var svgNode;
function parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, _decomposeJs.identity) : (0, _decomposeJsDefault.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function parseSvg(value) {
    if (value == null) return 0, _decomposeJs.identity;
    if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgNode.setAttribute("transform", value);
    if (!(value = svgNode.transform.baseVal.consolidate())) return 0, _decomposeJs.identity;
    value = value.matrix;
    return (0, _decomposeJsDefault.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

},{"./decompose.js":"9thPU","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"9thPU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "default", ()=>function(a, b, c, d, e, f) {
        var scaleX, scaleY, skewX;
        if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
        if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
        if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
        if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
        return {
            translateX: e,
            translateY: f,
            rotate: Math.atan2(b, a) * degrees,
            skewX: Math.atan(skewX) * degrees,
            scaleX: scaleX,
            scaleY: scaleY
        };
    });
var degrees = 180 / Math.PI;
var identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"adb4H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var epsilon2 = 1e-12;
function cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
exports.default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"25fGO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hslLong", ()=>hslLong);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _d3Color.hsl)(start)).h, (end = (0, _d3Color.hsl)(end)).h), s = (0, _colorJsDefault.default)(start.s, end.s), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
exports.default = hsl((0, _colorJs.hue));
var hslLong = hsl((0, _colorJsDefault.default));

},{"d3-color":"gqOvl","./color.js":"5P5bR","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"de8M0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>lab);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function lab(start, end) {
    var l = (0, _colorJsDefault.default)((start = (0, _d3Color.lab)(start)).l, (end = (0, _d3Color.lab)(end)).l), a = (0, _colorJsDefault.default)(start.a, end.a), b = (0, _colorJsDefault.default)(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

},{"d3-color":[["lab","h1jo5","default"]],"./color.js":"5P5bR","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"h1jo5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gray", ()=>gray);
parcelHelpers.export(exports, "default", ()=>lab);
parcelHelpers.export(exports, "Lab", ()=>Lab);
parcelHelpers.export(exports, "lch", ()=>lch);
parcelHelpers.export(exports, "hcl", ()=>hcl);
parcelHelpers.export(exports, "Hcl", ()=>Hcl);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
var _colorJs = require("./color.js");
var _mathJs = require("./math.js");
// https://observablehq.com/@mbostock/lab-and-rgb
const K = 18, Xn = 0.96422, Yn = 1, Zn = 0.82521, t0 = 4 / 29, t1 = 6 / 29, t2 = 3 * t1 * t1, t3 = t1 * t1 * t1;
function labConvert(o) {
    if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof Hcl) return hcl2lab(o);
    if (!(o instanceof (0, _colorJs.Rgb))) o = (0, _colorJs.rgbConvert)(o);
    var r = rgb2lrgb(o.r), g = rgb2lrgb(o.g), b = rgb2lrgb(o.b), y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
        z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
    }
    return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function gray(l, opacity) {
    return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function lab(l, a, b, opacity) {
    return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}
function Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Lab, lab, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter (k) {
        return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = Xn * lab2xyz(x);
        y = Yn * lab2xyz(y);
        z = Zn * lab2xyz(z);
        return new (0, _colorJs.Rgb)(lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function xyz2lab(t) {
    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}
function lab2xyz(t) {
    return t > t1 ? t * t * t : t2 * (t - t0);
}
function lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function hclConvert(o) {
    if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof Lab)) o = labConvert(o);
    if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, _mathJs.degrees);
    return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function lch(l, c, h, opacity) {
    return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function hcl(h, c, l, opacity) {
    return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function hcl2lab(o) {
    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
    var h = o.h * (0, _mathJs.radians);
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, _defineJsDefault.default)(Hcl, hcl, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter (k) {
        return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return hcl2lab(this).rgb();
    }
}));

},{"./define.js":"cOd61","./color.js":"gqOvl","./math.js":"36qMz","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"36qMz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "radians", ()=>radians);
parcelHelpers.export(exports, "degrees", ()=>degrees);
const radians = Math.PI / 180;
const degrees = 180 / Math.PI;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cHyEC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hclLong", ()=>hclLong);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _d3Color.hcl)(start)).h, (end = (0, _d3Color.hcl)(end)).h), c = (0, _colorJsDefault.default)(start.c, end.c), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
exports.default = hcl((0, _colorJs.hue));
var hclLong = hcl((0, _colorJsDefault.default));

},{"d3-color":"h1jo5","./color.js":"5P5bR","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"kfWIE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubehelixLong", ()=>cubehelixLong);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, _d3Color.cubehelix)(start)).h, (end = (0, _d3Color.cubehelix)(end)).h), s = (0, _colorJsDefault.default)(start.s, end.s), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
exports.default = cubehelix((0, _colorJs.hue));
var cubehelixLong = cubehelix((0, _colorJsDefault.default));

},{"d3-color":[["cubehelix","3xz1u","default"]],"./color.js":"5P5bR","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3xz1u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cubehelix);
parcelHelpers.export(exports, "Cubehelix", ()=>Cubehelix);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
var _colorJs = require("./color.js");
var _mathJs = require("./math.js");
var A = -0.14861, B = 1.78277, C = -0.29227, D = -0.90649, E = 1.97294, ED = E * D, EB = E * B, BC_DA = B * C - D * A;
function cubehelixConvert(o) {
    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, _colorJs.Rgb))) o = (0, _colorJs.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, _mathJs.degrees) - 120 : NaN;
    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Cubehelix, cubehelix, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter (k) {
        k = k == null ? (0, _colorJs.brighter) : Math.pow((0, _colorJs.brighter), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? (0, _colorJs.darker) : Math.pow((0, _colorJs.darker), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, _mathJs.radians), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, _colorJs.Rgb)(255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
    }
}));

},{"./define.js":"cOd61","./color.js":"gqOvl","./math.js":"36qMz","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cYceK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(interpolator, n) {
        var samples = new Array(n);
        for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
        return samples;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"fulOB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");

},{"../colors.js":"hyQ1Q","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hyQ1Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(specifier) {
        var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
        while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
        return colors;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"fSaTK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

},{"../colors.js":"hyQ1Q","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"gLzPP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");

},{"../colors.js":"hyQ1Q","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"fMku7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("4269d0efb118ff725c6cc5b03ca951ff8ab7a463f297bbf59c6b4e9498a0");

},{"../colors.js":"hyQ1Q","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3MZIk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");

},{"../colors.js":"hyQ1Q","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hWPoY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");

},{"../colors.js":"hyQ1Q","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hItV9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");

},{"../colors.js":"hyQ1Q","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"fAveY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");

},{"../colors.js":"hyQ1Q","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8JyVy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");

},{"../colors.js":"hyQ1Q","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"jDkWD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");

},{"../colors.js":"hyQ1Q","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"c2Nqb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "axisticks", ()=>AxisTicks);
parcelHelpers.export(exports, "datajoin", ()=>DataJoin);
parcelHelpers.export(exports, "encode", ()=>Encode);
parcelHelpers.export(exports, "legendentries", ()=>LegendEntries);
parcelHelpers.export(exports, "linkpath", ()=>LinkPath);
parcelHelpers.export(exports, "pie", ()=>Pie);
parcelHelpers.export(exports, "scale", ()=>Scale);
parcelHelpers.export(exports, "sortitems", ()=>SortItems);
parcelHelpers.export(exports, "stack", ()=>Stack);
var _vegaDataflow = require("vega-dataflow");
var _vegaScale = require("vega-scale");
var _vegaUtil = require("vega-util");
var _d3Array = require("d3-array");
var _d3Interpolate = require("d3-interpolate");
/**
 * Generates axis ticks for visualizing a spatial scale.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Scale} params.scale - The scale to generate ticks for.
 * @param {*} [params.count=10] - The approximate number of ticks, or
 *   desired tick interval, to use.
 * @param {Array<*>} [params.values] - The exact tick values to use.
 *   These must be legal domain values for the provided scale.
 *   If provided, the count argument is ignored.
 * @param {function(*):string} [params.formatSpecifier] - A format specifier
 *   to use in conjunction with scale.tickFormat. Legal values are
 *   any valid d3 4.0 format specifier.
 * @param {function(*):string} [params.format] - The format function to use.
 *   If provided, the formatSpecifier argument is ignored.
 */ function AxisTicks(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
(0, _vegaUtil.inherits)(AxisTicks, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (this.value && !_.modified()) return pulse.StopPropagation;
        var locale = pulse.dataflow.locale(), out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS), ticks = this.value, scale = _.scale, tally = _.count == null ? _.values ? _.values.length : 10 : _.count, count = (0, _vegaScale.tickCount)(scale, tally, _.minstep), format = _.format || (0, _vegaScale.tickFormat)(locale, scale, count, _.formatSpecifier, _.formatType, !!_.values), values = _.values ? (0, _vegaScale.validTicks)(scale, _.values, count) : (0, _vegaScale.tickValues)(scale, count);
        if (ticks) out.rem = ticks;
        ticks = values.map((value, i)=>(0, _vegaDataflow.ingest)({
                index: i / (values.length - 1 || 1),
                value: value,
                label: format(value)
            }));
        if (_.extra && ticks.length) // add an extra tick pegged to the initial domain value
        // this is used to generate axes with 'binned' domains
        ticks.push((0, _vegaDataflow.ingest)({
            index: -1,
            extra: {
                value: ticks[0].value
            },
            label: ''
        }));
        out.source = ticks;
        out.add = ticks;
        this.value = ticks;
        return out;
    }
});
/**
 * Joins a set of data elements against a set of visual items.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): object} [params.item] - An item generator function.
 * @param {function(object): *} [params.key] - The key field associating data and visual items.
 */ function DataJoin(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
function defaultItemCreate() {
    return (0, _vegaDataflow.ingest)({});
}
function newMap(key) {
    const map = (0, _vegaUtil.fastmap)().test((t)=>t.exit);
    map.lookup = (t)=>map.get(key(t));
    return map;
}
(0, _vegaUtil.inherits)(DataJoin, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var df = pulse.dataflow, out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS), item = _.item || defaultItemCreate, key = _.key || (0, _vegaDataflow.tupleid), map = this.value;
        // prevent transient (e.g., hover) requests from
        // cascading across marks derived from marks
        if ((0, _vegaUtil.isArray)(out.encode)) out.encode = null;
        if (map && (_.modified('key') || pulse.modified(key))) (0, _vegaUtil.error)('DataJoin does not support modified key function or fields.');
        if (!map) {
            pulse = pulse.addAll();
            this.value = map = newMap(key);
        }
        pulse.visit(pulse.ADD, (t)=>{
            const k = key(t);
            let x = map.get(k);
            if (x) {
                if (x.exit) {
                    map.empty--;
                    out.add.push(x);
                } else out.mod.push(x);
            } else {
                x = item(t);
                map.set(k, x);
                out.add.push(x);
            }
            x.datum = t;
            x.exit = false;
        });
        pulse.visit(pulse.MOD, (t)=>{
            const k = key(t), x = map.get(k);
            if (x) {
                x.datum = t;
                out.mod.push(x);
            }
        });
        pulse.visit(pulse.REM, (t)=>{
            const k = key(t), x = map.get(k);
            if (t === x.datum && !x.exit) {
                out.rem.push(x);
                x.exit = true;
                ++map.empty;
            }
        });
        if (pulse.changed(pulse.ADD_MOD)) out.modifies('datum');
        if (pulse.clean() || _.clean && map.empty > df.cleanThreshold) df.runAfter(map.clean);
        return out;
    }
});
/**
 * Invokes encoding functions for visual items.
 * @constructor
 * @param {object} params - The parameters to the encoding functions. This
 *   parameter object will be passed through to all invoked encoding functions.
 * @param {object} [params.mod=false] - Flag indicating if tuples in the input
 *   mod set that are unmodified by encoders should be included in the output.
 * @param {object} param.encoders - The encoding functions
 * @param {function(object, object): boolean} [param.encoders.update] - Update encoding set
 * @param {function(object, object): boolean} [param.encoders.enter] - Enter encoding set
 * @param {function(object, object): boolean} [param.encoders.exit] - Exit encoding set
 */ function Encode(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
(0, _vegaUtil.inherits)(Encode, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var out = pulse.fork(pulse.ADD_REM), fmod = _.mod || false, encoders = _.encoders, encode = pulse.encode;
        // if an array, the encode directive includes additional sets
        // that must be defined in order for the primary set to be invoked
        // e.g., only run the update set if the hover set is defined
        if ((0, _vegaUtil.isArray)(encode)) {
            if (out.changed() || encode.every((e)=>encoders[e])) {
                encode = encode[0];
                out.encode = null; // consume targeted encode directive
            } else return pulse.StopPropagation;
        }
        // marshall encoder functions
        var reenter = encode === 'enter', update = encoders.update || (0, _vegaUtil.falsy), enter = encoders.enter || (0, _vegaUtil.falsy), exit = encoders.exit || (0, _vegaUtil.falsy), set = (encode && !reenter ? encoders[encode] : update) || (0, _vegaUtil.falsy);
        if (pulse.changed(pulse.ADD)) {
            pulse.visit(pulse.ADD, (t)=>{
                enter(t, _);
                update(t, _);
            });
            out.modifies(enter.output);
            out.modifies(update.output);
            if (set !== (0, _vegaUtil.falsy) && set !== update) {
                pulse.visit(pulse.ADD, (t)=>{
                    set(t, _);
                });
                out.modifies(set.output);
            }
        }
        if (pulse.changed(pulse.REM) && exit !== (0, _vegaUtil.falsy)) {
            pulse.visit(pulse.REM, (t)=>{
                exit(t, _);
            });
            out.modifies(exit.output);
        }
        if (reenter || set !== (0, _vegaUtil.falsy)) {
            const flag = pulse.MOD | (_.modified() ? pulse.REFLOW : 0);
            if (reenter) {
                pulse.visit(flag, (t)=>{
                    const mod = enter(t, _) || fmod;
                    if (set(t, _) || mod) out.mod.push(t);
                });
                if (out.mod.length) out.modifies(enter.output);
            } else pulse.visit(flag, (t)=>{
                if (set(t, _) || fmod) out.mod.push(t);
            });
            if (out.mod.length) out.modifies(set.output);
        }
        return out.changed() ? out : pulse.StopPropagation;
    }
});
/**
 * Generates legend entries for visualizing a scale.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Scale} params.scale - The scale to generate items for.
 * @param {*} [params.count=5] - The approximate number of items, or
 *   desired tick interval, to use.
 * @param {*} [params.limit] - The maximum number of entries to
 *   include in a symbol legend.
 * @param {Array<*>} [params.values] - The exact tick values to use.
 *   These must be legal domain values for the provided scale.
 *   If provided, the count argument is ignored.
 * @param {string} [params.formatSpecifier] - A format specifier
 *   to use in conjunction with scale.tickFormat. Legal values are
 *   any valid D3 format specifier string.
 * @param {function(*):string} [params.format] - The format function to use.
 *   If provided, the formatSpecifier argument is ignored.
 */ function LegendEntries(params) {
    (0, _vegaDataflow.Transform).call(this, [], params);
}
(0, _vegaUtil.inherits)(LegendEntries, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (this.value != null && !_.modified()) return pulse.StopPropagation;
        var locale = pulse.dataflow.locale(), out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS), items = this.value, type = _.type || (0, _vegaScale.SymbolLegend), scale = _.scale, limit = +_.limit, count = (0, _vegaScale.tickCount)(scale, _.count == null ? 5 : _.count, _.minstep), lskip = !!_.values || type === (0, _vegaScale.SymbolLegend), format = _.format || (0, _vegaScale.labelFormat)(locale, scale, count, type, _.formatSpecifier, _.formatType, lskip), values = _.values || (0, _vegaScale.labelValues)(scale, count), domain, fraction, size, offset, ellipsis;
        if (items) out.rem = items;
        if (type === (0, _vegaScale.SymbolLegend)) {
            if (limit && values.length > limit) {
                pulse.dataflow.warn('Symbol legend count exceeds limit, filtering items.');
                items = values.slice(0, limit - 1);
                ellipsis = true;
            } else items = values;
            if ((0, _vegaUtil.isFunction)(size = _.size)) {
                // if first value maps to size zero, remove from list (vega#717)
                if (!_.values && scale(items[0]) === 0) items = items.slice(1);
                // compute size offset for legend entries
                offset = items.reduce((max, value)=>Math.max(max, size(value, _)), 0);
            } else size = (0, _vegaUtil.constant)(offset = size || 8);
            items = items.map((value, index)=>(0, _vegaDataflow.ingest)({
                    index: index,
                    label: format(value, index, items),
                    value: value,
                    offset: offset,
                    size: size(value, _)
                }));
            if (ellipsis) {
                ellipsis = values[items.length];
                items.push((0, _vegaDataflow.ingest)({
                    index: items.length,
                    label: `\u2026${values.length - items.length} entries`,
                    value: ellipsis,
                    offset: offset,
                    size: size(ellipsis, _)
                }));
            }
        } else if (type === (0, _vegaScale.GradientLegend)) {
            domain = scale.domain(), fraction = (0, _vegaScale.scaleFraction)(scale, domain[0], (0, _vegaUtil.peek)(domain));
            // if automatic label generation produces 2 or fewer values,
            // use the domain end points instead (fixes vega/vega#1364)
            if (values.length < 3 && !_.values && domain[0] !== (0, _vegaUtil.peek)(domain)) values = [
                domain[0],
                (0, _vegaUtil.peek)(domain)
            ];
            items = values.map((value, index)=>(0, _vegaDataflow.ingest)({
                    index: index,
                    label: format(value, index, values),
                    value: value,
                    perc: fraction(value)
                }));
        } else {
            size = values.length - 1;
            fraction = (0, _vegaScale.labelFraction)(scale);
            items = values.map((value, index)=>(0, _vegaDataflow.ingest)({
                    index: index,
                    label: format(value, index, values),
                    value: value,
                    perc: index ? fraction(value) : 0,
                    perc2: index === size ? 1 : fraction(values[index + 1])
                }));
        }
        out.source = items;
        out.add = items;
        this.value = items;
        return out;
    }
});
const sourceX = (t)=>t.source.x;
const sourceY = (t)=>t.source.y;
const targetX = (t)=>t.target.x;
const targetY = (t)=>t.target.y;
/**
 * Layout paths linking source and target elements.
 * @constructor
 * @param {object} params - The parameters for this operator.
 */ function LinkPath(params) {
    (0, _vegaDataflow.Transform).call(this, {}, params);
}
LinkPath.Definition = {
    'type': 'LinkPath',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'sourceX',
            'type': 'field',
            'default': 'source.x'
        },
        {
            'name': 'sourceY',
            'type': 'field',
            'default': 'source.y'
        },
        {
            'name': 'targetX',
            'type': 'field',
            'default': 'target.x'
        },
        {
            'name': 'targetY',
            'type': 'field',
            'default': 'target.y'
        },
        {
            'name': 'orient',
            'type': 'enum',
            'default': 'vertical',
            'values': [
                'horizontal',
                'vertical',
                'radial'
            ]
        },
        {
            'name': 'shape',
            'type': 'enum',
            'default': 'line',
            'values': [
                'line',
                'arc',
                'curve',
                'diagonal',
                'orthogonal'
            ]
        },
        {
            'name': 'require',
            'type': 'signal'
        },
        {
            'name': 'as',
            'type': 'string',
            'default': 'path'
        }
    ]
};
(0, _vegaUtil.inherits)(LinkPath, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var sx = _.sourceX || sourceX, sy = _.sourceY || sourceY, tx = _.targetX || targetX, ty = _.targetY || targetY, as = _.as || 'path', orient = _.orient || 'vertical', shape = _.shape || 'line', path = Paths.get(shape + '-' + orient) || Paths.get(shape);
        if (!path) (0, _vegaUtil.error)('LinkPath unsupported type: ' + _.shape + (_.orient ? '-' + _.orient : ''));
        pulse.visit(pulse.SOURCE, (t)=>{
            t[as] = path(sx(t), sy(t), tx(t), ty(t));
        });
        return pulse.reflow(_.modified()).modifies(as);
    }
});
const line = (sx, sy, tx, ty)=>'M' + sx + ',' + sy + 'L' + tx + ',' + ty;
const lineR = (sa, sr, ta, tr)=>line(sr * Math.cos(sa), sr * Math.sin(sa), tr * Math.cos(ta), tr * Math.sin(ta));
const arc = (sx, sy, tx, ty)=>{
    var dx = tx - sx, dy = ty - sy, rr = Math.hypot(dx, dy) / 2, ra = 180 * Math.atan2(dy, dx) / Math.PI;
    return 'M' + sx + ',' + sy + 'A' + rr + ',' + rr + ' ' + ra + ' 0 1' + ' ' + tx + ',' + ty;
};
const arcR = (sa, sr, ta, tr)=>arc(sr * Math.cos(sa), sr * Math.sin(sa), tr * Math.cos(ta), tr * Math.sin(ta));
const curve = (sx, sy, tx, ty)=>{
    const dx = tx - sx, dy = ty - sy, ix = 0.2 * (dx + dy), iy = 0.2 * (dy - dx);
    return 'M' + sx + ',' + sy + 'C' + (sx + ix) + ',' + (sy + iy) + ' ' + (tx + iy) + ',' + (ty - ix) + ' ' + tx + ',' + ty;
};
const curveR = (sa, sr, ta, tr)=>curve(sr * Math.cos(sa), sr * Math.sin(sa), tr * Math.cos(ta), tr * Math.sin(ta));
const orthoX = (sx, sy, tx, ty)=>'M' + sx + ',' + sy + 'V' + ty + 'H' + tx;
const orthoY = (sx, sy, tx, ty)=>'M' + sx + ',' + sy + 'H' + tx + 'V' + ty;
const orthoR = (sa, sr, ta, tr)=>{
    const sc = Math.cos(sa), ss = Math.sin(sa), tc = Math.cos(ta), ts = Math.sin(ta), sf = Math.abs(ta - sa) > Math.PI ? ta <= sa : ta > sa;
    return 'M' + sr * sc + ',' + sr * ss + 'A' + sr + ',' + sr + ' 0 0,' + (sf ? 1 : 0) + ' ' + sr * tc + ',' + sr * ts + 'L' + tr * tc + ',' + tr * ts;
};
const diagonalX = (sx, sy, tx, ty)=>{
    const m = (sx + tx) / 2;
    return 'M' + sx + ',' + sy + 'C' + m + ',' + sy + ' ' + m + ',' + ty + ' ' + tx + ',' + ty;
};
const diagonalY = (sx, sy, tx, ty)=>{
    const m = (sy + ty) / 2;
    return 'M' + sx + ',' + sy + 'C' + sx + ',' + m + ' ' + tx + ',' + m + ' ' + tx + ',' + ty;
};
const diagonalR = (sa, sr, ta, tr)=>{
    const sc = Math.cos(sa), ss = Math.sin(sa), tc = Math.cos(ta), ts = Math.sin(ta), mr = (sr + tr) / 2;
    return 'M' + sr * sc + ',' + sr * ss + 'C' + mr * sc + ',' + mr * ss + ' ' + mr * tc + ',' + mr * ts + ' ' + tr * tc + ',' + tr * ts;
};
const Paths = (0, _vegaUtil.fastmap)({
    'line': line,
    'line-radial': lineR,
    'arc': arc,
    'arc-radial': arcR,
    'curve': curve,
    'curve-radial': curveR,
    'orthogonal-horizontal': orthoX,
    'orthogonal-vertical': orthoY,
    'orthogonal-radial': orthoR,
    'diagonal-horizontal': diagonalX,
    'diagonal-vertical': diagonalY,
    'diagonal-radial': diagonalR
});
/**
 * Pie and donut chart layout.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The value field to size pie segments.
 * @param {number} [params.startAngle=0] - The start angle (in radians) of the layout.
 * @param {number} [params.endAngle=2π] - The end angle (in radians) of the layout.
 * @param {boolean} [params.sort] - Boolean flag for sorting sectors by value.
 */ function Pie(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Pie.Definition = {
    'type': 'Pie',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field'
        },
        {
            'name': 'startAngle',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'endAngle',
            'type': 'number',
            'default': 6.283185307179586
        },
        {
            'name': 'sort',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': 2,
            'default': [
                'startAngle',
                'endAngle'
            ]
        }
    ]
};
(0, _vegaUtil.inherits)(Pie, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var as = _.as || [
            'startAngle',
            'endAngle'
        ], startAngle = as[0], endAngle = as[1], field = _.field || (0, _vegaUtil.one), start = _.startAngle || 0, stop = _.endAngle != null ? _.endAngle : 2 * Math.PI, data = pulse.source, values = data.map(field), n = values.length, a = start, k = (stop - start) / (0, _d3Array.sum)(values), index = (0, _d3Array.range)(n), i, t, v;
        if (_.sort) index.sort((a, b)=>values[a] - values[b]);
        for(i = 0; i < n; ++i){
            v = values[index[i]];
            t = data[index[i]];
            t[startAngle] = a;
            t[endAngle] = a += v * k;
        }
        this.value = values;
        return pulse.reflow(_.modified()).modifies(as);
    }
});
const DEFAULT_COUNT = 5;
function includeZero(scale) {
    const type = scale.type;
    return !scale.bins && (type === (0, _vegaScale.Linear) || type === (0, _vegaScale.Pow) || type === (0, _vegaScale.Sqrt));
}
function includePad(type) {
    return (0, _vegaScale.isContinuous)(type) && type !== (0, _vegaScale.Sequential);
}
const SKIP = (0, _vegaUtil.toSet)([
    'set',
    'modified',
    'clear',
    'type',
    'scheme',
    'schemeExtent',
    'schemeCount',
    'domain',
    'domainMin',
    'domainMid',
    'domainMax',
    'domainRaw',
    'domainImplicit',
    'nice',
    'zero',
    'bins',
    'range',
    'rangeStep',
    'round',
    'reverse',
    'interpolate',
    'interpolateGamma'
]);
/**
 * Maintains a scale function mapping data values to visual channels.
 * @constructor
 * @param {object} params - The parameters for this operator.
 */ function Scale(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
    this.modified(true); // always treat as modified
}
(0, _vegaUtil.inherits)(Scale, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var df = pulse.dataflow, scale$1 = this.value, key = scaleKey(_);
        if (!scale$1 || key !== scale$1.type) this.value = scale$1 = (0, _vegaScale.scale)(key)();
        for(key in _)if (!SKIP[key]) {
            // padding is a scale property for band/point but not others
            if (key === 'padding' && includePad(scale$1.type)) continue;
            // invoke scale property setter, raise warning if not found
            (0, _vegaUtil.isFunction)(scale$1[key]) ? scale$1[key](_[key]) : df.warn('Unsupported scale property: ' + key);
        }
        configureRange(scale$1, _, configureBins(scale$1, _, configureDomain(scale$1, _, df)));
        return pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
    }
});
function scaleKey(_) {
    var t = _.type, d = '', n;
    // backwards compatibility pre Vega 5.
    if (t === (0, _vegaScale.Sequential)) return (0, _vegaScale.Sequential) + '-' + (0, _vegaScale.Linear);
    if (isContinuousColor(_)) {
        n = _.rawDomain ? _.rawDomain.length : _.domain ? _.domain.length + +(_.domainMid != null) : 0;
        d = n === 2 ? (0, _vegaScale.Sequential) + '-' : n === 3 ? (0, _vegaScale.Diverging) + '-' : '';
    }
    return (d + t || (0, _vegaScale.Linear)).toLowerCase();
}
function isContinuousColor(_) {
    const t = _.type;
    return (0, _vegaScale.isContinuous)(t) && t !== (0, _vegaScale.Time) && t !== (0, _vegaScale.UTC) && (_.scheme || _.range && _.range.length && _.range.every((0, _vegaUtil.isString)));
}
function configureDomain(scale, _, df) {
    // check raw domain, if provided use that and exit early
    const raw = rawDomain(scale, _.domainRaw, df);
    if (raw > -1) return raw;
    var domain = _.domain, type = scale.type, zero = _.zero || _.zero === undefined && includeZero(scale), n, mid;
    if (!domain) return 0;
    // adjust domain based on zero, min, max settings
    if (zero || _.domainMin != null || _.domainMax != null || _.domainMid != null) {
        n = (domain = domain.slice()).length - 1 || 1;
        if (zero) {
            if (domain[0] > 0) domain[0] = 0;
            if (domain[n] < 0) domain[n] = 0;
        }
        if (_.domainMin != null) domain[0] = _.domainMin;
        if (_.domainMax != null) domain[n] = _.domainMax;
        if (_.domainMid != null) {
            mid = _.domainMid;
            const i = mid > domain[n] ? n + 1 : mid < domain[0] ? 0 : n;
            if (i !== n) df.warn('Scale domainMid exceeds domain min or max.', mid);
            domain.splice(i, 0, mid);
        }
    }
    // adjust continuous domain for minimum pixel padding
    if (includePad(type) && _.padding && domain[0] !== (0, _vegaUtil.peek)(domain)) domain = padDomain(type, domain, _.range, _.padding, _.exponent, _.constant);
    // set the scale domain
    scale.domain(domainCheck(type, domain, df));
    // if ordinal scale domain is defined, prevent implicit
    // domain construction as side-effect of scale lookup
    if (type === (0, _vegaScale.Ordinal)) scale.unknown(_.domainImplicit ? (0, _vegaScale.scaleImplicit) : undefined);
    // perform 'nice' adjustment as requested
    if (_.nice && scale.nice) scale.nice(_.nice !== true && (0, _vegaScale.tickCount)(scale, _.nice) || null);
    // return the cardinality of the domain
    return domain.length;
}
function rawDomain(scale, raw, df) {
    if (raw) {
        scale.domain(domainCheck(scale.type, raw, df));
        return raw.length;
    } else return -1;
}
function padDomain(type, domain, range, pad, exponent, constant) {
    var span = Math.abs((0, _vegaUtil.peek)(range) - range[0]), frac = span / (span - 2 * pad), d = type === (0, _vegaScale.Log) ? (0, _vegaUtil.zoomLog)(domain, null, frac) : type === (0, _vegaScale.Sqrt) ? (0, _vegaUtil.zoomPow)(domain, null, frac, 0.5) : type === (0, _vegaScale.Pow) ? (0, _vegaUtil.zoomPow)(domain, null, frac, exponent || 1) : type === (0, _vegaScale.Symlog) ? (0, _vegaUtil.zoomSymlog)(domain, null, frac, constant || 1) : (0, _vegaUtil.zoomLinear)(domain, null, frac);
    domain = domain.slice();
    domain[0] = d[0];
    domain[domain.length - 1] = d[1];
    return domain;
}
function domainCheck(type, domain, df) {
    if ((0, _vegaScale.isLogarithmic)(type)) {
        // sum signs of domain values
        // if all pos or all neg, abs(sum) === domain.length
        var s = Math.abs(domain.reduce((s, v)=>s + (v < 0 ? -1 : v > 0 ? 1 : 0), 0));
        if (s !== domain.length) df.warn('Log scale domain includes zero: ' + (0, _vegaUtil.stringValue)(domain));
    }
    return domain;
}
function configureBins(scale, _, count) {
    let bins = _.bins;
    if (bins && !(0, _vegaUtil.isArray)(bins)) {
        // generate bin boundary array
        const domain = scale.domain(), lo = domain[0], hi = (0, _vegaUtil.peek)(domain), step = bins.step;
        let start = bins.start == null ? lo : bins.start, stop = bins.stop == null ? hi : bins.stop;
        if (!step) (0, _vegaUtil.error)('Scale bins parameter missing step property.');
        if (start < lo) start = step * Math.ceil(lo / step);
        if (stop > hi) stop = step * Math.floor(hi / step);
        bins = (0, _d3Array.range)(start, stop + step / 2, step);
    }
    if (bins) // assign bin boundaries to scale instance
    scale.bins = bins;
    else if (scale.bins) // no current bins, remove bins if previously set
    delete scale.bins;
    // special handling for bin-ordinal scales
    if (scale.type === (0, _vegaScale.BinOrdinal)) {
        if (!bins) // the domain specifies the bins
        scale.bins = scale.domain();
        else if (!_.domain && !_.domainRaw) {
            // the bins specify the domain
            scale.domain(bins);
            count = bins.length;
        }
    }
    // return domain cardinality
    return count;
}
function configureRange(scale, _, count) {
    var type = scale.type, round = _.round || false, range = _.range;
    // if range step specified, calculate full range extent
    if (_.rangeStep != null) range = configureRangeStep(type, _, count);
    else if (_.scheme) {
        range = configureScheme(type, _, count);
        if ((0, _vegaUtil.isFunction)(range)) {
            if (scale.interpolator) return scale.interpolator(range);
            else (0, _vegaUtil.error)(`Scale type ${type} does not support interpolating color schemes.`);
        }
    }
    // given a range array for an interpolating scale, convert to interpolator
    if (range && (0, _vegaScale.isInterpolating)(type)) return scale.interpolator((0, _vegaScale.interpolateColors)(flip(range, _.reverse), _.interpolate, _.interpolateGamma));
    // configure rounding / interpolation
    if (range && _.interpolate && scale.interpolate) scale.interpolate((0, _vegaScale.interpolate)(_.interpolate, _.interpolateGamma));
    else if ((0, _vegaUtil.isFunction)(scale.round)) scale.round(round);
    else if ((0, _vegaUtil.isFunction)(scale.rangeRound)) scale.interpolate(round ? (0, _d3Interpolate.interpolateRound) : (0, _d3Interpolate.interpolate));
    if (range) scale.range(flip(range, _.reverse));
}
function configureRangeStep(type, _, count) {
    if (type !== (0, _vegaScale.Band) && type !== (0, _vegaScale.Point)) (0, _vegaUtil.error)('Only band and point scales support rangeStep.');
    // calculate full range based on requested step size and padding
    var outer = (_.paddingOuter != null ? _.paddingOuter : _.padding) || 0, inner = type === (0, _vegaScale.Point) ? 1 : (_.paddingInner != null ? _.paddingInner : _.padding) || 0;
    return [
        0,
        _.rangeStep * (0, _vegaScale.bandSpace)(count, inner, outer)
    ];
}
function configureScheme(type, _, count) {
    var extent = _.schemeExtent, name, scheme$1;
    if ((0, _vegaUtil.isArray)(_.scheme)) scheme$1 = (0, _vegaScale.interpolateColors)(_.scheme, _.interpolate, _.interpolateGamma);
    else {
        name = _.scheme.toLowerCase();
        scheme$1 = (0, _vegaScale.scheme)(name);
        if (!scheme$1) (0, _vegaUtil.error)(`Unrecognized scheme name: ${_.scheme}`);
    }
    // determine size for potential discrete range
    count = type === (0, _vegaScale.Threshold) ? count + 1 : type === (0, _vegaScale.BinOrdinal) ? count - 1 : type === (0, _vegaScale.Quantile) || type === (0, _vegaScale.Quantize) ? +_.schemeCount || DEFAULT_COUNT : count;
    // adjust and/or quantize scheme as appropriate
    return (0, _vegaScale.isInterpolating)(type) ? adjustScheme(scheme$1, extent, _.reverse) : (0, _vegaUtil.isFunction)(scheme$1) ? (0, _vegaScale.quantizeInterpolator)(adjustScheme(scheme$1, extent), count) : type === (0, _vegaScale.Ordinal) ? scheme$1 : scheme$1.slice(0, count);
}
function adjustScheme(scheme, extent, reverse) {
    return (0, _vegaUtil.isFunction)(scheme) && (extent || reverse) ? (0, _vegaScale.interpolateRange)(scheme, flip(extent || [
        0,
        1
    ], reverse)) : scheme;
}
function flip(array, reverse) {
    return reverse ? array.slice().reverse() : array;
}
/**
 * Sorts scenegraph items in the pulse source array.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(*,*): number} [params.sort] - A comparator
 *   function for sorting tuples.
 */ function SortItems(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
(0, _vegaUtil.inherits)(SortItems, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const mod = _.modified('sort') || pulse.changed(pulse.ADD) || pulse.modified(_.sort.fields) || pulse.modified('datum');
        if (mod) pulse.source.sort((0, _vegaDataflow.stableCompare)(_.sort));
        this.modified(mod);
        return pulse;
    }
});
const Zero = 'zero', Center = 'center', Normalize = 'normalize', DefOutput = [
    'y0',
    'y1'
];
/**
 * Stack layout for visualization elements.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The value field to stack.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors to groupby.
 * @param {function(object,object): number} [params.sort] - A comparator for stack sorting.
 * @param {string} [offset='zero'] - Stack baseline offset. One of 'zero', 'center', 'normalize'.
 */ function Stack(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Stack.Definition = {
    'type': 'Stack',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field'
        },
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'sort',
            'type': 'compare'
        },
        {
            'name': 'offset',
            'type': 'enum',
            'default': Zero,
            'values': [
                Zero,
                Center,
                Normalize
            ]
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': 2,
            'default': DefOutput
        }
    ]
};
(0, _vegaUtil.inherits)(Stack, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var as = _.as || DefOutput, y0 = as[0], y1 = as[1], sort = (0, _vegaDataflow.stableCompare)(_.sort), field = _.field || (0, _vegaUtil.one), stack = _.offset === Center ? stackCenter : _.offset === Normalize ? stackNormalize : stackZero, groups, i, n, max;
        // partition, sum, and sort the stack groups
        groups = partition(pulse.source, _.groupby, sort, field);
        // compute stack layouts per group
        for(i = 0, n = groups.length, max = groups.max; i < n; ++i)stack(groups[i], max, field, y0, y1);
        return pulse.reflow(_.modified()).modifies(as);
    }
});
function stackCenter(group, max, field, y0, y1) {
    var last = (max - group.sum) / 2, m = group.length, j = 0, t;
    for(; j < m; ++j){
        t = group[j];
        t[y0] = last;
        t[y1] = last += Math.abs(field(t));
    }
}
function stackNormalize(group, max, field, y0, y1) {
    var scale = 1 / group.sum, last = 0, m = group.length, j = 0, v = 0, t;
    for(; j < m; ++j){
        t = group[j];
        t[y0] = last;
        t[y1] = last = scale * (v += Math.abs(field(t)));
    }
}
function stackZero(group, max, field, y0, y1) {
    var lastPos = 0, lastNeg = 0, m = group.length, j = 0, v, t;
    for(; j < m; ++j){
        t = group[j];
        v = +field(t);
        if (v < 0) {
            t[y0] = lastNeg;
            t[y1] = lastNeg += v;
        } else {
            t[y0] = lastPos;
            t[y1] = lastPos += v;
        }
    }
}
function partition(data, groupby, sort, field) {
    var groups = [], get = (f)=>f(t), map, i, n, m, t, k, g, s, max;
    // partition data points into stack groups
    if (groupby == null) groups.push(data.slice());
    else for(map = {}, i = 0, n = data.length; i < n; ++i){
        t = data[i];
        k = groupby.map(get);
        g = map[k];
        if (!g) {
            map[k] = g = [];
            groups.push(g);
        }
        g.push(t);
    }
    // compute sums of groups, sort groups as needed
    for(k = 0, max = 0, m = groups.length; k < m; ++k){
        g = groups[k];
        for(i = 0, s = 0, n = g.length; i < n; ++i)s += Math.abs(field(g[i]));
        g.sum = s;
        if (s > max) max = s;
        if (sort) g.sort(sort);
    }
    groups.max = max;
    return groups;
}

},{"vega-dataflow":"4An7U","vega-scale":"13gXz","vega-util":"7f6sQ","d3-array":[["range","2Qa4a","default"],["sum","l8cYr","default"]],"d3-interpolate":[["interpolate","bmQNW","default"],["interpolateRound","jOLhU","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dcuPv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contour", ()=>Contour);
parcelHelpers.export(exports, "geojson", ()=>GeoJSON);
parcelHelpers.export(exports, "geopath", ()=>GeoPath);
parcelHelpers.export(exports, "geopoint", ()=>GeoPoint);
parcelHelpers.export(exports, "geoshape", ()=>GeoShape);
parcelHelpers.export(exports, "graticule", ()=>Graticule);
parcelHelpers.export(exports, "heatmap", ()=>Heatmap);
parcelHelpers.export(exports, "isocontour", ()=>Isocontour);
parcelHelpers.export(exports, "kde2d", ()=>KDE2D);
parcelHelpers.export(exports, "projection", ()=>Projection);
var _vegaDataflow = require("vega-dataflow");
var _vegaUtil = require("vega-util");
var _d3Array = require("d3-array");
var _vegaStatistics = require("vega-statistics");
var _vegaProjection = require("vega-projection");
var _d3Geo = require("d3-geo");
var _d3Color = require("d3-color");
var _vegaCanvas = require("vega-canvas");
function noop() {}
const cases = [
    [],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ],
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ],
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    []
];
// Implementation adapted from d3/d3-contour. Thanks!
function contours() {
    var dx = 1, dy = 1, smooth = smoothLinear;
    function contours(values, tz) {
        return tz.map((value)=>contour(values, value));
    }
    // Accumulate, smooth contour rings, assign holes to exterior rings.
    // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
    function contour(values, value) {
        var polygons = [], holes = [];
        isorings(values, value, (ring)=>{
            smooth(ring, values, value);
            if (area(ring) > 0) polygons.push([
                ring
            ]);
            else holes.push(ring);
        });
        holes.forEach((hole)=>{
            for(var i = 0, n = polygons.length, polygon; i < n; ++i)if (contains((polygon = polygons[i])[0], hole) !== -1) {
                polygon.push(hole);
                return;
            }
        });
        return {
            type: 'MultiPolygon',
            value: value,
            coordinates: polygons
        };
    }
    // Marching squares with isolines stitched into rings.
    // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
    function isorings(values, value, callback) {
        var fragmentByStart = [], fragmentByEnd = [], x, y, t0, t1, t2, t3;
        // Special case for the first row (y = -1, t2 = t3 = 0).
        x = y = -1;
        t1 = values[0] >= value;
        cases[t1 << 1].forEach(stitch);
        while(++x < dx - 1){
            t0 = t1, t1 = values[x + 1] >= value;
            cases[t0 | t1 << 1].forEach(stitch);
        }
        cases[t1 << 0].forEach(stitch);
        // General case for the intermediate rows.
        while(++y < dy - 1){
            x = -1;
            t1 = values[y * dx + dx] >= value;
            t2 = values[y * dx] >= value;
            cases[t1 << 1 | t2 << 2].forEach(stitch);
            while(++x < dx - 1){
                t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
                t3 = t2, t2 = values[y * dx + x + 1] >= value;
                cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
            }
            cases[t1 | t2 << 3].forEach(stitch);
        }
        // Special case for the last row (y = dy - 1, t0 = t1 = 0).
        x = -1;
        t2 = values[y * dx] >= value;
        cases[t2 << 2].forEach(stitch);
        while(++x < dx - 1){
            t3 = t2, t2 = values[y * dx + x + 1] >= value;
            cases[t2 << 2 | t3 << 3].forEach(stitch);
        }
        cases[t2 << 3].forEach(stitch);
        function stitch(line) {
            var start = [
                line[0][0] + x,
                line[0][1] + y
            ], end = [
                line[1][0] + x,
                line[1][1] + y
            ], startIndex = index(start), endIndex = index(end), f, g;
            if (f = fragmentByEnd[startIndex]) {
                if (g = fragmentByStart[endIndex]) {
                    delete fragmentByEnd[f.end];
                    delete fragmentByStart[g.start];
                    if (f === g) {
                        f.ring.push(end);
                        callback(f.ring);
                    } else fragmentByStart[f.start] = fragmentByEnd[g.end] = {
                        start: f.start,
                        end: g.end,
                        ring: f.ring.concat(g.ring)
                    };
                } else {
                    delete fragmentByEnd[f.end];
                    f.ring.push(end);
                    fragmentByEnd[f.end = endIndex] = f;
                }
            } else if (f = fragmentByStart[endIndex]) {
                if (g = fragmentByEnd[startIndex]) {
                    delete fragmentByStart[f.start];
                    delete fragmentByEnd[g.end];
                    if (f === g) {
                        f.ring.push(end);
                        callback(f.ring);
                    } else fragmentByStart[g.start] = fragmentByEnd[f.end] = {
                        start: g.start,
                        end: f.end,
                        ring: g.ring.concat(f.ring)
                    };
                } else {
                    delete fragmentByStart[f.start];
                    f.ring.unshift(start);
                    fragmentByStart[f.start = startIndex] = f;
                }
            } else fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {
                start: startIndex,
                end: endIndex,
                ring: [
                    start,
                    end
                ]
            };
        }
    }
    function index(point) {
        return point[0] * 2 + point[1] * (dx + 1) * 4;
    }
    function smoothLinear(ring, values, value) {
        ring.forEach((point)=>{
            var x = point[0], y = point[1], xt = x | 0, yt = y | 0, v0, v1 = values[yt * dx + xt];
            if (x > 0 && x < dx && xt === x) {
                v0 = values[yt * dx + xt - 1];
                point[0] = x + (value - v0) / (v1 - v0) - 0.5;
            }
            if (y > 0 && y < dy && yt === y) {
                v0 = values[(yt - 1) * dx + xt];
                point[1] = y + (value - v0) / (v1 - v0) - 0.5;
            }
        });
    }
    contours.contour = contour;
    contours.size = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        var _0 = Math.floor(_[0]), _1 = Math.floor(_[1]);
        if (!(_0 >= 0 && _1 >= 0)) (0, _vegaUtil.error)('invalid size');
        return dx = _0, dy = _1, contours;
    };
    contours.smooth = function(_) {
        return arguments.length ? (smooth = _ ? smoothLinear : noop, contours) : smooth === smoothLinear;
    };
    return contours;
}
function area(ring) {
    var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
    while(++i < n)area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
    return area;
}
function contains(ring, hole) {
    var i = -1, n = hole.length, c;
    while(++i < n)if (c = ringContains(ring, hole[i])) return c;
    return 0;
}
function ringContains(ring, point) {
    var x = point[0], y = point[1], contains = -1;
    for(var i = 0, n = ring.length, j = n - 1; i < n; j = i++){
        var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
        if (segmentContains(pi, pj, point)) return 0;
        if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = -contains;
    }
    return contains;
}
function segmentContains(a, b, c) {
    var i;
    return collinear(a, b, c) && within(a[i = +(a[0] === b[0])], c[i], b[i]);
}
function collinear(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}
function within(p, q, r) {
    return p <= q && q <= r || r <= q && q <= p;
}
function quantize(k, nice, zero) {
    return function(values) {
        var ex = (0, _vegaUtil.extent)(values), start = zero ? Math.min(ex[0], 0) : ex[0], stop = ex[1], span = stop - start, step = nice ? (0, _d3Array.tickStep)(start, stop, k) : span / (k + 1);
        return (0, _d3Array.range)(start + step, stop, step);
    };
}
/**
 * Generate isocontours (level sets) based on input raster grid data.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} [params.field] - The field with raster grid
 *   data. If unspecified, the tuple itself is interpreted as a raster grid.
 * @param {Array<number>} [params.thresholds] - Contour threshold array. If
 *   specified, the levels, nice, resolve, and zero parameters are ignored.
 * @param {number} [params.levels] - The desired number of contour levels.
 * @param {boolean} [params.nice] - Boolean flag indicating if the contour
 *   threshold values should be automatically aligned to "nice"
 *   human-friendly values. Setting this flag may cause the number of
 *   thresholds to deviate from the specified levels.
 * @param {string} [params.resolve] - The method for resolving thresholds
 *   across multiple input grids. If 'independent' (the default), threshold
 *   calculation will be performed separately for each grid. If 'shared', a
 *   single set of threshold values will be used for all input grids.
 * @param {boolean} [params.zero] - Boolean flag indicating if the contour
 *   threshold values should include zero.
 * @param {boolean} [params.smooth] - Boolean flag indicating if the contour
 *   polygons should be smoothed using linear interpolation. The default is
 *   true. The parameter is ignored when using density estimation.
 * @param {boolean} [params.scale] - Optional numerical value by which to
 *   scale the output isocontour coordinates. This parameter can be useful
 *   to scale the contours to match a desired output resolution.
 * @param {string} [params.as='contour'] - The output field in which to store
 *   the generated isocontour data (default 'contour').
 */ function Isocontour(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Isocontour.Definition = {
    'type': 'Isocontour',
    'metadata': {
        'generates': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field'
        },
        {
            'name': 'thresholds',
            'type': 'number',
            'array': true
        },
        {
            'name': 'levels',
            'type': 'number'
        },
        {
            'name': 'nice',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'resolve',
            'type': 'enum',
            'values': [
                'shared',
                'independent'
            ],
            'default': 'independent'
        },
        {
            'name': 'zero',
            'type': 'boolean',
            'default': true
        },
        {
            'name': 'smooth',
            'type': 'boolean',
            'default': true
        },
        {
            'name': 'scale',
            'type': 'number',
            'expr': true
        },
        {
            'name': 'translate',
            'type': 'number',
            'array': true,
            'expr': true
        },
        {
            'name': 'as',
            'type': 'string',
            'null': true,
            'default': 'contour'
        }
    ]
};
(0, _vegaUtil.inherits)(Isocontour, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (this.value && !pulse.changed() && !_.modified()) return pulse.StopPropagation;
        var out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS), source = pulse.materialize(pulse.SOURCE).source, field = _.field || (0, _vegaUtil.identity), contour = contours().smooth(_.smooth !== false), tz = _.thresholds || levels(source, field, _), as = _.as === null ? null : _.as || 'contour', values = [];
        source.forEach((t)=>{
            const grid = field(t);
            // generate contour paths in GeoJSON format
            const paths = contour.size([
                grid.width,
                grid.height
            ])(grid.values, (0, _vegaUtil.isArray)(tz) ? tz : tz(grid.values));
            // adjust contour path coordinates as needed
            transformPaths(paths, grid, t, _);
            // ingest; copy source data properties to output
            paths.forEach((p)=>{
                values.push((0, _vegaDataflow.rederive)(t, (0, _vegaDataflow.ingest)(as != null ? {
                    [as]: p
                } : p)));
            });
        });
        if (this.value) out.rem = this.value;
        this.value = out.source = out.add = values;
        return out;
    }
});
function levels(values, f, _) {
    const q = quantize(_.levels || 10, _.nice, _.zero !== false);
    return _.resolve !== 'shared' ? q : q(values.map((t)=>(0, _d3Array.max)(f(t).values)));
}
function transformPaths(paths, grid, datum, _) {
    let s = _.scale || grid.scale, t = _.translate || grid.translate;
    if ((0, _vegaUtil.isFunction)(s)) s = s(datum, _);
    if ((0, _vegaUtil.isFunction)(t)) t = t(datum, _);
    if ((s === 1 || s == null) && !t) return;
    const sx = ((0, _vegaUtil.isNumber)(s) ? s : s[0]) || 1, sy = ((0, _vegaUtil.isNumber)(s) ? s : s[1]) || 1, tx = t && t[0] || 0, ty = t && t[1] || 0;
    paths.forEach(transform(grid, sx, sy, tx, ty));
}
function transform(grid, sx, sy, tx, ty) {
    const x1 = grid.x1 || 0, y1 = grid.y1 || 0, flip = sx * sy < 0;
    function transformPolygon(coordinates) {
        coordinates.forEach(transformRing);
    }
    function transformRing(coordinates) {
        if (flip) coordinates.reverse(); // maintain winding order
        coordinates.forEach(transformPoint);
    }
    function transformPoint(coordinates) {
        coordinates[0] = (coordinates[0] - x1) * sx + tx;
        coordinates[1] = (coordinates[1] - y1) * sy + ty;
    }
    return function(geometry) {
        geometry.coordinates.forEach(transformPolygon);
        return geometry;
    };
}
function radius(bw, data, f) {
    const v = bw >= 0 ? bw : (0, _vegaStatistics.bandwidthNRD)(data, f);
    return Math.round((Math.sqrt(4 * v * v + 1) - 1) / 2);
}
function number(_) {
    return (0, _vegaUtil.isFunction)(_) ? _ : (0, _vegaUtil.constant)(+_);
}
// Implementation adapted from d3/d3-contour. Thanks!
function density2D() {
    var x = (d)=>d[0], y = (d)=>d[1], weight = (0, _vegaUtil.one), bandwidth = [
        -1,
        -1
    ], dx = 960, dy = 500, k = 2; // log2(cellSize)
    function density(data, counts) {
        const rx = radius(bandwidth[0], data, x) >> k, // blur x-radius
        ry = radius(bandwidth[1], data, y) >> k, // blur y-radius
        ox = rx ? rx + 2 : 0, // x-offset padding for blur
        oy = ry ? ry + 2 : 0, // y-offset padding for blur
        n = 2 * ox + (dx >> k), // grid width
        m = 2 * oy + (dy >> k), // grid height
        values0 = new Float32Array(n * m), values1 = new Float32Array(n * m);
        let values = values0;
        data.forEach((d)=>{
            const xi = ox + (+x(d) >> k), yi = oy + (+y(d) >> k);
            if (xi >= 0 && xi < n && yi >= 0 && yi < m) values0[xi + yi * n] += +weight(d);
        });
        if (rx > 0 && ry > 0) {
            blurX(n, m, values0, values1, rx);
            blurY(n, m, values1, values0, ry);
            blurX(n, m, values0, values1, rx);
            blurY(n, m, values1, values0, ry);
            blurX(n, m, values0, values1, rx);
            blurY(n, m, values1, values0, ry);
        } else if (rx > 0) {
            blurX(n, m, values0, values1, rx);
            blurX(n, m, values1, values0, rx);
            blurX(n, m, values0, values1, rx);
            values = values1;
        } else if (ry > 0) {
            blurY(n, m, values0, values1, ry);
            blurY(n, m, values1, values0, ry);
            blurY(n, m, values0, values1, ry);
            values = values1;
        }
        // scale density estimates
        // density in points per square pixel or probability density
        const s = counts ? Math.pow(2, -2 * k) : 1 / (0, _d3Array.sum)(values);
        for(let i = 0, sz = n * m; i < sz; ++i)values[i] *= s;
        return {
            values: values,
            scale: 1 << k,
            width: n,
            height: m,
            x1: ox,
            y1: oy,
            x2: ox + (dx >> k),
            y2: oy + (dy >> k)
        };
    }
    density.x = function(_) {
        return arguments.length ? (x = number(_), density) : x;
    };
    density.y = function(_) {
        return arguments.length ? (y = number(_), density) : y;
    };
    density.weight = function(_) {
        return arguments.length ? (weight = number(_), density) : weight;
    };
    density.size = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        var _0 = +_[0], _1 = +_[1];
        if (!(_0 >= 0 && _1 >= 0)) (0, _vegaUtil.error)('invalid size');
        return dx = _0, dy = _1, density;
    };
    density.cellSize = function(_) {
        if (!arguments.length) return 1 << k;
        if (!((_ = +_) >= 1)) (0, _vegaUtil.error)('invalid cell size');
        k = Math.floor(Math.log(_) / Math.LN2);
        return density;
    };
    density.bandwidth = function(_) {
        if (!arguments.length) return bandwidth;
        _ = (0, _vegaUtil.array)(_);
        if (_.length === 1) _ = [
            +_[0],
            +_[0]
        ];
        if (_.length !== 2) (0, _vegaUtil.error)('invalid bandwidth');
        return bandwidth = _, density;
    };
    return density;
}
function blurX(n, m, source, target, r) {
    const w = (r << 1) + 1;
    for(let j = 0; j < m; ++j)for(let i = 0, sr = 0; i < n + r; ++i){
        if (i < n) sr += source[i + j * n];
        if (i >= r) {
            if (i >= w) sr -= source[i - w + j * n];
            target[i - r + j * n] = sr / Math.min(i + 1, n - 1 + w - i, w);
        }
    }
}
function blurY(n, m, source, target, r) {
    const w = (r << 1) + 1;
    for(let i = 0; i < n; ++i)for(let j = 0, sr = 0; j < m + r; ++j){
        if (j < m) sr += source[i + j * n];
        if (j >= r) {
            if (j >= w) sr -= source[i + (j - w) * n];
            target[i + (j - r) * n] = sr / Math.min(j + 1, m - 1 + w - j, w);
        }
    }
}
/**
 * Perform 2D kernel-density estimation of point data.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<number>} params.size - The [width, height] extent (in
 *   units of input pixels) over which to perform density estimation.
 * @param {function(object): number} params.x - The x-coordinate accessor.
 * @param {function(object): number} params.y - The y-coordinate accessor.
 * @param {function(object): number} [params.weight] - The weight accessor.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors
 *   to groupby.
 * @param {number} [params.cellSize] - Contour density calculation cell size.
 *   This parameter determines the level of spatial approximation. For example,
 *   the default value of 4 maps to 2x reductions in both x- and y- dimensions.
 *   A value of 1 will result in an output raster grid whose dimensions exactly
 *   matches the size parameter.
 * @param {Array<number>} [params.bandwidth] - The KDE kernel bandwidths,
 *   in pixels. The input can be a two-element array specifying separate
 *   x and y bandwidths, or a single-element array specifying both. If the
 *   bandwidth is unspecified or less than zero, the bandwidth will be
 *   automatically determined.
 * @param {boolean} [params.counts=false] - A boolean flag indicating if the
 *   output values should be probability estimates (false, default) or
 *   smoothed counts (true).
 * @param {string} [params.as='grid'] - The output field in which to store
 *   the generated raster grid (default 'grid').
 */ function KDE2D(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
KDE2D.Definition = {
    'type': 'KDE2D',
    'metadata': {
        'generates': true
    },
    'params': [
        {
            'name': 'size',
            'type': 'number',
            'array': true,
            'length': 2,
            'required': true
        },
        {
            'name': 'x',
            'type': 'field',
            'required': true
        },
        {
            'name': 'y',
            'type': 'field',
            'required': true
        },
        {
            'name': 'weight',
            'type': 'field'
        },
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'cellSize',
            'type': 'number'
        },
        {
            'name': 'bandwidth',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'counts',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'as',
            'type': 'string',
            'default': 'grid'
        }
    ]
};
const PARAMS = [
    'x',
    'y',
    'weight',
    'size',
    'cellSize',
    'bandwidth'
];
function params(obj, _) {
    PARAMS.forEach((param)=>_[param] != null ? obj[param](_[param]) : 0);
    return obj;
}
(0, _vegaUtil.inherits)(KDE2D, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (this.value && !pulse.changed() && !_.modified()) return pulse.StopPropagation;
        var out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS), source = pulse.materialize(pulse.SOURCE).source, groups = partition(source, _.groupby), names = (_.groupby || []).map((0, _vegaUtil.accessorName)), kde = params(density2D(), _), as = _.as || 'grid', values = [];
        function set(t, vals) {
            for(let i = 0; i < names.length; ++i)t[names[i]] = vals[i];
            return t;
        }
        // generate density raster grids
        values = groups.map((g)=>(0, _vegaDataflow.ingest)(set({
                [as]: kde(g, _.counts)
            }, g.dims)));
        if (this.value) out.rem = this.value;
        this.value = out.source = out.add = values;
        return out;
    }
});
function partition(data, groupby) {
    var groups = [], get = (f)=>f(t), map, i, n, t, k, g;
    // partition data points into groups
    if (groupby == null) groups.push(data);
    else for(map = {}, i = 0, n = data.length; i < n; ++i){
        t = data[i];
        k = groupby.map(get);
        g = map[k];
        if (!g) {
            map[k] = g = [];
            g.dims = k;
            groups.push(g);
        }
        g.push(t);
    }
    return groups;
}
/**
 * Generate contours based on kernel-density estimation of point data.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<number>} params.size - The dimensions [width, height] over which to compute contours.
 *  If the values parameter is provided, this must be the dimensions of the input data.
 *  If density estimation is performed, this is the output view dimensions in pixels.
 * @param {Array<number>} [params.values] - An array of numeric values representing an
 *  width x height grid of values over which to compute contours. If unspecified, this
 *  transform will instead attempt to compute contours for the kernel density estimate
 *  using values drawn from data tuples in the input pulse.
 * @param {function(object): number} [params.x] - The pixel x-coordinate accessor for density estimation.
 * @param {function(object): number} [params.y] - The pixel y-coordinate accessor for density estimation.
 * @param {function(object): number} [params.weight] - The data point weight accessor for density estimation.
 * @param {number} [params.cellSize] - Contour density calculation cell size.
 * @param {number} [params.bandwidth] - Kernel density estimation bandwidth.
 * @param {Array<number>} [params.thresholds] - Contour threshold array. If
 *   this parameter is set, the count and nice parameters will be ignored.
 * @param {number} [params.count] - The desired number of contours.
 * @param {boolean} [params.nice] - Boolean flag indicating if the contour
 *   threshold values should be automatically aligned to "nice"
 *   human-friendly values. Setting this flag may cause the number of
 *   thresholds to deviate from the specified count.
 * @param {boolean} [params.smooth] - Boolean flag indicating if the contour
 *   polygons should be smoothed using linear interpolation. The default is
 *   true. The parameter is ignored when using density estimation.
 */ function Contour(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Contour.Definition = {
    'type': 'Contour',
    'metadata': {
        'generates': true
    },
    'params': [
        {
            'name': 'size',
            'type': 'number',
            'array': true,
            'length': 2,
            'required': true
        },
        {
            'name': 'values',
            'type': 'number',
            'array': true
        },
        {
            'name': 'x',
            'type': 'field'
        },
        {
            'name': 'y',
            'type': 'field'
        },
        {
            'name': 'weight',
            'type': 'field'
        },
        {
            'name': 'cellSize',
            'type': 'number'
        },
        {
            'name': 'bandwidth',
            'type': 'number'
        },
        {
            'name': 'count',
            'type': 'number'
        },
        {
            'name': 'nice',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'thresholds',
            'type': 'number',
            'array': true
        },
        {
            'name': 'smooth',
            'type': 'boolean',
            'default': true
        }
    ]
};
(0, _vegaUtil.inherits)(Contour, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (this.value && !pulse.changed() && !_.modified()) return pulse.StopPropagation;
        var out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS), contour = contours().smooth(_.smooth !== false), values = _.values, thresh = _.thresholds || quantize(_.count || 10, _.nice, !!values), size = _.size, grid, post;
        if (!values) {
            values = pulse.materialize(pulse.SOURCE).source;
            grid = params(density2D(), _)(values, true);
            post = transform(grid, grid.scale || 1, grid.scale || 1, 0, 0);
            size = [
                grid.width,
                grid.height
            ];
            values = grid.values;
        }
        thresh = (0, _vegaUtil.isArray)(thresh) ? thresh : thresh(values);
        values = contour.size(size)(values, thresh);
        if (post) values.forEach(post);
        if (this.value) out.rem = this.value;
        this.value = out.source = out.add = (values || []).map((0, _vegaDataflow.ingest));
        return out;
    }
});
const Feature = 'Feature';
const FeatureCollection = 'FeatureCollection';
const MultiPoint = 'MultiPoint';
/**
 * Consolidate an array of [longitude, latitude] points or GeoJSON features
 * into a combined GeoJSON object. This transform is particularly useful for
 * combining geo data for a Projection's fit argument. The resulting GeoJSON
 * data is available as this transform's value. Input pulses are unchanged.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<function(object): *>} [params.fields] - A two-element array
 *   of field accessors for the longitude and latitude values.
 * @param {function(object): *} params.geojson - A field accessor for
 *   retrieving GeoJSON feature data.
 */ function GeoJSON(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
GeoJSON.Definition = {
    'type': 'GeoJSON',
    'metadata': {},
    'params': [
        {
            'name': 'fields',
            'type': 'field',
            'array': true,
            'length': 2
        },
        {
            'name': 'geojson',
            'type': 'field'
        }
    ]
};
(0, _vegaUtil.inherits)(GeoJSON, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var features = this._features, points = this._points, fields = _.fields, lon = fields && fields[0], lat = fields && fields[1], geojson = _.geojson || !fields && (0, _vegaUtil.identity), flag = pulse.ADD, mod;
        mod = _.modified() || pulse.changed(pulse.REM) || pulse.modified((0, _vegaUtil.accessorFields)(geojson)) || lon && pulse.modified((0, _vegaUtil.accessorFields)(lon)) || lat && pulse.modified((0, _vegaUtil.accessorFields)(lat));
        if (!this.value || mod) {
            flag = pulse.SOURCE;
            this._features = features = [];
            this._points = points = [];
        }
        if (geojson) pulse.visit(flag, (t)=>features.push(geojson(t)));
        if (lon && lat) {
            pulse.visit(flag, (t)=>{
                var x = lon(t), y = lat(t);
                if (x != null && y != null && (x = +x) === x && (y = +y) === y) points.push([
                    x,
                    y
                ]);
            });
            features = features.concat({
                type: Feature,
                geometry: {
                    type: MultiPoint,
                    coordinates: points
                }
            });
        }
        this.value = {
            type: FeatureCollection,
            features: features
        };
    }
});
/**
 * Map GeoJSON data to an SVG path string.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(number, number): *} params.projection - The cartographic
 *   projection to apply.
 * @param {function(object): *} [params.field] - The field with GeoJSON data,
 *   or null if the tuple itself is a GeoJSON feature.
 * @param {string} [params.as='path'] - The output field in which to store
 *   the generated path data (default 'path').
 */ function GeoPath(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
GeoPath.Definition = {
    'type': 'GeoPath',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'projection',
            'type': 'projection'
        },
        {
            'name': 'field',
            'type': 'field'
        },
        {
            'name': 'pointRadius',
            'type': 'number',
            'expr': true
        },
        {
            'name': 'as',
            'type': 'string',
            'default': 'path'
        }
    ]
};
(0, _vegaUtil.inherits)(GeoPath, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var out = pulse.fork(pulse.ALL), path = this.value, field = _.field || (0, _vegaUtil.identity), as = _.as || 'path', flag = out.SOURCE;
        if (!path || _.modified()) {
            // parameters updated, reset and reflow
            this.value = path = (0, _vegaProjection.getProjectionPath)(_.projection);
            out.materialize().reflow();
        } else flag = field === (0, _vegaUtil.identity) || pulse.modified(field.fields) ? out.ADD_MOD : out.ADD;
        const prev = initPath(path, _.pointRadius);
        out.visit(flag, (t)=>t[as] = path(field(t)));
        path.pointRadius(prev);
        return out.modifies(as);
    }
});
function initPath(path, pointRadius) {
    const prev = path.pointRadius();
    path.context(null);
    if (pointRadius != null) path.pointRadius(pointRadius);
    return prev;
}
/**
 * Geo-code a longitude/latitude point to an x/y coordinate.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(number, number): *} params.projection - The cartographic
 *   projection to apply.
 * @param {Array<function(object): *>} params.fields - A two-element array of
 *   field accessors for the longitude and latitude values.
 * @param {Array<string>} [params.as] - A two-element array of field names
 *   under which to store the result. Defaults to ['x','y'].
 */ function GeoPoint(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
GeoPoint.Definition = {
    'type': 'GeoPoint',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'projection',
            'type': 'projection',
            'required': true
        },
        {
            'name': 'fields',
            'type': 'field',
            'array': true,
            'required': true,
            'length': 2
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': 2,
            'default': [
                'x',
                'y'
            ]
        }
    ]
};
(0, _vegaUtil.inherits)(GeoPoint, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var proj = _.projection, lon = _.fields[0], lat = _.fields[1], as = _.as || [
            'x',
            'y'
        ], x = as[0], y = as[1], mod;
        function set(t) {
            const xy = proj([
                lon(t),
                lat(t)
            ]);
            if (xy) {
                t[x] = xy[0];
                t[y] = xy[1];
            } else {
                t[x] = undefined;
                t[y] = undefined;
            }
        }
        if (_.modified()) // parameters updated, reflow
        pulse = pulse.materialize().reflow(true).visit(pulse.SOURCE, set);
        else {
            mod = pulse.modified(lon.fields) || pulse.modified(lat.fields);
            pulse.visit(mod ? pulse.ADD_MOD : pulse.ADD, set);
        }
        return pulse.modifies(as);
    }
});
/**
 * Annotate items with a geopath shape generator.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(number, number): *} params.projection - The cartographic
 *   projection to apply.
 * @param {function(object): *} [params.field] - The field with GeoJSON data,
 *   or null if the tuple itself is a GeoJSON feature.
 * @param {string} [params.as='shape'] - The output field in which to store
 *   the generated path data (default 'shape').
 */ function GeoShape(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
GeoShape.Definition = {
    'type': 'GeoShape',
    'metadata': {
        'modifies': true,
        'nomod': true
    },
    'params': [
        {
            'name': 'projection',
            'type': 'projection'
        },
        {
            'name': 'field',
            'type': 'field',
            'default': 'datum'
        },
        {
            'name': 'pointRadius',
            'type': 'number',
            'expr': true
        },
        {
            'name': 'as',
            'type': 'string',
            'default': 'shape'
        }
    ]
};
(0, _vegaUtil.inherits)(GeoShape, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var out = pulse.fork(pulse.ALL), shape = this.value, as = _.as || 'shape', flag = out.ADD;
        if (!shape || _.modified()) {
            // parameters updated, reset and reflow
            this.value = shape = shapeGenerator((0, _vegaProjection.getProjectionPath)(_.projection), _.field || (0, _vegaUtil.field)('datum'), _.pointRadius);
            out.materialize().reflow();
            flag = out.SOURCE;
        }
        out.visit(flag, (t)=>t[as] = shape);
        return out.modifies(as);
    }
});
function shapeGenerator(path, field, pointRadius) {
    const shape = pointRadius == null ? (_)=>path(field(_)) : (_)=>{
        var prev = path.pointRadius(), value = path.pointRadius(pointRadius)(field(_));
        path.pointRadius(prev);
        return value;
    };
    shape.context = (_)=>{
        path.context(_);
        return shape;
    };
    return shape;
}
/**
 * GeoJSON feature generator for creating graticules.
 * @constructor
 */ function Graticule(params) {
    (0, _vegaDataflow.Transform).call(this, [], params);
    this.generator = (0, _d3Geo.geoGraticule)();
}
Graticule.Definition = {
    'type': 'Graticule',
    'metadata': {
        'changes': true,
        'generates': true
    },
    'params': [
        {
            'name': 'extent',
            'type': 'array',
            'array': true,
            'length': 2,
            'content': {
                'type': 'number',
                'array': true,
                'length': 2
            }
        },
        {
            'name': 'extentMajor',
            'type': 'array',
            'array': true,
            'length': 2,
            'content': {
                'type': 'number',
                'array': true,
                'length': 2
            }
        },
        {
            'name': 'extentMinor',
            'type': 'array',
            'array': true,
            'length': 2,
            'content': {
                'type': 'number',
                'array': true,
                'length': 2
            }
        },
        {
            'name': 'step',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'stepMajor',
            'type': 'number',
            'array': true,
            'length': 2,
            'default': [
                90,
                360
            ]
        },
        {
            'name': 'stepMinor',
            'type': 'number',
            'array': true,
            'length': 2,
            'default': [
                10,
                10
            ]
        },
        {
            'name': 'precision',
            'type': 'number',
            'default': 2.5
        }
    ]
};
(0, _vegaUtil.inherits)(Graticule, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var src = this.value, gen = this.generator, t;
        if (!src.length || _.modified()) {
            for(const prop in _)if ((0, _vegaUtil.isFunction)(gen[prop])) gen[prop](_[prop]);
        }
        t = gen();
        if (src.length) pulse.mod.push((0, _vegaDataflow.replace)(src[0], t));
        else pulse.add.push((0, _vegaDataflow.ingest)(t));
        src[0] = t;
        return pulse;
    }
});
/**
 * Render a heatmap image for input raster grid data.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} [params.field] - The field with raster grid
 *   data. If unspecified, the tuple itself is interpreted as a raster grid.
 * @param {string} [params.color] - A constant color value or function for
 *   individual pixel color. If a function, it will be invoked with an input
 *   object that includes $x, $y, $value, and $max fields for the grid.
 * @param {number} [params.opacity] - A constant opacity value or function for
 *   individual pixel opacity. If a function, it will be invoked with an input
 *   object that includes $x, $y, $value, and $max fields for the grid.
 * @param {string} [params.resolve] - The method for resolving maximum values
 *   across multiple input grids. If 'independent' (the default), maximum
 *   calculation will be performed separately for each grid. If 'shared',
 *   a single global maximum will be used for all input grids.
 * @param {string} [params.as='image'] - The output field in which to store
 *   the generated bitmap canvas images (default 'image').
 */ function Heatmap(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Heatmap.Definition = {
    'type': 'heatmap',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field'
        },
        {
            'name': 'color',
            'type': 'string',
            'expr': true
        },
        {
            'name': 'opacity',
            'type': 'number',
            'expr': true
        },
        {
            'name': 'resolve',
            'type': 'enum',
            'values': [
                'shared',
                'independent'
            ],
            'default': 'independent'
        },
        {
            'name': 'as',
            'type': 'string',
            'default': 'image'
        }
    ]
};
(0, _vegaUtil.inherits)(Heatmap, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (!pulse.changed() && !_.modified()) return pulse.StopPropagation;
        var source = pulse.materialize(pulse.SOURCE).source, shared = _.resolve === 'shared', field = _.field || (0, _vegaUtil.identity), opacity = opacity_(_.opacity, _), color = color_(_.color, _), as = _.as || 'image', obj = {
            $x: 0,
            $y: 0,
            $value: 0,
            $max: shared ? (0, _d3Array.max)(source.map((t)=>(0, _d3Array.max)(field(t).values))) : 0
        };
        source.forEach((t)=>{
            const v = field(t);
            // build proxy data object
            const o = (0, _vegaUtil.extend)({}, t, obj);
            // set maximum value if not globally shared
            if (!shared) o.$max = (0, _d3Array.max)(v.values || []);
            // generate canvas image
            // optimize color/opacity if not pixel-dependent
            t[as] = toCanvas(v, o, color.dep ? color : (0, _vegaUtil.constant)(color(o)), opacity.dep ? opacity : (0, _vegaUtil.constant)(opacity(o)));
        });
        return pulse.reflow(true).modifies(as);
    }
});
// get image color function
function color_(color, _) {
    let f;
    if ((0, _vegaUtil.isFunction)(color)) {
        f = (obj)=>(0, _d3Color.rgb)(color(obj, _));
        f.dep = dependency(color);
    } else // default to mid-grey
    f = (0, _vegaUtil.constant)((0, _d3Color.rgb)(color || '#888'));
    return f;
}
// get image opacity function
function opacity_(opacity, _) {
    let f;
    if ((0, _vegaUtil.isFunction)(opacity)) {
        f = (obj)=>opacity(obj, _);
        f.dep = dependency(opacity);
    } else if (opacity) f = (0, _vegaUtil.constant)(opacity);
    else {
        // default to [0, max] opacity gradient
        f = (obj)=>obj.$value / obj.$max || 0;
        f.dep = true;
    }
    return f;
}
// check if function depends on individual pixel data
function dependency(f) {
    if (!(0, _vegaUtil.isFunction)(f)) return false;
    const set = (0, _vegaUtil.toSet)((0, _vegaUtil.accessorFields)(f));
    return set.$x || set.$y || set.$value || set.$max;
}
// render raster grid to canvas
function toCanvas(grid, obj, color, opacity) {
    const n = grid.width, m = grid.height, x1 = grid.x1 || 0, y1 = grid.y1 || 0, x2 = grid.x2 || n, y2 = grid.y2 || m, val = grid.values, value = val ? (i)=>val[i] : (0, _vegaUtil.zero), can = (0, _vegaCanvas.canvas)(x2 - x1, y2 - y1), ctx = can.getContext('2d'), img = ctx.getImageData(0, 0, x2 - x1, y2 - y1), pix = img.data;
    for(let j = y1, k = 0; j < y2; ++j){
        obj.$y = j - y1;
        for(let i = x1, r = j * n; i < x2; ++i, k += 4){
            obj.$x = i - x1;
            obj.$value = value(i + r);
            const v = color(obj);
            pix[k + 0] = v.r;
            pix[k + 1] = v.g;
            pix[k + 2] = v.b;
            pix[k + 3] = ~~(255 * opacity(obj));
        }
    }
    ctx.putImageData(img, 0, 0);
    return can;
}
/**
 * Maintains a cartographic projection.
 * @constructor
 * @param {object} params - The parameters for this operator.
 */ function Projection(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
    this.modified(true); // always treat as modified
}
(0, _vegaUtil.inherits)(Projection, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        let proj = this.value;
        if (!proj || _.modified('type')) {
            this.value = proj = create(_.type);
            (0, _vegaProjection.projectionProperties).forEach((prop)=>{
                if (_[prop] != null) set(proj, prop, _[prop]);
            });
        } else (0, _vegaProjection.projectionProperties).forEach((prop)=>{
            if (_.modified(prop)) set(proj, prop, _[prop]);
        });
        if (_.pointRadius != null) proj.path.pointRadius(_.pointRadius);
        if (_.fit) fit(proj, _);
        return pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
    }
});
function fit(proj, _) {
    const data = collectGeoJSON(_.fit);
    _.extent ? proj.fitExtent(_.extent, data) : _.size && proj.fitSize(_.size, data);
}
function create(type) {
    const constructor = (0, _vegaProjection.projection)((type || 'mercator').toLowerCase());
    if (!constructor) (0, _vegaUtil.error)('Unrecognized projection type: ' + type);
    return constructor();
}
function set(proj, key, value) {
    if ((0, _vegaUtil.isFunction)(proj[key])) proj[key](value);
}
function collectGeoJSON(data) {
    data = (0, _vegaUtil.array)(data);
    return data.length === 1 ? data[0] : {
        type: FeatureCollection,
        features: data.reduce((a, f)=>a.concat(featurize(f)), [])
    };
}
function featurize(f) {
    return f.type === FeatureCollection ? f.features : (0, _vegaUtil.array)(f).filter((d)=>d != null).map((d)=>d.type === Feature ? d : {
            type: Feature,
            geometry: d
        });
}

},{"vega-dataflow":"4An7U","vega-util":"7f6sQ","d3-array":[["max","cV45R","default"],["range","2Qa4a","default"],["sum","l8cYr","default"],["tickStep","4kdy4"]],"vega-statistics":"lNUxJ","vega-projection":"ijSgT","d3-geo":[["geoGraticule","7hLZN","default"]],"d3-color":"gqOvl","vega-canvas":"duGNb","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"ijSgT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getProjectionPath", ()=>getProjectionPath);
parcelHelpers.export(exports, "projection", ()=>projection);
parcelHelpers.export(exports, "projectionProperties", ()=>projectionProperties);
var _d3Geo = require("d3-geo");
var _d3GeoProjection = require("d3-geo-projection");
var _vegaScale = require("vega-scale");
const defaultPath = (0, _d3Geo.geoPath)();
const projectionProperties = [
    // standard properties in d3-geo
    'clipAngle',
    'clipExtent',
    'scale',
    'translate',
    'center',
    'rotate',
    'parallels',
    'precision',
    'reflectX',
    'reflectY',
    // extended properties in d3-geo-projections
    'coefficient',
    'distance',
    'fraction',
    'lobes',
    'parallel',
    'radius',
    'ratio',
    'spacing',
    'tilt'
];
/**
 * Augment projections with their type and a copy method.
 */ function create(type, constructor) {
    return function projection() {
        const p = constructor();
        p.type = type;
        p.path = (0, _d3Geo.geoPath)().projection(p);
        p.copy = p.copy || function() {
            const c = projection();
            projectionProperties.forEach((prop)=>{
                if (p[prop]) c[prop](p[prop]());
            });
            c.path.pointRadius(p.path.pointRadius());
            return c;
        };
        return (0, _vegaScale.registerScale)(p);
    };
}
function projection(type, proj) {
    if (!type || typeof type !== 'string') throw new Error('Projection type must be a name string.');
    type = type.toLowerCase();
    if (arguments.length > 1) {
        projections[type] = create(type, proj);
        return this;
    } else return projections[type] || null;
}
function getProjectionPath(proj) {
    return proj && proj.path || defaultPath;
}
const projections = {
    // base d3-geo projection types
    albers: (0, _d3Geo.geoAlbers),
    albersusa: (0, _d3Geo.geoAlbersUsa),
    azimuthalequalarea: (0, _d3Geo.geoAzimuthalEqualArea),
    azimuthalequidistant: (0, _d3Geo.geoAzimuthalEquidistant),
    conicconformal: (0, _d3Geo.geoConicConformal),
    conicequalarea: (0, _d3Geo.geoConicEqualArea),
    conicequidistant: (0, _d3Geo.geoConicEquidistant),
    equalEarth: (0, _d3Geo.geoEqualEarth),
    equirectangular: (0, _d3Geo.geoEquirectangular),
    gnomonic: (0, _d3Geo.geoGnomonic),
    identity: (0, _d3Geo.geoIdentity),
    mercator: (0, _d3Geo.geoMercator),
    mollweide: (0, _d3GeoProjection.geoMollweide),
    naturalEarth1: (0, _d3Geo.geoNaturalEarth1),
    orthographic: (0, _d3Geo.geoOrthographic),
    stereographic: (0, _d3Geo.geoStereographic),
    transversemercator: (0, _d3Geo.geoTransverseMercator)
};
for(const key in projections)projection(key, projections[key]);

},{"d3-geo":[["geoAlbers","dgYrm","default"],["geoAlbersUsa","aBNXm","default"],["geoAzimuthalEqualArea","9VNXC","default"],["geoAzimuthalEquidistant","94amM","default"],["geoConicConformal","aYIaH","default"],["geoConicEqualArea","aC8Z6","default"],["geoConicEquidistant","2B05S","default"],["geoEqualEarth","jW12c","default"],["geoEquirectangular","f7TSK","default"],["geoGnomonic","hRfOp","default"],["geoIdentity","aZqPk","default"],["geoMercator","dPQja","default"],["geoNaturalEarth1","56P6U","default"],["geoOrthographic","8EN5n","default"],["geoPath","cM6Ml","default"],["geoStereographic","bwyJN","default"],["geoTransverseMercator","hLM9w","default"]],"d3-geo-projection":[["geoMollweide","6UNb9","default"]],"vega-scale":"13gXz","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dgYrm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicEqualAreaJsDefault.default)().parallels([
            29.5,
            45.5
        ]).scale(1070).translate([
            480,
            250
        ]).rotate([
            96,
            0
        ]).center([
            -0.6,
            38.7
        ]);
    });
var _conicEqualAreaJs = require("./conicEqualArea.js");
var _conicEqualAreaJsDefault = parcelHelpers.interopDefault(_conicEqualAreaJs);

},{"./conicEqualArea.js":"aC8Z6","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"aC8Z6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicEqualAreaRaw", ()=>conicEqualAreaRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicJs.conicProjection)(conicEqualAreaRaw).scale(155.424).center([
            0,
            33.6442
        ]);
    });
var _mathJs = require("../math.js");
var _conicJs = require("./conic.js");
var _cylindricalEqualAreaJs = require("./cylindricalEqualArea.js");
function conicEqualAreaRaw(y0, y1) {
    var sy0 = (0, _mathJs.sin)(y0), n = (sy0 + (0, _mathJs.sin)(y1)) / 2;
    // Are the parallels symmetrical around the Equator?
    if ((0, _mathJs.abs)(n) < (0, _mathJs.epsilon)) return (0, _cylindricalEqualAreaJs.cylindricalEqualAreaRaw)(y0);
    var c = 1 + sy0 * (2 * n - sy0), r0 = (0, _mathJs.sqrt)(c) / n;
    function project(x, y) {
        var r = (0, _mathJs.sqrt)(c - 2 * n * (0, _mathJs.sin)(y)) / n;
        return [
            r * (0, _mathJs.sin)(x *= n),
            r0 - r * (0, _mathJs.cos)(x)
        ];
    }
    project.invert = function(x, y) {
        var r0y = r0 - y, l = (0, _mathJs.atan2)(x, (0, _mathJs.abs)(r0y)) * (0, _mathJs.sign)(r0y);
        if (r0y * n < 0) l -= (0, _mathJs.pi) * (0, _mathJs.sign)(x) * (0, _mathJs.sign)(r0y);
        return [
            l / n,
            (0, _mathJs.asin)((c - (x * x + r0y * r0y) * n * n) / (2 * n))
        ];
    };
    return project;
}

},{"../math.js":"bttmd","./conic.js":"juhK7","./cylindricalEqualArea.js":"fvx6V","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bttmd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
parcelHelpers.export(exports, "epsilon2", ()=>epsilon2);
parcelHelpers.export(exports, "pi", ()=>pi);
parcelHelpers.export(exports, "halfPi", ()=>halfPi);
parcelHelpers.export(exports, "quarterPi", ()=>quarterPi);
parcelHelpers.export(exports, "tau", ()=>tau);
parcelHelpers.export(exports, "degrees", ()=>degrees);
parcelHelpers.export(exports, "radians", ()=>radians);
parcelHelpers.export(exports, "abs", ()=>abs);
parcelHelpers.export(exports, "atan", ()=>atan);
parcelHelpers.export(exports, "atan2", ()=>atan2);
parcelHelpers.export(exports, "cos", ()=>cos);
parcelHelpers.export(exports, "ceil", ()=>ceil);
parcelHelpers.export(exports, "exp", ()=>exp);
parcelHelpers.export(exports, "floor", ()=>floor);
parcelHelpers.export(exports, "hypot", ()=>hypot);
parcelHelpers.export(exports, "log", ()=>log);
parcelHelpers.export(exports, "pow", ()=>pow);
parcelHelpers.export(exports, "sin", ()=>sin);
parcelHelpers.export(exports, "sign", ()=>sign);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
parcelHelpers.export(exports, "tan", ()=>tan);
parcelHelpers.export(exports, "acos", ()=>acos);
parcelHelpers.export(exports, "asin", ()=>asin);
parcelHelpers.export(exports, "haversin", ()=>haversin);
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;
var degrees = 180 / pi;
var radians = pi / 180;
var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var floor = Math.floor;
var hypot = Math.hypot;
var log = Math.log;
var pow = Math.pow;
var sin = Math.sin;
var sign = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var sqrt = Math.sqrt;
var tan = Math.tan;
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
    return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}
function haversin(x) {
    return (x = sin(x / 2)) * x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"juhK7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicProjection", ()=>conicProjection);
var _mathJs = require("../math.js");
var _indexJs = require("./index.js");
function conicProjection(projectAt) {
    var phi0 = 0, phi1 = (0, _mathJs.pi) / 3, m = (0, _indexJs.projectionMutator)(projectAt), p = m(phi0, phi1);
    p.parallels = function(_) {
        return arguments.length ? m(phi0 = _[0] * (0, _mathJs.radians), phi1 = _[1] * (0, _mathJs.radians)) : [
            phi0 * (0, _mathJs.degrees),
            phi1 * (0, _mathJs.degrees)
        ];
    };
    return p;
}

},{"../math.js":"bttmd","./index.js":"1wC1W","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"1wC1W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>projection);
parcelHelpers.export(exports, "projectionMutator", ()=>projectionMutator);
var _antimeridianJs = require("../clip/antimeridian.js");
var _antimeridianJsDefault = parcelHelpers.interopDefault(_antimeridianJs);
var _circleJs = require("../clip/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _rectangleJs = require("../clip/rectangle.js");
var _rectangleJsDefault = parcelHelpers.interopDefault(_rectangleJs);
var _composeJs = require("../compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _identityJs = require("../identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _mathJs = require("../math.js");
var _rotationJs = require("../rotation.js");
var _transformJs = require("../transform.js");
var _fitJs = require("./fit.js");
var _resampleJs = require("./resample.js");
var _resampleJsDefault = parcelHelpers.interopDefault(_resampleJs);
var transformRadians = (0, _transformJs.transformer)({
    point: function(x, y) {
        this.stream.point(x * (0, _mathJs.radians), y * (0, _mathJs.radians));
    }
});
function transformRotate(rotate) {
    return (0, _transformJs.transformer)({
        point: function(x, y) {
            var r = rotate(x, y);
            return this.stream.point(r[0], r[1]);
        }
    });
}
function scaleTranslate(k, dx, dy, sx, sy) {
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            dx + k * x,
            dy - k * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            (x - dx) / k * sx,
            (dy - y) / k * sy
        ];
    };
    return transform;
}
function scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
    if (!alpha) return scaleTranslate(k, dx, dy, sx, sy);
    var cosAlpha = (0, _mathJs.cos)(alpha), sinAlpha = (0, _mathJs.sin)(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            a * x - b * y + dx,
            dy - b * x - a * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            sx * (ai * x - bi * y + ci),
            sy * (fi - bi * x - ai * y)
        ];
    };
    return transform;
}
function projection(project) {
    return projectionMutator(function() {
        return project;
    })();
}
function projectionMutator(projectAt) {
    var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = (0, _antimeridianJsDefault.default), x0 = null, y0, x1, y1, postclip = (0, _identityJsDefault.default), delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
    function projection(point) {
        return projectRotateTransform(point[0] * (0, _mathJs.radians), point[1] * (0, _mathJs.radians));
    }
    function invert(point) {
        point = projectRotateTransform.invert(point[0], point[1]);
        return point && [
            point[0] * (0, _mathJs.degrees),
            point[1] * (0, _mathJs.degrees)
        ];
    }
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
    };
    projection.preclip = function(_) {
        return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipAngle = function(_) {
        return arguments.length ? (preclip = +_ ? (0, _circleJsDefault.default)(theta = _ * (0, _mathJs.radians)) : (theta = null, _antimeridianJsDefault.default), reset()) : theta * (0, _mathJs.degrees);
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, _identityJsDefault.default) : (0, _rectangleJsDefault.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, recenter()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
            x,
            y
        ];
    };
    projection.center = function(_) {
        return arguments.length ? (lambda = _[0] % 360 * (0, _mathJs.radians), phi = _[1] % 360 * (0, _mathJs.radians), recenter()) : [
            lambda * (0, _mathJs.degrees),
            phi * (0, _mathJs.degrees)
        ];
    };
    projection.rotate = function(_) {
        return arguments.length ? (deltaLambda = _[0] % 360 * (0, _mathJs.radians), deltaPhi = _[1] % 360 * (0, _mathJs.radians), deltaGamma = _.length > 2 ? _[2] % 360 * (0, _mathJs.radians) : 0, recenter()) : [
            deltaLambda * (0, _mathJs.degrees),
            deltaPhi * (0, _mathJs.degrees),
            deltaGamma * (0, _mathJs.degrees)
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, _mathJs.radians), recenter()) : alpha * (0, _mathJs.degrees);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
    };
    projection.precision = function(_) {
        return arguments.length ? (projectResample = (0, _resampleJsDefault.default)(projectTransform, delta2 = _ * _), reset()) : (0, _mathJs.sqrt)(delta2);
    };
    projection.fitExtent = function(extent, object) {
        return (0, _fitJs.fitExtent)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, _fitJs.fitSize)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, _fitJs.fitWidth)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, _fitJs.fitHeight)(projection, height, object);
    };
    function recenter() {
        var center = scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform = scaleTranslateRotate(k, x - center[0], y - center[1], sx, sy, alpha);
        rotate = (0, _rotationJs.rotateRadians)(deltaLambda, deltaPhi, deltaGamma);
        projectTransform = (0, _composeJsDefault.default)(project, transform);
        projectRotateTransform = (0, _composeJsDefault.default)(rotate, projectTransform);
        projectResample = (0, _resampleJsDefault.default)(projectTransform, delta2);
        return reset();
    }
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return function() {
        project = projectAt.apply(this, arguments);
        projection.invert = project.invert && invert;
        return recenter();
    };
}

},{"../clip/antimeridian.js":"aGadX","../clip/circle.js":"aq6iP","../clip/rectangle.js":"a6i2W","../compose.js":"kAsab","../identity.js":"l1CAh","../math.js":"bttmd","../rotation.js":"918Qt","../transform.js":"aXfnq","./fit.js":"haKCe","./resample.js":"iNMon","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"aGadX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _mathJs = require("../math.js");
exports.default = (0, _indexJsDefault.default)(function() {
    return true;
}, clipAntimeridianLine, clipAntimeridianInterpolate, [
    -(0, _mathJs.pi),
    -(0, _mathJs.halfPi)
]);
// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
    var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
    return {
        lineStart: function() {
            stream.lineStart();
            clean = 1;
        },
        point: function(lambda1, phi1) {
            var sign1 = lambda1 > 0 ? (0, _mathJs.pi) : -(0, _mathJs.pi), delta = (0, _mathJs.abs)(lambda1 - lambda0);
            if ((0, _mathJs.abs)(delta - (0, _mathJs.pi)) < (0, _mathJs.epsilon)) {
                stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? (0, _mathJs.halfPi) : -(0, _mathJs.halfPi));
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                stream.point(lambda1, phi0);
                clean = 0;
            } else if (sign0 !== sign1 && delta >= (0, _mathJs.pi)) {
                if ((0, _mathJs.abs)(lambda0 - sign0) < (0, _mathJs.epsilon)) lambda0 -= sign0 * (0, _mathJs.epsilon); // handle degeneracies
                if ((0, _mathJs.abs)(lambda1 - sign1) < (0, _mathJs.epsilon)) lambda1 -= sign1 * (0, _mathJs.epsilon);
                phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                clean = 0;
            }
            stream.point(lambda0 = lambda1, phi0 = phi1);
            sign0 = sign1;
        },
        lineEnd: function() {
            stream.lineEnd();
            lambda0 = phi0 = NaN;
        },
        clean: function() {
            return 2 - clean; // if intersections, rejoin first and last segments
        }
    };
}
function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
    var cosPhi0, cosPhi1, sinLambda0Lambda1 = (0, _mathJs.sin)(lambda0 - lambda1);
    return (0, _mathJs.abs)(sinLambda0Lambda1) > (0, _mathJs.epsilon) ? (0, _mathJs.atan)(((0, _mathJs.sin)(phi0) * (cosPhi1 = (0, _mathJs.cos)(phi1)) * (0, _mathJs.sin)(lambda1) - (0, _mathJs.sin)(phi1) * (cosPhi0 = (0, _mathJs.cos)(phi0)) * (0, _mathJs.sin)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function clipAntimeridianInterpolate(from, to, direction, stream) {
    var phi;
    if (from == null) {
        phi = direction * (0, _mathJs.halfPi);
        stream.point(-(0, _mathJs.pi), phi);
        stream.point(0, phi);
        stream.point((0, _mathJs.pi), phi);
        stream.point((0, _mathJs.pi), 0);
        stream.point((0, _mathJs.pi), -phi);
        stream.point(0, -phi);
        stream.point(-(0, _mathJs.pi), -phi);
        stream.point(-(0, _mathJs.pi), 0);
        stream.point(-(0, _mathJs.pi), phi);
    } else if ((0, _mathJs.abs)(from[0] - to[0]) > (0, _mathJs.epsilon)) {
        var lambda = from[0] < to[0] ? (0, _mathJs.pi) : -(0, _mathJs.pi);
        phi = direction * lambda / 2;
        stream.point(-lambda, phi);
        stream.point(0, phi);
        stream.point(lambda, phi);
    } else stream.point(to[0], to[1]);
}

},{"./index.js":"4Kd1S","../math.js":"bttmd","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4Kd1S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(pointVisible, clipLine, interpolate, start) {
        return function(sink) {
            var line = clipLine(sink), ringBuffer = (0, _bufferJsDefault.default)(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
            var clip = {
                point: point,
                lineStart: lineStart,
                lineEnd: lineEnd,
                polygonStart: function() {
                    clip.point = pointRing;
                    clip.lineStart = ringStart;
                    clip.lineEnd = ringEnd;
                    segments = [];
                    polygon = [];
                },
                polygonEnd: function() {
                    clip.point = point;
                    clip.lineStart = lineStart;
                    clip.lineEnd = lineEnd;
                    segments = (0, _d3Array.merge)(segments);
                    var startInside = (0, _polygonContainsJsDefault.default)(polygon, start);
                    if (segments.length) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        (0, _rejoinJsDefault.default)(segments, compareIntersection, startInside, interpolate, sink);
                    } else if (startInside) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        sink.lineStart();
                        interpolate(null, null, 1, sink);
                        sink.lineEnd();
                    }
                    if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                    segments = polygon = null;
                },
                sphere: function() {
                    sink.polygonStart();
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                    sink.polygonEnd();
                }
            };
            function point(lambda, phi) {
                if (pointVisible(lambda, phi)) sink.point(lambda, phi);
            }
            function pointLine(lambda, phi) {
                line.point(lambda, phi);
            }
            function lineStart() {
                clip.point = pointLine;
                line.lineStart();
            }
            function lineEnd() {
                clip.point = point;
                line.lineEnd();
            }
            function pointRing(lambda, phi) {
                ring.push([
                    lambda,
                    phi
                ]);
                ringSink.point(lambda, phi);
            }
            function ringStart() {
                ringSink.lineStart();
                ring = [];
            }
            function ringEnd() {
                pointRing(ring[0][0], ring[0][1]);
                ringSink.lineEnd();
                var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
                ring.pop();
                polygon.push(ring);
                ring = null;
                if (!n) return;
                // No intersections.
                if (clean & 1) {
                    segment = ringSegments[0];
                    if ((m = segment.length - 1) > 0) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        sink.lineStart();
                        for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                        sink.lineEnd();
                    }
                    return;
                }
                // Rejoin connected segments.
                // TODO reuse ringBuffer.rejoin()?
                if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
                segments.push(ringSegments.filter(validSegment));
            }
            return clip;
        };
    });
var _bufferJs = require("./buffer.js");
var _bufferJsDefault = parcelHelpers.interopDefault(_bufferJs);
var _rejoinJs = require("./rejoin.js");
var _rejoinJsDefault = parcelHelpers.interopDefault(_rejoinJs);
var _mathJs = require("../math.js");
var _polygonContainsJs = require("../polygonContains.js");
var _polygonContainsJsDefault = parcelHelpers.interopDefault(_polygonContainsJs);
var _d3Array = require("d3-array");
function validSegment(segment) {
    return segment.length > 1;
}
// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - (0, _mathJs.halfPi) - (0, _mathJs.epsilon) : (0, _mathJs.halfPi) - a[1]) - ((b = b.x)[0] < 0 ? b[1] - (0, _mathJs.halfPi) - (0, _mathJs.epsilon) : (0, _mathJs.halfPi) - b[1]);
}

},{"./buffer.js":"gtpJa","./rejoin.js":"cHZ3P","../math.js":"bttmd","../polygonContains.js":"3uQTB","d3-array":[["merge","8UWhT","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"gtpJa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var lines = [], line;
        return {
            point: function(x, y, m) {
                line.push([
                    x,
                    y,
                    m
                ]);
            },
            lineStart: function() {
                lines.push(line = []);
            },
            lineEnd: (0, _noopJsDefault.default),
            rejoin: function() {
                if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
            },
            result: function() {
                var result = lines;
                lines = [];
                line = null;
                return result;
            }
        };
    });
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);

},{"../noop.js":"eRuPB","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"eRuPB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>noop);
function noop() {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cHZ3P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
parcelHelpers.export(exports, "default", ()=>function(segments, compareIntersection, startInside, interpolate, stream) {
        var subject = [], clip = [], i, n;
        segments.forEach(function(segment) {
            if ((n = segment.length - 1) <= 0) return;
            var n, p0 = segment[0], p1 = segment[n], x;
            if ((0, _pointEqualJsDefault.default)(p0, p1)) {
                if (!p0[2] && !p1[2]) {
                    stream.lineStart();
                    for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
                    stream.lineEnd();
                    return;
                }
                // handle degenerate cases by moving the point
                p1[0] += 2 * (0, _mathJs.epsilon);
            }
            subject.push(x = new Intersection(p0, segment, null, true));
            clip.push(x.o = new Intersection(p0, null, x, false));
            subject.push(x = new Intersection(p1, segment, null, false));
            clip.push(x.o = new Intersection(p1, null, x, true));
        });
        if (!subject.length) return;
        clip.sort(compareIntersection);
        link(subject);
        link(clip);
        for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
        var start = subject[0], points, point;
        while(true){
            // Find first unvisited intersection.
            var current = start, isSubject = true;
            while(current.v)if ((current = current.n) === start) return;
            points = current.z;
            stream.lineStart();
            do {
                current.v = current.o.v = true;
                if (current.e) {
                    if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                    else interpolate(current.x, current.n.x, 1, stream);
                    current = current.n;
                } else {
                    if (isSubject) {
                        points = current.p.z;
                        for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                    } else interpolate(current.x, current.p.x, -1, stream);
                    current = current.p;
                }
                current = current.o;
                points = current.z;
                isSubject = !isSubject;
            }while (!current.v);
            stream.lineEnd();
        }
    });
var _pointEqualJs = require("../pointEqual.js");
var _pointEqualJsDefault = parcelHelpers.interopDefault(_pointEqualJs);
var _mathJs = require("../math.js");
function Intersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other; // another intersection
    this.e = entry; // is an entry?
    this.v = false; // visited
    this.n = this.p = null; // next & previous
}
function link(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while(++i < n){
        a.n = b = array[i];
        b.p = a;
        a = b;
    }
    a.n = b = array[0];
    b.p = a;
}

},{"../pointEqual.js":"bf5VF","../math.js":"bttmd","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bf5VF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return (0, _mathJs.abs)(a[0] - b[0]) < (0, _mathJs.epsilon) && (0, _mathJs.abs)(a[1] - b[1]) < (0, _mathJs.epsilon);
    });
var _mathJs = require("./math.js");

},{"./math.js":"bttmd","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3uQTB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(polygon, point) {
        var lambda = longitude(point), phi = point[1], sinPhi = (0, _mathJs.sin)(phi), normal = [
            (0, _mathJs.sin)(lambda),
            -(0, _mathJs.cos)(lambda),
            0
        ], angle = 0, winding = 0;
        var sum = new (0, _d3Array.Adder)();
        if (sinPhi === 1) phi = (0, _mathJs.halfPi) + (0, _mathJs.epsilon);
        else if (sinPhi === -1) phi = -(0, _mathJs.halfPi) - (0, _mathJs.epsilon);
        for(var i = 0, n = polygon.length; i < n; ++i){
            if (!(m = (ring = polygon[i]).length)) continue;
            var ring, m, point0 = ring[m - 1], lambda0 = longitude(point0), phi0 = point0[1] / 2 + (0, _mathJs.quarterPi), sinPhi0 = (0, _mathJs.sin)(phi0), cosPhi0 = (0, _mathJs.cos)(phi0);
            for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
                var point1 = ring[j], lambda1 = longitude(point1), phi1 = point1[1] / 2 + (0, _mathJs.quarterPi), sinPhi1 = (0, _mathJs.sin)(phi1), cosPhi1 = (0, _mathJs.cos)(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > (0, _mathJs.pi), k = sinPhi0 * sinPhi1;
                sum.add((0, _mathJs.atan2)(k * sign * (0, _mathJs.sin)(absDelta), cosPhi0 * cosPhi1 + k * (0, _mathJs.cos)(absDelta)));
                angle += antimeridian ? delta + sign * (0, _mathJs.tau) : delta;
                // Are the longitudes either side of the point’s meridian (lambda),
                // and are the latitudes smaller than the parallel (phi)?
                if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                    var arc = (0, _cartesianJs.cartesianCross)((0, _cartesianJs.cartesian)(point0), (0, _cartesianJs.cartesian)(point1));
                    (0, _cartesianJs.cartesianNormalizeInPlace)(arc);
                    var intersection = (0, _cartesianJs.cartesianCross)(normal, arc);
                    (0, _cartesianJs.cartesianNormalizeInPlace)(intersection);
                    var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, _mathJs.asin)(intersection[2]);
                    if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
                }
            }
        }
        // First, determine whether the South pole is inside or outside:
        //
        // It is inside if:
        // * the polygon winds around it in a clockwise direction.
        // * the polygon does not (cumulatively) wind around it, but has a negative
        //   (counter-clockwise) area.
        //
        // Second, count the (signed) number of times a segment crosses a lambda
        // from the point to the South pole.  If it is zero, then the point is the
        // same side as the South pole.
        return (angle < -(0, _mathJs.epsilon) || angle < (0, _mathJs.epsilon) && sum < -(0, _mathJs.epsilon2)) ^ winding & 1;
    });
var _d3Array = require("d3-array");
var _cartesianJs = require("./cartesian.js");
var _mathJs = require("./math.js");
function longitude(point) {
    return (0, _mathJs.abs)(point[0]) <= (0, _mathJs.pi) ? point[0] : (0, _mathJs.sign)(point[0]) * (((0, _mathJs.abs)(point[0]) + (0, _mathJs.pi)) % (0, _mathJs.tau) - (0, _mathJs.pi));
}

},{"d3-array":"aPoQh","./cartesian.js":"h01nT","./math.js":"bttmd","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"h01nT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "spherical", ()=>spherical);
parcelHelpers.export(exports, "cartesian", ()=>cartesian);
parcelHelpers.export(exports, "cartesianDot", ()=>cartesianDot);
parcelHelpers.export(exports, "cartesianCross", ()=>cartesianCross);
// TODO return a
parcelHelpers.export(exports, "cartesianAddInPlace", ()=>cartesianAddInPlace);
parcelHelpers.export(exports, "cartesianScale", ()=>cartesianScale);
// TODO return d
parcelHelpers.export(exports, "cartesianNormalizeInPlace", ()=>cartesianNormalizeInPlace);
var _mathJs = require("./math.js");
function spherical(cartesian) {
    return [
        (0, _mathJs.atan2)(cartesian[1], cartesian[0]),
        (0, _mathJs.asin)(cartesian[2])
    ];
}
function cartesian(spherical) {
    var lambda = spherical[0], phi = spherical[1], cosPhi = (0, _mathJs.cos)(phi);
    return [
        cosPhi * (0, _mathJs.cos)(lambda),
        cosPhi * (0, _mathJs.sin)(lambda),
        (0, _mathJs.sin)(phi)
    ];
}
function cartesianDot(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function cartesianCross(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function cartesianAddInPlace(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function cartesianScale(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function cartesianNormalizeInPlace(d) {
    var l = (0, _mathJs.sqrt)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}

},{"./math.js":"bttmd","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"aq6iP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(radius) {
        var cr = (0, _mathJs.cos)(radius), delta = 2 * (0, _mathJs.radians), smallRadius = cr > 0, notHemisphere = (0, _mathJs.abs)(cr) > (0, _mathJs.epsilon); // TODO optimise for this common case
        function interpolate(from, to, direction, stream) {
            (0, _circleJs.circleStream)(stream, radius, delta, direction, from, to);
        }
        function visible(lambda, phi) {
            return (0, _mathJs.cos)(lambda) * (0, _mathJs.cos)(phi) > cr;
        }
        // Takes a line and cuts into visible segments. Return values used for polygon
        // clipping: 0 - there were intersections or the line was empty; 1 - no
        // intersections 2 - there were intersections, and the first and last segments
        // should be rejoined.
        function clipLine(stream) {
            var point0, c0, v0, v00, clean; // no intersections
            return {
                lineStart: function() {
                    v00 = v0 = false;
                    clean = 1;
                },
                point: function(lambda, phi) {
                    var point1 = [
                        lambda,
                        phi
                    ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? (0, _mathJs.pi) : -(0, _mathJs.pi)), phi) : 0;
                    if (!point0 && (v00 = v0 = v)) stream.lineStart();
                    if (v !== v0) {
                        point2 = intersect(point0, point1);
                        if (!point2 || (0, _pointEqualJsDefault.default)(point0, point2) || (0, _pointEqualJsDefault.default)(point1, point2)) point1[2] = 1;
                    }
                    if (v !== v0) {
                        clean = 0;
                        if (v) {
                            // outside going in
                            stream.lineStart();
                            point2 = intersect(point1, point0);
                            stream.point(point2[0], point2[1]);
                        } else {
                            // inside going out
                            point2 = intersect(point0, point1);
                            stream.point(point2[0], point2[1], 2);
                            stream.lineEnd();
                        }
                        point0 = point2;
                    } else if (notHemisphere && point0 && smallRadius ^ v) {
                        var t;
                        // If the codes for two points are different, or are both zero,
                        // and there this segment intersects with the small circle.
                        if (!(c & c0) && (t = intersect(point1, point0, true))) {
                            clean = 0;
                            if (smallRadius) {
                                stream.lineStart();
                                stream.point(t[0][0], t[0][1]);
                                stream.point(t[1][0], t[1][1]);
                                stream.lineEnd();
                            } else {
                                stream.point(t[1][0], t[1][1]);
                                stream.lineEnd();
                                stream.lineStart();
                                stream.point(t[0][0], t[0][1], 3);
                            }
                        }
                    }
                    if (v && (!point0 || !(0, _pointEqualJsDefault.default)(point0, point1))) stream.point(point1[0], point1[1]);
                    point0 = point1, v0 = v, c0 = c;
                },
                lineEnd: function() {
                    if (v0) stream.lineEnd();
                    point0 = null;
                },
                // Rejoin first and last segments if there were intersections and the first
                // and last points were visible.
                clean: function() {
                    return clean | (v00 && v0) << 1;
                }
            };
        }
        // Intersects the great circle between a and b with the clip circle.
        function intersect(a, b, two) {
            var pa = (0, _cartesianJs.cartesian)(a), pb = (0, _cartesianJs.cartesian)(b);
            // We have two planes, n1.p = d1 and n2.p = d2.
            // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
            var n1 = [
                1,
                0,
                0
            ], n2 = (0, _cartesianJs.cartesianCross)(pa, pb), n2n2 = (0, _cartesianJs.cartesianDot)(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
            // Two polar points.
            if (!determinant) return !two && a;
            var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = (0, _cartesianJs.cartesianCross)(n1, n2), A = (0, _cartesianJs.cartesianScale)(n1, c1), B = (0, _cartesianJs.cartesianScale)(n2, c2);
            (0, _cartesianJs.cartesianAddInPlace)(A, B);
            // Solve |p(t)|^2 = 1.
            var u = n1xn2, w = (0, _cartesianJs.cartesianDot)(A, u), uu = (0, _cartesianJs.cartesianDot)(u, u), t2 = w * w - uu * ((0, _cartesianJs.cartesianDot)(A, A) - 1);
            if (t2 < 0) return;
            var t = (0, _mathJs.sqrt)(t2), q = (0, _cartesianJs.cartesianScale)(u, (-w - t) / uu);
            (0, _cartesianJs.cartesianAddInPlace)(q, A);
            q = (0, _cartesianJs.spherical)(q);
            if (!two) return q;
            // Two intersection points.
            var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
            if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
            var delta = lambda1 - lambda0, polar = (0, _mathJs.abs)(delta - (0, _mathJs.pi)) < (0, _mathJs.epsilon), meridian = polar || delta < (0, _mathJs.epsilon);
            if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
            // Check that the first point is between a and b.
            if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, _mathJs.abs)(q[0] - lambda0) < (0, _mathJs.epsilon) ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > (0, _mathJs.pi) ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
                var q1 = (0, _cartesianJs.cartesianScale)(u, (-w + t) / uu);
                (0, _cartesianJs.cartesianAddInPlace)(q1, A);
                return [
                    q,
                    (0, _cartesianJs.spherical)(q1)
                ];
            }
        }
        // Generates a 4-bit vector representing the location of a point relative to
        // the small circle's bounding box.
        function code(lambda, phi) {
            var r = smallRadius ? radius : (0, _mathJs.pi) - radius, code = 0;
            if (lambda < -r) code |= 1; // left
            else if (lambda > r) code |= 2; // right
            if (phi < -r) code |= 4; // below
            else if (phi > r) code |= 8; // above
            return code;
        }
        return (0, _indexJsDefault.default)(visible, clipLine, interpolate, smallRadius ? [
            0,
            -radius
        ] : [
            -(0, _mathJs.pi),
            radius - (0, _mathJs.pi)
        ]);
    });
var _cartesianJs = require("../cartesian.js");
var _circleJs = require("../circle.js");
var _mathJs = require("../math.js");
var _pointEqualJs = require("../pointEqual.js");
var _pointEqualJsDefault = parcelHelpers.interopDefault(_pointEqualJs);
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);

},{"../cartesian.js":"h01nT","../circle.js":"cRnfV","../math.js":"bttmd","../pointEqual.js":"bf5VF","./index.js":"4Kd1S","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cRnfV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Generates a circle centered at [0°, 0°], with a given radius and precision.
parcelHelpers.export(exports, "circleStream", ()=>circleStream);
parcelHelpers.export(exports, "default", ()=>function() {
        var center = (0, _constantJsDefault.default)([
            0,
            0
        ]), radius = (0, _constantJsDefault.default)(90), precision = (0, _constantJsDefault.default)(2), ring, rotate, stream = {
            point: point
        };
        function point(x, y) {
            ring.push(x = rotate(x, y));
            x[0] *= (0, _mathJs.degrees), x[1] *= (0, _mathJs.degrees);
        }
        function circle() {
            var c = center.apply(this, arguments), r = radius.apply(this, arguments) * (0, _mathJs.radians), p = precision.apply(this, arguments) * (0, _mathJs.radians);
            ring = [];
            rotate = (0, _rotationJs.rotateRadians)(-c[0] * (0, _mathJs.radians), -c[1] * (0, _mathJs.radians), 0).invert;
            circleStream(stream, r, p, 1);
            c = {
                type: "Polygon",
                coordinates: [
                    ring
                ]
            };
            ring = rotate = null;
            return c;
        }
        circle.center = function(_) {
            return arguments.length ? (center = typeof _ === "function" ? _ : (0, _constantJsDefault.default)([
                +_[0],
                +_[1]
            ]), circle) : center;
        };
        circle.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), circle) : radius;
        };
        circle.precision = function(_) {
            return arguments.length ? (precision = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), circle) : precision;
        };
        return circle;
    });
var _cartesianJs = require("./cartesian.js");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _mathJs = require("./math.js");
var _rotationJs = require("./rotation.js");
function circleStream(stream, radius, delta, direction, t0, t1) {
    if (!delta) return;
    var cosRadius = (0, _mathJs.cos)(radius), sinRadius = (0, _mathJs.sin)(radius), step = direction * delta;
    if (t0 == null) {
        t0 = radius + direction * (0, _mathJs.tau);
        t1 = radius - step / 2;
    } else {
        t0 = circleRadius(cosRadius, t0);
        t1 = circleRadius(cosRadius, t1);
        if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * (0, _mathJs.tau);
    }
    for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
        point = (0, _cartesianJs.spherical)([
            cosRadius,
            -sinRadius * (0, _mathJs.cos)(t),
            -sinRadius * (0, _mathJs.sin)(t)
        ]);
        stream.point(point[0], point[1]);
    }
}
// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
    point = (0, _cartesianJs.cartesian)(point), point[0] -= cosRadius;
    (0, _cartesianJs.cartesianNormalizeInPlace)(point);
    var radius = (0, _mathJs.acos)(-point[1]);
    return ((-point[2] < 0 ? -radius : radius) + (0, _mathJs.tau) - (0, _mathJs.epsilon)) % (0, _mathJs.tau);
}

},{"./cartesian.js":"h01nT","./constant.js":"6BAz6","./math.js":"bttmd","./rotation.js":"918Qt","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"6BAz6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"918Qt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rotateRadians", ()=>rotateRadians);
parcelHelpers.export(exports, "default", ()=>function(rotate) {
        rotate = rotateRadians(rotate[0] * (0, _mathJs.radians), rotate[1] * (0, _mathJs.radians), rotate.length > 2 ? rotate[2] * (0, _mathJs.radians) : 0);
        function forward(coordinates) {
            coordinates = rotate(coordinates[0] * (0, _mathJs.radians), coordinates[1] * (0, _mathJs.radians));
            return coordinates[0] *= (0, _mathJs.degrees), coordinates[1] *= (0, _mathJs.degrees), coordinates;
        }
        forward.invert = function(coordinates) {
            coordinates = rotate.invert(coordinates[0] * (0, _mathJs.radians), coordinates[1] * (0, _mathJs.radians));
            return coordinates[0] *= (0, _mathJs.degrees), coordinates[1] *= (0, _mathJs.degrees), coordinates;
        };
        return forward;
    });
var _composeJs = require("./compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _mathJs = require("./math.js");
function rotationIdentity(lambda, phi) {
    if ((0, _mathJs.abs)(lambda) > (0, _mathJs.pi)) lambda -= Math.round(lambda / (0, _mathJs.tau)) * (0, _mathJs.tau);
    return [
        lambda,
        phi
    ];
}
rotationIdentity.invert = rotationIdentity;
function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
    return (deltaLambda %= (0, _mathJs.tau)) ? deltaPhi || deltaGamma ? (0, _composeJsDefault.default)(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma)) : rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma) : rotationIdentity;
}
function forwardRotationLambda(deltaLambda) {
    return function(lambda, phi) {
        lambda += deltaLambda;
        if ((0, _mathJs.abs)(lambda) > (0, _mathJs.pi)) lambda -= Math.round(lambda / (0, _mathJs.tau)) * (0, _mathJs.tau);
        return [
            lambda,
            phi
        ];
    };
}
function rotationLambda(deltaLambda) {
    var rotation = forwardRotationLambda(deltaLambda);
    rotation.invert = forwardRotationLambda(-deltaLambda);
    return rotation;
}
function rotationPhiGamma(deltaPhi, deltaGamma) {
    var cosDeltaPhi = (0, _mathJs.cos)(deltaPhi), sinDeltaPhi = (0, _mathJs.sin)(deltaPhi), cosDeltaGamma = (0, _mathJs.cos)(deltaGamma), sinDeltaGamma = (0, _mathJs.sin)(deltaGamma);
    function rotation(lambda, phi) {
        var cosPhi = (0, _mathJs.cos)(phi), x = (0, _mathJs.cos)(lambda) * cosPhi, y = (0, _mathJs.sin)(lambda) * cosPhi, z = (0, _mathJs.sin)(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
        return [
            (0, _mathJs.atan2)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
            (0, _mathJs.asin)(k * cosDeltaGamma + y * sinDeltaGamma)
        ];
    }
    rotation.invert = function(lambda, phi) {
        var cosPhi = (0, _mathJs.cos)(phi), x = (0, _mathJs.cos)(lambda) * cosPhi, y = (0, _mathJs.sin)(lambda) * cosPhi, z = (0, _mathJs.sin)(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
        return [
            (0, _mathJs.atan2)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
            (0, _mathJs.asin)(k * cosDeltaPhi - x * sinDeltaPhi)
        ];
    };
    return rotation;
}

},{"./compose.js":"kAsab","./math.js":"bttmd","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"kAsab":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        function compose(x, y) {
            return x = a(x, y), b(x[0], x[1]);
        }
        if (a.invert && b.invert) compose.invert = function(x, y) {
            return x = b.invert(x, y), x && a.invert(x[0], x[1]);
        };
        return compose;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"a6i2W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>clipRectangle);
var _mathJs = require("../math.js");
var _bufferJs = require("./buffer.js");
var _bufferJsDefault = parcelHelpers.interopDefault(_bufferJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _rejoinJs = require("./rejoin.js");
var _rejoinJsDefault = parcelHelpers.interopDefault(_rejoinJs);
var _d3Array = require("d3-array");
var clipMax = 1e9, clipMin = -clipMax;
function clipRectangle(x0, y0, x1, y1) {
    function visible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
    }
    function interpolate(from, to, direction, stream) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
        while ((a = (a + direction + 4) % 4) !== a1);
        else stream.point(to[0], to[1]);
    }
    function corner(p, direction) {
        return (0, _mathJs.abs)(p[0] - x0) < (0, _mathJs.epsilon) ? direction > 0 ? 0 : 3 : (0, _mathJs.abs)(p[0] - x1) < (0, _mathJs.epsilon) ? direction > 0 ? 2 : 1 : (0, _mathJs.abs)(p[1] - y0) < (0, _mathJs.epsilon) ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
    }
    function compareIntersection(a, b) {
        return comparePoint(a.x, b.x);
    }
    function comparePoint(a, b) {
        var ca = corner(a, 1), cb = corner(b, 1);
        return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
    return function(stream) {
        var activeStream = stream, bufferStream = (0, _bufferJsDefault.default)(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
        var clipStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: polygonStart,
            polygonEnd: polygonEnd
        };
        function point(x, y) {
            if (visible(x, y)) activeStream.point(x, y);
        }
        function polygonInside() {
            var winding = 0;
            for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                if (a1 <= y1) {
                    if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
            }
            return winding;
        }
        // Buffer geometry within a polygon and then clip it en masse.
        function polygonStart() {
            activeStream = bufferStream, segments = [], polygon = [], clean = true;
        }
        function polygonEnd() {
            var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = (0, _d3Array.merge)(segments)).length;
            if (cleanInside || visible) {
                stream.polygonStart();
                if (cleanInside) {
                    stream.lineStart();
                    interpolate(null, null, 1, stream);
                    stream.lineEnd();
                }
                if (visible) (0, _rejoinJsDefault.default)(segments, compareIntersection, startInside, interpolate, stream);
                stream.polygonEnd();
            }
            activeStream = stream, segments = polygon = ring = null;
        }
        function lineStart() {
            clipStream.point = linePoint;
            if (polygon) polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
        }
        // TODO rather than special-case polygons, simply handle them separately.
        // Ideally, coincident intersection points should be jittered to avoid
        // clipping issues.
        function lineEnd() {
            if (segments) {
                linePoint(x__, y__);
                if (v__ && v_) bufferStream.rejoin();
                segments.push(bufferStream.result());
            }
            clipStream.point = point;
            if (v_) activeStream.lineEnd();
        }
        function linePoint(x, y) {
            var v = visible(x, y);
            if (polygon) ring.push([
                x,
                y
            ]);
            if (first) {
                x__ = x, y__ = y, v__ = v;
                first = false;
                if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                }
            } else if (v && v_) activeStream.point(x, y);
            else {
                var a = [
                    x_ = Math.max(clipMin, Math.min(clipMax, x_)),
                    y_ = Math.max(clipMin, Math.min(clipMax, y_))
                ], b = [
                    x = Math.max(clipMin, Math.min(clipMax, x)),
                    y = Math.max(clipMin, Math.min(clipMax, y))
                ];
                if ((0, _lineJsDefault.default)(a, b, x0, y0, x1, y1)) {
                    if (!v_) {
                        activeStream.lineStart();
                        activeStream.point(a[0], a[1]);
                    }
                    activeStream.point(b[0], b[1]);
                    if (!v) activeStream.lineEnd();
                    clean = false;
                } else if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                    clean = false;
                }
            }
            x_ = x, y_ = y, v_ = v;
        }
        return clipStream;
    };
}

},{"../math.js":"bttmd","./buffer.js":"gtpJa","./line.js":"g2V9x","./rejoin.js":"cHZ3P","d3-array":[["merge","8UWhT","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"g2V9x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b, x0, y0, x1, y1) {
        var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
        r = x0 - ax;
        if (!dx && r > 0) return;
        r /= dx;
        if (dx < 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        } else if (dx > 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        }
        r = x1 - ax;
        if (!dx && r < 0) return;
        r /= dx;
        if (dx < 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        } else if (dx > 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        }
        r = y0 - ay;
        if (!dy && r > 0) return;
        r /= dy;
        if (dy < 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        } else if (dy > 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        }
        r = y1 - ay;
        if (!dy && r < 0) return;
        r /= dy;
        if (dy < 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        } else if (dy > 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        }
        if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
        if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
        return true;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"l1CAh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"aXfnq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(methods) {
        return {
            stream: transformer(methods)
        };
    });
parcelHelpers.export(exports, "transformer", ()=>transformer);
function transformer(methods) {
    return function(stream) {
        var s = new TransformStream;
        for(var key in methods)s[key] = methods[key];
        s.stream = stream;
        return s;
    };
}
function TransformStream() {}
TransformStream.prototype = {
    constructor: TransformStream,
    point: function(x, y) {
        this.stream.point(x, y);
    },
    sphere: function() {
        this.stream.sphere();
    },
    lineStart: function() {
        this.stream.lineStart();
    },
    lineEnd: function() {
        this.stream.lineEnd();
    },
    polygonStart: function() {
        this.stream.polygonStart();
    },
    polygonEnd: function() {
        this.stream.polygonEnd();
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"haKCe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fitExtent", ()=>fitExtent);
parcelHelpers.export(exports, "fitSize", ()=>fitSize);
parcelHelpers.export(exports, "fitWidth", ()=>fitWidth);
parcelHelpers.export(exports, "fitHeight", ()=>fitHeight);
var _streamJs = require("../stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var _boundsJs = require("../path/bounds.js");
var _boundsJsDefault = parcelHelpers.interopDefault(_boundsJs);
function fit(projection, fitBounds, object) {
    var clip = projection.clipExtent && projection.clipExtent();
    projection.scale(150).translate([
        0,
        0
    ]);
    if (clip != null) projection.clipExtent(null);
    (0, _streamJsDefault.default)(object, projection.stream((0, _boundsJsDefault.default)));
    fitBounds((0, _boundsJsDefault.default).result());
    if (clip != null) projection.clipExtent(clip);
    return projection;
}
function fitExtent(projection, extent, object) {
    return fit(projection, function(b) {
        var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function fitSize(projection, size, object) {
    return fitExtent(projection, [
        [
            0,
            0
        ],
        size
    ], object);
}
function fitWidth(projection, width, object) {
    return fit(projection, function(b) {
        var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function fitHeight(projection, height, object) {
    return fit(projection, function(b) {
        var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}

},{"../stream.js":"gKr6k","../path/bounds.js":"3BJkK","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"gKr6k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(object, stream) {
        if (object && streamObjectType.hasOwnProperty(object.type)) streamObjectType[object.type](object, stream);
        else streamGeometry(object, stream);
    });
function streamGeometry(geometry, stream) {
    if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) streamGeometryType[geometry.type](geometry, stream);
}
var streamObjectType = {
    Feature: function(object, stream) {
        streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)streamGeometry(features[i].geometry, stream);
    }
};
var streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)streamGeometry(geometries[i], stream);
    }
};
function streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3BJkK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var x0 = Infinity, y0 = x0, x1 = -x0, y1 = x1;
var boundsStream = {
    point: boundsPoint,
    lineStart: (0, _noopJsDefault.default),
    lineEnd: (0, _noopJsDefault.default),
    polygonStart: (0, _noopJsDefault.default),
    polygonEnd: (0, _noopJsDefault.default),
    result: function() {
        var bounds = [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x1 = y1 = -(y0 = x0 = Infinity);
        return bounds;
    }
};
function boundsPoint(x, y) {
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
}
exports.default = boundsStream;

},{"../noop.js":"eRuPB","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"iNMon":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(project, delta2) {
        return +delta2 ? resample(project, delta2) : resampleNone(project);
    });
var _cartesianJs = require("../cartesian.js");
var _mathJs = require("../math.js");
var _transformJs = require("../transform.js");
var maxDepth = 16, cosMinDistance = (0, _mathJs.cos)(30 * (0, _mathJs.radians)); // cos(minimum angular distance)
function resampleNone(project) {
    return (0, _transformJs.transformer)({
        point: function(x, y) {
            x = project(x, y);
            this.stream.point(x[0], x[1]);
        }
    });
}
function resample(project, delta2) {
    function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
        var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
        if (d2 > 4 * delta2 && depth--) {
            var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = (0, _mathJs.sqrt)(a * a + b * b + c * c), phi2 = (0, _mathJs.asin)(c /= m), lambda2 = (0, _mathJs.abs)((0, _mathJs.abs)(c) - 1) < (0, _mathJs.epsilon) || (0, _mathJs.abs)(lambda0 - lambda1) < (0, _mathJs.epsilon) ? (lambda0 + lambda1) / 2 : (0, _mathJs.atan2)(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > delta2 // perpendicular projected distance
             || (0, _mathJs.abs)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
             || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                stream.point(x2, y2);
                resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
            }
        }
    }
    return function(stream) {
        var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
        var resampleStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.polygonStart();
                resampleStream.lineStart = ringStart;
            },
            polygonEnd: function() {
                stream.polygonEnd();
                resampleStream.lineStart = lineStart;
            }
        };
        function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
        }
        function lineStart() {
            x0 = NaN;
            resampleStream.point = linePoint;
            stream.lineStart();
        }
        function linePoint(lambda, phi) {
            var c = (0, _cartesianJs.cartesian)([
                lambda,
                phi
            ]), p = project(lambda, phi);
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
            stream.point(x0, y0);
        }
        function lineEnd() {
            resampleStream.point = point;
            stream.lineEnd();
        }
        function ringStart() {
            lineStart();
            resampleStream.point = ringPoint;
            resampleStream.lineEnd = ringEnd;
        }
        function ringPoint(lambda, phi) {
            linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resampleStream.point = linePoint;
        }
        function ringEnd() {
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
            resampleStream.lineEnd = lineEnd;
            lineEnd();
        }
        return resampleStream;
    };
}

},{"../cartesian.js":"h01nT","../math.js":"bttmd","../transform.js":"aXfnq","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"fvx6V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cylindricalEqualAreaRaw", ()=>cylindricalEqualAreaRaw);
var _mathJs = require("../math.js");
function cylindricalEqualAreaRaw(phi0) {
    var cosPhi0 = (0, _mathJs.cos)(phi0);
    function forward(lambda, phi) {
        return [
            lambda * cosPhi0,
            (0, _mathJs.sin)(phi) / cosPhi0
        ];
    }
    forward.invert = function(x, y) {
        return [
            x / cosPhi0,
            (0, _mathJs.asin)(y * cosPhi0)
        ];
    };
    return forward;
}

},{"../math.js":"bttmd","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"aBNXm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
parcelHelpers.export(exports, "default", ()=>function() {
        var cache, cacheStream, lower48 = (0, _albersJsDefault.default)(), lower48Point, alaska = (0, _conicEqualAreaJsDefault.default)().rotate([
            154,
            0
        ]).center([
            -2,
            58.5
        ]).parallels([
            55,
            65
        ]), alaskaPoint, hawaii = (0, _conicEqualAreaJsDefault.default)().rotate([
            157,
            0
        ]).center([
            -3,
            19.9
        ]).parallels([
            8,
            18
        ]), hawaiiPoint, point, pointStream = {
            point: function(x, y) {
                point = [
                    x,
                    y
                ];
            }
        };
        function albersUsa(coordinates) {
            var x = coordinates[0], y = coordinates[1];
            return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
        }
        albersUsa.invert = function(coordinates) {
            var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
            return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
        };
        albersUsa.stream = function(stream) {
            return cache && cacheStream === stream ? cache : cache = multiplex([
                lower48.stream(cacheStream = stream),
                alaska.stream(stream),
                hawaii.stream(stream)
            ]);
        };
        albersUsa.precision = function(_) {
            if (!arguments.length) return lower48.precision();
            lower48.precision(_), alaska.precision(_), hawaii.precision(_);
            return reset();
        };
        albersUsa.scale = function(_) {
            if (!arguments.length) return lower48.scale();
            lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
            return albersUsa.translate(lower48.translate());
        };
        albersUsa.translate = function(_) {
            if (!arguments.length) return lower48.translate();
            var k = lower48.scale(), x = +_[0], y = +_[1];
            lower48Point = lower48.translate(_).clipExtent([
                [
                    x - 0.455 * k,
                    y - 0.238 * k
                ],
                [
                    x + 0.455 * k,
                    y + 0.238 * k
                ]
            ]).stream(pointStream);
            alaskaPoint = alaska.translate([
                x - 0.307 * k,
                y + 0.201 * k
            ]).clipExtent([
                [
                    x - 0.425 * k + (0, _mathJs.epsilon),
                    y + 0.120 * k + (0, _mathJs.epsilon)
                ],
                [
                    x - 0.214 * k - (0, _mathJs.epsilon),
                    y + 0.234 * k - (0, _mathJs.epsilon)
                ]
            ]).stream(pointStream);
            hawaiiPoint = hawaii.translate([
                x - 0.205 * k,
                y + 0.212 * k
            ]).clipExtent([
                [
                    x - 0.214 * k + (0, _mathJs.epsilon),
                    y + 0.166 * k + (0, _mathJs.epsilon)
                ],
                [
                    x - 0.115 * k - (0, _mathJs.epsilon),
                    y + 0.234 * k - (0, _mathJs.epsilon)
                ]
            ]).stream(pointStream);
            return reset();
        };
        albersUsa.fitExtent = function(extent, object) {
            return (0, _fitJs.fitExtent)(albersUsa, extent, object);
        };
        albersUsa.fitSize = function(size, object) {
            return (0, _fitJs.fitSize)(albersUsa, size, object);
        };
        albersUsa.fitWidth = function(width, object) {
            return (0, _fitJs.fitWidth)(albersUsa, width, object);
        };
        albersUsa.fitHeight = function(height, object) {
            return (0, _fitJs.fitHeight)(albersUsa, height, object);
        };
        function reset() {
            cache = cacheStream = null;
            return albersUsa;
        }
        return albersUsa.scale(1070);
    });
var _mathJs = require("../math.js");
var _albersJs = require("./albers.js");
var _albersJsDefault = parcelHelpers.interopDefault(_albersJs);
var _conicEqualAreaJs = require("./conicEqualArea.js");
var _conicEqualAreaJsDefault = parcelHelpers.interopDefault(_conicEqualAreaJs);
var _fitJs = require("./fit.js");
// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
    var n = streams.length;
    return {
        point: function(x, y) {
            var i = -1;
            while(++i < n)streams[i].point(x, y);
        },
        sphere: function() {
            var i = -1;
            while(++i < n)streams[i].sphere();
        },
        lineStart: function() {
            var i = -1;
            while(++i < n)streams[i].lineStart();
        },
        lineEnd: function() {
            var i = -1;
            while(++i < n)streams[i].lineEnd();
        },
        polygonStart: function() {
            var i = -1;
            while(++i < n)streams[i].polygonStart();
        },
        polygonEnd: function() {
            var i = -1;
            while(++i < n)streams[i].polygonEnd();
        }
    };
}

},{"../math.js":"bttmd","./albers.js":"dgYrm","./conicEqualArea.js":"aC8Z6","./fit.js":"haKCe","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"9VNXC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "azimuthalEqualAreaRaw", ()=>azimuthalEqualAreaRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(azimuthalEqualAreaRaw).scale(124.75).clipAngle(179.999);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var azimuthalEqualAreaRaw = (0, _azimuthalJs.azimuthalRaw)(function(cxcy) {
    return (0, _mathJs.sqrt)(2 / (1 + cxcy));
});
azimuthalEqualAreaRaw.invert = (0, _azimuthalJs.azimuthalInvert)(function(z) {
    return 2 * (0, _mathJs.asin)(z / 2);
});

},{"../math.js":"bttmd","./azimuthal.js":"hiKNz","./index.js":"1wC1W","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hiKNz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "azimuthalRaw", ()=>azimuthalRaw);
parcelHelpers.export(exports, "azimuthalInvert", ()=>azimuthalInvert);
var _mathJs = require("../math.js");
function azimuthalRaw(scale) {
    return function(x, y) {
        var cx = (0, _mathJs.cos)(x), cy = (0, _mathJs.cos)(y), k = scale(cx * cy);
        if (k === Infinity) return [
            2,
            0
        ];
        return [
            k * cy * (0, _mathJs.sin)(x),
            k * (0, _mathJs.sin)(y)
        ];
    };
}
function azimuthalInvert(angle) {
    return function(x, y) {
        var z = (0, _mathJs.sqrt)(x * x + y * y), c = angle(z), sc = (0, _mathJs.sin)(c), cc = (0, _mathJs.cos)(c);
        return [
            (0, _mathJs.atan2)(x * sc, z * cc),
            (0, _mathJs.asin)(z && y * sc / z)
        ];
    };
}

},{"../math.js":"bttmd","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"94amM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "azimuthalEquidistantRaw", ()=>azimuthalEquidistantRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(azimuthalEquidistantRaw).scale(79.4188).clipAngle(179.999);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var azimuthalEquidistantRaw = (0, _azimuthalJs.azimuthalRaw)(function(c) {
    return (c = (0, _mathJs.acos)(c)) && c / (0, _mathJs.sin)(c);
});
azimuthalEquidistantRaw.invert = (0, _azimuthalJs.azimuthalInvert)(function(z) {
    return z;
});

},{"../math.js":"bttmd","./azimuthal.js":"hiKNz","./index.js":"1wC1W","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"aYIaH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicConformalRaw", ()=>conicConformalRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicJs.conicProjection)(conicConformalRaw).scale(109.5).parallels([
            30,
            30
        ]);
    });
var _mathJs = require("../math.js");
var _conicJs = require("./conic.js");
var _mercatorJs = require("./mercator.js");
function tany(y) {
    return (0, _mathJs.tan)(((0, _mathJs.halfPi) + y) / 2);
}
function conicConformalRaw(y0, y1) {
    var cy0 = (0, _mathJs.cos)(y0), n = y0 === y1 ? (0, _mathJs.sin)(y0) : (0, _mathJs.log)(cy0 / (0, _mathJs.cos)(y1)) / (0, _mathJs.log)(tany(y1) / tany(y0)), f = cy0 * (0, _mathJs.pow)(tany(y0), n) / n;
    if (!n) return 0, _mercatorJs.mercatorRaw;
    function project(x, y) {
        if (f > 0) {
            if (y < -(0, _mathJs.halfPi) + (0, _mathJs.epsilon)) y = -(0, _mathJs.halfPi) + (0, _mathJs.epsilon);
        } else if (y > (0, _mathJs.halfPi) - (0, _mathJs.epsilon)) y = (0, _mathJs.halfPi) - (0, _mathJs.epsilon);
        var r = f / (0, _mathJs.pow)(tany(y), n);
        return [
            r * (0, _mathJs.sin)(n * x),
            f - r * (0, _mathJs.cos)(n * x)
        ];
    }
    project.invert = function(x, y) {
        var fy = f - y, r = (0, _mathJs.sign)(n) * (0, _mathJs.sqrt)(x * x + fy * fy), l = (0, _mathJs.atan2)(x, (0, _mathJs.abs)(fy)) * (0, _mathJs.sign)(fy);
        if (fy * n < 0) l -= (0, _mathJs.pi) * (0, _mathJs.sign)(x) * (0, _mathJs.sign)(fy);
        return [
            l / n,
            2 * (0, _mathJs.atan)((0, _mathJs.pow)(f / r, 1 / n)) - (0, _mathJs.halfPi)
        ];
    };
    return project;
}

},{"../math.js":"bttmd","./conic.js":"juhK7","./mercator.js":"dPQja","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dPQja":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mercatorRaw", ()=>mercatorRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return mercatorProjection(mercatorRaw).scale(961 / (0, _mathJs.tau));
    });
parcelHelpers.export(exports, "mercatorProjection", ()=>mercatorProjection);
var _mathJs = require("../math.js");
var _rotationJs = require("../rotation.js");
var _rotationJsDefault = parcelHelpers.interopDefault(_rotationJs);
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function mercatorRaw(lambda, phi) {
    return [
        lambda,
        (0, _mathJs.log)((0, _mathJs.tan)(((0, _mathJs.halfPi) + phi) / 2))
    ];
}
mercatorRaw.invert = function(x, y) {
    return [
        x,
        2 * (0, _mathJs.atan)((0, _mathJs.exp)(y)) - (0, _mathJs.halfPi)
    ];
};
function mercatorProjection(project) {
    var m = (0, _indexJsDefault.default)(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1; // clip extent
    m.scale = function(_) {
        return arguments.length ? (scale(_), reclip()) : scale();
    };
    m.translate = function(_) {
        return arguments.length ? (translate(_), reclip()) : translate();
    };
    m.center = function(_) {
        return arguments.length ? (center(_), reclip()) : center();
    };
    m.clipExtent = function(_) {
        return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    function reclip() {
        var k = (0, _mathJs.pi) * scale(), t = m((0, _rotationJsDefault.default)(m.rotate()).invert([
            0,
            0
        ]));
        return clipExtent(x0 == null ? [
            [
                t[0] - k,
                t[1] - k
            ],
            [
                t[0] + k,
                t[1] + k
            ]
        ] : project === mercatorRaw ? [
            [
                Math.max(t[0] - k, x0),
                y0
            ],
            [
                Math.min(t[0] + k, x1),
                y1
            ]
        ] : [
            [
                x0,
                Math.max(t[1] - k, y0)
            ],
            [
                x1,
                Math.min(t[1] + k, y1)
            ]
        ]);
    }
    return reclip();
}

},{"../math.js":"bttmd","../rotation.js":"918Qt","./index.js":"1wC1W","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"2B05S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicEquidistantRaw", ()=>conicEquidistantRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicJs.conicProjection)(conicEquidistantRaw).scale(131.154).center([
            0,
            13.9389
        ]);
    });
var _mathJs = require("../math.js");
var _conicJs = require("./conic.js");
var _equirectangularJs = require("./equirectangular.js");
function conicEquidistantRaw(y0, y1) {
    var cy0 = (0, _mathJs.cos)(y0), n = y0 === y1 ? (0, _mathJs.sin)(y0) : (cy0 - (0, _mathJs.cos)(y1)) / (y1 - y0), g = cy0 / n + y0;
    if ((0, _mathJs.abs)(n) < (0, _mathJs.epsilon)) return 0, _equirectangularJs.equirectangularRaw;
    function project(x, y) {
        var gy = g - y, nx = n * x;
        return [
            gy * (0, _mathJs.sin)(nx),
            g - gy * (0, _mathJs.cos)(nx)
        ];
    }
    project.invert = function(x, y) {
        var gy = g - y, l = (0, _mathJs.atan2)(x, (0, _mathJs.abs)(gy)) * (0, _mathJs.sign)(gy);
        if (gy * n < 0) l -= (0, _mathJs.pi) * (0, _mathJs.sign)(x) * (0, _mathJs.sign)(gy);
        return [
            l / n,
            g - (0, _mathJs.sign)(n) * (0, _mathJs.sqrt)(x * x + gy * gy)
        ];
    };
    return project;
}

},{"../math.js":"bttmd","./conic.js":"juhK7","./equirectangular.js":"f7TSK","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"f7TSK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "equirectangularRaw", ()=>equirectangularRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(equirectangularRaw).scale(152.63);
    });
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function equirectangularRaw(lambda, phi) {
    return [
        lambda,
        phi
    ];
}
equirectangularRaw.invert = equirectangularRaw;

},{"./index.js":"1wC1W","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"jW12c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "equalEarthRaw", ()=>equalEarthRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(equalEarthRaw).scale(177.158);
    });
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _mathJs = require("../math.js");
var A1 = 1.340264, A2 = -0.081106, A3 = 0.000893, A4 = 0.003796, M = (0, _mathJs.sqrt)(3) / 2, iterations = 12;
function equalEarthRaw(lambda, phi) {
    var l = (0, _mathJs.asin)(M * (0, _mathJs.sin)(phi)), l2 = l * l, l6 = l2 * l2 * l2;
    return [
        lambda * (0, _mathJs.cos)(l) / (M * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2))),
        l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2))
    ];
}
equalEarthRaw.invert = function(x, y) {
    var l = y, l2 = l * l, l6 = l2 * l2 * l2;
    for(var i = 0, delta, fy, fpy; i < iterations; ++i){
        fy = l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2)) - y;
        fpy = A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2);
        l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
        if ((0, _mathJs.abs)(delta) < (0, _mathJs.epsilon2)) break;
    }
    return [
        M * x * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2)) / (0, _mathJs.cos)(l),
        (0, _mathJs.asin)((0, _mathJs.sin)(l) / M)
    ];
};

},{"./index.js":"1wC1W","../math.js":"bttmd","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hRfOp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gnomonicRaw", ()=>gnomonicRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(gnomonicRaw).scale(144.049).clipAngle(60);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function gnomonicRaw(x, y) {
    var cy = (0, _mathJs.cos)(y), k = (0, _mathJs.cos)(x) * cy;
    return [
        cy * (0, _mathJs.sin)(x) / k,
        (0, _mathJs.sin)(y) / k
    ];
}
gnomonicRaw.invert = (0, _azimuthalJs.azimuthalInvert)((0, _mathJs.atan));

},{"../math.js":"bttmd","./azimuthal.js":"hiKNz","./index.js":"1wC1W","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"aZqPk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, alpha = 0, ca, sa, x0 = null, y0, x1, y1, kx = 1, ky = 1, transform = (0, _transformJs.transformer)({
            point: function(x, y) {
                var p = projection([
                    x,
                    y
                ]);
                this.stream.point(p[0], p[1]);
            }
        }), postclip = (0, _identityJsDefault.default), cache, cacheStream;
        function reset() {
            kx = k * sx;
            ky = k * sy;
            cache = cacheStream = null;
            return projection;
        }
        function projection(p) {
            var x = p[0] * kx, y = p[1] * ky;
            if (alpha) {
                var t = y * ca - x * sa;
                x = x * ca + y * sa;
                y = t;
            }
            return [
                x + tx,
                y + ty
            ];
        }
        projection.invert = function(p) {
            var x = p[0] - tx, y = p[1] - ty;
            if (alpha) {
                var t = y * ca + x * sa;
                x = x * ca - y * sa;
                y = t;
            }
            return [
                x / kx,
                y / ky
            ];
        };
        projection.stream = function(stream) {
            return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
        };
        projection.postclip = function(_) {
            return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
        };
        projection.clipExtent = function(_) {
            return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, _identityJsDefault.default) : (0, _rectangleJsDefault.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        };
        projection.scale = function(_) {
            return arguments.length ? (k = +_, reset()) : k;
        };
        projection.translate = function(_) {
            return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [
                tx,
                ty
            ];
        };
        projection.angle = function(_) {
            return arguments.length ? (alpha = _ % 360 * (0, _mathJs.radians), sa = (0, _mathJs.sin)(alpha), ca = (0, _mathJs.cos)(alpha), reset()) : alpha * (0, _mathJs.degrees);
        };
        projection.reflectX = function(_) {
            return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
        };
        projection.reflectY = function(_) {
            return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
        };
        projection.fitExtent = function(extent, object) {
            return (0, _fitJs.fitExtent)(projection, extent, object);
        };
        projection.fitSize = function(size, object) {
            return (0, _fitJs.fitSize)(projection, size, object);
        };
        projection.fitWidth = function(width, object) {
            return (0, _fitJs.fitWidth)(projection, width, object);
        };
        projection.fitHeight = function(height, object) {
            return (0, _fitJs.fitHeight)(projection, height, object);
        };
        return projection;
    });
var _rectangleJs = require("../clip/rectangle.js");
var _rectangleJsDefault = parcelHelpers.interopDefault(_rectangleJs);
var _identityJs = require("../identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _transformJs = require("../transform.js");
var _fitJs = require("./fit.js");
var _mathJs = require("../math.js");

},{"../clip/rectangle.js":"a6i2W","../identity.js":"l1CAh","../transform.js":"aXfnq","./fit.js":"haKCe","../math.js":"bttmd","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"56P6U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "naturalEarth1Raw", ()=>naturalEarth1Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(naturalEarth1Raw).scale(175.295);
    });
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _mathJs = require("../math.js");
function naturalEarth1Raw(lambda, phi) {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    return [
        lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
        phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
    ];
}
naturalEarth1Raw.invert = function(x, y) {
    var phi = y, i = 25, delta;
    do {
        var phi2 = phi * phi, phi4 = phi2 * phi2;
        phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.045255 + phi4 * (-0.311325 + 0.259866 * phi2 - 0.005916 * 11 * phi4)));
    }while ((0, _mathJs.abs)(delta) > (0, _mathJs.epsilon) && --i > 0);
    return [
        x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
        phi
    ];
};

},{"./index.js":"1wC1W","../math.js":"bttmd","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8EN5n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orthographicRaw", ()=>orthographicRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(orthographicRaw).scale(249.5).clipAngle(90 + (0, _mathJs.epsilon));
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function orthographicRaw(x, y) {
    return [
        (0, _mathJs.cos)(y) * (0, _mathJs.sin)(x),
        (0, _mathJs.sin)(y)
    ];
}
orthographicRaw.invert = (0, _azimuthalJs.azimuthalInvert)((0, _mathJs.asin));

},{"../math.js":"bttmd","./azimuthal.js":"hiKNz","./index.js":"1wC1W","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cM6Ml":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(projection, context) {
        let digits = 3, pointRadius = 4.5, projectionStream, contextStream;
        function path(object) {
            if (object) {
                if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
                (0, _streamJsDefault.default)(object, projectionStream(contextStream));
            }
            return contextStream.result();
        }
        path.area = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _areaJsDefault.default)));
            return (0, _areaJsDefault.default).result();
        };
        path.measure = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _measureJsDefault.default)));
            return (0, _measureJsDefault.default).result();
        };
        path.bounds = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _boundsJsDefault.default)));
            return (0, _boundsJsDefault.default).result();
        };
        path.centroid = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _centroidJsDefault.default)));
            return (0, _centroidJsDefault.default).result();
        };
        path.projection = function(_) {
            if (!arguments.length) return projection;
            projectionStream = _ == null ? (projection = null, _identityJsDefault.default) : (projection = _).stream;
            return path;
        };
        path.context = function(_) {
            if (!arguments.length) return context;
            contextStream = _ == null ? (context = null, new (0, _stringJsDefault.default)(digits)) : new (0, _contextJsDefault.default)(context = _);
            if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
            return path;
        };
        path.pointRadius = function(_) {
            if (!arguments.length) return pointRadius;
            pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
            return path;
        };
        path.digits = function(_) {
            if (!arguments.length) return digits;
            if (_ == null) digits = null;
            else {
                const d = Math.floor(_);
                if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
                digits = d;
            }
            if (context === null) contextStream = new (0, _stringJsDefault.default)(digits);
            return path;
        };
        return path.projection(projection).digits(digits).context(context);
    });
var _identityJs = require("../identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _streamJs = require("../stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _boundsJs = require("./bounds.js");
var _boundsJsDefault = parcelHelpers.interopDefault(_boundsJs);
var _centroidJs = require("./centroid.js");
var _centroidJsDefault = parcelHelpers.interopDefault(_centroidJs);
var _contextJs = require("./context.js");
var _contextJsDefault = parcelHelpers.interopDefault(_contextJs);
var _measureJs = require("./measure.js");
var _measureJsDefault = parcelHelpers.interopDefault(_measureJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);

},{"../identity.js":"l1CAh","../stream.js":"gKr6k","./area.js":"aIDib","./bounds.js":"3BJkK","./centroid.js":"1LWuu","./context.js":"emJ0O","./measure.js":"gv4Wp","./string.js":"54Snt","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"aIDib":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Array = require("d3-array");
var _mathJs = require("../math.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var areaSum = new (0, _d3Array.Adder)(), areaRingSum = new (0, _d3Array.Adder)(), x00, y00, x0, y0;
var areaStream = {
    point: (0, _noopJsDefault.default),
    lineStart: (0, _noopJsDefault.default),
    lineEnd: (0, _noopJsDefault.default),
    polygonStart: function() {
        areaStream.lineStart = areaRingStart;
        areaStream.lineEnd = areaRingEnd;
    },
    polygonEnd: function() {
        areaStream.lineStart = areaStream.lineEnd = areaStream.point = (0, _noopJsDefault.default);
        areaSum.add((0, _mathJs.abs)(areaRingSum));
        areaRingSum = new (0, _d3Array.Adder)();
    },
    result: function() {
        var area = areaSum / 2;
        areaSum = new (0, _d3Array.Adder)();
        return area;
    }
};
function areaRingStart() {
    areaStream.point = areaPointFirst;
}
function areaPointFirst(x, y) {
    areaStream.point = areaPoint;
    x00 = x0 = x, y00 = y0 = y;
}
function areaPoint(x, y) {
    areaRingSum.add(y0 * x - x0 * y);
    x0 = x, y0 = y;
}
function areaRingEnd() {
    areaPoint(x00, y00);
}
exports.default = areaStream;

},{"d3-array":"aPoQh","../math.js":"bttmd","../noop.js":"eRuPB","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"1LWuu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
// TODO Enforce positive area for exterior, negative area for interior?
var X0 = 0, Y0 = 0, Z0 = 0, X1 = 0, Y1 = 0, Z1 = 0, X2 = 0, Y2 = 0, Z2 = 0, x00, y00, x0, y0;
var centroidStream = {
    point: centroidPoint,
    lineStart: centroidLineStart,
    lineEnd: centroidLineEnd,
    polygonStart: function() {
        centroidStream.lineStart = centroidRingStart;
        centroidStream.lineEnd = centroidRingEnd;
    },
    polygonEnd: function() {
        centroidStream.point = centroidPoint;
        centroidStream.lineStart = centroidLineStart;
        centroidStream.lineEnd = centroidLineEnd;
    },
    result: function() {
        var centroid = Z2 ? [
            X2 / Z2,
            Y2 / Z2
        ] : Z1 ? [
            X1 / Z1,
            Y1 / Z1
        ] : Z0 ? [
            X0 / Z0,
            Y0 / Z0
        ] : [
            NaN,
            NaN
        ];
        X0 = Y0 = Z0 = X1 = Y1 = Z1 = X2 = Y2 = Z2 = 0;
        return centroid;
    }
};
function centroidPoint(x, y) {
    X0 += x;
    Y0 += y;
    ++Z0;
}
function centroidLineStart() {
    centroidStream.point = centroidPointFirstLine;
}
function centroidPointFirstLine(x, y) {
    centroidStream.point = centroidPointLine;
    centroidPoint(x0 = x, y0 = y);
}
function centroidPointLine(x, y) {
    var dx = x - x0, dy = y - y0, z = (0, _mathJs.sqrt)(dx * dx + dy * dy);
    X1 += z * (x0 + x) / 2;
    Y1 += z * (y0 + y) / 2;
    Z1 += z;
    centroidPoint(x0 = x, y0 = y);
}
function centroidLineEnd() {
    centroidStream.point = centroidPoint;
}
function centroidRingStart() {
    centroidStream.point = centroidPointFirstRing;
}
function centroidRingEnd() {
    centroidPointRing(x00, y00);
}
function centroidPointFirstRing(x, y) {
    centroidStream.point = centroidPointRing;
    centroidPoint(x00 = x0 = x, y00 = y0 = y);
}
function centroidPointRing(x, y) {
    var dx = x - x0, dy = y - y0, z = (0, _mathJs.sqrt)(dx * dx + dy * dy);
    X1 += z * (x0 + x) / 2;
    Y1 += z * (y0 + y) / 2;
    Z1 += z;
    z = y0 * x - x0 * y;
    X2 += z * (x0 + x);
    Y2 += z * (y0 + y);
    Z2 += z * 3;
    centroidPoint(x0 = x, y0 = y);
}
exports.default = centroidStream;

},{"../math.js":"bttmd","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"emJ0O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PathContext);
var _mathJs = require("../math.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
function PathContext(context) {
    this._context = context;
}
PathContext.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, _mathJs.tau));
                break;
        }
    },
    result: (0, _noopJsDefault.default)
};

},{"../math.js":"bttmd","../noop.js":"eRuPB","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"gv4Wp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Array = require("d3-array");
var _mathJs = require("../math.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var lengthSum = new (0, _d3Array.Adder)(), lengthRing, x00, y00, x0, y0;
var lengthStream = {
    point: (0, _noopJsDefault.default),
    lineStart: function() {
        lengthStream.point = lengthPointFirst;
    },
    lineEnd: function() {
        if (lengthRing) lengthPoint(x00, y00);
        lengthStream.point = (0, _noopJsDefault.default);
    },
    polygonStart: function() {
        lengthRing = true;
    },
    polygonEnd: function() {
        lengthRing = null;
    },
    result: function() {
        var length = +lengthSum;
        lengthSum = new (0, _d3Array.Adder)();
        return length;
    }
};
function lengthPointFirst(x, y) {
    lengthStream.point = lengthPoint;
    x00 = x0 = x, y00 = y0 = y;
}
function lengthPoint(x, y) {
    x0 -= x, y0 -= y;
    lengthSum.add((0, _mathJs.sqrt)(x0 * x0 + y0 * y0));
    x0 = x, y0 = y;
}
exports.default = lengthStream;

},{"d3-array":"aPoQh","../math.js":"bttmd","../noop.js":"eRuPB","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"54Snt":[function(require,module,exports,__globalThis) {
// Simple caching for constant-radius points.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let cacheDigits, cacheAppend, cacheRadius, cacheCircle;
class PathString {
    constructor(digits){
        this._append = digits == null ? append : appendRound(digits);
        this._radius = 4.5;
        this._ = "";
    }
    pointRadius(_) {
        this._radius = +_;
        return this;
    }
    polygonStart() {
        this._line = 0;
    }
    polygonEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line === 0) this._ += "Z";
        this._point = NaN;
    }
    point(x, y) {
        switch(this._point){
            case 0:
                this._append`M${x},${y}`;
                this._point = 1;
                break;
            case 1:
                this._append`L${x},${y}`;
                break;
            default:
                this._append`M${x},${y}`;
                if (this._radius !== cacheRadius || this._append !== cacheAppend) {
                    const r = this._radius;
                    const s = this._;
                    this._ = ""; // stash the old string so we can cache the circle path fragment
                    this._append`m0,${r}a${r},${r} 0 1,1 0,${-2 * r}a${r},${r} 0 1,1 0,${2 * r}z`;
                    cacheRadius = r;
                    cacheAppend = this._append;
                    cacheCircle = this._;
                    this._ = s;
                }
                this._ += cacheCircle;
                break;
        }
    }
    result() {
        const result = this._;
        this._ = "";
        return result.length ? result : null;
    }
}
exports.default = PathString;
function append(strings) {
    let i = 1;
    this._ += strings[0];
    for(const j = strings.length; i < j; ++i)this._ += arguments[i] + strings[i];
}
function appendRound(digits) {
    const d = Math.floor(digits);
    if (!(d >= 0)) throw new RangeError(`invalid digits: ${digits}`);
    if (d > 15) return append;
    if (d !== cacheDigits) {
        const k = 10 ** d;
        cacheDigits = d;
        cacheAppend = function append(strings) {
            let i = 1;
            this._ += strings[0];
            for(const j = strings.length; i < j; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
        };
    }
    return cacheAppend;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bwyJN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stereographicRaw", ()=>stereographicRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(stereographicRaw).scale(250).clipAngle(142);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function stereographicRaw(x, y) {
    var cy = (0, _mathJs.cos)(y), k = 1 + (0, _mathJs.cos)(x) * cy;
    return [
        cy * (0, _mathJs.sin)(x) / k,
        (0, _mathJs.sin)(y) / k
    ];
}
stereographicRaw.invert = (0, _azimuthalJs.azimuthalInvert)(function(z) {
    return 2 * (0, _mathJs.atan)(z);
});

},{"../math.js":"bttmd","./azimuthal.js":"hiKNz","./index.js":"1wC1W","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hLM9w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transverseMercatorRaw", ()=>transverseMercatorRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        var m = (0, _mercatorJs.mercatorProjection)(transverseMercatorRaw), center = m.center, rotate = m.rotate;
        m.center = function(_) {
            return arguments.length ? center([
                -_[1],
                _[0]
            ]) : (_ = center(), [
                _[1],
                -_[0]
            ]);
        };
        m.rotate = function(_) {
            return arguments.length ? rotate([
                _[0],
                _[1],
                _.length > 2 ? _[2] + 90 : 90
            ]) : (_ = rotate(), [
                _[0],
                _[1],
                _[2] - 90
            ]);
        };
        return rotate([
            0,
            0,
            90
        ]).scale(159.155);
    });
var _mathJs = require("../math.js");
var _mercatorJs = require("./mercator.js");
function transverseMercatorRaw(lambda, phi) {
    return [
        (0, _mathJs.log)((0, _mathJs.tan)(((0, _mathJs.halfPi) + phi) / 2)),
        -lambda
    ];
}
transverseMercatorRaw.invert = function(x, y) {
    return [
        -y,
        2 * (0, _mathJs.atan)((0, _mathJs.exp)(x)) - (0, _mathJs.halfPi)
    ];
};

},{"../math.js":"bttmd","./mercator.js":"dPQja","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"6UNb9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mollweideBromleyTheta", ()=>mollweideBromleyTheta);
parcelHelpers.export(exports, "mollweideBromleyRaw", ()=>mollweideBromleyRaw);
parcelHelpers.export(exports, "mollweideRaw", ()=>mollweideRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(mollweideRaw).scale(169.529);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function mollweideBromleyTheta(cp, phi) {
    var cpsinPhi = cp * (0, _mathJs.sin)(phi), i = 30, delta;
    do phi -= delta = (phi + (0, _mathJs.sin)(phi) - cpsinPhi) / (1 + (0, _mathJs.cos)(phi));
    while ((0, _mathJs.abs)(delta) > (0, _mathJs.epsilon) && --i > 0);
    return phi / 2;
}
function mollweideBromleyRaw(cx, cy, cp) {
    function forward(lambda, phi) {
        return [
            cx * lambda * (0, _mathJs.cos)(phi = mollweideBromleyTheta(cp, phi)),
            cy * (0, _mathJs.sin)(phi)
        ];
    }
    forward.invert = function(x, y) {
        return y = (0, _mathJs.asin)(y / cy), [
            x / (cx * (0, _mathJs.cos)(y)),
            (0, _mathJs.asin)((2 * y + (0, _mathJs.sin)(2 * y)) / cp)
        ];
    };
    return forward;
}
var mollweideRaw = mollweideBromleyRaw((0, _mathJs.sqrt2) / (0, _mathJs.halfPi), (0, _mathJs.sqrt2), (0, _mathJs.pi));

},{"d3-geo":[["geoProjection","1wC1W","default"]],"./math.js":"dg5To","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dg5To":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abs", ()=>abs);
parcelHelpers.export(exports, "atan", ()=>atan);
parcelHelpers.export(exports, "atan2", ()=>atan2);
parcelHelpers.export(exports, "ceil", ()=>ceil);
parcelHelpers.export(exports, "cos", ()=>cos);
parcelHelpers.export(exports, "exp", ()=>exp);
parcelHelpers.export(exports, "floor", ()=>floor);
parcelHelpers.export(exports, "log", ()=>log);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "pow", ()=>pow);
parcelHelpers.export(exports, "round", ()=>round);
parcelHelpers.export(exports, "sign", ()=>sign);
parcelHelpers.export(exports, "sin", ()=>sin);
parcelHelpers.export(exports, "tan", ()=>tan);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
parcelHelpers.export(exports, "epsilon2", ()=>epsilon2);
parcelHelpers.export(exports, "pi", ()=>pi);
parcelHelpers.export(exports, "halfPi", ()=>halfPi);
parcelHelpers.export(exports, "quarterPi", ()=>quarterPi);
parcelHelpers.export(exports, "sqrt1_2", ()=>sqrt1_2);
parcelHelpers.export(exports, "sqrt2", ()=>sqrt2);
parcelHelpers.export(exports, "sqrtPi", ()=>sqrtPi);
parcelHelpers.export(exports, "tau", ()=>tau);
parcelHelpers.export(exports, "degrees", ()=>degrees);
parcelHelpers.export(exports, "radians", ()=>radians);
parcelHelpers.export(exports, "sinci", ()=>sinci);
parcelHelpers.export(exports, "asin", ()=>asin);
parcelHelpers.export(exports, "acos", ()=>acos);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
parcelHelpers.export(exports, "tanh", ()=>tanh);
parcelHelpers.export(exports, "sinh", ()=>sinh);
parcelHelpers.export(exports, "cosh", ()=>cosh);
parcelHelpers.export(exports, "arsinh", ()=>arsinh);
parcelHelpers.export(exports, "arcosh", ()=>arcosh);
var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var ceil = Math.ceil;
var cos = Math.cos;
var exp = Math.exp;
var floor = Math.floor;
var log = Math.log;
var max = Math.max;
var min = Math.min;
var pow = Math.pow;
var round = Math.round;
var sign = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var sin = Math.sin;
var tan = Math.tan;
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var sqrt1_2 = Math.SQRT1_2;
var sqrt2 = sqrt(2);
var sqrtPi = sqrt(pi);
var tau = pi * 2;
var degrees = 180 / pi;
var radians = pi / 180;
function sinci(x) {
    return x ? x / Math.sin(x) : 1;
}
function asin(x) {
    return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function sqrt(x) {
    return x > 0 ? Math.sqrt(x) : 0;
}
function tanh(x) {
    x = exp(2 * x);
    return (x - 1) / (x + 1);
}
function sinh(x) {
    return (exp(x) - exp(-x)) / 2;
}
function cosh(x) {
    return (exp(x) + exp(-x)) / 2;
}
function arsinh(x) {
    return log(x + sqrt(x * x + 1));
}
function arcosh(x) {
    return log(x + sqrt(x * x - 1));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"7hLZN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>graticule);
parcelHelpers.export(exports, "graticule10", ()=>graticule10);
var _d3Array = require("d3-array");
var _mathJs = require("./math.js");
function graticuleX(y0, y1, dy) {
    var y = (0, _d3Array.range)(y0, y1 - (0, _mathJs.epsilon), dy).concat(y1);
    return function(x) {
        return y.map(function(y) {
            return [
                x,
                y
            ];
        });
    };
}
function graticuleY(x0, x1, dx) {
    var x = (0, _d3Array.range)(x0, x1 - (0, _mathJs.epsilon), dx).concat(x1);
    return function(y) {
        return x.map(function(x) {
            return [
                x,
                y
            ];
        });
    };
}
function graticule() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
        return {
            type: "MultiLineString",
            coordinates: lines()
        };
    }
    function lines() {
        return (0, _d3Array.range)((0, _mathJs.ceil)(X0 / DX) * DX, X1, DX).map(X).concat((0, _d3Array.range)((0, _mathJs.ceil)(Y0 / DY) * DY, Y1, DY).map(Y)).concat((0, _d3Array.range)((0, _mathJs.ceil)(x0 / dx) * dx, x1, dx).filter(function(x) {
            return (0, _mathJs.abs)(x % DX) > (0, _mathJs.epsilon);
        }).map(x)).concat((0, _d3Array.range)((0, _mathJs.ceil)(y0 / dy) * dy, y1, dy).filter(function(y) {
            return (0, _mathJs.abs)(y % DY) > (0, _mathJs.epsilon);
        }).map(y));
    }
    graticule.lines = function() {
        return lines().map(function(coordinates) {
            return {
                type: "LineString",
                coordinates: coordinates
            };
        });
    };
    graticule.outline = function() {
        return {
            type: "Polygon",
            coordinates: [
                X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
            ]
        };
    };
    graticule.extent = function(_) {
        if (!arguments.length) return graticule.extentMinor();
        return graticule.extentMajor(_).extentMinor(_);
    };
    graticule.extentMajor = function(_) {
        if (!arguments.length) return [
            [
                X0,
                Y0
            ],
            [
                X1,
                Y1
            ]
        ];
        X0 = +_[0][0], X1 = +_[1][0];
        Y0 = +_[0][1], Y1 = +_[1][1];
        if (X0 > X1) _ = X0, X0 = X1, X1 = _;
        if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
        return graticule.precision(precision);
    };
    graticule.extentMinor = function(_) {
        if (!arguments.length) return [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x0 = +_[0][0], x1 = +_[1][0];
        y0 = +_[0][1], y1 = +_[1][1];
        if (x0 > x1) _ = x0, x0 = x1, x1 = _;
        if (y0 > y1) _ = y0, y0 = y1, y1 = _;
        return graticule.precision(precision);
    };
    graticule.step = function(_) {
        if (!arguments.length) return graticule.stepMinor();
        return graticule.stepMajor(_).stepMinor(_);
    };
    graticule.stepMajor = function(_) {
        if (!arguments.length) return [
            DX,
            DY
        ];
        DX = +_[0], DY = +_[1];
        return graticule;
    };
    graticule.stepMinor = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        dx = +_[0], dy = +_[1];
        return graticule;
    };
    graticule.precision = function(_) {
        if (!arguments.length) return precision;
        precision = +_;
        x = graticuleX(y0, y1, 90);
        y = graticuleY(x0, x1, precision);
        X = graticuleX(Y0, Y1, 90);
        Y = graticuleY(X0, X1, precision);
        return graticule;
    };
    return graticule.extentMajor([
        [
            -180,
            -90 + (0, _mathJs.epsilon)
        ],
        [
            180,
            90 - (0, _mathJs.epsilon)
        ]
    ]).extentMinor([
        [
            -180,
            -80 - (0, _mathJs.epsilon)
        ],
        [
            180,
            80 + (0, _mathJs.epsilon)
        ]
    ]);
}
function graticule10() {
    return graticule()();
}

},{"d3-array":[["range","2Qa4a","default"]],"./math.js":"bttmd","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bjPWi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "force", ()=>Force);
var _vegaDataflow = require("vega-dataflow");
var _vegaUtil = require("vega-util");
var _d3Force = require("d3-force");
const ForceMap = {
    center: (0, _d3Force.forceCenter),
    collide: (0, _d3Force.forceCollide),
    nbody: (0, _d3Force.forceManyBody),
    link: (0, _d3Force.forceLink),
    x: (0, _d3Force.forceX),
    y: (0, _d3Force.forceY)
};
const Forces = 'forces', ForceParams = [
    'alpha',
    'alphaMin',
    'alphaTarget',
    'velocityDecay',
    'forces'
], ForceConfig = [
    'static',
    'iterations'
], ForceOutput = [
    'x',
    'y',
    'vx',
    'vy'
];
/**
 * Force simulation layout.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<object>} params.forces - The forces to apply.
 */ function Force(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Force.Definition = {
    'type': 'Force',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'static',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'restart',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'iterations',
            'type': 'number',
            'default': 300
        },
        {
            'name': 'alpha',
            'type': 'number',
            'default': 1
        },
        {
            'name': 'alphaMin',
            'type': 'number',
            'default': 0.001
        },
        {
            'name': 'alphaTarget',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'velocityDecay',
            'type': 'number',
            'default': 0.4
        },
        {
            'name': 'forces',
            'type': 'param',
            'array': true,
            'params': [
                {
                    'key': {
                        'force': 'center'
                    },
                    'params': [
                        {
                            'name': 'x',
                            'type': 'number',
                            'default': 0
                        },
                        {
                            'name': 'y',
                            'type': 'number',
                            'default': 0
                        }
                    ]
                },
                {
                    'key': {
                        'force': 'collide'
                    },
                    'params': [
                        {
                            'name': 'radius',
                            'type': 'number',
                            'expr': true
                        },
                        {
                            'name': 'strength',
                            'type': 'number',
                            'default': 0.7
                        },
                        {
                            'name': 'iterations',
                            'type': 'number',
                            'default': 1
                        }
                    ]
                },
                {
                    'key': {
                        'force': 'nbody'
                    },
                    'params': [
                        {
                            'name': 'strength',
                            'type': 'number',
                            'default': -30,
                            'expr': true
                        },
                        {
                            'name': 'theta',
                            'type': 'number',
                            'default': 0.9
                        },
                        {
                            'name': 'distanceMin',
                            'type': 'number',
                            'default': 1
                        },
                        {
                            'name': 'distanceMax',
                            'type': 'number'
                        }
                    ]
                },
                {
                    'key': {
                        'force': 'link'
                    },
                    'params': [
                        {
                            'name': 'links',
                            'type': 'data'
                        },
                        {
                            'name': 'id',
                            'type': 'field'
                        },
                        {
                            'name': 'distance',
                            'type': 'number',
                            'default': 30,
                            'expr': true
                        },
                        {
                            'name': 'strength',
                            'type': 'number',
                            'expr': true
                        },
                        {
                            'name': 'iterations',
                            'type': 'number',
                            'default': 1
                        }
                    ]
                },
                {
                    'key': {
                        'force': 'x'
                    },
                    'params': [
                        {
                            'name': 'strength',
                            'type': 'number',
                            'default': 0.1
                        },
                        {
                            'name': 'x',
                            'type': 'field'
                        }
                    ]
                },
                {
                    'key': {
                        'force': 'y'
                    },
                    'params': [
                        {
                            'name': 'strength',
                            'type': 'number',
                            'default': 0.1
                        },
                        {
                            'name': 'y',
                            'type': 'field'
                        }
                    ]
                }
            ]
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'modify': false,
            'default': ForceOutput
        }
    ]
};
(0, _vegaUtil.inherits)(Force, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var sim = this.value, change = pulse.changed(pulse.ADD_REM), params = _.modified(ForceParams), iters = _.iterations || 300;
        // configure simulation
        if (!sim) {
            this.value = sim = simulation(pulse.source, _);
            sim.on('tick', rerun(pulse.dataflow, this));
            if (!_.static) {
                change = true;
                sim.tick(); // ensure we run on init
            }
            pulse.modifies('index');
        } else {
            if (change) {
                pulse.modifies('index');
                sim.nodes(pulse.source);
            }
            if (params || pulse.changed(pulse.MOD)) setup(sim, _, 0, pulse);
        }
        // run simulation
        if (params || change || _.modified(ForceConfig) || pulse.changed() && _.restart) {
            sim.alpha(Math.max(sim.alpha(), _.alpha || 1)).alphaDecay(1 - Math.pow(sim.alphaMin(), 1 / iters));
            if (_.static) for(sim.stop(); --iters >= 0;)sim.tick();
            else {
                if (sim.stopped()) sim.restart();
                if (!change) return pulse.StopPropagation; // defer to sim ticks
            }
        }
        return this.finish(_, pulse);
    },
    finish (_, pulse) {
        const dataflow = pulse.dataflow;
        // inspect dependencies, touch link source data
        for(let args = this._argops, j = 0, m = args.length, arg; j < m; ++j){
            arg = args[j];
            if (arg.name !== Forces || arg.op._argval.force !== 'link') continue;
            for(var ops = arg.op._argops, i = 0, n = ops.length, op; i < n; ++i)if (ops[i].name === 'links' && (op = ops[i].op.source)) {
                dataflow.pulse(op, dataflow.changeset().reflow());
                break;
            }
        }
        // reflow all nodes
        return pulse.reflow(_.modified()).modifies(ForceOutput);
    }
});
function rerun(df, op) {
    return ()=>df.touch(op).run();
}
function simulation(nodes, _) {
    const sim = (0, _d3Force.forceSimulation)(nodes), stop = sim.stop, restart = sim.restart;
    let stopped = false;
    sim.stopped = ()=>stopped;
    sim.restart = ()=>(stopped = false, restart());
    sim.stop = ()=>(stopped = true, stop());
    return setup(sim, _, true).on('end', ()=>stopped = true);
}
function setup(sim, _, init, pulse) {
    var f = (0, _vegaUtil.array)(_.forces), i, n, p, name;
    for(i = 0, n = ForceParams.length; i < n; ++i){
        p = ForceParams[i];
        if (p !== Forces && _.modified(p)) sim[p](_[p]);
    }
    for(i = 0, n = f.length; i < n; ++i){
        name = Forces + i;
        p = init || _.modified(Forces, i) ? getForce(f[i]) : pulse && modified(f[i], pulse) ? sim.force(name) : null;
        if (p) sim.force(name, p);
    }
    for(n = sim.numForces || 0; i < n; ++i)sim.force(Forces + i, null); // remove
    sim.numForces = f.length;
    return sim;
}
function modified(f, pulse) {
    var k, v;
    for(k in f){
        if ((0, _vegaUtil.isFunction)(v = f[k]) && pulse.modified((0, _vegaUtil.accessorFields)(v))) return 1;
    }
    return 0;
}
function getForce(_) {
    var f, p;
    if (!(0, _vegaUtil.hasOwnProperty)(ForceMap, _.force)) (0, _vegaUtil.error)('Unrecognized force: ' + _.force);
    f = ForceMap[_.force]();
    for(p in _)if ((0, _vegaUtil.isFunction)(f[p])) setForceParam(f[p], _[p], _);
    return f;
}
function setForceParam(f, v, _) {
    f((0, _vegaUtil.isFunction)(v) ? (d)=>v(d, _) : v);
}

},{"vega-dataflow":"4An7U","vega-util":"7f6sQ","d3-force":[["forceCenter","7Du9z","default"],["forceCollide","jsUPx","default"],["forceLink","glu3p","default"],["forceManyBody","lTdnc","default"],["forceSimulation","be1kY","default"],["forceX","1PxGu","default"],["forceY","6fzxn","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"7Du9z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        var nodes, strength = 1;
        if (x == null) x = 0;
        if (y == null) y = 0;
        function force() {
            var i, n = nodes.length, node, sx = 0, sy = 0;
            for(i = 0; i < n; ++i)node = nodes[i], sx += node.x, sy += node.y;
            for(sx = (sx / n - x) * strength, sy = (sy / n - y) * strength, i = 0; i < n; ++i)node = nodes[i], node.x -= sx, node.y -= sy;
        }
        force.initialize = function(_) {
            nodes = _;
        };
        force.x = function(_) {
            return arguments.length ? (x = +_, force) : x;
        };
        force.y = function(_) {
            return arguments.length ? (y = +_, force) : y;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = +_, force) : strength;
        };
        return force;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"jsUPx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(radius) {
        var nodes, radii, random, strength = 1, iterations = 1;
        if (typeof radius !== "function") radius = (0, _constantJsDefault.default)(radius == null ? 1 : +radius);
        function force() {
            var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
            for(var k = 0; k < iterations; ++k){
                tree = (0, _d3Quadtree.quadtree)(nodes, x, y).visitAfter(prepare);
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    ri = radii[node.index], ri2 = ri * ri;
                    xi = node.x + node.vx;
                    yi = node.y + node.vy;
                    tree.visit(apply);
                }
            }
            function apply(quad, x0, y0, x1, y1) {
                var data = quad.data, rj = quad.r, r = ri + rj;
                if (data) {
                    if (data.index > node.index) {
                        var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                        if (l < r * r) {
                            if (x === 0) x = (0, _jiggleJsDefault.default)(random), l += x * x;
                            if (y === 0) y = (0, _jiggleJsDefault.default)(random), l += y * y;
                            l = (r - (l = Math.sqrt(l))) / l * strength;
                            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                            node.vy += (y *= l) * r;
                            data.vx -= x * (r = 1 - r);
                            data.vy -= y * r;
                        }
                    }
                    return;
                }
                return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
            }
        }
        function prepare(quad) {
            if (quad.data) return quad.r = radii[quad.data.index];
            for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, node;
            radii = new Array(n);
            for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.iterations = function(_) {
            return arguments.length ? (iterations = +_, force) : iterations;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = +_, force) : strength;
        };
        force.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : radius;
        };
        return force;
    });
var _d3Quadtree = require("d3-quadtree");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _jiggleJs = require("./jiggle.js");
var _jiggleJsDefault = parcelHelpers.interopDefault(_jiggleJs);
function x(d) {
    return d.x + d.vx;
}
function y(d) {
    return d.y + d.vy;
}

},{"d3-quadtree":[["quadtree","6dNhW","default"]],"./constant.js":"bpzwW","./jiggle.js":"kmVrX","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"6dNhW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quadtree);
var _addJs = require("./add.js");
var _addJsDefault = parcelHelpers.interopDefault(_addJs);
var _coverJs = require("./cover.js");
var _coverJsDefault = parcelHelpers.interopDefault(_coverJs);
var _dataJs = require("./data.js");
var _dataJsDefault = parcelHelpers.interopDefault(_dataJs);
var _extentJs = require("./extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _findJs = require("./find.js");
var _findJsDefault = parcelHelpers.interopDefault(_findJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _rootJs = require("./root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
var _sizeJs = require("./size.js");
var _sizeJsDefault = parcelHelpers.interopDefault(_sizeJs);
var _visitJs = require("./visit.js");
var _visitJsDefault = parcelHelpers.interopDefault(_visitJs);
var _visitAfterJs = require("./visitAfter.js");
var _visitAfterJsDefault = parcelHelpers.interopDefault(_visitAfterJs);
var _xJs = require("./x.js");
var _xJsDefault = parcelHelpers.interopDefault(_xJs);
var _yJs = require("./y.js");
var _yJsDefault = parcelHelpers.interopDefault(_yJs);
function quadtree(nodes, x, y) {
    var tree = new Quadtree(x == null ? (0, _xJs.defaultX) : x, y == null ? (0, _yJs.defaultY) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var treeProto = quadtree.prototype = Quadtree.prototype;
treeProto.copy = function() {
    var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = leaf_copy(child);
        }
    }
    return copy;
};
treeProto.add = (0, _addJsDefault.default);
treeProto.addAll = (0, _addJs.addAll);
treeProto.cover = (0, _coverJsDefault.default);
treeProto.data = (0, _dataJsDefault.default);
treeProto.extent = (0, _extentJsDefault.default);
treeProto.find = (0, _findJsDefault.default);
treeProto.remove = (0, _removeJsDefault.default);
treeProto.removeAll = (0, _removeJs.removeAll);
treeProto.root = (0, _rootJsDefault.default);
treeProto.size = (0, _sizeJsDefault.default);
treeProto.visit = (0, _visitJsDefault.default);
treeProto.visitAfter = (0, _visitAfterJsDefault.default);
treeProto.x = (0, _xJsDefault.default);
treeProto.y = (0, _yJsDefault.default);

},{"./add.js":"9kcEM","./cover.js":"8l85W","./data.js":"5eswe","./extent.js":"z1Ljj","./find.js":"1wfrz","./remove.js":"63hHn","./root.js":"7zqzJ","./size.js":"3g4lN","./visit.js":"47baJ","./visitAfter.js":"pL4aS","./x.js":"3dXeq","./y.js":"9sxhv","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"9kcEM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(d) {
        const x = +this._x.call(null, d), y = +this._y.call(null, d);
        return add(this.cover(x, y), x, y, d);
    });
parcelHelpers.export(exports, "addAll", ()=>addAll);
function add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function addAll(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)add(this, xz[i], yz[i], data[i]);
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8l85W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
        var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
        // If the quadtree has no extent, initialize them.
        // Integer extent are necessary so that if we later double the extent,
        // the existing quadrant boundaries don’t change due to floating point error!
        if (isNaN(x0)) {
            x1 = (x0 = Math.floor(x)) + 1;
            y1 = (y0 = Math.floor(y)) + 1;
        } else {
            var z = x1 - x0 || 1, node = this._root, parent, i;
            while(x0 > x || x >= x1 || y0 > y || y >= y1){
                i = (y < y0) << 1 | x < x0;
                parent = new Array(4), parent[i] = node, node = parent, z *= 2;
                switch(i){
                    case 0:
                        x1 = x0 + z, y1 = y0 + z;
                        break;
                    case 1:
                        x0 = x1 - z, y1 = y0 + z;
                        break;
                    case 2:
                        x1 = x0 + z, y0 = y1 - z;
                        break;
                    case 3:
                        x0 = x1 - z, y0 = y1 - z;
                        break;
                }
            }
            if (this._root && this._root.length) this._root = node;
        }
        this._x0 = x0;
        this._y0 = y0;
        this._x1 = x1;
        this._y1 = y1;
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5eswe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var data = [];
        this.visit(function(node) {
            if (!node.length) do data.push(node.data);
            while (node = node.next);
        });
        return data;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"z1Ljj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(_) {
        return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
            [
                this._x0,
                this._y0
            ],
            [
                this._x1,
                this._y1
            ]
        ];
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"1wfrz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y, radius) {
        var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
        if (node) quads.push(new (0, _quadJsDefault.default)(node, x0, y0, x3, y3));
        if (radius == null) radius = Infinity;
        else {
            x0 = x - radius, y0 = y - radius;
            x3 = x + radius, y3 = y + radius;
            radius *= radius;
        }
        while(q = quads.pop()){
            // Stop searching if this quadrant can’t contain a closer node.
            if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
            // Bisect the current quadrant.
            if (node.length) {
                var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
                quads.push(new (0, _quadJsDefault.default)(node[3], xm, ym, x2, y2), new (0, _quadJsDefault.default)(node[2], x1, ym, xm, y2), new (0, _quadJsDefault.default)(node[1], xm, y1, x2, ym), new (0, _quadJsDefault.default)(node[0], x1, y1, xm, ym));
                // Visit the closest quadrant first.
                if (i = (y >= ym) << 1 | x >= xm) {
                    q = quads[quads.length - 1];
                    quads[quads.length - 1] = quads[quads.length - 1 - i];
                    quads[quads.length - 1 - i] = q;
                }
            } else {
                var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
                if (d2 < radius) {
                    var d = Math.sqrt(radius = d2);
                    x0 = x - d, y0 = y - d;
                    x3 = x + d, y3 = y + d;
                    data = node.data;
                }
            }
        }
        return data;
    });
var _quadJs = require("./quad.js");
var _quadJsDefault = parcelHelpers.interopDefault(_quadJs);

},{"./quad.js":"3eE6Y","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3eE6Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node, x0, y0, x1, y1) {
        this.node = node;
        this.x0 = x0;
        this.y0 = y0;
        this.x1 = x1;
        this.y1 = y1;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"63hHn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(d) {
        if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
        var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
        // If the tree is empty, initialize the root as a leaf.
        if (!node) return this;
        // Find the leaf node for the point.
        // While descending, also retain the deepest parent with a non-removed sibling.
        if (node.length) while(true){
            if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
            else x1 = xm;
            if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
            else y1 = ym;
            if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
            if (!node.length) break;
            if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
        }
        // Find the point to remove.
        while(node.data !== d)if (!(previous = node, node = node.next)) return this;
        if (next = node.next) delete node.next;
        // If there are multiple coincident points, remove just the point.
        if (previous) return next ? previous.next = next : delete previous.next, this;
        // If this is the root point, remove it.
        if (!parent) return this._root = next, this;
        // Remove this leaf.
        next ? parent[i] = next : delete parent[i];
        // If the parent now contains exactly one leaf, collapse superfluous parents.
        if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
            if (retainer) retainer[j] = node;
            else this._root = node;
        }
        return this;
    });
parcelHelpers.export(exports, "removeAll", ()=>removeAll);
function removeAll(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"7zqzJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this._root;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3g4lN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var size = 0;
        this.visit(function(node) {
            if (!node.length) do ++size;
            while (node = node.next);
        });
        return size;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"47baJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        var quads = [], q, node = this._root, child, x0, y0, x1, y1;
        if (node) quads.push(new (0, _quadJsDefault.default)(node, this._x0, this._y0, this._x1, this._y1));
        while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
            var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[3]) quads.push(new (0, _quadJsDefault.default)(child, xm, ym, x1, y1));
            if (child = node[2]) quads.push(new (0, _quadJsDefault.default)(child, x0, ym, xm, y1));
            if (child = node[1]) quads.push(new (0, _quadJsDefault.default)(child, xm, y0, x1, ym));
            if (child = node[0]) quads.push(new (0, _quadJsDefault.default)(child, x0, y0, xm, ym));
        }
        return this;
    });
var _quadJs = require("./quad.js");
var _quadJsDefault = parcelHelpers.interopDefault(_quadJs);

},{"./quad.js":"3eE6Y","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"pL4aS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        var quads = [], next = [], q;
        if (this._root) quads.push(new (0, _quadJsDefault.default)(this._root, this._x0, this._y0, this._x1, this._y1));
        while(q = quads.pop()){
            var node = q.node;
            if (node.length) {
                var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
                if (child = node[0]) quads.push(new (0, _quadJsDefault.default)(child, x0, y0, xm, ym));
                if (child = node[1]) quads.push(new (0, _quadJsDefault.default)(child, xm, y0, x1, ym));
                if (child = node[2]) quads.push(new (0, _quadJsDefault.default)(child, x0, ym, xm, y1));
                if (child = node[3]) quads.push(new (0, _quadJsDefault.default)(child, xm, ym, x1, y1));
            }
            next.push(q);
        }
        while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
        return this;
    });
var _quadJs = require("./quad.js");
var _quadJsDefault = parcelHelpers.interopDefault(_quadJs);

},{"./quad.js":"3eE6Y","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3dXeq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultX", ()=>defaultX);
parcelHelpers.export(exports, "default", ()=>function(_) {
        return arguments.length ? (this._x = _, this) : this._x;
    });
function defaultX(d) {
    return d[0];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"9sxhv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultY", ()=>defaultY);
parcelHelpers.export(exports, "default", ()=>function(_) {
        return arguments.length ? (this._y = _, this) : this._y;
    });
function defaultY(d) {
    return d[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bpzwW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"kmVrX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(random) {
        return (random() - 0.5) * 1e-6;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"glu3p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(links) {
        var id = index, strength = defaultStrength, strengths, distance = (0, _constantJsDefault.default)(30), distances, nodes, count, bias, random, iterations = 1;
        if (links == null) links = [];
        function defaultStrength(link) {
            return 1 / Math.min(count[link.source.index], count[link.target.index]);
        }
        function force(alpha) {
            for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
                link = links[i], source = link.source, target = link.target;
                x = target.x + target.vx - source.x - source.vx || (0, _jiggleJsDefault.default)(random);
                y = target.y + target.vy - source.y - source.vy || (0, _jiggleJsDefault.default)(random);
                l = Math.sqrt(x * x + y * y);
                l = (l - distances[i]) / l * alpha * strengths[i];
                x *= l, y *= l;
                target.vx -= x * (b = bias[i]);
                target.vy -= y * b;
                source.vx += x * (b = 1 - b);
                source.vy += y * b;
            }
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, m = links.length, nodeById = new Map(nodes.map((d, i)=>[
                    id(d, i, nodes),
                    d
                ])), link;
            for(i = 0, count = new Array(n); i < m; ++i){
                link = links[i], link.index = i;
                if (typeof link.source !== "object") link.source = find(nodeById, link.source);
                if (typeof link.target !== "object") link.target = find(nodeById, link.target);
                count[link.source.index] = (count[link.source.index] || 0) + 1;
                count[link.target.index] = (count[link.target.index] || 0) + 1;
            }
            for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
            strengths = new Array(m), initializeStrength();
            distances = new Array(m), initializeDistance();
        }
        function initializeStrength() {
            if (!nodes) return;
            for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
        }
        function initializeDistance() {
            if (!nodes) return;
            for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.links = function(_) {
            return arguments.length ? (links = _, initialize(), force) : links;
        };
        force.id = function(_) {
            return arguments.length ? (id = _, force) : id;
        };
        force.iterations = function(_) {
            return arguments.length ? (iterations = +_, force) : iterations;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initializeStrength(), force) : strength;
        };
        force.distance = function(_) {
            return arguments.length ? (distance = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initializeDistance(), force) : distance;
        };
        return force;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _jiggleJs = require("./jiggle.js");
var _jiggleJsDefault = parcelHelpers.interopDefault(_jiggleJs);
function index(d) {
    return d.index;
}
function find(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("node not found: " + nodeId);
    return node;
}

},{"./constant.js":"bpzwW","./jiggle.js":"kmVrX","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"lTdnc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var nodes, node, random, alpha, strength = (0, _constantJsDefault.default)(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
        function force(_) {
            var i, n = nodes.length, tree = (0, _d3Quadtree.quadtree)(nodes, (0, _simulationJs.x), (0, _simulationJs.y)).visitAfter(accumulate);
            for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, node;
            strengths = new Array(n);
            for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
        }
        function accumulate(quad) {
            var strength = 0, q, c, weight = 0, x, y, i;
            // For internal nodes, accumulate forces from child quadrants.
            if (quad.length) {
                for(x = y = i = 0; i < 4; ++i)if ((q = quad[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * q.x, y += c * q.y;
                quad.x = x / weight;
                quad.y = y / weight;
            } else {
                q = quad;
                q.x = q.data.x;
                q.y = q.data.y;
                do strength += strengths[q.data.index];
                while (q = q.next);
            }
            quad.value = strength;
        }
        function apply(quad, x1, _, x2) {
            if (!quad.value) return true;
            var x = quad.x - node.x, y = quad.y - node.y, w = x2 - x1, l = x * x + y * y;
            // Apply the Barnes-Hut approximation if possible.
            // Limit forces for very close nodes; randomize direction if coincident.
            if (w * w / theta2 < l) {
                if (l < distanceMax2) {
                    if (x === 0) x = (0, _jiggleJsDefault.default)(random), l += x * x;
                    if (y === 0) y = (0, _jiggleJsDefault.default)(random), l += y * y;
                    if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                    node.vx += x * quad.value * alpha / l;
                    node.vy += y * quad.value * alpha / l;
                }
                return true;
            } else if (quad.length || l >= distanceMax2) return;
            // Limit forces for very close nodes; randomize direction if coincident.
            if (quad.data !== node || quad.next) {
                if (x === 0) x = (0, _jiggleJsDefault.default)(random), l += x * x;
                if (y === 0) y = (0, _jiggleJsDefault.default)(random), l += y * y;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
            }
            do if (quad.data !== node) {
                w = strengths[quad.data.index] * alpha / l;
                node.vx += x * w;
                node.vy += y * w;
            }
            while (quad = quad.next);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : strength;
        };
        force.distanceMin = function(_) {
            return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
        };
        force.distanceMax = function(_) {
            return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
        };
        force.theta = function(_) {
            return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
        };
        return force;
    });
var _d3Quadtree = require("d3-quadtree");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _jiggleJs = require("./jiggle.js");
var _jiggleJsDefault = parcelHelpers.interopDefault(_jiggleJs);
var _simulationJs = require("./simulation.js");

},{"d3-quadtree":[["quadtree","6dNhW","default"]],"./constant.js":"bpzwW","./jiggle.js":"kmVrX","./simulation.js":"be1kY","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"be1kY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "x", ()=>x);
parcelHelpers.export(exports, "y", ()=>y);
parcelHelpers.export(exports, "default", ()=>function(nodes) {
        var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = new Map(), stepper = (0, _d3Timer.timer)(step), event = (0, _d3Dispatch.dispatch)("tick", "end"), random = (0, _lcgJsDefault.default)();
        if (nodes == null) nodes = [];
        function step() {
            tick();
            event.call("tick", simulation);
            if (alpha < alphaMin) {
                stepper.stop();
                event.call("end", simulation);
            }
        }
        function tick(iterations) {
            var i, n = nodes.length, node;
            if (iterations === undefined) iterations = 1;
            for(var k = 0; k < iterations; ++k){
                alpha += (alphaTarget - alpha) * alphaDecay;
                forces.forEach(function(force) {
                    force(alpha);
                });
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    if (node.fx == null) node.x += node.vx *= velocityDecay;
                    else node.x = node.fx, node.vx = 0;
                    if (node.fy == null) node.y += node.vy *= velocityDecay;
                    else node.y = node.fy, node.vy = 0;
                }
            }
            return simulation;
        }
        function initializeNodes() {
            for(var i = 0, n = nodes.length, node; i < n; ++i){
                node = nodes[i], node.index = i;
                if (node.fx != null) node.x = node.fx;
                if (node.fy != null) node.y = node.fy;
                if (isNaN(node.x) || isNaN(node.y)) {
                    var radius = initialRadius * Math.sqrt(0.5 + i), angle = i * initialAngle;
                    node.x = radius * Math.cos(angle);
                    node.y = radius * Math.sin(angle);
                }
                if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
            }
        }
        function initializeForce(force) {
            if (force.initialize) force.initialize(nodes, random);
            return force;
        }
        initializeNodes();
        return simulation = {
            tick: tick,
            restart: function() {
                return stepper.restart(step), simulation;
            },
            stop: function() {
                return stepper.stop(), simulation;
            },
            nodes: function(_) {
                return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
            },
            alpha: function(_) {
                return arguments.length ? (alpha = +_, simulation) : alpha;
            },
            alphaMin: function(_) {
                return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
            },
            alphaDecay: function(_) {
                return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
            },
            alphaTarget: function(_) {
                return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
            },
            velocityDecay: function(_) {
                return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
            },
            randomSource: function(_) {
                return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
            },
            force: function(name, _) {
                return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
            },
            find: function(x, y, radius) {
                var i = 0, n = nodes.length, dx, dy, d2, node, closest;
                if (radius == null) radius = Infinity;
                else radius *= radius;
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    dx = x - node.x;
                    dy = y - node.y;
                    d2 = dx * dx + dy * dy;
                    if (d2 < radius) closest = node, radius = d2;
                }
                return closest;
            },
            on: function(name, _) {
                return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
            }
        };
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Timer = require("d3-timer");
var _lcgJs = require("./lcg.js");
var _lcgJsDefault = parcelHelpers.interopDefault(_lcgJs);
function x(d) {
    return d.x;
}
function y(d) {
    return d.y;
}
var initialRadius = 10, initialAngle = Math.PI * (3 - Math.sqrt(5));

},{"d3-dispatch":[["dispatch","bWCMJ","default"]],"d3-timer":"dTUeH","./lcg.js":"6OzYn","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bWCMJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var noop = {
    value: ()=>{}
};
function dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new Dispatch(_);
}
function Dispatch(_) {
    this._ = _;
}
function parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
Dispatch.prototype = dispatch.prototype = {
    constructor: Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
exports.default = dispatch;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dTUeH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "now", ()=>now);
parcelHelpers.export(exports, "Timer", ()=>Timer);
parcelHelpers.export(exports, "timer", ()=>timer);
parcelHelpers.export(exports, "timerFlush", ()=>timerFlush);
var frame = 0, timeout = 0, interval = 0, pokeDelay = 1000, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance === "object" && performance.now ? performance : Date, setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function now() {
    return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}
function clearNow() {
    clockNow = 0;
}
function Timer() {
    this._call = this._time = this._next = null;
}
Timer.prototype = timer.prototype = {
    constructor: Timer,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && taskTail !== this) {
            if (taskTail) taskTail._next = this;
            else taskHead = this;
            taskTail = this;
        }
        this._call = callback;
        this._time = time;
        sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            sleep();
        }
    }
};
function timer(callback, delay, time) {
    var t = new Timer;
    t.restart(callback, delay, time);
    return t;
}
function timerFlush() {
    now(); // Get the current time, if not already set.
    ++frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = taskHead, e;
    while(t){
        if ((e = clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --frame;
}
function wake() {
    clockNow = (clockLast = clock.now()) + clockSkew;
    frame = timeout = 0;
    try {
        timerFlush();
    } finally{
        frame = 0;
        nap();
        clockNow = 0;
    }
}
function poke() {
    var now = clock.now(), delay = now - clockLast;
    if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}
function nap() {
    var t0, t1 = taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
    taskTail = t0;
    sleep(time);
}
function sleep(time) {
    if (frame) return; // Soonest alarm already set, or will be.
    if (timeout) timeout = clearTimeout(timeout);
    var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
        if (interval) interval = clearInterval(interval);
    } else {
        if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
        frame = 1, setFrame(wake);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"6OzYn":[function(require,module,exports,__globalThis) {
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        let s = 1;
        return ()=>(s = (a * s + c) % m) / m;
    });
const a = 1664525;
const c = 1013904223;
const m = 4294967296; // 2^32

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"1PxGu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        var strength = (0, _constantJsDefault.default)(0.1), nodes, strengths, xz;
        if (typeof x !== "function") x = (0, _constantJsDefault.default)(x == null ? 0 : +x);
        function force(alpha) {
            for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            xz = new Array(n);
            for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : strength;
        };
        force.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : x;
        };
        return force;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);

},{"./constant.js":"bpzwW","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"6fzxn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(y) {
        var strength = (0, _constantJsDefault.default)(0.1), nodes, strengths, yz;
        if (typeof y !== "function") y = (0, _constantJsDefault.default)(y == null ? 0 : +y);
        function force(alpha) {
            for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            yz = new Array(n);
            for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : strength;
        };
        force.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : y;
        };
        return force;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);

},{"./constant.js":"bpzwW","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"68WRu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nest", ()=>Nest);
parcelHelpers.export(exports, "pack", ()=>Pack);
parcelHelpers.export(exports, "partition", ()=>Partition);
parcelHelpers.export(exports, "stratify", ()=>Stratify);
parcelHelpers.export(exports, "tree", ()=>Tree);
parcelHelpers.export(exports, "treelinks", ()=>TreeLinks);
parcelHelpers.export(exports, "treemap", ()=>Treemap);
var _vegaDataflow = require("vega-dataflow");
var _vegaUtil = require("vega-util");
var _d3Hierarchy = require("d3-hierarchy");
// Build lookup table mapping tuple keys to tree node instances
function lookup(tree, key, filter) {
    const map = {};
    tree.each((node)=>{
        const t = node.data;
        if (filter(t)) map[key(t)] = node;
    });
    tree.lookup = map;
    return tree;
}
/**
 * Nest tuples into a tree structure, grouped by key values.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<function(object): *>} params.keys - The key fields to nest by, in order.
 * @param {boolean} [params.generate=false] - A boolean flag indicating if
 *   non-leaf nodes generated by this transform should be included in the
 *   output. The default (false) includes only the input data (leaf nodes)
 *   in the data stream.
 */ function Nest(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Nest.Definition = {
    'type': 'Nest',
    'metadata': {
        'treesource': true,
        'changes': true
    },
    'params': [
        {
            'name': 'keys',
            'type': 'field',
            'array': true
        },
        {
            'name': 'generate',
            'type': 'boolean'
        }
    ]
};
const children = (n)=>n.values;
(0, _vegaUtil.inherits)(Nest, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (!pulse.source) (0, _vegaUtil.error)('Nest transform requires an upstream data source.');
        var gen = _.generate, mod = _.modified(), out = pulse.clone(), tree = this.value;
        if (!tree || mod || pulse.changed()) {
            // collect nodes to remove
            if (tree) tree.each((node)=>{
                if (node.children && (0, _vegaDataflow.isTuple)(node.data)) out.rem.push(node.data);
            });
            // generate new tree structure
            this.value = tree = (0, _d3Hierarchy.hierarchy)({
                values: (0, _vegaUtil.array)(_.keys).reduce((n, k)=>{
                    n.key(k);
                    return n;
                }, nest()).entries(out.source)
            }, children);
            // collect nodes to add
            if (gen) tree.each((node)=>{
                if (node.children) {
                    node = (0, _vegaDataflow.ingest)(node.data);
                    out.add.push(node);
                    out.source.push(node);
                }
            });
            // build lookup table
            lookup(tree, (0, _vegaDataflow.tupleid), (0, _vegaDataflow.tupleid));
        }
        out.source.root = tree;
        return out;
    }
});
function nest() {
    const keys = [], nest = {
        entries: (array)=>entries(apply(array, 0), 0),
        key: (d)=>(keys.push(d), nest)
    };
    function apply(array, depth) {
        if (depth >= keys.length) return array;
        const n = array.length, key = keys[depth++], valuesByKey = {}, result = {};
        let i = -1, keyValue, value, values;
        while(++i < n){
            keyValue = key(value = array[i]) + '';
            if (values = valuesByKey[keyValue]) values.push(value);
            else valuesByKey[keyValue] = [
                value
            ];
        }
        for(keyValue in valuesByKey)result[keyValue] = apply(valuesByKey[keyValue], depth);
        return result;
    }
    function entries(map, depth) {
        if (++depth > keys.length) return map;
        const array = [];
        for(const key in map)array.push({
            key,
            values: entries(map[key], depth)
        });
        return array;
    }
    return nest;
}
/**
 * Abstract class for tree layout.
 * @constructor
 * @param {object} params - The parameters for this operator.
 */ function HierarchyLayout(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
const defaultSeparation = (a, b)=>a.parent === b.parent ? 1 : 2;
(0, _vegaUtil.inherits)(HierarchyLayout, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (!pulse.source || !pulse.source.root) (0, _vegaUtil.error)(this.constructor.name + ' transform requires a backing tree data source.');
        const layout = this.layout(_.method), fields = this.fields, root = pulse.source.root, as = _.as || fields;
        if (_.field) root.sum(_.field);
        else root.count();
        if (_.sort) root.sort((0, _vegaDataflow.stableCompare)(_.sort, (d)=>d.data));
        setParams(layout, this.params, _);
        if (layout.separation) layout.separation(_.separation !== false ? defaultSeparation : (0, _vegaUtil.one));
        try {
            this.value = layout(root);
        } catch (err) {
            (0, _vegaUtil.error)(err);
        }
        root.each((node)=>setFields(node, fields, as));
        return pulse.reflow(_.modified()).modifies(as).modifies('leaf');
    }
});
function setParams(layout, params, _) {
    for(let p, i = 0, n = params.length; i < n; ++i){
        p = params[i];
        if (p in _) layout[p](_[p]);
    }
}
function setFields(node, fields, as) {
    const t = node.data, n = fields.length - 1;
    for(let i = 0; i < n; ++i)t[as[i]] = node[fields[i]];
    t[as[n]] = node.children ? node.children.length : 0;
}
const Output$3 = [
    'x',
    'y',
    'r',
    'depth',
    'children'
];
/**
 * Packed circle tree layout.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The value field to size nodes.
 */ function Pack(params) {
    HierarchyLayout.call(this, params);
}
Pack.Definition = {
    'type': 'Pack',
    'metadata': {
        'tree': true,
        'modifies': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field'
        },
        {
            'name': 'sort',
            'type': 'compare'
        },
        {
            'name': 'padding',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'radius',
            'type': 'field',
            'default': null
        },
        {
            'name': 'size',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': Output$3.length,
            'default': Output$3
        }
    ]
};
(0, _vegaUtil.inherits)(Pack, HierarchyLayout, {
    layout: (0, _d3Hierarchy.pack),
    params: [
        'radius',
        'size',
        'padding'
    ],
    fields: Output$3
});
const Output$2 = [
    'x0',
    'y0',
    'x1',
    'y1',
    'depth',
    'children'
];
/**
 * Partition tree layout.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The value field to size nodes.
 */ function Partition(params) {
    HierarchyLayout.call(this, params);
}
Partition.Definition = {
    'type': 'Partition',
    'metadata': {
        'tree': true,
        'modifies': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field'
        },
        {
            'name': 'sort',
            'type': 'compare'
        },
        {
            'name': 'padding',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'round',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'size',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': Output$2.length,
            'default': Output$2
        }
    ]
};
(0, _vegaUtil.inherits)(Partition, HierarchyLayout, {
    layout: (0, _d3Hierarchy.partition),
    params: [
        'size',
        'round',
        'padding'
    ],
    fields: Output$2
});
/**
 * Stratify a collection of tuples into a tree structure based on
 * id and parent id fields.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.key - Unique key field for each tuple.
 * @param {function(object): *} params.parentKey - Field with key for parent tuple.
 */ function Stratify(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Stratify.Definition = {
    'type': 'Stratify',
    'metadata': {
        'treesource': true
    },
    'params': [
        {
            'name': 'key',
            'type': 'field',
            'required': true
        },
        {
            'name': 'parentKey',
            'type': 'field',
            'required': true
        }
    ]
};
(0, _vegaUtil.inherits)(Stratify, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (!pulse.source) (0, _vegaUtil.error)('Stratify transform requires an upstream data source.');
        let tree = this.value;
        const mod = _.modified(), out = pulse.fork(pulse.ALL).materialize(pulse.SOURCE), run = !tree || mod || pulse.changed(pulse.ADD_REM) || pulse.modified(_.key.fields) || pulse.modified(_.parentKey.fields);
        // prevent upstream source pollution
        out.source = out.source.slice();
        if (run) tree = out.source.length ? lookup((0, _d3Hierarchy.stratify)().id(_.key).parentId(_.parentKey)(out.source), _.key, (0, _vegaUtil.truthy)) : lookup((0, _d3Hierarchy.stratify)()([
            {}
        ]), _.key, _.key);
        out.source.root = this.value = tree;
        return out;
    }
});
const Layouts = {
    tidy: (0, _d3Hierarchy.tree),
    cluster: (0, _d3Hierarchy.cluster)
};
const Output$1 = [
    'x',
    'y',
    'depth',
    'children'
];
/**
 * Tree layout. Depending on the method parameter, performs either
 * Reingold-Tilford 'tidy' layout or dendrogram 'cluster' layout.
 * @constructor
 * @param {object} params - The parameters for this operator.
 */ function Tree(params) {
    HierarchyLayout.call(this, params);
}
Tree.Definition = {
    'type': 'Tree',
    'metadata': {
        'tree': true,
        'modifies': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field'
        },
        {
            'name': 'sort',
            'type': 'compare'
        },
        {
            'name': 'method',
            'type': 'enum',
            'default': 'tidy',
            'values': [
                'tidy',
                'cluster'
            ]
        },
        {
            'name': 'size',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'nodeSize',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'separation',
            'type': 'boolean',
            'default': true
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': Output$1.length,
            'default': Output$1
        }
    ]
};
(0, _vegaUtil.inherits)(Tree, HierarchyLayout, {
    /**
   * Tree layout generator. Supports both 'tidy' and 'cluster' layouts.
   */ layout (method) {
        const m = method || 'tidy';
        if ((0, _vegaUtil.hasOwnProperty)(Layouts, m)) return Layouts[m]();
        else (0, _vegaUtil.error)('Unrecognized Tree layout method: ' + m);
    },
    params: [
        'size',
        'nodeSize'
    ],
    fields: Output$1
});
/**
 * Generate tuples representing links between tree nodes.
 * The resulting tuples will contain 'source' and 'target' fields,
 * which point to parent and child node tuples, respectively.
 * @constructor
 * @param {object} params - The parameters for this operator.
 */ function TreeLinks(params) {
    (0, _vegaDataflow.Transform).call(this, [], params);
}
TreeLinks.Definition = {
    'type': 'TreeLinks',
    'metadata': {
        'tree': true,
        'generates': true,
        'changes': true
    },
    'params': []
};
(0, _vegaUtil.inherits)(TreeLinks, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const links = this.value, tree = pulse.source && pulse.source.root, out = pulse.fork(pulse.NO_SOURCE), lut = {};
        if (!tree) (0, _vegaUtil.error)('TreeLinks transform requires a tree data source.');
        if (pulse.changed(pulse.ADD_REM)) {
            // remove previous links
            out.rem = links;
            // build lookup table of valid tuples
            pulse.visit(pulse.SOURCE, (t)=>lut[(0, _vegaDataflow.tupleid)(t)] = 1);
            // generate links for all edges incident on valid tuples
            tree.each((node)=>{
                const t = node.data, p = node.parent && node.parent.data;
                if (p && lut[(0, _vegaDataflow.tupleid)(t)] && lut[(0, _vegaDataflow.tupleid)(p)]) out.add.push((0, _vegaDataflow.ingest)({
                    source: p,
                    target: t
                }));
            });
            this.value = out.add;
        } else if (pulse.changed(pulse.MOD)) {
            // build lookup table of modified tuples
            pulse.visit(pulse.MOD, (t)=>lut[(0, _vegaDataflow.tupleid)(t)] = 1);
            // gather links incident on modified tuples
            links.forEach((link)=>{
                if (lut[(0, _vegaDataflow.tupleid)(link.source)] || lut[(0, _vegaDataflow.tupleid)(link.target)]) out.mod.push(link);
            });
        }
        return out;
    }
});
const Tiles = {
    binary: (0, _d3Hierarchy.treemapBinary),
    dice: (0, _d3Hierarchy.treemapDice),
    slice: (0, _d3Hierarchy.treemapSlice),
    slicedice: (0, _d3Hierarchy.treemapSliceDice),
    squarify: (0, _d3Hierarchy.treemapSquarify),
    resquarify: (0, _d3Hierarchy.treemapResquarify)
};
const Output = [
    'x0',
    'y0',
    'x1',
    'y1',
    'depth',
    'children'
];
/**
 * Treemap layout.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The value field to size nodes.
 */ function Treemap(params) {
    HierarchyLayout.call(this, params);
}
Treemap.Definition = {
    'type': 'Treemap',
    'metadata': {
        'tree': true,
        'modifies': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field'
        },
        {
            'name': 'sort',
            'type': 'compare'
        },
        {
            'name': 'method',
            'type': 'enum',
            'default': 'squarify',
            'values': [
                'squarify',
                'resquarify',
                'binary',
                'dice',
                'slice',
                'slicedice'
            ]
        },
        {
            'name': 'padding',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'paddingInner',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'paddingOuter',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'paddingTop',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'paddingRight',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'paddingBottom',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'paddingLeft',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'ratio',
            'type': 'number',
            'default': 1.618033988749895
        },
        {
            'name': 'round',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'size',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': Output.length,
            'default': Output
        }
    ]
};
(0, _vegaUtil.inherits)(Treemap, HierarchyLayout, {
    /**
   * Treemap layout generator. Adds 'method' and 'ratio' parameters
   * to configure the underlying tile method.
   */ layout () {
        const x = (0, _d3Hierarchy.treemap)();
        x.ratio = (_)=>{
            const t = x.tile();
            if (t.ratio) x.tile(t.ratio(_));
        };
        x.method = (_)=>{
            if ((0, _vegaUtil.hasOwnProperty)(Tiles, _)) x.tile(Tiles[_]);
            else (0, _vegaUtil.error)('Unrecognized Treemap layout method: ' + _);
        };
        return x;
    },
    params: [
        'method',
        'ratio',
        'size',
        'round',
        'padding',
        'paddingInner',
        'paddingOuter',
        'paddingTop',
        'paddingRight',
        'paddingBottom',
        'paddingLeft'
    ],
    fields: Output
});

},{"vega-dataflow":"4An7U","vega-util":"7f6sQ","d3-hierarchy":[["cluster","fRAiE","default"],["hierarchy","dKWDo","default"],["pack","dd2Cc","default"],["partition","dZDvs","default"],["stratify","fgxuK","default"],["tree","i5TRI","default"],["treemap","enQxF","default"],["treemapBinary","huo1k","default"],["treemapDice","9P9T1","default"],["treemapResquarify","7xbEA","default"],["treemapSlice","eov0u","default"],["treemapSliceDice","kzww2","default"],["treemapSquarify","lFjQX","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"fRAiE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var separation = defaultSeparation, dx = 1, dy = 1, nodeSize = false;
        function cluster(root) {
            var previousNode, x = 0;
            // First walk, computing the initial x & y values.
            root.eachAfter(function(node) {
                var children = node.children;
                if (children) {
                    node.x = meanX(children);
                    node.y = maxY(children);
                } else {
                    node.x = previousNode ? x += separation(node, previousNode) : 0;
                    node.y = 0;
                    previousNode = node;
                }
            });
            var left = leafLeft(root), right = leafRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
            // Second walk, normalizing x & y to the desired size.
            return root.eachAfter(nodeSize ? function(node) {
                node.x = (node.x - root.x) * dx;
                node.y = (root.y - node.y) * dy;
            } : function(node) {
                node.x = (node.x - x0) / (x1 - x0) * dx;
                node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
            });
        }
        cluster.separation = function(x) {
            return arguments.length ? (separation = x, cluster) : separation;
        };
        cluster.size = function(x) {
            return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [
                dx,
                dy
            ];
        };
        cluster.nodeSize = function(x) {
            return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [
                dx,
                dy
            ] : null;
        };
        return cluster;
    });
function defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
function meanX(children) {
    return children.reduce(meanXReduce, 0) / children.length;
}
function meanXReduce(x, c) {
    return x + c.x;
}
function maxY(children) {
    return 1 + children.reduce(maxYReduce, 0);
}
function maxYReduce(y, c) {
    return Math.max(y, c.y);
}
function leafLeft(node) {
    var children;
    while(children = node.children)node = children[0];
    return node;
}
function leafRight(node) {
    var children;
    while(children = node.children)node = children[children.length - 1];
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dKWDo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hierarchy);
parcelHelpers.export(exports, "computeHeight", ()=>computeHeight);
parcelHelpers.export(exports, "Node", ()=>Node);
var _countJs = require("./count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _eachJs = require("./each.js");
var _eachJsDefault = parcelHelpers.interopDefault(_eachJs);
var _eachBeforeJs = require("./eachBefore.js");
var _eachBeforeJsDefault = parcelHelpers.interopDefault(_eachBeforeJs);
var _eachAfterJs = require("./eachAfter.js");
var _eachAfterJsDefault = parcelHelpers.interopDefault(_eachAfterJs);
var _findJs = require("./find.js");
var _findJsDefault = parcelHelpers.interopDefault(_findJs);
var _sumJs = require("./sum.js");
var _sumJsDefault = parcelHelpers.interopDefault(_sumJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
var _ancestorsJs = require("./ancestors.js");
var _ancestorsJsDefault = parcelHelpers.interopDefault(_ancestorsJs);
var _descendantsJs = require("./descendants.js");
var _descendantsJsDefault = parcelHelpers.interopDefault(_descendantsJs);
var _leavesJs = require("./leaves.js");
var _leavesJsDefault = parcelHelpers.interopDefault(_leavesJs);
var _linksJs = require("./links.js");
var _linksJsDefault = parcelHelpers.interopDefault(_linksJs);
var _iteratorJs = require("./iterator.js");
var _iteratorJsDefault = parcelHelpers.interopDefault(_iteratorJs);
function hierarchy(data, children) {
    if (data instanceof Map) {
        data = [
            undefined,
            data
        ];
        if (children === undefined) children = mapChildren;
    } else if (children === undefined) children = objectChildren;
    var root = new Node(data), node, nodes = [
        root
    ], child, childs, i, n;
    while(node = nodes.pop())if ((childs = children(node.data)) && (n = (childs = Array.from(childs)).length)) {
        node.children = childs;
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = childs[i] = new Node(childs[i]));
            child.parent = node;
            child.depth = node.depth + 1;
        }
    }
    return root.eachBefore(computeHeight);
}
function node_copy() {
    return hierarchy(this).eachBefore(copyData);
}
function objectChildren(d) {
    return d.children;
}
function mapChildren(d) {
    return Array.isArray(d) ? d[1] : null;
}
function copyData(node) {
    if (node.data.value !== undefined) node.value = node.data.value;
    node.data = node.data.data;
}
function computeHeight(node) {
    var height = 0;
    do node.height = height;
    while ((node = node.parent) && node.height < ++height);
}
function Node(data) {
    this.data = data;
    this.depth = this.height = 0;
    this.parent = null;
}
Node.prototype = hierarchy.prototype = {
    constructor: Node,
    count: (0, _countJsDefault.default),
    each: (0, _eachJsDefault.default),
    eachAfter: (0, _eachAfterJsDefault.default),
    eachBefore: (0, _eachBeforeJsDefault.default),
    find: (0, _findJsDefault.default),
    sum: (0, _sumJsDefault.default),
    sort: (0, _sortJsDefault.default),
    path: (0, _pathJsDefault.default),
    ancestors: (0, _ancestorsJsDefault.default),
    descendants: (0, _descendantsJsDefault.default),
    leaves: (0, _leavesJsDefault.default),
    links: (0, _linksJsDefault.default),
    copy: node_copy,
    [Symbol.iterator]: (0, _iteratorJsDefault.default)
};

},{"./count.js":"3ubxV","./each.js":"42HVC","./eachBefore.js":"bhqlu","./eachAfter.js":"2zHVS","./find.js":"7N4oP","./sum.js":"lC2na","./sort.js":"5vH9j","./path.js":"lQkjj","./ancestors.js":"cFqPK","./descendants.js":"dRN5h","./leaves.js":"8lDJS","./links.js":"aOp05","./iterator.js":"7RGNE","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3ubxV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.eachAfter(count);
    });
function count(node) {
    var sum = 0, children = node.children, i = children && children.length;
    if (!i) sum = 1;
    else while(--i >= 0)sum += children[i].value;
    node.value = sum;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"42HVC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, that) {
        let index = -1;
        for (const node of this)callback.call(that, node, ++index, this);
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bhqlu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, that) {
        var node = this, nodes = [
            node
        ], children, i, index = -1;
        while(node = nodes.pop()){
            callback.call(that, node, ++index, this);
            if (children = node.children) for(i = children.length - 1; i >= 0; --i)nodes.push(children[i]);
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"2zHVS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, that) {
        var node = this, nodes = [
            node
        ], next = [], children, i, n, index = -1;
        while(node = nodes.pop()){
            next.push(node);
            if (children = node.children) for(i = 0, n = children.length; i < n; ++i)nodes.push(children[i]);
        }
        while(node = next.pop())callback.call(that, node, ++index, this);
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"7N4oP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, that) {
        let index = -1;
        for (const node of this){
            if (callback.call(that, node, ++index, this)) return node;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"lC2na":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return this.eachAfter(function(node) {
            var sum = +value(node.data) || 0, children = node.children, i = children && children.length;
            while(--i >= 0)sum += children[i].value;
            node.value = sum;
        });
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5vH9j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(compare) {
        return this.eachBefore(function(node) {
            if (node.children) node.children.sort(compare);
        });
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"lQkjj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(end) {
        var start = this, ancestor = leastCommonAncestor(start, end), nodes = [
            start
        ];
        while(start !== ancestor){
            start = start.parent;
            nodes.push(start);
        }
        var k = nodes.length;
        while(end !== ancestor){
            nodes.splice(k, 0, end);
            end = end.parent;
        }
        return nodes;
    });
function leastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
    a = aNodes.pop();
    b = bNodes.pop();
    while(a === b){
        c = a;
        a = aNodes.pop();
        b = bNodes.pop();
    }
    return c;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cFqPK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var node = this, nodes = [
            node
        ];
        while(node = node.parent)nodes.push(node);
        return nodes;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dRN5h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return Array.from(this);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8lDJS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var leaves = [];
        this.eachBefore(function(node) {
            if (!node.children) leaves.push(node);
        });
        return leaves;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"aOp05":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var root = this, links = [];
        root.each(function(node) {
            if (node !== root) links.push({
                source: node.parent,
                target: node
            });
        });
        return links;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"7RGNE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function*() {
        var node = this, current, next = [
            node
        ], children, i, n;
        do {
            current = next.reverse(), next = [];
            while(node = current.pop()){
                yield node;
                if (children = node.children) for(i = 0, n = children.length; i < n; ++i)next.push(children[i]);
            }
        }while (next.length);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dd2Cc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var radius = null, dx = 1, dy = 1, padding = (0, _constantJs.constantZero);
        function pack(root) {
            const random = (0, _lcgJsDefault.default)();
            root.x = dx / 2, root.y = dy / 2;
            if (radius) root.eachBefore(radiusLeaf(radius)).eachAfter(packChildrenRandom(padding, 0.5, random)).eachBefore(translateChild(1));
            else root.eachBefore(radiusLeaf(defaultRadius)).eachAfter(packChildrenRandom((0, _constantJs.constantZero), 1, random)).eachAfter(packChildrenRandom(padding, root.r / Math.min(dx, dy), random)).eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
            return root;
        }
        pack.radius = function(x) {
            return arguments.length ? (radius = (0, _accessorsJs.optional)(x), pack) : radius;
        };
        pack.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [
                dx,
                dy
            ];
        };
        pack.padding = function(x) {
            return arguments.length ? (padding = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), pack) : padding;
        };
        return pack;
    });
var _accessorsJs = require("../accessors.js");
var _constantJs = require("../constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _lcgJs = require("../lcg.js");
var _lcgJsDefault = parcelHelpers.interopDefault(_lcgJs);
var _siblingsJs = require("./siblings.js");
function defaultRadius(d) {
    return Math.sqrt(d.value);
}
function radiusLeaf(radius) {
    return function(node) {
        if (!node.children) node.r = Math.max(0, +radius(node) || 0);
    };
}
function packChildrenRandom(padding, k, random) {
    return function(node) {
        if (children = node.children) {
            var children, i, n = children.length, r = padding(node) * k || 0, e;
            if (r) for(i = 0; i < n; ++i)children[i].r += r;
            e = (0, _siblingsJs.packSiblingsRandom)(children, random);
            if (r) for(i = 0; i < n; ++i)children[i].r -= r;
            node.r = e + r;
        }
    };
}
function translateChild(k) {
    return function(node) {
        var parent = node.parent;
        node.r *= k;
        if (parent) {
            node.x = parent.x + k * node.x;
            node.y = parent.y + k * node.y;
        }
    };
}

},{"../accessors.js":"3bLvy","../constant.js":"2D0Zy","../lcg.js":"bnJ3T","./siblings.js":"kgCcv","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3bLvy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "optional", ()=>optional);
parcelHelpers.export(exports, "required", ()=>required);
function optional(f) {
    return f == null ? null : required(f);
}
function required(f) {
    if (typeof f !== "function") throw new Error;
    return f;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"2D0Zy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constantZero", ()=>constantZero);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });
function constantZero() {
    return 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bnJ3T":[function(require,module,exports,__globalThis) {
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        let s = 1;
        return ()=>(s = (a * s + c) % m) / m;
    });
const a = 1664525;
const c = 1013904223;
const m = 4294967296; // 2^32

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"kgCcv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "packSiblingsRandom", ()=>packSiblingsRandom);
parcelHelpers.export(exports, "default", ()=>function(circles) {
        packSiblingsRandom(circles, (0, _lcgJsDefault.default)());
        return circles;
    });
var _arrayJs = require("../array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _lcgJs = require("../lcg.js");
var _lcgJsDefault = parcelHelpers.interopDefault(_lcgJs);
var _encloseJs = require("./enclose.js");
function place(b, a, c) {
    var dx = b.x - a.x, x, a2, dy = b.y - a.y, y, b2, d2 = dx * dx + dy * dy;
    if (d2) {
        a2 = a.r + c.r, a2 *= a2;
        b2 = b.r + c.r, b2 *= b2;
        if (a2 > b2) {
            x = (d2 + b2 - a2) / (2 * d2);
            y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
            c.x = b.x - x * dx - y * dy;
            c.y = b.y - x * dy + y * dx;
        } else {
            x = (d2 + a2 - b2) / (2 * d2);
            y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
            c.x = a.x + x * dx - y * dy;
            c.y = a.y + x * dy + y * dx;
        }
    } else {
        c.x = a.x + c.r;
        c.y = a.y;
    }
}
function intersects(a, b) {
    var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function score(node) {
    var a = node._, b = node.next._, ab = a.r + b.r, dx = (a.x * b.r + b.x * a.r) / ab, dy = (a.y * b.r + b.y * a.r) / ab;
    return dx * dx + dy * dy;
}
function Node(circle) {
    this._ = circle;
    this.next = null;
    this.previous = null;
}
function packSiblingsRandom(circles, random) {
    if (!(n = (circles = (0, _arrayJsDefault.default)(circles)).length)) return 0;
    var a, b, c, n, aa, ca, i, j, k, sj, sk;
    // Place the first circle.
    a = circles[0], a.x = 0, a.y = 0;
    if (!(n > 1)) return a.r;
    // Place the second circle.
    b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
    if (!(n > 2)) return a.r + b.r;
    // Place the third circle.
    place(b, a, c = circles[2]);
    // Initialize the front-chain using the first three circles a, b and c.
    a = new Node(a), b = new Node(b), c = new Node(c);
    a.next = c.previous = b;
    b.next = a.previous = c;
    c.next = b.previous = a;
    // Attempt to place each remaining circle…
    pack: for(i = 3; i < n; ++i){
        place(a._, b._, c = circles[i]), c = new Node(c);
        // Find the closest intersecting circle on the front-chain, if any.
        // “Closeness” is determined by linear distance along the front-chain.
        // “Ahead” or “behind” is likewise determined by linear distance.
        j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
        do if (sj <= sk) {
            if (intersects(j._, c._)) {
                b = j, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sj += j._.r, j = j.next;
        } else {
            if (intersects(k._, c._)) {
                a = k, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sk += k._.r, k = k.previous;
        }
        while (j !== k.next);
        // Success! Insert the new circle c between a and b.
        c.previous = a, c.next = b, a.next = b.previous = b = c;
        // Compute the new closest circle pair to the centroid.
        aa = score(a);
        while((c = c.next) !== b)if ((ca = score(c)) < aa) a = c, aa = ca;
        b = a.next;
    }
    // Compute the enclosing circle of the front chain.
    a = [
        b._
    ], c = b;
    while((c = c.next) !== b)a.push(c._);
    c = (0, _encloseJs.packEncloseRandom)(a, random);
    // Translate the circles to put the enclosing circle around the origin.
    for(i = 0; i < n; ++i)a = circles[i], a.x -= c.x, a.y -= c.y;
    return c.r;
}

},{"../array.js":"4OaR9","../lcg.js":"bnJ3T","./enclose.js":"1u2Hh","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4OaR9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
         : Array.from(x); // Map, Set, iterable, string, or anything else
    });
parcelHelpers.export(exports, "shuffle", ()=>shuffle);
function shuffle(array, random) {
    let m = array.length, t, i;
    while(m){
        i = random() * m-- | 0;
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
    return array;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"1u2Hh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(circles) {
        return packEncloseRandom(circles, (0, _lcgJsDefault.default)());
    });
parcelHelpers.export(exports, "packEncloseRandom", ()=>packEncloseRandom);
var _arrayJs = require("../array.js");
var _lcgJs = require("../lcg.js");
var _lcgJsDefault = parcelHelpers.interopDefault(_lcgJs);
function packEncloseRandom(circles, random) {
    var i = 0, n = (circles = (0, _arrayJs.shuffle)(Array.from(circles), random)).length, B = [], p, e;
    while(i < n){
        p = circles[i];
        if (e && enclosesWeak(e, p)) ++i;
        else e = encloseBasis(B = extendBasis(B, p)), i = 0;
    }
    return e;
}
function extendBasis(B, p) {
    var i, j;
    if (enclosesWeakAll(p, B)) return [
        p
    ];
    // If we get here then B must have at least one element.
    for(i = 0; i < B.length; ++i){
        if (enclosesNot(p, B[i]) && enclosesWeakAll(encloseBasis2(B[i], p), B)) return [
            B[i],
            p
        ];
    }
    // If we get here then B must have at least two elements.
    for(i = 0; i < B.length - 1; ++i)for(j = i + 1; j < B.length; ++j){
        if (enclosesNot(encloseBasis2(B[i], B[j]), p) && enclosesNot(encloseBasis2(B[i], p), B[j]) && enclosesNot(encloseBasis2(B[j], p), B[i]) && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) return [
            B[i],
            B[j],
            p
        ];
    }
    // If we get here then something is very wrong.
    throw new Error;
}
function enclosesNot(a, b) {
    var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
    return dr < 0 || dr * dr < dx * dx + dy * dy;
}
function enclosesWeak(a, b) {
    var dr = a.r - b.r + Math.max(a.r, b.r, 1) * 1e-9, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function enclosesWeakAll(a, B) {
    for(var i = 0; i < B.length; ++i){
        if (!enclosesWeak(a, B[i])) return false;
    }
    return true;
}
function encloseBasis(B) {
    switch(B.length){
        case 1:
            return encloseBasis1(B[0]);
        case 2:
            return encloseBasis2(B[0], B[1]);
        case 3:
            return encloseBasis3(B[0], B[1], B[2]);
    }
}
function encloseBasis1(a) {
    return {
        x: a.x,
        y: a.y,
        r: a.r
    };
}
function encloseBasis2(a, b) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1, l = Math.sqrt(x21 * x21 + y21 * y21);
    return {
        x: (x1 + x2 + x21 / l * r21) / 2,
        y: (y1 + y2 + y21 / l * r21) / 2,
        r: (l + r1 + r2) / 2
    };
}
function encloseBasis3(a, b, c) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x3 = c.x, y3 = c.y, r3 = c.r, a2 = x1 - x2, a3 = x1 - x3, b2 = y1 - y2, b3 = y1 - y3, c2 = r2 - r1, c3 = r3 - r1, d1 = x1 * x1 + y1 * y1 - r1 * r1, d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2, d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3, ab = a3 * b2 - a2 * b3, xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1, xb = (b3 * c2 - b2 * c3) / ab, ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1, yb = (a2 * c3 - a3 * c2) / ab, A = xb * xb + yb * yb - 1, B = 2 * (r1 + xa * xb + ya * yb), C = xa * xa + ya * ya - r1 * r1, r = -(Math.abs(A) > 1e-6 ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
    return {
        x: x1 + xa + xb * r,
        y: y1 + ya + yb * r,
        r: r
    };
}

},{"../array.js":"4OaR9","../lcg.js":"bnJ3T","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dZDvs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var dx = 1, dy = 1, padding = 0, round = false;
        function partition(root) {
            var n = root.height + 1;
            root.x0 = root.y0 = padding;
            root.x1 = dx;
            root.y1 = dy / n;
            root.eachBefore(positionNode(dy, n));
            if (round) root.eachBefore((0, _roundJsDefault.default));
            return root;
        }
        function positionNode(dy, n) {
            return function(node) {
                if (node.children) (0, _diceJsDefault.default)(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
                var x0 = node.x0, y0 = node.y0, x1 = node.x1 - padding, y1 = node.y1 - padding;
                if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
                if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
                node.x0 = x0;
                node.y0 = y0;
                node.x1 = x1;
                node.y1 = y1;
            };
        }
        partition.round = function(x) {
            return arguments.length ? (round = !!x, partition) : round;
        };
        partition.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [
                dx,
                dy
            ];
        };
        partition.padding = function(x) {
            return arguments.length ? (padding = +x, partition) : padding;
        };
        return partition;
    });
var _roundJs = require("./treemap/round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _diceJs = require("./treemap/dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);

},{"./treemap/round.js":"5mFPG","./treemap/dice.js":"9P9T1","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5mFPG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node) {
        node.x0 = Math.round(node.x0);
        node.y0 = Math.round(node.y0);
        node.x1 = Math.round(node.x1);
        node.y1 = Math.round(node.y1);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"9P9T1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
        while(++i < n){
            node = nodes[i], node.y0 = y0, node.y1 = y1;
            node.x0 = x0, node.x1 = x0 += node.value * k;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"fgxuK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var id = defaultId, parentId = defaultParentId, path;
        function stratify(data) {
            var nodes = Array.from(data), currentId = id, currentParentId = parentId, n, d, i, root, parent, node, nodeId, nodeKey, nodeByKey = new Map;
            if (path != null) {
                const I = nodes.map((d, i)=>normalize(path(d, i, data)));
                const P = I.map(parentof);
                const S = new Set(I).add("");
                for (const i of P)if (!S.has(i)) {
                    S.add(i);
                    I.push(i);
                    P.push(parentof(i));
                    nodes.push(imputed);
                }
                currentId = (_, i)=>I[i];
                currentParentId = (_, i)=>P[i];
            }
            for(i = 0, n = nodes.length; i < n; ++i){
                d = nodes[i], node = nodes[i] = new (0, _indexJs.Node)(d);
                if ((nodeId = currentId(d, i, data)) != null && (nodeId += "")) {
                    nodeKey = node.id = nodeId;
                    nodeByKey.set(nodeKey, nodeByKey.has(nodeKey) ? ambiguous : node);
                }
                if ((nodeId = currentParentId(d, i, data)) != null && (nodeId += "")) node.parent = nodeId;
            }
            for(i = 0; i < n; ++i){
                node = nodes[i];
                if (nodeId = node.parent) {
                    parent = nodeByKey.get(nodeId);
                    if (!parent) throw new Error("missing: " + nodeId);
                    if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
                    if (parent.children) parent.children.push(node);
                    else parent.children = [
                        node
                    ];
                    node.parent = parent;
                } else {
                    if (root) throw new Error("multiple roots");
                    root = node;
                }
            }
            if (!root) throw new Error("no root");
            // When imputing internal nodes, only introduce roots if needed.
            // Then replace the imputed marker data with null.
            if (path != null) {
                while(root.data === imputed && root.children.length === 1)root = root.children[0], --n;
                for(let i = nodes.length - 1; i >= 0; --i){
                    node = nodes[i];
                    if (node.data !== imputed) break;
                    node.data = null;
                }
            }
            root.parent = preroot;
            root.eachBefore(function(node) {
                node.depth = node.parent.depth + 1;
                --n;
            }).eachBefore((0, _indexJs.computeHeight));
            root.parent = null;
            if (n > 0) throw new Error("cycle");
            return root;
        }
        stratify.id = function(x) {
            return arguments.length ? (id = (0, _accessorsJs.optional)(x), stratify) : id;
        };
        stratify.parentId = function(x) {
            return arguments.length ? (parentId = (0, _accessorsJs.optional)(x), stratify) : parentId;
        };
        stratify.path = function(x) {
            return arguments.length ? (path = (0, _accessorsJs.optional)(x), stratify) : path;
        };
        return stratify;
    });
var _accessorsJs = require("./accessors.js");
var _indexJs = require("./hierarchy/index.js");
var preroot = {
    depth: -1
}, ambiguous = {}, imputed = {};
function defaultId(d) {
    return d.id;
}
function defaultParentId(d) {
    return d.parentId;
}
// To normalize a path, we coerce to a string, strip the trailing slash if any
// (as long as the trailing slash is not immediately preceded by another slash),
// and add leading slash if missing.
function normalize(path) {
    path = `${path}`;
    let i = path.length;
    if (slash(path, i - 1) && !slash(path, i - 2)) path = path.slice(0, -1);
    return path[0] === "/" ? path : `/${path}`;
}
// Walk backwards to find the first slash that is not the leading slash, e.g.:
// "/foo/bar" ⇥ "/foo", "/foo" ⇥ "/", "/" ↦ "". (The root is special-cased
// because the id of the root must be a truthy value.)
function parentof(path) {
    let i = path.length;
    if (i < 2) return "";
    while(--i > 1)if (slash(path, i)) break;
    return path.slice(0, i);
}
// Slashes can be escaped; to determine whether a slash is a path delimiter, we
// count the number of preceding backslashes escaping the forward slash: an odd
// number indicates an escaped forward slash.
function slash(path, i) {
    if (path[i] === "/") {
        let k = 0;
        while(i > 0 && path[--i] === "\\")++k;
        if ((k & 1) === 0) return true;
    }
    return false;
}

},{"./accessors.js":"3bLvy","./hierarchy/index.js":"dKWDo","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"i5TRI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
parcelHelpers.export(exports, "default", ()=>function() {
        var separation = defaultSeparation, dx = 1, dy = 1, nodeSize = null;
        function tree(root) {
            var t = treeRoot(root);
            // Compute the layout using Buchheim et al.’s algorithm.
            t.eachAfter(firstWalk), t.parent.m = -t.z;
            t.eachBefore(secondWalk);
            // If a fixed node size is specified, scale x and y.
            if (nodeSize) root.eachBefore(sizeNode);
            else {
                var left = root, right = root, bottom = root;
                root.eachBefore(function(node) {
                    if (node.x < left.x) left = node;
                    if (node.x > right.x) right = node;
                    if (node.depth > bottom.depth) bottom = node;
                });
                var s = left === right ? 1 : separation(left, right) / 2, tx = s - left.x, kx = dx / (right.x + s + tx), ky = dy / (bottom.depth || 1);
                root.eachBefore(function(node) {
                    node.x = (node.x + tx) * kx;
                    node.y = node.depth * ky;
                });
            }
            return root;
        }
        // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
        // applied recursively to the children of v, as well as the function
        // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
        // node v is placed to the midpoint of its outermost children.
        function firstWalk(v) {
            var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
            if (children) {
                executeShifts(v);
                var midpoint = (children[0].z + children[children.length - 1].z) / 2;
                if (w) {
                    v.z = w.z + separation(v._, w._);
                    v.m = v.z - midpoint;
                } else v.z = midpoint;
            } else if (w) v.z = w.z + separation(v._, w._);
            v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
        }
        // Computes all real x-coordinates by summing up the modifiers recursively.
        function secondWalk(v) {
            v._.x = v.z + v.parent.m;
            v.m += v.parent.m;
        }
        // The core of the algorithm. Here, a new subtree is combined with the
        // previous subtrees. Threads are used to traverse the inside and outside
        // contours of the left and right subtree up to the highest common level. The
        // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
        // superscript o means outside and i means inside, the subscript - means left
        // subtree and + means right subtree. For summing up the modifiers along the
        // contour, we use respective variables si+, si-, so-, and so+. Whenever two
        // nodes of the inside contours conflict, we compute the left one of the
        // greatest uncommon ancestors using the function ANCESTOR and call MOVE
        // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
        // Finally, we add a new thread (if necessary).
        function apportion(v, w, ancestor) {
            if (w) {
                var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
                while(vim = nextRight(vim), vip = nextLeft(vip), vim && vip){
                    vom = nextLeft(vom);
                    vop = nextRight(vop);
                    vop.a = v;
                    shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
                    if (shift > 0) {
                        moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
                        sip += shift;
                        sop += shift;
                    }
                    sim += vim.m;
                    sip += vip.m;
                    som += vom.m;
                    sop += vop.m;
                }
                if (vim && !nextRight(vop)) {
                    vop.t = vim;
                    vop.m += sim - sop;
                }
                if (vip && !nextLeft(vom)) {
                    vom.t = vip;
                    vom.m += sip - som;
                    ancestor = v;
                }
            }
            return ancestor;
        }
        function sizeNode(node) {
            node.x *= dx;
            node.y = node.depth * dy;
        }
        tree.separation = function(x) {
            return arguments.length ? (separation = x, tree) : separation;
        };
        tree.size = function(x) {
            return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [
                dx,
                dy
            ];
        };
        tree.nodeSize = function(x) {
            return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [
                dx,
                dy
            ] : null;
        };
        return tree;
    });
var _indexJs = require("./hierarchy/index.js");
function defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }
// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
    var children = v.children;
    return children ? children[0] : v.t;
}
// This function works analogously to nextLeft.
function nextRight(v) {
    var children = v.children;
    return children ? children[children.length - 1] : v.t;
}
// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
}
// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while(--i >= 0){
        w = children[i];
        w.z += shift;
        w.m += shift;
        shift += w.s + (change += w.c);
    }
}
// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
}
function TreeNode(node, i) {
    this._ = node;
    this.parent = null;
    this.children = null;
    this.A = null; // default ancestor
    this.a = this; // ancestor
    this.z = 0; // prelim
    this.m = 0; // mod
    this.c = 0; // change
    this.s = 0; // shift
    this.t = null; // thread
    this.i = i; // number
}
TreeNode.prototype = Object.create((0, _indexJs.Node).prototype);
function treeRoot(root) {
    var tree = new TreeNode(root, 0), node, nodes = [
        tree
    ], child, children, i, n;
    while(node = nodes.pop())if (children = node._.children) {
        node.children = new Array(n = children.length);
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = node.children[i] = new TreeNode(children[i], i));
            child.parent = node;
        }
    }
    (tree.parent = new TreeNode(null, 0)).children = [
        tree
    ];
    return tree;
}

},{"./hierarchy/index.js":"dKWDo","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"enQxF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var tile = (0, _squarifyJsDefault.default), round = false, dx = 1, dy = 1, paddingStack = [
            0
        ], paddingInner = (0, _constantJs.constantZero), paddingTop = (0, _constantJs.constantZero), paddingRight = (0, _constantJs.constantZero), paddingBottom = (0, _constantJs.constantZero), paddingLeft = (0, _constantJs.constantZero);
        function treemap(root) {
            root.x0 = root.y0 = 0;
            root.x1 = dx;
            root.y1 = dy;
            root.eachBefore(positionNode);
            paddingStack = [
                0
            ];
            if (round) root.eachBefore((0, _roundJsDefault.default));
            return root;
        }
        function positionNode(node) {
            var p = paddingStack[node.depth], x0 = node.x0 + p, y0 = node.y0 + p, x1 = node.x1 - p, y1 = node.y1 - p;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            node.x0 = x0;
            node.y0 = y0;
            node.x1 = x1;
            node.y1 = y1;
            if (node.children) {
                p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
                x0 += paddingLeft(node) - p;
                y0 += paddingTop(node) - p;
                x1 -= paddingRight(node) - p;
                y1 -= paddingBottom(node) - p;
                if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
                if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
                tile(node, x0, y0, x1, y1);
            }
        }
        treemap.round = function(x) {
            return arguments.length ? (round = !!x, treemap) : round;
        };
        treemap.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [
                dx,
                dy
            ];
        };
        treemap.tile = function(x) {
            return arguments.length ? (tile = (0, _accessorsJs.required)(x), treemap) : tile;
        };
        treemap.padding = function(x) {
            return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
        };
        treemap.paddingInner = function(x) {
            return arguments.length ? (paddingInner = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingInner;
        };
        treemap.paddingOuter = function(x) {
            return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
        };
        treemap.paddingTop = function(x) {
            return arguments.length ? (paddingTop = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingTop;
        };
        treemap.paddingRight = function(x) {
            return arguments.length ? (paddingRight = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingRight;
        };
        treemap.paddingBottom = function(x) {
            return arguments.length ? (paddingBottom = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingBottom;
        };
        treemap.paddingLeft = function(x) {
            return arguments.length ? (paddingLeft = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingLeft;
        };
        return treemap;
    });
var _roundJs = require("./round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _squarifyJs = require("./squarify.js");
var _squarifyJsDefault = parcelHelpers.interopDefault(_squarifyJs);
var _accessorsJs = require("../accessors.js");
var _constantJs = require("../constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);

},{"./round.js":"5mFPG","./squarify.js":"lFjQX","../accessors.js":"3bLvy","../constant.js":"2D0Zy","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"lFjQX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "phi", ()=>phi);
parcelHelpers.export(exports, "squarifyRatio", ()=>squarifyRatio);
var _diceJs = require("./dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var phi = (1 + Math.sqrt(5)) / 2;
function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
    var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
    while(i0 < n){
        dx = x1 - x0, dy = y1 - y0;
        // Find the next non-empty node.
        do sumValue = nodes[i1++].value;
        while (!sumValue && i1 < n);
        minValue = maxValue = sumValue;
        alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
        beta = sumValue * sumValue * alpha;
        minRatio = Math.max(maxValue / beta, beta / minValue);
        // Keep adding nodes while the aspect ratio maintains or improves.
        for(; i1 < n; ++i1){
            sumValue += nodeValue = nodes[i1].value;
            if (nodeValue < minValue) minValue = nodeValue;
            if (nodeValue > maxValue) maxValue = nodeValue;
            beta = sumValue * sumValue * alpha;
            newRatio = Math.max(maxValue / beta, beta / minValue);
            if (newRatio > minRatio) {
                sumValue -= nodeValue;
                break;
            }
            minRatio = newRatio;
        }
        // Position and record the row orientation.
        rows.push(row = {
            value: sumValue,
            dice: dx < dy,
            children: nodes.slice(i0, i1)
        });
        if (row.dice) (0, _diceJsDefault.default)(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
        else (0, _sliceJsDefault.default)(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
        value -= sumValue, i0 = i1;
    }
    return rows;
}
exports.default = function custom(ratio) {
    function squarify(parent, x0, y0, x1, y1) {
        squarifyRatio(ratio, parent, x0, y0, x1, y1);
    }
    squarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return squarify;
}(phi);

},{"./dice.js":"9P9T1","./slice.js":"eov0u","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"eov0u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
        while(++i < n){
            node = nodes[i], node.x0 = x0, node.x1 = x1;
            node.y0 = y0, node.y1 = y0 += node.value * k;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"huo1k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        var nodes = parent.children, i, n = nodes.length, sum, sums = new Array(n + 1);
        for(sums[0] = sum = i = 0; i < n; ++i)sums[i + 1] = sum += nodes[i].value;
        partition(0, n, parent.value, x0, y0, x1, y1);
        function partition(i, j, value, x0, y0, x1, y1) {
            if (i >= j - 1) {
                var node = nodes[i];
                node.x0 = x0, node.y0 = y0;
                node.x1 = x1, node.y1 = y1;
                return;
            }
            var valueOffset = sums[i], valueTarget = value / 2 + valueOffset, k = i + 1, hi = j - 1;
            while(k < hi){
                var mid = k + hi >>> 1;
                if (sums[mid] < valueTarget) k = mid + 1;
                else hi = mid;
            }
            if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
            var valueLeft = sums[k] - valueOffset, valueRight = value - valueLeft;
            if (x1 - x0 > y1 - y0) {
                var xk = value ? (x0 * valueRight + x1 * valueLeft) / value : x1;
                partition(i, k, valueLeft, x0, y0, xk, y1);
                partition(k, j, valueRight, xk, y0, x1, y1);
            } else {
                var yk = value ? (y0 * valueRight + y1 * valueLeft) / value : y1;
                partition(i, k, valueLeft, x0, y0, x1, yk);
                partition(k, j, valueRight, x0, yk, x1, y1);
            }
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"7xbEA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _diceJs = require("./dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var _squarifyJs = require("./squarify.js");
exports.default = function custom(ratio) {
    function resquarify(parent, x0, y0, x1, y1) {
        if ((rows = parent._squarify) && rows.ratio === ratio) {
            var rows, row, nodes, i, j = -1, n, m = rows.length, value = parent.value;
            while(++j < m){
                row = rows[j], nodes = row.children;
                for(i = row.value = 0, n = nodes.length; i < n; ++i)row.value += nodes[i].value;
                if (row.dice) (0, _diceJsDefault.default)(row, x0, y0, x1, value ? y0 += (y1 - y0) * row.value / value : y1);
                else (0, _sliceJsDefault.default)(row, x0, y0, value ? x0 += (x1 - x0) * row.value / value : x1, y1);
                value -= row.value;
            }
        } else {
            parent._squarify = rows = (0, _squarifyJs.squarifyRatio)(ratio, parent, x0, y0, x1, y1);
            rows.ratio = ratio;
        }
    }
    resquarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return resquarify;
}((0, _squarifyJs.phi));

},{"./dice.js":"9P9T1","./slice.js":"eov0u","./squarify.js":"lFjQX","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"kzww2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        (parent.depth & 1 ? (0, _sliceJsDefault.default) : (0, _diceJsDefault.default))(parent, x0, y0, x1, y1);
    });
var _diceJs = require("./dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);

},{"./dice.js":"9P9T1","./slice.js":"eov0u","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"aIpKT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "label", ()=>Label);
var _vegaScenegraph = require("vega-scenegraph");
var _vegaCanvas = require("vega-canvas");
var _vegaDataflow = require("vega-dataflow");
var _vegaUtil = require("vega-util");
// bit mask for getting first 2 bytes of alpha value
const ALPHA_MASK = 0xff000000;
function baseBitmaps($, data) {
    const bitmap = $.bitmap();
    // when there is no base mark but data points are to be avoided
    (data || []).forEach((d)=>bitmap.set($(d.boundary[0]), $(d.boundary[3])));
    return [
        bitmap,
        undefined
    ];
}
function markBitmaps($, baseMark, avoidMarks, labelInside, isGroupArea) {
    // create canvas
    const width = $.width, height = $.height, border = labelInside || isGroupArea, context = (0, _vegaCanvas.canvas)(width, height).getContext('2d'), baseMarkContext = (0, _vegaCanvas.canvas)(width, height).getContext('2d'), strokeContext = border && (0, _vegaCanvas.canvas)(width, height).getContext('2d');
    // render all marks to be avoided into canvas
    avoidMarks.forEach((items)=>draw(context, items, false));
    draw(baseMarkContext, baseMark, false);
    if (border) draw(strokeContext, baseMark, true);
    // get canvas buffer, create bitmaps
    const buffer = getBuffer(context, width, height), baseMarkBuffer = getBuffer(baseMarkContext, width, height), strokeBuffer = border && getBuffer(strokeContext, width, height), layer1 = $.bitmap(), layer2 = border && $.bitmap();
    // populate bitmap layers
    let x, y, u, v, index, alpha, strokeAlpha, baseMarkAlpha;
    for(y = 0; y < height; ++y)for(x = 0; x < width; ++x){
        index = y * width + x;
        alpha = buffer[index] & ALPHA_MASK;
        baseMarkAlpha = baseMarkBuffer[index] & ALPHA_MASK;
        strokeAlpha = border && strokeBuffer[index] & ALPHA_MASK;
        if (alpha || strokeAlpha || baseMarkAlpha) {
            u = $(x);
            v = $(y);
            if (!isGroupArea && (alpha || baseMarkAlpha)) layer1.set(u, v); // update interior bitmap
            if (border && (alpha || strokeAlpha)) layer2.set(u, v); // update border bitmap
        }
    }
    return [
        layer1,
        layer2
    ];
}
function getBuffer(context, width, height) {
    return new Uint32Array(context.getImageData(0, 0, width, height).data.buffer);
}
function draw(context, items, interior) {
    if (!items.length) return;
    const type = items[0].mark.marktype;
    if (type === 'group') items.forEach((group)=>{
        group.items.forEach((mark)=>draw(context, mark.items, interior));
    });
    else (0, _vegaScenegraph.Marks)[type].draw(context, {
        items: interior ? items.map(prepare) : items
    });
}
/**
 * Prepare item before drawing into canvas (setting stroke and opacity)
 * @param {object} source item to be prepared
 * @returns prepared item
 */ function prepare(source) {
    const item = (0, _vegaDataflow.rederive)(source, {});
    if (item.stroke && item.strokeOpacity !== 0 || item.fill && item.fillOpacity !== 0) return {
        ...item,
        strokeOpacity: 1,
        stroke: '#000',
        fillOpacity: 0
    };
    return item;
}
const DIV = 5, // bit shift from x, y index to bit vector array index
MOD = 31, // bit mask for index lookup within a bit vector
SIZE = 32, // individual bit vector size
RIGHT0 = new Uint32Array(SIZE + 1), // left-anchored bit vectors, full -> 0
RIGHT1 = new Uint32Array(SIZE + 1); // right-anchored bit vectors, 0 -> full
RIGHT1[0] = 0;
RIGHT0[0] = ~RIGHT1[0];
for(let i = 1; i <= SIZE; ++i){
    RIGHT1[i] = RIGHT1[i - 1] << 1 | 1;
    RIGHT0[i] = ~RIGHT1[i];
}
function Bitmap(w, h) {
    const array = new Uint32Array(~~((w * h + SIZE) / SIZE));
    function _set(index, mask) {
        array[index] |= mask;
    }
    function _clear(index, mask) {
        array[index] &= mask;
    }
    return {
        array: array,
        get: (x, y)=>{
            const index = y * w + x;
            return array[index >>> DIV] & 1 << (index & MOD);
        },
        set: (x, y)=>{
            const index = y * w + x;
            _set(index >>> DIV, 1 << (index & MOD));
        },
        clear: (x, y)=>{
            const index = y * w + x;
            _clear(index >>> DIV, ~(1 << (index & MOD)));
        },
        getRange: (x, y, x2, y2)=>{
            let r = y2, start, end, indexStart, indexEnd;
            for(; r >= y; --r){
                start = r * w + x;
                end = r * w + x2;
                indexStart = start >>> DIV;
                indexEnd = end >>> DIV;
                if (indexStart === indexEnd) {
                    if (array[indexStart] & RIGHT0[start & MOD] & RIGHT1[(end & MOD) + 1]) return true;
                } else {
                    if (array[indexStart] & RIGHT0[start & MOD]) return true;
                    if (array[indexEnd] & RIGHT1[(end & MOD) + 1]) return true;
                    for(let i = indexStart + 1; i < indexEnd; ++i){
                        if (array[i]) return true;
                    }
                }
            }
            return false;
        },
        setRange: (x, y, x2, y2)=>{
            let start, end, indexStart, indexEnd, i;
            for(; y <= y2; ++y){
                start = y * w + x;
                end = y * w + x2;
                indexStart = start >>> DIV;
                indexEnd = end >>> DIV;
                if (indexStart === indexEnd) _set(indexStart, RIGHT0[start & MOD] & RIGHT1[(end & MOD) + 1]);
                else {
                    _set(indexStart, RIGHT0[start & MOD]);
                    _set(indexEnd, RIGHT1[(end & MOD) + 1]);
                    for(i = indexStart + 1; i < indexEnd; ++i)_set(i, 0xffffffff);
                }
            }
        },
        clearRange: (x, y, x2, y2)=>{
            let start, end, indexStart, indexEnd, i;
            for(; y <= y2; ++y){
                start = y * w + x;
                end = y * w + x2;
                indexStart = start >>> DIV;
                indexEnd = end >>> DIV;
                if (indexStart === indexEnd) _clear(indexStart, RIGHT1[start & MOD] | RIGHT0[(end & MOD) + 1]);
                else {
                    _clear(indexStart, RIGHT1[start & MOD]);
                    _clear(indexEnd, RIGHT0[(end & MOD) + 1]);
                    for(i = indexStart + 1; i < indexEnd; ++i)_clear(i, 0);
                }
            }
        },
        outOfBounds: (x, y, x2, y2)=>x < 0 || y < 0 || y2 >= h || x2 >= w
    };
}
function scaler(width, height, padding) {
    const ratio = Math.max(1, Math.sqrt(width * height / 1e6)), w = ~~((width + 2 * padding + ratio) / ratio), h = ~~((height + 2 * padding + ratio) / ratio), scale = (_)=>~~((_ + padding) / ratio);
    scale.invert = (_)=>_ * ratio - padding;
    scale.bitmap = ()=>Bitmap(w, h);
    scale.ratio = ratio;
    scale.padding = padding;
    scale.width = width;
    scale.height = height;
    return scale;
}
function placeAreaLabelNaive($, bitmaps, avoidBaseMark, markIndex) {
    const width = $.width, height = $.height;
    // try to place a label within an input area mark
    return function(d) {
        const items = d.datum.datum.items[markIndex].items, // area points
        n = items.length, // number of points
        textHeight = d.datum.fontSize, // label width
        textWidth = (0, _vegaScenegraph.textMetrics).width(d.datum, d.datum.text); // label height
        let maxAreaWidth = 0, x1, x2, y1, y2, x, y, areaWidth;
        // for each area sample point
        for(let i = 0; i < n; ++i){
            x1 = items[i].x;
            y1 = items[i].y;
            x2 = items[i].x2 === undefined ? x1 : items[i].x2;
            y2 = items[i].y2 === undefined ? y1 : items[i].y2;
            x = (x1 + x2) / 2;
            y = (y1 + y2) / 2;
            areaWidth = Math.abs(x2 - x1 + y2 - y1);
            if (areaWidth >= maxAreaWidth) {
                maxAreaWidth = areaWidth;
                d.x = x;
                d.y = y;
            }
        }
        x = textWidth / 2;
        y = textHeight / 2;
        x1 = d.x - x;
        x2 = d.x + x;
        y1 = d.y - y;
        y2 = d.y + y;
        d.align = 'center';
        if (x1 < 0 && x2 <= width) d.align = 'left';
        else if (0 <= x1 && width < x2) d.align = 'right';
        d.baseline = 'middle';
        if (y1 < 0 && y2 <= height) d.baseline = 'top';
        else if (0 <= y1 && height < y2) d.baseline = 'bottom';
        return true;
    };
}
function outOfBounds(x, y, textWidth, textHeight, width, height) {
    let r = textWidth / 2;
    return x - r < 0 || x + r > width || y - (r = textHeight / 2) < 0 || y + r > height;
}
function collision($, x, y, textHeight, textWidth, h, bm0, bm1) {
    const w = textWidth * h / (textHeight * 2), x1 = $(x - w), x2 = $(x + w), y1 = $(y - (h = h / 2)), y2 = $(y + h);
    return bm0.outOfBounds(x1, y1, x2, y2) || bm0.getRange(x1, y1, x2, y2) || bm1 && bm1.getRange(x1, y1, x2, y2);
}
function placeAreaLabelReducedSearch($, bitmaps, avoidBaseMark, markIndex) {
    const width = $.width, height = $.height, bm0 = bitmaps[0], // where labels have been placed
    bm1 = bitmaps[1]; // area outlines
    function tryLabel(_x, _y, maxSize, textWidth, textHeight) {
        const x = $.invert(_x), y = $.invert(_y);
        let lo = maxSize, hi = height, mid;
        if (!outOfBounds(x, y, textWidth, textHeight, width, height) && !collision($, x, y, textHeight, textWidth, lo, bm0, bm1) && !collision($, x, y, textHeight, textWidth, textHeight, bm0, null)) {
            // if the label fits at the current sample point,
            // perform binary search to find the largest font size that fits
            while(hi - lo >= 1){
                mid = (lo + hi) / 2;
                if (collision($, x, y, textHeight, textWidth, mid, bm0, bm1)) hi = mid;
                else lo = mid;
            }
            // place label if current lower bound exceeds prior max font size
            if (lo > maxSize) return [
                x,
                y,
                lo,
                true
            ];
        }
    }
    // try to place a label within an input area mark
    return function(d) {
        const items = d.datum.datum.items[markIndex].items, // area points
        n = items.length, // number of points
        textHeight = d.datum.fontSize, // label width
        textWidth = (0, _vegaScenegraph.textMetrics).width(d.datum, d.datum.text); // label height
        let maxSize = avoidBaseMark ? textHeight : 0, labelPlaced = false, labelPlaced2 = false, maxAreaWidth = 0, x1, x2, y1, y2, x, y, _x, _y, _x1, _xMid, _x2, _y1, _yMid, _y2, areaWidth, result, swapTmp;
        // for each area sample point
        for(let i = 0; i < n; ++i){
            x1 = items[i].x;
            y1 = items[i].y;
            x2 = items[i].x2 === undefined ? x1 : items[i].x2;
            y2 = items[i].y2 === undefined ? y1 : items[i].y2;
            if (x1 > x2) {
                swapTmp = x1;
                x1 = x2;
                x2 = swapTmp;
            }
            if (y1 > y2) {
                swapTmp = y1;
                y1 = y2;
                y2 = swapTmp;
            }
            _x1 = $(x1);
            _x2 = $(x2);
            _xMid = ~~((_x1 + _x2) / 2);
            _y1 = $(y1);
            _y2 = $(y2);
            _yMid = ~~((_y1 + _y2) / 2);
            // search along the line from mid point between the 2 border to lower border
            for(_x = _xMid; _x >= _x1; --_x)for(_y = _yMid; _y >= _y1; --_y){
                result = tryLabel(_x, _y, maxSize, textWidth, textHeight);
                if (result) [d.x, d.y, maxSize, labelPlaced] = result;
            }
            // search along the line from mid point between the 2 border to upper border
            for(_x = _xMid; _x <= _x2; ++_x)for(_y = _yMid; _y <= _y2; ++_y){
                result = tryLabel(_x, _y, maxSize, textWidth, textHeight);
                if (result) [d.x, d.y, maxSize, labelPlaced] = result;
            }
            // place label at slice center if not placed through other means
            // and if we're not avoiding overlap with other areas
            if (!labelPlaced && !avoidBaseMark) {
                // one span is zero, hence we can add
                areaWidth = Math.abs(x2 - x1 + y2 - y1);
                x = (x1 + x2) / 2;
                y = (y1 + y2) / 2;
                // place label if it fits and improves the max area width
                if (areaWidth >= maxAreaWidth && !outOfBounds(x, y, textWidth, textHeight, width, height) && !collision($, x, y, textHeight, textWidth, textHeight, bm0, null)) {
                    maxAreaWidth = areaWidth;
                    d.x = x;
                    d.y = y;
                    labelPlaced2 = true;
                }
            }
        }
        // record current label placement information, update label bitmap
        if (labelPlaced || labelPlaced2) {
            x = textWidth / 2;
            y = textHeight / 2;
            bm0.setRange($(d.x - x), $(d.y - y), $(d.x + x), $(d.y + y));
            d.align = 'center';
            d.baseline = 'middle';
            return true;
        } else return false;
    };
}
// pixel direction offsets for flood fill search
const X_DIR = [
    -1,
    -1,
    1,
    1
];
const Y_DIR = [
    -1,
    1,
    -1,
    1
];
function placeAreaLabelFloodFill($, bitmaps, avoidBaseMark, markIndex) {
    const width = $.width, height = $.height, bm0 = bitmaps[0], // where labels have been placed
    bm1 = bitmaps[1], // area outlines
    bm2 = $.bitmap(); // flood-fill visitations
    // try to place a label within an input area mark
    return function(d) {
        const items = d.datum.datum.items[markIndex].items, // area points
        n = items.length, // number of points
        textHeight = d.datum.fontSize, // label width
        textWidth = (0, _vegaScenegraph.textMetrics).width(d.datum, d.datum.text), // label height
        stack = []; // flood fill stack
        let maxSize = avoidBaseMark ? textHeight : 0, labelPlaced = false, labelPlaced2 = false, maxAreaWidth = 0, x1, x2, y1, y2, x, y, _x, _y, lo, hi, mid, areaWidth;
        // for each area sample point
        for(let i = 0; i < n; ++i){
            x1 = items[i].x;
            y1 = items[i].y;
            x2 = items[i].x2 === undefined ? x1 : items[i].x2;
            y2 = items[i].y2 === undefined ? y1 : items[i].y2;
            // add scaled center point to stack
            stack.push([
                $((x1 + x2) / 2),
                $((y1 + y2) / 2)
            ]);
            // perform flood fill, visit points
            while(stack.length){
                [_x, _y] = stack.pop();
                // exit if point already marked
                if (bm0.get(_x, _y) || bm1.get(_x, _y) || bm2.get(_x, _y)) continue;
                // mark point in flood fill bitmap
                // add search points for all (in bound) directions
                bm2.set(_x, _y);
                for(let j = 0; j < 4; ++j){
                    x = _x + X_DIR[j];
                    y = _y + Y_DIR[j];
                    if (!bm2.outOfBounds(x, y, x, y)) stack.push([
                        x,
                        y
                    ]);
                }
                // unscale point back to x, y space
                x = $.invert(_x);
                y = $.invert(_y);
                lo = maxSize;
                hi = height; // TODO: make this bound smaller
                if (!outOfBounds(x, y, textWidth, textHeight, width, height) && !collision($, x, y, textHeight, textWidth, lo, bm0, bm1) && !collision($, x, y, textHeight, textWidth, textHeight, bm0, null)) {
                    // if the label fits at the current sample point,
                    // perform binary search to find the largest font size that fits
                    while(hi - lo >= 1){
                        mid = (lo + hi) / 2;
                        if (collision($, x, y, textHeight, textWidth, mid, bm0, bm1)) hi = mid;
                        else lo = mid;
                    }
                    // place label if current lower bound exceeds prior max font size
                    if (lo > maxSize) {
                        d.x = x;
                        d.y = y;
                        maxSize = lo;
                        labelPlaced = true;
                    }
                }
            }
            // place label at slice center if not placed through other means
            // and if we're not avoiding overlap with other areas
            if (!labelPlaced && !avoidBaseMark) {
                // one span is zero, hence we can add
                areaWidth = Math.abs(x2 - x1 + y2 - y1);
                x = (x1 + x2) / 2;
                y = (y1 + y2) / 2;
                // place label if it fits and improves the max area width
                if (areaWidth >= maxAreaWidth && !outOfBounds(x, y, textWidth, textHeight, width, height) && !collision($, x, y, textHeight, textWidth, textHeight, bm0, null)) {
                    maxAreaWidth = areaWidth;
                    d.x = x;
                    d.y = y;
                    labelPlaced2 = true;
                }
            }
        }
        // record current label placement information, update label bitmap
        if (labelPlaced || labelPlaced2) {
            x = textWidth / 2;
            y = textHeight / 2;
            bm0.setRange($(d.x - x), $(d.y - y), $(d.x + x), $(d.y + y));
            d.align = 'center';
            d.baseline = 'middle';
            return true;
        } else return false;
    };
}
const Aligns = [
    'right',
    'center',
    'left'
], Baselines = [
    'bottom',
    'middle',
    'top'
];
function placeMarkLabel($, bitmaps, anchors, offsets) {
    const width = $.width, height = $.height, bm0 = bitmaps[0], bm1 = bitmaps[1], n = offsets.length;
    return function(d) {
        const boundary = d.boundary, textHeight = d.datum.fontSize;
        // can not be placed if the mark is not visible in the graph bound
        if (boundary[2] < 0 || boundary[5] < 0 || boundary[0] > width || boundary[3] > height) return false;
        let textWidth = d.textWidth ?? 0, dx, dy, isInside, sizeFactor, insideFactor, x1, x2, y1, y2, xc, yc, _x1, _x2, _y1, _y2;
        // for each anchor and offset
        for(let i = 0; i < n; ++i){
            dx = (anchors[i] & 0x3) - 1;
            dy = (anchors[i] >>> 0x2 & 0x3) - 1;
            isInside = dx === 0 && dy === 0 || offsets[i] < 0;
            sizeFactor = dx && dy ? Math.SQRT1_2 : 1;
            insideFactor = offsets[i] < 0 ? -1 : 1;
            x1 = boundary[1 + dx] + offsets[i] * dx * sizeFactor;
            yc = boundary[4 + dy] + insideFactor * textHeight * dy / 2 + offsets[i] * dy * sizeFactor;
            y1 = yc - textHeight / 2;
            y2 = yc + textHeight / 2;
            _x1 = $(x1);
            _y1 = $(y1);
            _y2 = $(y2);
            if (!textWidth) {
                // to avoid finding width of text label,
                if (!test(_x1, _x1, _y1, _y2, bm0, bm1, x1, x1, y1, y2, boundary, isInside)) continue;
                else // Otherwise, find the label width
                textWidth = (0, _vegaScenegraph.textMetrics).width(d.datum, d.datum.text);
            }
            xc = x1 + insideFactor * textWidth * dx / 2;
            x1 = xc - textWidth / 2;
            x2 = xc + textWidth / 2;
            _x1 = $(x1);
            _x2 = $(x2);
            if (test(_x1, _x2, _y1, _y2, bm0, bm1, x1, x2, y1, y2, boundary, isInside)) {
                // place label if the position is placeable
                d.x = !dx ? xc : dx * insideFactor < 0 ? x2 : x1;
                d.y = !dy ? yc : dy * insideFactor < 0 ? y2 : y1;
                d.align = Aligns[dx * insideFactor + 1];
                d.baseline = Baselines[dy * insideFactor + 1];
                bm0.setRange(_x1, _y1, _x2, _y2);
                return true;
            }
        }
        return false;
    };
}
// Test if a label with the given dimensions can be added without overlap
function test(_x1, _x2, _y1, _y2, bm0, bm1, x1, x2, y1, y2, boundary, isInside) {
    return !(bm0.outOfBounds(_x1, _y1, _x2, _y2) || (isInside && bm1 || bm0).getRange(_x1, _y1, _x2, _y2));
}
// 8-bit representation of anchors
const TOP = 0x0, MIDDLE = 0x4, BOTTOM = 0x8, LEFT = 0x0, CENTER = 0x1, RIGHT = 0x2;
// Mapping from text anchor to number representation
const anchorCode = {
    'top-left': TOP + LEFT,
    'top': TOP + CENTER,
    'top-right': TOP + RIGHT,
    'left': MIDDLE + LEFT,
    'middle': MIDDLE + CENTER,
    'right': MIDDLE + RIGHT,
    'bottom-left': BOTTOM + LEFT,
    'bottom': BOTTOM + CENTER,
    'bottom-right': BOTTOM + RIGHT
};
const placeAreaLabel = {
    'naive': placeAreaLabelNaive,
    'reduced-search': placeAreaLabelReducedSearch,
    'floodfill': placeAreaLabelFloodFill
};
function labelLayout(texts, size, compare, offset, anchor, avoidMarks, avoidBaseMark, lineAnchor, markIndex, padding, method) {
    // early exit for empty data
    if (!texts.length) return texts;
    const positions = Math.max(offset.length, anchor.length), offsets = getOffsets(offset, positions), anchors = getAnchors(anchor, positions), marktype = markType(texts[0].datum), grouptype = marktype === 'group' && texts[0].datum.items[markIndex].marktype, isGroupArea = grouptype === 'area', boundary = markBoundary(marktype, grouptype, lineAnchor, markIndex), infPadding = padding === null || padding === Infinity, isNaiveGroupArea = isGroupArea && method === 'naive';
    let maxTextWidth = -1, maxTextHeight = -1;
    // prepare text mark data for placing
    const data = texts.map((d)=>{
        const textWidth = infPadding ? (0, _vegaScenegraph.textMetrics).width(d, d.text) : undefined;
        maxTextWidth = Math.max(maxTextWidth, textWidth);
        maxTextHeight = Math.max(maxTextHeight, d.fontSize);
        return {
            datum: d,
            opacity: 0,
            x: undefined,
            y: undefined,
            align: undefined,
            baseline: undefined,
            boundary: boundary(d),
            textWidth
        };
    });
    padding = padding === null || padding === Infinity ? Math.max(maxTextWidth, maxTextHeight) + Math.max(...offset) : padding;
    const $ = scaler(size[0], size[1], padding);
    let bitmaps;
    if (!isNaiveGroupArea) {
        // sort labels in priority order, if comparator is provided
        if (compare) data.sort((a, b)=>compare(a.datum, b.datum));
        // flag indicating if label can be placed inside its base mark
        let labelInside = false;
        for(let i = 0; i < anchors.length && !labelInside; ++i)// label inside if anchor is at center
        // label inside if offset to be inside the mark bound
        labelInside = anchors[i] === 0x5 || offsets[i] < 0;
        // extract data information from base mark when base mark is to be avoided
        // base mark is implicitly avoided if it is a group area
        const baseMark = (marktype && avoidBaseMark || isGroupArea) && texts.map((d)=>d.datum);
        // generate bitmaps for layout calculation
        bitmaps = avoidMarks.length || baseMark ? markBitmaps($, baseMark || [], avoidMarks, labelInside, isGroupArea) : baseBitmaps($, avoidBaseMark && data);
    }
    // generate label placement function
    const place = isGroupArea ? placeAreaLabel[method]($, bitmaps, avoidBaseMark, markIndex) : placeMarkLabel($, bitmaps, anchors, offsets);
    // place all labels
    data.forEach((d)=>d.opacity = +place(d));
    return data;
}
function getOffsets(_, count) {
    const offsets = new Float64Array(count), n = _.length;
    for(let i = 0; i < n; ++i)offsets[i] = _[i] || 0;
    for(let i = n; i < count; ++i)offsets[i] = offsets[n - 1];
    return offsets;
}
function getAnchors(_, count) {
    const anchors = new Int8Array(count), n = _.length;
    for(let i = 0; i < n; ++i)anchors[i] |= anchorCode[_[i]];
    for(let i = n; i < count; ++i)anchors[i] = anchors[n - 1];
    return anchors;
}
function markType(item) {
    return item && item.mark && item.mark.marktype;
}
/**
 * Factory function for function for getting base mark boundary, depending
 * on mark and group type. When mark type is undefined, line or area: boundary
 * is the coordinate of each data point. When base mark is grouped line,
 * boundary is either at the start or end of the line depending on the
 * value of lineAnchor. Otherwise, use bounds of base mark.
 */ function markBoundary(marktype, grouptype, lineAnchor, markIndex) {
    const xy = (d)=>[
            d.x,
            d.x,
            d.x,
            d.y,
            d.y,
            d.y
        ];
    if (!marktype) return xy; // no reactive geometry
    else if (marktype === 'line' || marktype === 'area') return (d)=>xy(d.datum);
    else if (grouptype === 'line') return (d)=>{
        const items = d.datum.items[markIndex].items;
        return xy(items.length ? items[lineAnchor === 'start' ? 0 : items.length - 1] : {
            x: NaN,
            y: NaN
        });
    };
    else return (d)=>{
        const b = d.datum.bounds;
        return [
            b.x1,
            (b.x1 + b.x2) / 2,
            b.x2,
            b.y1,
            (b.y1 + b.y2) / 2,
            b.y2
        ];
    };
}
const Output = [
    'x',
    'y',
    'opacity',
    'align',
    'baseline'
];
const Anchors = [
    'top-left',
    'left',
    'bottom-left',
    'top',
    'bottom',
    'top-right',
    'right',
    'bottom-right'
];
/**
 * Compute text label layout to annotate marks.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<number>} params.size - The size of the layout, provided as a [width, height] array.
 * @param {function(*,*): number} [params.sort] - An optional
 *   comparator function for sorting label data in priority order.
 * @param {Array<string>} [params.anchor] - Label anchor points relative to the base mark bounding box.
 *   The available options are 'top-left', 'left', 'bottom-left', 'top',
 *   'bottom', 'top-right', 'right', 'bottom-right', 'middle'.
 * @param {Array<number>} [params.offset] - Label offsets (in pixels) from the base mark bounding box.
 *   This parameter is parallel to the list of anchor points.
 * @param {number | null} [params.padding=0] - The amount (in pixels) that a label may exceed the layout size.
 *   If this parameter is null, a label may exceed the layout size without any boundary.
 * @param {string} [params.lineAnchor='end'] - For group line mark labels only, indicates the anchor
 *   position for labels. One of 'start' or 'end'.
 * @param {string} [params.markIndex=0] - For group mark labels only, an index indicating
 *   which mark within the group should be labeled.
 * @param {Array<number>} [params.avoidMarks] - A list of additional mark names for which the label
 *   layout should avoid overlap.
 * @param {boolean} [params.avoidBaseMark=true] - Boolean flag indicating if labels should avoid
 *   overlap with the underlying base mark being labeled.
 * @param {string} [params.method='naive'] - For area make labels only, a method for
 *   place labels. One of 'naive', 'reduced-search', or 'floodfill'.
 * @param {Array<string>} [params.as] - The output fields written by the transform.
 *   The default is ['x', 'y', 'opacity', 'align', 'baseline'].
 */ function Label(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Label.Definition = {
    type: 'Label',
    metadata: {
        modifies: true
    },
    params: [
        {
            name: 'size',
            type: 'number',
            array: true,
            length: 2,
            required: true
        },
        {
            name: 'sort',
            type: 'compare'
        },
        {
            name: 'anchor',
            type: 'string',
            array: true,
            default: Anchors
        },
        {
            name: 'offset',
            type: 'number',
            array: true,
            default: [
                1
            ]
        },
        {
            name: 'padding',
            type: 'number',
            default: 0,
            null: true
        },
        {
            name: 'lineAnchor',
            type: 'string',
            values: [
                'start',
                'end'
            ],
            default: 'end'
        },
        {
            name: 'markIndex',
            type: 'number',
            default: 0
        },
        {
            name: 'avoidBaseMark',
            type: 'boolean',
            default: true
        },
        {
            name: 'avoidMarks',
            type: 'data',
            array: true
        },
        {
            name: 'method',
            type: 'string',
            default: 'naive'
        },
        {
            name: 'as',
            type: 'string',
            array: true,
            length: Output.length,
            default: Output
        }
    ]
};
(0, _vegaUtil.inherits)(Label, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        function modp(param) {
            const p = _[param];
            return (0, _vegaUtil.isFunction)(p) && pulse.modified(p.fields);
        }
        const mod = _.modified();
        if (!(mod || pulse.changed(pulse.ADD_REM) || modp('sort'))) return;
        if (!_.size || _.size.length !== 2) (0, _vegaUtil.error)('Size parameter should be specified as a [width, height] array.');
        const as = _.as || Output;
        // run label layout
        labelLayout(pulse.materialize(pulse.SOURCE).source || [], _.size, _.sort, (0, _vegaUtil.array)(_.offset == null ? 1 : _.offset), (0, _vegaUtil.array)(_.anchor || Anchors), _.avoidMarks || [], _.avoidBaseMark !== false, _.lineAnchor || 'end', _.markIndex || 0, _.padding === undefined ? 0 : _.padding, _.method || 'naive').forEach((l)=>{
            // write layout results to data stream
            const t = l.datum;
            t[as[0]] = l.x;
            t[as[1]] = l.y;
            t[as[2]] = l.opacity;
            t[as[3]] = l.align;
            t[as[4]] = l.baseline;
        });
        return pulse.reflow(mod).modifies(as);
    }
});

},{"vega-scenegraph":"823vy","vega-canvas":"duGNb","vega-dataflow":"4An7U","vega-util":"7f6sQ","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8OJCr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loess", ()=>Loess);
parcelHelpers.export(exports, "regression", ()=>Regression);
var _vegaStatistics = require("vega-statistics");
var _vegaDataflow = require("vega-dataflow");
var _vegaUtil = require("vega-util");
function partition(data, groupby) {
    var groups = [], get = function(f) {
        return f(t);
    }, map, i, n, t, k, g;
    // partition data points into stack groups
    if (groupby == null) groups.push(data);
    else for(map = {}, i = 0, n = data.length; i < n; ++i){
        t = data[i];
        k = groupby.map(get);
        g = map[k];
        if (!g) {
            map[k] = g = [];
            g.dims = k;
            groups.push(g);
        }
        g.push(t);
    }
    return groups;
}
/**
 * Compute locally-weighted regression fits for one or more data groups.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.x - An accessor for the predictor data field.
 * @param {function(object): *} params.y - An accessor for the predicted data field.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors to groupby.
 * @param {number} [params.bandwidth=0.3] - The loess bandwidth.
 */ function Loess(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Loess.Definition = {
    'type': 'Loess',
    'metadata': {
        'generates': true
    },
    'params': [
        {
            'name': 'x',
            'type': 'field',
            'required': true
        },
        {
            'name': 'y',
            'type': 'field',
            'required': true
        },
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'bandwidth',
            'type': 'number',
            'default': 0.3
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true
        }
    ]
};
(0, _vegaUtil.inherits)(Loess, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
        if (!this.value || pulse.changed() || _.modified()) {
            const source = pulse.materialize(pulse.SOURCE).source, groups = partition(source, _.groupby), names = (_.groupby || []).map((0, _vegaUtil.accessorName)), m = names.length, as = _.as || [
                (0, _vegaUtil.accessorName)(_.x),
                (0, _vegaUtil.accessorName)(_.y)
            ], values = [];
            groups.forEach((g)=>{
                (0, _vegaStatistics.regressionLoess)(g, _.x, _.y, _.bandwidth || 0.3).forEach((p)=>{
                    const t = {};
                    for(let i = 0; i < m; ++i)t[names[i]] = g.dims[i];
                    t[as[0]] = p[0];
                    t[as[1]] = p[1];
                    values.push((0, _vegaDataflow.ingest)(t));
                });
            });
            if (this.value) out.rem = this.value;
            this.value = out.add = out.source = values;
        }
        return out;
    }
});
const Methods = {
    constant: (0, _vegaStatistics.regressionConstant),
    linear: (0, _vegaStatistics.regressionLinear),
    log: (0, _vegaStatistics.regressionLog),
    exp: (0, _vegaStatistics.regressionExp),
    pow: (0, _vegaStatistics.regressionPow),
    quad: (0, _vegaStatistics.regressionQuad),
    poly: (0, _vegaStatistics.regressionPoly)
};
const degreesOfFreedom = (method, order)=>method === 'poly' ? order : method === 'quad' ? 2 : 1;
/**
 * Compute regression fits for one or more data groups.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.x - An accessor for the predictor data field.
 * @param {function(object): *} params.y - An accessor for the predicted data field.
 * @param {string} [params.method='linear'] - The regression method to apply.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors to groupby.
 * @param {Array<number>} [params.extent] - The domain extent over which to plot the regression line.
 * @param {number} [params.order=3] - The polynomial order. Only applies to the 'poly' method.
 */ function Regression(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Regression.Definition = {
    'type': 'Regression',
    'metadata': {
        'generates': true
    },
    'params': [
        {
            'name': 'x',
            'type': 'field',
            'required': true
        },
        {
            'name': 'y',
            'type': 'field',
            'required': true
        },
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'method',
            'type': 'string',
            'default': 'linear',
            'values': Object.keys(Methods)
        },
        {
            'name': 'order',
            'type': 'number',
            'default': 3
        },
        {
            'name': 'extent',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'params',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true
        }
    ]
};
(0, _vegaUtil.inherits)(Regression, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
        if (!this.value || pulse.changed() || _.modified()) {
            const source = pulse.materialize(pulse.SOURCE).source, groups = partition(source, _.groupby), names = (_.groupby || []).map((0, _vegaUtil.accessorName)), method = _.method || 'linear', order = _.order == null ? 3 : _.order, dof = degreesOfFreedom(method, order), as = _.as || [
                (0, _vegaUtil.accessorName)(_.x),
                (0, _vegaUtil.accessorName)(_.y)
            ], fit = Methods[method], values = [];
            let domain = _.extent;
            if (!(0, _vegaUtil.hasOwnProperty)(Methods, method)) (0, _vegaUtil.error)('Invalid regression method: ' + method);
            if (domain != null) {
                if (method === 'log' && domain[0] <= 0) {
                    pulse.dataflow.warn('Ignoring extent with values <= 0 for log regression.');
                    domain = null;
                }
            }
            groups.forEach((g)=>{
                const n = g.length;
                if (n <= dof) {
                    pulse.dataflow.warn('Skipping regression with more parameters than data points.');
                    return;
                }
                const model = fit(g, _.x, _.y, order);
                if (_.params) {
                    // if parameter vectors requested return those
                    values.push((0, _vegaDataflow.ingest)({
                        keys: g.dims,
                        coef: model.coef,
                        rSquared: model.rSquared
                    }));
                    return;
                }
                const dom = domain || (0, _vegaUtil.extent)(g, _.x), add = (p)=>{
                    const t = {};
                    for(let i = 0; i < names.length; ++i)t[names[i]] = g.dims[i];
                    t[as[0]] = p[0];
                    t[as[1]] = p[1];
                    values.push((0, _vegaDataflow.ingest)(t));
                };
                if (method === 'linear' || method === 'constant') // for linear or constant regression we only need the end points
                dom.forEach((x)=>add([
                        x,
                        model.predict(x)
                    ]));
                else // otherwise return trend line sample points
                (0, _vegaStatistics.sampleCurve)(model.predict, dom, 25, 200).forEach(add);
            });
            if (this.value) out.rem = this.value;
            this.value = out.add = out.source = values;
        }
        return out;
    }
});

},{"vega-statistics":"lNUxJ","vega-dataflow":"4An7U","vega-util":"7f6sQ","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"6mtJw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "voronoi", ()=>Voronoi);
var _vegaDataflow = require("vega-dataflow");
var _vegaUtil = require("vega-util");
var _d3Delaunay = require("d3-delaunay");
function Voronoi(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Voronoi.Definition = {
    'type': 'Voronoi',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'x',
            'type': 'field',
            'required': true
        },
        {
            'name': 'y',
            'type': 'field',
            'required': true
        },
        {
            'name': 'size',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'extent',
            'type': 'array',
            'array': true,
            'length': 2,
            'default': [
                [
                    -100000,
                    -100000
                ],
                [
                    1e5,
                    1e5
                ]
            ],
            'content': {
                'type': 'number',
                'array': true,
                'length': 2
            }
        },
        {
            'name': 'as',
            'type': 'string',
            'default': 'path'
        }
    ]
};
const defaultExtent = [
    -100000,
    -100000,
    1e5,
    1e5
];
(0, _vegaUtil.inherits)(Voronoi, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const as = _.as || 'path', data = pulse.source;
        // nothing to do if no data
        if (!data || !data.length) return pulse;
        // configure and construct voronoi diagram
        let s = _.size;
        s = s ? [
            0,
            0,
            s[0],
            s[1]
        ] : (s = _.extent) ? [
            s[0][0],
            s[0][1],
            s[1][0],
            s[1][1]
        ] : defaultExtent;
        const voronoi = this.value = (0, _d3Delaunay.Delaunay).from(data, _.x, _.y).voronoi(s);
        // map polygons to paths
        for(let i = 0, n = data.length; i < n; ++i){
            const polygon = voronoi.cellPolygon(i);
            data[i][as] = polygon && !isPoint(polygon) ? toPathString(polygon) : null;
        }
        return pulse.reflow(_.modified()).modifies(as);
    }
});
// suppress duplicated end point vertices
function toPathString(p) {
    const x = p[0][0], y = p[0][1];
    let n = p.length - 1;
    for(; p[n][0] === x && p[n][1] === y; --n);
    return 'M' + p.slice(0, n + 1).join('L') + 'Z';
}
function isPoint(p) {
    return p.length === 2 && p[0][0] === p[1][0] && p[0][1] === p[1][1];
}

},{"vega-dataflow":"4An7U","vega-util":"7f6sQ","d3-delaunay":[["Delaunay","4Qqwe","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4Qqwe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _delaunator = require("delaunator");
var _delaunatorDefault = parcelHelpers.interopDefault(_delaunator);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
var _polygonJs = require("./polygon.js");
var _polygonJsDefault = parcelHelpers.interopDefault(_polygonJs);
var _voronoiJs = require("./voronoi.js");
var _voronoiJsDefault = parcelHelpers.interopDefault(_voronoiJs);
const tau = 2 * Math.PI, pow = Math.pow;
function pointX(p) {
    return p[0];
}
function pointY(p) {
    return p[1];
}
// A triangulation is collinear if all its triangles have a non-null area
function collinear(d) {
    const { triangles, coords } = d;
    for(let i = 0; i < triangles.length; i += 3){
        const a = 2 * triangles[i], b = 2 * triangles[i + 1], c = 2 * triangles[i + 2], cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
        if (cross > 1e-10) return false;
    }
    return true;
}
function jitter(x, y, r) {
    return [
        x + Math.sin(x + y) * r,
        y + Math.cos(x - y) * r
    ];
}
class Delaunay {
    static from(points, fx = pointX, fy = pointY, that) {
        return new Delaunay("length" in points ? flatArray(points, fx, fy, that) : Float64Array.from(flatIterable(points, fx, fy, that)));
    }
    constructor(points){
        this._delaunator = new (0, _delaunatorDefault.default)(points);
        this.inedges = new Int32Array(points.length / 2);
        this._hullIndex = new Int32Array(points.length / 2);
        this.points = this._delaunator.coords;
        this._init();
    }
    update() {
        this._delaunator.update();
        this._init();
        return this;
    }
    _init() {
        const d = this._delaunator, points = this.points;
        // check for collinear
        if (d.hull && d.hull.length > 2 && collinear(d)) {
            this.collinear = Int32Array.from({
                length: points.length / 2
            }, (_, i)=>i).sort((i, j)=>points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]); // for exact neighbors
            const e = this.collinear[0], f = this.collinear[this.collinear.length - 1], bounds = [
                points[2 * e],
                points[2 * e + 1],
                points[2 * f],
                points[2 * f + 1]
            ], r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
            for(let i = 0, n = points.length / 2; i < n; ++i){
                const p = jitter(points[2 * i], points[2 * i + 1], r);
                points[2 * i] = p[0];
                points[2 * i + 1] = p[1];
            }
            this._delaunator = new (0, _delaunatorDefault.default)(points);
        } else delete this.collinear;
        const halfedges = this.halfedges = this._delaunator.halfedges;
        const hull = this.hull = this._delaunator.hull;
        const triangles = this.triangles = this._delaunator.triangles;
        const inedges = this.inedges.fill(-1);
        const hullIndex = this._hullIndex.fill(-1);
        // Compute an index from each point to an (arbitrary) incoming halfedge
        // Used to give the first neighbor of each point; for this reason,
        // on the hull we give priority to exterior halfedges
        for(let e = 0, n = halfedges.length; e < n; ++e){
            const p = triangles[e % 3 === 2 ? e - 2 : e + 1];
            if (halfedges[e] === -1 || inedges[p] === -1) inedges[p] = e;
        }
        for(let i = 0, n = hull.length; i < n; ++i)hullIndex[hull[i]] = i;
        // degenerate case: 1 or 2 (distinct) points
        if (hull.length <= 2 && hull.length > 0) {
            this.triangles = new Int32Array(3).fill(-1);
            this.halfedges = new Int32Array(3).fill(-1);
            this.triangles[0] = hull[0];
            inedges[hull[0]] = 1;
            if (hull.length === 2) {
                inedges[hull[1]] = 0;
                this.triangles[1] = hull[1];
                this.triangles[2] = hull[1];
            }
        }
    }
    voronoi(bounds) {
        return new (0, _voronoiJsDefault.default)(this, bounds);
    }
    *neighbors(i) {
        const { inedges, hull, _hullIndex, halfedges, triangles, collinear } = this;
        // degenerate case with several collinear points
        if (collinear) {
            const l = collinear.indexOf(i);
            if (l > 0) yield collinear[l - 1];
            if (l < collinear.length - 1) yield collinear[l + 1];
            return;
        }
        const e0 = inedges[i];
        if (e0 === -1) return; // coincident point
        let e = e0, p0 = -1;
        do {
            yield p0 = triangles[e];
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) return; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                const p = hull[(_hullIndex[i] + 1) % hull.length];
                if (p !== p0) yield p;
                return;
            }
        }while (e !== e0);
    }
    find(x, y, i = 0) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
        const i0 = i;
        let c;
        while((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0)i = c;
        return c;
    }
    _step(i, x, y) {
        const { inedges, hull, _hullIndex, halfedges, triangles, points } = this;
        if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
        let c = i;
        let dc = pow(x - points[i * 2], 2) + pow(y - points[i * 2 + 1], 2);
        const e0 = inedges[i];
        let e = e0;
        do {
            let t = triangles[e];
            const dt = pow(x - points[t * 2], 2) + pow(y - points[t * 2 + 1], 2);
            if (dt < dc) dc = dt, c = t;
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                e = hull[(_hullIndex[i] + 1) % hull.length];
                if (e !== t) {
                    if (pow(x - points[e * 2], 2) + pow(y - points[e * 2 + 1], 2) < dc) return e;
                }
                break;
            }
        }while (e !== e0);
        return c;
    }
    render(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { points, halfedges, triangles } = this;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = triangles[i] * 2;
            const tj = triangles[j] * 2;
            context.moveTo(points[ti], points[ti + 1]);
            context.lineTo(points[tj], points[tj + 1]);
        }
        this.renderHull(context);
        return buffer && buffer.value();
    }
    renderPoints(context, r) {
        if (r === undefined && (!context || typeof context.moveTo !== "function")) r = context, context = null;
        r = r == undefined ? 2 : +r;
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { points } = this;
        for(let i = 0, n = points.length; i < n; i += 2){
            const x = points[i], y = points[i + 1];
            context.moveTo(x + r, y);
            context.arc(x, y, r, 0, tau);
        }
        return buffer && buffer.value();
    }
    renderHull(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { hull, points } = this;
        const h = hull[0] * 2, n = hull.length;
        context.moveTo(points[h], points[h + 1]);
        for(let i = 1; i < n; ++i){
            const h = 2 * hull[i];
            context.lineTo(points[h], points[h + 1]);
        }
        context.closePath();
        return buffer && buffer.value();
    }
    hullPolygon() {
        const polygon = new (0, _polygonJsDefault.default);
        this.renderHull(polygon);
        return polygon.value();
    }
    renderTriangle(i, context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { points, triangles } = this;
        const t0 = triangles[i *= 3] * 2;
        const t1 = triangles[i + 1] * 2;
        const t2 = triangles[i + 2] * 2;
        context.moveTo(points[t0], points[t0 + 1]);
        context.lineTo(points[t1], points[t1 + 1]);
        context.lineTo(points[t2], points[t2 + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *trianglePolygons() {
        const { triangles } = this;
        for(let i = 0, n = triangles.length / 3; i < n; ++i)yield this.trianglePolygon(i);
    }
    trianglePolygon(i) {
        const polygon = new (0, _polygonJsDefault.default);
        this.renderTriangle(i, polygon);
        return polygon.value();
    }
}
exports.default = Delaunay;
function flatArray(points, fx, fy, that) {
    const n = points.length;
    const array = new Float64Array(n * 2);
    for(let i = 0; i < n; ++i){
        const p = points[i];
        array[i * 2] = fx.call(that, p, i, points);
        array[i * 2 + 1] = fy.call(that, p, i, points);
    }
    return array;
}
function* flatIterable(points, fx, fy, that) {
    let i = 0;
    for (const p of points){
        yield fx.call(that, p, i, points);
        yield fy.call(that, p, i, points);
        ++i;
    }
}

},{"delaunator":"cmGGo","./path.js":"2MH7X","./polygon.js":"iN814","./voronoi.js":"k7lzi","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cmGGo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _robustPredicates = require("robust-predicates");
const EPSILON = Math.pow(2, -52);
const EDGE_STACK = new Uint32Array(512);
class Delaunator {
    static from(points, getX = defaultGetX, getY = defaultGetY) {
        const n = points.length;
        const coords = new Float64Array(n * 2);
        for(let i = 0; i < n; i++){
            const p = points[i];
            coords[2 * i] = getX(p);
            coords[2 * i + 1] = getY(p);
        }
        return new Delaunator(coords);
    }
    constructor(coords){
        const n = coords.length >> 1;
        if (n > 0 && typeof coords[0] !== 'number') throw new Error('Expected coords to contain numbers.');
        this.coords = coords;
        // arrays that will store the triangulation graph
        const maxTriangles = Math.max(2 * n - 5, 0);
        this._triangles = new Uint32Array(maxTriangles * 3);
        this._halfedges = new Int32Array(maxTriangles * 3);
        // temporary arrays for tracking the edges of the advancing convex hull
        this._hashSize = Math.ceil(Math.sqrt(n));
        this._hullPrev = new Uint32Array(n); // edge to prev edge
        this._hullNext = new Uint32Array(n); // edge to next edge
        this._hullTri = new Uint32Array(n); // edge to adjacent triangle
        this._hullHash = new Int32Array(this._hashSize); // angular edge hash
        // temporary arrays for sorting points
        this._ids = new Uint32Array(n);
        this._dists = new Float64Array(n);
        this.update();
    }
    update() {
        const { coords, _hullPrev: hullPrev, _hullNext: hullNext, _hullTri: hullTri, _hullHash: hullHash } = this;
        const n = coords.length >> 1;
        // populate an array of point indices; calculate input data bbox
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for(let i = 0; i < n; i++){
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            this._ids[i] = i;
        }
        const cx = (minX + maxX) / 2;
        const cy = (minY + maxY) / 2;
        let i0, i1, i2;
        // pick a seed point close to the center
        for(let i = 0, minDist = Infinity; i < n; i++){
            const d = dist(cx, cy, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist) {
                i0 = i;
                minDist = d;
            }
        }
        const i0x = coords[2 * i0];
        const i0y = coords[2 * i0 + 1];
        // find the point closest to the seed
        for(let i = 0, minDist = Infinity; i < n; i++){
            if (i === i0) continue;
            const d = dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist && d > 0) {
                i1 = i;
                minDist = d;
            }
        }
        let i1x = coords[2 * i1];
        let i1y = coords[2 * i1 + 1];
        let minRadius = Infinity;
        // find the third point which forms the smallest circumcircle with the first two
        for(let i = 0; i < n; i++){
            if (i === i0 || i === i1) continue;
            const r = circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);
            if (r < minRadius) {
                i2 = i;
                minRadius = r;
            }
        }
        let i2x = coords[2 * i2];
        let i2y = coords[2 * i2 + 1];
        if (minRadius === Infinity) {
            // order collinear points by dx (or dy if all x are identical)
            // and return the list as a hull
            for(let i = 0; i < n; i++)this._dists[i] = coords[2 * i] - coords[0] || coords[2 * i + 1] - coords[1];
            quicksort(this._ids, this._dists, 0, n - 1);
            const hull = new Uint32Array(n);
            let j = 0;
            for(let i = 0, d0 = -Infinity; i < n; i++){
                const id = this._ids[i];
                const d = this._dists[id];
                if (d > d0) {
                    hull[j++] = id;
                    d0 = d;
                }
            }
            this.hull = hull.subarray(0, j);
            this.triangles = new Uint32Array(0);
            this.halfedges = new Uint32Array(0);
            return;
        }
        // swap the order of the seed points for counter-clockwise orientation
        if ((0, _robustPredicates.orient2d)(i0x, i0y, i1x, i1y, i2x, i2y) < 0) {
            const i = i1;
            const x = i1x;
            const y = i1y;
            i1 = i2;
            i1x = i2x;
            i1y = i2y;
            i2 = i;
            i2x = x;
            i2y = y;
        }
        const center = circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
        this._cx = center.x;
        this._cy = center.y;
        for(let i = 0; i < n; i++)this._dists[i] = dist(coords[2 * i], coords[2 * i + 1], center.x, center.y);
        // sort the points by distance from the seed triangle circumcenter
        quicksort(this._ids, this._dists, 0, n - 1);
        // set up the seed triangle as the starting hull
        this._hullStart = i0;
        let hullSize = 3;
        hullNext[i0] = hullPrev[i2] = i1;
        hullNext[i1] = hullPrev[i0] = i2;
        hullNext[i2] = hullPrev[i1] = i0;
        hullTri[i0] = 0;
        hullTri[i1] = 1;
        hullTri[i2] = 2;
        hullHash.fill(-1);
        hullHash[this._hashKey(i0x, i0y)] = i0;
        hullHash[this._hashKey(i1x, i1y)] = i1;
        hullHash[this._hashKey(i2x, i2y)] = i2;
        this.trianglesLen = 0;
        this._addTriangle(i0, i1, i2, -1, -1, -1);
        for(let k = 0, xp, yp; k < this._ids.length; k++){
            const i = this._ids[k];
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            // skip near-duplicate points
            if (k > 0 && Math.abs(x - xp) <= EPSILON && Math.abs(y - yp) <= EPSILON) continue;
            xp = x;
            yp = y;
            // skip seed triangle points
            if (i === i0 || i === i1 || i === i2) continue;
            // find a visible edge on the convex hull using edge hash
            let start = 0;
            for(let j = 0, key = this._hashKey(x, y); j < this._hashSize; j++){
                start = hullHash[(key + j) % this._hashSize];
                if (start !== -1 && start !== hullNext[start]) break;
            }
            start = hullPrev[start];
            let e = start, q;
            while(q = hullNext[e], (0, _robustPredicates.orient2d)(x, y, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1]) >= 0){
                e = q;
                if (e === start) {
                    e = -1;
                    break;
                }
            }
            if (e === -1) continue; // likely a near-duplicate point; skip it
            // add the first triangle from the point
            let t = this._addTriangle(e, i, hullNext[e], -1, -1, hullTri[e]);
            // recursively flip triangles from the point until they satisfy the Delaunay condition
            hullTri[i] = this._legalize(t + 2);
            hullTri[e] = t; // keep track of boundary triangles on the hull
            hullSize++;
            // walk forward through the hull, adding more triangles and flipping recursively
            let n = hullNext[e];
            while(q = hullNext[n], (0, _robustPredicates.orient2d)(x, y, coords[2 * n], coords[2 * n + 1], coords[2 * q], coords[2 * q + 1]) < 0){
                t = this._addTriangle(n, i, q, hullTri[i], -1, hullTri[n]);
                hullTri[i] = this._legalize(t + 2);
                hullNext[n] = n; // mark as removed
                hullSize--;
                n = q;
            }
            // walk backward from the other side, adding more triangles and flipping
            if (e === start) while(q = hullPrev[e], (0, _robustPredicates.orient2d)(x, y, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1]) < 0){
                t = this._addTriangle(q, i, e, -1, hullTri[e], hullTri[q]);
                this._legalize(t + 2);
                hullTri[q] = t;
                hullNext[e] = e; // mark as removed
                hullSize--;
                e = q;
            }
            // update the hull indices
            this._hullStart = hullPrev[i] = e;
            hullNext[e] = hullPrev[n] = i;
            hullNext[i] = n;
            // save the two new edges in the hash table
            hullHash[this._hashKey(x, y)] = i;
            hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
        }
        this.hull = new Uint32Array(hullSize);
        for(let i = 0, e = this._hullStart; i < hullSize; i++){
            this.hull[i] = e;
            e = hullNext[e];
        }
        // trim typed triangle mesh arrays
        this.triangles = this._triangles.subarray(0, this.trianglesLen);
        this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
    }
    _hashKey(x, y) {
        return Math.floor(pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
    }
    _legalize(a) {
        const { _triangles: triangles, _halfedges: halfedges, coords } = this;
        let i = 0;
        let ar = 0;
        // recursion eliminated with a fixed-size stack
        while(true){
            const b = halfedges[a];
            /* if the pair of triangles doesn't satisfy the Delaunay condition
             * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
             * then do the same check/flip recursively for the new pair of triangles
             *
             *           pl                    pl
             *          /||\                  /  \
             *       al/ || \bl            al/    \a
             *        /  ||  \              /      \
             *       /  a||b  \    flip    /___ar___\
             *     p0\   ||   /p1   =>   p0\---bl---/p1
             *        \  ||  /              \      /
             *       ar\ || /br             b\    /br
             *          \||/                  \  /
             *           pr                    pr
             */ const a0 = a - a % 3;
            ar = a0 + (a + 2) % 3;
            if (b === -1) {
                if (i === 0) break;
                a = EDGE_STACK[--i];
                continue;
            }
            const b0 = b - b % 3;
            const al = a0 + (a + 1) % 3;
            const bl = b0 + (b + 2) % 3;
            const p0 = triangles[ar];
            const pr = triangles[a];
            const pl = triangles[al];
            const p1 = triangles[bl];
            const illegal = inCircle(coords[2 * p0], coords[2 * p0 + 1], coords[2 * pr], coords[2 * pr + 1], coords[2 * pl], coords[2 * pl + 1], coords[2 * p1], coords[2 * p1 + 1]);
            if (illegal) {
                triangles[a] = p1;
                triangles[b] = p0;
                const hbl = halfedges[bl];
                // edge swapped on the other side of the hull (rare); fix the halfedge reference
                if (hbl === -1) {
                    let e = this._hullStart;
                    do {
                        if (this._hullTri[e] === bl) {
                            this._hullTri[e] = a;
                            break;
                        }
                        e = this._hullPrev[e];
                    }while (e !== this._hullStart);
                }
                this._link(a, hbl);
                this._link(b, halfedges[ar]);
                this._link(ar, bl);
                const br = b0 + (b + 1) % 3;
                // don't worry about hitting the cap: it can only happen on extremely degenerate input
                if (i < EDGE_STACK.length) EDGE_STACK[i++] = br;
            } else {
                if (i === 0) break;
                a = EDGE_STACK[--i];
            }
        }
        return ar;
    }
    _link(a, b) {
        this._halfedges[a] = b;
        if (b !== -1) this._halfedges[b] = a;
    }
    // add a new triangle given vertex indices and adjacent half-edge ids
    _addTriangle(i0, i1, i2, a, b, c) {
        const t = this.trianglesLen;
        this._triangles[t] = i0;
        this._triangles[t + 1] = i1;
        this._triangles[t + 2] = i2;
        this._link(t, a);
        this._link(t + 1, b);
        this._link(t + 2, c);
        this.trianglesLen += 3;
        return t;
    }
}
exports.default = Delaunator;
// monotonically increases with real angle, but doesn't need expensive trigonometry
function pseudoAngle(dx, dy) {
    const p = dx / (Math.abs(dx) + Math.abs(dy));
    return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
}
function dist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}
function inCircle(ax, ay, bx, by, cx, cy, px, py) {
    const dx = ax - px;
    const dy = ay - py;
    const ex = bx - px;
    const ey = by - py;
    const fx = cx - px;
    const fy = cy - py;
    const ap = dx * dx + dy * dy;
    const bp = ex * ex + ey * ey;
    const cp = fx * fx + fy * fy;
    return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
}
function circumradius(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = (ey * bl - dy * cl) * d;
    const y = (dx * cl - ex * bl) * d;
    return x * x + y * y;
}
function circumcenter(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = ax + (ey * bl - dy * cl) * d;
    const y = ay + (dx * cl - ex * bl) * d;
    return {
        x,
        y
    };
}
function quicksort(ids, dists, left, right) {
    if (right - left <= 20) for(let i = left + 1; i <= right; i++){
        const temp = ids[i];
        const tempDist = dists[temp];
        let j = i - 1;
        while(j >= left && dists[ids[j]] > tempDist)ids[j + 1] = ids[j--];
        ids[j + 1] = temp;
    }
    else {
        const median = left + right >> 1;
        let i = left + 1;
        let j = right;
        swap(ids, median, i);
        if (dists[ids[left]] > dists[ids[right]]) swap(ids, left, right);
        if (dists[ids[i]] > dists[ids[right]]) swap(ids, i, right);
        if (dists[ids[left]] > dists[ids[i]]) swap(ids, left, i);
        const temp = ids[i];
        const tempDist = dists[temp];
        while(true){
            do i++;
            while (dists[ids[i]] < tempDist);
            do j--;
            while (dists[ids[j]] > tempDist);
            if (j < i) break;
            swap(ids, i, j);
        }
        ids[left + 1] = ids[j];
        ids[j] = temp;
        if (right - i + 1 >= j - left) {
            quicksort(ids, dists, i, right);
            quicksort(ids, dists, left, j - 1);
        } else {
            quicksort(ids, dists, left, j - 1);
            quicksort(ids, dists, i, right);
        }
    }
}
function swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
function defaultGetX(p) {
    return p[0];
}
function defaultGetY(p) {
    return p[1];
}

},{"robust-predicates":"8JxSm","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8JxSm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orient2d", ()=>(0, _orient2DJs.orient2d));
parcelHelpers.export(exports, "orient2dfast", ()=>(0, _orient2DJs.orient2dfast));
parcelHelpers.export(exports, "orient3d", ()=>(0, _orient3DJs.orient3d));
parcelHelpers.export(exports, "orient3dfast", ()=>(0, _orient3DJs.orient3dfast));
parcelHelpers.export(exports, "incircle", ()=>(0, _incircleJs.incircle));
parcelHelpers.export(exports, "incirclefast", ()=>(0, _incircleJs.incirclefast));
parcelHelpers.export(exports, "insphere", ()=>(0, _insphereJs.insphere));
parcelHelpers.export(exports, "inspherefast", ()=>(0, _insphereJs.inspherefast));
var _orient2DJs = require("./esm/orient2d.js");
var _orient3DJs = require("./esm/orient3d.js");
var _incircleJs = require("./esm/incircle.js");
var _insphereJs = require("./esm/insphere.js");

},{"./esm/orient2d.js":"bCUai","./esm/orient3d.js":"fyHMy","./esm/incircle.js":"4meRT","./esm/insphere.js":"7BwL0","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bCUai":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orient2d", ()=>orient2d);
parcelHelpers.export(exports, "orient2dfast", ()=>orient2dfast);
var _utilJs = require("./util.js");
const ccwerrboundA = (3 + 16 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const ccwerrboundB = (2 + 12 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const ccwerrboundC = (9 + 64 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon) * (0, _utilJs.epsilon);
const B = (0, _utilJs.vec)(4);
const C1 = (0, _utilJs.vec)(8);
const C2 = (0, _utilJs.vec)(12);
const D = (0, _utilJs.vec)(16);
const u = (0, _utilJs.vec)(4);
function orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
    let acxtail, acytail, bcxtail, bcytail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const acx = ax - cx;
    const bcx = bx - cx;
    const acy = ay - cy;
    const bcy = by - cy;
    s1 = acx * bcy;
    c = (0, _utilJs.splitter) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, _utilJs.splitter) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcx;
    c = (0, _utilJs.splitter) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, _utilJs.splitter) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    B[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    B[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    B[2] = _j - (u3 - bvirt) + (_i - bvirt);
    B[3] = u3;
    let det = (0, _utilJs.estimate)(4, B);
    let errbound = ccwerrboundB * detsum;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - acx;
    acxtail = ax - (acx + bvirt) + (bvirt - cx);
    bvirt = bx - bcx;
    bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
    bvirt = ay - acy;
    acytail = ay - (acy + bvirt) + (bvirt - cy);
    bvirt = by - bcy;
    bcytail = by - (bcy + bvirt) + (bvirt - cy);
    if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) return det;
    errbound = ccwerrboundC * detsum + (0, _utilJs.resulterrbound) * Math.abs(det);
    det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
    if (det >= errbound || -det >= errbound) return det;
    s1 = acxtail * bcy;
    c = (0, _utilJs.splitter) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, _utilJs.splitter) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcx;
    c = (0, _utilJs.splitter) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, _utilJs.splitter) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    u[3] = u3;
    const C1len = (0, _utilJs.sum)(4, B, 4, u, C1);
    s1 = acx * bcytail;
    c = (0, _utilJs.splitter) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, _utilJs.splitter) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcxtail;
    c = (0, _utilJs.splitter) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, _utilJs.splitter) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    u[3] = u3;
    const C2len = (0, _utilJs.sum)(C1len, C1, 4, u, C2);
    s1 = acxtail * bcytail;
    c = (0, _utilJs.splitter) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, _utilJs.splitter) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcxtail;
    c = (0, _utilJs.splitter) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, _utilJs.splitter) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    u[3] = u3;
    const Dlen = (0, _utilJs.sum)(C2len, C2, 4, u, D);
    return D[Dlen - 1];
}
function orient2d(ax, ay, bx, by, cx, cy) {
    const detleft = (ay - cy) * (bx - cx);
    const detright = (ax - cx) * (by - cy);
    const det = detleft - detright;
    const detsum = Math.abs(detleft + detright);
    if (Math.abs(det) >= ccwerrboundA * detsum) return det;
    return -orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
}
function orient2dfast(ax, ay, bx, by, cx, cy) {
    return (ay - cy) * (bx - cx) - (ax - cx) * (by - cy);
}

},{"./util.js":"3oCKI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3oCKI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
parcelHelpers.export(exports, "splitter", ()=>splitter);
parcelHelpers.export(exports, "resulterrbound", ()=>resulterrbound);
// fast_expansion_sum_zeroelim routine from oritinal code
parcelHelpers.export(exports, "sum", ()=>sum);
parcelHelpers.export(exports, "sum_three", ()=>sum_three);
// scale_expansion_zeroelim routine from oritinal code
parcelHelpers.export(exports, "scale", ()=>scale);
parcelHelpers.export(exports, "negate", ()=>negate);
parcelHelpers.export(exports, "estimate", ()=>estimate);
parcelHelpers.export(exports, "vec", ()=>vec);
const epsilon = 1.1102230246251565e-16;
const splitter = 134217729;
const resulterrbound = (3 + 8 * epsilon) * epsilon;
function sum(elen, e, flen, f, h) {
    let Q, Qnew, hh, bvirt;
    let enow = e[0];
    let fnow = f[0];
    let eindex = 0;
    let findex = 0;
    if (fnow > enow === fnow > -enow) {
        Q = enow;
        enow = e[++eindex];
    } else {
        Q = fnow;
        fnow = f[++findex];
    }
    let hindex = 0;
    if (eindex < elen && findex < flen) {
        if (fnow > enow === fnow > -enow) {
            Qnew = enow + Q;
            hh = Q - (Qnew - enow);
            enow = e[++eindex];
        } else {
            Qnew = fnow + Q;
            hh = Q - (Qnew - fnow);
            fnow = f[++findex];
        }
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
        while(eindex < elen && findex < flen){
            if (fnow > enow === fnow > -enow) {
                Qnew = Q + enow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (enow - bvirt);
                enow = e[++eindex];
            } else {
                Qnew = Q + fnow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                fnow = f[++findex];
            }
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
    }
    while(eindex < elen){
        Qnew = Q + enow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (enow - bvirt);
        enow = e[++eindex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    while(findex < flen){
        Qnew = Q + fnow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (fnow - bvirt);
        fnow = f[++findex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function sum_three(alen, a, blen, b, clen, c, tmp, out) {
    return sum(sum(alen, a, blen, b, tmp), tmp, clen, c, out);
}
function scale(elen, e, b, h) {
    let Q, sum, hh, product1, product0;
    let bvirt, c, ahi, alo, bhi, blo;
    c = splitter * b;
    bhi = c - (c - b);
    blo = b - bhi;
    let enow = e[0];
    Q = enow * b;
    c = splitter * enow;
    ahi = c - (c - enow);
    alo = enow - ahi;
    hh = alo * blo - (Q - ahi * bhi - alo * bhi - ahi * blo);
    let hindex = 0;
    if (hh !== 0) h[hindex++] = hh;
    for(let i = 1; i < elen; i++){
        enow = e[i];
        product1 = enow * b;
        c = splitter * enow;
        ahi = c - (c - enow);
        alo = enow - ahi;
        product0 = alo * blo - (product1 - ahi * bhi - alo * bhi - ahi * blo);
        sum = Q + product0;
        bvirt = sum - Q;
        hh = Q - (sum - bvirt) + (product0 - bvirt);
        if (hh !== 0) h[hindex++] = hh;
        Q = product1 + sum;
        hh = sum - (Q - product1);
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function negate(elen, e) {
    for(let i = 0; i < elen; i++)e[i] = -e[i];
    return elen;
}
function estimate(elen, e) {
    let Q = e[0];
    for(let i = 1; i < elen; i++)Q += e[i];
    return Q;
}
function vec(n) {
    return new Float64Array(n);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"fyHMy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orient3d", ()=>orient3d);
parcelHelpers.export(exports, "orient3dfast", ()=>orient3dfast);
var _utilJs = require("./util.js");
const o3derrboundA = (7 + 56 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const o3derrboundB = (3 + 28 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const o3derrboundC = (26 + 288 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon) * (0, _utilJs.epsilon);
const bc = (0, _utilJs.vec)(4);
const ca = (0, _utilJs.vec)(4);
const ab = (0, _utilJs.vec)(4);
const at_b = (0, _utilJs.vec)(4);
const at_c = (0, _utilJs.vec)(4);
const bt_c = (0, _utilJs.vec)(4);
const bt_a = (0, _utilJs.vec)(4);
const ct_a = (0, _utilJs.vec)(4);
const ct_b = (0, _utilJs.vec)(4);
const bct = (0, _utilJs.vec)(8);
const cat = (0, _utilJs.vec)(8);
const abt = (0, _utilJs.vec)(8);
const u = (0, _utilJs.vec)(4);
const _8 = (0, _utilJs.vec)(8);
const _8b = (0, _utilJs.vec)(8);
const _16 = (0, _utilJs.vec)(8);
const _12 = (0, _utilJs.vec)(12);
let fin = (0, _utilJs.vec)(192);
let fin2 = (0, _utilJs.vec)(192);
function finadd(finlen, alen, a) {
    finlen = (0, _utilJs.sum)(finlen, fin, alen, a, fin2);
    const tmp = fin;
    fin = fin2;
    fin2 = tmp;
    return finlen;
}
function tailinit(xtail, ytail, ax, ay, bx, by, a, b) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3, negate;
    if (xtail === 0) {
        if (ytail === 0) {
            a[0] = 0;
            b[0] = 0;
            return 1;
        } else {
            negate = -ytail;
            s1 = negate * ax;
            c = (0, _utilJs.splitter) * negate;
            ahi = c - (c - negate);
            alo = negate - ahi;
            c = (0, _utilJs.splitter) * ax;
            bhi = c - (c - ax);
            blo = ax - bhi;
            a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            a[1] = s1;
            s1 = ytail * bx;
            c = (0, _utilJs.splitter) * ytail;
            ahi = c - (c - ytail);
            alo = ytail - ahi;
            c = (0, _utilJs.splitter) * bx;
            bhi = c - (c - bx);
            blo = bx - bhi;
            b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            b[1] = s1;
            return 2;
        }
    } else if (ytail === 0) {
        s1 = xtail * ay;
        c = (0, _utilJs.splitter) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, _utilJs.splitter) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        a[1] = s1;
        negate = -xtail;
        s1 = negate * by;
        c = (0, _utilJs.splitter) * negate;
        ahi = c - (c - negate);
        alo = negate - ahi;
        c = (0, _utilJs.splitter) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        b[1] = s1;
        return 2;
    } else {
        s1 = xtail * ay;
        c = (0, _utilJs.splitter) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, _utilJs.splitter) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = ytail * ax;
        c = (0, _utilJs.splitter) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, _utilJs.splitter) * ax;
        bhi = c - (c - ax);
        blo = ax - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        a[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        a[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        a[2] = _j - (u3 - bvirt) + (_i - bvirt);
        a[3] = u3;
        s1 = ytail * bx;
        c = (0, _utilJs.splitter) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, _utilJs.splitter) * bx;
        bhi = c - (c - bx);
        blo = bx - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = xtail * by;
        c = (0, _utilJs.splitter) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, _utilJs.splitter) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        b[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        b[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        b[2] = _j - (u3 - bvirt) + (_i - bvirt);
        b[3] = u3;
        return 4;
    }
}
function tailadd(finlen, a, b, k, z) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, u3;
    s1 = a * b;
    c = (0, _utilJs.splitter) * a;
    ahi = c - (c - a);
    alo = a - ahi;
    c = (0, _utilJs.splitter) * b;
    bhi = c - (c - b);
    blo = b - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    c = (0, _utilJs.splitter) * k;
    bhi = c - (c - k);
    blo = k - bhi;
    _i = s0 * k;
    c = (0, _utilJs.splitter) * s0;
    ahi = c - (c - s0);
    alo = s0 - ahi;
    u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
    _j = s1 * k;
    c = (0, _utilJs.splitter) * s1;
    ahi = c - (c - s1);
    alo = s1 - ahi;
    _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
    _k = _i + _0;
    bvirt = _k - _i;
    u[1] = _i - (_k - bvirt) + (_0 - bvirt);
    u3 = _j + _k;
    u[2] = _k - (u3 - _j);
    u[3] = u3;
    finlen = finadd(finlen, 4, u);
    if (z !== 0) {
        c = (0, _utilJs.splitter) * z;
        bhi = c - (c - z);
        blo = z - bhi;
        _i = s0 * z;
        c = (0, _utilJs.splitter) * s0;
        ahi = c - (c - s0);
        alo = s0 - ahi;
        u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
        _j = s1 * z;
        c = (0, _utilJs.splitter) * s1;
        ahi = c - (c - s1);
        alo = s1 - ahi;
        _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
        _k = _i + _0;
        bvirt = _k - _i;
        u[1] = _i - (_k - bvirt) + (_0 - bvirt);
        u3 = _j + _k;
        u[2] = _k - (u3 - _j);
        u[3] = u3;
        finlen = finadd(finlen, 4, u);
    }
    return finlen;
}
function orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail;
    let adytail, bdytail, cdytail;
    let adztail, bdztail, cdztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    s1 = bdx * cdy;
    c = (0, _utilJs.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, _utilJs.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, _utilJs.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, _utilJs.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    bc[3] = u3;
    s1 = cdx * ady;
    c = (0, _utilJs.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, _utilJs.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, _utilJs.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, _utilJs.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ca[3] = u3;
    s1 = adx * bdy;
    c = (0, _utilJs.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, _utilJs.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, _utilJs.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, _utilJs.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ab[3] = u3;
    finlen = (0, _utilJs.sum)((0, _utilJs.sum)((0, _utilJs.scale)(4, bc, adz, _8), _8, (0, _utilJs.scale)(4, ca, bdz, _8b), _8b, _16), _16, (0, _utilJs.scale)(4, ab, cdz, _8), _8, fin);
    let det = (0, _utilJs.estimate)(finlen, fin);
    let errbound = o3derrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    bvirt = az - adz;
    adztail = az - (adz + bvirt) + (bvirt - dz);
    bvirt = bz - bdz;
    bdztail = bz - (bdz + bvirt) + (bvirt - dz);
    bvirt = cz - cdz;
    cdztail = cz - (cdz + bvirt) + (bvirt - dz);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0 && adztail === 0 && bdztail === 0 && cdztail === 0) return det;
    errbound = o3derrboundC * permanent + (0, _utilJs.resulterrbound) * Math.abs(det);
    det += adz * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + adztail * (bdx * cdy - bdy * cdx) + bdz * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + bdztail * (cdx * ady - cdy * adx) + cdz * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + cdztail * (adx * bdy - ady * bdx);
    if (det >= errbound || -det >= errbound) return det;
    const at_len = tailinit(adxtail, adytail, bdx, bdy, cdx, cdy, at_b, at_c);
    const bt_len = tailinit(bdxtail, bdytail, cdx, cdy, adx, ady, bt_c, bt_a);
    const ct_len = tailinit(cdxtail, cdytail, adx, ady, bdx, bdy, ct_a, ct_b);
    const bctlen = (0, _utilJs.sum)(bt_len, bt_c, ct_len, ct_b, bct);
    finlen = finadd(finlen, (0, _utilJs.scale)(bctlen, bct, adz, _16), _16);
    const catlen = (0, _utilJs.sum)(ct_len, ct_a, at_len, at_c, cat);
    finlen = finadd(finlen, (0, _utilJs.scale)(catlen, cat, bdz, _16), _16);
    const abtlen = (0, _utilJs.sum)(at_len, at_b, bt_len, bt_a, abt);
    finlen = finadd(finlen, (0, _utilJs.scale)(abtlen, abt, cdz, _16), _16);
    if (adztail !== 0) {
        finlen = finadd(finlen, (0, _utilJs.scale)(4, bc, adztail, _12), _12);
        finlen = finadd(finlen, (0, _utilJs.scale)(bctlen, bct, adztail, _16), _16);
    }
    if (bdztail !== 0) {
        finlen = finadd(finlen, (0, _utilJs.scale)(4, ca, bdztail, _12), _12);
        finlen = finadd(finlen, (0, _utilJs.scale)(catlen, cat, bdztail, _16), _16);
    }
    if (cdztail !== 0) {
        finlen = finadd(finlen, (0, _utilJs.scale)(4, ab, cdztail, _12), _12);
        finlen = finadd(finlen, (0, _utilJs.scale)(abtlen, abt, cdztail, _16), _16);
    }
    if (adxtail !== 0) {
        if (bdytail !== 0) finlen = tailadd(finlen, adxtail, bdytail, cdz, cdztail);
        if (cdytail !== 0) finlen = tailadd(finlen, -adxtail, cdytail, bdz, bdztail);
    }
    if (bdxtail !== 0) {
        if (cdytail !== 0) finlen = tailadd(finlen, bdxtail, cdytail, adz, adztail);
        if (adytail !== 0) finlen = tailadd(finlen, -bdxtail, adytail, cdz, cdztail);
    }
    if (cdxtail !== 0) {
        if (adytail !== 0) finlen = tailadd(finlen, cdxtail, adytail, bdz, bdztail);
        if (bdytail !== 0) finlen = tailadd(finlen, -cdxtail, bdytail, adz, adztail);
    }
    return fin[finlen - 1];
}
function orient3d(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const det = adz * (bdxcdy - cdxbdy) + bdz * (cdxady - adxcdy) + cdz * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz) + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz) + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz);
    const errbound = o3derrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent);
}
function orient3dfast(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    return adx * (bdy * cdz - bdz * cdy) + bdx * (cdy * adz - cdz * ady) + cdx * (ady * bdz - adz * bdy);
}

},{"./util.js":"3oCKI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4meRT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "incircle", ()=>incircle);
parcelHelpers.export(exports, "incirclefast", ()=>incirclefast);
var _utilJs = require("./util.js");
const iccerrboundA = (10 + 96 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const iccerrboundB = (4 + 48 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const iccerrboundC = (44 + 576 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon) * (0, _utilJs.epsilon);
const bc = (0, _utilJs.vec)(4);
const ca = (0, _utilJs.vec)(4);
const ab = (0, _utilJs.vec)(4);
const aa = (0, _utilJs.vec)(4);
const bb = (0, _utilJs.vec)(4);
const cc = (0, _utilJs.vec)(4);
const u = (0, _utilJs.vec)(4);
const v = (0, _utilJs.vec)(4);
const axtbc = (0, _utilJs.vec)(8);
const aytbc = (0, _utilJs.vec)(8);
const bxtca = (0, _utilJs.vec)(8);
const bytca = (0, _utilJs.vec)(8);
const cxtab = (0, _utilJs.vec)(8);
const cytab = (0, _utilJs.vec)(8);
const abt = (0, _utilJs.vec)(8);
const bct = (0, _utilJs.vec)(8);
const cat = (0, _utilJs.vec)(8);
const abtt = (0, _utilJs.vec)(4);
const bctt = (0, _utilJs.vec)(4);
const catt = (0, _utilJs.vec)(4);
const _8 = (0, _utilJs.vec)(8);
const _16 = (0, _utilJs.vec)(16);
const _16b = (0, _utilJs.vec)(16);
const _16c = (0, _utilJs.vec)(16);
const _32 = (0, _utilJs.vec)(32);
const _32b = (0, _utilJs.vec)(32);
const _48 = (0, _utilJs.vec)(48);
const _64 = (0, _utilJs.vec)(64);
let fin = (0, _utilJs.vec)(1152);
let fin2 = (0, _utilJs.vec)(1152);
function finadd(finlen, a, alen) {
    finlen = (0, _utilJs.sum)(finlen, fin, a, alen, fin2);
    const tmp = fin;
    fin = fin2;
    fin2 = tmp;
    return finlen;
}
function incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail, adytail, bdytail, cdytail;
    let axtbclen, aytbclen, bxtcalen, bytcalen, cxtablen, cytablen;
    let abtlen, bctlen, catlen;
    let abttlen, bcttlen, cattlen;
    let n1, n0;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    s1 = bdx * cdy;
    c = (0, _utilJs.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, _utilJs.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, _utilJs.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, _utilJs.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    bc[3] = u3;
    s1 = cdx * ady;
    c = (0, _utilJs.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, _utilJs.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, _utilJs.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, _utilJs.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ca[3] = u3;
    s1 = adx * bdy;
    c = (0, _utilJs.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, _utilJs.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, _utilJs.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, _utilJs.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ab[3] = u3;
    finlen = (0, _utilJs.sum)((0, _utilJs.sum)((0, _utilJs.sum)((0, _utilJs.scale)((0, _utilJs.scale)(4, bc, adx, _8), _8, adx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, bc, ady, _8), _8, ady, _16b), _16b, _32), _32, (0, _utilJs.sum)((0, _utilJs.scale)((0, _utilJs.scale)(4, ca, bdx, _8), _8, bdx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, ca, bdy, _8), _8, bdy, _16b), _16b, _32b), _32b, _64), _64, (0, _utilJs.sum)((0, _utilJs.scale)((0, _utilJs.scale)(4, ab, cdx, _8), _8, cdx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, ab, cdy, _8), _8, cdy, _16b), _16b, _32), _32, fin);
    let det = (0, _utilJs.estimate)(finlen, fin);
    let errbound = iccerrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0) return det;
    errbound = iccerrboundC * permanent + (0, _utilJs.resulterrbound) * Math.abs(det);
    det += (adx * adx + ady * ady) * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + 2 * (adx * adxtail + ady * adytail) * (bdx * cdy - bdy * cdx) + ((bdx * bdx + bdy * bdy) * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + 2 * (bdx * bdxtail + bdy * bdytail) * (cdx * ady - cdy * adx)) + ((cdx * cdx + cdy * cdy) * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + 2 * (cdx * cdxtail + cdy * cdytail) * (adx * bdy - ady * bdx));
    if (det >= errbound || -det >= errbound) return det;
    if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
        s1 = adx * adx;
        c = (0, _utilJs.splitter) * adx;
        ahi = c - (c - adx);
        alo = adx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = ady * ady;
        c = (0, _utilJs.splitter) * ady;
        ahi = c - (c - ady);
        alo = ady - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        aa[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        aa[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        aa[2] = _j - (u3 - bvirt) + (_i - bvirt);
        aa[3] = u3;
    }
    if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
        s1 = bdx * bdx;
        c = (0, _utilJs.splitter) * bdx;
        ahi = c - (c - bdx);
        alo = bdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = bdy * bdy;
        c = (0, _utilJs.splitter) * bdy;
        ahi = c - (c - bdy);
        alo = bdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        bb[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        bb[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        bb[2] = _j - (u3 - bvirt) + (_i - bvirt);
        bb[3] = u3;
    }
    if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
        s1 = cdx * cdx;
        c = (0, _utilJs.splitter) * cdx;
        ahi = c - (c - cdx);
        alo = cdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = cdy * cdy;
        c = (0, _utilJs.splitter) * cdy;
        ahi = c - (c - cdy);
        alo = cdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        cc[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        cc[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        cc[2] = _j - (u3 - bvirt) + (_i - bvirt);
        cc[3] = u3;
    }
    if (adxtail !== 0) {
        axtbclen = (0, _utilJs.scale)(4, bc, adxtail, axtbc);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(axtbclen, axtbc, 2 * adx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, adxtail, _8), _8, bdy, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, adxtail, _8), _8, -cdy, _16c), _16c, _32, _48), _48);
    }
    if (adytail !== 0) {
        aytbclen = (0, _utilJs.scale)(4, bc, adytail, aytbc);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(aytbclen, aytbc, 2 * ady, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, adytail, _8), _8, cdx, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, adytail, _8), _8, -bdx, _16c), _16c, _32, _48), _48);
    }
    if (bdxtail !== 0) {
        bxtcalen = (0, _utilJs.scale)(4, ca, bdxtail, bxtca);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(bxtcalen, bxtca, 2 * bdx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, bdxtail, _8), _8, cdy, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, bdxtail, _8), _8, -ady, _16c), _16c, _32, _48), _48);
    }
    if (bdytail !== 0) {
        bytcalen = (0, _utilJs.scale)(4, ca, bdytail, bytca);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(bytcalen, bytca, 2 * bdy, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, bdytail, _8), _8, adx, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, bdytail, _8), _8, -cdx, _16c), _16c, _32, _48), _48);
    }
    if (cdxtail !== 0) {
        cxtablen = (0, _utilJs.scale)(4, ab, cdxtail, cxtab);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(cxtablen, cxtab, 2 * cdx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, cdxtail, _8), _8, ady, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, cdxtail, _8), _8, -bdy, _16c), _16c, _32, _48), _48);
    }
    if (cdytail !== 0) {
        cytablen = (0, _utilJs.scale)(4, ab, cdytail, cytab);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(cytablen, cytab, 2 * cdy, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, cdytail, _8), _8, bdx, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, cdytail, _8), _8, -adx, _16c), _16c, _32, _48), _48);
    }
    if (adxtail !== 0 || adytail !== 0) {
        if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
            s1 = bdxtail * cdy;
            c = (0, _utilJs.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, _utilJs.splitter) * cdy;
            bhi = c - (c - cdy);
            blo = cdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * cdytail;
            c = (0, _utilJs.splitter) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, _utilJs.splitter) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            u[3] = u3;
            s1 = cdxtail * -bdy;
            c = (0, _utilJs.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, _utilJs.splitter) * -bdy;
            bhi = c - (c - -bdy);
            blo = -bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * -bdytail;
            c = (0, _utilJs.splitter) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, _utilJs.splitter) * -bdytail;
            bhi = c - (c - -bdytail);
            blo = -bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            v[3] = u3;
            bctlen = (0, _utilJs.sum)(4, u, 4, v, bct);
            s1 = bdxtail * cdytail;
            c = (0, _utilJs.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, _utilJs.splitter) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdxtail * bdytail;
            c = (0, _utilJs.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, _utilJs.splitter) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            bctt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            bctt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            bctt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            bctt[3] = u3;
            bcttlen = 4;
        } else {
            bct[0] = 0;
            bctlen = 1;
            bctt[0] = 0;
            bcttlen = 1;
        }
        if (adxtail !== 0) {
            const len = (0, _utilJs.scale)(bctlen, bct, adxtail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(axtbclen, axtbc, adxtail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * adx, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(bcttlen, bctt, adxtail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * adx, _16), _16, (0, _utilJs.scale)(len2, _8, adxtail, _16b), _16b, (0, _utilJs.scale)(len, _16c, adxtail, _32), _32, _32b, _64), _64);
            if (bdytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, adxtail, _8), _8, bdytail, _16), _16);
            if (cdytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, -adxtail, _8), _8, cdytail, _16), _16);
        }
        if (adytail !== 0) {
            const len = (0, _utilJs.scale)(bctlen, bct, adytail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(aytbclen, aytbc, adytail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * ady, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(bcttlen, bctt, adytail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * ady, _16), _16, (0, _utilJs.scale)(len2, _8, adytail, _16b), _16b, (0, _utilJs.scale)(len, _16c, adytail, _32), _32, _32b, _64), _64);
        }
    }
    if (bdxtail !== 0 || bdytail !== 0) {
        if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
            s1 = cdxtail * ady;
            c = (0, _utilJs.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, _utilJs.splitter) * ady;
            bhi = c - (c - ady);
            blo = ady - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * adytail;
            c = (0, _utilJs.splitter) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, _utilJs.splitter) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            u[3] = u3;
            n1 = -cdy;
            n0 = -cdytail;
            s1 = adxtail * n1;
            c = (0, _utilJs.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, _utilJs.splitter) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * n0;
            c = (0, _utilJs.splitter) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, _utilJs.splitter) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            v[3] = u3;
            catlen = (0, _utilJs.sum)(4, u, 4, v, cat);
            s1 = cdxtail * adytail;
            c = (0, _utilJs.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, _utilJs.splitter) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adxtail * cdytail;
            c = (0, _utilJs.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, _utilJs.splitter) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            catt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            catt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            catt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            catt[3] = u3;
            cattlen = 4;
        } else {
            cat[0] = 0;
            catlen = 1;
            catt[0] = 0;
            cattlen = 1;
        }
        if (bdxtail !== 0) {
            const len = (0, _utilJs.scale)(catlen, cat, bdxtail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(bxtcalen, bxtca, bdxtail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * bdx, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(cattlen, catt, bdxtail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * bdx, _16), _16, (0, _utilJs.scale)(len2, _8, bdxtail, _16b), _16b, (0, _utilJs.scale)(len, _16c, bdxtail, _32), _32, _32b, _64), _64);
            if (cdytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, bdxtail, _8), _8, cdytail, _16), _16);
            if (adytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, -bdxtail, _8), _8, adytail, _16), _16);
        }
        if (bdytail !== 0) {
            const len = (0, _utilJs.scale)(catlen, cat, bdytail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(bytcalen, bytca, bdytail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * bdy, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(cattlen, catt, bdytail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * bdy, _16), _16, (0, _utilJs.scale)(len2, _8, bdytail, _16b), _16b, (0, _utilJs.scale)(len, _16c, bdytail, _32), _32, _32b, _64), _64);
        }
    }
    if (cdxtail !== 0 || cdytail !== 0) {
        if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
            s1 = adxtail * bdy;
            c = (0, _utilJs.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, _utilJs.splitter) * bdy;
            bhi = c - (c - bdy);
            blo = bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * bdytail;
            c = (0, _utilJs.splitter) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, _utilJs.splitter) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            u[3] = u3;
            n1 = -ady;
            n0 = -adytail;
            s1 = bdxtail * n1;
            c = (0, _utilJs.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, _utilJs.splitter) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * n0;
            c = (0, _utilJs.splitter) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, _utilJs.splitter) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            v[3] = u3;
            abtlen = (0, _utilJs.sum)(4, u, 4, v, abt);
            s1 = adxtail * bdytail;
            c = (0, _utilJs.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, _utilJs.splitter) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdxtail * adytail;
            c = (0, _utilJs.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, _utilJs.splitter) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            abtt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            abtt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            abtt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            abtt[3] = u3;
            abttlen = 4;
        } else {
            abt[0] = 0;
            abtlen = 1;
            abtt[0] = 0;
            abttlen = 1;
        }
        if (cdxtail !== 0) {
            const len = (0, _utilJs.scale)(abtlen, abt, cdxtail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(cxtablen, cxtab, cdxtail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * cdx, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(abttlen, abtt, cdxtail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * cdx, _16), _16, (0, _utilJs.scale)(len2, _8, cdxtail, _16b), _16b, (0, _utilJs.scale)(len, _16c, cdxtail, _32), _32, _32b, _64), _64);
            if (adytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, cdxtail, _8), _8, adytail, _16), _16);
            if (bdytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, -cdxtail, _8), _8, bdytail, _16), _16);
        }
        if (cdytail !== 0) {
            const len = (0, _utilJs.scale)(abtlen, abt, cdytail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(cytablen, cytab, cdytail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * cdy, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(abttlen, abtt, cdytail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * cdy, _16), _16, (0, _utilJs.scale)(len2, _8, cdytail, _16b), _16b, (0, _utilJs.scale)(len, _16c, cdytail, _32), _32, _32b, _64), _64);
        }
    }
    return fin[finlen - 1];
}
function incircle(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const alift = adx * adx + ady * ady;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const blift = bdx * bdx + bdy * bdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const clift = cdx * cdx + cdy * cdy;
    const det = alift * (bdxcdy - cdxbdy) + blift * (cdxady - adxcdy) + clift * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * alift + (Math.abs(cdxady) + Math.abs(adxcdy)) * blift + (Math.abs(adxbdy) + Math.abs(bdxady)) * clift;
    const errbound = iccerrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent);
}
function incirclefast(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const ady = ay - dy;
    const bdx = bx - dx;
    const bdy = by - dy;
    const cdx = cx - dx;
    const cdy = cy - dy;
    const abdet = adx * bdy - bdx * ady;
    const bcdet = bdx * cdy - cdx * bdy;
    const cadet = cdx * ady - adx * cdy;
    const alift = adx * adx + ady * ady;
    const blift = bdx * bdx + bdy * bdy;
    const clift = cdx * cdx + cdy * cdy;
    return alift * bcdet + blift * cadet + clift * abdet;
}

},{"./util.js":"3oCKI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"7BwL0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "insphere", ()=>insphere);
parcelHelpers.export(exports, "inspherefast", ()=>inspherefast);
var _utilJs = require("./util.js");
const isperrboundA = (16 + 224 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const isperrboundB = (5 + 72 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const isperrboundC = (71 + 1408 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon) * (0, _utilJs.epsilon);
const ab = (0, _utilJs.vec)(4);
const bc = (0, _utilJs.vec)(4);
const cd = (0, _utilJs.vec)(4);
const de = (0, _utilJs.vec)(4);
const ea = (0, _utilJs.vec)(4);
const ac = (0, _utilJs.vec)(4);
const bd = (0, _utilJs.vec)(4);
const ce = (0, _utilJs.vec)(4);
const da = (0, _utilJs.vec)(4);
const eb = (0, _utilJs.vec)(4);
const abc = (0, _utilJs.vec)(24);
const bcd = (0, _utilJs.vec)(24);
const cde = (0, _utilJs.vec)(24);
const dea = (0, _utilJs.vec)(24);
const eab = (0, _utilJs.vec)(24);
const abd = (0, _utilJs.vec)(24);
const bce = (0, _utilJs.vec)(24);
const cda = (0, _utilJs.vec)(24);
const deb = (0, _utilJs.vec)(24);
const eac = (0, _utilJs.vec)(24);
const adet = (0, _utilJs.vec)(1152);
const bdet = (0, _utilJs.vec)(1152);
const cdet = (0, _utilJs.vec)(1152);
const ddet = (0, _utilJs.vec)(1152);
const edet = (0, _utilJs.vec)(1152);
const abdet = (0, _utilJs.vec)(2304);
const cddet = (0, _utilJs.vec)(2304);
const cdedet = (0, _utilJs.vec)(3456);
const deter = (0, _utilJs.vec)(5760);
const _8 = (0, _utilJs.vec)(8);
const _8b = (0, _utilJs.vec)(8);
const _8c = (0, _utilJs.vec)(8);
const _16 = (0, _utilJs.vec)(16);
const _24 = (0, _utilJs.vec)(24);
const _48 = (0, _utilJs.vec)(48);
const _48b = (0, _utilJs.vec)(48);
const _96 = (0, _utilJs.vec)(96);
const _192 = (0, _utilJs.vec)(192);
const _384x = (0, _utilJs.vec)(384);
const _384y = (0, _utilJs.vec)(384);
const _384z = (0, _utilJs.vec)(384);
const _768 = (0, _utilJs.vec)(768);
function sum_three_scale(a, b, c, az, bz, cz, out) {
    return (0, _utilJs.sum_three)((0, _utilJs.scale)(4, a, az, _8), _8, (0, _utilJs.scale)(4, b, bz, _8b), _8b, (0, _utilJs.scale)(4, c, cz, _8c), _8c, _16, out);
}
function liftexact(alen, a, blen, b, clen, c, dlen, d, x, y, z, out) {
    const len = (0, _utilJs.sum)((0, _utilJs.sum)(alen, a, blen, b, _48), _48, (0, _utilJs.negate)((0, _utilJs.sum)(clen, c, dlen, d, _48b), _48b), _48b, _96);
    return (0, _utilJs.sum_three)((0, _utilJs.scale)((0, _utilJs.scale)(len, _96, x, _192), _192, x, _384x), _384x, (0, _utilJs.scale)((0, _utilJs.scale)(len, _96, y, _192), _192, y, _384y), _384y, (0, _utilJs.scale)((0, _utilJs.scale)(len, _96, z, _192), _192, z, _384z), _384z, _768, out);
}
function insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    s1 = ax * by;
    c = (0, _utilJs.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, _utilJs.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ay;
    c = (0, _utilJs.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, _utilJs.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ab[3] = u3;
    s1 = bx * cy;
    c = (0, _utilJs.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, _utilJs.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * by;
    c = (0, _utilJs.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, _utilJs.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    bc[3] = u3;
    s1 = cx * dy;
    c = (0, _utilJs.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, _utilJs.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * cy;
    c = (0, _utilJs.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, _utilJs.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    cd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    cd[3] = u3;
    s1 = dx * ey;
    c = (0, _utilJs.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, _utilJs.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * dy;
    c = (0, _utilJs.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, _utilJs.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    de[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    de[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    de[2] = _j - (u3 - bvirt) + (_i - bvirt);
    de[3] = u3;
    s1 = ex * ay;
    c = (0, _utilJs.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, _utilJs.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * ey;
    c = (0, _utilJs.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, _utilJs.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ea[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ea[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ea[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ea[3] = u3;
    s1 = ax * cy;
    c = (0, _utilJs.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, _utilJs.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * ay;
    c = (0, _utilJs.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, _utilJs.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ac[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ac[3] = u3;
    s1 = bx * dy;
    c = (0, _utilJs.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, _utilJs.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * by;
    c = (0, _utilJs.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, _utilJs.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    bd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    bd[3] = u3;
    s1 = cx * ey;
    c = (0, _utilJs.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, _utilJs.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * cy;
    c = (0, _utilJs.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, _utilJs.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ce[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ce[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ce[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ce[3] = u3;
    s1 = dx * ay;
    c = (0, _utilJs.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, _utilJs.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * dy;
    c = (0, _utilJs.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, _utilJs.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    da[2] = _j - (u3 - bvirt) + (_i - bvirt);
    da[3] = u3;
    s1 = ex * by;
    c = (0, _utilJs.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, _utilJs.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ey;
    c = (0, _utilJs.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, _utilJs.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    eb[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    eb[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    eb[2] = _j - (u3 - bvirt) + (_i - bvirt);
    eb[3] = u3;
    const abclen = sum_three_scale(ab, bc, ac, cz, az, -bz, abc);
    const bcdlen = sum_three_scale(bc, cd, bd, dz, bz, -cz, bcd);
    const cdelen = sum_three_scale(cd, de, ce, ez, cz, -dz, cde);
    const dealen = sum_three_scale(de, ea, da, az, dz, -ez, dea);
    const eablen = sum_three_scale(ea, ab, eb, bz, ez, -az, eab);
    const abdlen = sum_three_scale(ab, bd, da, dz, az, bz, abd);
    const bcelen = sum_three_scale(bc, ce, eb, ez, bz, cz, bce);
    const cdalen = sum_three_scale(cd, da, ac, az, cz, dz, cda);
    const deblen = sum_three_scale(de, eb, bd, bz, dz, ez, deb);
    const eaclen = sum_three_scale(ea, ac, ce, cz, ez, az, eac);
    const deterlen = (0, _utilJs.sum_three)(liftexact(cdelen, cde, bcelen, bce, deblen, deb, bcdlen, bcd, ax, ay, az, adet), adet, liftexact(dealen, dea, cdalen, cda, eaclen, eac, cdelen, cde, bx, by, bz, bdet), bdet, (0, _utilJs.sum_three)(liftexact(eablen, eab, deblen, deb, abdlen, abd, dealen, dea, cx, cy, cz, cdet), cdet, liftexact(abclen, abc, eaclen, eac, bcelen, bce, eablen, eab, dx, dy, dz, ddet), ddet, liftexact(bcdlen, bcd, abdlen, abd, cdalen, cda, abclen, abc, ex, ey, ez, edet), edet, cddet, cdedet), cdedet, abdet, deter);
    return deter[deterlen - 1];
}
const xdet = (0, _utilJs.vec)(96);
const ydet = (0, _utilJs.vec)(96);
const zdet = (0, _utilJs.vec)(96);
const fin = (0, _utilJs.vec)(1152);
function liftadapt(a, b, c, az, bz, cz, x, y, z, out) {
    const len = sum_three_scale(a, b, c, az, bz, cz, _24);
    return (0, _utilJs.sum_three)((0, _utilJs.scale)((0, _utilJs.scale)(len, _24, x, _48), _48, x, xdet), xdet, (0, _utilJs.scale)((0, _utilJs.scale)(len, _24, y, _48), _48, y, ydet), ydet, (0, _utilJs.scale)((0, _utilJs.scale)(len, _24, z, _48), _48, z, zdet), zdet, _192, out);
}
function insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent) {
    let ab3, bc3, cd3, da3, ac3, bd3;
    let aextail, bextail, cextail, dextail;
    let aeytail, beytail, ceytail, deytail;
    let aeztail, beztail, ceztail, deztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0;
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    s1 = aex * bey;
    c = (0, _utilJs.splitter) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, _utilJs.splitter) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bex * aey;
    c = (0, _utilJs.splitter) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, _utilJs.splitter) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ab3 = _j + _i;
    bvirt = ab3 - _j;
    ab[2] = _j - (ab3 - bvirt) + (_i - bvirt);
    ab[3] = ab3;
    s1 = bex * cey;
    c = (0, _utilJs.splitter) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, _utilJs.splitter) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * bey;
    c = (0, _utilJs.splitter) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, _utilJs.splitter) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bc3 = _j + _i;
    bvirt = bc3 - _j;
    bc[2] = _j - (bc3 - bvirt) + (_i - bvirt);
    bc[3] = bc3;
    s1 = cex * dey;
    c = (0, _utilJs.splitter) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, _utilJs.splitter) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * cey;
    c = (0, _utilJs.splitter) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, _utilJs.splitter) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    cd3 = _j + _i;
    bvirt = cd3 - _j;
    cd[2] = _j - (cd3 - bvirt) + (_i - bvirt);
    cd[3] = cd3;
    s1 = dex * aey;
    c = (0, _utilJs.splitter) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, _utilJs.splitter) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = aex * dey;
    c = (0, _utilJs.splitter) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, _utilJs.splitter) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    da3 = _j + _i;
    bvirt = da3 - _j;
    da[2] = _j - (da3 - bvirt) + (_i - bvirt);
    da[3] = da3;
    s1 = aex * cey;
    c = (0, _utilJs.splitter) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, _utilJs.splitter) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * aey;
    c = (0, _utilJs.splitter) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, _utilJs.splitter) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ac3 = _j + _i;
    bvirt = ac3 - _j;
    ac[2] = _j - (ac3 - bvirt) + (_i - bvirt);
    ac[3] = ac3;
    s1 = bex * dey;
    c = (0, _utilJs.splitter) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, _utilJs.splitter) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * bey;
    c = (0, _utilJs.splitter) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, _utilJs.splitter) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bd3 = _j + _i;
    bvirt = bd3 - _j;
    bd[2] = _j - (bd3 - bvirt) + (_i - bvirt);
    bd[3] = bd3;
    const finlen = (0, _utilJs.sum)((0, _utilJs.sum)((0, _utilJs.negate)(liftadapt(bc, cd, bd, dez, bez, -cez, aex, aey, aez, adet), adet), adet, liftadapt(cd, da, ac, aez, cez, dez, bex, bey, bez, bdet), bdet, abdet), abdet, (0, _utilJs.sum)((0, _utilJs.negate)(liftadapt(da, ab, bd, bez, dez, aez, cex, cey, cez, cdet), cdet), cdet, liftadapt(ab, bc, ac, cez, aez, -bez, dex, dey, dez, ddet), ddet, cddet), cddet, fin);
    let det = (0, _utilJs.estimate)(finlen, fin);
    let errbound = isperrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - aex;
    aextail = ax - (aex + bvirt) + (bvirt - ex);
    bvirt = ay - aey;
    aeytail = ay - (aey + bvirt) + (bvirt - ey);
    bvirt = az - aez;
    aeztail = az - (aez + bvirt) + (bvirt - ez);
    bvirt = bx - bex;
    bextail = bx - (bex + bvirt) + (bvirt - ex);
    bvirt = by - bey;
    beytail = by - (bey + bvirt) + (bvirt - ey);
    bvirt = bz - bez;
    beztail = bz - (bez + bvirt) + (bvirt - ez);
    bvirt = cx - cex;
    cextail = cx - (cex + bvirt) + (bvirt - ex);
    bvirt = cy - cey;
    ceytail = cy - (cey + bvirt) + (bvirt - ey);
    bvirt = cz - cez;
    ceztail = cz - (cez + bvirt) + (bvirt - ez);
    bvirt = dx - dex;
    dextail = dx - (dex + bvirt) + (bvirt - ex);
    bvirt = dy - dey;
    deytail = dy - (dey + bvirt) + (bvirt - ey);
    bvirt = dz - dez;
    deztail = dz - (dez + bvirt) + (bvirt - ez);
    if (aextail === 0 && aeytail === 0 && aeztail === 0 && bextail === 0 && beytail === 0 && beztail === 0 && cextail === 0 && ceytail === 0 && ceztail === 0 && dextail === 0 && deytail === 0 && deztail === 0) return det;
    errbound = isperrboundC * permanent + (0, _utilJs.resulterrbound) * Math.abs(det);
    const abeps = aex * beytail + bey * aextail - (aey * bextail + bex * aeytail);
    const bceps = bex * ceytail + cey * bextail - (bey * cextail + cex * beytail);
    const cdeps = cex * deytail + dey * cextail - (cey * dextail + dex * ceytail);
    const daeps = dex * aeytail + aey * dextail - (dey * aextail + aex * deytail);
    const aceps = aex * ceytail + cey * aextail - (aey * cextail + cex * aeytail);
    const bdeps = bex * deytail + dey * bextail - (bey * dextail + dex * beytail);
    det += (bex * bex + bey * bey + bez * bez) * (cez * daeps + dez * aceps + aez * cdeps + (ceztail * da3 + deztail * ac3 + aeztail * cd3)) + (dex * dex + dey * dey + dez * dez) * (aez * bceps - bez * aceps + cez * abeps + (aeztail * bc3 - beztail * ac3 + ceztail * ab3)) - ((aex * aex + aey * aey + aez * aez) * (bez * cdeps - cez * bdeps + dez * bceps + (beztail * cd3 - ceztail * bd3 + deztail * bc3)) + (cex * cex + cey * cey + cez * cez) * (dez * abeps + aez * bdeps + bez * daeps + (deztail * ab3 + aeztail * bd3 + beztail * da3))) + 2 * ((bex * bextail + bey * beytail + bez * beztail) * (cez * da3 + dez * ac3 + aez * cd3) + (dex * dextail + dey * deytail + dez * deztail) * (aez * bc3 - bez * ac3 + cez * ab3) - ((aex * aextail + aey * aeytail + aez * aeztail) * (bez * cd3 - cez * bd3 + dez * bc3) + (cex * cextail + cey * ceytail + cez * ceztail) * (dez * ab3 + aez * bd3 + bez * da3)));
    if (det >= errbound || -det >= errbound) return det;
    return insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez);
}
function insphere(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    const aexbey = aex * bey;
    const bexaey = bex * aey;
    const ab = aexbey - bexaey;
    const bexcey = bex * cey;
    const cexbey = cex * bey;
    const bc = bexcey - cexbey;
    const cexdey = cex * dey;
    const dexcey = dex * cey;
    const cd = cexdey - dexcey;
    const dexaey = dex * aey;
    const aexdey = aex * dey;
    const da = dexaey - aexdey;
    const aexcey = aex * cey;
    const cexaey = cex * aey;
    const ac = aexcey - cexaey;
    const bexdey = bex * dey;
    const dexbey = dex * bey;
    const bd = bexdey - dexbey;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    const det = clift * (dez * ab + aez * bd + bez * da) - dlift * (aez * bc - bez * ac + cez * ab) + (alift * (bez * cd - cez * bd + dez * bc) - blift * (cez * da + dez * ac + aez * cd));
    const aezplus = Math.abs(aez);
    const bezplus = Math.abs(bez);
    const cezplus = Math.abs(cez);
    const dezplus = Math.abs(dez);
    const aexbeyplus = Math.abs(aexbey) + Math.abs(bexaey);
    const bexceyplus = Math.abs(bexcey) + Math.abs(cexbey);
    const cexdeyplus = Math.abs(cexdey) + Math.abs(dexcey);
    const dexaeyplus = Math.abs(dexaey) + Math.abs(aexdey);
    const aexceyplus = Math.abs(aexcey) + Math.abs(cexaey);
    const bexdeyplus = Math.abs(bexdey) + Math.abs(dexbey);
    const permanent = (cexdeyplus * bezplus + bexdeyplus * cezplus + bexceyplus * dezplus) * alift + (dexaeyplus * cezplus + aexceyplus * dezplus + cexdeyplus * aezplus) * blift + (aexbeyplus * dezplus + bexdeyplus * aezplus + dexaeyplus * bezplus) * clift + (bexceyplus * aezplus + aexceyplus * bezplus + aexbeyplus * cezplus) * dlift;
    const errbound = isperrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return -insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent);
}
function inspherefast(pax, pay, paz, pbx, pby, pbz, pcx, pcy, pcz, pdx, pdy, pdz, pex, pey, pez) {
    const aex = pax - pex;
    const bex = pbx - pex;
    const cex = pcx - pex;
    const dex = pdx - pex;
    const aey = pay - pey;
    const bey = pby - pey;
    const cey = pcy - pey;
    const dey = pdy - pey;
    const aez = paz - pez;
    const bez = pbz - pez;
    const cez = pcz - pez;
    const dez = pdz - pez;
    const ab = aex * bey - bex * aey;
    const bc = bex * cey - cex * bey;
    const cd = cex * dey - dex * cey;
    const da = dex * aey - aex * dey;
    const ac = aex * cey - cex * aey;
    const bd = bex * dey - dex * bey;
    const abc = aez * bc - bez * ac + cez * ab;
    const bcd = bez * cd - cez * bd + dez * bc;
    const cda = cez * da + dez * ac + aez * cd;
    const dab = dez * ab + aez * bd + bez * da;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    return clift * dab - dlift * abc + (alift * bcd - blift * cda);
}

},{"./util.js":"3oCKI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"2MH7X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const epsilon = 1e-6;
class Path {
    constructor(){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
    }
    moveTo(x, y) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    }
    lineTo(x, y) {
        this._ += `L${this._x1 = +x},${this._y1 = +y}`;
    }
    arc(x, y, r) {
        x = +x, y = +y, r = +r;
        const x0 = x + r;
        const y0 = y;
        if (r < 0) throw new Error("negative radius");
        if (this._x1 === null) this._ += `M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._ += "L" + x0 + "," + y0;
        if (!r) return;
        this._ += `A${r},${r},0,1,1,${x - r},${y}A${r},${r},0,1,1,${this._x1 = x0},${this._y1 = y0}`;
    }
    rect(x, y, w, h) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${+w}v${+h}h${-w}Z`;
    }
    value() {
        return this._ || null;
    }
}
exports.default = Path;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"iN814":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class Polygon {
    constructor(){
        this._ = [];
    }
    moveTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    closePath() {
        this._.push(this._[0].slice());
    }
    lineTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    value() {
        return this._.length ? this._ : null;
    }
}
exports.default = Polygon;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"k7lzi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
var _polygonJs = require("./polygon.js");
var _polygonJsDefault = parcelHelpers.interopDefault(_polygonJs);
class Voronoi {
    constructor(delaunay, [xmin, ymin, xmax, ymax] = [
        0,
        0,
        960,
        500
    ]){
        if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
        this.delaunay = delaunay;
        this._circumcenters = new Float64Array(delaunay.points.length * 2);
        this.vectors = new Float64Array(delaunay.points.length * 2);
        this.xmax = xmax, this.xmin = xmin;
        this.ymax = ymax, this.ymin = ymin;
        this._init();
    }
    update() {
        this.delaunay.update();
        this._init();
        return this;
    }
    _init() {
        const { delaunay: { points, hull, triangles }, vectors } = this;
        let bx, by; // lazily computed barycenter of the hull
        // Compute circumcenters.
        const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
        for(let i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2){
            const t1 = triangles[i] * 2;
            const t2 = triangles[i + 1] * 2;
            const t3 = triangles[i + 2] * 2;
            const x1 = points[t1];
            const y1 = points[t1 + 1];
            const x2 = points[t2];
            const y2 = points[t2 + 1];
            const x3 = points[t3];
            const y3 = points[t3 + 1];
            const dx = x2 - x1;
            const dy = y2 - y1;
            const ex = x3 - x1;
            const ey = y3 - y1;
            const ab = (dx * ey - dy * ex) * 2;
            if (Math.abs(ab) < 1e-9) {
                // For a degenerate triangle, the circumcenter is at the infinity, in a
                // direction orthogonal to the halfedge and away from the “center” of
                // the diagram <bx, by>, defined as the hull’s barycenter.
                if (bx === undefined) {
                    bx = by = 0;
                    for (const i of hull)bx += points[i * 2], by += points[i * 2 + 1];
                    bx /= hull.length, by /= hull.length;
                }
                const a = 1e9 * Math.sign((bx - x1) * ey - (by - y1) * ex);
                x = (x1 + x3) / 2 - a * ey;
                y = (y1 + y3) / 2 + a * ex;
            } else {
                const d = 1 / ab;
                const bl = dx * dx + dy * dy;
                const cl = ex * ex + ey * ey;
                x = x1 + (ey * bl - dy * cl) * d;
                y = y1 + (dx * cl - ex * bl) * d;
            }
            circumcenters[j] = x;
            circumcenters[j + 1] = y;
        }
        // Compute exterior cell rays.
        let h = hull[hull.length - 1];
        let p0, p1 = h * 4;
        let x0, x1 = points[2 * h];
        let y0, y1 = points[2 * h + 1];
        vectors.fill(0);
        for(let i = 0; i < hull.length; ++i){
            h = hull[i];
            p0 = p1, x0 = x1, y0 = y1;
            p1 = h * 4, x1 = points[2 * h], y1 = points[2 * h + 1];
            vectors[p0 + 2] = vectors[p1] = y0 - y1;
            vectors[p0 + 3] = vectors[p1 + 1] = x1 - x0;
        }
    }
    render(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { delaunay: { halfedges, inedges, hull }, circumcenters, vectors } = this;
        if (hull.length <= 1) return null;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = Math.floor(i / 3) * 2;
            const tj = Math.floor(j / 3) * 2;
            const xi = circumcenters[ti];
            const yi = circumcenters[ti + 1];
            const xj = circumcenters[tj];
            const yj = circumcenters[tj + 1];
            this._renderSegment(xi, yi, xj, yj, context);
        }
        let h0, h1 = hull[hull.length - 1];
        for(let i = 0; i < hull.length; ++i){
            h0 = h1, h1 = hull[i];
            const t = Math.floor(inedges[h1] / 3) * 2;
            const x = circumcenters[t];
            const y = circumcenters[t + 1];
            const v = h0 * 4;
            const p = this._project(x, y, vectors[v + 2], vectors[v + 3]);
            if (p) this._renderSegment(x, y, p[0], p[1], context);
        }
        return buffer && buffer.value();
    }
    renderBounds(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
        return buffer && buffer.value();
    }
    renderCell(i, context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const points = this._clip(i);
        if (points === null || !points.length) return;
        context.moveTo(points[0], points[1]);
        let n = points.length;
        while(points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1)n -= 2;
        for(let i = 2; i < n; i += 2)if (points[i] !== points[i - 2] || points[i + 1] !== points[i - 1]) context.lineTo(points[i], points[i + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *cellPolygons() {
        const { delaunay: { points } } = this;
        for(let i = 0, n = points.length / 2; i < n; ++i){
            const cell = this.cellPolygon(i);
            if (cell) cell.index = i, yield cell;
        }
    }
    cellPolygon(i) {
        const polygon = new (0, _polygonJsDefault.default);
        this.renderCell(i, polygon);
        return polygon.value();
    }
    _renderSegment(x0, y0, x1, y1, context) {
        let S;
        const c0 = this._regioncode(x0, y0);
        const c1 = this._regioncode(x1, y1);
        if (c0 === 0 && c1 === 0) {
            context.moveTo(x0, y0);
            context.lineTo(x1, y1);
        } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
            context.moveTo(S[0], S[1]);
            context.lineTo(S[2], S[3]);
        }
    }
    contains(i, x, y) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
        return this.delaunay._step(i, x, y) === i;
    }
    *neighbors(i) {
        const ci = this._clip(i);
        if (ci) for (const j of this.delaunay.neighbors(i)){
            const cj = this._clip(j);
            // find the common edge
            if (cj) loop: for(let ai = 0, li = ci.length; ai < li; ai += 2){
                for(let aj = 0, lj = cj.length; aj < lj; aj += 2)if (ci[ai] === cj[aj] && ci[ai + 1] === cj[aj + 1] && ci[(ai + 2) % li] === cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] === cj[(aj + lj - 1) % lj]) {
                    yield j;
                    break loop;
                }
            }
        }
    }
    _cell(i) {
        const { circumcenters, delaunay: { inedges, halfedges, triangles } } = this;
        const e0 = inedges[i];
        if (e0 === -1) return null; // coincident point
        const points = [];
        let e = e0;
        do {
            const t = Math.floor(e / 3);
            points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
        }while (e !== e0 && e !== -1);
        return points;
    }
    _clip(i) {
        // degenerate case (1 valid point: return the box)
        if (i === 0 && this.delaunay.hull.length === 1) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        const points = this._cell(i);
        if (points === null) return null;
        const { vectors: V } = this;
        const v = i * 4;
        return this._simplify(V[v] || V[v + 1] ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3]) : this._clipFinite(i, points));
    }
    _clipFinite(i, points) {
        const n = points.length;
        let P = null;
        let x0, y0, x1 = points[n - 2], y1 = points[n - 1];
        let c0, c1 = this._regioncode(x1, y1);
        let e0, e1 = 0;
        for(let j = 0; j < n; j += 2){
            x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
            c0 = c1, c1 = this._regioncode(x1, y1);
            if (c0 === 0 && c1 === 0) {
                e0 = e1, e1 = 0;
                if (P) P.push(x1, y1);
                else P = [
                    x1,
                    y1
                ];
            } else {
                let S, sx0, sy0, sx1, sy1;
                if (c0 === 0) {
                    if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
                    [sx0, sy0, sx1, sy1] = S;
                } else {
                    if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
                    [sx1, sy1, sx0, sy0] = S;
                    e0 = e1, e1 = this._edgecode(sx0, sy0);
                    if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                    if (P) P.push(sx0, sy0);
                    else P = [
                        sx0,
                        sy0
                    ];
                }
                e0 = e1, e1 = this._edgecode(sx1, sy1);
                if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                if (P) P.push(sx1, sy1);
                else P = [
                    sx1,
                    sy1
                ];
            }
        }
        if (P) {
            e0 = e1, e1 = this._edgecode(P[0], P[1]);
            if (e0 && e1) this._edge(i, e0, e1, P, P.length);
        } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        return P;
    }
    _clipSegment(x0, y0, x1, y1, c0, c1) {
        // for more robustness, always consider the segment in the same order
        const flip = c0 < c1;
        if (flip) [x0, y0, x1, y1, c0, c1] = [
            x1,
            y1,
            x0,
            y0,
            c1,
            c0
        ];
        while(true){
            if (c0 === 0 && c1 === 0) return flip ? [
                x1,
                y1,
                x0,
                y0
            ] : [
                x0,
                y0,
                x1,
                y1
            ];
            if (c0 & c1) return null;
            let x, y, c = c0 || c1;
            if (c & 8) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;
            else if (c & 4) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;
            else if (c & 2) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;
            else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
            if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);
            else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
        }
    }
    _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
        let P = Array.from(points), p;
        if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
        if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
        if (P = this._clipFinite(i, P)) for(let j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2){
            c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
            if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
        }
        else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) P = [
            this.xmin,
            this.ymin,
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax
        ];
        return P;
    }
    _edge(i, e0, e1, P, j) {
        while(e0 !== e1){
            let x, y;
            switch(e0){
                case 5:
                    e0 = 4;
                    continue; // top-left
                case 4:
                    e0 = 6, x = this.xmax, y = this.ymin;
                    break; // top
                case 6:
                    e0 = 2;
                    continue; // top-right
                case 2:
                    e0 = 10, x = this.xmax, y = this.ymax;
                    break; // right
                case 10:
                    e0 = 8;
                    continue; // bottom-right
                case 8:
                    e0 = 9, x = this.xmin, y = this.ymax;
                    break; // bottom
                case 9:
                    e0 = 1;
                    continue; // bottom-left
                case 1:
                    e0 = 5, x = this.xmin, y = this.ymin;
                    break; // left
            }
            // Note: this implicitly checks for out of bounds: if P[j] or P[j+1] are
            // undefined, the conditional statement will be executed.
            if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) P.splice(j, 0, x, y), j += 2;
        }
        return j;
    }
    _project(x0, y0, vx, vy) {
        let t = Infinity, c, x, y;
        if (vy < 0) {
            if (y0 <= this.ymin) return null;
            if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
        } else if (vy > 0) {
            if (y0 >= this.ymax) return null;
            if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
        }
        if (vx > 0) {
            if (x0 >= this.xmax) return null;
            if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
        } else if (vx < 0) {
            if (x0 <= this.xmin) return null;
            if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
        }
        return [
            x,
            y
        ];
    }
    _edgecode(x, y) {
        return (x === this.xmin ? 1 : x === this.xmax ? 2 : 0) | (y === this.ymin ? 4 : y === this.ymax ? 8 : 0);
    }
    _regioncode(x, y) {
        return (x < this.xmin ? 1 : x > this.xmax ? 2 : 0) | (y < this.ymin ? 4 : y > this.ymax ? 8 : 0);
    }
    _simplify(P) {
        if (P && P.length > 4) {
            for(let i = 0; i < P.length; i += 2){
                const j = (i + 2) % P.length, k = (i + 4) % P.length;
                if (P[i] === P[j] && P[j] === P[k] || P[i + 1] === P[j + 1] && P[j + 1] === P[k + 1]) P.splice(j, 2), i -= 2;
            }
            if (!P.length) P = null;
        }
        return P;
    }
}
exports.default = Voronoi;

},{"./path.js":"2MH7X","./polygon.js":"iN814","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"avVAf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wordcloud", ()=>Wordcloud);
var _vegaCanvas = require("vega-canvas");
var _vegaDataflow = require("vega-dataflow");
var _vegaUtil = require("vega-util");
var _vegaScale = require("vega-scale");
var _vegaStatistics = require("vega-statistics");
/*
Copyright (c) 2013, Jason Davies.
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

  * Redistributions of source code must retain the above copyright notice, this
    list of conditions and the following disclaimer.

  * Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
    and/or other materials provided with the distribution.

  * The name Jason Davies may not be used to endorse or promote products
    derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL JASON DAVIES BE LIABLE FOR ANY DIRECT, INDIRECT,
INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ // Word cloud layout by Jason Davies, https://www.jasondavies.com/wordcloud/
// Algorithm due to Jonathan Feinberg, http://static.mrfeinberg.com/bv_ch03.pdf
var cloudRadians = Math.PI / 180, cw = 64, ch = 2048;
function cloud() {
    var size = [
        256,
        256
    ], text, font, fontSize, fontStyle, fontWeight, rotate, padding, spiral = archimedeanSpiral, words = [], random = Math.random, cloud = {};
    cloud.layout = function() {
        var contextAndRatio = getContext((0, _vegaCanvas.canvas)()), board = zeroArray((size[0] >> 5) * size[1]), bounds = null, n = words.length, i = -1, tags = [], data = words.map((d)=>({
                text: text(d),
                font: font(d),
                style: fontStyle(d),
                weight: fontWeight(d),
                rotate: rotate(d),
                size: ~~(fontSize(d) + 1e-14),
                padding: padding(d),
                xoff: 0,
                yoff: 0,
                x1: 0,
                y1: 0,
                x0: 0,
                y0: 0,
                hasText: false,
                sprite: null,
                datum: d
            })).sort((a, b)=>b.size - a.size);
        while(++i < n){
            var d = data[i];
            d.x = size[0] * (random() + .5) >> 1;
            d.y = size[1] * (random() + .5) >> 1;
            cloudSprite(contextAndRatio, d, data, i);
            if (d.hasText && place(board, d, bounds)) {
                tags.push(d);
                if (bounds) cloudBounds(bounds, d);
                else bounds = [
                    {
                        x: d.x + d.x0,
                        y: d.y + d.y0
                    },
                    {
                        x: d.x + d.x1,
                        y: d.y + d.y1
                    }
                ];
                // Temporary hack
                d.x -= size[0] >> 1;
                d.y -= size[1] >> 1;
            }
        }
        return tags;
    };
    function getContext(canvas) {
        canvas.width = canvas.height = 1;
        var ratio = Math.sqrt(canvas.getContext('2d').getImageData(0, 0, 1, 1).data.length >> 2);
        canvas.width = (cw << 5) / ratio;
        canvas.height = ch / ratio;
        var context = canvas.getContext('2d');
        context.fillStyle = context.strokeStyle = 'red';
        context.textAlign = 'center';
        return {
            context: context,
            ratio: ratio
        };
    }
    function place(board, tag, bounds) {
        var startX = tag.x, startY = tag.y, maxDelta = Math.hypot(size[0], size[1]), s = spiral(size), dt = random() < .5 ? 1 : -1, t = -dt, dxdy, dx, dy;
        while(dxdy = s(t += dt)){
            dx = ~~dxdy[0];
            dy = ~~dxdy[1];
            if (Math.min(Math.abs(dx), Math.abs(dy)) >= maxDelta) break;
            tag.x = startX + dx;
            tag.y = startY + dy;
            if (tag.x + tag.x0 < 0 || tag.y + tag.y0 < 0 || tag.x + tag.x1 > size[0] || tag.y + tag.y1 > size[1]) continue;
            // TODO only check for collisions within current bounds.
            if (!bounds || !cloudCollide(tag, board, size[0])) {
                if (!bounds || collideRects(tag, bounds)) {
                    var sprite = tag.sprite, w = tag.width >> 5, sw = size[0] >> 5, lx = tag.x - (w << 4), sx = lx & 0x7f, msx = 32 - sx, h = tag.y1 - tag.y0, x = (tag.y + tag.y0) * sw + (lx >> 5), last;
                    for(var j = 0; j < h; j++){
                        last = 0;
                        for(var i = 0; i <= w; i++)board[x + i] |= last << msx | (i < w ? (last = sprite[j * w + i]) >>> sx : 0);
                        x += sw;
                    }
                    tag.sprite = null;
                    return true;
                }
            }
        }
        return false;
    }
    cloud.words = function(_) {
        if (arguments.length) {
            words = _;
            return cloud;
        } else return words;
    };
    cloud.size = function(_) {
        if (arguments.length) {
            size = [
                +_[0],
                +_[1]
            ];
            return cloud;
        } else return size;
    };
    cloud.font = function(_) {
        if (arguments.length) {
            font = functor(_);
            return cloud;
        } else return font;
    };
    cloud.fontStyle = function(_) {
        if (arguments.length) {
            fontStyle = functor(_);
            return cloud;
        } else return fontStyle;
    };
    cloud.fontWeight = function(_) {
        if (arguments.length) {
            fontWeight = functor(_);
            return cloud;
        } else return fontWeight;
    };
    cloud.rotate = function(_) {
        if (arguments.length) {
            rotate = functor(_);
            return cloud;
        } else return rotate;
    };
    cloud.text = function(_) {
        if (arguments.length) {
            text = functor(_);
            return cloud;
        } else return text;
    };
    cloud.spiral = function(_) {
        if (arguments.length) {
            spiral = spirals[_] || _;
            return cloud;
        } else return spiral;
    };
    cloud.fontSize = function(_) {
        if (arguments.length) {
            fontSize = functor(_);
            return cloud;
        } else return fontSize;
    };
    cloud.padding = function(_) {
        if (arguments.length) {
            padding = functor(_);
            return cloud;
        } else return padding;
    };
    cloud.random = function(_) {
        if (arguments.length) {
            random = _;
            return cloud;
        } else return random;
    };
    return cloud;
}
// Fetches a monochrome sprite bitmap for the specified text.
// Load in batches for speed.
function cloudSprite(contextAndRatio, d, data, di) {
    if (d.sprite) return;
    var c = contextAndRatio.context, ratio = contextAndRatio.ratio;
    c.clearRect(0, 0, (cw << 5) / ratio, ch / ratio);
    var x = 0, y = 0, maxh = 0, n = data.length, w, w32, h, i, j;
    --di;
    while(++di < n){
        d = data[di];
        c.save();
        c.font = d.style + ' ' + d.weight + ' ' + ~~((d.size + 1) / ratio) + 'px ' + d.font;
        w = c.measureText(d.text + 'm').width * ratio;
        h = d.size << 1;
        if (d.rotate) {
            var sr = Math.sin(d.rotate * cloudRadians), cr = Math.cos(d.rotate * cloudRadians), wcr = w * cr, wsr = w * sr, hcr = h * cr, hsr = h * sr;
            w = Math.max(Math.abs(wcr + hsr), Math.abs(wcr - hsr)) + 0x1f >> 5 << 5;
            h = ~~Math.max(Math.abs(wsr + hcr), Math.abs(wsr - hcr));
        } else w = w + 0x1f >> 5 << 5;
        if (h > maxh) maxh = h;
        if (x + w >= cw << 5) {
            x = 0;
            y += maxh;
            maxh = 0;
        }
        if (y + h >= ch) break;
        c.translate((x + (w >> 1)) / ratio, (y + (h >> 1)) / ratio);
        if (d.rotate) c.rotate(d.rotate * cloudRadians);
        c.fillText(d.text, 0, 0);
        if (d.padding) {
            c.lineWidth = 2 * d.padding;
            c.strokeText(d.text, 0, 0);
        }
        c.restore();
        d.width = w;
        d.height = h;
        d.xoff = x;
        d.yoff = y;
        d.x1 = w >> 1;
        d.y1 = h >> 1;
        d.x0 = -d.x1;
        d.y0 = -d.y1;
        d.hasText = true;
        x += w;
    }
    var pixels = c.getImageData(0, 0, (cw << 5) / ratio, ch / ratio).data, sprite = [];
    while(--di >= 0){
        d = data[di];
        if (!d.hasText) continue;
        w = d.width;
        w32 = w >> 5;
        h = d.y1 - d.y0;
        // Zero the buffer
        for(i = 0; i < h * w32; i++)sprite[i] = 0;
        x = d.xoff;
        if (x == null) return;
        y = d.yoff;
        var seen = 0, seenRow = -1;
        for(j = 0; j < h; j++){
            for(i = 0; i < w; i++){
                var k = w32 * j + (i >> 5), m = pixels[(y + j) * (cw << 5) + (x + i) << 2] ? 1 << 31 - i % 32 : 0;
                sprite[k] |= m;
                seen |= m;
            }
            if (seen) seenRow = j;
            else {
                d.y0++;
                h--;
                j--;
                y++;
            }
        }
        d.y1 = d.y0 + seenRow;
        d.sprite = sprite.slice(0, (d.y1 - d.y0) * w32);
    }
}
// Use mask-based collision detection.
function cloudCollide(tag, board, sw) {
    sw >>= 5;
    var sprite = tag.sprite, w = tag.width >> 5, lx = tag.x - (w << 4), sx = lx & 0x7f, msx = 32 - sx, h = tag.y1 - tag.y0, x = (tag.y + tag.y0) * sw + (lx >> 5), last;
    for(var j = 0; j < h; j++){
        last = 0;
        for(var i = 0; i <= w; i++){
            if ((last << msx | (i < w ? (last = sprite[j * w + i]) >>> sx : 0)) & board[x + i]) return true;
        }
        x += sw;
    }
    return false;
}
function cloudBounds(bounds, d) {
    var b0 = bounds[0], b1 = bounds[1];
    if (d.x + d.x0 < b0.x) b0.x = d.x + d.x0;
    if (d.y + d.y0 < b0.y) b0.y = d.y + d.y0;
    if (d.x + d.x1 > b1.x) b1.x = d.x + d.x1;
    if (d.y + d.y1 > b1.y) b1.y = d.y + d.y1;
}
function collideRects(a, b) {
    return a.x + a.x1 > b[0].x && a.x + a.x0 < b[1].x && a.y + a.y1 > b[0].y && a.y + a.y0 < b[1].y;
}
function archimedeanSpiral(size) {
    var e = size[0] / size[1];
    return function(t) {
        return [
            e * (t *= .1) * Math.cos(t),
            t * Math.sin(t)
        ];
    };
}
function rectangularSpiral(size) {
    var dy = 4, dx = dy * size[0] / size[1], x = 0, y = 0;
    return function(t) {
        var sign = t < 0 ? -1 : 1;
        // See triangular numbers: T_n = n * (n + 1) / 2.
        switch(Math.sqrt(1 + 4 * sign * t) - sign & 3){
            case 0:
                x += dx;
                break;
            case 1:
                y += dy;
                break;
            case 2:
                x -= dx;
                break;
            default:
                y -= dy;
                break;
        }
        return [
            x,
            y
        ];
    };
}
// TODO reuse arrays?
function zeroArray(n) {
    var a = [], i = -1;
    while(++i < n)a[i] = 0;
    return a;
}
function functor(d) {
    return typeof d === 'function' ? d : function() {
        return d;
    };
}
var spirals = {
    archimedean: archimedeanSpiral,
    rectangular: rectangularSpiral
};
const Output = [
    'x',
    'y',
    'font',
    'fontSize',
    'fontStyle',
    'fontWeight',
    'angle'
];
const Params = [
    'text',
    'font',
    'rotate',
    'fontSize',
    'fontStyle',
    'fontWeight'
];
function Wordcloud(params) {
    (0, _vegaDataflow.Transform).call(this, cloud(), params);
}
Wordcloud.Definition = {
    'type': 'Wordcloud',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'size',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'font',
            'type': 'string',
            'expr': true,
            'default': 'sans-serif'
        },
        {
            'name': 'fontStyle',
            'type': 'string',
            'expr': true,
            'default': 'normal'
        },
        {
            'name': 'fontWeight',
            'type': 'string',
            'expr': true,
            'default': 'normal'
        },
        {
            'name': 'fontSize',
            'type': 'number',
            'expr': true,
            'default': 14
        },
        {
            'name': 'fontSizeRange',
            'type': 'number',
            'array': 'nullable',
            'default': [
                10,
                50
            ]
        },
        {
            'name': 'rotate',
            'type': 'number',
            'expr': true,
            'default': 0
        },
        {
            'name': 'text',
            'type': 'field'
        },
        {
            'name': 'spiral',
            'type': 'string',
            'values': [
                'archimedean',
                'rectangular'
            ]
        },
        {
            'name': 'padding',
            'type': 'number',
            'expr': true
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': 7,
            'default': Output
        }
    ]
};
(0, _vegaUtil.inherits)(Wordcloud, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (_.size && !(_.size[0] && _.size[1])) (0, _vegaUtil.error)('Wordcloud size dimensions must be non-zero.');
        function modp(param) {
            const p = _[param];
            return (0, _vegaUtil.isFunction)(p) && pulse.modified(p.fields);
        }
        const mod = _.modified();
        if (!(mod || pulse.changed(pulse.ADD_REM) || Params.some(modp))) return;
        const data = pulse.materialize(pulse.SOURCE).source, layout = this.value, as = _.as || Output;
        let fontSize = _.fontSize || 14, range;
        (0, _vegaUtil.isFunction)(fontSize) ? range = _.fontSizeRange : fontSize = (0, _vegaUtil.constant)(fontSize);
        // create font size scaling function as needed
        if (range) {
            const fsize = fontSize, sizeScale = (0, _vegaScale.scale)('sqrt')().domain((0, _vegaUtil.extent)(data, fsize)).range(range);
            fontSize = (x)=>sizeScale(fsize(x));
        }
        data.forEach((t)=>{
            t[as[0]] = NaN;
            t[as[1]] = NaN;
            t[as[3]] = 0;
        });
        // configure layout
        const words = layout.words(data).text(_.text).size(_.size || [
            500,
            500
        ]).padding(_.padding || 1).spiral(_.spiral || 'archimedean').rotate(_.rotate || 0).font(_.font || 'sans-serif').fontStyle(_.fontStyle || 'normal').fontWeight(_.fontWeight || 'normal').fontSize(fontSize).random((0, _vegaStatistics.random)).layout();
        const size = layout.size(), dx = size[0] >> 1, dy = size[1] >> 1, n = words.length;
        for(let i = 0, w, t; i < n; ++i){
            w = words[i];
            t = w.datum;
            t[as[0]] = w.x + dx;
            t[as[1]] = w.y + dy;
            t[as[2]] = w.font;
            t[as[3]] = w.size;
            t[as[4]] = w.style;
            t[as[5]] = w.weight;
            t[as[6]] = w.rotate;
        }
        return pulse.reflow(mod).modifies(as);
    }
});

},{"vega-canvas":"duGNb","vega-dataflow":"4An7U","vega-util":"7f6sQ","vega-scale":"13gXz","vega-statistics":"lNUxJ","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3mSgx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "crossfilter", ()=>CrossFilter);
parcelHelpers.export(exports, "resolvefilter", ()=>ResolveFilter);
var _d3Array = require("d3-array");
var _vegaDataflow = require("vega-dataflow");
var _vegaUtil = require("vega-util");
const array8 = (n)=>new Uint8Array(n);
const array16 = (n)=>new Uint16Array(n);
const array32 = (n)=>new Uint32Array(n);
/**
 * Maintains CrossFilter state.
 */ function Bitmaps() {
    let width = 8, data = [], seen = array32(0), curr = array(0, width), prev = array(0, width);
    return {
        data: ()=>data,
        seen: ()=>seen = lengthen(seen, data.length),
        add (array) {
            for(let i = 0, j = data.length, n = array.length, t; i < n; ++i){
                t = array[i];
                t._index = j++;
                data.push(t);
            }
        },
        remove (num, map) {
            // map: index -> boolean (true => remove)
            const n = data.length, copy = Array(n - num), reindex = data; // reuse old data array for index map
            let t, i, j;
            // seek forward to first removal
            for(i = 0; !map[i] && i < n; ++i){
                copy[i] = data[i];
                reindex[i] = i;
            }
            // condense arrays
            for(j = i; i < n; ++i){
                t = data[i];
                if (!map[i]) {
                    reindex[i] = j;
                    curr[j] = curr[i];
                    prev[j] = prev[i];
                    copy[j] = t;
                    t._index = j++;
                } else reindex[i] = -1;
                curr[i] = 0; // clear unused bits
            }
            data = copy;
            return reindex;
        },
        size: ()=>data.length,
        curr: ()=>curr,
        prev: ()=>prev,
        reset: (k)=>prev[k] = curr[k],
        all: ()=>width < 0x101 ? 0xff : width < 0x10001 ? 0xffff : 0xffffffff,
        set (k, one) {
            curr[k] |= one;
        },
        clear (k, one) {
            curr[k] &= ~one;
        },
        resize (n, m) {
            const k = curr.length;
            if (n > k || m > width) {
                width = Math.max(m, width);
                curr = array(n, width, curr);
                prev = array(n, width);
            }
        }
    };
}
function lengthen(array, length, copy) {
    if (array.length >= length) return array;
    copy = copy || new array.constructor(length);
    copy.set(array);
    return copy;
}
function array(n, m, array) {
    const copy = (m < 0x101 ? array8 : m < 0x10001 ? array16 : array32)(n);
    if (array) copy.set(array);
    return copy;
}
function Dimension(index, i, query) {
    const bit = 1 << i;
    return {
        one: bit,
        zero: ~bit,
        range: query.slice(),
        bisect: index.bisect,
        index: index.index,
        size: index.size,
        onAdd (added, curr) {
            const dim = this, range = dim.bisect(dim.range, added.value), idx = added.index, lo = range[0], hi = range[1], n1 = idx.length;
            let i;
            for(i = 0; i < lo; ++i)curr[idx[i]] |= bit;
            for(i = hi; i < n1; ++i)curr[idx[i]] |= bit;
            return dim;
        }
    };
}
/**
 * Maintains a list of values, sorted by key.
 */ function SortedIndex() {
    let index = array32(0), value = [], size = 0;
    function insert(key, data, base) {
        if (!data.length) return [];
        const n0 = size, n1 = data.length, addi = array32(n1);
        let addv = Array(n1), oldv, oldi, i;
        for(i = 0; i < n1; ++i){
            addv[i] = key(data[i]);
            addi[i] = i;
        }
        addv = sort(addv, addi);
        if (n0) {
            oldv = value;
            oldi = index;
            value = Array(n0 + n1);
            index = array32(n0 + n1);
            merge(base, oldv, oldi, n0, addv, addi, n1, value, index);
        } else {
            if (base > 0) for(i = 0; i < n1; ++i)addi[i] += base;
            value = addv;
            index = addi;
        }
        size = n0 + n1;
        return {
            index: addi,
            value: addv
        };
    }
    function remove(num, map) {
        // map: index -> remove
        const n = size;
        let idx, i, j;
        // seek forward to first removal
        for(i = 0; !map[index[i]] && i < n; ++i);
        // condense index and value arrays
        for(j = i; i < n; ++i)if (!map[idx = index[i]]) {
            index[j] = idx;
            value[j] = value[i];
            ++j;
        }
        size = n - num;
    }
    function reindex(map) {
        for(let i = 0, n = size; i < n; ++i)index[i] = map[index[i]];
    }
    function bisect(range, array) {
        let n;
        if (array) n = array.length;
        else {
            array = value;
            n = size;
        }
        return [
            (0, _d3Array.bisectLeft)(array, range[0], 0, n),
            (0, _d3Array.bisectRight)(array, range[1], 0, n)
        ];
    }
    return {
        insert: insert,
        remove: remove,
        bisect: bisect,
        reindex: reindex,
        index: ()=>index,
        size: ()=>size
    };
}
function sort(values, index) {
    values.sort.call(index, (a, b)=>{
        const x = values[a], y = values[b];
        return x < y ? -1 : x > y ? 1 : 0;
    });
    return (0, _d3Array.permute)(values, index);
}
function merge(base, value0, index0, n0, value1, index1, n1, value, index) {
    let i0 = 0, i1 = 0, i;
    for(i = 0; i0 < n0 && i1 < n1; ++i)if (value0[i0] < value1[i1]) {
        value[i] = value0[i0];
        index[i] = index0[i0++];
    } else {
        value[i] = value1[i1];
        index[i] = index1[i1++] + base;
    }
    for(; i0 < n0; ++i0, ++i){
        value[i] = value0[i0];
        index[i] = index0[i0];
    }
    for(; i1 < n1; ++i1, ++i){
        value[i] = value1[i1];
        index[i] = index1[i1] + base;
    }
}
/**
 * An indexed multi-dimensional filter.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<function(object): *>} params.fields - An array of dimension accessors to filter.
 * @param {Array} params.query - An array of per-dimension range queries.
 */ function CrossFilter(params) {
    (0, _vegaDataflow.Transform).call(this, Bitmaps(), params);
    this._indices = null;
    this._dims = null;
}
CrossFilter.Definition = {
    'type': 'CrossFilter',
    'metadata': {},
    'params': [
        {
            'name': 'fields',
            'type': 'field',
            'array': true,
            'required': true
        },
        {
            'name': 'query',
            'type': 'array',
            'array': true,
            'required': true,
            'content': {
                'type': 'number',
                'array': true,
                'length': 2
            }
        }
    ]
};
(0, _vegaUtil.inherits)(CrossFilter, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (!this._dims) return this.init(_, pulse);
        else {
            var init = _.modified('fields') || _.fields.some((f)=>pulse.modified(f.fields));
            return init ? this.reinit(_, pulse) : this.eval(_, pulse);
        }
    },
    init (_, pulse) {
        const fields = _.fields, query = _.query, indices = this._indices = {}, dims = this._dims = [], m = query.length;
        let i = 0, key, index;
        // instantiate indices and dimensions
        for(; i < m; ++i){
            key = fields[i].fname;
            index = indices[key] || (indices[key] = SortedIndex());
            dims.push(Dimension(index, i, query[i]));
        }
        return this.eval(_, pulse);
    },
    reinit (_, pulse) {
        const output = pulse.materialize().fork(), fields = _.fields, query = _.query, indices = this._indices, dims = this._dims, bits = this.value, curr = bits.curr(), prev = bits.prev(), all = bits.all(), out = output.rem = output.add, mod = output.mod, m = query.length, adds = {};
        let add, index, key, mods, remMap, modMap, i, n, f;
        // set prev to current state
        prev.set(curr);
        // if pulse has remove tuples, process them first
        if (pulse.rem.length) remMap = this.remove(_, pulse, output);
        // if pulse has added tuples, add them to state
        if (pulse.add.length) bits.add(pulse.add);
        // if pulse has modified tuples, create an index map
        if (pulse.mod.length) {
            modMap = {};
            for(mods = pulse.mod, i = 0, n = mods.length; i < n; ++i)modMap[mods[i]._index] = 1;
        }
        // re-initialize indices as needed, update curr bitmap
        for(i = 0; i < m; ++i){
            f = fields[i];
            if (!dims[i] || _.modified('fields', i) || pulse.modified(f.fields)) {
                key = f.fname;
                if (!(add = adds[key])) {
                    indices[key] = index = SortedIndex();
                    adds[key] = add = index.insert(f, pulse.source, 0);
                }
                dims[i] = Dimension(index, i, query[i]).onAdd(add, curr);
            }
        }
        // visit each tuple
        // if filter state changed, push index to add/rem
        // else if in mod and passes a filter, push index to mod
        for(i = 0, n = bits.data().length; i < n; ++i){
            if (remMap[i]) continue;
            else if (prev[i] !== curr[i]) // add if state changed
            out.push(i);
            else if (modMap[i] && curr[i] !== all) // otherwise, pass mods through
            mod.push(i);
        }
        bits.mask = (1 << m) - 1;
        return output;
    },
    eval (_, pulse) {
        const output = pulse.materialize().fork(), m = this._dims.length;
        let mask = 0;
        if (pulse.rem.length) {
            this.remove(_, pulse, output);
            mask |= (1 << m) - 1;
        }
        if (_.modified('query') && !_.modified('fields')) mask |= this.update(_, pulse, output);
        if (pulse.add.length) {
            this.insert(_, pulse, output);
            mask |= (1 << m) - 1;
        }
        if (pulse.mod.length) {
            this.modify(pulse, output);
            mask |= (1 << m) - 1;
        }
        this.value.mask = mask;
        return output;
    },
    insert (_, pulse, output) {
        const tuples = pulse.add, bits = this.value, dims = this._dims, indices = this._indices, fields = _.fields, adds = {}, out = output.add, n = bits.size() + tuples.length, m = dims.length;
        let k = bits.size(), j, key, add;
        // resize bitmaps and add tuples as needed
        bits.resize(n, m);
        bits.add(tuples);
        const curr = bits.curr(), prev = bits.prev(), all = bits.all();
        // add to dimensional indices
        for(j = 0; j < m; ++j){
            key = fields[j].fname;
            add = adds[key] || (adds[key] = indices[key].insert(fields[j], tuples, k));
            dims[j].onAdd(add, curr);
        }
        // set previous filters, output if passes at least one filter
        for(; k < n; ++k){
            prev[k] = all;
            if (curr[k] !== all) out.push(k);
        }
    },
    modify (pulse, output) {
        const out = output.mod, bits = this.value, curr = bits.curr(), all = bits.all(), tuples = pulse.mod;
        let i, n, k;
        for(i = 0, n = tuples.length; i < n; ++i){
            k = tuples[i]._index;
            if (curr[k] !== all) out.push(k);
        }
    },
    remove (_, pulse, output) {
        const indices = this._indices, bits = this.value, curr = bits.curr(), prev = bits.prev(), all = bits.all(), map = {}, out = output.rem, tuples = pulse.rem;
        let i, n, k, f;
        // process tuples, output if passes at least one filter
        for(i = 0, n = tuples.length; i < n; ++i){
            k = tuples[i]._index;
            map[k] = 1; // build index map
            prev[k] = f = curr[k];
            curr[k] = all;
            if (f !== all) out.push(k);
        }
        // remove from dimensional indices
        for(k in indices)indices[k].remove(n, map);
        this.reindex(pulse, n, map);
        return map;
    },
    // reindex filters and indices after propagation completes
    reindex (pulse, num, map) {
        const indices = this._indices, bits = this.value;
        pulse.runAfter(()=>{
            const indexMap = bits.remove(num, map);
            for(const key in indices)indices[key].reindex(indexMap);
        });
    },
    update (_, pulse, output) {
        const dims = this._dims, query = _.query, stamp = pulse.stamp, m = dims.length;
        let mask = 0, i, q;
        // survey how many queries have changed
        output.filters = 0;
        for(q = 0; q < m; ++q)if (_.modified('query', q)) {
            i = q;
            ++mask;
        }
        if (mask === 1) {
            // only one query changed, use more efficient update
            mask = dims[i].one;
            this.incrementOne(dims[i], query[i], output.add, output.rem);
        } else // multiple queries changed, perform full record keeping
        for(q = 0, mask = 0; q < m; ++q){
            if (!_.modified('query', q)) continue;
            mask |= dims[q].one;
            this.incrementAll(dims[q], query[q], stamp, output.add);
            output.rem = output.add; // duplicate add/rem for downstream resolve
        }
        return mask;
    },
    incrementAll (dim, query, stamp, out) {
        const bits = this.value, seen = bits.seen(), curr = bits.curr(), prev = bits.prev(), index = dim.index(), old = dim.bisect(dim.range), range = dim.bisect(query), lo1 = range[0], hi1 = range[1], lo0 = old[0], hi0 = old[1], one = dim.one;
        let i, j, k;
        // Fast incremental update based on previous lo index.
        if (lo1 < lo0) for(i = lo1, j = Math.min(lo0, hi1); i < j; ++i){
            k = index[i];
            if (seen[k] !== stamp) {
                prev[k] = curr[k];
                seen[k] = stamp;
                out.push(k);
            }
            curr[k] ^= one;
        }
        else if (lo1 > lo0) for(i = lo0, j = Math.min(lo1, hi0); i < j; ++i){
            k = index[i];
            if (seen[k] !== stamp) {
                prev[k] = curr[k];
                seen[k] = stamp;
                out.push(k);
            }
            curr[k] ^= one;
        }
        // Fast incremental update based on previous hi index.
        if (hi1 > hi0) for(i = Math.max(lo1, hi0), j = hi1; i < j; ++i){
            k = index[i];
            if (seen[k] !== stamp) {
                prev[k] = curr[k];
                seen[k] = stamp;
                out.push(k);
            }
            curr[k] ^= one;
        }
        else if (hi1 < hi0) for(i = Math.max(lo0, hi1), j = hi0; i < j; ++i){
            k = index[i];
            if (seen[k] !== stamp) {
                prev[k] = curr[k];
                seen[k] = stamp;
                out.push(k);
            }
            curr[k] ^= one;
        }
        dim.range = query.slice();
    },
    incrementOne (dim, query, add, rem) {
        const bits = this.value, curr = bits.curr(), index = dim.index(), old = dim.bisect(dim.range), range = dim.bisect(query), lo1 = range[0], hi1 = range[1], lo0 = old[0], hi0 = old[1], one = dim.one;
        let i, j, k;
        // Fast incremental update based on previous lo index.
        if (lo1 < lo0) for(i = lo1, j = Math.min(lo0, hi1); i < j; ++i){
            k = index[i];
            curr[k] ^= one;
            add.push(k);
        }
        else if (lo1 > lo0) for(i = lo0, j = Math.min(lo1, hi0); i < j; ++i){
            k = index[i];
            curr[k] ^= one;
            rem.push(k);
        }
        // Fast incremental update based on previous hi index.
        if (hi1 > hi0) for(i = Math.max(lo1, hi0), j = hi1; i < j; ++i){
            k = index[i];
            curr[k] ^= one;
            add.push(k);
        }
        else if (hi1 < hi0) for(i = Math.max(lo0, hi1), j = hi0; i < j; ++i){
            k = index[i];
            curr[k] ^= one;
            rem.push(k);
        }
        dim.range = query.slice();
    }
});
/**
 * Selectively filters tuples by resolving against a filter bitmap.
 * Useful for processing the output of a cross-filter transform.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {object} params.ignore - A bit mask indicating which filters to ignore.
 * @param {object} params.filter - The per-tuple filter bitmaps. Typically this
 *   parameter value is a reference to a {@link CrossFilter} transform.
 */ function ResolveFilter(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
ResolveFilter.Definition = {
    'type': 'ResolveFilter',
    'metadata': {},
    'params': [
        {
            'name': 'ignore',
            'type': 'number',
            'required': true,
            'description': 'A bit mask indicating which filters to ignore.'
        },
        {
            'name': 'filter',
            'type': 'object',
            'required': true,
            'description': 'Per-tuple filter bitmaps from a CrossFilter transform.'
        }
    ]
};
(0, _vegaUtil.inherits)(ResolveFilter, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const ignore = ~(_.ignore || 0), // bit mask where zeros -> dims to ignore
        bitmap = _.filter, mask = bitmap.mask;
        // exit early if no relevant filter changes
        if ((mask & ignore) === 0) return pulse.StopPropagation;
        const output = pulse.fork(pulse.ALL), data = bitmap.data(), curr = bitmap.curr(), prev = bitmap.prev(), pass = (k)=>!(curr[k] & ignore) ? data[k] : null;
        // propagate all mod tuples that pass the filter
        output.filter(output.MOD, pass);
        // determine add & rem tuples via filter functions
        // for efficiency, we do *not* populate new arrays,
        // instead we add filter functions applied downstream
        if (!(mask & mask - 1)) {
            // only one filter changed
            output.filter(output.ADD, pass);
            output.filter(output.REM, (k)=>(curr[k] & ignore) === mask ? data[k] : null);
        } else {
            // multiple filters changed
            output.filter(output.ADD, (k)=>{
                const c = curr[k] & ignore, f = !c && c ^ prev[k] & ignore;
                return f ? data[k] : null;
            });
            output.filter(output.REM, (k)=>{
                const c = curr[k] & ignore, f = c && !(c ^ (c ^ prev[k] & ignore));
                return f ? data[k] : null;
            });
        }
        // add filter to source data in case of reflow...
        return output.filter(output.SOURCE, (t)=>pass(t._index));
    }
});

},{"d3-array":[["bisectLeft","8oF0X"],["bisectRight","8oF0X"],["permute","bvoXq","default"]],"vega-dataflow":"4An7U","vega-util":"7f6sQ","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"6aPCc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "View", ()=>View);
var _vegaUtil = require("vega-util");
var _vegaDataflow = require("vega-dataflow");
var _vegaScenegraph = require("vega-scenegraph");
var _d3Array = require("d3-array");
var _vegaFunctions = require("vega-functions");
var _vegaRuntime = require("vega-runtime");
var _d3Timer = require("d3-timer");
var _vegaFormat = require("vega-format");
// initialize aria role and label attributes
function initializeAria(view) {
    const el = view.container();
    if (el) {
        el.setAttribute('role', 'graphics-document');
        el.setAttribute('aria-roleDescription', 'visualization');
        ariaLabel(el, view.description());
    }
}
// update aria-label if we have a DOM container element
function ariaLabel(el, desc) {
    if (el) desc == null ? el.removeAttribute('aria-label') : el.setAttribute('aria-label', desc);
}
function background(view) {
    // respond to background signal
    view.add(null, (_)=>{
        view._background = _.bg;
        view._resize = 1;
        return _.bg;
    }, {
        bg: view._signals.background
    });
}
const Default = 'default';
function cursor(view) {
    // get cursor signal, add to dataflow if needed
    const cursor = view._signals.cursor || (view._signals.cursor = view.add({
        user: Default,
        item: null
    }));
    // evaluate cursor on each pointermove event
    view.on(view.events('view', 'pointermove'), cursor, (_, event)=>{
        const value = cursor.value, user = value ? (0, _vegaUtil.isString)(value) ? value : value.user : Default, item = event.item && event.item.cursor || null;
        return value && user === value.user && item == value.item ? value : {
            user: user,
            item: item
        };
    });
    // when cursor signal updates, set visible cursor
    view.add(null, function(_) {
        let user = _.cursor, item = this.value;
        if (!(0, _vegaUtil.isString)(user)) {
            item = user.item;
            user = user.user;
        }
        setCursor(view, user && user !== Default ? user : item || user);
        return item;
    }, {
        cursor: cursor
    });
}
function setCursor(view, cursor) {
    const el = view.globalCursor() ? typeof document !== 'undefined' && document.body : view.container();
    if (el) return cursor == null ? el.style.removeProperty('cursor') : el.style.cursor = cursor;
}
function dataref(view, name) {
    var data = view._runtime.data;
    if (!(0, _vegaUtil.hasOwnProperty)(data, name)) (0, _vegaUtil.error)('Unrecognized data set: ' + name);
    return data[name];
}
function data(name, values) {
    return arguments.length < 2 ? dataref(this, name).values.value : change.call(this, name, (0, _vegaDataflow.changeset)().remove((0, _vegaUtil.truthy)).insert(values));
}
function change(name, changes) {
    if (!(0, _vegaDataflow.isChangeSet)(changes)) (0, _vegaUtil.error)('Second argument to changes must be a changeset.');
    const dataset = dataref(this, name);
    dataset.modified = true;
    return this.pulse(dataset.input, changes);
}
function insert(name, _) {
    return change.call(this, name, (0, _vegaDataflow.changeset)().insert(_));
}
function remove(name, _) {
    return change.call(this, name, (0, _vegaDataflow.changeset)().remove(_));
}
function width(view) {
    var padding = view.padding();
    return Math.max(0, view._viewWidth + padding.left + padding.right);
}
function height(view) {
    var padding = view.padding();
    return Math.max(0, view._viewHeight + padding.top + padding.bottom);
}
function offset(view) {
    var padding = view.padding(), origin = view._origin;
    return [
        padding.left + origin[0],
        padding.top + origin[1]
    ];
}
function resizeRenderer(view) {
    var origin = offset(view), w = width(view), h = height(view);
    view._renderer.background(view.background());
    view._renderer.resize(w, h, origin);
    view._handler.origin(origin);
    view._resizeListeners.forEach((handler)=>{
        try {
            handler(w, h);
        } catch (error) {
            view.error(error);
        }
    });
}
/**
 * Extend an event with additional view-specific methods.
 * Adds a new property ('vega') to an event that provides a number
 * of methods for querying information about the current interaction.
 * The vega object provides the following methods:
 *   view - Returns the backing View instance.
 *   item - Returns the currently active scenegraph item (if any).
 *   group - Returns the currently active scenegraph group (if any).
 *     This method accepts a single string-typed argument indicating the name
 *     of the desired parent group. The scenegraph will be traversed from
 *     the item up towards the root to search for a matching group. If no
 *     argument is provided the enclosing group for the active item is
 *     returned, unless the item it itself a group, in which case it is
 *     returned directly.
 *   xy - Returns a two-element array containing the x and y coordinates for
 *     mouse or touch events. For touch events, this is based on the first
 *     elements in the changedTouches array. This method accepts a single
 *     argument: either an item instance or mark name that should serve as
 *     the reference coordinate system. If no argument is provided the
 *     top-level view coordinate system is assumed.
 *   x - Returns the current x-coordinate, accepts the same arguments as xy.
 *   y - Returns the current y-coordinate, accepts the same arguments as xy.
 * @param {Event} event - The input event to extend.
 * @param {Item} item - The currently active scenegraph item (if any).
 * @return {Event} - The extended input event.
 */ function eventExtend(view, event, item) {
    var r = view._renderer, el = r && r.canvas(), p, e, translate;
    if (el) {
        translate = offset(view);
        e = event.changedTouches ? event.changedTouches[0] : event;
        p = (0, _vegaScenegraph.point)(e, el);
        p[0] -= translate[0];
        p[1] -= translate[1];
    }
    event.dataflow = view;
    event.item = item;
    event.vega = extension(view, item, p);
    return event;
}
function extension(view, item, point) {
    const itemGroup = item ? item.mark.marktype === 'group' ? item : item.mark.group : null;
    function group(name) {
        var g = itemGroup, i;
        if (name) {
            for(i = item; i; i = i.mark.group)if (i.mark.name === name) {
                g = i;
                break;
            }
        }
        return g && g.mark && g.mark.interactive ? g : {};
    }
    function xy(item) {
        if (!item) return point;
        if ((0, _vegaUtil.isString)(item)) item = group(item);
        const p = point.slice();
        while(item){
            p[0] -= item.x || 0;
            p[1] -= item.y || 0;
            item = item.mark && item.mark.group;
        }
        return p;
    }
    return {
        view: (0, _vegaUtil.constant)(view),
        item: (0, _vegaUtil.constant)(item || {}),
        group: group,
        xy: xy,
        x: (item)=>xy(item)[0],
        y: (item)=>xy(item)[1]
    };
}
const VIEW = 'view', TIMER = 'timer', WINDOW = 'window', NO_TRAP = {
    trap: false
};
/**
 * Initialize event handling configuration.
 * @param {object} config - The configuration settings.
 * @return {object}
 */ function initializeEventConfig(config) {
    const events = (0, _vegaUtil.extend)({
        defaults: {}
    }, config);
    const unpack = (obj, keys)=>{
        keys.forEach((k)=>{
            if ((0, _vegaUtil.isArray)(obj[k])) obj[k] = (0, _vegaUtil.toSet)(obj[k]);
        });
    };
    unpack(events.defaults, [
        'prevent',
        'allow'
    ]);
    unpack(events, [
        'view',
        'window',
        'selector'
    ]);
    return events;
}
function trackEventListener(view, sources, type, handler) {
    view._eventListeners.push({
        type: type,
        sources: (0, _vegaUtil.array)(sources),
        handler: handler
    });
}
function prevent(view, type) {
    var def = view._eventConfig.defaults, prevent = def.prevent, allow = def.allow;
    return prevent === false || allow === true ? false : prevent === true || allow === false ? true : prevent ? prevent[type] : allow ? !allow[type] : view.preventDefault();
}
function permit(view, key, type) {
    const rule = view._eventConfig && view._eventConfig[key];
    if (rule === false || (0, _vegaUtil.isObject)(rule) && !rule[type]) {
        view.warn(`Blocked ${key} ${type} event listener.`);
        return false;
    }
    return true;
}
/**
 * Create a new event stream from an event source.
 * @param {object} source - The event source to monitor.
 * @param {string} type - The event type.
 * @param {function(object): boolean} [filter] - Event filter function.
 * @return {EventStream}
 */ function events(source, type, filter) {
    var view = this, s = new (0, _vegaDataflow.EventStream)(filter), send = function(e, item) {
        view.runAsync(null, ()=>{
            if (source === VIEW && prevent(view, type)) e.preventDefault();
            s.receive(eventExtend(view, e, item));
        });
    }, sources;
    if (source === TIMER) {
        if (permit(view, 'timer', type)) view.timer(send, type);
    } else if (source === VIEW) {
        if (permit(view, 'view', type)) // send traps errors, so use {trap: false} option
        view.addEventListener(type, send, NO_TRAP);
    } else {
        if (source === WINDOW) {
            if (permit(view, 'window', type) && typeof window !== 'undefined') sources = [
                window
            ];
        } else if (typeof document !== 'undefined') {
            if (permit(view, 'selector', type)) sources = Array.from(document.querySelectorAll(source));
        }
        if (!sources) view.warn('Can not resolve event source: ' + source);
        else {
            for(var i = 0, n = sources.length; i < n; ++i)sources[i].addEventListener(type, send);
            trackEventListener(view, sources, type, send);
        }
    }
    return s;
}
function itemFilter(event) {
    return event.item;
}
function markTarget(event) {
    // grab upstream collector feeding the mark operator
    return event.item.mark.source;
}
function invoke(name) {
    return function(_, event) {
        return event.vega.view().changeset().encode(event.item, name);
    };
}
function hover(hoverSet, leaveSet) {
    hoverSet = [
        hoverSet || 'hover'
    ];
    leaveSet = [
        leaveSet || 'update',
        hoverSet[0]
    ];
    // invoke hover set upon pointerover
    this.on(this.events('view', 'pointerover', itemFilter), markTarget, invoke(hoverSet));
    // invoke leave set upon pointerout
    this.on(this.events('view', 'pointerout', itemFilter), markTarget, invoke(leaveSet));
    return this;
}
/**
 * Finalize a View instance that is being removed.
 * Cancel any running timers.
 * Remove all external event listeners.
 * Remove any currently displayed tooltip.
 */ function finalize() {
    var tooltip = this._tooltip, timers = this._timers, handlers = this._handler.handlers(), listeners = this._eventListeners, n, m, e, h, t;
    n = timers.length;
    while(--n >= 0)timers[n].stop();
    n = listeners.length;
    while(--n >= 0){
        e = listeners[n];
        m = e.sources.length;
        while(--m >= 0)e.sources[m].removeEventListener(e.type, e.handler);
    }
    if (tooltip) tooltip.call(this, this._handler, null, null, null);
    // turn off all registered handlers
    n = handlers.length;
    while(--n >= 0){
        t = handlers[n].type;
        h = handlers[n].handler;
        this._handler.off(t, h);
    }
    return this;
}
function element(tag, attr, text) {
    const el = document.createElement(tag);
    for(const key in attr)el.setAttribute(key, attr[key]);
    if (text != null) el.textContent = text;
    return el;
}
const BindClass = 'vega-bind', NameClass = 'vega-bind-name', RadioClass = 'vega-bind-radio';
/**
 * Bind a signal to an external HTML input element. The resulting two-way
 * binding will propagate input changes to signals, and propagate signal
 * changes to the input element state. If this view instance has no parent
 * element, we assume the view is headless and no bindings are created.
 * @param {Element|string} el - The parent DOM element to which the input
 *   element should be appended as a child. If string-valued, this argument
 *   will be treated as a CSS selector. If null or undefined, the parent
 *   element of this view will be used as the element.
 * @param {object} param - The binding parameters which specify the signal
 *   to bind to, the input element type, and type-specific configuration.
 * @return {View} - This view instance.
 */ function bind(view, el, binding) {
    if (!el) return;
    const param = binding.param;
    let bind = binding.state;
    if (!bind) {
        bind = binding.state = {
            elements: null,
            active: false,
            set: null,
            update: (value)=>{
                if (value != view.signal(param.signal)) view.runAsync(null, ()=>{
                    bind.source = true;
                    view.signal(param.signal, value);
                });
            }
        };
        if (param.debounce) bind.update = (0, _vegaUtil.debounce)(param.debounce, bind.update);
    }
    const create = param.input == null && param.element ? target : generate;
    create(bind, el, param, view);
    if (!bind.active) {
        view.on(view._signals[param.signal], null, ()=>{
            bind.source ? bind.source = false : bind.set(view.signal(param.signal));
        });
        bind.active = true;
    }
    return bind;
}
/**
 * Bind the signal to an external EventTarget.
 */ function target(bind, node, param, view) {
    const type = param.event || 'input';
    const handler = ()=>bind.update(node.value);
    // initialize signal value to external input value
    view.signal(param.signal, node.value);
    // listen for changes on the element
    node.addEventListener(type, handler);
    // register with view, so we can remove it upon finalization
    trackEventListener(view, node, type, handler);
    // propagate change to element
    bind.set = (value)=>{
        node.value = value;
        node.dispatchEvent(event(type));
    };
}
function event(type) {
    return typeof Event !== 'undefined' ? new Event(type) : {
        type
    };
}
/**
 * Generate an HTML input form element and bind it to a signal.
 */ function generate(bind, el, param, view) {
    const value = view.signal(param.signal);
    const div = element('div', {
        'class': BindClass
    });
    const wrapper = param.input === 'radio' ? div : div.appendChild(element('label'));
    wrapper.appendChild(element('span', {
        'class': NameClass
    }, param.name || param.signal));
    el.appendChild(div);
    let input = form;
    switch(param.input){
        case 'checkbox':
            input = checkbox;
            break;
        case 'select':
            input = select;
            break;
        case 'radio':
            input = radio;
            break;
        case 'range':
            input = range;
            break;
    }
    input(bind, wrapper, param, value);
}
/**
 * Generates an arbitrary input form element.
 * The input type is controlled via user-provided parameters.
 */ function form(bind, el, param, value) {
    const node = element('input');
    for(const key in param)if (key !== 'signal' && key !== 'element') node.setAttribute(key === 'input' ? 'type' : key, param[key]);
    node.setAttribute('name', param.signal);
    node.value = value;
    el.appendChild(node);
    node.addEventListener('input', ()=>bind.update(node.value));
    bind.elements = [
        node
    ];
    bind.set = (value)=>node.value = value;
}
/**
 * Generates a checkbox input element.
 */ function checkbox(bind, el, param, value) {
    const attr = {
        type: 'checkbox',
        name: param.signal
    };
    if (value) attr.checked = true;
    const node = element('input', attr);
    el.appendChild(node);
    node.addEventListener('change', ()=>bind.update(node.checked));
    bind.elements = [
        node
    ];
    bind.set = (value)=>node.checked = !!value || null;
}
/**
 * Generates a selection list input element.
 */ function select(bind, el, param, value) {
    const node = element('select', {
        name: param.signal
    }), labels = param.labels || [];
    param.options.forEach((option, i)=>{
        const attr = {
            value: option
        };
        if (valuesEqual(option, value)) attr.selected = true;
        node.appendChild(element('option', attr, (labels[i] || option) + ''));
    });
    el.appendChild(node);
    node.addEventListener('change', ()=>{
        bind.update(param.options[node.selectedIndex]);
    });
    bind.elements = [
        node
    ];
    bind.set = (value)=>{
        for(let i = 0, n = param.options.length; i < n; ++i)if (valuesEqual(param.options[i], value)) {
            node.selectedIndex = i;
            return;
        }
    };
}
/**
 * Generates a radio button group.
 */ function radio(bind, el, param, value) {
    const group = element('span', {
        'class': RadioClass
    }), labels = param.labels || [];
    el.appendChild(group);
    bind.elements = param.options.map((option, i)=>{
        const attr = {
            type: 'radio',
            name: param.signal,
            value: option
        };
        if (valuesEqual(option, value)) attr.checked = true;
        const input = element('input', attr);
        input.addEventListener('change', ()=>bind.update(option));
        const label = element('label', {}, (labels[i] || option) + '');
        label.prepend(input);
        group.appendChild(label);
        return input;
    });
    bind.set = (value)=>{
        const nodes = bind.elements, n = nodes.length;
        for(let i = 0; i < n; ++i)if (valuesEqual(nodes[i].value, value)) nodes[i].checked = true;
    };
}
/**
 * Generates a slider input element.
 */ function range(bind, el, param, value) {
    value = value !== undefined ? value : (+param.max + +param.min) / 2;
    const max = param.max != null ? param.max : Math.max(100, +value) || 100, min = param.min || Math.min(0, max, +value) || 0, step = param.step || (0, _d3Array.tickStep)(min, max, 100);
    const node = element('input', {
        type: 'range',
        name: param.signal,
        min: min,
        max: max,
        step: step
    });
    node.value = value;
    const span = element('span', {}, +value);
    el.appendChild(node);
    el.appendChild(span);
    const update = ()=>{
        span.textContent = node.value;
        bind.update(+node.value);
    };
    // subscribe to both input and change
    node.addEventListener('input', update);
    node.addEventListener('change', update);
    bind.elements = [
        node
    ];
    bind.set = (value)=>{
        node.value = value;
        span.textContent = value;
    };
}
function valuesEqual(a, b) {
    return a === b || a + '' === b + '';
}
function initializeRenderer(view, r, el, constructor, scaleFactor, opt) {
    r = r || new constructor(view.loader());
    return r.initialize(el, width(view), height(view), offset(view), scaleFactor, opt).background(view.background());
}
function trap(view, fn) {
    return !fn ? null : function() {
        try {
            fn.apply(this, arguments);
        } catch (error) {
            view.error(error);
        }
    };
}
function initializeHandler(view, prevHandler, el, constructor) {
    // instantiate scenegraph handler
    const handler = new constructor(view.loader(), trap(view, view.tooltip())).scene(view.scenegraph().root).initialize(el, offset(view), view);
    // transfer event handlers
    if (prevHandler) prevHandler.handlers().forEach((h)=>{
        handler.on(h.type, h.handler);
    });
    return handler;
}
function initialize(el, elBind) {
    const view = this, type = view._renderType, config = view._eventConfig.bind, module = (0, _vegaScenegraph.renderModule)(type);
    // containing dom element
    el = view._el = el ? lookup(view, el, true) : null;
    // initialize aria attributes
    initializeAria(view);
    // select appropriate renderer & handler
    if (!module) view.error('Unrecognized renderer type: ' + type);
    const Handler = module.handler || (0, _vegaScenegraph.CanvasHandler), Renderer = el ? module.renderer : module.headless;
    // initialize renderer and input handler
    view._renderer = !Renderer ? null : initializeRenderer(view, view._renderer, el, Renderer);
    view._handler = initializeHandler(view, view._handler, el, Handler);
    view._redraw = true;
    // initialize signal bindings
    if (el && config !== 'none') {
        elBind = elBind ? view._elBind = lookup(view, elBind, true) : el.appendChild(element('form', {
            'class': 'vega-bindings'
        }));
        view._bind.forEach((_)=>{
            if (_.param.element && config !== 'container') _.element = lookup(view, _.param.element, !!_.param.input);
        });
        view._bind.forEach((_)=>{
            bind(view, _.element || elBind, _);
        });
    }
    return view;
}
function lookup(view, el, clear) {
    if (typeof el === 'string') {
        if (typeof document !== 'undefined') {
            el = document.querySelector(el);
            if (!el) {
                view.error('Signal bind element not found: ' + el);
                return null;
            }
        } else {
            view.error('DOM document instance not found.');
            return null;
        }
    }
    if (el && clear) try {
        el.textContent = '';
    } catch (e) {
        el = null;
        view.error(e);
    }
    return el;
}
const number = (_)=>+_ || 0;
const paddingObject = (_)=>({
        top: _,
        bottom: _,
        left: _,
        right: _
    });
function padding(_) {
    return (0, _vegaUtil.isObject)(_) ? {
        top: number(_.top),
        bottom: number(_.bottom),
        left: number(_.left),
        right: number(_.right)
    } : paddingObject(number(_));
}
/**
 * Render the current scene in a headless fashion.
 * This method is asynchronous, returning a Promise instance.
 * @return {Promise} - A Promise that resolves to a renderer.
 */ async function renderHeadless(view, type, scaleFactor, opt) {
    const module = (0, _vegaScenegraph.renderModule)(type), ctr = module && module.headless;
    if (!ctr) (0, _vegaUtil.error)('Unrecognized renderer type: ' + type);
    await view.runAsync();
    return initializeRenderer(view, null, null, ctr, scaleFactor, opt).renderAsync(view._scenegraph.root);
}
/**
 * Produce an image URL for the visualization. Depending on the type
 * parameter, the generated URL contains data for either a PNG or SVG image.
 * The URL can be used (for example) to download images of the visualization.
 * This method is asynchronous, returning a Promise instance.
 * @param {string} type - The image type. One of 'svg', 'png' or 'canvas'.
 *   The 'canvas' and 'png' types are synonyms for a PNG image.
 * @return {Promise} - A promise that resolves to an image URL.
 */ async function renderToImageURL(type, scaleFactor) {
    if (type !== (0, _vegaScenegraph.RenderType).Canvas && type !== (0, _vegaScenegraph.RenderType).SVG && type !== (0, _vegaScenegraph.RenderType).PNG) (0, _vegaUtil.error)('Unrecognized image type: ' + type);
    const r = await renderHeadless(this, type, scaleFactor);
    return type === (0, _vegaScenegraph.RenderType).SVG ? toBlobURL(r.svg(), 'image/svg+xml') : r.canvas().toDataURL('image/png');
}
function toBlobURL(data, mime) {
    const blob = new Blob([
        data
    ], {
        type: mime
    });
    return window.URL.createObjectURL(blob);
}
/**
 * Produce a Canvas instance containing a rendered visualization.
 * This method is asynchronous, returning a Promise instance.
 * @return {Promise} - A promise that resolves to a Canvas instance.
 */ async function renderToCanvas(scaleFactor, opt) {
    const r = await renderHeadless(this, (0, _vegaScenegraph.RenderType).Canvas, scaleFactor, opt);
    return r.canvas();
}
/**
 * Produce a rendered SVG string of the visualization.
 * This method is asynchronous, returning a Promise instance.
 * @return {Promise} - A promise that resolves to an SVG string.
 */ async function renderToSVG(scaleFactor) {
    const r = await renderHeadless(this, (0, _vegaScenegraph.RenderType).SVG, scaleFactor);
    return r.svg();
}
function runtime(view, spec, expr) {
    return (0, _vegaRuntime.context)(view, (0, _vegaDataflow.transforms), (0, _vegaFunctions.functionContext), expr).parse(spec);
}
function scale(name) {
    var scales = this._runtime.scales;
    if (!(0, _vegaUtil.hasOwnProperty)(scales, name)) (0, _vegaUtil.error)('Unrecognized scale or projection: ' + name);
    return scales[name].value;
}
var Width = 'width', Height = 'height', Padding = 'padding', Skip = {
    skip: true
};
function viewWidth(view, width) {
    var a = view.autosize(), p = view.padding();
    return width - (a && a.contains === Padding ? p.left + p.right : 0);
}
function viewHeight(view, height) {
    var a = view.autosize(), p = view.padding();
    return height - (a && a.contains === Padding ? p.top + p.bottom : 0);
}
function initializeResize(view) {
    var s = view._signals, w = s[Width], h = s[Height], p = s[Padding];
    function resetSize() {
        view._autosize = view._resize = 1;
    }
    // respond to width signal
    view._resizeWidth = view.add(null, (_)=>{
        view._width = _.size;
        view._viewWidth = viewWidth(view, _.size);
        resetSize();
    }, {
        size: w
    });
    // respond to height signal
    view._resizeHeight = view.add(null, (_)=>{
        view._height = _.size;
        view._viewHeight = viewHeight(view, _.size);
        resetSize();
    }, {
        size: h
    });
    // respond to padding signal
    const resizePadding = view.add(null, resetSize, {
        pad: p
    });
    // set rank to run immediately after source signal
    view._resizeWidth.rank = w.rank + 1;
    view._resizeHeight.rank = h.rank + 1;
    resizePadding.rank = p.rank + 1;
}
function resizeView(viewWidth, viewHeight, width, height, origin, auto) {
    this.runAfter((view)=>{
        let rerun = 0;
        // reset autosize flag
        view._autosize = 0;
        // width value changed: update signal, skip resize op
        if (view.width() !== width) {
            rerun = 1;
            view.signal(Width, width, Skip); // set width, skip update calc
            view._resizeWidth.skip(true); // skip width resize handler
        }
        // height value changed: update signal, skip resize op
        if (view.height() !== height) {
            rerun = 1;
            view.signal(Height, height, Skip); // set height, skip update calc
            view._resizeHeight.skip(true); // skip height resize handler
        }
        // view width changed: update view property, set resize flag
        if (view._viewWidth !== viewWidth) {
            view._resize = 1;
            view._viewWidth = viewWidth;
        }
        // view height changed: update view property, set resize flag
        if (view._viewHeight !== viewHeight) {
            view._resize = 1;
            view._viewHeight = viewHeight;
        }
        // origin changed: update view property, set resize flag
        if (view._origin[0] !== origin[0] || view._origin[1] !== origin[1]) {
            view._resize = 1;
            view._origin = origin;
        }
        // run dataflow on width/height signal change
        if (rerun) view.run('enter');
        if (auto) view.runAfter((v)=>v.resize());
    }, false, 1);
}
/**
 * Get the current view state, consisting of signal values and/or data sets.
 * @param {object} [options] - Options flags indicating which state to export.
 *   If unspecified, all signals and data sets will be exported.
 * @param {function(string, Operator):boolean} [options.signals] - Optional
 *   predicate function for testing if a signal should be included in the
 *   exported state. If unspecified, all signals will be included, except for
 *   those named 'parent' or those which refer to a Transform value.
 * @param {function(string, object):boolean} [options.data] - Optional
 *   predicate function for testing if a data set's input should be included
 *   in the exported state. If unspecified, all data sets that have been
 *   explicitly modified will be included.
 * @param {boolean} [options.recurse=true] - Flag indicating if the exported
 *   state should recursively include state from group mark sub-contexts.
 * @return {object} - An object containing the exported state values.
 */ function getState(options) {
    return this._runtime.getState(options || {
        data: dataTest,
        signals: signalTest,
        recurse: true
    });
}
function dataTest(name, data) {
    return data.modified && (0, _vegaUtil.isArray)(data.input.value) && !name.startsWith('_:vega:_');
}
function signalTest(name, op) {
    return !(name === 'parent' || op instanceof (0, _vegaDataflow.transforms).proxy);
}
/**
 * Sets the current view state and updates the view by invoking run.
 * @param {object} state - A state object containing signal and/or
 *   data set values, following the format used by the getState method.
 * @return {View} - This view instance.
 */ function setState(state) {
    this.runAsync(null, (v)=>{
        v._trigger = false;
        v._runtime.setState(state);
    }, (v)=>{
        v._trigger = true;
    });
    return this;
}
function timer(callback, delay) {
    function tick(elapsed) {
        callback({
            timestamp: Date.now(),
            elapsed: elapsed
        });
    }
    this._timers.push((0, _d3Timer.interval)(tick, delay));
}
function defaultTooltip(handler, event, item, value) {
    const el = handler.element();
    if (el) el.setAttribute('title', formatTooltip(value));
}
function formatTooltip(value) {
    return value == null ? '' : (0, _vegaUtil.isArray)(value) ? formatArray(value) : (0, _vegaUtil.isObject)(value) && !(0, _vegaUtil.isDate)(value) ? formatObject(value) : value + '';
}
function formatObject(obj) {
    return Object.keys(obj).map((key)=>{
        const v = obj[key];
        return key + ': ' + ((0, _vegaUtil.isArray)(v) ? formatArray(v) : formatValue(v));
    }).join('\n');
}
function formatArray(value) {
    return '[' + value.map(formatValue).join(', ') + ']';
}
function formatValue(value) {
    return (0, _vegaUtil.isArray)(value) ? '[\u2026]' : (0, _vegaUtil.isObject)(value) && !(0, _vegaUtil.isDate)(value) ? '{\u2026}' : value;
}
function watchPixelRatio() {
    // based on https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio#monitoring_screen_resolution_or_zoom_level_changes
    if (this.renderer() === 'canvas' && this._renderer._canvas) {
        let remove = null;
        const updatePixelRatio = ()=>{
            if (remove != null) remove();
            const media = matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`);
            media.addEventListener('change', updatePixelRatio);
            remove = ()=>{
                media.removeEventListener('change', updatePixelRatio);
            };
            this._renderer._canvas.getContext('2d').pixelRatio = window.devicePixelRatio || 1;
            this._redraw = true;
            this._resize = 1;
            this.resize().runAsync();
        };
        updatePixelRatio();
    }
}
/**
 * Create a new View instance from a Vega dataflow runtime specification.
 * The generated View will not immediately be ready for display. Callers
 * should also invoke the initialize method (e.g., to set the parent
 * DOM element in browser-based deployment) and then invoke the run
 * method to evaluate the dataflow graph. Rendering will automatically
 * be performed upon dataflow runs.
 * @constructor
 * @param {object} spec - The Vega dataflow runtime specification.
 */ function View(spec, options) {
    const view = this;
    options = options || {};
    (0, _vegaDataflow.Dataflow).call(view);
    if (options.loader) view.loader(options.loader);
    if (options.logger) view.logger(options.logger);
    if (options.logLevel != null) view.logLevel(options.logLevel);
    if (options.locale || spec.locale) {
        const loc = (0, _vegaUtil.extend)({}, spec.locale, options.locale);
        view.locale((0, _vegaFormat.locale)(loc.number, loc.time));
    }
    view._el = null;
    view._elBind = null;
    view._renderType = options.renderer || (0, _vegaScenegraph.RenderType).Canvas;
    view._scenegraph = new (0, _vegaScenegraph.Scenegraph)();
    const root = view._scenegraph.root;
    // initialize renderer, handler and event management
    view._renderer = null;
    view._tooltip = options.tooltip || defaultTooltip, view._redraw = true;
    view._handler = new (0, _vegaScenegraph.CanvasHandler)().scene(root);
    view._globalCursor = false;
    view._preventDefault = false;
    view._timers = [];
    view._eventListeners = [];
    view._resizeListeners = [];
    // initialize event configuration
    view._eventConfig = initializeEventConfig(spec.eventConfig);
    view.globalCursor(view._eventConfig.globalCursor);
    // initialize dataflow graph
    const ctx = runtime(view, spec, options.expr);
    view._runtime = ctx;
    view._signals = ctx.signals;
    view._bind = (spec.bindings || []).map((_)=>({
            state: null,
            param: (0, _vegaUtil.extend)({}, _)
        }));
    // initialize scenegraph
    if (ctx.root) ctx.root.set(root);
    root.source = ctx.data.root.input;
    view.pulse(ctx.data.root.input, view.changeset().insert(root.items));
    // initialize view size
    view._width = view.width();
    view._height = view.height();
    view._viewWidth = viewWidth(view, view._width);
    view._viewHeight = viewHeight(view, view._height);
    view._origin = [
        0,
        0
    ];
    view._resize = 0;
    view._autosize = 1;
    initializeResize(view);
    // initialize background color
    background(view);
    // initialize cursor
    cursor(view);
    // initialize view description
    view.description(spec.description);
    // initialize hover proessing, if requested
    if (options.hover) view.hover();
    // initialize DOM container(s) and renderer
    if (options.container) view.initialize(options.container, options.bind);
    if (options.watchPixelRatio) view._watchPixelRatio();
}
function lookupSignal(view, name) {
    return (0, _vegaUtil.hasOwnProperty)(view._signals, name) ? view._signals[name] : (0, _vegaUtil.error)('Unrecognized signal name: ' + (0, _vegaUtil.stringValue)(name));
}
function findOperatorHandler(op, handler) {
    const h = (op._targets || []).filter((op)=>op._update && op._update.handler === handler);
    return h.length ? h[0] : null;
}
function addOperatorListener(view, name, op, handler) {
    let h = findOperatorHandler(op, handler);
    if (!h) {
        h = trap(view, ()=>handler(name, op.value));
        h.handler = handler;
        view.on(op, null, h);
    }
    return view;
}
function removeOperatorListener(view, op, handler) {
    const h = findOperatorHandler(op, handler);
    if (h) op._targets.remove(h);
    return view;
}
(0, _vegaUtil.inherits)(View, (0, _vegaDataflow.Dataflow), {
    // -- DATAFLOW / RENDERING ----
    async evaluate (encode, prerun, postrun) {
        // evaluate dataflow and prerun
        await (0, _vegaDataflow.Dataflow).prototype.evaluate.call(this, encode, prerun);
        // render as needed
        if (this._redraw || this._resize) try {
            if (this._renderer) {
                if (this._resize) {
                    this._resize = 0;
                    resizeRenderer(this);
                }
                await this._renderer.renderAsync(this._scenegraph.root);
            }
            this._redraw = false;
        } catch (e) {
            this.error(e);
        }
        // evaluate postrun
        if (postrun) (0, _vegaDataflow.asyncCallback)(this, postrun);
        return this;
    },
    dirty (item) {
        this._redraw = true;
        this._renderer && this._renderer.dirty(item);
    },
    // -- GET / SET ----
    description (text) {
        if (arguments.length) {
            const desc = text != null ? text + '' : null;
            if (desc !== this._desc) ariaLabel(this._el, this._desc = desc);
            return this;
        }
        return this._desc;
    },
    container () {
        return this._el;
    },
    scenegraph () {
        return this._scenegraph;
    },
    origin () {
        return this._origin.slice();
    },
    signal (name, value, options) {
        const op = lookupSignal(this, name);
        return arguments.length === 1 ? op.value : this.update(op, value, options);
    },
    width (_) {
        return arguments.length ? this.signal('width', _) : this.signal('width');
    },
    height (_) {
        return arguments.length ? this.signal('height', _) : this.signal('height');
    },
    padding (_) {
        return arguments.length ? this.signal('padding', padding(_)) : padding(this.signal('padding'));
    },
    autosize (_) {
        return arguments.length ? this.signal('autosize', _) : this.signal('autosize');
    },
    background (_) {
        return arguments.length ? this.signal('background', _) : this.signal('background');
    },
    renderer (type) {
        if (!arguments.length) return this._renderType;
        if (!(0, _vegaScenegraph.renderModule)(type)) (0, _vegaUtil.error)('Unrecognized renderer type: ' + type);
        if (type !== this._renderType) {
            this._renderType = type;
            this._resetRenderer();
        }
        return this;
    },
    tooltip (handler) {
        if (!arguments.length) return this._tooltip;
        if (handler !== this._tooltip) {
            this._tooltip = handler;
            this._resetRenderer();
        }
        return this;
    },
    loader (loader) {
        if (!arguments.length) return this._loader;
        if (loader !== this._loader) {
            (0, _vegaDataflow.Dataflow).prototype.loader.call(this, loader);
            this._resetRenderer();
        }
        return this;
    },
    resize () {
        // set flag to perform autosize
        this._autosize = 1;
        // touch autosize signal to ensure top-level ViewLayout runs
        return this.touch(lookupSignal(this, 'autosize'));
    },
    _resetRenderer () {
        if (this._renderer) {
            this._renderer = null;
            this.initialize(this._el, this._elBind);
        }
    },
    // -- SIZING ----
    _resizeView: resizeView,
    // -- EVENT HANDLING ----
    addEventListener (type, handler, options) {
        let callback = handler;
        if (!(options && options.trap === false)) {
            // wrap callback in error handler
            callback = trap(this, handler);
            callback.raw = handler;
        }
        this._handler.on(type, callback);
        return this;
    },
    removeEventListener (type, handler) {
        var handlers = this._handler.handlers(type), i = handlers.length, h, t;
        // search registered handlers, remove if match found
        while(--i >= 0){
            t = handlers[i].type;
            h = handlers[i].handler;
            if (type === t && (handler === h || handler === h.raw)) {
                this._handler.off(t, h);
                break;
            }
        }
        return this;
    },
    addResizeListener (handler) {
        const l = this._resizeListeners;
        if (!l.includes(handler)) // add handler if it isn't already registered
        // note: error trapping handled elsewhere, so
        // no need to wrap handlers here
        l.push(handler);
        return this;
    },
    removeResizeListener (handler) {
        var l = this._resizeListeners, i = l.indexOf(handler);
        if (i >= 0) l.splice(i, 1);
        return this;
    },
    addSignalListener (name, handler) {
        return addOperatorListener(this, name, lookupSignal(this, name), handler);
    },
    removeSignalListener (name, handler) {
        return removeOperatorListener(this, lookupSignal(this, name), handler);
    },
    addDataListener (name, handler) {
        return addOperatorListener(this, name, dataref(this, name).values, handler);
    },
    removeDataListener (name, handler) {
        return removeOperatorListener(this, dataref(this, name).values, handler);
    },
    globalCursor (_) {
        if (arguments.length) {
            if (this._globalCursor !== !!_) {
                const prev = setCursor(this, null); // clear previous cursor
                this._globalCursor = !!_;
                if (prev) setCursor(this, prev); // swap cursor
            }
            return this;
        } else return this._globalCursor;
    },
    preventDefault (_) {
        if (arguments.length) {
            this._preventDefault = _;
            return this;
        } else return this._preventDefault;
    },
    timer,
    events,
    finalize,
    hover,
    // -- DATA ----
    data,
    change,
    insert,
    remove,
    // -- SCALES --
    scale,
    // -- INITIALIZATION ----
    initialize,
    // -- HEADLESS RENDERING ----
    toImageURL: renderToImageURL,
    toCanvas: renderToCanvas,
    toSVG: renderToSVG,
    // -- SAVE / RESTORE STATE ----
    getState,
    setState,
    // RE-RENDER ON ZOOM
    _watchPixelRatio: watchPixelRatio
});

},{"vega-util":"7f6sQ","vega-dataflow":"4An7U","vega-scenegraph":"823vy","d3-array":"4kdy4","vega-functions":"8ACB6","vega-runtime":"hNLpK","d3-timer":[["interval","5mHvd","default"]],"vega-format":"kHjpR","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8ACB6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataPrefix", ()=>DataPrefix);
parcelHelpers.export(exports, "IndexPrefix", ()=>IndexPrefix);
parcelHelpers.export(exports, "ScalePrefix", ()=>ScalePrefix);
parcelHelpers.export(exports, "SignalPrefix", ()=>SignalPrefix);
parcelHelpers.export(exports, "bandspace", ()=>bandspace);
parcelHelpers.export(exports, "bandwidth", ()=>bandwidth);
parcelHelpers.export(exports, "codeGenerator", ()=>codeGenerator);
parcelHelpers.export(exports, "codegenParams", ()=>codegenParams);
parcelHelpers.export(exports, "containerSize", ()=>containerSize);
parcelHelpers.export(exports, "contrast", ()=>contrast);
parcelHelpers.export(exports, "copy", ()=>copy);
parcelHelpers.export(exports, "data", ()=>data);
parcelHelpers.export(exports, "dataVisitor", ()=>dataVisitor);
parcelHelpers.export(exports, "dayAbbrevFormat", ()=>dayAbbrevFormat);
parcelHelpers.export(exports, "dayFormat", ()=>dayFormat);
parcelHelpers.export(exports, "debug", ()=>debug);
parcelHelpers.export(exports, "domain", ()=>domain);
parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "expressionFunction", ()=>expressionFunction);
parcelHelpers.export(exports, "format", ()=>format);
parcelHelpers.export(exports, "functionContext", ()=>functionContext);
parcelHelpers.export(exports, "geoArea", ()=>geoArea);
parcelHelpers.export(exports, "geoBounds", ()=>geoBounds);
parcelHelpers.export(exports, "geoCentroid", ()=>geoCentroid);
parcelHelpers.export(exports, "geoScale", ()=>geoScale);
parcelHelpers.export(exports, "geoShape", ()=>geoShape);
parcelHelpers.export(exports, "inScope", ()=>inScope);
parcelHelpers.export(exports, "indata", ()=>indata);
parcelHelpers.export(exports, "indataVisitor", ()=>indataVisitor);
parcelHelpers.export(exports, "indexof", ()=>indexof);
parcelHelpers.export(exports, "info", ()=>info);
parcelHelpers.export(exports, "invert", ()=>invert);
parcelHelpers.export(exports, "join", ()=>join);
parcelHelpers.export(exports, "lastindexof", ()=>lastindexof);
parcelHelpers.export(exports, "luminance", ()=>luminance);
parcelHelpers.export(exports, "merge", ()=>merge);
parcelHelpers.export(exports, "modify", ()=>modify);
parcelHelpers.export(exports, "monthAbbrevFormat", ()=>monthAbbrevFormat);
parcelHelpers.export(exports, "monthFormat", ()=>monthFormat);
parcelHelpers.export(exports, "parseExpression", ()=>parser);
parcelHelpers.export(exports, "pathShape", ()=>pathShape);
parcelHelpers.export(exports, "pinchAngle", ()=>pinchAngle);
parcelHelpers.export(exports, "pinchDistance", ()=>pinchDistance);
parcelHelpers.export(exports, "pluck", ()=>pluck);
parcelHelpers.export(exports, "range", ()=>range);
parcelHelpers.export(exports, "replace", ()=>replace);
parcelHelpers.export(exports, "reverse", ()=>reverse);
parcelHelpers.export(exports, "scale", ()=>scale);
parcelHelpers.export(exports, "scaleGradient", ()=>scaleGradient);
parcelHelpers.export(exports, "scaleVisitor", ()=>scaleVisitor);
parcelHelpers.export(exports, "screen", ()=>screen);
parcelHelpers.export(exports, "setdata", ()=>setdata);
parcelHelpers.export(exports, "slice", ()=>slice);
parcelHelpers.export(exports, "sort", ()=>sort);
parcelHelpers.export(exports, "timeFormat", ()=>timeFormat);
parcelHelpers.export(exports, "timeParse", ()=>timeParse);
parcelHelpers.export(exports, "treeAncestors", ()=>treeAncestors);
parcelHelpers.export(exports, "treePath", ()=>treePath);
parcelHelpers.export(exports, "utcFormat", ()=>utcFormat);
parcelHelpers.export(exports, "utcParse", ()=>utcParse);
parcelHelpers.export(exports, "warn", ()=>warn);
parcelHelpers.export(exports, "windowSize", ()=>windowSize);
var _vegaUtil = require("vega-util");
var _vegaExpression = require("vega-expression");
var _vegaScale = require("vega-scale");
var _d3Geo = require("d3-geo");
var _d3Color = require("d3-color");
var _vegaDataflow = require("vega-dataflow");
var _vegaScenegraph = require("vega-scenegraph");
var _vegaSelections = require("vega-selections");
var _vegaStatistics = require("vega-statistics");
var _vegaTime = require("vega-time");
var _d3Array = require("d3-array");
function data(name) {
    const data = this.context.data[name];
    return data ? data.values.value : [];
}
function indata(name, field, value) {
    const index = this.context.data[name]['index:' + field], entry = index ? index.value.get(value) : undefined;
    return entry ? entry.count : entry;
}
function setdata(name, tuples) {
    const df = this.context.dataflow, data = this.context.data[name], input = data.input;
    df.pulse(input, df.changeset().remove((0, _vegaUtil.truthy)).insert(tuples));
    return 1;
}
function encode(item, name, retval) {
    if (item) {
        const df = this.context.dataflow, target = item.mark.source;
        df.pulse(target, df.changeset().encode(item, name));
    }
    return retval !== undefined ? retval : item;
}
const wrap = (method)=>function(value, spec) {
        const locale = this.context.dataflow.locale();
        return value === null ? 'null' : locale[method](spec)(value);
    };
const format = wrap('format');
const timeFormat = wrap('timeFormat');
const utcFormat = wrap('utcFormat');
const timeParse = wrap('timeParse');
const utcParse = wrap('utcParse');
const dateObj = new Date(2000, 0, 1);
function time(month, day, specifier) {
    if (!Number.isInteger(month) || !Number.isInteger(day)) return '';
    dateObj.setYear(2000);
    dateObj.setMonth(month);
    dateObj.setDate(day);
    return timeFormat.call(this, dateObj, specifier);
}
function monthFormat(month) {
    return time.call(this, month, 1, '%B');
}
function monthAbbrevFormat(month) {
    return time.call(this, month, 1, '%b');
}
function dayFormat(day) {
    return time.call(this, 0, 2 + day, '%A');
}
function dayAbbrevFormat(day) {
    return time.call(this, 0, 2 + day, '%a');
}
const DataPrefix = ':';
const IndexPrefix = '@';
const ScalePrefix = '%';
const SignalPrefix = '$';
function dataVisitor(name, args, scope, params) {
    if (args[0].type !== (0, _vegaExpression.Literal)) (0, _vegaUtil.error)('First argument to data functions must be a string literal.');
    const data = args[0].value, dataName = DataPrefix + data;
    if (!(0, _vegaUtil.hasOwnProperty)(dataName, params)) try {
        params[dataName] = scope.getData(data).tuplesRef();
    } catch (err) {
    // if data set does not exist, there's nothing to track
    }
}
function indataVisitor(name, args, scope, params) {
    if (args[0].type !== (0, _vegaExpression.Literal)) (0, _vegaUtil.error)('First argument to indata must be a string literal.');
    if (args[1].type !== (0, _vegaExpression.Literal)) (0, _vegaUtil.error)('Second argument to indata must be a string literal.');
    const data = args[0].value, field = args[1].value, indexName = IndexPrefix + field;
    if (!(0, _vegaUtil.hasOwnProperty)(indexName, params)) params[indexName] = scope.getData(data).indataRef(scope, field);
}
function scaleVisitor(name, args, scope, params) {
    if (args[0].type === (0, _vegaExpression.Literal)) // add scale dependency
    addScaleDependency(scope, params, args[0].value);
    else // indirect scale lookup; add all scales as parameters
    for(name in scope.scales)addScaleDependency(scope, params, name);
}
function addScaleDependency(scope, params, name) {
    const scaleName = ScalePrefix + name;
    if (!(0, _vegaUtil.hasOwnProperty)(params, scaleName)) try {
        params[scaleName] = scope.scaleRef(name);
    } catch (err) {
    // TODO: error handling? warning?
    }
}
/**
 * nameOrFunction must be a string or function that was registered.
 * Return undefined if scale is not recognized.
 */ function getScale(nameOrFunction, ctx) {
    if ((0, _vegaUtil.isString)(nameOrFunction)) {
        const maybeScale = ctx.scales[nameOrFunction];
        return maybeScale && (0, _vegaScale.isRegisteredScale)(maybeScale.value) ? maybeScale.value : undefined;
    } else if ((0, _vegaUtil.isFunction)(nameOrFunction)) return (0, _vegaScale.isRegisteredScale)(nameOrFunction) ? nameOrFunction : undefined;
    return undefined;
}
function internalScaleFunctions(codegen, fnctx, visitors) {
    // add helper method to the 'this' expression function context
    fnctx.__bandwidth = (s)=>s && s.bandwidth ? s.bandwidth() : 0;
    // register AST visitors for internal scale functions
    visitors._bandwidth = scaleVisitor;
    visitors._range = scaleVisitor;
    visitors._scale = scaleVisitor;
    // resolve scale reference directly to the signal hash argument
    const ref = (arg)=>'_[' + (arg.type === (0, _vegaExpression.Literal) ? (0, _vegaUtil.stringValue)(ScalePrefix + arg.value) : (0, _vegaUtil.stringValue)(ScalePrefix) + '+' + codegen(arg)) + ']';
    // define and return internal scale function code generators
    // these internal functions are called by mark encoders
    return {
        _bandwidth: (args)=>`this.__bandwidth(${ref(args[0])})`,
        _range: (args)=>`${ref(args[0])}.range()`,
        _scale: (args)=>`${ref(args[0])}(${codegen(args[1])})`
    };
}
function geoMethod(methodName, globalMethod) {
    return function(projection, geojson, group) {
        if (projection) {
            // projection defined, use it
            const p = getScale(projection, (group || this).context);
            return p && p.path[methodName](geojson);
        } else // projection undefined, use global method
        return globalMethod(geojson);
    };
}
const geoArea = geoMethod('area', (0, _d3Geo.geoArea));
const geoBounds = geoMethod('bounds', (0, _d3Geo.geoBounds));
const geoCentroid = geoMethod('centroid', (0, _d3Geo.geoCentroid));
function geoScale(projection, group) {
    const p = getScale(projection, (group || this).context);
    return p && p.scale();
}
function inScope(item) {
    const group = this.context.group;
    let value = false;
    if (group) while(item){
        if (item === group) {
            value = true;
            break;
        }
        item = item.mark.group;
    }
    return value;
}
function log(df, method, args) {
    try {
        df[method].apply(df, [
            'EXPRESSION'
        ].concat([].slice.call(args)));
    } catch (err) {
        df.warn(err);
    }
    return args[args.length - 1];
}
function warn() {
    return log(this.context.dataflow, 'warn', arguments);
}
function info() {
    return log(this.context.dataflow, 'info', arguments);
}
function debug() {
    return log(this.context.dataflow, 'debug', arguments);
}
// https://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
function channel_luminance_value(channelValue) {
    const val = channelValue / 255;
    if (val <= 0.03928) return val / 12.92;
    return Math.pow((val + 0.055) / 1.055, 2.4);
}
function luminance(color) {
    const c = (0, _d3Color.rgb)(color), r = channel_luminance_value(c.r), g = channel_luminance_value(c.g), b = channel_luminance_value(c.b);
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
// https://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
function contrast(color1, color2) {
    const lum1 = luminance(color1), lum2 = luminance(color2), lumL = Math.max(lum1, lum2), lumD = Math.min(lum1, lum2);
    return (lumL + 0.05) / (lumD + 0.05);
}
function merge() {
    const args = [].slice.call(arguments);
    args.unshift({});
    return (0, _vegaUtil.extend)(...args);
}
function equal(a, b) {
    return a === b || a !== a && b !== b ? true : (0, _vegaUtil.isArray)(a) ? (0, _vegaUtil.isArray)(b) && a.length === b.length ? equalArray(a, b) : false : (0, _vegaUtil.isObject)(a) && (0, _vegaUtil.isObject)(b) ? equalObject(a, b) : false;
}
function equalArray(a, b) {
    for(let i = 0, n = a.length; i < n; ++i){
        if (!equal(a[i], b[i])) return false;
    }
    return true;
}
function equalObject(a, b) {
    for(const key in a){
        if (!equal(a[key], b[key])) return false;
    }
    return true;
}
function removePredicate(props) {
    return (_)=>equalObject(props, _);
}
function modify(name, insert, remove, toggle, modify, values) {
    const df = this.context.dataflow, data = this.context.data[name], input = data.input, stamp = df.stamp();
    let changes = data.changes, predicate, key;
    if (df._trigger === false || !(input.value.length || insert || toggle)) // nothing to do!
    return 0;
    if (!changes || changes.stamp < stamp) {
        data.changes = changes = df.changeset();
        changes.stamp = stamp;
        df.runAfter(()=>{
            data.modified = true;
            df.pulse(input, changes).run();
        }, true, 1);
    }
    if (remove) {
        predicate = remove === true ? (0, _vegaUtil.truthy) : (0, _vegaUtil.isArray)(remove) || (0, _vegaDataflow.isTuple)(remove) ? remove : removePredicate(remove);
        changes.remove(predicate);
    }
    if (insert) changes.insert(insert);
    if (toggle) {
        predicate = removePredicate(toggle);
        if (input.value.some(predicate)) changes.remove(predicate);
        else changes.insert(toggle);
    }
    if (modify) for(key in values)changes.modify(modify, key, values[key]);
    return 1;
}
function pinchDistance(event) {
    const t = event.touches, dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY;
    return Math.hypot(dx, dy);
}
function pinchAngle(event) {
    const t = event.touches;
    return Math.atan2(t[0].clientY - t[1].clientY, t[0].clientX - t[1].clientX);
}
// memoize accessor functions
const accessors = {};
function pluck(data, name) {
    const accessor = accessors[name] || (accessors[name] = (0, _vegaUtil.field)(name));
    return (0, _vegaUtil.isArray)(data) ? data.map(accessor) : accessor(data);
}
function array(seq) {
    return (0, _vegaUtil.isArray)(seq) || ArrayBuffer.isView(seq) ? seq : null;
}
function sequence(seq) {
    return array(seq) || ((0, _vegaUtil.isString)(seq) ? seq : null);
}
function join(seq) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    return array(seq).join(...args);
}
function indexof(seq) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    return sequence(seq).indexOf(...args);
}
function lastindexof(seq) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return sequence(seq).lastIndexOf(...args);
}
function slice(seq) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    return sequence(seq).slice(...args);
}
function replace(str, pattern, repl) {
    if ((0, _vegaUtil.isFunction)(repl)) (0, _vegaUtil.error)('Function argument passed to replace.');
    if (!(0, _vegaUtil.isString)(pattern) && !(0, _vegaUtil.isRegExp)(pattern)) (0, _vegaUtil.error)('Please pass a string or RegExp argument to replace.');
    return String(str).replace(pattern, repl);
}
function reverse(seq) {
    return array(seq).slice().reverse();
}
function sort(seq) {
    return array(seq).slice().sort((0, _vegaUtil.ascending));
}
function bandspace(count, paddingInner, paddingOuter) {
    return (0, _vegaScale.bandSpace)(count || 0, paddingInner || 0, paddingOuter || 0);
}
function bandwidth(name, group) {
    const s = getScale(name, (group || this).context);
    return s && s.bandwidth ? s.bandwidth() : 0;
}
function copy(name, group) {
    const s = getScale(name, (group || this).context);
    return s ? s.copy() : undefined;
}
function domain(name, group) {
    const s = getScale(name, (group || this).context);
    return s ? s.domain() : [];
}
function invert(name, range, group) {
    const s = getScale(name, (group || this).context);
    return !s ? undefined : (0, _vegaUtil.isArray)(range) ? (s.invertRange || s.invert)(range) : (s.invert || s.invertExtent)(range);
}
function range(name, group) {
    const s = getScale(name, (group || this).context);
    return s && s.range ? s.range() : [];
}
function scale(name, value, group) {
    const s = getScale(name, (group || this).context);
    return s ? s(value) : undefined;
}
function scaleGradient(scale, p0, p1, count, group) {
    scale = getScale(scale, (group || this).context);
    const gradient = (0, _vegaScenegraph.Gradient)(p0, p1);
    let stops = scale.domain(), min = stops[0], max = (0, _vegaUtil.peek)(stops), fraction = (0, _vegaUtil.identity);
    if (!(max - min)) // expand scale if domain has zero span, fix #1479
    scale = (scale.interpolator ? (0, _vegaScale.scale)('sequential')().interpolator(scale.interpolator()) : (0, _vegaScale.scale)('linear')().interpolate(scale.interpolate()).range(scale.range())).domain([
        min = 0,
        max = 1
    ]);
    else fraction = (0, _vegaScale.scaleFraction)(scale, min, max);
    if (scale.ticks) {
        stops = scale.ticks(+count || 15);
        if (min !== stops[0]) stops.unshift(min);
        if (max !== (0, _vegaUtil.peek)(stops)) stops.push(max);
    }
    stops.forEach((_)=>gradient.stop(fraction(_), scale(_)));
    return gradient;
}
function geoShape(projection, geojson, group) {
    const p = getScale(projection, (group || this).context);
    return function(context) {
        return p ? p.path.context(context)(geojson) : '';
    };
}
function pathShape(path) {
    let p = null;
    return function(context) {
        return context ? (0, _vegaScenegraph.pathRender)(context, p = p || (0, _vegaScenegraph.pathParse)(path)) : path;
    };
}
const datum = (d)=>d.data;
function treeNodes(name, context) {
    const tree = data.call(context, name);
    return tree.root && tree.root.lookup || {};
}
function treePath(name, source, target) {
    const nodes = treeNodes(name, this), s = nodes[source], t = nodes[target];
    return s && t ? s.path(t).map(datum) : undefined;
}
function treeAncestors(name, node) {
    const n = treeNodes(name, this)[node];
    return n ? n.ancestors().map(datum) : undefined;
}
const _window = ()=>typeof window !== 'undefined' && window || null;
function screen() {
    const w = _window();
    return w ? w.screen : {};
}
function windowSize() {
    const w = _window();
    return w ? [
        w.innerWidth,
        w.innerHeight
    ] : [
        undefined,
        undefined
    ];
}
function containerSize() {
    const view = this.context.dataflow, el = view.container && view.container();
    return el ? [
        el.clientWidth,
        el.clientHeight
    ] : [
        undefined,
        undefined
    ];
}
function intersect(b, opt, group) {
    if (!b) return [];
    const [u, v] = b, box = new (0, _vegaScenegraph.Bounds)().set(u[0], u[1], v[0], v[1]), scene = group || this.context.dataflow.scenegraph().root;
    return (0, _vegaScenegraph.intersect)(scene, box, filter(opt));
}
function filter(opt) {
    let p = null;
    if (opt) {
        const types = (0, _vegaUtil.array)(opt.marktype), names = (0, _vegaUtil.array)(opt.markname);
        p = (_)=>(!types.length || types.some((t)=>_.marktype === t)) && (!names.length || names.some((s)=>_.name === s));
    }
    return p;
}
/**
 * Appends a new point to the lasso
 *
 * @param {*} lasso the lasso in pixel space
 * @param {*} x the x coordinate in pixel space
 * @param {*} y the y coordinate in pixel space
 * @param {*} minDist the minimum distance, in pixels, that thenew point needs to be apart from the last point
 * @returns a new array containing the lasso with the new point
 */ function lassoAppend(lasso, x, y) {
    let minDist = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 5;
    lasso = (0, _vegaUtil.array)(lasso);
    const last = lasso[lasso.length - 1];
    // Add point to lasso if its the first point or distance to last point exceed minDist
    return last === undefined || Math.hypot(last[0] - x, last[1] - y) > minDist ? [
        ...lasso,
        [
            x,
            y
        ]
    ] : lasso;
}
/**
 * Generates a svg path command which draws a lasso
 *
 * @param {*} lasso the lasso in pixel space in the form [[x,y], [x,y], ...]
 * @returns the svg path command that draws the lasso
 */ function lassoPath(lasso) {
    return (0, _vegaUtil.array)(lasso).reduce((svg, _ref, i)=>{
        let [x, y] = _ref;
        return svg += i == 0 ? `M ${x},${y} ` : i === lasso.length - 1 ? ' Z' : `L ${x},${y} `;
    }, '');
}
/**
 * Inverts the lasso from pixel space to an array of vega scenegraph tuples
 *
 * @param {*} data the dataset
 * @param {*} pixelLasso the lasso in pixel space, [[x,y], [x,y], ...]
 * @param {*} unit the unit where the lasso is defined
 *
 * @returns an array of vega scenegraph tuples
 */ function intersectLasso(markname, pixelLasso, unit) {
    const { x, y, mark } = unit;
    const bb = new (0, _vegaScenegraph.Bounds)().set(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, Number.MIN_SAFE_INTEGER, Number.MIN_SAFE_INTEGER);
    // Get bounding box around lasso
    for (const [px, py] of pixelLasso){
        if (px < bb.x1) bb.x1 = px;
        if (px > bb.x2) bb.x2 = px;
        if (py < bb.y1) bb.y1 = py;
        if (py > bb.y2) bb.y2 = py;
    }
    // Translate bb against unit coordinates
    bb.translate(x, y);
    const intersection = intersect([
        [
            bb.x1,
            bb.y1
        ],
        [
            bb.x2,
            bb.y2
        ]
    ], markname, mark);
    // Check every point against the lasso
    return intersection.filter((tuple)=>pointInPolygon(tuple.x, tuple.y, pixelLasso));
}
/**
 * Performs a test if a point is inside a polygon based on the idea from
 * https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html
 *
 * This method will not need the same start/end point since it wraps around the edges of the array
 *
 * @param {*} test a point to test against
 * @param {*} polygon a polygon in the form [[x,y], [x,y], ...]
 * @returns true if the point lies inside the polygon, false otherwise
 */ function pointInPolygon(testx, testy, polygon) {
    let intersections = 0;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const [prevX, prevY] = polygon[j];
        const [x, y] = polygon[i];
        // count intersections
        if (y > testy != prevY > testy && testx < (prevX - x) * (testy - y) / (prevY - y) + x) intersections++;
    }
    // point is in polygon if intersection count is odd
    return intersections & 1;
}
// Expression function context object
const functionContext = {
    random () {
        return (0, _vegaStatistics.random)();
    },
    cumulativeNormal: // override default
    (0, _vegaStatistics.cumulativeNormal),
    cumulativeLogNormal: (0, _vegaStatistics.cumulativeLogNormal),
    cumulativeUniform: (0, _vegaStatistics.cumulativeUniform),
    densityNormal: (0, _vegaStatistics.densityNormal),
    densityLogNormal: (0, _vegaStatistics.densityLogNormal),
    densityUniform: (0, _vegaStatistics.densityUniform),
    quantileNormal: (0, _vegaStatistics.quantileNormal),
    quantileLogNormal: (0, _vegaStatistics.quantileLogNormal),
    quantileUniform: (0, _vegaStatistics.quantileUniform),
    sampleNormal: (0, _vegaStatistics.sampleNormal),
    sampleLogNormal: (0, _vegaStatistics.sampleLogNormal),
    sampleUniform: (0, _vegaStatistics.sampleUniform),
    isArray: (0, _vegaUtil.isArray),
    isBoolean: (0, _vegaUtil.isBoolean),
    isDate: (0, _vegaUtil.isDate),
    isDefined (_) {
        return _ !== undefined;
    },
    isNumber: (0, _vegaUtil.isNumber),
    isObject: (0, _vegaUtil.isObject),
    isRegExp: (0, _vegaUtil.isRegExp),
    isString: (0, _vegaUtil.isString),
    isTuple: (0, _vegaDataflow.isTuple),
    isValid (_) {
        return _ != null && _ === _;
    },
    toBoolean: (0, _vegaUtil.toBoolean),
    toDate (_) {
        return (0, _vegaUtil.toDate)(_);
    },
    toNumber: // suppress extra arguments
    (0, _vegaUtil.toNumber),
    toString: (0, _vegaUtil.toString),
    indexof,
    join,
    lastindexof,
    replace,
    reverse,
    sort,
    slice,
    flush: (0, _vegaUtil.flush),
    lerp: (0, _vegaUtil.lerp),
    merge,
    pad: (0, _vegaUtil.pad),
    peek: (0, _vegaUtil.peek),
    pluck,
    span: (0, _vegaUtil.span),
    inrange: (0, _vegaUtil.inrange),
    truncate: (0, _vegaUtil.truncate),
    rgb: (0, _d3Color.rgb),
    lab: (0, _d3Color.lab),
    hcl: (0, _d3Color.hcl),
    hsl: (0, _d3Color.hsl),
    luminance,
    contrast,
    sequence: (0, _d3Array.range),
    format,
    utcFormat,
    utcParse,
    utcOffset: (0, _vegaTime.utcOffset),
    utcSequence: (0, _vegaTime.utcSequence),
    timeFormat,
    timeParse,
    timeOffset: (0, _vegaTime.timeOffset),
    timeSequence: (0, _vegaTime.timeSequence),
    timeUnitSpecifier: (0, _vegaTime.timeUnitSpecifier),
    monthFormat,
    monthAbbrevFormat,
    dayFormat,
    dayAbbrevFormat,
    quarter: (0, _vegaUtil.quarter),
    utcquarter: (0, _vegaUtil.utcquarter),
    week: (0, _vegaTime.week),
    utcweek: (0, _vegaTime.utcweek),
    dayofyear: (0, _vegaTime.dayofyear),
    utcdayofyear: (0, _vegaTime.utcdayofyear),
    warn,
    info,
    debug,
    extent (_) {
        return (0, _vegaUtil.extent)(_);
    },
    // suppress extra arguments
    inScope,
    intersect,
    clampRange: (0, _vegaUtil.clampRange),
    pinchDistance,
    pinchAngle,
    screen,
    containerSize,
    windowSize,
    bandspace,
    setdata,
    pathShape,
    panLinear: (0, _vegaUtil.panLinear),
    panLog: (0, _vegaUtil.panLog),
    panPow: (0, _vegaUtil.panPow),
    panSymlog: (0, _vegaUtil.panSymlog),
    zoomLinear: (0, _vegaUtil.zoomLinear),
    zoomLog: (0, _vegaUtil.zoomLog),
    zoomPow: (0, _vegaUtil.zoomPow),
    zoomSymlog: (0, _vegaUtil.zoomSymlog),
    encode,
    modify,
    lassoAppend,
    lassoPath,
    intersectLasso
};
const eventFunctions = [
    'view',
    'item',
    'group',
    'xy',
    'x',
    'y'
], // event functions
eventPrefix = 'event.vega.', // event function prefix
thisPrefix = 'this.', // function context prefix
astVisitors = {}; // AST visitors for dependency analysis
// export code generator parameters
const codegenParams = {
    forbidden: [
        '_'
    ],
    allowed: [
        'datum',
        'event',
        'item'
    ],
    fieldvar: 'datum',
    globalvar: (id)=>`_[${(0, _vegaUtil.stringValue)(SignalPrefix + id)}]`,
    functions: buildFunctions,
    constants: (0, _vegaExpression.constants),
    visitors: astVisitors
};
// export code generator
const codeGenerator = (0, _vegaExpression.codegenExpression)(codegenParams);
// Build expression function registry
function buildFunctions(codegen) {
    const fn = (0, _vegaExpression.functions)(codegen);
    eventFunctions.forEach((name)=>fn[name] = eventPrefix + name);
    for(const name in functionContext)fn[name] = thisPrefix + name;
    (0, _vegaUtil.extend)(fn, internalScaleFunctions(codegen, functionContext, astVisitors));
    return fn;
}
// Register an expression function
function expressionFunction(name, fn, visitor) {
    if (arguments.length === 1) return functionContext[name];
    // register with the functionContext
    functionContext[name] = fn;
    // if there is an astVisitor register that, too
    if (visitor) astVisitors[name] = visitor;
    // if the code generator has already been initialized,
    // we need to also register the function with it
    if (codeGenerator) codeGenerator.functions[name] = thisPrefix + name;
    return this;
}
// register expression functions with ast visitors
expressionFunction('bandwidth', bandwidth, scaleVisitor);
expressionFunction('copy', copy, scaleVisitor);
expressionFunction('domain', domain, scaleVisitor);
expressionFunction('range', range, scaleVisitor);
expressionFunction('invert', invert, scaleVisitor);
expressionFunction('scale', scale, scaleVisitor);
expressionFunction('gradient', scaleGradient, scaleVisitor);
expressionFunction('geoArea', geoArea, scaleVisitor);
expressionFunction('geoBounds', geoBounds, scaleVisitor);
expressionFunction('geoCentroid', geoCentroid, scaleVisitor);
expressionFunction('geoShape', geoShape, scaleVisitor);
expressionFunction('geoScale', geoScale, scaleVisitor);
expressionFunction('indata', indata, indataVisitor);
expressionFunction('data', data, dataVisitor);
expressionFunction('treePath', treePath, dataVisitor);
expressionFunction('treeAncestors', treeAncestors, dataVisitor);
// register Vega-Lite selection functions
expressionFunction('vlSelectionTest', (0, _vegaSelections.selectionTest), (0, _vegaSelections.selectionVisitor));
expressionFunction('vlSelectionIdTest', (0, _vegaSelections.selectionIdTest), (0, _vegaSelections.selectionVisitor));
expressionFunction('vlSelectionResolve', (0, _vegaSelections.selectionResolve), (0, _vegaSelections.selectionVisitor));
expressionFunction('vlSelectionTuples', (0, _vegaSelections.selectionTuples));
function parser(expr, scope) {
    const params = {};
    // parse the expression to an abstract syntax tree (ast)
    let ast;
    try {
        expr = (0, _vegaUtil.isString)(expr) ? expr : (0, _vegaUtil.stringValue)(expr) + '';
        ast = (0, _vegaExpression.parseExpression)(expr);
    } catch (err) {
        (0, _vegaUtil.error)('Expression parse error: ' + expr);
    }
    // analyze ast function calls for dependencies
    ast.visit((node)=>{
        if (node.type !== (0, _vegaExpression.CallExpression)) return;
        const name = node.callee.name, visit = codegenParams.visitors[name];
        if (visit) visit(name, node.arguments, scope, params);
    });
    // perform code generation
    const gen = codeGenerator(ast);
    // collect signal dependencies
    gen.globals.forEach((name)=>{
        const signalName = SignalPrefix + name;
        if (!(0, _vegaUtil.hasOwnProperty)(params, signalName) && scope.getSignal(name)) params[signalName] = scope.signalRef(name);
    });
    // return generated expression code and dependencies
    return {
        $expr: (0, _vegaUtil.extend)({
            code: gen.code
        }, scope.options.ast ? {
            ast
        } : null),
        $fields: gen.fields,
        $params: params
    };
}

},{"vega-util":"7f6sQ","vega-expression":"clSwj","vega-scale":"13gXz","d3-geo":[["geoArea","faaVf","default"],["geoBounds","hvWAG","default"],["geoCentroid","3QJSV","default"]],"d3-color":[["hcl","h1jo5"],["lab","h1jo5","default"],["hsl","gqOvl"],["rgb","gqOvl"]],"vega-dataflow":"4An7U","vega-scenegraph":"823vy","vega-selections":"b6ZcA","vega-statistics":"lNUxJ","vega-time":"4oydN","d3-array":[["range","2Qa4a","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"clSwj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ASTNode", ()=>ASTNode);
parcelHelpers.export(exports, "ArrayExpression", ()=>ArrayExpression);
parcelHelpers.export(exports, "BinaryExpression", ()=>BinaryExpression);
parcelHelpers.export(exports, "CallExpression", ()=>CallExpression);
parcelHelpers.export(exports, "ConditionalExpression", ()=>ConditionalExpression);
parcelHelpers.export(exports, "Identifier", ()=>Identifier);
parcelHelpers.export(exports, "Literal", ()=>Literal);
parcelHelpers.export(exports, "LogicalExpression", ()=>LogicalExpression);
parcelHelpers.export(exports, "MemberExpression", ()=>MemberExpression);
parcelHelpers.export(exports, "ObjectExpression", ()=>ObjectExpression);
parcelHelpers.export(exports, "Property", ()=>Property);
parcelHelpers.export(exports, "RawCode", ()=>RawCode);
parcelHelpers.export(exports, "UnaryExpression", ()=>UnaryExpression);
parcelHelpers.export(exports, "codegenExpression", ()=>codegen);
parcelHelpers.export(exports, "constants", ()=>Constants);
parcelHelpers.export(exports, "functions", ()=>Functions);
parcelHelpers.export(exports, "parseExpression", ()=>parser);
var _vegaUtil = require("vega-util");
const RawCode = 'RawCode';
const Literal = 'Literal';
const Property = 'Property';
const Identifier = 'Identifier';
const ArrayExpression = 'ArrayExpression';
const BinaryExpression = 'BinaryExpression';
const CallExpression = 'CallExpression';
const ConditionalExpression = 'ConditionalExpression';
const LogicalExpression = 'LogicalExpression';
const MemberExpression = 'MemberExpression';
const ObjectExpression = 'ObjectExpression';
const UnaryExpression = 'UnaryExpression';
function ASTNode(type) {
    this.type = type;
}
ASTNode.prototype.visit = function(visitor) {
    let c, i, n;
    if (visitor(this)) return 1;
    for(c = children(this), i = 0, n = c.length; i < n; ++i){
        if (c[i].visit(visitor)) return 1;
    }
};
function children(node) {
    switch(node.type){
        case ArrayExpression:
            return node.elements;
        case BinaryExpression:
        case LogicalExpression:
            return [
                node.left,
                node.right
            ];
        case CallExpression:
            return [
                node.callee
            ].concat(node.arguments);
        case ConditionalExpression:
            return [
                node.test,
                node.consequent,
                node.alternate
            ];
        case MemberExpression:
            return [
                node.object,
                node.property
            ];
        case ObjectExpression:
            return node.properties;
        case Property:
            return [
                node.key,
                node.value
            ];
        case UnaryExpression:
            return [
                node.argument
            ];
        case Identifier:
        case Literal:
        case RawCode:
        default:
            return [];
    }
}
/*
  The following expression parser is based on Esprima (http://esprima.org/).
  Original header comment and license for Esprima is included here:

  Copyright (C) 2013 Ariya Hidayat <ariya.hidayat@gmail.com>
  Copyright (C) 2013 Thaddee Tyl <thaddee.tyl@gmail.com>
  Copyright (C) 2013 Mathias Bynens <mathias@qiwi.be>
  Copyright (C) 2012 Ariya Hidayat <ariya.hidayat@gmail.com>
  Copyright (C) 2012 Mathias Bynens <mathias@qiwi.be>
  Copyright (C) 2012 Joost-Wim Boekesteijn <joost-wim@boekesteijn.nl>
  Copyright (C) 2012 Kris Kowal <kris.kowal@cixar.com>
  Copyright (C) 2012 Yusuke Suzuki <utatane.tea@gmail.com>
  Copyright (C) 2012 Arpad Borsos <arpad.borsos@googlemail.com>
  Copyright (C) 2011 Ariya Hidayat <ariya.hidayat@gmail.com>

  Redistribution and use in source and binary forms, with or without
  modification, are permitted provided that the following conditions are met:

    * Redistributions of source code must retain the above copyright
      notice, this list of conditions and the following disclaimer.
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the
      documentation and/or other materials provided with the distribution.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
  ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
  DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
  ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
  THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ var TokenName, source, index, length, lookahead;
var TokenBooleanLiteral = 1, TokenEOF = 2, TokenIdentifier = 3, TokenKeyword = 4, TokenNullLiteral = 5, TokenNumericLiteral = 6, TokenPunctuator = 7, TokenStringLiteral = 8, TokenRegularExpression = 9;
TokenName = {};
TokenName[TokenBooleanLiteral] = 'Boolean';
TokenName[TokenEOF] = '<end>';
TokenName[TokenIdentifier] = 'Identifier';
TokenName[TokenKeyword] = 'Keyword';
TokenName[TokenNullLiteral] = 'Null';
TokenName[TokenNumericLiteral] = 'Numeric';
TokenName[TokenPunctuator] = 'Punctuator';
TokenName[TokenStringLiteral] = 'String';
TokenName[TokenRegularExpression] = 'RegularExpression';
var SyntaxArrayExpression = 'ArrayExpression', SyntaxBinaryExpression = 'BinaryExpression', SyntaxCallExpression = 'CallExpression', SyntaxConditionalExpression = 'ConditionalExpression', SyntaxIdentifier = 'Identifier', SyntaxLiteral = 'Literal', SyntaxLogicalExpression = 'LogicalExpression', SyntaxMemberExpression = 'MemberExpression', SyntaxObjectExpression = 'ObjectExpression', SyntaxProperty = 'Property', SyntaxUnaryExpression = 'UnaryExpression';
// Error messages should be identical to V8.
var MessageUnexpectedToken = 'Unexpected token %0', MessageUnexpectedNumber = 'Unexpected number', MessageUnexpectedString = 'Unexpected string', MessageUnexpectedIdentifier = 'Unexpected identifier', MessageUnexpectedReserved = 'Unexpected reserved word', MessageUnexpectedEOS = 'Unexpected end of input', MessageInvalidRegExp = 'Invalid regular expression', MessageUnterminatedRegExp = 'Invalid regular expression: missing /', MessageStrictOctalLiteral = 'Octal literals are not allowed in strict mode.', MessageStrictDuplicateProperty = 'Duplicate data property in object literal not allowed in strict mode';
var ILLEGAL = 'ILLEGAL', DISABLED = 'Disabled.';
// See also tools/generate-unicode-regex.py.
var RegexNonAsciiIdentifierStart = new RegExp('[\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0370-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u037F\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u048A-\\u052F\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0620-\\u064A\\u066E\\u066F\\u0671-\\u06D3\\u06D5\\u06E5\\u06E6\\u06EE\\u06EF\\u06FA-\\u06FC\\u06FF\\u0710\\u0712-\\u072F\\u074D-\\u07A5\\u07B1\\u07CA-\\u07EA\\u07F4\\u07F5\\u07FA\\u0800-\\u0815\\u081A\\u0824\\u0828\\u0840-\\u0858\\u08A0-\\u08B2\\u0904-\\u0939\\u093D\\u0950\\u0958-\\u0961\\u0971-\\u0980\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BD\\u09CE\\u09DC\\u09DD\\u09DF-\\u09E1\\u09F0\\u09F1\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A59-\\u0A5C\\u0A5E\\u0A72-\\u0A74\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABD\\u0AD0\\u0AE0\\u0AE1\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3D\\u0B5C\\u0B5D\\u0B5F-\\u0B61\\u0B71\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BD0\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C39\\u0C3D\\u0C58\\u0C59\\u0C60\\u0C61\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBD\\u0CDE\\u0CE0\\u0CE1\\u0CF1\\u0CF2\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D\\u0D4E\\u0D60\\u0D61\\u0D7A-\\u0D7F\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0E01-\\u0E30\\u0E32\\u0E33\\u0E40-\\u0E46\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB0\\u0EB2\\u0EB3\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EDC-\\u0EDF\\u0F00\\u0F40-\\u0F47\\u0F49-\\u0F6C\\u0F88-\\u0F8C\\u1000-\\u102A\\u103F\\u1050-\\u1055\\u105A-\\u105D\\u1061\\u1065\\u1066\\u106E-\\u1070\\u1075-\\u1081\\u108E\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16EE-\\u16F8\\u1700-\\u170C\\u170E-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176C\\u176E-\\u1770\\u1780-\\u17B3\\u17D7\\u17DC\\u1820-\\u1877\\u1880-\\u18A8\\u18AA\\u18B0-\\u18F5\\u1900-\\u191E\\u1950-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19C1-\\u19C7\\u1A00-\\u1A16\\u1A20-\\u1A54\\u1AA7\\u1B05-\\u1B33\\u1B45-\\u1B4B\\u1B83-\\u1BA0\\u1BAE\\u1BAF\\u1BBA-\\u1BE5\\u1C00-\\u1C23\\u1C4D-\\u1C4F\\u1C5A-\\u1C7D\\u1CE9-\\u1CEC\\u1CEE-\\u1CF1\\u1CF5\\u1CF6\\u1D00-\\u1DBF\\u1E00-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u2071\\u207F\\u2090-\\u209C\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2160-\\u2188\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CEE\\u2CF2\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D80-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2E2F\\u3005-\\u3007\\u3021-\\u3029\\u3031-\\u3035\\u3038-\\u303C\\u3041-\\u3096\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA61F\\uA62A\\uA62B\\uA640-\\uA66E\\uA67F-\\uA69D\\uA6A0-\\uA6EF\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA7AD\\uA7B0\\uA7B1\\uA7F7-\\uA801\\uA803-\\uA805\\uA807-\\uA80A\\uA80C-\\uA822\\uA840-\\uA873\\uA882-\\uA8B3\\uA8F2-\\uA8F7\\uA8FB\\uA90A-\\uA925\\uA930-\\uA946\\uA960-\\uA97C\\uA984-\\uA9B2\\uA9CF\\uA9E0-\\uA9E4\\uA9E6-\\uA9EF\\uA9FA-\\uA9FE\\uAA00-\\uAA28\\uAA40-\\uAA42\\uAA44-\\uAA4B\\uAA60-\\uAA76\\uAA7A\\uAA7E-\\uAAAF\\uAAB1\\uAAB5\\uAAB6\\uAAB9-\\uAABD\\uAAC0\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEA\\uAAF2-\\uAAF4\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uAB30-\\uAB5A\\uAB5C-\\uAB5F\\uAB64\\uAB65\\uABC0-\\uABE2\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D\\uFB1F-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF21-\\uFF3A\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC]'), // eslint-disable-next-line no-misleading-character-class
RegexNonAsciiIdentifierPart = new RegExp('[\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0300-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u037F\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u0483-\\u0487\\u048A-\\u052F\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u0591-\\u05BD\\u05BF\\u05C1\\u05C2\\u05C4\\u05C5\\u05C7\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0610-\\u061A\\u0620-\\u0669\\u066E-\\u06D3\\u06D5-\\u06DC\\u06DF-\\u06E8\\u06EA-\\u06FC\\u06FF\\u0710-\\u074A\\u074D-\\u07B1\\u07C0-\\u07F5\\u07FA\\u0800-\\u082D\\u0840-\\u085B\\u08A0-\\u08B2\\u08E4-\\u0963\\u0966-\\u096F\\u0971-\\u0983\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BC-\\u09C4\\u09C7\\u09C8\\u09CB-\\u09CE\\u09D7\\u09DC\\u09DD\\u09DF-\\u09E3\\u09E6-\\u09F1\\u0A01-\\u0A03\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A3C\\u0A3E-\\u0A42\\u0A47\\u0A48\\u0A4B-\\u0A4D\\u0A51\\u0A59-\\u0A5C\\u0A5E\\u0A66-\\u0A75\\u0A81-\\u0A83\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABC-\\u0AC5\\u0AC7-\\u0AC9\\u0ACB-\\u0ACD\\u0AD0\\u0AE0-\\u0AE3\\u0AE6-\\u0AEF\\u0B01-\\u0B03\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3C-\\u0B44\\u0B47\\u0B48\\u0B4B-\\u0B4D\\u0B56\\u0B57\\u0B5C\\u0B5D\\u0B5F-\\u0B63\\u0B66-\\u0B6F\\u0B71\\u0B82\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BBE-\\u0BC2\\u0BC6-\\u0BC8\\u0BCA-\\u0BCD\\u0BD0\\u0BD7\\u0BE6-\\u0BEF\\u0C00-\\u0C03\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C39\\u0C3D-\\u0C44\\u0C46-\\u0C48\\u0C4A-\\u0C4D\\u0C55\\u0C56\\u0C58\\u0C59\\u0C60-\\u0C63\\u0C66-\\u0C6F\\u0C81-\\u0C83\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBC-\\u0CC4\\u0CC6-\\u0CC8\\u0CCA-\\u0CCD\\u0CD5\\u0CD6\\u0CDE\\u0CE0-\\u0CE3\\u0CE6-\\u0CEF\\u0CF1\\u0CF2\\u0D01-\\u0D03\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D-\\u0D44\\u0D46-\\u0D48\\u0D4A-\\u0D4E\\u0D57\\u0D60-\\u0D63\\u0D66-\\u0D6F\\u0D7A-\\u0D7F\\u0D82\\u0D83\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0DCA\\u0DCF-\\u0DD4\\u0DD6\\u0DD8-\\u0DDF\\u0DE6-\\u0DEF\\u0DF2\\u0DF3\\u0E01-\\u0E3A\\u0E40-\\u0E4E\\u0E50-\\u0E59\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB9\\u0EBB-\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EC8-\\u0ECD\\u0ED0-\\u0ED9\\u0EDC-\\u0EDF\\u0F00\\u0F18\\u0F19\\u0F20-\\u0F29\\u0F35\\u0F37\\u0F39\\u0F3E-\\u0F47\\u0F49-\\u0F6C\\u0F71-\\u0F84\\u0F86-\\u0F97\\u0F99-\\u0FBC\\u0FC6\\u1000-\\u1049\\u1050-\\u109D\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u135D-\\u135F\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16EE-\\u16F8\\u1700-\\u170C\\u170E-\\u1714\\u1720-\\u1734\\u1740-\\u1753\\u1760-\\u176C\\u176E-\\u1770\\u1772\\u1773\\u1780-\\u17D3\\u17D7\\u17DC\\u17DD\\u17E0-\\u17E9\\u180B-\\u180D\\u1810-\\u1819\\u1820-\\u1877\\u1880-\\u18AA\\u18B0-\\u18F5\\u1900-\\u191E\\u1920-\\u192B\\u1930-\\u193B\\u1946-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19B0-\\u19C9\\u19D0-\\u19D9\\u1A00-\\u1A1B\\u1A20-\\u1A5E\\u1A60-\\u1A7C\\u1A7F-\\u1A89\\u1A90-\\u1A99\\u1AA7\\u1AB0-\\u1ABD\\u1B00-\\u1B4B\\u1B50-\\u1B59\\u1B6B-\\u1B73\\u1B80-\\u1BF3\\u1C00-\\u1C37\\u1C40-\\u1C49\\u1C4D-\\u1C7D\\u1CD0-\\u1CD2\\u1CD4-\\u1CF6\\u1CF8\\u1CF9\\u1D00-\\u1DF5\\u1DFC-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u200C\\u200D\\u203F\\u2040\\u2054\\u2071\\u207F\\u2090-\\u209C\\u20D0-\\u20DC\\u20E1\\u20E5-\\u20F0\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2160-\\u2188\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D7F-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2DE0-\\u2DFF\\u2E2F\\u3005-\\u3007\\u3021-\\u302F\\u3031-\\u3035\\u3038-\\u303C\\u3041-\\u3096\\u3099\\u309A\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA62B\\uA640-\\uA66F\\uA674-\\uA67D\\uA67F-\\uA69D\\uA69F-\\uA6F1\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA7AD\\uA7B0\\uA7B1\\uA7F7-\\uA827\\uA840-\\uA873\\uA880-\\uA8C4\\uA8D0-\\uA8D9\\uA8E0-\\uA8F7\\uA8FB\\uA900-\\uA92D\\uA930-\\uA953\\uA960-\\uA97C\\uA980-\\uA9C0\\uA9CF-\\uA9D9\\uA9E0-\\uA9FE\\uAA00-\\uAA36\\uAA40-\\uAA4D\\uAA50-\\uAA59\\uAA60-\\uAA76\\uAA7A-\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEF\\uAAF2-\\uAAF6\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uAB30-\\uAB5A\\uAB5C-\\uAB5F\\uAB64\\uAB65\\uABC0-\\uABEA\\uABEC\\uABED\\uABF0-\\uABF9\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE00-\\uFE0F\\uFE20-\\uFE2D\\uFE33\\uFE34\\uFE4D-\\uFE4F\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF10-\\uFF19\\uFF21-\\uFF3A\\uFF3F\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC]');
// Ensure the condition is true, otherwise throw an error.
// This is only to have a better contract semantic, i.e. another safety net
// to catch a logic error. The condition shall be fulfilled in normal case.
// Do NOT use this to enforce a certain condition on any user input.
function assert(condition, message) {
    /* istanbul ignore next */ if (!condition) throw new Error('ASSERT: ' + message);
}
function isDecimalDigit(ch) {
    return ch >= 0x30 && ch <= 0x39; // 0..9
}
function isHexDigit(ch) {
    return '0123456789abcdefABCDEF'.includes(ch);
}
function isOctalDigit(ch) {
    return '01234567'.includes(ch);
}
// 7.2 White Space
function isWhiteSpace(ch) {
    return ch === 0x20 || ch === 0x09 || ch === 0x0B || ch === 0x0C || ch === 0xA0 || ch >= 0x1680 && [
        0x1680,
        0x180E,
        0x2000,
        0x2001,
        0x2002,
        0x2003,
        0x2004,
        0x2005,
        0x2006,
        0x2007,
        0x2008,
        0x2009,
        0x200A,
        0x202F,
        0x205F,
        0x3000,
        0xFEFF
    ].includes(ch);
}
// 7.3 Line Terminators
function isLineTerminator(ch) {
    return ch === 0x0A || ch === 0x0D || ch === 0x2028 || ch === 0x2029;
}
// 7.6 Identifier Names and Identifiers
function isIdentifierStart(ch) {
    return ch === 0x24 || ch === 0x5F || // $ (dollar) and _ (underscore)
    ch >= 0x41 && ch <= 0x5A || // A..Z
    ch >= 0x61 && ch <= 0x7A || // a..z
    ch === 0x5C || // \ (backslash)
    ch >= 0x80 && RegexNonAsciiIdentifierStart.test(String.fromCharCode(ch));
}
function isIdentifierPart(ch) {
    return ch === 0x24 || ch === 0x5F || // $ (dollar) and _ (underscore)
    ch >= 0x41 && ch <= 0x5A || // A..Z
    ch >= 0x61 && ch <= 0x7A || // a..z
    ch >= 0x30 && ch <= 0x39 || // 0..9
    ch === 0x5C || // \ (backslash)
    ch >= 0x80 && RegexNonAsciiIdentifierPart.test(String.fromCharCode(ch));
}
// 7.6.1.1 Keywords
const keywords = {
    'if': 1,
    'in': 1,
    'do': 1,
    'var': 1,
    'for': 1,
    'new': 1,
    'try': 1,
    'let': 1,
    'this': 1,
    'else': 1,
    'case': 1,
    'void': 1,
    'with': 1,
    'enum': 1,
    'while': 1,
    'break': 1,
    'catch': 1,
    'throw': 1,
    'const': 1,
    'yield': 1,
    'class': 1,
    'super': 1,
    'return': 1,
    'typeof': 1,
    'delete': 1,
    'switch': 1,
    'export': 1,
    'import': 1,
    'public': 1,
    'static': 1,
    'default': 1,
    'finally': 1,
    'extends': 1,
    'package': 1,
    'private': 1,
    'function': 1,
    'continue': 1,
    'debugger': 1,
    'interface': 1,
    'protected': 1,
    'instanceof': 1,
    'implements': 1
};
function skipComment() {
    while(index < length){
        const ch = source.charCodeAt(index);
        if (isWhiteSpace(ch) || isLineTerminator(ch)) ++index;
        else break;
    }
}
function scanHexEscape(prefix) {
    var i, len, ch, code = 0;
    len = prefix === 'u' ? 4 : 2;
    for(i = 0; i < len; ++i)if (index < length && isHexDigit(source[index])) {
        ch = source[index++];
        code = code * 16 + '0123456789abcdef'.indexOf(ch.toLowerCase());
    } else throwError({}, MessageUnexpectedToken, ILLEGAL);
    return String.fromCharCode(code);
}
function scanUnicodeCodePointEscape() {
    var ch, code, cu1, cu2;
    ch = source[index];
    code = 0;
    // At least, one hex digit is required.
    if (ch === '}') throwError({}, MessageUnexpectedToken, ILLEGAL);
    while(index < length){
        ch = source[index++];
        if (!isHexDigit(ch)) break;
        code = code * 16 + '0123456789abcdef'.indexOf(ch.toLowerCase());
    }
    if (code > 0x10FFFF || ch !== '}') throwError({}, MessageUnexpectedToken, ILLEGAL);
    // UTF-16 Encoding
    if (code <= 0xFFFF) return String.fromCharCode(code);
    cu1 = (code - 0x10000 >> 10) + 0xD800;
    cu2 = (code - 0x10000 & 1023) + 0xDC00;
    return String.fromCharCode(cu1, cu2);
}
function getEscapedIdentifier() {
    var ch, id;
    ch = source.charCodeAt(index++);
    id = String.fromCharCode(ch);
    // '\u' (U+005C, U+0075) denotes an escaped character.
    if (ch === 0x5C) {
        if (source.charCodeAt(index) !== 0x75) throwError({}, MessageUnexpectedToken, ILLEGAL);
        ++index;
        ch = scanHexEscape('u');
        if (!ch || ch === '\\' || !isIdentifierStart(ch.charCodeAt(0))) throwError({}, MessageUnexpectedToken, ILLEGAL);
        id = ch;
    }
    while(index < length){
        ch = source.charCodeAt(index);
        if (!isIdentifierPart(ch)) break;
        ++index;
        id += String.fromCharCode(ch);
        // '\u' (U+005C, U+0075) denotes an escaped character.
        if (ch === 0x5C) {
            id = id.substr(0, id.length - 1);
            if (source.charCodeAt(index) !== 0x75) throwError({}, MessageUnexpectedToken, ILLEGAL);
            ++index;
            ch = scanHexEscape('u');
            if (!ch || ch === '\\' || !isIdentifierPart(ch.charCodeAt(0))) throwError({}, MessageUnexpectedToken, ILLEGAL);
            id += ch;
        }
    }
    return id;
}
function getIdentifier() {
    var start, ch;
    start = index++;
    while(index < length){
        ch = source.charCodeAt(index);
        if (ch === 0x5C) {
            // Blackslash (U+005C) marks Unicode escape sequence.
            index = start;
            return getEscapedIdentifier();
        }
        if (isIdentifierPart(ch)) ++index;
        else break;
    }
    return source.slice(start, index);
}
function scanIdentifier() {
    var start, id, type;
    start = index;
    // Backslash (U+005C) starts an escaped character.
    id = source.charCodeAt(index) === 0x5C ? getEscapedIdentifier() : getIdentifier();
    // There is no keyword or literal with only one character.
    // Thus, it must be an identifier.
    if (id.length === 1) type = TokenIdentifier;
    else if (keywords.hasOwnProperty(id)) // eslint-disable-line no-prototype-builtins
    type = TokenKeyword;
    else if (id === 'null') type = TokenNullLiteral;
    else if (id === 'true' || id === 'false') type = TokenBooleanLiteral;
    else type = TokenIdentifier;
    return {
        type: type,
        value: id,
        start: start,
        end: index
    };
}
// 7.7 Punctuators
function scanPunctuator() {
    var start = index, code = source.charCodeAt(index), code2, ch1 = source[index], ch2, ch3, ch4;
    switch(code){
        // Check for most common single-character punctuators.
        case 0x2E:
        case 0x28:
        case 0x29:
        case 0x3B:
        case 0x2C:
        case 0x7B:
        case 0x7D:
        case 0x5B:
        case 0x5D:
        case 0x3A:
        case 0x3F:
        case 0x7E:
            // ~
            ++index;
            return {
                type: TokenPunctuator,
                value: String.fromCharCode(code),
                start: start,
                end: index
            };
        default:
            code2 = source.charCodeAt(index + 1);
            // '=' (U+003D) marks an assignment or comparison operator.
            if (code2 === 0x3D) switch(code){
                case 0x2B:
                case 0x2D:
                case 0x2F:
                case 0x3C:
                case 0x3E:
                case 0x5E:
                case 0x7C:
                case 0x25:
                case 0x26:
                case 0x2A:
                    // *
                    index += 2;
                    return {
                        type: TokenPunctuator,
                        value: String.fromCharCode(code) + String.fromCharCode(code2),
                        start: start,
                        end: index
                    };
                case 0x21:
                case 0x3D:
                    // =
                    index += 2;
                    // !== and ===
                    if (source.charCodeAt(index) === 0x3D) ++index;
                    return {
                        type: TokenPunctuator,
                        value: source.slice(start, index),
                        start: start,
                        end: index
                    };
            }
    }
    // 4-character punctuator: >>>=
    ch4 = source.substr(index, 4);
    if (ch4 === '>>>=') {
        index += 4;
        return {
            type: TokenPunctuator,
            value: ch4,
            start: start,
            end: index
        };
    }
    // 3-character punctuators: === !== >>> <<= >>=
    ch3 = ch4.substr(0, 3);
    if (ch3 === '>>>' || ch3 === '<<=' || ch3 === '>>=') {
        index += 3;
        return {
            type: TokenPunctuator,
            value: ch3,
            start: start,
            end: index
        };
    }
    // Other 2-character punctuators: ++ -- << >> && ||
    ch2 = ch3.substr(0, 2);
    if (ch1 === ch2[1] && '+-<>&|'.includes(ch1) || ch2 === '=>') {
        index += 2;
        return {
            type: TokenPunctuator,
            value: ch2,
            start: start,
            end: index
        };
    }
    if (ch2 === '//') throwError({}, MessageUnexpectedToken, ILLEGAL);
    // 1-character punctuators: < > = ! + - * % & | ^ /
    if ('<>=!+-*%&|^/'.includes(ch1)) {
        ++index;
        return {
            type: TokenPunctuator,
            value: ch1,
            start: start,
            end: index
        };
    }
    throwError({}, MessageUnexpectedToken, ILLEGAL);
}
// 7.8.3 Numeric Literals
function scanHexLiteral(start) {
    let number = '';
    while(index < length){
        if (!isHexDigit(source[index])) break;
        number += source[index++];
    }
    if (number.length === 0) throwError({}, MessageUnexpectedToken, ILLEGAL);
    if (isIdentifierStart(source.charCodeAt(index))) throwError({}, MessageUnexpectedToken, ILLEGAL);
    return {
        type: TokenNumericLiteral,
        value: parseInt('0x' + number, 16),
        start: start,
        end: index
    };
}
function scanOctalLiteral(start) {
    let number = '0' + source[index++];
    while(index < length){
        if (!isOctalDigit(source[index])) break;
        number += source[index++];
    }
    if (isIdentifierStart(source.charCodeAt(index)) || isDecimalDigit(source.charCodeAt(index))) throwError({}, MessageUnexpectedToken, ILLEGAL);
    return {
        type: TokenNumericLiteral,
        value: parseInt(number, 8),
        octal: true,
        start: start,
        end: index
    };
}
function scanNumericLiteral() {
    var number, start, ch;
    ch = source[index];
    assert(isDecimalDigit(ch.charCodeAt(0)) || ch === '.', 'Numeric literal must start with a decimal digit or a decimal point');
    start = index;
    number = '';
    if (ch !== '.') {
        number = source[index++];
        ch = source[index];
        // Hex number starts with '0x'.
        // Octal number starts with '0'.
        if (number === '0') {
            if (ch === 'x' || ch === 'X') {
                ++index;
                return scanHexLiteral(start);
            }
            if (isOctalDigit(ch)) return scanOctalLiteral(start);
            // decimal number starts with '0' such as '09' is illegal.
            if (ch && isDecimalDigit(ch.charCodeAt(0))) throwError({}, MessageUnexpectedToken, ILLEGAL);
        }
        while(isDecimalDigit(source.charCodeAt(index)))number += source[index++];
        ch = source[index];
    }
    if (ch === '.') {
        number += source[index++];
        while(isDecimalDigit(source.charCodeAt(index)))number += source[index++];
        ch = source[index];
    }
    if (ch === 'e' || ch === 'E') {
        number += source[index++];
        ch = source[index];
        if (ch === '+' || ch === '-') number += source[index++];
        if (isDecimalDigit(source.charCodeAt(index))) while(isDecimalDigit(source.charCodeAt(index)))number += source[index++];
        else throwError({}, MessageUnexpectedToken, ILLEGAL);
    }
    if (isIdentifierStart(source.charCodeAt(index))) throwError({}, MessageUnexpectedToken, ILLEGAL);
    return {
        type: TokenNumericLiteral,
        value: parseFloat(number),
        start: start,
        end: index
    };
}
// 7.8.4 String Literals
function scanStringLiteral() {
    var str = '', quote, start, ch, code, octal = false;
    quote = source[index];
    assert(quote === '\'' || quote === '"', 'String literal must starts with a quote');
    start = index;
    ++index;
    while(index < length){
        ch = source[index++];
        if (ch === quote) {
            quote = '';
            break;
        } else if (ch === '\\') {
            ch = source[index++];
            if (!ch || !isLineTerminator(ch.charCodeAt(0))) switch(ch){
                case 'u':
                case 'x':
                    if (source[index] === '{') {
                        ++index;
                        str += scanUnicodeCodePointEscape();
                    } else str += scanHexEscape(ch);
                    break;
                case 'n':
                    str += '\n';
                    break;
                case 'r':
                    str += '\r';
                    break;
                case 't':
                    str += '\t';
                    break;
                case 'b':
                    str += '\b';
                    break;
                case 'f':
                    str += '\f';
                    break;
                case 'v':
                    str += '\x0B';
                    break;
                default:
                    if (isOctalDigit(ch)) {
                        code = '01234567'.indexOf(ch);
                        // \0 is not octal escape sequence
                        if (code !== 0) octal = true;
                        if (index < length && isOctalDigit(source[index])) {
                            octal = true;
                            code = code * 8 + '01234567'.indexOf(source[index++]);
                            // 3 digits are only allowed when string starts
                            // with 0, 1, 2, 3
                            if ('0123'.includes(ch) && index < length && isOctalDigit(source[index])) code = code * 8 + '01234567'.indexOf(source[index++]);
                        }
                        str += String.fromCharCode(code);
                    } else str += ch;
                    break;
            }
            else if (ch === '\r' && source[index] === '\n') ++index;
        } else if (isLineTerminator(ch.charCodeAt(0))) break;
        else str += ch;
    }
    if (quote !== '') throwError({}, MessageUnexpectedToken, ILLEGAL);
    return {
        type: TokenStringLiteral,
        value: str,
        octal: octal,
        start: start,
        end: index
    };
}
function testRegExp(pattern, flags) {
    let tmp = pattern;
    if (flags.includes('u')) // Replace each astral symbol and every Unicode code point
    // escape sequence with a single ASCII symbol to avoid throwing on
    // regular expressions that are only valid in combination with the
    // `/u` flag.
    // Note: replacing with the ASCII symbol `x` might cause false
    // negatives in unlikely scenarios. For example, `[\u{61}-b]` is a
    // perfectly valid pattern that is equivalent to `[a-b]`, but it
    // would be replaced by `[x-b]` which throws an error.
    tmp = tmp.replace(/\\u\{([0-9a-fA-F]+)\}/g, ($0, $1)=>{
        if (parseInt($1, 16) <= 0x10FFFF) return 'x';
        throwError({}, MessageInvalidRegExp);
    }).replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, 'x');
    // First, detect invalid regular expressions.
    try {
        new RegExp(tmp);
    } catch (e) {
        throwError({}, MessageInvalidRegExp);
    }
    // Return a regular expression object for this pattern-flag pair, or
    // `null` in case the current environment doesn't support the flags it
    // uses.
    try {
        return new RegExp(pattern, flags);
    } catch (exception) {
        return null;
    }
}
function scanRegExpBody() {
    var ch, str, classMarker, terminated, body;
    ch = source[index];
    assert(ch === '/', 'Regular expression literal must start with a slash');
    str = source[index++];
    classMarker = false;
    terminated = false;
    while(index < length){
        ch = source[index++];
        str += ch;
        if (ch === '\\') {
            ch = source[index++];
            // ECMA-262 7.8.5
            if (isLineTerminator(ch.charCodeAt(0))) throwError({}, MessageUnterminatedRegExp);
            str += ch;
        } else if (isLineTerminator(ch.charCodeAt(0))) throwError({}, MessageUnterminatedRegExp);
        else if (classMarker) {
            if (ch === ']') classMarker = false;
        } else {
            if (ch === '/') {
                terminated = true;
                break;
            } else if (ch === '[') classMarker = true;
        }
    }
    if (!terminated) throwError({}, MessageUnterminatedRegExp);
    // Exclude leading and trailing slash.
    body = str.substr(1, str.length - 2);
    return {
        value: body,
        literal: str
    };
}
function scanRegExpFlags() {
    var ch, str, flags;
    str = '';
    flags = '';
    while(index < length){
        ch = source[index];
        if (!isIdentifierPart(ch.charCodeAt(0))) break;
        ++index;
        if (ch === '\\' && index < length) throwError({}, MessageUnexpectedToken, ILLEGAL);
        else {
            flags += ch;
            str += ch;
        }
    }
    if (flags.search(/[^gimuy]/g) >= 0) throwError({}, MessageInvalidRegExp, flags);
    return {
        value: flags,
        literal: str
    };
}
function scanRegExp() {
    var start, body, flags, value;
    lookahead = null;
    skipComment();
    start = index;
    body = scanRegExpBody();
    flags = scanRegExpFlags();
    value = testRegExp(body.value, flags.value);
    return {
        literal: body.literal + flags.literal,
        value: value,
        regex: {
            pattern: body.value,
            flags: flags.value
        },
        start: start,
        end: index
    };
}
function isIdentifierName(token) {
    return token.type === TokenIdentifier || token.type === TokenKeyword || token.type === TokenBooleanLiteral || token.type === TokenNullLiteral;
}
function advance() {
    skipComment();
    if (index >= length) return {
        type: TokenEOF,
        start: index,
        end: index
    };
    const ch = source.charCodeAt(index);
    if (isIdentifierStart(ch)) return scanIdentifier();
    // Very common: ( and ) and ;
    if (ch === 0x28 || ch === 0x29 || ch === 0x3B) return scanPunctuator();
    // String literal starts with single quote (U+0027) or double quote (U+0022).
    if (ch === 0x27 || ch === 0x22) return scanStringLiteral();
    // Dot (.) U+002E can also start a floating-point number, hence the need
    // to check the next character.
    if (ch === 0x2E) {
        if (isDecimalDigit(source.charCodeAt(index + 1))) return scanNumericLiteral();
        return scanPunctuator();
    }
    if (isDecimalDigit(ch)) return scanNumericLiteral();
    return scanPunctuator();
}
function lex() {
    const token = lookahead;
    index = token.end;
    lookahead = advance();
    index = token.end;
    return token;
}
function peek() {
    const pos = index;
    lookahead = advance();
    index = pos;
}
function finishArrayExpression(elements) {
    const node = new ASTNode(SyntaxArrayExpression);
    node.elements = elements;
    return node;
}
function finishBinaryExpression(operator, left, right) {
    const node = new ASTNode(operator === '||' || operator === '&&' ? SyntaxLogicalExpression : SyntaxBinaryExpression);
    node.operator = operator;
    node.left = left;
    node.right = right;
    return node;
}
function finishCallExpression(callee, args) {
    const node = new ASTNode(SyntaxCallExpression);
    node.callee = callee;
    node.arguments = args;
    return node;
}
function finishConditionalExpression(test, consequent, alternate) {
    const node = new ASTNode(SyntaxConditionalExpression);
    node.test = test;
    node.consequent = consequent;
    node.alternate = alternate;
    return node;
}
function finishIdentifier(name) {
    const node = new ASTNode(SyntaxIdentifier);
    node.name = name;
    return node;
}
function finishLiteral(token) {
    const node = new ASTNode(SyntaxLiteral);
    node.value = token.value;
    node.raw = source.slice(token.start, token.end);
    if (token.regex) {
        if (node.raw === '//') node.raw = '/(?:)/';
        node.regex = token.regex;
    }
    return node;
}
function finishMemberExpression(accessor, object, property) {
    const node = new ASTNode(SyntaxMemberExpression);
    node.computed = accessor === '[';
    node.object = object;
    node.property = property;
    if (!node.computed) property.member = true;
    return node;
}
function finishObjectExpression(properties) {
    const node = new ASTNode(SyntaxObjectExpression);
    node.properties = properties;
    return node;
}
function finishProperty(kind, key, value) {
    const node = new ASTNode(SyntaxProperty);
    node.key = key;
    node.value = value;
    node.kind = kind;
    return node;
}
function finishUnaryExpression(operator, argument) {
    const node = new ASTNode(SyntaxUnaryExpression);
    node.operator = operator;
    node.argument = argument;
    node.prefix = true;
    return node;
}
// Throw an exception
function throwError(token, messageFormat) {
    var error, args = Array.prototype.slice.call(arguments, 2), msg = messageFormat.replace(/%(\d)/g, (whole, index)=>{
        assert(index < args.length, 'Message reference must be in range');
        return args[index];
    });
    error = new Error(msg);
    error.index = index;
    error.description = msg;
    throw error;
}
// Throw an exception because of the token.
function throwUnexpected(token) {
    if (token.type === TokenEOF) throwError(token, MessageUnexpectedEOS);
    if (token.type === TokenNumericLiteral) throwError(token, MessageUnexpectedNumber);
    if (token.type === TokenStringLiteral) throwError(token, MessageUnexpectedString);
    if (token.type === TokenIdentifier) throwError(token, MessageUnexpectedIdentifier);
    if (token.type === TokenKeyword) throwError(token, MessageUnexpectedReserved);
    // BooleanLiteral, NullLiteral, or Punctuator.
    throwError(token, MessageUnexpectedToken, token.value);
}
// Expect the next token to match the specified punctuator.
// If not, an exception will be thrown.
function expect(value) {
    const token = lex();
    if (token.type !== TokenPunctuator || token.value !== value) throwUnexpected(token);
}
// Return true if the next token matches the specified punctuator.
function match(value) {
    return lookahead.type === TokenPunctuator && lookahead.value === value;
}
// Return true if the next token matches the specified keyword
function matchKeyword(keyword) {
    return lookahead.type === TokenKeyword && lookahead.value === keyword;
}
// 11.1.4 Array Initialiser
function parseArrayInitialiser() {
    const elements = [];
    index = lookahead.start;
    expect('[');
    while(!match(']'))if (match(',')) {
        lex();
        elements.push(null);
    } else {
        elements.push(parseConditionalExpression());
        if (!match(']')) expect(',');
    }
    lex();
    return finishArrayExpression(elements);
}
// 11.1.5 Object Initialiser
function parseObjectPropertyKey() {
    index = lookahead.start;
    const token = lex();
    // Note: This function is called only from parseObjectProperty(), where
    // EOF and Punctuator tokens are already filtered out.
    if (token.type === TokenStringLiteral || token.type === TokenNumericLiteral) {
        if (token.octal) throwError(token, MessageStrictOctalLiteral);
        return finishLiteral(token);
    }
    return finishIdentifier(token.value);
}
function parseObjectProperty() {
    var token, key, id, value;
    index = lookahead.start;
    token = lookahead;
    if (token.type === TokenIdentifier) {
        id = parseObjectPropertyKey();
        expect(':');
        value = parseConditionalExpression();
        return finishProperty('init', id, value);
    }
    if (token.type === TokenEOF || token.type === TokenPunctuator) throwUnexpected(token);
    else {
        key = parseObjectPropertyKey();
        expect(':');
        value = parseConditionalExpression();
        return finishProperty('init', key, value);
    }
}
function parseObjectInitialiser() {
    var properties = [], property, name, key, map = {}, toString = String;
    index = lookahead.start;
    expect('{');
    while(!match('}')){
        property = parseObjectProperty();
        if (property.key.type === SyntaxIdentifier) name = property.key.name;
        else name = toString(property.key.value);
        key = '$' + name;
        if (Object.prototype.hasOwnProperty.call(map, key)) throwError({}, MessageStrictDuplicateProperty);
        else map[key] = true;
        properties.push(property);
        if (!match('}')) expect(',');
    }
    expect('}');
    return finishObjectExpression(properties);
}
// 11.1.6 The Grouping Operator
function parseGroupExpression() {
    expect('(');
    const expr = parseExpression();
    expect(')');
    return expr;
}
// 11.1 Primary Expressions
const legalKeywords = {
    'if': 1
};
function parsePrimaryExpression() {
    var type, token, expr;
    if (match('(')) return parseGroupExpression();
    if (match('[')) return parseArrayInitialiser();
    if (match('{')) return parseObjectInitialiser();
    type = lookahead.type;
    index = lookahead.start;
    if (type === TokenIdentifier || legalKeywords[lookahead.value]) expr = finishIdentifier(lex().value);
    else if (type === TokenStringLiteral || type === TokenNumericLiteral) {
        if (lookahead.octal) throwError(lookahead, MessageStrictOctalLiteral);
        expr = finishLiteral(lex());
    } else if (type === TokenKeyword) throw new Error(DISABLED);
    else if (type === TokenBooleanLiteral) {
        token = lex();
        token.value = token.value === 'true';
        expr = finishLiteral(token);
    } else if (type === TokenNullLiteral) {
        token = lex();
        token.value = null;
        expr = finishLiteral(token);
    } else if (match('/') || match('/=')) {
        expr = finishLiteral(scanRegExp());
        peek();
    } else throwUnexpected(lex());
    return expr;
}
// 11.2 Left-Hand-Side Expressions
function parseArguments() {
    const args = [];
    expect('(');
    if (!match(')')) while(index < length){
        args.push(parseConditionalExpression());
        if (match(')')) break;
        expect(',');
    }
    expect(')');
    return args;
}
function parseNonComputedProperty() {
    index = lookahead.start;
    const token = lex();
    if (!isIdentifierName(token)) throwUnexpected(token);
    return finishIdentifier(token.value);
}
function parseNonComputedMember() {
    expect('.');
    return parseNonComputedProperty();
}
function parseComputedMember() {
    expect('[');
    const expr = parseExpression();
    expect(']');
    return expr;
}
function parseLeftHandSideExpressionAllowCall() {
    var expr, args, property;
    expr = parsePrimaryExpression();
    for(;;){
        if (match('.')) {
            property = parseNonComputedMember();
            expr = finishMemberExpression('.', expr, property);
        } else if (match('(')) {
            args = parseArguments();
            expr = finishCallExpression(expr, args);
        } else if (match('[')) {
            property = parseComputedMember();
            expr = finishMemberExpression('[', expr, property);
        } else break;
    }
    return expr;
}
// 11.3 Postfix Expressions
function parsePostfixExpression() {
    const expr = parseLeftHandSideExpressionAllowCall();
    if (lookahead.type === TokenPunctuator) {
        if (match('++') || match('--')) throw new Error(DISABLED);
    }
    return expr;
}
// 11.4 Unary Operators
function parseUnaryExpression() {
    var token, expr;
    if (lookahead.type !== TokenPunctuator && lookahead.type !== TokenKeyword) expr = parsePostfixExpression();
    else if (match('++') || match('--')) throw new Error(DISABLED);
    else if (match('+') || match('-') || match('~') || match('!')) {
        token = lex();
        expr = parseUnaryExpression();
        expr = finishUnaryExpression(token.value, expr);
    } else if (matchKeyword('delete') || matchKeyword('void') || matchKeyword('typeof')) throw new Error(DISABLED);
    else expr = parsePostfixExpression();
    return expr;
}
function binaryPrecedence(token) {
    let prec = 0;
    if (token.type !== TokenPunctuator && token.type !== TokenKeyword) return 0;
    switch(token.value){
        case '||':
            prec = 1;
            break;
        case '&&':
            prec = 2;
            break;
        case '|':
            prec = 3;
            break;
        case '^':
            prec = 4;
            break;
        case '&':
            prec = 5;
            break;
        case '==':
        case '!=':
        case '===':
        case '!==':
            prec = 6;
            break;
        case '<':
        case '>':
        case '<=':
        case '>=':
        case 'instanceof':
        case 'in':
            prec = 7;
            break;
        case '<<':
        case '>>':
        case '>>>':
            prec = 8;
            break;
        case '+':
        case '-':
            prec = 9;
            break;
        case '*':
        case '/':
        case '%':
            prec = 11;
            break;
    }
    return prec;
}
// 11.5 Multiplicative Operators
// 11.6 Additive Operators
// 11.7 Bitwise Shift Operators
// 11.8 Relational Operators
// 11.9 Equality Operators
// 11.10 Binary Bitwise Operators
// 11.11 Binary Logical Operators
function parseBinaryExpression() {
    var marker, markers, expr, token, prec, stack, right, operator, left, i;
    marker = lookahead;
    left = parseUnaryExpression();
    token = lookahead;
    prec = binaryPrecedence(token);
    if (prec === 0) return left;
    token.prec = prec;
    lex();
    markers = [
        marker,
        lookahead
    ];
    right = parseUnaryExpression();
    stack = [
        left,
        token,
        right
    ];
    while((prec = binaryPrecedence(lookahead)) > 0){
        // Reduce: make a binary expression from the three topmost entries.
        while(stack.length > 2 && prec <= stack[stack.length - 2].prec){
            right = stack.pop();
            operator = stack.pop().value;
            left = stack.pop();
            markers.pop();
            expr = finishBinaryExpression(operator, left, right);
            stack.push(expr);
        }
        // Shift.
        token = lex();
        token.prec = prec;
        stack.push(token);
        markers.push(lookahead);
        expr = parseUnaryExpression();
        stack.push(expr);
    }
    // Final reduce to clean-up the stack.
    i = stack.length - 1;
    expr = stack[i];
    markers.pop();
    while(i > 1){
        markers.pop();
        expr = finishBinaryExpression(stack[i - 1].value, stack[i - 2], expr);
        i -= 2;
    }
    return expr;
}
// 11.12 Conditional Operator
function parseConditionalExpression() {
    var expr, consequent, alternate;
    expr = parseBinaryExpression();
    if (match('?')) {
        lex();
        consequent = parseConditionalExpression();
        expect(':');
        alternate = parseConditionalExpression();
        expr = finishConditionalExpression(expr, consequent, alternate);
    }
    return expr;
}
// 11.14 Comma Operator
function parseExpression() {
    const expr = parseConditionalExpression();
    if (match(',')) throw new Error(DISABLED); // no sequence expressions
    return expr;
}
function parser(code) {
    source = code;
    index = 0;
    length = source.length;
    lookahead = null;
    peek();
    const expr = parseExpression();
    if (lookahead.type !== TokenEOF) throw new Error('Unexpect token after expression.');
    return expr;
}
var Constants = {
    NaN: 'NaN',
    E: 'Math.E',
    LN2: 'Math.LN2',
    LN10: 'Math.LN10',
    LOG2E: 'Math.LOG2E',
    LOG10E: 'Math.LOG10E',
    PI: 'Math.PI',
    SQRT1_2: 'Math.SQRT1_2',
    SQRT2: 'Math.SQRT2',
    MIN_VALUE: 'Number.MIN_VALUE',
    MAX_VALUE: 'Number.MAX_VALUE'
};
function Functions(codegen) {
    function fncall(name, args, cast, type) {
        let obj = codegen(args[0]);
        if (cast) {
            obj = cast + '(' + obj + ')';
            if (cast.lastIndexOf('new ', 0) === 0) obj = '(' + obj + ')';
        }
        return obj + '.' + name + (type < 0 ? '' : type === 0 ? '()' : '(' + args.slice(1).map(codegen).join(',') + ')');
    }
    function fn(name, cast, type) {
        return (args)=>fncall(name, args, cast, type);
    }
    const DATE = 'new Date', STRING = 'String', REGEXP = 'RegExp';
    return {
        // MATH functions
        isNaN: 'Number.isNaN',
        isFinite: 'Number.isFinite',
        abs: 'Math.abs',
        acos: 'Math.acos',
        asin: 'Math.asin',
        atan: 'Math.atan',
        atan2: 'Math.atan2',
        ceil: 'Math.ceil',
        cos: 'Math.cos',
        exp: 'Math.exp',
        floor: 'Math.floor',
        hypot: 'Math.hypot',
        log: 'Math.log',
        max: 'Math.max',
        min: 'Math.min',
        pow: 'Math.pow',
        random: 'Math.random',
        round: 'Math.round',
        sin: 'Math.sin',
        sqrt: 'Math.sqrt',
        tan: 'Math.tan',
        clamp: function(args) {
            if (args.length < 3) (0, _vegaUtil.error)('Missing arguments to clamp function.');
            if (args.length > 3) (0, _vegaUtil.error)('Too many arguments to clamp function.');
            const a = args.map(codegen);
            return 'Math.max(' + a[1] + ', Math.min(' + a[2] + ',' + a[0] + '))';
        },
        // DATE functions
        now: 'Date.now',
        utc: 'Date.UTC',
        datetime: DATE,
        date: fn('getDate', DATE, 0),
        day: fn('getDay', DATE, 0),
        year: fn('getFullYear', DATE, 0),
        month: fn('getMonth', DATE, 0),
        hours: fn('getHours', DATE, 0),
        minutes: fn('getMinutes', DATE, 0),
        seconds: fn('getSeconds', DATE, 0),
        milliseconds: fn('getMilliseconds', DATE, 0),
        time: fn('getTime', DATE, 0),
        timezoneoffset: fn('getTimezoneOffset', DATE, 0),
        utcdate: fn('getUTCDate', DATE, 0),
        utcday: fn('getUTCDay', DATE, 0),
        utcyear: fn('getUTCFullYear', DATE, 0),
        utcmonth: fn('getUTCMonth', DATE, 0),
        utchours: fn('getUTCHours', DATE, 0),
        utcminutes: fn('getUTCMinutes', DATE, 0),
        utcseconds: fn('getUTCSeconds', DATE, 0),
        utcmilliseconds: fn('getUTCMilliseconds', DATE, 0),
        // sequence functions
        length: fn('length', null, -1),
        // STRING functions
        parseFloat: 'parseFloat',
        parseInt: 'parseInt',
        upper: fn('toUpperCase', STRING, 0),
        lower: fn('toLowerCase', STRING, 0),
        substring: fn('substring', STRING),
        split: fn('split', STRING),
        trim: fn('trim', STRING, 0),
        // base64 encode/decode
        btoa: 'btoa',
        atob: 'atob',
        // REGEXP functions
        regexp: REGEXP,
        test: fn('test', REGEXP),
        // Control Flow functions
        if: function(args) {
            if (args.length < 3) (0, _vegaUtil.error)('Missing arguments to if function.');
            if (args.length > 3) (0, _vegaUtil.error)('Too many arguments to if function.');
            const a = args.map(codegen);
            return '(' + a[0] + '?' + a[1] + ':' + a[2] + ')';
        }
    };
}
function stripQuotes(s) {
    const n = s && s.length - 1;
    return n && (s[0] === '"' && s[n] === '"' || s[0] === '\'' && s[n] === '\'') ? s.slice(1, -1) : s;
}
function codegen(opt) {
    opt = opt || {};
    const allowed = opt.allowed ? (0, _vegaUtil.toSet)(opt.allowed) : {}, forbidden = opt.forbidden ? (0, _vegaUtil.toSet)(opt.forbidden) : {}, constants = opt.constants || Constants, functions = (opt.functions || Functions)(visit), globalvar = opt.globalvar, fieldvar = opt.fieldvar, outputGlobal = (0, _vegaUtil.isFunction)(globalvar) ? globalvar : (id)=>`${globalvar}["${id}"]`;
    let globals = {}, fields = {}, memberDepth = 0;
    function visit(ast) {
        if ((0, _vegaUtil.isString)(ast)) return ast;
        const generator = Generators[ast.type];
        if (generator == null) (0, _vegaUtil.error)('Unsupported type: ' + ast.type);
        return generator(ast);
    }
    const Generators = {
        Literal: (n)=>n.raw,
        Identifier: (n)=>{
            const id = n.name;
            if (memberDepth > 0) return id;
            else if ((0, _vegaUtil.hasOwnProperty)(forbidden, id)) return (0, _vegaUtil.error)('Illegal identifier: ' + id);
            else if ((0, _vegaUtil.hasOwnProperty)(constants, id)) return constants[id];
            else if ((0, _vegaUtil.hasOwnProperty)(allowed, id)) return id;
            else {
                globals[id] = 1;
                return outputGlobal(id);
            }
        },
        MemberExpression: (n)=>{
            const d = !n.computed, o = visit(n.object);
            if (d) memberDepth += 1;
            const p = visit(n.property);
            if (o === fieldvar) // strip quotes to sanitize field name (#1653)
            fields[stripQuotes(p)] = 1;
            if (d) memberDepth -= 1;
            return o + (d ? '.' + p : '[' + p + ']');
        },
        CallExpression: (n)=>{
            if (n.callee.type !== 'Identifier') (0, _vegaUtil.error)('Illegal callee type: ' + n.callee.type);
            const callee = n.callee.name, args = n.arguments, fn = (0, _vegaUtil.hasOwnProperty)(functions, callee) && functions[callee];
            if (!fn) (0, _vegaUtil.error)('Unrecognized function: ' + callee);
            return (0, _vegaUtil.isFunction)(fn) ? fn(args) : fn + '(' + args.map(visit).join(',') + ')';
        },
        ArrayExpression: (n)=>'[' + n.elements.map(visit).join(',') + ']',
        BinaryExpression: (n)=>'(' + visit(n.left) + ' ' + n.operator + ' ' + visit(n.right) + ')',
        UnaryExpression: (n)=>'(' + n.operator + visit(n.argument) + ')',
        ConditionalExpression: (n)=>'(' + visit(n.test) + '?' + visit(n.consequent) + ':' + visit(n.alternate) + ')',
        LogicalExpression: (n)=>'(' + visit(n.left) + n.operator + visit(n.right) + ')',
        ObjectExpression: (n)=>'{' + n.properties.map(visit).join(',') + '}',
        Property: (n)=>{
            memberDepth += 1;
            const k = visit(n.key);
            memberDepth -= 1;
            return k + ':' + visit(n.value);
        }
    };
    function codegen(ast) {
        const result = {
            code: visit(ast),
            globals: Object.keys(globals),
            fields: Object.keys(fields)
        };
        globals = {};
        fields = {};
        return result;
    }
    codegen.functions = functions;
    codegen.constants = constants;
    return codegen;
}

},{"vega-util":"7f6sQ","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"faaVf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "areaRingSum", ()=>areaRingSum);
parcelHelpers.export(exports, "areaStream", ()=>areaStream);
parcelHelpers.export(exports, "default", ()=>function(object) {
        areaSum = new (0, _d3Array.Adder)();
        (0, _streamJsDefault.default)(object, areaStream);
        return areaSum * 2;
    });
var _d3Array = require("d3-array");
var _mathJs = require("./math.js");
var _noopJs = require("./noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var areaRingSum = new (0, _d3Array.Adder)();
// hello?
var areaSum = new (0, _d3Array.Adder)(), lambda00, phi00, lambda0, cosPhi0, sinPhi0;
var areaStream = {
    point: (0, _noopJsDefault.default),
    lineStart: (0, _noopJsDefault.default),
    lineEnd: (0, _noopJsDefault.default),
    polygonStart: function() {
        areaRingSum = new (0, _d3Array.Adder)();
        areaStream.lineStart = areaRingStart;
        areaStream.lineEnd = areaRingEnd;
    },
    polygonEnd: function() {
        var areaRing = +areaRingSum;
        areaSum.add(areaRing < 0 ? (0, _mathJs.tau) + areaRing : areaRing);
        this.lineStart = this.lineEnd = this.point = (0, _noopJsDefault.default);
    },
    sphere: function() {
        areaSum.add((0, _mathJs.tau));
    }
};
function areaRingStart() {
    areaStream.point = areaPointFirst;
}
function areaRingEnd() {
    areaPoint(lambda00, phi00);
}
function areaPointFirst(lambda, phi) {
    areaStream.point = areaPoint;
    lambda00 = lambda, phi00 = phi;
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    lambda0 = lambda, cosPhi0 = (0, _mathJs.cos)(phi = phi / 2 + (0, _mathJs.quarterPi)), sinPhi0 = (0, _mathJs.sin)(phi);
}
function areaPoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    phi = phi / 2 + (0, _mathJs.quarterPi); // half the angular distance from south pole
    // Spherical excess E for a spherical triangle with vertices: south pole,
    // previous point, current point.  Uses a formula derived from Cagnoli’s
    // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
    var dLambda = lambda - lambda0, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = (0, _mathJs.cos)(phi), sinPhi = (0, _mathJs.sin)(phi), k = sinPhi0 * sinPhi, u = cosPhi0 * cosPhi + k * (0, _mathJs.cos)(adLambda), v = k * sdLambda * (0, _mathJs.sin)(adLambda);
    areaRingSum.add((0, _mathJs.atan2)(v, u));
    // Advance the previous points.
    lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

},{"d3-array":"aPoQh","./math.js":"bttmd","./noop.js":"eRuPB","./stream.js":"gKr6k","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hvWAG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(feature) {
        var i, n, a, b, merged, deltaMax, delta;
        phi1 = lambda1 = -(lambda0 = phi0 = Infinity);
        ranges = [];
        (0, _streamJsDefault.default)(feature, boundsStream);
        // First, sort ranges by their minimum longitudes.
        if (n = ranges.length) {
            ranges.sort(rangeCompare);
            // Then, merge any ranges that overlap.
            for(i = 1, a = ranges[0], merged = [
                a
            ]; i < n; ++i){
                b = ranges[i];
                if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
                    if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
                    if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
                } else merged.push(a = b);
            }
            // Finally, find the largest gap between the merged ranges.
            // The final bounding box will be the inverse of this gap.
            for(deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i){
                b = merged[i];
                if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0 = b[0], lambda1 = a[1];
            }
        }
        ranges = range = null;
        return lambda0 === Infinity || phi0 === Infinity ? [
            [
                NaN,
                NaN
            ],
            [
                NaN,
                NaN
            ]
        ] : [
            [
                lambda0,
                phi0
            ],
            [
                lambda1,
                phi1
            ]
        ];
    });
var _d3Array = require("d3-array");
var _areaJs = require("./area.js");
var _cartesianJs = require("./cartesian.js");
var _mathJs = require("./math.js");
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var lambda0, phi0, lambda1, phi1, lambda2, lambda00, phi00, p0, deltaSum, ranges, range;
var boundsStream = {
    point: boundsPoint,
    lineStart: boundsLineStart,
    lineEnd: boundsLineEnd,
    polygonStart: function() {
        boundsStream.point = boundsRingPoint;
        boundsStream.lineStart = boundsRingStart;
        boundsStream.lineEnd = boundsRingEnd;
        deltaSum = new (0, _d3Array.Adder)();
        (0, _areaJs.areaStream).polygonStart();
    },
    polygonEnd: function() {
        (0, _areaJs.areaStream).polygonEnd();
        boundsStream.point = boundsPoint;
        boundsStream.lineStart = boundsLineStart;
        boundsStream.lineEnd = boundsLineEnd;
        if ((0, _areaJs.areaRingSum) < 0) lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
        else if (deltaSum > (0, _mathJs.epsilon)) phi1 = 90;
        else if (deltaSum < -(0, _mathJs.epsilon)) phi0 = -90;
        range[0] = lambda0, range[1] = lambda1;
    },
    sphere: function() {
        lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    }
};
function boundsPoint(lambda, phi) {
    ranges.push(range = [
        lambda0 = lambda,
        lambda1 = lambda
    ]);
    if (phi < phi0) phi0 = phi;
    if (phi > phi1) phi1 = phi;
}
function linePoint(lambda, phi) {
    var p = (0, _cartesianJs.cartesian)([
        lambda * (0, _mathJs.radians),
        phi * (0, _mathJs.radians)
    ]);
    if (p0) {
        var normal = (0, _cartesianJs.cartesianCross)(p0, p), equatorial = [
            normal[1],
            -normal[0],
            0
        ], inflection = (0, _cartesianJs.cartesianCross)(equatorial, normal);
        (0, _cartesianJs.cartesianNormalizeInPlace)(inflection);
        inflection = (0, _cartesianJs.spherical)(inflection);
        var delta = lambda - lambda2, sign = delta > 0 ? 1 : -1, lambdai = inflection[0] * (0, _mathJs.degrees) * sign, phii, antimeridian = (0, _mathJs.abs)(delta) > 180;
        if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = inflection[1] * (0, _mathJs.degrees);
            if (phii > phi1) phi1 = phii;
        } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = -inflection[1] * (0, _mathJs.degrees);
            if (phii < phi0) phi0 = phii;
        } else {
            if (phi < phi0) phi0 = phi;
            if (phi > phi1) phi1 = phi;
        }
        if (antimeridian) {
            if (lambda < lambda2) {
                if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
            } else if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        } else if (lambda1 >= lambda0) {
            if (lambda < lambda0) lambda0 = lambda;
            if (lambda > lambda1) lambda1 = lambda;
        } else {
            if (lambda > lambda2) {
                if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
            } else if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        }
    } else ranges.push(range = [
        lambda0 = lambda,
        lambda1 = lambda
    ]);
    if (phi < phi0) phi0 = phi;
    if (phi > phi1) phi1 = phi;
    p0 = p, lambda2 = lambda;
}
function boundsLineStart() {
    boundsStream.point = linePoint;
}
function boundsLineEnd() {
    range[0] = lambda0, range[1] = lambda1;
    boundsStream.point = boundsPoint;
    p0 = null;
}
function boundsRingPoint(lambda, phi) {
    if (p0) {
        var delta = lambda - lambda2;
        deltaSum.add((0, _mathJs.abs)(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
    } else lambda00 = lambda, phi00 = phi;
    (0, _areaJs.areaStream).point(lambda, phi);
    linePoint(lambda, phi);
}
function boundsRingStart() {
    (0, _areaJs.areaStream).lineStart();
}
function boundsRingEnd() {
    boundsRingPoint(lambda00, phi00);
    (0, _areaJs.areaStream).lineEnd();
    if ((0, _mathJs.abs)(deltaSum) > (0, _mathJs.epsilon)) lambda0 = -(lambda1 = 180);
    range[0] = lambda0, range[1] = lambda1;
    p0 = null;
}
// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
    return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}
function rangeCompare(a, b) {
    return a[0] - b[0];
}
function rangeContains(range, x) {
    return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

},{"d3-array":"aPoQh","./area.js":"faaVf","./cartesian.js":"h01nT","./math.js":"bttmd","./stream.js":"gKr6k","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3QJSV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(object) {
        W0 = W1 = X0 = Y0 = Z0 = X1 = Y1 = Z1 = 0;
        X2 = new (0, _d3Array.Adder)();
        Y2 = new (0, _d3Array.Adder)();
        Z2 = new (0, _d3Array.Adder)();
        (0, _streamJsDefault.default)(object, centroidStream);
        var x = +X2, y = +Y2, z = +Z2, m = (0, _mathJs.hypot)(x, y, z);
        // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
        if (m < (0, _mathJs.epsilon2)) {
            x = X1, y = Y1, z = Z1;
            // If the feature has zero length, fall back to arithmetic mean of point vectors.
            if (W1 < (0, _mathJs.epsilon)) x = X0, y = Y0, z = Z0;
            m = (0, _mathJs.hypot)(x, y, z);
            // If the feature still has an undefined ccentroid, then return.
            if (m < (0, _mathJs.epsilon2)) return [
                NaN,
                NaN
            ];
        }
        return [
            (0, _mathJs.atan2)(y, x) * (0, _mathJs.degrees),
            (0, _mathJs.asin)(z / m) * (0, _mathJs.degrees)
        ];
    });
var _d3Array = require("d3-array");
var _mathJs = require("./math.js");
var _noopJs = require("./noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var W0, W1, X0, Y0, Z0, X1, Y1, Z1, X2, Y2, Z2, lambda00, phi00, x0, y0, z0; // previous point
var centroidStream = {
    sphere: (0, _noopJsDefault.default),
    point: centroidPoint,
    lineStart: centroidLineStart,
    lineEnd: centroidLineEnd,
    polygonStart: function() {
        centroidStream.lineStart = centroidRingStart;
        centroidStream.lineEnd = centroidRingEnd;
    },
    polygonEnd: function() {
        centroidStream.lineStart = centroidLineStart;
        centroidStream.lineEnd = centroidLineEnd;
    }
};
// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi);
    centroidPointCartesian(cosPhi * (0, _mathJs.cos)(lambda), cosPhi * (0, _mathJs.sin)(lambda), (0, _mathJs.sin)(phi));
}
function centroidPointCartesian(x, y, z) {
    ++W0;
    X0 += (x - X0) / W0;
    Y0 += (y - Y0) / W0;
    Z0 += (z - Z0) / W0;
}
function centroidLineStart() {
    centroidStream.point = centroidLinePointFirst;
}
function centroidLinePointFirst(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi);
    x0 = cosPhi * (0, _mathJs.cos)(lambda);
    y0 = cosPhi * (0, _mathJs.sin)(lambda);
    z0 = (0, _mathJs.sin)(phi);
    centroidStream.point = centroidLinePoint;
    centroidPointCartesian(x0, y0, z0);
}
function centroidLinePoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi), x = cosPhi * (0, _mathJs.cos)(lambda), y = cosPhi * (0, _mathJs.sin)(lambda), z = (0, _mathJs.sin)(phi), w = (0, _mathJs.atan2)((0, _mathJs.sqrt)((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
    W1 += w;
    X1 += w * (x0 + (x0 = x));
    Y1 += w * (y0 + (y0 = y));
    Z1 += w * (z0 + (z0 = z));
    centroidPointCartesian(x0, y0, z0);
}
function centroidLineEnd() {
    centroidStream.point = centroidPoint;
}
// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
    centroidStream.point = centroidRingPointFirst;
}
function centroidRingEnd() {
    centroidRingPoint(lambda00, phi00);
    centroidStream.point = centroidPoint;
}
function centroidRingPointFirst(lambda, phi) {
    lambda00 = lambda, phi00 = phi;
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    centroidStream.point = centroidRingPoint;
    var cosPhi = (0, _mathJs.cos)(phi);
    x0 = cosPhi * (0, _mathJs.cos)(lambda);
    y0 = cosPhi * (0, _mathJs.sin)(lambda);
    z0 = (0, _mathJs.sin)(phi);
    centroidPointCartesian(x0, y0, z0);
}
function centroidRingPoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi), x = cosPhi * (0, _mathJs.cos)(lambda), y = cosPhi * (0, _mathJs.sin)(lambda), z = (0, _mathJs.sin)(phi), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = (0, _mathJs.hypot)(cx, cy, cz), w = (0, _mathJs.asin)(m), v = m && -w / m; // area weight multiplier
    X2.add(v * cx);
    Y2.add(v * cy);
    Z2.add(v * cz);
    W1 += w;
    X1 += w * (x0 + (x0 = x));
    Y1 += w * (y0 + (y0 = y));
    Z1 += w * (z0 + (z0 = z));
    centroidPointCartesian(x0, y0, z0);
}

},{"d3-array":"aPoQh","./math.js":"bttmd","./noop.js":"eRuPB","./stream.js":"gKr6k","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"b6ZcA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectionIdTest", ()=>selectionIdTest);
parcelHelpers.export(exports, "selectionResolve", ()=>selectionResolve);
parcelHelpers.export(exports, "selectionTest", ()=>selectionTest);
parcelHelpers.export(exports, "selectionTuples", ()=>selectionTuples);
parcelHelpers.export(exports, "selectionVisitor", ()=>selectionVisitor);
var _d3Array = require("d3-array");
var _vegaUtil = require("vega-util");
var _vegaExpression = require("vega-expression");
// Registers vega-util field accessors to protect against XSS attacks
const SELECTION_GETTER = Symbol('vega_selection_getter');
function getter(f) {
    if (!f.getter || !f.getter[SELECTION_GETTER]) {
        f.getter = (0, _vegaUtil.field)(f.field);
        f.getter[SELECTION_GETTER] = true;
    }
    return f.getter;
}
const Intersect = 'intersect';
const Union = 'union';
const VlMulti = 'vlMulti';
const VlPoint = 'vlPoint';
const Or = 'or';
const And = 'and';
const SelectionId = '_vgsid_';
const $selectionId = (0, _vegaUtil.field)(SelectionId);
const TYPE_ENUM = 'E', TYPE_RANGE_INC = 'R', TYPE_RANGE_EXC = 'R-E', TYPE_RANGE_LE = 'R-LE', TYPE_RANGE_RE = 'R-RE', TYPE_PRED_LT = 'E-LT', TYPE_PRED_LTE = 'E-LTE', TYPE_PRED_GT = 'E-GT', TYPE_PRED_GTE = 'E-GTE', TYPE_PRED_VALID = 'E-VALID', TYPE_PRED_ONE_OF = 'E-ONE', UNIT_INDEX = 'index:unit';
// TODO: revisit date coercion?
function testPoint(datum, entry) {
    var fields = entry.fields, values = entry.values, n = fields.length, i = 0, dval, f;
    for(; i < n; ++i){
        f = fields[i];
        dval = getter(f)(datum);
        if ((0, _vegaUtil.isDate)(dval)) dval = (0, _vegaUtil.toNumber)(dval);
        if ((0, _vegaUtil.isDate)(values[i])) values[i] = (0, _vegaUtil.toNumber)(values[i]);
        if ((0, _vegaUtil.isArray)(values[i]) && (0, _vegaUtil.isDate)(values[i][0])) values[i] = values[i].map((0, _vegaUtil.toNumber));
        if (f.type === TYPE_ENUM) {
            // Enumerated fields can either specify individual values (single/multi selections)
            // or an array of values (interval selections).
            if ((0, _vegaUtil.isArray)(values[i]) ? !values[i].includes(dval) : dval !== values[i]) return false;
        } else {
            if (f.type === TYPE_RANGE_INC) {
                if (!(0, _vegaUtil.inrange)(dval, values[i])) return false;
            } else if (f.type === TYPE_RANGE_RE) {
                // Discrete selection of bins test within the range [bin_start, bin_end).
                if (!(0, _vegaUtil.inrange)(dval, values[i], true, false)) return false;
            } else if (f.type === TYPE_RANGE_EXC) {
                // 'R-E'/'R-LE' included for completeness.
                if (!(0, _vegaUtil.inrange)(dval, values[i], false, false)) return false;
            } else if (f.type === TYPE_RANGE_LE) {
                if (!(0, _vegaUtil.inrange)(dval, values[i], false, true)) return false;
            } else if (f.type === TYPE_PRED_LT) {
                if (dval >= values[i]) return false;
            } else if (f.type === TYPE_PRED_LTE) {
                if (dval > values[i]) return false;
            } else if (f.type === TYPE_PRED_GT) {
                if (dval <= values[i]) return false;
            } else if (f.type === TYPE_PRED_GTE) {
                if (dval < values[i]) return false;
            } else if (f.type === TYPE_PRED_VALID) {
                if (dval === null || isNaN(dval)) return false;
            } else if (f.type === TYPE_PRED_ONE_OF) {
                if (values[i].indexOf(dval) === -1) return false;
            }
        }
    }
    return true;
}
/**
 * Tests if a tuple is contained within an interactive selection.
 * @param {string} name - The name of the data set representing the selection.
 *  Tuples in the dataset are of the form
 *  {unit: string, fields: array<fielddef>, values: array<*>}.
 *  Fielddef is of the form
 *  {field: string, channel: string, type: 'E' | 'R'} where
 *  'type' identifies whether tuples in the dataset enumerate
 *  values for the field, or specify a continuous range.
 * @param {object} datum - The tuple to test for inclusion.
 * @param {string} op - The set operation for combining selections.
 *   One of 'intersect' or 'union' (default).
 * @return {boolean} - True if the datum is in the selection, false otherwise.
 */ function selectionTest(name, datum, op) {
    var data = this.context.data[name], entries = data ? data.values.value : [], unitIdx = data ? data[UNIT_INDEX] && data[UNIT_INDEX].value : undefined, intersect = op === Intersect, n = entries.length, i = 0, entry, miss, count, unit, b;
    for(; i < n; ++i){
        entry = entries[i];
        if (unitIdx && intersect) {
            // multi selections union within the same unit and intersect across units.
            miss = miss || {};
            count = miss[unit = entry.unit] || 0;
            // if we've already matched this unit, skip.
            if (count === -1) continue;
            b = testPoint(datum, entry);
            miss[unit] = b ? -1 : ++count;
            // if we match and there are no other units return true
            // if we've missed against all tuples in this unit return false
            if (b && unitIdx.size === 1) return true;
            if (!b && count === unitIdx.get(unit).count) return false;
        } else {
            b = testPoint(datum, entry);
            // if we find a miss and we do require intersection return false
            // if we find a match and we don't require intersection return true
            if (intersect ^ b) return b;
        }
    }
    // if intersecting and we made it here, then we saw no misses
    // if not intersecting, then we saw no matches
    // if no active selections, return false
    return n && intersect;
}
const bisect = (0, _d3Array.bisector)($selectionId), bisectLeft = bisect.left, bisectRight = bisect.right;
function selectionIdTest(name, datum, op) {
    const data = this.context.data[name], entries = data ? data.values.value : [], unitIdx = data ? data[UNIT_INDEX] && data[UNIT_INDEX].value : undefined, intersect = op === Intersect, value = $selectionId(datum), index = bisectLeft(entries, value);
    if (index === entries.length) return false;
    if ($selectionId(entries[index]) !== value) return false;
    if (unitIdx && intersect) {
        if (unitIdx.size === 1) return true;
        if (bisectRight(entries, value) - index < unitIdx.size) return false;
    }
    return true;
}
/**
 * Maps an array of scene graph items to an array of selection tuples.
 * @param {string} name  - The name of the dataset representing the selection.
 * @param {string} base  - The base object that generated tuples extend.
 *
 * @returns {array} An array of selection entries for the given unit.
 */ function selectionTuples(array, base) {
    return array.map((x)=>(0, _vegaUtil.extend)(base.fields ? {
            values: base.fields.map((f)=>getter(f)(x.datum))
        } : {
            [SelectionId]: $selectionId(x.datum)
        }, base));
}
/**
 * Resolves selection for use as a scale domain or reads via the API.
 * @param {string} name - The name of the dataset representing the selection
 * @param {string} [op='union'] - The set operation for combining selections.
 *                 One of 'intersect' or 'union' (default).
 * @param {boolean} isMulti - Identifies a "multi" selection to perform more
 *                 expensive resolution computation.
 * @param {boolean} vl5 - With Vega-Lite v5, "multi" selections are now called "point"
 *                 selections, and thus the resolved tuple should reflect this name.
 *                 This parameter allows us to reflect this change without triggering
 *                 a major version bump for Vega.
 * @returns {object} An object of selected fields and values.
 */ function selectionResolve(name, op, isMulti, vl5) {
    var data = this.context.data[name], entries = data ? data.values.value : [], resolved = {}, multiRes = {}, types = {}, entry, fields, values, unit, field, value, res, resUnit, type, union, n = entries.length, i = 0, j, m;
    // First union all entries within the same unit.
    for(; i < n; ++i){
        entry = entries[i];
        unit = entry.unit;
        fields = entry.fields;
        values = entry.values;
        if (fields && values) {
            // Intentional selection stores
            for(j = 0, m = fields.length; j < m; ++j){
                field = fields[j];
                res = resolved[field.field] || (resolved[field.field] = {});
                resUnit = res[unit] || (res[unit] = []);
                types[field.field] = type = field.type.charAt(0);
                union = ops[`${type}_union`];
                res[unit] = union(resUnit, (0, _vegaUtil.array)(values[j]));
            }
            // If the same multi-selection is repeated over views and projected over
            // an encoding, it may operate over different fields making it especially
            // tricky to reliably resolve it. At best, we can de-dupe identical entries
            // but doing so may be more computationally expensive than it is worth.
            // Instead, for now, we simply transform our store representation into
            // a more human-friendly one.
            if (isMulti) {
                resUnit = multiRes[unit] || (multiRes[unit] = []);
                resUnit.push((0, _vegaUtil.array)(values).reduce((obj, curr, j)=>(obj[fields[j].field] = curr, obj), {}));
            }
        } else {
            // Short circuit extensional selectionId stores which hold sorted IDs unique to each unit.
            field = SelectionId;
            value = $selectionId(entry);
            res = resolved[field] || (resolved[field] = {});
            resUnit = res[unit] || (res[unit] = []);
            resUnit.push(value);
            if (isMulti) {
                resUnit = multiRes[unit] || (multiRes[unit] = []);
                resUnit.push({
                    [SelectionId]: value
                });
            }
        }
    }
    // Then resolve fields across units as per the op.
    op = op || Union;
    if (resolved[SelectionId]) resolved[SelectionId] = ops[`${SelectionId}_${op}`](...Object.values(resolved[SelectionId]));
    else Object.keys(resolved).forEach((field)=>{
        resolved[field] = Object.keys(resolved[field]).map((unit)=>resolved[field][unit]).reduce((acc, curr)=>acc === undefined ? curr : ops[`${types[field]}_${op}`](acc, curr));
    });
    entries = Object.keys(multiRes);
    if (isMulti && entries.length) {
        const key = vl5 ? VlPoint : VlMulti;
        resolved[key] = op === Union ? {
            [Or]: entries.reduce((acc, k)=>(acc.push(...multiRes[k]), acc), [])
        } : {
            [And]: entries.map((k)=>({
                    [Or]: multiRes[k]
                }))
        };
    }
    return resolved;
}
var ops = {
    [`${SelectionId}_union`]: (0, _d3Array.union),
    [`${SelectionId}_intersect`]: (0, _d3Array.intersection),
    E_union: function(base, value) {
        if (!base.length) return value;
        var i = 0, n = value.length;
        for(; i < n; ++i)if (!base.includes(value[i])) base.push(value[i]);
        return base;
    },
    E_intersect: function(base, value) {
        return !base.length ? value : base.filter((v)=>value.includes(v));
    },
    R_union: function(base, value) {
        var lo = (0, _vegaUtil.toNumber)(value[0]), hi = (0, _vegaUtil.toNumber)(value[1]);
        if (lo > hi) {
            lo = value[1];
            hi = value[0];
        }
        if (!base.length) return [
            lo,
            hi
        ];
        if (base[0] > lo) base[0] = lo;
        if (base[1] < hi) base[1] = hi;
        return base;
    },
    R_intersect: function(base, value) {
        var lo = (0, _vegaUtil.toNumber)(value[0]), hi = (0, _vegaUtil.toNumber)(value[1]);
        if (lo > hi) {
            lo = value[1];
            hi = value[0];
        }
        if (!base.length) return [
            lo,
            hi
        ];
        if (hi < base[0] || base[1] < lo) return [];
        else {
            if (base[0] < lo) base[0] = lo;
            if (base[1] > hi) base[1] = hi;
        }
        return base;
    }
};
const DataPrefix = ':', IndexPrefix = '@';
function selectionVisitor(name, args, scope, params) {
    if (args[0].type !== (0, _vegaExpression.Literal)) (0, _vegaUtil.error)('First argument to selection functions must be a string literal.');
    const data = args[0].value, op = args.length >= 2 && (0, _vegaUtil.peek)(args).value, field = 'unit', indexName = IndexPrefix + field, dataName = DataPrefix + data;
    // eslint-disable-next-line no-prototype-builtins
    if (op === Intersect && !(0, _vegaUtil.hasOwnProperty)(params, indexName)) params[indexName] = scope.getData(data).indataRef(scope, field);
    // eslint-disable-next-line no-prototype-builtins
    if (!(0, _vegaUtil.hasOwnProperty)(params, dataName)) params[dataName] = scope.getData(data).tuplesRef();
}

},{"d3-array":[["bisector","iWiWc","default"],["intersection","77dMh","default"],["union","6iv1Q","default"]],"vega-util":"7f6sQ","vega-expression":"clSwj","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hNLpK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "context", ()=>context);
var _vegaUtil = require("vega-util");
var _vegaDataflow = require("vega-dataflow");
/**
 * Parse a serialized dataflow specification.
 */ function parse(spec) {
    const ctx = this, operators = spec.operators || [];
    // parse background
    if (spec.background) ctx.background = spec.background;
    // parse event configuration
    if (spec.eventConfig) ctx.eventConfig = spec.eventConfig;
    // parse locale configuration
    if (spec.locale) ctx.locale = spec.locale;
    // parse operators
    operators.forEach((entry)=>ctx.parseOperator(entry));
    // parse operator parameters
    operators.forEach((entry)=>ctx.parseOperatorParameters(entry));
    // parse streams
    (spec.streams || []).forEach((entry)=>ctx.parseStream(entry));
    // parse updates
    (spec.updates || []).forEach((entry)=>ctx.parseUpdate(entry));
    return ctx.resolve();
}
const Skip = (0, _vegaUtil.toSet)([
    'rule'
]), Swap = (0, _vegaUtil.toSet)([
    'group',
    'image',
    'rect'
]);
function adjustSpatial(encode, marktype) {
    let code = '';
    if (Skip[marktype]) return code;
    if (encode.x2) {
        if (encode.x) {
            if (Swap[marktype]) code += 'if(o.x>o.x2)$=o.x,o.x=o.x2,o.x2=$;';
            code += 'o.width=o.x2-o.x;';
        } else code += 'o.x=o.x2-(o.width||0);';
    }
    if (encode.xc) code += 'o.x=o.xc-(o.width||0)/2;';
    if (encode.y2) {
        if (encode.y) {
            if (Swap[marktype]) code += 'if(o.y>o.y2)$=o.y,o.y=o.y2,o.y2=$;';
            code += 'o.height=o.y2-o.y;';
        } else code += 'o.y=o.y2-(o.height||0);';
    }
    if (encode.yc) code += 'o.y=o.yc-(o.height||0)/2;';
    return code;
}
function canonicalType(type) {
    return (type + '').toLowerCase();
}
function isOperator(type) {
    return canonicalType(type) === 'operator';
}
function isCollect(type) {
    return canonicalType(type) === 'collect';
}
function expression(ctx, args, code) {
    // wrap code in return statement if expression does not terminate
    if (!code.endsWith(';')) code = 'return(' + code + ');';
    const fn = Function(...args.concat(code));
    return ctx && ctx.functions ? fn.bind(ctx.functions) : fn;
}
// generate code for comparing a single field
function _compare(u, v, lt, gt) {
    return `((u = ${u}) < (v = ${v}) || u == null) && v != null ? ${lt}
  : (u > v || v == null) && u != null ? ${gt}
  : ((v = v instanceof Date ? +v : v), (u = u instanceof Date ? +u : u)) !== u && v === v ? ${lt}
  : v !== v && u === u ? ${gt} : `;
}
var expressionCodegen = {
    /**
   * Parse an expression used to update an operator value.
   */ operator: (ctx, expr)=>expression(ctx, [
            '_'
        ], expr.code),
    /**
   * Parse an expression provided as an operator parameter value.
   */ parameter: (ctx, expr)=>expression(ctx, [
            'datum',
            '_'
        ], expr.code),
    /**
   * Parse an expression applied to an event stream.
   */ event: (ctx, expr)=>expression(ctx, [
            'event'
        ], expr.code),
    /**
   * Parse an expression used to handle an event-driven operator update.
   */ handler: (ctx, expr)=>{
        const code = `var datum=event.item&&event.item.datum;return ${expr.code};`;
        return expression(ctx, [
            '_',
            'event'
        ], code);
    },
    /**
   * Parse an expression that performs visual encoding.
   */ encode: (ctx, encode)=>{
        const { marktype, channels } = encode;
        let code = 'var o=item,datum=o.datum,m=0,$;';
        for(const name in channels){
            const o = 'o[' + (0, _vegaUtil.stringValue)(name) + ']';
            code += `$=${channels[name].code};if(${o}!==$)${o}=$,m=1;`;
        }
        code += adjustSpatial(channels, marktype);
        code += 'return m;';
        return expression(ctx, [
            'item',
            '_'
        ], code);
    },
    /**
   * Optimized code generators for access and comparison.
   */ codegen: {
        get (path) {
            const ref = `[${path.map((0, _vegaUtil.stringValue)).join('][')}]`;
            const get = Function('_', `return _${ref};`);
            get.path = ref;
            return get;
        },
        comparator (fields, orders) {
            let t;
            const map = (f, i)=>{
                const o = orders[i];
                let u, v;
                if (f.path) {
                    u = `a${f.path}`;
                    v = `b${f.path}`;
                } else {
                    (t = t || {})['f' + i] = f;
                    u = `this.f${i}(a)`;
                    v = `this.f${i}(b)`;
                }
                return _compare(u, v, -o, o);
            };
            const fn = Function('a', 'b', 'var u, v; return ' + fields.map(map).join('') + '0;');
            return t ? fn.bind(t) : fn;
        }
    }
};
/**
 * Parse a dataflow operator.
 */ function parseOperator(spec) {
    const ctx = this;
    if (isOperator(spec.type) || !spec.type) ctx.operator(spec, spec.update ? ctx.operatorExpression(spec.update) : null);
    else ctx.transform(spec, spec.type);
}
/**
 * Parse and assign operator parameters.
 */ function parseOperatorParameters(spec) {
    const ctx = this;
    if (spec.params) {
        const op = ctx.get(spec.id);
        if (!op) (0, _vegaUtil.error)('Invalid operator id: ' + spec.id);
        ctx.dataflow.connect(op, op.parameters(ctx.parseParameters(spec.params), spec.react, spec.initonly));
    }
}
/**
 * Parse a set of operator parameters.
 */ function parseParameters(spec, params) {
    params = params || {};
    const ctx = this;
    for(const key in spec){
        const value = spec[key];
        params[key] = (0, _vegaUtil.isArray)(value) ? value.map((v)=>parseParameter(v, ctx, params)) : parseParameter(value, ctx, params);
    }
    return params;
}
/**
 * Parse a single parameter.
 */ function parseParameter(spec, ctx, params) {
    if (!spec || !(0, _vegaUtil.isObject)(spec)) return spec;
    for(let i = 0, n = PARSERS.length, p; i < n; ++i){
        p = PARSERS[i];
        if ((0, _vegaUtil.hasOwnProperty)(spec, p.key)) return p.parse(spec, ctx, params);
    }
    return spec;
}
/** Reference parsers. */ var PARSERS = [
    {
        key: '$ref',
        parse: getOperator
    },
    {
        key: '$key',
        parse: getKey
    },
    {
        key: '$expr',
        parse: getExpression
    },
    {
        key: '$field',
        parse: getField
    },
    {
        key: '$encode',
        parse: getEncode
    },
    {
        key: '$compare',
        parse: getCompare
    },
    {
        key: '$context',
        parse: getContext
    },
    {
        key: '$subflow',
        parse: getSubflow
    },
    {
        key: '$tupleid',
        parse: getTupleId
    }
];
/**
 * Resolve an operator reference.
 */ function getOperator(_, ctx) {
    return ctx.get(_.$ref) || (0, _vegaUtil.error)('Operator not defined: ' + _.$ref);
}
/**
 * Resolve an expression reference.
 */ function getExpression(_, ctx, params) {
    if (_.$params) // parse expression parameters
    ctx.parseParameters(_.$params, params);
    const k = 'e:' + _.$expr.code;
    return ctx.fn[k] || (ctx.fn[k] = (0, _vegaUtil.accessor)(ctx.parameterExpression(_.$expr), _.$fields));
}
/**
 * Resolve a key accessor reference.
 */ function getKey(_, ctx) {
    const k = 'k:' + _.$key + '_' + !!_.$flat;
    return ctx.fn[k] || (ctx.fn[k] = (0, _vegaUtil.key)(_.$key, _.$flat, ctx.expr.codegen));
}
/**
 * Resolve a field accessor reference.
 */ function getField(_, ctx) {
    if (!_.$field) return null;
    const k = 'f:' + _.$field + '_' + _.$name;
    return ctx.fn[k] || (ctx.fn[k] = (0, _vegaUtil.field)(_.$field, _.$name, ctx.expr.codegen));
}
/**
 * Resolve a comparator function reference.
 */ function getCompare(_, ctx) {
    // As of Vega 5.5.3, $tupleid sort is no longer used.
    // Keep here for now for backwards compatibility.
    const k = 'c:' + _.$compare + '_' + _.$order, c = (0, _vegaUtil.array)(_.$compare).map((_)=>_ && _.$tupleid ? (0, _vegaDataflow.tupleid) : _);
    return ctx.fn[k] || (ctx.fn[k] = (0, _vegaUtil.compare)(c, _.$order, ctx.expr.codegen));
}
/**
 * Resolve an encode operator reference.
 */ function getEncode(_, ctx) {
    const spec = _.$encode, encode = {};
    for(const name in spec){
        const enc = spec[name];
        encode[name] = (0, _vegaUtil.accessor)(ctx.encodeExpression(enc.$expr), enc.$fields);
        encode[name].output = enc.$output;
    }
    return encode;
}
/**
 * Resolve a context reference.
 */ function getContext(_, ctx) {
    return ctx;
}
/**
 * Resolve a recursive subflow specification.
 */ function getSubflow(_, ctx) {
    const spec = _.$subflow;
    return function(dataflow, key, parent) {
        const subctx = ctx.fork().parse(spec), op = subctx.get(spec.operators[0].id), p = subctx.signals.parent;
        if (p) p.set(parent);
        op.detachSubflow = ()=>ctx.detach(subctx);
        return op;
    };
}
/**
 * Resolve a tuple id reference.
 */ function getTupleId() {
    return 0, _vegaDataflow.tupleid;
}
/**
 * Parse an event stream specification.
 */ function parseStream(spec) {
    var ctx = this, filter = spec.filter != null ? ctx.eventExpression(spec.filter) : undefined, stream = spec.stream != null ? ctx.get(spec.stream) : undefined, args;
    if (spec.source) stream = ctx.events(spec.source, spec.type, filter);
    else if (spec.merge) {
        args = spec.merge.map((_)=>ctx.get(_));
        stream = args[0].merge.apply(args[0], args.slice(1));
    }
    if (spec.between) {
        args = spec.between.map((_)=>ctx.get(_));
        stream = stream.between(args[0], args[1]);
    }
    if (spec.filter) stream = stream.filter(filter);
    if (spec.throttle != null) stream = stream.throttle(+spec.throttle);
    if (spec.debounce != null) stream = stream.debounce(+spec.debounce);
    if (stream == null) (0, _vegaUtil.error)('Invalid stream definition: ' + JSON.stringify(spec));
    if (spec.consume) stream.consume(true);
    ctx.stream(spec, stream);
}
/**
 * Parse an event-driven operator update.
 */ function parseUpdate(spec) {
    var ctx = this, srcid = (0, _vegaUtil.isObject)(srcid = spec.source) ? srcid.$ref : srcid, source = ctx.get(srcid), target = null, update = spec.update, params = undefined;
    if (!source) (0, _vegaUtil.error)('Source not defined: ' + spec.source);
    target = spec.target && spec.target.$expr ? ctx.eventExpression(spec.target.$expr) : ctx.get(spec.target);
    if (update && update.$expr) {
        if (update.$params) params = ctx.parseParameters(update.$params);
        update = ctx.handlerExpression(update.$expr);
    }
    ctx.update(spec, source, target, update, params);
}
const SKIP = {
    skip: true
};
function getState(options) {
    var ctx = this, state = {};
    if (options.signals) {
        var signals = state.signals = {};
        Object.keys(ctx.signals).forEach((key)=>{
            const op = ctx.signals[key];
            if (options.signals(key, op)) signals[key] = op.value;
        });
    }
    if (options.data) {
        var data = state.data = {};
        Object.keys(ctx.data).forEach((key)=>{
            const dataset = ctx.data[key];
            if (options.data(key, dataset)) data[key] = dataset.input.value;
        });
    }
    if (ctx.subcontext && options.recurse !== false) state.subcontext = ctx.subcontext.map((ctx)=>ctx.getState(options));
    return state;
}
function setState(state) {
    var ctx = this, df = ctx.dataflow, data = state.data, signals = state.signals;
    Object.keys(signals || {}).forEach((key)=>{
        df.update(ctx.signals[key], signals[key], SKIP);
    });
    Object.keys(data || {}).forEach((key)=>{
        df.pulse(ctx.data[key].input, df.changeset().remove((0, _vegaUtil.truthy)).insert(data[key]));
    });
    (state.subcontext || []).forEach((substate, i)=>{
        const subctx = ctx.subcontext[i];
        if (subctx) subctx.setState(substate);
    });
}
/**
 * Context objects store the current parse state.
 * Enables lookup of parsed operators, event streams, accessors, etc.
 * Provides a 'fork' method for creating child contexts for subflows.
 */ function context(df, transforms, functions, expr) {
    return new Context(df, transforms, functions, expr);
}
function Context(df, transforms, functions, expr) {
    this.dataflow = df;
    this.transforms = transforms;
    this.events = df.events.bind(df);
    this.expr = expr || expressionCodegen, this.signals = {};
    this.scales = {};
    this.nodes = {};
    this.data = {};
    this.fn = {};
    if (functions) {
        this.functions = Object.create(functions);
        this.functions.context = this;
    }
}
function Subcontext(ctx) {
    this.dataflow = ctx.dataflow;
    this.transforms = ctx.transforms;
    this.events = ctx.events;
    this.expr = ctx.expr;
    this.signals = Object.create(ctx.signals);
    this.scales = Object.create(ctx.scales);
    this.nodes = Object.create(ctx.nodes);
    this.data = Object.create(ctx.data);
    this.fn = Object.create(ctx.fn);
    if (ctx.functions) {
        this.functions = Object.create(ctx.functions);
        this.functions.context = this;
    }
}
Context.prototype = Subcontext.prototype = {
    fork () {
        const ctx = new Subcontext(this);
        (this.subcontext || (this.subcontext = [])).push(ctx);
        return ctx;
    },
    detach (ctx) {
        this.subcontext = this.subcontext.filter((c)=>c !== ctx);
        // disconnect all nodes in the subcontext
        // wipe out targets first for better efficiency
        const keys = Object.keys(ctx.nodes);
        for (const key of keys)ctx.nodes[key]._targets = null;
        for (const key of keys)ctx.nodes[key].detach();
        ctx.nodes = null;
    },
    get (id) {
        return this.nodes[id];
    },
    set (id, node) {
        return this.nodes[id] = node;
    },
    add (spec, op) {
        const ctx = this, df = ctx.dataflow, data = spec.value;
        ctx.set(spec.id, op);
        if (isCollect(spec.type) && data) {
            if (data.$ingest) df.ingest(op, data.$ingest, data.$format);
            else if (data.$request) df.preload(op, data.$request, data.$format);
            else df.pulse(op, df.changeset().insert(data));
        }
        if (spec.root) ctx.root = op;
        if (spec.parent) {
            let p = ctx.get(spec.parent.$ref);
            if (p) {
                df.connect(p, [
                    op
                ]);
                op.targets().add(p);
            } else (ctx.unresolved = ctx.unresolved || []).push(()=>{
                p = ctx.get(spec.parent.$ref);
                df.connect(p, [
                    op
                ]);
                op.targets().add(p);
            });
        }
        if (spec.signal) ctx.signals[spec.signal] = op;
        if (spec.scale) ctx.scales[spec.scale] = op;
        if (spec.data) for(const name in spec.data){
            const data = ctx.data[name] || (ctx.data[name] = {});
            spec.data[name].forEach((role)=>data[role] = op);
        }
    },
    resolve () {
        (this.unresolved || []).forEach((fn)=>fn());
        delete this.unresolved;
        return this;
    },
    operator (spec, update) {
        this.add(spec, this.dataflow.add(spec.value, update));
    },
    transform (spec, type) {
        this.add(spec, this.dataflow.add(this.transforms[canonicalType(type)]));
    },
    stream (spec, stream) {
        this.set(spec.id, stream);
    },
    update (spec, stream, target, update, params) {
        this.dataflow.on(stream, target, update, params, spec.options);
    },
    // expression parsing
    operatorExpression (expr) {
        return this.expr.operator(this, expr);
    },
    parameterExpression (expr) {
        return this.expr.parameter(this, expr);
    },
    eventExpression (expr) {
        return this.expr.event(this, expr);
    },
    handlerExpression (expr) {
        return this.expr.handler(this, expr);
    },
    encodeExpression (encode) {
        return this.expr.encode(this, encode);
    },
    // parse methods
    parse,
    parseOperator,
    parseOperatorParameters,
    parseParameters,
    parseStream,
    parseUpdate,
    // state methods
    getState,
    setState
};

},{"vega-util":"7f6sQ","vega-dataflow":"4An7U","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5mHvd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, delay, time) {
        var t = new (0, _timerJs.Timer), total = delay;
        if (delay == null) return t.restart(callback, delay, time), t;
        t._restart = t.restart;
        t.restart = function(callback, delay, time) {
            delay = +delay, time = time == null ? (0, _timerJs.now)() : +time;
            t._restart(function tick(elapsed) {
                elapsed += total;
                t._restart(tick, total += delay, time);
                callback(elapsed);
            }, delay, time);
        };
        t.restart(callback, delay, time);
        return t;
    });
var _timerJs = require("./timer.js");

},{"./timer.js":"dTUeH","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"2ZEi7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AxisDomainRole", ()=>AxisDomainRole);
parcelHelpers.export(exports, "AxisGridRole", ()=>AxisGridRole);
parcelHelpers.export(exports, "AxisLabelRole", ()=>AxisLabelRole);
parcelHelpers.export(exports, "AxisRole", ()=>AxisRole);
parcelHelpers.export(exports, "AxisTickRole", ()=>AxisTickRole);
parcelHelpers.export(exports, "AxisTitleRole", ()=>AxisTitleRole);
parcelHelpers.export(exports, "DataScope", ()=>DataScope);
parcelHelpers.export(exports, "FrameRole", ()=>FrameRole);
parcelHelpers.export(exports, "LegendEntryRole", ()=>LegendEntryRole);
parcelHelpers.export(exports, "LegendLabelRole", ()=>LegendLabelRole);
parcelHelpers.export(exports, "LegendRole", ()=>LegendRole);
parcelHelpers.export(exports, "LegendSymbolRole", ()=>LegendSymbolRole);
parcelHelpers.export(exports, "LegendTitleRole", ()=>LegendTitleRole);
parcelHelpers.export(exports, "MarkRole", ()=>MarkRole);
parcelHelpers.export(exports, "Scope", ()=>Scope);
parcelHelpers.export(exports, "ScopeRole", ()=>ScopeRole);
parcelHelpers.export(exports, "config", ()=>defaults);
parcelHelpers.export(exports, "parse", ()=>parse);
parcelHelpers.export(exports, "signal", ()=>parseSignal);
parcelHelpers.export(exports, "signalUpdates", ()=>parseSignalUpdates);
parcelHelpers.export(exports, "stream", ()=>parseStream);
var _vegaUtil = require("vega-util");
var _vegaFunctions = require("vega-functions");
var _vegaEventSelector = require("vega-event-selector");
var _vegaScale = require("vega-scale");
var _vegaDataflow = require("vega-dataflow");
function parseAutosize(spec) {
    return (0, _vegaUtil.isObject)(spec) ? spec : {
        type: spec || 'pad'
    };
}
const number = (_)=>+_ || 0;
const paddingObject = (_)=>({
        top: _,
        bottom: _,
        left: _,
        right: _
    });
function parsePadding(spec) {
    return !(0, _vegaUtil.isObject)(spec) ? paddingObject(number(spec)) : spec.signal ? spec : {
        top: number(spec.top),
        bottom: number(spec.bottom),
        left: number(spec.left),
        right: number(spec.right)
    };
}
const encoder = (_)=>(0, _vegaUtil.isObject)(_) && !(0, _vegaUtil.isArray)(_) ? (0, _vegaUtil.extend)({}, _) : {
        value: _
    };
function addEncode(object, name, value, set) {
    if (value != null) {
        const isEncoder = (0, _vegaUtil.isObject)(value) && !(0, _vegaUtil.isArray)(value) || (0, _vegaUtil.isArray)(value) && value.length && (0, _vegaUtil.isObject)(value[0]);
        // Always assign signal to update, even if the signal is from the enter block
        if (isEncoder) object.update[name] = value;
        else object[set || 'enter'][name] = {
            value: value
        };
        return 1;
    } else return 0;
}
function addEncoders(object, enter, update) {
    for(const name in enter)addEncode(object, name, enter[name]);
    for(const name in update)addEncode(object, name, update[name], 'update');
}
function extendEncode(encode, extra, skip) {
    for(const name in extra){
        if (skip && (0, _vegaUtil.hasOwnProperty)(skip, name)) continue;
        encode[name] = (0, _vegaUtil.extend)(encode[name] || {}, extra[name]);
    }
    return encode;
}
function has(key, encode) {
    return encode && (encode.enter && encode.enter[key] || encode.update && encode.update[key]);
}
const MarkRole = 'mark';
const FrameRole = 'frame';
const ScopeRole = 'scope';
const AxisRole = 'axis';
const AxisDomainRole = 'axis-domain';
const AxisGridRole = 'axis-grid';
const AxisLabelRole = 'axis-label';
const AxisTickRole = 'axis-tick';
const AxisTitleRole = 'axis-title';
const LegendRole = 'legend';
const LegendBandRole = 'legend-band';
const LegendEntryRole = 'legend-entry';
const LegendGradientRole = 'legend-gradient';
const LegendLabelRole = 'legend-label';
const LegendSymbolRole = 'legend-symbol';
const LegendTitleRole = 'legend-title';
const TitleRole = 'title';
const TitleTextRole = 'title-text';
const TitleSubtitleRole = 'title-subtitle';
function applyDefaults(encode, type, role, style, config) {
    const defaults = {}, enter = {};
    let update, key, skip, props;
    // if text mark, apply global lineBreak settings (#2370)
    key = 'lineBreak';
    if (type === 'text' && config[key] != null && !has(key, encode)) applyDefault(defaults, key, config[key]);
    // ignore legend and axis roles
    if (role == 'legend' || String(role).startsWith('axis')) role = null;
    // resolve mark config
    props = role === FrameRole ? config.group : role === MarkRole ? (0, _vegaUtil.extend)({}, config.mark, config[type]) : null;
    for(key in props){
        // do not apply defaults if relevant fields are defined
        skip = has(key, encode) || (key === 'fill' || key === 'stroke') && (has('fill', encode) || has('stroke', encode));
        if (!skip) applyDefault(defaults, key, props[key]);
    }
    // resolve styles, apply with increasing precedence
    (0, _vegaUtil.array)(style).forEach((name)=>{
        const props = config.style && config.style[name];
        for(const key in props)if (!has(key, encode)) applyDefault(defaults, key, props[key]);
    });
    encode = (0, _vegaUtil.extend)({}, encode); // defensive copy
    for(key in defaults){
        props = defaults[key];
        if (props.signal) (update = update || {})[key] = props;
        else enter[key] = props;
    }
    encode.enter = (0, _vegaUtil.extend)(enter, encode.enter);
    if (update) encode.update = (0, _vegaUtil.extend)(update, encode.update);
    return encode;
}
function applyDefault(defaults, key, value) {
    defaults[key] = value && value.signal ? {
        signal: value.signal
    } : {
        value: value
    };
}
const scaleRef = (scale)=>(0, _vegaUtil.isString)(scale) ? (0, _vegaUtil.stringValue)(scale) : scale.signal ? `(${scale.signal})` : field(scale);
function entry$1(enc) {
    if (enc.gradient != null) return gradient(enc);
    let value = enc.signal ? `(${enc.signal})` : enc.color ? color(enc.color) : enc.field != null ? field(enc.field) : enc.value !== undefined ? (0, _vegaUtil.stringValue)(enc.value) : undefined;
    if (enc.scale != null) value = scale(enc, value);
    if (value === undefined) value = null;
    if (enc.exponent != null) value = `pow(${value},${property(enc.exponent)})`;
    if (enc.mult != null) value += `*${property(enc.mult)}`;
    if (enc.offset != null) value += `+${property(enc.offset)}`;
    if (enc.round) value = `round(${value})`;
    return value;
}
const _color = (type, x, y, z)=>`(${type}(${[
        x,
        y,
        z
    ].map(entry$1).join(',')})+'')`;
function color(enc) {
    return enc.c ? _color('hcl', enc.h, enc.c, enc.l) : enc.h || enc.s ? _color('hsl', enc.h, enc.s, enc.l) : enc.l || enc.a ? _color('lab', enc.l, enc.a, enc.b) : enc.r || enc.g || enc.b ? _color('rgb', enc.r, enc.g, enc.b) : null;
}
function gradient(enc) {
    // map undefined to null; expression lang does not allow undefined
    const args = [
        enc.start,
        enc.stop,
        enc.count
    ].map((_)=>_ == null ? null : (0, _vegaUtil.stringValue)(_));
    // trim null inputs from the end
    while(args.length && (0, _vegaUtil.peek)(args) == null)args.pop();
    args.unshift(scaleRef(enc.gradient));
    return `gradient(${args.join(',')})`;
}
function property(property) {
    return (0, _vegaUtil.isObject)(property) ? '(' + entry$1(property) + ')' : property;
}
function field(ref) {
    return resolveField((0, _vegaUtil.isObject)(ref) ? ref : {
        datum: ref
    });
}
function resolveField(ref) {
    let object, level, field;
    if (ref.signal) {
        object = 'datum';
        field = ref.signal;
    } else if (ref.group || ref.parent) {
        level = Math.max(1, ref.level || 1);
        object = 'item';
        while(level-- > 0)object += '.mark.group';
        if (ref.parent) {
            field = ref.parent;
            object += '.datum';
        } else field = ref.group;
    } else if (ref.datum) {
        object = 'datum';
        field = ref.datum;
    } else (0, _vegaUtil.error)('Invalid field reference: ' + (0, _vegaUtil.stringValue)(ref));
    if (!ref.signal) field = (0, _vegaUtil.isString)(field) ? (0, _vegaUtil.splitAccessPath)(field).map((0, _vegaUtil.stringValue)).join('][') : resolveField(field);
    return object + '[' + field + ']';
}
function scale(enc, value) {
    const scale = scaleRef(enc.scale);
    if (enc.range != null) // pull value from scale range
    value = `lerp(_range(${scale}), ${+enc.range})`;
    else {
        // run value through scale and/or pull scale bandwidth
        if (value !== undefined) value = `_scale(${scale}, ${value})`;
        if (enc.band) {
            value = (value ? value + '+' : '') + `_bandwidth(${scale})` + (+enc.band === 1 ? '' : '*' + property(enc.band));
            if (enc.extra) // include logic to handle extraneous elements
            value = `(datum.extra ? _scale(${scale}, datum.extra.value) : ${value})`;
        }
        if (value == null) value = '0';
    }
    return value;
}
function rule(enc) {
    let code = '';
    enc.forEach((rule)=>{
        const value = entry$1(rule);
        code += rule.test ? `(${rule.test})?${value}:` : value;
    });
    // if no else clause, terminate with null (#1366)
    if ((0, _vegaUtil.peek)(code) === ':') code += 'null';
    return code;
}
function parseEncode(encode, type, role, style, scope, params) {
    const enc = {};
    params = params || {};
    params.encoders = {
        $encode: enc
    };
    encode = applyDefaults(encode, type, role, style, scope.config);
    for(const key in encode)enc[key] = parseBlock(encode[key], type, params, scope);
    return params;
}
function parseBlock(block, marktype, params, scope) {
    const channels = {}, fields = {};
    for(const name in block)if (block[name] != null) // skip any null entries
    channels[name] = parse$1(expr(block[name]), scope, params, fields);
    return {
        $expr: {
            marktype,
            channels
        },
        $fields: Object.keys(fields),
        $output: Object.keys(block)
    };
}
function expr(enc) {
    return (0, _vegaUtil.isArray)(enc) ? rule(enc) : entry$1(enc);
}
function parse$1(code, scope, params, fields) {
    const expr = (0, _vegaFunctions.parseExpression)(code, scope);
    expr.$fields.forEach((name)=>fields[name] = 1);
    (0, _vegaUtil.extend)(params, expr.$params);
    return expr.$expr;
}
const OUTER = 'outer', OUTER_INVALID = [
    'value',
    'update',
    'init',
    'react',
    'bind'
];
function outerError(prefix, name) {
    (0, _vegaUtil.error)(prefix + ' for "outer" push: ' + (0, _vegaUtil.stringValue)(name));
}
function parseSignal(signal, scope) {
    const name = signal.name;
    if (signal.push === OUTER) {
        // signal must already be defined, raise error if not
        if (!scope.signals[name]) outerError('No prior signal definition', name);
        // signal push must not use properties reserved for standard definition
        OUTER_INVALID.forEach((prop)=>{
            if (signal[prop] !== undefined) outerError('Invalid property ', prop);
        });
    } else {
        // define a new signal in the current scope
        const op = scope.addSignal(name, signal.value);
        if (signal.react === false) op.react = false;
        if (signal.bind) scope.addBinding(name, signal.bind);
    }
}
function Entry(type, value, params, parent) {
    this.id = -1;
    this.type = type;
    this.value = value;
    this.params = params;
    if (parent) this.parent = parent;
}
function entry(type, value, params, parent) {
    return new Entry(type, value, params, parent);
}
function operator(value, params) {
    return entry('operator', value, params);
}
// -----
function ref(op) {
    const ref = {
        $ref: op.id
    };
    // if operator not yet registered, cache ref to resolve later
    if (op.id < 0) (op.refs = op.refs || []).push(ref);
    return ref;
}
function fieldRef$1(field, name) {
    return name ? {
        $field: field,
        $name: name
    } : {
        $field: field
    };
}
const keyFieldRef = fieldRef$1('key');
function compareRef(fields, orders) {
    return {
        $compare: fields,
        $order: orders
    };
}
function keyRef(fields, flat) {
    const ref = {
        $key: fields
    };
    if (flat) ref.$flat = true;
    return ref;
}
// -----
const Ascending = 'ascending';
const Descending = 'descending';
function sortKey(sort) {
    return !(0, _vegaUtil.isObject)(sort) ? '' : (sort.order === Descending ? '-' : '+') + aggrField(sort.op, sort.field);
}
function aggrField(op, field) {
    return (op && op.signal ? '$' + op.signal : op || '') + (op && field ? '_' : '') + (field && field.signal ? '$' + field.signal : field || '');
}
// -----
const Scope$1 = 'scope';
const View = 'view';
function isSignal(_) {
    return _ && _.signal;
}
function isExpr$1(_) {
    return _ && _.expr;
}
function hasSignal(_) {
    if (isSignal(_)) return true;
    if ((0, _vegaUtil.isObject)(_)) for(const key in _){
        if (hasSignal(_[key])) return true;
    }
    return false;
}
function value(specValue, defaultValue) {
    return specValue != null ? specValue : defaultValue;
}
function deref(v) {
    return v && v.signal || v;
}
const Timer = 'timer';
function parseStream(stream, scope) {
    const method = stream.merge ? mergeStream : stream.stream ? nestedStream : stream.type ? eventStream : (0, _vegaUtil.error)('Invalid stream specification: ' + (0, _vegaUtil.stringValue)(stream));
    return method(stream, scope);
}
function eventSource(source) {
    return source === Scope$1 ? View : source || View;
}
function mergeStream(stream, scope) {
    const list = stream.merge.map((s)=>parseStream(s, scope)), entry = streamParameters({
        merge: list
    }, stream, scope);
    return scope.addStream(entry).id;
}
function nestedStream(stream, scope) {
    const id = parseStream(stream.stream, scope), entry = streamParameters({
        stream: id
    }, stream, scope);
    return scope.addStream(entry).id;
}
function eventStream(stream, scope) {
    let id;
    if (stream.type === Timer) {
        id = scope.event(Timer, stream.throttle);
        stream = {
            between: stream.between,
            filter: stream.filter
        };
    } else id = scope.event(eventSource(stream.source), stream.type);
    const entry = streamParameters({
        stream: id
    }, stream, scope);
    return Object.keys(entry).length === 1 ? id : scope.addStream(entry).id;
}
function streamParameters(entry, stream, scope) {
    let param = stream.between;
    if (param) {
        if (param.length !== 2) (0, _vegaUtil.error)('Stream "between" parameter must have 2 entries: ' + (0, _vegaUtil.stringValue)(stream));
        entry.between = [
            parseStream(param[0], scope),
            parseStream(param[1], scope)
        ];
    }
    param = stream.filter ? [].concat(stream.filter) : [];
    if (stream.marktype || stream.markname || stream.markrole) // add filter for mark type, name and/or role
    param.push(filterMark(stream.marktype, stream.markname, stream.markrole));
    if (stream.source === Scope$1) // add filter to limit events from sub-scope only
    param.push('inScope(event.item)');
    if (param.length) entry.filter = (0, _vegaFunctions.parseExpression)('(' + param.join(')&&(') + ')', scope).$expr;
    if ((param = stream.throttle) != null) entry.throttle = +param;
    if ((param = stream.debounce) != null) entry.debounce = +param;
    if (stream.consume) entry.consume = true;
    return entry;
}
function filterMark(type, name, role) {
    const item = 'event.item';
    return item + (type && type !== '*' ? '&&' + item + '.mark.marktype===\'' + type + '\'' : '') + (role ? '&&' + item + '.mark.role===\'' + role + '\'' : '') + (name ? '&&' + item + '.mark.name===\'' + name + '\'' : '');
}
// bypass expression parser for internal operator references
const OP_VALUE_EXPR = {
    code: '_.$value',
    ast: {
        type: 'Identifier',
        value: 'value'
    }
};
function parseUpdate(spec, scope, target) {
    const encode = spec.encode, entry = {
        target: target
    };
    let events = spec.events, update = spec.update, sources = [];
    if (!events) (0, _vegaUtil.error)('Signal update missing events specification.');
    // interpret as an event selector string
    if ((0, _vegaUtil.isString)(events)) events = (0, _vegaEventSelector.parseSelector)(events, scope.isSubscope() ? Scope$1 : View);
    // separate event streams from signal updates
    events = (0, _vegaUtil.array)(events).filter((s)=>s.signal || s.scale ? (sources.push(s), 0) : 1);
    // merge internal operator listeners
    if (sources.length > 1) sources = [
        mergeSources(sources)
    ];
    // merge event streams, include as source
    if (events.length) sources.push(events.length > 1 ? {
        merge: events
    } : events[0]);
    if (encode != null) {
        if (update) (0, _vegaUtil.error)('Signal encode and update are mutually exclusive.');
        update = 'encode(item(),' + (0, _vegaUtil.stringValue)(encode) + ')';
    }
    // resolve update value
    entry.update = (0, _vegaUtil.isString)(update) ? (0, _vegaFunctions.parseExpression)(update, scope) : update.expr != null ? (0, _vegaFunctions.parseExpression)(update.expr, scope) : update.value != null ? update.value : update.signal != null ? {
        $expr: OP_VALUE_EXPR,
        $params: {
            $value: scope.signalRef(update.signal)
        }
    } : (0, _vegaUtil.error)('Invalid signal update specification.');
    if (spec.force) entry.options = {
        force: true
    };
    sources.forEach((source)=>scope.addUpdate((0, _vegaUtil.extend)(streamSource(source, scope), entry)));
}
function streamSource(stream, scope) {
    return {
        source: stream.signal ? scope.signalRef(stream.signal) : stream.scale ? scope.scaleRef(stream.scale) : parseStream(stream, scope)
    };
}
function mergeSources(sources) {
    return {
        signal: '[' + sources.map((s)=>s.scale ? 'scale("' + s.scale + '")' : s.signal) + ']'
    };
}
function parseSignalUpdates(signal, scope) {
    const op = scope.getSignal(signal.name);
    let expr = signal.update;
    if (signal.init) {
        if (expr) (0, _vegaUtil.error)('Signals can not include both init and update expressions.');
        else {
            expr = signal.init;
            op.initonly = true;
        }
    }
    if (expr) {
        expr = (0, _vegaFunctions.parseExpression)(expr, scope);
        op.update = expr.$expr;
        op.params = expr.$params;
    }
    if (signal.on) signal.on.forEach((_)=>parseUpdate(_, scope, op.id));
}
const transform = (name)=>(params, value, parent)=>entry(name, value, params || undefined, parent);
const Aggregate = transform('aggregate');
const AxisTicks = transform('axisticks');
const Bound = transform('bound');
const Collect = transform('collect');
const Compare = transform('compare');
const DataJoin = transform('datajoin');
const Encode = transform('encode');
const Expression = transform('expression');
const Facet = transform('facet');
const Field = transform('field');
const Key = transform('key');
const LegendEntries = transform('legendentries');
const Load = transform('load');
const Mark = transform('mark');
const MultiExtent = transform('multiextent');
const MultiValues = transform('multivalues');
const Overlap = transform('overlap');
const Params = transform('params');
const PreFacet = transform('prefacet');
const Projection = transform('projection');
const Proxy = transform('proxy');
const Relay = transform('relay');
const Render = transform('render');
const Scale = transform('scale');
const Sieve = transform('sieve');
const SortItems = transform('sortitems');
const ViewLayout = transform('viewlayout');
const Values = transform('values');
let FIELD_REF_ID = 0;
const MULTIDOMAIN_SORT_OPS = {
    min: 'min',
    max: 'max',
    count: 'sum'
};
function initScale(spec, scope) {
    const type = spec.type || 'linear';
    if (!(0, _vegaScale.isValidScaleType)(type)) (0, _vegaUtil.error)('Unrecognized scale type: ' + (0, _vegaUtil.stringValue)(type));
    scope.addScale(spec.name, {
        type,
        domain: undefined
    });
}
function parseScale(spec, scope) {
    const params = scope.getScale(spec.name).params;
    let key;
    params.domain = parseScaleDomain(spec.domain, spec, scope);
    if (spec.range != null) params.range = parseScaleRange(spec, scope, params);
    if (spec.interpolate != null) parseScaleInterpolate(spec.interpolate, params);
    if (spec.nice != null) params.nice = parseScaleNice(spec.nice, scope);
    if (spec.bins != null) params.bins = parseScaleBins(spec.bins, scope);
    for(key in spec){
        if ((0, _vegaUtil.hasOwnProperty)(params, key) || key === 'name') continue;
        params[key] = parseLiteral(spec[key], scope);
    }
}
function parseLiteral(v, scope) {
    return !(0, _vegaUtil.isObject)(v) ? v : v.signal ? scope.signalRef(v.signal) : (0, _vegaUtil.error)('Unsupported object: ' + (0, _vegaUtil.stringValue)(v));
}
function parseArray(v, scope) {
    return v.signal ? scope.signalRef(v.signal) : v.map((v)=>parseLiteral(v, scope));
}
function dataLookupError(name) {
    (0, _vegaUtil.error)('Can not find data set: ' + (0, _vegaUtil.stringValue)(name));
}
// -- SCALE DOMAIN ----
function parseScaleDomain(domain, spec, scope) {
    if (!domain) {
        if (spec.domainMin != null || spec.domainMax != null) (0, _vegaUtil.error)('No scale domain defined for domainMin/domainMax to override.');
        return; // default domain
    }
    return domain.signal ? scope.signalRef(domain.signal) : ((0, _vegaUtil.isArray)(domain) ? explicitDomain : domain.fields ? multipleDomain : singularDomain)(domain, spec, scope);
}
function explicitDomain(domain, spec, scope) {
    return domain.map((v)=>parseLiteral(v, scope));
}
function singularDomain(domain, spec, scope) {
    const data = scope.getData(domain.data);
    if (!data) dataLookupError(domain.data);
    return (0, _vegaScale.isDiscrete)(spec.type) ? data.valuesRef(scope, domain.field, parseSort(domain.sort, false)) : (0, _vegaScale.isQuantile)(spec.type) ? data.domainRef(scope, domain.field) : data.extentRef(scope, domain.field);
}
function multipleDomain(domain, spec, scope) {
    const data = domain.data, fields = domain.fields.reduce((dom, d)=>{
        d = (0, _vegaUtil.isString)(d) ? {
            data: data,
            field: d
        } : (0, _vegaUtil.isArray)(d) || d.signal ? fieldRef(d, scope) : d;
        dom.push(d);
        return dom;
    }, []);
    return ((0, _vegaScale.isDiscrete)(spec.type) ? ordinalMultipleDomain : (0, _vegaScale.isQuantile)(spec.type) ? quantileMultipleDomain : numericMultipleDomain)(domain, scope, fields);
}
function fieldRef(data, scope) {
    const name = '_:vega:_' + FIELD_REF_ID++, coll = Collect({});
    if ((0, _vegaUtil.isArray)(data)) coll.value = {
        $ingest: data
    };
    else if (data.signal) {
        const code = 'setdata(' + (0, _vegaUtil.stringValue)(name) + ',' + data.signal + ')';
        coll.params.input = scope.signalRef(code);
    }
    scope.addDataPipeline(name, [
        coll,
        Sieve({})
    ]);
    return {
        data: name,
        field: 'data'
    };
}
function ordinalMultipleDomain(domain, scope, fields) {
    const sort = parseSort(domain.sort, true);
    let a, v;
    // get value counts for each domain field
    const counts = fields.map((f)=>{
        const data = scope.getData(f.data);
        if (!data) dataLookupError(f.data);
        return data.countsRef(scope, f.field, sort);
    });
    // aggregate the results from each domain field
    const p = {
        groupby: keyFieldRef,
        pulse: counts
    };
    if (sort) {
        a = sort.op || 'count';
        v = sort.field ? aggrField(a, sort.field) : 'count';
        p.ops = [
            MULTIDOMAIN_SORT_OPS[a]
        ];
        p.fields = [
            scope.fieldRef(v)
        ];
        p.as = [
            v
        ];
    }
    a = scope.add(Aggregate(p));
    // collect aggregate output
    const c = scope.add(Collect({
        pulse: ref(a)
    }));
    // extract values for combined domain
    v = scope.add(Values({
        field: keyFieldRef,
        sort: scope.sortRef(sort),
        pulse: ref(c)
    }));
    return ref(v);
}
function parseSort(sort, multidomain) {
    if (sort) {
        if (!sort.field && !sort.op) {
            if ((0, _vegaUtil.isObject)(sort)) sort.field = 'key';
            else sort = {
                field: 'key'
            };
        } else if (!sort.field && sort.op !== 'count') (0, _vegaUtil.error)('No field provided for sort aggregate op: ' + sort.op);
        else if (multidomain && sort.field) {
            if (sort.op && !MULTIDOMAIN_SORT_OPS[sort.op]) (0, _vegaUtil.error)('Multiple domain scales can not be sorted using ' + sort.op);
        }
    }
    return sort;
}
function quantileMultipleDomain(domain, scope, fields) {
    // get value arrays for each domain field
    const values = fields.map((f)=>{
        const data = scope.getData(f.data);
        if (!data) dataLookupError(f.data);
        return data.domainRef(scope, f.field);
    });
    // combine value arrays
    return ref(scope.add(MultiValues({
        values: values
    })));
}
function numericMultipleDomain(domain, scope, fields) {
    // get extents for each domain field
    const extents = fields.map((f)=>{
        const data = scope.getData(f.data);
        if (!data) dataLookupError(f.data);
        return data.extentRef(scope, f.field);
    });
    // combine extents
    return ref(scope.add(MultiExtent({
        extents: extents
    })));
}
// -- SCALE BINS -----
function parseScaleBins(v, scope) {
    return v.signal || (0, _vegaUtil.isArray)(v) ? parseArray(v, scope) : scope.objectProperty(v);
}
// -- SCALE NICE -----
function parseScaleNice(nice, scope) {
    return nice.signal ? scope.signalRef(nice.signal) : (0, _vegaUtil.isObject)(nice) ? {
        interval: parseLiteral(nice.interval),
        step: parseLiteral(nice.step)
    } : parseLiteral(nice);
}
// -- SCALE INTERPOLATION -----
function parseScaleInterpolate(interpolate, params) {
    params.interpolate = parseLiteral(interpolate.type || interpolate);
    if (interpolate.gamma != null) params.interpolateGamma = parseLiteral(interpolate.gamma);
}
// -- SCALE RANGE -----
function parseScaleRange(spec, scope, params) {
    const config = scope.config.range;
    let range = spec.range;
    if (range.signal) return scope.signalRef(range.signal);
    else if ((0, _vegaUtil.isString)(range)) {
        if (config && (0, _vegaUtil.hasOwnProperty)(config, range)) {
            spec = (0, _vegaUtil.extend)({}, spec, {
                range: config[range]
            });
            return parseScaleRange(spec, scope, params);
        } else if (range === 'width') range = [
            0,
            {
                signal: 'width'
            }
        ];
        else if (range === 'height') range = (0, _vegaScale.isDiscrete)(spec.type) ? [
            0,
            {
                signal: 'height'
            }
        ] : [
            {
                signal: 'height'
            },
            0
        ];
        else (0, _vegaUtil.error)('Unrecognized scale range value: ' + (0, _vegaUtil.stringValue)(range));
    } else if (range.scheme) {
        params.scheme = (0, _vegaUtil.isArray)(range.scheme) ? parseArray(range.scheme, scope) : parseLiteral(range.scheme, scope);
        if (range.extent) params.schemeExtent = parseArray(range.extent, scope);
        if (range.count) params.schemeCount = parseLiteral(range.count, scope);
        return;
    } else if (range.step) {
        params.rangeStep = parseLiteral(range.step, scope);
        return;
    } else if ((0, _vegaScale.isDiscrete)(spec.type) && !(0, _vegaUtil.isArray)(range)) return parseScaleDomain(range, spec, scope);
    else if (!(0, _vegaUtil.isArray)(range)) (0, _vegaUtil.error)('Unsupported range type: ' + (0, _vegaUtil.stringValue)(range));
    return range.map((v)=>((0, _vegaUtil.isArray)(v) ? parseArray : parseLiteral)(v, scope));
}
function parseProjection(proj, scope) {
    const config = scope.config.projection || {}, params = {};
    for(const name in proj){
        if (name === 'name') continue;
        params[name] = parseParameter$1(proj[name], name, scope);
    }
    // apply projection defaults from config
    for(const name in config)if (params[name] == null) params[name] = parseParameter$1(config[name], name, scope);
    scope.addProjection(proj.name, params);
}
function parseParameter$1(_, name, scope) {
    return (0, _vegaUtil.isArray)(_) ? _.map((_)=>parseParameter$1(_, name, scope)) : !(0, _vegaUtil.isObject)(_) ? _ : _.signal ? scope.signalRef(_.signal) : name === 'fit' ? _ : (0, _vegaUtil.error)('Unsupported parameter object: ' + (0, _vegaUtil.stringValue)(_));
}
const Top = 'top';
const Left = 'left';
const Right = 'right';
const Bottom = 'bottom';
const Center = 'center';
const Vertical = 'vertical';
const Start = 'start';
const Middle = 'middle';
const End = 'end';
const Index = 'index';
const Label = 'label';
const Offset = 'offset';
const Perc = 'perc';
const Perc2 = 'perc2';
const Value = 'value';
const GuideLabelStyle = 'guide-label';
const GuideTitleStyle = 'guide-title';
const GroupTitleStyle = 'group-title';
const GroupSubtitleStyle = 'group-subtitle';
/** All values of LegendType */ const Symbols = 'symbol';
const Gradient = 'gradient';
const Discrete = 'discrete';
const Size = 'size';
const Shape = 'shape';
const Fill = 'fill';
const Stroke = 'stroke';
const StrokeWidth = 'strokeWidth';
const StrokeDash = 'strokeDash';
const Opacity = 'opacity';
// Encoding channels supported by legends
// In priority order of 'canonical' scale
const LegendScales = [
    Size,
    Shape,
    Fill,
    Stroke,
    StrokeWidth,
    StrokeDash,
    Opacity
];
const Skip = {
    name: 1,
    style: 1,
    interactive: 1
};
const zero = {
    value: 0
};
const one = {
    value: 1
};
const GroupMark = 'group';
const RectMark = 'rect';
const RuleMark = 'rule';
const SymbolMark = 'symbol';
const TextMark = 'text';
function guideGroup(mark) {
    mark.type = GroupMark;
    mark.interactive = mark.interactive || false;
    return mark;
}
function lookup(spec, config) {
    const _ = (name, dflt)=>value(spec[name], value(config[name], dflt));
    _.isVertical = (s)=>Vertical === value(spec.direction, config.direction || (s ? config.symbolDirection : config.gradientDirection));
    _.gradientLength = ()=>value(spec.gradientLength, config.gradientLength || config.gradientWidth);
    _.gradientThickness = ()=>value(spec.gradientThickness, config.gradientThickness || config.gradientHeight);
    _.entryColumns = ()=>value(spec.columns, value(config.columns, +_.isVertical(true)));
    return _;
}
function getEncoding(name, encode) {
    const v = encode && (encode.update && encode.update[name] || encode.enter && encode.enter[name]);
    return v && v.signal ? v : v ? v.value : null;
}
function getStyle(name, scope, style) {
    const s = scope.config.style[style];
    return s && s[name];
}
function anchorExpr(s, e, m) {
    return `item.anchor === '${Start}' ? ${s} : item.anchor === '${End}' ? ${e} : ${m}`;
}
const alignExpr$1 = anchorExpr((0, _vegaUtil.stringValue)(Left), (0, _vegaUtil.stringValue)(Right), (0, _vegaUtil.stringValue)(Center));
function tickBand(_) {
    const v = _('tickBand');
    let offset = _('tickOffset'), band, extra;
    if (!v) {
        // if no tick band entry, fall back on other properties
        band = _('bandPosition');
        extra = _('tickExtra');
    } else if (v.signal) {
        // if signal, augment code to interpret values
        band = {
            signal: `(${v.signal}) === 'extent' ? 1 : 0.5`
        };
        extra = {
            signal: `(${v.signal}) === 'extent'`
        };
        if (!(0, _vegaUtil.isObject)(offset)) offset = {
            signal: `(${v.signal}) === 'extent' ? 0 : ${offset}`
        };
    } else if (v === 'extent') {
        // if constant, simply set values
        band = 1;
        extra = true;
        offset = 0;
    } else {
        band = 0.5;
        extra = false;
    }
    return {
        extra,
        band,
        offset
    };
}
function extendOffset(value, offset) {
    return !offset ? value : !value ? offset : !(0, _vegaUtil.isObject)(value) ? {
        value,
        offset
    } : Object.assign({}, value, {
        offset: extendOffset(value.offset, offset)
    });
}
function guideMark(mark, extras) {
    if (extras) {
        mark.name = extras.name;
        mark.style = extras.style || mark.style;
        mark.interactive = !!extras.interactive;
        mark.encode = extendEncode(mark.encode, extras, Skip);
    } else mark.interactive = false;
    return mark;
}
function legendGradient(spec, scale, config, userEncode) {
    const _ = lookup(spec, config), vertical = _.isVertical(), thickness = _.gradientThickness(), length = _.gradientLength();
    let enter, start, stop, width, height;
    if (vertical) {
        start = [
            0,
            1
        ];
        stop = [
            0,
            0
        ];
        width = thickness;
        height = length;
    } else {
        start = [
            0,
            0
        ];
        stop = [
            1,
            0
        ];
        width = length;
        height = thickness;
    }
    const encode = {
        enter: enter = {
            opacity: zero,
            x: zero,
            y: zero,
            width: encoder(width),
            height: encoder(height)
        },
        update: (0, _vegaUtil.extend)({}, enter, {
            opacity: one,
            fill: {
                gradient: scale,
                start: start,
                stop: stop
            }
        }),
        exit: {
            opacity: zero
        }
    };
    addEncoders(encode, {
        stroke: _('gradientStrokeColor'),
        strokeWidth: _('gradientStrokeWidth')
    }, {
        // update
        opacity: _('gradientOpacity')
    });
    return guideMark({
        type: RectMark,
        role: LegendGradientRole,
        encode
    }, userEncode);
}
function legendGradientDiscrete(spec, scale, config, userEncode, dataRef) {
    const _ = lookup(spec, config), vertical = _.isVertical(), thickness = _.gradientThickness(), length = _.gradientLength();
    let u, v, uu, vv, adjust = '';
    vertical ? (u = 'y', uu = 'y2', v = 'x', vv = 'width', adjust = '1-') : (u = 'x', uu = 'x2', v = 'y', vv = 'height');
    const enter = {
        opacity: zero,
        fill: {
            scale: scale,
            field: Value
        }
    };
    enter[u] = {
        signal: adjust + 'datum.' + Perc,
        mult: length
    };
    enter[v] = zero;
    enter[uu] = {
        signal: adjust + 'datum.' + Perc2,
        mult: length
    };
    enter[vv] = encoder(thickness);
    const encode = {
        enter: enter,
        update: (0, _vegaUtil.extend)({}, enter, {
            opacity: one
        }),
        exit: {
            opacity: zero
        }
    };
    addEncoders(encode, {
        stroke: _('gradientStrokeColor'),
        strokeWidth: _('gradientStrokeWidth')
    }, {
        // update
        opacity: _('gradientOpacity')
    });
    return guideMark({
        type: RectMark,
        role: LegendBandRole,
        key: Value,
        from: dataRef,
        encode
    }, userEncode);
}
const alignExpr = `datum.${Perc}<=0?"${Left}":datum.${Perc}>=1?"${Right}":"${Center}"`, baselineExpr = `datum.${Perc}<=0?"${Bottom}":datum.${Perc}>=1?"${Top}":"${Middle}"`;
function legendGradientLabels(spec, config, userEncode, dataRef) {
    const _ = lookup(spec, config), vertical = _.isVertical(), thickness = encoder(_.gradientThickness()), length = _.gradientLength();
    let overlap = _('labelOverlap'), enter, update, u, v, adjust = '';
    const encode = {
        enter: enter = {
            opacity: zero
        },
        update: update = {
            opacity: one,
            text: {
                field: Label
            }
        },
        exit: {
            opacity: zero
        }
    };
    addEncoders(encode, {
        fill: _('labelColor'),
        fillOpacity: _('labelOpacity'),
        font: _('labelFont'),
        fontSize: _('labelFontSize'),
        fontStyle: _('labelFontStyle'),
        fontWeight: _('labelFontWeight'),
        limit: value(spec.labelLimit, config.gradientLabelLimit)
    });
    if (vertical) {
        enter.align = {
            value: 'left'
        };
        enter.baseline = update.baseline = {
            signal: baselineExpr
        };
        u = 'y';
        v = 'x';
        adjust = '1-';
    } else {
        enter.align = update.align = {
            signal: alignExpr
        };
        enter.baseline = {
            value: 'top'
        };
        u = 'x';
        v = 'y';
    }
    enter[u] = update[u] = {
        signal: adjust + 'datum.' + Perc,
        mult: length
    };
    enter[v] = update[v] = thickness;
    thickness.offset = value(spec.labelOffset, config.gradientLabelOffset) || 0;
    overlap = overlap ? {
        separation: _('labelSeparation'),
        method: overlap,
        order: 'datum.' + Index
    } : undefined;
    // type, role, style, key, dataRef, encode, extras
    return guideMark({
        type: TextMark,
        role: LegendLabelRole,
        style: GuideLabelStyle,
        key: Value,
        from: dataRef,
        encode,
        overlap
    }, userEncode);
}
// userEncode is top-level, includes entries, symbols, labels
function legendSymbolGroups(spec, config, userEncode, dataRef, columns) {
    const _ = lookup(spec, config), entries = userEncode.entries, interactive = !!(entries && entries.interactive), name = entries ? entries.name : undefined, height = _('clipHeight'), symbolOffset = _('symbolOffset'), valueRef = {
        data: 'value'
    }, xSignal = `(${columns}) ? datum.${Offset} : datum.${Size}`, yEncode = height ? encoder(height) : {
        field: Size
    }, index = `datum.${Index}`, ncols = `max(1, ${columns})`;
    let encode, enter, update, nrows, sort;
    yEncode.mult = 0.5;
    // -- LEGEND SYMBOLS --
    encode = {
        enter: enter = {
            opacity: zero,
            x: {
                signal: xSignal,
                mult: 0.5,
                offset: symbolOffset
            },
            y: yEncode
        },
        update: update = {
            opacity: one,
            x: enter.x,
            y: enter.y
        },
        exit: {
            opacity: zero
        }
    };
    let baseFill = null, baseStroke = null;
    if (!spec.fill) {
        baseFill = config.symbolBaseFillColor;
        baseStroke = config.symbolBaseStrokeColor;
    }
    addEncoders(encode, {
        fill: _('symbolFillColor', baseFill),
        shape: _('symbolType'),
        size: _('symbolSize'),
        stroke: _('symbolStrokeColor', baseStroke),
        strokeDash: _('symbolDash'),
        strokeDashOffset: _('symbolDashOffset'),
        strokeWidth: _('symbolStrokeWidth')
    }, {
        // update
        opacity: _('symbolOpacity')
    });
    LegendScales.forEach((scale)=>{
        if (spec[scale]) update[scale] = enter[scale] = {
            scale: spec[scale],
            field: Value
        };
    });
    const symbols = guideMark({
        type: SymbolMark,
        role: LegendSymbolRole,
        key: Value,
        from: valueRef,
        clip: height ? true : undefined,
        encode
    }, userEncode.symbols);
    // -- LEGEND LABELS --
    const labelOffset = encoder(symbolOffset);
    labelOffset.offset = _('labelOffset');
    encode = {
        enter: enter = {
            opacity: zero,
            x: {
                signal: xSignal,
                offset: labelOffset
            },
            y: yEncode
        },
        update: update = {
            opacity: one,
            text: {
                field: Label
            },
            x: enter.x,
            y: enter.y
        },
        exit: {
            opacity: zero
        }
    };
    addEncoders(encode, {
        align: _('labelAlign'),
        baseline: _('labelBaseline'),
        fill: _('labelColor'),
        fillOpacity: _('labelOpacity'),
        font: _('labelFont'),
        fontSize: _('labelFontSize'),
        fontStyle: _('labelFontStyle'),
        fontWeight: _('labelFontWeight'),
        limit: _('labelLimit')
    });
    const labels = guideMark({
        type: TextMark,
        role: LegendLabelRole,
        style: GuideLabelStyle,
        key: Value,
        from: valueRef,
        encode
    }, userEncode.labels);
    // -- LEGEND ENTRY GROUPS --
    encode = {
        enter: {
            noBound: {
                value: !height
            },
            // ignore width/height in bounds calc
            width: zero,
            height: height ? encoder(height) : zero,
            opacity: zero
        },
        exit: {
            opacity: zero
        },
        update: update = {
            opacity: one,
            row: {
                signal: null
            },
            column: {
                signal: null
            }
        }
    };
    // annotate and sort groups to ensure correct ordering
    if (_.isVertical(true)) {
        nrows = `ceil(item.mark.items.length / ${ncols})`;
        update.row.signal = `${index}%${nrows}`;
        update.column.signal = `floor(${index} / ${nrows})`;
        sort = {
            field: [
                'row',
                index
            ]
        };
    } else {
        update.row.signal = `floor(${index} / ${ncols})`;
        update.column.signal = `${index} % ${ncols}`;
        sort = {
            field: index
        };
    }
    // handle zero column case (implies infinite columns)
    update.column.signal = `(${columns})?${update.column.signal}:${index}`;
    // facet legend entries into sub-groups
    dataRef = {
        facet: {
            data: dataRef,
            name: 'value',
            groupby: Index
        }
    };
    return guideGroup({
        role: ScopeRole,
        from: dataRef,
        encode: extendEncode(encode, entries, Skip),
        marks: [
            symbols,
            labels
        ],
        name,
        interactive,
        sort
    });
}
function legendSymbolLayout(spec, config) {
    const _ = lookup(spec, config);
    // layout parameters for legend entries
    return {
        align: _('gridAlign'),
        columns: _.entryColumns(),
        center: {
            row: true,
            column: false
        },
        padding: {
            row: _('rowPadding'),
            column: _('columnPadding')
        }
    };
}
// expression logic for align, anchor, angle, and baseline calculation
const isL = 'item.orient === "left"', isR = 'item.orient === "right"', isLR = `(${isL} || ${isR})`, isVG = `datum.vgrad && ${isLR}`, baseline = anchorExpr('"top"', '"bottom"', '"middle"'), alignFlip = anchorExpr('"right"', '"left"', '"center"'), exprAlign = `datum.vgrad && ${isR} ? (${alignFlip}) : (${isLR} && !(datum.vgrad && ${isL})) ? "left" : ${alignExpr$1}`, exprAnchor = `item._anchor || (${isLR} ? "middle" : "start")`, exprAngle = `${isVG} ? (${isL} ? -90 : 90) : 0`, exprBaseline = `${isLR} ? (datum.vgrad ? (${isR} ? "bottom" : "top") : ${baseline}) : "top"`;
function legendTitle(spec, config, userEncode, dataRef) {
    const _ = lookup(spec, config);
    const encode = {
        enter: {
            opacity: zero
        },
        update: {
            opacity: one,
            x: {
                field: {
                    group: 'padding'
                }
            },
            y: {
                field: {
                    group: 'padding'
                }
            }
        },
        exit: {
            opacity: zero
        }
    };
    addEncoders(encode, {
        orient: _('titleOrient'),
        _anchor: _('titleAnchor'),
        anchor: {
            signal: exprAnchor
        },
        angle: {
            signal: exprAngle
        },
        align: {
            signal: exprAlign
        },
        baseline: {
            signal: exprBaseline
        },
        text: spec.title,
        fill: _('titleColor'),
        fillOpacity: _('titleOpacity'),
        font: _('titleFont'),
        fontSize: _('titleFontSize'),
        fontStyle: _('titleFontStyle'),
        fontWeight: _('titleFontWeight'),
        limit: _('titleLimit'),
        lineHeight: _('titleLineHeight')
    }, {
        // require update
        align: _('titleAlign'),
        baseline: _('titleBaseline')
    });
    return guideMark({
        type: TextMark,
        role: LegendTitleRole,
        style: GuideTitleStyle,
        from: dataRef,
        encode
    }, userEncode);
}
function clip(clip, scope) {
    let expr;
    if ((0, _vegaUtil.isObject)(clip)) {
        if (clip.signal) expr = clip.signal;
        else if (clip.path) expr = 'pathShape(' + param(clip.path) + ')';
        else if (clip.sphere) expr = 'geoShape(' + param(clip.sphere) + ', {type: "Sphere"})';
    }
    return expr ? scope.signalRef(expr) : !!clip;
}
function param(value) {
    return (0, _vegaUtil.isObject)(value) && value.signal ? value.signal : (0, _vegaUtil.stringValue)(value);
}
function getRole(spec) {
    const role = spec.role || '';
    return role.startsWith('axis') || role.startsWith('legend') || role.startsWith('title') ? role : spec.type === GroupMark ? ScopeRole : role || MarkRole;
}
function definition(spec) {
    return {
        marktype: spec.type,
        name: spec.name || undefined,
        role: spec.role || getRole(spec),
        zindex: +spec.zindex || undefined,
        aria: spec.aria,
        description: spec.description
    };
}
function interactive(spec, scope) {
    return spec && spec.signal ? scope.signalRef(spec.signal) : spec === false ? false : true;
}
/**
 * Parse a data transform specification.
 */ function parseTransform(spec, scope) {
    const def = (0, _vegaDataflow.definition)(spec.type);
    if (!def) (0, _vegaUtil.error)('Unrecognized transform type: ' + (0, _vegaUtil.stringValue)(spec.type));
    const t = entry(def.type.toLowerCase(), null, parseParameters(def, spec, scope));
    if (spec.signal) scope.addSignal(spec.signal, scope.proxy(t));
    t.metadata = def.metadata || {};
    return t;
}
/**
 * Parse all parameters of a data transform.
 */ function parseParameters(def, spec, scope) {
    const params = {}, n = def.params.length;
    for(let i = 0; i < n; ++i){
        const pdef = def.params[i];
        params[pdef.name] = parseParameter(pdef, spec, scope);
    }
    return params;
}
/**
 * Parse a data transform parameter.
 */ function parseParameter(def, spec, scope) {
    const type = def.type, value = spec[def.name];
    if (type === 'index') return parseIndexParameter(def, spec, scope);
    else if (value === undefined) {
        if (def.required) (0, _vegaUtil.error)('Missing required ' + (0, _vegaUtil.stringValue)(spec.type) + ' parameter: ' + (0, _vegaUtil.stringValue)(def.name));
        return;
    } else if (type === 'param') return parseSubParameters(def, spec, scope);
    else if (type === 'projection') return scope.projectionRef(spec[def.name]);
    return def.array && !isSignal(value) ? value.map((v)=>parameterValue(def, v, scope)) : parameterValue(def, value, scope);
}
/**
 * Parse a single parameter value.
 */ function parameterValue(def, value, scope) {
    const type = def.type;
    if (isSignal(value)) return isExpr(type) ? (0, _vegaUtil.error)('Expression references can not be signals.') : isField(type) ? scope.fieldRef(value) : isCompare(type) ? scope.compareRef(value) : scope.signalRef(value.signal);
    else {
        const expr = def.expr || isField(type);
        return expr && outerExpr(value) ? scope.exprRef(value.expr, value.as) : expr && outerField(value) ? fieldRef$1(value.field, value.as) : isExpr(type) ? (0, _vegaFunctions.parseExpression)(value, scope) : isData(type) ? ref(scope.getData(value).values) : isField(type) ? fieldRef$1(value) : isCompare(type) ? scope.compareRef(value) : value;
    }
}
/**
 * Parse parameter for accessing an index of another data set.
 */ function parseIndexParameter(def, spec, scope) {
    if (!(0, _vegaUtil.isString)(spec.from)) (0, _vegaUtil.error)('Lookup "from" parameter must be a string literal.');
    return scope.getData(spec.from).lookupRef(scope, spec.key);
}
/**
 * Parse a parameter that contains one or more sub-parameter objects.
 */ function parseSubParameters(def, spec, scope) {
    const value = spec[def.name];
    if (def.array) {
        if (!(0, _vegaUtil.isArray)(value)) // signals not allowed!
        (0, _vegaUtil.error)('Expected an array of sub-parameters. Instead: ' + (0, _vegaUtil.stringValue)(value));
        return value.map((v)=>parseSubParameter(def, v, scope));
    } else return parseSubParameter(def, value, scope);
}
/**
 * Parse a sub-parameter object.
 */ function parseSubParameter(def, value, scope) {
    const n = def.params.length;
    let pdef;
    // loop over defs to find matching key
    for(let i = 0; i < n; ++i){
        pdef = def.params[i];
        for(const k in pdef.key)if (pdef.key[k] !== value[k]) {
            pdef = null;
            break;
        }
        if (pdef) break;
    }
    // raise error if matching key not found
    if (!pdef) (0, _vegaUtil.error)('Unsupported parameter: ' + (0, _vegaUtil.stringValue)(value));
    // parse params, create Params transform, return ref
    const params = (0, _vegaUtil.extend)(parseParameters(pdef, value, scope), pdef.key);
    return ref(scope.add(Params(params)));
}
// -- Utilities -----
const outerExpr = (_)=>_ && _.expr;
const outerField = (_)=>_ && _.field;
const isData = (_)=>_ === 'data';
const isExpr = (_)=>_ === 'expr';
const isField = (_)=>_ === 'field';
const isCompare = (_)=>_ === 'compare';
function parseData$1(from, group, scope) {
    let facet, key, op, dataRef, parent;
    // if no source data, generate singleton datum
    if (!from) dataRef = ref(scope.add(Collect(null, [
        {}
    ])));
    else if (facet = from.facet) {
        if (!group) (0, _vegaUtil.error)('Only group marks can be faceted.');
        // use pre-faceted source data, if available
        if (facet.field != null) dataRef = parent = getDataRef(facet, scope);
        else {
            // generate facet aggregates if no direct data specification
            if (!from.data) {
                op = parseTransform((0, _vegaUtil.extend)({
                    type: 'aggregate',
                    groupby: (0, _vegaUtil.array)(facet.groupby)
                }, facet.aggregate), scope);
                op.params.key = scope.keyRef(facet.groupby);
                op.params.pulse = getDataRef(facet, scope);
                dataRef = parent = ref(scope.add(op));
            } else parent = ref(scope.getData(from.data).aggregate);
            key = scope.keyRef(facet.groupby, true);
        }
    }
    // if not yet defined, get source data reference
    if (!dataRef) dataRef = getDataRef(from, scope);
    return {
        key: key,
        pulse: dataRef,
        parent: parent
    };
}
function getDataRef(from, scope) {
    return from.$ref ? from : from.data && from.data.$ref ? from.data : ref(scope.getData(from.data).output);
}
function DataScope(scope, input, output, values, aggr) {
    this.scope = scope; // parent scope object
    this.input = input; // first operator in pipeline (tuple input)
    this.output = output; // last operator in pipeline (tuple output)
    this.values = values; // operator for accessing tuples (but not tuple flow)
    // last aggregate in transform pipeline
    this.aggregate = aggr;
    // lookup table of field indices
    this.index = {};
}
DataScope.fromEntries = function(scope, entries) {
    const n = entries.length, values = entries[n - 1], output = entries[n - 2];
    let input = entries[0], aggr = null, i = 1;
    if (input && input.type === 'load') input = entries[1];
    // add operator entries to this scope, wire up pulse chain
    scope.add(entries[0]);
    for(; i < n; ++i){
        entries[i].params.pulse = ref(entries[i - 1]);
        scope.add(entries[i]);
        if (entries[i].type === 'aggregate') aggr = entries[i];
    }
    return new DataScope(scope, input, output, values, aggr);
};
function fieldKey(field) {
    return (0, _vegaUtil.isString)(field) ? field : null;
}
function addSortField(scope, p, sort) {
    const as = aggrField(sort.op, sort.field);
    let s;
    if (p.ops) for(let i = 0, n = p.as.length; i < n; ++i){
        if (p.as[i] === as) return;
    }
    else {
        p.ops = [
            'count'
        ];
        p.fields = [
            null
        ];
        p.as = [
            'count'
        ];
    }
    if (sort.op) {
        p.ops.push((s = sort.op.signal) ? scope.signalRef(s) : sort.op);
        p.fields.push(scope.fieldRef(sort.field));
        p.as.push(as);
    }
}
function cache(scope, ds, name, optype, field, counts, index) {
    const cache = ds[name] || (ds[name] = {}), sort = sortKey(counts);
    let k = fieldKey(field), v, op;
    if (k != null) {
        scope = ds.scope;
        k = k + (sort ? '|' + sort : '');
        v = cache[k];
    }
    if (!v) {
        const params = counts ? {
            field: keyFieldRef,
            pulse: ds.countsRef(scope, field, counts)
        } : {
            field: scope.fieldRef(field),
            pulse: ref(ds.output)
        };
        if (sort) params.sort = scope.sortRef(counts);
        op = scope.add(entry(optype, undefined, params));
        if (index) ds.index[field] = op;
        v = ref(op);
        if (k != null) cache[k] = v;
    }
    return v;
}
DataScope.prototype = {
    countsRef (scope, field, sort) {
        const ds = this, cache = ds.counts || (ds.counts = {}), k = fieldKey(field);
        let v, a, p;
        if (k != null) {
            scope = ds.scope;
            v = cache[k];
        }
        if (!v) {
            p = {
                groupby: scope.fieldRef(field, 'key'),
                pulse: ref(ds.output)
            };
            if (sort && sort.field) addSortField(scope, p, sort);
            a = scope.add(Aggregate(p));
            v = scope.add(Collect({
                pulse: ref(a)
            }));
            v = {
                agg: a,
                ref: ref(v)
            };
            if (k != null) cache[k] = v;
        } else if (sort && sort.field) addSortField(scope, v.agg.params, sort);
        return v.ref;
    },
    tuplesRef () {
        return ref(this.values);
    },
    extentRef (scope, field) {
        return cache(scope, this, 'extent', 'extent', field, false);
    },
    domainRef (scope, field) {
        return cache(scope, this, 'domain', 'values', field, false);
    },
    valuesRef (scope, field, sort) {
        return cache(scope, this, 'vals', 'values', field, sort || true);
    },
    lookupRef (scope, field) {
        return cache(scope, this, 'lookup', 'tupleindex', field, false);
    },
    indataRef (scope, field) {
        return cache(scope, this, 'indata', 'tupleindex', field, true, true);
    }
};
function parseFacet(spec, scope, group) {
    const facet = spec.from.facet, name = facet.name, data = getDataRef(facet, scope);
    let op;
    if (!facet.name) (0, _vegaUtil.error)('Facet must have a name: ' + (0, _vegaUtil.stringValue)(facet));
    if (!facet.data) (0, _vegaUtil.error)('Facet must reference a data set: ' + (0, _vegaUtil.stringValue)(facet));
    if (facet.field) op = scope.add(PreFacet({
        field: scope.fieldRef(facet.field),
        pulse: data
    }));
    else if (facet.groupby) op = scope.add(Facet({
        key: scope.keyRef(facet.groupby),
        group: ref(scope.proxy(group.parent)),
        pulse: data
    }));
    else (0, _vegaUtil.error)('Facet must specify groupby or field: ' + (0, _vegaUtil.stringValue)(facet));
    // initialize facet subscope
    const subscope = scope.fork(), source = subscope.add(Collect()), values = subscope.add(Sieve({
        pulse: ref(source)
    }));
    subscope.addData(name, new DataScope(subscope, source, source, values));
    subscope.addSignal('parent', null);
    // parse faceted subflow
    op.params.subflow = {
        $subflow: subscope.parse(spec).toRuntime()
    };
}
function parseSubflow(spec, scope, input) {
    const op = scope.add(PreFacet({
        pulse: input.pulse
    })), subscope = scope.fork();
    subscope.add(Sieve());
    subscope.addSignal('parent', null);
    // parse group mark subflow
    op.params.subflow = {
        $subflow: subscope.parse(spec).toRuntime()
    };
}
function parseTrigger(spec, scope, name) {
    const remove = spec.remove, insert = spec.insert, toggle = spec.toggle, modify = spec.modify, values = spec.values, op = scope.add(operator());
    const update = 'if(' + spec.trigger + ',modify("' + name + '",' + [
        insert,
        remove,
        toggle,
        modify,
        values
    ].map((_)=>_ == null ? 'null' : _).join(',') + '),0)';
    const expr = (0, _vegaFunctions.parseExpression)(update, scope);
    op.update = expr.$expr;
    op.params = expr.$params;
}
function parseMark(spec, scope) {
    const role = getRole(spec), group = spec.type === GroupMark, facet = spec.from && spec.from.facet, overlap = spec.overlap;
    let layout = spec.layout || role === ScopeRole || role === FrameRole, ops, op, store, enc, name, layoutRef, boundRef;
    const nested = role === MarkRole || layout || facet;
    // resolve input data
    const input = parseData$1(spec.from, group, scope);
    // data join to map tuples to visual items
    op = scope.add(DataJoin({
        key: input.key || (spec.key ? fieldRef$1(spec.key) : undefined),
        pulse: input.pulse,
        clean: !group
    }));
    const joinRef = ref(op);
    // collect visual items
    op = store = scope.add(Collect({
        pulse: joinRef
    }));
    // connect visual items to scenegraph
    op = scope.add(Mark({
        markdef: definition(spec),
        interactive: interactive(spec.interactive, scope),
        clip: clip(spec.clip, scope),
        context: {
            $context: true
        },
        groups: scope.lookup(),
        parent: scope.signals.parent ? scope.signalRef('parent') : null,
        index: scope.markpath(),
        pulse: ref(op)
    }));
    const markRef = ref(op);
    // add visual encoders
    op = enc = scope.add(Encode(parseEncode(spec.encode, spec.type, role, spec.style, scope, {
        mod: false,
        pulse: markRef
    })));
    // monitor parent marks to propagate changes
    op.params.parent = scope.encode();
    // add post-encoding transforms, if defined
    if (spec.transform) spec.transform.forEach((_)=>{
        const tx = parseTransform(_, scope), md = tx.metadata;
        if (md.generates || md.changes) (0, _vegaUtil.error)('Mark transforms should not generate new data.');
        if (!md.nomod) enc.params.mod = true; // update encode mod handling
        tx.params.pulse = ref(op);
        scope.add(op = tx);
    });
    // if item sort specified, perform post-encoding
    if (spec.sort) op = scope.add(SortItems({
        sort: scope.compareRef(spec.sort),
        pulse: ref(op)
    }));
    const encodeRef = ref(op);
    // add view layout operator if needed
    if (facet || layout) {
        layout = scope.add(ViewLayout({
            layout: scope.objectProperty(spec.layout),
            legends: scope.legends,
            mark: markRef,
            pulse: encodeRef
        }));
        layoutRef = ref(layout);
    }
    // compute bounding boxes
    const bound = scope.add(Bound({
        mark: markRef,
        pulse: layoutRef || encodeRef
    }));
    boundRef = ref(bound);
    // if group mark, recurse to parse nested content
    if (group) {
        // juggle layout & bounds to ensure they run *after* any faceting transforms
        if (nested) {
            ops = scope.operators;
            ops.pop();
            if (layout) ops.pop();
        }
        scope.pushState(encodeRef, layoutRef || boundRef, joinRef);
        facet ? parseFacet(spec, scope, input) // explicit facet
         : nested ? parseSubflow(spec, scope, input) // standard mark group
         : scope.parse(spec); // guide group, we can avoid nested scopes
        scope.popState();
        if (nested) {
            if (layout) ops.push(layout);
            ops.push(bound);
        }
    }
    // if requested, add overlap removal transform
    if (overlap) boundRef = parseOverlap(overlap, boundRef, scope);
    // render / sieve items
    const render = scope.add(Render({
        pulse: boundRef
    })), sieve = scope.add(Sieve({
        pulse: ref(render)
    }, undefined, scope.parent()));
    // if mark is named, make accessible as reactive geometry
    // add trigger updates if defined
    if (spec.name != null) {
        name = spec.name;
        scope.addData(name, new DataScope(scope, store, render, sieve));
        if (spec.on) spec.on.forEach((on)=>{
            if (on.insert || on.remove || on.toggle) (0, _vegaUtil.error)('Marks only support modify triggers.');
            parseTrigger(on, scope, name);
        });
    }
}
function parseOverlap(overlap, source, scope) {
    const method = overlap.method, bound = overlap.bound, sep = overlap.separation;
    const params = {
        separation: isSignal(sep) ? scope.signalRef(sep.signal) : sep,
        method: isSignal(method) ? scope.signalRef(method.signal) : method,
        pulse: source
    };
    if (overlap.order) params.sort = scope.compareRef({
        field: overlap.order
    });
    if (bound) {
        const tol = bound.tolerance;
        params.boundTolerance = isSignal(tol) ? scope.signalRef(tol.signal) : +tol;
        params.boundScale = scope.scaleRef(bound.scale);
        params.boundOrient = bound.orient;
    }
    return ref(scope.add(Overlap(params)));
}
function parseLegend(spec, scope) {
    const config = scope.config.legend, encode = spec.encode || {}, _ = lookup(spec, config), legendEncode = encode.legend || {}, name = legendEncode.name || undefined, interactive = legendEncode.interactive, style = legendEncode.style, scales = {};
    let scale = 0, entryLayout, params, children;
    // resolve scales and 'canonical' scale name
    LegendScales.forEach((s)=>spec[s] ? (scales[s] = spec[s], scale = scale || spec[s]) : 0);
    if (!scale) (0, _vegaUtil.error)('Missing valid scale for legend.');
    // resolve legend type (symbol, gradient, or discrete gradient)
    const type = legendType(spec, scope.scaleType(scale));
    // single-element data source for legend group
    const datum = {
        title: spec.title != null,
        scales: scales,
        type: type,
        vgrad: type !== 'symbol' && _.isVertical()
    };
    const dataRef = ref(scope.add(Collect(null, [
        datum
    ])));
    // encoding properties for legend entry sub-group
    const entryEncode = {
        enter: {
            x: {
                value: 0
            },
            y: {
                value: 0
            }
        }
    };
    // data source for legend values
    const entryRef = ref(scope.add(LegendEntries(params = {
        type: type,
        scale: scope.scaleRef(scale),
        count: scope.objectProperty(_('tickCount')),
        limit: scope.property(_('symbolLimit')),
        values: scope.objectProperty(spec.values),
        minstep: scope.property(spec.tickMinStep),
        formatType: scope.property(spec.formatType),
        formatSpecifier: scope.property(spec.format)
    })));
    // continuous gradient legend
    if (type === Gradient) {
        children = [
            legendGradient(spec, scale, config, encode.gradient),
            legendGradientLabels(spec, config, encode.labels, entryRef)
        ];
        // adjust default tick count based on the gradient length
        params.count = params.count || scope.signalRef(`max(2,2*floor((${deref(_.gradientLength())})/100))`);
    } else if (type === Discrete) children = [
        legendGradientDiscrete(spec, scale, config, encode.gradient, entryRef),
        legendGradientLabels(spec, config, encode.labels, entryRef)
    ];
    else {
        // determine legend symbol group layout
        entryLayout = legendSymbolLayout(spec, config);
        children = [
            legendSymbolGroups(spec, config, encode, entryRef, deref(entryLayout.columns))
        ];
        // pass symbol size information to legend entry generator
        params.size = sizeExpression(spec, scope, children[0].marks);
    }
    // generate legend marks
    children = [
        guideGroup({
            role: LegendEntryRole,
            from: dataRef,
            encode: entryEncode,
            marks: children,
            layout: entryLayout,
            interactive
        })
    ];
    // include legend title if defined
    if (datum.title) children.push(legendTitle(spec, config, encode.title, dataRef));
    // parse legend specification
    return parseMark(guideGroup({
        role: LegendRole,
        from: dataRef,
        encode: extendEncode(buildLegendEncode(_, spec, config), legendEncode, Skip),
        marks: children,
        aria: _('aria'),
        description: _('description'),
        zindex: _('zindex'),
        name,
        interactive,
        style
    }), scope);
}
function legendType(spec, scaleType) {
    let type = spec.type || Symbols;
    if (!spec.type && scaleCount(spec) === 1 && (spec.fill || spec.stroke)) type = (0, _vegaScale.isContinuous)(scaleType) ? Gradient : (0, _vegaScale.isDiscretizing)(scaleType) ? Discrete : Symbols;
    return type !== Gradient ? type : (0, _vegaScale.isDiscretizing)(scaleType) ? Discrete : Gradient;
}
function scaleCount(spec) {
    return LegendScales.reduce((count, type)=>count + (spec[type] ? 1 : 0), 0);
}
function buildLegendEncode(_, spec, config) {
    const encode = {
        enter: {},
        update: {}
    };
    addEncoders(encode, {
        orient: _('orient'),
        offset: _('offset'),
        padding: _('padding'),
        titlePadding: _('titlePadding'),
        cornerRadius: _('cornerRadius'),
        fill: _('fillColor'),
        stroke: _('strokeColor'),
        strokeWidth: config.strokeWidth,
        strokeDash: config.strokeDash,
        x: _('legendX'),
        y: _('legendY'),
        // accessibility support
        format: spec.format,
        formatType: spec.formatType
    });
    return encode;
}
function sizeExpression(spec, scope, marks) {
    const size = deref(getChannel('size', spec, marks)), strokeWidth = deref(getChannel('strokeWidth', spec, marks)), fontSize = deref(getFontSize(marks[1].encode, scope, GuideLabelStyle));
    return (0, _vegaFunctions.parseExpression)(`max(ceil(sqrt(${size})+${strokeWidth}),${fontSize})`, scope);
}
function getChannel(name, spec, marks) {
    return spec[name] ? `scale("${spec[name]}",datum)` : getEncoding(name, marks[0].encode);
}
function getFontSize(encode, scope, style) {
    return getEncoding('fontSize', encode) || getStyle('fontSize', scope, style);
}
const angleExpr = `item.orient==="${Left}"?-90:item.orient==="${Right}"?90:0`;
function parseTitle(spec, scope) {
    spec = (0, _vegaUtil.isString)(spec) ? {
        text: spec
    } : spec;
    const _ = lookup(spec, scope.config.title), encode = spec.encode || {}, userEncode = encode.group || {}, name = userEncode.name || undefined, interactive = userEncode.interactive, style = userEncode.style, children = [];
    // single-element data source for group title
    const datum = {}, dataRef = ref(scope.add(Collect(null, [
        datum
    ])));
    // include title text
    children.push(buildTitle(spec, _, titleEncode(spec), dataRef));
    // include subtitle text
    if (spec.subtitle) children.push(buildSubTitle(spec, _, encode.subtitle, dataRef));
    // parse title specification
    return parseMark(guideGroup({
        role: TitleRole,
        from: dataRef,
        encode: groupEncode(_, userEncode),
        marks: children,
        aria: _('aria'),
        description: _('description'),
        zindex: _('zindex'),
        name,
        interactive,
        style
    }), scope);
}
// provide backwards-compatibility for title custom encode;
// the top-level encode block has been *deprecated*.
function titleEncode(spec) {
    const encode = spec.encode;
    return encode && encode.title || (0, _vegaUtil.extend)({
        name: spec.name,
        interactive: spec.interactive,
        style: spec.style
    }, encode);
}
function groupEncode(_, userEncode) {
    const encode = {
        enter: {},
        update: {}
    };
    addEncoders(encode, {
        orient: _('orient'),
        anchor: _('anchor'),
        align: {
            signal: alignExpr$1
        },
        angle: {
            signal: angleExpr
        },
        limit: _('limit'),
        frame: _('frame'),
        offset: _('offset') || 0,
        padding: _('subtitlePadding')
    });
    return extendEncode(encode, userEncode, Skip);
}
function buildTitle(spec, _, userEncode, dataRef) {
    const zero = {
        value: 0
    }, text = spec.text, encode = {
        enter: {
            opacity: zero
        },
        update: {
            opacity: {
                value: 1
            }
        },
        exit: {
            opacity: zero
        }
    };
    addEncoders(encode, {
        text: text,
        align: {
            signal: 'item.mark.group.align'
        },
        angle: {
            signal: 'item.mark.group.angle'
        },
        limit: {
            signal: 'item.mark.group.limit'
        },
        baseline: 'top',
        dx: _('dx'),
        dy: _('dy'),
        fill: _('color'),
        font: _('font'),
        fontSize: _('fontSize'),
        fontStyle: _('fontStyle'),
        fontWeight: _('fontWeight'),
        lineHeight: _('lineHeight')
    }, {
        // update
        align: _('align'),
        angle: _('angle'),
        baseline: _('baseline')
    });
    return guideMark({
        type: TextMark,
        role: TitleTextRole,
        style: GroupTitleStyle,
        from: dataRef,
        encode
    }, userEncode);
}
function buildSubTitle(spec, _, userEncode, dataRef) {
    const zero = {
        value: 0
    }, text = spec.subtitle, encode = {
        enter: {
            opacity: zero
        },
        update: {
            opacity: {
                value: 1
            }
        },
        exit: {
            opacity: zero
        }
    };
    addEncoders(encode, {
        text: text,
        align: {
            signal: 'item.mark.group.align'
        },
        angle: {
            signal: 'item.mark.group.angle'
        },
        limit: {
            signal: 'item.mark.group.limit'
        },
        baseline: 'top',
        dx: _('dx'),
        dy: _('dy'),
        fill: _('subtitleColor'),
        font: _('subtitleFont'),
        fontSize: _('subtitleFontSize'),
        fontStyle: _('subtitleFontStyle'),
        fontWeight: _('subtitleFontWeight'),
        lineHeight: _('subtitleLineHeight')
    }, {
        // update
        align: _('align'),
        angle: _('angle'),
        baseline: _('baseline')
    });
    return guideMark({
        type: TextMark,
        role: TitleSubtitleRole,
        style: GroupSubtitleStyle,
        from: dataRef,
        encode
    }, userEncode);
}
function parseData(data, scope) {
    const transforms = [];
    if (data.transform) data.transform.forEach((tx)=>{
        transforms.push(parseTransform(tx, scope));
    });
    if (data.on) data.on.forEach((on)=>{
        parseTrigger(on, scope, data.name);
    });
    scope.addDataPipeline(data.name, analyze(data, scope, transforms));
}
/**
 * Analyze a data pipeline, add needed operators.
 */ function analyze(data, scope, ops) {
    const output = [];
    let source = null, modify = false, generate = false, upstream, i, n, t, m;
    if (data.values) {
        // hard-wired input data set
        if (isSignal(data.values) || hasSignal(data.format)) {
            // if either values is signal or format has signal, use dynamic loader
            output.push(load(scope, data));
            output.push(source = collect());
        } else // otherwise, ingest upon dataflow init
        output.push(source = collect({
            $ingest: data.values,
            $format: data.format
        }));
    } else if (data.url) {
        // load data from external source
        if (hasSignal(data.url) || hasSignal(data.format)) {
            // if either url or format has signal, use dynamic loader
            output.push(load(scope, data));
            output.push(source = collect());
        } else // otherwise, request load upon dataflow init
        output.push(source = collect({
            $request: data.url,
            $format: data.format
        }));
    } else if (data.source) {
        // derives from one or more other data sets
        source = upstream = (0, _vegaUtil.array)(data.source).map((d)=>ref(scope.getData(d).output));
        output.push(null); // populate later
    }
    // scan data transforms, add collectors as needed
    for(i = 0, n = ops.length; i < n; ++i){
        t = ops[i];
        m = t.metadata;
        if (!source && !m.source) output.push(source = collect());
        output.push(t);
        if (m.generates) generate = true;
        if (m.modifies && !generate) modify = true;
        if (m.source) source = t;
        else if (m.changes) source = null;
    }
    if (upstream) {
        n = upstream.length - 1;
        output[0] = Relay({
            derive: modify,
            pulse: n ? upstream : upstream[0]
        });
        if (modify || n) // collect derived and multi-pulse tuples
        output.splice(1, 0, collect());
    }
    if (!source) output.push(collect());
    output.push(Sieve({}));
    return output;
}
function collect(values) {
    const s = Collect({}, values);
    s.metadata = {
        source: true
    };
    return s;
}
function load(scope, data) {
    return Load({
        url: data.url ? scope.property(data.url) : undefined,
        async: data.async ? scope.property(data.async) : undefined,
        values: data.values ? scope.property(data.values) : undefined,
        format: scope.objectProperty(data.format)
    });
}
const isX = (orient)=>orient === Bottom || orient === Top;
// get sign coefficient based on axis orient
const getSign = (orient, a, b)=>isSignal(orient) ? ifLeftTopExpr(orient.signal, a, b) : orient === Left || orient === Top ? a : b;
// condition on axis x-direction
const ifX = (orient, a, b)=>isSignal(orient) ? ifXEnc(orient.signal, a, b) : isX(orient) ? a : b;
// condition on axis y-direction
const ifY = (orient, a, b)=>isSignal(orient) ? ifYEnc(orient.signal, a, b) : isX(orient) ? b : a;
const ifTop = (orient, a, b)=>isSignal(orient) ? ifTopExpr(orient.signal, a, b) : orient === Top ? {
        value: a
    } : {
        value: b
    };
const ifRight = (orient, a, b)=>isSignal(orient) ? ifRightExpr(orient.signal, a, b) : orient === Right ? {
        value: a
    } : {
        value: b
    };
const ifXEnc = ($orient, a, b)=>ifEnc(`${$orient} === '${Top}' || ${$orient} === '${Bottom}'`, a, b);
const ifYEnc = ($orient, a, b)=>ifEnc(`${$orient} !== '${Top}' && ${$orient} !== '${Bottom}'`, a, b);
const ifLeftTopExpr = ($orient, a, b)=>ifExpr(`${$orient} === '${Left}' || ${$orient} === '${Top}'`, a, b);
const ifTopExpr = ($orient, a, b)=>ifExpr(`${$orient} === '${Top}'`, a, b);
const ifRightExpr = ($orient, a, b)=>ifExpr(`${$orient} === '${Right}'`, a, b);
const ifEnc = (test, a, b)=>{
    // ensure inputs are encoder objects (or null)
    a = a != null ? encoder(a) : a;
    b = b != null ? encoder(b) : b;
    if (isSimple(a) && isSimple(b)) {
        // if possible generate simple signal expression
        a = a ? a.signal || (0, _vegaUtil.stringValue)(a.value) : null;
        b = b ? b.signal || (0, _vegaUtil.stringValue)(b.value) : null;
        return {
            signal: `${test} ? (${a}) : (${b})`
        };
    } else // otherwise generate rule set
    return [
        (0, _vegaUtil.extend)({
            test
        }, a)
    ].concat(b || []);
};
const isSimple = (enc)=>enc == null || Object.keys(enc).length === 1;
const ifExpr = (test, a, b)=>({
        signal: `${test} ? (${toExpr(a)}) : (${toExpr(b)})`
    });
const ifOrient = ($orient, t, b, l, r)=>({
        signal: (l != null ? `${$orient} === '${Left}' ? (${toExpr(l)}) : ` : '') + (b != null ? `${$orient} === '${Bottom}' ? (${toExpr(b)}) : ` : '') + (r != null ? `${$orient} === '${Right}' ? (${toExpr(r)}) : ` : '') + (t != null ? `${$orient} === '${Top}' ? (${toExpr(t)}) : ` : '') + '(null)'
    });
const toExpr = (v)=>isSignal(v) ? v.signal : v == null ? null : (0, _vegaUtil.stringValue)(v);
const mult = (sign, value)=>value === 0 ? 0 : isSignal(sign) ? {
        signal: `(${sign.signal}) * ${value}`
    } : {
        value: sign * value
    };
const patch = (value, base)=>{
    const s = value.signal;
    return s && s.endsWith('(null)') ? {
        signal: s.slice(0, -6) + base.signal
    } : value;
};
function fallback(prop, config, axisConfig, style) {
    let styleProp;
    if (config && (0, _vegaUtil.hasOwnProperty)(config, prop)) return config[prop];
    else if ((0, _vegaUtil.hasOwnProperty)(axisConfig, prop)) return axisConfig[prop];
    else if (prop.startsWith('title')) {
        switch(prop){
            case 'titleColor':
                styleProp = 'fill';
                break;
            case 'titleFont':
            case 'titleFontSize':
            case 'titleFontWeight':
                styleProp = prop[5].toLowerCase() + prop.slice(6);
        }
        return style[GuideTitleStyle][styleProp];
    } else if (prop.startsWith('label')) {
        switch(prop){
            case 'labelColor':
                styleProp = 'fill';
                break;
            case 'labelFont':
            case 'labelFontSize':
                styleProp = prop[5].toLowerCase() + prop.slice(6);
        }
        return style[GuideLabelStyle][styleProp];
    }
    return null;
}
function keys(objects) {
    const map = {};
    for (const obj of objects){
        if (!obj) continue;
        for(const key in obj)map[key] = 1;
    }
    return Object.keys(map);
}
function axisConfig(spec, scope) {
    var config = scope.config, style = config.style, axis = config.axis, band = scope.scaleType(spec.scale) === 'band' && config.axisBand, orient = spec.orient, xy, or, key;
    if (isSignal(orient)) {
        const xyKeys = keys([
            config.axisX,
            config.axisY
        ]), orientKeys = keys([
            config.axisTop,
            config.axisBottom,
            config.axisLeft,
            config.axisRight
        ]);
        xy = {};
        for (key of xyKeys)xy[key] = ifX(orient, fallback(key, config.axisX, axis, style), fallback(key, config.axisY, axis, style));
        or = {};
        for (key of orientKeys)or[key] = ifOrient(orient.signal, fallback(key, config.axisTop, axis, style), fallback(key, config.axisBottom, axis, style), fallback(key, config.axisLeft, axis, style), fallback(key, config.axisRight, axis, style));
    } else {
        xy = orient === Top || orient === Bottom ? config.axisX : config.axisY;
        or = config['axis' + orient[0].toUpperCase() + orient.slice(1)];
    }
    const result = xy || or || band ? (0, _vegaUtil.extend)({}, axis, xy, or, band) : axis;
    return result;
}
function axisDomain(spec, config, userEncode, dataRef) {
    const _ = lookup(spec, config), orient = spec.orient;
    let enter, update;
    const encode = {
        enter: enter = {
            opacity: zero
        },
        update: update = {
            opacity: one
        },
        exit: {
            opacity: zero
        }
    };
    addEncoders(encode, {
        stroke: _('domainColor'),
        strokeCap: _('domainCap'),
        strokeDash: _('domainDash'),
        strokeDashOffset: _('domainDashOffset'),
        strokeWidth: _('domainWidth'),
        strokeOpacity: _('domainOpacity')
    });
    const pos0 = position(spec, 0);
    const pos1 = position(spec, 1);
    enter.x = update.x = ifX(orient, pos0, zero);
    enter.x2 = update.x2 = ifX(orient, pos1);
    enter.y = update.y = ifY(orient, pos0, zero);
    enter.y2 = update.y2 = ifY(orient, pos1);
    return guideMark({
        type: RuleMark,
        role: AxisDomainRole,
        from: dataRef,
        encode
    }, userEncode);
}
function position(spec, pos) {
    return {
        scale: spec.scale,
        range: pos
    };
}
function axisGrid(spec, config, userEncode, dataRef, band) {
    const _ = lookup(spec, config), orient = spec.orient, vscale = spec.gridScale, sign = getSign(orient, 1, -1), offset = offsetValue(spec.offset, sign);
    let enter, exit, update;
    const encode = {
        enter: enter = {
            opacity: zero
        },
        update: update = {
            opacity: one
        },
        exit: exit = {
            opacity: zero
        }
    };
    addEncoders(encode, {
        stroke: _('gridColor'),
        strokeCap: _('gridCap'),
        strokeDash: _('gridDash'),
        strokeDashOffset: _('gridDashOffset'),
        strokeOpacity: _('gridOpacity'),
        strokeWidth: _('gridWidth')
    });
    const tickPos = {
        scale: spec.scale,
        field: Value,
        band: band.band,
        extra: band.extra,
        offset: band.offset,
        round: _('tickRound')
    };
    const sz = ifX(orient, {
        signal: 'height'
    }, {
        signal: 'width'
    });
    const gridStart = vscale ? {
        scale: vscale,
        range: 0,
        mult: sign,
        offset: offset
    } : {
        value: 0,
        offset: offset
    };
    const gridEnd = vscale ? {
        scale: vscale,
        range: 1,
        mult: sign,
        offset: offset
    } : (0, _vegaUtil.extend)(sz, {
        mult: sign,
        offset: offset
    });
    enter.x = update.x = ifX(orient, tickPos, gridStart);
    enter.y = update.y = ifY(orient, tickPos, gridStart);
    enter.x2 = update.x2 = ifY(orient, gridEnd);
    enter.y2 = update.y2 = ifX(orient, gridEnd);
    exit.x = ifX(orient, tickPos);
    exit.y = ifY(orient, tickPos);
    return guideMark({
        type: RuleMark,
        role: AxisGridRole,
        key: Value,
        from: dataRef,
        encode
    }, userEncode);
}
function offsetValue(offset, sign) {
    if (sign === 1) ;
    else if (!(0, _vegaUtil.isObject)(offset)) offset = isSignal(sign) ? {
        signal: `(${sign.signal}) * (${offset || 0})`
    } : sign * (offset || 0);
    else {
        let entry = offset = (0, _vegaUtil.extend)({}, offset);
        while(entry.mult != null)if (!(0, _vegaUtil.isObject)(entry.mult)) {
            entry.mult = isSignal(sign) // no offset if sign === 1
             ? {
                signal: `(${entry.mult}) * (${sign.signal})`
            } : entry.mult * sign;
            return offset;
        } else entry = entry.mult = (0, _vegaUtil.extend)({}, entry.mult);
        entry.mult = sign;
    }
    return offset;
}
function axisTicks(spec, config, userEncode, dataRef, size, band) {
    const _ = lookup(spec, config), orient = spec.orient, sign = getSign(orient, -1, 1);
    let enter, exit, update;
    const encode = {
        enter: enter = {
            opacity: zero
        },
        update: update = {
            opacity: one
        },
        exit: exit = {
            opacity: zero
        }
    };
    addEncoders(encode, {
        stroke: _('tickColor'),
        strokeCap: _('tickCap'),
        strokeDash: _('tickDash'),
        strokeDashOffset: _('tickDashOffset'),
        strokeOpacity: _('tickOpacity'),
        strokeWidth: _('tickWidth')
    });
    const tickSize = encoder(size);
    tickSize.mult = sign;
    const tickPos = {
        scale: spec.scale,
        field: Value,
        band: band.band,
        extra: band.extra,
        offset: band.offset,
        round: _('tickRound')
    };
    update.y = enter.y = ifX(orient, zero, tickPos);
    update.y2 = enter.y2 = ifX(orient, tickSize);
    exit.x = ifX(orient, tickPos);
    update.x = enter.x = ifY(orient, zero, tickPos);
    update.x2 = enter.x2 = ifY(orient, tickSize);
    exit.y = ifY(orient, tickPos);
    return guideMark({
        type: RuleMark,
        role: AxisTickRole,
        key: Value,
        from: dataRef,
        encode
    }, userEncode);
}
function flushExpr(scale, threshold, a, b, c) {
    return {
        signal: 'flush(range("' + scale + '"), ' + 'scale("' + scale + '", datum.value), ' + threshold + ',' + a + ',' + b + ',' + c + ')'
    };
}
function axisLabels(spec, config, userEncode, dataRef, size, band) {
    const _ = lookup(spec, config), orient = spec.orient, scale = spec.scale, sign = getSign(orient, -1, 1), flush = deref(_('labelFlush')), flushOffset = deref(_('labelFlushOffset')), labelAlign = _('labelAlign'), labelBaseline = _('labelBaseline');
    let flushOn = flush === 0 || !!flush, update;
    const tickSize = encoder(size);
    tickSize.mult = sign;
    tickSize.offset = encoder(_('labelPadding') || 0);
    tickSize.offset.mult = sign;
    const tickPos = {
        scale: scale,
        field: Value,
        band: 0.5,
        offset: extendOffset(band.offset, _('labelOffset'))
    };
    const align = ifX(orient, flushOn ? flushExpr(scale, flush, '"left"', '"right"', '"center"') : {
        value: 'center'
    }, ifRight(orient, 'left', 'right'));
    const baseline = ifX(orient, ifTop(orient, 'bottom', 'top'), flushOn ? flushExpr(scale, flush, '"top"', '"bottom"', '"middle"') : {
        value: 'middle'
    });
    const offsetExpr = flushExpr(scale, flush, `-(${flushOffset})`, flushOffset, 0);
    flushOn = flushOn && flushOffset;
    const enter = {
        opacity: zero,
        x: ifX(orient, tickPos, tickSize),
        y: ifY(orient, tickPos, tickSize)
    };
    const encode = {
        enter: enter,
        update: update = {
            opacity: one,
            text: {
                field: Label
            },
            x: enter.x,
            y: enter.y,
            align,
            baseline
        },
        exit: {
            opacity: zero,
            x: enter.x,
            y: enter.y
        }
    };
    addEncoders(encode, {
        dx: !labelAlign && flushOn ? ifX(orient, offsetExpr) : null,
        dy: !labelBaseline && flushOn ? ifY(orient, offsetExpr) : null
    });
    addEncoders(encode, {
        angle: _('labelAngle'),
        fill: _('labelColor'),
        fillOpacity: _('labelOpacity'),
        font: _('labelFont'),
        fontSize: _('labelFontSize'),
        fontWeight: _('labelFontWeight'),
        fontStyle: _('labelFontStyle'),
        limit: _('labelLimit'),
        lineHeight: _('labelLineHeight')
    }, {
        align: labelAlign,
        baseline: labelBaseline
    });
    const bound = _('labelBound');
    let overlap = _('labelOverlap');
    // if overlap method or bound defined, request label overlap removal
    overlap = overlap || bound ? {
        separation: _('labelSeparation'),
        method: overlap,
        order: 'datum.index',
        bound: bound ? {
            scale,
            orient,
            tolerance: bound
        } : null
    } : undefined;
    if (update.align !== align) update.align = patch(update.align, align);
    if (update.baseline !== baseline) update.baseline = patch(update.baseline, baseline);
    return guideMark({
        type: TextMark,
        role: AxisLabelRole,
        style: GuideLabelStyle,
        key: Value,
        from: dataRef,
        encode,
        overlap
    }, userEncode);
}
function axisTitle(spec, config, userEncode, dataRef) {
    const _ = lookup(spec, config), orient = spec.orient, sign = getSign(orient, -1, 1);
    let enter, update;
    const encode = {
        enter: enter = {
            opacity: zero,
            anchor: encoder(_('titleAnchor', null)),
            align: {
                signal: alignExpr$1
            }
        },
        update: update = (0, _vegaUtil.extend)({}, enter, {
            opacity: one,
            text: encoder(spec.title)
        }),
        exit: {
            opacity: zero
        }
    };
    const titlePos = {
        signal: `lerp(range("${spec.scale}"), ${anchorExpr(0, 1, 0.5)})`
    };
    update.x = ifX(orient, titlePos);
    update.y = ifY(orient, titlePos);
    enter.angle = ifX(orient, zero, mult(sign, 90));
    enter.baseline = ifX(orient, ifTop(orient, Bottom, Top), {
        value: Bottom
    });
    update.angle = enter.angle;
    update.baseline = enter.baseline;
    addEncoders(encode, {
        fill: _('titleColor'),
        fillOpacity: _('titleOpacity'),
        font: _('titleFont'),
        fontSize: _('titleFontSize'),
        fontStyle: _('titleFontStyle'),
        fontWeight: _('titleFontWeight'),
        limit: _('titleLimit'),
        lineHeight: _('titleLineHeight')
    }, {
        // require update
        align: _('titleAlign'),
        angle: _('titleAngle'),
        baseline: _('titleBaseline')
    });
    autoLayout(_, orient, encode, userEncode);
    encode.update.align = patch(encode.update.align, enter.align);
    encode.update.angle = patch(encode.update.angle, enter.angle);
    encode.update.baseline = patch(encode.update.baseline, enter.baseline);
    return guideMark({
        type: TextMark,
        role: AxisTitleRole,
        style: GuideTitleStyle,
        from: dataRef,
        encode
    }, userEncode);
}
function autoLayout(_, orient, encode, userEncode) {
    const auto = (value, dim)=>value != null ? (encode.update[dim] = patch(encoder(value), encode.update[dim]), false) : !has(dim, userEncode) ? true : false;
    const autoY = auto(_('titleX'), 'x'), autoX = auto(_('titleY'), 'y');
    encode.enter.auto = autoX === autoY ? encoder(autoX) : ifX(orient, encoder(autoX), encoder(autoY));
}
function parseAxis(spec, scope) {
    const config = axisConfig(spec, scope), encode = spec.encode || {}, axisEncode = encode.axis || {}, name = axisEncode.name || undefined, interactive = axisEncode.interactive, style = axisEncode.style, _ = lookup(spec, config), band = tickBand(_);
    // single-element data source for axis group
    const datum = {
        scale: spec.scale,
        ticks: !!_('ticks'),
        labels: !!_('labels'),
        grid: !!_('grid'),
        domain: !!_('domain'),
        title: spec.title != null
    };
    const dataRef = ref(scope.add(Collect({}, [
        datum
    ])));
    // data source for axis ticks
    const ticksRef = ref(scope.add(AxisTicks({
        scale: scope.scaleRef(spec.scale),
        extra: scope.property(band.extra),
        count: scope.objectProperty(spec.tickCount),
        values: scope.objectProperty(spec.values),
        minstep: scope.property(spec.tickMinStep),
        formatType: scope.property(spec.formatType),
        formatSpecifier: scope.property(spec.format)
    })));
    // generate axis marks
    const children = [];
    let size;
    // include axis gridlines if requested
    if (datum.grid) children.push(axisGrid(spec, config, encode.grid, ticksRef, band));
    // include axis ticks if requested
    if (datum.ticks) {
        size = _('tickSize');
        children.push(axisTicks(spec, config, encode.ticks, ticksRef, size, band));
    }
    // include axis labels if requested
    if (datum.labels) {
        size = datum.ticks ? size : 0;
        children.push(axisLabels(spec, config, encode.labels, ticksRef, size, band));
    }
    // include axis domain path if requested
    if (datum.domain) children.push(axisDomain(spec, config, encode.domain, dataRef));
    // include axis title if defined
    if (datum.title) children.push(axisTitle(spec, config, encode.title, dataRef));
    // parse axis specification
    return parseMark(guideGroup({
        role: AxisRole,
        from: dataRef,
        encode: extendEncode(buildAxisEncode(_, spec), axisEncode, Skip),
        marks: children,
        aria: _('aria'),
        description: _('description'),
        zindex: _('zindex'),
        name,
        interactive,
        style
    }), scope);
}
function buildAxisEncode(_, spec) {
    const encode = {
        enter: {},
        update: {}
    };
    addEncoders(encode, {
        orient: _('orient'),
        offset: _('offset') || 0,
        position: value(spec.position, 0),
        titlePadding: _('titlePadding'),
        minExtent: _('minExtent'),
        maxExtent: _('maxExtent'),
        range: {
            signal: `abs(span(range("${spec.scale}")))`
        },
        translate: _('translate'),
        // accessibility support
        format: spec.format,
        formatType: spec.formatType
    });
    return encode;
}
function parseScope(spec, scope, preprocessed) {
    const signals = (0, _vegaUtil.array)(spec.signals), scales = (0, _vegaUtil.array)(spec.scales);
    // parse signal definitions, if not already preprocessed
    if (!preprocessed) signals.forEach((_)=>parseSignal(_, scope));
    // parse cartographic projection definitions
    (0, _vegaUtil.array)(spec.projections).forEach((_)=>parseProjection(_, scope));
    // initialize scale references
    scales.forEach((_)=>initScale(_, scope));
    // parse data sources
    (0, _vegaUtil.array)(spec.data).forEach((_)=>parseData(_, scope));
    // parse scale definitions
    scales.forEach((_)=>parseScale(_, scope));
    // parse signal updates
    (preprocessed || signals).forEach((_)=>parseSignalUpdates(_, scope));
    // parse axis definitions
    (0, _vegaUtil.array)(spec.axes).forEach((_)=>parseAxis(_, scope));
    // parse mark definitions
    (0, _vegaUtil.array)(spec.marks).forEach((_)=>parseMark(_, scope));
    // parse legend definitions
    (0, _vegaUtil.array)(spec.legends).forEach((_)=>parseLegend(_, scope));
    // parse title, if defined
    if (spec.title) parseTitle(spec.title, scope);
    // parse collected lambda (anonymous) expressions
    scope.parseLambdas();
    return scope;
}
const rootEncode = (spec)=>extendEncode({
        enter: {
            x: {
                value: 0
            },
            y: {
                value: 0
            }
        },
        update: {
            width: {
                signal: 'width'
            },
            height: {
                signal: 'height'
            }
        }
    }, spec);
function parseView(spec, scope) {
    const config = scope.config;
    // add scenegraph root
    const root = ref(scope.root = scope.add(operator()));
    // parse top-level signal definitions
    const signals = collectSignals(spec, config);
    signals.forEach((_)=>parseSignal(_, scope));
    // assign description, event, legend, and locale configuration
    scope.description = spec.description || config.description;
    scope.eventConfig = config.events;
    scope.legends = scope.objectProperty(config.legend && config.legend.layout);
    scope.locale = config.locale;
    // store root group item
    const input = scope.add(Collect());
    // encode root group item
    const encode = scope.add(Encode(parseEncode(rootEncode(spec.encode), GroupMark, FrameRole, spec.style, scope, {
        pulse: ref(input)
    })));
    // perform view layout
    const parent = scope.add(ViewLayout({
        layout: scope.objectProperty(spec.layout),
        legends: scope.legends,
        autosize: scope.signalRef('autosize'),
        mark: root,
        pulse: ref(encode)
    }));
    scope.operators.pop();
    // parse remainder of specification
    scope.pushState(ref(encode), ref(parent), null);
    parseScope(spec, scope, signals);
    scope.operators.push(parent);
    // bound / render / sieve root item
    let op = scope.add(Bound({
        mark: root,
        pulse: ref(parent)
    }));
    op = scope.add(Render({
        pulse: ref(op)
    }));
    op = scope.add(Sieve({
        pulse: ref(op)
    }));
    // track metadata for root item
    scope.addData('root', new DataScope(scope, input, input, op));
    return scope;
}
function signalObject(name, value) {
    return value && value.signal ? {
        name,
        update: value.signal
    } : {
        name,
        value
    };
}
/**
 * Collect top-level signals, merging values as needed. Signals
 * defined in the config signals arrays are added only if that
 * signal is not explicitly defined in the specification.
 * Built-in signals (autosize, background, padding, width, height)
 * receive special treatment. They are initialized using the
 * top-level spec property, or, if undefined in the spec, using
 * the corresponding top-level config property. If this property
 * is a signal reference object, the signal expression maps to the
 * signal 'update' property. If the spec's top-level signal array
 * contains an entry that matches a built-in signal, that entry
 * will be merged with the built-in specification, potentially
 * overwriting existing 'value' or 'update' properties.
 */ function collectSignals(spec, config) {
    const _ = (name)=>value(spec[name], config[name]), signals = [
        signalObject('background', _('background')),
        signalObject('autosize', parseAutosize(_('autosize'))),
        signalObject('padding', parsePadding(_('padding'))),
        signalObject('width', _('width') || 0),
        signalObject('height', _('height') || 0)
    ], pre = signals.reduce((p, s)=>(p[s.name] = s, p), {}), map = {};
    // add spec signal array
    (0, _vegaUtil.array)(spec.signals).forEach((s)=>{
        if ((0, _vegaUtil.hasOwnProperty)(pre, s.name)) // merge if built-in signal
        s = (0, _vegaUtil.extend)(pre[s.name], s);
        else // otherwise add to signal list
        signals.push(s);
        map[s.name] = s;
    });
    // add config signal array
    (0, _vegaUtil.array)(config.signals).forEach((s)=>{
        if (!(0, _vegaUtil.hasOwnProperty)(map, s.name) && !(0, _vegaUtil.hasOwnProperty)(pre, s.name)) // add to signal list if not already defined
        signals.push(s);
    });
    return signals;
}
function Scope(config, options) {
    this.config = config || {};
    this.options = options || {};
    this.bindings = [];
    this.field = {};
    this.signals = {};
    this.lambdas = {};
    this.scales = {};
    this.events = {};
    this.data = {};
    this.streams = [];
    this.updates = [];
    this.operators = [];
    this.eventConfig = null;
    this.locale = null;
    this._id = 0;
    this._subid = 0;
    this._nextsub = [
        0
    ];
    this._parent = [];
    this._encode = [];
    this._lookup = [];
    this._markpath = [];
}
function Subscope(scope) {
    this.config = scope.config;
    this.options = scope.options;
    this.legends = scope.legends;
    this.field = Object.create(scope.field);
    this.signals = Object.create(scope.signals);
    this.lambdas = Object.create(scope.lambdas);
    this.scales = Object.create(scope.scales);
    this.events = Object.create(scope.events);
    this.data = Object.create(scope.data);
    this.streams = [];
    this.updates = [];
    this.operators = [];
    this._id = 0;
    this._subid = ++scope._nextsub[0];
    this._nextsub = scope._nextsub;
    this._parent = scope._parent.slice();
    this._encode = scope._encode.slice();
    this._lookup = scope._lookup.slice();
    this._markpath = scope._markpath;
}
Scope.prototype = Subscope.prototype = {
    parse (spec) {
        return parseScope(spec, this);
    },
    fork () {
        return new Subscope(this);
    },
    isSubscope () {
        return this._subid > 0;
    },
    toRuntime () {
        this.finish();
        return {
            description: this.description,
            operators: this.operators,
            streams: this.streams,
            updates: this.updates,
            bindings: this.bindings,
            eventConfig: this.eventConfig,
            locale: this.locale
        };
    },
    id () {
        return (this._subid ? this._subid + ':' : 0) + this._id++;
    },
    add (op) {
        this.operators.push(op);
        op.id = this.id();
        // if pre-registration references exist, resolve them now
        if (op.refs) {
            op.refs.forEach((ref)=>{
                ref.$ref = op.id;
            });
            op.refs = null;
        }
        return op;
    },
    proxy (op) {
        const vref = op instanceof Entry ? ref(op) : op;
        return this.add(Proxy({
            value: vref
        }));
    },
    addStream (stream) {
        this.streams.push(stream);
        stream.id = this.id();
        return stream;
    },
    addUpdate (update) {
        this.updates.push(update);
        return update;
    },
    // Apply metadata
    finish () {
        let name, ds;
        // annotate root
        if (this.root) this.root.root = true;
        // annotate signals
        for(name in this.signals)this.signals[name].signal = name;
        // annotate scales
        for(name in this.scales)this.scales[name].scale = name;
        // annotate data sets
        function annotate(op, name, type) {
            let data, list;
            if (op) {
                data = op.data || (op.data = {});
                list = data[name] || (data[name] = []);
                list.push(type);
            }
        }
        for(name in this.data){
            ds = this.data[name];
            annotate(ds.input, name, 'input');
            annotate(ds.output, name, 'output');
            annotate(ds.values, name, 'values');
            for(const field in ds.index)annotate(ds.index[field], name, 'index:' + field);
        }
        return this;
    },
    // ----
    pushState (encode, parent, lookup) {
        this._encode.push(ref(this.add(Sieve({
            pulse: encode
        }))));
        this._parent.push(parent);
        this._lookup.push(lookup ? ref(this.proxy(lookup)) : null);
        this._markpath.push(-1);
    },
    popState () {
        this._encode.pop();
        this._parent.pop();
        this._lookup.pop();
        this._markpath.pop();
    },
    parent () {
        return (0, _vegaUtil.peek)(this._parent);
    },
    encode () {
        return (0, _vegaUtil.peek)(this._encode);
    },
    lookup () {
        return (0, _vegaUtil.peek)(this._lookup);
    },
    markpath () {
        const p = this._markpath;
        return ++p[p.length - 1];
    },
    // ----
    fieldRef (field, name) {
        if ((0, _vegaUtil.isString)(field)) return fieldRef$1(field, name);
        if (!field.signal) (0, _vegaUtil.error)('Unsupported field reference: ' + (0, _vegaUtil.stringValue)(field));
        const s = field.signal;
        let f = this.field[s];
        if (!f) {
            const params = {
                name: this.signalRef(s)
            };
            if (name) params.as = name;
            this.field[s] = f = ref(this.add(Field(params)));
        }
        return f;
    },
    compareRef (cmp) {
        let signal = false;
        const check = (_)=>isSignal(_) ? (signal = true, this.signalRef(_.signal)) : isExpr$1(_) ? (signal = true, this.exprRef(_.expr)) : _;
        const fields = (0, _vegaUtil.array)(cmp.field).map(check), orders = (0, _vegaUtil.array)(cmp.order).map(check);
        return signal ? ref(this.add(Compare({
            fields: fields,
            orders: orders
        }))) : compareRef(fields, orders);
    },
    keyRef (fields, flat) {
        let signal = false;
        const check = (_)=>isSignal(_) ? (signal = true, ref(sig[_.signal])) : _;
        const sig = this.signals;
        fields = (0, _vegaUtil.array)(fields).map(check);
        return signal ? ref(this.add(Key({
            fields: fields,
            flat: flat
        }))) : keyRef(fields, flat);
    },
    sortRef (sort) {
        if (!sort) return sort;
        // including id ensures stable sorting
        const a = aggrField(sort.op, sort.field), o = sort.order || Ascending;
        return o.signal ? ref(this.add(Compare({
            fields: a,
            orders: this.signalRef(o.signal)
        }))) : compareRef(a, o);
    },
    // ----
    event (source, type) {
        const key = source + ':' + type;
        if (!this.events[key]) {
            const id = this.id();
            this.streams.push({
                id: id,
                source: source,
                type: type
            });
            this.events[key] = id;
        }
        return this.events[key];
    },
    // ----
    hasOwnSignal (name) {
        return (0, _vegaUtil.hasOwnProperty)(this.signals, name);
    },
    addSignal (name, value) {
        if (this.hasOwnSignal(name)) (0, _vegaUtil.error)('Duplicate signal name: ' + (0, _vegaUtil.stringValue)(name));
        const op = value instanceof Entry ? value : this.add(operator(value));
        return this.signals[name] = op;
    },
    getSignal (name) {
        if (!this.signals[name]) (0, _vegaUtil.error)('Unrecognized signal name: ' + (0, _vegaUtil.stringValue)(name));
        return this.signals[name];
    },
    signalRef (s) {
        if (this.signals[s]) return ref(this.signals[s]);
        else if (!(0, _vegaUtil.hasOwnProperty)(this.lambdas, s)) this.lambdas[s] = this.add(operator(null));
        return ref(this.lambdas[s]);
    },
    parseLambdas () {
        const code = Object.keys(this.lambdas);
        for(let i = 0, n = code.length; i < n; ++i){
            const s = code[i], e = (0, _vegaFunctions.parseExpression)(s, this), op = this.lambdas[s];
            op.params = e.$params;
            op.update = e.$expr;
        }
    },
    property (spec) {
        return spec && spec.signal ? this.signalRef(spec.signal) : spec;
    },
    objectProperty (spec) {
        return !spec || !(0, _vegaUtil.isObject)(spec) ? spec : this.signalRef(spec.signal || propertyLambda(spec));
    },
    exprRef (code, name) {
        const params = {
            expr: (0, _vegaFunctions.parseExpression)(code, this)
        };
        if (name) params.expr.$name = name;
        return ref(this.add(Expression(params)));
    },
    addBinding (name, bind) {
        if (!this.bindings) (0, _vegaUtil.error)('Nested signals do not support binding: ' + (0, _vegaUtil.stringValue)(name));
        this.bindings.push((0, _vegaUtil.extend)({
            signal: name
        }, bind));
    },
    // ----
    addScaleProj (name, transform) {
        if ((0, _vegaUtil.hasOwnProperty)(this.scales, name)) (0, _vegaUtil.error)('Duplicate scale or projection name: ' + (0, _vegaUtil.stringValue)(name));
        this.scales[name] = this.add(transform);
    },
    addScale (name, params) {
        this.addScaleProj(name, Scale(params));
    },
    addProjection (name, params) {
        this.addScaleProj(name, Projection(params));
    },
    getScale (name) {
        if (!this.scales[name]) (0, _vegaUtil.error)('Unrecognized scale name: ' + (0, _vegaUtil.stringValue)(name));
        return this.scales[name];
    },
    scaleRef (name) {
        return ref(this.getScale(name));
    },
    scaleType (name) {
        return this.getScale(name).params.type;
    },
    projectionRef (name) {
        return this.scaleRef(name);
    },
    projectionType (name) {
        return this.scaleType(name);
    },
    // ----
    addData (name, dataScope) {
        if ((0, _vegaUtil.hasOwnProperty)(this.data, name)) (0, _vegaUtil.error)('Duplicate data set name: ' + (0, _vegaUtil.stringValue)(name));
        return this.data[name] = dataScope;
    },
    getData (name) {
        if (!this.data[name]) (0, _vegaUtil.error)('Undefined data set name: ' + (0, _vegaUtil.stringValue)(name));
        return this.data[name];
    },
    addDataPipeline (name, entries) {
        if ((0, _vegaUtil.hasOwnProperty)(this.data, name)) (0, _vegaUtil.error)('Duplicate data set name: ' + (0, _vegaUtil.stringValue)(name));
        return this.addData(name, DataScope.fromEntries(this, entries));
    }
};
function propertyLambda(spec) {
    return ((0, _vegaUtil.isArray)(spec) ? arrayLambda : objectLambda)(spec);
}
function arrayLambda(array) {
    const n = array.length;
    let code = '[';
    for(let i = 0; i < n; ++i){
        const value = array[i];
        code += (i > 0 ? ',' : '') + ((0, _vegaUtil.isObject)(value) ? value.signal || propertyLambda(value) : (0, _vegaUtil.stringValue)(value));
    }
    return code + ']';
}
function objectLambda(obj) {
    let code = '{', i = 0, key, value;
    for(key in obj){
        value = obj[key];
        code += (++i > 1 ? ',' : '') + (0, _vegaUtil.stringValue)(key) + ':' + ((0, _vegaUtil.isObject)(value) ? value.signal || propertyLambda(value) : (0, _vegaUtil.stringValue)(value));
    }
    return code + '}';
}
/**
 * Standard configuration defaults for Vega specification parsing.
 * Users can provide their own (sub-)set of these default values
 * by passing in a config object to the top-level parse method.
 */ function defaults() {
    const defaultFont = 'sans-serif', defaultSymbolSize = 30, defaultStrokeWidth = 2, defaultColor = '#4c78a8', black = '#000', gray = '#888', lightGray = '#ddd';
    return {
        // default visualization description
        description: 'Vega visualization',
        // default padding around visualization
        padding: 0,
        // default for automatic sizing; options: 'none', 'pad', 'fit'
        // or provide an object (e.g., {'type': 'pad', 'resize': true})
        autosize: 'pad',
        // default view background color
        // covers the entire view component
        background: null,
        // default event handling configuration
        // preventDefault for view-sourced event types except 'wheel'
        events: {
            defaults: {
                allow: [
                    'wheel'
                ]
            }
        },
        // defaults for top-level group marks
        // accepts mark properties (fill, stroke, etc)
        // covers the data rectangle within group width/height
        group: null,
        // defaults for basic mark types
        // each subset accepts mark properties (fill, stroke, etc)
        mark: null,
        arc: {
            fill: defaultColor
        },
        area: {
            fill: defaultColor
        },
        image: null,
        line: {
            stroke: defaultColor,
            strokeWidth: defaultStrokeWidth
        },
        path: {
            stroke: defaultColor
        },
        rect: {
            fill: defaultColor
        },
        rule: {
            stroke: black
        },
        shape: {
            stroke: defaultColor
        },
        symbol: {
            fill: defaultColor,
            size: 64
        },
        text: {
            fill: black,
            font: defaultFont,
            fontSize: 11
        },
        trail: {
            fill: defaultColor,
            size: defaultStrokeWidth
        },
        // style definitions
        style: {
            // axis & legend labels
            'guide-label': {
                fill: black,
                font: defaultFont,
                fontSize: 10
            },
            // axis & legend titles
            'guide-title': {
                fill: black,
                font: defaultFont,
                fontSize: 11,
                fontWeight: 'bold'
            },
            // headers, including chart title
            'group-title': {
                fill: black,
                font: defaultFont,
                fontSize: 13,
                fontWeight: 'bold'
            },
            // chart subtitle
            'group-subtitle': {
                fill: black,
                font: defaultFont,
                fontSize: 12
            },
            // defaults for styled point marks in Vega-Lite
            point: {
                size: defaultSymbolSize,
                strokeWidth: defaultStrokeWidth,
                shape: 'circle'
            },
            circle: {
                size: defaultSymbolSize,
                strokeWidth: defaultStrokeWidth
            },
            square: {
                size: defaultSymbolSize,
                strokeWidth: defaultStrokeWidth,
                shape: 'square'
            },
            // defaults for styled group marks in Vega-Lite
            cell: {
                fill: 'transparent',
                stroke: lightGray
            },
            view: {
                fill: 'transparent'
            }
        },
        // defaults for title
        title: {
            orient: 'top',
            anchor: 'middle',
            offset: 4,
            subtitlePadding: 3
        },
        // defaults for axes
        axis: {
            minExtent: 0,
            maxExtent: 200,
            bandPosition: 0.5,
            domain: true,
            domainWidth: 1,
            domainColor: gray,
            grid: false,
            gridWidth: 1,
            gridColor: lightGray,
            labels: true,
            labelAngle: 0,
            labelLimit: 180,
            labelOffset: 0,
            labelPadding: 2,
            ticks: true,
            tickColor: gray,
            tickOffset: 0,
            tickRound: true,
            tickSize: 5,
            tickWidth: 1,
            titlePadding: 4
        },
        // correction for centering bias
        axisBand: {
            tickOffset: -0.5
        },
        // defaults for cartographic projection
        projection: {
            type: 'mercator'
        },
        // defaults for legends
        legend: {
            orient: 'right',
            padding: 0,
            gridAlign: 'each',
            columnPadding: 10,
            rowPadding: 2,
            symbolDirection: 'vertical',
            gradientDirection: 'vertical',
            gradientLength: 200,
            gradientThickness: 16,
            gradientStrokeColor: lightGray,
            gradientStrokeWidth: 0,
            gradientLabelOffset: 2,
            labelAlign: 'left',
            labelBaseline: 'middle',
            labelLimit: 160,
            labelOffset: 4,
            labelOverlap: true,
            symbolLimit: 30,
            symbolType: 'circle',
            symbolSize: 100,
            symbolOffset: 0,
            symbolStrokeWidth: 1.5,
            symbolBaseFillColor: 'transparent',
            symbolBaseStrokeColor: gray,
            titleLimit: 180,
            titleOrient: 'top',
            titlePadding: 5,
            layout: {
                offset: 18,
                direction: 'horizontal',
                left: {
                    direction: 'vertical'
                },
                right: {
                    direction: 'vertical'
                }
            }
        },
        // defaults for scale ranges
        range: {
            category: {
                scheme: 'tableau10'
            },
            ordinal: {
                scheme: 'blues'
            },
            heatmap: {
                scheme: 'yellowgreenblue'
            },
            ramp: {
                scheme: 'blues'
            },
            diverging: {
                scheme: 'blueorange',
                extent: [
                    1,
                    0
                ]
            },
            symbol: [
                'circle',
                'square',
                'triangle-up',
                'cross',
                'diamond',
                'triangle-right',
                'triangle-down',
                'triangle-left'
            ]
        }
    };
}
function parse(spec, config, options) {
    if (!(0, _vegaUtil.isObject)(spec)) (0, _vegaUtil.error)('Input Vega specification must be an object.');
    config = (0, _vegaUtil.mergeConfig)(defaults(), config, spec.config);
    return parseView(spec, new Scope(config, options)).toRuntime();
}

},{"vega-util":"7f6sQ","vega-functions":"8ACB6","vega-event-selector":"ijmxJ","vega-scale":"13gXz","vega-dataflow":"4An7U","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"ijmxJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseSelector", ()=>eventSelector);
const VIEW = 'view', LBRACK = '[', RBRACK = ']', LBRACE = '{', RBRACE = '}', COLON = ':', COMMA = ',', NAME = '@', GT = '>', ILLEGAL = /[[\]{}]/, DEFAULT_MARKS = {
    '*': 1,
    arc: 1,
    area: 1,
    group: 1,
    image: 1,
    line: 1,
    path: 1,
    rect: 1,
    rule: 1,
    shape: 1,
    symbol: 1,
    text: 1,
    trail: 1
};
let DEFAULT_SOURCE, MARKS;
/**
 * Parse an event selector string.
 * Returns an array of event stream definitions.
 */ function eventSelector(selector, source, marks) {
    DEFAULT_SOURCE = source || VIEW;
    MARKS = marks || DEFAULT_MARKS;
    return parseMerge(selector.trim()).map(parseSelector);
}
function isMarkType(type) {
    return MARKS[type];
}
function find(s, i, endChar, pushChar, popChar) {
    const n = s.length;
    let count = 0, c;
    for(; i < n; ++i){
        c = s[i];
        if (!count && c === endChar) return i;
        else if (popChar && popChar.indexOf(c) >= 0) --count;
        else if (pushChar && pushChar.indexOf(c) >= 0) ++count;
    }
    return i;
}
function parseMerge(s) {
    const output = [], n = s.length;
    let start = 0, i = 0;
    while(i < n){
        i = find(s, i, COMMA, LBRACK + LBRACE, RBRACK + RBRACE);
        output.push(s.substring(start, i).trim());
        start = ++i;
    }
    if (output.length === 0) throw 'Empty event selector: ' + s;
    return output;
}
function parseSelector(s) {
    return s[0] === '[' ? parseBetween(s) : parseStream(s);
}
function parseBetween(s) {
    const n = s.length;
    let i = 1, b;
    i = find(s, i, RBRACK, LBRACK, RBRACK);
    if (i === n) throw 'Empty between selector: ' + s;
    b = parseMerge(s.substring(1, i));
    if (b.length !== 2) throw 'Between selector must have two elements: ' + s;
    s = s.slice(i + 1).trim();
    if (s[0] !== GT) throw 'Expected \'>\' after between selector: ' + s;
    b = b.map(parseSelector);
    const stream = parseSelector(s.slice(1).trim());
    if (stream.between) return {
        between: b,
        stream: stream
    };
    else stream.between = b;
    return stream;
}
function parseStream(s) {
    const stream = {
        source: DEFAULT_SOURCE
    }, source = [];
    let throttle = [
        0,
        0
    ], markname = 0, start = 0, n = s.length, i = 0, j, filter;
    // extract throttle from end
    if (s[n - 1] === RBRACE) {
        i = s.lastIndexOf(LBRACE);
        if (i >= 0) {
            try {
                throttle = parseThrottle(s.substring(i + 1, n - 1));
            } catch (e) {
                throw 'Invalid throttle specification: ' + s;
            }
            s = s.slice(0, i).trim();
            n = s.length;
        } else throw 'Unmatched right brace: ' + s;
        i = 0;
    }
    if (!n) throw s;
    // set name flag based on first char
    if (s[0] === NAME) markname = ++i;
    // extract first part of multi-part stream selector
    j = find(s, i, COLON);
    if (j < n) {
        source.push(s.substring(start, j).trim());
        start = i = ++j;
    }
    // extract remaining part of stream selector
    i = find(s, i, LBRACK);
    if (i === n) source.push(s.substring(start, n).trim());
    else {
        source.push(s.substring(start, i).trim());
        filter = [];
        start = ++i;
        if (start === n) throw 'Unmatched left bracket: ' + s;
    }
    // extract filters
    while(i < n){
        i = find(s, i, RBRACK);
        if (i === n) throw 'Unmatched left bracket: ' + s;
        filter.push(s.substring(start, i).trim());
        if (i < n - 1 && s[++i] !== LBRACK) throw 'Expected left bracket: ' + s;
        start = ++i;
    }
    // marshall event stream specification
    if (!(n = source.length) || ILLEGAL.test(source[n - 1])) throw 'Invalid event selector: ' + s;
    if (n > 1) {
        stream.type = source[1];
        if (markname) stream.markname = source[0].slice(1);
        else if (isMarkType(source[0])) stream.marktype = source[0];
        else stream.source = source[0];
    } else stream.type = source[0];
    if (stream.type.slice(-1) === '!') {
        stream.consume = true;
        stream.type = stream.type.slice(0, -1);
    }
    if (filter != null) stream.filter = filter;
    if (throttle[0]) stream.throttle = throttle[0];
    if (throttle[1]) stream.debounce = throttle[1];
    return stream;
}
function parseThrottle(s) {
    const a = s.split(COMMA);
    if (!s.length || a.length > 2) throw s;
    return a.map((_)=>{
        const x = +_;
        if (x !== x) throw s;
        return x;
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"6yTPM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compile", ()=>(0, _compile.compile));
parcelHelpers.export(exports, "normalize", ()=>(0, _normalize.normalize));
parcelHelpers.export(exports, "version", ()=>version);
var _packageJson = require("../package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
var _compile = require("./compile/compile");
var _normalize = require("./normalize");
var _util = require("./util");
parcelHelpers.exportAll(_util, exports);
const version = (0, _packageJsonDefault.default).version;

},{"../package.json":"k7aMA","./compile/compile":"2qs3U","./normalize":"9Cce5","./util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"k7aMA":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"name\":\"vega-lite\",\"author\":\"Dominik Moritz, Kanit \\\"Ham\\\" Wongsuphasawat, Arvind Satyanarayan, Jeffrey Heer\",\"version\":\"5.23.0\",\"collaborators\":[\"Kanit Wongsuphasawat (http://kanitw.yellowpigz.com)\",\"Dominik Moritz (https://www.domoritz.de)\",\"Arvind Satyanarayan (https://arvindsatya.com)\",\"Jeffrey Heer (https://jheer.org)\"],\"homepage\":\"https://vega.github.io/vega-lite/\",\"description\":\"Vega-Lite is a concise high-level language for interactive visualization.\",\"keywords\":[\"vega\",\"chart\",\"visualization\"],\"main\":\"build/vega-lite.js\",\"unpkg\":\"build/vega-lite.min.js\",\"jsdelivr\":\"build/vega-lite.min.js\",\"module\":\"build/src/index\",\"types\":\"build/src/index.d.ts\",\"bin\":{\"vl2pdf\":\"./bin/vl2pdf\",\"vl2png\":\"./bin/vl2png\",\"vl2svg\":\"./bin/vl2svg\",\"vl2vg\":\"./bin/vl2vg\"},\"files\":[\"bin\",\"build\",\"src\",\"vega-lite*\",\"tsconfig.json\"],\"scripts\":{\"changelog\":\"conventional-changelog -p angular -r 2\",\"prebuild\":\"yarn clean:build\",\"build\":\"yarn build:only\",\"build:only\":\"tsc -p tsconfig.build.json && rollup -c\",\"prebuild:examples\":\"yarn build:only\",\"build:examples\":\"yarn data && TZ=America/Los_Angeles scripts/build-examples.sh\",\"prebuild:examples-full\":\"yarn build:only\",\"build:examples-full\":\"TZ=America/Los_Angeles scripts/build-examples.sh 1\",\"build:example\":\"TZ=America/Los_Angeles scripts/build-example.sh\",\"build:toc\":\"yarn build:jekyll && scripts/generate-toc\",\"build:site\":\"rollup -c site/rollup.config.mjs\",\"build:jekyll\":\"pushd site && bundle exec jekyll build -q && popd\",\"build:versions\":\"scripts/update-version.sh\",\"clean\":\"yarn clean:build && del-cli 'site/data/*' 'examples/compiled/*.png' && find site/examples ! -name 'index.md' ! -name 'data' -type f -delete\",\"clean:build\":\"del-cli 'build/*' !build/vega-lite-schema.json\",\"data\":\"rsync -r node_modules/vega-datasets/data/* site/data\",\"build-editor-preview\":\"scripts/build-editor-preview.sh\",\"schema\":\"mkdir -p build && ts-json-schema-generator -f tsconfig.json -p src/index.ts -t TopLevelSpec --no-type-check --no-ref-encode > build/vega-lite-schema.json && yarn renameschema && cp build/vega-lite-schema.json site/_data/\",\"renameschema\":\"scripts/rename-schema.sh\",\"presite\":\"yarn data && yarn schema && yarn build:site && yarn build:versions && scripts/create-example-pages.sh\",\"site\":\"yarn site:only\",\"site:only\":\"pushd site && bundle exec jekyll serve -I -l && popd\",\"prettierbase\":\"prettier '**/*.{md,css,yml}'\",\"format\":\"eslint . --fix && yarn prettierbase --write\",\"lint\":\"eslint . && yarn prettierbase --check\",\"test\":\"yarn jest test/ && yarn lint && yarn schema && yarn jest examples/ && yarn test:runtime\",\"test:cover\":\"yarn jest --collectCoverage test/\",\"test:inspect\":\"node --inspect-brk ./node_modules/.bin/jest --runInBand test\",\"test:runtime\":\"TZ=America/Los_Angeles npx jest test-runtime/ --config test-runtime/jest-config.json\",\"test:runtime:generate\":\"yarn build:only && del-cli test-runtime/resources && VL_GENERATE_TESTS=true yarn test:runtime\",\"watch\":\"tsc -p tsconfig.build.json -w\",\"watch:site\":\"yarn build:site -w\",\"watch:test\":\"yarn jest --watch test/\",\"watch:test:runtime\":\"TZ=America/Los_Angeles npx jest --watch test-runtime/ --config test-runtime/jest-config.json\",\"release\":\"release-it\"},\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/vega/vega-lite.git\"},\"license\":\"BSD-3-Clause\",\"bugs\":{\"url\":\"https://github.com/vega/vega-lite/issues\"},\"devDependencies\":{\"@babel/core\":\"^7.26.0\",\"@babel/preset-env\":\"^7.26.0\",\"@babel/preset-typescript\":\"^7.26.0\",\"@release-it/conventional-changelog\":\"^9.0.3\",\"@rollup/plugin-alias\":\"^5.1.1\",\"@rollup/plugin-babel\":\"^6.0.4\",\"@rollup/plugin-commonjs\":\"^28.0.1\",\"@rollup/plugin-json\":\"^6.1.0\",\"@rollup/plugin-node-resolve\":\"^15.3.0\",\"@rollup/plugin-terser\":\"^0.4.4\",\"@types/d3\":\"^7.4.3\",\"@types/jest\":\"^29.5.14\",\"@types/pako\":\"^2.0.3\",\"@typescript-eslint/eslint-plugin\":\"^7.17.0\",\"@typescript-eslint/parser\":\"^7.17.0\",\"ajv\":\"^8.17.1\",\"ajv-formats\":\"^3.0.1\",\"cheerio\":\"^1.0.0\",\"conventional-changelog-cli\":\"^5.0.0\",\"d3\":\"^7.9.0\",\"del-cli\":\"^6.0.0\",\"eslint\":\"^8.57.0\",\"eslint-config-prettier\":\"^9.1.0\",\"eslint-plugin-jest\":\"^27.9.0\",\"eslint-plugin-prettier\":\"^5.2.1\",\"fast-json-stable-stringify\":\"~2.1.0\",\"highlight.js\":\"^11.10.0\",\"jest\":\"^29.7.0\",\"jest-dev-server\":\"^10.1.4\",\"mkdirp\":\"^3.0.1\",\"pako\":\"^2.1.0\",\"prettier\":\"^3.3.3\",\"puppeteer\":\"^15.0.0\",\"release-it\":\"17.10.0\",\"rollup\":\"^4.27.3\",\"rollup-plugin-bundle-size\":\"^1.0.3\",\"serve\":\"^14.2.4\",\"terser\":\"^5.36.0\",\"ts-jest\":\"^29.2.5\",\"ts-json-schema-generator\":\"^2.3.0\",\"typescript\":\"~5.7.2\",\"vega-cli\":\"^5.30.0\",\"vega-datasets\":\"^2.11.0\",\"vega-embed\":\"^6.28.0\",\"vega-tooltip\":\"^0.35.2\",\"yaml-front-matter\":\"^4.1.1\"},\"dependencies\":{\"json-stringify-pretty-compact\":\"~4.0.0\",\"tslib\":\"~2.8.1\",\"vega-event-selector\":\"~3.0.1\",\"vega-expression\":\"~5.1.1\",\"vega-util\":\"~1.17.2\",\"yargs\":\"~17.7.2\"},\"peerDependencies\":{\"vega\":\"^5.24.0\"},\"engines\":{\"node\":\">=18\"},\"packageManager\":\"yarn@1.22.22\"}");

},{}],"2qs3U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Vega-Lite's main function, for compiling Vega-Lite spec into Vega spec.
 *
 * At a high-level, we make the following transformations in different phases:
 *
 * Input spec
 *     |
 *     |  (Normalization)
 *     v
 * Normalized Spec (Row/Column channels in single-view specs becomes faceted specs, composite marks becomes layered specs.)
 *     |
 *     |  (Build Model)
 *     v
 * A model tree of the spec
 *     |
 *     |  (Parse)
 *     v
 * A model tree with parsed components (intermediate structure of visualization primitives in a format that can be easily merged)
 *     |
 *     | (Optimize)
 *     v
 * A model tree with parsed components with the data component optimized
 *     |
 *     | (Assemble)
 *     v
 * Vega spec
 *
 * @param inputSpec The Vega-Lite specification.
 * @param opt       Optional arguments passed to the Vega-Lite compiler.
 * @returns         An object containing the compiled Vega spec and normalized Vega-Lite spec.
 */ parcelHelpers.export(exports, "compile", ()=>compile);
var _vegaUtil = require("vega-util");
var _channel = require("../channel");
var _channeldef = require("../channeldef");
var _config = require("../config");
var _log = require("../log");
var _normalize = require("../normalize");
var _parameter = require("../parameter");
var _toplevel = require("../spec/toplevel");
var _util = require("../util");
var _buildmodel = require("./buildmodel");
var _assemble = require("./data/assemble");
var _optimize = require("./data/optimize");
function compile(inputSpec, opt = {}) {
    // 0. Augment opt with default opts
    if (opt.logger) // set the singleton logger to the provided logger
    _log.set(opt.logger);
    if (opt.fieldTitle) // set the singleton field title formatter
    _channeldef.setTitleFormatter(opt.fieldTitle);
    try {
        // 1. Initialize config by deep merging default config with the config provided via option and the input spec.
        const config = (0, _config.initConfig)((0, _vegaUtil.mergeConfig)(opt.config, inputSpec.config));
        // 2. Normalize: Convert input spec -> normalized spec
        // - Decompose all extended unit specs into composition of unit spec. For example, a box plot get expanded into multiple layers of bars, ticks, and rules. The shorthand row/column channel is also expanded to a facet spec.
        // - Normalize autosize and width or height spec
        const spec = (0, _normalize.normalize)(inputSpec, config);
        // 3. Build Model: normalized spec -> Model (a tree structure)
        // This phases instantiates the models with default config by doing a top-down traversal. This allows us to pass properties that child models derive from their parents via their constructors.
        // See the abstract `Model` class and its children (UnitModel, LayerModel, FacetModel, ConcatModel) for different types of models.
        const model = (0, _buildmodel.buildModel)(spec, null, '', undefined, config);
        // 4 Parse: Model --> Model with components
        // Note that components = intermediate representations that are equivalent to Vega specs.
        // We need these intermediate representation because we need to merge many visualization "components" like projections, scales, axes, and legends.
        // We will later convert these components into actual Vega specs in the assemble phase.
        // In this phase, we do a bottom-up traversal over the whole tree to
        // parse for each type of components once (e.g., data, layout, mark, scale).
        // By doing bottom-up traversal, we start parsing components of unit specs and
        // then merge child components of parent composite specs.
        //
        // Please see inside model.parse() for order of different components parsed.
        model.parse();
        // drawDataflow(model.component.data.sources);
        // 5. Optimize the dataflow. This will modify the data component of the model.
        (0, _optimize.optimizeDataflow)(model.component.data, model);
        // drawDataflow(model.component.data.sources);
        // 6. Assemble: convert model components --> Vega Spec.
        const vgSpec = assembleTopLevelModel(model, getTopLevelProperties(inputSpec, spec.autosize, config, model), inputSpec.datasets, inputSpec.usermeta);
        return {
            spec: vgSpec,
            normalized: spec
        };
    } finally{
        // Reset the singleton logger if a logger is provided
        if (opt.logger) _log.reset();
        // Reset the singleton field title formatter if provided
        if (opt.fieldTitle) _channeldef.resetTitleFormatter();
    }
}
function getTopLevelProperties(inputSpec, autosize, config, model) {
    const width = model.component.layoutSize.get('width');
    const height = model.component.layoutSize.get('height');
    if (autosize === undefined) {
        autosize = {
            type: 'pad'
        };
        if (model.hasAxisOrientSignalRef()) autosize.resize = true;
    } else if ((0, _vegaUtil.isString)(autosize)) autosize = {
        type: autosize
    };
    if (width && height && (0, _toplevel.isFitType)(autosize.type)) {
        if (width === 'step' && height === 'step') {
            _log.warn(_log.message.droppingFit());
            autosize.type = 'pad';
        } else if (width === 'step' || height === 'step') {
            // effectively XOR, because else if
            // get step dimension
            const sizeType = width === 'step' ? 'width' : 'height';
            // log that we're dropping fit for respective channel
            _log.warn(_log.message.droppingFit((0, _channel.getPositionScaleChannel)(sizeType)));
            // setting type to inverse fit (so if we dropped fit-x, type is now fit-y)
            const inverseSizeType = sizeType === 'width' ? 'height' : 'width';
            autosize.type = (0, _toplevel.getFitType)(inverseSizeType);
        }
    }
    return {
        ...(0, _util.keys)(autosize).length === 1 && autosize.type ? autosize.type === 'pad' ? {} : {
            autosize: autosize.type
        } : {
            autosize
        },
        ...(0, _toplevel.extractTopLevelProperties)(config, false),
        ...(0, _toplevel.extractTopLevelProperties)(inputSpec, true)
    };
}
/*
 * Assemble the top-level model to a Vega spec.
 *
 * Note: this couldn't be `model.assemble()` since the top-level model
 * needs some special treatment to generate top-level properties.
 */ function assembleTopLevelModel(model, topLevelProperties, datasets = {}, usermeta) {
    // Config with Vega-Lite only config removed.
    const vgConfig = model.config ? (0, _config.stripAndRedirectConfig)(model.config) : undefined;
    const rootData = (0, _assemble.assembleRootData)(model.component.data, datasets);
    const data = model.assembleSelectionData(rootData);
    const projections = model.assembleProjections();
    const title = model.assembleTitle();
    const style = model.assembleGroupStyle();
    const encodeEntry = model.assembleGroupEncodeEntry(true);
    let layoutSignals = model.assembleLayoutSignals();
    // move width and height signals with values to top level
    layoutSignals = layoutSignals.filter((signal)=>{
        if ((signal.name === 'width' || signal.name === 'height') && signal.value !== undefined) {
            topLevelProperties[signal.name] = +signal.value;
            return false;
        }
        return true;
    });
    const { params, ...otherTopLevelProps } = topLevelProperties;
    return {
        $schema: 'https://vega.github.io/schema/vega/v5.json',
        ...model.description ? {
            description: model.description
        } : {},
        ...otherTopLevelProps,
        ...title ? {
            title
        } : {},
        ...style ? {
            style
        } : {},
        ...encodeEntry ? {
            encode: {
                update: encodeEntry
            }
        } : {},
        data,
        ...projections.length > 0 ? {
            projections
        } : {},
        ...model.assembleGroup([
            ...layoutSignals,
            ...model.assembleSelectionTopLevelSignals([]),
            ...(0, _parameter.assembleParameterSignals)(params)
        ]),
        ...vgConfig ? {
            config: vgConfig
        } : {},
        ...usermeta ? {
            usermeta
        } : {}
    };
}

},{"vega-util":"7f6sQ","../channel":"liLED","../channeldef":"dsccb","../config":"8TUzf","../log":"loqTw","../normalize":"9Cce5","../parameter":"arxqh","../spec/toplevel":"beMiN","../util":"acUGA","./buildmodel":"2GQcr","./data/assemble":"64EbN","./data/optimize":"kc01N","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"liLED":[function(require,module,exports,__globalThis) {
/*
 * Constants and utilities for encoding channels (Visual variables)
 * such as 'x', 'y', 'color'.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ROW", ()=>ROW);
parcelHelpers.export(exports, "COLUMN", ()=>COLUMN);
parcelHelpers.export(exports, "FACET", ()=>FACET);
parcelHelpers.export(exports, "X", ()=>X);
parcelHelpers.export(exports, "Y", ()=>Y);
parcelHelpers.export(exports, "X2", ()=>X2);
parcelHelpers.export(exports, "Y2", ()=>Y2);
parcelHelpers.export(exports, "XOFFSET", ()=>XOFFSET);
parcelHelpers.export(exports, "YOFFSET", ()=>YOFFSET);
parcelHelpers.export(exports, "RADIUS", ()=>RADIUS);
parcelHelpers.export(exports, "RADIUS2", ()=>RADIUS2);
parcelHelpers.export(exports, "THETA", ()=>THETA);
parcelHelpers.export(exports, "THETA2", ()=>THETA2);
parcelHelpers.export(exports, "LATITUDE", ()=>LATITUDE);
parcelHelpers.export(exports, "LONGITUDE", ()=>LONGITUDE);
parcelHelpers.export(exports, "LATITUDE2", ()=>LATITUDE2);
parcelHelpers.export(exports, "LONGITUDE2", ()=>LONGITUDE2);
parcelHelpers.export(exports, "TIME", ()=>TIME);
parcelHelpers.export(exports, "COLOR", ()=>COLOR);
parcelHelpers.export(exports, "FILL", ()=>FILL);
parcelHelpers.export(exports, "STROKE", ()=>STROKE);
parcelHelpers.export(exports, "SHAPE", ()=>SHAPE);
parcelHelpers.export(exports, "SIZE", ()=>SIZE);
parcelHelpers.export(exports, "ANGLE", ()=>ANGLE);
parcelHelpers.export(exports, "OPACITY", ()=>OPACITY);
parcelHelpers.export(exports, "FILLOPACITY", ()=>FILLOPACITY);
parcelHelpers.export(exports, "STROKEOPACITY", ()=>STROKEOPACITY);
parcelHelpers.export(exports, "STROKEWIDTH", ()=>STROKEWIDTH);
parcelHelpers.export(exports, "STROKEDASH", ()=>STROKEDASH);
parcelHelpers.export(exports, "TEXT", ()=>TEXT);
parcelHelpers.export(exports, "ORDER", ()=>ORDER);
parcelHelpers.export(exports, "DETAIL", ()=>DETAIL);
parcelHelpers.export(exports, "KEY", ()=>KEY);
parcelHelpers.export(exports, "TOOLTIP", ()=>TOOLTIP);
parcelHelpers.export(exports, "HREF", ()=>HREF);
parcelHelpers.export(exports, "URL", ()=>URL);
parcelHelpers.export(exports, "DESCRIPTION", ()=>DESCRIPTION);
parcelHelpers.export(exports, "isPolarPositionChannel", ()=>isPolarPositionChannel);
parcelHelpers.export(exports, "getPositionChannelFromLatLong", ()=>getPositionChannelFromLatLong);
parcelHelpers.export(exports, "isGeoPositionChannel", ()=>isGeoPositionChannel);
parcelHelpers.export(exports, "GEOPOSITION_CHANNELS", ()=>GEOPOSITION_CHANNELS);
parcelHelpers.export(exports, "isColorChannel", ()=>isColorChannel);
parcelHelpers.export(exports, "FACET_CHANNELS", ()=>FACET_CHANNELS);
parcelHelpers.export(exports, "CHANNELS", ()=>CHANNELS);
parcelHelpers.export(exports, "SINGLE_DEF_CHANNELS", ()=>SINGLE_DEF_CHANNELS);
parcelHelpers.export(exports, "SINGLE_DEF_UNIT_CHANNELS", ()=>SINGLE_DEF_UNIT_CHANNELS);
parcelHelpers.export(exports, "isSingleDefUnitChannel", ()=>isSingleDefUnitChannel);
parcelHelpers.export(exports, "isChannel", ()=>isChannel);
parcelHelpers.export(exports, "SECONDARY_RANGE_CHANNEL", ()=>SECONDARY_RANGE_CHANNEL);
parcelHelpers.export(exports, "isSecondaryRangeChannel", ()=>isSecondaryRangeChannel);
/**
 * Get the main channel for a range channel. E.g. `x` for `x2`.
 */ parcelHelpers.export(exports, "getMainRangeChannel", ()=>getMainRangeChannel);
parcelHelpers.export(exports, "getVgPositionChannel", ()=>getVgPositionChannel);
/**
 * Get the main channel for a range channel. E.g. `x` for `x2`.
 */ parcelHelpers.export(exports, "getSecondaryRangeChannel", ()=>getSecondaryRangeChannel);
parcelHelpers.export(exports, "getSizeChannel", ()=>getSizeChannel);
/**
 * Get the main channel for a range channel. E.g. `x` for `x2`.
 */ parcelHelpers.export(exports, "getOffsetChannel", ()=>getOffsetChannel);
/**
 * Get the main channel for a range channel. E.g. `x` for `x2`.
 */ parcelHelpers.export(exports, "getOffsetScaleChannel", ()=>getOffsetScaleChannel);
parcelHelpers.export(exports, "getMainChannelFromOffsetChannel", ()=>getMainChannelFromOffsetChannel);
parcelHelpers.export(exports, "UNIT_CHANNELS", ()=>UNIT_CHANNELS);
parcelHelpers.export(exports, "NONPOSITION_CHANNELS", ()=>NONPOSITION_CHANNELS);
parcelHelpers.export(exports, "POSITION_SCALE_CHANNELS", ()=>POSITION_SCALE_CHANNELS);
parcelHelpers.export(exports, "isXorY", ()=>isXorY);
parcelHelpers.export(exports, "POLAR_POSITION_SCALE_CHANNEL_INDEX", ()=>POLAR_POSITION_SCALE_CHANNEL_INDEX);
parcelHelpers.export(exports, "POLAR_POSITION_SCALE_CHANNELS", ()=>POLAR_POSITION_SCALE_CHANNELS);
parcelHelpers.export(exports, "getPositionScaleChannel", ()=>getPositionScaleChannel);
parcelHelpers.export(exports, "OFFSET_SCALE_CHANNELS", ()=>OFFSET_SCALE_CHANNELS);
parcelHelpers.export(exports, "isXorYOffset", ()=>isXorYOffset);
parcelHelpers.export(exports, "TIME_SCALE_CHANNELS", ()=>TIME_SCALE_CHANNELS);
parcelHelpers.export(exports, "isTime", ()=>isTime);
parcelHelpers.export(exports, "NONPOSITION_SCALE_CHANNELS", ()=>NONPOSITION_SCALE_CHANNELS);
parcelHelpers.export(exports, "isNonPositionScaleChannel", ()=>isNonPositionScaleChannel);
/**
 * @returns whether Vega supports legends for a particular channel
 */ parcelHelpers.export(exports, "supportLegend", ()=>supportLegend);
parcelHelpers.export(exports, "SCALE_CHANNELS", ()=>SCALE_CHANNELS);
parcelHelpers.export(exports, "isScaleChannel", ()=>isScaleChannel);
/**
 * Return whether a channel supports a particular mark type.
 * @param channel  channel name
 * @param mark the mark type
 * @return whether the mark supports the channel
 */ parcelHelpers.export(exports, "supportMark", ()=>supportMark);
parcelHelpers.export(exports, "rangeType", ()=>rangeType);
var _vegaUtil = require("vega-util");
var _util = require("./util");
const ROW = 'row';
const COLUMN = 'column';
const FACET = 'facet';
const X = 'x';
const Y = 'y';
const X2 = 'x2';
const Y2 = 'y2';
const XOFFSET = 'xOffset';
const YOFFSET = 'yOffset';
const RADIUS = 'radius';
const RADIUS2 = 'radius2';
const THETA = 'theta';
const THETA2 = 'theta2';
const LATITUDE = 'latitude';
const LONGITUDE = 'longitude';
const LATITUDE2 = 'latitude2';
const LONGITUDE2 = 'longitude2';
const TIME = 'time';
const COLOR = 'color';
const FILL = 'fill';
const STROKE = 'stroke';
const SHAPE = 'shape';
const SIZE = 'size';
const ANGLE = 'angle';
const OPACITY = 'opacity';
const FILLOPACITY = 'fillOpacity';
const STROKEOPACITY = 'strokeOpacity';
const STROKEWIDTH = 'strokeWidth';
const STROKEDASH = 'strokeDash';
const TEXT = 'text';
const ORDER = 'order';
const DETAIL = 'detail';
const KEY = 'key';
const TOOLTIP = 'tooltip';
const HREF = 'href';
const URL = 'url';
const DESCRIPTION = 'description';
const POSITION_CHANNEL_INDEX = {
    x: 1,
    y: 1,
    x2: 1,
    y2: 1
};
const POLAR_POSITION_CHANNEL_INDEX = {
    theta: 1,
    theta2: 1,
    radius: 1,
    radius2: 1
};
function isPolarPositionChannel(c) {
    return (0, _vegaUtil.hasOwnProperty)(POLAR_POSITION_CHANNEL_INDEX, c);
}
const GEO_POSIITON_CHANNEL_INDEX = {
    longitude: 1,
    longitude2: 1,
    latitude: 1,
    latitude2: 1
};
function getPositionChannelFromLatLong(channel) {
    switch(channel){
        case LATITUDE:
            return 'y';
        case LATITUDE2:
            return 'y2';
        case LONGITUDE:
            return 'x';
        case LONGITUDE2:
            return 'x2';
    }
}
function isGeoPositionChannel(c) {
    return (0, _vegaUtil.hasOwnProperty)(GEO_POSIITON_CHANNEL_INDEX, c);
}
const GEOPOSITION_CHANNELS = (0, _util.keys)(GEO_POSIITON_CHANNEL_INDEX);
const UNIT_CHANNEL_INDEX = {
    ...POSITION_CHANNEL_INDEX,
    ...POLAR_POSITION_CHANNEL_INDEX,
    ...GEO_POSIITON_CHANNEL_INDEX,
    xOffset: 1,
    yOffset: 1,
    // color
    color: 1,
    fill: 1,
    stroke: 1,
    // time
    time: 1,
    // other non-position with scale
    opacity: 1,
    fillOpacity: 1,
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeDash: 1,
    size: 1,
    angle: 1,
    shape: 1,
    // channels without scales
    order: 1,
    text: 1,
    detail: 1,
    key: 1,
    tooltip: 1,
    href: 1,
    url: 1,
    description: 1
};
function isColorChannel(channel) {
    return channel === COLOR || channel === FILL || channel === STROKE;
}
const FACET_CHANNEL_INDEX = {
    row: 1,
    column: 1,
    facet: 1
};
const FACET_CHANNELS = (0, _util.keys)(FACET_CHANNEL_INDEX);
const CHANNEL_INDEX = {
    ...UNIT_CHANNEL_INDEX,
    ...FACET_CHANNEL_INDEX
};
const CHANNELS = (0, _util.keys)(CHANNEL_INDEX);
const { order: _o, detail: _d, tooltip: _tt1, ...SINGLE_DEF_CHANNEL_INDEX } = CHANNEL_INDEX;
const { row: _r, column: _c, facet: _f, ...SINGLE_DEF_UNIT_CHANNEL_INDEX } = SINGLE_DEF_CHANNEL_INDEX;
const SINGLE_DEF_CHANNELS = (0, _util.keys)(SINGLE_DEF_CHANNEL_INDEX);
const SINGLE_DEF_UNIT_CHANNELS = (0, _util.keys)(SINGLE_DEF_UNIT_CHANNEL_INDEX);
function isSingleDefUnitChannel(str) {
    return (0, _vegaUtil.hasOwnProperty)(SINGLE_DEF_UNIT_CHANNEL_INDEX, str);
}
function isChannel(str) {
    return (0, _vegaUtil.hasOwnProperty)(CHANNEL_INDEX, str);
}
const SECONDARY_RANGE_CHANNEL = [
    X2,
    Y2,
    LATITUDE2,
    LONGITUDE2,
    THETA2,
    RADIUS2
];
function isSecondaryRangeChannel(c) {
    const main = getMainRangeChannel(c);
    return main !== c;
}
function getMainRangeChannel(channel) {
    switch(channel){
        case X2:
            return X;
        case Y2:
            return Y;
        case LATITUDE2:
            return LATITUDE;
        case LONGITUDE2:
            return LONGITUDE;
        case THETA2:
            return THETA;
        case RADIUS2:
            return RADIUS;
    }
    return channel;
}
function getVgPositionChannel(channel) {
    if (isPolarPositionChannel(channel)) switch(channel){
        case THETA:
            return 'startAngle';
        case THETA2:
            return 'endAngle';
        case RADIUS:
            return 'outerRadius';
        case RADIUS2:
            return 'innerRadius';
    }
    return channel;
}
function getSecondaryRangeChannel(channel) {
    switch(channel){
        case X:
            return X2;
        case Y:
            return Y2;
        case LATITUDE:
            return LATITUDE2;
        case LONGITUDE:
            return LONGITUDE2;
        case THETA:
            return THETA2;
        case RADIUS:
            return RADIUS2;
    }
    return undefined;
}
function getSizeChannel(channel) {
    switch(channel){
        case X:
        case X2:
            return 'width';
        case Y:
        case Y2:
            return 'height';
    }
    return undefined;
}
function getOffsetChannel(channel) {
    switch(channel){
        case X:
            return 'xOffset';
        case Y:
            return 'yOffset';
        case X2:
            return 'x2Offset';
        case Y2:
            return 'y2Offset';
        case THETA:
            return 'thetaOffset';
        case RADIUS:
            return 'radiusOffset';
        case THETA2:
            return 'theta2Offset';
        case RADIUS2:
            return 'radius2Offset';
    }
    return undefined;
}
function getOffsetScaleChannel(channel) {
    switch(channel){
        case X:
            return 'xOffset';
        case Y:
            return 'yOffset';
    }
    return undefined;
}
function getMainChannelFromOffsetChannel(channel) {
    switch(channel){
        case 'xOffset':
            return 'x';
        case 'yOffset':
            return 'y';
    }
}
const UNIT_CHANNELS = (0, _util.keys)(UNIT_CHANNEL_INDEX);
// NONPOSITION_CHANNELS = UNIT_CHANNELS without X, Y, X2, Y2;
const { x: _x, y: _y, // x2 and y2 share the same scale as x and y
x2: _x2, y2: _y2, //
xOffset: _xo, yOffset: _yo, latitude: _latitude, longitude: _longitude, latitude2: _latitude2, longitude2: _longitude2, theta: _theta, theta2: _theta2, radius: _radius, radius2: _radius2, // The rest of unit channels then have scale
...NONPOSITION_CHANNEL_INDEX } = UNIT_CHANNEL_INDEX;
const NONPOSITION_CHANNELS = (0, _util.keys)(NONPOSITION_CHANNEL_INDEX);
const POSITION_SCALE_CHANNEL_INDEX = {
    x: 1,
    y: 1
};
const POSITION_SCALE_CHANNELS = (0, _util.keys)(POSITION_SCALE_CHANNEL_INDEX);
function isXorY(channel) {
    return (0, _vegaUtil.hasOwnProperty)(POSITION_SCALE_CHANNEL_INDEX, channel);
}
const POLAR_POSITION_SCALE_CHANNEL_INDEX = {
    theta: 1,
    radius: 1
};
const POLAR_POSITION_SCALE_CHANNELS = (0, _util.keys)(POLAR_POSITION_SCALE_CHANNEL_INDEX);
function getPositionScaleChannel(sizeType) {
    return sizeType === 'width' ? X : Y;
}
const OFFSET_SCALE_CHANNEL_INDEX = {
    xOffset: 1,
    yOffset: 1
};
const OFFSET_SCALE_CHANNELS = (0, _util.keys)(OFFSET_SCALE_CHANNEL_INDEX);
function isXorYOffset(channel) {
    return (0, _vegaUtil.hasOwnProperty)(OFFSET_SCALE_CHANNEL_INDEX, channel);
}
const TIME_SCALE_CHANNEL_INDEX = {
    time: 1
};
const TIME_SCALE_CHANNELS = (0, _util.keys)(TIME_SCALE_CHANNEL_INDEX);
function isTime(channel) {
    return channel in TIME_SCALE_CHANNEL_INDEX;
}
// NON_POSITION_SCALE_CHANNEL = SCALE_CHANNELS without position / offset
const { // x2 and y2 share the same scale as x and y
// text and tooltip have format instead of scale,
// href has neither format, nor scale
text: _t, tooltip: _tt, href: _hr, url: _u, description: _al, // detail and order have no scale
detail: _dd, key: _k, order: _oo, ...NONPOSITION_SCALE_CHANNEL_INDEX } = NONPOSITION_CHANNEL_INDEX;
const NONPOSITION_SCALE_CHANNELS = (0, _util.keys)(NONPOSITION_SCALE_CHANNEL_INDEX);
function isNonPositionScaleChannel(channel) {
    return (0, _vegaUtil.hasOwnProperty)(NONPOSITION_CHANNEL_INDEX, channel);
}
function supportLegend(channel) {
    switch(channel){
        case COLOR:
        case FILL:
        case STROKE:
        case SIZE:
        case SHAPE:
        case OPACITY:
        case STROKEWIDTH:
        case STROKEDASH:
            return true;
        case FILLOPACITY:
        case STROKEOPACITY:
        case ANGLE:
        case TIME:
            return false;
    }
}
// Declare SCALE_CHANNEL_INDEX
const SCALE_CHANNEL_INDEX = {
    ...POSITION_SCALE_CHANNEL_INDEX,
    ...POLAR_POSITION_SCALE_CHANNEL_INDEX,
    ...OFFSET_SCALE_CHANNEL_INDEX,
    ...NONPOSITION_SCALE_CHANNEL_INDEX
};
const SCALE_CHANNELS = (0, _util.keys)(SCALE_CHANNEL_INDEX);
function isScaleChannel(channel) {
    return (0, _vegaUtil.hasOwnProperty)(SCALE_CHANNEL_INDEX, channel);
}
function supportMark(channel, mark) {
    return getSupportedMark(channel)[mark];
}
const ALL_MARKS = {
    // all marks
    arc: 'always',
    area: 'always',
    bar: 'always',
    circle: 'always',
    geoshape: 'always',
    image: 'always',
    line: 'always',
    rule: 'always',
    point: 'always',
    rect: 'always',
    square: 'always',
    trail: 'always',
    text: 'always',
    tick: 'always'
};
const { geoshape: _g, ...ALL_MARKS_EXCEPT_GEOSHAPE } = ALL_MARKS;
/**
 * Return a dictionary showing whether a channel supports mark type.
 * @param channel
 * @return A dictionary mapping mark types to 'always', 'binned', or undefined
 */ function getSupportedMark(channel) {
    switch(channel){
        case COLOR:
        case FILL:
        case STROKE:
        // falls through
        case DESCRIPTION:
        case DETAIL:
        case KEY:
        case TOOLTIP:
        case HREF:
        case ORDER:
        case OPACITY:
        case FILLOPACITY:
        case STROKEOPACITY:
        case STROKEWIDTH:
        // falls through
        case FACET:
        case ROW:
        case COLUMN:
            return ALL_MARKS;
        case X:
        case Y:
        case XOFFSET:
        case YOFFSET:
        case LATITUDE:
        case LONGITUDE:
        case TIME:
            // all marks except geoshape. geoshape does not use X, Y -- it uses a projection
            return ALL_MARKS_EXCEPT_GEOSHAPE;
        case X2:
        case Y2:
        case LATITUDE2:
        case LONGITUDE2:
            return {
                area: 'always',
                bar: 'always',
                image: 'always',
                rect: 'always',
                rule: 'always',
                circle: 'binned',
                point: 'binned',
                square: 'binned',
                tick: 'binned',
                line: 'binned',
                trail: 'binned'
            };
        case SIZE:
            return {
                point: 'always',
                tick: 'always',
                rule: 'always',
                circle: 'always',
                square: 'always',
                bar: 'always',
                text: 'always',
                line: 'always',
                trail: 'always'
            };
        case STROKEDASH:
            return {
                line: 'always',
                point: 'always',
                tick: 'always',
                rule: 'always',
                circle: 'always',
                square: 'always',
                bar: 'always',
                geoshape: 'always'
            };
        case SHAPE:
            return {
                point: 'always',
                geoshape: 'always'
            };
        case TEXT:
            return {
                text: 'always'
            };
        case ANGLE:
            return {
                point: 'always',
                square: 'always',
                text: 'always'
            };
        case URL:
            return {
                image: 'always'
            };
        case THETA:
            return {
                text: 'always',
                arc: 'always'
            };
        case RADIUS:
            return {
                text: 'always',
                arc: 'always'
            };
        case THETA2:
        case RADIUS2:
            return {
                arc: 'always'
            };
    }
}
function rangeType(channel) {
    switch(channel){
        case X:
        case Y:
        case THETA:
        case RADIUS:
        case XOFFSET:
        case YOFFSET:
        case SIZE:
        case ANGLE:
        case STROKEWIDTH:
        case OPACITY:
        case FILLOPACITY:
        case STROKEOPACITY:
        case TIME:
        // X2 and Y2 use X and Y scales, so they similarly have continuous range. [falls through]
        case X2:
        case Y2:
        case THETA2:
        case RADIUS2:
            return undefined;
        case FACET:
        case ROW:
        case COLUMN:
        case SHAPE:
        case STROKEDASH:
        // TEXT, TOOLTIP, URL, and HREF have no scale but have discrete output [falls through]
        case TEXT:
        case TOOLTIP:
        case HREF:
        case URL:
        case DESCRIPTION:
            return 'discrete';
        // Color can be either continuous or discrete, depending on scale type.
        case COLOR:
        case FILL:
        case STROKE:
            return 'flexible';
        // No scale, no range type.
        case LATITUDE:
        case LONGITUDE:
        case LATITUDE2:
        case LONGITUDE2:
        case DETAIL:
        case KEY:
        case ORDER:
            return undefined;
    }
}

},{"vega-util":"7f6sQ","./util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"acUGA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "duplicate", ()=>duplicate);
parcelHelpers.export(exports, "never", ()=>never);
/**
 * Creates an object composed of the picked object properties.
 *
 * var object = {'a': 1, 'b': '2', 'c': 3};
 * pick(object, ['a', 'c']);
 * // → {'a': 1, 'c': 3}
 */ // eslint-disable-next-line @typescript-eslint/ban-types
parcelHelpers.export(exports, "pick", ()=>pick);
/**
 * The opposite of _.pick; this method creates an object composed of the own
 * and inherited enumerable string keyed properties of object that are not omitted.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
parcelHelpers.export(exports, "omit", ()=>omit);
/**
 * Converts any object to a string of limited size, or a number.
 */ parcelHelpers.export(exports, "hash", ()=>hash);
parcelHelpers.export(exports, "isNullOrFalse", ()=>isNullOrFalse);
parcelHelpers.export(exports, "contains", ()=>contains);
/**
 * Returns true if any item returns true.
 */ parcelHelpers.export(exports, "some", ()=>some);
/**
 * Returns true if all items return true.
 */ parcelHelpers.export(exports, "every", ()=>every);
/**
 * recursively merges src into dest
 */ parcelHelpers.export(exports, "mergeDeep", ()=>mergeDeep);
parcelHelpers.export(exports, "unique", ()=>unique);
/**
 * Returns true if the two dictionaries agree. Applies only to defined values.
 */ parcelHelpers.export(exports, "isEqual", ()=>isEqual);
parcelHelpers.export(exports, "setEqual", ()=>setEqual);
parcelHelpers.export(exports, "hasIntersection", ()=>hasIntersection);
parcelHelpers.export(exports, "prefixGenerator", ()=>prefixGenerator);
/**
 * Returns true if a and b have an intersection. Also return true if a or b are undefined
 * since this means we don't know what fields a node produces or depends on.
 */ parcelHelpers.export(exports, "fieldIntersection", ()=>fieldIntersection);
// eslint-disable-next-line @typescript-eslint/ban-types
parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
parcelHelpers.export(exports, "keys", ()=>keys);
parcelHelpers.export(exports, "vals", ()=>vals);
parcelHelpers.export(exports, "entries", ()=>entries);
parcelHelpers.export(exports, "isBoolean", ()=>isBoolean);
/**
 * Convert a string into a valid variable name
 */ parcelHelpers.export(exports, "varName", ()=>varName);
parcelHelpers.export(exports, "logicalExpr", ()=>logicalExpr);
/**
 * Delete nested property of an object, and delete the ancestors of the property if they become empty.
 */ parcelHelpers.export(exports, "deleteNestedProperty", ()=>deleteNestedProperty);
parcelHelpers.export(exports, "titleCase", ()=>titleCase);
/**
 * Converts a path to an access path with datum.
 * @param path The field name.
 * @param datum The string to use for `datum`.
 */ parcelHelpers.export(exports, "accessPathWithDatum", ()=>accessPathWithDatum);
/**
 * Return access with datum to the flattened field.
 *
 * @param path The field name.
 * @param datum The string to use for `datum`.
 */ parcelHelpers.export(exports, "flatAccessWithDatum", ()=>flatAccessWithDatum);
/**
 * Return access with datum to **an unescaped path**.
 *
 * ```ts
 * console.log(accessWithDatumToUnescapedPath("vega's favorite"))
 * // "datum['vega\\'s favorite']"
 * ```
 *
 * @param path The unescaped path name. E.g., `"a.b"`, `"vega's favorite"`. (Note
 * that the field defs take escaped strings like `"a\\.b"`, `"vega\\'s favorite"`,
 * but this function is for the unescaped field/path)
 */ parcelHelpers.export(exports, "accessWithDatumToUnescapedPath", ()=>accessWithDatumToUnescapedPath);
/**
 * Replaces path accesses with access to non-nested field.
 * For example, `foo["bar"].baz` becomes `foo\\.bar\\.baz`.
 */ parcelHelpers.export(exports, "replacePathInField", ()=>replacePathInField);
/**
 * Replace all occurrences of a string with another string.
 *
 * @param string the string to replace in
 * @param find the string to replace
 * @param replacement the replacement
 */ parcelHelpers.export(exports, "replaceAll", ()=>replaceAll);
/**
 * Remove path accesses with access from field.
 * For example, `foo["bar"].baz` becomes `foo.bar.baz`.
 */ parcelHelpers.export(exports, "removePathFromField", ()=>removePathFromField);
/**
 * Count the depth of the path. Returns 1 for fields that are not nested.
 */ parcelHelpers.export(exports, "accessPathDepth", ()=>accessPathDepth);
/**
 * This is a replacement for chained || for numeric properties or properties that respect null so that 0 will be included.
 */ parcelHelpers.export(exports, "getFirstDefined", ()=>getFirstDefined);
/**
 * Returns a new random id every time it gets called.
 *
 * Has side effect!
 */ parcelHelpers.export(exports, "uniqueId", ()=>uniqueId);
/**
 * Resets the id counter used in uniqueId. This can be useful for testing.
 */ parcelHelpers.export(exports, "resetIdCounter", ()=>resetIdCounter);
parcelHelpers.export(exports, "internalField", ()=>internalField);
parcelHelpers.export(exports, "isInternalField", ()=>isInternalField);
/**
 * Normalize angle to be within [0,360).
 */ parcelHelpers.export(exports, "normalizeAngle", ()=>normalizeAngle);
/**
 * Returns whether the passed in value is a valid number.
 */ parcelHelpers.export(exports, "isNumeric", ()=>isNumeric);
/**
 * Compares two values for equality, including arrays and objects.
 *
 * Adapted from https://github.com/epoberezkin/fast-deep-equal.
 */ parcelHelpers.export(exports, "deepEqual", ()=>deepEqual);
/**
 * Converts any object to a string representation that can be consumed by humans.
 *
 * Adapted from https://github.com/epoberezkin/fast-json-stable-stringify
 */ parcelHelpers.export(exports, "stringify", ()=>stringify);
/**
 * Check if the input object has the property and it's not undefined.
 *
 * @param object the object
 * @param property the property to search
 * @returns if the object has the property and it's not undefined.
 */ parcelHelpers.export(exports, "hasProperty", ()=>hasProperty);
var _vegaUtil = require("vega-util");
var _logical = require("./logical");
const duplicate = structuredClone;
function never(message) {
    throw new Error(message);
}
function pick(obj, props) {
    const copy = {};
    for (const prop of props)if ((0, _vegaUtil.hasOwnProperty)(obj, prop)) copy[prop] = obj[prop];
    return copy;
}
function omit(obj, props) {
    const copy = {
        ...obj
    };
    for (const prop of props)delete copy[prop];
    return copy;
}
/**
 * Monkey patch Set so that `stringify` produces a string representation of sets.
 */ Set.prototype['toJSON'] = function() {
    return `Set(${[
        ...this
    ].map((x)=>stringify(x)).join(',')})`;
};
function hash(a) {
    if ((0, _vegaUtil.isNumber)(a)) return a;
    const str = (0, _vegaUtil.isString)(a) ? a : stringify(a);
    // short strings can be used as hash directly, longer strings are hashed to reduce memory usage
    if (str.length < 250) return str;
    // from http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
    let h = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        h = (h << 5) - h + char;
        h = h & h; // Convert to 32bit integer
    }
    return h;
}
function isNullOrFalse(x) {
    return x === false || x === null;
}
function contains(array, item) {
    return array.includes(item);
}
function some(arr, f) {
    let i = 0;
    for (const [k, a] of arr.entries()){
        if (f(a, k, i++)) return true;
    }
    return false;
}
function every(arr, f) {
    let i = 0;
    for (const [k, a] of arr.entries()){
        if (!f(a, k, i++)) return false;
    }
    return true;
}
function mergeDeep(dest, ...src) {
    for (const s of src)deepMerge_(dest, s ?? {});
    return dest;
}
function deepMerge_(dest, src) {
    for (const property of keys(src))(0, _vegaUtil.writeConfig)(dest, property, src[property], true);
}
function unique(values, f) {
    const results = [];
    const u = {};
    let v;
    for (const val of values){
        v = f(val);
        if (v in u) continue;
        u[v] = 1;
        results.push(val);
    }
    return results;
}
function isEqual(dict, other) {
    const dictKeys = keys(dict);
    const otherKeys = keys(other);
    if (dictKeys.length !== otherKeys.length) return false;
    for (const key of dictKeys){
        if (dict[key] !== other[key]) return false;
    }
    return true;
}
function setEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const e of a){
        if (!b.has(e)) return false;
    }
    return true;
}
function hasIntersection(a, b) {
    for (const key of a){
        if (b.has(key)) return true;
    }
    return false;
}
function prefixGenerator(a) {
    const prefixes = new Set();
    for (const x of a){
        const splitField = (0, _vegaUtil.splitAccessPath)(x);
        // Wrap every element other than the first in `[]`
        const wrappedWithAccessors = splitField.map((y, i)=>i === 0 ? y : `[${y}]`);
        const computedPrefixes = wrappedWithAccessors.map((_, i)=>wrappedWithAccessors.slice(0, i + 1).join(''));
        for (const y of computedPrefixes)prefixes.add(y);
    }
    return prefixes;
}
function fieldIntersection(a, b) {
    if (a === undefined || b === undefined) return true;
    return hasIntersection(prefixGenerator(a), prefixGenerator(b));
}
function isEmpty(obj) {
    return keys(obj).length === 0;
}
const keys = Object.keys;
const vals = Object.values;
const entries = Object.entries;
function isBoolean(b) {
    return b === true || b === false;
}
function varName(s) {
    // Replace non-alphanumeric characters (anything besides a-zA-Z0-9_) with _
    const alphanumericS = s.replace(/\W/g, '_');
    // Add _ if the string has leading numbers.
    return (s.match(/^\d+/) ? '_' : '') + alphanumericS;
}
function logicalExpr(op, cb) {
    if ((0, _logical.isLogicalNot)(op)) return `!(${logicalExpr(op.not, cb)})`;
    else if ((0, _logical.isLogicalAnd)(op)) return `(${op.and.map((and)=>logicalExpr(and, cb)).join(') && (')})`;
    else if ((0, _logical.isLogicalOr)(op)) return `(${op.or.map((or)=>logicalExpr(or, cb)).join(') || (')})`;
    else return cb(op);
}
function deleteNestedProperty(obj, orderedProps) {
    if (orderedProps.length === 0) return true;
    const prop = orderedProps.shift(); // eslint-disable-line @typescript-eslint/no-non-null-assertion
    if (prop in obj && deleteNestedProperty(obj[prop], orderedProps)) delete obj[prop];
    return isEmpty(obj);
}
function titleCase(s) {
    return s.charAt(0).toUpperCase() + s.substr(1);
}
function accessPathWithDatum(path, datum = 'datum') {
    const pieces = (0, _vegaUtil.splitAccessPath)(path);
    const prefixes = [];
    for(let i = 1; i <= pieces.length; i++){
        const prefix = `[${pieces.slice(0, i).map((0, _vegaUtil.stringValue)).join('][')}]`;
        prefixes.push(`${datum}${prefix}`);
    }
    return prefixes.join(' && ');
}
function flatAccessWithDatum(path, datum = 'datum') {
    return `${datum}[${(0, _vegaUtil.stringValue)((0, _vegaUtil.splitAccessPath)(path).join('.'))}]`;
}
function accessWithDatumToUnescapedPath(unescapedPath) {
    const singleQuoteEscapedPath = unescapedPath.replaceAll("'", "\\'");
    return `datum['${singleQuoteEscapedPath}']`;
}
function escapePathAccess(string) {
    return string.replace(/(\[|\]|\.|'|")/g, '\\$1');
}
function replacePathInField(path) {
    return `${(0, _vegaUtil.splitAccessPath)(path).map(escapePathAccess).join('\\.')}`;
}
function replaceAll(string, find, replacement) {
    return string.replace(new RegExp(find.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g'), replacement);
}
function removePathFromField(path) {
    return `${(0, _vegaUtil.splitAccessPath)(path).join('.')}`;
}
function accessPathDepth(path) {
    if (!path) return 0;
    return (0, _vegaUtil.splitAccessPath)(path).length;
}
function getFirstDefined(...args) {
    return args.find((a)=>a !== undefined);
}
// variable used to generate id
let idCounter = 42;
function uniqueId(prefix) {
    const id = ++idCounter;
    return prefix ? String(prefix) + id : id;
}
function resetIdCounter() {
    idCounter = 42;
}
function internalField(name) {
    return isInternalField(name) ? name : `__${name}`;
}
function isInternalField(name) {
    return name.startsWith('__');
}
function normalizeAngle(angle) {
    if (angle === undefined) return undefined;
    return (angle % 360 + 360) % 360;
}
function isNumeric(value) {
    if ((0, _vegaUtil.isNumber)(value)) return true;
    return !isNaN(value) && !isNaN(parseFloat(value));
}
const clonedProto = Object.getPrototypeOf(structuredClone({}));
function deepEqual(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        // compare names to avoid issues with structured clone
        if (a.constructor.name !== b.constructor.name) return false;
        let length;
        let i;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!deepEqual(a[i], b[i])) return false;
            return true;
        }
        if (a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            for (const e of a.entries())if (!b.has(e[0])) return false;
            for (const e of a.entries())if (!deepEqual(e[1], b.get(e[0]))) return false;
            return true;
        }
        if (a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            for (const e of a.entries())if (!b.has(e[0])) return false;
            return true;
        }
        if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // also compare to structured clone prototype
        if (a.valueOf !== Object.prototype.valueOf && a.valueOf !== clonedProto.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && a.toString !== clonedProto.toString) return a.toString() === b.toString();
        const ks = Object.keys(a);
        length = ks.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, ks[i])) return false;
        for(i = length; i-- !== 0;){
            const key = ks[i];
            if (!deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
}
function stringify(data) {
    const seen = [];
    return function _stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return undefined;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        let i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += _stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.includes(node)) throw new TypeError('Converting circular structure to JSON');
        const seenIndex = seen.push(node) - 1;
        const ks = Object.keys(node).sort();
        out = '';
        for(i = 0; i < ks.length; i++){
            const key = ks[i];
            const value = _stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return `{${out}}`;
    }(data);
}
function hasProperty(obj, key) {
    return (0, _vegaUtil.isObject)(obj) && (0, _vegaUtil.hasOwnProperty)(obj, key) && obj[key] !== undefined;
}

},{"vega-util":"7f6sQ","./logical":"ksUsC","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"ksUsC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isLogicalOr", ()=>isLogicalOr);
parcelHelpers.export(exports, "isLogicalAnd", ()=>isLogicalAnd);
parcelHelpers.export(exports, "isLogicalNot", ()=>isLogicalNot);
parcelHelpers.export(exports, "forEachLeaf", ()=>forEachLeaf);
parcelHelpers.export(exports, "normalizeLogicalComposition", ()=>normalizeLogicalComposition);
var _util = require("./util");
function isLogicalOr(op) {
    return (0, _util.hasProperty)(op, 'or');
}
function isLogicalAnd(op) {
    return (0, _util.hasProperty)(op, 'and');
}
function isLogicalNot(op) {
    return (0, _util.hasProperty)(op, 'not');
}
function forEachLeaf(op, fn) {
    if (isLogicalNot(op)) forEachLeaf(op.not, fn);
    else if (isLogicalAnd(op)) for (const subop of op.and)forEachLeaf(subop, fn);
    else if (isLogicalOr(op)) for (const subop of op.or)forEachLeaf(subop, fn);
    else fn(op);
}
function normalizeLogicalComposition(op, normalizer) {
    if (isLogicalNot(op)) return {
        not: normalizeLogicalComposition(op.not, normalizer)
    };
    else if (isLogicalAnd(op)) return {
        and: op.and.map((o)=>normalizeLogicalComposition(o, normalizer))
    };
    else if (isLogicalOr(op)) return {
        or: op.or.map((o)=>normalizeLogicalComposition(o, normalizer))
    };
    else return normalizer(op);
}

},{"./util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dsccb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isConditionalParameter", ()=>isConditionalParameter);
parcelHelpers.export(exports, "isRepeatRef", ()=>isRepeatRef);
parcelHelpers.export(exports, "toFieldDefBase", ()=>toFieldDefBase);
parcelHelpers.export(exports, "isSortableFieldDef", ()=>isSortableFieldDef);
parcelHelpers.export(exports, "getBandPosition", ()=>getBandPosition);
parcelHelpers.export(exports, "getBandSize", ()=>getBandSize);
parcelHelpers.export(exports, "hasBandEnd", ()=>hasBandEnd);
parcelHelpers.export(exports, "isOrderOnlyDef", ()=>isOrderOnlyDef);
parcelHelpers.export(exports, "isConditionalDef", ()=>isConditionalDef);
/**
 * Return if a channelDef is a ConditionalValueDef with ConditionFieldDef
 */ parcelHelpers.export(exports, "hasConditionalFieldDef", ()=>hasConditionalFieldDef);
parcelHelpers.export(exports, "hasConditionalFieldOrDatumDef", ()=>hasConditionalFieldOrDatumDef);
parcelHelpers.export(exports, "hasConditionalValueDef", ()=>hasConditionalValueDef);
parcelHelpers.export(exports, "isFieldDef", ()=>isFieldDef);
parcelHelpers.export(exports, "channelDefType", ()=>channelDefType);
parcelHelpers.export(exports, "isDatumDef", ()=>isDatumDef);
parcelHelpers.export(exports, "isContinuousFieldOrDatumDef", ()=>isContinuousFieldOrDatumDef);
parcelHelpers.export(exports, "isUnbinnedQuantitativeFieldOrDatumDef", ()=>isUnbinnedQuantitativeFieldOrDatumDef);
parcelHelpers.export(exports, "isNumericDataDef", ()=>isNumericDataDef);
parcelHelpers.export(exports, "isFieldOrDatumDef", ()=>isFieldOrDatumDef);
parcelHelpers.export(exports, "isTypedFieldDef", ()=>isTypedFieldDef);
parcelHelpers.export(exports, "isValueDef", ()=>isValueDef);
parcelHelpers.export(exports, "isScaleFieldDef", ()=>isScaleFieldDef);
parcelHelpers.export(exports, "isPositionFieldOrDatumDef", ()=>isPositionFieldOrDatumDef);
parcelHelpers.export(exports, "isMarkPropFieldOrDatumDef", ()=>isMarkPropFieldOrDatumDef);
parcelHelpers.export(exports, "isStringFieldOrDatumDef", ()=>isStringFieldOrDatumDef);
parcelHelpers.export(exports, "toStringFieldDef", ()=>toStringFieldDef);
/**
 * Get a Vega field reference from a Vega-Lite field def.
 */ parcelHelpers.export(exports, "vgField", ()=>vgField);
parcelHelpers.export(exports, "isDiscrete", ()=>isDiscrete);
parcelHelpers.export(exports, "isDiscretizing", ()=>isDiscretizing);
parcelHelpers.export(exports, "isCount", ()=>isCount);
parcelHelpers.export(exports, "verbalTitleFormatter", ()=>verbalTitleFormatter);
parcelHelpers.export(exports, "functionalTitleFormatter", ()=>functionalTitleFormatter);
parcelHelpers.export(exports, "defaultTitleFormatter", ()=>defaultTitleFormatter);
parcelHelpers.export(exports, "setTitleFormatter", ()=>setTitleFormatter);
parcelHelpers.export(exports, "resetTitleFormatter", ()=>resetTitleFormatter);
parcelHelpers.export(exports, "title", ()=>title);
parcelHelpers.export(exports, "getGuide", ()=>getGuide);
parcelHelpers.export(exports, "defaultTitle", ()=>defaultTitle);
parcelHelpers.export(exports, "getFormatMixins", ()=>getFormatMixins);
parcelHelpers.export(exports, "defaultType", ()=>defaultType);
/**
 * Returns the fieldDef -- either from the outer channelDef or from the condition of channelDef.
 * @param channelDef
 */ parcelHelpers.export(exports, "getFieldDef", ()=>getFieldDef);
parcelHelpers.export(exports, "getFieldOrDatumDef", ()=>getFieldOrDatumDef);
/**
 * Convert type to full, lowercase type, or augment the fieldDef with a default type if missing.
 */ parcelHelpers.export(exports, "initChannelDef", ()=>initChannelDef);
parcelHelpers.export(exports, "initFieldOrDatumDef", ()=>initFieldOrDatumDef);
parcelHelpers.export(exports, "initFieldDef", ()=>initFieldDef);
parcelHelpers.export(exports, "normalizeBin", ()=>normalizeBin);
parcelHelpers.export(exports, "channelCompatibility", ()=>channelCompatibility);
/**
 * Check if the field def uses a time format or does not use any format but is temporal
 * (this does not cover field defs that are temporal but use a number format).
 */ parcelHelpers.export(exports, "isFieldOrDatumDefForTimeFormat", ()=>isFieldOrDatumDefForTimeFormat);
/**
 * Check if field def has type `temporal`. If you want to also cover field defs that use a time format, use `isFieldOrDatumDefForTimeFormat`.
 */ parcelHelpers.export(exports, "isTemporalFieldDef", ()=>isTemporalFieldDef);
/**
 * Getting a value associated with a fielddef.
 * Convert the value to Vega expression if applicable (for datetime object, or string if the field def is temporal or has timeUnit)
 */ parcelHelpers.export(exports, "valueExpr", ()=>valueExpr);
/**
 * Standardize value array -- convert each value to Vega expression if applicable
 */ parcelHelpers.export(exports, "valueArray", ()=>valueArray);
/**
 * Checks whether a fieldDef for a particular channel requires a computed bin range.
 */ parcelHelpers.export(exports, "binRequiresRange", ()=>binRequiresRange);
var _vegaUtil = require("vega-util");
var _aggregate = require("./aggregate");
var _bin = require("./bin");
var _channel = require("./channel");
var _common = require("./compile/common");
var _format = require("./compile/format");
var _datetime = require("./datetime");
var _expr = require("./expr");
var _log = require("./log");
var _mark = require("./mark");
var _scale = require("./scale");
var _sort = require("./sort");
var _facet = require("./spec/facet");
var _timeunit = require("./timeunit");
var _type = require("./type");
var _util = require("./util");
var _vegaSchema = require("./vega.schema");
function isConditionalParameter(c) {
    return (0, _util.hasProperty)(c, 'param');
}
function isRepeatRef(field) {
    return !(0, _vegaUtil.isString)(field) && (0, _util.hasProperty)(field, 'repeat');
}
function toFieldDefBase(fieldDef) {
    const { field, timeUnit, bin, aggregate } = fieldDef;
    return {
        ...timeUnit ? {
            timeUnit
        } : {},
        ...bin ? {
            bin
        } : {},
        ...aggregate ? {
            aggregate
        } : {},
        field
    };
}
function isSortableFieldDef(fieldDef) {
    return (0, _util.hasProperty)(fieldDef, 'sort');
}
function getBandPosition({ fieldDef, fieldDef2, markDef: mark, config }) {
    if (isFieldOrDatumDef(fieldDef) && fieldDef.bandPosition !== undefined) return fieldDef.bandPosition;
    if (isFieldDef(fieldDef)) {
        const { timeUnit, bin } = fieldDef;
        if (timeUnit && !fieldDef2) return (0, _common.getMarkConfig)('timeUnitBandPosition', mark, config);
        else if ((0, _bin.isBinning)(bin)) return 0.5;
    }
    return undefined;
}
function getBandSize({ channel, fieldDef, fieldDef2, markDef: mark, config, scaleType, useVlSizeChannel }) {
    const sizeChannel = (0, _channel.getSizeChannel)(channel);
    const size = (0, _common.getMarkPropOrConfig)(useVlSizeChannel ? 'size' : sizeChannel, mark, config, {
        vgChannel: sizeChannel
    });
    if (size !== undefined) return size;
    if (isFieldDef(fieldDef)) {
        const { timeUnit, bin } = fieldDef;
        if (timeUnit && !fieldDef2) return {
            band: (0, _common.getMarkConfig)('timeUnitBandSize', mark, config)
        };
        else if ((0, _bin.isBinning)(bin) && !(0, _scale.hasDiscreteDomain)(scaleType)) return {
            band: 1
        };
    }
    if ((0, _mark.isRectBasedMark)(mark.type)) {
        if (scaleType) {
            if ((0, _scale.hasDiscreteDomain)(scaleType)) return config[mark.type]?.discreteBandSize || {
                band: 1
            };
            else return config[mark.type]?.continuousBandSize;
        }
        return config[mark.type]?.discreteBandSize;
    }
    return undefined;
}
function hasBandEnd(fieldDef, fieldDef2, markDef, config) {
    if ((0, _bin.isBinning)(fieldDef.bin) || fieldDef.timeUnit && isTypedFieldDef(fieldDef) && fieldDef.type === 'temporal') // Need to check bandPosition because non-rect marks (e.g., point) with timeUnit
    // doesn't have to use bandEnd if there is no bandPosition.
    return getBandPosition({
        fieldDef,
        fieldDef2,
        markDef,
        config
    }) !== undefined;
    return false;
}
function isOrderOnlyDef(orderDef) {
    return (0, _util.hasProperty)(orderDef, 'sort') && !(0, _util.hasProperty)(orderDef, 'field');
}
function isConditionalDef(channelDef) {
    return (0, _util.hasProperty)(channelDef, 'condition');
}
function hasConditionalFieldDef(channelDef) {
    const condition = channelDef?.['condition'];
    return !!condition && !(0, _vegaUtil.isArray)(condition) && isFieldDef(condition);
}
function hasConditionalFieldOrDatumDef(channelDef) {
    const condition = channelDef?.['condition'];
    return !!condition && !(0, _vegaUtil.isArray)(condition) && isFieldOrDatumDef(condition);
}
function hasConditionalValueDef(channelDef) {
    const condition = channelDef?.['condition'];
    return !!condition && ((0, _vegaUtil.isArray)(condition) || isValueDef(condition));
}
function isFieldDef(channelDef) {
    return (0, _util.hasProperty)(channelDef, 'field') || channelDef?.aggregate === 'count';
}
function channelDefType(channelDef) {
    return channelDef?.['type'];
}
function isDatumDef(channelDef) {
    return (0, _util.hasProperty)(channelDef, 'datum');
}
function isContinuousFieldOrDatumDef(cd) {
    // TODO: make datum support DateTime object
    return isTypedFieldDef(cd) && !isDiscrete(cd) || isNumericDataDef(cd);
}
function isUnbinnedQuantitativeFieldOrDatumDef(cd) {
    // TODO: make datum support DateTime object
    return isTypedFieldDef(cd) && cd.type === 'quantitative' && !cd.bin || isNumericDataDef(cd);
}
function isNumericDataDef(cd) {
    return isDatumDef(cd) && (0, _vegaUtil.isNumber)(cd.datum);
}
function isFieldOrDatumDef(channelDef) {
    return isFieldDef(channelDef) || isDatumDef(channelDef);
}
function isTypedFieldDef(channelDef) {
    return channelDef && ((0, _util.hasProperty)(channelDef, 'field') || channelDef['aggregate'] === 'count') && (0, _util.hasProperty)(channelDef, 'type');
}
function isValueDef(channelDef) {
    return (0, _util.hasProperty)(channelDef, 'value');
}
function isScaleFieldDef(channelDef) {
    return (0, _util.hasProperty)(channelDef, 'scale') || (0, _util.hasProperty)(channelDef, 'sort');
}
function isPositionFieldOrDatumDef(channelDef) {
    return (0, _util.hasProperty)(channelDef, 'axis') || (0, _util.hasProperty)(channelDef, 'stack') || (0, _util.hasProperty)(channelDef, 'impute');
}
function isMarkPropFieldOrDatumDef(channelDef) {
    return (0, _util.hasProperty)(channelDef, 'legend');
}
function isStringFieldOrDatumDef(channelDef) {
    return (0, _util.hasProperty)(channelDef, 'format') || (0, _util.hasProperty)(channelDef, 'formatType');
}
function toStringFieldDef(fieldDef) {
    // omit properties that don't exist in string field defs
    return (0, _util.omit)(fieldDef, [
        'legend',
        'axis',
        'header',
        'scale'
    ]);
}
function isOpFieldDef(fieldDef) {
    return (0, _util.hasProperty)(fieldDef, 'op');
}
function vgField(fieldDef, opt = {}) {
    let field = fieldDef.field;
    const prefix = opt.prefix;
    let suffix = opt.suffix;
    let argAccessor = ''; // for accessing argmin/argmax field at the end without getting escaped
    if (isCount(fieldDef)) field = (0, _util.internalField)('count');
    else {
        let fn;
        if (!opt.nofn) {
            if (isOpFieldDef(fieldDef)) fn = fieldDef.op;
            else {
                const { bin, aggregate, timeUnit } = fieldDef;
                if ((0, _bin.isBinning)(bin)) {
                    fn = (0, _bin.binToString)(bin);
                    suffix = (opt.binSuffix ?? '') + (opt.suffix ?? '');
                } else if (aggregate) {
                    if ((0, _aggregate.isArgmaxDef)(aggregate)) {
                        argAccessor = `["${field}"]`;
                        field = `argmax_${aggregate.argmax}`;
                    } else if ((0, _aggregate.isArgminDef)(aggregate)) {
                        argAccessor = `["${field}"]`;
                        field = `argmin_${aggregate.argmin}`;
                    } else fn = String(aggregate);
                } else if (timeUnit && !(0, _timeunit.isBinnedTimeUnit)(timeUnit)) {
                    fn = (0, _timeunit.timeUnitToString)(timeUnit);
                    suffix = (![
                        'range',
                        'mid'
                    ].includes(opt.binSuffix) && opt.binSuffix || '') + (opt.suffix ?? '');
                }
            }
        }
        if (fn) field = field ? `${fn}_${field}` : fn;
    }
    if (suffix) field = `${field}_${suffix}`;
    if (prefix) field = `${prefix}_${field}`;
    if (opt.forAs) return (0, _util.removePathFromField)(field);
    else if (opt.expr) // Expression to access flattened field. No need to escape dots.
    return (0, _util.flatAccessWithDatum)(field, opt.expr) + argAccessor;
    else // We flattened all fields so paths should have become dot.
    return (0, _util.replacePathInField)(field) + argAccessor;
}
function isDiscrete(def) {
    switch(def.type){
        case 'nominal':
        case 'ordinal':
        case 'geojson':
            return true;
        case 'quantitative':
            return isFieldDef(def) && !!def.bin;
        case 'temporal':
            return false;
    }
    throw new Error(_log.message.invalidFieldType(def.type));
}
function isDiscretizing(def) {
    return isScaleFieldDef(def) && (0, _scale.isContinuousToDiscrete)(def.scale?.type);
}
function isCount(fieldDef) {
    return fieldDef.aggregate === 'count';
}
function verbalTitleFormatter(fieldDef, config) {
    const { field, bin, timeUnit, aggregate } = fieldDef;
    if (aggregate === 'count') return config.countTitle;
    else if ((0, _bin.isBinning)(bin)) return `${field} (binned)`;
    else if (timeUnit && !(0, _timeunit.isBinnedTimeUnit)(timeUnit)) {
        const unit = (0, _timeunit.normalizeTimeUnit)(timeUnit)?.unit;
        if (unit) return `${field} (${(0, _timeunit.getTimeUnitParts)(unit).join('-')})`;
    } else if (aggregate) {
        if ((0, _aggregate.isArgmaxDef)(aggregate)) return `${field} for max ${aggregate.argmax}`;
        else if ((0, _aggregate.isArgminDef)(aggregate)) return `${field} for min ${aggregate.argmin}`;
        else return `${(0, _util.titleCase)(aggregate)} of ${field}`;
    }
    return field;
}
function functionalTitleFormatter(fieldDef) {
    const { aggregate, bin, timeUnit, field } = fieldDef;
    if ((0, _aggregate.isArgmaxDef)(aggregate)) return `${field} for argmax(${aggregate.argmax})`;
    else if ((0, _aggregate.isArgminDef)(aggregate)) return `${field} for argmin(${aggregate.argmin})`;
    const timeUnitParams = timeUnit && !(0, _timeunit.isBinnedTimeUnit)(timeUnit) ? (0, _timeunit.normalizeTimeUnit)(timeUnit) : undefined;
    const fn = aggregate || timeUnitParams?.unit || timeUnitParams?.maxbins && 'timeunit' || (0, _bin.isBinning)(bin) && 'bin';
    return fn ? `${fn.toUpperCase()}(${field})` : field;
}
const defaultTitleFormatter = (fieldDef, config)=>{
    switch(config.fieldTitle){
        case 'plain':
            return fieldDef.field;
        case 'functional':
            return functionalTitleFormatter(fieldDef);
        default:
            return verbalTitleFormatter(fieldDef, config);
    }
};
let titleFormatter = defaultTitleFormatter;
function setTitleFormatter(formatter) {
    titleFormatter = formatter;
}
function resetTitleFormatter() {
    setTitleFormatter(defaultTitleFormatter);
}
function title(fieldOrDatumDef, config, { allowDisabling, includeDefault = true }) {
    const guideTitle = getGuide(fieldOrDatumDef)?.title;
    if (!isFieldDef(fieldOrDatumDef)) return guideTitle ?? fieldOrDatumDef.title;
    const fieldDef = fieldOrDatumDef;
    const def = includeDefault ? defaultTitle(fieldDef, config) : undefined;
    if (allowDisabling) return (0, _util.getFirstDefined)(guideTitle, fieldDef.title, def);
    else return guideTitle ?? fieldDef.title ?? def;
}
function getGuide(fieldDef) {
    if (isPositionFieldOrDatumDef(fieldDef) && fieldDef.axis) return fieldDef.axis;
    else if (isMarkPropFieldOrDatumDef(fieldDef) && fieldDef.legend) return fieldDef.legend;
    else if ((0, _facet.isFacetFieldDef)(fieldDef) && fieldDef.header) return fieldDef.header;
    return undefined;
}
function defaultTitle(fieldDef, config) {
    return titleFormatter(fieldDef, config);
}
function getFormatMixins(fieldDef) {
    if (isStringFieldOrDatumDef(fieldDef)) {
        const { format, formatType } = fieldDef;
        return {
            format,
            formatType
        };
    } else {
        const guide = getGuide(fieldDef) ?? {};
        const { format, formatType } = guide;
        return {
            format,
            formatType
        };
    }
}
function defaultType(fieldDef, channel) {
    switch(channel){
        case 'latitude':
        case 'longitude':
            return 'quantitative';
        case 'row':
        case 'column':
        case 'facet':
        case 'shape':
        case 'strokeDash':
            return 'nominal';
        case 'order':
            return 'ordinal';
    }
    if (isSortableFieldDef(fieldDef) && (0, _vegaUtil.isArray)(fieldDef.sort)) return 'ordinal';
    const { aggregate, bin, timeUnit } = fieldDef;
    if (timeUnit) return 'temporal';
    if (bin || aggregate && !(0, _aggregate.isArgmaxDef)(aggregate) && !(0, _aggregate.isArgminDef)(aggregate)) return 'quantitative';
    if (isScaleFieldDef(fieldDef) && fieldDef.scale?.type) switch((0, _scale.SCALE_CATEGORY_INDEX)[fieldDef.scale.type]){
        case 'numeric':
        case 'discretizing':
            return 'quantitative';
        case 'time':
            return 'temporal';
    }
    return 'nominal';
}
function getFieldDef(channelDef) {
    if (isFieldDef(channelDef)) return channelDef;
    else if (hasConditionalFieldDef(channelDef)) return channelDef.condition;
    return undefined;
}
function getFieldOrDatumDef(channelDef) {
    if (isFieldOrDatumDef(channelDef)) return channelDef;
    else if (hasConditionalFieldOrDatumDef(channelDef)) return channelDef.condition;
    return undefined;
}
function initChannelDef(channelDef, channel, config, opt = {}) {
    if ((0, _vegaUtil.isString)(channelDef) || (0, _vegaUtil.isNumber)(channelDef) || (0, _vegaUtil.isBoolean)(channelDef)) {
        const primitiveType = (0, _vegaUtil.isString)(channelDef) ? 'string' : (0, _vegaUtil.isNumber)(channelDef) ? 'number' : 'boolean';
        _log.warn(_log.message.primitiveChannelDef(channel, primitiveType, channelDef));
        return {
            value: channelDef
        };
    }
    // If a fieldDef contains a field, we need type.
    if (isFieldOrDatumDef(channelDef)) return initFieldOrDatumDef(channelDef, channel, config, opt);
    else if (hasConditionalFieldOrDatumDef(channelDef)) return {
        ...channelDef,
        // Need to cast as normalizeFieldDef normally return FieldDef, but here we know that it is definitely Condition<FieldDef>
        condition: initFieldOrDatumDef(channelDef.condition, channel, config, opt)
    };
    return channelDef;
}
function initFieldOrDatumDef(fd, channel, config, opt) {
    if (isStringFieldOrDatumDef(fd)) {
        const { format, formatType, ...rest } = fd;
        if ((0, _format.isCustomFormatType)(formatType) && !config.customFormatTypes) {
            _log.warn(_log.message.customFormatTypeNotAllowed(channel));
            return initFieldOrDatumDef(rest, channel, config, opt);
        }
    } else {
        const guideType = isPositionFieldOrDatumDef(fd) ? 'axis' : isMarkPropFieldOrDatumDef(fd) ? 'legend' : (0, _facet.isFacetFieldDef)(fd) ? 'header' : null;
        if (guideType && fd[guideType]) {
            const { format, formatType, ...newGuide } = fd[guideType];
            if ((0, _format.isCustomFormatType)(formatType) && !config.customFormatTypes) {
                _log.warn(_log.message.customFormatTypeNotAllowed(channel));
                return initFieldOrDatumDef({
                    ...fd,
                    [guideType]: newGuide
                }, channel, config, opt);
            }
        }
    }
    if (isFieldDef(fd)) return initFieldDef(fd, channel, opt);
    return initDatumDef(fd);
}
function initDatumDef(datumDef) {
    let type = datumDef['type'];
    if (type) return datumDef;
    const { datum } = datumDef;
    type = (0, _vegaUtil.isNumber)(datum) ? 'quantitative' : (0, _vegaUtil.isString)(datum) ? 'nominal' : (0, _datetime.isDateTime)(datum) ? 'temporal' : undefined;
    return {
        ...datumDef,
        type
    };
}
function initFieldDef(fd, channel, { compositeMark = false } = {}) {
    const { aggregate, timeUnit, bin, field } = fd;
    const fieldDef = {
        ...fd
    };
    // Drop invalid aggregate
    if (!compositeMark && aggregate && !(0, _aggregate.isAggregateOp)(aggregate) && !(0, _aggregate.isArgmaxDef)(aggregate) && !(0, _aggregate.isArgminDef)(aggregate)) {
        _log.warn(_log.message.invalidAggregate(aggregate));
        delete fieldDef.aggregate;
    }
    // Normalize Time Unit
    if (timeUnit) fieldDef.timeUnit = (0, _timeunit.normalizeTimeUnit)(timeUnit);
    if (field) fieldDef.field = `${field}`;
    // Normalize bin
    if ((0, _bin.isBinning)(bin)) fieldDef.bin = normalizeBin(bin, channel);
    if ((0, _bin.isBinned)(bin) && !(0, _channel.isXorY)(channel)) _log.warn(_log.message.channelShouldNotBeUsedForBinned(channel));
    // Normalize Type
    if (isTypedFieldDef(fieldDef)) {
        const { type } = fieldDef;
        const fullType = (0, _type.getFullName)(type);
        if (type !== fullType) // convert short type to full type
        fieldDef.type = fullType;
        if (type !== 'quantitative') {
            if ((0, _aggregate.isCountingAggregateOp)(aggregate)) {
                _log.warn(_log.message.invalidFieldTypeForCountAggregate(type, aggregate));
                fieldDef.type = 'quantitative';
            }
        }
    } else if (!(0, _channel.isSecondaryRangeChannel)(channel)) {
        // If type is empty / invalid, then augment with default type
        const newType = defaultType(fieldDef, channel);
        fieldDef['type'] = newType;
    }
    if (isTypedFieldDef(fieldDef)) {
        const { compatible, warning } = channelCompatibility(fieldDef, channel) || {};
        if (compatible === false) _log.warn(warning);
    }
    if (isSortableFieldDef(fieldDef) && (0, _vegaUtil.isString)(fieldDef.sort)) {
        const { sort } = fieldDef;
        if ((0, _sort.isSortByChannel)(sort)) return {
            ...fieldDef,
            sort: {
                encoding: sort
            }
        };
        const sub = sort.substring(1);
        if (sort.charAt(0) === '-' && (0, _sort.isSortByChannel)(sub)) return {
            ...fieldDef,
            sort: {
                encoding: sub,
                order: 'descending'
            }
        };
    }
    if ((0, _facet.isFacetFieldDef)(fieldDef)) {
        const { header } = fieldDef;
        if (header) {
            const { orient, ...rest } = header;
            if (orient) return {
                ...fieldDef,
                header: {
                    ...rest,
                    labelOrient: header.labelOrient || orient,
                    titleOrient: header.titleOrient || orient
                }
            };
        }
    }
    return fieldDef;
}
function normalizeBin(bin, channel) {
    if ((0, _vegaUtil.isBoolean)(bin)) return {
        maxbins: (0, _bin.autoMaxBins)(channel)
    };
    else if (bin === 'binned') return {
        binned: true
    };
    else if (!bin.maxbins && !bin.step) return {
        ...bin,
        maxbins: (0, _bin.autoMaxBins)(channel)
    };
    else return bin;
}
const COMPATIBLE = {
    compatible: true
};
function channelCompatibility(fieldDef, channel) {
    const type = fieldDef.type;
    if (type === 'geojson' && channel !== 'shape') return {
        compatible: false,
        warning: `Channel ${channel} should not be used with a geojson data.`
    };
    switch(channel){
        case 0, _channel.ROW:
        case 0, _channel.COLUMN:
        case 0, _channel.FACET:
            if (!isDiscrete(fieldDef)) return {
                compatible: false,
                warning: _log.message.channelShouldBeDiscrete(channel)
            };
            return COMPATIBLE;
        case 0, _channel.X:
        case 0, _channel.Y:
        case 0, _channel.XOFFSET:
        case 0, _channel.YOFFSET:
        case 0, _channel.COLOR:
        case 0, _channel.FILL:
        case 0, _channel.STROKE:
        case 0, _channel.TEXT:
        case 0, _channel.DETAIL:
        case 0, _channel.KEY:
        case 0, _channel.TOOLTIP:
        case 0, _channel.HREF:
        case 0, _channel.URL:
        case 0, _channel.ANGLE:
        case 0, _channel.THETA:
        case 0, _channel.RADIUS:
        case 0, _channel.DESCRIPTION:
            return COMPATIBLE;
        case 0, _channel.LONGITUDE:
        case 0, _channel.LONGITUDE2:
        case 0, _channel.LATITUDE:
        case 0, _channel.LATITUDE2:
            if (type !== (0, _type.QUANTITATIVE)) return {
                compatible: false,
                warning: `Channel ${channel} should be used with a quantitative field only, not ${fieldDef.type} field.`
            };
            return COMPATIBLE;
        case 0, _channel.OPACITY:
        case 0, _channel.FILLOPACITY:
        case 0, _channel.STROKEOPACITY:
        case 0, _channel.STROKEWIDTH:
        case 0, _channel.SIZE:
        case 0, _channel.THETA2:
        case 0, _channel.RADIUS2:
        case 0, _channel.X2:
        case 0, _channel.Y2:
        case 0, _channel.TIME:
            if (type === 'nominal' && !fieldDef['sort']) return {
                compatible: false,
                warning: `Channel ${channel} should not be used with an unsorted discrete field.`
            };
            return COMPATIBLE;
        case 0, _channel.SHAPE:
        case 0, _channel.STROKEDASH:
            if (!isDiscrete(fieldDef) && !isDiscretizing(fieldDef)) return {
                compatible: false,
                warning: _log.message.channelShouldBeDiscreteOrDiscretizing(channel)
            };
            return COMPATIBLE;
        case 0, _channel.ORDER:
            if (fieldDef.type === 'nominal' && !('sort' in fieldDef)) return {
                compatible: false,
                warning: `Channel order is inappropriate for nominal field, which has no inherent order.`
            };
            return COMPATIBLE;
    }
}
function isFieldOrDatumDefForTimeFormat(fieldOrDatumDef) {
    const { formatType } = getFormatMixins(fieldOrDatumDef);
    return formatType === 'time' || !formatType && isTemporalFieldDef(fieldOrDatumDef);
}
function isTemporalFieldDef(def) {
    return def && (def['type'] === 'temporal' || isFieldDef(def) && !!def.timeUnit);
}
function valueExpr(v, { timeUnit, type, wrapTime, undefinedIfExprNotRequired }) {
    const unit = timeUnit && (0, _timeunit.normalizeTimeUnit)(timeUnit)?.unit;
    let isTime = unit || type === 'temporal';
    let expr;
    if ((0, _expr.isExprRef)(v)) expr = v.expr;
    else if ((0, _vegaSchema.isSignalRef)(v)) expr = v.signal;
    else if ((0, _datetime.isDateTime)(v)) {
        isTime = true;
        expr = (0, _datetime.dateTimeToExpr)(v);
    } else if ((0, _vegaUtil.isString)(v) || (0, _vegaUtil.isNumber)(v)) {
        if (isTime) {
            expr = `datetime(${(0, _util.stringify)(v)})`;
            if ((0, _timeunit.isLocalSingleTimeUnit)(unit)) // for single timeUnit, we will use dateTimeToExpr to convert number/string to match the timeUnit
            {
                if ((0, _vegaUtil.isNumber)(v) && v < 10000 || (0, _vegaUtil.isString)(v) && isNaN(Date.parse(v))) expr = (0, _datetime.dateTimeToExpr)({
                    [unit]: v
                });
            }
        }
    }
    if (expr) return wrapTime && isTime ? `time(${expr})` : expr;
    // number or boolean or normal string
    return undefinedIfExprNotRequired ? undefined : (0, _util.stringify)(v);
}
function valueArray(fieldOrDatumDef, values) {
    const { type } = fieldOrDatumDef;
    return values.map((v)=>{
        const timeUnit = isFieldDef(fieldOrDatumDef) && !(0, _timeunit.isBinnedTimeUnit)(fieldOrDatumDef.timeUnit) ? fieldOrDatumDef.timeUnit : undefined;
        const expr = valueExpr(v, {
            timeUnit,
            type,
            undefinedIfExprNotRequired: true
        });
        // return signal for the expression if we need an expression
        if (expr !== undefined) return {
            signal: expr
        };
        // otherwise just return the original value
        return v;
    });
}
function binRequiresRange(fieldDef, channel) {
    if (!(0, _bin.isBinning)(fieldDef.bin)) {
        console.warn('Only call this method for binned field defs.');
        return false;
    }
    // We need the range only when the user explicitly forces a binned field to be use discrete scale. In this case, bin range is used in axis and legend labels.
    // We could check whether the axis or legend exists (not disabled) but that seems overkill.
    return (0, _channel.isScaleChannel)(channel) && [
        'ordinal',
        'nominal'
    ].includes(fieldDef.type);
}

},{"vega-util":"7f6sQ","./aggregate":"d7bUU","./bin":"3cpW8","./channel":"liLED","./compile/common":"jegt8","./compile/format":"79ccI","./datetime":"gp5cf","./expr":"ev4sO","./log":"loqTw","./mark":"3Z1xx","./scale":"bdpXN","./sort":"aWnXd","./spec/facet":"3pm05","./timeunit":"eky0T","./type":"cbWGP","./util":"acUGA","./vega.schema":"3mBOT","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"d7bUU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MULTIDOMAIN_SORT_OP_INDEX", ()=>MULTIDOMAIN_SORT_OP_INDEX);
parcelHelpers.export(exports, "isArgminDef", ()=>isArgminDef);
parcelHelpers.export(exports, "isArgmaxDef", ()=>isArgmaxDef);
parcelHelpers.export(exports, "isAggregateOp", ()=>isAggregateOp);
parcelHelpers.export(exports, "COUNTING_OPS", ()=>COUNTING_OPS);
parcelHelpers.export(exports, "isCountingAggregateOp", ()=>isCountingAggregateOp);
parcelHelpers.export(exports, "isMinMaxOp", ()=>isMinMaxOp);
parcelHelpers.export(exports, "SUM_OPS", ()=>SUM_OPS);
parcelHelpers.export(exports, "SHARED_DOMAIN_OPS", ()=>SHARED_DOMAIN_OPS);
var _vegaUtil = require("vega-util");
var _util = require("./util");
const AGGREGATE_OP_INDEX = {
    argmax: 1,
    argmin: 1,
    average: 1,
    count: 1,
    distinct: 1,
    exponential: 1,
    exponentialb: 1,
    product: 1,
    max: 1,
    mean: 1,
    median: 1,
    min: 1,
    missing: 1,
    q1: 1,
    q3: 1,
    ci0: 1,
    ci1: 1,
    stderr: 1,
    stdev: 1,
    stdevp: 1,
    sum: 1,
    valid: 1,
    values: 1,
    variance: 1,
    variancep: 1
};
const MULTIDOMAIN_SORT_OP_INDEX = {
    count: 1,
    min: 1,
    max: 1
};
function isArgminDef(a) {
    return (0, _util.hasProperty)(a, 'argmin');
}
function isArgmaxDef(a) {
    return (0, _util.hasProperty)(a, 'argmax');
}
function isAggregateOp(a) {
    return (0, _vegaUtil.isString)(a) && (0, _vegaUtil.hasOwnProperty)(AGGREGATE_OP_INDEX, a);
}
const COUNTING_OPS = new Set([
    'count',
    'valid',
    'missing',
    'distinct'
]);
function isCountingAggregateOp(aggregate) {
    return (0, _vegaUtil.isString)(aggregate) && COUNTING_OPS.has(aggregate);
}
function isMinMaxOp(aggregate) {
    return (0, _vegaUtil.isString)(aggregate) && (0, _util.contains)([
        'min',
        'max'
    ], aggregate);
}
const SUM_OPS = new Set([
    'count',
    'sum',
    'distinct',
    'valid',
    'missing'
]);
const SHARED_DOMAIN_OPS = new Set([
    'mean',
    'average',
    'median',
    'q1',
    'q3',
    'min',
    'max'
]);

},{"vega-util":"7f6sQ","./util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3cpW8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create a key for the bin configuration. Not for prebinned bin.
 */ parcelHelpers.export(exports, "binToString", ()=>binToString);
/**
 * Vega-Lite should bin the data.
 */ parcelHelpers.export(exports, "isBinning", ()=>isBinning);
/**
 * The data is already binned and so Vega-Lite should not bin it again.
 */ parcelHelpers.export(exports, "isBinned", ()=>isBinned);
parcelHelpers.export(exports, "isBinParams", ()=>isBinParams);
parcelHelpers.export(exports, "isParameterExtent", ()=>isParameterExtent);
parcelHelpers.export(exports, "autoMaxBins", ()=>autoMaxBins);
var _vegaUtil = require("vega-util");
var _channel = require("./channel");
var _channeldef = require("./channeldef");
var _util = require("./util");
function binToString(bin) {
    if ((0, _vegaUtil.isBoolean)(bin)) bin = (0, _channeldef.normalizeBin)(bin, undefined);
    return 'bin' + (0, _util.keys)(bin).map((p)=>isParameterExtent(bin[p]) ? (0, _util.varName)(`_${p}_${(0, _util.entries)(bin[p])}`) : (0, _util.varName)(`_${p}_${bin[p]}`)).join('');
}
function isBinning(bin) {
    return bin === true || isBinParams(bin) && !bin.binned;
}
function isBinned(bin) {
    return bin === 'binned' || isBinParams(bin) && bin.binned === true;
}
function isBinParams(bin) {
    return (0, _vegaUtil.isObject)(bin);
}
function isParameterExtent(extent) {
    return (0, _util.hasProperty)(extent, 'param');
}
function autoMaxBins(channel) {
    switch(channel){
        case 0, _channel.ROW:
        case 0, _channel.COLUMN:
        case 0, _channel.SIZE:
        case 0, _channel.COLOR:
        case 0, _channel.FILL:
        case 0, _channel.STROKE:
        case 0, _channel.STROKEWIDTH:
        case 0, _channel.OPACITY:
        case 0, _channel.FILLOPACITY:
        case 0, _channel.STROKEOPACITY:
        // Facets and Size shouldn't have too many bins
        // We choose 6 like shape to simplify the rule [falls through]
        case 0, _channel.SHAPE:
            return 6; // Vega's "shape" has 6 distinct values
        case 0, _channel.STROKEDASH:
            return 4; // We only provide 5 different stroke dash values (but 4 is more effective)
        default:
            return 10;
    }
}

},{"vega-util":"7f6sQ","./channel":"liLED","./channeldef":"dsccb","./util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"jegt8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BIN_RANGE_DELIMITER", ()=>BIN_RANGE_DELIMITER);
parcelHelpers.export(exports, "signalOrValueRefWithCondition", ()=>signalOrValueRefWithCondition);
parcelHelpers.export(exports, "signalRefOrValue", ()=>signalRefOrValue);
parcelHelpers.export(exports, "conditionalSignalRefOrValue", ()=>conditionalSignalRefOrValue);
parcelHelpers.export(exports, "signalOrValueRef", ()=>signalOrValueRef);
parcelHelpers.export(exports, "exprFromSignalRefOrValue", ()=>exprFromSignalRefOrValue);
parcelHelpers.export(exports, "exprFromValueRefOrSignalRef", ()=>exprFromValueRefOrSignalRef);
parcelHelpers.export(exports, "signalOrStringValue", ()=>signalOrStringValue);
parcelHelpers.export(exports, "applyMarkConfig", ()=>applyMarkConfig);
parcelHelpers.export(exports, "getStyles", ()=>getStyles);
parcelHelpers.export(exports, "getMarkPropOrConfig", ()=>getMarkPropOrConfig);
/**
 * Return property value from style or mark specific config property if exists.
 * Otherwise, return general mark specific config.
 */ parcelHelpers.export(exports, "getMarkConfig", ()=>getMarkConfig);
parcelHelpers.export(exports, "getMarkStyleConfig", ()=>getMarkStyleConfig);
parcelHelpers.export(exports, "getStyleConfig", ()=>getStyleConfig);
/**
 * Return Vega sort parameters (tuple of field and order).
 */ parcelHelpers.export(exports, "sortParams", ()=>sortParams);
parcelHelpers.export(exports, "mergeTitleFieldDefs", ()=>mergeTitleFieldDefs);
parcelHelpers.export(exports, "mergeTitle", ()=>mergeTitle);
parcelHelpers.export(exports, "mergeTitleComponent", ()=>mergeTitleComponent);
var _vegaUtil = require("vega-util");
var _channeldef = require("../channeldef");
var _expr = require("../expr");
var _title = require("../title");
var _util = require("../util");
var _vegaSchema = require("../vega.schema");
const BIN_RANGE_DELIMITER = ' \u2013 ';
function signalOrValueRefWithCondition(val) {
    const condition = (0, _vegaUtil.isArray)(val.condition) ? val.condition.map(conditionalSignalRefOrValue) : conditionalSignalRefOrValue(val.condition);
    return {
        ...signalRefOrValue(val),
        condition
    };
}
function signalRefOrValue(value) {
    if ((0, _expr.isExprRef)(value)) {
        const { expr, ...rest } = value;
        return {
            signal: expr,
            ...rest
        };
    }
    return value;
}
function conditionalSignalRefOrValue(value) {
    if ((0, _expr.isExprRef)(value)) {
        const { expr, ...rest } = value;
        return {
            signal: expr,
            ...rest
        };
    }
    return value;
}
function signalOrValueRef(value) {
    if ((0, _expr.isExprRef)(value)) {
        const { expr, ...rest } = value;
        return {
            signal: expr,
            ...rest
        };
    }
    if ((0, _vegaSchema.isSignalRef)(value)) return value;
    return value !== undefined ? {
        value
    } : undefined;
}
function exprFromSignalRefOrValue(ref) {
    if ((0, _vegaSchema.isSignalRef)(ref)) return ref.signal;
    return (0, _vegaUtil.stringValue)(ref);
}
function exprFromValueRefOrSignalRef(ref) {
    if ((0, _vegaSchema.isSignalRef)(ref)) return ref.signal;
    return (0, _vegaUtil.stringValue)(ref.value);
}
function signalOrStringValue(v) {
    if ((0, _vegaSchema.isSignalRef)(v)) return v.signal;
    return v == null ? null : (0, _vegaUtil.stringValue)(v);
}
function applyMarkConfig(e, model, propsList) {
    for (const property of propsList){
        const value = getMarkConfig(property, model.markDef, model.config);
        if (value !== undefined) e[property] = signalOrValueRef(value);
    }
    return e;
}
function getStyles(mark) {
    return [].concat(mark.type, mark.style ?? []);
}
function getMarkPropOrConfig(channel, mark, config, opt = {}) {
    const { vgChannel, ignoreVgConfig } = opt;
    if (vgChannel && (0, _util.hasProperty)(mark, vgChannel)) return mark[vgChannel];
    else if (mark[channel] !== undefined) return mark[channel];
    else if (ignoreVgConfig && (!vgChannel || vgChannel === channel)) return undefined;
    return getMarkConfig(channel, mark, config, opt);
}
function getMarkConfig(channel, mark, config, { vgChannel } = {}) {
    const cfg = getMarkStyleConfig(channel, mark, config.style);
    return (0, _util.getFirstDefined)(// style config has highest precedence
    vgChannel ? cfg : undefined, cfg, // then mark-specific config
    vgChannel ? config[mark.type][vgChannel] : undefined, config[mark.type][channel], // If there is vgChannel, skip vl channel.
    // For example, vl size for text is vg fontSize, but config.mark.size is only for point size.
    vgChannel ? config.mark[vgChannel] : config.mark[channel] // Need to cast for the same reason as above
    );
}
function getMarkStyleConfig(prop, mark, styleConfigIndex) {
    return getStyleConfig(prop, getStyles(mark), styleConfigIndex);
}
function getStyleConfig(p, styles, styleConfigIndex) {
    styles = (0, _vegaUtil.array)(styles);
    let value;
    for (const style of styles){
        const styleConfig = styleConfigIndex[style];
        if ((0, _util.hasProperty)(styleConfig, p)) value = styleConfig[p];
    }
    return value;
}
function sortParams(orderDef, fieldRefOption) {
    return (0, _vegaUtil.array)(orderDef).reduce((s, orderChannelDef)=>{
        s.field.push((0, _channeldef.vgField)(orderChannelDef, fieldRefOption));
        s.order.push(orderChannelDef.sort ?? 'ascending');
        return s;
    }, {
        field: [],
        order: []
    });
}
function mergeTitleFieldDefs(f1, f2) {
    const merged = [
        ...f1
    ];
    f2.forEach((fdToMerge)=>{
        for (const fieldDef1 of merged){
            // If already exists, no need to append to merged array
            if ((0, _util.deepEqual)(fieldDef1, fdToMerge)) return;
        }
        merged.push(fdToMerge);
    });
    return merged;
}
function mergeTitle(title1, title2) {
    if ((0, _util.deepEqual)(title1, title2) || !title2) // if titles are the same or title2 is falsy
    return title1;
    else if (!title1) // if title1 is falsy
    return title2;
    else return [
        ...(0, _vegaUtil.array)(title1),
        ...(0, _vegaUtil.array)(title2)
    ].join(', ');
}
function mergeTitleComponent(v1, v2) {
    const v1Val = v1.value;
    const v2Val = v2.value;
    if (v1Val == null || v2Val === null) return {
        explicit: v1.explicit,
        value: null
    };
    else if (((0, _title.isText)(v1Val) || (0, _vegaSchema.isSignalRef)(v1Val)) && ((0, _title.isText)(v2Val) || (0, _vegaSchema.isSignalRef)(v2Val))) return {
        explicit: v1.explicit,
        value: mergeTitle(v1Val, v2Val)
    };
    else if ((0, _title.isText)(v1Val) || (0, _vegaSchema.isSignalRef)(v1Val)) return {
        explicit: v1.explicit,
        value: v1Val
    };
    else if ((0, _title.isText)(v2Val) || (0, _vegaSchema.isSignalRef)(v2Val)) return {
        explicit: v1.explicit,
        value: v2Val
    };
    else if (!(0, _title.isText)(v1Val) && !(0, _vegaSchema.isSignalRef)(v1Val) && !(0, _title.isText)(v2Val) && !(0, _vegaSchema.isSignalRef)(v2Val)) return {
        explicit: v1.explicit,
        value: mergeTitleFieldDefs(v1Val, v2Val)
    };
    /* istanbul ignore next: Condition should not happen -- only for warning in development. */ throw new Error('It should never reach here');
}

},{"vega-util":"7f6sQ","../channeldef":"dsccb","../expr":"ev4sO","../title":"bnPA4","../util":"acUGA","../vega.schema":"3mBOT","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"ev4sO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isExprRef", ()=>isExprRef);
parcelHelpers.export(exports, "replaceExprRef", ()=>replaceExprRef);
var _common = require("./compile/common");
var _util = require("./util");
function isExprRef(o) {
    return (0, _util.hasProperty)(o, 'expr');
}
function replaceExprRef(index, { level } = {
    level: 0
}) {
    const props = (0, _util.keys)(index || {});
    const newIndex = {};
    for (const prop of props)newIndex[prop] = level === 0 ? (0, _common.signalRefOrValue)(index[prop]) : replaceExprRef(index[prop], {
        level: level - 1
    });
    return newIndex;
}

},{"./compile/common":"jegt8","./util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bnPA4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractTitleConfig", ()=>extractTitleConfig);
parcelHelpers.export(exports, "isText", ()=>isText);
var _vegaUtil = require("vega-util");
var _util = require("./util");
function extractTitleConfig(titleConfig) {
    const { // These are non-mark title config that need to be hardcoded
    anchor, frame, offset, orient, angle, limit, // color needs to be redirect to fill
    color, // subtitle properties
    subtitleColor, subtitleFont, subtitleFontSize, subtitleFontStyle, subtitleFontWeight, subtitleLineHeight, subtitlePadding, // The rest are mark config.
    ...rest } = titleConfig;
    const titleMarkConfig = {
        ...rest,
        ...color ? {
            fill: color
        } : {}
    };
    // These are non-mark title config that need to be hardcoded
    const nonMarkTitleProperties = {
        ...anchor ? {
            anchor
        } : {},
        ...frame ? {
            frame
        } : {},
        ...offset ? {
            offset
        } : {},
        ...orient ? {
            orient
        } : {},
        ...angle !== undefined ? {
            angle
        } : {},
        ...limit !== undefined ? {
            limit
        } : {}
    };
    // subtitle part can stay in config.title since header titles do not use subtitle
    const subtitle = {
        ...subtitleColor ? {
            subtitleColor
        } : {},
        ...subtitleFont ? {
            subtitleFont
        } : {},
        ...subtitleFontSize ? {
            subtitleFontSize
        } : {},
        ...subtitleFontStyle ? {
            subtitleFontStyle
        } : {},
        ...subtitleFontWeight ? {
            subtitleFontWeight
        } : {},
        ...subtitleLineHeight ? {
            subtitleLineHeight
        } : {},
        ...subtitlePadding ? {
            subtitlePadding
        } : {}
    };
    const subtitleMarkConfig = (0, _util.pick)(titleConfig, [
        'align',
        'baseline',
        'dx',
        'dy',
        'limit'
    ]);
    return {
        titleMarkConfig,
        subtitleMarkConfig,
        nonMarkTitleProperties,
        subtitle
    };
}
function isText(v) {
    return (0, _vegaUtil.isString)(v) || (0, _vegaUtil.isArray)(v) && (0, _vegaUtil.isString)(v[0]);
}

},{"vega-util":"7f6sQ","./util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3mBOT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSignalRef", ()=>isSignalRef);
parcelHelpers.export(exports, "isVgRangeStep", ()=>isVgRangeStep);
parcelHelpers.export(exports, "isDataRefUnionedDomain", ()=>isDataRefUnionedDomain);
parcelHelpers.export(exports, "isFieldRefUnionDomain", ()=>isFieldRefUnionDomain);
parcelHelpers.export(exports, "isDataRefDomain", ()=>isDataRefDomain);
parcelHelpers.export(exports, "VG_MARK_CONFIGS", ()=>VG_MARK_CONFIGS);
parcelHelpers.export(exports, "VG_MARK_INDEX", ()=>VG_MARK_INDEX);
parcelHelpers.export(exports, "VG_CORNERRADIUS_CHANNELS", ()=>VG_CORNERRADIUS_CHANNELS);
var _vegaUtil = require("vega-util");
var _util = require("./util");
function isSignalRef(o) {
    return (0, _util.hasProperty)(o, 'signal');
}
function isVgRangeStep(range) {
    return (0, _util.hasProperty)(range, 'step');
}
function isDataRefUnionedDomain(domain) {
    if (!(0, _vegaUtil.isArray)(domain)) return (0, _util.hasProperty)(domain, 'fields') && !(0, _util.hasProperty)(domain, 'data');
    return false;
}
function isFieldRefUnionDomain(domain) {
    if (!(0, _vegaUtil.isArray)(domain)) return (0, _util.hasProperty)(domain, 'fields') && (0, _util.hasProperty)(domain, 'data');
    return false;
}
function isDataRefDomain(domain) {
    if (!(0, _vegaUtil.isArray)(domain)) return (0, _util.hasProperty)(domain, 'field') && (0, _util.hasProperty)(domain, 'data');
    return false;
}
const VG_MARK_CONFIG_INDEX = {
    aria: 1,
    description: 1,
    ariaRole: 1,
    ariaRoleDescription: 1,
    blend: 1,
    opacity: 1,
    fill: 1,
    fillOpacity: 1,
    stroke: 1,
    strokeCap: 1,
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeDash: 1,
    strokeDashOffset: 1,
    strokeJoin: 1,
    strokeOffset: 1,
    strokeMiterLimit: 1,
    startAngle: 1,
    endAngle: 1,
    padAngle: 1,
    innerRadius: 1,
    outerRadius: 1,
    size: 1,
    shape: 1,
    interpolate: 1,
    tension: 1,
    orient: 1,
    align: 1,
    baseline: 1,
    text: 1,
    dir: 1,
    dx: 1,
    dy: 1,
    ellipsis: 1,
    limit: 1,
    radius: 1,
    theta: 1,
    angle: 1,
    font: 1,
    fontSize: 1,
    fontWeight: 1,
    fontStyle: 1,
    lineBreak: 1,
    lineHeight: 1,
    cursor: 1,
    href: 1,
    tooltip: 1,
    cornerRadius: 1,
    cornerRadiusTopLeft: 1,
    cornerRadiusTopRight: 1,
    cornerRadiusBottomLeft: 1,
    cornerRadiusBottomRight: 1,
    aspect: 1,
    width: 1,
    height: 1,
    url: 1,
    smooth: 1
};
const VG_MARK_CONFIGS = (0, _util.keys)(VG_MARK_CONFIG_INDEX);
const VG_MARK_INDEX = {
    arc: 1,
    area: 1,
    group: 1,
    image: 1,
    line: 1,
    path: 1,
    rect: 1,
    rule: 1,
    shape: 1,
    symbol: 1,
    text: 1,
    trail: 1
};
const VG_CORNERRADIUS_CHANNELS = [
    'cornerRadius',
    'cornerRadiusTopLeft',
    'cornerRadiusTopRight',
    'cornerRadiusBottomLeft',
    'cornerRadiusBottomRight'
];

},{"vega-util":"7f6sQ","./util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"79ccI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isCustomFormatType", ()=>isCustomFormatType);
parcelHelpers.export(exports, "BIN_RANGE_DELIMITER", ()=>BIN_RANGE_DELIMITER);
parcelHelpers.export(exports, "formatSignalRef", ()=>formatSignalRef);
parcelHelpers.export(exports, "formatCustomType", ()=>formatCustomType);
parcelHelpers.export(exports, "guideFormat", ()=>guideFormat);
parcelHelpers.export(exports, "guideFormatType", ()=>guideFormatType);
/**
 * Returns number format for a fieldDef.
 */ parcelHelpers.export(exports, "numberFormat", ()=>numberFormat);
/**
 * Returns time format for a fieldDef for use in guides.
 */ parcelHelpers.export(exports, "timeFormat", ()=>timeFormat);
parcelHelpers.export(exports, "binFormatExpression", ()=>binFormatExpression);
/**
 * Returns the time expression used for axis/legend labels or text mark for a temporal field
 */ parcelHelpers.export(exports, "timeFormatExpression", ()=>timeFormatExpression);
var _vegaUtil = require("vega-util");
var _bin = require("../bin");
var _channeldef = require("../channeldef");
var _predicate = require("../predicate");
var _scale = require("../scale");
var _timeunit = require("../timeunit");
var _type = require("../type");
var _util = require("../util");
var _vegaSchema = require("../vega.schema");
var _valueref = require("./mark/encode/valueref");
function isCustomFormatType(formatType) {
    return formatType && formatType !== 'number' && formatType !== 'time';
}
function customFormatExpr(formatType, field, format) {
    return `${formatType}(${field}${format ? `, ${(0, _util.stringify)(format)}` : ''})`;
}
const BIN_RANGE_DELIMITER = ' \u2013 ';
function formatSignalRef({ fieldOrDatumDef, format, formatType, expr, normalizeStack, config }) {
    if (isCustomFormatType(formatType)) return formatCustomType({
        fieldOrDatumDef,
        format,
        formatType,
        expr,
        config
    });
    const field = fieldToFormat(fieldOrDatumDef, expr, normalizeStack);
    const type = (0, _channeldef.channelDefType)(fieldOrDatumDef);
    if (format === undefined && formatType === undefined && config.customFormatTypes) {
        if (type === 'quantitative') {
            if (normalizeStack && config.normalizedNumberFormatType) return formatCustomType({
                fieldOrDatumDef,
                format: config.normalizedNumberFormat,
                formatType: config.normalizedNumberFormatType,
                expr,
                config
            });
            if (config.numberFormatType) return formatCustomType({
                fieldOrDatumDef,
                format: config.numberFormat,
                formatType: config.numberFormatType,
                expr,
                config
            });
        }
        if (type === 'temporal' && config.timeFormatType && (0, _channeldef.isFieldDef)(fieldOrDatumDef) && fieldOrDatumDef.timeUnit === undefined) return formatCustomType({
            fieldOrDatumDef,
            format: config.timeFormat,
            formatType: config.timeFormatType,
            expr,
            config
        });
    }
    if ((0, _channeldef.isFieldOrDatumDefForTimeFormat)(fieldOrDatumDef)) {
        const signal = timeFormatExpression({
            field,
            timeUnit: (0, _channeldef.isFieldDef)(fieldOrDatumDef) ? (0, _timeunit.normalizeTimeUnit)(fieldOrDatumDef.timeUnit)?.unit : undefined,
            format,
            formatType: config.timeFormatType,
            rawTimeFormat: config.timeFormat,
            isUTCScale: (0, _channeldef.isScaleFieldDef)(fieldOrDatumDef) && fieldOrDatumDef.scale?.type === (0, _scale.ScaleType).UTC
        });
        return signal ? {
            signal
        } : undefined;
    }
    format = numberFormat({
        type,
        specifiedFormat: format,
        config,
        normalizeStack
    });
    if ((0, _channeldef.isFieldDef)(fieldOrDatumDef) && (0, _bin.isBinning)(fieldOrDatumDef.bin)) {
        const endField = (0, _channeldef.vgField)(fieldOrDatumDef, {
            expr,
            binSuffix: 'end'
        });
        return {
            signal: binFormatExpression(field, endField, format, formatType, config)
        };
    } else if (format || (0, _channeldef.channelDefType)(fieldOrDatumDef) === 'quantitative') return {
        signal: `${formatExpr(field, format)}`
    };
    else return {
        signal: `isValid(${field}) ? ${field} : ""+${field}`
    };
}
function fieldToFormat(fieldOrDatumDef, expr, normalizeStack) {
    if ((0, _channeldef.isFieldDef)(fieldOrDatumDef)) {
        if (normalizeStack) return `${(0, _channeldef.vgField)(fieldOrDatumDef, {
            expr,
            suffix: 'end'
        })}-${(0, _channeldef.vgField)(fieldOrDatumDef, {
            expr,
            suffix: 'start'
        })}`;
        else return (0, _channeldef.vgField)(fieldOrDatumDef, {
            expr
        });
    } else return (0, _valueref.datumDefToExpr)(fieldOrDatumDef);
}
function formatCustomType({ fieldOrDatumDef, format, formatType, expr, normalizeStack, config, field }) {
    field ?? (field = fieldToFormat(fieldOrDatumDef, expr, normalizeStack));
    if (field !== 'datum.value' && // For axis/legend, we can't correctly know the end of the bin from `datum`
    (0, _channeldef.isFieldDef)(fieldOrDatumDef) && (0, _bin.isBinning)(fieldOrDatumDef.bin)) {
        const endField = (0, _channeldef.vgField)(fieldOrDatumDef, {
            expr,
            binSuffix: 'end'
        });
        return {
            signal: binFormatExpression(field, endField, format, formatType, config)
        };
    }
    return {
        signal: customFormatExpr(formatType, field, format)
    };
}
function guideFormat(fieldOrDatumDef, type, format, formatType, config, omitTimeFormatConfig // axis doesn't use config.timeFormat
) {
    if ((0, _vegaUtil.isString)(formatType) && isCustomFormatType(formatType)) return undefined; // handled in encode block
    else if (format === undefined && formatType === undefined && config.customFormatTypes) {
        if ((0, _channeldef.channelDefType)(fieldOrDatumDef) === 'quantitative') {
            if (config.normalizedNumberFormatType && (0, _channeldef.isPositionFieldOrDatumDef)(fieldOrDatumDef) && fieldOrDatumDef.stack === 'normalize') return undefined; // handled in encode block
            if (config.numberFormatType) return undefined; // handled in encode block
        }
    }
    if ((0, _channeldef.isPositionFieldOrDatumDef)(fieldOrDatumDef) && fieldOrDatumDef.stack === 'normalize' && config.normalizedNumberFormat) return numberFormat({
        type: 'quantitative',
        config,
        normalizeStack: true
    });
    if ((0, _channeldef.isFieldOrDatumDefForTimeFormat)(fieldOrDatumDef)) {
        const timeUnit = (0, _channeldef.isFieldDef)(fieldOrDatumDef) ? (0, _timeunit.normalizeTimeUnit)(fieldOrDatumDef.timeUnit)?.unit : undefined;
        if (timeUnit === undefined && config.customFormatTypes && config.timeFormatType) return undefined; // hanlded in encode block
        return timeFormat({
            specifiedFormat: format,
            timeUnit,
            config,
            omitTimeFormatConfig
        });
    }
    return numberFormat({
        type,
        specifiedFormat: format,
        config
    });
}
function guideFormatType(formatType, fieldOrDatumDef, scaleType) {
    if (formatType && ((0, _vegaSchema.isSignalRef)(formatType) || formatType === 'number' || formatType === 'time')) return formatType;
    if ((0, _channeldef.isFieldOrDatumDefForTimeFormat)(fieldOrDatumDef) && scaleType !== 'time' && scaleType !== 'utc') return (0, _channeldef.isFieldDef)(fieldOrDatumDef) && (0, _timeunit.normalizeTimeUnit)(fieldOrDatumDef?.timeUnit)?.utc ? 'utc' : 'time';
    return undefined;
}
function numberFormat({ type, specifiedFormat, config, normalizeStack }) {
    // Specified format in axis/legend has higher precedence than fieldDef.format
    if ((0, _vegaUtil.isString)(specifiedFormat)) return specifiedFormat;
    if (type === (0, _type.QUANTITATIVE)) // we only apply the default if the field is quantitative
    return normalizeStack ? config.normalizedNumberFormat : config.numberFormat;
    return undefined;
}
function timeFormat({ specifiedFormat, timeUnit, config, omitTimeFormatConfig }) {
    if (specifiedFormat) return specifiedFormat;
    if (timeUnit) return {
        signal: (0, _timeunit.timeUnitSpecifierExpression)(timeUnit)
    };
    return omitTimeFormatConfig ? undefined : config.timeFormat;
}
function formatExpr(field, format) {
    return `format(${field}, "${format || ''}")`;
}
function binNumberFormatExpr(field, format, formatType, config) {
    if (isCustomFormatType(formatType)) return customFormatExpr(formatType, field, format);
    return formatExpr(field, ((0, _vegaUtil.isString)(format) ? format : undefined) ?? config.numberFormat);
}
function binFormatExpression(startField, endField, format, formatType, config) {
    if (format === undefined && formatType === undefined && config.customFormatTypes && config.numberFormatType) return binFormatExpression(startField, endField, config.numberFormat, config.numberFormatType, config);
    const start = binNumberFormatExpr(startField, format, formatType, config);
    const end = binNumberFormatExpr(endField, format, formatType, config);
    return `${(0, _predicate.fieldValidPredicate)(startField, false)} ? "null" : ${start} + "${BIN_RANGE_DELIMITER}" + ${end}`;
}
function timeFormatExpression({ field, timeUnit, format, formatType, rawTimeFormat, isUTCScale }) {
    if (!timeUnit || format) {
        // If there is no time unit, or if user explicitly specifies format for axis/legend/text.
        if (!timeUnit && formatType) return `${formatType}(${field}, '${format}')`;
        format = (0, _vegaUtil.isString)(format) ? format : rawTimeFormat; // only use provided timeFormat if there is no timeUnit.
        return `${isUTCScale ? 'utc' : 'time'}Format(${field}, '${format}')`;
    } else return (0, _timeunit.formatExpression)(timeUnit, field, isUTCScale);
}

},{"vega-util":"7f6sQ","../bin":"3cpW8","../channeldef":"dsccb","../predicate":"gynPW","../scale":"bdpXN","../timeunit":"eky0T","../type":"cbWGP","../util":"acUGA","../vega.schema":"3mBOT","./mark/encode/valueref":"hE3Wg","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"gynPW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSelectionPredicate", ()=>isSelectionPredicate);
parcelHelpers.export(exports, "isFieldEqualPredicate", ()=>isFieldEqualPredicate);
parcelHelpers.export(exports, "isFieldLTPredicate", ()=>isFieldLTPredicate);
parcelHelpers.export(exports, "isFieldLTEPredicate", ()=>isFieldLTEPredicate);
parcelHelpers.export(exports, "isFieldGTPredicate", ()=>isFieldGTPredicate);
parcelHelpers.export(exports, "isFieldGTEPredicate", ()=>isFieldGTEPredicate);
parcelHelpers.export(exports, "isFieldRangePredicate", ()=>isFieldRangePredicate);
parcelHelpers.export(exports, "isFieldOneOfPredicate", ()=>isFieldOneOfPredicate);
parcelHelpers.export(exports, "isFieldValidPredicate", ()=>isFieldValidPredicate);
parcelHelpers.export(exports, "isFieldPredicate", ()=>isFieldPredicate);
// This method is used by Voyager. Do not change its behavior without changing Voyager.
parcelHelpers.export(exports, "fieldFilterExpression", ()=>fieldFilterExpression);
parcelHelpers.export(exports, "fieldValidPredicate", ()=>fieldValidPredicate);
parcelHelpers.export(exports, "normalizePredicate", ()=>normalizePredicate);
var _vegaUtil = require("vega-util");
var _channeldef = require("./channeldef");
var _expr = require("./expr");
var _timeunit = require("./timeunit");
var _util = require("./util");
var _vegaSchema = require("./vega.schema");
function isSelectionPredicate(predicate) {
    return (0, _util.hasProperty)(predicate, 'param');
}
function isFieldEqualPredicate(predicate) {
    return !!predicate?.field && predicate.equal !== undefined;
}
function isFieldLTPredicate(predicate) {
    return !!predicate?.field && predicate.lt !== undefined;
}
function isFieldLTEPredicate(predicate) {
    return !!predicate?.field && predicate.lte !== undefined;
}
function isFieldGTPredicate(predicate) {
    return !!predicate?.field && predicate.gt !== undefined;
}
function isFieldGTEPredicate(predicate) {
    return !!predicate?.field && predicate.gte !== undefined;
}
function isFieldRangePredicate(predicate) {
    if (predicate?.field) {
        if ((0, _vegaUtil.isArray)(predicate.range) && predicate.range.length === 2) return true;
        else if ((0, _vegaSchema.isSignalRef)(predicate.range)) return true;
    }
    return false;
}
function isFieldOneOfPredicate(predicate) {
    return !!predicate?.field && ((0, _vegaUtil.isArray)(predicate.oneOf) || (0, _vegaUtil.isArray)(predicate.in) // backward compatibility
    );
}
function isFieldValidPredicate(predicate) {
    return !!predicate?.field && predicate.valid !== undefined;
}
function isFieldPredicate(predicate) {
    return isFieldOneOfPredicate(predicate) || isFieldEqualPredicate(predicate) || isFieldRangePredicate(predicate) || isFieldLTPredicate(predicate) || isFieldGTPredicate(predicate) || isFieldLTEPredicate(predicate) || isFieldGTEPredicate(predicate);
}
function predicateValueExpr(v, timeUnit) {
    return (0, _channeldef.valueExpr)(v, {
        timeUnit,
        wrapTime: true
    });
}
function predicateValuesExpr(vals, timeUnit) {
    return vals.map((v)=>predicateValueExpr(v, timeUnit));
}
function fieldFilterExpression(predicate, useInRange = true) {
    const { field } = predicate;
    const normalizedTimeUnit = (0, _timeunit.normalizeTimeUnit)(predicate.timeUnit);
    const { unit, binned } = normalizedTimeUnit || {};
    const rawFieldExpr = (0, _channeldef.vgField)(predicate, {
        expr: 'datum'
    });
    const fieldExpr = unit ? // TODO: We calculate timeUnit on the fly here. Consider if we would like to consolidate this with timeUnit pipeline
    // TODO: support utc
    `time(${!binned ? (0, _timeunit.fieldExpr)(unit, field) : rawFieldExpr})` : rawFieldExpr;
    if (isFieldEqualPredicate(predicate)) return `${fieldExpr}===${predicateValueExpr(predicate.equal, unit)}`;
    else if (isFieldLTPredicate(predicate)) {
        const upper = predicate.lt;
        return `${fieldExpr}<${predicateValueExpr(upper, unit)}`;
    } else if (isFieldGTPredicate(predicate)) {
        const lower = predicate.gt;
        return `${fieldExpr}>${predicateValueExpr(lower, unit)}`;
    } else if (isFieldLTEPredicate(predicate)) {
        const upper = predicate.lte;
        return `${fieldExpr}<=${predicateValueExpr(upper, unit)}`;
    } else if (isFieldGTEPredicate(predicate)) {
        const lower = predicate.gte;
        return `${fieldExpr}>=${predicateValueExpr(lower, unit)}`;
    } else if (isFieldOneOfPredicate(predicate)) return `indexof([${predicateValuesExpr(predicate.oneOf, unit).join(',')}], ${fieldExpr}) !== -1`;
    else if (isFieldValidPredicate(predicate)) return fieldValidPredicate(fieldExpr, predicate.valid);
    else if (isFieldRangePredicate(predicate)) {
        const { range } = (0, _expr.replaceExprRef)(predicate);
        const lower = (0, _vegaSchema.isSignalRef)(range) ? {
            signal: `${range.signal}[0]`
        } : range[0];
        const upper = (0, _vegaSchema.isSignalRef)(range) ? {
            signal: `${range.signal}[1]`
        } : range[1];
        if (lower !== null && upper !== null && useInRange) return 'inrange(' + fieldExpr + ', [' + predicateValueExpr(lower, unit) + ', ' + predicateValueExpr(upper, unit) + '])';
        const exprs = [];
        if (lower !== null) exprs.push(`${fieldExpr} >= ${predicateValueExpr(lower, unit)}`);
        if (upper !== null) exprs.push(`${fieldExpr} <= ${predicateValueExpr(upper, unit)}`);
        return exprs.length > 0 ? exprs.join(' && ') : 'true';
    }
    /* istanbul ignore next: it should never reach here */ throw new Error(`Invalid field predicate: ${(0, _util.stringify)(predicate)}`);
}
function fieldValidPredicate(fieldExpr, valid = true) {
    if (valid) return `isValid(${fieldExpr}) && isFinite(+${fieldExpr})`;
    else return `!isValid(${fieldExpr}) || !isFinite(+${fieldExpr})`;
}
function normalizePredicate(f) {
    if (isFieldPredicate(f) && f.timeUnit) return {
        ...f,
        timeUnit: (0, _timeunit.normalizeTimeUnit)(f.timeUnit)
    };
    return f;
}

},{"vega-util":"7f6sQ","./channeldef":"dsccb","./expr":"ev4sO","./timeunit":"eky0T","./util":"acUGA","./vega.schema":"3mBOT","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"eky0T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LOCAL_SINGLE_TIMEUNIT_INDEX", ()=>LOCAL_SINGLE_TIMEUNIT_INDEX);
parcelHelpers.export(exports, "TIMEUNIT_PARTS", ()=>TIMEUNIT_PARTS);
parcelHelpers.export(exports, "isLocalSingleTimeUnit", ()=>isLocalSingleTimeUnit);
parcelHelpers.export(exports, "UTC_SINGLE_TIMEUNIT_INDEX", ()=>UTC_SINGLE_TIMEUNIT_INDEX);
parcelHelpers.export(exports, "LOCAL_MULTI_TIMEUNIT_INDEX", ()=>LOCAL_MULTI_TIMEUNIT_INDEX);
parcelHelpers.export(exports, "BINNED_TIMEUNIT_INDEX", ()=>BINNED_TIMEUNIT_INDEX);
parcelHelpers.export(exports, "isBinnedTimeUnit", ()=>isBinnedTimeUnit);
parcelHelpers.export(exports, "isBinnedTimeUnitString", ()=>isBinnedTimeUnitString);
parcelHelpers.export(exports, "UTC_MULTI_TIMEUNIT_INDEX", ()=>UTC_MULTI_TIMEUNIT_INDEX);
parcelHelpers.export(exports, "isUTCTimeUnit", ()=>isUTCTimeUnit);
parcelHelpers.export(exports, "getLocalTimeUnitFromUTCTimeUnit", ()=>getLocalTimeUnitFromUTCTimeUnit);
parcelHelpers.export(exports, "VEGALITE_TIMEFORMAT", ()=>VEGALITE_TIMEFORMAT);
parcelHelpers.export(exports, "getTimeUnitParts", ()=>getTimeUnitParts);
parcelHelpers.export(exports, "getSmallestTimeUnitPart", ()=>getSmallestTimeUnitPart);
/** Returns true if fullTimeUnit contains the timeUnit, false otherwise. */ parcelHelpers.export(exports, "containsTimeUnit", ()=>containsTimeUnit);
/**
 * Returns Vega expression for a given timeUnit and fieldRef
 */ parcelHelpers.export(exports, "fieldExpr", ()=>fieldExpr);
parcelHelpers.export(exports, "timeUnitSpecifierExpression", ()=>timeUnitSpecifierExpression);
/**
 * Returns the signal expression used for axis labels for a time unit.
 */ parcelHelpers.export(exports, "formatExpression", ()=>formatExpression);
parcelHelpers.export(exports, "normalizeTimeUnit", ()=>normalizeTimeUnit);
parcelHelpers.export(exports, "timeUnitToString", ()=>timeUnitToString);
parcelHelpers.export(exports, "durationExpr", ()=>durationExpr);
parcelHelpers.export(exports, "isDatePart", ()=>isDatePart);
parcelHelpers.export(exports, "getDateTimePartAndStep", ()=>getDateTimePartAndStep);
var _vegaUtil = require("vega-util");
var _datetime = require("./datetime");
var _util = require("./util");
var _vega = require("vega");
const LOCAL_SINGLE_TIMEUNIT_INDEX = {
    year: 1,
    quarter: 1,
    month: 1,
    week: 1,
    day: 1,
    dayofyear: 1,
    date: 1,
    hours: 1,
    minutes: 1,
    seconds: 1,
    milliseconds: 1
};
const TIMEUNIT_PARTS = (0, _util.keys)(LOCAL_SINGLE_TIMEUNIT_INDEX);
function isLocalSingleTimeUnit(timeUnit) {
    return (0, _vega.hasOwnProperty)(LOCAL_SINGLE_TIMEUNIT_INDEX, timeUnit);
}
const UTC_SINGLE_TIMEUNIT_INDEX = {
    utcyear: 1,
    utcquarter: 1,
    utcmonth: 1,
    utcweek: 1,
    utcday: 1,
    utcdayofyear: 1,
    utcdate: 1,
    utchours: 1,
    utcminutes: 1,
    utcseconds: 1,
    utcmilliseconds: 1
};
const LOCAL_MULTI_TIMEUNIT_INDEX = {
    yearquarter: 1,
    yearquartermonth: 1,
    yearmonth: 1,
    yearmonthdate: 1,
    yearmonthdatehours: 1,
    yearmonthdatehoursminutes: 1,
    yearmonthdatehoursminutesseconds: 1,
    yearweek: 1,
    yearweekday: 1,
    yearweekdayhours: 1,
    yearweekdayhoursminutes: 1,
    yearweekdayhoursminutesseconds: 1,
    yeardayofyear: 1,
    quartermonth: 1,
    monthdate: 1,
    monthdatehours: 1,
    monthdatehoursminutes: 1,
    monthdatehoursminutesseconds: 1,
    weekday: 1,
    weekdayhours: 1,
    weekdayhoursminutes: 1,
    weekdayhoursminutesseconds: 1,
    dayhours: 1,
    dayhoursminutes: 1,
    dayhoursminutesseconds: 1,
    hoursminutes: 1,
    hoursminutesseconds: 1,
    minutesseconds: 1,
    secondsmilliseconds: 1
};
const BINNED_LOCAL_TIMEUNIT_INDEX = {
    binnedyear: 1,
    binnedyearquarter: 1,
    binnedyearquartermonth: 1,
    binnedyearmonth: 1,
    binnedyearmonthdate: 1,
    binnedyearmonthdatehours: 1,
    binnedyearmonthdatehoursminutes: 1,
    binnedyearmonthdatehoursminutesseconds: 1,
    binnedyearweek: 1,
    binnedyearweekday: 1,
    binnedyearweekdayhours: 1,
    binnedyearweekdayhoursminutes: 1,
    binnedyearweekdayhoursminutesseconds: 1,
    binnedyeardayofyear: 1
};
const BINNED_UTC_TIMEUNIT_INDEX = {
    binnedutcyear: 1,
    binnedutcyearquarter: 1,
    binnedutcyearquartermonth: 1,
    binnedutcyearmonth: 1,
    binnedutcyearmonthdate: 1,
    binnedutcyearmonthdatehours: 1,
    binnedutcyearmonthdatehoursminutes: 1,
    binnedutcyearmonthdatehoursminutesseconds: 1,
    binnedutcyearweek: 1,
    binnedutcyearweekday: 1,
    binnedutcyearweekdayhours: 1,
    binnedutcyearweekdayhoursminutes: 1,
    binnedutcyearweekdayhoursminutesseconds: 1,
    binnedutcyeardayofyear: 1
};
const BINNED_TIMEUNIT_INDEX = {
    ...BINNED_LOCAL_TIMEUNIT_INDEX,
    ...BINNED_UTC_TIMEUNIT_INDEX
};
function isBinnedTimeUnit(timeUnit) {
    if ((0, _vegaUtil.isObject)(timeUnit)) return timeUnit.binned;
    return isBinnedTimeUnitString(timeUnit);
}
function isBinnedTimeUnitString(timeUnit) {
    return timeUnit && timeUnit.startsWith('binned');
}
const UTC_MULTI_TIMEUNIT_INDEX = {
    utcyearquarter: 1,
    utcyearquartermonth: 1,
    utcyearmonth: 1,
    utcyearmonthdate: 1,
    utcyearmonthdatehours: 1,
    utcyearmonthdatehoursminutes: 1,
    utcyearmonthdatehoursminutesseconds: 1,
    utcyearweek: 1,
    utcyearweekday: 1,
    utcyearweekdayhours: 1,
    utcyearweekdayhoursminutes: 1,
    utcyearweekdayhoursminutesseconds: 1,
    utcyeardayofyear: 1,
    utcquartermonth: 1,
    utcmonthdate: 1,
    utcmonthdatehours: 1,
    utcmonthdatehoursminutes: 1,
    utcmonthdatehoursminutesseconds: 1,
    utcweekday: 1,
    utcweekdayhours: 1,
    utcweekdayhoursminutes: 1,
    utcweekdayhoursminutesseconds: 1,
    utcdayhours: 1,
    utcdayhoursminutes: 1,
    utcdayhoursminutesseconds: 1,
    utchoursminutes: 1,
    utchoursminutesseconds: 1,
    utcminutesseconds: 1,
    utcsecondsmilliseconds: 1
};
function isUTCTimeUnit(t) {
    return t.startsWith('utc');
}
function getLocalTimeUnitFromUTCTimeUnit(t) {
    return t.substring(3);
}
const VEGALITE_TIMEFORMAT = {
    'year-month': '%b %Y ',
    'year-month-date': '%b %d, %Y '
};
function getTimeUnitParts(timeUnit) {
    return TIMEUNIT_PARTS.filter((part)=>containsTimeUnit(timeUnit, part));
}
function getSmallestTimeUnitPart(timeUnit) {
    const parts = getTimeUnitParts(timeUnit);
    return parts[parts.length - 1];
}
function containsTimeUnit(fullTimeUnit, timeUnit) {
    const index = fullTimeUnit.indexOf(timeUnit);
    if (index < 0) return false;
    // exclude milliseconds
    if (index > 0 && timeUnit === 'seconds' && fullTimeUnit.charAt(index - 1) === 'i') return false;
    // exclude dayofyear
    if (fullTimeUnit.length > index + 3 && timeUnit === 'day' && fullTimeUnit.charAt(index + 3) === 'o') return false;
    if (index > 0 && timeUnit === 'year' && fullTimeUnit.charAt(index - 1) === 'f') return false;
    return true;
}
function fieldExpr(fullTimeUnit, field, { end } = {
    end: false
}) {
    const fieldRef = (0, _util.accessPathWithDatum)(field);
    const utc = isUTCTimeUnit(fullTimeUnit) ? 'utc' : '';
    function func(timeUnit) {
        if (timeUnit === 'quarter') // quarter starting at 0 (0,3,6,9).
        return `(${utc}quarter(${fieldRef})-1)`;
        else return `${utc}${timeUnit}(${fieldRef})`;
    }
    let lastTimeUnit;
    const dateExpr = {};
    for (const part of TIMEUNIT_PARTS)if (containsTimeUnit(fullTimeUnit, part)) {
        dateExpr[part] = func(part);
        lastTimeUnit = part;
    }
    if (end) dateExpr[lastTimeUnit] += '+1';
    return (0, _datetime.dateTimeExprToExpr)(dateExpr);
}
function timeUnitSpecifierExpression(timeUnit) {
    if (!timeUnit) return undefined;
    const timeUnitParts = getTimeUnitParts(timeUnit);
    return `timeUnitSpecifier(${(0, _util.stringify)(timeUnitParts)}, ${(0, _util.stringify)(VEGALITE_TIMEFORMAT)})`;
}
function formatExpression(timeUnit, field, isUTCScale) {
    if (!timeUnit) return undefined;
    const expr = timeUnitSpecifierExpression(timeUnit);
    // We only use utcFormat for utc scale
    // For utc time units, the data is already converted as a part of timeUnit transform.
    // Thus, utc time units should use timeFormat to avoid shifting the time twice.
    const utc = isUTCScale || isUTCTimeUnit(timeUnit);
    return `${utc ? 'utc' : 'time'}Format(${field}, ${expr})`;
}
function normalizeTimeUnit(timeUnit) {
    if (!timeUnit) return undefined;
    let params;
    if ((0, _vegaUtil.isString)(timeUnit)) {
        if (isBinnedTimeUnitString(timeUnit)) params = {
            unit: timeUnit.substring(6),
            binned: true
        };
        else params = {
            unit: timeUnit
        };
    } else if ((0, _vegaUtil.isObject)(timeUnit)) params = {
        ...timeUnit,
        ...timeUnit.unit ? {
            unit: timeUnit.unit
        } : {}
    };
    if (isUTCTimeUnit(params.unit)) {
        params.utc = true;
        params.unit = getLocalTimeUnitFromUTCTimeUnit(params.unit);
    }
    return params;
}
function timeUnitToString(tu) {
    const { utc, ...rest } = normalizeTimeUnit(tu);
    if (rest.unit) return (utc ? 'utc' : '') + (0, _util.keys)(rest).map((p)=>(0, _util.varName)(`${p === 'unit' ? '' : `_${p}_`}${rest[p]}`)).join('');
    else // when maxbins is specified instead of units
    return (utc ? 'utc' : '') + 'timeunit' + (0, _util.keys)(rest).map((p)=>(0, _util.varName)(`_${p}_${rest[p]}`)).join('');
}
function durationExpr(timeUnit, wrap = (x)=>x) {
    const normalizedTimeUnit = normalizeTimeUnit(timeUnit);
    const smallestUnitPart = getSmallestTimeUnitPart(normalizedTimeUnit.unit);
    if (smallestUnitPart && smallestUnitPart !== 'day') {
        const startDate = {
            year: 2001,
            month: 1,
            date: 1,
            hours: 0,
            minutes: 0,
            seconds: 0,
            milliseconds: 0
        };
        const { step, part } = getDateTimePartAndStep(smallestUnitPart, normalizedTimeUnit.step);
        const endDate = {
            ...startDate,
            [part]: +startDate[part] + step
        };
        // Calculate timestamp duration for the smallest unit listed
        return `${wrap((0, _datetime.dateTimeToExpr)(endDate))} - ${wrap((0, _datetime.dateTimeToExpr)(startDate))}`;
    }
    return undefined;
}
const DATE_PARTS = {
    year: 1,
    month: 1,
    date: 1,
    hours: 1,
    minutes: 1,
    seconds: 1,
    milliseconds: 1
};
function isDatePart(timeUnit) {
    return (0, _vega.hasOwnProperty)(DATE_PARTS, timeUnit);
}
function getDateTimePartAndStep(timeUnit, step = 1) {
    if (isDatePart(timeUnit)) return {
        part: timeUnit,
        step
    };
    switch(timeUnit){
        case 'day':
        case 'dayofyear':
            return {
                part: 'date',
                step
            };
        case 'quarter':
            return {
                part: 'month',
                step: step * 3
            };
        case 'week':
            return {
                part: 'date',
                step: step * 7
            };
    }
}

},{"vega-util":"7f6sQ","./datetime":"gp5cf","./util":"acUGA","vega":"2Jj1D","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"gp5cf":[function(require,module,exports,__globalThis) {
// DateTime definition object
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDateTime", ()=>isDateTime);
parcelHelpers.export(exports, "MONTHS", ()=>MONTHS);
parcelHelpers.export(exports, "SHORT_MONTHS", ()=>SHORT_MONTHS);
parcelHelpers.export(exports, "DAYS", ()=>DAYS);
parcelHelpers.export(exports, "SHORT_DAYS", ()=>SHORT_DAYS);
/**
 * Return Vega expression for a date time.
 *
 * @param d the date time.
 * @returns the Vega expression.
 */ parcelHelpers.export(exports, "dateTimeToExpr", ()=>dateTimeToExpr);
/**
 * Return Vega expression for a date time expression.
 *
 * @param d the internal date time object with expression.
 * @returns the Vega expression.
 */ parcelHelpers.export(exports, "dateTimeExprToExpr", ()=>dateTimeExprToExpr);
/**
 * @param d the date time.
 * @returns the timestamp.
 */ parcelHelpers.export(exports, "dateTimeToTimestamp", ()=>dateTimeToTimestamp);
var _vegaUtil = require("vega-util");
var _log = require("./log");
var _timeunit = require("./timeunit");
var _util = require("./util");
function isDateTime(o) {
    if (o && (0, _vegaUtil.isObject)(o)) for (const part of (0, _timeunit.TIMEUNIT_PARTS)){
        if ((0, _util.hasProperty)(o, part)) return true;
    }
    return false;
}
const MONTHS = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december'
];
const SHORT_MONTHS = MONTHS.map((m)=>m.substr(0, 3));
const DAYS = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday'
];
const SHORT_DAYS = DAYS.map((d)=>d.substr(0, 3));
function normalizeQuarter(q) {
    if ((0, _util.isNumeric)(q)) q = +q;
    if ((0, _vegaUtil.isNumber)(q)) {
        if (q > 4) _log.warn(_log.message.invalidTimeUnit('quarter', q));
        // We accept 1-based quarter, so need to readjust to 0-based quarter
        return q - 1;
    } else // Invalid quarter
    throw new Error(_log.message.invalidTimeUnit('quarter', q));
}
function normalizeMonth(m) {
    if ((0, _util.isNumeric)(m)) m = +m;
    if ((0, _vegaUtil.isNumber)(m)) // We accept 1-based month, so need to readjust to 0-based month
    return m - 1;
    else {
        const lowerM = m.toLowerCase();
        const monthIndex = MONTHS.indexOf(lowerM);
        if (monthIndex !== -1) return monthIndex; // 0 for january, ...
        const shortM = lowerM.substr(0, 3);
        const shortMonthIndex = SHORT_MONTHS.indexOf(shortM);
        if (shortMonthIndex !== -1) return shortMonthIndex;
        // Invalid month
        throw new Error(_log.message.invalidTimeUnit('month', m));
    }
}
function normalizeDay(d) {
    if ((0, _util.isNumeric)(d)) d = +d;
    if ((0, _vegaUtil.isNumber)(d)) // mod so that this can be both 0-based where 0 = sunday
    // and 1-based where 7=sunday
    return d % 7;
    else {
        const lowerD = d.toLowerCase();
        const dayIndex = DAYS.indexOf(lowerD);
        if (dayIndex !== -1) return dayIndex; // 0 for january, ...
        const shortD = lowerD.substr(0, 3);
        const shortDayIndex = SHORT_DAYS.indexOf(shortD);
        if (shortDayIndex !== -1) return shortDayIndex;
        // Invalid day
        throw new Error(_log.message.invalidTimeUnit('day', d));
    }
}
/**
 * @param d the date.
 * @param normalize whether to normalize quarter, month, day. This should probably be true if d is a DateTime.
 * @returns array of date time parts [year, month, day, hours, minutes, seconds, milliseconds]
 */ function dateTimeParts(d, normalize) {
    const parts = [];
    if (normalize && d.day !== undefined) {
        if ((0, _util.keys)(d).length > 1) {
            _log.warn(_log.message.droppedDay(d));
            d = (0, _util.duplicate)(d);
            delete d.day;
        }
    }
    if (d.year !== undefined) parts.push(d.year);
    else // Just like Vega's timeunit transform, set default year to 2012, so domain conversion will be compatible with Vega
    // Note: 2012 is a leap year (and so the date February 29 is respected) that begins on a Sunday (and so days of the week will order properly at the beginning of the year).
    parts.push(2012);
    if (d.month !== undefined) {
        const month = normalize ? normalizeMonth(d.month) : d.month;
        parts.push(month);
    } else if (d.quarter !== undefined) {
        const quarter = normalize ? normalizeQuarter(d.quarter) : d.quarter;
        parts.push((0, _vegaUtil.isNumber)(quarter) ? quarter * 3 : `${quarter}*3`);
    } else parts.push(0); // months start at zero in JS
    if (d.date !== undefined) parts.push(d.date);
    else if (d.day !== undefined) {
        // HACK: Day only works as a standalone unit
        // This is only correct because we always set year to 2006 for day
        const day = normalize ? normalizeDay(d.day) : d.day;
        parts.push((0, _vegaUtil.isNumber)(day) ? day + 1 : `${day}+1`);
    } else parts.push(1); // Date starts at 1 in JS
    // Note: can't use TimeUnit enum here as importing it will create
    // circular dependency problem!
    for (const timeUnit of [
        'hours',
        'minutes',
        'seconds',
        'milliseconds'
    ]){
        const unit = d[timeUnit];
        parts.push(typeof unit === 'undefined' ? 0 : unit);
    }
    return parts;
}
function dateTimeToExpr(d) {
    const parts = dateTimeParts(d, true);
    const string = parts.join(', ');
    if (d.utc) return `utc(${string})`;
    else return `datetime(${string})`;
}
function dateTimeExprToExpr(d) {
    const parts = dateTimeParts(d, false);
    const string = parts.join(', ');
    if (d.utc) return `utc(${string})`;
    else return `datetime(${string})`;
}
function dateTimeToTimestamp(d) {
    const parts = dateTimeParts(d, true);
    if (d.utc) return +new Date(Date.UTC(...parts));
    else return +new Date(...parts);
}

},{"vega-util":"7f6sQ","./log":"loqTw","./timeunit":"eky0T","./util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"loqTw":[function(require,module,exports,__globalThis) {
/**
 * Vega-Lite's singleton logger utility.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "message", ()=>_message);
/**
 * Logger tool for checking if the code throws correct warning.
 */ parcelHelpers.export(exports, "LocalLogger", ()=>LocalLogger);
parcelHelpers.export(exports, "wrap", ()=>wrap);
/**
 * Set the singleton logger to be a custom logger.
 */ parcelHelpers.export(exports, "set", ()=>set);
/**
 * Reset the main logger to use the default Vega Logger.
 */ parcelHelpers.export(exports, "reset", ()=>reset);
parcelHelpers.export(exports, "error", ()=>error);
parcelHelpers.export(exports, "warn", ()=>warn);
parcelHelpers.export(exports, "info", ()=>info);
parcelHelpers.export(exports, "debug", ()=>debug);
var _vegaUtil = require("vega-util");
var _message = require("./message");
var __classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var __classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _LocalLogger_level;
/**
 * Main (default) Vega Logger instance for Vega-Lite.
 */ const main = (0, _vegaUtil.logger)((0, _vegaUtil.Warn));
let current = main;
class LocalLogger {
    constructor(){
        this.warns = [];
        this.infos = [];
        this.debugs = [];
        _LocalLogger_level.set(this, (0, _vegaUtil.Warn));
    }
    level(_) {
        if (_) {
            __classPrivateFieldSet(this, _LocalLogger_level, _, "f");
            return this;
        }
        return __classPrivateFieldGet(this, _LocalLogger_level, "f");
    }
    warn(...args) {
        if (__classPrivateFieldGet(this, _LocalLogger_level, "f") >= (0, _vegaUtil.Warn)) this.warns.push(...args);
        return this;
    }
    info(...args) {
        if (__classPrivateFieldGet(this, _LocalLogger_level, "f") >= (0, _vegaUtil.Info)) this.infos.push(...args);
        return this;
    }
    debug(...args) {
        if (__classPrivateFieldGet(this, _LocalLogger_level, "f") >= (0, _vegaUtil.Debug)) this.debugs.push(...args);
        return this;
    }
    error(...args) {
        if (__classPrivateFieldGet(this, _LocalLogger_level, "f") >= (0, _vegaUtil.Error)) throw Error(...args);
        return this;
    }
}
_LocalLogger_level = new WeakMap();
function wrap(f) {
    return ()=>{
        current = new LocalLogger();
        f(current);
        reset();
    };
}
function set(newLogger) {
    current = newLogger;
    return current;
}
function reset() {
    current = main;
    return current;
}
function error(...args) {
    current.error(...args);
}
function warn(...args) {
    current.warn(...args);
}
function info(...args) {
    current.info(...args);
}
function debug(...args) {
    current.debug(...args);
}

},{"vega-util":"7f6sQ","./message":"fb2MK","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"fb2MK":[function(require,module,exports,__globalThis) {
/**
 * Collection of all Vega-Lite Error Messages
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invalidSpec", ()=>invalidSpec);
parcelHelpers.export(exports, "FIT_NON_SINGLE", ()=>FIT_NON_SINGLE);
parcelHelpers.export(exports, "containerSizeNonSingle", ()=>containerSizeNonSingle);
parcelHelpers.export(exports, "containerSizeNotCompatibleWithAutosize", ()=>containerSizeNotCompatibleWithAutosize);
parcelHelpers.export(exports, "droppingFit", ()=>droppingFit);
// VIEW SIZE
parcelHelpers.export(exports, "unknownField", ()=>unknownField);
// SELECTION
parcelHelpers.export(exports, "cannotProjectOnChannelWithoutField", ()=>cannotProjectOnChannelWithoutField);
parcelHelpers.export(exports, "cannotProjectAggregate", ()=>cannotProjectAggregate);
parcelHelpers.export(exports, "nearestNotSupportForContinuous", ()=>nearestNotSupportForContinuous);
parcelHelpers.export(exports, "selectionNotSupported", ()=>selectionNotSupported);
parcelHelpers.export(exports, "selectionNotFound", ()=>selectionNotFound);
parcelHelpers.export(exports, "SCALE_BINDINGS_CONTINUOUS", ()=>SCALE_BINDINGS_CONTINUOUS);
parcelHelpers.export(exports, "SEQUENTIAL_SCALE_DEPRECATED", ()=>SEQUENTIAL_SCALE_DEPRECATED);
parcelHelpers.export(exports, "LEGEND_BINDINGS_MUST_HAVE_PROJECTION", ()=>LEGEND_BINDINGS_MUST_HAVE_PROJECTION);
parcelHelpers.export(exports, "cannotLookupVariableParameter", ()=>cannotLookupVariableParameter);
parcelHelpers.export(exports, "noSameUnitLookup", ()=>noSameUnitLookup);
parcelHelpers.export(exports, "NEEDS_SAME_SELECTION", ()=>NEEDS_SAME_SELECTION);
parcelHelpers.export(exports, "INTERVAL_INITIALIZED_WITH_POS", ()=>INTERVAL_INITIALIZED_WITH_POS);
// REPEAT
parcelHelpers.export(exports, "noSuchRepeatedValue", ()=>noSuchRepeatedValue);
parcelHelpers.export(exports, "columnsNotSupportByRowCol", ()=>columnsNotSupportByRowCol);
parcelHelpers.export(exports, "MULTIPLE_TIMER_ANIMATION_SELECTION", ()=>MULTIPLE_TIMER_ANIMATION_SELECTION);
parcelHelpers.export(exports, "MULTI_VIEW_ANIMATION_UNSUPPORTED", ()=>MULTI_VIEW_ANIMATION_UNSUPPORTED);
parcelHelpers.export(exports, "selectionAsScaleDomainWithoutField", ()=>selectionAsScaleDomainWithoutField);
parcelHelpers.export(exports, "selectionAsScaleDomainWrongEncodings", ()=>selectionAsScaleDomainWrongEncodings);
parcelHelpers.export(exports, "CONCAT_CANNOT_SHARE_AXIS", ()=>CONCAT_CANNOT_SHARE_AXIS);
// DATA
parcelHelpers.export(exports, "unrecognizedParse", ()=>unrecognizedParse);
parcelHelpers.export(exports, "differentParse", ()=>differentParse);
parcelHelpers.export(exports, "ADD_SAME_CHILD_TWICE", ()=>ADD_SAME_CHILD_TWICE);
// TRANSFORMS
parcelHelpers.export(exports, "invalidTransformIgnored", ()=>invalidTransformIgnored);
parcelHelpers.export(exports, "NO_FIELDS_NEEDS_AS", ()=>NO_FIELDS_NEEDS_AS);
// ENCODING & FACET
parcelHelpers.export(exports, "customFormatTypeNotAllowed", ()=>customFormatTypeNotAllowed);
parcelHelpers.export(exports, "projectionOverridden", ()=>projectionOverridden);
parcelHelpers.export(exports, "REPLACE_ANGLE_WITH_THETA", ()=>REPLACE_ANGLE_WITH_THETA);
parcelHelpers.export(exports, "offsetNestedInsideContinuousPositionScaleDropped", ()=>offsetNestedInsideContinuousPositionScaleDropped);
parcelHelpers.export(exports, "primitiveChannelDef", ()=>primitiveChannelDef);
parcelHelpers.export(exports, "invalidFieldType", ()=>invalidFieldType);
parcelHelpers.export(exports, "invalidFieldTypeForCountAggregate", ()=>invalidFieldTypeForCountAggregate);
parcelHelpers.export(exports, "invalidAggregate", ()=>invalidAggregate);
parcelHelpers.export(exports, "missingFieldType", ()=>missingFieldType);
parcelHelpers.export(exports, "droppingColor", ()=>droppingColor);
parcelHelpers.export(exports, "relativeBandSizeNotSupported", ()=>relativeBandSizeNotSupported);
parcelHelpers.export(exports, "emptyFieldDef", ()=>emptyFieldDef);
parcelHelpers.export(exports, "LINE_WITH_VARYING_SIZE", ()=>LINE_WITH_VARYING_SIZE);
parcelHelpers.export(exports, "incompatibleChannel", ()=>incompatibleChannel);
parcelHelpers.export(exports, "offsetEncodingScaleIgnored", ()=>offsetEncodingScaleIgnored);
parcelHelpers.export(exports, "invalidEncodingChannel", ()=>invalidEncodingChannel);
parcelHelpers.export(exports, "channelShouldBeDiscrete", ()=>channelShouldBeDiscrete);
parcelHelpers.export(exports, "channelShouldBeDiscreteOrDiscretizing", ()=>channelShouldBeDiscreteOrDiscretizing);
parcelHelpers.export(exports, "facetChannelDropped", ()=>facetChannelDropped);
parcelHelpers.export(exports, "discreteChannelCannotEncode", ()=>discreteChannelCannotEncode);
// MARK
parcelHelpers.export(exports, "rangeMarkAlignmentCannotBeExpression", ()=>rangeMarkAlignmentCannotBeExpression);
parcelHelpers.export(exports, "lineWithRange", ()=>lineWithRange);
parcelHelpers.export(exports, "orientOverridden", ()=>orientOverridden);
parcelHelpers.export(exports, "CANNOT_UNION_CUSTOM_DOMAIN_WITH_FIELD_DOMAIN", ()=>CANNOT_UNION_CUSTOM_DOMAIN_WITH_FIELD_DOMAIN);
parcelHelpers.export(exports, "cannotUseScalePropertyWithNonColor", ()=>cannotUseScalePropertyWithNonColor);
parcelHelpers.export(exports, "cannotUseRelativeBandSizeWithNonBandScale", ()=>cannotUseRelativeBandSizeWithNonBandScale);
parcelHelpers.export(exports, "unaggregateDomainHasNoEffectForRawField", ()=>unaggregateDomainHasNoEffectForRawField);
parcelHelpers.export(exports, "unaggregateDomainWithNonSharedDomainOp", ()=>unaggregateDomainWithNonSharedDomainOp);
parcelHelpers.export(exports, "unaggregatedDomainWithLogScale", ()=>unaggregatedDomainWithLogScale);
parcelHelpers.export(exports, "cannotApplySizeToNonOrientedMark", ()=>cannotApplySizeToNonOrientedMark);
parcelHelpers.export(exports, "scaleTypeNotWorkWithChannel", ()=>scaleTypeNotWorkWithChannel);
parcelHelpers.export(exports, "scaleTypeNotWorkWithFieldDef", ()=>scaleTypeNotWorkWithFieldDef);
parcelHelpers.export(exports, "scalePropertyNotWorkWithScaleType", ()=>scalePropertyNotWorkWithScaleType);
parcelHelpers.export(exports, "scaleTypeNotWorkWithMark", ()=>scaleTypeNotWorkWithMark);
parcelHelpers.export(exports, "stepDropped", ()=>stepDropped);
parcelHelpers.export(exports, "mergeConflictingProperty", ()=>mergeConflictingProperty);
parcelHelpers.export(exports, "mergeConflictingDomainProperty", ()=>mergeConflictingDomainProperty);
parcelHelpers.export(exports, "independentScaleMeansIndependentGuide", ()=>independentScaleMeansIndependentGuide);
parcelHelpers.export(exports, "domainSortDropped", ()=>domainSortDropped);
parcelHelpers.export(exports, "MORE_THAN_ONE_SORT", ()=>MORE_THAN_ONE_SORT);
parcelHelpers.export(exports, "FACETED_INDEPENDENT_DIFFERENT_SOURCES", ()=>FACETED_INDEPENDENT_DIFFERENT_SOURCES);
parcelHelpers.export(exports, "FACETED_INDEPENDENT_SAME_FIELDS_DIFFERENT_SOURCES", ()=>FACETED_INDEPENDENT_SAME_FIELDS_DIFFERENT_SOURCES);
parcelHelpers.export(exports, "FACETED_INDEPENDENT_SAME_SOURCE", ()=>FACETED_INDEPENDENT_SAME_SOURCE);
parcelHelpers.export(exports, "INVALID_CHANNEL_FOR_AXIS", ()=>INVALID_CHANNEL_FOR_AXIS);
// STACK
parcelHelpers.export(exports, "cannotStackRangedMark", ()=>cannotStackRangedMark);
parcelHelpers.export(exports, "stackNonLinearScale", ()=>stackNonLinearScale);
parcelHelpers.export(exports, "stackNonSummativeAggregate", ()=>stackNonSummativeAggregate);
// TIMEUNIT
parcelHelpers.export(exports, "invalidTimeUnit", ()=>invalidTimeUnit);
parcelHelpers.export(exports, "droppedDay", ()=>droppedDay);
parcelHelpers.export(exports, "errorBarCenterAndExtentAreNotNeeded", ()=>errorBarCenterAndExtentAreNotNeeded);
parcelHelpers.export(exports, "errorBarCenterIsUsedWithWrongExtent", ()=>errorBarCenterIsUsedWithWrongExtent);
parcelHelpers.export(exports, "errorBarContinuousAxisHasCustomizedAggregate", ()=>errorBarContinuousAxisHasCustomizedAggregate);
parcelHelpers.export(exports, "errorBand1DNotSupport", ()=>errorBand1DNotSupport);
// CHANNEL
parcelHelpers.export(exports, "channelRequiredForBinned", ()=>channelRequiredForBinned);
parcelHelpers.export(exports, "channelShouldNotBeUsedForBinned", ()=>channelShouldNotBeUsedForBinned);
parcelHelpers.export(exports, "domainRequiredForThresholdScale", ()=>domainRequiredForThresholdScale);
var _vega = require("vega");
var _channel = require("../channel");
var _util = require("../util");
function invalidSpec(spec) {
    return `Invalid specification ${(0, _util.stringify)(spec)}. Make sure the specification includes at least one of the following properties: "mark", "layer", "facet", "hconcat", "vconcat", "concat", or "repeat".`;
}
const FIT_NON_SINGLE = 'Autosize "fit" only works for single views and layered views.';
function containerSizeNonSingle(name) {
    const uName = name == 'width' ? 'Width' : 'Height';
    return `${uName} "container" only works for single views and layered views.`;
}
function containerSizeNotCompatibleWithAutosize(name) {
    const uName = name == 'width' ? 'Width' : 'Height';
    const fitDirection = name == 'width' ? 'x' : 'y';
    return `${uName} "container" only works well with autosize "fit" or "fit-${fitDirection}".`;
}
function droppingFit(channel) {
    return channel ? `Dropping "fit-${channel}" because spec has discrete ${(0, _channel.getSizeChannel)(channel)}.` : `Dropping "fit" because spec has discrete size.`;
}
function unknownField(channel) {
    return `Unknown field for ${channel}. Cannot calculate view size.`;
}
function cannotProjectOnChannelWithoutField(channel) {
    return `Cannot project a selection on encoding channel "${channel}", which has no field.`;
}
function cannotProjectAggregate(channel, aggregate) {
    return `Cannot project a selection on encoding channel "${channel}" as it uses an aggregate function ("${aggregate}").`;
}
function nearestNotSupportForContinuous(mark) {
    return `The "nearest" transform is not supported for ${mark} marks.`;
}
function selectionNotSupported(mark) {
    return `Selection not supported for ${mark} yet.`;
}
function selectionNotFound(name) {
    return `Cannot find a selection named "${name}".`;
}
const SCALE_BINDINGS_CONTINUOUS = 'Scale bindings are currently only supported for scales with unbinned, continuous domains.';
const SEQUENTIAL_SCALE_DEPRECATED = 'Sequntial scales are deprecated. The available quantitative scale type values are linear, log, pow, sqrt, symlog, time and utc';
const LEGEND_BINDINGS_MUST_HAVE_PROJECTION = 'Legend bindings are only supported for selections over an individual field or encoding channel.';
function cannotLookupVariableParameter(name) {
    return `Lookups can only be performed on selection parameters. "${name}" is a variable parameter.`;
}
function noSameUnitLookup(name) {
    return `Cannot define and lookup the "${name}" selection in the same view. ` + `Try moving the lookup into a second, layered view?`;
}
const NEEDS_SAME_SELECTION = 'The same selection must be used to override scale domains in a layered view.';
const INTERVAL_INITIALIZED_WITH_POS = 'Interval selections should be initialized using "x", "y", "longitude", or "latitude" keys.';
function noSuchRepeatedValue(field) {
    return `Unknown repeated value "${field}".`;
}
function columnsNotSupportByRowCol(type) {
    return `The "columns" property cannot be used when "${type}" has nested row/column.`;
}
const MULTIPLE_TIMER_ANIMATION_SELECTION = 'Multiple timer selections in one unit spec are not supported. Ignoring all but the first.';
const MULTI_VIEW_ANIMATION_UNSUPPORTED = 'Animation involving facet, layer, or concat is currently unsupported.';
function selectionAsScaleDomainWithoutField(field) {
    return 'A "field" or "encoding" must be specified when using a selection as a scale domain. ' + `Using "field": ${(0, _vega.stringValue)(field)}.`;
}
function selectionAsScaleDomainWrongEncodings(encodings, encoding, extent, field) {
    return (!encodings.length ? 'No ' : 'Multiple ') + `matching ${(0, _vega.stringValue)(encoding)} encoding found for selection ${(0, _vega.stringValue)(extent.param)}. ` + `Using "field": ${(0, _vega.stringValue)(field)}.`;
}
const CONCAT_CANNOT_SHARE_AXIS = 'Axes cannot be shared in concatenated or repeated views yet (https://github.com/vega/vega-lite/issues/2415).';
function unrecognizedParse(p) {
    return `Unrecognized parse "${p}".`;
}
function differentParse(field, local, ancestor) {
    return `An ancestor parsed field "${field}" as ${ancestor} but a child wants to parse the field as ${local}.`;
}
const ADD_SAME_CHILD_TWICE = 'Attempt to add the same child twice.';
function invalidTransformIgnored(transform) {
    return `Ignoring an invalid transform: ${(0, _util.stringify)(transform)}.`;
}
const NO_FIELDS_NEEDS_AS = 'If "from.fields" is not specified, "as" has to be a string that specifies the key to be used for the data from the secondary source.';
function customFormatTypeNotAllowed(channel) {
    return `Config.customFormatTypes is not true, thus custom format type and format for channel ${channel} are dropped.`;
}
function projectionOverridden(opt) {
    const { parentProjection, projection } = opt;
    return `Layer's shared projection ${(0, _util.stringify)(parentProjection)} is overridden by a child projection ${(0, _util.stringify)(projection)}.`;
}
const REPLACE_ANGLE_WITH_THETA = 'Arc marks uses theta channel rather than angle, replacing angle with theta.';
function offsetNestedInsideContinuousPositionScaleDropped(mainChannel) {
    return `${mainChannel}Offset dropped because ${mainChannel} is continuous`;
}
function primitiveChannelDef(channel, type, value) {
    return `Channel ${channel} is a ${type}. Converted to {value: ${(0, _util.stringify)(value)}}.`;
}
function invalidFieldType(type) {
    return `Invalid field type "${type}".`;
}
function invalidFieldTypeForCountAggregate(type, aggregate) {
    return `Invalid field type "${type}" for aggregate: "${aggregate}", using "quantitative" instead.`;
}
function invalidAggregate(aggregate) {
    return `Invalid aggregation operator "${aggregate}".`;
}
function missingFieldType(channel, newType) {
    return `Missing type for channel "${channel}", using "${newType}" instead.`;
}
function droppingColor(type, opt) {
    const { fill, stroke } = opt;
    return `Dropping color ${type} as the plot also has ${fill && stroke ? 'fill and stroke' : fill ? 'fill' : 'stroke'}.`;
}
function relativeBandSizeNotSupported(sizeChannel) {
    return `Position range does not support relative band size for ${sizeChannel}.`;
}
function emptyFieldDef(fieldDef, channel) {
    return `Dropping ${(0, _util.stringify)(fieldDef)} from channel "${channel}" since it does not contain any data field, datum, value, or signal.`;
}
const LINE_WITH_VARYING_SIZE = 'Line marks cannot encode size with a non-groupby field. You may want to use trail marks instead.';
function incompatibleChannel(channel, markOrFacet, when) {
    return `${channel} dropped as it is incompatible with "${markOrFacet}"${when ? ` when ${when}` : ''}.`;
}
function offsetEncodingScaleIgnored(channel) {
    return `${channel} encoding has no scale, so specified scale is ignored.`;
}
function invalidEncodingChannel(channel) {
    return `${channel}-encoding is dropped as ${channel} is not a valid encoding channel.`;
}
function channelShouldBeDiscrete(channel) {
    return `${channel} encoding should be discrete (ordinal / nominal / binned).`;
}
function channelShouldBeDiscreteOrDiscretizing(channel) {
    return `${channel} encoding should be discrete (ordinal / nominal / binned) or use a discretizing scale (e.g. threshold).`;
}
function facetChannelDropped(channels) {
    return `Facet encoding dropped as ${channels.join(' and ')} ${channels.length > 1 ? 'are' : 'is'} also specified.`;
}
function discreteChannelCannotEncode(channel, type) {
    return `Using discrete channel "${channel}" to encode "${type}" field can be misleading as it does not encode ${type === 'ordinal' ? 'order' : 'magnitude'}.`;
}
function rangeMarkAlignmentCannotBeExpression(align) {
    return `The ${align} for range marks cannot be an expression`;
}
function lineWithRange(hasX2, hasY2) {
    const channels = hasX2 && hasY2 ? 'x2 and y2' : hasX2 ? 'x2' : 'y2';
    return `Line mark is for continuous lines and thus cannot be used with ${channels}. We will use the rule mark (line segments) instead.`;
}
function orientOverridden(original, actual) {
    return `Specified orient "${original}" overridden with "${actual}".`;
}
const CANNOT_UNION_CUSTOM_DOMAIN_WITH_FIELD_DOMAIN = 'Custom domain scale cannot be unioned with default field-based domain.';
function cannotUseScalePropertyWithNonColor(prop) {
    return `Cannot use the scale property "${prop}" with non-color channel.`;
}
function cannotUseRelativeBandSizeWithNonBandScale(scaleType) {
    return `Cannot use the relative band size with ${scaleType} scale.`;
}
function unaggregateDomainHasNoEffectForRawField(fieldDef) {
    return `Using unaggregated domain with raw field has no effect (${(0, _util.stringify)(fieldDef)}).`;
}
function unaggregateDomainWithNonSharedDomainOp(aggregate) {
    return `Unaggregated domain not applicable for "${aggregate}" since it produces values outside the origin domain of the source data.`;
}
function unaggregatedDomainWithLogScale(fieldDef) {
    return `Unaggregated domain is currently unsupported for log scale (${(0, _util.stringify)(fieldDef)}).`;
}
function cannotApplySizeToNonOrientedMark(mark) {
    return `Cannot apply size to non-oriented mark "${mark}".`;
}
function scaleTypeNotWorkWithChannel(channel, scaleType, defaultScaleType) {
    return `Channel "${channel}" does not work with "${scaleType}" scale. We are using "${defaultScaleType}" scale instead.`;
}
function scaleTypeNotWorkWithFieldDef(scaleType, defaultScaleType) {
    return `FieldDef does not work with "${scaleType}" scale. We are using "${defaultScaleType}" scale instead.`;
}
function scalePropertyNotWorkWithScaleType(scaleType, propName, channel) {
    return `${channel}-scale's "${propName}" is dropped as it does not work with ${scaleType} scale.`;
}
function scaleTypeNotWorkWithMark(mark, scaleType) {
    return `Scale type "${scaleType}" does not work with mark "${mark}".`;
}
function stepDropped(channel) {
    return `The step for "${channel}" is dropped because the ${channel === 'width' ? 'x' : 'y'} is continuous.`;
}
function mergeConflictingProperty(property, propertyOf, v1, v2) {
    return `Conflicting ${propertyOf.toString()} property "${property.toString()}" (${(0, _util.stringify)(v1)} and ${(0, _util.stringify)(v2)}). Using ${(0, _util.stringify)(v1)}.`;
}
function mergeConflictingDomainProperty(property, propertyOf, v1, v2) {
    return `Conflicting ${propertyOf.toString()} property "${property.toString()}" (${(0, _util.stringify)(v1)} and ${(0, _util.stringify)(v2)}). Using the union of the two domains.`;
}
function independentScaleMeansIndependentGuide(channel) {
    return `Setting the scale to be independent for "${channel}" means we also have to set the guide (axis or legend) to be independent.`;
}
function domainSortDropped(sort) {
    return `Dropping sort property ${(0, _util.stringify)(sort)} as unioned domains only support boolean or op "count", "min", and "max".`;
}
const MORE_THAN_ONE_SORT = 'Domains that should be unioned has conflicting sort properties. Sort will be set to true.';
const FACETED_INDEPENDENT_DIFFERENT_SOURCES = 'Detected faceted independent scales that union domain of multiple fields from different data sources. We will use the first field. The result view size may be incorrect.';
const FACETED_INDEPENDENT_SAME_FIELDS_DIFFERENT_SOURCES = 'Detected faceted independent scales that union domain of the same fields from different source. We will assume that this is the same field from a different fork of the same data source. However, if this is not the case, the result view size may be incorrect.';
const FACETED_INDEPENDENT_SAME_SOURCE = 'Detected faceted independent scales that union domain of multiple fields from the same data source. We will use the first field. The result view size may be incorrect.';
const INVALID_CHANNEL_FOR_AXIS = 'Invalid channel for axis.';
function cannotStackRangedMark(channel) {
    return `Cannot stack "${channel}" if there is already "${channel}2".`;
}
function stackNonLinearScale(scaleType) {
    return `Stack is applied to a non-linear scale (${scaleType}).`;
}
function stackNonSummativeAggregate(aggregate) {
    return `Stacking is applied even though the aggregate function is non-summative ("${aggregate}").`;
}
function invalidTimeUnit(unitName, value) {
    return `Invalid ${unitName}: ${(0, _util.stringify)(value)}.`;
}
function droppedDay(d) {
    return `Dropping day from datetime ${(0, _util.stringify)(d)} as day cannot be combined with other units.`;
}
function errorBarCenterAndExtentAreNotNeeded(center, extent) {
    return `${extent ? 'extent ' : ''}${extent && center ? 'and ' : ''}${center ? 'center ' : ''}${extent && center ? 'are ' : 'is '}not needed when data are aggregated.`;
}
function errorBarCenterIsUsedWithWrongExtent(center, extent, mark) {
    return `${center} is not usually used with ${extent} for ${mark}.`;
}
function errorBarContinuousAxisHasCustomizedAggregate(aggregate, compositeMark) {
    return `Continuous axis should not have customized aggregation function ${aggregate}; ${compositeMark} already agregates the axis.`;
}
function errorBand1DNotSupport(property) {
    return `1D error band does not support ${property}.`;
}
function channelRequiredForBinned(channel) {
    return `Channel ${channel} is required for "binned" bin.`;
}
function channelShouldNotBeUsedForBinned(channel) {
    return `Channel ${channel} should not be used with "binned" bin.`;
}
function domainRequiredForThresholdScale(channel) {
    return `Domain for ${channel} is required for threshold scale.`;
}

},{"vega":"2Jj1D","../channel":"liLED","../util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bdpXN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScaleType", ()=>ScaleType);
parcelHelpers.export(exports, "SCALE_CATEGORY_INDEX", ()=>SCALE_CATEGORY_INDEX);
parcelHelpers.export(exports, "SCALE_TYPES", ()=>SCALE_TYPES);
/**
 * Whether the two given scale types can be merged together.
 */ parcelHelpers.export(exports, "scaleCompatible", ()=>scaleCompatible);
/**
 * Return scale categories -- only scale of the same categories can be merged together.
 */ parcelHelpers.export(exports, "scaleTypePrecedence", ()=>scaleTypePrecedence);
parcelHelpers.export(exports, "QUANTITATIVE_SCALES", ()=>QUANTITATIVE_SCALES);
parcelHelpers.export(exports, "CONTINUOUS_TO_CONTINUOUS_SCALES", ()=>CONTINUOUS_TO_CONTINUOUS_SCALES);
parcelHelpers.export(exports, "isQuantitative", ()=>isQuantitative);
parcelHelpers.export(exports, "CONTINUOUS_TO_DISCRETE_SCALES", ()=>CONTINUOUS_TO_DISCRETE_SCALES);
parcelHelpers.export(exports, "CONTINUOUS_DOMAIN_SCALES", ()=>CONTINUOUS_DOMAIN_SCALES);
parcelHelpers.export(exports, "DISCRETE_DOMAIN_SCALES", ()=>DISCRETE_DOMAIN_SCALES);
parcelHelpers.export(exports, "TIME_SCALE_TYPES", ()=>TIME_SCALE_TYPES);
parcelHelpers.export(exports, "hasDiscreteDomain", ()=>hasDiscreteDomain);
parcelHelpers.export(exports, "hasContinuousDomain", ()=>hasContinuousDomain);
parcelHelpers.export(exports, "isContinuousToContinuous", ()=>isContinuousToContinuous);
parcelHelpers.export(exports, "isContinuousToDiscrete", ()=>isContinuousToDiscrete);
parcelHelpers.export(exports, "defaultScaleConfig", ()=>defaultScaleConfig);
parcelHelpers.export(exports, "isExtendedScheme", ()=>isExtendedScheme);
parcelHelpers.export(exports, "isParameterDomain", ()=>isParameterDomain);
parcelHelpers.export(exports, "isDomainUnionWith", ()=>isDomainUnionWith);
parcelHelpers.export(exports, "isFieldRange", ()=>isFieldRange);
parcelHelpers.export(exports, "SCALE_PROPERTIES", ()=>SCALE_PROPERTIES);
parcelHelpers.export(exports, "NON_TYPE_DOMAIN_RANGE_VEGA_SCALE_PROPERTIES", ()=>NON_TYPE_DOMAIN_RANGE_VEGA_SCALE_PROPERTIES);
parcelHelpers.export(exports, "scaleTypeSupportProperty", ()=>scaleTypeSupportProperty);
/**
 * Returns undefined if the input channel supports the input scale property name
 */ parcelHelpers.export(exports, "channelScalePropertyIncompatability", ()=>channelScalePropertyIncompatability);
parcelHelpers.export(exports, "scaleTypeSupportDataType", ()=>scaleTypeSupportDataType);
parcelHelpers.export(exports, "channelSupportScaleType", ()=>channelSupportScaleType);
var _vegaUtil = require("vega-util");
var _channel = require("./channel");
var _log = require("./log");
var _type = require("./type");
var _util = require("./util");
const ScaleType = {
    // Continuous - Quantitative
    LINEAR: 'linear',
    LOG: 'log',
    POW: 'pow',
    SQRT: 'sqrt',
    SYMLOG: 'symlog',
    IDENTITY: 'identity',
    SEQUENTIAL: 'sequential',
    // Continuous - Time
    TIME: 'time',
    UTC: 'utc',
    // Discretizing scales
    QUANTILE: 'quantile',
    QUANTIZE: 'quantize',
    THRESHOLD: 'threshold',
    BIN_ORDINAL: 'bin-ordinal',
    // Discrete scales
    ORDINAL: 'ordinal',
    POINT: 'point',
    BAND: 'band'
};
const SCALE_CATEGORY_INDEX = {
    linear: 'numeric',
    log: 'numeric',
    pow: 'numeric',
    sqrt: 'numeric',
    symlog: 'numeric',
    identity: 'numeric',
    sequential: 'numeric',
    time: 'time',
    utc: 'time',
    ordinal: 'ordinal',
    'bin-ordinal': 'bin-ordinal',
    point: 'ordinal-position',
    band: 'ordinal-position',
    quantile: 'discretizing',
    quantize: 'discretizing',
    threshold: 'discretizing'
};
const SCALE_TYPES = (0, _util.keys)(SCALE_CATEGORY_INDEX);
function scaleCompatible(scaleType1, scaleType2) {
    const scaleCategory1 = SCALE_CATEGORY_INDEX[scaleType1];
    const scaleCategory2 = SCALE_CATEGORY_INDEX[scaleType2];
    return scaleCategory1 === scaleCategory2 || scaleCategory1 === 'ordinal-position' && scaleCategory2 === 'time' || scaleCategory2 === 'ordinal-position' && scaleCategory1 === 'time';
}
/**
 * Index for scale precedence -- high score = higher priority for merging.
 */ const SCALE_PRECEDENCE_INDEX = {
    // numeric
    linear: 0,
    log: 1,
    pow: 1,
    sqrt: 1,
    symlog: 1,
    identity: 1,
    sequential: 1,
    // time
    time: 0,
    utc: 0,
    // ordinal-position -- these have higher precedence than continuous scales as they support more types of data
    point: 10,
    band: 11,
    // non grouped types
    ordinal: 0,
    'bin-ordinal': 0,
    quantile: 0,
    quantize: 0,
    threshold: 0
};
function scaleTypePrecedence(scaleType) {
    return SCALE_PRECEDENCE_INDEX[scaleType];
}
const QUANTITATIVE_SCALES = new Set([
    'linear',
    'log',
    'pow',
    'sqrt',
    'symlog'
]);
const CONTINUOUS_TO_CONTINUOUS_SCALES = new Set([
    ...QUANTITATIVE_SCALES,
    'time',
    'utc'
]);
function isQuantitative(type) {
    return QUANTITATIVE_SCALES.has(type);
}
const CONTINUOUS_TO_DISCRETE_SCALES = new Set([
    'quantile',
    'quantize',
    'threshold'
]);
const CONTINUOUS_DOMAIN_SCALES = new Set([
    ...CONTINUOUS_TO_CONTINUOUS_SCALES,
    ...CONTINUOUS_TO_DISCRETE_SCALES,
    'sequential',
    'identity'
]);
const DISCRETE_DOMAIN_SCALES = new Set([
    'ordinal',
    'bin-ordinal',
    'point',
    'band'
]);
const TIME_SCALE_TYPES = new Set([
    'time',
    'utc'
]);
function hasDiscreteDomain(type) {
    return DISCRETE_DOMAIN_SCALES.has(type);
}
function hasContinuousDomain(type) {
    return CONTINUOUS_DOMAIN_SCALES.has(type);
}
function isContinuousToContinuous(type) {
    return CONTINUOUS_TO_CONTINUOUS_SCALES.has(type);
}
function isContinuousToDiscrete(type) {
    return CONTINUOUS_TO_DISCRETE_SCALES.has(type);
}
const defaultScaleConfig = {
    pointPadding: 0.5,
    barBandPaddingInner: 0.1,
    rectBandPaddingInner: 0,
    tickBandPaddingInner: 0.25,
    bandWithNestedOffsetPaddingInner: 0.2,
    bandWithNestedOffsetPaddingOuter: 0.2,
    minBandSize: 2,
    minFontSize: 8,
    maxFontSize: 40,
    minOpacity: 0.3,
    maxOpacity: 0.8,
    // FIXME: revise if these *can* become ratios of width/height step
    minSize: 4,
    minStrokeWidth: 1,
    maxStrokeWidth: 4,
    quantileCount: 4,
    quantizeCount: 4,
    zero: true,
    framesPerSecond: 2,
    animationDuration: 5
};
function isExtendedScheme(scheme) {
    return !(0, _vegaUtil.isString)(scheme) && (0, _util.hasProperty)(scheme, 'name');
}
function isParameterDomain(domain) {
    return (0, _util.hasProperty)(domain, 'param');
}
function isDomainUnionWith(domain) {
    return (0, _util.hasProperty)(domain, 'unionWith');
}
function isFieldRange(range) {
    return (0, _vegaUtil.isObject)(range) && 'field' in range;
}
const SCALE_PROPERTY_INDEX = {
    type: 1,
    domain: 1,
    domainMax: 1,
    domainMin: 1,
    domainMid: 1,
    domainRaw: 1,
    align: 1,
    range: 1,
    rangeMax: 1,
    rangeMin: 1,
    scheme: 1,
    bins: 1,
    // Other properties
    reverse: 1,
    round: 1,
    // quantitative / time
    clamp: 1,
    nice: 1,
    // quantitative
    base: 1,
    exponent: 1,
    constant: 1,
    interpolate: 1,
    zero: 1,
    // band/point
    padding: 1,
    paddingInner: 1,
    paddingOuter: 1
};
const SCALE_PROPERTIES = (0, _util.keys)(SCALE_PROPERTY_INDEX);
const { type, domain, range, rangeMax, rangeMin, scheme, ...NON_TYPE_DOMAIN_RANGE_VEGA_SCALE_PROPERTY_INDEX } = SCALE_PROPERTY_INDEX;
const NON_TYPE_DOMAIN_RANGE_VEGA_SCALE_PROPERTIES = (0, _util.keys)(NON_TYPE_DOMAIN_RANGE_VEGA_SCALE_PROPERTY_INDEX);
function scaleTypeSupportProperty(scaleType, propName) {
    switch(propName){
        case 'type':
        case 'domain':
        case 'reverse':
        case 'range':
            return true;
        case 'scheme':
        case 'interpolate':
            return ![
                'point',
                'band',
                'identity'
            ].includes(scaleType);
        case 'bins':
            return ![
                'point',
                'band',
                'identity',
                'ordinal'
            ].includes(scaleType);
        case 'round':
            return isContinuousToContinuous(scaleType) || scaleType === 'band' || scaleType === 'point';
        case 'padding':
        case 'rangeMin':
        case 'rangeMax':
            return isContinuousToContinuous(scaleType) || [
                'point',
                'band'
            ].includes(scaleType);
        case 'paddingOuter':
        case 'align':
            return [
                'point',
                'band'
            ].includes(scaleType);
        case 'paddingInner':
            return scaleType === 'band';
        case 'domainMax':
        case 'domainMid':
        case 'domainMin':
        case 'domainRaw':
        case 'clamp':
            return isContinuousToContinuous(scaleType);
        case 'nice':
            return isContinuousToContinuous(scaleType) || scaleType === 'quantize' || scaleType === 'threshold';
        case 'exponent':
            return scaleType === 'pow';
        case 'base':
            return scaleType === 'log';
        case 'constant':
            return scaleType === 'symlog';
        case 'zero':
            return hasContinuousDomain(scaleType) && !(0, _util.contains)([
                'log',
                'time',
                'utc',
                'threshold',
                'quantile' // quantile depends on distribution so zero does not matter
            ], scaleType);
    }
}
function channelScalePropertyIncompatability(channel, propName) {
    switch(propName){
        case 'interpolate':
        case 'scheme':
        case 'domainMid':
            if (!(0, _channel.isColorChannel)(channel)) return _log.message.cannotUseScalePropertyWithNonColor(propName);
            return undefined;
        case 'align':
        case 'type':
        case 'bins':
        case 'domain':
        case 'domainMax':
        case 'domainMin':
        case 'domainRaw':
        case 'range':
        case 'base':
        case 'exponent':
        case 'constant':
        case 'nice':
        case 'padding':
        case 'paddingInner':
        case 'paddingOuter':
        case 'rangeMax':
        case 'rangeMin':
        case 'reverse':
        case 'round':
        case 'clamp':
        case 'zero':
            return undefined; // GOOD!
    }
}
function scaleTypeSupportDataType(specifiedType, fieldDefType) {
    if ((0, _util.contains)([
        (0, _type.ORDINAL),
        (0, _type.NOMINAL)
    ], fieldDefType)) return specifiedType === undefined || hasDiscreteDomain(specifiedType);
    else if (fieldDefType === (0, _type.TEMPORAL)) return (0, _util.contains)([
        ScaleType.TIME,
        ScaleType.UTC,
        undefined
    ], specifiedType);
    else if (fieldDefType === (0, _type.QUANTITATIVE)) return isQuantitative(specifiedType) || isContinuousToDiscrete(specifiedType) || specifiedType === undefined;
    return true;
}
function channelSupportScaleType(channel, scaleType, hasNestedOffsetScale = false) {
    if (!_channel.isScaleChannel(channel)) return false;
    switch(channel){
        case _channel.X:
        case _channel.Y:
        case _channel.XOFFSET:
        case _channel.YOFFSET:
        case _channel.THETA:
        case _channel.RADIUS:
            if (isContinuousToContinuous(scaleType)) return true;
            else if (scaleType === 'band') return true;
            else if (scaleType === 'point') /*
                  Point scale can't be use if the position has a nested offset scale
                  because if there is a nested scale, then it's band.
                */ return !hasNestedOffsetScale;
            return false;
        case _channel.TIME:
            return (0, _util.contains)([
                'linear',
                'band'
            ], scaleType);
        case _channel.SIZE:
        case _channel.STROKEWIDTH:
        case _channel.OPACITY:
        case _channel.FILLOPACITY:
        case _channel.STROKEOPACITY:
        case _channel.ANGLE:
            // Although it generally doesn't make sense to use band with size and opacity,
            // it can also work since we use band: 0.5 to get midpoint.
            return isContinuousToContinuous(scaleType) || isContinuousToDiscrete(scaleType) || (0, _util.contains)([
                'band',
                'point',
                'ordinal'
            ], scaleType);
        case _channel.COLOR:
        case _channel.FILL:
        case _channel.STROKE:
            return scaleType !== 'band'; // band does not make sense with color
        case _channel.STROKEDASH:
        case _channel.SHAPE:
            return scaleType === 'ordinal' || isContinuousToDiscrete(scaleType);
    }
}

},{"vega-util":"7f6sQ","./channel":"liLED","./log":"loqTw","./type":"cbWGP","./util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cbWGP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Type", ()=>Type);
parcelHelpers.export(exports, "isType", ()=>isType);
parcelHelpers.export(exports, "isContinuous", ()=>isContinuous);
parcelHelpers.export(exports, "isDiscrete", ()=>isDiscrete);
parcelHelpers.export(exports, "QUANTITATIVE", ()=>QUANTITATIVE);
parcelHelpers.export(exports, "ORDINAL", ()=>ORDINAL);
parcelHelpers.export(exports, "TEMPORAL", ()=>TEMPORAL);
parcelHelpers.export(exports, "NOMINAL", ()=>NOMINAL);
parcelHelpers.export(exports, "GEOJSON", ()=>GEOJSON);
parcelHelpers.export(exports, "TYPES", ()=>TYPES);
/**
 * Get full, lowercase type name for a given type.
 * @param  type
 * @return Full type name.
 */ parcelHelpers.export(exports, "getFullName", ()=>getFullName);
var _vegaUtil = require("vega-util");
var _util = require("./util");
const Type = {
    quantitative: 'quantitative',
    ordinal: 'ordinal',
    temporal: 'temporal',
    nominal: 'nominal',
    geojson: 'geojson'
};
function isType(t) {
    return (0, _vegaUtil.hasOwnProperty)(Type, t);
}
function isContinuous(type) {
    return type === 'quantitative' || type === 'temporal';
}
function isDiscrete(type) {
    return type === 'ordinal' || type === 'nominal';
}
const QUANTITATIVE = Type.quantitative;
const ORDINAL = Type.ordinal;
const TEMPORAL = Type.temporal;
const NOMINAL = Type.nominal;
const GEOJSON = Type.geojson;
const TYPES = (0, _util.keys)(Type);
function getFullName(type) {
    if (type) {
        type = type.toLowerCase();
        switch(type){
            case 'q':
            case QUANTITATIVE:
                return 'quantitative';
            case 't':
            case TEMPORAL:
                return 'temporal';
            case 'o':
            case ORDINAL:
                return 'ordinal';
            case 'n':
            case NOMINAL:
                return 'nominal';
            case GEOJSON:
                return 'geojson';
        }
    }
    // If we get invalid input, return undefined type.
    return undefined;
}

},{"vega-util":"7f6sQ","./util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hE3Wg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "midPointRefWithPositionInvalidTest", ()=>midPointRefWithPositionInvalidTest);
parcelHelpers.export(exports, "datumDefToExpr", ()=>datumDefToExpr);
parcelHelpers.export(exports, "valueRefForFieldOrDatumDef", ()=>valueRefForFieldOrDatumDef);
/**
 * Signal that returns the middle of a bin from start and end field. Should only be used with x and y.
 */ parcelHelpers.export(exports, "interpolatedSignalRef", ()=>interpolatedSignalRef);
parcelHelpers.export(exports, "binSizeExpr", ()=>binSizeExpr);
/**
 * @returns {VgValueRef} Value Ref for xc / yc or mid point for other channels.
 */ parcelHelpers.export(exports, "midPoint", ()=>midPoint);
/**
 * Convert special "width" and "height" values in Vega-Lite into Vega value ref.
 */ parcelHelpers.export(exports, "widthHeightValueOrSignalRef", ()=>widthHeightValueOrSignalRef);
var _vegaUtil = require("vega-util");
var _bin = require("../../../bin");
var _channel = require("../../../channel");
var _channeldef = require("../../../channeldef");
var _datetime = require("../../../datetime");
var _expr = require("../../../expr");
var _log = require("../../../log");
var _scale = require("../../../scale");
var _type = require("../../../type");
var _util = require("../../../util");
var _vegaSchema = require("../../../vega.schema");
var _common = require("../../common");
var _invalid = require("./invalid");
function midPointRefWithPositionInvalidTest(params) {
    const { channel, channelDef, markDef, scale, scaleName, config } = params;
    const scaleChannel = (0, _channel.getMainRangeChannel)(channel);
    const mainRef = midPoint(params);
    const valueRefForIncludingInvalid = (0, _invalid.getConditionalValueRefForIncludingInvalidValue)({
        scaleChannel,
        channelDef,
        scale,
        scaleName,
        markDef,
        config
    });
    return valueRefForIncludingInvalid !== undefined ? [
        valueRefForIncludingInvalid,
        mainRef
    ] : mainRef;
}
function datumDefToExpr(datumDef) {
    const { datum } = datumDef;
    if ((0, _datetime.isDateTime)(datum)) return (0, _datetime.dateTimeToExpr)(datum);
    return `${(0, _util.stringify)(datum)}`;
}
function valueRefForFieldOrDatumDef(fieldDef, scaleName, opt, encode) {
    const ref = {};
    if (scaleName) ref.scale = scaleName;
    if ((0, _channeldef.isDatumDef)(fieldDef)) {
        const { datum } = fieldDef;
        if ((0, _datetime.isDateTime)(datum)) ref.signal = (0, _datetime.dateTimeToExpr)(datum);
        else if ((0, _vegaSchema.isSignalRef)(datum)) ref.signal = datum.signal;
        else if ((0, _expr.isExprRef)(datum)) ref.signal = datum.expr;
        else ref.value = datum;
    } else ref.field = (0, _channeldef.vgField)(fieldDef, opt);
    if (encode) {
        const { offset, band } = encode;
        if (offset) ref.offset = offset;
        if (band) ref.band = band;
    }
    return ref;
}
function interpolatedSignalRef({ scaleName, fieldOrDatumDef, fieldOrDatumDef2, offset, startSuffix, endSuffix = 'end', bandPosition = 0.5 }) {
    const expr = !(0, _vegaSchema.isSignalRef)(bandPosition) && 0 < bandPosition && bandPosition < 1 ? 'datum' : undefined;
    const start = (0, _channeldef.vgField)(fieldOrDatumDef, {
        expr,
        suffix: startSuffix
    });
    const end = fieldOrDatumDef2 !== undefined ? (0, _channeldef.vgField)(fieldOrDatumDef2, {
        expr
    }) : (0, _channeldef.vgField)(fieldOrDatumDef, {
        suffix: endSuffix,
        expr
    });
    const ref = {};
    if (bandPosition === 0 || bandPosition === 1) {
        ref.scale = scaleName;
        const field = bandPosition === 0 ? start : end;
        ref.field = field;
    } else {
        const datum = (0, _vegaSchema.isSignalRef)(bandPosition) ? `(1-${bandPosition.signal}) * ${start} + ${bandPosition.signal} * ${end}` : `${1 - bandPosition} * ${start} + ${bandPosition} * ${end}`;
        ref.signal = `scale("${scaleName}", ${datum})`;
    }
    if (offset) ref.offset = offset;
    return ref;
}
function binSizeExpr({ scaleName, fieldDef }) {
    const start = (0, _channeldef.vgField)(fieldDef, {
        expr: 'datum'
    });
    const end = (0, _channeldef.vgField)(fieldDef, {
        expr: 'datum',
        suffix: 'end'
    });
    return `abs(scale("${scaleName}", ${end}) - scale("${scaleName}", ${start}))`;
}
function midPoint({ channel, channelDef, channel2Def, markDef, config, scaleName, scale, stack, offset, defaultRef, bandPosition }) {
    // TODO: datum support
    if (channelDef) {
        /* istanbul ignore else */ if ((0, _channeldef.isFieldOrDatumDef)(channelDef)) {
            const scaleType = scale?.get('type');
            if ((0, _channeldef.isTypedFieldDef)(channelDef)) {
                bandPosition ?? (bandPosition = (0, _channeldef.getBandPosition)({
                    fieldDef: channelDef,
                    fieldDef2: channel2Def,
                    markDef,
                    config
                }));
                const { bin, timeUnit, type } = channelDef;
                if ((0, _bin.isBinning)(bin) || bandPosition && timeUnit && type === (0, _type.TEMPORAL)) {
                    // Use middle only for x an y to place marks in the center between start and end of the bin range.
                    // We do not use the mid point for other channels (e.g. size) so that properties of legends and marks match.
                    if (stack?.impute) // For stack, we computed bin_mid so we can impute.
                    return valueRefForFieldOrDatumDef(channelDef, scaleName, {
                        binSuffix: 'mid'
                    }, {
                        offset
                    });
                    if (bandPosition && !(0, _scale.hasDiscreteDomain)(scaleType)) // if band = 0, no need to call interpolation
                    // For non-stack, we can just calculate bin mid on the fly using signal.
                    return interpolatedSignalRef({
                        scaleName,
                        fieldOrDatumDef: channelDef,
                        bandPosition,
                        offset
                    });
                    return valueRefForFieldOrDatumDef(channelDef, scaleName, (0, _channeldef.binRequiresRange)(channelDef, channel) ? {
                        binSuffix: 'range'
                    } : {}, {
                        offset
                    });
                } else if ((0, _bin.isBinned)(bin)) {
                    if ((0, _channeldef.isFieldDef)(channel2Def)) return interpolatedSignalRef({
                        scaleName,
                        fieldOrDatumDef: channelDef,
                        fieldOrDatumDef2: channel2Def,
                        bandPosition,
                        offset
                    });
                    else {
                        const channel2 = channel === (0, _channel.X) ? (0, _channel.X2) : (0, _channel.Y2);
                        _log.warn(_log.message.channelRequiredForBinned(channel2));
                    }
                }
            }
            return valueRefForFieldOrDatumDef(channelDef, scaleName, (0, _scale.hasDiscreteDomain)(scaleType) ? {
                binSuffix: 'range'
            } : {}, {
                offset,
                // For band, to get mid point, need to offset by half of the band
                band: scaleType === 'band' ? bandPosition ?? channelDef.bandPosition ?? 0.5 : undefined
            });
        } else if ((0, _channeldef.isValueDef)(channelDef)) {
            const value = channelDef.value;
            const offsetMixins = offset ? {
                offset
            } : {};
            return {
                ...widthHeightValueOrSignalRef(channel, value),
                ...offsetMixins
            };
        }
    // If channelDef is neither field def or value def, it's a condition-only def.
    // In such case, we will use default ref.
    }
    if ((0, _vegaUtil.isFunction)(defaultRef)) defaultRef = defaultRef();
    if (defaultRef) // for non-position, ref could be undefined.
    return {
        ...defaultRef,
        // only include offset when it is non-zero (zero = no offset)
        ...offset ? {
            offset
        } : {}
    };
    return defaultRef;
}
function widthHeightValueOrSignalRef(channel, value) {
    if ((0, _util.contains)([
        'x',
        'x2'
    ], channel) && value === 'width') return {
        field: {
            group: 'width'
        }
    };
    else if ((0, _util.contains)([
        'y',
        'y2'
    ], channel) && value === 'height') return {
        field: {
            group: 'height'
        }
    };
    return (0, _common.signalOrValueRef)(value);
}

},{"vega-util":"7f6sQ","../../../bin":"3cpW8","../../../channel":"liLED","../../../channeldef":"dsccb","../../../datetime":"gp5cf","../../../expr":"ev4sO","../../../log":"loqTw","../../../scale":"bdpXN","../../../type":"cbWGP","../../../util":"acUGA","../../../vega.schema":"3mBOT","../../common":"jegt8","./invalid":"h87qQ","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"h87qQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getConditionalValueRefForIncludingInvalidValue", ()=>getConditionalValueRefForIncludingInvalidValue);
var _aggregate = require("../../../aggregate");
var _channeldef = require("../../../channeldef");
var _invalid = require("../../../invalid");
var _predicate = require("../../../predicate");
var _vegaSchema = require("../../../vega.schema");
var _scaleInvalidDataMode = require("../../invalid/ScaleInvalidDataMode");
var _scaledZeroOrMinOrMax = require("./scaledZeroOrMinOrMax");
function getConditionalValueRefForIncludingInvalidValue({ scaleChannel, channelDef, scale, scaleName, markDef, config }) {
    const scaleType = scale?.get('type');
    const fieldDef = (0, _channeldef.getFieldDef)(channelDef);
    const isCountAggregate = (0, _aggregate.isCountingAggregateOp)(fieldDef?.aggregate);
    const invalidDataMode = (0, _scaleInvalidDataMode.getScaleInvalidDataMode)({
        scaleChannel,
        markDef,
        config,
        scaleType,
        isCountAggregate
    });
    if (fieldDef && invalidDataMode === 'show') {
        const includeAs = config.scale.invalid?.[scaleChannel] ?? 'zero-or-min';
        return {
            test: (0, _predicate.fieldValidPredicate)((0, _channeldef.vgField)(fieldDef, {
                expr: 'datum'
            }), false),
            ...refForInvalidValues(includeAs, scale, scaleName)
        };
    }
    return undefined;
}
function refForInvalidValues(includeAs, scale, scaleName) {
    if ((0, _invalid.isScaleInvalidDataIncludeAsValue)(includeAs)) {
        const { value } = includeAs;
        return (0, _vegaSchema.isSignalRef)(value) ? {
            signal: value.signal
        } : {
            value
        };
    }
    return (0, _scaledZeroOrMinOrMax.scaledZeroOrMinOrMax)({
        scale,
        scaleName,
        mode: 'zeroOrMin'
    });
}

},{"../../../aggregate":"d7bUU","../../../channeldef":"dsccb","../../../invalid":"d1J6X","../../../predicate":"gynPW","../../../vega.schema":"3mBOT","../../invalid/ScaleInvalidDataMode":"1nWTz","./scaledZeroOrMinOrMax":"bDhJn","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"d1J6X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isScaleInvalidDataIncludeAsValue", ()=>isScaleInvalidDataIncludeAsValue);
var _vegaUtil = require("vega-util");
function isScaleInvalidDataIncludeAsValue(invalidDataMode) {
    return (0, _vegaUtil.isObject)(invalidDataMode) && 'value' in invalidDataMode;
}

},{"vega-util":"7f6sQ","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"1nWTz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getScaleInvalidDataMode", ()=>getScaleInvalidDataMode);
parcelHelpers.export(exports, "shouldBreakPath", ()=>shouldBreakPath);
var _mark = require("../../mark");
var _scale = require("../../scale");
var _common = require("../common");
var _normalizeInvalidDataMode = require("./normalizeInvalidDataMode");
function getScaleInvalidDataMode({ markDef, config, scaleChannel, scaleType, isCountAggregate }) {
    if (!scaleType || !(0, _scale.hasContinuousDomain)(scaleType) || isCountAggregate) // - Discrete scales can always display null as another category
    // - Count cannot output null values
    return 'always-valid';
    const invalidMode = (0, _normalizeInvalidDataMode.normalizeInvalidDataMode)((0, _common.getMarkPropOrConfig)('invalid', markDef, config), {
        isPath: (0, _mark.isPathMark)(markDef.type)
    });
    const scaleOutputForInvalid = config.scale?.invalid?.[scaleChannel];
    if (scaleOutputForInvalid !== undefined) // Regardless of the current invalid mode, if the channel has a default value, we consider the field valid.
    return 'show';
    return invalidMode;
}
function shouldBreakPath(mode) {
    return mode === 'break-paths-filter-domains' || mode === 'break-paths-show-domains';
}

},{"../../mark":"3Z1xx","../../scale":"bdpXN","../common":"jegt8","./normalizeInvalidDataMode":"kTDie","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3Z1xx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mark", ()=>Mark);
parcelHelpers.export(exports, "ARC", ()=>ARC);
parcelHelpers.export(exports, "AREA", ()=>AREA);
parcelHelpers.export(exports, "BAR", ()=>BAR);
parcelHelpers.export(exports, "IMAGE", ()=>IMAGE);
parcelHelpers.export(exports, "LINE", ()=>LINE);
parcelHelpers.export(exports, "POINT", ()=>POINT);
parcelHelpers.export(exports, "RECT", ()=>RECT);
parcelHelpers.export(exports, "RULE", ()=>RULE);
parcelHelpers.export(exports, "TEXT", ()=>TEXT);
parcelHelpers.export(exports, "TICK", ()=>TICK);
parcelHelpers.export(exports, "TRAIL", ()=>TRAIL);
parcelHelpers.export(exports, "CIRCLE", ()=>CIRCLE);
parcelHelpers.export(exports, "SQUARE", ()=>SQUARE);
parcelHelpers.export(exports, "GEOSHAPE", ()=>GEOSHAPE);
parcelHelpers.export(exports, "isMark", ()=>isMark);
parcelHelpers.export(exports, "PATH_MARKS", ()=>PATH_MARKS);
parcelHelpers.export(exports, "isPathMark", ()=>isPathMark);
parcelHelpers.export(exports, "isRectBasedMark", ()=>isRectBasedMark);
parcelHelpers.export(exports, "PRIMITIVE_MARKS", ()=>PRIMITIVE_MARKS);
parcelHelpers.export(exports, "isMarkDef", ()=>isMarkDef);
parcelHelpers.export(exports, "isPrimitiveMark", ()=>isPrimitiveMark);
parcelHelpers.export(exports, "STROKE_CONFIG", ()=>STROKE_CONFIG);
parcelHelpers.export(exports, "FILL_CONFIG", ()=>FILL_CONFIG);
parcelHelpers.export(exports, "FILL_STROKE_CONFIG", ()=>FILL_STROKE_CONFIG);
parcelHelpers.export(exports, "VL_ONLY_MARK_CONFIG_PROPERTIES", ()=>VL_ONLY_MARK_CONFIG_PROPERTIES);
parcelHelpers.export(exports, "VL_ONLY_MARK_SPECIFIC_CONFIG_PROPERTY_INDEX", ()=>VL_ONLY_MARK_SPECIFIC_CONFIG_PROPERTY_INDEX);
parcelHelpers.export(exports, "defaultMarkConfig", ()=>defaultMarkConfig);
parcelHelpers.export(exports, "MARK_CONFIGS", ()=>MARK_CONFIGS);
parcelHelpers.export(exports, "isRelativeBandSize", ()=>isRelativeBandSize);
parcelHelpers.export(exports, "BAR_CORNER_RADIUS_INDEX", ()=>BAR_CORNER_RADIUS_INDEX);
parcelHelpers.export(exports, "defaultRectConfig", ()=>defaultRectConfig);
parcelHelpers.export(exports, "defaultBarConfig", ()=>defaultBarConfig);
parcelHelpers.export(exports, "defaultTickConfig", ()=>defaultTickConfig);
parcelHelpers.export(exports, "getMarkType", ()=>getMarkType);
var _vegaUtil = require("vega-util");
var _util = require("./util");
const Mark = {
    arc: 'arc',
    area: 'area',
    bar: 'bar',
    image: 'image',
    line: 'line',
    point: 'point',
    rect: 'rect',
    rule: 'rule',
    text: 'text',
    tick: 'tick',
    trail: 'trail',
    circle: 'circle',
    square: 'square',
    geoshape: 'geoshape'
};
const ARC = Mark.arc;
const AREA = Mark.area;
const BAR = Mark.bar;
const IMAGE = Mark.image;
const LINE = Mark.line;
const POINT = Mark.point;
const RECT = Mark.rect;
const RULE = Mark.rule;
const TEXT = Mark.text;
const TICK = Mark.tick;
const TRAIL = Mark.trail;
const CIRCLE = Mark.circle;
const SQUARE = Mark.square;
const GEOSHAPE = Mark.geoshape;
function isMark(m) {
    return (0, _vegaUtil.hasOwnProperty)(Mark, m);
}
const PATH_MARKS = [
    'line',
    'area',
    'trail'
];
function isPathMark(m) {
    return [
        'line',
        'area',
        'trail'
    ].includes(m);
}
function isRectBasedMark(m) {
    return [
        'rect',
        'bar',
        'image',
        'arc',
        'tick' /* arc is rect/interval in polar coordinate */ 
    ].includes(m);
}
const PRIMITIVE_MARKS = new Set((0, _util.keys)(Mark));
function isMarkDef(mark) {
    return (0, _util.hasProperty)(mark, 'type');
}
function isPrimitiveMark(mark) {
    const markType = isMarkDef(mark) ? mark.type : mark;
    return PRIMITIVE_MARKS.has(markType);
}
const STROKE_CONFIG = [
    'stroke',
    'strokeWidth',
    'strokeDash',
    'strokeDashOffset',
    'strokeOpacity',
    'strokeJoin',
    'strokeMiterLimit'
];
const FILL_CONFIG = [
    'fill',
    'fillOpacity'
];
const FILL_STROKE_CONFIG = [
    ...STROKE_CONFIG,
    ...FILL_CONFIG
];
const VL_ONLY_MARK_CONFIG_INDEX = {
    color: 1,
    filled: 1,
    invalid: 1,
    order: 1,
    radius2: 1,
    theta2: 1,
    timeUnitBandSize: 1,
    timeUnitBandPosition: 1
};
const VL_ONLY_MARK_CONFIG_PROPERTIES = (0, _util.keys)(VL_ONLY_MARK_CONFIG_INDEX);
const VL_ONLY_RECT_CONFIG = [
    'binSpacing',
    'continuousBandSize',
    'discreteBandSize',
    'minBandSize'
];
const VL_ONLY_MARK_SPECIFIC_CONFIG_PROPERTY_INDEX = {
    area: [
        'line',
        'point'
    ],
    bar: VL_ONLY_RECT_CONFIG,
    rect: VL_ONLY_RECT_CONFIG,
    line: [
        'point'
    ],
    tick: [
        'bandSize',
        'thickness',
        ...VL_ONLY_RECT_CONFIG
    ]
};
const defaultMarkConfig = {
    color: '#4c78a8',
    invalid: 'break-paths-show-path-domains',
    timeUnitBandSize: 1
};
const MARK_CONFIG_INDEX = {
    mark: 1,
    arc: 1,
    area: 1,
    bar: 1,
    circle: 1,
    image: 1,
    line: 1,
    point: 1,
    rect: 1,
    rule: 1,
    square: 1,
    text: 1,
    tick: 1,
    trail: 1,
    geoshape: 1
};
const MARK_CONFIGS = (0, _util.keys)(MARK_CONFIG_INDEX);
function isRelativeBandSize(o) {
    return (0, _util.hasProperty)(o, 'band');
}
const BAR_CORNER_RADIUS_INDEX = {
    horizontal: [
        'cornerRadiusTopRight',
        'cornerRadiusBottomRight'
    ],
    vertical: [
        'cornerRadiusTopLeft',
        'cornerRadiusTopRight'
    ]
};
const DEFAULT_RECT_BAND_SIZE = 5;
const defaultRectConfig = {
    binSpacing: 0,
    continuousBandSize: DEFAULT_RECT_BAND_SIZE,
    minBandSize: 0.25,
    timeUnitBandPosition: 0.5
};
const defaultBarConfig = {
    ...defaultRectConfig,
    binSpacing: 1
};
const defaultTickConfig = {
    ...defaultRectConfig,
    thickness: 1
};
function getMarkType(m) {
    return isMarkDef(m) ? m.type : m;
}

},{"vega-util":"7f6sQ","./util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"kTDie":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeInvalidDataMode", ()=>normalizeInvalidDataMode);
function normalizeInvalidDataMode(mode, { isPath }) {
    if (mode === undefined || mode === 'break-paths-show-path-domains') return isPath ? 'break-paths-show-domains' : 'filter';
    else if (mode === null) return 'show';
    return mode;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bDhJn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scaledZeroOrMinOrMax", ()=>scaledZeroOrMinOrMax);
function scaledZeroOrMinOrMax({ scaleName, scale, mode }) {
    const domain = `domain('${scaleName}')`;
    if (!scale || !scaleName) return undefined;
    const min = `${domain}[0]`;
    const max = `peek(${domain})`; // peek = the last item of the array
    // If there is a scale (and hence its name)
    const domainHasZero = scale.domainHasZero();
    // zeroOrMin or zeroOrMax mode
    if (domainHasZero === 'definitely') return {
        scale: scaleName,
        value: 0
    };
    else if (domainHasZero === 'maybe') {
        const nonZeroValue = mode === 'zeroOrMin' ? min : max;
        return {
            signal: `scale('${scaleName}', inrange(0, ${domain}) ? 0 : ${nonZeroValue})`
        };
    } else // domainHasZero === 'definitely-not'
    return {
        signal: `scale('${scaleName}', ${mode === 'zeroOrMin' ? min : max})`
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"aWnXd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_SORT_OP", ()=>DEFAULT_SORT_OP);
parcelHelpers.export(exports, "isSortByChannel", ()=>isSortByChannel);
parcelHelpers.export(exports, "isSortByEncoding", ()=>isSortByEncoding);
parcelHelpers.export(exports, "isSortField", ()=>isSortField);
parcelHelpers.export(exports, "isSortArray", ()=>isSortArray);
var _vegaUtil = require("vega-util");
var _util = require("./util");
const DEFAULT_SORT_OP = 'min';
const SORT_BY_CHANNEL_INDEX = {
    x: 1,
    y: 1,
    color: 1,
    fill: 1,
    stroke: 1,
    strokeWidth: 1,
    size: 1,
    shape: 1,
    fillOpacity: 1,
    strokeOpacity: 1,
    opacity: 1,
    text: 1
};
function isSortByChannel(c) {
    return (0, _vegaUtil.hasOwnProperty)(SORT_BY_CHANNEL_INDEX, c);
}
function isSortByEncoding(sort) {
    return (0, _util.hasProperty)(sort, 'encoding');
}
function isSortField(sort) {
    return sort && (sort.op === 'count' || (0, _util.hasProperty)(sort, 'field'));
}
function isSortArray(sort) {
    return sort && (0, _vegaUtil.isArray)(sort);
}

},{"vega-util":"7f6sQ","./util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3pm05":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFacetMapping", ()=>isFacetMapping);
parcelHelpers.export(exports, "isFacetFieldDef", ()=>isFacetFieldDef);
parcelHelpers.export(exports, "isFacetSpec", ()=>isFacetSpec);
var _util = require("../util");
function isFacetMapping(f) {
    return (0, _util.hasProperty)(f, 'row') || (0, _util.hasProperty)(f, 'column');
}
function isFacetFieldDef(channelDef) {
    return (0, _util.hasProperty)(channelDef, 'header');
}
function isFacetSpec(spec) {
    return (0, _util.hasProperty)(spec, 'facet');
}

},{"../util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8TUzf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getViewConfigContinuousSize", ()=>getViewConfigContinuousSize);
parcelHelpers.export(exports, "getViewConfigDiscreteStep", ()=>getViewConfigDiscreteStep);
parcelHelpers.export(exports, "getViewConfigDiscreteSize", ()=>getViewConfigDiscreteSize);
parcelHelpers.export(exports, "DEFAULT_STEP", ()=>DEFAULT_STEP);
parcelHelpers.export(exports, "defaultViewConfig", ()=>defaultViewConfig);
parcelHelpers.export(exports, "isVgScheme", ()=>isVgScheme);
parcelHelpers.export(exports, "defaultConfig", ()=>defaultConfig);
parcelHelpers.export(exports, "DEFAULT_FONT_SIZE", ()=>DEFAULT_FONT_SIZE);
parcelHelpers.export(exports, "DEFAULT_COLOR", ()=>DEFAULT_COLOR);
parcelHelpers.export(exports, "colorSignalConfig", ()=>colorSignalConfig);
parcelHelpers.export(exports, "fontSizeSignalConfig", ()=>fontSizeSignalConfig);
parcelHelpers.export(exports, "fontConfig", ()=>fontConfig);
/**
 * Merge specified config with default config and config for the `color` flag,
 * then replace all expressions with signals
 */ parcelHelpers.export(exports, "initConfig", ()=>initConfig);
parcelHelpers.export(exports, "stripAndRedirectConfig", ()=>stripAndRedirectConfig);
var _vegaUtil = require("vega-util");
var _axis = require("./axis");
var _common = require("./compile/common");
var _compositemark = require("./compositemark");
var _expr = require("./expr");
var _guide = require("./guide");
var _header = require("./header");
var _legend = require("./legend");
var _mark = require("./mark");
var _parameter = require("./parameter");
var _scale = require("./scale");
var _selection = require("./selection");
var _base = require("./spec/base");
var _title = require("./title");
var _util = require("./util");
function getViewConfigContinuousSize(viewConfig, channel) {
    return viewConfig[channel] ?? viewConfig[channel === 'width' ? 'continuousWidth' : 'continuousHeight']; // get width/height for backwards compatibility
}
function getViewConfigDiscreteStep(viewConfig, channel) {
    const size = getViewConfigDiscreteSize(viewConfig, channel);
    return (0, _base.isStep)(size) ? size.step : DEFAULT_STEP;
}
function getViewConfigDiscreteSize(viewConfig, channel) {
    const size = viewConfig[channel] ?? viewConfig[channel === 'width' ? 'discreteWidth' : 'discreteHeight']; // get width/height for backwards compatibility
    return (0, _util.getFirstDefined)(size, {
        step: viewConfig.step
    });
}
const DEFAULT_STEP = 20;
const defaultViewConfig = {
    continuousWidth: 200,
    continuousHeight: 200,
    step: DEFAULT_STEP
};
function isVgScheme(rangeScheme) {
    return (0, _util.hasProperty)(rangeScheme, 'scheme');
}
const defaultConfig = {
    background: 'white',
    padding: 5,
    timeFormat: '%b %d, %Y',
    countTitle: 'Count of Records',
    view: defaultViewConfig,
    mark: _mark.defaultMarkConfig,
    arc: {},
    area: {},
    bar: _mark.defaultBarConfig,
    circle: {},
    geoshape: {},
    image: {},
    line: {},
    point: {},
    rect: _mark.defaultRectConfig,
    rule: {
        color: 'black'
    },
    square: {},
    text: {
        color: 'black'
    },
    tick: _mark.defaultTickConfig,
    trail: {},
    boxplot: {
        size: 14,
        extent: 1.5,
        box: {},
        median: {
            color: 'white'
        },
        outliers: {},
        rule: {},
        ticks: null
    },
    errorbar: {
        center: 'mean',
        rule: true,
        ticks: false
    },
    errorband: {
        band: {
            opacity: 0.3
        },
        borders: false
    },
    scale: (0, _scale.defaultScaleConfig),
    projection: {},
    legend: (0, _legend.defaultLegendConfig),
    header: {
        titlePadding: 10,
        labelPadding: 10
    },
    headerColumn: {},
    headerRow: {},
    headerFacet: {},
    selection: (0, _selection.defaultConfig),
    style: {},
    title: {},
    facet: {
        spacing: (0, _base.DEFAULT_SPACING)
    },
    concat: {
        spacing: (0, _base.DEFAULT_SPACING)
    },
    normalizedNumberFormat: '.0%'
};
// Tableau10 color palette, copied from `vegaScale.scheme('tableau10')`
const tab10 = [
    '#4c78a8',
    '#f58518',
    '#e45756',
    '#72b7b2',
    '#54a24b',
    '#eeca3b',
    '#b279a2',
    '#ff9da6',
    '#9d755d',
    '#bab0ac'
];
const DEFAULT_FONT_SIZE = {
    text: 11,
    guideLabel: 10,
    guideTitle: 11,
    groupTitle: 13,
    groupSubtitle: 12
};
const DEFAULT_COLOR = {
    blue: tab10[0],
    orange: tab10[1],
    red: tab10[2],
    teal: tab10[3],
    green: tab10[4],
    yellow: tab10[5],
    purple: tab10[6],
    pink: tab10[7],
    brown: tab10[8],
    gray0: '#000',
    gray1: '#111',
    gray2: '#222',
    gray3: '#333',
    gray4: '#444',
    gray5: '#555',
    gray6: '#666',
    gray7: '#777',
    gray8: '#888',
    gray9: '#999',
    gray10: '#aaa',
    gray11: '#bbb',
    gray12: '#ccc',
    gray13: '#ddd',
    gray14: '#eee',
    gray15: '#fff'
};
function colorSignalConfig(color = {}) {
    return {
        signals: [
            {
                name: 'color',
                value: (0, _vegaUtil.isObject)(color) ? {
                    ...DEFAULT_COLOR,
                    ...color
                } : DEFAULT_COLOR
            }
        ],
        mark: {
            color: {
                signal: 'color.blue'
            }
        },
        rule: {
            color: {
                signal: 'color.gray0'
            }
        },
        text: {
            color: {
                signal: 'color.gray0'
            }
        },
        style: {
            'guide-label': {
                fill: {
                    signal: 'color.gray0'
                }
            },
            'guide-title': {
                fill: {
                    signal: 'color.gray0'
                }
            },
            'group-title': {
                fill: {
                    signal: 'color.gray0'
                }
            },
            'group-subtitle': {
                fill: {
                    signal: 'color.gray0'
                }
            },
            cell: {
                stroke: {
                    signal: 'color.gray8'
                }
            }
        },
        axis: {
            domainColor: {
                signal: 'color.gray13'
            },
            gridColor: {
                signal: 'color.gray8'
            },
            tickColor: {
                signal: 'color.gray13'
            }
        },
        range: {
            category: [
                {
                    signal: 'color.blue'
                },
                {
                    signal: 'color.orange'
                },
                {
                    signal: 'color.red'
                },
                {
                    signal: 'color.teal'
                },
                {
                    signal: 'color.green'
                },
                {
                    signal: 'color.yellow'
                },
                {
                    signal: 'color.purple'
                },
                {
                    signal: 'color.pink'
                },
                {
                    signal: 'color.brown'
                },
                {
                    signal: 'color.grey8'
                }
            ]
        }
    };
}
function fontSizeSignalConfig(fontSize) {
    return {
        signals: [
            {
                name: 'fontSize',
                value: (0, _vegaUtil.isObject)(fontSize) ? {
                    ...DEFAULT_FONT_SIZE,
                    ...fontSize
                } : DEFAULT_FONT_SIZE
            }
        ],
        text: {
            fontSize: {
                signal: 'fontSize.text'
            }
        },
        style: {
            'guide-label': {
                fontSize: {
                    signal: 'fontSize.guideLabel'
                }
            },
            'guide-title': {
                fontSize: {
                    signal: 'fontSize.guideTitle'
                }
            },
            'group-title': {
                fontSize: {
                    signal: 'fontSize.groupTitle'
                }
            },
            'group-subtitle': {
                fontSize: {
                    signal: 'fontSize.groupSubtitle'
                }
            }
        }
    };
}
function fontConfig(font) {
    return {
        text: {
            font
        },
        style: {
            'guide-label': {
                font
            },
            'guide-title': {
                font
            },
            'group-title': {
                font
            },
            'group-subtitle': {
                font
            }
        }
    };
}
function getAxisConfigInternal(axisConfig) {
    const props = (0, _util.keys)(axisConfig || {});
    const axisConfigInternal = {};
    for (const prop of props){
        const val = axisConfig[prop];
        axisConfigInternal[prop] = (0, _axis.isConditionalAxisValue)(val) ? (0, _common.signalOrValueRefWithCondition)(val) : (0, _common.signalRefOrValue)(val);
    }
    return axisConfigInternal;
}
function getStyleConfigInternal(styleConfig) {
    const props = (0, _util.keys)(styleConfig);
    const styleConfigInternal = {};
    for (const prop of props)// We need to cast to cheat a bit here since styleConfig can be either mark config or axis config
    styleConfigInternal[prop] = getAxisConfigInternal(styleConfig[prop]);
    return styleConfigInternal;
}
const configPropsWithExpr = [
    ...(0, _mark.MARK_CONFIGS),
    ...(0, _axis.AXIS_CONFIGS),
    ...(0, _header.HEADER_CONFIGS),
    'background',
    'padding',
    'legend',
    'lineBreak',
    'scale',
    'style',
    'title',
    'view'
];
function initConfig(specifiedConfig = {}) {
    const { color, font, fontSize, selection, ...restConfig } = specifiedConfig;
    const mergedConfig = (0, _vegaUtil.mergeConfig)({}, (0, _util.duplicate)(defaultConfig), font ? fontConfig(font) : {}, color ? colorSignalConfig(color) : {}, fontSize ? fontSizeSignalConfig(fontSize) : {}, restConfig || {});
    // mergeConfig doesn't recurse and overrides object values.
    if (selection) (0, _vegaUtil.writeConfig)(mergedConfig, 'selection', selection, true);
    const outputConfig = (0, _util.omit)(mergedConfig, configPropsWithExpr);
    for (const prop of [
        'background',
        'lineBreak',
        'padding'
    ])if (mergedConfig[prop]) outputConfig[prop] = (0, _common.signalRefOrValue)(mergedConfig[prop]);
    for (const markConfigType of _mark.MARK_CONFIGS)if (mergedConfig[markConfigType]) // FIXME: outputConfig[markConfigType] expects that types are replaced recursively but replaceExprRef only replaces one level deep
    outputConfig[markConfigType] = (0, _expr.replaceExprRef)(mergedConfig[markConfigType]);
    for (const axisConfigType of (0, _axis.AXIS_CONFIGS))if (mergedConfig[axisConfigType]) outputConfig[axisConfigType] = getAxisConfigInternal(mergedConfig[axisConfigType]);
    for (const headerConfigType of (0, _header.HEADER_CONFIGS))if (mergedConfig[headerConfigType]) outputConfig[headerConfigType] = (0, _expr.replaceExprRef)(mergedConfig[headerConfigType]);
    if (mergedConfig.legend) outputConfig.legend = (0, _expr.replaceExprRef)(mergedConfig.legend);
    if (mergedConfig.scale) {
        const { invalid, ...otherScaleConfig } = mergedConfig.scale;
        const newScaleInvalid = (0, _expr.replaceExprRef)(invalid, {
            level: 1
        });
        outputConfig.scale = {
            ...(0, _expr.replaceExprRef)(otherScaleConfig),
            ...(0, _util.keys)(newScaleInvalid).length > 0 ? {
                invalid: newScaleInvalid
            } : {}
        };
    }
    if (mergedConfig.style) outputConfig.style = getStyleConfigInternal(mergedConfig.style);
    if (mergedConfig.title) outputConfig.title = (0, _expr.replaceExprRef)(mergedConfig.title);
    if (mergedConfig.view) outputConfig.view = (0, _expr.replaceExprRef)(mergedConfig.view);
    return outputConfig;
}
const MARK_STYLES = new Set([
    'view',
    ...(0, _mark.PRIMITIVE_MARKS)
]);
const VL_ONLY_CONFIG_PROPERTIES = [
    'color',
    'fontSize',
    'background',
    'padding',
    'facet',
    'concat',
    'numberFormat',
    'numberFormatType',
    'normalizedNumberFormat',
    'normalizedNumberFormatType',
    'timeFormat',
    'countTitle',
    'header',
    'axisQuantitative',
    'axisTemporal',
    'axisDiscrete',
    'axisPoint',
    'axisXBand',
    'axisXPoint',
    'axisXDiscrete',
    'axisXQuantitative',
    'axisXTemporal',
    'axisYBand',
    'axisYPoint',
    'axisYDiscrete',
    'axisYQuantitative',
    'axisYTemporal',
    'scale',
    'selection',
    'overlay' // FIXME: Redesign and unhide this
];
const VL_ONLY_ALL_MARK_SPECIFIC_CONFIG_PROPERTY_INDEX = {
    view: [
        'continuousWidth',
        'continuousHeight',
        'discreteWidth',
        'discreteHeight',
        'step'
    ],
    ...(0, _mark.VL_ONLY_MARK_SPECIFIC_CONFIG_PROPERTY_INDEX)
};
function stripAndRedirectConfig(config) {
    config = (0, _util.duplicate)(config);
    for (const prop of VL_ONLY_CONFIG_PROPERTIES)delete config[prop];
    if (config.axis) {
        // delete condition axis config
        for(const prop in config.axis)if ((0, _axis.isConditionalAxisValue)(config.axis[prop])) delete config.axis[prop];
    }
    if (config.legend) for (const prop of (0, _guide.VL_ONLY_LEGEND_CONFIG))delete config.legend[prop];
    // Remove Vega-Lite only generic mark config
    if (config.mark) {
        for (const prop of (0, _mark.VL_ONLY_MARK_CONFIG_PROPERTIES))delete config.mark[prop];
        if (config.mark.tooltip && (0, _vegaUtil.isObject)(config.mark.tooltip)) delete config.mark.tooltip;
    }
    if (config.params) {
        config.signals = (config.signals || []).concat((0, _parameter.assembleParameterSignals)(config.params));
        delete config.params;
    }
    for (const markType of MARK_STYLES){
        // Remove Vega-Lite-only mark config
        for (const prop of (0, _mark.VL_ONLY_MARK_CONFIG_PROPERTIES))delete config[markType][prop];
        // Remove Vega-Lite only mark-specific config
        const vlOnlyMarkSpecificConfigs = VL_ONLY_ALL_MARK_SPECIFIC_CONFIG_PROPERTY_INDEX[markType];
        if (vlOnlyMarkSpecificConfigs) for (const prop of vlOnlyMarkSpecificConfigs)delete config[markType][prop];
        // Redirect mark config to config.style so that mark config only affect its own mark type
        // without affecting other marks that share the same underlying Vega marks.
        // For example, config.rect should not affect bar marks.
        redirectConfigToStyleConfig(config, markType);
    }
    for (const m of (0, _compositemark.getAllCompositeMarks)())// Clean up the composite mark config as we don't need them in the output specs anymore
    delete config[m];
    redirectTitleConfig(config);
    // Remove empty config objects.
    for(const prop in config)// @ts-ignore
    if ((0, _vegaUtil.isObject)(config[prop]) && (0, _util.isEmpty)(config[prop])) // @ts-ignore
    delete config[prop];
    return (0, _util.isEmpty)(config) ? undefined : config;
}
/**
 *
 * Redirect config.title -- so that title config do not affect header labels,
 * which also uses `title` directive to implement.
 *
 * For subtitle configs in config.title, keep them in config.title as header titles never have subtitles.
 */ function redirectTitleConfig(config) {
    const { titleMarkConfig, subtitleMarkConfig, subtitle } = (0, _title.extractTitleConfig)(config.title);
    // set config.style if title/subtitleMarkConfig is not an empty object
    if (!(0, _util.isEmpty)(titleMarkConfig)) config.style['group-title'] = {
        ...config.style['group-title'],
        ...titleMarkConfig // config.title has higher precedence than config.style.group-title in Vega
    };
    if (!(0, _util.isEmpty)(subtitleMarkConfig)) config.style['group-subtitle'] = {
        ...config.style['group-subtitle'],
        ...subtitleMarkConfig
    };
    // subtitle part can stay in config.title since header titles do not use subtitle
    if (!(0, _util.isEmpty)(subtitle)) config.title = subtitle;
    else delete config.title;
}
function redirectConfigToStyleConfig(config, prop, toProp, compositeMarkPart) {
    const propConfig = compositeMarkPart ? config[prop][compositeMarkPart] : config[prop];
    if (prop === 'view') toProp = 'cell'; // View's default style is "cell"
    const style = {
        ...propConfig,
        ...config.style[toProp ?? prop]
    };
    // set config.style if it is not an empty object
    if (!(0, _util.isEmpty)(style)) config.style[toProp ?? prop] = style;
    if (!compositeMarkPart) // For composite mark, so don't delete the whole config yet as we have to do multiple redirections.
    delete config[prop];
}

},{"vega-util":"7f6sQ","./axis":"4nB06","./compile/common":"jegt8","./compositemark":"dTrjk","./expr":"ev4sO","./guide":"b5Aps","./header":"17rRI","./legend":"wjMIJ","./mark":"3Z1xx","./parameter":"arxqh","./scale":"bdpXN","./selection":"jtWSq","./spec/base":"5uH6T","./title":"bnPA4","./util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4nB06":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONDITIONAL_AXIS_PROP_INDEX", ()=>CONDITIONAL_AXIS_PROP_INDEX);
parcelHelpers.export(exports, "isConditionalAxisValue", ()=>isConditionalAxisValue);
parcelHelpers.export(exports, "AXIS_PARTS", ()=>AXIS_PARTS);
parcelHelpers.export(exports, "AXIS_PROPERTY_TYPE", ()=>AXIS_PROPERTY_TYPE);
parcelHelpers.export(exports, "COMMON_AXIS_PROPERTIES_INDEX", ()=>COMMON_AXIS_PROPERTIES_INDEX);
parcelHelpers.export(exports, "isAxisProperty", ()=>isAxisProperty);
parcelHelpers.export(exports, "AXIS_PROPERTIES", ()=>AXIS_PROPERTIES);
parcelHelpers.export(exports, "AXIS_CONFIGS", ()=>AXIS_CONFIGS);
var _util = require("./util");
var _vegaUtil = require("vega-util");
const CONDITIONAL_AXIS_PROP_INDEX = {
    labelAlign: {
        part: 'labels',
        vgProp: 'align'
    },
    labelBaseline: {
        part: 'labels',
        vgProp: 'baseline'
    },
    labelColor: {
        part: 'labels',
        vgProp: 'fill'
    },
    labelFont: {
        part: 'labels',
        vgProp: 'font'
    },
    labelFontSize: {
        part: 'labels',
        vgProp: 'fontSize'
    },
    labelFontStyle: {
        part: 'labels',
        vgProp: 'fontStyle'
    },
    labelFontWeight: {
        part: 'labels',
        vgProp: 'fontWeight'
    },
    labelOpacity: {
        part: 'labels',
        vgProp: 'opacity'
    },
    labelOffset: null,
    labelPadding: null,
    gridColor: {
        part: 'grid',
        vgProp: 'stroke'
    },
    gridDash: {
        part: 'grid',
        vgProp: 'strokeDash'
    },
    gridDashOffset: {
        part: 'grid',
        vgProp: 'strokeDashOffset'
    },
    gridOpacity: {
        part: 'grid',
        vgProp: 'opacity'
    },
    gridWidth: {
        part: 'grid',
        vgProp: 'strokeWidth'
    },
    tickColor: {
        part: 'ticks',
        vgProp: 'stroke'
    },
    tickDash: {
        part: 'ticks',
        vgProp: 'strokeDash'
    },
    tickDashOffset: {
        part: 'ticks',
        vgProp: 'strokeDashOffset'
    },
    tickOpacity: {
        part: 'ticks',
        vgProp: 'opacity'
    },
    tickSize: null,
    tickWidth: {
        part: 'ticks',
        vgProp: 'strokeWidth'
    }
};
function isConditionalAxisValue(v) {
    return v?.condition;
}
const AXIS_PARTS = [
    'domain',
    'grid',
    'labels',
    'ticks',
    'title'
];
const AXIS_PROPERTY_TYPE = {
    grid: 'grid',
    gridCap: 'grid',
    gridColor: 'grid',
    gridDash: 'grid',
    gridDashOffset: 'grid',
    gridOpacity: 'grid',
    gridScale: 'grid',
    gridWidth: 'grid',
    orient: 'main',
    bandPosition: 'both',
    aria: 'main',
    description: 'main',
    domain: 'main',
    domainCap: 'main',
    domainColor: 'main',
    domainDash: 'main',
    domainDashOffset: 'main',
    domainOpacity: 'main',
    domainWidth: 'main',
    format: 'main',
    formatType: 'main',
    labelAlign: 'main',
    labelAngle: 'main',
    labelBaseline: 'main',
    labelBound: 'main',
    labelColor: 'main',
    labelFlush: 'main',
    labelFlushOffset: 'main',
    labelFont: 'main',
    labelFontSize: 'main',
    labelFontStyle: 'main',
    labelFontWeight: 'main',
    labelLimit: 'main',
    labelLineHeight: 'main',
    labelOffset: 'main',
    labelOpacity: 'main',
    labelOverlap: 'main',
    labelPadding: 'main',
    labels: 'main',
    labelSeparation: 'main',
    maxExtent: 'main',
    minExtent: 'main',
    offset: 'both',
    position: 'main',
    tickCap: 'main',
    tickColor: 'main',
    tickDash: 'main',
    tickDashOffset: 'main',
    tickMinStep: 'both',
    tickOffset: 'both',
    tickOpacity: 'main',
    tickRound: 'both',
    ticks: 'main',
    tickSize: 'main',
    tickWidth: 'both',
    title: 'main',
    titleAlign: 'main',
    titleAnchor: 'main',
    titleAngle: 'main',
    titleBaseline: 'main',
    titleColor: 'main',
    titleFont: 'main',
    titleFontSize: 'main',
    titleFontStyle: 'main',
    titleFontWeight: 'main',
    titleLimit: 'main',
    titleLineHeight: 'main',
    titleOpacity: 'main',
    titlePadding: 'main',
    titleX: 'main',
    titleY: 'main',
    encode: 'both',
    scale: 'both',
    tickBand: 'both',
    tickCount: 'both',
    tickExtra: 'both',
    translate: 'both',
    values: 'both',
    zindex: 'both' // this is actually set afterward, so it doesn't matter
};
const COMMON_AXIS_PROPERTIES_INDEX = {
    orient: 1,
    aria: 1,
    bandPosition: 1,
    description: 1,
    domain: 1,
    domainCap: 1,
    domainColor: 1,
    domainDash: 1,
    domainDashOffset: 1,
    domainOpacity: 1,
    domainWidth: 1,
    format: 1,
    formatType: 1,
    grid: 1,
    gridCap: 1,
    gridColor: 1,
    gridDash: 1,
    gridDashOffset: 1,
    gridOpacity: 1,
    gridWidth: 1,
    labelAlign: 1,
    labelAngle: 1,
    labelBaseline: 1,
    labelBound: 1,
    labelColor: 1,
    labelFlush: 1,
    labelFlushOffset: 1,
    labelFont: 1,
    labelFontSize: 1,
    labelFontStyle: 1,
    labelFontWeight: 1,
    labelLimit: 1,
    labelLineHeight: 1,
    labelOffset: 1,
    labelOpacity: 1,
    labelOverlap: 1,
    labelPadding: 1,
    labels: 1,
    labelSeparation: 1,
    maxExtent: 1,
    minExtent: 1,
    offset: 1,
    position: 1,
    tickBand: 1,
    tickCap: 1,
    tickColor: 1,
    tickCount: 1,
    tickDash: 1,
    tickDashOffset: 1,
    tickExtra: 1,
    tickMinStep: 1,
    tickOffset: 1,
    tickOpacity: 1,
    tickRound: 1,
    ticks: 1,
    tickSize: 1,
    tickWidth: 1,
    title: 1,
    titleAlign: 1,
    titleAnchor: 1,
    titleAngle: 1,
    titleBaseline: 1,
    titleColor: 1,
    titleFont: 1,
    titleFontSize: 1,
    titleFontStyle: 1,
    titleFontWeight: 1,
    titleLimit: 1,
    titleLineHeight: 1,
    titleOpacity: 1,
    titlePadding: 1,
    titleX: 1,
    titleY: 1,
    translate: 1,
    values: 1,
    zindex: 1
};
const AXIS_PROPERTIES_INDEX = {
    ...COMMON_AXIS_PROPERTIES_INDEX,
    style: 1,
    labelExpr: 1,
    encoding: 1
};
function isAxisProperty(prop) {
    return (0, _vegaUtil.hasOwnProperty)(AXIS_PROPERTIES_INDEX, prop);
}
const AXIS_PROPERTIES = (0, _util.keys)(AXIS_PROPERTIES_INDEX);
const AXIS_CONFIGS_INDEX = {
    axis: 1,
    axisBand: 1,
    axisBottom: 1,
    axisDiscrete: 1,
    axisLeft: 1,
    axisPoint: 1,
    axisQuantitative: 1,
    axisRight: 1,
    axisTemporal: 1,
    axisTop: 1,
    axisX: 1,
    axisXBand: 1,
    axisXDiscrete: 1,
    axisXPoint: 1,
    axisXQuantitative: 1,
    axisXTemporal: 1,
    axisY: 1,
    axisYBand: 1,
    axisYDiscrete: 1,
    axisYPoint: 1,
    axisYQuantitative: 1,
    axisYTemporal: 1
};
const AXIS_CONFIGS = (0, _util.keys)(AXIS_CONFIGS_INDEX);

},{"./util":"acUGA","vega-util":"7f6sQ","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dTrjk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "add", ()=>add);
parcelHelpers.export(exports, "remove", ()=>remove);
parcelHelpers.export(exports, "getAllCompositeMarks", ()=>getAllCompositeMarks);
var _util = require("../util");
var _base = require("./base");
var _boxplot = require("./boxplot");
var _errorband = require("./errorband");
var _errorbar = require("./errorbar");
/**
 * Registry index for all composite mark's normalizer
 */ const compositeMarkRegistry = {};
function add(mark, run, parts) {
    const normalizer = new (0, _base.CompositeMarkNormalizer)(mark, run);
    compositeMarkRegistry[mark] = {
        normalizer,
        parts
    };
}
function remove(mark) {
    delete compositeMarkRegistry[mark];
}
function getAllCompositeMarks() {
    return (0, _util.keys)(compositeMarkRegistry);
}
add((0, _boxplot.BOXPLOT), (0, _boxplot.normalizeBoxPlot), (0, _boxplot.BOXPLOT_PARTS));
add((0, _errorbar.ERRORBAR), (0, _errorbar.normalizeErrorBar), (0, _errorbar.ERRORBAR_PARTS));
add((0, _errorband.ERRORBAND), (0, _errorband.normalizeErrorBand), (0, _errorband.ERRORBAND_PARTS));

},{"../util":"acUGA","./base":"jVVvX","./boxplot":"6f3ni","./errorband":"fn7Pn","./errorbar":"bSILL","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"jVVvX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompositeMarkNormalizer", ()=>CompositeMarkNormalizer);
var _mark = require("../mark");
var _unit = require("../spec/unit");
class CompositeMarkNormalizer {
    constructor(name, run){
        this.name = name;
        this.run = run;
    }
    hasMatchingType(spec) {
        if ((0, _unit.isUnitSpec)(spec)) return (0, _mark.getMarkType)(spec.mark) === this.name;
        return false;
    }
}

},{"../mark":"3Z1xx","../spec/unit":"eKdDP","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"eKdDP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isUnitSpec", ()=>isUnitSpec);
var _util = require("../util");
function isUnitSpec(spec) {
    return (0, _util.hasProperty)(spec, 'mark');
}

},{"../util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"6f3ni":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BOXPLOT", ()=>BOXPLOT);
parcelHelpers.export(exports, "BOXPLOT_PARTS", ()=>BOXPLOT_PARTS);
parcelHelpers.export(exports, "boxPlotNormalizer", ()=>boxPlotNormalizer);
parcelHelpers.export(exports, "getBoxPlotType", ()=>getBoxPlotType);
parcelHelpers.export(exports, "normalizeBoxPlot", ()=>normalizeBoxPlot);
var _vegaUtil = require("vega-util");
var _common = require("../compile/common");
var _encoding = require("../encoding");
var _log = require("../log");
var _mark = require("../mark");
var _util = require("../util");
var _base = require("./base");
var _common1 = require("./common");
const BOXPLOT = 'boxplot';
const BOXPLOT_PARTS = [
    'box',
    'median',
    'outliers',
    'rule',
    'ticks'
];
const boxPlotNormalizer = new (0, _base.CompositeMarkNormalizer)(BOXPLOT, normalizeBoxPlot);
function getBoxPlotType(extent) {
    if ((0, _vegaUtil.isNumber)(extent)) return 'tukey';
    // Ham: If we ever want to, we could add another extent syntax `{kIQR: number}` for the original [Q1-k*IQR, Q3+k*IQR] whisker and call this boxPlotType = `kIQR`. However, I'm not exposing this for now.
    return extent;
}
function normalizeBoxPlot(spec, { config }) {
    // Need to initEncoding first so we can infer type
    spec = {
        ...spec,
        encoding: (0, _encoding.normalizeEncoding)(spec.encoding, config)
    };
    const { mark, encoding: _encoding1, params, projection: _p, ...outerSpec } = spec;
    const markDef = (0, _mark.isMarkDef)(mark) ? mark : {
        type: mark
    };
    // TODO(https://github.com/vega/vega-lite/issues/3702): add selection support
    if (params) _log.warn(_log.message.selectionNotSupported('boxplot'));
    const extent = markDef.extent ?? config.boxplot.extent;
    const sizeValue = (0, _common.getMarkPropOrConfig)('size', markDef, config);
    const invalid = markDef.invalid;
    const boxPlotType = getBoxPlotType(extent);
    const { bins, timeUnits, transform, continuousAxisChannelDef, continuousAxis, groupby, aggregate, encodingWithoutContinuousAxis, ticksOrient, boxOrient, customTooltipWithoutAggregatedField } = boxParams(spec, extent, config);
    const aliasedFieldName = (0, _util.removePathFromField)(continuousAxisChannelDef.field);
    const { color, size, ...encodingWithoutSizeColorAndContinuousAxis } = encodingWithoutContinuousAxis;
    const makeBoxPlotPart = (sharedEncoding)=>{
        return (0, _common1.makeCompositeAggregatePartFactory)(markDef, continuousAxis, continuousAxisChannelDef, sharedEncoding, config.boxplot);
    };
    const makeBoxPlotExtent = makeBoxPlotPart(encodingWithoutSizeColorAndContinuousAxis);
    const makeBoxPlotBox = makeBoxPlotPart(encodingWithoutContinuousAxis);
    const defaultBoxColor = ((0, _vegaUtil.isObject)(config.boxplot.box) ? config.boxplot.box.color : config.mark.color) || '#4c78a8';
    const makeBoxPlotMidTick = makeBoxPlotPart({
        ...encodingWithoutSizeColorAndContinuousAxis,
        ...size ? {
            size
        } : {},
        color: {
            condition: {
                test: `${(0, _util.accessWithDatumToUnescapedPath)(`lower_box_${continuousAxisChannelDef.field}`)} >= ${(0, _util.accessWithDatumToUnescapedPath)(`upper_box_${continuousAxisChannelDef.field}`)}`,
                ...color || {
                    value: defaultBoxColor
                }
            }
        }
    });
    const fiveSummaryTooltipEncoding = (0, _common1.getCompositeMarkTooltip)([
        {
            fieldPrefix: boxPlotType === 'min-max' ? 'upper_whisker_' : 'max_',
            titlePrefix: 'Max'
        },
        {
            fieldPrefix: 'upper_box_',
            titlePrefix: 'Q3'
        },
        {
            fieldPrefix: 'mid_box_',
            titlePrefix: 'Median'
        },
        {
            fieldPrefix: 'lower_box_',
            titlePrefix: 'Q1'
        },
        {
            fieldPrefix: boxPlotType === 'min-max' ? 'lower_whisker_' : 'min_',
            titlePrefix: 'Min'
        }
    ], continuousAxisChannelDef, encodingWithoutContinuousAxis);
    // ## Whisker Layers
    const endTick = {
        type: 'tick',
        color: 'black',
        opacity: 1,
        orient: ticksOrient,
        invalid,
        aria: false
    };
    const whiskerTooltipEncoding = boxPlotType === 'min-max' ? fiveSummaryTooltipEncoding // for min-max, show five-summary tooltip for whisker
     : (0, _common1.getCompositeMarkTooltip)([
        {
            fieldPrefix: 'upper_whisker_',
            titlePrefix: 'Upper Whisker'
        },
        {
            fieldPrefix: 'lower_whisker_',
            titlePrefix: 'Lower Whisker'
        }
    ], continuousAxisChannelDef, encodingWithoutContinuousAxis);
    const whiskerLayers = [
        ...makeBoxPlotExtent({
            partName: 'rule',
            mark: {
                type: 'rule',
                invalid,
                aria: false
            },
            positionPrefix: 'lower_whisker',
            endPositionPrefix: 'lower_box',
            extraEncoding: whiskerTooltipEncoding
        }),
        ...makeBoxPlotExtent({
            partName: 'rule',
            mark: {
                type: 'rule',
                invalid,
                aria: false
            },
            positionPrefix: 'upper_box',
            endPositionPrefix: 'upper_whisker',
            extraEncoding: whiskerTooltipEncoding
        }),
        ...makeBoxPlotExtent({
            partName: 'ticks',
            mark: endTick,
            positionPrefix: 'lower_whisker',
            extraEncoding: whiskerTooltipEncoding
        }),
        ...makeBoxPlotExtent({
            partName: 'ticks',
            mark: endTick,
            positionPrefix: 'upper_whisker',
            extraEncoding: whiskerTooltipEncoding
        })
    ];
    // ## Box Layers
    // TODO: support hiding certain mark parts
    const boxLayers = [
        ...boxPlotType !== 'tukey' ? whiskerLayers : [],
        ...makeBoxPlotBox({
            partName: 'box',
            mark: {
                type: 'bar',
                ...sizeValue ? {
                    size: sizeValue
                } : {},
                orient: boxOrient,
                invalid,
                ariaRoleDescription: 'box'
            },
            positionPrefix: 'lower_box',
            endPositionPrefix: 'upper_box',
            extraEncoding: fiveSummaryTooltipEncoding
        }),
        ...makeBoxPlotMidTick({
            partName: 'median',
            mark: {
                type: 'tick',
                invalid,
                ...(0, _vegaUtil.isObject)(config.boxplot.median) && config.boxplot.median.color ? {
                    color: config.boxplot.median.color
                } : {},
                ...sizeValue ? {
                    size: sizeValue
                } : {},
                orient: ticksOrient,
                aria: false
            },
            positionPrefix: 'mid_box',
            extraEncoding: fiveSummaryTooltipEncoding
        })
    ];
    if (boxPlotType === 'min-max') return {
        ...outerSpec,
        transform: (outerSpec.transform ?? []).concat(transform),
        layer: boxLayers
    };
    // Tukey Box Plot
    const lowerBoxExpr = (0, _util.accessWithDatumToUnescapedPath)(`lower_box_${continuousAxisChannelDef.field}`);
    const upperBoxExpr = (0, _util.accessWithDatumToUnescapedPath)(`upper_box_${continuousAxisChannelDef.field}`);
    const iqrExpr = `(${upperBoxExpr} - ${lowerBoxExpr})`;
    const lowerWhiskerExpr = `${lowerBoxExpr} - ${extent} * ${iqrExpr}`;
    const upperWhiskerExpr = `${upperBoxExpr} + ${extent} * ${iqrExpr}`;
    const fieldExpr = (0, _util.accessWithDatumToUnescapedPath)(continuousAxisChannelDef.field);
    const joinaggregateTransform = {
        joinaggregate: boxParamsQuartiles(continuousAxisChannelDef.field),
        groupby
    };
    const filteredWhiskerSpec = {
        transform: [
            {
                filter: `(${lowerWhiskerExpr} <= ${fieldExpr}) && (${fieldExpr} <= ${upperWhiskerExpr})`
            },
            {
                aggregate: [
                    {
                        op: 'min',
                        field: continuousAxisChannelDef.field,
                        as: `lower_whisker_${aliasedFieldName}`
                    },
                    {
                        op: 'max',
                        field: continuousAxisChannelDef.field,
                        as: `upper_whisker_${aliasedFieldName}`
                    },
                    // preserve lower_box / upper_box
                    {
                        op: 'min',
                        field: `lower_box_${continuousAxisChannelDef.field}`,
                        as: `lower_box_${aliasedFieldName}`
                    },
                    {
                        op: 'max',
                        field: `upper_box_${continuousAxisChannelDef.field}`,
                        as: `upper_box_${aliasedFieldName}`
                    },
                    ...aggregate
                ],
                groupby
            }
        ],
        layer: whiskerLayers
    };
    const { tooltip, ...encodingWithoutSizeColorContinuousAxisAndTooltip } = encodingWithoutSizeColorAndContinuousAxis;
    const { scale, axis } = continuousAxisChannelDef;
    const title = (0, _common1.getTitle)(continuousAxisChannelDef);
    const axisWithoutTitle = (0, _util.omit)(axis, [
        'title'
    ]);
    const outlierLayersMixins = (0, _common1.partLayerMixins)(markDef, 'outliers', config.boxplot, {
        transform: [
            {
                filter: `(${fieldExpr} < ${lowerWhiskerExpr}) || (${fieldExpr} > ${upperWhiskerExpr})`
            }
        ],
        mark: 'point',
        encoding: {
            [continuousAxis]: {
                field: continuousAxisChannelDef.field,
                type: continuousAxisChannelDef.type,
                ...title !== undefined ? {
                    title
                } : {},
                ...scale !== undefined ? {
                    scale
                } : {},
                // add axis without title since we already added the title above
                ...(0, _util.isEmpty)(axisWithoutTitle) ? {} : {
                    axis: axisWithoutTitle
                }
            },
            ...encodingWithoutSizeColorContinuousAxisAndTooltip,
            ...color ? {
                color
            } : {},
            ...customTooltipWithoutAggregatedField ? {
                tooltip: customTooltipWithoutAggregatedField
            } : {}
        }
    })[0];
    let filteredLayersMixins;
    const filteredLayersMixinsTransforms = [
        ...bins,
        ...timeUnits,
        joinaggregateTransform
    ];
    if (outlierLayersMixins) filteredLayersMixins = {
        transform: filteredLayersMixinsTransforms,
        layer: [
            outlierLayersMixins,
            filteredWhiskerSpec
        ]
    };
    else {
        filteredLayersMixins = filteredWhiskerSpec;
        filteredLayersMixins.transform.unshift(...filteredLayersMixinsTransforms);
    }
    return {
        ...outerSpec,
        layer: [
            filteredLayersMixins,
            {
                // boxplot
                transform,
                layer: boxLayers
            }
        ]
    };
}
function boxParamsQuartiles(continousAxisField) {
    const aliasedFieldName = (0, _util.removePathFromField)(continousAxisField);
    return [
        {
            op: 'q1',
            field: continousAxisField,
            as: `lower_box_${aliasedFieldName}`
        },
        {
            op: 'q3',
            field: continousAxisField,
            as: `upper_box_${aliasedFieldName}`
        }
    ];
}
function boxParams(spec, extent, config) {
    const orient = (0, _common1.compositeMarkOrient)(spec, BOXPLOT);
    const { continuousAxisChannelDef, continuousAxis } = (0, _common1.compositeMarkContinuousAxis)(spec, orient, BOXPLOT);
    const continuousFieldName = continuousAxisChannelDef.field;
    const aliasedFieldName = (0, _util.removePathFromField)(continuousFieldName);
    const boxPlotType = getBoxPlotType(extent);
    const boxplotSpecificAggregate = [
        ...boxParamsQuartiles(continuousFieldName),
        {
            op: 'median',
            field: continuousFieldName,
            as: `mid_box_${aliasedFieldName}`
        },
        {
            op: 'min',
            field: continuousFieldName,
            as: (boxPlotType === 'min-max' ? 'lower_whisker_' : 'min_') + aliasedFieldName
        },
        {
            op: 'max',
            field: continuousFieldName,
            as: (boxPlotType === 'min-max' ? 'upper_whisker_' : 'max_') + aliasedFieldName
        }
    ];
    const postAggregateCalculates = boxPlotType === 'min-max' || boxPlotType === 'tukey' ? [] : [
        // This is for the  original k-IQR, which we do not expose
        {
            calculate: `${(0, _util.accessWithDatumToUnescapedPath)(`upper_box_${aliasedFieldName}`)} - ${(0, _util.accessWithDatumToUnescapedPath)(`lower_box_${aliasedFieldName}`)}`,
            as: `iqr_${aliasedFieldName}`
        },
        {
            calculate: `min(${(0, _util.accessWithDatumToUnescapedPath)(`upper_box_${aliasedFieldName}`)} + ${(0, _util.accessWithDatumToUnescapedPath)(`iqr_${aliasedFieldName}`)} * ${extent}, ${(0, _util.accessWithDatumToUnescapedPath)(`max_${aliasedFieldName}`)})`,
            as: `upper_whisker_${aliasedFieldName}`
        },
        {
            calculate: `max(${(0, _util.accessWithDatumToUnescapedPath)(`lower_box_${aliasedFieldName}`)} - ${(0, _util.accessWithDatumToUnescapedPath)(`iqr_${aliasedFieldName}`)} * ${extent}, ${(0, _util.accessWithDatumToUnescapedPath)(`min_${aliasedFieldName}`)})`,
            as: `lower_whisker_${aliasedFieldName}`
        }
    ];
    const { [continuousAxis]: oldContinuousAxisChannelDef, ...oldEncodingWithoutContinuousAxis } = spec.encoding;
    const { customTooltipWithoutAggregatedField, filteredEncoding } = (0, _common1.filterTooltipWithAggregatedField)(oldEncodingWithoutContinuousAxis);
    const { bins, timeUnits, aggregate, groupby, encoding: encodingWithoutContinuousAxis } = (0, _encoding.extractTransformsFromEncoding)(filteredEncoding, config);
    const ticksOrient = orient === 'vertical' ? 'horizontal' : 'vertical';
    const boxOrient = orient;
    const transform = [
        ...bins,
        ...timeUnits,
        {
            aggregate: [
                ...aggregate,
                ...boxplotSpecificAggregate
            ],
            groupby
        },
        ...postAggregateCalculates
    ];
    return {
        bins,
        timeUnits,
        transform,
        groupby,
        aggregate,
        continuousAxisChannelDef,
        continuousAxis,
        encodingWithoutContinuousAxis,
        ticksOrient,
        boxOrient,
        customTooltipWithoutAggregatedField
    };
}

},{"vega-util":"7f6sQ","../compile/common":"jegt8","../encoding":"2Ohsj","../log":"loqTw","../mark":"3Z1xx","../util":"acUGA","./base":"jVVvX","./common":"2TkZH","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"2Ohsj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "channelHasField", ()=>channelHasField);
parcelHelpers.export(exports, "channelHasFieldOrDatum", ()=>channelHasFieldOrDatum);
parcelHelpers.export(exports, "channelHasNestedOffsetScale", ()=>channelHasNestedOffsetScale);
parcelHelpers.export(exports, "isAggregate", ()=>isAggregate);
parcelHelpers.export(exports, "extractTransformsFromEncoding", ()=>extractTransformsFromEncoding);
parcelHelpers.export(exports, "markChannelCompatible", ()=>markChannelCompatible);
parcelHelpers.export(exports, "initEncoding", ()=>initEncoding);
/**
 * For composite marks, we have to call initChannelDef during init so we can infer types earlier.
 */ parcelHelpers.export(exports, "normalizeEncoding", ()=>normalizeEncoding);
parcelHelpers.export(exports, "fieldDefs", ()=>fieldDefs);
parcelHelpers.export(exports, "forEach", ()=>forEach);
parcelHelpers.export(exports, "reduce", ()=>reduce);
/**
 * Returns list of path grouping fields for the given encoding
 */ parcelHelpers.export(exports, "pathGroupingFields", ()=>pathGroupingFields);
var _vegaUtil = require("vega-util");
var _aggregate = require("./aggregate");
var _bin = require("./bin");
var _channel = require("./channel");
var _channeldef = require("./channeldef");
var _log = require("./log");
var _type = require("./type");
var _util = require("./util");
var _vegaSchema = require("./vega.schema");
var _timeunit = require("./timeunit");
function channelHasField(encoding, channel) {
    const channelDef = encoding && encoding[channel];
    if (channelDef) {
        if ((0, _vegaUtil.isArray)(channelDef)) return (0, _util.some)(channelDef, (fieldDef)=>!!fieldDef.field);
        else return (0, _channeldef.isFieldDef)(channelDef) || (0, _channeldef.hasConditionalFieldDef)(channelDef);
    }
    return false;
}
function channelHasFieldOrDatum(encoding, channel) {
    const channelDef = encoding && encoding[channel];
    if (channelDef) {
        if ((0, _vegaUtil.isArray)(channelDef)) return (0, _util.some)(channelDef, (fieldDef)=>!!fieldDef.field);
        else return (0, _channeldef.isFieldDef)(channelDef) || (0, _channeldef.isDatumDef)(channelDef) || (0, _channeldef.hasConditionalFieldOrDatumDef)(channelDef);
    }
    return false;
}
function channelHasNestedOffsetScale(encoding, channel) {
    if ((0, _channel.isXorY)(channel)) {
        const fieldDef = encoding[channel];
        if (((0, _channeldef.isFieldDef)(fieldDef) || (0, _channeldef.isDatumDef)(fieldDef)) && ((0, _type.isDiscrete)(fieldDef.type) || (0, _channeldef.isFieldDef)(fieldDef) && fieldDef.timeUnit)) {
            const offsetChannel = (0, _channel.getOffsetScaleChannel)(channel);
            return channelHasFieldOrDatum(encoding, offsetChannel);
        }
    }
    return false;
}
function isAggregate(encoding) {
    return (0, _util.some)((0, _channel.CHANNELS), (channel)=>{
        if (channelHasField(encoding, channel)) {
            const channelDef = encoding[channel];
            if ((0, _vegaUtil.isArray)(channelDef)) return (0, _util.some)(channelDef, (fieldDef)=>!!fieldDef.aggregate);
            else {
                const fieldDef = (0, _channeldef.getFieldDef)(channelDef);
                return fieldDef && !!fieldDef.aggregate;
            }
        }
        return false;
    });
}
function extractTransformsFromEncoding(oldEncoding, config) {
    const groupby = [];
    const bins = [];
    const timeUnits = [];
    const aggregate = [];
    const encoding = {};
    forEach(oldEncoding, (channelDef, channel)=>{
        // Extract potential embedded transformations along with remaining properties
        if ((0, _channeldef.isFieldDef)(channelDef)) {
            const { field, aggregate: aggOp, bin, timeUnit, ...remaining } = channelDef;
            if (aggOp || timeUnit || bin) {
                const guide = (0, _channeldef.getGuide)(channelDef);
                const isTitleDefined = guide?.title;
                let newField = (0, _channeldef.vgField)(channelDef, {
                    forAs: true
                });
                const newFieldDef = {
                    // Only add title if it doesn't exist
                    ...isTitleDefined ? [] : {
                        title: (0, _channeldef.title)(channelDef, config, {
                            allowDisabling: true
                        })
                    },
                    ...remaining,
                    // Always overwrite field
                    field: newField
                };
                if (aggOp) {
                    let op;
                    if ((0, _aggregate.isArgmaxDef)(aggOp)) {
                        op = 'argmax';
                        newField = (0, _channeldef.vgField)({
                            op: 'argmax',
                            field: aggOp.argmax
                        }, {
                            forAs: true
                        });
                        newFieldDef.field = `${newField}.${field}`;
                    } else if ((0, _aggregate.isArgminDef)(aggOp)) {
                        op = 'argmin';
                        newField = (0, _channeldef.vgField)({
                            op: 'argmin',
                            field: aggOp.argmin
                        }, {
                            forAs: true
                        });
                        newFieldDef.field = `${newField}.${field}`;
                    } else if (aggOp !== 'boxplot' && aggOp !== 'errorbar' && aggOp !== 'errorband') op = aggOp;
                    if (op) {
                        const aggregateEntry = {
                            op,
                            as: newField
                        };
                        if (field) aggregateEntry.field = field;
                        aggregate.push(aggregateEntry);
                    }
                } else {
                    groupby.push(newField);
                    if ((0, _channeldef.isTypedFieldDef)(channelDef) && (0, _bin.isBinning)(bin)) {
                        bins.push({
                            bin,
                            field,
                            as: newField
                        });
                        // Add additional groupbys for range and end of bins
                        groupby.push((0, _channeldef.vgField)(channelDef, {
                            binSuffix: 'end'
                        }));
                        if ((0, _channeldef.binRequiresRange)(channelDef, channel)) groupby.push((0, _channeldef.vgField)(channelDef, {
                            binSuffix: 'range'
                        }));
                        // Create accompanying 'x2' or 'y2' field if channel is 'x' or 'y' respectively
                        if ((0, _channel.isXorY)(channel)) {
                            const secondaryChannel = {
                                field: `${newField}_end`
                            };
                            encoding[`${channel}2`] = secondaryChannel;
                        }
                        newFieldDef.bin = 'binned';
                        if (!(0, _channel.isSecondaryRangeChannel)(channel)) newFieldDef['type'] = (0, _type.QUANTITATIVE);
                    } else if (timeUnit && !(0, _timeunit.isBinnedTimeUnit)(timeUnit)) {
                        timeUnits.push({
                            timeUnit,
                            field,
                            as: newField
                        });
                        // define the format type for later compilation
                        const formatType = (0, _channeldef.isTypedFieldDef)(channelDef) && channelDef.type !== (0, _type.TEMPORAL) && 'time';
                        if (formatType) {
                            if (channel === (0, _channel.TEXT) || channel === (0, _channel.TOOLTIP)) newFieldDef['formatType'] = formatType;
                            else if ((0, _channel.isNonPositionScaleChannel)(channel)) newFieldDef['legend'] = {
                                formatType,
                                ...newFieldDef['legend']
                            };
                            else if ((0, _channel.isXorY)(channel)) newFieldDef['axis'] = {
                                formatType,
                                ...newFieldDef['axis']
                            };
                        }
                    }
                }
                // now the field should refer to post-transformed field instead
                encoding[channel] = newFieldDef;
            } else {
                groupby.push(field);
                encoding[channel] = oldEncoding[channel];
            }
        } else // For value def / signal ref / datum def, just copy
        encoding[channel] = oldEncoding[channel];
    });
    return {
        bins,
        timeUnits,
        aggregate,
        groupby,
        encoding
    };
}
function markChannelCompatible(encoding, channel, mark) {
    const markSupported = (0, _channel.supportMark)(channel, mark);
    if (!markSupported) return false;
    else if (markSupported === 'binned') {
        const primaryFieldDef = encoding[channel === (0, _channel.X2) ? (0, _channel.X) : (0, _channel.Y)];
        // circle, point, square and tick only support x2/y2 when their corresponding x/y fieldDef
        // has "binned" data and thus need x2/y2 to specify the bin-end field.
        if ((0, _channeldef.isFieldDef)(primaryFieldDef) && (0, _channeldef.isFieldDef)(encoding[channel]) && (0, _bin.isBinned)(primaryFieldDef.bin)) return true;
        else return false;
    }
    return true;
}
function initEncoding(encoding, mark, filled, config) {
    const normalizedEncoding = {};
    for (const key of (0, _util.keys)(encoding))if (!(0, _channel.isChannel)(key)) // Drop invalid channel
    _log.warn(_log.message.invalidEncodingChannel(key));
    for (let channel of (0, _channel.UNIT_CHANNELS)){
        if (!encoding[channel]) continue;
        const channelDef = encoding[channel];
        if ((0, _channel.isXorYOffset)(channel)) {
            const mainChannel = (0, _channel.getMainChannelFromOffsetChannel)(channel);
            const positionDef = normalizedEncoding[mainChannel];
            if ((0, _channeldef.isFieldDef)(positionDef)) {
                if ((0, _type.isContinuous)(positionDef.type)) {
                    if ((0, _channeldef.isFieldDef)(channelDef) && !positionDef.timeUnit) {
                        // TODO: nesting continuous field instead continuous field should
                        // behave like offsetting the data in data domain
                        _log.warn(_log.message.offsetNestedInsideContinuousPositionScaleDropped(mainChannel));
                        continue;
                    }
                }
            }
        }
        if (channel === 'angle' && mark === 'arc' && !encoding.theta) {
            _log.warn(_log.message.REPLACE_ANGLE_WITH_THETA);
            channel = (0, _channel.THETA);
        }
        if (!markChannelCompatible(encoding, channel, mark)) {
            // Drop unsupported channel
            _log.warn(_log.message.incompatibleChannel(channel, mark));
            continue;
        }
        // Drop line's size if the field is aggregated.
        if (channel === (0, _channel.SIZE) && mark === 'line') {
            const fieldDef = (0, _channeldef.getFieldDef)(encoding[channel]);
            if (fieldDef?.aggregate) {
                _log.warn(_log.message.LINE_WITH_VARYING_SIZE);
                continue;
            }
        }
        // Drop color if either fill or stroke is specified
        if (channel === (0, _channel.COLOR) && (filled ? 'fill' in encoding : 'stroke' in encoding)) {
            _log.warn(_log.message.droppingColor('encoding', {
                fill: 'fill' in encoding,
                stroke: 'stroke' in encoding
            }));
            continue;
        }
        if (channel === (0, _channel.DETAIL) || channel === (0, _channel.ORDER) && !(0, _vegaUtil.isArray)(channelDef) && !(0, _channeldef.isValueDef)(channelDef) || channel === (0, _channel.TOOLTIP) && (0, _vegaUtil.isArray)(channelDef)) {
            if (channelDef) {
                if (channel === (0, _channel.ORDER)) {
                    const def = encoding[channel];
                    if ((0, _channeldef.isOrderOnlyDef)(def)) {
                        normalizedEncoding[channel] = def;
                        continue;
                    }
                }
                // Array of fieldDefs for detail channel (or production rule)
                normalizedEncoding[channel] = (0, _vegaUtil.array)(channelDef).reduce((defs, fieldDef)=>{
                    if (!(0, _channeldef.isFieldDef)(fieldDef)) _log.warn(_log.message.emptyFieldDef(fieldDef, channel));
                    else defs.push((0, _channeldef.initFieldDef)(fieldDef, channel));
                    return defs;
                }, []);
            }
        } else {
            if (channel === (0, _channel.TOOLTIP) && channelDef === null) // Preserve null so we can use it to disable tooltip
            normalizedEncoding[channel] = null;
            else if (!(0, _channeldef.isFieldDef)(channelDef) && !(0, _channeldef.isDatumDef)(channelDef) && !(0, _channeldef.isValueDef)(channelDef) && !(0, _channeldef.isConditionalDef)(channelDef) && !(0, _vegaSchema.isSignalRef)(channelDef)) {
                _log.warn(_log.message.emptyFieldDef(channelDef, channel));
                continue;
            }
            normalizedEncoding[channel] = (0, _channeldef.initChannelDef)(channelDef, channel, config);
        }
    }
    return normalizedEncoding;
}
function normalizeEncoding(encoding, config) {
    const normalizedEncoding = {};
    for (const channel of (0, _util.keys)(encoding)){
        const newChannelDef = (0, _channeldef.initChannelDef)(encoding[channel], channel, config, {
            compositeMark: true
        });
        normalizedEncoding[channel] = newChannelDef;
    }
    return normalizedEncoding;
}
function fieldDefs(encoding) {
    const arr = [];
    for (const channel of (0, _util.keys)(encoding))if (channelHasField(encoding, channel)) {
        const channelDef = encoding[channel];
        const channelDefArray = (0, _vegaUtil.array)(channelDef);
        for (const def of channelDefArray){
            if ((0, _channeldef.isFieldDef)(def)) arr.push(def);
            else if ((0, _channeldef.hasConditionalFieldDef)(def)) arr.push(def.condition);
        }
    }
    return arr;
}
function forEach(mapping, f, thisArg) {
    if (!mapping) return;
    for (const channel of (0, _util.keys)(mapping)){
        const el = mapping[channel];
        if ((0, _vegaUtil.isArray)(el)) for (const channelDef of el)f.call(thisArg, channelDef, channel);
        else f.call(thisArg, el, channel);
    }
}
function reduce(mapping, f, init, thisArg) {
    if (!mapping) return init;
    return (0, _util.keys)(mapping).reduce((r, channel)=>{
        const map = mapping[channel];
        if ((0, _vegaUtil.isArray)(map)) return map.reduce((r1, channelDef)=>{
            return f.call(thisArg, r1, channelDef, channel);
        }, r);
        else return f.call(thisArg, r, map, channel);
    }, init);
}
function pathGroupingFields(mark, encoding) {
    return (0, _util.keys)(encoding).reduce((details, channel)=>{
        switch(channel){
            // x, y, x2, y2, lat, long, lat1, long2, order, tooltip, href, aria label, cursor should not cause lines to group
            case 0, _channel.X:
            case 0, _channel.Y:
            case 0, _channel.HREF:
            case 0, _channel.DESCRIPTION:
            case 0, _channel.URL:
            case 0, _channel.X2:
            case 0, _channel.Y2:
            case 0, _channel.XOFFSET:
            case 0, _channel.YOFFSET:
            case 0, _channel.THETA:
            case 0, _channel.THETA2:
            case 0, _channel.RADIUS:
            case 0, _channel.RADIUS2:
            case 0, _channel.TIME:
            // falls through
            case 0, _channel.LATITUDE:
            case 0, _channel.LONGITUDE:
            case 0, _channel.LATITUDE2:
            case 0, _channel.LONGITUDE2:
            // TODO: case 'cursor':
            // text, shape, shouldn't be a part of line/trail/area [falls through]
            case 0, _channel.TEXT:
            case 0, _channel.SHAPE:
            case 0, _channel.ANGLE:
            // falls through
            // tooltip fields should not be added to group by [falls through]
            case 0, _channel.TOOLTIP:
                return details;
            case 0, _channel.ORDER:
                // order should not group line / trail
                if (mark === 'line' || mark === 'trail') return details;
            // but order should group area for stacking (falls through)
            case 0, _channel.DETAIL:
            case 0, _channel.KEY:
                {
                    const channelDef = encoding[channel];
                    if ((0, _vegaUtil.isArray)(channelDef) || (0, _channeldef.isFieldDef)(channelDef)) {
                        for (const fieldDef of (0, _vegaUtil.array)(channelDef))if (!fieldDef.aggregate) details.push((0, _channeldef.vgField)(fieldDef, {}));
                    }
                    return details;
                }
            case 0, _channel.SIZE:
                if (mark === 'trail') // For trail, size should not group trail lines.
                return details;
            // For line, size should group lines.
            // falls through
            case 0, _channel.COLOR:
            case 0, _channel.FILL:
            case 0, _channel.STROKE:
            case 0, _channel.OPACITY:
            case 0, _channel.FILLOPACITY:
            case 0, _channel.STROKEOPACITY:
            case 0, _channel.STROKEDASH:
            case 0, _channel.STROKEWIDTH:
                {
                    // TODO strokeDashOffset:
                    // falls through
                    const fieldDef = (0, _channeldef.getFieldDef)(encoding[channel]);
                    if (fieldDef && !fieldDef.aggregate) details.push((0, _channeldef.vgField)(fieldDef, {}));
                    return details;
                }
        }
    }, []);
}

},{"vega-util":"7f6sQ","./aggregate":"d7bUU","./bin":"3cpW8","./channel":"liLED","./channeldef":"dsccb","./log":"loqTw","./type":"cbWGP","./util":"acUGA","./vega.schema":"3mBOT","./timeunit":"eky0T","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"2TkZH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterTooltipWithAggregatedField", ()=>filterTooltipWithAggregatedField);
parcelHelpers.export(exports, "getCompositeMarkTooltip", ()=>getCompositeMarkTooltip);
parcelHelpers.export(exports, "getTitle", ()=>getTitle);
parcelHelpers.export(exports, "makeCompositeAggregatePartFactory", ()=>makeCompositeAggregatePartFactory);
parcelHelpers.export(exports, "partLayerMixins", ()=>partLayerMixins);
parcelHelpers.export(exports, "compositeMarkContinuousAxis", ()=>compositeMarkContinuousAxis);
parcelHelpers.export(exports, "compositeMarkOrient", ()=>compositeMarkOrient);
var _vegaUtil = require("vega-util");
var _channeldef = require("../channeldef");
var _encoding = require("../encoding");
var _log = require("../log");
var _mark = require("../mark");
var _util = require("../util");
var _vegaSchema = require("../vega.schema");
var _channeldef1 = require("./../channeldef");
function filterTooltipWithAggregatedField(oldEncoding) {
    const { tooltip, ...filteredEncoding } = oldEncoding;
    if (!tooltip) return {
        filteredEncoding
    };
    let customTooltipWithAggregatedField;
    let customTooltipWithoutAggregatedField;
    if ((0, _vegaUtil.isArray)(tooltip)) {
        for (const t of tooltip)if (t.aggregate) {
            if (!customTooltipWithAggregatedField) customTooltipWithAggregatedField = [];
            customTooltipWithAggregatedField.push(t);
        } else {
            if (!customTooltipWithoutAggregatedField) customTooltipWithoutAggregatedField = [];
            customTooltipWithoutAggregatedField.push(t);
        }
        if (customTooltipWithAggregatedField) filteredEncoding.tooltip = customTooltipWithAggregatedField;
    } else if (tooltip.aggregate) filteredEncoding.tooltip = tooltip;
    else customTooltipWithoutAggregatedField = tooltip;
    if ((0, _vegaUtil.isArray)(customTooltipWithoutAggregatedField) && customTooltipWithoutAggregatedField.length === 1) customTooltipWithoutAggregatedField = customTooltipWithoutAggregatedField[0];
    return {
        customTooltipWithoutAggregatedField,
        filteredEncoding
    };
}
function getCompositeMarkTooltip(tooltipSummary, continuousAxisChannelDef, encodingWithoutContinuousAxis, withFieldName = true) {
    if ('tooltip' in encodingWithoutContinuousAxis) return {
        tooltip: encodingWithoutContinuousAxis.tooltip
    };
    const fiveSummaryTooltip = tooltipSummary.map(({ fieldPrefix, titlePrefix })=>{
        const mainTitle = withFieldName ? ` of ${getTitle(continuousAxisChannelDef)}` : '';
        return {
            field: fieldPrefix + continuousAxisChannelDef.field,
            type: continuousAxisChannelDef.type,
            title: (0, _vegaSchema.isSignalRef)(titlePrefix) ? {
                signal: `${titlePrefix}"${escape(mainTitle)}"`
            } : titlePrefix + mainTitle
        };
    });
    const tooltipFieldDefs = (0, _encoding.fieldDefs)(encodingWithoutContinuousAxis).map((0, _channeldef1.toStringFieldDef));
    return {
        tooltip: [
            ...fiveSummaryTooltip,
            // need to cast because TextFieldDef supports fewer types of bin
            ...(0, _util.unique)(tooltipFieldDefs, (0, _util.hash))
        ]
    };
}
function getTitle(continuousAxisChannelDef) {
    const { title, field } = continuousAxisChannelDef;
    return (0, _util.getFirstDefined)(title, field);
}
function makeCompositeAggregatePartFactory(compositeMarkDef, continuousAxis, continuousAxisChannelDef, sharedEncoding, compositeMarkConfig) {
    const { scale, axis } = continuousAxisChannelDef;
    return ({ partName, mark, positionPrefix, endPositionPrefix, extraEncoding = {} })=>{
        const title = getTitle(continuousAxisChannelDef);
        return partLayerMixins(compositeMarkDef, partName, compositeMarkConfig, {
            mark,
            encoding: {
                [continuousAxis]: {
                    field: `${positionPrefix}_${continuousAxisChannelDef.field}`,
                    type: continuousAxisChannelDef.type,
                    ...title !== undefined ? {
                        title
                    } : {},
                    ...scale !== undefined ? {
                        scale
                    } : {},
                    ...axis !== undefined ? {
                        axis
                    } : {}
                },
                ...(0, _vegaUtil.isString)(endPositionPrefix) ? {
                    [`${continuousAxis}2`]: {
                        field: `${endPositionPrefix}_${continuousAxisChannelDef.field}`
                    }
                } : {},
                ...sharedEncoding,
                ...extraEncoding
            }
        });
    };
}
function partLayerMixins(markDef, part, compositeMarkConfig, partBaseSpec) {
    const { clip, color, opacity } = markDef;
    const mark = markDef.type;
    if (markDef[part] || markDef[part] === undefined && compositeMarkConfig[part]) return [
        {
            ...partBaseSpec,
            mark: {
                ...compositeMarkConfig[part],
                ...clip ? {
                    clip
                } : {},
                ...color ? {
                    color
                } : {},
                ...opacity ? {
                    opacity
                } : {},
                ...(0, _mark.isMarkDef)(partBaseSpec.mark) ? partBaseSpec.mark : {
                    type: partBaseSpec.mark
                },
                style: `${mark}-${String(part)}`,
                ...(0, _vegaUtil.isBoolean)(markDef[part]) ? {} : markDef[part]
            }
        }
    ];
    return [];
}
function compositeMarkContinuousAxis(spec, orient, compositeMark) {
    const { encoding } = spec;
    const continuousAxis = orient === 'vertical' ? 'y' : 'x';
    const continuousAxisChannelDef = encoding[continuousAxis]; // Safe to cast because if x is not continuous fielddef, the orient would not be horizontal.
    const continuousAxisChannelDef2 = encoding[`${continuousAxis}2`];
    const continuousAxisChannelDefError = encoding[`${continuousAxis}Error`];
    const continuousAxisChannelDefError2 = encoding[`${continuousAxis}Error2`];
    return {
        continuousAxisChannelDef: filterAggregateFromChannelDef(continuousAxisChannelDef, compositeMark),
        continuousAxisChannelDef2: filterAggregateFromChannelDef(continuousAxisChannelDef2, compositeMark),
        continuousAxisChannelDefError: filterAggregateFromChannelDef(continuousAxisChannelDefError, compositeMark),
        continuousAxisChannelDefError2: filterAggregateFromChannelDef(continuousAxisChannelDefError2, compositeMark),
        continuousAxis
    };
}
function filterAggregateFromChannelDef(continuousAxisChannelDef, compositeMark) {
    if (continuousAxisChannelDef?.aggregate) {
        const { aggregate, ...continuousAxisWithoutAggregate } = continuousAxisChannelDef;
        if (aggregate !== compositeMark) _log.warn(_log.message.errorBarContinuousAxisHasCustomizedAggregate(aggregate, compositeMark));
        return continuousAxisWithoutAggregate;
    } else return continuousAxisChannelDef;
}
function compositeMarkOrient(spec, compositeMark) {
    const { mark, encoding } = spec;
    const { x, y } = encoding;
    if ((0, _mark.isMarkDef)(mark) && mark.orient) return mark.orient;
    if ((0, _channeldef.isContinuousFieldOrDatumDef)(x)) {
        // x is continuous
        if ((0, _channeldef.isContinuousFieldOrDatumDef)(y)) {
            // both x and y are continuous
            const xAggregate = (0, _channeldef.isFieldDef)(x) && x.aggregate;
            const yAggregate = (0, _channeldef.isFieldDef)(y) && y.aggregate;
            if (!xAggregate && yAggregate === compositeMark) return 'vertical';
            else if (!yAggregate && xAggregate === compositeMark) return 'horizontal';
            else if (xAggregate === compositeMark && yAggregate === compositeMark) throw new Error('Both x and y cannot have aggregate');
            else {
                if ((0, _channeldef.isFieldOrDatumDefForTimeFormat)(y) && !(0, _channeldef.isFieldOrDatumDefForTimeFormat)(x)) // y is temporal but x is not
                return 'horizontal';
                // default orientation for two continuous
                return 'vertical';
            }
        }
        return 'horizontal';
    } else if ((0, _channeldef.isContinuousFieldOrDatumDef)(y)) // y is continuous but x is not
    return 'vertical';
    else // Neither x nor y is continuous.
    throw new Error(`Need a valid continuous axis for ${compositeMark}s`);
}

},{"vega-util":"7f6sQ","../channeldef":"dsccb","../encoding":"2Ohsj","../log":"loqTw","../mark":"3Z1xx","../util":"acUGA","../vega.schema":"3mBOT","./../channeldef":"dsccb","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"fn7Pn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ERRORBAND", ()=>ERRORBAND);
parcelHelpers.export(exports, "ERRORBAND_PARTS", ()=>ERRORBAND_PARTS);
parcelHelpers.export(exports, "errorBandNormalizer", ()=>errorBandNormalizer);
parcelHelpers.export(exports, "normalizeErrorBand", ()=>normalizeErrorBand);
var _encoding = require("../encoding");
var _log = require("../log");
var _base = require("./base");
var _common = require("./common");
var _errorbar = require("./errorbar");
const ERRORBAND = 'errorband';
const ERRORBAND_PARTS = [
    'band',
    'borders'
];
const errorBandNormalizer = new (0, _base.CompositeMarkNormalizer)(ERRORBAND, normalizeErrorBand);
function normalizeErrorBand(spec, { config }) {
    // Need to initEncoding first so we can infer type
    spec = {
        ...spec,
        encoding: (0, _encoding.normalizeEncoding)(spec.encoding, config)
    };
    const { transform, continuousAxisChannelDef, continuousAxis, encodingWithoutContinuousAxis, markDef, outerSpec, tooltipEncoding } = (0, _errorbar.errorBarParams)(spec, ERRORBAND, config);
    const errorBandDef = markDef;
    const makeErrorBandPart = (0, _common.makeCompositeAggregatePartFactory)(errorBandDef, continuousAxis, continuousAxisChannelDef, encodingWithoutContinuousAxis, config.errorband);
    const is2D = spec.encoding.x !== undefined && spec.encoding.y !== undefined;
    let bandMark = {
        type: is2D ? 'area' : 'rect'
    };
    let bordersMark = {
        type: is2D ? 'line' : 'rule'
    };
    const interpolate = {
        ...errorBandDef.interpolate ? {
            interpolate: errorBandDef.interpolate
        } : {},
        ...errorBandDef.tension && errorBandDef.interpolate ? {
            tension: errorBandDef.tension
        } : {}
    };
    if (is2D) {
        bandMark = {
            ...bandMark,
            ...interpolate,
            ariaRoleDescription: 'errorband'
        };
        bordersMark = {
            ...bordersMark,
            ...interpolate,
            aria: false
        };
    } else if (errorBandDef.interpolate) _log.warn(_log.message.errorBand1DNotSupport('interpolate'));
    else if (errorBandDef.tension) _log.warn(_log.message.errorBand1DNotSupport('tension'));
    return {
        ...outerSpec,
        transform,
        layer: [
            ...makeErrorBandPart({
                partName: 'band',
                mark: bandMark,
                positionPrefix: 'lower',
                endPositionPrefix: 'upper',
                extraEncoding: tooltipEncoding
            }),
            ...makeErrorBandPart({
                partName: 'borders',
                mark: bordersMark,
                positionPrefix: 'lower',
                extraEncoding: tooltipEncoding
            }),
            ...makeErrorBandPart({
                partName: 'borders',
                mark: bordersMark,
                positionPrefix: 'upper',
                extraEncoding: tooltipEncoding
            })
        ]
    };
}

},{"../encoding":"2Ohsj","../log":"loqTw","./base":"jVVvX","./common":"2TkZH","./errorbar":"bSILL","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bSILL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ERRORBAR", ()=>ERRORBAR);
parcelHelpers.export(exports, "ERRORBAR_PARTS", ()=>ERRORBAR_PARTS);
parcelHelpers.export(exports, "errorBarNormalizer", ()=>errorBarNormalizer);
parcelHelpers.export(exports, "normalizeErrorBar", ()=>normalizeErrorBar);
parcelHelpers.export(exports, "errorBarParams", ()=>errorBarParams);
var _channeldef = require("../channeldef");
var _encoding = require("../encoding");
var _log = require("../log");
var _mark = require("../mark");
var _util = require("../util");
var _base = require("./base");
var _common = require("./common");
const ERRORBAR = 'errorbar';
const ERRORBAR_PARTS = [
    'ticks',
    'rule'
];
const errorBarNormalizer = new (0, _base.CompositeMarkNormalizer)(ERRORBAR, normalizeErrorBar);
function normalizeErrorBar(spec, { config }) {
    // Need to initEncoding first so we can infer type
    spec = {
        ...spec,
        encoding: (0, _encoding.normalizeEncoding)(spec.encoding, config)
    };
    const { transform, continuousAxisChannelDef, continuousAxis, encodingWithoutContinuousAxis, ticksOrient, markDef, outerSpec, tooltipEncoding } = errorBarParams(spec, ERRORBAR, config);
    delete encodingWithoutContinuousAxis.size;
    const makeErrorBarPart = (0, _common.makeCompositeAggregatePartFactory)(markDef, continuousAxis, continuousAxisChannelDef, encodingWithoutContinuousAxis, config.errorbar);
    const thickness = markDef.thickness;
    const size = markDef.size;
    const tick = {
        type: 'tick',
        orient: ticksOrient,
        aria: false,
        ...thickness !== undefined ? {
            thickness
        } : {},
        ...size !== undefined ? {
            size
        } : {}
    };
    const layer = [
        ...makeErrorBarPart({
            partName: 'ticks',
            mark: tick,
            positionPrefix: 'lower',
            extraEncoding: tooltipEncoding
        }),
        ...makeErrorBarPart({
            partName: 'ticks',
            mark: tick,
            positionPrefix: 'upper',
            extraEncoding: tooltipEncoding
        }),
        ...makeErrorBarPart({
            partName: 'rule',
            mark: {
                type: 'rule',
                ariaRoleDescription: 'errorbar',
                ...thickness !== undefined ? {
                    size: thickness
                } : {}
            },
            positionPrefix: 'lower',
            endPositionPrefix: 'upper',
            extraEncoding: tooltipEncoding
        })
    ];
    return {
        ...outerSpec,
        transform,
        ...layer.length > 1 ? {
            layer
        } : {
            ...layer[0]
        }
    };
}
function errorBarOrientAndInputType(spec, compositeMark) {
    const { encoding } = spec;
    if (errorBarIsInputTypeRaw(encoding)) return {
        orient: (0, _common.compositeMarkOrient)(spec, compositeMark),
        inputType: 'raw'
    };
    const isTypeAggregatedUpperLower = errorBarIsInputTypeAggregatedUpperLower(encoding);
    const isTypeAggregatedError = errorBarIsInputTypeAggregatedError(encoding);
    const x = encoding.x;
    const y = encoding.y;
    if (isTypeAggregatedUpperLower) {
        // type is aggregated-upper-lower
        if (isTypeAggregatedError) throw new Error(`${compositeMark} cannot be both type aggregated-upper-lower and aggregated-error`);
        const x2 = encoding.x2;
        const y2 = encoding.y2;
        if ((0, _channeldef.isFieldOrDatumDef)(x2) && (0, _channeldef.isFieldOrDatumDef)(y2)) // having both x, x2 and y, y2
        throw new Error(`${compositeMark} cannot have both x2 and y2`);
        else if ((0, _channeldef.isFieldOrDatumDef)(x2)) {
            if ((0, _channeldef.isContinuousFieldOrDatumDef)(x)) // having x, x2 quantitative and field y, y2 are not specified
            return {
                orient: 'horizontal',
                inputType: 'aggregated-upper-lower'
            };
            else // having x, x2 that are not both quantitative
            throw new Error(`Both x and x2 have to be quantitative in ${compositeMark}`);
        } else if ((0, _channeldef.isFieldOrDatumDef)(y2)) {
            // y2 is a FieldDef
            if ((0, _channeldef.isContinuousFieldOrDatumDef)(y)) // having y, y2 quantitative and field x, x2 are not specified
            return {
                orient: 'vertical',
                inputType: 'aggregated-upper-lower'
            };
            else // having y, y2 that are not both quantitative
            throw new Error(`Both y and y2 have to be quantitative in ${compositeMark}`);
        }
        throw new Error('No ranged axis');
    } else {
        // type is aggregated-error
        const xError = encoding.xError;
        const xError2 = encoding.xError2;
        const yError = encoding.yError;
        const yError2 = encoding.yError2;
        if ((0, _channeldef.isFieldOrDatumDef)(xError2) && !(0, _channeldef.isFieldOrDatumDef)(xError)) // having xError2 without xError
        throw new Error(`${compositeMark} cannot have xError2 without xError`);
        if ((0, _channeldef.isFieldOrDatumDef)(yError2) && !(0, _channeldef.isFieldOrDatumDef)(yError)) // having yError2 without yError
        throw new Error(`${compositeMark} cannot have yError2 without yError`);
        if ((0, _channeldef.isFieldOrDatumDef)(xError) && (0, _channeldef.isFieldOrDatumDef)(yError)) // having both xError and yError
        throw new Error(`${compositeMark} cannot have both xError and yError with both are quantiative`);
        else if ((0, _channeldef.isFieldOrDatumDef)(xError)) {
            if ((0, _channeldef.isContinuousFieldOrDatumDef)(x)) // having x and xError that are all quantitative
            return {
                orient: 'horizontal',
                inputType: 'aggregated-error'
            };
            else // having x, xError, and xError2 that are not all quantitative
            throw new Error('All x, xError, and xError2 (if exist) have to be quantitative');
        } else if ((0, _channeldef.isFieldOrDatumDef)(yError)) {
            if ((0, _channeldef.isContinuousFieldOrDatumDef)(y)) // having y and yError that are all quantitative
            return {
                orient: 'vertical',
                inputType: 'aggregated-error'
            };
            else // having y, yError, and yError2 that are not all quantitative
            throw new Error('All y, yError, and yError2 (if exist) have to be quantitative');
        }
        throw new Error('No ranged axis');
    }
}
function errorBarIsInputTypeRaw(encoding) {
    return ((0, _channeldef.isFieldOrDatumDef)(encoding.x) || (0, _channeldef.isFieldOrDatumDef)(encoding.y)) && !(0, _channeldef.isFieldOrDatumDef)(encoding.x2) && !(0, _channeldef.isFieldOrDatumDef)(encoding.y2) && !(0, _channeldef.isFieldOrDatumDef)(encoding.xError) && !(0, _channeldef.isFieldOrDatumDef)(encoding.xError2) && !(0, _channeldef.isFieldOrDatumDef)(encoding.yError) && !(0, _channeldef.isFieldOrDatumDef)(encoding.yError2);
}
function errorBarIsInputTypeAggregatedUpperLower(encoding) {
    return (0, _channeldef.isFieldOrDatumDef)(encoding.x2) || (0, _channeldef.isFieldOrDatumDef)(encoding.y2);
}
function errorBarIsInputTypeAggregatedError(encoding) {
    return (0, _channeldef.isFieldOrDatumDef)(encoding.xError) || (0, _channeldef.isFieldOrDatumDef)(encoding.xError2) || (0, _channeldef.isFieldOrDatumDef)(encoding.yError) || (0, _channeldef.isFieldOrDatumDef)(encoding.yError2);
}
function errorBarParams(spec, compositeMark, config) {
    // TODO: use selection
    const { mark, encoding, params, projection: _p, ...outerSpec } = spec;
    const markDef = (0, _mark.isMarkDef)(mark) ? mark : {
        type: mark
    };
    // TODO(https://github.com/vega/vega-lite/issues/3702): add selection support
    if (params) _log.warn(_log.message.selectionNotSupported(compositeMark));
    const { orient, inputType } = errorBarOrientAndInputType(spec, compositeMark);
    const { continuousAxisChannelDef, continuousAxisChannelDef2, continuousAxisChannelDefError, continuousAxisChannelDefError2, continuousAxis } = (0, _common.compositeMarkContinuousAxis)(spec, orient, compositeMark);
    const { errorBarSpecificAggregate, postAggregateCalculates, tooltipSummary, tooltipTitleWithFieldName } = errorBarAggregationAndCalculation(markDef, continuousAxisChannelDef, continuousAxisChannelDef2, continuousAxisChannelDefError, continuousAxisChannelDefError2, inputType, compositeMark, config);
    const { [continuousAxis]: oldContinuousAxisChannelDef, [continuousAxis === 'x' ? 'x2' : 'y2']: oldContinuousAxisChannelDef2, [continuousAxis === 'x' ? 'xError' : 'yError']: oldContinuousAxisChannelDefError, [continuousAxis === 'x' ? 'xError2' : 'yError2']: oldContinuousAxisChannelDefError2, ...oldEncodingWithoutContinuousAxis } = encoding;
    const { bins, timeUnits, aggregate: oldAggregate, groupby: oldGroupBy, encoding: encodingWithoutContinuousAxis } = (0, _encoding.extractTransformsFromEncoding)(oldEncodingWithoutContinuousAxis, config);
    const aggregate = [
        ...oldAggregate,
        ...errorBarSpecificAggregate
    ];
    const groupby = inputType !== 'raw' ? [] : oldGroupBy;
    const tooltipEncoding = (0, _common.getCompositeMarkTooltip)(tooltipSummary, continuousAxisChannelDef, encodingWithoutContinuousAxis, tooltipTitleWithFieldName);
    return {
        transform: [
            ...outerSpec.transform ?? [],
            ...bins,
            ...timeUnits,
            ...aggregate.length === 0 ? [] : [
                {
                    aggregate,
                    groupby
                }
            ],
            ...postAggregateCalculates
        ],
        groupby,
        continuousAxisChannelDef,
        continuousAxis,
        encodingWithoutContinuousAxis,
        ticksOrient: orient === 'vertical' ? 'horizontal' : 'vertical',
        markDef,
        outerSpec,
        tooltipEncoding
    };
}
function errorBarAggregationAndCalculation(markDef, continuousAxisChannelDef, continuousAxisChannelDef2, continuousAxisChannelDefError, continuousAxisChannelDefError2, inputType, compositeMark, config) {
    let errorBarSpecificAggregate = [];
    let postAggregateCalculates = [];
    const continuousFieldName = continuousAxisChannelDef.field;
    let tooltipSummary;
    let tooltipTitleWithFieldName = false;
    if (inputType === 'raw') {
        const center = markDef.center ? markDef.center : markDef.extent ? markDef.extent === 'iqr' ? 'median' : 'mean' : config.errorbar.center;
        const extent = markDef.extent ? markDef.extent : center === 'mean' ? 'stderr' : 'iqr';
        if (center === 'median' !== (extent === 'iqr')) _log.warn(_log.message.errorBarCenterIsUsedWithWrongExtent(center, extent, compositeMark));
        if (extent === 'stderr' || extent === 'stdev') {
            errorBarSpecificAggregate = [
                {
                    op: extent,
                    field: continuousFieldName,
                    as: `extent_${continuousFieldName}`
                },
                {
                    op: center,
                    field: continuousFieldName,
                    as: `center_${continuousFieldName}`
                }
            ];
            postAggregateCalculates = [
                {
                    calculate: `${(0, _util.accessWithDatumToUnescapedPath)(`center_${continuousFieldName}`)} + ${(0, _util.accessWithDatumToUnescapedPath)(`extent_${continuousFieldName}`)}`,
                    as: `upper_${continuousFieldName}`
                },
                {
                    calculate: `${(0, _util.accessWithDatumToUnescapedPath)(`center_${continuousFieldName}`)} - ${(0, _util.accessWithDatumToUnescapedPath)(`extent_${continuousFieldName}`)}`,
                    as: `lower_${continuousFieldName}`
                }
            ];
            tooltipSummary = [
                {
                    fieldPrefix: 'center_',
                    titlePrefix: (0, _util.titleCase)(center)
                },
                {
                    fieldPrefix: 'upper_',
                    titlePrefix: getTitlePrefix(center, extent, '+')
                },
                {
                    fieldPrefix: 'lower_',
                    titlePrefix: getTitlePrefix(center, extent, '-')
                }
            ];
            tooltipTitleWithFieldName = true;
        } else {
            let centerOp;
            let lowerExtentOp;
            let upperExtentOp;
            if (extent === 'ci') {
                centerOp = 'mean';
                lowerExtentOp = 'ci0';
                upperExtentOp = 'ci1';
            } else {
                centerOp = 'median';
                lowerExtentOp = 'q1';
                upperExtentOp = 'q3';
            }
            errorBarSpecificAggregate = [
                {
                    op: lowerExtentOp,
                    field: continuousFieldName,
                    as: `lower_${continuousFieldName}`
                },
                {
                    op: upperExtentOp,
                    field: continuousFieldName,
                    as: `upper_${continuousFieldName}`
                },
                {
                    op: centerOp,
                    field: continuousFieldName,
                    as: `center_${continuousFieldName}`
                }
            ];
            tooltipSummary = [
                {
                    fieldPrefix: 'upper_',
                    titlePrefix: (0, _channeldef.title)({
                        field: continuousFieldName,
                        aggregate: upperExtentOp,
                        type: 'quantitative'
                    }, config, {
                        allowDisabling: false
                    })
                },
                {
                    fieldPrefix: 'lower_',
                    titlePrefix: (0, _channeldef.title)({
                        field: continuousFieldName,
                        aggregate: lowerExtentOp,
                        type: 'quantitative'
                    }, config, {
                        allowDisabling: false
                    })
                },
                {
                    fieldPrefix: 'center_',
                    titlePrefix: (0, _channeldef.title)({
                        field: continuousFieldName,
                        aggregate: centerOp,
                        type: 'quantitative'
                    }, config, {
                        allowDisabling: false
                    })
                }
            ];
        }
    } else {
        if (markDef.center || markDef.extent) _log.warn(_log.message.errorBarCenterAndExtentAreNotNeeded(markDef.center, markDef.extent));
        if (inputType === 'aggregated-upper-lower') {
            tooltipSummary = [];
            postAggregateCalculates = [
                {
                    calculate: (0, _util.accessWithDatumToUnescapedPath)(continuousAxisChannelDef2.field),
                    as: `upper_${continuousFieldName}`
                },
                {
                    calculate: (0, _util.accessWithDatumToUnescapedPath)(continuousFieldName),
                    as: `lower_${continuousFieldName}`
                }
            ];
        } else if (inputType === 'aggregated-error') {
            tooltipSummary = [
                {
                    fieldPrefix: '',
                    titlePrefix: continuousFieldName
                }
            ];
            postAggregateCalculates = [
                {
                    calculate: `${(0, _util.accessWithDatumToUnescapedPath)(continuousFieldName)} + ${(0, _util.accessWithDatumToUnescapedPath)(continuousAxisChannelDefError.field)}`,
                    as: `upper_${continuousFieldName}`
                }
            ];
            if (continuousAxisChannelDefError2) postAggregateCalculates.push({
                calculate: `${(0, _util.accessWithDatumToUnescapedPath)(continuousFieldName)} + ${(0, _util.accessWithDatumToUnescapedPath)(continuousAxisChannelDefError2.field)}`,
                as: `lower_${continuousFieldName}`
            });
            else postAggregateCalculates.push({
                calculate: `${(0, _util.accessWithDatumToUnescapedPath)(continuousFieldName)} - ${(0, _util.accessWithDatumToUnescapedPath)(continuousAxisChannelDefError.field)}`,
                as: `lower_${continuousFieldName}`
            });
        }
        for (const postAggregateCalculate of postAggregateCalculates)tooltipSummary.push({
            fieldPrefix: postAggregateCalculate.as.substring(0, 6),
            titlePrefix: (0, _util.replaceAll)((0, _util.replaceAll)(postAggregateCalculate.calculate, "datum['", ''), "']", '')
        });
    }
    return {
        postAggregateCalculates,
        errorBarSpecificAggregate,
        tooltipSummary,
        tooltipTitleWithFieldName
    };
}
function getTitlePrefix(center, extent, operation) {
    return `${(0, _util.titleCase)(center)} ${operation} ${extent}`;
}

},{"../channeldef":"dsccb","../encoding":"2Ohsj","../log":"loqTw","../mark":"3Z1xx","../util":"acUGA","./base":"jVVvX","./common":"2TkZH","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"b5Aps":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VL_ONLY_LEGEND_CONFIG", ()=>VL_ONLY_LEGEND_CONFIG);
const VL_ONLY_LEGEND_CONFIG = [
    'gradientHorizontalMaxLength',
    'gradientHorizontalMinLength',
    'gradientVerticalMaxLength',
    'gradientVerticalMinLength',
    'unselectedOpacity'
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"17rRI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HEADER_TITLE_PROPERTIES_MAP", ()=>HEADER_TITLE_PROPERTIES_MAP);
parcelHelpers.export(exports, "HEADER_LABEL_PROPERTIES_MAP", ()=>HEADER_LABEL_PROPERTIES_MAP);
parcelHelpers.export(exports, "HEADER_TITLE_PROPERTIES", ()=>HEADER_TITLE_PROPERTIES);
parcelHelpers.export(exports, "HEADER_LABEL_PROPERTIES", ()=>HEADER_LABEL_PROPERTIES);
parcelHelpers.export(exports, "HEADER_CONFIGS", ()=>HEADER_CONFIGS);
var _util = require("./util");
const HEADER_TITLE_PROPERTIES_MAP = {
    titleAlign: 'align',
    titleAnchor: 'anchor',
    titleAngle: 'angle',
    titleBaseline: 'baseline',
    titleColor: 'color',
    titleFont: 'font',
    titleFontSize: 'fontSize',
    titleFontStyle: 'fontStyle',
    titleFontWeight: 'fontWeight',
    titleLimit: 'limit',
    titleLineHeight: 'lineHeight',
    titleOrient: 'orient',
    titlePadding: 'offset'
};
const HEADER_LABEL_PROPERTIES_MAP = {
    labelAlign: 'align',
    labelAnchor: 'anchor',
    labelAngle: 'angle',
    labelBaseline: 'baseline',
    labelColor: 'color',
    labelFont: 'font',
    labelFontSize: 'fontSize',
    labelFontStyle: 'fontStyle',
    labelFontWeight: 'fontWeight',
    labelLimit: 'limit',
    labelLineHeight: 'lineHeight',
    labelOrient: 'orient',
    labelPadding: 'offset'
};
const HEADER_TITLE_PROPERTIES = (0, _util.keys)(HEADER_TITLE_PROPERTIES_MAP);
const HEADER_LABEL_PROPERTIES = (0, _util.keys)(HEADER_LABEL_PROPERTIES_MAP);
const HEADER_CONFIGS_INDEX = {
    header: 1,
    headerRow: 1,
    headerColumn: 1,
    headerFacet: 1
};
const HEADER_CONFIGS = (0, _util.keys)(HEADER_CONFIGS_INDEX);

},{"./util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"wjMIJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LEGEND_SCALE_CHANNELS", ()=>LEGEND_SCALE_CHANNELS);
parcelHelpers.export(exports, "defaultLegendConfig", ()=>defaultLegendConfig);
parcelHelpers.export(exports, "COMMON_LEGEND_PROPERTY_INDEX", ()=>COMMON_LEGEND_PROPERTY_INDEX);
parcelHelpers.export(exports, "LEGEND_PROPERTIES", ()=>LEGEND_PROPERTIES);
var _util = require("./util");
const LEGEND_SCALE_CHANNELS = [
    'size',
    'shape',
    'fill',
    'stroke',
    'strokeDash',
    'strokeWidth',
    'opacity'
];
const defaultLegendConfig = {
    gradientHorizontalMaxLength: 200,
    gradientHorizontalMinLength: 100,
    gradientVerticalMaxLength: 200,
    gradientVerticalMinLength: 64,
    unselectedOpacity: 0.35
};
const COMMON_LEGEND_PROPERTY_INDEX = {
    aria: 1,
    clipHeight: 1,
    columnPadding: 1,
    columns: 1,
    cornerRadius: 1,
    description: 1,
    direction: 1,
    fillColor: 1,
    format: 1,
    formatType: 1,
    gradientLength: 1,
    gradientOpacity: 1,
    gradientStrokeColor: 1,
    gradientStrokeWidth: 1,
    gradientThickness: 1,
    gridAlign: 1,
    labelAlign: 1,
    labelBaseline: 1,
    labelColor: 1,
    labelFont: 1,
    labelFontSize: 1,
    labelFontStyle: 1,
    labelFontWeight: 1,
    labelLimit: 1,
    labelOffset: 1,
    labelOpacity: 1,
    labelOverlap: 1,
    labelPadding: 1,
    labelSeparation: 1,
    legendX: 1,
    legendY: 1,
    offset: 1,
    orient: 1,
    padding: 1,
    rowPadding: 1,
    strokeColor: 1,
    symbolDash: 1,
    symbolDashOffset: 1,
    symbolFillColor: 1,
    symbolLimit: 1,
    symbolOffset: 1,
    symbolOpacity: 1,
    symbolSize: 1,
    symbolStrokeColor: 1,
    symbolStrokeWidth: 1,
    symbolType: 1,
    tickCount: 1,
    tickMinStep: 1,
    title: 1,
    titleAlign: 1,
    titleAnchor: 1,
    titleBaseline: 1,
    titleColor: 1,
    titleFont: 1,
    titleFontSize: 1,
    titleFontStyle: 1,
    titleFontWeight: 1,
    titleLimit: 1,
    titleLineHeight: 1,
    titleOpacity: 1,
    titleOrient: 1,
    titlePadding: 1,
    type: 1,
    values: 1,
    zindex: 1
};
const LEGEND_PROPERTIES = (0, _util.keys)(COMMON_LEGEND_PROPERTY_INDEX);

},{"./util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"arxqh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assembleParameterSignals", ()=>assembleParameterSignals);
var _selection = require("./selection");
function assembleParameterSignals(params) {
    const signals = [];
    for (const param of params || []){
        // Selection parameters are handled separately via assembleSelectionTopLevelSignals
        // and assembleSignals methods registered on the Model.
        if ((0, _selection.isSelectionParameter)(param)) continue;
        const { expr, bind, ...rest } = param;
        if (bind && expr) {
            // Vega's InitSignal -- apply expr to "init"
            const signal = {
                ...rest,
                bind,
                init: expr
            };
            signals.push(signal);
        } else {
            const signal = {
                ...rest,
                ...expr ? {
                    update: expr
                } : {},
                ...bind ? {
                    bind
                } : {}
            };
            signals.push(signal);
        }
    }
    return signals;
}

},{"./selection":"jtWSq","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"jtWSq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SELECTION_ID", ()=>SELECTION_ID);
parcelHelpers.export(exports, "defaultConfig", ()=>defaultConfig);
parcelHelpers.export(exports, "isLegendBinding", ()=>isLegendBinding);
parcelHelpers.export(exports, "isLegendStreamBinding", ()=>isLegendStreamBinding);
parcelHelpers.export(exports, "isSelectionParameter", ()=>isSelectionParameter);
var _vegaUtil = require("vega-util");
const SELECTION_ID = '_vgsid_';
const defaultConfig = {
    point: {
        on: 'click',
        fields: [
            SELECTION_ID
        ],
        toggle: 'event.shiftKey',
        resolve: 'global',
        clear: 'dblclick'
    },
    interval: {
        on: '[pointerdown, window:pointerup] > window:pointermove!',
        encodings: [
            'x',
            'y'
        ],
        translate: '[pointerdown, window:pointerup] > window:pointermove!',
        zoom: 'wheel!',
        mark: {
            fill: '#333',
            fillOpacity: 0.125,
            stroke: 'white'
        },
        resolve: 'global',
        clear: 'dblclick'
    }
};
function isLegendBinding(bind) {
    return bind === 'legend' || !!bind?.legend;
}
function isLegendStreamBinding(bind) {
    return isLegendBinding(bind) && (0, _vegaUtil.isObject)(bind);
}
function isSelectionParameter(param) {
    return !!param?.['select'];
}

},{"vega-util":"7f6sQ","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5uH6T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStepFor", ()=>getStepFor);
parcelHelpers.export(exports, "isStep", ()=>isStep);
parcelHelpers.export(exports, "isFrameMixins", ()=>isFrameMixins);
parcelHelpers.export(exports, "DEFAULT_SPACING", ()=>DEFAULT_SPACING);
parcelHelpers.export(exports, "extractCompositionLayout", ()=>extractCompositionLayout);
var _vegaUtil = require("vega-util");
var _util = require("../util");
var _concat = require("./concat");
var _facet = require("./facet");
function getStepFor({ step, offsetIsDiscrete }) {
    if (offsetIsDiscrete) return step.for ?? 'offset';
    else return 'position';
}
function isStep(size) {
    return (0, _util.hasProperty)(size, 'step');
}
function isFrameMixins(o) {
    return (0, _util.hasProperty)(o, 'view') || (0, _util.hasProperty)(o, 'width') || (0, _util.hasProperty)(o, 'height');
}
const DEFAULT_SPACING = 20;
const COMPOSITION_LAYOUT_INDEX = {
    align: 1,
    bounds: 1,
    center: 1,
    columns: 1,
    spacing: 1
};
const COMPOSITION_LAYOUT_PROPERTIES = (0, _util.keys)(COMPOSITION_LAYOUT_INDEX);
function extractCompositionLayout(spec, specType, config) {
    const compositionConfig = config[specType];
    const layout = {};
    // Apply config first
    const { spacing: spacingConfig, columns } = compositionConfig;
    if (spacingConfig !== undefined) layout.spacing = spacingConfig;
    if (columns !== undefined) {
        if ((0, _facet.isFacetSpec)(spec) && !(0, _facet.isFacetMapping)(spec.facet) || (0, _concat.isConcatSpec)(spec)) layout.columns = columns;
    }
    if ((0, _concat.isVConcatSpec)(spec)) layout.columns = 1;
    // Then copy properties from the spec
    for (const prop of COMPOSITION_LAYOUT_PROPERTIES)if (spec[prop] !== undefined) {
        if (prop === 'spacing') {
            const spacing = spec[prop];
            layout[prop] = (0, _vegaUtil.isNumber)(spacing) ? spacing : {
                row: spacing.row ?? spacingConfig,
                column: spacing.column ?? spacingConfig
            };
        } else layout[prop] = spec[prop];
    }
    return layout;
}

},{"vega-util":"7f6sQ","../util":"acUGA","./concat":"c5trE","./facet":"3pm05","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"c5trE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAnyConcatSpec", ()=>isAnyConcatSpec);
parcelHelpers.export(exports, "isConcatSpec", ()=>isConcatSpec);
parcelHelpers.export(exports, "isVConcatSpec", ()=>isVConcatSpec);
parcelHelpers.export(exports, "isHConcatSpec", ()=>isHConcatSpec);
var _util = require("../util");
function isAnyConcatSpec(spec) {
    return isVConcatSpec(spec) || isHConcatSpec(spec) || isConcatSpec(spec);
}
function isConcatSpec(spec) {
    return (0, _util.hasProperty)(spec, 'concat');
}
function isVConcatSpec(spec) {
    return (0, _util.hasProperty)(spec, 'vconcat');
}
function isHConcatSpec(spec) {
    return (0, _util.hasProperty)(spec, 'hconcat');
}

},{"../util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"9Cce5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalize", ()=>normalize);
/**
 * Normalize autosize and deal with width or height == "container".
 */ parcelHelpers.export(exports, "normalizeAutoSize", ()=>normalizeAutoSize);
var _vegaUtil = require("vega-util");
var _config = require("../config");
var _log = require("../log");
var _spec = require("../spec");
var _util = require("../util");
var _core = require("./core");
var _selectioncompat = require("./selectioncompat");
var _toplevelselection = require("./toplevelselection");
function normalize(spec, config) {
    if (config === undefined) config = (0, _config.initConfig)(spec.config);
    const normalizedSpec = normalizeGenericSpec(spec, config);
    const { width, height } = spec;
    const autosize = normalizeAutoSize(normalizedSpec, {
        width,
        height,
        autosize: spec.autosize
    }, config);
    return {
        ...normalizedSpec,
        ...autosize ? {
            autosize
        } : {}
    };
}
const coreNormalizer = new (0, _core.CoreNormalizer)();
const selectionCompatNormalizer = new (0, _selectioncompat.SelectionCompatibilityNormalizer)();
const topLevelSelectionNormalizer = new (0, _toplevelselection.TopLevelSelectionsNormalizer)();
/**
 * Decompose extended unit specs into composition of pure unit specs.
 * And push top-level selection definitions down to unit specs.
 */ function normalizeGenericSpec(spec, config = {}) {
    const normParams = {
        config
    };
    return topLevelSelectionNormalizer.map(coreNormalizer.map(selectionCompatNormalizer.map(spec, normParams), normParams), normParams);
}
function _normalizeAutoSize(autosize) {
    return (0, _vegaUtil.isString)(autosize) ? {
        type: autosize
    } : autosize ?? {};
}
function normalizeAutoSize(spec, sizeInfo, config) {
    let { width, height } = sizeInfo;
    const isFitCompatible = (0, _spec.isUnitSpec)(spec) || (0, _spec.isLayerSpec)(spec);
    const autosizeDefault = {};
    if (!isFitCompatible) {
        // If spec is not compatible with autosize == "fit", discard width/height == container
        if (width == 'container') {
            _log.warn(_log.message.containerSizeNonSingle('width'));
            width = undefined;
        }
        if (height == 'container') {
            _log.warn(_log.message.containerSizeNonSingle('height'));
            height = undefined;
        }
    } else {
        // Default autosize parameters to fit when width/height is "container"
        if (width == 'container' && height == 'container') {
            autosizeDefault.type = 'fit';
            autosizeDefault.contains = 'padding';
        } else if (width == 'container') {
            autosizeDefault.type = 'fit-x';
            autosizeDefault.contains = 'padding';
        } else if (height == 'container') {
            autosizeDefault.type = 'fit-y';
            autosizeDefault.contains = 'padding';
        }
    }
    const autosize = {
        type: 'pad',
        ...autosizeDefault,
        ...config ? _normalizeAutoSize(config.autosize) : {},
        ..._normalizeAutoSize(spec.autosize)
    };
    if (autosize.type === 'fit' && !isFitCompatible) {
        _log.warn(_log.message.FIT_NON_SINGLE);
        autosize.type = 'pad';
    }
    if (width == 'container' && !(autosize.type == 'fit' || autosize.type == 'fit-x')) _log.warn(_log.message.containerSizeNotCompatibleWithAutosize('width'));
    if (height == 'container' && !(autosize.type == 'fit' || autosize.type == 'fit-y')) _log.warn(_log.message.containerSizeNotCompatibleWithAutosize('height'));
    // Delete autosize property if it's Vega's default
    if ((0, _util.deepEqual)(autosize, {
        type: 'pad'
    })) return undefined;
    return autosize;
}

},{"vega-util":"7f6sQ","../config":"8TUzf","../log":"loqTw","../spec":"5gjAD","../util":"acUGA","./core":"bLPRs","./selectioncompat":"7yqnU","./toplevelselection":"9JeOM","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5gjAD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAnyConcatSpec", ()=>(0, _concat.isAnyConcatSpec));
parcelHelpers.export(exports, "isHConcatSpec", ()=>(0, _concat.isHConcatSpec));
parcelHelpers.export(exports, "isVConcatSpec", ()=>(0, _concat.isVConcatSpec));
parcelHelpers.export(exports, "isFacetSpec", ()=>(0, _facet.isFacetSpec));
parcelHelpers.export(exports, "isLayerSpec", ()=>(0, _layer.isLayerSpec));
parcelHelpers.export(exports, "isRepeatSpec", ()=>(0, _repeat.isRepeatSpec));
parcelHelpers.export(exports, "isUnitSpec", ()=>(0, _unit.isUnitSpec));
var _concat = require("./concat");
var _facet = require("./facet");
var _layer = require("./layer");
var _repeat = require("./repeat");
var _unit = require("./unit");

},{"./concat":"c5trE","./facet":"3pm05","./layer":"5hxG5","./repeat":"64wq7","./unit":"eKdDP","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5hxG5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isLayerSpec", ()=>isLayerSpec);
var _util = require("../util");
function isLayerSpec(spec) {
    return (0, _util.hasProperty)(spec, 'layer');
}

},{"../util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"64wq7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRepeatSpec", ()=>isRepeatSpec);
parcelHelpers.export(exports, "isLayerRepeatSpec", ()=>isLayerRepeatSpec);
var _vegaUtil = require("vega-util");
var _util = require("../util");
function isRepeatSpec(spec) {
    return (0, _util.hasProperty)(spec, 'repeat');
}
function isLayerRepeatSpec(spec) {
    return !(0, _vegaUtil.isArray)(spec.repeat) && (0, _util.hasProperty)(spec.repeat, 'layer');
}

},{"vega-util":"7f6sQ","../util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bLPRs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CoreNormalizer", ()=>CoreNormalizer);
var _vegaUtil = require("vega-util");
var _channel = require("../channel");
var _channeldef = require("../channeldef");
var _boxplot = require("../compositemark/boxplot");
var _errorband = require("../compositemark/errorband");
var _errorbar = require("../compositemark/errorbar");
var _encoding = require("../encoding");
var _log = require("../log");
var _facet = require("../spec/facet");
var _map = require("../spec/map");
var _repeat = require("../spec/repeat");
var _unit = require("../spec/unit");
var _util = require("../util");
var _vegaSchema = require("../vega.schema");
var _pathoverlay = require("./pathoverlay");
var _repeater = require("./repeater");
var _ruleforrangedline = require("./ruleforrangedline");
class CoreNormalizer extends (0, _map.SpecMapper) {
    constructor(){
        super(...arguments);
        this.nonFacetUnitNormalizers = [
            (0, _boxplot.boxPlotNormalizer),
            (0, _errorbar.errorBarNormalizer),
            (0, _errorband.errorBandNormalizer),
            new (0, _pathoverlay.PathOverlayNormalizer)(),
            new (0, _ruleforrangedline.RuleForRangedLineNormalizer)()
        ];
    }
    map(spec, params) {
        // Special handling for a faceted unit spec as it can return a facet spec, not just a layer or unit spec like a normal unit spec.
        if ((0, _unit.isUnitSpec)(spec)) {
            const hasRow = (0, _encoding.channelHasField)(spec.encoding, (0, _channel.ROW));
            const hasColumn = (0, _encoding.channelHasField)(spec.encoding, (0, _channel.COLUMN));
            const hasFacet = (0, _encoding.channelHasField)(spec.encoding, (0, _channel.FACET));
            if (hasRow || hasColumn || hasFacet) return this.mapFacetedUnit(spec, params);
        }
        return super.map(spec, params);
    }
    // This is for normalizing non-facet unit
    mapUnit(spec, params) {
        const { parentEncoding, parentProjection } = params;
        const encoding = (0, _repeater.replaceRepeaterInEncoding)(spec.encoding, params.repeater);
        const specWithReplacedEncoding = {
            ...spec,
            ...spec.name ? {
                name: [
                    params.repeaterPrefix,
                    spec.name
                ].filter((n)=>n).join('_')
            } : {},
            ...encoding ? {
                encoding
            } : {}
        };
        if (parentEncoding || parentProjection) return this.mapUnitWithParentEncodingOrProjection(specWithReplacedEncoding, params);
        const normalizeLayerOrUnit = this.mapLayerOrUnit.bind(this);
        for (const unitNormalizer of this.nonFacetUnitNormalizers){
            if (unitNormalizer.hasMatchingType(specWithReplacedEncoding, params.config)) return unitNormalizer.run(specWithReplacedEncoding, params, normalizeLayerOrUnit);
        }
        return specWithReplacedEncoding;
    }
    mapRepeat(spec, params) {
        if ((0, _repeat.isLayerRepeatSpec)(spec)) return this.mapLayerRepeat(spec, params);
        else return this.mapNonLayerRepeat(spec, params);
    }
    mapLayerRepeat(spec, params) {
        const { repeat, spec: childSpec, ...rest } = spec;
        const { row, column, layer } = repeat;
        const { repeater = {}, repeaterPrefix = '' } = params;
        if (row || column) return this.mapRepeat({
            ...spec,
            repeat: {
                ...row ? {
                    row
                } : {},
                ...column ? {
                    column
                } : {}
            },
            spec: {
                repeat: {
                    layer
                },
                spec: childSpec
            }
        }, params);
        else return {
            ...rest,
            layer: layer.map((layerValue)=>{
                const childRepeater = {
                    ...repeater,
                    layer: layerValue
                };
                const childName = `${(childSpec.name ? `${childSpec.name}_` : '') + repeaterPrefix}child__layer_${(0, _util.varName)(layerValue)}`;
                const child = this.mapLayerOrUnit(childSpec, {
                    ...params,
                    repeater: childRepeater,
                    repeaterPrefix: childName
                });
                child.name = childName;
                return child;
            })
        };
    }
    mapNonLayerRepeat(spec, params) {
        const { repeat, spec: childSpec, data, ...remainingProperties } = spec;
        if (!(0, _vegaUtil.isArray)(repeat) && spec.columns) {
            // is repeat with row/column
            spec = (0, _util.omit)(spec, [
                'columns'
            ]);
            _log.warn(_log.message.columnsNotSupportByRowCol('repeat'));
        }
        const concat = [];
        const { repeater = {}, repeaterPrefix = '' } = params;
        const row = !(0, _vegaUtil.isArray)(repeat) && repeat.row || [
            repeater ? repeater.row : null
        ];
        const column = !(0, _vegaUtil.isArray)(repeat) && repeat.column || [
            repeater ? repeater.column : null
        ];
        const repeatValues = (0, _vegaUtil.isArray)(repeat) && repeat || [
            repeater ? repeater.repeat : null
        ];
        // cross product
        for (const repeatValue of repeatValues){
            for (const rowValue of row)for (const columnValue of column){
                const childRepeater = {
                    repeat: repeatValue,
                    row: rowValue,
                    column: columnValue,
                    layer: repeater.layer
                };
                const childName = (childSpec.name ? `${childSpec.name}_` : '') + repeaterPrefix + 'child__' + ((0, _vegaUtil.isArray)(repeat) ? `${(0, _util.varName)(repeatValue)}` : (repeat.row ? `row_${(0, _util.varName)(rowValue)}` : '') + (repeat.column ? `column_${(0, _util.varName)(columnValue)}` : ''));
                const child = this.map(childSpec, {
                    ...params,
                    repeater: childRepeater,
                    repeaterPrefix: childName
                });
                child.name = childName;
                // we move data up
                concat.push((0, _util.omit)(child, [
                    'data'
                ]));
            }
        }
        const columns = (0, _vegaUtil.isArray)(repeat) ? spec.columns : repeat.column ? repeat.column.length : 1;
        return {
            data: childSpec.data ?? data,
            align: 'all',
            ...remainingProperties,
            columns,
            concat
        };
    }
    mapFacet(spec, params) {
        const { facet } = spec;
        if ((0, _facet.isFacetMapping)(facet) && spec.columns) {
            // is facet with row/column
            spec = (0, _util.omit)(spec, [
                'columns'
            ]);
            _log.warn(_log.message.columnsNotSupportByRowCol('facet'));
        }
        return super.mapFacet(spec, params);
    }
    mapUnitWithParentEncodingOrProjection(spec, params) {
        const { encoding, projection } = spec;
        const { parentEncoding, parentProjection, config } = params;
        const mergedProjection = mergeProjection({
            parentProjection,
            projection
        });
        const mergedEncoding = mergeEncoding({
            parentEncoding,
            encoding: (0, _repeater.replaceRepeaterInEncoding)(encoding, params.repeater)
        });
        return this.mapUnit({
            ...spec,
            ...mergedProjection ? {
                projection: mergedProjection
            } : {},
            ...mergedEncoding ? {
                encoding: mergedEncoding
            } : {}
        }, {
            config
        });
    }
    mapFacetedUnit(spec, normParams) {
        // New encoding in the inside spec should not contain row / column
        // as row/column should be moved to facet
        const { row, column, facet, ...encoding } = spec.encoding;
        // Mark and encoding should be moved into the inner spec
        const { mark, width, projection, height, view, params, encoding: _, ...outerSpec } = spec;
        const { facetMapping, layout } = this.getFacetMappingAndLayout({
            row,
            column,
            facet
        }, normParams);
        const newEncoding = (0, _repeater.replaceRepeaterInEncoding)(encoding, normParams.repeater);
        return this.mapFacet({
            ...outerSpec,
            ...layout,
            // row / column has higher precedence than facet
            facet: facetMapping,
            spec: {
                ...width ? {
                    width
                } : {},
                ...height ? {
                    height
                } : {},
                ...view ? {
                    view
                } : {},
                ...projection ? {
                    projection
                } : {},
                mark,
                encoding: newEncoding,
                ...params ? {
                    params
                } : {}
            }
        }, normParams);
    }
    getFacetMappingAndLayout(facets, params) {
        const { row, column, facet } = facets;
        if (row || column) {
            if (facet) _log.warn(_log.message.facetChannelDropped([
                ...row ? [
                    (0, _channel.ROW)
                ] : [],
                ...column ? [
                    (0, _channel.COLUMN)
                ] : []
            ]));
            const facetMapping = {};
            const layout = {};
            for (const channel of [
                (0, _channel.ROW),
                (0, _channel.COLUMN)
            ]){
                const def = facets[channel];
                if (def) {
                    const { align, center, spacing, columns, ...defWithoutLayout } = def;
                    facetMapping[channel] = defWithoutLayout;
                    for (const prop of [
                        'align',
                        'center',
                        'spacing'
                    ])if (def[prop] !== undefined) {
                        layout[prop] ?? (layout[prop] = {});
                        layout[prop][channel] = def[prop];
                    }
                }
            }
            return {
                facetMapping,
                layout
            };
        } else {
            const { align, center, spacing, columns, ...facetMapping } = facet;
            return {
                facetMapping: (0, _repeater.replaceRepeaterInFacet)(facetMapping, params.repeater),
                layout: {
                    ...align ? {
                        align
                    } : {},
                    ...center ? {
                        center
                    } : {},
                    ...spacing ? {
                        spacing
                    } : {},
                    ...columns ? {
                        columns
                    } : {}
                }
            };
        }
    }
    mapLayer(spec, { parentEncoding, parentProjection, ...otherParams }) {
        // Special handling for extended layer spec
        const { encoding, projection, ...rest } = spec;
        const params = {
            ...otherParams,
            parentEncoding: mergeEncoding({
                parentEncoding,
                encoding,
                layer: true
            }),
            parentProjection: mergeProjection({
                parentProjection,
                projection
            })
        };
        return super.mapLayer({
            ...rest,
            ...spec.name ? {
                name: [
                    params.repeaterPrefix,
                    spec.name
                ].filter((n)=>n).join('_')
            } : {}
        }, params);
    }
}
function mergeEncoding({ parentEncoding, encoding = {}, layer }) {
    let merged = {};
    if (parentEncoding) {
        const channels = new Set([
            ...(0, _util.keys)(parentEncoding),
            ...(0, _util.keys)(encoding)
        ]);
        for (const channel of channels){
            const channelDef = encoding[channel];
            const parentChannelDef = parentEncoding[channel];
            if ((0, _channeldef.isFieldOrDatumDef)(channelDef)) {
                // Field/Datum Def can inherit properties from its parent
                // Note that parentChannelDef doesn't have to be a field/datum def if the channelDef is already one.
                const mergedChannelDef = {
                    ...parentChannelDef,
                    ...channelDef
                };
                merged[channel] = mergedChannelDef;
            } else if ((0, _channeldef.hasConditionalFieldOrDatumDef)(channelDef)) merged[channel] = {
                ...channelDef,
                condition: {
                    ...parentChannelDef,
                    ...channelDef.condition
                }
            };
            else if (channelDef || channelDef === null) merged[channel] = channelDef;
            else if (layer || (0, _channeldef.isValueDef)(parentChannelDef) || (0, _vegaSchema.isSignalRef)(parentChannelDef) || (0, _channeldef.isFieldOrDatumDef)(parentChannelDef) || (0, _vegaUtil.isArray)(parentChannelDef)) merged[channel] = parentChannelDef;
        }
    } else merged = encoding;
    return !merged || (0, _util.isEmpty)(merged) ? undefined : merged;
}
function mergeProjection(opt) {
    const { parentProjection, projection } = opt;
    if (parentProjection && projection) _log.warn(_log.message.projectionOverridden({
        parentProjection,
        projection
    }));
    return projection ?? parentProjection;
}

},{"vega-util":"7f6sQ","../channel":"liLED","../channeldef":"dsccb","../compositemark/boxplot":"6f3ni","../compositemark/errorband":"fn7Pn","../compositemark/errorbar":"bSILL","../encoding":"2Ohsj","../log":"loqTw","../spec/facet":"3pm05","../spec/map":"8IUh5","../spec/repeat":"64wq7","../spec/unit":"eKdDP","../util":"acUGA","../vega.schema":"3mBOT","./pathoverlay":"aIhhw","./repeater":"fAgpf","./ruleforrangedline":"tHdAx","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8IUh5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SpecMapper", ()=>SpecMapper);
var _log = require("../log");
var _concat = require("./concat");
var _facet = require("./facet");
var _layer = require("./layer");
var _repeat = require("./repeat");
var _unit = require("./unit");
class SpecMapper {
    map(spec, params) {
        if ((0, _facet.isFacetSpec)(spec)) return this.mapFacet(spec, params);
        else if ((0, _repeat.isRepeatSpec)(spec)) return this.mapRepeat(spec, params);
        else if ((0, _concat.isHConcatSpec)(spec)) return this.mapHConcat(spec, params);
        else if ((0, _concat.isVConcatSpec)(spec)) return this.mapVConcat(spec, params);
        else if ((0, _concat.isConcatSpec)(spec)) return this.mapConcat(spec, params);
        else return this.mapLayerOrUnit(spec, params);
    }
    mapLayerOrUnit(spec, params) {
        if ((0, _layer.isLayerSpec)(spec)) return this.mapLayer(spec, params);
        else if ((0, _unit.isUnitSpec)(spec)) return this.mapUnit(spec, params);
        throw new Error(_log.message.invalidSpec(spec));
    }
    mapLayer(spec, params) {
        return {
            ...spec,
            layer: spec.layer.map((subspec)=>this.mapLayerOrUnit(subspec, params))
        };
    }
    mapHConcat(spec, params) {
        return {
            ...spec,
            hconcat: spec.hconcat.map((subspec)=>this.map(subspec, params))
        };
    }
    mapVConcat(spec, params) {
        return {
            ...spec,
            vconcat: spec.vconcat.map((subspec)=>this.map(subspec, params))
        };
    }
    mapConcat(spec, params) {
        const { concat, ...rest } = spec;
        return {
            ...rest,
            concat: concat.map((subspec)=>this.map(subspec, params))
        };
    }
    mapFacet(spec, params) {
        return {
            // as any is required here since TS cannot infer that FO may only be FieldName or Field, but not RepeatRef
            ...spec,
            // TODO: remove "any" once we support all facet listed in https://github.com/vega/vega-lite/issues/2760
            spec: this.map(spec.spec, params)
        };
    }
    mapRepeat(spec, params) {
        return {
            ...spec,
            // as any is required here since TS cannot infer that the output type satisfies the input type
            spec: this.map(spec.spec, params)
        };
    }
}

},{"../log":"loqTw","./concat":"c5trE","./facet":"3pm05","./layer":"5hxG5","./repeat":"64wq7","./unit":"eKdDP","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"aIhhw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PathOverlayNormalizer", ()=>PathOverlayNormalizer);
var _vegaUtil = require("vega-util");
var _encoding = require("../encoding");
var _mark = require("../mark");
var _unit = require("../spec/unit");
var _stack = require("../stack");
var _util = require("../util");
var _init = require("../compile/mark/init");
function dropLineAndPoint(markDef) {
    const { point: _point, line: _line, ...mark } = markDef;
    return (0, _util.keys)(mark).length > 1 ? mark : mark.type;
}
function dropLineAndPointFromConfig(config) {
    for (const mark of [
        'line',
        'area',
        'rule',
        'trail'
    ])if (config[mark]) config = {
        ...config,
        // TODO: remove as any
        [mark]: (0, _util.omit)(config[mark], [
            'point',
            'line'
        ])
    };
    return config;
}
function getPointOverlay(markDef, markConfig = {}, encoding) {
    if (markDef.point === 'transparent') return {
        opacity: 0
    };
    else if (markDef.point) // truthy : true or object
    return (0, _vegaUtil.isObject)(markDef.point) ? markDef.point : {};
    else if (markDef.point !== undefined) // false or null
    return null;
    else {
        // undefined (not disabled)
        if (markConfig.point || encoding.shape) // enable point overlay if config[mark].point is truthy or if encoding.shape is provided
        return (0, _vegaUtil.isObject)(markConfig.point) ? markConfig.point : {};
        // markDef.point is defined as falsy
        return undefined;
    }
}
function getLineOverlay(markDef, markConfig = {}) {
    if (markDef.line) // true or object
    return markDef.line === true ? {} : markDef.line;
    else if (markDef.line !== undefined) // false or null
    return null;
    else {
        // undefined (not disabled)
        if (markConfig.line) // enable line overlay if config[mark].line is truthy
        return markConfig.line === true ? {} : markConfig.line;
        // markDef.point is defined as falsy
        return undefined;
    }
}
class PathOverlayNormalizer {
    constructor(){
        this.name = 'path-overlay';
    }
    hasMatchingType(spec, config) {
        if ((0, _unit.isUnitSpec)(spec)) {
            const { mark, encoding } = spec;
            const markDef = (0, _mark.isMarkDef)(mark) ? mark : {
                type: mark
            };
            switch(markDef.type){
                case 'line':
                case 'rule':
                case 'trail':
                    return !!getPointOverlay(markDef, config[markDef.type], encoding);
                case 'area':
                    return(// false / null are also included as we want to remove the properties
                    !!getPointOverlay(markDef, config[markDef.type], encoding) || !!getLineOverlay(markDef, config[markDef.type]));
            }
        }
        return false;
    }
    run(spec, normParams, normalize) {
        const { config } = normParams;
        const { params, projection, mark, name, encoding: e, ...outerSpec } = spec;
        // Need to call normalizeEncoding because we need the inferred types to correctly determine stack
        const encoding = (0, _encoding.normalizeEncoding)(e, config);
        const markDef = (0, _mark.isMarkDef)(mark) ? mark : {
            type: mark
        };
        const pointOverlay = getPointOverlay(markDef, config[markDef.type], encoding);
        const lineOverlay = markDef.type === 'area' && getLineOverlay(markDef, config[markDef.type]);
        const layer = [
            {
                name,
                ...params ? {
                    params
                } : {},
                mark: dropLineAndPoint({
                    // TODO: extract this 0.7 to be shared with default opacity for point/tick/...
                    ...markDef.type === 'area' && markDef.opacity === undefined && markDef.fillOpacity === undefined ? {
                        opacity: 0.7
                    } : {},
                    ...markDef
                }),
                // drop shape from encoding as this might be used to trigger point overlay
                encoding: (0, _util.omit)(encoding, [
                    'shape'
                ])
            }
        ];
        // FIXME: determine rules for applying selections.
        // Need to copy stack config to overlayed layer
        // FIXME: normalizer shouldn't call `initMarkdef`, a method from an init phase.
        const stackProps = (0, _stack.stack)((0, _init.initMarkdef)(markDef, encoding, config), encoding);
        let overlayEncoding = encoding;
        if (stackProps) {
            const { fieldChannel: stackFieldChannel, offset } = stackProps;
            overlayEncoding = {
                ...encoding,
                [stackFieldChannel]: {
                    ...encoding[stackFieldChannel],
                    ...offset ? {
                        stack: offset
                    } : {}
                }
            };
        }
        // overlay line layer should be on the edge of area but passing y2/x2 makes
        // it as "rule" mark so that it draws unwanted vertical/horizontal lines.
        // point overlay also should not have y2/x2 as it does not support.
        overlayEncoding = (0, _util.omit)(overlayEncoding, [
            'y2',
            'x2'
        ]);
        if (lineOverlay) layer.push({
            ...projection ? {
                projection
            } : {},
            mark: {
                type: 'line',
                ...(0, _util.pick)(markDef, [
                    'clip',
                    'interpolate',
                    'tension',
                    'tooltip'
                ]),
                ...lineOverlay
            },
            encoding: overlayEncoding
        });
        if (pointOverlay) layer.push({
            ...projection ? {
                projection
            } : {},
            mark: {
                type: 'point',
                opacity: 1,
                filled: true,
                ...(0, _util.pick)(markDef, [
                    'clip',
                    'tooltip'
                ]),
                ...pointOverlay
            },
            encoding: overlayEncoding
        });
        return normalize({
            ...outerSpec,
            layer
        }, {
            ...normParams,
            config: dropLineAndPointFromConfig(config)
        });
    }
}

},{"vega-util":"7f6sQ","../encoding":"2Ohsj","../mark":"3Z1xx","../spec/unit":"eKdDP","../stack":"gEfq8","../util":"acUGA","../compile/mark/init":"6MO2i","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"gEfq8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isStackOffset", ()=>isStackOffset);
parcelHelpers.export(exports, "STACKABLE_MARKS", ()=>STACKABLE_MARKS);
parcelHelpers.export(exports, "STACK_BY_DEFAULT_MARKS", ()=>STACK_BY_DEFAULT_MARKS);
parcelHelpers.export(exports, "stack", ()=>stack);
var _vegaUtil = require("vega-util");
var _aggregate = require("./aggregate");
var _channel = require("./channel");
var _channeldef = require("./channeldef");
var _encoding = require("./encoding");
var _log = require("./log");
var _mark = require("./mark");
var _scale = require("./scale");
const STACK_OFFSET_INDEX = {
    zero: 1,
    center: 1,
    normalize: 1
};
function isStackOffset(s) {
    return (0, _vegaUtil.hasOwnProperty)(STACK_OFFSET_INDEX, s);
}
const STACKABLE_MARKS = new Set([
    (0, _mark.ARC),
    (0, _mark.BAR),
    (0, _mark.AREA),
    (0, _mark.RULE),
    (0, _mark.POINT),
    (0, _mark.CIRCLE),
    (0, _mark.SQUARE),
    (0, _mark.LINE),
    (0, _mark.TEXT),
    (0, _mark.TICK)
]);
const STACK_BY_DEFAULT_MARKS = new Set([
    (0, _mark.BAR),
    (0, _mark.AREA),
    (0, _mark.ARC)
]);
function isUnbinnedQuantitative(channelDef) {
    return (0, _channeldef.isFieldDef)(channelDef) && (0, _channeldef.channelDefType)(channelDef) === 'quantitative' && !channelDef.bin;
}
function potentialStackedChannel(encoding, x, { orient, type: mark }) {
    const y = x === 'x' ? 'y' : 'radius';
    const isCartesianBarOrArea = x === 'x' && [
        'bar',
        'area'
    ].includes(mark);
    const xDef = encoding[x];
    const yDef = encoding[y];
    if ((0, _channeldef.isFieldDef)(xDef) && (0, _channeldef.isFieldDef)(yDef)) {
        if (isUnbinnedQuantitative(xDef) && isUnbinnedQuantitative(yDef)) {
            if (xDef.stack) return x;
            else if (yDef.stack) return y;
            const xAggregate = (0, _channeldef.isFieldDef)(xDef) && !!xDef.aggregate;
            const yAggregate = (0, _channeldef.isFieldDef)(yDef) && !!yDef.aggregate;
            // if there is no explicit stacking, only apply stack if there is only one aggregate for x or y
            if (xAggregate !== yAggregate) return xAggregate ? x : y;
            if (isCartesianBarOrArea) {
                if (orient === 'vertical') return y;
                else if (orient === 'horizontal') return x;
            }
        } else if (isUnbinnedQuantitative(xDef)) return x;
        else if (isUnbinnedQuantitative(yDef)) return y;
    } else if (isUnbinnedQuantitative(xDef)) {
        if (isCartesianBarOrArea && orient === 'vertical') return undefined;
        return x;
    } else if (isUnbinnedQuantitative(yDef)) {
        if (isCartesianBarOrArea && orient === 'horizontal') return undefined;
        return y;
    }
    return undefined;
}
function getDimensionChannel(channel) {
    switch(channel){
        case 'x':
            return 'y';
        case 'y':
            return 'x';
        case 'theta':
            return 'radius';
        case 'radius':
            return 'theta';
    }
}
function stack(m, encoding) {
    const markDef = (0, _mark.isMarkDef)(m) ? m : {
        type: m
    };
    const mark = markDef.type;
    // Should have stackable mark
    if (!STACKABLE_MARKS.has(mark)) return null;
    // Run potential stacked twice, one for Cartesian and another for Polar,
    // so text marks can be stacked in any of the coordinates.
    // Note: The logic here is not perfectly correct.  If we want to support stacked dot plots where each dot is a pie chart with label, we have to change the stack logic here to separate Cartesian stacking for polar stacking.
    // However, since we probably never want to do that, let's just note the limitation here.
    const fieldChannel = potentialStackedChannel(encoding, 'x', markDef) || potentialStackedChannel(encoding, 'theta', markDef);
    if (!fieldChannel) return null;
    const stackedFieldDef = encoding[fieldChannel];
    const stackedField = (0, _channeldef.isFieldDef)(stackedFieldDef) ? (0, _channeldef.vgField)(stackedFieldDef, {}) : undefined;
    const dimensionChannel = getDimensionChannel(fieldChannel);
    const groupbyChannels = [];
    const groupbyFields = new Set();
    if (encoding[dimensionChannel]) {
        const dimensionDef = encoding[dimensionChannel];
        const dimensionField = (0, _channeldef.isFieldDef)(dimensionDef) ? (0, _channeldef.vgField)(dimensionDef, {}) : undefined;
        if (dimensionField && dimensionField !== stackedField) {
            // avoid grouping by the stacked field
            groupbyChannels.push(dimensionChannel);
            groupbyFields.add(dimensionField);
        }
    }
    const dimensionOffsetChannel = dimensionChannel === 'x' ? 'xOffset' : 'yOffset';
    const dimensionOffsetDef = encoding[dimensionOffsetChannel];
    const dimensionOffsetField = (0, _channeldef.isFieldDef)(dimensionOffsetDef) ? (0, _channeldef.vgField)(dimensionOffsetDef, {}) : undefined;
    if (dimensionOffsetField && dimensionOffsetField !== stackedField) {
        // avoid grouping by the stacked field
        groupbyChannels.push(dimensionOffsetChannel);
        groupbyFields.add(dimensionOffsetField);
    }
    // If the dimension has offset, don't stack anymore
    // Should have grouping level of detail that is different from the dimension field
    const stackBy = (0, _channel.NONPOSITION_CHANNELS).reduce((sc, channel)=>{
        // Ignore tooltip in stackBy (https://github.com/vega/vega-lite/issues/4001)
        if (channel !== 'tooltip' && (0, _encoding.channelHasField)(encoding, channel)) {
            const channelDef = encoding[channel];
            for (const cDef of (0, _vegaUtil.array)(channelDef)){
                const fieldDef = (0, _channeldef.getFieldDef)(cDef);
                if (fieldDef.aggregate) continue;
                // Check whether the channel's field is identical to x/y's field or if the channel is a repeat
                const f = (0, _channeldef.vgField)(fieldDef, {});
                if (// if fielddef is a repeat, just include it in the stack by
                !f || // otherwise, the field must be different from the groupBy fields.
                !groupbyFields.has(f)) sc.push({
                    channel,
                    fieldDef
                });
            }
        }
        return sc;
    }, []);
    // Automatically determine offset
    let offset;
    if (stackedFieldDef.stack !== undefined) {
        if ((0, _vegaUtil.isBoolean)(stackedFieldDef.stack)) offset = stackedFieldDef.stack ? 'zero' : null;
        else offset = stackedFieldDef.stack;
    } else if (STACK_BY_DEFAULT_MARKS.has(mark)) offset = 'zero';
    if (!offset || !isStackOffset(offset)) return null;
    if ((0, _encoding.isAggregate)(encoding) && stackBy.length === 0) return null;
    // warn when stacking non-linear
    if (stackedFieldDef?.scale?.type && stackedFieldDef?.scale?.type !== (0, _scale.ScaleType).LINEAR) {
        if (stackedFieldDef?.stack) _log.warn(_log.message.stackNonLinearScale(stackedFieldDef.scale.type));
    }
    // Check if it is a ranged mark
    if ((0, _channeldef.isFieldOrDatumDef)(encoding[(0, _channel.getSecondaryRangeChannel)(fieldChannel)])) {
        if (stackedFieldDef.stack !== undefined) _log.warn(_log.message.cannotStackRangedMark(fieldChannel));
        return null;
    }
    // Warn if stacking non-summative aggregate
    if ((0, _channeldef.isFieldDef)(stackedFieldDef) && stackedFieldDef.aggregate && !(0, _aggregate.SUM_OPS).has(stackedFieldDef.aggregate)) _log.warn(_log.message.stackNonSummativeAggregate(stackedFieldDef.aggregate));
    return {
        groupbyChannels,
        groupbyFields,
        fieldChannel,
        impute: stackedFieldDef.impute === null ? false : (0, _mark.isPathMark)(mark),
        stackBy,
        offset
    };
}

},{"vega-util":"7f6sQ","./aggregate":"d7bUU","./channel":"liLED","./channeldef":"dsccb","./encoding":"2Ohsj","./log":"loqTw","./mark":"3Z1xx","./scale":"bdpXN","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"6MO2i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initMarkdef", ()=>initMarkdef);
parcelHelpers.export(exports, "defaultFilled", ()=>defaultFilled);
var _bin = require("../../bin");
var _channeldef = require("../../channeldef");
var _encoding = require("../../encoding");
var _expr = require("../../expr");
var _log = require("../../log");
var _mark = require("../../mark");
var _type = require("../../type");
var _util = require("../../util");
var _common = require("../common");
function initMarkdef(originalMarkDef, encoding, config) {
    // FIXME: markDef expects that exprRefs are replaced recursively but replaceExprRef only replaces the top level
    const markDef = (0, _expr.replaceExprRef)(originalMarkDef);
    // set orient, which can be overridden by rules as sometimes the specified orient is invalid.
    const specifiedOrient = (0, _common.getMarkPropOrConfig)('orient', markDef, config);
    markDef.orient = orient(markDef.type, encoding, specifiedOrient);
    if (specifiedOrient !== undefined && specifiedOrient !== markDef.orient) _log.warn(_log.message.orientOverridden(markDef.orient, specifiedOrient));
    if (markDef.type === 'bar' && markDef.orient) {
        const cornerRadiusEnd = (0, _common.getMarkPropOrConfig)('cornerRadiusEnd', markDef, config);
        if (cornerRadiusEnd !== undefined) {
            const newProps = markDef.orient === 'horizontal' && encoding.x2 || markDef.orient === 'vertical' && encoding.y2 ? [
                'cornerRadius'
            ] : (0, _mark.BAR_CORNER_RADIUS_INDEX)[markDef.orient];
            for (const newProp of newProps)markDef[newProp] = cornerRadiusEnd;
            if (markDef.cornerRadiusEnd !== undefined) delete markDef.cornerRadiusEnd; // no need to keep the original cap cornerRadius
        }
    }
    // set opacity and filled if not specified in mark config
    const specifiedOpacity = (0, _common.getMarkPropOrConfig)('opacity', markDef, config);
    const specifiedfillOpacity = (0, _common.getMarkPropOrConfig)('fillOpacity', markDef, config);
    if (specifiedOpacity === undefined && specifiedfillOpacity === undefined) markDef.opacity = opacity(markDef.type, encoding);
    // set cursor, which should be pointer if href channel is present unless otherwise specified
    const specifiedCursor = (0, _common.getMarkPropOrConfig)('cursor', markDef, config);
    if (specifiedCursor === undefined) markDef.cursor = cursor(markDef, encoding, config);
    return markDef;
}
function cursor(markDef, encoding, config) {
    if (encoding.href || markDef.href || (0, _common.getMarkPropOrConfig)('href', markDef, config)) return 'pointer';
    return markDef.cursor;
}
function opacity(mark, encoding) {
    if ((0, _util.contains)([
        (0, _mark.POINT),
        (0, _mark.TICK),
        (0, _mark.CIRCLE),
        (0, _mark.SQUARE)
    ], mark)) {
        // point-based marks
        if (!(0, _encoding.isAggregate)(encoding)) return 0.7;
    }
    return undefined;
}
function defaultFilled(markDef, config, { graticule }) {
    if (graticule) return false;
    const filledConfig = (0, _common.getMarkConfig)('filled', markDef, config);
    const mark = markDef.type;
    return (0, _util.getFirstDefined)(filledConfig, mark !== (0, _mark.POINT) && mark !== (0, _mark.LINE) && mark !== (0, _mark.RULE));
}
function orient(mark, encoding, specifiedOrient) {
    switch(mark){
        case 0, _mark.POINT:
        case 0, _mark.CIRCLE:
        case 0, _mark.SQUARE:
        case 0, _mark.TEXT:
        case 0, _mark.RECT:
        case 0, _mark.IMAGE:
            // orient is meaningless for these marks.
            return undefined;
    }
    const { x, y, x2, y2 } = encoding;
    switch(mark){
        case 0, _mark.BAR:
            if ((0, _channeldef.isFieldDef)(x) && ((0, _bin.isBinned)(x.bin) || (0, _channeldef.isFieldDef)(y) && y.aggregate && !x.aggregate)) return 'vertical';
            if ((0, _channeldef.isFieldDef)(y) && ((0, _bin.isBinned)(y.bin) || (0, _channeldef.isFieldDef)(x) && x.aggregate && !y.aggregate)) return 'horizontal';
            if (y2 || x2) {
                // Ranged bar does not always have clear orientation, so we allow overriding
                if (specifiedOrient) return specifiedOrient;
                // If y is range and x is non-range, non-bin Q
                if (!x2) {
                    if ((0, _channeldef.isFieldDef)(x) && x.type === (0, _type.QUANTITATIVE) && !(0, _bin.isBinning)(x.bin) || (0, _channeldef.isNumericDataDef)(x)) {
                        if ((0, _channeldef.isFieldDef)(y) && (0, _bin.isBinned)(y.bin)) return 'horizontal';
                    }
                    return 'vertical';
                }
                // If x is range and y is non-range, non-bin Q
                if (!y2) {
                    if ((0, _channeldef.isFieldDef)(y) && y.type === (0, _type.QUANTITATIVE) && !(0, _bin.isBinning)(y.bin) || (0, _channeldef.isNumericDataDef)(y)) {
                        if ((0, _channeldef.isFieldDef)(x) && (0, _bin.isBinned)(x.bin)) return 'vertical';
                    }
                    return 'horizontal';
                }
            }
        // falls through
        case 0, _mark.RULE:
            // return undefined for line segment rule and bar with both axis ranged
            // we have to ignore the case that the data are already binned
            if (x2 && !((0, _channeldef.isFieldDef)(x) && (0, _bin.isBinned)(x.bin)) && y2 && !((0, _channeldef.isFieldDef)(y) && (0, _bin.isBinned)(y.bin))) return undefined;
        // falls through
        case 0, _mark.AREA:
            // If there are range for both x and y, y (vertical) has higher precedence.
            if (y2) {
                if ((0, _channeldef.isFieldDef)(y) && (0, _bin.isBinned)(y.bin)) return 'horizontal';
                else return 'vertical';
            } else if (x2) {
                if ((0, _channeldef.isFieldDef)(x) && (0, _bin.isBinned)(x.bin)) return 'vertical';
                else return 'horizontal';
            } else if (mark === (0, _mark.RULE)) {
                if (x && !y) return 'vertical';
                else if (y && !x) return 'horizontal';
            }
        // falls through
        case 0, _mark.LINE:
        case 0, _mark.TICK:
            {
                const xIsMeasure = (0, _channeldef.isUnbinnedQuantitativeFieldOrDatumDef)(x);
                const yIsMeasure = (0, _channeldef.isUnbinnedQuantitativeFieldOrDatumDef)(y);
                if (specifiedOrient) return specifiedOrient;
                else if (xIsMeasure && !yIsMeasure) // Tick is opposite to bar, line, area
                return mark !== 'tick' ? 'horizontal' : 'vertical';
                else if (!xIsMeasure && yIsMeasure) // Tick is opposite to bar, line, area
                return mark !== 'tick' ? 'vertical' : 'horizontal';
                else if (xIsMeasure && yIsMeasure) return 'vertical';
                else {
                    const xIsTemporal = (0, _channeldef.isTypedFieldDef)(x) && x.type === (0, _type.TEMPORAL);
                    const yIsTemporal = (0, _channeldef.isTypedFieldDef)(y) && y.type === (0, _type.TEMPORAL);
                    // x: T, y: N --> vertical tick
                    if (xIsTemporal && !yIsTemporal) return 'vertical';
                    else if (!xIsTemporal && yIsTemporal) return 'horizontal';
                }
                return undefined;
            }
    }
    return 'vertical';
}

},{"../../bin":"3cpW8","../../channeldef":"dsccb","../../encoding":"2Ohsj","../../expr":"ev4sO","../../log":"loqTw","../../mark":"3Z1xx","../../type":"cbWGP","../../util":"acUGA","../common":"jegt8","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"fAgpf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "replaceRepeaterInFacet", ()=>replaceRepeaterInFacet);
parcelHelpers.export(exports, "replaceRepeaterInEncoding", ()=>replaceRepeaterInEncoding);
var _vegaUtil = require("vega-util");
var _channeldef = require("../channeldef");
var _log = require("../log");
var _sort = require("../sort");
var _facet = require("../spec/facet");
var _util = require("../util");
function replaceRepeaterInFacet(facet, repeater) {
    if (!repeater) return facet;
    if ((0, _facet.isFacetMapping)(facet)) return replaceRepeaterInMapping(facet, repeater);
    return replaceRepeaterInFieldDef(facet, repeater);
}
function replaceRepeaterInEncoding(encoding, repeater) {
    if (!repeater) return encoding;
    return replaceRepeaterInMapping(encoding, repeater);
}
/**
 * Replaces repeated value and returns if the repeated value is valid.
 */ function replaceRepeatInProp(prop, o, repeater) {
    const val = o[prop];
    if ((0, _channeldef.isRepeatRef)(val)) {
        if (val.repeat in repeater) return {
            ...o,
            [prop]: repeater[val.repeat]
        };
        else {
            _log.warn(_log.message.noSuchRepeatedValue(val.repeat));
            return undefined;
        }
    }
    return o;
}
/**
 * Replace repeater values in a field def with the concrete field name.
 */ function replaceRepeaterInFieldDef(fieldDef, repeater) {
    fieldDef = replaceRepeatInProp('field', fieldDef, repeater);
    if (fieldDef === undefined) // the field def should be ignored
    return undefined;
    else if (fieldDef === null) return null;
    if ((0, _channeldef.isSortableFieldDef)(fieldDef) && (0, _sort.isSortField)(fieldDef.sort)) {
        const sort = replaceRepeatInProp('field', fieldDef.sort, repeater);
        fieldDef = {
            ...fieldDef,
            ...sort ? {
                sort
            } : {}
        };
    }
    return fieldDef;
}
function replaceRepeaterInFieldOrDatumDef(def, repeater) {
    if ((0, _channeldef.isFieldDef)(def)) return replaceRepeaterInFieldDef(def, repeater);
    else {
        const datumDef = replaceRepeatInProp('datum', def, repeater);
        if (datumDef !== def && !datumDef.type) datumDef.type = 'nominal';
        return datumDef;
    }
}
function replaceRepeaterInChannelDef(channelDef, repeater) {
    if ((0, _channeldef.isFieldOrDatumDef)(channelDef)) {
        const fd = replaceRepeaterInFieldOrDatumDef(channelDef, repeater);
        if (fd) return fd;
        else if ((0, _channeldef.isConditionalDef)(channelDef)) return {
            condition: channelDef.condition
        };
    } else {
        if ((0, _channeldef.hasConditionalFieldOrDatumDef)(channelDef)) {
            const fd = replaceRepeaterInFieldOrDatumDef(channelDef.condition, repeater);
            if (fd) return {
                ...channelDef,
                condition: fd
            };
            else {
                const { condition, ...channelDefWithoutCondition } = channelDef;
                return channelDefWithoutCondition;
            }
        }
        return channelDef;
    }
    return undefined;
}
function replaceRepeaterInMapping(mapping, repeater) {
    const out = {};
    for(const channel in mapping)if ((0, _util.hasProperty)(mapping, channel)) {
        const channelDef = mapping[channel];
        if ((0, _vegaUtil.isArray)(channelDef)) // array cannot have condition
        out[channel] = channelDef // somehow we need to cast it here
        .map((cd)=>replaceRepeaterInChannelDef(cd, repeater)).filter((cd)=>cd);
        else {
            const cd = replaceRepeaterInChannelDef(channelDef, repeater);
            if (cd !== undefined) out[channel] = cd;
        }
    }
    return out;
}

},{"vega-util":"7f6sQ","../channeldef":"dsccb","../log":"loqTw","../sort":"aWnXd","../spec/facet":"3pm05","../util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"tHdAx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuleForRangedLineNormalizer", ()=>RuleForRangedLineNormalizer);
var _vegaUtil = require("vega-util");
var _bin = require("../bin");
var _channel = require("../channel");
var _channeldef = require("../channeldef");
var _log = require("../log");
var _mark = require("../mark");
var _unit = require("../spec/unit");
class RuleForRangedLineNormalizer {
    constructor(){
        this.name = 'RuleForRangedLine';
    }
    hasMatchingType(spec) {
        if ((0, _unit.isUnitSpec)(spec)) {
            const { encoding, mark } = spec;
            if (mark === 'line' || (0, _mark.isMarkDef)(mark) && mark.type === 'line') for (const channel of (0, _channel.SECONDARY_RANGE_CHANNEL)){
                const mainChannel = (0, _channel.getMainRangeChannel)(channel);
                const mainChannelDef = encoding[mainChannel];
                if (encoding[channel]) {
                    if ((0, _channeldef.isFieldDef)(mainChannelDef) && !(0, _bin.isBinned)(mainChannelDef.bin) || (0, _channeldef.isDatumDef)(mainChannelDef)) return true;
                }
            }
        }
        return false;
    }
    run(spec, params, normalize) {
        const { encoding, mark } = spec;
        _log.warn(_log.message.lineWithRange(!!encoding.x2, !!encoding.y2));
        return normalize({
            ...spec,
            mark: (0, _vegaUtil.isObject)(mark) ? {
                ...mark,
                type: 'rule'
            } : 'rule'
        }, params);
    }
}

},{"vega-util":"7f6sQ","../bin":"3cpW8","../channel":"liLED","../channeldef":"dsccb","../log":"loqTw","../mark":"3Z1xx","../spec/unit":"eKdDP","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"7yqnU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectionCompatibilityNormalizer", ()=>SelectionCompatibilityNormalizer);
var _vegaUtil = require("vega-util");
var _bin = require("../bin");
var _channeldef = require("../channeldef");
var _logical = require("../logical");
var _map = require("../spec/map");
var _transform = require("../transform");
var _util = require("../util");
class SelectionCompatibilityNormalizer extends (0, _map.SpecMapper) {
    map(spec, normParams) {
        normParams.emptySelections ?? (normParams.emptySelections = {});
        normParams.selectionPredicates ?? (normParams.selectionPredicates = {});
        spec = normalizeTransforms(spec, normParams);
        return super.map(spec, normParams);
    }
    mapLayerOrUnit(spec, normParams) {
        spec = normalizeTransforms(spec, normParams);
        if (spec.encoding) {
            const encoding = {};
            for (const [channel, enc] of (0, _util.entries)(spec.encoding))encoding[channel] = normalizeChannelDef(enc, normParams);
            spec = {
                ...spec,
                encoding
            };
        }
        return super.mapLayerOrUnit(spec, normParams);
    }
    mapUnit(spec, normParams) {
        const { selection, ...rest } = spec;
        if (selection) return {
            ...rest,
            params: (0, _util.entries)(selection).map(([name, selDef])=>{
                const { init: value, bind, empty, ...select } = selDef;
                if (select.type === 'single') {
                    select.type = 'point';
                    select.toggle = false;
                } else if (select.type === 'multi') select.type = 'point';
                // Propagate emptiness forwards and backwards
                normParams.emptySelections[name] = empty !== 'none';
                for (const pred of (0, _util.vals)(normParams.selectionPredicates[name] ?? {}))pred.empty = empty !== 'none';
                return {
                    name,
                    value,
                    select,
                    bind
                };
            })
        };
        return spec;
    }
}
function normalizeTransforms(spec, normParams) {
    const { transform: tx, ...rest } = spec;
    if (tx) {
        const transform = tx.map((t)=>{
            if ((0, _transform.isFilter)(t)) return {
                filter: normalizePredicate(t, normParams)
            };
            else if ((0, _transform.isBin)(t) && (0, _bin.isBinParams)(t.bin)) return {
                ...t,
                bin: normalizeBinExtent(t.bin)
            };
            else if ((0, _transform.isLookup)(t)) {
                const { selection: param, ...from } = t.from;
                return param ? {
                    ...t,
                    from: {
                        param,
                        ...from
                    }
                } : t;
            }
            return t;
        });
        return {
            ...rest,
            transform
        };
    }
    return spec;
}
function normalizeChannelDef(obj, normParams) {
    const enc = (0, _util.duplicate)(obj);
    if ((0, _channeldef.isFieldDef)(enc) && (0, _bin.isBinParams)(enc.bin)) enc.bin = normalizeBinExtent(enc.bin);
    if ((0, _channeldef.isScaleFieldDef)(enc) && enc.scale?.domain?.selection) {
        const { selection: param, ...domain } = enc.scale.domain;
        enc.scale.domain = {
            ...domain,
            ...param ? {
                param
            } : {}
        };
    }
    if ((0, _channeldef.isConditionalDef)(enc)) {
        if ((0, _vegaUtil.isArray)(enc.condition)) enc.condition = enc.condition.map((c)=>{
            const { selection, param, test, ...cond } = c;
            return param ? c : {
                ...cond,
                test: normalizePredicate(c, normParams)
            };
        });
        else {
            const { selection, param, test, ...cond } = normalizeChannelDef(enc.condition, normParams);
            enc.condition = param ? enc.condition : {
                ...cond,
                test: normalizePredicate(enc.condition, normParams)
            };
        }
    }
    return enc;
}
function normalizeBinExtent(bin) {
    const ext = bin.extent;
    if (ext?.selection) {
        const { selection: param, ...rest } = ext;
        return {
            ...bin,
            extent: {
                ...rest,
                param
            }
        };
    }
    return bin;
}
function normalizePredicate(op, normParams) {
    // Normalize old compositions of selection names (e.g., selection: {and: ["one", "two"]})
    const normalizeSelectionComposition = (o)=>{
        return (0, _logical.normalizeLogicalComposition)(o, (param)=>{
            var _a;
            const empty = normParams.emptySelections[param] ?? true;
            const pred = {
                param,
                empty
            };
            (_a = normParams.selectionPredicates)[param] ?? (_a[param] = []);
            normParams.selectionPredicates[param].push(pred);
            return pred;
        });
    };
    return op.selection ? normalizeSelectionComposition(op.selection) : (0, _logical.normalizeLogicalComposition)(op.test || op.filter, (o)=>o.selection ? normalizeSelectionComposition(o.selection) : o);
}

},{"vega-util":"7f6sQ","../bin":"3cpW8","../channeldef":"dsccb","../logical":"ksUsC","../spec/map":"8IUh5","../transform":"ld5WF","../util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"ld5WF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFilter", ()=>isFilter);
parcelHelpers.export(exports, "isImputeSequence", ()=>isImputeSequence);
parcelHelpers.export(exports, "isLookup", ()=>isLookup);
parcelHelpers.export(exports, "isLookupData", ()=>isLookupData);
parcelHelpers.export(exports, "isLookupSelection", ()=>isLookupSelection);
parcelHelpers.export(exports, "isPivot", ()=>isPivot);
parcelHelpers.export(exports, "isDensity", ()=>isDensity);
parcelHelpers.export(exports, "isQuantile", ()=>isQuantile);
parcelHelpers.export(exports, "isRegression", ()=>isRegression);
parcelHelpers.export(exports, "isLoess", ()=>isLoess);
parcelHelpers.export(exports, "isSample", ()=>isSample);
parcelHelpers.export(exports, "isWindow", ()=>isWindow);
parcelHelpers.export(exports, "isJoinAggregate", ()=>isJoinAggregate);
parcelHelpers.export(exports, "isFlatten", ()=>isFlatten);
parcelHelpers.export(exports, "isCalculate", ()=>isCalculate);
parcelHelpers.export(exports, "isBin", ()=>isBin);
parcelHelpers.export(exports, "isImpute", ()=>isImpute);
parcelHelpers.export(exports, "isTimeUnit", ()=>isTimeUnit);
parcelHelpers.export(exports, "isAggregate", ()=>isAggregate);
parcelHelpers.export(exports, "isStack", ()=>isStack);
parcelHelpers.export(exports, "isFold", ()=>isFold);
parcelHelpers.export(exports, "isExtent", ()=>isExtent);
parcelHelpers.export(exports, "normalizeTransform", ()=>normalizeTransform);
var _logical = require("./logical");
var _predicate = require("./predicate");
var _util = require("./util");
function isFilter(t) {
    return (0, _util.hasProperty)(t, 'filter');
}
function isImputeSequence(t) {
    return (0, _util.hasProperty)(t, 'stop');
}
function isLookup(t) {
    return (0, _util.hasProperty)(t, 'lookup');
}
function isLookupData(from) {
    return (0, _util.hasProperty)(from, 'data');
}
function isLookupSelection(from) {
    return (0, _util.hasProperty)(from, 'param');
}
function isPivot(t) {
    return (0, _util.hasProperty)(t, 'pivot');
}
function isDensity(t) {
    return (0, _util.hasProperty)(t, 'density');
}
function isQuantile(t) {
    return (0, _util.hasProperty)(t, 'quantile');
}
function isRegression(t) {
    return (0, _util.hasProperty)(t, 'regression');
}
function isLoess(t) {
    return (0, _util.hasProperty)(t, 'loess');
}
function isSample(t) {
    return (0, _util.hasProperty)(t, 'sample');
}
function isWindow(t) {
    return (0, _util.hasProperty)(t, 'window');
}
function isJoinAggregate(t) {
    return (0, _util.hasProperty)(t, 'joinaggregate');
}
function isFlatten(t) {
    return (0, _util.hasProperty)(t, 'flatten');
}
function isCalculate(t) {
    return (0, _util.hasProperty)(t, 'calculate');
}
function isBin(t) {
    return (0, _util.hasProperty)(t, 'bin');
}
function isImpute(t) {
    return (0, _util.hasProperty)(t, 'impute');
}
function isTimeUnit(t) {
    return (0, _util.hasProperty)(t, 'timeUnit');
}
function isAggregate(t) {
    return (0, _util.hasProperty)(t, 'aggregate');
}
function isStack(t) {
    return (0, _util.hasProperty)(t, 'stack');
}
function isFold(t) {
    return (0, _util.hasProperty)(t, 'fold');
}
function isExtent(t) {
    return (0, _util.hasProperty)(t, 'extent') && !(0, _util.hasProperty)(t, 'density') && !(0, _util.hasProperty)(t, 'regression');
}
function normalizeTransform(transform) {
    return transform.map((t)=>{
        if (isFilter(t)) return {
            filter: (0, _logical.normalizeLogicalComposition)(t.filter, (0, _predicate.normalizePredicate))
        };
        return t;
    });
}

},{"./logical":"ksUsC","./predicate":"gynPW","./util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"9JeOM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TopLevelSelectionsNormalizer", ()=>TopLevelSelectionsNormalizer);
var _vegaUtil = require("vega-util");
var _selection = require("../selection");
var _spec = require("../spec");
var _map = require("../spec/map");
class TopLevelSelectionsNormalizer extends (0, _map.SpecMapper) {
    map(spec, normParams) {
        const selections = normParams.selections ?? [];
        if (spec.params && !(0, _spec.isUnitSpec)(spec)) {
            const params = [];
            for (const param of spec.params)if ((0, _selection.isSelectionParameter)(param)) selections.push(param);
            else params.push(param);
            spec.params = params;
        }
        normParams.selections = selections;
        return super.map(spec, normParams);
    }
    mapUnit(spec, normParams) {
        const selections = normParams.selections;
        if (!selections || !selections.length) return spec;
        const path = (normParams.path ?? []).concat(spec.name);
        const params = [];
        for (const selection of selections)// By default, apply selections to all unit views.
        if (!selection.views || !selection.views.length) params.push(selection);
        else {
            for (const view of selection.views)// view is either a specific unit name, or a partial path through the spec tree.
            if ((0, _vegaUtil.isString)(view) && (view === spec.name || path.includes(view)) || (0, _vegaUtil.isArray)(view) && // logic for backwards compatibility with view paths before we had unique names
            // @ts-ignore
            view.map((v)=>path.indexOf(v)).every((v, i, arr)=>v !== -1 && (i === 0 || v > arr[i - 1]))) params.push(selection);
        }
        if (params.length) spec.params = params;
        return spec;
    }
}
for (const method of [
    'mapFacet',
    'mapRepeat',
    'mapHConcat',
    'mapVConcat',
    'mapLayer'
]){
    const proto = TopLevelSelectionsNormalizer.prototype[method];
    TopLevelSelectionsNormalizer.prototype[method] = function(spec, params) {
        return proto.call(this, spec, addSpecNameToParams(spec, params));
    };
}
function addSpecNameToParams(spec, params) {
    return spec.name ? {
        ...params,
        path: (params.path ?? []).concat(spec.name)
    } : params;
}

},{"vega-util":"7f6sQ","../selection":"jtWSq","../spec":"5gjAD","../spec/map":"8IUh5","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"beMiN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFitType", ()=>isFitType);
parcelHelpers.export(exports, "getFitType", ()=>getFitType);
parcelHelpers.export(exports, "extractTopLevelProperties", ()=>extractTopLevelProperties);
var _channel = require("../channel");
var _common = require("../compile/common");
function isFitType(autoSizeType) {
    return [
        'fit',
        'fit-x',
        'fit-y'
    ].includes(autoSizeType);
}
function getFitType(sizeType) {
    return sizeType ? `fit-${(0, _channel.getPositionScaleChannel)(sizeType)}` : 'fit';
}
const TOP_LEVEL_PROPERTIES = [
    'background',
    'padding'
];
function extractTopLevelProperties(t, includeParams) {
    const o = {};
    for (const p of TOP_LEVEL_PROPERTIES)if (t && t[p] !== undefined) o[p] = (0, _common.signalRefOrValue)(t[p]);
    if (includeParams) o.params = t.params;
    return o;
}

},{"../channel":"liLED","../compile/common":"jegt8","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"2GQcr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildModel", ()=>buildModel);
var _log = require("../log");
var _spec = require("../spec");
var _concat = require("./concat");
var _facet = require("./facet");
var _layer = require("./layer");
var _unit = require("./unit");
function buildModel(spec, parent, parentGivenName, unitSize, config) {
    if ((0, _spec.isFacetSpec)(spec)) return new (0, _facet.FacetModel)(spec, parent, parentGivenName, config);
    else if ((0, _spec.isLayerSpec)(spec)) return new (0, _layer.LayerModel)(spec, parent, parentGivenName, unitSize, config);
    else if ((0, _spec.isUnitSpec)(spec)) return new (0, _unit.UnitModel)(spec, parent, parentGivenName, unitSize, config);
    else if ((0, _spec.isAnyConcatSpec)(spec)) return new (0, _concat.ConcatModel)(spec, parent, parentGivenName, config);
    throw new Error(_log.message.invalidSpec(spec));
}

},{"../log":"loqTw","../spec":"5gjAD","./concat":"bg8Hl","./facet":"7tiXg","./layer":"gdgrZ","./unit":"jvFxg","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bg8Hl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConcatModel", ()=>ConcatModel);
var _log = require("../log");
var _spec = require("../spec");
var _util = require("../util");
var _buildmodel = require("./buildmodel");
var _parse = require("./data/parse");
var _assemble = require("./layoutsize/assemble");
var _parse1 = require("./layoutsize/parse");
var _model = require("./model");
var _message = require("../log/message");
var _selection = require("./selection");
class ConcatModel extends (0, _model.Model) {
    constructor(spec, parent, parentGivenName, config){
        super(spec, 'concat', parent, parentGivenName, config, spec.resolve);
        if (spec.resolve?.axis?.x === 'shared' || spec.resolve?.axis?.y === 'shared') _log.warn(_log.message.CONCAT_CANNOT_SHARE_AXIS);
        this.children = this.getChildren(spec).map((child, i)=>{
            return (0, _buildmodel.buildModel)(child, this, this.getName(`concat_${i}`), undefined, config);
        });
    }
    parseData() {
        this.component.data = (0, _parse.parseData)(this);
        for (const child of this.children)child.parseData();
    }
    parseSelections() {
        // Merge selections up the hierarchy so that they may be referenced
        // across unit specs. Persist their definitions within each child
        // to assemble signals which remain within output Vega unit groups.
        this.component.selection = {};
        for (const child of this.children){
            child.parseSelections();
            for (const key of (0, _util.keys)(child.component.selection))this.component.selection[key] = child.component.selection[key];
        }
        if (Object.values(this.component.selection).some((selCmpt)=>(0, _selection.isTimerSelection)(selCmpt))) _log.error((0, _message.MULTI_VIEW_ANIMATION_UNSUPPORTED));
    }
    parseMarkGroup() {
        for (const child of this.children)child.parseMarkGroup();
    }
    parseAxesAndHeaders() {
        for (const child of this.children)child.parseAxesAndHeaders();
    // TODO(#2415): support shared axes
    }
    getChildren(spec) {
        if ((0, _spec.isVConcatSpec)(spec)) return spec.vconcat;
        else if ((0, _spec.isHConcatSpec)(spec)) return spec.hconcat;
        return spec.concat;
    }
    parseLayoutSize() {
        (0, _parse1.parseConcatLayoutSize)(this);
    }
    parseAxisGroup() {
        return null;
    }
    assembleSelectionTopLevelSignals(signals) {
        return this.children.reduce((sg, child)=>child.assembleSelectionTopLevelSignals(sg), signals);
    }
    assembleSignals() {
        this.children.forEach((child)=>child.assembleSignals());
        return [];
    }
    assembleLayoutSignals() {
        const layoutSignals = (0, _assemble.assembleLayoutSignals)(this);
        for (const child of this.children)layoutSignals.push(...child.assembleLayoutSignals());
        return layoutSignals;
    }
    assembleSelectionData(data) {
        return this.children.reduce((db, child)=>child.assembleSelectionData(db), data);
    }
    assembleMarks() {
        // only children have marks
        return this.children.map((child)=>{
            const title = child.assembleTitle();
            const style = child.assembleGroupStyle();
            const encodeEntry = child.assembleGroupEncodeEntry(false);
            return {
                type: 'group',
                name: child.getName('group'),
                ...title ? {
                    title
                } : {},
                ...style ? {
                    style
                } : {},
                ...encodeEntry ? {
                    encode: {
                        update: encodeEntry
                    }
                } : {},
                ...child.assembleGroup()
            };
        });
    }
    assembleGroupStyle() {
        return undefined;
    }
    assembleDefaultLayout() {
        const columns = this.layout.columns;
        return {
            ...columns != null ? {
                columns
            } : {},
            bounds: 'full',
            // Use align each so it can work with multiple plots with different size
            align: 'each'
        };
    }
}

},{"../log":"loqTw","../spec":"5gjAD","../util":"acUGA","./buildmodel":"2GQcr","./data/parse":"5V0Ly","./layoutsize/assemble":"cyXx5","./layoutsize/parse":"84zTX","./model":"hQHib","../log/message":"fb2MK","./selection":"7GXIu","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5V0Ly":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findSource", ()=>findSource);
/**
 * Parses a transform array into a chain of connected dataflow nodes.
 */ parcelHelpers.export(exports, "parseTransformArray", ()=>parseTransformArray);
/*
Description of the dataflow (http://asciiflow.com/):
     +--------+
     | Source |
     +---+----+
         |
         v
     FormatParse
     (explicit)
         |
         v
     Transforms
(Filter, Calculate, Binning, TimeUnit, Aggregate, Window, ...)
         |
         v
     FormatParse
     (implicit)
         |
         v
 Binning (in `encoding`)
         |
         v
 Timeunit (in `encoding`)
         |
         v
Formula From Sort Array
         |
         v
      +--+--+
      | Raw |
      +-----+
         |
         v
  Aggregate (in `encoding`)
         |
         v
  Stack (in `encoding`)
         |
         v
+- - - - - - - - - - -+
|   PreFilterInvalid  | - - - -> scale domains
|(when scales need it)|
+- - - - - - - - - - -+
         |
         v
  Invalid Filter (if the main data source needs it)
         |
         v
   +----------+
   |   Main   | - - - -> scale domains
   +----------+
         |
         v
+- - - - - - - - - - -+
|   PostFilterInvalid | - - - -> scale domains
|(when scales need it)|
+- - - - - - - - - - -+
         |
         v
     +-------+
     | Facet |----> "column", "column-layout", and "row"
     +-------+
         |
         v
  ...Child data...
*/ parcelHelpers.export(exports, "parseData", ()=>parseData);
var _ = require(".");
var _data = require("../../data");
var _datasources = require("../invalid/datasources");
var _log = require("../../log");
var _mark = require("../../mark");
var _transform = require("../../transform");
var _util = require("../../util");
var _common = require("../common");
var _model = require("../model");
var _selection = require("../selection");
var _parse = require("../selection/parse");
var _aggregate = require("./aggregate");
var _bin = require("./bin");
var _calculate = require("./calculate");
var _dataflow = require("./dataflow");
var _density = require("./density");
var _extent = require("./extent");
var _facet = require("./facet");
var _filter = require("./filter");
var _filterinvalid = require("./filterinvalid");
var _flatten = require("./flatten");
var _fold = require("./fold");
var _formatparse = require("./formatparse");
var _geojson = require("./geojson");
var _geopoint = require("./geopoint");
var _graticule = require("./graticule");
var _identifier = require("./identifier");
var _impute = require("./impute");
var _joinaggregate = require("./joinaggregate");
var _joinaggregatefacet = require("./joinaggregatefacet");
var _loess = require("./loess");
var _lookup = require("./lookup");
var _pivot = require("./pivot");
var _quantile = require("./quantile");
var _regression = require("./regression");
var _sample = require("./sample");
var _sequence = require("./sequence");
var _source = require("./source");
var _stack = require("./stack");
var _timeunit = require("./timeunit");
var _window = require("./window");
function findSource(data, sources) {
    for (const other of sources){
        const otherData = other.data;
        // if both datasets have a name defined, we cannot merge
        if (data.name && other.hasName() && data.name !== other.dataName) continue;
        const formatMesh = data.format?.mesh;
        const otherFeature = otherData.format?.feature;
        // feature and mesh are mutually exclusive
        if (formatMesh && otherFeature) continue;
        // we have to extract the same feature or mesh
        const formatFeature = data.format?.feature;
        if ((formatFeature || otherFeature) && formatFeature !== otherFeature) continue;
        const otherMesh = otherData.format?.mesh;
        if ((formatMesh || otherMesh) && formatMesh !== otherMesh) continue;
        if ((0, _data.isInlineData)(data) && (0, _data.isInlineData)(otherData)) {
            if ((0, _util.deepEqual)(data.values, otherData.values)) return other;
        } else if ((0, _data.isUrlData)(data) && (0, _data.isUrlData)(otherData)) {
            if (data.url === otherData.url) return other;
        } else if ((0, _data.isNamedData)(data)) {
            if (data.name === other.dataName) return other;
        }
    }
    return null;
}
function parseRoot(model, sources) {
    if (model.data || !model.parent) {
        // if the model defines a data source or is the root, create a source node
        if (model.data === null) {
            // data: null means we should ignore the parent's data so we just create a new data source
            const source = new (0, _source.SourceNode)({
                values: []
            });
            sources.push(source);
            return source;
        }
        const existingSource = findSource(model.data, sources);
        if (existingSource) {
            if (!(0, _data.isGenerator)(model.data)) existingSource.data.format = (0, _util.mergeDeep)({}, model.data.format, existingSource.data.format);
            // if the new source has a name but the existing one does not, we can set it
            if (!existingSource.hasName() && model.data.name) existingSource.dataName = model.data.name;
            return existingSource;
        } else {
            const source = new (0, _source.SourceNode)(model.data);
            sources.push(source);
            return source;
        }
    } else // If we don't have a source defined (overriding parent's data), use the parent's facet root or main.
    return model.parent.component.data.facetRoot ? model.parent.component.data.facetRoot : model.parent.component.data.main;
}
function parseTransformArray(head, model, ancestorParse) {
    let lookupCounter = 0;
    for (const t of model.transforms){
        let derivedType = undefined;
        let transformNode;
        if ((0, _transform.isCalculate)(t)) {
            transformNode = head = new (0, _calculate.CalculateNode)(head, t);
            derivedType = 'derived';
        } else if ((0, _transform.isFilter)(t)) {
            const implicit = (0, _formatparse.getImplicitFromFilterTransform)(t);
            transformNode = head = (0, _formatparse.ParseNode).makeWithAncestors(head, {}, implicit, ancestorParse) ?? head;
            head = new (0, _filter.FilterNode)(head, model, t.filter);
        } else if ((0, _transform.isBin)(t)) {
            transformNode = head = (0, _bin.BinNode).makeFromTransform(head, t, model);
            derivedType = 'number';
        } else if ((0, _transform.isTimeUnit)(t)) {
            derivedType = 'date';
            const parsedAs = ancestorParse.getWithExplicit(t.field);
            // Create parse node because the input to time unit is always date.
            if (parsedAs.value === undefined) {
                head = new (0, _formatparse.ParseNode)(head, {
                    [t.field]: derivedType
                });
                ancestorParse.set(t.field, derivedType, false);
            }
            transformNode = head = (0, _timeunit.TimeUnitNode).makeFromTransform(head, t);
        } else if ((0, _transform.isAggregate)(t)) {
            transformNode = head = (0, _aggregate.AggregateNode).makeFromTransform(head, t);
            derivedType = 'number';
            if ((0, _selection.requiresSelectionId)(model)) head = new (0, _identifier.IdentifierNode)(head);
        } else if ((0, _transform.isLookup)(t)) {
            transformNode = head = (0, _lookup.LookupNode).make(head, model, t, lookupCounter++);
            derivedType = 'derived';
        } else if ((0, _transform.isWindow)(t)) {
            transformNode = head = new (0, _window.WindowTransformNode)(head, t);
            derivedType = 'number';
        } else if ((0, _transform.isJoinAggregate)(t)) {
            transformNode = head = new (0, _joinaggregate.JoinAggregateTransformNode)(head, t);
            derivedType = 'number';
        } else if ((0, _transform.isStack)(t)) {
            transformNode = head = (0, _stack.StackNode).makeFromTransform(head, t);
            derivedType = 'derived';
        } else if ((0, _transform.isFold)(t)) {
            transformNode = head = new (0, _fold.FoldTransformNode)(head, t);
            derivedType = 'derived';
        } else if ((0, _transform.isExtent)(t)) {
            transformNode = head = new (0, _extent.ExtentTransformNode)(head, t);
            derivedType = 'derived';
        } else if ((0, _transform.isFlatten)(t)) {
            transformNode = head = new (0, _flatten.FlattenTransformNode)(head, t);
            derivedType = 'derived';
        } else if ((0, _transform.isPivot)(t)) {
            transformNode = head = new (0, _pivot.PivotTransformNode)(head, t);
            derivedType = 'derived';
        } else if ((0, _transform.isSample)(t)) head = new (0, _sample.SampleTransformNode)(head, t);
        else if ((0, _transform.isImpute)(t)) {
            transformNode = head = (0, _impute.ImputeNode).makeFromTransform(head, t);
            derivedType = 'derived';
        } else if ((0, _transform.isDensity)(t)) {
            transformNode = head = new (0, _density.DensityTransformNode)(head, t);
            derivedType = 'derived';
        } else if ((0, _transform.isQuantile)(t)) {
            transformNode = head = new (0, _quantile.QuantileTransformNode)(head, t);
            derivedType = 'derived';
        } else if ((0, _transform.isRegression)(t)) {
            transformNode = head = new (0, _regression.RegressionTransformNode)(head, t);
            derivedType = 'derived';
        } else if ((0, _transform.isLoess)(t)) {
            transformNode = head = new (0, _loess.LoessTransformNode)(head, t);
            derivedType = 'derived';
        } else {
            _log.warn(_log.message.invalidTransformIgnored(t));
            continue;
        }
        if (transformNode && derivedType !== undefined) for (const field of transformNode.producedFields() ?? [])ancestorParse.set(field, derivedType, false);
    }
    return head;
}
function parseData(model) {
    let head = parseRoot(model, model.component.data.sources);
    const { outputNodes, outputNodeRefCounts } = model.component.data;
    const data = model.data;
    const newData = data && ((0, _data.isGenerator)(data) || (0, _data.isUrlData)(data) || (0, _data.isInlineData)(data));
    const ancestorParse = !newData && model.parent ? model.parent.component.data.ancestorParse.clone() : new (0, _.AncestorParse)();
    if ((0, _data.isGenerator)(data)) {
        // insert generator transform
        if ((0, _data.isSequenceGenerator)(data)) head = new (0, _sequence.SequenceNode)(head, data.sequence);
        else if ((0, _data.isGraticuleGenerator)(data)) head = new (0, _graticule.GraticuleNode)(head, data.graticule);
        // no parsing necessary for generator
        ancestorParse.parseNothing = true;
    } else if (data?.format?.parse === null) // format.parse: null means disable parsing
    ancestorParse.parseNothing = true;
    head = (0, _formatparse.ParseNode).makeExplicit(head, model, ancestorParse) ?? head;
    // Default discrete selections require an identifer transform to
    // uniquely identify data points. Add this transform at the head of
    // the pipeline such that the identifier field is available for all
    // subsequent datasets. During optimization, we will remove this
    // transform if it proves to be unnecessary. Additional identifier
    // transforms will be necessary when new tuples are constructed
    // (e.g., post-aggregation).
    head = new (0, _identifier.IdentifierNode)(head);
    // HACK: This is equivalent for merging bin extent for union scale.
    // FIXME(https://github.com/vega/vega-lite/issues/2270): Correctly merge extent / bin node for shared bin scale
    const parentIsLayer = model.parent && (0, _model.isLayerModel)(model.parent);
    if ((0, _model.isUnitModel)(model) || (0, _model.isFacetModel)(model)) {
        if (parentIsLayer) head = (0, _bin.BinNode).makeFromEncoding(head, model) ?? head;
    }
    if (model.transforms.length > 0) head = parseTransformArray(head, model, ancestorParse);
    // create parse nodes for fields that need to be parsed (or flattened) implicitly
    const implicitSelection = (0, _formatparse.getImplicitFromSelection)(model);
    const implicitEncoding = (0, _formatparse.getImplicitFromEncoding)(model);
    head = (0, _formatparse.ParseNode).makeWithAncestors(head, {}, {
        ...implicitSelection,
        ...implicitEncoding
    }, ancestorParse) ?? head;
    if ((0, _model.isUnitModel)(model)) {
        head = (0, _geojson.GeoJSONNode).parseAll(head, model);
        head = (0, _geopoint.GeoPointNode).parseAll(head, model);
    }
    if ((0, _model.isUnitModel)(model) || (0, _model.isFacetModel)(model)) {
        if (!parentIsLayer) head = (0, _bin.BinNode).makeFromEncoding(head, model) ?? head;
        head = (0, _timeunit.TimeUnitNode).makeFromEncoding(head, model) ?? head;
        head = (0, _calculate.CalculateNode).parseAllForSortIndex(head, model);
    }
    // add an output node pre aggregation
    const raw = head = makeOutputNode((0, _data.DataSourceType).Raw, model, head);
    if ((0, _model.isUnitModel)(model)) {
        const agg = (0, _aggregate.AggregateNode).makeFromEncoding(head, model);
        if (agg) {
            head = agg;
            if ((0, _selection.requiresSelectionId)(model)) head = new (0, _identifier.IdentifierNode)(head);
        }
        head = (0, _impute.ImputeNode).makeFromEncoding(head, model) ?? head;
        head = (0, _stack.StackNode).makeFromEncoding(head, model) ?? head;
    }
    let preFilterInvalid;
    let dataSourcesForHandlingInvalidValues;
    if ((0, _model.isUnitModel)(model)) {
        const { markDef, mark, config } = model;
        const invalid = (0, _common.getMarkPropOrConfig)('invalid', markDef, config);
        const { marks, scales } = dataSourcesForHandlingInvalidValues = (0, _datasources.getDataSourcesForHandlingInvalidValues)({
            invalid,
            isPath: (0, _mark.isPathMark)(mark)
        });
        if (marks !== scales && scales === 'include-invalid-values') // Create a seperate preFilterInvalid dataSource if scales need pre-filter data but marks needs post-filter.
        preFilterInvalid = head = makeOutputNode((0, _data.DataSourceType).PreFilterInvalid, model, head);
        if (marks === 'exclude-invalid-values') head = (0, _filterinvalid.FilterInvalidNode).make(head, model, dataSourcesForHandlingInvalidValues) ?? head;
    }
    // output "main" node for marks
    const main = head = makeOutputNode((0, _data.DataSourceType).Main, model, head);
    let postFilterInvalid;
    if ((0, _model.isUnitModel)(model) && dataSourcesForHandlingInvalidValues) {
        const { marks, scales } = dataSourcesForHandlingInvalidValues;
        if (marks === 'include-invalid-values' && scales === 'exclude-invalid-values') {
            // Create a seperate postFilterInvalid dataSource if scales need post-filter data but marks needs pre-filter.
            head = (0, _filterinvalid.FilterInvalidNode).make(head, model, dataSourcesForHandlingInvalidValues) ?? head;
            postFilterInvalid = head = makeOutputNode((0, _data.DataSourceType).PostFilterInvalid, model, head);
        }
    }
    if ((0, _model.isUnitModel)(model)) (0, _parse.materializeSelections)(model, main);
    // add facet marker
    let facetRoot = null;
    if ((0, _model.isFacetModel)(model)) {
        const facetName = model.getName('facet');
        // Derive new aggregate for facet's sort field
        // augment data source with new fields for crossed facet
        head = (0, _joinaggregatefacet.makeJoinAggregateFromFacet)(head, model.facet) ?? head;
        facetRoot = new (0, _facet.FacetNode)(head, model, facetName, main.getSource());
        outputNodes[facetName] = facetRoot;
    }
    return {
        ...model.component.data,
        outputNodes,
        outputNodeRefCounts,
        raw,
        main,
        facetRoot,
        ancestorParse,
        preFilterInvalid,
        postFilterInvalid
    };
}
function makeOutputNode(dataSourceType, model, head) {
    const { outputNodes, outputNodeRefCounts } = model.component.data;
    const name = model.getDataName(dataSourceType);
    const node = new (0, _dataflow.OutputNode)(head, name, dataSourceType, outputNodeRefCounts);
    outputNodes[name] = node;
    return node;
}

},{".":"3sqbI","../../data":"dILEy","../invalid/datasources":"grpNH","../../log":"loqTw","../../mark":"3Z1xx","../../transform":"ld5WF","../../util":"acUGA","../common":"jegt8","../model":"hQHib","../selection":"7GXIu","../selection/parse":"bgKKc","./aggregate":"8WvlR","./bin":"3xZkr","./calculate":"aCN2T","./dataflow":"btJXI","./density":"aWjoR","./extent":"4tyGU","./facet":"ce2Ry","./filter":"8Tzn7","./filterinvalid":"2Zybg","./flatten":"ceJ4t","./fold":"1zNXb","./formatparse":"2mSh3","./geojson":"aXTII","./geopoint":"hJ38i","./graticule":"84yrw","./identifier":"cuiH8","./impute":"7krbQ","./joinaggregate":"fFW6U","./joinaggregatefacet":"eucfh","./loess":"gMkGf","./lookup":"k5SyK","./pivot":"7CfmC","./quantile":"k1FJv","./regression":"a2AiO","./sample":"lElH5","./sequence":"jQuXh","./source":"bhsCG","./stack":"2WMdr","./timeunit":"iPsUH","./window":"gHMn4","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3sqbI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Class to track interesting properties (see https://15721.courses.cs.cmu.edu/spring2016/papers/graefe-ieee1995.pdf)
 * about how fields have been parsed or whether they have been derived in a transform. We use this to not parse the
 * same field again (or differently).
 */ parcelHelpers.export(exports, "AncestorParse", ()=>AncestorParse);
var _split = require("../split");
class AncestorParse extends (0, _split.Split) {
    constructor(explicit = {}, implicit = {}, parseNothing = false){
        super(explicit, implicit);
        this.explicit = explicit;
        this.implicit = implicit;
        this.parseNothing = parseNothing;
    }
    clone() {
        const clone = super.clone();
        clone.parseNothing = this.parseNothing;
        return clone;
    }
}

},{"../split":"eXS2w","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"eXS2w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Generic class for storing properties that are explicitly specified
 * and implicitly determined by the compiler.
 * This is important for scale/axis/legend merging as
 * we want to prioritize properties that users explicitly specified.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
parcelHelpers.export(exports, "Split", ()=>Split);
parcelHelpers.export(exports, "makeExplicit", ()=>makeExplicit);
parcelHelpers.export(exports, "makeImplicit", ()=>makeImplicit);
parcelHelpers.export(exports, "tieBreakByComparing", ()=>tieBreakByComparing);
parcelHelpers.export(exports, "defaultTieBreaker", ()=>defaultTieBreaker);
parcelHelpers.export(exports, "mergeValuesWithExplicit", ()=>mergeValuesWithExplicit);
var _log = require("../log");
var _util = require("../util");
class Split {
    constructor(explicit = {}, implicit = {}){
        this.explicit = explicit;
        this.implicit = implicit;
    }
    clone() {
        return new Split((0, _util.duplicate)(this.explicit), (0, _util.duplicate)(this.implicit));
    }
    combine() {
        return {
            ...this.explicit,
            ...this.implicit
        };
    }
    get(key) {
        // Explicit has higher precedence
        return (0, _util.getFirstDefined)(this.explicit[key], this.implicit[key]);
    }
    getWithExplicit(key) {
        // Explicit has higher precedence
        if (this.explicit[key] !== undefined) return {
            explicit: true,
            value: this.explicit[key]
        };
        else if (this.implicit[key] !== undefined) return {
            explicit: false,
            value: this.implicit[key]
        };
        return {
            explicit: false,
            value: undefined
        };
    }
    setWithExplicit(key, { value, explicit }) {
        if (value !== undefined) this.set(key, value, explicit);
    }
    set(key, value, explicit) {
        delete this[explicit ? 'implicit' : 'explicit'][key];
        this[explicit ? 'explicit' : 'implicit'][key] = value;
        return this;
    }
    copyKeyFromSplit(key, { explicit, implicit }) {
        // Explicit has higher precedence
        if (explicit[key] !== undefined) this.set(key, explicit[key], true);
        else if (implicit[key] !== undefined) this.set(key, implicit[key], false);
    }
    copyKeyFromObject(key, s) {
        // Explicit has higher precedence
        if (s[key] !== undefined) this.set(key, s[key], true);
    }
    /**
     * Merge split object into this split object. Properties from the other split
     * overwrite properties from this split.
     */ copyAll(other) {
        for (const key of (0, _util.keys)(other.combine())){
            const val = other.getWithExplicit(key);
            this.setWithExplicit(key, val);
        }
    }
}
function makeExplicit(value) {
    return {
        explicit: true,
        value
    };
}
function makeImplicit(value) {
    return {
        explicit: false,
        value
    };
}
function tieBreakByComparing(compare) {
    return (v1, v2, property, propertyOf)=>{
        const diff = compare(v1.value, v2.value);
        if (diff > 0) return v1;
        else if (diff < 0) return v2;
        return defaultTieBreaker(v1, v2, property, propertyOf);
    };
}
function defaultTieBreaker(v1, v2, property, propertyOf) {
    if (v1.explicit && v2.explicit) _log.warn(_log.message.mergeConflictingProperty(property, propertyOf, v1.value, v2.value));
    // If equal score, prefer v1.
    return v1;
}
function mergeValuesWithExplicit(v1, v2, property, propertyOf, tieBreaker = defaultTieBreaker) {
    if (v1 === undefined || v1.value === undefined) // For first run
    return v2;
    if (v1.explicit && !v2.explicit) return v1;
    else if (v2.explicit && !v1.explicit) return v2;
    else if ((0, _util.deepEqual)(v1.value, v2.value)) return v1;
    else return tieBreaker(v1, v2, property, propertyOf);
}

},{"../log":"loqTw","../util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dILEy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isUrlData", ()=>isUrlData);
parcelHelpers.export(exports, "isInlineData", ()=>isInlineData);
parcelHelpers.export(exports, "isNamedData", ()=>isNamedData);
parcelHelpers.export(exports, "isGenerator", ()=>isGenerator);
parcelHelpers.export(exports, "isSequenceGenerator", ()=>isSequenceGenerator);
parcelHelpers.export(exports, "isSphereGenerator", ()=>isSphereGenerator);
parcelHelpers.export(exports, "isGraticuleGenerator", ()=>isGraticuleGenerator);
parcelHelpers.export(exports, "DataSourceType", ()=>DataSourceType);
var _util = require("./util");
function isUrlData(data) {
    return (0, _util.hasProperty)(data, 'url');
}
function isInlineData(data) {
    return (0, _util.hasProperty)(data, 'values');
}
function isNamedData(data) {
    return (0, _util.hasProperty)(data, 'name') && !isUrlData(data) && !isInlineData(data) && !isGenerator(data);
}
function isGenerator(data) {
    return data && (isSequenceGenerator(data) || isSphereGenerator(data) || isGraticuleGenerator(data));
}
function isSequenceGenerator(data) {
    return (0, _util.hasProperty)(data, 'sequence');
}
function isSphereGenerator(data) {
    return (0, _util.hasProperty)(data, 'sphere');
}
function isGraticuleGenerator(data) {
    return (0, _util.hasProperty)(data, 'graticule');
}
var DataSourceType;
(function(DataSourceType) {
    DataSourceType[DataSourceType["Raw"] = 0] = "Raw";
    /** Main data source for marks */ DataSourceType[DataSourceType["Main"] = 1] = "Main";
    DataSourceType[DataSourceType["Row"] = 2] = "Row";
    DataSourceType[DataSourceType["Column"] = 3] = "Column";
    DataSourceType[DataSourceType["Lookup"] = 4] = "Lookup";
    /** Pre-filter-invalid data source for scale domains */ DataSourceType[DataSourceType["PreFilterInvalid"] = 5] = "PreFilterInvalid";
    /** Post-filter-invalid data source for scale domains */ DataSourceType[DataSourceType["PostFilterInvalid"] = 6] = "PostFilterInvalid";
})(DataSourceType || (DataSourceType = {}));

},{"./util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"grpNH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDataSourcesForHandlingInvalidValues", ()=>getDataSourcesForHandlingInvalidValues);
parcelHelpers.export(exports, "getScaleDataSourceForHandlingInvalidValues", ()=>getScaleDataSourceForHandlingInvalidValues);
var _data = require("../../data");
var _normalizeInvalidDataMode = require("./normalizeInvalidDataMode");
function getDataSourcesForHandlingInvalidValues({ invalid, isPath }) {
    const normalizedInvalid = (0, _normalizeInvalidDataMode.normalizeInvalidDataMode)(invalid, {
        isPath
    });
    switch(normalizedInvalid){
        case 'filter':
            // Both marks and scales use post-filter data
            return {
                marks: 'exclude-invalid-values',
                scales: 'exclude-invalid-values'
            };
        case 'break-paths-show-domains':
            return {
                // Path-based marks use pre-filter data so we know to skip these invalid points in the path.
                // For non-path based marks, we skip by not showing them at all.
                marks: isPath ? 'include-invalid-values' : 'exclude-invalid-values',
                scales: 'include-invalid-values'
            };
        case 'break-paths-filter-domains':
            // For path marks, the marks will use unfiltered data (and skip points). But we need a separate data sources to feed the domain.
            // For non-path marks, we can use the filtered data for both marks and scales.
            return {
                marks: isPath ? 'include-invalid-values' : 'exclude-invalid-values',
                // Unlike 'break-paths-show-domains', 'break-paths-filter-domains' uses post-filter data to feed scale.
                scales: 'exclude-invalid-values'
            };
        case 'show':
            return {
                marks: 'include-invalid-values',
                scales: 'include-invalid-values'
            };
    }
}
function getScaleDataSourceForHandlingInvalidValues(props) {
    const { marks, scales } = getDataSourcesForHandlingInvalidValues(props);
    if (marks === scales) // If both marks and scales use the same data, there is only the main data source.
    return (0, _data.DataSourceType).Main;
    // If marks and scales use differetnt data, return the pre/post-filter data source accordingly.
    return scales === 'include-invalid-values' ? (0, _data.DataSourceType).PreFilterInvalid : (0, _data.DataSourceType).PostFilterInvalid;
}

},{"../../data":"dILEy","./normalizeInvalidDataMode":"kTDie","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hQHib":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NameMap", ()=>NameMap);
/*
  We use type guards instead of `instanceof` as `instanceof` makes
  different parts of the compiler depend on the actual implementation of
  the model classes, which in turn depend on different parts of the compiler.
  Thus, `instanceof` leads to circular dependency problems.

  On the other hand, type guards only make different parts of the compiler
  depend on the type of the model classes, but not the actual implementation.
*/ parcelHelpers.export(exports, "isUnitModel", ()=>isUnitModel);
parcelHelpers.export(exports, "isFacetModel", ()=>isFacetModel);
parcelHelpers.export(exports, "isConcatModel", ()=>isConcatModel);
parcelHelpers.export(exports, "isLayerModel", ()=>isLayerModel);
parcelHelpers.export(exports, "Model", ()=>Model);
/** Abstract class for UnitModel and FacetModel. Both of which can contain fieldDefs as a part of its own specification. */ parcelHelpers.export(exports, "ModelWithField", ()=>ModelWithField);
var _channel = require("../channel");
var _channeldef = require("../channeldef");
var _data = require("../data");
var _encoding = require("../encoding");
var _expr = require("../expr");
var _log = require("../log");
var _scale = require("../scale");
var _spec = require("../spec");
var _base = require("../spec/base");
var _title = require("../title");
var _transform = require("../transform");
var _util = require("../util");
var _vegaSchema = require("../vega.schema");
var _assemble = require("./axis/assemble");
var _common = require("./common");
var _assemble1 = require("./header/assemble");
var _component = require("./header/component");
var _assemble2 = require("./layoutsize/assemble");
var _component1 = require("./layoutsize/component");
var _assemble3 = require("./legend/assemble");
var _parse = require("./legend/parse");
var _assemble4 = require("./projection/assemble");
var _parse1 = require("./projection/parse");
var _assemble5 = require("./scale/assemble");
var _domain = require("./scale/domain");
var _parse2 = require("./scale/parse");
var _split = require("./split");
class NameMap {
    constructor(){
        this.nameMap = {};
    }
    rename(oldName, newName) {
        this.nameMap[oldName] = newName;
    }
    has(name) {
        return this.nameMap[name] !== undefined;
    }
    get(name) {
        // If the name appears in the _nameMap, we need to read its new name.
        // We have to loop over the dict just in case the new name also gets renamed.
        while(this.nameMap[name] && name !== this.nameMap[name])name = this.nameMap[name];
        return name;
    }
}
function isUnitModel(model) {
    return model?.type === 'unit';
}
function isFacetModel(model) {
    return model?.type === 'facet';
}
function isConcatModel(model) {
    return model?.type === 'concat';
}
function isLayerModel(model) {
    return model?.type === 'layer';
}
class Model {
    constructor(spec, type, parent, parentGivenName, config, resolve, view){
        this.type = type;
        this.parent = parent;
        this.config = config;
        this.parent = parent;
        this.config = config;
        this.view = (0, _expr.replaceExprRef)(view);
        // If name is not provided, always use parent's givenName to avoid name conflicts.
        this.name = spec.name ?? parentGivenName;
        this.title = (0, _title.isText)(spec.title) ? {
            text: spec.title
        } : spec.title ? (0, _expr.replaceExprRef)(spec.title) : undefined;
        // Shared name maps
        this.scaleNameMap = parent ? parent.scaleNameMap : new NameMap();
        this.projectionNameMap = parent ? parent.projectionNameMap : new NameMap();
        this.signalNameMap = parent ? parent.signalNameMap : new NameMap();
        this.data = spec.data;
        this.description = spec.description;
        this.transforms = (0, _transform.normalizeTransform)(spec.transform ?? []);
        this.layout = type === 'layer' || type === 'unit' ? {} : (0, _base.extractCompositionLayout)(spec, type, config);
        this.component = {
            data: {
                sources: parent ? parent.component.data.sources : [],
                outputNodes: parent ? parent.component.data.outputNodes : {},
                outputNodeRefCounts: parent ? parent.component.data.outputNodeRefCounts : {},
                // data is faceted if the spec is a facet spec or the parent has faceted data and data is undefined
                isFaceted: (0, _spec.isFacetSpec)(spec) || parent?.component.data.isFaceted && spec.data === undefined
            },
            layoutSize: new (0, _split.Split)(),
            layoutHeaders: {
                row: {},
                column: {},
                facet: {}
            },
            mark: null,
            resolve: {
                scale: {},
                axis: {},
                legend: {},
                ...resolve ? (0, _util.duplicate)(resolve) : {}
            },
            selection: null,
            scales: null,
            projection: null,
            axes: {},
            legends: {}
        };
    }
    get width() {
        return this.getSizeSignalRef('width');
    }
    get height() {
        return this.getSizeSignalRef('height');
    }
    parse() {
        this.parseScale();
        this.parseLayoutSize(); // depends on scale
        this.renameTopLevelLayoutSizeSignal();
        this.parseSelections();
        this.parseProjection();
        this.parseData(); // (pathorder) depends on markDef; selection filters depend on parsed selections; depends on projection because some transforms require the finalized projection name.
        this.parseAxesAndHeaders(); // depends on scale and layout size
        this.parseLegends(); // depends on scale, markDef
        this.parseMarkGroup(); // depends on data name, scale, layout size, axisGroup, and children's scale, axis, legend and mark.
    }
    parseScale() {
        (0, _parse2.parseScales)(this);
    }
    parseProjection() {
        (0, _parse1.parseProjection)(this);
    }
    /**
     * Rename top-level spec's size to be just width / height, ignoring model name.
     * This essentially merges the top-level spec's width/height signals with the width/height signals
     * to help us reduce redundant signals declaration.
     */ renameTopLevelLayoutSizeSignal() {
        if (this.getName('width') !== 'width') this.renameSignal(this.getName('width'), 'width');
        if (this.getName('height') !== 'height') this.renameSignal(this.getName('height'), 'height');
    }
    parseLegends() {
        (0, _parse.parseLegend)(this);
    }
    assembleEncodeFromView(view) {
        // Exclude "style"
        const { style: _, ...baseView } = view;
        const e = {};
        for (const property of (0, _util.keys)(baseView)){
            const value = baseView[property];
            if (value !== undefined) e[property] = (0, _common.signalOrValueRef)(value);
        }
        return e;
    }
    assembleGroupEncodeEntry(isTopLevel) {
        let encodeEntry = {};
        if (this.view) encodeEntry = this.assembleEncodeFromView(this.view);
        if (!isTopLevel) {
            // Descriptions are already added to the top-level description so we only need to add them to the inner views.
            if (this.description) encodeEntry['description'] = (0, _common.signalOrValueRef)(this.description);
            // For top-level spec, we can set the global width and height signal to adjust the group size.
            // For other child specs, we have to manually set width and height in the encode entry.
            if (this.type === 'unit' || this.type === 'layer') return {
                width: this.getSizeSignalRef('width'),
                height: this.getSizeSignalRef('height'),
                ...encodeEntry
            };
        }
        return (0, _util.isEmpty)(encodeEntry) ? undefined : encodeEntry;
    }
    assembleLayout() {
        if (!this.layout) return undefined;
        const { spacing, ...layout } = this.layout;
        const { component, config } = this;
        const titleBand = (0, _assemble1.assembleLayoutTitleBand)(component.layoutHeaders, config);
        return {
            padding: spacing,
            ...this.assembleDefaultLayout(),
            ...layout,
            ...titleBand ? {
                titleBand
            } : {}
        };
    }
    assembleDefaultLayout() {
        return {};
    }
    assembleHeaderMarks() {
        const { layoutHeaders } = this.component;
        let headerMarks = [];
        for (const channel of (0, _channel.FACET_CHANNELS))if (layoutHeaders[channel].title) headerMarks.push((0, _assemble1.assembleTitleGroup)(this, channel));
        for (const channel of (0, _component.HEADER_CHANNELS))headerMarks = headerMarks.concat((0, _assemble1.assembleHeaderGroups)(this, channel));
        return headerMarks;
    }
    assembleAxes() {
        return (0, _assemble.assembleAxes)(this.component.axes, this.config);
    }
    assembleLegends() {
        return (0, _assemble3.assembleLegends)(this);
    }
    assembleProjections() {
        return (0, _assemble4.assembleProjections)(this);
    }
    assembleTitle() {
        const { encoding, ...titleNoEncoding } = this.title ?? {};
        const title = {
            ...(0, _title.extractTitleConfig)(this.config.title).nonMarkTitleProperties,
            ...titleNoEncoding,
            ...encoding ? {
                encode: {
                    update: encoding
                }
            } : {}
        };
        if (title.text) {
            if ((0, _util.contains)([
                'unit',
                'layer'
            ], this.type)) // Unit/Layer
            {
                if ((0, _util.contains)([
                    'middle',
                    undefined
                ], title.anchor)) title.frame ?? (title.frame = 'group');
            } else // composition with Vega layout
            // Set title = "start" by default for composition as "middle" does not look nice
            // https://github.com/vega/vega/issues/960#issuecomment-471360328
            title.anchor ?? (title.anchor = 'start');
            return (0, _util.isEmpty)(title) ? undefined : title;
        }
        return undefined;
    }
    /**
     * Assemble the mark group for this model. We accept optional `signals` so that we can include concat top-level signals with the top-level model's local signals.
     */ assembleGroup(signals = []) {
        const group = {};
        signals = signals.concat(this.assembleSignals());
        if (signals.length > 0) group.signals = signals;
        const layout = this.assembleLayout();
        if (layout) group.layout = layout;
        group.marks = [].concat(this.assembleHeaderMarks(), this.assembleMarks());
        // Only include scales if this spec is top-level or if parent is facet.
        // (Otherwise, it will be merged with upper-level's scope.)
        const scales = !this.parent || isFacetModel(this.parent) ? (0, _assemble5.assembleScales)(this) : [];
        if (scales.length > 0) group.scales = scales;
        const axes = this.assembleAxes();
        if (axes.length > 0) group.axes = axes;
        const legends = this.assembleLegends();
        if (legends.length > 0) group.legends = legends;
        return group;
    }
    getName(text) {
        return (0, _util.varName)((this.name ? `${this.name}_` : '') + text);
    }
    getDataName(type) {
        return this.getName((0, _data.DataSourceType)[type].toLowerCase());
    }
    /**
     * Request a data source name for the given data source type and mark that data source as required.
     * This method should be called in parse, so that all used data source can be correctly instantiated in assembleData().
     * You can lookup the correct dataset name in assemble with `lookupDataSource`.
     */ requestDataName(name) {
        const fullName = this.getDataName(name);
        // Increase ref count. This is critical because otherwise we won't create a data source.
        // We also increase the ref counts on OutputNode.getSource() calls.
        const refCounts = this.component.data.outputNodeRefCounts;
        refCounts[fullName] = (refCounts[fullName] || 0) + 1;
        return fullName;
    }
    getSizeSignalRef(layoutSizeType) {
        if (isFacetModel(this.parent)) {
            const sizeType = (0, _component1.getSizeTypeFromLayoutSizeType)(layoutSizeType);
            const channel = (0, _channel.getPositionScaleChannel)(sizeType);
            const scaleComponent = this.component.scales[channel];
            if (scaleComponent && !scaleComponent.merged) {
                // independent scale
                const type = scaleComponent.get('type');
                const range = scaleComponent.get('range');
                if ((0, _scale.hasDiscreteDomain)(type) && (0, _vegaSchema.isVgRangeStep)(range)) {
                    const scaleName = scaleComponent.get('name');
                    const domain = (0, _domain.assembleDomain)(this, channel);
                    const field = (0, _domain.getFieldFromDomain)(domain);
                    if (field) {
                        const fieldRef = (0, _channeldef.vgField)({
                            aggregate: 'distinct',
                            field
                        }, {
                            expr: 'datum'
                        });
                        return {
                            signal: (0, _assemble2.sizeExpr)(scaleName, scaleComponent, fieldRef)
                        };
                    } else {
                        _log.warn(_log.message.unknownField(channel));
                        return null;
                    }
                }
            }
        }
        return {
            signal: this.signalNameMap.get(this.getName(layoutSizeType))
        };
    }
    /**
     * Lookup the name of the datasource for an output node. You probably want to call this in assemble.
     */ lookupDataSource(name) {
        const node = this.component.data.outputNodes[name];
        if (!node) // Name not found in map so let's just return what we got.
        // This can happen if we already have the correct name.
        return name;
        return node.getSource();
    }
    getSignalName(oldSignalName) {
        return this.signalNameMap.get(oldSignalName);
    }
    renameSignal(oldName, newName) {
        this.signalNameMap.rename(oldName, newName);
    }
    renameScale(oldName, newName) {
        this.scaleNameMap.rename(oldName, newName);
    }
    renameProjection(oldName, newName) {
        this.projectionNameMap.rename(oldName, newName);
    }
    /**
     * @return scale name for a given channel after the scale has been parsed and named.
     */ scaleName(originalScaleName, parse) {
        if (parse) // During the parse phase always return a value
        // No need to refer to rename map because a scale can't be renamed
        // before it has the original name.
        return this.getName(originalScaleName);
        // If there is a scale for the channel, it should either
        // be in the scale component or exist in the name map
        if (// If there is a scale for the channel, there should be a local scale component for it
        (0, _channel.isChannel)(originalScaleName) && (0, _channel.isScaleChannel)(originalScaleName) && this.component.scales[originalScaleName] || // in the scale name map (the scale get merged by its parent)
        this.scaleNameMap.has(this.getName(originalScaleName))) return this.scaleNameMap.get(this.getName(originalScaleName));
        return undefined;
    }
    /**
     * @return projection name after the projection has been parsed and named.
     */ projectionName(parse) {
        if (parse) // During the parse phase always return a value
        // No need to refer to rename map because a projection can't be renamed
        // before it has the original name.
        return this.getName('projection');
        if (this.component.projection && !this.component.projection.merged || this.projectionNameMap.has(this.getName('projection'))) return this.projectionNameMap.get(this.getName('projection'));
        return undefined;
    }
    /**
     * Traverse a model's hierarchy to get the scale component for a particular channel.
     */ getScaleComponent(channel) {
        /* istanbul ignore next: This is warning for debugging test */ if (!this.component.scales) throw new Error('getScaleComponent cannot be called before parseScale(). Make sure you have called parseScale or use parseUnitModelWithScale().');
        const localScaleComponent = this.component.scales[channel];
        if (localScaleComponent && !localScaleComponent.merged) return localScaleComponent;
        return this.parent ? this.parent.getScaleComponent(channel) : undefined;
    }
    getScaleType(channel) {
        const scaleComponent = this.getScaleComponent(channel);
        return scaleComponent ? scaleComponent.get('type') : undefined;
    }
    /**
     * Traverse a model's hierarchy to get a particular selection component.
     */ getSelectionComponent(variableName, origName) {
        let sel = this.component.selection[variableName];
        if (!sel && this.parent) sel = this.parent.getSelectionComponent(variableName, origName);
        if (!sel) throw new Error(_log.message.selectionNotFound(origName));
        return sel;
    }
    /**
     * Returns true if the model has a signalRef for an axis orient.
     */ hasAxisOrientSignalRef() {
        return this.component.axes.x?.some((a)=>a.hasOrientSignalRef()) || this.component.axes.y?.some((a)=>a.hasOrientSignalRef());
    }
}
class ModelWithField extends Model {
    /** Get "field" reference for Vega */ vgField(channel, opt = {}) {
        const fieldDef = this.fieldDef(channel);
        if (!fieldDef) return undefined;
        return (0, _channeldef.vgField)(fieldDef, opt);
    }
    reduceFieldDef(f, init) {
        return (0, _encoding.reduce)(this.getMapping(), (acc, cd, c)=>{
            const fieldDef = (0, _channeldef.getFieldDef)(cd);
            if (fieldDef) return f(acc, fieldDef, c);
            return acc;
        }, init);
    }
    forEachFieldDef(f, t) {
        (0, _encoding.forEach)(this.getMapping(), (cd, c)=>{
            const fieldDef = (0, _channeldef.getFieldDef)(cd);
            if (fieldDef) f(fieldDef, c);
        }, t);
    }
}

},{"../channel":"liLED","../channeldef":"dsccb","../data":"dILEy","../encoding":"2Ohsj","../expr":"ev4sO","../log":"loqTw","../scale":"bdpXN","../spec":"5gjAD","../spec/base":"5uH6T","../title":"bnPA4","../transform":"ld5WF","../util":"acUGA","../vega.schema":"3mBOT","./axis/assemble":"jjOQk","./common":"jegt8","./header/assemble":"kmU8z","./header/component":"d5ljn","./layoutsize/assemble":"cyXx5","./layoutsize/component":"dwyom","./legend/assemble":"fTNbV","./legend/parse":"dE0Bh","./projection/assemble":"dzHqC","./projection/parse":"bG3b4","./scale/assemble":"tWUai","./scale/domain":"ebJoM","./scale/parse":"3mgst","./split":"eXS2w","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"jjOQk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assembleAxis", ()=>assembleAxis);
/**
 * Add axis signals so grid line works correctly
 * (Fix https://github.com/vega/vega-lite/issues/4226)
 */ parcelHelpers.export(exports, "assembleAxisSignals", ()=>assembleAxisSignals);
parcelHelpers.export(exports, "assembleAxes", ()=>assembleAxes);
var _vegaUtil = require("vega-util");
var _axis = require("../../axis");
var _channel = require("../../channel");
var _channeldef = require("../../channeldef");
var _title = require("../../title");
var _util = require("../../util");
var _vegaSchema = require("../../vega.schema");
var _common = require("../common");
var _predicate = require("../predicate");
function assembleTitle(title, config) {
    if (!title) return undefined;
    if ((0, _vegaUtil.isArray)(title) && !(0, _title.isText)(title)) return title.map((fieldDef)=>(0, _channeldef.defaultTitle)(fieldDef, config)).join(', ');
    return title;
}
function setAxisEncode(axis, part, vgProp, vgRef) {
    var _a, _b;
    axis.encode ?? (axis.encode = {});
    (_a = axis.encode)[part] ?? (_a[part] = {});
    (_b = axis.encode[part]).update ?? (_b.update = {});
    // TODO: remove as any after https://github.com/prisma/nexus-prisma/issues/291
    axis.encode[part].update[vgProp] = vgRef;
}
function assembleAxis(axisCmpt, kind, config, opt = {
    header: false
}) {
    const { disable, orient, scale, labelExpr, title, zindex, ...axis } = axisCmpt.combine();
    if (disable) return undefined;
    for(const p in axis){
        const prop = p;
        const propType = (0, _axis.AXIS_PROPERTY_TYPE)[prop];
        const propValue = axis[prop];
        if (propType && propType !== kind && propType !== 'both') // Remove properties that are not valid for this kind of axis
        delete axis[prop];
        else if ((0, _axis.isConditionalAxisValue)(propValue)) {
            // deal with conditional axis value
            const { condition, ...valueOrSignalRef } = propValue;
            const conditions = (0, _vegaUtil.array)(condition);
            const propIndex = (0, _axis.CONDITIONAL_AXIS_PROP_INDEX)[prop];
            if (propIndex) {
                const { vgProp, part } = propIndex;
                // If there is a corresponding Vega property for the channel,
                // use Vega's custom axis encoding and delete the original axis property to avoid conflicts
                const vgRef = [
                    ...conditions.map((c)=>{
                        const { test, ...valueOrSignalCRef } = c;
                        return {
                            test: (0, _predicate.expression)(null, test),
                            ...valueOrSignalCRef
                        };
                    }),
                    valueOrSignalRef
                ];
                setAxisEncode(axis, part, vgProp, vgRef);
                delete axis[prop];
            } else if (propIndex === null) {
                // If propIndex is null, this means we support conditional axis property by converting the condition to signal instead.
                const signalRef = {
                    signal: conditions.map((c)=>{
                        const { test, ...valueOrSignalCRef } = c;
                        return `${(0, _predicate.expression)(null, test)} ? ${(0, _common.exprFromValueRefOrSignalRef)(valueOrSignalCRef)} : `;
                    }).join('') + (0, _common.exprFromValueRefOrSignalRef)(valueOrSignalRef)
                };
                axis[prop] = signalRef;
            }
        } else if ((0, _vegaSchema.isSignalRef)(propValue)) {
            const propIndex = (0, _axis.CONDITIONAL_AXIS_PROP_INDEX)[prop];
            if (propIndex) {
                const { vgProp, part } = propIndex;
                // FIXME: remove as any
                setAxisEncode(axis, part, vgProp, propValue);
                delete axis[prop];
            } // else do nothing since the property already supports signal
        }
        // Do not pass labelAlign/Baseline = null to Vega since it won't pass the schema
        // Note that we need to use null so the default labelAlign is preserved.
        if ((0, _util.contains)([
            'labelAlign',
            'labelBaseline'
        ], prop) && axis[prop] === null) delete axis[prop];
    }
    if (kind === 'grid') {
        if (!axis.grid) return undefined;
        // Remove unnecessary encode block
        if (axis.encode) {
            // Only need to keep encode block for grid
            const { grid } = axis.encode;
            axis.encode = {
                ...grid ? {
                    grid
                } : {}
            };
            if ((0, _util.isEmpty)(axis.encode)) delete axis.encode;
        }
        return {
            scale,
            orient,
            ...axis,
            domain: false,
            labels: false,
            aria: false,
            // Always set min/maxExtent to 0 to ensure that `config.axis*.minExtent` and `config.axis*.maxExtent`
            // would not affect gridAxis
            maxExtent: 0,
            minExtent: 0,
            ticks: false,
            zindex: (0, _util.getFirstDefined)(zindex, 0) // put grid behind marks by default
        };
    } else {
        // kind === 'main'
        if (!opt.header && axisCmpt.mainExtracted) // if mainExtracted has been extracted to a separate facet
        return undefined;
        if (labelExpr !== undefined) {
            let expr = labelExpr;
            if (axis.encode?.labels?.update && (0, _vegaSchema.isSignalRef)(axis.encode.labels.update.text)) expr = (0, _util.replaceAll)(labelExpr, 'datum.label', axis.encode.labels.update.text.signal);
            setAxisEncode(axis, 'labels', 'text', {
                signal: expr
            });
        }
        if (axis.labelAlign === null) delete axis.labelAlign;
        // Remove unnecessary encode block
        if (axis.encode) {
            for (const part of (0, _axis.AXIS_PARTS))if (!axisCmpt.hasAxisPart(part)) delete axis.encode[part];
            if ((0, _util.isEmpty)(axis.encode)) delete axis.encode;
        }
        const titleString = assembleTitle(title, config);
        return {
            scale,
            orient,
            grid: false,
            ...titleString ? {
                title: titleString
            } : {},
            ...axis,
            ...config.aria === false ? {
                aria: false
            } : {},
            zindex: (0, _util.getFirstDefined)(zindex, 0) // put axis line above marks by default
        };
    }
}
function assembleAxisSignals(model) {
    const { axes } = model.component;
    const signals = [];
    for (const channel of (0, _channel.POSITION_SCALE_CHANNELS))if (axes[channel]) {
        for (const axis of axes[channel])if (!axis.get('disable') && !axis.get('gridScale')) {
            // If there is x-axis but no y-scale for gridScale, need to set height/width so x-axis can draw the grid with the right height. Same for y-axis and width.
            const sizeType = channel === 'x' ? 'height' : 'width';
            const update = model.getSizeSignalRef(sizeType).signal;
            if (sizeType !== update) signals.push({
                name: sizeType,
                update
            });
        }
    }
    return signals;
}
function assembleAxes(axisComponents, config) {
    const { x = [], y = [] } = axisComponents;
    return [
        ...x.map((a)=>assembleAxis(a, 'grid', config)),
        ...y.map((a)=>assembleAxis(a, 'grid', config)),
        ...x.map((a)=>assembleAxis(a, 'main', config)),
        ...y.map((a)=>assembleAxis(a, 'main', config))
    ].filter((a)=>a); // filter undefined
}

},{"vega-util":"7f6sQ","../../axis":"4nB06","../../channel":"liLED","../../channeldef":"dsccb","../../title":"bnPA4","../../util":"acUGA","../../vega.schema":"3mBOT","../common":"jegt8","../predicate":"d0sTM","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"d0sTM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Converts a predicate into an expression.
 */ // model is only used for selection filters.
parcelHelpers.export(exports, "expression", ()=>expression);
var _vegaUtil = require("vega-util");
var _predicate = require("../predicate");
var _util = require("../util");
var _parse = require("./selection/parse");
function expression(model, filterOp, node) {
    return (0, _util.logicalExpr)(filterOp, (predicate)=>{
        if ((0, _vegaUtil.isString)(predicate)) return predicate;
        else if ((0, _predicate.isSelectionPredicate)(predicate)) return (0, _parse.parseSelectionPredicate)(model, predicate, node);
        else // Filter Object
        return (0, _predicate.fieldFilterExpression)(predicate);
    });
}

},{"vega-util":"7f6sQ","../predicate":"gynPW","../util":"acUGA","./selection/parse":"bgKKc","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bgKKc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseUnitSelection", ()=>parseUnitSelection);
parcelHelpers.export(exports, "parseSelectionPredicate", ()=>parseSelectionPredicate);
parcelHelpers.export(exports, "parseSelectionExtent", ()=>parseSelectionExtent);
parcelHelpers.export(exports, "materializeSelections", ()=>materializeSelections);
var _vegaEventSelector = require("vega-event-selector");
var _vegaUtil = require("vega-util");
var _ = require(".");
var _log = require("../../log");
var _util = require("../../util");
var _dataflow = require("../data/dataflow");
var _filter = require("../data/filter");
var _data = require("../../data");
var _message = require("../../log/message");
function parseUnitSelection(model, selDefs) {
    const selCmpts = {};
    const selectionConfig = model.config.selection;
    if (!selDefs || !selDefs.length) return selCmpts;
    let nTimerSelections = 0;
    for (const def of selDefs){
        const name = (0, _util.varName)(def.name);
        const selDef = def.select;
        const type = (0, _vegaUtil.isString)(selDef) ? selDef : selDef.type;
        const defaults = (0, _vegaUtil.isObject)(selDef) ? (0, _util.duplicate)(selDef) : {
            type
        };
        // Set default values from config if a property hasn't been specified,
        // or if it is true. E.g., "translate": true should use the default
        // event handlers for translate. However, true may be a valid value for
        // a property (e.g., "nearest": true).
        const cfg = selectionConfig[type];
        for(const key in cfg){
            // Project transform applies its defaults.
            if (key === 'fields' || key === 'encodings') continue;
            if (key === 'mark') defaults.mark = {
                ...cfg.mark,
                ...defaults.mark
            };
            if (defaults[key] === undefined || defaults[key] === true) defaults[key] = (0, _util.duplicate)(cfg[key] ?? defaults[key]);
        }
        const selCmpt = selCmpts[name] = {
            ...defaults,
            name,
            type,
            init: def.value,
            bind: def.bind,
            events: (0, _vegaUtil.isString)(defaults.on) ? (0, _vegaEventSelector.parseSelector)(defaults.on, 'scope') : (0, _vegaUtil.array)((0, _util.duplicate)(defaults.on))
        };
        if ((0, _.isTimerSelection)(selCmpt)) {
            nTimerSelections++;
            // check for multiple timer selections and ignore all but the first one
            if (nTimerSelections > 1) {
                delete selCmpts[name];
                continue;
            }
        }
        const def_ = (0, _util.duplicate)(def); // defensive copy to prevent compilers from causing side effects
        for (const c of (0, _.selectionCompilers))if (c.defined(selCmpt) && c.parse) c.parse(model, selCmpt, def_);
    }
    if (nTimerSelections > 1) // if multiple timer selections were found, issue a warning
    (0, _log.warn)((0, _message.MULTIPLE_TIMER_ANIMATION_SELECTION));
    return selCmpts;
}
function parseSelectionPredicate(model, pred, dfnode, datum = 'datum') {
    const name = (0, _vegaUtil.isString)(pred) ? pred : pred.param;
    const vname = (0, _util.varName)(name);
    const store = (0, _vegaUtil.stringValue)(vname + (0, _.STORE));
    let selCmpt;
    try {
        selCmpt = model.getSelectionComponent(vname, name);
    } catch (e) {
        // If a selection isn't found, treat as a variable parameter and coerce to boolean.
        return `!!${vname}`;
    }
    if (selCmpt.project.timeUnit) {
        const child = dfnode ?? model.component.data.raw;
        const tunode = selCmpt.project.timeUnit.clone();
        if (child.parent) tunode.insertAsParentOf(child);
        else child.parent = tunode;
    }
    const fn = selCmpt.project.hasSelectionId ? 'vlSelectionIdTest(' : 'vlSelectionTest(';
    const resolve = selCmpt.resolve === 'global' ? ')' : `, ${(0, _vegaUtil.stringValue)(selCmpt.resolve)})`;
    const test = `${fn}${store}, ${datum}${resolve}`;
    const length = `length(data(${store}))`;
    return pred.empty === false ? `${length} && ${test}` : `!${length} || ${test}`;
}
function parseSelectionExtent(model, name, extent) {
    const vname = (0, _util.varName)(name);
    const encoding = extent.encoding;
    let field = extent.field;
    let selCmpt;
    try {
        selCmpt = model.getSelectionComponent(vname, name);
    } catch (e) {
        // If a selection isn't found, treat it as a variable parameter.
        return vname;
    }
    if (!encoding && !field) {
        field = selCmpt.project.items[0].field;
        if (selCmpt.project.items.length > 1) (0, _log.warn)((0, _message.selectionAsScaleDomainWithoutField)(field));
    } else if (encoding && !field) {
        const encodings = selCmpt.project.items.filter((p)=>p.channel === encoding);
        if (!encodings.length || encodings.length > 1) {
            field = selCmpt.project.items[0].field;
            (0, _log.warn)((0, _message.selectionAsScaleDomainWrongEncodings)(encodings, encoding, extent, field));
        } else field = encodings[0].field;
    }
    return `${selCmpt.name}[${(0, _vegaUtil.stringValue)((0, _util.replacePathInField)(field))}]`;
}
function materializeSelections(model, main) {
    for (const [selection, selCmpt] of (0, _util.entries)(model.component.selection ?? {})){
        const lookupName = model.getName(`lookup_${selection}`);
        model.component.data.outputNodes[lookupName] = selCmpt.materialized = new (0, _dataflow.OutputNode)(new (0, _filter.FilterNode)(main, model, {
            param: selection
        }), lookupName, (0, _data.DataSourceType).Lookup, model.component.data.outputNodeRefCounts);
    }
}

},{"vega-event-selector":"ijmxJ","vega-util":"7f6sQ",".":"7GXIu","../../log":"loqTw","../../util":"acUGA","../data/dataflow":"btJXI","../data/filter":"8Tzn7","../../data":"dILEy","../../log/message":"fb2MK","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"7GXIu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "STORE", ()=>STORE);
parcelHelpers.export(exports, "TUPLE", ()=>TUPLE);
parcelHelpers.export(exports, "MODIFY", ()=>MODIFY);
parcelHelpers.export(exports, "SELECTION_DOMAIN", ()=>SELECTION_DOMAIN);
parcelHelpers.export(exports, "VL_SELECTION_RESOLVE", ()=>VL_SELECTION_RESOLVE);
parcelHelpers.export(exports, "selectionCompilers", ()=>selectionCompilers);
parcelHelpers.export(exports, "unitName", ()=>unitName);
parcelHelpers.export(exports, "requiresSelectionId", ()=>requiresSelectionId);
// Binding a point selection to query widgets or legends disables default direct manipulation interaction.
// A user can choose to re-enable it by explicitly specifying triggering input events.
parcelHelpers.export(exports, "disableDirectManipulation", ()=>disableDirectManipulation);
parcelHelpers.export(exports, "isTimerSelection", ()=>isTimerSelection);
var _vega = require("vega");
var _vegaUtil = require("vega-util");
var _channel = require("../../channel");
var _util = require("../../util");
var _model = require("../model");
var _interval = require("./interval");
var _intervalDefault = parcelHelpers.interopDefault(_interval);
var _point = require("./point");
var _pointDefault = parcelHelpers.interopDefault(_point);
var _clear = require("./clear");
var _clearDefault = parcelHelpers.interopDefault(_clear);
var _inputs = require("./inputs");
var _inputsDefault = parcelHelpers.interopDefault(_inputs);
var _nearest = require("./nearest");
var _nearestDefault = parcelHelpers.interopDefault(_nearest);
var _project = require("./project");
var _projectDefault = parcelHelpers.interopDefault(_project);
var _scales = require("./scales");
var _scalesDefault = parcelHelpers.interopDefault(_scales);
var _legends = require("./legends");
var _legendsDefault = parcelHelpers.interopDefault(_legends);
var _toggle = require("./toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _translate = require("./translate");
var _translateDefault = parcelHelpers.interopDefault(_translate);
var _zoom = require("./zoom");
var _zoomDefault = parcelHelpers.interopDefault(_zoom);
const STORE = '_store';
const TUPLE = '_tuple';
const MODIFY = '_modify';
const SELECTION_DOMAIN = '_selection_domain_';
const VL_SELECTION_RESOLVE = 'vlSelectionResolve';
const selectionCompilers = [
    (0, _pointDefault.default),
    (0, _intervalDefault.default),
    (0, _projectDefault.default),
    (0, _toggleDefault.default),
    // Bindings may disable direct manipulation.
    (0, _inputsDefault.default),
    (0, _scalesDefault.default),
    (0, _legendsDefault.default),
    (0, _clearDefault.default),
    (0, _translateDefault.default),
    (0, _zoomDefault.default),
    (0, _nearestDefault.default)
];
function getFacetModel(model) {
    let parent = model.parent;
    while(parent){
        if ((0, _model.isFacetModel)(parent)) break;
        parent = parent.parent;
    }
    return parent;
}
function unitName(model, { escape } = {
    escape: true
}) {
    let name = escape ? (0, _vegaUtil.stringValue)(model.name) : model.name;
    const facetModel = getFacetModel(model);
    if (facetModel) {
        const { facet } = facetModel;
        for (const channel of (0, _channel.FACET_CHANNELS))if (facet[channel]) name += ` + '__facet_${channel}_' + (facet[${(0, _vegaUtil.stringValue)(facetModel.vgField(channel))}])`;
    }
    return name;
}
function requiresSelectionId(model) {
    return (0, _util.vals)(model.component.selection ?? {}).reduce((identifier, selCmpt)=>{
        return identifier || selCmpt.project.hasSelectionId;
    }, false);
}
function disableDirectManipulation(selCmpt, selDef) {
    if ((0, _vega.isString)(selDef.select) || !selDef.select.on) delete selCmpt.events;
    if ((0, _vega.isString)(selDef.select) || !selDef.select.clear) delete selCmpt.clear;
    if ((0, _vega.isString)(selDef.select) || !selDef.select.toggle) delete selCmpt.toggle;
}
function isTimerSelection(selCmpt) {
    return selCmpt.events?.find((e)=>'type' in e && e.type === 'timer');
}

},{"vega":"2Jj1D","vega-util":"7f6sQ","../../channel":"liLED","../../util":"acUGA","../model":"hQHib","./interval":"2V19o","./point":"2aEbF","./clear":"9BjA7","./inputs":"4TL2S","./nearest":"6cvnw","./project":"inhDL","./scales":"P3xQI","./legends":"anCex","./toggle":"2fffE","./translate":"1bMTD","./zoom":"efzbs","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"2V19o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BRUSH", ()=>BRUSH);
parcelHelpers.export(exports, "SCALE_TRIGGER", ()=>SCALE_TRIGGER);
parcelHelpers.export(exports, "GEO_INIT_TICK", ()=>GEO_INIT_TICK);
var _vega = require("vega");
var _vegaUtil = require("vega-util");
var _ = require(".");
var _channel = require("../../channel");
var _log = require("../../log");
var _scale = require("../../scale");
var _selection = require("../../selection");
var _util = require("../../util");
var _model = require("../model");
var _assemble = require("./assemble");
var _project = require("./project");
var _scales = require("./scales");
var _scalesDefault = parcelHelpers.interopDefault(_scales);
const BRUSH = '_brush';
const SCALE_TRIGGER = '_scale_trigger';
const GEO_INIT_TICK = 'geo_interval_init_tick'; // Workaround for https://github.com/vega/vega/issues/3481
const INIT = '_init';
const CENTER = '_center';
const interval = {
    defined: (selCmpt)=>selCmpt.type === 'interval',
    parse: (model, selCmpt, selDef)=>{
        var _a;
        if (model.hasProjection) {
            const def = {
                ...(0, _vega.isObject)(selDef.select) ? selDef.select : {}
            };
            def.fields = [
                (0, _selection.SELECTION_ID)
            ];
            if (!def.encodings) // Remap default x/y projection
            def.encodings = selDef.value ? (0, _util.keys)(selDef.value) : [
                (0, _channel.LONGITUDE),
                (0, _channel.LATITUDE)
            ];
            selDef.select = {
                type: 'interval',
                ...def
            };
        }
        if (selCmpt.translate && !(0, _scalesDefault.default).defined(selCmpt)) {
            const filterExpr = `!event.item || event.item.mark.name !== ${(0, _vegaUtil.stringValue)(selCmpt.name + BRUSH)}`;
            for (const evt of selCmpt.events){
                if (!evt.between) {
                    (0, _log.warn)(`${evt} is not an ordered event stream for interval selections.`);
                    continue;
                }
                const filters = (0, _vegaUtil.array)((_a = evt.between[0]).filter ?? (_a.filter = []));
                if (!filters.includes(filterExpr)) filters.push(filterExpr);
            }
        }
    },
    signals: (model, selCmpt, signals)=>{
        const name = selCmpt.name;
        const tupleSg = name + (0, _.TUPLE);
        const channels = (0, _util.vals)(selCmpt.project.hasChannel).filter((p)=>p.channel === (0, _channel.X) || p.channel === (0, _channel.Y));
        const init = selCmpt.init ? selCmpt.init[0] : null;
        signals.push(...channels.reduce((arr, proj)=>arr.concat(channelSignals(model, selCmpt, proj, init && init[proj.index])), []));
        if (!model.hasProjection) {
            // Proxy scale reactions to ensure that an infinite loop doesn't occur
            // when an interval selection filter touches the scale.
            if (!(0, _scalesDefault.default).defined(selCmpt)) {
                const triggerSg = name + SCALE_TRIGGER;
                const scaleTriggers = channels.map((proj)=>{
                    const channel = proj.channel;
                    const { data: dname, visual: vname } = proj.signals;
                    const scaleName = (0, _vegaUtil.stringValue)(model.scaleName(channel));
                    const scaleType = model.getScaleComponent(channel).get('type');
                    const toNum = (0, _scale.hasContinuousDomain)(scaleType) ? '+' : '';
                    return `(!isArray(${dname}) || ` + `(${toNum}invert(${scaleName}, ${vname})[0] === ${toNum}${dname}[0] && ` + `${toNum}invert(${scaleName}, ${vname})[1] === ${toNum}${dname}[1]))`;
                });
                if (scaleTriggers.length) signals.push({
                    name: triggerSg,
                    value: {},
                    on: [
                        {
                            events: channels.map((proj)=>({
                                    scale: model.scaleName(proj.channel)
                                })),
                            update: scaleTriggers.join(' && ') + ` ? ${triggerSg} : {}`
                        }
                    ]
                });
            }
            // Only add an interval to the store if it has valid data extents. Data extents
            // are set to null if pixel extents are equal to account for intervals over
            // ordinal/nominal domains which, when inverted, will still produce a valid datum.
            const dataSignals = channels.map((proj)=>proj.signals.data);
            const update = `unit: ${(0, _.unitName)(model)}, fields: ${name + (0, _project.TUPLE_FIELDS)}, values`;
            return signals.concat({
                name: tupleSg,
                ...init ? {
                    init: `{${update}: ${(0, _assemble.assembleInit)(init)}}`
                } : {},
                ...dataSignals.length ? {
                    on: [
                        {
                            events: [
                                {
                                    signal: dataSignals.join(' || ')
                                }
                            ],
                            update: `${dataSignals.join(' && ')} ? {${update}: [${dataSignals}]} : null`
                        }
                    ]
                } : {}
            });
        } else {
            const projection = (0, _vegaUtil.stringValue)(model.projectionName());
            const centerSg = model.projectionName() + CENTER;
            const { x, y } = selCmpt.project.hasChannel;
            const xvname = x && x.signals.visual;
            const yvname = y && y.signals.visual;
            const xinit = x ? init && init[x.index] : `${centerSg}[0]`;
            const yinit = y ? init && init[y.index] : `${centerSg}[1]`;
            const sizeSg = (layout)=>model.getSizeSignalRef(layout).signal;
            const bbox = `[` + `[${xvname ? xvname + '[0]' : '0'}, ${yvname ? yvname + '[0]' : '0'}],` + `[${xvname ? xvname + '[1]' : sizeSg('width')}, ` + `${yvname ? yvname + '[1]' : sizeSg('height')}]` + `]`;
            if (init) {
                signals.unshift({
                    name: name + INIT,
                    init: `[scale(${projection}, [${x ? xinit[0] : xinit}, ${y ? yinit[0] : yinit}]), ` + `scale(${projection}, [${x ? xinit[1] : xinit}, ${y ? yinit[1] : yinit}])]`
                });
                if (!x || !y) {
                    // If initializing a uni-dimensional brush, use the center of the view to determine the other coord
                    const hasCenterSg = signals.find((s)=>s.name === centerSg);
                    if (!hasCenterSg) signals.unshift({
                        name: centerSg,
                        update: `invert(${projection}, [${sizeSg('width')}/2, ${sizeSg('height')}/2])`
                    });
                }
            }
            const intersect = `intersect(${bbox}, {markname: ${(0, _vegaUtil.stringValue)(model.getName('marks'))}}, unit.mark)`;
            const base = `{unit: ${(0, _.unitName)(model)}}`;
            const update = `vlSelectionTuples(${intersect}, ${base})`;
            const visualSignals = channels.map((proj)=>proj.signals.visual);
            return signals.concat({
                name: tupleSg,
                on: [
                    {
                        events: [
                            ...visualSignals.length ? [
                                {
                                    signal: visualSignals.join(' || ')
                                }
                            ] : [],
                            ...init ? [
                                {
                                    signal: GEO_INIT_TICK
                                }
                            ] : []
                        ],
                        update
                    }
                ]
            });
        }
    },
    topLevelSignals: (model, selCmpt, signals)=>{
        if ((0, _model.isUnitModel)(model) && model.hasProjection && selCmpt.init) {
            // Workaround for https://github.com/vega/vega/issues/3481
            // The scenegraph isn't populated on the first pulse. So we use a timer signal
            // to re-pulse the dataflow as soon as possible. We return an object to ensure
            // this only occurs once.
            const hasTick = signals.filter((s)=>s.name === GEO_INIT_TICK);
            if (!hasTick.length) signals.unshift({
                name: GEO_INIT_TICK,
                value: null,
                on: [
                    {
                        events: 'timer{1}',
                        update: `${GEO_INIT_TICK} === null ? {} : ${GEO_INIT_TICK}`
                    }
                ]
            });
        }
        return signals;
    },
    marks: (model, selCmpt, marks)=>{
        const name = selCmpt.name;
        const { x, y } = selCmpt.project.hasChannel;
        const xvname = x?.signals.visual;
        const yvname = y?.signals.visual;
        const store = `data(${(0, _vegaUtil.stringValue)(selCmpt.name + (0, _.STORE))})`;
        // Do not add a brush if we're binding to scales
        // or we don't have a valid interval projection
        if ((0, _scalesDefault.default).defined(selCmpt) || !x && !y) return marks;
        const update = {
            x: x !== undefined ? {
                signal: `${xvname}[0]`
            } : {
                value: 0
            },
            y: y !== undefined ? {
                signal: `${yvname}[0]`
            } : {
                value: 0
            },
            x2: x !== undefined ? {
                signal: `${xvname}[1]`
            } : {
                field: {
                    group: 'width'
                }
            },
            y2: y !== undefined ? {
                signal: `${yvname}[1]`
            } : {
                field: {
                    group: 'height'
                }
            }
        };
        // If the selection is resolved to global, only a single interval is in
        // the store. Wrap brush mark's encodings with a production rule to test
        // this based on the `unit` property. Hide the brush mark if it corresponds
        // to a unit different from the one in the store.
        if (selCmpt.resolve === 'global') for (const key of (0, _util.keys)(update))update[key] = [
            {
                test: `${store}.length && ${store}[0].unit === ${(0, _.unitName)(model)}`,
                ...update[key]
            },
            {
                value: 0
            }
        ];
        // Two brush marks ensure that fill colors and other aesthetic choices do
        // not interefere with the core marks, but that the brushed region can still
        // be interacted with (e.g., dragging it around).
        const { fill, fillOpacity, cursor, ...stroke } = selCmpt.mark;
        const vgStroke = (0, _util.keys)(stroke).reduce((def, k)=>{
            def[k] = [
                {
                    test: [
                        x !== undefined && `${xvname}[0] !== ${xvname}[1]`,
                        y !== undefined && `${yvname}[0] !== ${yvname}[1]`
                    ].filter((t)=>t).join(' && '),
                    value: stroke[k]
                },
                {
                    value: null
                }
            ];
            return def;
        }, {});
        // Set cursor to move unless the brush cannot be translated
        const vgCursor = cursor ?? (selCmpt.translate ? 'move' : null);
        return [
            {
                name: `${name + BRUSH}_bg`,
                type: 'rect',
                clip: true,
                encode: {
                    enter: {
                        fill: {
                            value: fill
                        },
                        fillOpacity: {
                            value: fillOpacity
                        }
                    },
                    update
                }
            },
            ...marks,
            {
                name: name + BRUSH,
                type: 'rect',
                clip: true,
                encode: {
                    enter: {
                        ...vgCursor ? {
                            cursor: {
                                value: vgCursor
                            }
                        } : {},
                        fill: {
                            value: 'transparent'
                        }
                    },
                    update: {
                        ...update,
                        ...vgStroke
                    }
                }
            }
        ];
    }
};
exports.default = interval;
/**
 * Returns the visual and data signals for an interval selection.
 */ function channelSignals(model, selCmpt, proj, init) {
    const scaledInterval = !model.hasProjection;
    const channel = proj.channel;
    const vname = proj.signals.visual;
    const scaleName = (0, _vegaUtil.stringValue)(scaledInterval ? model.scaleName(channel) : model.projectionName());
    const scaled = (str)=>`scale(${scaleName}, ${str})`;
    const size = model.getSizeSignalRef(channel === (0, _channel.X) ? 'width' : 'height').signal;
    const coord = `${channel}(unit)`;
    const von = selCmpt.events.reduce((def, evt)=>{
        return [
            ...def,
            {
                events: evt.between[0],
                update: `[${coord}, ${coord}]`
            },
            {
                events: evt,
                update: `[${vname}[0], clamp(${coord}, 0, ${size})]`
            } // Brush End
        ];
    }, []);
    if (scaledInterval) {
        const dname = proj.signals.data;
        const hasScales = (0, _scalesDefault.default).defined(selCmpt);
        const scale = model.getScaleComponent(channel);
        const scaleType = scale ? scale.get('type') : undefined;
        const vinit = init ? {
            init: (0, _assemble.assembleInit)(init, true, scaled)
        } : {
            value: []
        };
        // React to pan/zooms of continuous scales. Non-continuous scales
        // (band, point) cannot be pan/zoomed and any other changes
        // to their domains (e.g., filtering) should clear the brushes.
        von.push({
            events: {
                signal: selCmpt.name + SCALE_TRIGGER
            },
            update: (0, _scale.hasContinuousDomain)(scaleType) ? `[${scaled(`${dname}[0]`)}, ${scaled(`${dname}[1]`)}]` : `[0, 0]`
        });
        return hasScales ? [
            {
                name: dname,
                on: []
            }
        ] : [
            {
                name: vname,
                ...vinit,
                on: von
            },
            {
                name: dname,
                ...init ? {
                    init: (0, _assemble.assembleInit)(init)
                } : {},
                on: [
                    {
                        events: {
                            signal: vname
                        },
                        update: `${vname}[0] === ${vname}[1] ? null : invert(${scaleName}, ${vname})`
                    }
                ]
            }
        ];
    } else {
        const initIdx = channel === (0, _channel.X) ? 0 : 1;
        const initSg = selCmpt.name + INIT;
        const vinit = init ? {
            init: `[${initSg}[0][${initIdx}], ${initSg}[1][${initIdx}]]`
        } : {
            value: []
        };
        return [
            {
                name: vname,
                ...vinit,
                on: von
            }
        ];
    }
}

},{"vega":"2Jj1D","vega-util":"7f6sQ",".":"7GXIu","../../channel":"liLED","../../log":"loqTw","../../scale":"bdpXN","../../selection":"jtWSq","../../util":"acUGA","../model":"hQHib","./assemble":"4YKkA","./project":"inhDL","./scales":"P3xQI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4YKkA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assembleProjection", ()=>assembleProjection);
parcelHelpers.export(exports, "assembleInit", ()=>assembleInit);
parcelHelpers.export(exports, "assembleUnitSelectionSignals", ()=>assembleUnitSelectionSignals);
parcelHelpers.export(exports, "assembleFacetSignals", ()=>assembleFacetSignals);
parcelHelpers.export(exports, "assembleTopLevelSignals", ()=>assembleTopLevelSignals);
parcelHelpers.export(exports, "assembleUnitSelectionData", ()=>assembleUnitSelectionData);
parcelHelpers.export(exports, "assembleUnitSelectionMarks", ()=>assembleUnitSelectionMarks);
parcelHelpers.export(exports, "assembleLayerSelectionMarks", ()=>assembleLayerSelectionMarks);
parcelHelpers.export(exports, "assembleSelectionScaleDomain", ()=>assembleSelectionScaleDomain);
var _vegaEventSelector = require("vega-event-selector");
var _vegaUtil = require("vega-util");
var _ = require(".");
var _datetime = require("../../datetime");
var _scale = require("../../scale");
var _selection = require("../../selection");
var _util = require("../../util");
var _model = require("../model");
var _parse = require("./parse");
var _point = require("./point");
var _data = require("../../data");
function assembleProjection(proj) {
    const { signals, hasLegend, index, ...rest } = proj;
    rest.field = (0, _util.replacePathInField)(rest.field);
    return rest;
}
function assembleInit(init, isExpr = true, wrap = (0, _vegaUtil.identity)) {
    if ((0, _vegaUtil.isArray)(init)) {
        const assembled = init.map((v)=>assembleInit(v, isExpr, wrap));
        return isExpr ? `[${assembled.join(', ')}]` : assembled;
    } else if ((0, _datetime.isDateTime)(init)) {
        if (isExpr) return wrap((0, _datetime.dateTimeToExpr)(init));
        else return wrap((0, _datetime.dateTimeToTimestamp)(init));
    }
    return isExpr ? wrap((0, _util.stringify)(init)) : init;
}
function assembleUnitSelectionSignals(model, signals) {
    for (const selCmpt of (0, _util.vals)(model.component.selection ?? {})){
        const name = selCmpt.name;
        let modifyExpr = `${name}${(0, _.TUPLE)}, ${selCmpt.resolve === 'global' ? 'true' : `{unit: ${(0, _.unitName)(model)}}`}`;
        for (const c of (0, _.selectionCompilers)){
            if (!c.defined(selCmpt)) continue;
            if (c.signals) signals = c.signals(model, selCmpt, signals);
            if (c.modifyExpr) modifyExpr = c.modifyExpr(model, selCmpt, modifyExpr);
        }
        signals.push({
            name: name + (0, _.MODIFY),
            on: [
                {
                    events: {
                        signal: selCmpt.name + (0, _.TUPLE)
                    },
                    update: `modify(${(0, _vegaUtil.stringValue)(selCmpt.name + (0, _.STORE))}, ${modifyExpr})`
                }
            ]
        });
    }
    return cleanupEmptyOnArray(signals);
}
function assembleFacetSignals(model, signals) {
    if (model.component.selection && (0, _util.keys)(model.component.selection).length) {
        const name = (0, _vegaUtil.stringValue)(model.getName('cell'));
        signals.unshift({
            name: 'facet',
            value: {},
            on: [
                {
                    events: (0, _vegaEventSelector.parseSelector)('pointermove', 'scope'),
                    update: `isTuple(facet) ? facet : group(${name}).datum`
                }
            ]
        });
    }
    return cleanupEmptyOnArray(signals);
}
function assembleTopLevelSignals(model, signals) {
    let hasSelections = false;
    for (const selCmpt of (0, _util.vals)(model.component.selection ?? {})){
        const name = selCmpt.name;
        const store = (0, _vegaUtil.stringValue)(name + (0, _.STORE));
        const hasSg = signals.filter((s)=>s.name === name);
        if (hasSg.length === 0) {
            const resolve = selCmpt.resolve === 'global' ? 'union' : selCmpt.resolve;
            const isPoint = selCmpt.type === 'point' ? ', true, true)' : ')';
            signals.push({
                name: selCmpt.name,
                update: `${(0, _.VL_SELECTION_RESOLVE)}(${store}, ${(0, _vegaUtil.stringValue)(resolve)}${isPoint}`
            });
        }
        hasSelections = true;
        for (const c of (0, _.selectionCompilers))if (c.defined(selCmpt) && c.topLevelSignals) signals = c.topLevelSignals(model, selCmpt, signals);
    }
    if (hasSelections) {
        const hasUnit = signals.filter((s)=>s.name === 'unit');
        if (hasUnit.length === 0) signals.unshift({
            name: 'unit',
            value: {},
            on: [
                {
                    events: 'pointermove',
                    update: 'isTuple(group()) ? group() : unit'
                }
            ]
        });
    }
    return cleanupEmptyOnArray(signals);
}
function assembleUnitSelectionData(model, data) {
    const selectionData = [];
    const animationData = [];
    const unit = (0, _.unitName)(model, {
        escape: false
    });
    for (const selCmpt of (0, _util.vals)(model.component.selection ?? {})){
        const store = {
            name: selCmpt.name + (0, _.STORE)
        };
        if (selCmpt.project.hasSelectionId) store.transform = [
            {
                type: 'collect',
                sort: {
                    field: (0, _selection.SELECTION_ID)
                }
            }
        ];
        if (selCmpt.init) {
            const fields = selCmpt.project.items.map(assembleProjection);
            store.values = selCmpt.project.hasSelectionId ? selCmpt.init.map((i)=>({
                    unit,
                    [(0, _selection.SELECTION_ID)]: assembleInit(i, false)[0]
                })) : selCmpt.init.map((i)=>({
                    unit,
                    fields,
                    values: assembleInit(i, false)
                }));
        }
        const contains = [
            ...selectionData,
            ...data
        ].filter((d)=>d.name === selCmpt.name + (0, _.STORE));
        if (!contains.length) selectionData.push(store);
        if ((0, _.isTimerSelection)(selCmpt) && data.length) {
            // TODO(jzong): eventually uncomment this stuff when we want to support multi-view
            // const sourceName =
            //   model.parent && model.parent.type !== 'unit' // facet, layer, or concat
            //     ? model.parent.lookupDataSource(model.parent.getDataName(DataSourceType.Main))
            //     : model.lookupDataSource(model.getDataName(DataSourceType.Main));
            const sourceName = model.lookupDataSource(model.getDataName((0, _data.DataSourceType).Main));
            const sourceData = data.find((d)=>d.name === sourceName);
            // find the filter transform for the current selection
            const sourceDataFilter = sourceData.transform.find((t)=>t.type === 'filter' && t.expr.includes('vlSelectionTest'));
            if (sourceDataFilter) {
                // remove it from the original dataset
                sourceData.transform = sourceData.transform.filter((t)=>t !== sourceDataFilter);
                // create dataset to hold current animation frame
                const currentFrame = {
                    name: sourceData.name + (0, _point.CURR),
                    source: sourceData.name,
                    transform: [
                        sourceDataFilter
                    ] // add the selection filter to the animation dataset
                };
                animationData.push(currentFrame);
            }
        }
    }
    return selectionData.concat(data, animationData);
}
function assembleUnitSelectionMarks(model, marks) {
    for (const selCmpt of (0, _util.vals)(model.component.selection ?? {})){
        for (const c of (0, _.selectionCompilers))if (c.defined(selCmpt) && c.marks) marks = c.marks(model, selCmpt, marks);
    }
    return marks;
}
function assembleLayerSelectionMarks(model, marks) {
    for (const child of model.children)if ((0, _model.isUnitModel)(child)) marks = assembleUnitSelectionMarks(child, marks);
    return marks;
}
function assembleSelectionScaleDomain(model, extent, scaleCmpt, domain) {
    const parsedExtent = (0, _parse.parseSelectionExtent)(model, extent.param, extent);
    return {
        signal: (0, _scale.hasContinuousDomain)(scaleCmpt.get('type')) && (0, _vegaUtil.isArray)(domain) && domain[0] > domain[1] ? `isValid(${parsedExtent}) && reverse(${parsedExtent})` : parsedExtent
    };
}
function cleanupEmptyOnArray(signals) {
    return signals.map((s)=>{
        if (s.on && !s.on.length) delete s.on;
        return s;
    });
}

},{"vega-event-selector":"ijmxJ","vega-util":"7f6sQ",".":"7GXIu","../../datetime":"gp5cf","../../scale":"bdpXN","../../selection":"jtWSq","../../util":"acUGA","../model":"hQHib","./parse":"bgKKc","./point":"2aEbF","../../data":"dILEy","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"2aEbF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CURR", ()=>CURR);
parcelHelpers.export(exports, "ANIM_VALUE", ()=>ANIM_VALUE);
parcelHelpers.export(exports, "ANIM_CLOCK", ()=>ANIM_CLOCK);
parcelHelpers.export(exports, "EASED_ANIM_CLOCK", ()=>EASED_ANIM_CLOCK);
parcelHelpers.export(exports, "MIN_EXTENT", ()=>MIN_EXTENT);
parcelHelpers.export(exports, "MAX_RANGE_EXTENT", ()=>MAX_RANGE_EXTENT);
parcelHelpers.export(exports, "LAST_TICK", ()=>LAST_TICK);
parcelHelpers.export(exports, "IS_PLAYING", ()=>IS_PLAYING);
parcelHelpers.export(exports, "THROTTLE", ()=>THROTTLE);
var _vegaUtil = require("vega-util");
var _ = require(".");
var _selection = require("../../selection");
var _util = require("../../util");
var _interval = require("./interval");
var _project = require("./project");
var _channel = require("../../channel");
const CURR = '_curr';
const ANIM_VALUE = 'anim_value';
const ANIM_CLOCK = 'anim_clock';
const EASED_ANIM_CLOCK = 'eased_anim_clock';
const MIN_EXTENT = 'min_extent';
const MAX_RANGE_EXTENT = 'max_range_extent';
const LAST_TICK = 'last_tick_at';
const IS_PLAYING = 'is_playing';
const THROTTLE = 1 / 60 * 1000; // 60 FPS
const animationSignals = (selectionName, scaleName)=>{
    return [
        // timer signals
        {
            name: EASED_ANIM_CLOCK,
            // update: 'easeLinear(anim_clock / max_range_extent) * max_range_extent'
            update: ANIM_CLOCK // TODO: replace with above once easing functions are implemented in vega-functions
        },
        // scale signals
        // TODO(jzong): uncomment commented signals below when implementing interpolation
        {
            name: `${selectionName}_domain`,
            init: `domain('${scaleName}')`
        },
        {
            name: MIN_EXTENT,
            init: `extent(${selectionName}_domain)[0]`
        },
        // {name: 'max_extent', init: `extent(${selectionName}_domain)[1]`},
        {
            name: MAX_RANGE_EXTENT,
            init: `extent(range('${scaleName}'))[1]`
        },
        // {name: 't_index', update: `indexof(${selectionName}_domain, anim_value)`},
        {
            name: ANIM_VALUE,
            update: `invert('${scaleName}', ${EASED_ANIM_CLOCK})`
        }
    ];
};
const point = {
    defined: (selCmpt)=>selCmpt.type === 'point',
    topLevelSignals: (model, selCmpt, signals)=>{
        if ((0, _.isTimerSelection)(selCmpt)) signals = signals.concat([
            {
                name: ANIM_CLOCK,
                init: '0',
                on: [
                    {
                        events: {
                            type: 'timer',
                            throttle: THROTTLE
                        },
                        update: `${IS_PLAYING} ? (${ANIM_CLOCK} + (now() - ${LAST_TICK}) > ${MAX_RANGE_EXTENT} ? 0 : ${ANIM_CLOCK} + (now() - ${LAST_TICK})) : ${ANIM_CLOCK}`
                    }
                ]
            },
            {
                name: LAST_TICK,
                init: 'now()',
                on: [
                    {
                        events: [
                            {
                                signal: ANIM_CLOCK
                            },
                            {
                                signal: IS_PLAYING
                            }
                        ],
                        update: 'now()'
                    }
                ]
            },
            {
                name: IS_PLAYING,
                init: 'true'
            }
        ]);
        return signals;
    },
    signals: (model, selCmpt, signals)=>{
        const name = selCmpt.name;
        const fieldsSg = name + (0, _project.TUPLE_FIELDS);
        const project = selCmpt.project;
        const datum = '(item().isVoronoi ? datum.datum : datum)';
        // Only add a discrete selection to the store if a datum is present _and_
        // the interaction isn't occurring on a group mark. This guards against
        // polluting interactive state with invalid values in faceted displays
        // as the group marks are also data-driven. We force the update to account
        // for constant null states but varying toggles (e.g., shift-click in
        // whitespace followed by a click in whitespace; the store should only
        // be cleared on the second click).
        const brushes = (0, _util.vals)(model.component.selection ?? {}).reduce((acc, cmpt)=>{
            return cmpt.type === 'interval' ? acc.concat(cmpt.name + (0, _interval.BRUSH)) : acc;
        }, []).map((b)=>`indexof(item().mark.name, '${b}') < 0`).join(' && ');
        const test = `datum && item().mark.marktype !== 'group' && indexof(item().mark.role, 'legend') < 0${brushes ? ` && ${brushes}` : ''}`;
        let update = `unit: ${(0, _.unitName)(model)}, `;
        if (selCmpt.project.hasSelectionId) update += `${0, _selection.SELECTION_ID}: ${datum}[${(0, _vegaUtil.stringValue)((0, _selection.SELECTION_ID))}]`;
        else if ((0, _.isTimerSelection)(selCmpt)) update += `fields: ${fieldsSg}, values: [${ANIM_VALUE} ? ${ANIM_VALUE} : ${MIN_EXTENT}]`;
        else {
            const values = project.items.map((p)=>{
                const fieldDef = model.fieldDef(p.channel);
                // Binned fields should capture extents, for a range test against the raw field.
                return fieldDef?.bin ? `[${datum}[${(0, _vegaUtil.stringValue)(model.vgField(p.channel, {}))}], ` + `${datum}[${(0, _vegaUtil.stringValue)(model.vgField(p.channel, {
                    binSuffix: 'end'
                }))}]]` : `${datum}[${(0, _vegaUtil.stringValue)(p.field)}]`;
            }).join(', ');
            update += `fields: ${fieldsSg}, values: [${values}]`;
        }
        if ((0, _.isTimerSelection)(selCmpt)) // timer event: selection is for animation
        return signals.concat(animationSignals(selCmpt.name, model.scaleName((0, _channel.TIME))), [
            {
                name: name + (0, _.TUPLE),
                on: [
                    {
                        events: [
                            {
                                signal: EASED_ANIM_CLOCK
                            },
                            {
                                signal: ANIM_VALUE
                            }
                        ],
                        update: `{${update}}`,
                        force: true
                    }
                ]
            }
        ]);
        else {
            const events = selCmpt.events;
            return signals.concat([
                {
                    name: name + (0, _.TUPLE),
                    on: events ? [
                        {
                            events,
                            update: `${test} ? {${update}} : null`,
                            force: true
                        }
                    ] : []
                }
            ]);
        }
    }
};
exports.default = point;

},{"vega-util":"7f6sQ",".":"7GXIu","../../selection":"jtWSq","../../util":"acUGA","./interval":"2V19o","./project":"inhDL","../../channel":"liLED","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"inhDL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TUPLE_FIELDS", ()=>TUPLE_FIELDS);
parcelHelpers.export(exports, "SelectionProjectionComponent", ()=>SelectionProjectionComponent);
var _vegaUtil = require("vega-util");
var _channel = require("../../channel");
var _log = require("../../log");
var _scale = require("../../scale");
var _selection = require("../../selection");
var _util = require("../../util");
var _timeunit = require("../data/timeunit");
var _assemble = require("./assemble");
var _timeunit1 = require("../../timeunit");
const TUPLE_FIELDS = '_tuple_fields';
class SelectionProjectionComponent {
    constructor(...items){
        this.items = items;
        this.hasChannel = {};
        this.hasField = {};
        this.hasSelectionId = false;
    }
}
const project = {
    defined: ()=>{
        return true; // This transform handles its own defaults, so always run parse.
    },
    parse: (model, selCmpt, selDef)=>{
        const name = selCmpt.name;
        const proj = selCmpt.project ?? (selCmpt.project = new SelectionProjectionComponent());
        const parsed = {};
        const timeUnits = {};
        const signals = new Set();
        const signalName = (p, range)=>{
            const suffix = range === 'visual' ? p.channel : p.field;
            let sg = (0, _util.varName)(`${name}_${suffix}`);
            for(let counter = 1; signals.has(sg); counter++)sg = (0, _util.varName)(`${name}_${suffix}_${counter}`);
            signals.add(sg);
            return {
                [range]: sg
            };
        };
        const type = selCmpt.type;
        const cfg = model.config.selection[type];
        const init = selDef.value !== undefined ? (0, _vegaUtil.array)(selDef.value) : null;
        // If no explicit projection (either fields or encodings) is specified, set some defaults.
        // If an initial value is set, try to infer projections.
        let { fields, encodings } = (0, _vegaUtil.isObject)(selDef.select) ? selDef.select : {};
        if (!fields && !encodings && init) for (const initVal of init){
            // initVal may be a scalar value to smoothen varParam -> pointSelection gradient.
            if (!(0, _vegaUtil.isObject)(initVal)) continue;
            for (const key of (0, _util.keys)(initVal)){
                if ((0, _channel.isSingleDefUnitChannel)(key)) (encodings || (encodings = [])).push(key);
                else if (type === 'interval') {
                    _log.warn(_log.message.INTERVAL_INITIALIZED_WITH_POS);
                    encodings = cfg.encodings;
                } else (fields ?? (fields = [])).push(key);
            }
        }
        // If no initial value is specified, use the default configuration.
        // We break this out as a separate if block (instead of an else condition)
        // to account for unprojected point selections that have scalar initial values
        if (!fields && !encodings) {
            encodings = cfg.encodings;
            if ('fields' in cfg) fields = cfg.fields;
        }
        for (const channel of encodings ?? []){
            const fieldDef = model.fieldDef(channel);
            if (fieldDef) {
                let field = fieldDef.field;
                if (fieldDef.aggregate) {
                    _log.warn(_log.message.cannotProjectAggregate(channel, fieldDef.aggregate));
                    continue;
                } else if (!field) {
                    _log.warn(_log.message.cannotProjectOnChannelWithoutField(channel));
                    continue;
                }
                if (fieldDef.timeUnit && !(0, _timeunit1.isBinnedTimeUnit)(fieldDef.timeUnit)) {
                    field = model.vgField(channel);
                    // Construct TimeUnitComponents which will be combined into a
                    // TimeUnitNode. This node may need to be inserted into the
                    // dataflow if the selection is used across views that do not
                    // have these time units defined.
                    const component = {
                        timeUnit: fieldDef.timeUnit,
                        as: field,
                        field: fieldDef.field
                    };
                    timeUnits[(0, _util.hash)(component)] = component;
                }
                // Prevent duplicate projections on the same field.
                // TODO: what if the same field is bound to multiple channels (e.g., SPLOM diag).
                if (!parsed[field]) {
                    // Determine whether the tuple will store enumerated or ranged values.
                    // Interval selections store ranges for continuous scales, and enumerations otherwise.
                    // Single/multi selections store ranges for binned fields, and enumerations otherwise.
                    const tplType = type === 'interval' && (0, _channel.isScaleChannel)(channel) && (0, _scale.hasContinuousDomain)(model.getScaleComponent(channel).get('type')) ? 'R' : fieldDef.bin ? 'R-RE' : 'E';
                    const p = {
                        field,
                        channel,
                        type: tplType,
                        index: proj.items.length
                    };
                    p.signals = {
                        ...signalName(p, 'data'),
                        ...signalName(p, 'visual')
                    };
                    proj.items.push(parsed[field] = p);
                    proj.hasField[field] = parsed[field];
                    proj.hasSelectionId = proj.hasSelectionId || field === (0, _selection.SELECTION_ID);
                    if ((0, _channel.isGeoPositionChannel)(channel)) {
                        p.geoChannel = channel;
                        p.channel = (0, _channel.getPositionChannelFromLatLong)(channel);
                        proj.hasChannel[p.channel] = parsed[field];
                    } else proj.hasChannel[channel] = parsed[field];
                }
            } else _log.warn(_log.message.cannotProjectOnChannelWithoutField(channel));
        }
        for (const field of fields ?? []){
            if (proj.hasField[field]) continue;
            const p = {
                type: 'E',
                field,
                index: proj.items.length
            };
            p.signals = {
                ...signalName(p, 'data')
            };
            proj.items.push(p);
            proj.hasField[field] = p;
            proj.hasSelectionId = proj.hasSelectionId || field === (0, _selection.SELECTION_ID);
        }
        if (init) selCmpt.init = init.map((v)=>{
            // Selections can be initialized either with a full object that maps projections to values
            // or scalar values to smoothen the abstraction gradient from variable params to point selections.
            return proj.items.map((p)=>(0, _vegaUtil.isObject)(v) ? v[p.geoChannel || p.channel] !== undefined ? v[p.geoChannel || p.channel] : v[p.field] : v);
        });
        if (!(0, _util.isEmpty)(timeUnits)) proj.timeUnit = new (0, _timeunit.TimeUnitNode)(null, timeUnits);
    },
    signals: (model, selCmpt, allSignals)=>{
        const name = selCmpt.name + TUPLE_FIELDS;
        const hasSignal = allSignals.filter((s)=>s.name === name);
        return hasSignal.length > 0 || selCmpt.project.hasSelectionId ? allSignals : allSignals.concat({
            name,
            value: selCmpt.project.items.map((0, _assemble.assembleProjection))
        });
    }
};
exports.default = project;

},{"vega-util":"7f6sQ","../../channel":"liLED","../../log":"loqTw","../../scale":"bdpXN","../../selection":"jtWSq","../../util":"acUGA","../data/timeunit":"iPsUH","./assemble":"4YKkA","../../timeunit":"eky0T","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"iPsUH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeUnitNode", ()=>TimeUnitNode);
parcelHelpers.export(exports, "OFFSETTED_RECT_START_SUFFIX", ()=>OFFSETTED_RECT_START_SUFFIX);
parcelHelpers.export(exports, "OFFSETTED_RECT_END_SUFFIX", ()=>OFFSETTED_RECT_END_SUFFIX);
var _channeldef = require("../../channeldef");
var _timeunit = require("../../timeunit");
var _util = require("../../util");
var _model = require("../model");
var _dataflow = require("./dataflow");
var _mark = require("../../mark");
var _channel = require("../../channel");
function isTimeUnitTransformComponent(timeUnitComponent) {
    return timeUnitComponent.as !== undefined;
}
function offsetAs(field) {
    return `${field}_end`;
}
class TimeUnitNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new TimeUnitNode(null, (0, _util.duplicate)(this.timeUnits));
    }
    constructor(parent, timeUnits){
        super(parent);
        this.timeUnits = timeUnits;
    }
    static makeFromEncoding(parent, model) {
        const formula = model.reduceFieldDef((timeUnitComponent, fieldDef, channel)=>{
            const { field, timeUnit } = fieldDef;
            if (timeUnit) {
                let component;
                if ((0, _timeunit.isBinnedTimeUnit)(timeUnit)) // For binned time unit, only produce end if the mark is a rect-based mark (rect, bar, image, arc), which needs "range".
                {
                    if ((0, _model.isUnitModel)(model)) {
                        const { mark, markDef, config } = model;
                        const bandPosition = (0, _channeldef.getBandPosition)({
                            fieldDef,
                            markDef,
                            config
                        });
                        if ((0, _mark.isRectBasedMark)(mark) || !!bandPosition) component = {
                            timeUnit: (0, _timeunit.normalizeTimeUnit)(timeUnit),
                            field
                        };
                    }
                } else component = {
                    as: (0, _channeldef.vgField)(fieldDef, {
                        forAs: true
                    }),
                    field,
                    timeUnit
                };
                if ((0, _model.isUnitModel)(model)) {
                    const { mark, markDef, config } = model;
                    const bandPosition = (0, _channeldef.getBandPosition)({
                        fieldDef,
                        markDef,
                        config
                    });
                    if ((0, _mark.isRectBasedMark)(mark) && (0, _channel.isXorY)(channel) && bandPosition !== 0.5) component.rectBandPosition = bandPosition;
                }
                if (component) timeUnitComponent[(0, _util.hash)(component)] = component;
            }
            return timeUnitComponent;
        }, {});
        if ((0, _util.isEmpty)(formula)) return null;
        return new TimeUnitNode(parent, formula);
    }
    static makeFromTransform(parent, t) {
        const { timeUnit, ...other } = {
            ...t
        };
        const normalizedTimeUnit = (0, _timeunit.normalizeTimeUnit)(timeUnit);
        const component = {
            ...other,
            timeUnit: normalizedTimeUnit
        };
        return new TimeUnitNode(parent, {
            [(0, _util.hash)(component)]: component
        });
    }
    /**
     * Merge together TimeUnitNodes assigning the children of `other` to `this`
     * and removing `other`.
     */ merge(other) {
        this.timeUnits = {
            ...this.timeUnits
        };
        // if the same hash happen twice, merge
        for(const key in other.timeUnits)if (!this.timeUnits[key]) // copy if it's not a duplicate
        this.timeUnits[key] = other.timeUnits[key];
        for (const child of other.children){
            other.removeChild(child);
            child.parent = this;
        }
        other.remove();
    }
    /**
     * Remove time units coming from the other node.
     */ removeFormulas(fields) {
        const newFormula = {};
        for (const [key, timeUnitComponent] of (0, _util.entries)(this.timeUnits)){
            const fieldAs = isTimeUnitTransformComponent(timeUnitComponent) ? timeUnitComponent.as : `${timeUnitComponent.field}_end`;
            if (!fields.has(fieldAs)) newFormula[key] = timeUnitComponent;
        }
        this.timeUnits = newFormula;
    }
    producedFields() {
        return new Set((0, _util.vals)(this.timeUnits).map((f)=>{
            return isTimeUnitTransformComponent(f) ? f.as : offsetAs(f.field);
        }));
    }
    dependentFields() {
        return new Set((0, _util.vals)(this.timeUnits).map((f)=>f.field));
    }
    hash() {
        return `TimeUnit ${(0, _util.hash)(this.timeUnits)}`;
    }
    assemble() {
        const transforms = [];
        for (const f of (0, _util.vals)(this.timeUnits)){
            const { rectBandPosition } = f;
            const normalizedTimeUnit = (0, _timeunit.normalizeTimeUnit)(f.timeUnit);
            if (isTimeUnitTransformComponent(f)) {
                const { field, as } = f;
                const { unit, utc, ...params } = normalizedTimeUnit;
                const startEnd = [
                    as,
                    `${as}_end`
                ];
                transforms.push({
                    field: (0, _util.replacePathInField)(field),
                    type: 'timeunit',
                    ...unit ? {
                        units: (0, _timeunit.getTimeUnitParts)(unit)
                    } : {},
                    ...utc ? {
                        timezone: 'utc'
                    } : {},
                    ...params,
                    as: startEnd
                });
                transforms.push(...offsetedRectFormulas(startEnd, rectBandPosition, normalizedTimeUnit));
            } else if (f) {
                const { field: escapedField } = f;
                // since this is a expression, we want the unescaped field name
                const field = escapedField.replaceAll('\\.', '.');
                const expr = offsetExpr({
                    timeUnit: normalizedTimeUnit,
                    field
                });
                const endAs = offsetAs(field);
                transforms.push({
                    type: 'formula',
                    expr,
                    as: endAs
                });
                transforms.push(...offsetedRectFormulas([
                    field,
                    endAs
                ], rectBandPosition, normalizedTimeUnit));
            }
        }
        return transforms;
    }
}
const OFFSETTED_RECT_START_SUFFIX = 'offsetted_rect_start';
const OFFSETTED_RECT_END_SUFFIX = 'offsetted_rect_end';
function offsetExpr({ timeUnit, field, reverse }) {
    const { unit, utc } = timeUnit;
    const smallestUnit = (0, _timeunit.getSmallestTimeUnitPart)(unit);
    const { part, step } = (0, _timeunit.getDateTimePartAndStep)(smallestUnit, timeUnit.step);
    const offsetFn = utc ? 'utcOffset' : 'timeOffset';
    const expr = `${offsetFn}('${part}', ${(0, _util.accessWithDatumToUnescapedPath)(field)}, ${reverse ? -step : step})`;
    return expr;
}
function offsetedRectFormulas([startField, endField], rectBandPosition, timeUnit) {
    if (rectBandPosition !== undefined && rectBandPosition !== 0.5) {
        const startExpr = (0, _util.accessWithDatumToUnescapedPath)(startField);
        const endExpr = (0, _util.accessWithDatumToUnescapedPath)(endField);
        return [
            {
                type: 'formula',
                expr: interpolateExpr([
                    offsetExpr({
                        timeUnit,
                        field: startField,
                        reverse: true
                    }),
                    startExpr
                ], rectBandPosition + 0.5),
                as: `${startField}_${OFFSETTED_RECT_START_SUFFIX}`
            },
            {
                type: 'formula',
                expr: interpolateExpr([
                    startExpr,
                    endExpr
                ], rectBandPosition + 0.5),
                as: `${startField}_${OFFSETTED_RECT_END_SUFFIX}`
            }
        ];
    }
    return [];
}
function interpolateExpr([start, end], fraction) {
    return `${1 - fraction} * ${start} + ${fraction} * ${end}`;
}

},{"../../channeldef":"dsccb","../../timeunit":"eky0T","../../util":"acUGA","../model":"hQHib","./dataflow":"btJXI","../../mark":"3Z1xx","../../channel":"liLED","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"btJXI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A node in the dataflow tree.
 */ parcelHelpers.export(exports, "DataFlowNode", ()=>DataFlowNode);
parcelHelpers.export(exports, "OutputNode", ()=>OutputNode);
var _log = require("../../log");
var _util = require("../../util");
class DataFlowNode {
    constructor(parent, debugName){
        this.debugName = debugName;
        this._children = [];
        this._parent = null;
        if (parent) this.parent = parent;
    }
    /**
     * Clone this node with a deep copy but don't clone links to children or parents.
     */ clone() {
        throw new Error('Cannot clone node');
    }
    get parent() {
        return this._parent;
    }
    /**
     * Set the parent of the node and also add this node to the parent's children.
     */ set parent(parent) {
        this._parent = parent;
        if (parent) parent.addChild(this);
    }
    get children() {
        return this._children;
    }
    numChildren() {
        return this._children.length;
    }
    addChild(child, loc) {
        // do not add the same child twice
        if (this._children.includes(child)) {
            _log.warn(_log.message.ADD_SAME_CHILD_TWICE);
            return;
        }
        if (loc !== undefined) this._children.splice(loc, 0, child);
        else this._children.push(child);
    }
    removeChild(oldChild) {
        const loc = this._children.indexOf(oldChild);
        this._children.splice(loc, 1);
        return loc;
    }
    /**
     * Remove node from the dataflow.
     */ remove() {
        let loc = this._parent.removeChild(this);
        for (const child of this._children){
            // do not use the set method because we want to insert at a particular location
            child._parent = this._parent;
            this._parent.addChild(child, loc++);
        }
    }
    /**
     * Insert another node as a parent of this node.
     */ insertAsParentOf(other) {
        const parent = other.parent;
        parent.removeChild(this);
        this.parent = parent;
        other.parent = this;
    }
    swapWithParent() {
        const parent = this._parent;
        const newParent = parent.parent;
        // reconnect the children
        for (const child of this._children)child.parent = parent;
        // remove old links
        this._children = []; // equivalent to removing every child link one by one
        parent.removeChild(this);
        const loc = parent.parent.removeChild(parent);
        // swap two nodes but maintain order in children
        this._parent = newParent;
        newParent.addChild(this, loc);
        parent.parent = this;
    }
}
class OutputNode extends DataFlowNode {
    clone() {
        const cloneObj = new this.constructor();
        cloneObj.debugName = `clone_${this.debugName}`;
        cloneObj._source = this._source;
        cloneObj._name = `clone_${this._name}`;
        cloneObj.type = this.type;
        cloneObj.refCounts = this.refCounts;
        cloneObj.refCounts[cloneObj._name] = 0;
        return cloneObj;
    }
    /**
     * @param source The name of the source. Will change in assemble.
     * @param type The type of the output node.
     * @param refCounts A global ref counter map.
     */ constructor(parent, source, type, refCounts){
        super(parent, source);
        this.type = type;
        this.refCounts = refCounts;
        this._source = this._name = source;
        if (this.refCounts && !(this._name in this.refCounts)) this.refCounts[this._name] = 0;
    }
    dependentFields() {
        return new Set();
    }
    producedFields() {
        return new Set();
    }
    hash() {
        if (this._hash === undefined) this._hash = `Output ${(0, _util.uniqueId)()}`;
        return this._hash;
    }
    /**
     * Request the datasource name and increase the ref counter.
     *
     * During the parsing phase, this will return the simple name such as 'main' or 'raw'.
     * It is crucial to request the name from an output node to mark it as a required node.
     * If nobody ever requests the name, this datasource will not be instantiated in the assemble phase.
     *
     * In the assemble phase, this will return the correct name.
     */ getSource() {
        this.refCounts[this._name]++;
        return this._source;
    }
    isRequired() {
        return !!this.refCounts[this._name];
    }
    setSource(source) {
        this._source = source;
    }
}

},{"../../log":"loqTw","../../util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"P3xQI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "domain", ()=>domain);
var _vegaUtil = require("vega-util");
var _ = require(".");
var _channel = require("../../channel");
var _log = require("../../log");
var _scale = require("../../scale");
var _model = require("../model");
var _util = require("../../util");
const scaleBindings = {
    defined: (selCmpt)=>{
        return selCmpt.type === 'interval' && selCmpt.resolve === 'global' && selCmpt.bind && selCmpt.bind === 'scales';
    },
    parse: (model, selCmpt)=>{
        const bound = selCmpt.scales = [];
        for (const proj of selCmpt.project.items){
            const channel = proj.channel;
            if (!(0, _channel.isScaleChannel)(channel)) continue;
            const scale = model.getScaleComponent(channel);
            const scaleType = scale ? scale.get('type') : undefined;
            if (scaleType == 'sequential') _log.warn(_log.message.SEQUENTIAL_SCALE_DEPRECATED);
            if (!scale || !(0, _scale.hasContinuousDomain)(scaleType)) {
                _log.warn(_log.message.SCALE_BINDINGS_CONTINUOUS);
                continue;
            }
            scale.set('selectionExtent', {
                param: selCmpt.name,
                field: proj.field
            }, true);
            bound.push(proj);
        }
    },
    topLevelSignals: (model, selCmpt, signals)=>{
        const bound = selCmpt.scales.filter((proj)=>signals.filter((s)=>s.name === proj.signals.data).length === 0);
        // Top-level signals are only needed for multiview displays and if this
        // view's top-level signals haven't already been generated.
        if (!model.parent || isTopLevelLayer(model) || bound.length === 0) return signals;
        // vlSelectionResolve does not account for the behavior of bound scales in
        // multiview displays. Each unit view adds a tuple to the store, but the
        // state of the selection is the unit selection most recently updated. This
        // state is captured by the top-level signals that we insert and "push
        // outer" to from within the units. We need to reassemble this state into
        // the top-level named signal, except no single selCmpt has a global view.
        const namedSg = signals.find((s)=>s.name === selCmpt.name);
        let update = namedSg.update;
        if (update.includes((0, _.VL_SELECTION_RESOLVE))) namedSg.update = `{${bound.map((proj)=>`${(0, _vegaUtil.stringValue)((0, _util.replacePathInField)(proj.field))}: ${proj.signals.data}`).join(', ')}}`;
        else {
            for (const proj of bound){
                const mapping = `${(0, _vegaUtil.stringValue)((0, _util.replacePathInField)(proj.field))}: ${proj.signals.data}`;
                if (!update.includes(mapping)) update = `${update.substring(0, update.length - 1)}, ${mapping}}`;
            }
            namedSg.update = update;
        }
        return signals.concat(bound.map((proj)=>({
                name: proj.signals.data
            })));
    },
    signals: (model, selCmpt, signals)=>{
        // Nested signals need only push to top-level signals with multiview displays.
        if (model.parent && !isTopLevelLayer(model)) for (const proj of selCmpt.scales){
            const signal = signals.find((s)=>s.name === proj.signals.data);
            signal.push = 'outer';
            delete signal.value;
            delete signal.update;
        }
        return signals;
    }
};
exports.default = scaleBindings;
function domain(model, channel) {
    const scale = (0, _vegaUtil.stringValue)(model.scaleName(channel));
    return `domain(${scale})`;
}
function isTopLevelLayer(model) {
    return model.parent && (0, _model.isLayerModel)(model.parent) && (!model.parent.parent || isTopLevelLayer(model.parent.parent));
}

},{"vega-util":"7f6sQ",".":"7GXIu","../../channel":"liLED","../../log":"loqTw","../../scale":"bdpXN","../model":"hQHib","../../util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"9BjA7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vegaEventSelector = require("vega-event-selector");
var _vegaUtil = require("vega-util");
var _ = require(".");
var _util = require("../../util");
var _inputs = require("./inputs");
var _inputsDefault = parcelHelpers.interopDefault(_inputs);
var _toggle = require("./toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
const clear = {
    defined: (selCmpt)=>{
        return selCmpt.clear !== undefined && selCmpt.clear !== false && !(0, _.isTimerSelection)(selCmpt);
    },
    parse: (model, selCmpt)=>{
        if (selCmpt.clear) selCmpt.clear = (0, _vegaUtil.isString)(selCmpt.clear) ? (0, _vegaEventSelector.parseSelector)(selCmpt.clear, 'view') : selCmpt.clear;
    },
    topLevelSignals: (model, selCmpt, signals)=>{
        if ((0, _inputsDefault.default).defined(selCmpt)) for (const proj of selCmpt.project.items){
            const idx = signals.findIndex((n)=>n.name === (0, _util.varName)(`${selCmpt.name}_${proj.field}`));
            if (idx !== -1) signals[idx].on.push({
                events: selCmpt.clear,
                update: 'null'
            });
        }
        return signals;
    },
    signals: (model, selCmpt, signals)=>{
        function addClear(idx, update) {
            if (idx !== -1 && signals[idx].on) signals[idx].on.push({
                events: selCmpt.clear,
                update
            });
        }
        // Be as minimalist as possible when adding clear triggers to minimize dataflow execution.
        if (selCmpt.type === 'interval') for (const proj of selCmpt.project.items){
            const vIdx = signals.findIndex((n)=>n.name === proj.signals.visual);
            addClear(vIdx, '[0, 0]');
            if (vIdx === -1) {
                const dIdx = signals.findIndex((n)=>n.name === proj.signals.data);
                addClear(dIdx, 'null');
            }
        }
        else {
            let tIdx = signals.findIndex((n)=>n.name === selCmpt.name + (0, _.TUPLE));
            addClear(tIdx, 'null');
            if ((0, _toggleDefault.default).defined(selCmpt)) {
                tIdx = signals.findIndex((n)=>n.name === selCmpt.name + (0, _toggle.TOGGLE));
                addClear(tIdx, 'false');
            }
        }
        return signals;
    }
};
exports.default = clear;

},{"vega-event-selector":"ijmxJ","vega-util":"7f6sQ",".":"7GXIu","../../util":"acUGA","./inputs":"4TL2S","./toggle":"2fffE","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4TL2S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vegaUtil = require("vega-util");
var _ = require(".");
var _util = require("../../util");
var _assemble = require("./assemble");
var _nearest = require("./nearest");
var _nearestDefault = parcelHelpers.interopDefault(_nearest);
var _project = require("./project");
var _selection = require("../../selection");
const inputBindings = {
    defined: (selCmpt)=>{
        return selCmpt.type === 'point' && selCmpt.resolve === 'global' && selCmpt.bind && selCmpt.bind !== 'scales' && !(0, _selection.isLegendBinding)(selCmpt.bind);
    },
    parse: (model, selCmpt, selDef)=>(0, _.disableDirectManipulation)(selCmpt, selDef),
    topLevelSignals: (model, selCmpt, signals)=>{
        const name = selCmpt.name;
        const proj = selCmpt.project;
        const bind = selCmpt.bind;
        const init = selCmpt.init && selCmpt.init[0]; // Can only exist on single selections (one initial value).
        const datum = (0, _nearestDefault.default).defined(selCmpt) ? '(item().isVoronoi ? datum.datum : datum)' : 'datum';
        proj.items.forEach((p, i)=>{
            const sgname = (0, _util.varName)(`${name}_${p.field}`);
            const hasSignal = signals.filter((s)=>s.name === sgname);
            if (!hasSignal.length) signals.unshift({
                name: sgname,
                ...init ? {
                    init: (0, _assemble.assembleInit)(init[i])
                } : {
                    value: null
                },
                on: selCmpt.events ? [
                    {
                        events: selCmpt.events,
                        update: `datum && item().mark.marktype !== 'group' ? ${datum}[${(0, _vegaUtil.stringValue)(p.field)}] : null`
                    }
                ] : [],
                bind: bind[p.field] ?? bind[p.channel] ?? bind
            });
        });
        return signals;
    },
    signals: (model, selCmpt, signals)=>{
        const name = selCmpt.name;
        const proj = selCmpt.project;
        const signal = signals.find((s)=>s.name === name + (0, _.TUPLE));
        const fields = name + (0, _project.TUPLE_FIELDS);
        const values = proj.items.map((p)=>(0, _util.varName)(`${name}_${p.field}`));
        const valid = values.map((v)=>`${v} !== null`).join(' && ');
        if (values.length) signal.update = `${valid} ? {fields: ${fields}, values: [${values.join(', ')}]} : null`;
        delete signal.value;
        delete signal.on;
        return signals;
    }
};
exports.default = inputBindings;

},{"vega-util":"7f6sQ",".":"7GXIu","../../util":"acUGA","./assemble":"4YKkA","./nearest":"6cvnw","./project":"inhDL","../../selection":"jtWSq","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"6cvnw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _log = require("../../log");
var _mark = require("../../mark");
var _encode = require("../mark/encode");
const VORONOI = 'voronoi';
const nearest = {
    defined: (selCmpt)=>{
        return selCmpt.type === 'point' && selCmpt.nearest;
    },
    parse: (model, selCmpt)=>{
        // Scope selection events to the voronoi mark to prevent capturing
        // events that occur on the group mark (https://github.com/vega/vega/issues/2112).
        if (selCmpt.events) for (const s of selCmpt.events)s.markname = model.getName(VORONOI);
    },
    marks: (model, selCmpt, marks)=>{
        const { x, y } = selCmpt.project.hasChannel;
        const markType = model.mark;
        if ((0, _mark.isPathMark)(markType)) {
            _log.warn(_log.message.nearestNotSupportForContinuous(markType));
            return marks;
        }
        const cellDef = {
            name: model.getName(VORONOI),
            type: 'path',
            interactive: true,
            from: {
                data: model.getName('marks')
            },
            encode: {
                update: {
                    fill: {
                        value: 'transparent'
                    },
                    strokeWidth: {
                        value: 0.35
                    },
                    stroke: {
                        value: 'transparent'
                    },
                    isVoronoi: {
                        value: true
                    },
                    ...(0, _encode.tooltip)(model, {
                        reactiveGeom: true
                    })
                }
            },
            transform: [
                {
                    type: 'voronoi',
                    x: {
                        expr: x || !y ? 'datum.datum.x || 0' : '0'
                    },
                    y: {
                        expr: y || !x ? 'datum.datum.y || 0' : '0'
                    },
                    size: [
                        model.getSizeSignalRef('width'),
                        model.getSizeSignalRef('height')
                    ]
                }
            ]
        };
        let index = 0;
        let exists = false;
        marks.forEach((mark, i)=>{
            const name = mark.name ?? '';
            if (name === model.component.mark[0].name) index = i;
            else if (name.includes(VORONOI)) exists = true;
        });
        if (!exists) marks.splice(index + 1, 0, cellDef);
        return marks;
    }
};
exports.default = nearest;

},{"../../log":"loqTw","../../mark":"3Z1xx","../mark/encode":"3WiQk","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3WiQk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "aria", ()=>(0, _aria.aria));
parcelHelpers.export(exports, "baseEncodeEntry", ()=>(0, _base.baseEncodeEntry));
parcelHelpers.export(exports, "color", ()=>(0, _color.color));
parcelHelpers.export(exports, "defined", ()=>(0, _defined.defined));
parcelHelpers.export(exports, "valueIfDefined", ()=>(0, _defined.valueIfDefined));
parcelHelpers.export(exports, "nonPosition", ()=>(0, _nonposition.nonPosition));
parcelHelpers.export(exports, "pointPosition", ()=>(0, _positionPoint.pointPosition));
parcelHelpers.export(exports, "pointOrRangePosition", ()=>(0, _positionRange.pointOrRangePosition));
parcelHelpers.export(exports, "rangePosition", ()=>(0, _positionRange.rangePosition));
parcelHelpers.export(exports, "rectPosition", ()=>(0, _positionRect.rectPosition));
parcelHelpers.export(exports, "text", ()=>(0, _text.text));
parcelHelpers.export(exports, "tooltip", ()=>(0, _tooltip.tooltip));
parcelHelpers.export(exports, "tooltipRefForEncoding", ()=>(0, _tooltip.tooltipRefForEncoding));
var _aria = require("./aria");
var _base = require("./base");
var _color = require("./color");
var _defined = require("./defined");
var _nonposition = require("./nonposition");
var _positionPoint = require("./position-point");
var _positionRange = require("./position-range");
var _positionRect = require("./position-rect");
var _text = require("./text");
var _tooltip = require("./tooltip");

},{"./aria":"7nuT5","./base":"d9d9g","./color":"1q1Ze","./defined":"bX2yv","./nonposition":"d8HzF","./position-point":"6mDjO","./position-range":"u0zxU","./position-rect":"fqquP","./text":"jRyEK","./tooltip":"j4ek2","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"7nuT5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "aria", ()=>aria);
parcelHelpers.export(exports, "description", ()=>description);
var _vegaUtil = require("vega-util");
var _util = require("../../../util");
var _common = require("../../common");
var _vegaSchema = require("./../../../vega.schema");
var _conditional = require("./conditional");
var _text = require("./text");
var _tooltip = require("./tooltip");
function aria(model) {
    const { markDef, config } = model;
    const enableAria = (0, _common.getMarkPropOrConfig)('aria', markDef, config);
    // We can ignore other aria properties if ariaHidden is true.
    if (enableAria === false) // getMarkGroups sets aria to false already so we don't have to set it in the encode block
    return {};
    return {
        ...enableAria ? {
            aria: enableAria
        } : {},
        ...ariaRoleDescription(model),
        ...description(model)
    };
}
function ariaRoleDescription(model) {
    const { mark, markDef, config } = model;
    if (config.aria === false) return {};
    const ariaRoleDesc = (0, _common.getMarkPropOrConfig)('ariaRoleDescription', markDef, config);
    if (ariaRoleDesc != null) return {
        ariaRoleDescription: {
            value: ariaRoleDesc
        }
    };
    return (0, _vegaUtil.hasOwnProperty)((0, _vegaSchema.VG_MARK_INDEX), mark) ? {} : {
        ariaRoleDescription: {
            value: mark
        }
    };
}
function description(model) {
    const { encoding, markDef, config, stack } = model;
    const channelDef = encoding.description;
    if (channelDef) return (0, _conditional.wrapCondition)({
        model,
        channelDef,
        vgChannel: 'description',
        mainRefFn: (cDef)=>(0, _text.textRef)(cDef, model.config),
        invalidValueRef: undefined // aria encoding doesn't have continuous scales and thus can't have invalid values
    });
    // Use default from mark def or config if defined.
    // Functions in encode usually just return undefined but since we are defining a default below, we need to check the default here.
    const descriptionValue = (0, _common.getMarkPropOrConfig)('description', markDef, config);
    if (descriptionValue != null) return {
        description: (0, _common.signalOrValueRef)(descriptionValue)
    };
    if (config.aria === false) return {};
    const data = (0, _tooltip.tooltipData)(encoding, stack, config);
    if ((0, _util.isEmpty)(data)) return undefined;
    return {
        description: {
            signal: (0, _util.entries)(data).map(([key, value], index)=>`"${index > 0 ? '; ' : ''}${key}: " + (${value})`).join(' + ')
        }
    };
}

},{"vega-util":"7f6sQ","../../../util":"acUGA","../../common":"jegt8","./../../../vega.schema":"3mBOT","./conditional":"k2lvv","./text":"jRyEK","./tooltip":"j4ek2","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"k2lvv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Return a VgEncodeEntry that includes a Vega production rule for a scale channel's encoding or guide encoding, which includes:
 * (1) the conditional rules (if provided as part of channelDef)
 * (2) invalidValueRef for handling invalid values (if provided as a parameter of this method)
 * (3) main reference for the encoded data.
 */ parcelHelpers.export(exports, "wrapCondition", ()=>wrapCondition);
var _vegaUtil = require("vega-util");
var _channeldef = require("../../../channeldef");
var _predicate = require("../../predicate");
var _parse = require("../../selection/parse");
function wrapCondition({ model, channelDef, vgChannel, invalidValueRef, mainRefFn }) {
    const condition = (0, _channeldef.isConditionalDef)(channelDef) && channelDef.condition;
    let valueRefs = [];
    if (condition) {
        const conditions = (0, _vegaUtil.array)(condition);
        valueRefs = conditions.map((c)=>{
            const conditionValueRef = mainRefFn(c);
            if ((0, _channeldef.isConditionalParameter)(c)) {
                const { param, empty } = c;
                const test = (0, _parse.parseSelectionPredicate)(model, {
                    param,
                    empty
                });
                return {
                    test,
                    ...conditionValueRef
                };
            } else {
                const test = (0, _predicate.expression)(model, c.test); // FIXME: remove casting once TS is no longer dumb about it
                return {
                    test,
                    ...conditionValueRef
                };
            }
        });
    }
    if (invalidValueRef !== undefined) valueRefs.push(invalidValueRef);
    const mainValueRef = mainRefFn(channelDef);
    if (mainValueRef !== undefined) valueRefs.push(mainValueRef);
    if (valueRefs.length > 1 || valueRefs.length === 1 && Boolean(valueRefs[0].test) // We must use array form valueRefs if test exists, otherwise Vega won't execute the test.
    ) return {
        [vgChannel]: valueRefs
    };
    else if (valueRefs.length === 1) return {
        [vgChannel]: valueRefs[0]
    };
    return {};
}

},{"vega-util":"7f6sQ","../../../channeldef":"dsccb","../../predicate":"d0sTM","../../selection/parse":"bgKKc","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"jRyEK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "text", ()=>text);
parcelHelpers.export(exports, "textRef", ()=>textRef);
var _channeldef = require("../../../channeldef");
var _common = require("../../common");
var _format = require("../../format");
var _conditional = require("./conditional");
function text(model, channel = 'text') {
    const channelDef = model.encoding[channel];
    return (0, _conditional.wrapCondition)({
        model,
        channelDef,
        vgChannel: channel,
        mainRefFn: (cDef)=>textRef(cDef, model.config),
        invalidValueRef: undefined // text encoding doesn't have continuous scales and thus can't have invalid values
    });
}
function textRef(channelDef, config, expr = 'datum') {
    // text
    if (channelDef) {
        if ((0, _channeldef.isValueDef)(channelDef)) return (0, _common.signalOrValueRef)(channelDef.value);
        if ((0, _channeldef.isFieldOrDatumDef)(channelDef)) {
            const { format, formatType } = (0, _channeldef.getFormatMixins)(channelDef);
            return (0, _format.formatSignalRef)({
                fieldOrDatumDef: channelDef,
                format,
                formatType,
                expr,
                config
            });
        }
    }
    return undefined;
}

},{"../../../channeldef":"dsccb","../../common":"jegt8","../../format":"79ccI","./conditional":"k2lvv","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"j4ek2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tooltip", ()=>tooltip);
parcelHelpers.export(exports, "tooltipData", ()=>tooltipData);
parcelHelpers.export(exports, "tooltipRefForEncoding", ()=>tooltipRefForEncoding);
var _vegaUtil = require("vega-util");
var _bin = require("../../../bin");
var _channel = require("../../../channel");
var _channeldef = require("../../../channeldef");
var _encoding = require("../../../encoding");
var _util = require("../../../util");
var _vegaSchema = require("../../../vega.schema");
var _common = require("../../common");
var _format = require("../../format");
var _conditional = require("./conditional");
var _text = require("./text");
function tooltip(model, opt = {}) {
    const { encoding, markDef, config, stack } = model;
    const channelDef = encoding.tooltip;
    if ((0, _vegaUtil.isArray)(channelDef)) return {
        tooltip: tooltipRefForEncoding({
            tooltip: channelDef
        }, stack, config, opt)
    };
    else {
        const datum = opt.reactiveGeom ? 'datum.datum' : 'datum';
        const mainRefFn = (cDef)=>{
            // use valueRef based on channelDef first
            const tooltipRefFromChannelDef = (0, _text.textRef)(cDef, config, datum);
            if (tooltipRefFromChannelDef) return tooltipRefFromChannelDef;
            if (cDef === null) // Allow using encoding.tooltip = null to disable tooltip
            return undefined;
            let markTooltip = (0, _common.getMarkPropOrConfig)('tooltip', markDef, config);
            if (markTooltip === true) markTooltip = {
                content: 'encoding'
            };
            if ((0, _vegaUtil.isString)(markTooltip)) return {
                value: markTooltip
            };
            else if ((0, _vegaUtil.isObject)(markTooltip)) {
                // `tooltip` is `{fields: 'encodings' | 'fields'}`
                if ((0, _vegaSchema.isSignalRef)(markTooltip)) return markTooltip;
                else if (markTooltip.content === 'encoding') return tooltipRefForEncoding(encoding, stack, config, opt);
                else return {
                    signal: datum
                };
            }
            return undefined;
        };
        return (0, _conditional.wrapCondition)({
            model,
            channelDef,
            vgChannel: 'tooltip',
            mainRefFn,
            invalidValueRef: undefined // tooltip encoding doesn't have continuous scales and thus can't have invalid values
        });
    }
}
function tooltipData(encoding, stack, config, { reactiveGeom } = {}) {
    const formatConfig = {
        ...config,
        ...config.tooltipFormat
    };
    const toSkip = new Set();
    const expr = reactiveGeom ? 'datum.datum' : 'datum';
    const tuples = [];
    function add(fDef, channel) {
        const mainChannel = (0, _channel.getMainRangeChannel)(channel);
        const fieldDef = (0, _channeldef.isTypedFieldDef)(fDef) ? fDef : {
            ...fDef,
            type: encoding[mainChannel].type // for secondary field def, copy type from main channel
        };
        const title = fieldDef.title || (0, _channeldef.defaultTitle)(fieldDef, formatConfig);
        const key = (0, _vegaUtil.array)(title).join(', ').replaceAll(/"/g, '\\"');
        let value;
        if ((0, _channel.isXorY)(channel)) {
            const channel2 = channel === 'x' ? 'x2' : 'y2';
            const fieldDef2 = (0, _channeldef.getFieldDef)(encoding[channel2]);
            if ((0, _bin.isBinned)(fieldDef.bin) && fieldDef2) {
                const startField = (0, _channeldef.vgField)(fieldDef, {
                    expr
                });
                const endField = (0, _channeldef.vgField)(fieldDef2, {
                    expr
                });
                const { format, formatType } = (0, _channeldef.getFormatMixins)(fieldDef);
                value = (0, _format.binFormatExpression)(startField, endField, format, formatType, formatConfig);
                toSkip.add(channel2);
            }
        }
        if (((0, _channel.isXorY)(channel) || channel === (0, _channel.THETA) || channel === (0, _channel.RADIUS)) && stack && stack.fieldChannel === channel && stack.offset === 'normalize') {
            const { format, formatType } = (0, _channeldef.getFormatMixins)(fieldDef);
            value = (0, _format.formatSignalRef)({
                fieldOrDatumDef: fieldDef,
                format,
                formatType,
                expr,
                config: formatConfig,
                normalizeStack: true
            }).signal;
        }
        value ?? (value = (0, _text.textRef)(fieldDef, formatConfig, expr).signal);
        tuples.push({
            channel,
            key,
            value
        });
    }
    (0, _encoding.forEach)(encoding, (channelDef, channel)=>{
        if ((0, _channeldef.isFieldDef)(channelDef)) add(channelDef, channel);
        else if ((0, _channeldef.hasConditionalFieldDef)(channelDef)) add(channelDef.condition, channel);
    });
    const out = {};
    for (const { channel, key, value } of tuples)if (!toSkip.has(channel) && !out[key]) out[key] = value;
    return out;
}
function tooltipRefForEncoding(encoding, stack, config, { reactiveGeom } = {}) {
    const data = tooltipData(encoding, stack, config, {
        reactiveGeom
    });
    const keyValues = (0, _util.entries)(data).map(([key, value])=>`"${key}": ${value}`);
    return keyValues.length > 0 ? {
        signal: `{${keyValues.join(', ')}}`
    } : undefined;
}

},{"vega-util":"7f6sQ","../../../bin":"3cpW8","../../../channel":"liLED","../../../channeldef":"dsccb","../../../encoding":"2Ohsj","../../../util":"acUGA","../../../vega.schema":"3mBOT","../../common":"jegt8","../../format":"79ccI","./conditional":"k2lvv","./text":"jRyEK","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"d9d9g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "color", ()=>(0, _color.color));
parcelHelpers.export(exports, "nonPosition", ()=>(0, _nonposition.nonPosition));
parcelHelpers.export(exports, "pointPosition", ()=>(0, _positionPoint.pointPosition));
parcelHelpers.export(exports, "pointOrRangePosition", ()=>(0, _positionRange.pointOrRangePosition));
parcelHelpers.export(exports, "rangePosition", ()=>(0, _positionRange.rangePosition));
parcelHelpers.export(exports, "rectPosition", ()=>(0, _positionRect.rectPosition));
parcelHelpers.export(exports, "text", ()=>(0, _text.text));
parcelHelpers.export(exports, "tooltip", ()=>(0, _tooltip.tooltip));
parcelHelpers.export(exports, "baseEncodeEntry", ()=>baseEncodeEntry);
var _util = require("../../../util");
var _vegaSchema = require("../../../vega.schema");
var _common = require("../../common");
var _aria = require("./aria");
var _color = require("./color");
var _nonposition = require("./nonposition");
var _text = require("./text");
var _tooltip = require("./tooltip");
var _zindex = require("./zindex");
var _positionPoint = require("./position-point");
var _positionRange = require("./position-range");
var _positionRect = require("./position-rect");
const ALWAYS_IGNORE = new Set([
    'aria',
    'width',
    'height'
]);
function baseEncodeEntry(model, ignore) {
    const { fill, stroke } = ignore.color === 'include' ? (0, _color.color)(model) : {};
    return {
        ...markDefProperties(model.markDef, ignore),
        ...colorRef('fill', fill),
        ...colorRef('stroke', stroke),
        ...(0, _nonposition.nonPosition)('opacity', model),
        ...(0, _nonposition.nonPosition)('fillOpacity', model),
        ...(0, _nonposition.nonPosition)('strokeOpacity', model),
        ...(0, _nonposition.nonPosition)('strokeWidth', model),
        ...(0, _nonposition.nonPosition)('strokeDash', model),
        ...(0, _zindex.zindex)(model),
        ...(0, _tooltip.tooltip)(model),
        ...(0, _text.text)(model, 'href'),
        ...(0, _aria.aria)(model)
    };
}
function colorRef(channel, valueRef) {
    return valueRef ? {
        [channel]: valueRef
    } : {};
}
function markDefProperties(mark, ignore) {
    return (0, _vegaSchema.VG_MARK_CONFIGS).reduce((m, prop)=>{
        if (!ALWAYS_IGNORE.has(prop) && (0, _util.hasProperty)(mark, prop) && ignore[prop] !== 'ignore') m[prop] = (0, _common.signalOrValueRef)(mark[prop]);
        return m;
    }, {});
}

},{"../../../util":"acUGA","../../../vega.schema":"3mBOT","../../common":"jegt8","./aria":"7nuT5","./color":"1q1Ze","./nonposition":"d8HzF","./text":"jRyEK","./tooltip":"j4ek2","./zindex":"apXkn","./position-point":"6mDjO","./position-range":"u0zxU","./position-rect":"fqquP","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"1q1Ze":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "color", ()=>color);
var _log = require("../../../log");
var _util = require("../../../util");
var _common = require("../../common");
var _nonposition = require("./nonposition");
function color(model, opt = {
    filled: undefined
}) {
    const { markDef, encoding, config } = model;
    const { type: markType } = markDef;
    // Allow filled to be overridden (for trail's "filled")
    const filled = opt.filled ?? (0, _common.getMarkPropOrConfig)('filled', markDef, config);
    const transparentIfNeeded = (0, _util.contains)([
        'bar',
        'point',
        'circle',
        'square',
        'geoshape'
    ], markType) ? 'transparent' : undefined;
    const defaultFill = (0, _common.getMarkPropOrConfig)(filled === true ? 'color' : undefined, markDef, config, {
        vgChannel: 'fill'
    }) ?? // need to add this manually as getMarkConfig normally drops config.mark[channel] if vgChannel is specified
    config.mark[filled === true && 'color'] ?? // If there is no fill, always fill symbols, bar, geoshape
    // with transparent fills https://github.com/vega/vega-lite/issues/1316
    transparentIfNeeded;
    const defaultStroke = (0, _common.getMarkPropOrConfig)(filled === false ? 'color' : undefined, markDef, config, {
        vgChannel: 'stroke'
    }) ?? // need to add this manually as getMarkConfig normally drops config.mark[channel] if vgChannel is specified
    config.mark[filled === false && 'color'];
    const colorVgChannel = filled ? 'fill' : 'stroke';
    const fillStrokeMarkDefAndConfig = {
        ...defaultFill ? {
            fill: (0, _common.signalOrValueRef)(defaultFill)
        } : {},
        ...defaultStroke ? {
            stroke: (0, _common.signalOrValueRef)(defaultStroke)
        } : {}
    };
    if (markDef.color && (filled ? markDef.fill : markDef.stroke)) _log.warn(_log.message.droppingColor('property', {
        fill: 'fill' in markDef,
        stroke: 'stroke' in markDef
    }));
    return {
        ...fillStrokeMarkDefAndConfig,
        ...(0, _nonposition.nonPosition)('color', model, {
            vgChannel: colorVgChannel,
            defaultValue: filled ? defaultFill : defaultStroke
        }),
        ...(0, _nonposition.nonPosition)('fill', model, {
            // if there is encoding.fill, include default fill just in case we have conditional-only fill encoding
            defaultValue: encoding.fill ? defaultFill : undefined
        }),
        ...(0, _nonposition.nonPosition)('stroke', model, {
            // if there is encoding.stroke, include default fill just in case we have conditional-only stroke encoding
            defaultValue: encoding.stroke ? defaultStroke : undefined
        })
    };
}

},{"../../../log":"loqTw","../../../util":"acUGA","../../common":"jegt8","./nonposition":"d8HzF","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"d8HzF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Return encode for non-positional channels with scales. (Text doesn't have scale.)
 */ parcelHelpers.export(exports, "nonPosition", ()=>nonPosition);
var _channeldef = require("../../../channeldef");
var _common = require("../../common");
var _conditional = require("./conditional");
var _valueref = require("./valueref");
var _invalid = require("./invalid");
function nonPosition(channel, model, opt = {}) {
    const { markDef, encoding, config } = model;
    const { vgChannel } = opt;
    let { defaultRef, defaultValue } = opt;
    const channelDef = encoding[channel];
    if (defaultRef === undefined) {
        // prettier-ignore
        defaultValue ?? (defaultValue = (0, _common.getMarkPropOrConfig)(channel, markDef, config, {
            vgChannel,
            // If there is no conditonal def, we ignore vgConfig so the output spec is concise.
            // However, if there is a conditional def, we must include vgConfig so the default is respected.
            ignoreVgConfig: !(0, _channeldef.isConditionalDef)(channelDef)
        }));
        if (defaultValue !== undefined) defaultRef = (0, _common.signalOrValueRef)(defaultValue);
    }
    const commonProps = {
        markDef,
        config,
        scaleName: model.scaleName(channel),
        scale: model.getScaleComponent(channel)
    };
    const invalidValueRef = (0, _invalid.getConditionalValueRefForIncludingInvalidValue)({
        ...commonProps,
        scaleChannel: channel,
        channelDef
    });
    const mainRefFn = (cDef)=>{
        return _valueref.midPoint({
            ...commonProps,
            channel,
            channelDef: cDef,
            stack: null,
            defaultRef
        });
    };
    return (0, _conditional.wrapCondition)({
        model,
        channelDef,
        vgChannel: vgChannel ?? channel,
        invalidValueRef,
        mainRefFn
    });
}

},{"../../../channeldef":"dsccb","../../common":"jegt8","./conditional":"k2lvv","./valueref":"hE3Wg","./invalid":"h87qQ","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"apXkn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zindex", ()=>zindex);
var _channeldef = require("../../../channeldef");
var _mark = require("../../../mark");
var _common = require("../../common");
var _conditional = require("./conditional");
function zindex(model) {
    const { encoding, mark } = model;
    const order = encoding.order;
    if (!(0, _mark.isPathMark)(mark) && (0, _channeldef.isValueDef)(order)) return (0, _conditional.wrapCondition)({
        model,
        channelDef: order,
        vgChannel: 'zindex',
        mainRefFn: (cd)=>(0, _common.signalOrValueRef)(cd.value),
        invalidValueRef: undefined // zindex encoding doesn't have continuous scales and thus can't have invalid values
    });
    return {};
}

},{"../../../channeldef":"dsccb","../../../mark":"3Z1xx","../../common":"jegt8","./conditional":"k2lvv","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"6mDjO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Return encode for point (non-band) position channels.
 */ parcelHelpers.export(exports, "pointPosition", ()=>pointPosition);
// TODO: we need to find a way to refactor these so that scaleName is a part of scale
// but that's complicated. For now, this is a huge step moving forward.
/**
 * @return Vega ValueRef for normal x- or y-position without projection
 */ parcelHelpers.export(exports, "positionRef", ()=>positionRef);
parcelHelpers.export(exports, "pointPositionDefaultRef", ()=>pointPositionDefaultRef);
var _channel = require("../../../channel");
var _channeldef = require("../../../channeldef");
var _common = require("../../common");
var _offset = require("./offset");
var _valueref = require("./valueref");
var _scaledZeroOrMinOrMax = require("./scaledZeroOrMinOrMax");
function pointPosition(channel, model, { defaultPos, vgChannel }) {
    const { encoding, markDef, config, stack } = model;
    const channelDef = encoding[channel];
    const channel2Def = encoding[(0, _channel.getSecondaryRangeChannel)(channel)];
    const scaleName = model.scaleName(channel);
    const scale = model.getScaleComponent(channel);
    const { offset, offsetType } = (0, _offset.positionOffset)({
        channel,
        markDef,
        encoding,
        model,
        bandPosition: 0.5
    });
    // Get default position or position from mark def
    const defaultRef = pointPositionDefaultRef({
        model,
        defaultPos,
        channel,
        scaleName,
        scale
    });
    const valueRef = !channelDef && (0, _channel.isXorY)(channel) && (encoding.latitude || encoding.longitude) ? {
        field: model.getName(channel)
    } : positionRef({
        channel,
        channelDef,
        channel2Def,
        markDef,
        config,
        scaleName,
        scale,
        stack,
        offset,
        defaultRef,
        bandPosition: offsetType === 'encoding' ? 0 : undefined
    });
    return valueRef ? {
        [vgChannel || channel]: valueRef
    } : undefined;
}
function positionRef(params) {
    const { channel, channelDef, scaleName, stack, offset, markDef } = params;
    // This isn't a part of midPoint because we use midPoint for non-position too
    if ((0, _channeldef.isFieldOrDatumDef)(channelDef) && stack && channel === stack.fieldChannel) {
        if ((0, _channeldef.isFieldDef)(channelDef)) {
            let bandPosition = channelDef.bandPosition;
            if (bandPosition === undefined && markDef.type === 'text' && (channel === 'radius' || channel === 'theta')) // theta and radius of text mark should use bandPosition = 0.5 by default
            // so that labels for arc marks are centered automatically
            bandPosition = 0.5;
            if (bandPosition !== undefined) return _valueref.interpolatedSignalRef({
                scaleName,
                fieldOrDatumDef: channelDef,
                startSuffix: 'start',
                bandPosition,
                offset
            });
        }
        // x or y use stack_end so that stacked line's point mark use stack_end too.
        return _valueref.valueRefForFieldOrDatumDef(channelDef, scaleName, {
            suffix: 'end'
        }, {
            offset
        });
    }
    return _valueref.midPointRefWithPositionInvalidTest(params);
}
function pointPositionDefaultRef({ model, defaultPos, channel, scaleName, scale }) {
    const { markDef, config } = model;
    return ()=>{
        const mainChannel = (0, _channel.getMainRangeChannel)(channel);
        const vgChannel = (0, _channel.getVgPositionChannel)(channel);
        const definedValueOrConfig = (0, _common.getMarkPropOrConfig)(channel, markDef, config, {
            vgChannel
        });
        if (definedValueOrConfig !== undefined) return _valueref.widthHeightValueOrSignalRef(channel, definedValueOrConfig);
        switch(defaultPos){
            case 'zeroOrMin':
                return zeroOrMinOrMaxPosition({
                    scaleName,
                    scale,
                    mode: 'zeroOrMin',
                    mainChannel,
                    config
                });
            case 'zeroOrMax':
                return zeroOrMinOrMaxPosition({
                    scaleName,
                    scale,
                    mode: {
                        zeroOrMax: {
                            widthSignal: model.width.signal,
                            heightSignal: model.height.signal
                        }
                    },
                    mainChannel,
                    config
                });
            case 'mid':
                {
                    const sizeRef = model[(0, _channel.getSizeChannel)(channel)];
                    return {
                        ...sizeRef,
                        mult: 0.5
                    };
                }
        }
        // defaultPos === null
        return undefined;
    };
}
function zeroOrMinOrMaxPosition({ mainChannel, config, ...otherProps }) {
    const scaledValueRef = (0, _scaledZeroOrMinOrMax.scaledZeroOrMinOrMax)(otherProps);
    const { mode } = otherProps;
    if (scaledValueRef) return scaledValueRef;
    switch(mainChannel){
        case 'radius':
            {
                if (mode === 'zeroOrMin') return {
                    value: 0
                }; // min value
                const { widthSignal, heightSignal } = mode.zeroOrMax;
                // max of radius is min(width, height) / 2
                return {
                    signal: `min(${widthSignal},${heightSignal})/2`
                };
            }
        case 'theta':
            return mode === 'zeroOrMin' ? {
                value: 0
            } : {
                signal: '2*PI'
            };
        case 'x':
            return mode === 'zeroOrMin' ? {
                value: 0
            } : {
                field: {
                    group: 'width'
                }
            };
        case 'y':
            return mode === 'zeroOrMin' ? {
                field: {
                    group: 'height'
                }
            } : {
                value: 0
            };
    }
}

},{"../../../channel":"liLED","../../../channeldef":"dsccb","../../common":"jegt8","./offset":"cwCFH","./valueref":"hE3Wg","./scaledZeroOrMinOrMax":"bDhJn","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cwCFH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "positionOffset", ()=>positionOffset);
var _common = require("../../common");
var _valueref = require("./valueref");
function positionOffset({ channel: baseChannel, markDef, encoding = {}, model, bandPosition }) {
    const channel = `${baseChannel}Offset`; // Need to cast as the type can't be inferred automatically
    const defaultValue = markDef[channel];
    // FIXME: remove as any
    const channelDef = encoding[channel];
    if ((channel === 'xOffset' || channel === 'yOffset') && channelDef) {
        const ref = (0, _valueref.midPoint)({
            channel: channel,
            channelDef,
            markDef,
            config: model?.config,
            scaleName: model.scaleName(channel),
            scale: model.getScaleComponent(channel),
            stack: null,
            defaultRef: (0, _common.signalOrValueRef)(defaultValue),
            bandPosition
        });
        return {
            offsetType: 'encoding',
            offset: ref
        };
    }
    const markDefOffsetValue = markDef[channel];
    if (markDefOffsetValue) return {
        offsetType: 'visual',
        offset: markDefOffsetValue
    };
    return {};
}

},{"../../common":"jegt8","./valueref":"hE3Wg","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"u0zxU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Utility for area/rule position, which can be either point or range.
 * (One of the axes should be point and the other should be range.)
 */ parcelHelpers.export(exports, "pointOrRangePosition", ()=>pointOrRangePosition);
parcelHelpers.export(exports, "rangePosition", ()=>rangePosition);
parcelHelpers.export(exports, "position2Ref", ()=>position2Ref);
var _channel = require("../../../channel");
var _channeldef = require("../../../channeldef");
var _log = require("../../../log");
var _mark = require("../../../mark");
var _common = require("../../common");
var _offset = require("./offset");
var _positionAlign = require("./position-align");
var _positionPoint = require("./position-point");
var _valueref = require("./valueref");
function pointOrRangePosition(channel, model, { defaultPos, defaultPos2, range }) {
    if (range) return rangePosition(channel, model, {
        defaultPos,
        defaultPos2
    });
    return (0, _positionPoint.pointPosition)(channel, model, {
        defaultPos
    });
}
function rangePosition(channel, model, { defaultPos, defaultPos2 }) {
    const { markDef, config } = model;
    const channel2 = (0, _channel.getSecondaryRangeChannel)(channel);
    const sizeChannel = (0, _channel.getSizeChannel)(channel);
    const pos2Mixins = pointPosition2OrSize(model, defaultPos2, channel2);
    const vgChannel = pos2Mixins[sizeChannel] ? (0, _positionAlign.vgAlignedPositionChannel)(channel, markDef, config) : (0, _channel.getVgPositionChannel)(channel);
    return {
        ...(0, _positionPoint.pointPosition)(channel, model, {
            defaultPos,
            vgChannel
        }),
        ...pos2Mixins
    };
}
/**
 * Return encode for x2, y2.
 * If channel is not specified, return one channel based on orientation.
 */ function pointPosition2OrSize(model, defaultPos, channel) {
    const { encoding, mark, markDef, stack, config } = model;
    const baseChannel = (0, _channel.getMainRangeChannel)(channel);
    const sizeChannel = (0, _channel.getSizeChannel)(channel);
    const vgChannel = (0, _channel.getVgPositionChannel)(channel);
    const channelDef = encoding[baseChannel];
    const scaleName = model.scaleName(baseChannel);
    const scale = model.getScaleComponent(baseChannel);
    const { offset } = channel in encoding || channel in markDef ? (0, _offset.positionOffset)({
        channel,
        markDef,
        encoding,
        model
    }) : (0, _offset.positionOffset)({
        channel: baseChannel,
        markDef,
        encoding,
        model
    });
    if (!channelDef && (channel === 'x2' || channel === 'y2') && (encoding.latitude || encoding.longitude)) {
        const vgSizeChannel = (0, _channel.getSizeChannel)(channel);
        const size = model.markDef[vgSizeChannel];
        if (size != null) return {
            [vgSizeChannel]: {
                value: size
            }
        };
        else return {
            [vgChannel]: {
                field: model.getName(channel)
            }
        };
    }
    const valueRef = position2Ref({
        channel,
        channelDef,
        channel2Def: encoding[channel],
        markDef,
        config,
        scaleName,
        scale,
        stack,
        offset,
        defaultRef: undefined
    });
    if (valueRef !== undefined) return {
        [vgChannel]: valueRef
    };
    // TODO: check width/height encoding here once we add them
    // no x2/y2 encoding, then try to read x2/y2 or width/height based on precedence:
    // markDef > config.style > mark-specific config (config[mark]) > general mark config (config.mark)
    return position2orSize(channel, markDef) || position2orSize(channel, {
        [channel]: (0, _common.getMarkStyleConfig)(channel, markDef, config.style),
        [sizeChannel]: (0, _common.getMarkStyleConfig)(sizeChannel, markDef, config.style)
    }) || position2orSize(channel, config[mark]) || position2orSize(channel, config.mark) || {
        [vgChannel]: (0, _positionPoint.pointPositionDefaultRef)({
            model,
            defaultPos,
            channel,
            scaleName,
            scale
        })()
    };
}
function position2Ref({ channel, channelDef, channel2Def, markDef, config, scaleName, scale, stack, offset, defaultRef }) {
    if ((0, _channeldef.isFieldOrDatumDef)(channelDef) && stack && // If fieldChannel is X and channel is X2 (or Y and Y2)
    channel.charAt(0) === stack.fieldChannel.charAt(0)) return _valueref.valueRefForFieldOrDatumDef(channelDef, scaleName, {
        suffix: 'start'
    }, {
        offset
    });
    return _valueref.midPointRefWithPositionInvalidTest({
        channel,
        channelDef: channel2Def,
        scaleName,
        scale,
        stack,
        markDef,
        config,
        offset,
        defaultRef
    });
}
function position2orSize(channel, markDef) {
    const sizeChannel = (0, _channel.getSizeChannel)(channel);
    const vgChannel = (0, _channel.getVgPositionChannel)(channel);
    if (markDef[vgChannel] !== undefined) return {
        [vgChannel]: _valueref.widthHeightValueOrSignalRef(channel, markDef[vgChannel])
    };
    else if (markDef[channel] !== undefined) return {
        [vgChannel]: _valueref.widthHeightValueOrSignalRef(channel, markDef[channel])
    };
    else if (markDef[sizeChannel]) {
        const dimensionSize = markDef[sizeChannel];
        if ((0, _mark.isRelativeBandSize)(dimensionSize)) _log.warn(_log.message.relativeBandSizeNotSupported(sizeChannel));
        else return {
            [sizeChannel]: _valueref.widthHeightValueOrSignalRef(channel, dimensionSize)
        };
    }
    return undefined;
}

},{"../../../channel":"liLED","../../../channeldef":"dsccb","../../../log":"loqTw","../../../mark":"3Z1xx","../../common":"jegt8","./offset":"cwCFH","./position-align":"dNjeC","./position-point":"6mDjO","./valueref":"hE3Wg","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dNjeC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "vgAlignedPositionChannel", ()=>vgAlignedPositionChannel);
var _channel = require("../../../channel");
var _log = require("../../../log");
var _vegaSchema = require("../../../vega.schema");
var _common = require("../../common");
const ALIGNED_X_CHANNEL = {
    left: 'x',
    center: 'xc',
    right: 'x2'
};
const BASELINED_Y_CHANNEL = {
    top: 'y',
    middle: 'yc',
    bottom: 'y2'
};
function vgAlignedPositionChannel(channel, markDef, config, defaultAlign = 'middle') {
    if (channel === 'radius' || channel === 'theta') return (0, _channel.getVgPositionChannel)(channel);
    const alignChannel = channel === 'x' ? 'align' : 'baseline';
    const align = (0, _common.getMarkPropOrConfig)(alignChannel, markDef, config);
    let alignExcludingSignal;
    if ((0, _vegaSchema.isSignalRef)(align)) {
        _log.warn(_log.message.rangeMarkAlignmentCannotBeExpression(alignChannel));
        alignExcludingSignal = undefined;
    } else alignExcludingSignal = align;
    // FIXME: remove as any
    if (channel === 'x') return ALIGNED_X_CHANNEL[alignExcludingSignal || (defaultAlign === 'top' ? 'left' : 'center')];
    else return BASELINED_Y_CHANNEL[alignExcludingSignal || defaultAlign];
}

},{"../../../channel":"liLED","../../../log":"loqTw","../../../vega.schema":"3mBOT","../../common":"jegt8","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"fqquP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rectPosition", ()=>rectPosition);
var _vegaUtil = require("vega-util");
var _bin = require("../../../bin");
var _channel = require("../../../channel");
var _channeldef = require("../../../channeldef");
var _config = require("../../../config");
var _log = require("../../../log");
var _mark = require("../../../mark");
var _scale = require("../../../scale");
var _vegaSchema = require("../../../vega.schema");
var _common = require("../../common");
var _nonposition = require("./nonposition");
var _offset = require("./offset");
var _positionAlign = require("./position-align");
var _positionPoint = require("./position-point");
var _positionRange = require("./position-range");
var _valueref = require("./valueref");
var _util = require("../../../util");
var _timeunit = require("../../data/timeunit");
function rectPosition(model, channel) {
    const { config, encoding, markDef } = model;
    const mark = markDef.type;
    const channel2 = (0, _channel.getSecondaryRangeChannel)(channel);
    const sizeChannel = (0, _channel.getSizeChannel)(channel);
    const channelDef = encoding[channel];
    const channelDef2 = encoding[channel2];
    const scale = model.getScaleComponent(channel);
    const scaleType = scale ? scale.get('type') : undefined;
    const orient = markDef.orient;
    const hasSizeDef = encoding[sizeChannel] ?? encoding.size ?? (0, _common.getMarkPropOrConfig)('size', markDef, config, {
        vgChannel: sizeChannel
    });
    const offsetScaleChannel = (0, _channel.getOffsetChannel)(channel);
    const isBarOrTickBand = mark === 'bar' && (channel === 'x' ? orient === 'vertical' : orient === 'horizontal') || mark === 'tick' && (channel === 'y' ? orient === 'vertical' : orient === 'horizontal');
    // x, x2, and width -- we must specify two of these in all conditions
    if ((0, _channeldef.isFieldDef)(channelDef) && ((0, _bin.isBinning)(channelDef.bin) || (0, _bin.isBinned)(channelDef.bin) || channelDef.timeUnit && !channelDef2) && !(hasSizeDef && !(0, _mark.isRelativeBandSize)(hasSizeDef)) && !encoding[offsetScaleChannel] && !(0, _scale.hasDiscreteDomain)(scaleType)) return rectBinPosition({
        fieldDef: channelDef,
        fieldDef2: channelDef2,
        channel,
        model
    });
    else if (((0, _channeldef.isFieldOrDatumDef)(channelDef) && (0, _scale.hasDiscreteDomain)(scaleType) || isBarOrTickBand) && !channelDef2) return positionAndSize(channelDef, channel, model);
    else return (0, _positionRange.rangePosition)(channel, model, {
        defaultPos: 'zeroOrMax',
        defaultPos2: 'zeroOrMin'
    });
}
function defaultSizeRef(sizeChannel, scaleName, scale, config, bandSize, hasFieldDef, mark) {
    if ((0, _mark.isRelativeBandSize)(bandSize)) {
        if (scale) {
            const scaleType = scale.get('type');
            if (scaleType === 'band') {
                let bandWidth = `bandwidth('${scaleName}')`;
                if (bandSize.band !== 1) bandWidth = `${bandSize.band} * ${bandWidth}`;
                const minBandSize = (0, _common.getMarkConfig)('minBandSize', {
                    type: mark
                }, config);
                return {
                    signal: minBandSize ? `max(${(0, _common.signalOrStringValue)(minBandSize)}, ${bandWidth})` : bandWidth
                };
            } else if (bandSize.band !== 1) {
                _log.warn(_log.message.cannotUseRelativeBandSizeWithNonBandScale(scaleType));
                bandSize = undefined;
            }
        } else return {
            mult: bandSize.band,
            field: {
                group: sizeChannel
            }
        };
    } else if ((0, _vegaSchema.isSignalRef)(bandSize)) return bandSize;
    else if (bandSize) return {
        value: bandSize
    };
    // no valid band size
    if (scale) {
        const scaleRange = scale.get('range');
        if ((0, _vegaSchema.isVgRangeStep)(scaleRange) && (0, _vegaUtil.isNumber)(scaleRange.step)) return {
            value: scaleRange.step - 2
        };
    }
    if (!hasFieldDef) {
        const { bandPaddingInner, barBandPaddingInner, rectBandPaddingInner, tickBandPaddingInner } = config.scale;
        const padding = (0, _util.getFirstDefined)(bandPaddingInner, mark === 'tick' ? tickBandPaddingInner : mark === 'bar' ? barBandPaddingInner : rectBandPaddingInner); // this part is like paddingInner in scale.ts
        if ((0, _vegaSchema.isSignalRef)(padding)) return {
            signal: `(1 - (${padding.signal})) * ${sizeChannel}`
        };
        else if ((0, _vegaUtil.isNumber)(padding)) return {
            signal: `${1 - padding} * ${sizeChannel}`
        };
    }
    const defaultStep = (0, _config.getViewConfigDiscreteStep)(config.view, sizeChannel);
    return {
        value: defaultStep - 2
    };
}
/**
 * Output position encoding and its size encoding for continuous, point, and band scales.
 */ function positionAndSize(fieldDef, channel, model) {
    const { markDef, encoding, config, stack } = model;
    const orient = markDef.orient;
    const scaleName = model.scaleName(channel);
    const scale = model.getScaleComponent(channel);
    const vgSizeChannel = (0, _channel.getSizeChannel)(channel);
    const channel2 = (0, _channel.getSecondaryRangeChannel)(channel);
    const offsetScaleChannel = (0, _channel.getOffsetChannel)(channel);
    const offsetScaleName = model.scaleName(offsetScaleChannel);
    const offsetScale = model.getScaleComponent((0, _channel.getOffsetScaleChannel)(channel));
    const useVlSizeChannel = // Always uses size channel for ticks, because tick only calls rectPosition() for the size channel
    markDef.type === 'tick' || // use "size" channel for bars, if there is orient and the channel matches the right orientation
    orient === 'horizontal' && channel === 'y' || orient === 'vertical' && channel === 'x';
    // Use size encoding / mark property / config if it exists
    let sizeMixins;
    if (encoding.size || markDef.size) {
        if (useVlSizeChannel) sizeMixins = (0, _nonposition.nonPosition)('size', model, {
            vgChannel: vgSizeChannel,
            defaultRef: (0, _common.signalOrValueRef)(markDef.size)
        });
        else _log.warn(_log.message.cannotApplySizeToNonOrientedMark(markDef.type));
    }
    const hasSizeFromMarkOrEncoding = !!sizeMixins;
    // Otherwise, apply default value
    const bandSize = (0, _channeldef.getBandSize)({
        channel,
        fieldDef,
        markDef,
        config,
        scaleType: (scale || offsetScale)?.get('type'),
        useVlSizeChannel
    });
    sizeMixins = sizeMixins || {
        [vgSizeChannel]: defaultSizeRef(vgSizeChannel, offsetScaleName || scaleName, offsetScale || scale, config, bandSize, !!fieldDef, markDef.type)
    };
    /*
      Band scales with size value and all point scales, use xc/yc + band=0.5
  
      Otherwise (band scales that has size based on a band ref), use x/y with position band = (1 - size_band) / 2.
      In this case, size_band is the band specified in the x/y-encoding.
      By default band is 1, so `(1 - band) / 2` = 0.
      If band is 0.6, the the x/y position in such case should be `(1 - band) / 2` = 0.2
     */ const defaultBandAlign = (scale || offsetScale)?.get('type') === 'band' && (0, _mark.isRelativeBandSize)(bandSize) && !hasSizeFromMarkOrEncoding ? 'top' : 'middle';
    const vgChannel = (0, _positionAlign.vgAlignedPositionChannel)(channel, markDef, config, defaultBandAlign);
    const center = vgChannel === 'xc' || vgChannel === 'yc';
    const { offset, offsetType } = (0, _offset.positionOffset)({
        channel,
        markDef,
        encoding,
        model,
        bandPosition: center ? 0.5 : 0
    });
    const posRef = _valueref.midPointRefWithPositionInvalidTest({
        channel,
        channelDef: fieldDef,
        markDef,
        config,
        scaleName,
        scale,
        stack,
        offset,
        defaultRef: (0, _positionPoint.pointPositionDefaultRef)({
            model,
            defaultPos: 'mid',
            channel,
            scaleName,
            scale
        }),
        bandPosition: center ? offsetType === 'encoding' ? 0 : 0.5 : (0, _vegaSchema.isSignalRef)(bandSize) ? {
            signal: `(1-${bandSize})/2`
        } : (0, _mark.isRelativeBandSize)(bandSize) ? (1 - bandSize.band) / 2 : 0
    });
    if (vgSizeChannel) return {
        [vgChannel]: posRef,
        ...sizeMixins
    };
    else {
        // otherwise, we must simulate size by setting position2 = position + size
        // (for theta/radius since Vega doesn't have thetaWidth/radiusWidth)
        const vgChannel2 = (0, _channel.getVgPositionChannel)(channel2);
        const sizeRef = sizeMixins[vgSizeChannel];
        const sizeOffset = offset ? {
            ...sizeRef,
            offset
        } : sizeRef;
        return {
            [vgChannel]: posRef,
            // posRef might be an array that wraps position invalid test
            [vgChannel2]: (0, _vegaUtil.isArray)(posRef) ? [
                posRef[0],
                {
                    ...posRef[1],
                    offset: sizeOffset
                }
            ] : {
                ...posRef,
                offset: sizeOffset
            }
        };
    }
}
function getBinSpacing(channel, spacing, reverse, axisTranslate, offset, minBandSize, bandSizeExpr) {
    if ((0, _channel.isPolarPositionChannel)(channel)) return 0;
    const isEnd = channel === 'x' || channel === 'y2';
    const spacingOffset = isEnd ? -spacing / 2 : spacing / 2;
    if ((0, _vegaSchema.isSignalRef)(reverse) || (0, _vegaSchema.isSignalRef)(offset) || (0, _vegaSchema.isSignalRef)(axisTranslate) || minBandSize) {
        const reverseExpr = (0, _common.signalOrStringValue)(reverse);
        const offsetExpr = (0, _common.signalOrStringValue)(offset);
        const axisTranslateExpr = (0, _common.signalOrStringValue)(axisTranslate);
        const minBandSizeExpr = (0, _common.signalOrStringValue)(minBandSize);
        const sign = isEnd ? '' : '-';
        const spacingAndSizeOffset = minBandSize ? `(${bandSizeExpr} < ${minBandSizeExpr} ? ${sign}0.5 * (${minBandSizeExpr} - (${bandSizeExpr})) : ${spacingOffset})` : spacingOffset;
        const t = axisTranslateExpr ? `${axisTranslateExpr} + ` : '';
        const r = reverseExpr ? `(${reverseExpr} ? -1 : 1) * ` : '';
        const o = offsetExpr ? `(${offsetExpr} + ${spacingAndSizeOffset})` : spacingAndSizeOffset;
        return {
            signal: t + r + o
        };
    } else {
        offset = offset || 0;
        return axisTranslate + (reverse ? -offset - spacingOffset : +offset + spacingOffset);
    }
}
function rectBinPosition({ fieldDef, fieldDef2, channel, model }) {
    const { config, markDef, encoding } = model;
    const scale = model.getScaleComponent(channel);
    const scaleName = model.scaleName(channel);
    const scaleType = scale ? scale.get('type') : undefined;
    const reverse = scale.get('reverse');
    const bandSize = (0, _channeldef.getBandSize)({
        channel,
        fieldDef,
        markDef,
        config,
        scaleType
    });
    const axis = model.component.axes[channel]?.[0];
    const axisTranslate = axis?.get('translate') ?? 0.5; // vega default is 0.5
    const spacing = (0, _channel.isXorY)(channel) ? (0, _common.getMarkPropOrConfig)('binSpacing', markDef, config) ?? 0 : 0;
    const channel2 = (0, _channel.getSecondaryRangeChannel)(channel);
    const vgChannel = (0, _channel.getVgPositionChannel)(channel);
    const vgChannel2 = (0, _channel.getVgPositionChannel)(channel2);
    const minBandSize = (0, _common.getMarkConfig)('minBandSize', markDef, config);
    const { offset } = (0, _offset.positionOffset)({
        channel,
        markDef,
        encoding,
        model,
        bandPosition: 0
    });
    const { offset: offset2 } = (0, _offset.positionOffset)({
        channel: channel2,
        markDef,
        encoding,
        model,
        bandPosition: 0
    });
    const bandSizeExpr = _valueref.binSizeExpr({
        fieldDef,
        scaleName
    });
    const binSpacingOffset = getBinSpacing(channel, spacing, reverse, axisTranslate, offset, minBandSize, bandSizeExpr);
    const binSpacingOffset2 = getBinSpacing(channel2, spacing, reverse, axisTranslate, offset2 ?? offset, minBandSize, bandSizeExpr);
    const bandPositionForBandSize = (0, _vegaSchema.isSignalRef)(bandSize) ? {
        signal: `(1-${bandSize.signal})/2`
    } : (0, _mark.isRelativeBandSize)(bandSize) ? (1 - bandSize.band) / 2 : 0.5;
    const bandPosition = (0, _channeldef.getBandPosition)({
        fieldDef,
        fieldDef2,
        markDef,
        config
    });
    if ((0, _bin.isBinning)(fieldDef.bin) || fieldDef.timeUnit) {
        const useRectOffsetField = fieldDef.timeUnit && bandPosition !== 0.5;
        return {
            [vgChannel2]: rectBinRef({
                fieldDef,
                scaleName,
                bandPosition: bandPositionForBandSize,
                offset: binSpacingOffset2,
                useRectOffsetField
            }),
            [vgChannel]: rectBinRef({
                fieldDef,
                scaleName,
                bandPosition: (0, _vegaSchema.isSignalRef)(bandPositionForBandSize) ? {
                    signal: `1-${bandPositionForBandSize.signal}`
                } : 1 - bandPositionForBandSize,
                offset: binSpacingOffset,
                useRectOffsetField
            })
        };
    } else if ((0, _bin.isBinned)(fieldDef.bin)) {
        const startRef = _valueref.valueRefForFieldOrDatumDef(fieldDef, scaleName, {}, {
            offset: binSpacingOffset2
        });
        if ((0, _channeldef.isFieldDef)(fieldDef2)) return {
            [vgChannel2]: startRef,
            [vgChannel]: _valueref.valueRefForFieldOrDatumDef(fieldDef2, scaleName, {}, {
                offset: binSpacingOffset
            })
        };
        else if ((0, _bin.isBinParams)(fieldDef.bin) && fieldDef.bin.step) return {
            [vgChannel2]: startRef,
            [vgChannel]: {
                signal: `scale("${scaleName}", ${(0, _channeldef.vgField)(fieldDef, {
                    expr: 'datum'
                })} + ${fieldDef.bin.step})`,
                offset: binSpacingOffset
            }
        };
    }
    _log.warn(_log.message.channelRequiredForBinned(channel2));
    return undefined;
}
/**
 * Value Ref for binned fields
 */ function rectBinRef({ fieldDef, scaleName, bandPosition, offset, useRectOffsetField }) {
    return _valueref.interpolatedSignalRef({
        scaleName,
        fieldOrDatumDef: fieldDef,
        bandPosition,
        offset,
        ...useRectOffsetField ? {
            startSuffix: (0, _timeunit.OFFSETTED_RECT_START_SUFFIX),
            endSuffix: (0, _timeunit.OFFSETTED_RECT_END_SUFFIX)
        } : {}
    });
}

},{"vega-util":"7f6sQ","../../../bin":"3cpW8","../../../channel":"liLED","../../../channeldef":"dsccb","../../../config":"8TUzf","../../../log":"loqTw","../../../mark":"3Z1xx","../../../scale":"bdpXN","../../../vega.schema":"3mBOT","../../common":"jegt8","./nonposition":"d8HzF","./offset":"cwCFH","./position-align":"dNjeC","./position-point":"6mDjO","./position-range":"u0zxU","./valueref":"hE3Wg","../../../util":"acUGA","../../data/timeunit":"iPsUH","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bX2yv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create Vega's "defined" encoding to break paths in a path mark for invalid values.
 */ parcelHelpers.export(exports, "defined", ()=>defined);
parcelHelpers.export(exports, "valueIfDefined", ()=>valueIfDefined);
var _aggregate = require("../../../aggregate");
var _channel = require("../../../channel");
var _predicate = require("../../../predicate");
var _common = require("../../common");
var _scaleInvalidDataMode = require("../../invalid/ScaleInvalidDataMode");
function defined(model) {
    const { config, markDef } = model;
    // For each channel (x/y), add fields to break path to a set first.
    const fieldsToBreakPath = new Set();
    model.forEachFieldDef((fieldDef, channel)=>{
        let scaleType;
        if (!(0, _channel.isScaleChannel)(channel) || !(scaleType = model.getScaleType(channel))) // Skip if the channel is not a scale channel or does not have a scale
        return;
        const isCountAggregate = (0, _aggregate.isCountingAggregateOp)(fieldDef.aggregate);
        const invalidDataMode = (0, _scaleInvalidDataMode.getScaleInvalidDataMode)({
            scaleChannel: channel,
            markDef,
            config,
            scaleType,
            isCountAggregate
        });
        if ((0, _scaleInvalidDataMode.shouldBreakPath)(invalidDataMode)) {
            const field = model.vgField(channel, {
                expr: 'datum',
                binSuffix: model.stack?.impute ? 'mid' : undefined
            });
            if (field) fieldsToBreakPath.add(field);
        }
    });
    // If the set is not empty, return a defined signal.
    if (fieldsToBreakPath.size > 0) {
        const signal = [
            ...fieldsToBreakPath
        ].map((field)=>(0, _predicate.fieldValidPredicate)(field, true)).join(' && ');
        return {
            defined: {
                signal
            }
        };
    }
    return undefined;
}
function valueIfDefined(prop, value) {
    if (value !== undefined) return {
        [prop]: (0, _common.signalOrValueRef)(value)
    };
    return undefined;
}

},{"../../../aggregate":"d7bUU","../../../channel":"liLED","../../../predicate":"gynPW","../../common":"jegt8","../../invalid/ScaleInvalidDataMode":"1nWTz","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"2fffE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TOGGLE", ()=>TOGGLE);
var _ = require(".");
const TOGGLE = '_toggle';
const toggle = {
    defined: (selCmpt)=>{
        return selCmpt.type === 'point' && !(0, _.isTimerSelection)(selCmpt) && !!selCmpt.toggle;
    },
    signals: (model, selCmpt, signals)=>{
        return signals.concat({
            name: selCmpt.name + TOGGLE,
            value: false,
            on: [
                {
                    events: selCmpt.events,
                    update: selCmpt.toggle
                }
            ]
        });
    },
    modifyExpr: (model, selCmpt)=>{
        const tpl = selCmpt.name + (0, _.TUPLE);
        const signal = selCmpt.name + TOGGLE;
        return `${signal} ? null : ${tpl}, ` + (selCmpt.resolve === 'global' ? `${signal} ? null : true, ` : `${signal} ? null : {unit: ${(0, _.unitName)(model)}}, `) + `${signal} ? ${tpl} : null`;
    }
};
exports.default = toggle;

},{".":"7GXIu","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"anCex":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseInteractiveLegend", ()=>parseInteractiveLegend);
var _vega = require("vega");
var _vegaEventSelector = require("vega-event-selector");
var _vegaUtil = require("vega-util");
var _ = require(".");
var _log = require("../../log");
var _selection = require("../../selection");
var _util = require("../../util");
var _project = require("./project");
var _toggle = require("./toggle");
const legendBindings = {
    defined: (selCmpt)=>{
        const spec = selCmpt.resolve === 'global' && selCmpt.bind && (0, _selection.isLegendBinding)(selCmpt.bind);
        const projLen = selCmpt.project.items.length === 1 && selCmpt.project.items[0].field !== (0, _selection.SELECTION_ID);
        if (spec && !projLen) _log.warn(_log.message.LEGEND_BINDINGS_MUST_HAVE_PROJECTION);
        return spec && projLen;
    },
    parse: (model, selCmpt, selDef)=>{
        // Allow legend items to be toggleable by default even though direct manipulation is disabled.
        const selDef_ = (0, _util.duplicate)(selDef);
        selDef_.select = (0, _vegaUtil.isString)(selDef_.select) ? {
            type: selDef_.select,
            toggle: selCmpt.toggle
        } : {
            ...selDef_.select,
            toggle: selCmpt.toggle
        };
        (0, _.disableDirectManipulation)(selCmpt, selDef_);
        if ((0, _vega.isObject)(selDef.select) && (selDef.select.on || selDef.select.clear)) {
            const legendFilter = 'event.item && indexof(event.item.mark.role, "legend") < 0';
            for (const evt of selCmpt.events){
                evt.filter = (0, _vegaUtil.array)(evt.filter ?? []);
                if (!evt.filter.includes(legendFilter)) evt.filter.push(legendFilter);
            }
        }
        const evt = (0, _selection.isLegendStreamBinding)(selCmpt.bind) ? selCmpt.bind.legend : 'click';
        const stream = (0, _vegaUtil.isString)(evt) ? (0, _vegaEventSelector.parseSelector)(evt, 'view') : (0, _vegaUtil.array)(evt);
        selCmpt.bind = {
            legend: {
                merge: stream
            }
        };
    },
    topLevelSignals: (model, selCmpt, signals)=>{
        const selName = selCmpt.name;
        const stream = (0, _selection.isLegendStreamBinding)(selCmpt.bind) && selCmpt.bind.legend;
        const markName = (name)=>(s)=>{
                const ds = (0, _util.duplicate)(s);
                ds.markname = name;
                return ds;
            };
        for (const proj of selCmpt.project.items){
            if (!proj.hasLegend) continue;
            const prefix = `${(0, _util.varName)(proj.field)}_legend`;
            const sgName = `${selName}_${prefix}`;
            const hasSignal = signals.filter((s)=>s.name === sgName);
            if (hasSignal.length === 0) {
                const events = stream.merge.map(markName(`${prefix}_symbols`)).concat(stream.merge.map(markName(`${prefix}_labels`))).concat(stream.merge.map(markName(`${prefix}_entries`)));
                signals.unshift({
                    name: sgName,
                    ...!selCmpt.init ? {
                        value: null
                    } : {},
                    on: [
                        // Legend entries do not store values, so we need to walk the scenegraph to the symbol datum.
                        {
                            events,
                            update: 'isDefined(datum.value) ? datum.value : item().items[0].items[0].datum.value',
                            force: true
                        },
                        {
                            events: stream.merge,
                            update: `!event.item || !datum ? null : ${sgName}`,
                            force: true
                        }
                    ]
                });
            }
        }
        return signals;
    },
    signals: (model, selCmpt, signals)=>{
        const name = selCmpt.name;
        const proj = selCmpt.project;
        const tuple = signals.find((s)=>s.name === name + (0, _.TUPLE));
        const fields = name + (0, _project.TUPLE_FIELDS);
        const values = proj.items.filter((p)=>p.hasLegend).map((p)=>(0, _util.varName)(`${name}_${(0, _util.varName)(p.field)}_legend`));
        const valid = values.map((v)=>`${v} !== null`).join(' && ');
        const update = `${valid} ? {fields: ${fields}, values: [${values.join(', ')}]} : null`;
        if (selCmpt.events && values.length > 0) tuple.on.push({
            events: values.map((signal)=>({
                    signal
                })),
            update
        });
        else if (values.length > 0) {
            tuple.update = update;
            delete tuple.value;
            delete tuple.on;
        }
        const toggle = signals.find((s)=>s.name === name + (0, _toggle.TOGGLE));
        const events = (0, _selection.isLegendStreamBinding)(selCmpt.bind) && selCmpt.bind.legend;
        if (toggle) {
            if (!selCmpt.events) toggle.on[0].events = events;
            else toggle.on.push({
                ...toggle.on[0],
                events
            });
        }
        return signals;
    }
};
exports.default = legendBindings;
function parseInteractiveLegend(model, channel, legendCmpt) {
    const field = model.fieldDef(channel)?.field;
    for (const selCmpt of (0, _util.vals)(model.component.selection ?? {})){
        const proj = selCmpt.project.hasField[field] ?? selCmpt.project.hasChannel[channel];
        if (proj && legendBindings.defined(selCmpt)) {
            const legendSelections = legendCmpt.get('selections') ?? [];
            legendSelections.push(selCmpt.name);
            legendCmpt.set('selections', legendSelections, false);
            proj.hasLegend = true;
        }
    }
}

},{"vega":"2Jj1D","vega-event-selector":"ijmxJ","vega-util":"7f6sQ",".":"7GXIu","../../log":"loqTw","../../selection":"jtWSq","../../util":"acUGA","./project":"inhDL","./toggle":"2fffE","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"1bMTD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vegaEventSelector = require("vega-event-selector");
var _channel = require("../../channel");
var _interval = require("./interval");
var _scales = require("./scales");
var _scalesDefault = parcelHelpers.interopDefault(_scales);
const ANCHOR = '_translate_anchor';
const DELTA = '_translate_delta';
const translate = {
    defined: (selCmpt)=>{
        return selCmpt.type === 'interval' && selCmpt.translate;
    },
    signals: (model, selCmpt, signals)=>{
        const name = selCmpt.name;
        const boundScales = (0, _scalesDefault.default).defined(selCmpt);
        const anchor = name + ANCHOR;
        const { x, y } = selCmpt.project.hasChannel;
        let events = (0, _vegaEventSelector.parseSelector)(selCmpt.translate, 'scope');
        if (!boundScales) events = events.map((e)=>(e.between[0].markname = name + (0, _interval.BRUSH), e));
        signals.push({
            name: anchor,
            value: {},
            on: [
                {
                    events: events.map((e)=>e.between[0]),
                    update: '{x: x(unit), y: y(unit)' + (x !== undefined ? `, extent_x: ${boundScales ? (0, _scales.domain)(model, (0, _channel.X)) : `slice(${x.signals.visual})`}` : '') + (y !== undefined ? `, extent_y: ${boundScales ? (0, _scales.domain)(model, (0, _channel.Y)) : `slice(${y.signals.visual})`}` : '') + '}'
                }
            ]
        }, {
            name: name + DELTA,
            value: {},
            on: [
                {
                    events,
                    update: `{x: ${anchor}.x - x(unit), y: ${anchor}.y - y(unit)}`
                }
            ]
        });
        if (x !== undefined) onDelta(model, selCmpt, x, 'width', signals);
        if (y !== undefined) onDelta(model, selCmpt, y, 'height', signals);
        return signals;
    }
};
exports.default = translate;
function onDelta(model, selCmpt, proj, size, signals) {
    const name = selCmpt.name;
    const anchor = name + ANCHOR;
    const delta = name + DELTA;
    const channel = proj.channel;
    const boundScales = (0, _scalesDefault.default).defined(selCmpt);
    const signal = signals.find((s)=>s.name === proj.signals[boundScales ? 'data' : 'visual']);
    const sizeSg = model.getSizeSignalRef(size).signal;
    const scaleCmpt = model.getScaleComponent(channel);
    const scaleType = scaleCmpt && scaleCmpt.get('type');
    const reversed = scaleCmpt && scaleCmpt.get('reverse'); // scale parsing sets this flag for fieldDef.sort
    const sign = !boundScales ? '' : channel === (0, _channel.X) ? reversed ? '' : '-' : reversed ? '-' : '';
    const extent = `${anchor}.extent_${channel}`;
    const offset = `${sign}${delta}.${channel} / ${boundScales ? `${sizeSg}` : `span(${extent})`}`;
    const panFn = !boundScales || !scaleCmpt ? 'panLinear' : scaleType === 'log' ? 'panLog' : scaleType === 'symlog' ? 'panSymlog' : scaleType === 'pow' ? 'panPow' : 'panLinear';
    const arg = !boundScales ? '' : scaleType === 'pow' ? `, ${scaleCmpt.get('exponent') ?? 1}` : scaleType === 'symlog' ? `, ${scaleCmpt.get('constant') ?? 1}` : '';
    const update = `${panFn}(${extent}, ${offset}${arg})`;
    signal.on.push({
        events: {
            signal: delta
        },
        update: boundScales ? update : `clampRange(${update}, 0, ${sizeSg})`
    });
}

},{"vega-event-selector":"ijmxJ","../../channel":"liLED","./interval":"2V19o","./scales":"P3xQI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"efzbs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vegaEventSelector = require("vega-event-selector");
var _vegaUtil = require("vega-util");
var _channel = require("../../channel");
var _interval = require("./interval");
var _scales = require("./scales");
var _scalesDefault = parcelHelpers.interopDefault(_scales);
const ANCHOR = '_zoom_anchor';
const DELTA = '_zoom_delta';
const zoom = {
    defined: (selCmpt)=>{
        return selCmpt.type === 'interval' && selCmpt.zoom;
    },
    signals: (model, selCmpt, signals)=>{
        const name = selCmpt.name;
        const boundScales = (0, _scalesDefault.default).defined(selCmpt);
        const delta = name + DELTA;
        const { x, y } = selCmpt.project.hasChannel;
        const sx = (0, _vegaUtil.stringValue)(model.scaleName((0, _channel.X)));
        const sy = (0, _vegaUtil.stringValue)(model.scaleName((0, _channel.Y)));
        let events = (0, _vegaEventSelector.parseSelector)(selCmpt.zoom, 'scope');
        if (!boundScales) events = events.map((e)=>(e.markname = name + (0, _interval.BRUSH), e));
        signals.push({
            name: name + ANCHOR,
            on: [
                {
                    events,
                    update: !boundScales ? `{x: x(unit), y: y(unit)}` : '{' + [
                        sx ? `x: invert(${sx}, x(unit))` : '',
                        sy ? `y: invert(${sy}, y(unit))` : ''
                    ].filter((expr)=>expr).join(', ') + '}'
                }
            ]
        }, {
            name: delta,
            on: [
                {
                    events,
                    force: true,
                    update: 'pow(1.001, event.deltaY * pow(16, event.deltaMode))'
                }
            ]
        });
        if (x !== undefined) onDelta(model, selCmpt, x, 'width', signals);
        if (y !== undefined) onDelta(model, selCmpt, y, 'height', signals);
        return signals;
    }
};
exports.default = zoom;
function onDelta(model, selCmpt, proj, size, signals) {
    const name = selCmpt.name;
    const channel = proj.channel;
    const boundScales = (0, _scalesDefault.default).defined(selCmpt);
    const signal = signals.find((s)=>s.name === proj.signals[boundScales ? 'data' : 'visual']);
    const sizeSg = model.getSizeSignalRef(size).signal;
    const scaleCmpt = model.getScaleComponent(channel);
    const scaleType = scaleCmpt && scaleCmpt.get('type');
    const base = boundScales ? (0, _scales.domain)(model, channel) : signal.name;
    const delta = name + DELTA;
    const anchor = `${name}${ANCHOR}.${channel}`;
    const zoomFn = !boundScales || !scaleCmpt ? 'zoomLinear' : scaleType === 'log' ? 'zoomLog' : scaleType === 'symlog' ? 'zoomSymlog' : scaleType === 'pow' ? 'zoomPow' : 'zoomLinear';
    const arg = !boundScales ? '' : scaleType === 'pow' ? `, ${scaleCmpt.get('exponent') ?? 1}` : scaleType === 'symlog' ? `, ${scaleCmpt.get('constant') ?? 1}` : '';
    const update = `${zoomFn}(${base}, ${anchor}, ${delta}${arg})`;
    signal.on.push({
        events: {
            signal: delta
        },
        update: boundScales ? update : `clampRange(${update}, 0, ${sizeSg})`
    });
}

},{"vega-event-selector":"ijmxJ","vega-util":"7f6sQ","../../channel":"liLED","./interval":"2V19o","./scales":"P3xQI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8Tzn7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterNode", ()=>FilterNode);
var _util = require("../../util");
var _predicate = require("../predicate");
var _dataflow = require("./dataflow");
var _expressions = require("./expressions");
class FilterNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new FilterNode(null, this.model, (0, _util.duplicate)(this.filter));
    }
    constructor(parent, model, filter){
        super(parent);
        this.model = model;
        this.filter = filter;
        // TODO: refactor this to not take a node and
        // then add a static function makeFromOperand and make the constructor take only an expression
        this.expr = (0, _predicate.expression)(this.model, this.filter, this);
        this._dependentFields = (0, _expressions.getDependentFields)(this.expr);
    }
    dependentFields() {
        return this._dependentFields;
    }
    producedFields() {
        return new Set(); // filter does not produce any new fields
    }
    assemble() {
        return {
            type: 'filter',
            expr: this.expr
        };
    }
    hash() {
        return `Filter ${this.expr}`;
    }
}

},{"../../util":"acUGA","../predicate":"d0sTM","./dataflow":"btJXI","./expressions":"5Wule","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5Wule":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDependentFields", ()=>getDependentFields);
var _vegaExpression = require("vega-expression");
function getName(node) {
    const name = [];
    if (node.type === 'Identifier') return [
        node.name
    ];
    if (node.type === 'Literal') return [
        node.value
    ];
    if (node.type === 'MemberExpression') {
        name.push(...getName(node.object));
        name.push(...getName(node.property));
    }
    return name;
}
function startsWithDatum(node) {
    if (node.object.type === 'MemberExpression') return startsWithDatum(node.object);
    return node.object.name === 'datum';
}
function getDependentFields(expression) {
    const ast = (0, _vegaExpression.parseExpression)(expression);
    const dependents = new Set();
    // visit is missing in types https://github.com/vega/vega/issues/3298
    ast.visit((node)=>{
        if (node.type === 'MemberExpression' && startsWithDatum(node)) dependents.add(getName(node).slice(1).join('.'));
    });
    return dependents;
}

},{"vega-expression":"9NyKJ","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"9NyKJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ASTNode", ()=>ASTNode);
parcelHelpers.export(exports, "ArrayExpression", ()=>ArrayExpression);
parcelHelpers.export(exports, "BinaryExpression", ()=>BinaryExpression);
parcelHelpers.export(exports, "CallExpression", ()=>CallExpression);
parcelHelpers.export(exports, "ConditionalExpression", ()=>ConditionalExpression);
parcelHelpers.export(exports, "Identifier", ()=>Identifier);
parcelHelpers.export(exports, "Literal", ()=>Literal);
parcelHelpers.export(exports, "LogicalExpression", ()=>LogicalExpression);
parcelHelpers.export(exports, "MemberExpression", ()=>MemberExpression);
parcelHelpers.export(exports, "ObjectExpression", ()=>ObjectExpression);
parcelHelpers.export(exports, "Property", ()=>Property);
parcelHelpers.export(exports, "RawCode", ()=>RawCode);
parcelHelpers.export(exports, "UnaryExpression", ()=>UnaryExpression);
parcelHelpers.export(exports, "codegenExpression", ()=>codegen);
parcelHelpers.export(exports, "constants", ()=>Constants);
parcelHelpers.export(exports, "functions", ()=>Functions);
parcelHelpers.export(exports, "parseExpression", ()=>parser);
var _vegaUtil = require("vega-util");
const RawCode = 'RawCode';
const Literal = 'Literal';
const Property = 'Property';
const Identifier = 'Identifier';
const ArrayExpression = 'ArrayExpression';
const BinaryExpression = 'BinaryExpression';
const CallExpression = 'CallExpression';
const ConditionalExpression = 'ConditionalExpression';
const LogicalExpression = 'LogicalExpression';
const MemberExpression = 'MemberExpression';
const ObjectExpression = 'ObjectExpression';
const UnaryExpression = 'UnaryExpression';
function ASTNode(type) {
    this.type = type;
}
ASTNode.prototype.visit = function(visitor) {
    let c, i, n;
    if (visitor(this)) return 1;
    for(c = children(this), i = 0, n = c.length; i < n; ++i){
        if (c[i].visit(visitor)) return 1;
    }
};
function children(node) {
    switch(node.type){
        case ArrayExpression:
            return node.elements;
        case BinaryExpression:
        case LogicalExpression:
            return [
                node.left,
                node.right
            ];
        case CallExpression:
            return [
                node.callee
            ].concat(node.arguments);
        case ConditionalExpression:
            return [
                node.test,
                node.consequent,
                node.alternate
            ];
        case MemberExpression:
            return [
                node.object,
                node.property
            ];
        case ObjectExpression:
            return node.properties;
        case Property:
            return [
                node.key,
                node.value
            ];
        case UnaryExpression:
            return [
                node.argument
            ];
        case Identifier:
        case Literal:
        case RawCode:
        default:
            return [];
    }
}
/*
  The following expression parser is based on Esprima (http://esprima.org/).
  Original header comment and license for Esprima is included here:

  Copyright (C) 2013 Ariya Hidayat <ariya.hidayat@gmail.com>
  Copyright (C) 2013 Thaddee Tyl <thaddee.tyl@gmail.com>
  Copyright (C) 2013 Mathias Bynens <mathias@qiwi.be>
  Copyright (C) 2012 Ariya Hidayat <ariya.hidayat@gmail.com>
  Copyright (C) 2012 Mathias Bynens <mathias@qiwi.be>
  Copyright (C) 2012 Joost-Wim Boekesteijn <joost-wim@boekesteijn.nl>
  Copyright (C) 2012 Kris Kowal <kris.kowal@cixar.com>
  Copyright (C) 2012 Yusuke Suzuki <utatane.tea@gmail.com>
  Copyright (C) 2012 Arpad Borsos <arpad.borsos@googlemail.com>
  Copyright (C) 2011 Ariya Hidayat <ariya.hidayat@gmail.com>

  Redistribution and use in source and binary forms, with or without
  modification, are permitted provided that the following conditions are met:

    * Redistributions of source code must retain the above copyright
      notice, this list of conditions and the following disclaimer.
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the
      documentation and/or other materials provided with the distribution.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
  ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
  DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
  ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
  THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ var TokenName, source, index, length, lookahead;
var TokenBooleanLiteral = 1, TokenEOF = 2, TokenIdentifier = 3, TokenKeyword = 4, TokenNullLiteral = 5, TokenNumericLiteral = 6, TokenPunctuator = 7, TokenStringLiteral = 8, TokenRegularExpression = 9;
TokenName = {};
TokenName[TokenBooleanLiteral] = 'Boolean';
TokenName[TokenEOF] = '<end>';
TokenName[TokenIdentifier] = 'Identifier';
TokenName[TokenKeyword] = 'Keyword';
TokenName[TokenNullLiteral] = 'Null';
TokenName[TokenNumericLiteral] = 'Numeric';
TokenName[TokenPunctuator] = 'Punctuator';
TokenName[TokenStringLiteral] = 'String';
TokenName[TokenRegularExpression] = 'RegularExpression';
var SyntaxArrayExpression = 'ArrayExpression', SyntaxBinaryExpression = 'BinaryExpression', SyntaxCallExpression = 'CallExpression', SyntaxConditionalExpression = 'ConditionalExpression', SyntaxIdentifier = 'Identifier', SyntaxLiteral = 'Literal', SyntaxLogicalExpression = 'LogicalExpression', SyntaxMemberExpression = 'MemberExpression', SyntaxObjectExpression = 'ObjectExpression', SyntaxProperty = 'Property', SyntaxUnaryExpression = 'UnaryExpression';
// Error messages should be identical to V8.
var MessageUnexpectedToken = 'Unexpected token %0', MessageUnexpectedNumber = 'Unexpected number', MessageUnexpectedString = 'Unexpected string', MessageUnexpectedIdentifier = 'Unexpected identifier', MessageUnexpectedReserved = 'Unexpected reserved word', MessageUnexpectedEOS = 'Unexpected end of input', MessageInvalidRegExp = 'Invalid regular expression', MessageUnterminatedRegExp = 'Invalid regular expression: missing /', MessageStrictOctalLiteral = 'Octal literals are not allowed in strict mode.', MessageStrictDuplicateProperty = 'Duplicate data property in object literal not allowed in strict mode';
var ILLEGAL = 'ILLEGAL', DISABLED = 'Disabled.';
// See also tools/generate-unicode-regex.py.
var RegexNonAsciiIdentifierStart = new RegExp('[\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0370-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u037F\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u048A-\\u052F\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0620-\\u064A\\u066E\\u066F\\u0671-\\u06D3\\u06D5\\u06E5\\u06E6\\u06EE\\u06EF\\u06FA-\\u06FC\\u06FF\\u0710\\u0712-\\u072F\\u074D-\\u07A5\\u07B1\\u07CA-\\u07EA\\u07F4\\u07F5\\u07FA\\u0800-\\u0815\\u081A\\u0824\\u0828\\u0840-\\u0858\\u08A0-\\u08B2\\u0904-\\u0939\\u093D\\u0950\\u0958-\\u0961\\u0971-\\u0980\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BD\\u09CE\\u09DC\\u09DD\\u09DF-\\u09E1\\u09F0\\u09F1\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A59-\\u0A5C\\u0A5E\\u0A72-\\u0A74\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABD\\u0AD0\\u0AE0\\u0AE1\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3D\\u0B5C\\u0B5D\\u0B5F-\\u0B61\\u0B71\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BD0\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C39\\u0C3D\\u0C58\\u0C59\\u0C60\\u0C61\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBD\\u0CDE\\u0CE0\\u0CE1\\u0CF1\\u0CF2\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D\\u0D4E\\u0D60\\u0D61\\u0D7A-\\u0D7F\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0E01-\\u0E30\\u0E32\\u0E33\\u0E40-\\u0E46\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB0\\u0EB2\\u0EB3\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EDC-\\u0EDF\\u0F00\\u0F40-\\u0F47\\u0F49-\\u0F6C\\u0F88-\\u0F8C\\u1000-\\u102A\\u103F\\u1050-\\u1055\\u105A-\\u105D\\u1061\\u1065\\u1066\\u106E-\\u1070\\u1075-\\u1081\\u108E\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16EE-\\u16F8\\u1700-\\u170C\\u170E-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176C\\u176E-\\u1770\\u1780-\\u17B3\\u17D7\\u17DC\\u1820-\\u1877\\u1880-\\u18A8\\u18AA\\u18B0-\\u18F5\\u1900-\\u191E\\u1950-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19C1-\\u19C7\\u1A00-\\u1A16\\u1A20-\\u1A54\\u1AA7\\u1B05-\\u1B33\\u1B45-\\u1B4B\\u1B83-\\u1BA0\\u1BAE\\u1BAF\\u1BBA-\\u1BE5\\u1C00-\\u1C23\\u1C4D-\\u1C4F\\u1C5A-\\u1C7D\\u1CE9-\\u1CEC\\u1CEE-\\u1CF1\\u1CF5\\u1CF6\\u1D00-\\u1DBF\\u1E00-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u2071\\u207F\\u2090-\\u209C\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2160-\\u2188\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CEE\\u2CF2\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D80-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2E2F\\u3005-\\u3007\\u3021-\\u3029\\u3031-\\u3035\\u3038-\\u303C\\u3041-\\u3096\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA61F\\uA62A\\uA62B\\uA640-\\uA66E\\uA67F-\\uA69D\\uA6A0-\\uA6EF\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA7AD\\uA7B0\\uA7B1\\uA7F7-\\uA801\\uA803-\\uA805\\uA807-\\uA80A\\uA80C-\\uA822\\uA840-\\uA873\\uA882-\\uA8B3\\uA8F2-\\uA8F7\\uA8FB\\uA90A-\\uA925\\uA930-\\uA946\\uA960-\\uA97C\\uA984-\\uA9B2\\uA9CF\\uA9E0-\\uA9E4\\uA9E6-\\uA9EF\\uA9FA-\\uA9FE\\uAA00-\\uAA28\\uAA40-\\uAA42\\uAA44-\\uAA4B\\uAA60-\\uAA76\\uAA7A\\uAA7E-\\uAAAF\\uAAB1\\uAAB5\\uAAB6\\uAAB9-\\uAABD\\uAAC0\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEA\\uAAF2-\\uAAF4\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uAB30-\\uAB5A\\uAB5C-\\uAB5F\\uAB64\\uAB65\\uABC0-\\uABE2\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D\\uFB1F-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF21-\\uFF3A\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC]'), // eslint-disable-next-line no-misleading-character-class
RegexNonAsciiIdentifierPart = new RegExp('[\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0300-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u037F\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u0483-\\u0487\\u048A-\\u052F\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u0591-\\u05BD\\u05BF\\u05C1\\u05C2\\u05C4\\u05C5\\u05C7\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0610-\\u061A\\u0620-\\u0669\\u066E-\\u06D3\\u06D5-\\u06DC\\u06DF-\\u06E8\\u06EA-\\u06FC\\u06FF\\u0710-\\u074A\\u074D-\\u07B1\\u07C0-\\u07F5\\u07FA\\u0800-\\u082D\\u0840-\\u085B\\u08A0-\\u08B2\\u08E4-\\u0963\\u0966-\\u096F\\u0971-\\u0983\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BC-\\u09C4\\u09C7\\u09C8\\u09CB-\\u09CE\\u09D7\\u09DC\\u09DD\\u09DF-\\u09E3\\u09E6-\\u09F1\\u0A01-\\u0A03\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A3C\\u0A3E-\\u0A42\\u0A47\\u0A48\\u0A4B-\\u0A4D\\u0A51\\u0A59-\\u0A5C\\u0A5E\\u0A66-\\u0A75\\u0A81-\\u0A83\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABC-\\u0AC5\\u0AC7-\\u0AC9\\u0ACB-\\u0ACD\\u0AD0\\u0AE0-\\u0AE3\\u0AE6-\\u0AEF\\u0B01-\\u0B03\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3C-\\u0B44\\u0B47\\u0B48\\u0B4B-\\u0B4D\\u0B56\\u0B57\\u0B5C\\u0B5D\\u0B5F-\\u0B63\\u0B66-\\u0B6F\\u0B71\\u0B82\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BBE-\\u0BC2\\u0BC6-\\u0BC8\\u0BCA-\\u0BCD\\u0BD0\\u0BD7\\u0BE6-\\u0BEF\\u0C00-\\u0C03\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C39\\u0C3D-\\u0C44\\u0C46-\\u0C48\\u0C4A-\\u0C4D\\u0C55\\u0C56\\u0C58\\u0C59\\u0C60-\\u0C63\\u0C66-\\u0C6F\\u0C81-\\u0C83\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBC-\\u0CC4\\u0CC6-\\u0CC8\\u0CCA-\\u0CCD\\u0CD5\\u0CD6\\u0CDE\\u0CE0-\\u0CE3\\u0CE6-\\u0CEF\\u0CF1\\u0CF2\\u0D01-\\u0D03\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D-\\u0D44\\u0D46-\\u0D48\\u0D4A-\\u0D4E\\u0D57\\u0D60-\\u0D63\\u0D66-\\u0D6F\\u0D7A-\\u0D7F\\u0D82\\u0D83\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0DCA\\u0DCF-\\u0DD4\\u0DD6\\u0DD8-\\u0DDF\\u0DE6-\\u0DEF\\u0DF2\\u0DF3\\u0E01-\\u0E3A\\u0E40-\\u0E4E\\u0E50-\\u0E59\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB9\\u0EBB-\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EC8-\\u0ECD\\u0ED0-\\u0ED9\\u0EDC-\\u0EDF\\u0F00\\u0F18\\u0F19\\u0F20-\\u0F29\\u0F35\\u0F37\\u0F39\\u0F3E-\\u0F47\\u0F49-\\u0F6C\\u0F71-\\u0F84\\u0F86-\\u0F97\\u0F99-\\u0FBC\\u0FC6\\u1000-\\u1049\\u1050-\\u109D\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u135D-\\u135F\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16EE-\\u16F8\\u1700-\\u170C\\u170E-\\u1714\\u1720-\\u1734\\u1740-\\u1753\\u1760-\\u176C\\u176E-\\u1770\\u1772\\u1773\\u1780-\\u17D3\\u17D7\\u17DC\\u17DD\\u17E0-\\u17E9\\u180B-\\u180D\\u1810-\\u1819\\u1820-\\u1877\\u1880-\\u18AA\\u18B0-\\u18F5\\u1900-\\u191E\\u1920-\\u192B\\u1930-\\u193B\\u1946-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19B0-\\u19C9\\u19D0-\\u19D9\\u1A00-\\u1A1B\\u1A20-\\u1A5E\\u1A60-\\u1A7C\\u1A7F-\\u1A89\\u1A90-\\u1A99\\u1AA7\\u1AB0-\\u1ABD\\u1B00-\\u1B4B\\u1B50-\\u1B59\\u1B6B-\\u1B73\\u1B80-\\u1BF3\\u1C00-\\u1C37\\u1C40-\\u1C49\\u1C4D-\\u1C7D\\u1CD0-\\u1CD2\\u1CD4-\\u1CF6\\u1CF8\\u1CF9\\u1D00-\\u1DF5\\u1DFC-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u200C\\u200D\\u203F\\u2040\\u2054\\u2071\\u207F\\u2090-\\u209C\\u20D0-\\u20DC\\u20E1\\u20E5-\\u20F0\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2160-\\u2188\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D7F-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2DE0-\\u2DFF\\u2E2F\\u3005-\\u3007\\u3021-\\u302F\\u3031-\\u3035\\u3038-\\u303C\\u3041-\\u3096\\u3099\\u309A\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA62B\\uA640-\\uA66F\\uA674-\\uA67D\\uA67F-\\uA69D\\uA69F-\\uA6F1\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA7AD\\uA7B0\\uA7B1\\uA7F7-\\uA827\\uA840-\\uA873\\uA880-\\uA8C4\\uA8D0-\\uA8D9\\uA8E0-\\uA8F7\\uA8FB\\uA900-\\uA92D\\uA930-\\uA953\\uA960-\\uA97C\\uA980-\\uA9C0\\uA9CF-\\uA9D9\\uA9E0-\\uA9FE\\uAA00-\\uAA36\\uAA40-\\uAA4D\\uAA50-\\uAA59\\uAA60-\\uAA76\\uAA7A-\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEF\\uAAF2-\\uAAF6\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uAB30-\\uAB5A\\uAB5C-\\uAB5F\\uAB64\\uAB65\\uABC0-\\uABEA\\uABEC\\uABED\\uABF0-\\uABF9\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE00-\\uFE0F\\uFE20-\\uFE2D\\uFE33\\uFE34\\uFE4D-\\uFE4F\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF10-\\uFF19\\uFF21-\\uFF3A\\uFF3F\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC]');
// Ensure the condition is true, otherwise throw an error.
// This is only to have a better contract semantic, i.e. another safety net
// to catch a logic error. The condition shall be fulfilled in normal case.
// Do NOT use this to enforce a certain condition on any user input.
function assert(condition, message) {
    /* istanbul ignore next */ if (!condition) throw new Error('ASSERT: ' + message);
}
function isDecimalDigit(ch) {
    return ch >= 0x30 && ch <= 0x39; // 0..9
}
function isHexDigit(ch) {
    return '0123456789abcdefABCDEF'.includes(ch);
}
function isOctalDigit(ch) {
    return '01234567'.includes(ch);
}
// 7.2 White Space
function isWhiteSpace(ch) {
    return ch === 0x20 || ch === 0x09 || ch === 0x0B || ch === 0x0C || ch === 0xA0 || ch >= 0x1680 && [
        0x1680,
        0x180E,
        0x2000,
        0x2001,
        0x2002,
        0x2003,
        0x2004,
        0x2005,
        0x2006,
        0x2007,
        0x2008,
        0x2009,
        0x200A,
        0x202F,
        0x205F,
        0x3000,
        0xFEFF
    ].includes(ch);
}
// 7.3 Line Terminators
function isLineTerminator(ch) {
    return ch === 0x0A || ch === 0x0D || ch === 0x2028 || ch === 0x2029;
}
// 7.6 Identifier Names and Identifiers
function isIdentifierStart(ch) {
    return ch === 0x24 || ch === 0x5F || // $ (dollar) and _ (underscore)
    ch >= 0x41 && ch <= 0x5A || // A..Z
    ch >= 0x61 && ch <= 0x7A || // a..z
    ch === 0x5C || // \ (backslash)
    ch >= 0x80 && RegexNonAsciiIdentifierStart.test(String.fromCharCode(ch));
}
function isIdentifierPart(ch) {
    return ch === 0x24 || ch === 0x5F || // $ (dollar) and _ (underscore)
    ch >= 0x41 && ch <= 0x5A || // A..Z
    ch >= 0x61 && ch <= 0x7A || // a..z
    ch >= 0x30 && ch <= 0x39 || // 0..9
    ch === 0x5C || // \ (backslash)
    ch >= 0x80 && RegexNonAsciiIdentifierPart.test(String.fromCharCode(ch));
}
// 7.6.1.1 Keywords
const keywords = {
    'if': 1,
    'in': 1,
    'do': 1,
    'var': 1,
    'for': 1,
    'new': 1,
    'try': 1,
    'let': 1,
    'this': 1,
    'else': 1,
    'case': 1,
    'void': 1,
    'with': 1,
    'enum': 1,
    'while': 1,
    'break': 1,
    'catch': 1,
    'throw': 1,
    'const': 1,
    'yield': 1,
    'class': 1,
    'super': 1,
    'return': 1,
    'typeof': 1,
    'delete': 1,
    'switch': 1,
    'export': 1,
    'import': 1,
    'public': 1,
    'static': 1,
    'default': 1,
    'finally': 1,
    'extends': 1,
    'package': 1,
    'private': 1,
    'function': 1,
    'continue': 1,
    'debugger': 1,
    'interface': 1,
    'protected': 1,
    'instanceof': 1,
    'implements': 1
};
function skipComment() {
    while(index < length){
        const ch = source.charCodeAt(index);
        if (isWhiteSpace(ch) || isLineTerminator(ch)) ++index;
        else break;
    }
}
function scanHexEscape(prefix) {
    var i, len, ch, code = 0;
    len = prefix === 'u' ? 4 : 2;
    for(i = 0; i < len; ++i)if (index < length && isHexDigit(source[index])) {
        ch = source[index++];
        code = code * 16 + '0123456789abcdef'.indexOf(ch.toLowerCase());
    } else throwError({}, MessageUnexpectedToken, ILLEGAL);
    return String.fromCharCode(code);
}
function scanUnicodeCodePointEscape() {
    var ch, code, cu1, cu2;
    ch = source[index];
    code = 0;
    // At least, one hex digit is required.
    if (ch === '}') throwError({}, MessageUnexpectedToken, ILLEGAL);
    while(index < length){
        ch = source[index++];
        if (!isHexDigit(ch)) break;
        code = code * 16 + '0123456789abcdef'.indexOf(ch.toLowerCase());
    }
    if (code > 0x10FFFF || ch !== '}') throwError({}, MessageUnexpectedToken, ILLEGAL);
    // UTF-16 Encoding
    if (code <= 0xFFFF) return String.fromCharCode(code);
    cu1 = (code - 0x10000 >> 10) + 0xD800;
    cu2 = (code - 0x10000 & 1023) + 0xDC00;
    return String.fromCharCode(cu1, cu2);
}
function getEscapedIdentifier() {
    var ch, id;
    ch = source.charCodeAt(index++);
    id = String.fromCharCode(ch);
    // '\u' (U+005C, U+0075) denotes an escaped character.
    if (ch === 0x5C) {
        if (source.charCodeAt(index) !== 0x75) throwError({}, MessageUnexpectedToken, ILLEGAL);
        ++index;
        ch = scanHexEscape('u');
        if (!ch || ch === '\\' || !isIdentifierStart(ch.charCodeAt(0))) throwError({}, MessageUnexpectedToken, ILLEGAL);
        id = ch;
    }
    while(index < length){
        ch = source.charCodeAt(index);
        if (!isIdentifierPart(ch)) break;
        ++index;
        id += String.fromCharCode(ch);
        // '\u' (U+005C, U+0075) denotes an escaped character.
        if (ch === 0x5C) {
            id = id.substr(0, id.length - 1);
            if (source.charCodeAt(index) !== 0x75) throwError({}, MessageUnexpectedToken, ILLEGAL);
            ++index;
            ch = scanHexEscape('u');
            if (!ch || ch === '\\' || !isIdentifierPart(ch.charCodeAt(0))) throwError({}, MessageUnexpectedToken, ILLEGAL);
            id += ch;
        }
    }
    return id;
}
function getIdentifier() {
    var start, ch;
    start = index++;
    while(index < length){
        ch = source.charCodeAt(index);
        if (ch === 0x5C) {
            // Blackslash (U+005C) marks Unicode escape sequence.
            index = start;
            return getEscapedIdentifier();
        }
        if (isIdentifierPart(ch)) ++index;
        else break;
    }
    return source.slice(start, index);
}
function scanIdentifier() {
    var start, id, type;
    start = index;
    // Backslash (U+005C) starts an escaped character.
    id = source.charCodeAt(index) === 0x5C ? getEscapedIdentifier() : getIdentifier();
    // There is no keyword or literal with only one character.
    // Thus, it must be an identifier.
    if (id.length === 1) type = TokenIdentifier;
    else if (keywords.hasOwnProperty(id)) // eslint-disable-line no-prototype-builtins
    type = TokenKeyword;
    else if (id === 'null') type = TokenNullLiteral;
    else if (id === 'true' || id === 'false') type = TokenBooleanLiteral;
    else type = TokenIdentifier;
    return {
        type: type,
        value: id,
        start: start,
        end: index
    };
}
// 7.7 Punctuators
function scanPunctuator() {
    var start = index, code = source.charCodeAt(index), code2, ch1 = source[index], ch2, ch3, ch4;
    switch(code){
        // Check for most common single-character punctuators.
        case 0x2E:
        case 0x28:
        case 0x29:
        case 0x3B:
        case 0x2C:
        case 0x7B:
        case 0x7D:
        case 0x5B:
        case 0x5D:
        case 0x3A:
        case 0x3F:
        case 0x7E:
            // ~
            ++index;
            return {
                type: TokenPunctuator,
                value: String.fromCharCode(code),
                start: start,
                end: index
            };
        default:
            code2 = source.charCodeAt(index + 1);
            // '=' (U+003D) marks an assignment or comparison operator.
            if (code2 === 0x3D) switch(code){
                case 0x2B:
                case 0x2D:
                case 0x2F:
                case 0x3C:
                case 0x3E:
                case 0x5E:
                case 0x7C:
                case 0x25:
                case 0x26:
                case 0x2A:
                    // *
                    index += 2;
                    return {
                        type: TokenPunctuator,
                        value: String.fromCharCode(code) + String.fromCharCode(code2),
                        start: start,
                        end: index
                    };
                case 0x21:
                case 0x3D:
                    // =
                    index += 2;
                    // !== and ===
                    if (source.charCodeAt(index) === 0x3D) ++index;
                    return {
                        type: TokenPunctuator,
                        value: source.slice(start, index),
                        start: start,
                        end: index
                    };
            }
    }
    // 4-character punctuator: >>>=
    ch4 = source.substr(index, 4);
    if (ch4 === '>>>=') {
        index += 4;
        return {
            type: TokenPunctuator,
            value: ch4,
            start: start,
            end: index
        };
    }
    // 3-character punctuators: === !== >>> <<= >>=
    ch3 = ch4.substr(0, 3);
    if (ch3 === '>>>' || ch3 === '<<=' || ch3 === '>>=') {
        index += 3;
        return {
            type: TokenPunctuator,
            value: ch3,
            start: start,
            end: index
        };
    }
    // Other 2-character punctuators: ++ -- << >> && ||
    ch2 = ch3.substr(0, 2);
    if (ch1 === ch2[1] && '+-<>&|'.includes(ch1) || ch2 === '=>') {
        index += 2;
        return {
            type: TokenPunctuator,
            value: ch2,
            start: start,
            end: index
        };
    }
    if (ch2 === '//') throwError({}, MessageUnexpectedToken, ILLEGAL);
    // 1-character punctuators: < > = ! + - * % & | ^ /
    if ('<>=!+-*%&|^/'.includes(ch1)) {
        ++index;
        return {
            type: TokenPunctuator,
            value: ch1,
            start: start,
            end: index
        };
    }
    throwError({}, MessageUnexpectedToken, ILLEGAL);
}
// 7.8.3 Numeric Literals
function scanHexLiteral(start) {
    let number = '';
    while(index < length){
        if (!isHexDigit(source[index])) break;
        number += source[index++];
    }
    if (number.length === 0) throwError({}, MessageUnexpectedToken, ILLEGAL);
    if (isIdentifierStart(source.charCodeAt(index))) throwError({}, MessageUnexpectedToken, ILLEGAL);
    return {
        type: TokenNumericLiteral,
        value: parseInt('0x' + number, 16),
        start: start,
        end: index
    };
}
function scanOctalLiteral(start) {
    let number = '0' + source[index++];
    while(index < length){
        if (!isOctalDigit(source[index])) break;
        number += source[index++];
    }
    if (isIdentifierStart(source.charCodeAt(index)) || isDecimalDigit(source.charCodeAt(index))) throwError({}, MessageUnexpectedToken, ILLEGAL);
    return {
        type: TokenNumericLiteral,
        value: parseInt(number, 8),
        octal: true,
        start: start,
        end: index
    };
}
function scanNumericLiteral() {
    var number, start, ch;
    ch = source[index];
    assert(isDecimalDigit(ch.charCodeAt(0)) || ch === '.', 'Numeric literal must start with a decimal digit or a decimal point');
    start = index;
    number = '';
    if (ch !== '.') {
        number = source[index++];
        ch = source[index];
        // Hex number starts with '0x'.
        // Octal number starts with '0'.
        if (number === '0') {
            if (ch === 'x' || ch === 'X') {
                ++index;
                return scanHexLiteral(start);
            }
            if (isOctalDigit(ch)) return scanOctalLiteral(start);
            // decimal number starts with '0' such as '09' is illegal.
            if (ch && isDecimalDigit(ch.charCodeAt(0))) throwError({}, MessageUnexpectedToken, ILLEGAL);
        }
        while(isDecimalDigit(source.charCodeAt(index)))number += source[index++];
        ch = source[index];
    }
    if (ch === '.') {
        number += source[index++];
        while(isDecimalDigit(source.charCodeAt(index)))number += source[index++];
        ch = source[index];
    }
    if (ch === 'e' || ch === 'E') {
        number += source[index++];
        ch = source[index];
        if (ch === '+' || ch === '-') number += source[index++];
        if (isDecimalDigit(source.charCodeAt(index))) while(isDecimalDigit(source.charCodeAt(index)))number += source[index++];
        else throwError({}, MessageUnexpectedToken, ILLEGAL);
    }
    if (isIdentifierStart(source.charCodeAt(index))) throwError({}, MessageUnexpectedToken, ILLEGAL);
    return {
        type: TokenNumericLiteral,
        value: parseFloat(number),
        start: start,
        end: index
    };
}
// 7.8.4 String Literals
function scanStringLiteral() {
    var str = '', quote, start, ch, code, octal = false;
    quote = source[index];
    assert(quote === '\'' || quote === '"', 'String literal must starts with a quote');
    start = index;
    ++index;
    while(index < length){
        ch = source[index++];
        if (ch === quote) {
            quote = '';
            break;
        } else if (ch === '\\') {
            ch = source[index++];
            if (!ch || !isLineTerminator(ch.charCodeAt(0))) switch(ch){
                case 'u':
                case 'x':
                    if (source[index] === '{') {
                        ++index;
                        str += scanUnicodeCodePointEscape();
                    } else str += scanHexEscape(ch);
                    break;
                case 'n':
                    str += '\n';
                    break;
                case 'r':
                    str += '\r';
                    break;
                case 't':
                    str += '\t';
                    break;
                case 'b':
                    str += '\b';
                    break;
                case 'f':
                    str += '\f';
                    break;
                case 'v':
                    str += '\x0B';
                    break;
                default:
                    if (isOctalDigit(ch)) {
                        code = '01234567'.indexOf(ch);
                        // \0 is not octal escape sequence
                        if (code !== 0) octal = true;
                        if (index < length && isOctalDigit(source[index])) {
                            octal = true;
                            code = code * 8 + '01234567'.indexOf(source[index++]);
                            // 3 digits are only allowed when string starts
                            // with 0, 1, 2, 3
                            if ('0123'.includes(ch) && index < length && isOctalDigit(source[index])) code = code * 8 + '01234567'.indexOf(source[index++]);
                        }
                        str += String.fromCharCode(code);
                    } else str += ch;
                    break;
            }
            else if (ch === '\r' && source[index] === '\n') ++index;
        } else if (isLineTerminator(ch.charCodeAt(0))) break;
        else str += ch;
    }
    if (quote !== '') throwError({}, MessageUnexpectedToken, ILLEGAL);
    return {
        type: TokenStringLiteral,
        value: str,
        octal: octal,
        start: start,
        end: index
    };
}
function testRegExp(pattern, flags) {
    let tmp = pattern;
    if (flags.includes('u')) // Replace each astral symbol and every Unicode code point
    // escape sequence with a single ASCII symbol to avoid throwing on
    // regular expressions that are only valid in combination with the
    // `/u` flag.
    // Note: replacing with the ASCII symbol `x` might cause false
    // negatives in unlikely scenarios. For example, `[\u{61}-b]` is a
    // perfectly valid pattern that is equivalent to `[a-b]`, but it
    // would be replaced by `[x-b]` which throws an error.
    tmp = tmp.replace(/\\u\{([0-9a-fA-F]+)\}/g, ($0, $1)=>{
        if (parseInt($1, 16) <= 0x10FFFF) return 'x';
        throwError({}, MessageInvalidRegExp);
    }).replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, 'x');
    // First, detect invalid regular expressions.
    try {
        new RegExp(tmp);
    } catch (e) {
        throwError({}, MessageInvalidRegExp);
    }
    // Return a regular expression object for this pattern-flag pair, or
    // `null` in case the current environment doesn't support the flags it
    // uses.
    try {
        return new RegExp(pattern, flags);
    } catch (exception) {
        return null;
    }
}
function scanRegExpBody() {
    var ch, str, classMarker, terminated, body;
    ch = source[index];
    assert(ch === '/', 'Regular expression literal must start with a slash');
    str = source[index++];
    classMarker = false;
    terminated = false;
    while(index < length){
        ch = source[index++];
        str += ch;
        if (ch === '\\') {
            ch = source[index++];
            // ECMA-262 7.8.5
            if (isLineTerminator(ch.charCodeAt(0))) throwError({}, MessageUnterminatedRegExp);
            str += ch;
        } else if (isLineTerminator(ch.charCodeAt(0))) throwError({}, MessageUnterminatedRegExp);
        else if (classMarker) {
            if (ch === ']') classMarker = false;
        } else {
            if (ch === '/') {
                terminated = true;
                break;
            } else if (ch === '[') classMarker = true;
        }
    }
    if (!terminated) throwError({}, MessageUnterminatedRegExp);
    // Exclude leading and trailing slash.
    body = str.substr(1, str.length - 2);
    return {
        value: body,
        literal: str
    };
}
function scanRegExpFlags() {
    var ch, str, flags;
    str = '';
    flags = '';
    while(index < length){
        ch = source[index];
        if (!isIdentifierPart(ch.charCodeAt(0))) break;
        ++index;
        if (ch === '\\' && index < length) throwError({}, MessageUnexpectedToken, ILLEGAL);
        else {
            flags += ch;
            str += ch;
        }
    }
    if (flags.search(/[^gimuy]/g) >= 0) throwError({}, MessageInvalidRegExp, flags);
    return {
        value: flags,
        literal: str
    };
}
function scanRegExp() {
    var start, body, flags, value;
    lookahead = null;
    skipComment();
    start = index;
    body = scanRegExpBody();
    flags = scanRegExpFlags();
    value = testRegExp(body.value, flags.value);
    return {
        literal: body.literal + flags.literal,
        value: value,
        regex: {
            pattern: body.value,
            flags: flags.value
        },
        start: start,
        end: index
    };
}
function isIdentifierName(token) {
    return token.type === TokenIdentifier || token.type === TokenKeyword || token.type === TokenBooleanLiteral || token.type === TokenNullLiteral;
}
function advance() {
    skipComment();
    if (index >= length) return {
        type: TokenEOF,
        start: index,
        end: index
    };
    const ch = source.charCodeAt(index);
    if (isIdentifierStart(ch)) return scanIdentifier();
    // Very common: ( and ) and ;
    if (ch === 0x28 || ch === 0x29 || ch === 0x3B) return scanPunctuator();
    // String literal starts with single quote (U+0027) or double quote (U+0022).
    if (ch === 0x27 || ch === 0x22) return scanStringLiteral();
    // Dot (.) U+002E can also start a floating-point number, hence the need
    // to check the next character.
    if (ch === 0x2E) {
        if (isDecimalDigit(source.charCodeAt(index + 1))) return scanNumericLiteral();
        return scanPunctuator();
    }
    if (isDecimalDigit(ch)) return scanNumericLiteral();
    return scanPunctuator();
}
function lex() {
    const token = lookahead;
    index = token.end;
    lookahead = advance();
    index = token.end;
    return token;
}
function peek() {
    const pos = index;
    lookahead = advance();
    index = pos;
}
function finishArrayExpression(elements) {
    const node = new ASTNode(SyntaxArrayExpression);
    node.elements = elements;
    return node;
}
function finishBinaryExpression(operator, left, right) {
    const node = new ASTNode(operator === '||' || operator === '&&' ? SyntaxLogicalExpression : SyntaxBinaryExpression);
    node.operator = operator;
    node.left = left;
    node.right = right;
    return node;
}
function finishCallExpression(callee, args) {
    const node = new ASTNode(SyntaxCallExpression);
    node.callee = callee;
    node.arguments = args;
    return node;
}
function finishConditionalExpression(test, consequent, alternate) {
    const node = new ASTNode(SyntaxConditionalExpression);
    node.test = test;
    node.consequent = consequent;
    node.alternate = alternate;
    return node;
}
function finishIdentifier(name) {
    const node = new ASTNode(SyntaxIdentifier);
    node.name = name;
    return node;
}
function finishLiteral(token) {
    const node = new ASTNode(SyntaxLiteral);
    node.value = token.value;
    node.raw = source.slice(token.start, token.end);
    if (token.regex) {
        if (node.raw === '//') node.raw = '/(?:)/';
        node.regex = token.regex;
    }
    return node;
}
function finishMemberExpression(accessor, object, property) {
    const node = new ASTNode(SyntaxMemberExpression);
    node.computed = accessor === '[';
    node.object = object;
    node.property = property;
    if (!node.computed) property.member = true;
    return node;
}
function finishObjectExpression(properties) {
    const node = new ASTNode(SyntaxObjectExpression);
    node.properties = properties;
    return node;
}
function finishProperty(kind, key, value) {
    const node = new ASTNode(SyntaxProperty);
    node.key = key;
    node.value = value;
    node.kind = kind;
    return node;
}
function finishUnaryExpression(operator, argument) {
    const node = new ASTNode(SyntaxUnaryExpression);
    node.operator = operator;
    node.argument = argument;
    node.prefix = true;
    return node;
}
// Throw an exception
function throwError(token, messageFormat) {
    var error, args = Array.prototype.slice.call(arguments, 2), msg = messageFormat.replace(/%(\d)/g, (whole, index)=>{
        assert(index < args.length, 'Message reference must be in range');
        return args[index];
    });
    error = new Error(msg);
    error.index = index;
    error.description = msg;
    throw error;
}
// Throw an exception because of the token.
function throwUnexpected(token) {
    if (token.type === TokenEOF) throwError(token, MessageUnexpectedEOS);
    if (token.type === TokenNumericLiteral) throwError(token, MessageUnexpectedNumber);
    if (token.type === TokenStringLiteral) throwError(token, MessageUnexpectedString);
    if (token.type === TokenIdentifier) throwError(token, MessageUnexpectedIdentifier);
    if (token.type === TokenKeyword) throwError(token, MessageUnexpectedReserved);
    // BooleanLiteral, NullLiteral, or Punctuator.
    throwError(token, MessageUnexpectedToken, token.value);
}
// Expect the next token to match the specified punctuator.
// If not, an exception will be thrown.
function expect(value) {
    const token = lex();
    if (token.type !== TokenPunctuator || token.value !== value) throwUnexpected(token);
}
// Return true if the next token matches the specified punctuator.
function match(value) {
    return lookahead.type === TokenPunctuator && lookahead.value === value;
}
// Return true if the next token matches the specified keyword
function matchKeyword(keyword) {
    return lookahead.type === TokenKeyword && lookahead.value === keyword;
}
// 11.1.4 Array Initialiser
function parseArrayInitialiser() {
    const elements = [];
    index = lookahead.start;
    expect('[');
    while(!match(']'))if (match(',')) {
        lex();
        elements.push(null);
    } else {
        elements.push(parseConditionalExpression());
        if (!match(']')) expect(',');
    }
    lex();
    return finishArrayExpression(elements);
}
// 11.1.5 Object Initialiser
function parseObjectPropertyKey() {
    index = lookahead.start;
    const token = lex();
    // Note: This function is called only from parseObjectProperty(), where
    // EOF and Punctuator tokens are already filtered out.
    if (token.type === TokenStringLiteral || token.type === TokenNumericLiteral) {
        if (token.octal) throwError(token, MessageStrictOctalLiteral);
        return finishLiteral(token);
    }
    return finishIdentifier(token.value);
}
function parseObjectProperty() {
    var token, key, id, value;
    index = lookahead.start;
    token = lookahead;
    if (token.type === TokenIdentifier) {
        id = parseObjectPropertyKey();
        expect(':');
        value = parseConditionalExpression();
        return finishProperty('init', id, value);
    }
    if (token.type === TokenEOF || token.type === TokenPunctuator) throwUnexpected(token);
    else {
        key = parseObjectPropertyKey();
        expect(':');
        value = parseConditionalExpression();
        return finishProperty('init', key, value);
    }
}
function parseObjectInitialiser() {
    var properties = [], property, name, key, map = {}, toString = String;
    index = lookahead.start;
    expect('{');
    while(!match('}')){
        property = parseObjectProperty();
        if (property.key.type === SyntaxIdentifier) name = property.key.name;
        else name = toString(property.key.value);
        key = '$' + name;
        if (Object.prototype.hasOwnProperty.call(map, key)) throwError({}, MessageStrictDuplicateProperty);
        else map[key] = true;
        properties.push(property);
        if (!match('}')) expect(',');
    }
    expect('}');
    return finishObjectExpression(properties);
}
// 11.1.6 The Grouping Operator
function parseGroupExpression() {
    expect('(');
    const expr = parseExpression();
    expect(')');
    return expr;
}
// 11.1 Primary Expressions
const legalKeywords = {
    'if': 1
};
function parsePrimaryExpression() {
    var type, token, expr;
    if (match('(')) return parseGroupExpression();
    if (match('[')) return parseArrayInitialiser();
    if (match('{')) return parseObjectInitialiser();
    type = lookahead.type;
    index = lookahead.start;
    if (type === TokenIdentifier || legalKeywords[lookahead.value]) expr = finishIdentifier(lex().value);
    else if (type === TokenStringLiteral || type === TokenNumericLiteral) {
        if (lookahead.octal) throwError(lookahead, MessageStrictOctalLiteral);
        expr = finishLiteral(lex());
    } else if (type === TokenKeyword) throw new Error(DISABLED);
    else if (type === TokenBooleanLiteral) {
        token = lex();
        token.value = token.value === 'true';
        expr = finishLiteral(token);
    } else if (type === TokenNullLiteral) {
        token = lex();
        token.value = null;
        expr = finishLiteral(token);
    } else if (match('/') || match('/=')) {
        expr = finishLiteral(scanRegExp());
        peek();
    } else throwUnexpected(lex());
    return expr;
}
// 11.2 Left-Hand-Side Expressions
function parseArguments() {
    const args = [];
    expect('(');
    if (!match(')')) while(index < length){
        args.push(parseConditionalExpression());
        if (match(')')) break;
        expect(',');
    }
    expect(')');
    return args;
}
function parseNonComputedProperty() {
    index = lookahead.start;
    const token = lex();
    if (!isIdentifierName(token)) throwUnexpected(token);
    return finishIdentifier(token.value);
}
function parseNonComputedMember() {
    expect('.');
    return parseNonComputedProperty();
}
function parseComputedMember() {
    expect('[');
    const expr = parseExpression();
    expect(']');
    return expr;
}
function parseLeftHandSideExpressionAllowCall() {
    var expr, args, property;
    expr = parsePrimaryExpression();
    for(;;){
        if (match('.')) {
            property = parseNonComputedMember();
            expr = finishMemberExpression('.', expr, property);
        } else if (match('(')) {
            args = parseArguments();
            expr = finishCallExpression(expr, args);
        } else if (match('[')) {
            property = parseComputedMember();
            expr = finishMemberExpression('[', expr, property);
        } else break;
    }
    return expr;
}
// 11.3 Postfix Expressions
function parsePostfixExpression() {
    const expr = parseLeftHandSideExpressionAllowCall();
    if (lookahead.type === TokenPunctuator) {
        if (match('++') || match('--')) throw new Error(DISABLED);
    }
    return expr;
}
// 11.4 Unary Operators
function parseUnaryExpression() {
    var token, expr;
    if (lookahead.type !== TokenPunctuator && lookahead.type !== TokenKeyword) expr = parsePostfixExpression();
    else if (match('++') || match('--')) throw new Error(DISABLED);
    else if (match('+') || match('-') || match('~') || match('!')) {
        token = lex();
        expr = parseUnaryExpression();
        expr = finishUnaryExpression(token.value, expr);
    } else if (matchKeyword('delete') || matchKeyword('void') || matchKeyword('typeof')) throw new Error(DISABLED);
    else expr = parsePostfixExpression();
    return expr;
}
function binaryPrecedence(token) {
    let prec = 0;
    if (token.type !== TokenPunctuator && token.type !== TokenKeyword) return 0;
    switch(token.value){
        case '||':
            prec = 1;
            break;
        case '&&':
            prec = 2;
            break;
        case '|':
            prec = 3;
            break;
        case '^':
            prec = 4;
            break;
        case '&':
            prec = 5;
            break;
        case '==':
        case '!=':
        case '===':
        case '!==':
            prec = 6;
            break;
        case '<':
        case '>':
        case '<=':
        case '>=':
        case 'instanceof':
        case 'in':
            prec = 7;
            break;
        case '<<':
        case '>>':
        case '>>>':
            prec = 8;
            break;
        case '+':
        case '-':
            prec = 9;
            break;
        case '*':
        case '/':
        case '%':
            prec = 11;
            break;
    }
    return prec;
}
// 11.5 Multiplicative Operators
// 11.6 Additive Operators
// 11.7 Bitwise Shift Operators
// 11.8 Relational Operators
// 11.9 Equality Operators
// 11.10 Binary Bitwise Operators
// 11.11 Binary Logical Operators
function parseBinaryExpression() {
    var marker, markers, expr, token, prec, stack, right, operator, left, i;
    marker = lookahead;
    left = parseUnaryExpression();
    token = lookahead;
    prec = binaryPrecedence(token);
    if (prec === 0) return left;
    token.prec = prec;
    lex();
    markers = [
        marker,
        lookahead
    ];
    right = parseUnaryExpression();
    stack = [
        left,
        token,
        right
    ];
    while((prec = binaryPrecedence(lookahead)) > 0){
        // Reduce: make a binary expression from the three topmost entries.
        while(stack.length > 2 && prec <= stack[stack.length - 2].prec){
            right = stack.pop();
            operator = stack.pop().value;
            left = stack.pop();
            markers.pop();
            expr = finishBinaryExpression(operator, left, right);
            stack.push(expr);
        }
        // Shift.
        token = lex();
        token.prec = prec;
        stack.push(token);
        markers.push(lookahead);
        expr = parseUnaryExpression();
        stack.push(expr);
    }
    // Final reduce to clean-up the stack.
    i = stack.length - 1;
    expr = stack[i];
    markers.pop();
    while(i > 1){
        markers.pop();
        expr = finishBinaryExpression(stack[i - 1].value, stack[i - 2], expr);
        i -= 2;
    }
    return expr;
}
// 11.12 Conditional Operator
function parseConditionalExpression() {
    var expr, consequent, alternate;
    expr = parseBinaryExpression();
    if (match('?')) {
        lex();
        consequent = parseConditionalExpression();
        expect(':');
        alternate = parseConditionalExpression();
        expr = finishConditionalExpression(expr, consequent, alternate);
    }
    return expr;
}
// 11.14 Comma Operator
function parseExpression() {
    const expr = parseConditionalExpression();
    if (match(',')) throw new Error(DISABLED); // no sequence expressions
    return expr;
}
function parser(code) {
    source = code;
    index = 0;
    length = source.length;
    lookahead = null;
    peek();
    const expr = parseExpression();
    if (lookahead.type !== TokenEOF) throw new Error('Unexpect token after expression.');
    return expr;
}
var Constants = {
    NaN: 'NaN',
    E: 'Math.E',
    LN2: 'Math.LN2',
    LN10: 'Math.LN10',
    LOG2E: 'Math.LOG2E',
    LOG10E: 'Math.LOG10E',
    PI: 'Math.PI',
    SQRT1_2: 'Math.SQRT1_2',
    SQRT2: 'Math.SQRT2',
    MIN_VALUE: 'Number.MIN_VALUE',
    MAX_VALUE: 'Number.MAX_VALUE'
};
function Functions(codegen) {
    function fncall(name, args, cast, type) {
        let obj = codegen(args[0]);
        if (cast) {
            obj = cast + '(' + obj + ')';
            if (cast.lastIndexOf('new ', 0) === 0) obj = '(' + obj + ')';
        }
        return obj + '.' + name + (type < 0 ? '' : type === 0 ? '()' : '(' + args.slice(1).map(codegen).join(',') + ')');
    }
    function fn(name, cast, type) {
        return (args)=>fncall(name, args, cast, type);
    }
    const DATE = 'new Date', STRING = 'String', REGEXP = 'RegExp';
    return {
        // MATH functions
        isNaN: 'Number.isNaN',
        isFinite: 'Number.isFinite',
        abs: 'Math.abs',
        acos: 'Math.acos',
        asin: 'Math.asin',
        atan: 'Math.atan',
        atan2: 'Math.atan2',
        ceil: 'Math.ceil',
        cos: 'Math.cos',
        exp: 'Math.exp',
        floor: 'Math.floor',
        hypot: 'Math.hypot',
        log: 'Math.log',
        max: 'Math.max',
        min: 'Math.min',
        pow: 'Math.pow',
        random: 'Math.random',
        round: 'Math.round',
        sin: 'Math.sin',
        sqrt: 'Math.sqrt',
        tan: 'Math.tan',
        clamp: function(args) {
            if (args.length < 3) (0, _vegaUtil.error)('Missing arguments to clamp function.');
            if (args.length > 3) (0, _vegaUtil.error)('Too many arguments to clamp function.');
            const a = args.map(codegen);
            return 'Math.max(' + a[1] + ', Math.min(' + a[2] + ',' + a[0] + '))';
        },
        // DATE functions
        now: 'Date.now',
        utc: 'Date.UTC',
        datetime: DATE,
        date: fn('getDate', DATE, 0),
        day: fn('getDay', DATE, 0),
        year: fn('getFullYear', DATE, 0),
        month: fn('getMonth', DATE, 0),
        hours: fn('getHours', DATE, 0),
        minutes: fn('getMinutes', DATE, 0),
        seconds: fn('getSeconds', DATE, 0),
        milliseconds: fn('getMilliseconds', DATE, 0),
        time: fn('getTime', DATE, 0),
        timezoneoffset: fn('getTimezoneOffset', DATE, 0),
        utcdate: fn('getUTCDate', DATE, 0),
        utcday: fn('getUTCDay', DATE, 0),
        utcyear: fn('getUTCFullYear', DATE, 0),
        utcmonth: fn('getUTCMonth', DATE, 0),
        utchours: fn('getUTCHours', DATE, 0),
        utcminutes: fn('getUTCMinutes', DATE, 0),
        utcseconds: fn('getUTCSeconds', DATE, 0),
        utcmilliseconds: fn('getUTCMilliseconds', DATE, 0),
        // sequence functions
        length: fn('length', null, -1),
        // STRING functions
        parseFloat: 'parseFloat',
        parseInt: 'parseInt',
        upper: fn('toUpperCase', STRING, 0),
        lower: fn('toLowerCase', STRING, 0),
        substring: fn('substring', STRING),
        split: fn('split', STRING),
        trim: fn('trim', STRING, 0),
        // REGEXP functions
        regexp: REGEXP,
        test: fn('test', REGEXP),
        // Control Flow functions
        if: function(args) {
            if (args.length < 3) (0, _vegaUtil.error)('Missing arguments to if function.');
            if (args.length > 3) (0, _vegaUtil.error)('Too many arguments to if function.');
            const a = args.map(codegen);
            return '(' + a[0] + '?' + a[1] + ':' + a[2] + ')';
        }
    };
}
function stripQuotes(s) {
    const n = s && s.length - 1;
    return n && (s[0] === '"' && s[n] === '"' || s[0] === '\'' && s[n] === '\'') ? s.slice(1, -1) : s;
}
function codegen(opt) {
    opt = opt || {};
    const allowed = opt.allowed ? (0, _vegaUtil.toSet)(opt.allowed) : {}, forbidden = opt.forbidden ? (0, _vegaUtil.toSet)(opt.forbidden) : {}, constants = opt.constants || Constants, functions = (opt.functions || Functions)(visit), globalvar = opt.globalvar, fieldvar = opt.fieldvar, outputGlobal = (0, _vegaUtil.isFunction)(globalvar) ? globalvar : (id)=>`${globalvar}["${id}"]`;
    let globals = {}, fields = {}, memberDepth = 0;
    function visit(ast) {
        if ((0, _vegaUtil.isString)(ast)) return ast;
        const generator = Generators[ast.type];
        if (generator == null) (0, _vegaUtil.error)('Unsupported type: ' + ast.type);
        return generator(ast);
    }
    const Generators = {
        Literal: (n)=>n.raw,
        Identifier: (n)=>{
            const id = n.name;
            if (memberDepth > 0) return id;
            else if ((0, _vegaUtil.hasOwnProperty)(forbidden, id)) return (0, _vegaUtil.error)('Illegal identifier: ' + id);
            else if ((0, _vegaUtil.hasOwnProperty)(constants, id)) return constants[id];
            else if ((0, _vegaUtil.hasOwnProperty)(allowed, id)) return id;
            else {
                globals[id] = 1;
                return outputGlobal(id);
            }
        },
        MemberExpression: (n)=>{
            const d = !n.computed, o = visit(n.object);
            if (d) memberDepth += 1;
            const p = visit(n.property);
            if (o === fieldvar) // strip quotes to sanitize field name (#1653)
            fields[stripQuotes(p)] = 1;
            if (d) memberDepth -= 1;
            return o + (d ? '.' + p : '[' + p + ']');
        },
        CallExpression: (n)=>{
            if (n.callee.type !== 'Identifier') (0, _vegaUtil.error)('Illegal callee type: ' + n.callee.type);
            const callee = n.callee.name, args = n.arguments, fn = (0, _vegaUtil.hasOwnProperty)(functions, callee) && functions[callee];
            if (!fn) (0, _vegaUtil.error)('Unrecognized function: ' + callee);
            return (0, _vegaUtil.isFunction)(fn) ? fn(args) : fn + '(' + args.map(visit).join(',') + ')';
        },
        ArrayExpression: (n)=>'[' + n.elements.map(visit).join(',') + ']',
        BinaryExpression: (n)=>'(' + visit(n.left) + ' ' + n.operator + ' ' + visit(n.right) + ')',
        UnaryExpression: (n)=>'(' + n.operator + visit(n.argument) + ')',
        ConditionalExpression: (n)=>'(' + visit(n.test) + '?' + visit(n.consequent) + ':' + visit(n.alternate) + ')',
        LogicalExpression: (n)=>'(' + visit(n.left) + n.operator + visit(n.right) + ')',
        ObjectExpression: (n)=>'{' + n.properties.map(visit).join(',') + '}',
        Property: (n)=>{
            memberDepth += 1;
            const k = visit(n.key);
            memberDepth -= 1;
            return k + ':' + visit(n.value);
        }
    };
    function codegen(ast) {
        const result = {
            code: visit(ast),
            globals: Object.keys(globals),
            fields: Object.keys(fields)
        };
        globals = {};
        fields = {};
        return result;
    }
    codegen.functions = functions;
    codegen.constants = constants;
    return codegen;
}

},{"vega-util":"7f6sQ","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"kmU8z":[function(require,module,exports,__globalThis) {
/**
 * Utility for generating row / column headers
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// TODO: rename to assembleHeaderTitleGroup
parcelHelpers.export(exports, "assembleTitleGroup", ()=>assembleTitleGroup);
parcelHelpers.export(exports, "defaultHeaderGuideAlign", ()=>defaultHeaderGuideAlign);
parcelHelpers.export(exports, "defaultHeaderGuideBaseline", ()=>defaultHeaderGuideBaseline);
parcelHelpers.export(exports, "assembleHeaderGroups", ()=>assembleHeaderGroups);
parcelHelpers.export(exports, "assembleLabelTitle", ()=>assembleLabelTitle);
parcelHelpers.export(exports, "assembleHeaderGroup", ()=>assembleHeaderGroup);
parcelHelpers.export(exports, "getLayoutTitleBand", ()=>getLayoutTitleBand);
parcelHelpers.export(exports, "assembleLayoutTitleBand", ()=>assembleLayoutTitleBand);
parcelHelpers.export(exports, "assembleHeaderProperties", ()=>assembleHeaderProperties);
var _vegaUtil = require("vega-util");
var _channel = require("../../channel");
var _channeldef = require("../../channeldef");
var _header = require("../../header");
var _sort = require("../../sort");
var _facet = require("../../spec/facet");
var _util = require("../../util");
var _properties = require("../axis/properties");
var _calculate = require("../data/calculate");
var _format = require("../format");
var _model = require("../model");
var _common = require("./common");
var _component = require("./component");
function assembleTitleGroup(model, channel) {
    const title = model.component.layoutHeaders[channel].title;
    const config = model.config ? model.config : undefined;
    const facetFieldDef = model.component.layoutHeaders[channel].facetFieldDef ? model.component.layoutHeaders[channel].facetFieldDef : undefined;
    const { titleAnchor, titleAngle: ta, titleOrient } = (0, _common.getHeaderProperties)([
        'titleAnchor',
        'titleAngle',
        'titleOrient'
    ], facetFieldDef.header, config, channel);
    const headerChannel = (0, _common.getHeaderChannel)(channel, titleOrient);
    const titleAngle = (0, _util.normalizeAngle)(ta);
    return {
        name: `${channel}-title`,
        type: 'group',
        role: `${headerChannel}-title`,
        title: {
            text: title,
            ...channel === 'row' ? {
                orient: 'left'
            } : {},
            style: 'guide-title',
            ...defaultHeaderGuideBaseline(titleAngle, headerChannel),
            ...defaultHeaderGuideAlign(headerChannel, titleAngle, titleAnchor),
            ...assembleHeaderProperties(config, facetFieldDef, channel, (0, _header.HEADER_TITLE_PROPERTIES), (0, _header.HEADER_TITLE_PROPERTIES_MAP))
        }
    };
}
function defaultHeaderGuideAlign(headerChannel, angle, anchor = 'middle') {
    switch(anchor){
        case 'start':
            return {
                align: 'left'
            };
        case 'end':
            return {
                align: 'right'
            };
    }
    const align = (0, _properties.defaultLabelAlign)(angle, headerChannel === 'row' ? 'left' : 'top', headerChannel === 'row' ? 'y' : 'x');
    return align ? {
        align
    } : {};
}
function defaultHeaderGuideBaseline(angle, channel) {
    const baseline = (0, _properties.defaultLabelBaseline)(angle, channel === 'row' ? 'left' : 'top', channel === 'row' ? 'y' : 'x', true);
    return baseline ? {
        baseline
    } : {};
}
function assembleHeaderGroups(model, channel) {
    const layoutHeader = model.component.layoutHeaders[channel];
    const groups = [];
    for (const headerType of (0, _component.HEADER_TYPES)){
        if (layoutHeader[headerType]) for (const headerComponent of layoutHeader[headerType]){
            const group = assembleHeaderGroup(model, channel, headerType, layoutHeader, headerComponent);
            if (group != null) groups.push(group);
        }
    }
    return groups;
}
function getSort(facetFieldDef, channel) {
    const { sort } = facetFieldDef;
    if ((0, _sort.isSortField)(sort)) return {
        field: (0, _channeldef.vgField)(sort, {
            expr: 'datum'
        }),
        order: sort.order ?? 'ascending'
    };
    else if ((0, _vegaUtil.isArray)(sort)) return {
        field: (0, _calculate.sortArrayIndexField)(facetFieldDef, channel, {
            expr: 'datum'
        }),
        order: 'ascending'
    };
    else return {
        field: (0, _channeldef.vgField)(facetFieldDef, {
            expr: 'datum'
        }),
        order: sort ?? 'ascending'
    };
}
function assembleLabelTitle(facetFieldDef, channel, config) {
    const { format, formatType, labelAngle, labelAnchor, labelOrient, labelExpr } = (0, _common.getHeaderProperties)([
        'format',
        'formatType',
        'labelAngle',
        'labelAnchor',
        'labelOrient',
        'labelExpr'
    ], facetFieldDef.header, config, channel);
    const titleTextExpr = (0, _format.formatSignalRef)({
        fieldOrDatumDef: facetFieldDef,
        format,
        formatType,
        expr: 'parent',
        config
    }).signal;
    const headerChannel = (0, _common.getHeaderChannel)(channel, labelOrient);
    return {
        text: {
            signal: labelExpr ? (0, _util.replaceAll)((0, _util.replaceAll)(labelExpr, 'datum.label', titleTextExpr), 'datum.value', (0, _channeldef.vgField)(facetFieldDef, {
                expr: 'parent'
            })) : titleTextExpr
        },
        ...channel === 'row' ? {
            orient: 'left'
        } : {},
        style: 'guide-label',
        frame: 'group',
        ...defaultHeaderGuideBaseline(labelAngle, headerChannel),
        ...defaultHeaderGuideAlign(headerChannel, labelAngle, labelAnchor),
        ...assembleHeaderProperties(config, facetFieldDef, channel, (0, _header.HEADER_LABEL_PROPERTIES), (0, _header.HEADER_LABEL_PROPERTIES_MAP))
    };
}
function assembleHeaderGroup(model, channel, headerType, layoutHeader, headerComponent) {
    if (headerComponent) {
        let title = null;
        const { facetFieldDef } = layoutHeader;
        const config = model.config ? model.config : undefined;
        if (facetFieldDef && headerComponent.labels) {
            const { labelOrient } = (0, _common.getHeaderProperties)([
                'labelOrient'
            ], facetFieldDef.header, config, channel);
            // Include label title in the header if orient aligns with the channel
            if (channel === 'row' && !(0, _util.contains)([
                'top',
                'bottom'
            ], labelOrient) || channel === 'column' && !(0, _util.contains)([
                'left',
                'right'
            ], labelOrient)) title = assembleLabelTitle(facetFieldDef, channel, config);
        }
        const isFacetWithoutRowCol = (0, _model.isFacetModel)(model) && !(0, _facet.isFacetMapping)(model.facet);
        const axes = headerComponent.axes;
        const hasAxes = axes?.length > 0;
        if (title || hasAxes) {
            const sizeChannel = channel === 'row' ? 'height' : 'width';
            return {
                name: model.getName(`${channel}_${headerType}`),
                type: 'group',
                role: `${channel}-${headerType}`,
                ...layoutHeader.facetFieldDef ? {
                    from: {
                        data: model.getName(`${channel}_domain`)
                    },
                    sort: getSort(facetFieldDef, channel)
                } : {},
                ...hasAxes && isFacetWithoutRowCol ? {
                    from: {
                        data: model.getName(`facet_domain_${channel}`)
                    }
                } : {},
                ...title ? {
                    title
                } : {},
                ...headerComponent.sizeSignal ? {
                    encode: {
                        update: {
                            [sizeChannel]: headerComponent.sizeSignal
                        }
                    }
                } : {},
                ...hasAxes ? {
                    axes
                } : {}
            };
        }
    }
    return null;
}
const LAYOUT_TITLE_BAND = {
    column: {
        start: 0,
        end: 1
    },
    row: {
        start: 1,
        end: 0
    }
};
function getLayoutTitleBand(titleAnchor, headerChannel) {
    return LAYOUT_TITLE_BAND[headerChannel][titleAnchor];
}
function assembleLayoutTitleBand(headerComponentIndex, config) {
    const titleBand = {};
    for (const channel of (0, _channel.FACET_CHANNELS)){
        const headerComponent = headerComponentIndex[channel];
        if (headerComponent?.facetFieldDef) {
            const { titleAnchor, titleOrient } = (0, _common.getHeaderProperties)([
                'titleAnchor',
                'titleOrient'
            ], headerComponent.facetFieldDef.header, config, channel);
            const headerChannel = (0, _common.getHeaderChannel)(channel, titleOrient);
            const band = getLayoutTitleBand(titleAnchor, headerChannel);
            if (band !== undefined) titleBand[headerChannel] = band;
        }
    }
    return (0, _util.isEmpty)(titleBand) ? undefined : titleBand;
}
function assembleHeaderProperties(config, facetFieldDef, channel, properties, propertiesMap) {
    const props = {};
    for (const prop of properties){
        if (!propertiesMap[prop]) continue;
        const value = (0, _common.getHeaderProperty)(prop, facetFieldDef?.header, config, channel);
        if (value !== undefined) props[propertiesMap[prop]] = value;
    }
    return props;
}

},{"vega-util":"7f6sQ","../../channel":"liLED","../../channeldef":"dsccb","../../header":"17rRI","../../sort":"aWnXd","../../spec/facet":"3pm05","../../util":"acUGA","../axis/properties":"dkAYu","../data/calculate":"aCN2T","../format":"79ccI","../model":"hQHib","./common":"aM8kl","./component":"d5ljn","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dkAYu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "axisRules", ()=>axisRules);
// TODO: we need to refactor this method after we take care of config refactoring
/**
 * Default rules for whether to show a grid should be shown for a channel.
 * If `grid` is unspecified, the default value is `true` for ordinal scales that are not binned
 */ parcelHelpers.export(exports, "defaultGrid", ()=>defaultGrid);
parcelHelpers.export(exports, "gridScale", ()=>gridScale);
parcelHelpers.export(exports, "getLabelAngle", ()=>getLabelAngle);
parcelHelpers.export(exports, "normalizeAngleExpr", ()=>normalizeAngleExpr);
parcelHelpers.export(exports, "defaultLabelBaseline", ()=>defaultLabelBaseline);
parcelHelpers.export(exports, "defaultLabelAlign", ()=>defaultLabelAlign);
parcelHelpers.export(exports, "defaultLabelFlush", ()=>defaultLabelFlush);
parcelHelpers.export(exports, "defaultLabelOverlap", ()=>defaultLabelOverlap);
parcelHelpers.export(exports, "defaultOrient", ()=>defaultOrient);
parcelHelpers.export(exports, "defaultTickCount", ()=>defaultTickCount);
parcelHelpers.export(exports, "defaultTickMinStep", ()=>defaultTickMinStep);
parcelHelpers.export(exports, "getFieldDefTitle", ()=>getFieldDefTitle);
parcelHelpers.export(exports, "values", ()=>values);
parcelHelpers.export(exports, "defaultZindex", ()=>defaultZindex);
var _vegaUtil = require("vega-util");
var _bin = require("../../bin");
var _channel = require("../../channel");
var _channeldef = require("../../channeldef");
var _scale = require("../../scale");
var _timeunit = require("../../timeunit");
var _type = require("../../type");
var _util = require("../../util");
var _vegaSchema = require("../../vega.schema");
var _common = require("../common");
var _config = require("./config");
const axisRules = {
    scale: ({ model, channel })=>model.scaleName(channel),
    format: ({ format })=>format,
    formatType: ({ formatType })=>formatType,
    grid: ({ fieldOrDatumDef, axis, scaleType })=>axis.grid ?? defaultGrid(scaleType, fieldOrDatumDef),
    gridScale: ({ model, channel })=>gridScale(model, channel),
    labelAlign: ({ axis, labelAngle, orient, channel })=>axis.labelAlign || defaultLabelAlign(labelAngle, orient, channel),
    labelAngle: ({ labelAngle })=>labelAngle,
    labelBaseline: ({ axis, labelAngle, orient, channel })=>axis.labelBaseline || defaultLabelBaseline(labelAngle, orient, channel),
    labelFlush: ({ axis, fieldOrDatumDef, channel })=>axis.labelFlush ?? defaultLabelFlush(fieldOrDatumDef.type, channel),
    labelOverlap: ({ axis, fieldOrDatumDef, scaleType })=>axis.labelOverlap ?? defaultLabelOverlap(fieldOrDatumDef.type, scaleType, (0, _channeldef.isFieldDef)(fieldOrDatumDef) && !!fieldOrDatumDef.timeUnit, (0, _channeldef.isFieldDef)(fieldOrDatumDef) ? fieldOrDatumDef.sort : undefined),
    // we already calculate orient in parse
    orient: ({ orient })=>orient,
    tickCount: ({ channel, model, axis, fieldOrDatumDef, scaleType })=>{
        const sizeType = channel === 'x' ? 'width' : channel === 'y' ? 'height' : undefined;
        const size = sizeType ? model.getSizeSignalRef(sizeType) : undefined;
        return axis.tickCount ?? defaultTickCount({
            fieldOrDatumDef,
            scaleType,
            size,
            values: axis.values
        });
    },
    tickMinStep: defaultTickMinStep,
    title: ({ axis, model, channel })=>{
        if (axis.title !== undefined) return axis.title;
        const fieldDefTitle = getFieldDefTitle(model, channel);
        if (fieldDefTitle !== undefined) return fieldDefTitle;
        const fieldDef = model.typedFieldDef(channel);
        const channel2 = channel === 'x' ? 'x2' : 'y2';
        const fieldDef2 = model.fieldDef(channel2);
        // If title not specified, store base parts of fieldDef (and fieldDef2 if exists)
        return (0, _common.mergeTitleFieldDefs)(fieldDef ? [
            (0, _channeldef.toFieldDefBase)(fieldDef)
        ] : [], (0, _channeldef.isFieldDef)(fieldDef2) ? [
            (0, _channeldef.toFieldDefBase)(fieldDef2)
        ] : []);
    },
    values: ({ axis, fieldOrDatumDef })=>values(axis, fieldOrDatumDef),
    zindex: ({ axis, fieldOrDatumDef, mark })=>axis.zindex ?? defaultZindex(mark, fieldOrDatumDef)
};
function defaultGrid(scaleType, fieldDef) {
    return !(0, _scale.hasDiscreteDomain)(scaleType) && (0, _channeldef.isFieldDef)(fieldDef) && !(0, _bin.isBinning)(fieldDef?.bin) && !(0, _bin.isBinned)(fieldDef?.bin);
}
function gridScale(model, channel) {
    const gridChannel = channel === 'x' ? 'y' : 'x';
    if (model.getScaleComponent(gridChannel)) return model.scaleName(gridChannel);
    return undefined;
}
function getLabelAngle(fieldOrDatumDef, axis, channel, styleConfig, axisConfigs) {
    const labelAngle = axis?.labelAngle;
    // try axis value
    if (labelAngle !== undefined) return (0, _vegaSchema.isSignalRef)(labelAngle) ? labelAngle : (0, _util.normalizeAngle)(labelAngle);
    else {
        // try axis config value
        const { configValue: angle } = (0, _config.getAxisConfig)('labelAngle', styleConfig, axis?.style, axisConfigs);
        if (angle !== undefined) return (0, _util.normalizeAngle)(angle);
        else {
            // get default value
            if (channel === (0, _channel.X) && (0, _util.contains)([
                (0, _type.NOMINAL),
                (0, _type.ORDINAL)
            ], fieldOrDatumDef.type) && !((0, _channeldef.isFieldDef)(fieldOrDatumDef) && fieldOrDatumDef.timeUnit)) return 270;
            // no default
            return undefined;
        }
    }
}
function normalizeAngleExpr(angle) {
    return `(((${angle.signal} % 360) + 360) % 360)`;
}
function defaultLabelBaseline(angle, orient, channel, alwaysIncludeMiddle) {
    if (angle !== undefined) {
        if (channel === 'x') {
            if ((0, _vegaSchema.isSignalRef)(angle)) {
                const a = normalizeAngleExpr(angle);
                const orientIsTop = (0, _vegaSchema.isSignalRef)(orient) ? `(${orient.signal} === "top")` : orient === 'top';
                return {
                    signal: `(45 < ${a} && ${a} < 135) || (225 < ${a} && ${a} < 315) ? "middle" :` + `(${a} <= 45 || 315 <= ${a}) === ${orientIsTop} ? "bottom" : "top"`
                };
            }
            if (45 < angle && angle < 135 || 225 < angle && angle < 315) return 'middle';
            if ((0, _vegaSchema.isSignalRef)(orient)) {
                const op = angle <= 45 || 315 <= angle ? '===' : '!==';
                return {
                    signal: `${orient.signal} ${op} "top" ? "bottom" : "top"`
                };
            }
            return (angle <= 45 || 315 <= angle) === (orient === 'top') ? 'bottom' : 'top';
        } else {
            if ((0, _vegaSchema.isSignalRef)(angle)) {
                const a = normalizeAngleExpr(angle);
                const orientIsLeft = (0, _vegaSchema.isSignalRef)(orient) ? `(${orient.signal} === "left")` : orient === 'left';
                const middle = alwaysIncludeMiddle ? '"middle"' : 'null';
                return {
                    signal: `${a} <= 45 || 315 <= ${a} || (135 <= ${a} && ${a} <= 225) ? ${middle} : (45 <= ${a} && ${a} <= 135) === ${orientIsLeft} ? "top" : "bottom"`
                };
            }
            if (angle <= 45 || 315 <= angle || 135 <= angle && angle <= 225) return alwaysIncludeMiddle ? 'middle' : null;
            if ((0, _vegaSchema.isSignalRef)(orient)) {
                const op = 45 <= angle && angle <= 135 ? '===' : '!==';
                return {
                    signal: `${orient.signal} ${op} "left" ? "top" : "bottom"`
                };
            }
            return (45 <= angle && angle <= 135) === (orient === 'left') ? 'top' : 'bottom';
        }
    }
    return undefined;
}
function defaultLabelAlign(angle, orient, channel) {
    if (angle === undefined) return undefined;
    const isX = channel === 'x';
    const startAngle = isX ? 0 : 90;
    const mainOrient = isX ? 'bottom' : 'left';
    if ((0, _vegaSchema.isSignalRef)(angle)) {
        const a = normalizeAngleExpr(angle);
        const orientIsMain = (0, _vegaSchema.isSignalRef)(orient) ? `(${orient.signal} === "${mainOrient}")` : orient === mainOrient;
        return {
            signal: `(${startAngle ? `(${a} + 90)` : a} % 180 === 0) ? ${isX ? null : '"center"'} :` + `(${startAngle} < ${a} && ${a} < ${180 + startAngle}) === ${orientIsMain} ? "left" : "right"`
        };
    }
    if ((angle + startAngle) % 180 === 0) // For bottom, use default label align so label flush still works
    return isX ? null : 'center';
    if ((0, _vegaSchema.isSignalRef)(orient)) {
        const op = startAngle < angle && angle < 180 + startAngle ? '===' : '!==';
        const orientIsMain = `${orient.signal} ${op} "${mainOrient}"`;
        return {
            signal: `${orientIsMain} ? "left" : "right"`
        };
    }
    if ((startAngle < angle && angle < 180 + startAngle) === (orient === mainOrient)) return 'left';
    return 'right';
}
function defaultLabelFlush(type, channel) {
    if (channel === 'x' && (0, _util.contains)([
        'quantitative',
        'temporal'
    ], type)) return true;
    return undefined;
}
function defaultLabelOverlap(type, scaleType, hasTimeUnit, sort) {
    // do not prevent overlap for nominal data because there is no way to infer what the missing labels are
    if (hasTimeUnit && !(0, _vegaUtil.isObject)(sort) || type !== 'nominal' && type !== 'ordinal') {
        if (scaleType === 'log' || scaleType === 'symlog') return 'greedy';
        return true;
    }
    return undefined;
}
function defaultOrient(channel) {
    return channel === 'x' ? 'bottom' : 'left';
}
function defaultTickCount({ fieldOrDatumDef, scaleType, size, values: vals }) {
    if (!vals && !(0, _scale.hasDiscreteDomain)(scaleType) && scaleType !== 'log') {
        if ((0, _channeldef.isFieldDef)(fieldOrDatumDef)) {
            if ((0, _bin.isBinning)(fieldOrDatumDef.bin)) // for binned data, we don't want more ticks than maxbins
            return {
                signal: `ceil(${size.signal}/10)`
            };
            if (fieldOrDatumDef.timeUnit && (0, _util.contains)([
                'month',
                'hours',
                'day',
                'quarter'
            ], (0, _timeunit.normalizeTimeUnit)(fieldOrDatumDef.timeUnit)?.unit)) return undefined;
        }
        return {
            signal: `ceil(${size.signal}/40)`
        };
    }
    return undefined;
}
function defaultTickMinStep({ format, fieldOrDatumDef }) {
    if (format === 'd') return 1;
    if ((0, _channeldef.isFieldDef)(fieldOrDatumDef)) {
        const { timeUnit } = fieldOrDatumDef;
        if (timeUnit) {
            const signal = (0, _timeunit.durationExpr)(timeUnit);
            if (signal) return {
                signal
            };
        }
    }
    return undefined;
}
function getFieldDefTitle(model, channel) {
    const channel2 = channel === 'x' ? 'x2' : 'y2';
    const fieldDef = model.fieldDef(channel);
    const fieldDef2 = model.fieldDef(channel2);
    const title1 = fieldDef ? fieldDef.title : undefined;
    const title2 = fieldDef2 ? fieldDef2.title : undefined;
    if (title1 && title2) return (0, _common.mergeTitle)(title1, title2);
    else if (title1) return title1;
    else if (title2) return title2;
    else if (title1 !== undefined) // falsy value to disable config
    return title1;
    else if (title2 !== undefined) // falsy value to disable config
    return title2;
    return undefined;
}
function values(axis, fieldOrDatumDef) {
    const vals = axis.values;
    if ((0, _vegaUtil.isArray)(vals)) return (0, _channeldef.valueArray)(fieldOrDatumDef, vals);
    else if ((0, _vegaSchema.isSignalRef)(vals)) return vals;
    return undefined;
}
function defaultZindex(mark, fieldDef) {
    if (mark === 'rect' && (0, _channeldef.isDiscrete)(fieldDef)) return 1;
    return 0;
}

},{"vega-util":"7f6sQ","../../bin":"3cpW8","../../channel":"liLED","../../channeldef":"dsccb","../../scale":"bdpXN","../../timeunit":"eky0T","../../type":"cbWGP","../../util":"acUGA","../../vega.schema":"3mBOT","../common":"jegt8","./config":"34G7k","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"34G7k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAxisConfigs", ()=>getAxisConfigs);
parcelHelpers.export(exports, "getAxisConfigStyle", ()=>getAxisConfigStyle);
parcelHelpers.export(exports, "getAxisConfig", ()=>getAxisConfig);
var _vegaUtil = require("vega-util");
var _scale = require("../../scale");
var _util = require("../../util");
var _vegaSchema = require("../../vega.schema");
var _common = require("../common");
function getAxisConfigFromConfigTypes(configTypes, config, channel, orient) {
    // TODO: add special casing to add conditional value based on orient signal
    return Object.assign.apply(null, [
        {},
        ...configTypes.map((configType)=>{
            if (configType === 'axisOrient') {
                const orient1 = channel === 'x' ? 'bottom' : 'left';
                const orientConfig1 = config[channel === 'x' ? 'axisBottom' : 'axisLeft'] || {};
                const orientConfig2 = config[channel === 'x' ? 'axisTop' : 'axisRight'] || {};
                const props = new Set([
                    ...(0, _util.keys)(orientConfig1),
                    ...(0, _util.keys)(orientConfig2)
                ]);
                const conditionalOrientAxisConfig = {};
                for (const prop of props.values())conditionalOrientAxisConfig[prop] = {
                    // orient is surely signal in this case
                    signal: `${orient['signal']} === "${orient1}" ? ${(0, _common.signalOrStringValue)(orientConfig1[prop])} : ${(0, _common.signalOrStringValue)(orientConfig2[prop])}`
                };
                return conditionalOrientAxisConfig;
            }
            return config[configType];
        })
    ]);
}
function getAxisConfigs(channel, scaleType, orient, config) {
    const typeBasedConfigTypes = scaleType === 'band' ? [
        'axisDiscrete',
        'axisBand'
    ] : scaleType === 'point' ? [
        'axisDiscrete',
        'axisPoint'
    ] : (0, _scale.isQuantitative)(scaleType) ? [
        'axisQuantitative'
    ] : scaleType === 'time' || scaleType === 'utc' ? [
        'axisTemporal'
    ] : [];
    const axisChannel = channel === 'x' ? 'axisX' : 'axisY';
    const axisOrient = (0, _vegaSchema.isSignalRef)(orient) ? 'axisOrient' : `axis${(0, _util.titleCase)(orient)}`; // axisTop, axisBottom, ...
    const vlOnlyConfigTypes = [
        // technically Vega does have axisBand, but if we make another separation here,
        // it will further introduce complexity in the code
        ...typeBasedConfigTypes,
        ...typeBasedConfigTypes.map((c)=>axisChannel + c.substr(4))
    ];
    const vgConfigTypes = [
        'axis',
        axisOrient,
        axisChannel
    ];
    return {
        vlOnlyAxisConfig: getAxisConfigFromConfigTypes(vlOnlyConfigTypes, config, channel, orient),
        vgAxisConfig: getAxisConfigFromConfigTypes(vgConfigTypes, config, channel, orient),
        axisConfigStyle: getAxisConfigStyle([
            ...vgConfigTypes,
            ...vlOnlyConfigTypes
        ], config)
    };
}
function getAxisConfigStyle(axisConfigTypes, config) {
    const toMerge = [
        {}
    ];
    for (const configType of axisConfigTypes){
        // TODO: add special casing to add conditional value based on orient signal
        let style = config[configType]?.style;
        if (style) {
            style = (0, _vegaUtil.array)(style);
            for (const s of style)toMerge.push(config.style[s]);
        }
    }
    return Object.assign.apply(null, toMerge);
}
function getAxisConfig(property, styleConfigIndex, style, axisConfigs = {}) {
    const styleConfig = (0, _common.getStyleConfig)(property, style, styleConfigIndex);
    if (styleConfig !== undefined) return {
        configFrom: 'style',
        configValue: styleConfig
    };
    for (const configFrom of [
        'vlOnlyAxisConfig',
        'vgAxisConfig',
        'axisConfigStyle'
    ]){
        if (axisConfigs[configFrom]?.[property] !== undefined) return {
            configFrom,
            configValue: axisConfigs[configFrom][property]
        };
    }
    return {};
}

},{"vega-util":"7f6sQ","../../scale":"bdpXN","../../util":"acUGA","../../vega.schema":"3mBOT","../common":"jegt8","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"aCN2T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalculateNode", ()=>CalculateNode);
parcelHelpers.export(exports, "sortArrayIndexField", ()=>sortArrayIndexField);
var _channeldef = require("../../channeldef");
var _predicate = require("../../predicate");
var _sort = require("../../sort");
var _util = require("../../util");
var _dataflow = require("./dataflow");
var _expressions = require("./expressions");
class CalculateNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new CalculateNode(null, (0, _util.duplicate)(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
        this._dependentFields = (0, _expressions.getDependentFields)(this.transform.calculate);
    }
    static parseAllForSortIndex(parent, model) {
        // get all the encoding with sort fields from model
        model.forEachFieldDef((fieldDef, channel)=>{
            if (!(0, _channeldef.isScaleFieldDef)(fieldDef)) return;
            if ((0, _sort.isSortArray)(fieldDef.sort)) {
                const { field, timeUnit } = fieldDef;
                const sort = fieldDef.sort;
                // generate `datum["a"] === val0 ? 0 : datum["a"] === val1 ? 1 : ... : n` via FieldEqualPredicate
                const calculate = sort.map((sortValue, i)=>{
                    return `${(0, _predicate.fieldFilterExpression)({
                        field,
                        timeUnit,
                        equal: sortValue
                    })} ? ${i} : `;
                }).join('') + sort.length;
                parent = new CalculateNode(parent, {
                    calculate,
                    as: sortArrayIndexField(fieldDef, channel, {
                        forAs: true
                    })
                });
            }
        });
        return parent;
    }
    producedFields() {
        return new Set([
            this.transform.as
        ]);
    }
    dependentFields() {
        return this._dependentFields;
    }
    assemble() {
        return {
            type: 'formula',
            expr: this.transform.calculate,
            as: this.transform.as
        };
    }
    hash() {
        return `Calculate ${(0, _util.hash)(this.transform)}`;
    }
}
function sortArrayIndexField(fieldDef, channel, opt) {
    return (0, _channeldef.vgField)(fieldDef, {
        prefix: channel,
        suffix: 'sort_index',
        ...opt
    });
}

},{"../../channeldef":"dsccb","../../predicate":"gynPW","../../sort":"aWnXd","../../util":"acUGA","./dataflow":"btJXI","./expressions":"5Wule","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"aM8kl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Get header channel, which can be different from facet channel when orient is specified or when the facet channel is facet.
 */ parcelHelpers.export(exports, "getHeaderChannel", ()=>getHeaderChannel);
parcelHelpers.export(exports, "getHeaderProperty", ()=>getHeaderProperty);
parcelHelpers.export(exports, "getHeaderProperties", ()=>getHeaderProperties);
var _util = require("../../util");
function getHeaderChannel(channel, orient) {
    if ((0, _util.contains)([
        'top',
        'bottom'
    ], orient)) return 'column';
    else if ((0, _util.contains)([
        'left',
        'right'
    ], orient)) return 'row';
    return channel === 'row' ? 'row' : 'column';
}
function getHeaderProperty(prop, header, config, channel) {
    const headerSpecificConfig = channel === 'row' ? config.headerRow : channel === 'column' ? config.headerColumn : config.headerFacet;
    return (0, _util.getFirstDefined)((header || {})[prop], headerSpecificConfig[prop], config.header[prop]);
}
function getHeaderProperties(properties, header, config, channel) {
    const props = {};
    for (const prop of properties){
        const value = getHeaderProperty(prop, header || {}, config, channel);
        if (value !== undefined) props[prop] = value;
    }
    return props;
}

},{"../../util":"acUGA","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"d5ljn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HEADER_CHANNELS", ()=>HEADER_CHANNELS);
parcelHelpers.export(exports, "HEADER_TYPES", ()=>HEADER_TYPES);
const HEADER_CHANNELS = [
    'row',
    'column'
];
const HEADER_TYPES = [
    'header',
    'footer'
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cyXx5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assembleLayoutSignals", ()=>assembleLayoutSignals);
parcelHelpers.export(exports, "sizeSignals", ()=>sizeSignals);
parcelHelpers.export(exports, "sizeExpr", ()=>sizeExpr);
var _config = require("../../config");
var _scale = require("../../scale");
var _util = require("../../util");
var _vegaSchema = require("../../vega.schema");
var _common = require("../common");
var _model = require("../model");
function assembleLayoutSignals(model) {
    return [
        ...sizeSignals(model, 'width'),
        ...sizeSignals(model, 'height'),
        ...sizeSignals(model, 'childWidth'),
        ...sizeSignals(model, 'childHeight')
    ];
}
function sizeSignals(model, sizeType) {
    const channel = sizeType === 'width' ? 'x' : 'y';
    const size = model.component.layoutSize.get(sizeType);
    if (!size || size === 'merged') return [];
    // Read size signal name from name map, just in case it is the top-level size signal that got renamed.
    const name = model.getSizeSignalRef(sizeType).signal;
    if (size === 'step') {
        const scaleComponent = model.getScaleComponent(channel);
        if (scaleComponent) {
            const type = scaleComponent.get('type');
            const range = scaleComponent.get('range');
            if ((0, _scale.hasDiscreteDomain)(type) && (0, _vegaSchema.isVgRangeStep)(range)) {
                const scaleName = model.scaleName(channel);
                if ((0, _model.isFacetModel)(model.parent)) {
                    // If parent is facet and this is an independent scale, return only signal signal
                    // as the width/height will be calculated using the cardinality from
                    // facet's aggregate rather than reading from scale domain
                    const parentResolve = model.parent.component.resolve;
                    if (parentResolve.scale[channel] === 'independent') return [
                        stepSignal(scaleName, range)
                    ];
                }
                return [
                    stepSignal(scaleName, range),
                    {
                        name,
                        update: sizeExpr(scaleName, scaleComponent, `domain('${scaleName}').length`)
                    }
                ];
            }
        }
        /* istanbul ignore next: Condition should not happen -- only for warning in development. */ throw new Error('layout size is step although width/height is not step.');
    } else if (size == 'container') {
        const isWidth = name.endsWith('width');
        const expr = isWidth ? 'containerSize()[0]' : 'containerSize()[1]';
        const defaultValue = (0, _config.getViewConfigContinuousSize)(model.config.view, isWidth ? 'width' : 'height');
        const safeExpr = `isFinite(${expr}) ? ${expr} : ${defaultValue}`;
        return [
            {
                name,
                init: safeExpr,
                on: [
                    {
                        update: safeExpr,
                        events: 'window:resize'
                    }
                ]
            }
        ];
    } else return [
        {
            name,
            value: size
        }
    ];
}
function stepSignal(scaleName, range) {
    const name = `${scaleName}_step`;
    if ((0, _vegaSchema.isSignalRef)(range.step)) return {
        name,
        update: range.step.signal
    };
    else return {
        name,
        value: range.step
    };
}
function sizeExpr(scaleName, scaleComponent, cardinality) {
    const type = scaleComponent.get('type');
    const padding = scaleComponent.get('padding');
    const paddingOuter = (0, _util.getFirstDefined)(scaleComponent.get('paddingOuter'), padding);
    let paddingInner = scaleComponent.get('paddingInner');
    paddingInner = type === 'band' ? paddingInner !== undefined ? paddingInner : padding : // it's equivalent to have paddingInner = 1 since there is only n-1 steps between n points.
    1;
    return `bandspace(${cardinality}, ${(0, _common.signalOrStringValue)(paddingInner)}, ${(0, _common.signalOrStringValue)(paddingOuter)}) * ${scaleName}_step`;
}

},{"../../config":"8TUzf","../../scale":"bdpXN","../../util":"acUGA","../../vega.schema":"3mBOT","../common":"jegt8","../model":"hQHib","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dwyom":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSizeTypeFromLayoutSizeType", ()=>getSizeTypeFromLayoutSizeType);
function getSizeTypeFromLayoutSizeType(layoutSizeType) {
    return layoutSizeType === 'childWidth' ? 'width' : layoutSizeType === 'childHeight' ? 'height' : layoutSizeType;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"fTNbV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assembleLegends", ()=>assembleLegends);
parcelHelpers.export(exports, "assembleLegend", ()=>assembleLegend);
var _legend = require("../../legend");
var _util = require("../../util");
var _vegaSchema = require("../../vega.schema");
var _parse = require("./parse");
function setLegendEncode(legend, part, vgProp, vgRef) {
    var _a, _b;
    legend.encode ?? (legend.encode = {});
    (_a = legend.encode)[part] ?? (_a[part] = {});
    (_b = legend.encode[part]).update ?? (_b.update = {});
    // TODO: remove as any after https://github.com/prisma/nexus-prisma/issues/291
    legend.encode[part].update[vgProp] = vgRef;
}
function assembleLegends(model) {
    const legendComponentIndex = model.component.legends;
    const legendByDomain = {};
    for (const channel of (0, _util.keys)(legendComponentIndex)){
        const scaleComponent = model.getScaleComponent(channel);
        const domainHash = (0, _util.stringify)(scaleComponent.get('domains'));
        if (legendByDomain[domainHash]) for (const mergedLegendComponent of legendByDomain[domainHash]){
            const merged = (0, _parse.mergeLegendComponent)(mergedLegendComponent, legendComponentIndex[channel]);
            if (!merged) // If cannot merge, need to add this legend separately
            legendByDomain[domainHash].push(legendComponentIndex[channel]);
        }
        else legendByDomain[domainHash] = [
            legendComponentIndex[channel].clone()
        ];
    }
    const legends = (0, _util.vals)(legendByDomain).flat().map((l)=>assembleLegend(l, model.config)).filter((l)=>l !== undefined);
    return legends;
}
function assembleLegend(legendCmpt, config) {
    const { disable, labelExpr, selections, ...legend } = legendCmpt.combine();
    if (disable) return undefined;
    if (config.aria === false && legend.aria == undefined) legend.aria = false;
    if (legend.encode?.symbols) {
        const out = legend.encode.symbols.update;
        if (out.fill && out.fill['value'] !== 'transparent' && !out.stroke && !legend.stroke) // For non color channel's legend, we need to override symbol stroke config from Vega config if stroke channel is not used.
        out.stroke = {
            value: 'transparent'
        };
        // Remove properties that the legend is encoding.
        for (const property of (0, _legend.LEGEND_SCALE_CHANNELS))if (legend[property]) delete out[property];
    }
    if (!legend.title) // title schema doesn't include null, ''
    delete legend.title;
    if (labelExpr !== undefined) {
        let expr = labelExpr;
        if (legend.encode?.labels?.update && (0, _vegaSchema.isSignalRef)(legend.encode.labels.update.text)) expr = (0, _util.replaceAll)(labelExpr, 'datum.label', legend.encode.labels.update.text.signal);
        setLegendEncode(legend, 'labels', 'text', {
            signal: expr
        });
    }
    return legend;
}

},{"../../legend":"wjMIJ","../../util":"acUGA","../../vega.schema":"3mBOT","./parse":"dE0Bh","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dE0Bh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseLegend", ()=>parseLegend);
parcelHelpers.export(exports, "parseLegendForChannel", ()=>parseLegendForChannel);
parcelHelpers.export(exports, "mergeLegendComponent", ()=>mergeLegendComponent);
var _channel = require("../../channel");
var _channeldef = require("../../channeldef");
var _legend = require("../../legend");
var _timeunit = require("../../timeunit");
var _type = require("../../type");
var _util = require("../../util");
var _common = require("../common");
var _guide = require("../guide");
var _model = require("../model");
var _resolve = require("../resolve");
var _legends = require("../selection/legends");
var _split = require("../split");
var _component = require("./component");
var _encode = require("./encode");
var _properties = require("./properties");
function parseLegend(model) {
    const legendComponent = (0, _model.isUnitModel)(model) ? parseUnitLegend(model) : parseNonUnitLegend(model);
    model.component.legends = legendComponent;
    return legendComponent;
}
function parseUnitLegend(model) {
    const { encoding } = model;
    const legendComponent = {};
    for (const channel of [
        (0, _channel.COLOR),
        ...(0, _legend.LEGEND_SCALE_CHANNELS)
    ]){
        const def = (0, _channeldef.getFieldOrDatumDef)(encoding[channel]);
        if (!def || !model.getScaleComponent(channel)) continue;
        if (channel === (0, _channel.SHAPE) && (0, _channeldef.isFieldDef)(def) && def.type === (0, _type.GEOJSON)) continue;
        legendComponent[channel] = parseLegendForChannel(model, channel);
    }
    return legendComponent;
}
function getLegendDefWithScale(model, channel) {
    const scale = model.scaleName(channel);
    if (model.mark === 'trail') {
        if (channel === 'color') // trail is a filled mark, but its default symbolType ("stroke") should use "stroke"
        return {
            stroke: scale
        };
        else if (channel === 'size') return {
            strokeWidth: scale
        };
    }
    if (channel === 'color') return model.markDef.filled ? {
        fill: scale
    } : {
        stroke: scale
    };
    return {
        [channel]: scale
    };
}
// eslint-disable-next-line @typescript-eslint/ban-types
function isExplicit(value, property, legend, fieldDef) {
    switch(property){
        case 'disable':
            return legend !== undefined; // if axis is specified or null/false, then its enable/disable state is explicit
        case 'values':
            // specified legend.values is already respected, but may get transformed.
            return !!legend?.values;
        case 'title':
            // title can be explicit if fieldDef.title is set
            if (property === 'title' && value === fieldDef?.title) return true;
    }
    // Otherwise, things are explicit if the returned value matches the specified property
    return value === (legend || {})[property];
}
function parseLegendForChannel(model, channel) {
    let legend = model.legend(channel);
    const { markDef, encoding, config } = model;
    const legendConfig = config.legend;
    const legendCmpt = new (0, _component.LegendComponent)({}, getLegendDefWithScale(model, channel));
    (0, _legends.parseInteractiveLegend)(model, channel, legendCmpt);
    const disable = legend !== undefined ? !legend : legendConfig.disable;
    legendCmpt.set('disable', disable, legend !== undefined);
    if (disable) return legendCmpt;
    legend = legend || {};
    const scaleType = model.getScaleComponent(channel).get('type');
    const fieldOrDatumDef = (0, _channeldef.getFieldOrDatumDef)(encoding[channel]);
    const timeUnit = (0, _channeldef.isFieldDef)(fieldOrDatumDef) ? (0, _timeunit.normalizeTimeUnit)(fieldOrDatumDef.timeUnit)?.unit : undefined;
    const orient = legend.orient || config.legend.orient || 'right';
    const legendType = (0, _properties.getLegendType)({
        legend,
        channel,
        timeUnit,
        scaleType
    });
    const direction = (0, _properties.getDirection)({
        legend,
        legendType,
        orient,
        legendConfig
    });
    const ruleParams = {
        legend,
        channel,
        model,
        markDef,
        encoding,
        fieldOrDatumDef,
        legendConfig,
        config,
        scaleType,
        orient,
        legendType,
        direction
    };
    for (const property of (0, _component.LEGEND_COMPONENT_PROPERTIES)){
        if (legendType === 'gradient' && property.startsWith('symbol') || legendType === 'symbol' && property.startsWith('gradient')) continue;
        const value = property in (0, _properties.legendRules) ? (0, _properties.legendRules)[property](ruleParams) : legend[property];
        if (value !== undefined) {
            const explicit = isExplicit(value, property, legend, model.fieldDef(channel));
            if (explicit || config.legend[property] === undefined) legendCmpt.set(property, value, explicit);
        }
    }
    const legendEncoding = legend?.encoding ?? {};
    const selections = legendCmpt.get('selections');
    const legendEncode = {};
    const legendEncodeParams = {
        fieldOrDatumDef,
        model,
        channel,
        legendCmpt,
        legendType
    };
    for (const part of [
        'labels',
        'legend',
        'title',
        'symbols',
        'gradient',
        'entries'
    ]){
        // FIXME: remove as any (figure out what legendEncoding.entries is)
        const legendEncodingPart = (0, _guide.guideEncodeEntry)(legendEncoding[part] ?? {}, model);
        const value = part in (0, _encode.legendEncodeRules) ? (0, _encode.legendEncodeRules)[part](legendEncodingPart, legendEncodeParams) // apply rule
         : legendEncodingPart; // no rule -- just default values
        if (value !== undefined && !(0, _util.isEmpty)(value)) legendEncode[part] = {
            ...selections?.length && (0, _channeldef.isFieldDef)(fieldOrDatumDef) ? {
                name: `${(0, _util.varName)(fieldOrDatumDef.field)}_legend_${part}`
            } : {},
            ...selections?.length ? {
                interactive: !!selections
            } : {},
            update: value
        };
    }
    if (!(0, _util.isEmpty)(legendEncode)) legendCmpt.set('encode', legendEncode, !!legend?.encoding);
    return legendCmpt;
}
function parseNonUnitLegend(model) {
    const { legends, resolve } = model.component;
    for (const child of model.children){
        parseLegend(child);
        for (const channel of (0, _util.keys)(child.component.legends)){
            resolve.legend[channel] = (0, _resolve.parseGuideResolve)(model.component.resolve, channel);
            if (resolve.legend[channel] === 'shared') {
                // If the resolve says shared (and has not been overridden)
                // We will try to merge and see if there is a conflict
                legends[channel] = mergeLegendComponent(legends[channel], child.component.legends[channel]);
                if (!legends[channel]) {
                    // If merge returns nothing, there is a conflict so we cannot make the legend shared.
                    // Thus, mark legend as independent and remove the legend component.
                    resolve.legend[channel] = 'independent';
                    delete legends[channel];
                }
            }
        }
    }
    for (const channel of (0, _util.keys)(legends))for (const child of model.children){
        if (!child.component.legends[channel]) continue;
        if (resolve.legend[channel] === 'shared') // After merging shared legend, make sure to remove legend from child
        delete child.component.legends[channel];
    }
    return legends;
}
function mergeLegendComponent(mergedLegend, childLegend) {
    if (!mergedLegend) return childLegend.clone();
    const mergedOrient = mergedLegend.getWithExplicit('orient');
    const childOrient = childLegend.getWithExplicit('orient');
    if (mergedOrient.explicit && childOrient.explicit && mergedOrient.value !== childOrient.value) // TODO: throw warning if resolve is explicit (We don't have info about explicit/implicit resolve yet.)
    // Cannot merge due to inconsistent orient
    return undefined;
    let typeMerged = false;
    // Otherwise, let's merge
    for (const prop of (0, _component.LEGEND_COMPONENT_PROPERTIES)){
        const mergedValueWithExplicit = (0, _split.mergeValuesWithExplicit)(mergedLegend.getWithExplicit(prop), childLegend.getWithExplicit(prop), prop, 'legend', // Tie breaker function
        (v1, v2)=>{
            switch(prop){
                case 'symbolType':
                    return mergeSymbolType(v1, v2);
                case 'title':
                    return (0, _common.mergeTitleComponent)(v1, v2);
                case 'type':
                    // There are only two types. If we have different types, then prefer symbol over gradient.
                    typeMerged = true;
                    return (0, _split.makeImplicit)('symbol');
            }
            return (0, _split.defaultTieBreaker)(v1, v2, prop, 'legend');
        });
        mergedLegend.setWithExplicit(prop, mergedValueWithExplicit);
    }
    if (typeMerged) {
        if (mergedLegend.implicit?.encode?.gradient) (0, _util.deleteNestedProperty)(mergedLegend.implicit, [
            'encode',
            'gradient'
        ]);
        if (mergedLegend.explicit?.encode?.gradient) (0, _util.deleteNestedProperty)(mergedLegend.explicit, [
            'encode',
            'gradient'
        ]);
    }
    return mergedLegend;
}
function mergeSymbolType(st1, st2) {
    if (st2.value === 'circle') // prefer "circle" over "stroke"
    return st2;
    return st1;
}

},{"../../channel":"liLED","../../channeldef":"dsccb","../../legend":"wjMIJ","../../timeunit":"eky0T","../../type":"cbWGP","../../util":"acUGA","../common":"jegt8","../guide":"kKC4h","../model":"hQHib","../resolve":"felCG","../selection/legends":"anCex","../split":"eXS2w","./component":"9EYvS","./encode":"4n6hs","./properties":"dFsNT","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"kKC4h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "guideEncodeEntry", ()=>guideEncodeEntry);
var _util = require("../util");
var _common = require("./common");
var _conditional = require("./mark/encode/conditional");
function guideEncodeEntry(encoding, model) {
    return (0, _util.keys)(encoding).reduce((encode, channel)=>{
        return {
            ...encode,
            ...(0, _conditional.wrapCondition)({
                model,
                channelDef: encoding[channel],
                vgChannel: channel,
                mainRefFn: (def)=>(0, _common.signalOrValueRef)(def.value),
                invalidValueRef: undefined // guide encoding won't show invalid values for the scale
            })
        };
    }, {});
}

},{"../util":"acUGA","./common":"jegt8","./mark/encode/conditional":"k2lvv","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"felCG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultScaleResolve", ()=>defaultScaleResolve);
parcelHelpers.export(exports, "parseGuideResolve", ()=>parseGuideResolve);
var _channel = require("../channel");
var _log = require("../log");
var _model = require("./model");
function defaultScaleResolve(channel, model) {
    if ((0, _model.isFacetModel)(model)) return channel === 'theta' ? 'independent' : 'shared';
    else if ((0, _model.isLayerModel)(model)) return 'shared';
    else if ((0, _model.isConcatModel)(model)) return (0, _channel.isXorY)(channel) || channel === 'theta' || channel === 'radius' ? 'independent' : 'shared';
    /* istanbul ignore next: should never reach here. */ throw new Error('invalid model type for resolve');
}
function parseGuideResolve(resolve, channel) {
    const channelScaleResolve = resolve.scale[channel];
    const guide = (0, _channel.isXorY)(channel) ? 'axis' : 'legend';
    if (channelScaleResolve === 'independent') {
        if (resolve[guide][channel] === 'shared') _log.warn(_log.message.independentScaleMeansIndependentGuide(channel));
        return 'independent';
    }
    return resolve[guide][channel] || 'shared';
}

},{"../channel":"liLED","../log":"loqTw","./model":"hQHib","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"9EYvS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LEGEND_COMPONENT_PROPERTIES", ()=>LEGEND_COMPONENT_PROPERTIES);
parcelHelpers.export(exports, "LegendComponent", ()=>LegendComponent);
var _legend = require("../../legend");
var _util = require("../../util");
var _split = require("../split");
const LEGEND_COMPONENT_PROPERTY_INDEX = {
    ...(0, _legend.COMMON_LEGEND_PROPERTY_INDEX),
    disable: 1,
    labelExpr: 1,
    selections: 1,
    // channel scales
    opacity: 1,
    shape: 1,
    stroke: 1,
    fill: 1,
    size: 1,
    strokeWidth: 1,
    strokeDash: 1,
    // encode
    encode: 1
};
const LEGEND_COMPONENT_PROPERTIES = (0, _util.keys)(LEGEND_COMPONENT_PROPERTY_INDEX);
class LegendComponent extends (0, _split.Split) {
}

},{"../../legend":"wjMIJ","../../util":"acUGA","../split":"eXS2w","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4n6hs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "legendEncodeRules", ()=>legendEncodeRules);
parcelHelpers.export(exports, "symbols", ()=>symbols);
parcelHelpers.export(exports, "gradient", ()=>gradient);
parcelHelpers.export(exports, "labels", ()=>labels);
parcelHelpers.export(exports, "entries", ()=>entries);
parcelHelpers.export(exports, "getFirstConditionValue", ()=>getFirstConditionValue);
var _vegaUtil = require("vega-util");
var _channel = require("../../channel");
var _channeldef = require("../../channeldef");
var _mark = require("../../mark");
var _util = require("../../util");
var _common = require("../common");
var _format = require("../format");
var _encode = require("../mark/encode");
var _selection = require("../selection");
const legendEncodeRules = {
    symbols,
    gradient,
    labels,
    entries
};
function symbols(symbolsSpec, { fieldOrDatumDef, model, channel, legendCmpt, legendType }) {
    if (legendType !== 'symbol') return undefined;
    const { markDef, encoding, config, mark } = model;
    const filled = markDef.filled && mark !== 'trail';
    let out = {
        ...(0, _common.applyMarkConfig)({}, model, (0, _mark.FILL_STROKE_CONFIG)),
        ..._encode.color(model, {
            filled
        })
    }; // FIXME: remove this when VgEncodeEntry is compatible with SymbolEncodeEntry
    const symbolOpacity = legendCmpt.get('symbolOpacity') ?? config.legend.symbolOpacity;
    const symbolFillColor = legendCmpt.get('symbolFillColor') ?? config.legend.symbolFillColor;
    const symbolStrokeColor = legendCmpt.get('symbolStrokeColor') ?? config.legend.symbolStrokeColor;
    const opacity = symbolOpacity === undefined ? getMaxValue(encoding.opacity) ?? markDef.opacity : undefined;
    if (out.fill) {
        // for fill legend, we don't want any fill in symbol
        if (channel === 'fill' || filled && channel === (0, _channel.COLOR)) delete out.fill;
        else if ((0, _util.hasProperty)(out.fill, 'field')) {
            // For others, set fill to some opaque value (or nothing if a color is already set)
            if (symbolFillColor) delete out.fill;
            else {
                out.fill = (0, _common.signalOrValueRef)(config.legend.symbolBaseFillColor ?? 'black');
                out.fillOpacity = (0, _common.signalOrValueRef)(opacity ?? 1);
            }
        } else if ((0, _vegaUtil.isArray)(out.fill)) {
            const fill = getFirstConditionValue(encoding.fill ?? encoding.color) ?? markDef.fill ?? (filled && markDef.color);
            if (fill) out.fill = (0, _common.signalOrValueRef)(fill);
        }
    }
    if (out.stroke) {
        if (channel === 'stroke' || !filled && channel === (0, _channel.COLOR)) delete out.stroke;
        else if ((0, _util.hasProperty)(out.stroke, 'field') || symbolStrokeColor) // For others, remove stroke field
        delete out.stroke;
        else if ((0, _vegaUtil.isArray)(out.stroke)) {
            const stroke = (0, _util.getFirstDefined)(getFirstConditionValue(encoding.stroke || encoding.color), markDef.stroke, filled ? markDef.color : undefined);
            if (stroke) out.stroke = {
                value: stroke
            };
        }
    }
    if (channel !== (0, _channel.OPACITY)) {
        const condition = (0, _channeldef.isFieldDef)(fieldOrDatumDef) && selectedCondition(model, legendCmpt, fieldOrDatumDef);
        if (condition) out.opacity = [
            {
                test: condition,
                ...(0, _common.signalOrValueRef)(opacity ?? 1)
            },
            (0, _common.signalOrValueRef)(config.legend.unselectedOpacity)
        ];
        else if (opacity) out.opacity = (0, _common.signalOrValueRef)(opacity);
    }
    out = {
        ...out,
        ...symbolsSpec
    };
    return (0, _util.isEmpty)(out) ? undefined : out;
}
function gradient(gradientSpec, { model, legendType, legendCmpt }) {
    if (legendType !== 'gradient') return undefined;
    const { config, markDef, encoding } = model;
    let out = {};
    const gradientOpacity = legendCmpt.get('gradientOpacity') ?? config.legend.gradientOpacity;
    const opacity = gradientOpacity === undefined ? getMaxValue(encoding.opacity) || markDef.opacity : undefined;
    if (opacity) // only apply opacity if it is neither zero or undefined
    out.opacity = (0, _common.signalOrValueRef)(opacity);
    out = {
        ...out,
        ...gradientSpec
    };
    return (0, _util.isEmpty)(out) ? undefined : out;
}
function labels(specifiedlabelsSpec, { fieldOrDatumDef, model, channel, legendCmpt }) {
    const legend = model.legend(channel) || {};
    const config = model.config;
    const condition = (0, _channeldef.isFieldDef)(fieldOrDatumDef) ? selectedCondition(model, legendCmpt, fieldOrDatumDef) : undefined;
    const opacity = condition ? [
        {
            test: condition,
            value: 1
        },
        {
            value: config.legend.unselectedOpacity
        }
    ] : undefined;
    const { format, formatType } = legend;
    let text = undefined;
    if ((0, _format.isCustomFormatType)(formatType)) text = (0, _format.formatCustomType)({
        fieldOrDatumDef,
        field: 'datum.value',
        format,
        formatType,
        config
    });
    else if (format === undefined && formatType === undefined && config.customFormatTypes) {
        if (fieldOrDatumDef.type === 'quantitative' && config.numberFormatType) text = (0, _format.formatCustomType)({
            fieldOrDatumDef,
            field: 'datum.value',
            format: config.numberFormat,
            formatType: config.numberFormatType,
            config
        });
        else if (fieldOrDatumDef.type === 'temporal' && config.timeFormatType && (0, _channeldef.isFieldDef)(fieldOrDatumDef) && fieldOrDatumDef.timeUnit === undefined) text = (0, _format.formatCustomType)({
            fieldOrDatumDef,
            field: 'datum.value',
            format: config.timeFormat,
            formatType: config.timeFormatType,
            config
        });
    }
    const labelsSpec = {
        ...opacity ? {
            opacity
        } : {},
        ...text ? {
            text
        } : {},
        ...specifiedlabelsSpec
    };
    return (0, _util.isEmpty)(labelsSpec) ? undefined : labelsSpec;
}
function entries(entriesSpec, { legendCmpt }) {
    const selections = legendCmpt.get('selections');
    return selections?.length ? {
        ...entriesSpec,
        fill: {
            value: 'transparent'
        }
    } : entriesSpec;
}
function getMaxValue(channelDef) {
    return getConditionValue(channelDef, (v, conditionalDef)=>Math.max(v, conditionalDef.value));
}
function getFirstConditionValue(channelDef) {
    return getConditionValue(channelDef, (v, conditionalDef)=>{
        return (0, _util.getFirstDefined)(v, conditionalDef.value);
    });
}
function getConditionValue(channelDef, reducer) {
    if ((0, _channeldef.hasConditionalValueDef)(channelDef)) return (0, _vegaUtil.array)(channelDef.condition).reduce(reducer, channelDef.value);
    else if ((0, _channeldef.isValueDef)(channelDef)) return channelDef.value;
    return undefined;
}
function selectedCondition(model, legendCmpt, fieldDef) {
    const selections = legendCmpt.get('selections');
    if (!selections?.length) return undefined;
    const field = (0, _vegaUtil.stringValue)(fieldDef.field);
    return selections.map((name)=>{
        const store = (0, _vegaUtil.stringValue)((0, _util.varName)(name) + (0, _selection.STORE));
        return `(!length(data(${store})) || (${name}[${field}] && indexof(${name}[${field}], datum.value) >= 0))`;
    }).join(' || ');
}

},{"vega-util":"7f6sQ","../../channel":"liLED","../../channeldef":"dsccb","../../mark":"3Z1xx","../../util":"acUGA","../common":"jegt8","../format":"79ccI","../mark/encode":"3WiQk","../selection":"7GXIu","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dFsNT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "legendRules", ()=>legendRules);
parcelHelpers.export(exports, "values", ()=>values);
parcelHelpers.export(exports, "defaultSymbolType", ()=>defaultSymbolType);
parcelHelpers.export(exports, "clipHeight", ()=>clipHeight);
parcelHelpers.export(exports, "getLegendType", ()=>getLegendType);
parcelHelpers.export(exports, "defaultType", ()=>defaultType);
parcelHelpers.export(exports, "getDirection", ()=>getDirection);
parcelHelpers.export(exports, "defaultDirection", ()=>defaultDirection);
parcelHelpers.export(exports, "defaultGradientLength", ()=>defaultGradientLength);
parcelHelpers.export(exports, "defaultLabelOverlap", ()=>defaultLabelOverlap);
var _vegaUtil = require("vega-util");
var _channel = require("../../channel");
var _channeldef = require("../../channeldef");
var _scale = require("../../scale");
var _util = require("../../util");
var _vegaSchema = require("../../vega.schema");
var _format = require("../format");
var _encode = require("./encode");
const legendRules = {
    direction: ({ direction })=>direction,
    format: ({ fieldOrDatumDef, legend, config })=>{
        const { format, formatType } = legend;
        return (0, _format.guideFormat)(fieldOrDatumDef, fieldOrDatumDef.type, format, formatType, config, false);
    },
    formatType: ({ legend, fieldOrDatumDef, scaleType })=>{
        const { formatType } = legend;
        return (0, _format.guideFormatType)(formatType, fieldOrDatumDef, scaleType);
    },
    gradientLength: (params)=>{
        const { legend, legendConfig } = params;
        return legend.gradientLength ?? legendConfig.gradientLength ?? defaultGradientLength(params);
    },
    labelOverlap: ({ legend, legendConfig, scaleType })=>legend.labelOverlap ?? legendConfig.labelOverlap ?? defaultLabelOverlap(scaleType),
    symbolType: ({ legend, markDef, channel, encoding })=>legend.symbolType ?? defaultSymbolType(markDef.type, channel, encoding.shape, markDef.shape),
    title: ({ fieldOrDatumDef, config })=>(0, _channeldef.title)(fieldOrDatumDef, config, {
            allowDisabling: true
        }),
    type: ({ legendType, scaleType, channel })=>{
        if ((0, _channel.isColorChannel)(channel) && (0, _scale.isContinuousToContinuous)(scaleType)) {
            if (legendType === 'gradient') return undefined;
        } else if (legendType === 'symbol') return undefined;
        return legendType;
    },
    values: ({ fieldOrDatumDef, legend })=>values(legend, fieldOrDatumDef)
};
function values(legend, fieldOrDatumDef) {
    const vals = legend.values;
    if ((0, _vegaUtil.isArray)(vals)) return (0, _channeldef.valueArray)(fieldOrDatumDef, vals);
    else if ((0, _vegaSchema.isSignalRef)(vals)) return vals;
    return undefined;
}
function defaultSymbolType(mark, channel, shapeChannelDef, markShape) {
    if (channel !== 'shape') {
        // use the value from the shape encoding or the mark config if they exist
        const shape = (0, _encode.getFirstConditionValue)(shapeChannelDef) ?? markShape;
        if (shape) return shape;
    }
    switch(mark){
        case 'bar':
        case 'rect':
        case 'image':
        case 'square':
            return 'square';
        case 'line':
        case 'trail':
        case 'rule':
            return 'stroke';
        case 'arc':
        case 'point':
        case 'circle':
        case 'tick':
        case 'geoshape':
        case 'area':
        case 'text':
            return 'circle';
    }
}
function clipHeight(legendType) {
    if (legendType === 'gradient') return 20;
    return undefined;
}
function getLegendType(params) {
    const { legend } = params;
    return (0, _util.getFirstDefined)(legend.type, defaultType(params));
}
function defaultType({ channel, timeUnit, scaleType }) {
    // Following the logic in https://github.com/vega/vega-parser/blob/master/src/parsers/legend.js
    if ((0, _channel.isColorChannel)(channel)) {
        if ((0, _util.contains)([
            'quarter',
            'month',
            'day'
        ], timeUnit)) return 'symbol';
        if ((0, _scale.isContinuousToContinuous)(scaleType)) return 'gradient';
    }
    return 'symbol';
}
function getDirection({ legendConfig, legendType, orient, legend }) {
    return legend.direction ?? legendConfig[legendType ? 'gradientDirection' : 'symbolDirection'] ?? defaultDirection(orient, legendType);
}
function defaultDirection(orient, legendType) {
    switch(orient){
        case 'top':
        case 'bottom':
            return 'horizontal';
        case 'left':
        case 'right':
        case 'none':
        case undefined:
            return undefined; // vertical is Vega's default
        default:
            // top-left / ...
            // For inner legend, uses compact layout like Tableau
            return legendType === 'gradient' ? 'horizontal' : undefined;
    }
}
function defaultGradientLength({ legendConfig, model, direction, orient, scaleType }) {
    const { gradientHorizontalMaxLength, gradientHorizontalMinLength, gradientVerticalMaxLength, gradientVerticalMinLength } = legendConfig;
    if ((0, _scale.isContinuousToContinuous)(scaleType)) {
        if (direction === 'horizontal') {
            if (orient === 'top' || orient === 'bottom') return gradientLengthSignal(model, 'width', gradientHorizontalMinLength, gradientHorizontalMaxLength);
            else return gradientHorizontalMinLength;
        } else // vertical / undefined (Vega uses vertical by default)
        return gradientLengthSignal(model, 'height', gradientVerticalMinLength, gradientVerticalMaxLength);
    }
    return undefined;
}
function gradientLengthSignal(model, sizeType, min, max) {
    const sizeSignal = model.getSizeSignalRef(sizeType).signal;
    return {
        signal: `clamp(${sizeSignal}, ${min}, ${max})`
    };
}
function defaultLabelOverlap(scaleType) {
    if ((0, _util.contains)([
        'quantile',
        'threshold',
        'log',
        'symlog'
    ], scaleType)) return 'greedy';
    return undefined;
}

},{"vega-util":"7f6sQ","../../channel":"liLED","../../channeldef":"dsccb","../../scale":"bdpXN","../../util":"acUGA","../../vega.schema":"3mBOT","../format":"79ccI","./encode":"4n6hs","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dzHqC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assembleProjections", ()=>assembleProjections);
parcelHelpers.export(exports, "assembleProjectionsForModelAndChildren", ()=>assembleProjectionsForModelAndChildren);
parcelHelpers.export(exports, "assembleProjectionForModel", ()=>assembleProjectionForModel);
var _util = require("../../util");
var _vegaSchema = require("../../vega.schema");
var _model = require("../model");
function assembleProjections(model) {
    if ((0, _model.isLayerModel)(model) || (0, _model.isConcatModel)(model)) return assembleProjectionsForModelAndChildren(model);
    else return assembleProjectionForModel(model);
}
function assembleProjectionsForModelAndChildren(model) {
    return model.children.reduce((projections, child)=>{
        return projections.concat(child.assembleProjections());
    }, assembleProjectionForModel(model));
}
function assembleProjectionForModel(model) {
    const component = model.component.projection;
    if (!component || component.merged) return [];
    const projection = component.combine();
    const { name } = projection; // we need to extract name so that it is always present in the output and pass TS type validation
    if (!component.data) // generate custom projection, no automatic fitting
    return [
        {
            name,
            // translate to center by default
            translate: {
                signal: '[width / 2, height / 2]'
            },
            // parameters, overwrite default translate if specified
            ...projection
        }
    ];
    else {
        // generate projection that uses extent fitting
        const size = {
            signal: `[${component.size.map((ref)=>ref.signal).join(', ')}]`
        };
        const fits = component.data.reduce((sources, data)=>{
            const source = (0, _vegaSchema.isSignalRef)(data) ? data.signal : `data('${model.lookupDataSource(data)}')`;
            if (!(0, _util.contains)(sources, source)) // build a unique list of sources
            sources.push(source);
            return sources;
        }, []);
        if (fits.length <= 0) throw new Error("Projection's fit didn't find any data sources");
        return [
            {
                name,
                size,
                fit: {
                    signal: fits.length > 1 ? `[${fits.join(', ')}]` : fits[0]
                },
                ...projection
            }
        ];
    }
}

},{"../../util":"acUGA","../../vega.schema":"3mBOT","../model":"hQHib","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bG3b4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseProjection", ()=>parseProjection);
var _vegaUtil = require("vega-util");
var _channel = require("../../channel");
var _channeldef = require("../../channeldef");
var _data = require("../../data");
var _expr = require("../../expr");
var _projection = require("../../projection");
var _type = require("../../type");
var _util = require("../../util");
var _model = require("../model");
var _component = require("./component");
function parseProjection(model) {
    model.component.projection = (0, _model.isUnitModel)(model) ? parseUnitProjection(model) : parseNonUnitProjections(model);
}
function parseUnitProjection(model) {
    if (model.hasProjection) {
        const proj = (0, _expr.replaceExprRef)(model.specifiedProjection);
        const fit = !(proj && (proj.scale != null || proj.translate != null));
        const size = fit ? [
            model.getSizeSignalRef('width'),
            model.getSizeSignalRef('height')
        ] : undefined;
        const data = fit ? gatherFitData(model) : undefined;
        const projComp = new (0, _component.ProjectionComponent)(model.projectionName(true), {
            ...(0, _expr.replaceExprRef)(model.config.projection),
            ...proj
        }, size, data);
        if (!projComp.get('type')) projComp.set('type', 'equalEarth', false);
        return projComp;
    }
    return undefined;
}
function gatherFitData(model) {
    const data = [];
    const { encoding } = model;
    for (const posssiblePair of [
        [
            (0, _channel.LONGITUDE),
            (0, _channel.LATITUDE)
        ],
        [
            (0, _channel.LONGITUDE2),
            (0, _channel.LATITUDE2)
        ]
    ])if ((0, _channeldef.getFieldOrDatumDef)(encoding[posssiblePair[0]]) || (0, _channeldef.getFieldOrDatumDef)(encoding[posssiblePair[1]])) data.push({
        signal: model.getName(`geojson_${data.length}`)
    });
    if (model.channelHasField((0, _channel.SHAPE)) && model.typedFieldDef((0, _channel.SHAPE)).type === (0, _type.GEOJSON)) data.push({
        signal: model.getName(`geojson_${data.length}`)
    });
    if (data.length === 0) // main source is geojson, so we can just use that
    data.push(model.requestDataName((0, _data.DataSourceType).Main));
    return data;
}
function mergeIfNoConflict(first, second) {
    const allPropertiesShared = (0, _util.every)((0, _projection.PROJECTION_PROPERTIES), (prop)=>{
        // neither has the property
        if (!(0, _vegaUtil.hasOwnProperty)(first.explicit, prop) && !(0, _vegaUtil.hasOwnProperty)(second.explicit, prop)) return true;
        // both have property and an equal value for property
        if ((0, _vegaUtil.hasOwnProperty)(first.explicit, prop) && (0, _vegaUtil.hasOwnProperty)(second.explicit, prop) && // some properties might be signals or objects and require hashing for comparison
        (0, _util.deepEqual)(first.get(prop), second.get(prop))) return true;
        return false;
    });
    const size = (0, _util.deepEqual)(first.size, second.size);
    if (size) {
        if (allPropertiesShared) return first;
        else if ((0, _util.deepEqual)(first.explicit, {})) return second;
        else if ((0, _util.deepEqual)(second.explicit, {})) return first;
    }
    // if all properties don't match, let each unit spec have its own projection
    return null;
}
function parseNonUnitProjections(model) {
    if (model.children.length === 0) return undefined;
    let nonUnitProjection;
    // parse all children first
    for (const child of model.children)parseProjection(child);
    // analyze parsed projections, attempt to merge
    const mergable = (0, _util.every)(model.children, (child)=>{
        const projection = child.component.projection;
        if (!projection) // child layer does not use a projection
        return true;
        else if (!nonUnitProjection) {
            // cached 'projection' is null, cache this one
            nonUnitProjection = projection;
            return true;
        } else {
            const merge = mergeIfNoConflict(nonUnitProjection, projection);
            if (merge) nonUnitProjection = merge;
            return !!merge;
        }
    });
    // if cached one and all other children share the same projection,
    if (nonUnitProjection && mergable) {
        // so we can elevate it to the layer level
        const name = model.projectionName(true);
        const modelProjection = new (0, _component.ProjectionComponent)(name, nonUnitProjection.specifiedProjection, nonUnitProjection.size, (0, _util.duplicate)(nonUnitProjection.data));
        // rename and assign all others as merged
        for (const child of model.children){
            const projection = child.component.projection;
            if (projection) {
                if (projection.isFit) modelProjection.data.push(...child.component.projection.data);
                child.renameProjection(projection.get('name'), name);
                projection.merged = true;
            }
        }
        return modelProjection;
    }
    return undefined;
}

},{"vega-util":"7f6sQ","../../channel":"liLED","../../channeldef":"dsccb","../../data":"dILEy","../../expr":"ev4sO","../../projection":"5KTyY","../../type":"cbWGP","../../util":"acUGA","../model":"hQHib","./component":"cBc3T","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5KTyY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PROJECTION_PROPERTIES", ()=>PROJECTION_PROPERTIES);
const PROJECTION_PROPERTIES = [
    'type',
    'clipAngle',
    'clipExtent',
    'center',
    'rotate',
    'precision',
    'reflectX',
    'reflectY',
    'coefficient',
    'distance',
    'fraction',
    'lobes',
    'parallel',
    'radius',
    'ratio',
    'spacing',
    'tilt'
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cBc3T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProjectionComponent", ()=>ProjectionComponent);
var _split = require("../split");
class ProjectionComponent extends (0, _split.Split) {
    constructor(name, specifiedProjection, size, data){
        super({
            ...specifiedProjection
        }, {
            name
        } // name as initial implicit property
        );
        this.specifiedProjection = specifiedProjection;
        this.size = size;
        this.data = data;
        this.merged = false;
    }
    /**
     * Whether the projection parameters should fit provided data.
     */ get isFit() {
        return !!this.data;
    }
}

},{"../split":"eXS2w","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"tWUai":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assembleScales", ()=>assembleScales);
parcelHelpers.export(exports, "assembleScalesForModel", ()=>assembleScalesForModel);
parcelHelpers.export(exports, "assembleScaleRange", ()=>assembleScaleRange);
var _vegaUtil = require("vega-util");
var _channel = require("../../channel");
var _util = require("../../util");
var _vegaSchema = require("../../vega.schema");
var _model = require("../model");
var _assemble = require("../selection/assemble");
var _domain = require("./domain");
function assembleScales(model) {
    if ((0, _model.isLayerModel)(model) || (0, _model.isConcatModel)(model)) // For concat and layer, include scales of children too
    return model.children.reduce((scales, child)=>{
        return scales.concat(assembleScales(child));
    }, assembleScalesForModel(model));
    else // For facet, child scales would not be included in the parent's scope.
    // For unit, there is no child.
    return assembleScalesForModel(model);
}
function assembleScalesForModel(model) {
    return (0, _util.keys)(model.component.scales).reduce((scales, channel)=>{
        const scaleComponent = model.component.scales[channel];
        if (scaleComponent.merged) // Skipped merged scales
        return scales;
        const scale = scaleComponent.combine();
        const { name, type, selectionExtent, domains: _d, range: _r, reverse, ...otherScaleProps } = scale;
        const range = assembleScaleRange(scale.range, name, channel, model);
        const domain = (0, _domain.assembleDomain)(model, channel);
        const domainRaw = selectionExtent ? (0, _assemble.assembleSelectionScaleDomain)(model, selectionExtent, scaleComponent, domain) : null;
        scales.push({
            name,
            type,
            ...domain ? {
                domain
            } : {},
            ...domainRaw ? {
                domainRaw
            } : {},
            range,
            ...reverse !== undefined ? {
                reverse: reverse
            } : {},
            ...otherScaleProps
        });
        return scales;
    }, []);
}
function assembleScaleRange(scaleRange, scaleName, channel, model) {
    // add signals to x/y range
    if ((0, _channel.isXorY)(channel)) {
        if ((0, _vegaSchema.isVgRangeStep)(scaleRange)) // For width/height step, use a signal created in layout assemble instead of a constant step.
        return {
            step: {
                signal: `${scaleName}_step`
            }
        };
    } else if ((0, _vegaUtil.isObject)(scaleRange) && (0, _vegaSchema.isDataRefDomain)(scaleRange)) return {
        ...scaleRange,
        data: model.lookupDataSource(scaleRange.data)
    };
    return scaleRange;
}

},{"vega-util":"7f6sQ","../../channel":"liLED","../../util":"acUGA","../../vega.schema":"3mBOT","../model":"hQHib","../selection/assemble":"4YKkA","./domain":"ebJoM","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"ebJoM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseScaleDomain", ()=>parseScaleDomain);
parcelHelpers.export(exports, "parseDomainForChannel", ()=>parseDomainForChannel);
parcelHelpers.export(exports, "domainSort", ()=>domainSort);
/**
 * Determine if a scale can use unaggregated domain.
 * @return {Boolean} Returns true if all of the following conditions apply:
 * 1. `scale.domain` is `unaggregated`
 * 2. Aggregation function is not `count` or `sum`
 * 3. The scale is quantitative or time scale.
 */ parcelHelpers.export(exports, "canUseUnaggregatedDomain", ()=>canUseUnaggregatedDomain);
/**
 * Converts an array of domains to a single Vega scale domain.
 */ parcelHelpers.export(exports, "mergeDomains", ()=>mergeDomains);
/**
 * Return a field if a scale uses a single field.
 * Return `undefined` otherwise.
 */ parcelHelpers.export(exports, "getFieldFromDomain", ()=>getFieldFromDomain);
parcelHelpers.export(exports, "assembleDomain", ()=>assembleDomain);
var _vegaUtil = require("vega-util");
var _aggregate = require("../../aggregate");
var _bin = require("../../bin");
var _channel = require("../../channel");
var _channeldef = require("../../channeldef");
var _data = require("../../data");
var _log = require("../../log");
var _mark = require("../../mark");
var _scale = require("../../scale");
var _sort = require("../../sort");
var _timeunit = require("../../timeunit");
var _util = require("../../util");
var _vegaSchema = require("../../vega.schema");
var _common = require("../common");
var _bin1 = require("../data/bin");
var _calculate = require("../data/calculate");
var _optimize = require("../data/optimize");
var _timeunit1 = require("../data/timeunit");
var _datasources = require("../invalid/datasources");
var _model = require("../model");
var _signal = require("../signal");
var _split = require("../split");
function parseScaleDomain(model) {
    if ((0, _model.isUnitModel)(model)) parseUnitScaleDomain(model);
    else parseNonUnitScaleDomain(model);
}
function parseUnitScaleDomain(model) {
    const localScaleComponents = model.component.scales;
    for (const channel of _util.keys(localScaleComponents)){
        const domains = parseDomainForChannel(model, channel);
        const localScaleCmpt = localScaleComponents[channel];
        localScaleCmpt.setWithExplicit('domains', domains);
        parseSelectionDomain(model, channel);
        if (model.component.data.isFaceted) {
            // get resolve from closest facet parent as this decides whether we need to refer to cloned subtree or not
            let facetParent = model;
            while(!(0, _model.isFacetModel)(facetParent) && facetParent.parent)facetParent = facetParent.parent;
            const resolve = facetParent.component.resolve.scale[channel];
            if (resolve === 'shared') {
                for (const domain of domains.value)// Replace the scale domain with data output from a cloned subtree after the facet.
                if ((0, _vegaSchema.isDataRefDomain)(domain)) // use data from cloned subtree (which is the same as data but with a prefix added once)
                domain.data = (0, _optimize.FACET_SCALE_PREFIX) + domain.data.replace((0, _optimize.FACET_SCALE_PREFIX), '');
            }
        }
    }
}
function parseNonUnitScaleDomain(model) {
    for (const child of model.children)parseScaleDomain(child);
    const localScaleComponents = model.component.scales;
    for (const channel of _util.keys(localScaleComponents)){
        let domains;
        let selectionExtent = null;
        for (const child of model.children){
            const childComponent = child.component.scales[channel];
            if (childComponent) {
                if (domains === undefined) domains = childComponent.getWithExplicit('domains');
                else domains = (0, _split.mergeValuesWithExplicit)(domains, childComponent.getWithExplicit('domains'), 'domains', 'scale', domainsTieBreaker);
                const se = childComponent.get('selectionExtent');
                if (selectionExtent && se && selectionExtent.param !== se.param) _log.warn(_log.message.NEEDS_SAME_SELECTION);
                selectionExtent = se;
            }
        }
        localScaleComponents[channel].setWithExplicit('domains', domains);
        if (selectionExtent) localScaleComponents[channel].set('selectionExtent', selectionExtent, true);
    }
}
/**
 * Remove unaggregated domain if it is not applicable
 * Add unaggregated domain if domain is not specified and config.scale.useUnaggregatedDomain is true.
 */ function normalizeUnaggregatedDomain(domain, fieldDef, scaleType, scaleConfig) {
    if (domain === 'unaggregated') {
        const { valid, reason } = canUseUnaggregatedDomain(fieldDef, scaleType);
        if (!valid) {
            _log.warn(reason);
            return undefined;
        }
    } else if (domain === undefined && scaleConfig.useUnaggregatedDomain) {
        // Apply config if domain is not specified.
        const { valid } = canUseUnaggregatedDomain(fieldDef, scaleType);
        if (valid) return 'unaggregated';
    }
    return domain;
}
function parseDomainForChannel(model, channel) {
    const scaleType = model.getScaleComponent(channel).get('type');
    const { encoding } = model;
    const domain = normalizeUnaggregatedDomain(model.scaleDomain(channel), model.typedFieldDef(channel), scaleType, model.config.scale);
    if (domain !== model.scaleDomain(channel)) model.specifiedScales[channel] = {
        ...model.specifiedScales[channel],
        domain
    };
    // If channel is either X or Y then union them with X2 & Y2 if they exist
    if (channel === 'x' && (0, _channeldef.getFieldOrDatumDef)(encoding.x2)) {
        if ((0, _channeldef.getFieldOrDatumDef)(encoding.x)) return (0, _split.mergeValuesWithExplicit)(parseSingleChannelDomain(scaleType, domain, model, 'x'), parseSingleChannelDomain(scaleType, domain, model, 'x2'), 'domain', 'scale', domainsTieBreaker);
        else return parseSingleChannelDomain(scaleType, domain, model, 'x2');
    } else if (channel === 'y' && (0, _channeldef.getFieldOrDatumDef)(encoding.y2)) {
        if ((0, _channeldef.getFieldOrDatumDef)(encoding.y)) return (0, _split.mergeValuesWithExplicit)(parseSingleChannelDomain(scaleType, domain, model, 'y'), parseSingleChannelDomain(scaleType, domain, model, 'y2'), 'domain', 'scale', domainsTieBreaker);
        else return parseSingleChannelDomain(scaleType, domain, model, 'y2');
    }
    return parseSingleChannelDomain(scaleType, domain, model, channel);
}
function mapDomainToDataSignal(domain, type, timeUnit) {
    return domain.map((v)=>{
        const data = (0, _channeldef.valueExpr)(v, {
            timeUnit,
            type
        });
        return {
            signal: `{data: ${data}}`
        };
    });
}
function convertDomainIfItIsDateTime(domain, type, timeUnit) {
    // explicit value
    const normalizedTimeUnit = (0, _timeunit.normalizeTimeUnit)(timeUnit)?.unit;
    if (type === 'temporal' || normalizedTimeUnit) return mapDomainToDataSignal(domain, type, normalizedTimeUnit);
    return [
        domain
    ]; // Date time won't make sense
}
function parseSingleChannelDomain(scaleType, domain, model, channel) {
    const { encoding, markDef, mark, config, stack } = model;
    const fieldOrDatumDef = (0, _channeldef.getFieldOrDatumDef)(encoding[channel]);
    const { type } = fieldOrDatumDef;
    const timeUnit = fieldOrDatumDef['timeUnit'];
    const dataSourceTypeForScaleDomain = (0, _datasources.getScaleDataSourceForHandlingInvalidValues)({
        invalid: (0, _common.getMarkConfig)('invalid', markDef, config),
        isPath: (0, _mark.isPathMark)(mark)
    });
    if ((0, _scale.isDomainUnionWith)(domain)) {
        const defaultDomain = parseSingleChannelDomain(scaleType, undefined, model, channel);
        const unionWith = convertDomainIfItIsDateTime(domain.unionWith, type, timeUnit);
        return (0, _split.makeExplicit)([
            ...unionWith,
            ...defaultDomain.value
        ]);
    } else if ((0, _vegaSchema.isSignalRef)(domain)) return (0, _split.makeExplicit)([
        domain
    ]);
    else if (domain && domain !== 'unaggregated' && !(0, _scale.isParameterDomain)(domain)) return (0, _split.makeExplicit)(convertDomainIfItIsDateTime(domain, type, timeUnit));
    if (stack && channel === stack.fieldChannel) {
        if (stack.offset === 'normalize') return (0, _split.makeImplicit)([
            [
                0,
                1
            ]
        ]);
        const data = model.requestDataName(dataSourceTypeForScaleDomain);
        return (0, _split.makeImplicit)([
            {
                data,
                field: model.vgField(channel, {
                    suffix: 'start'
                })
            },
            {
                data,
                field: model.vgField(channel, {
                    suffix: 'end'
                })
            }
        ]);
    }
    const sort = (0, _channel.isScaleChannel)(channel) && (0, _channeldef.isFieldDef)(fieldOrDatumDef) ? domainSort(model, channel, scaleType) : undefined;
    if ((0, _channeldef.isDatumDef)(fieldOrDatumDef)) {
        const d = convertDomainIfItIsDateTime([
            fieldOrDatumDef.datum
        ], type, timeUnit);
        return (0, _split.makeImplicit)(d);
    }
    const fieldDef = fieldOrDatumDef; // now we can be sure it's a fieldDef
    if (domain === 'unaggregated') {
        const { field } = fieldOrDatumDef;
        return (0, _split.makeImplicit)([
            {
                data: model.requestDataName(dataSourceTypeForScaleDomain),
                field: (0, _channeldef.vgField)({
                    field,
                    aggregate: 'min'
                })
            },
            {
                data: model.requestDataName(dataSourceTypeForScaleDomain),
                field: (0, _channeldef.vgField)({
                    field,
                    aggregate: 'max'
                })
            }
        ]);
    } else if ((0, _bin.isBinning)(fieldDef.bin)) {
        if ((0, _scale.hasDiscreteDomain)(scaleType)) {
            if (scaleType === 'bin-ordinal') // we can omit the domain as it is inferred from the `bins` property
            return (0, _split.makeImplicit)([]);
            // ordinal bin scale takes domain from bin_range, ordered by bin start
            // This is useful for both axis-based scale (x/y) and legend-based scale (other channels).
            return (0, _split.makeImplicit)([
                {
                    // If sort by aggregation of a specified sort field, we need to use RAW table,
                    // so we can aggregate values for the scale independently from the main aggregation.
                    data: _util.isBoolean(sort) ? model.requestDataName(dataSourceTypeForScaleDomain) : model.requestDataName((0, _data.DataSourceType).Raw),
                    // Use range if we added it and the scale does not support computing a range as a signal.
                    field: model.vgField(channel, (0, _channeldef.binRequiresRange)(fieldDef, channel) ? {
                        binSuffix: 'range'
                    } : {}),
                    // we have to use a sort object if sort = true to make the sort correct by bin start
                    sort: sort === true || !(0, _vegaUtil.isObject)(sort) ? {
                        field: model.vgField(channel, {}),
                        op: 'min' // min or max doesn't matter since we sort by the start of the bin range
                    } : sort
                }
            ]);
        } else {
            // continuous scales
            const { bin } = fieldDef;
            if ((0, _bin.isBinning)(bin)) {
                const binSignal = (0, _bin1.getBinSignalName)(model, fieldDef.field, bin);
                return (0, _split.makeImplicit)([
                    new (0, _signal.SignalRefWrapper)(()=>{
                        const signal = model.getSignalName(binSignal);
                        return `[${signal}.start, ${signal}.stop]`;
                    })
                ]);
            } else return (0, _split.makeImplicit)([
                {
                    data: model.requestDataName(dataSourceTypeForScaleDomain),
                    field: model.vgField(channel, {})
                }
            ]);
        }
    } else if (fieldDef.timeUnit && _util.contains([
        'time',
        'utc'
    ], scaleType)) {
        const fieldDef2 = encoding[(0, _channel.getSecondaryRangeChannel)(channel)];
        if ((0, _channeldef.hasBandEnd)(fieldDef, fieldDef2, markDef, config)) {
            const data = model.requestDataName(dataSourceTypeForScaleDomain);
            const bandPosition = (0, _channeldef.getBandPosition)({
                fieldDef,
                fieldDef2,
                markDef,
                config
            });
            const isRectWithOffset = (0, _mark.isRectBasedMark)(mark) && bandPosition !== 0.5 && (0, _channel.isXorY)(channel);
            return (0, _split.makeImplicit)([
                {
                    data,
                    field: model.vgField(channel, isRectWithOffset ? {
                        suffix: (0, _timeunit1.OFFSETTED_RECT_START_SUFFIX)
                    } : {})
                },
                {
                    data,
                    field: model.vgField(channel, {
                        suffix: isRectWithOffset ? (0, _timeunit1.OFFSETTED_RECT_END_SUFFIX) : 'end'
                    })
                }
            ]);
        }
    }
    if (sort) return (0, _split.makeImplicit)([
        {
            // If sort by aggregation of a specified sort field, we need to use RAW table,
            // so we can aggregate values for the scale independently from the main aggregation.
            data: _util.isBoolean(sort) ? model.requestDataName(dataSourceTypeForScaleDomain) : model.requestDataName((0, _data.DataSourceType).Raw),
            field: model.vgField(channel),
            sort
        }
    ]);
    else return (0, _split.makeImplicit)([
        {
            data: model.requestDataName(dataSourceTypeForScaleDomain),
            field: model.vgField(channel)
        }
    ]);
}
function normalizeSortField(sort, isStackedMeasure) {
    const { op, field, order } = sort;
    return {
        // Apply default op
        op: op ?? (isStackedMeasure ? 'sum' : (0, _sort.DEFAULT_SORT_OP)),
        // flatten nested fields
        ...field ? {
            field: _util.replacePathInField(field)
        } : {},
        ...order ? {
            order
        } : {}
    };
}
function parseSelectionDomain(model, channel) {
    const scale = model.component.scales[channel];
    const spec = model.specifiedScales[channel].domain;
    const bin = model.fieldDef(channel)?.bin;
    const domain = (0, _scale.isParameterDomain)(spec) ? spec : undefined;
    const extent = (0, _bin.isBinParams)(bin) && (0, _bin.isParameterExtent)(bin.extent) ? bin.extent : undefined;
    if (domain || extent) // As scale parsing occurs before selection parsing, we cannot set
    // domainRaw directly. So instead, we store the selectionExtent on
    // the scale component, and then add domainRaw during scale assembly.
    scale.set('selectionExtent', domain ?? extent, true);
}
function domainSort(model, channel, scaleType) {
    if (!(0, _scale.hasDiscreteDomain)(scaleType)) return undefined;
    // save to cast as the only exception is the geojson type for shape, which would not generate a scale
    const fieldDef = model.fieldDef(channel);
    const sort = fieldDef.sort;
    // if the sort is specified with array, use the derived sort index field
    if ((0, _sort.isSortArray)(sort)) return {
        op: 'min',
        field: (0, _calculate.sortArrayIndexField)(fieldDef, channel),
        order: 'ascending'
    };
    const { stack } = model;
    const stackDimensions = stack ? new Set([
        ...stack.groupbyFields,
        ...stack.stackBy.map((s)=>s.fieldDef.field)
    ]) : undefined;
    // Sorted based on an aggregate calculation over a specified sort field (only for ordinal scale)
    if ((0, _sort.isSortField)(sort)) {
        const isStackedMeasure = stack && !stackDimensions.has(sort.field);
        return normalizeSortField(sort, isStackedMeasure);
    } else if ((0, _sort.isSortByEncoding)(sort)) {
        const { encoding, order } = sort;
        const fieldDefToSortBy = model.fieldDef(encoding);
        const { aggregate, field } = fieldDefToSortBy;
        const isStackedMeasure = stack && !stackDimensions.has(field);
        if ((0, _aggregate.isArgminDef)(aggregate) || (0, _aggregate.isArgmaxDef)(aggregate)) return normalizeSortField({
            field: (0, _channeldef.vgField)(fieldDefToSortBy),
            order
        }, isStackedMeasure);
        else if ((0, _aggregate.isAggregateOp)(aggregate) || !aggregate) return normalizeSortField({
            op: aggregate,
            field,
            order
        }, isStackedMeasure);
    } else if (sort === 'descending') return {
        op: 'min',
        field: model.vgField(channel),
        order: 'descending'
    };
    else if (_util.contains([
        'ascending',
        undefined /* default =ascending*/ 
    ], sort)) return true;
    // sort == null
    return undefined;
}
function canUseUnaggregatedDomain(fieldDef, scaleType) {
    const { aggregate, type } = fieldDef;
    if (!aggregate) return {
        valid: false,
        reason: _log.message.unaggregateDomainHasNoEffectForRawField(fieldDef)
    };
    if ((0, _vegaUtil.isString)(aggregate) && !(0, _aggregate.SHARED_DOMAIN_OPS).has(aggregate)) return {
        valid: false,
        reason: _log.message.unaggregateDomainWithNonSharedDomainOp(aggregate)
    };
    if (type === 'quantitative') {
        if (scaleType === 'log') return {
            valid: false,
            reason: _log.message.unaggregatedDomainWithLogScale(fieldDef)
        };
    }
    return {
        valid: true
    };
}
/**
 * Tie breaker for mergeValuesWithExplicit for domains. We concat the specified values.
 */ function domainsTieBreaker(v1, v2, property, propertyOf) {
    if (v1.explicit && v2.explicit) _log.warn(_log.message.mergeConflictingDomainProperty(property, propertyOf, v1.value, v2.value));
    // If equal score, concat the domains so that we union them later.
    return {
        explicit: v1.explicit,
        value: [
            ...v1.value,
            ...v2.value
        ]
    };
}
function mergeDomains(domains) {
    const uniqueDomains = _util.unique(domains.map((domain)=>{
        // ignore sort property when computing the unique domains
        if ((0, _vegaSchema.isDataRefDomain)(domain)) {
            const { sort: _s, ...domainWithoutSort } = domain;
            return domainWithoutSort;
        }
        return domain;
    }), _util.hash);
    const sorts = _util.unique(domains.map((d)=>{
        if ((0, _vegaSchema.isDataRefDomain)(d)) {
            const s = d.sort;
            if (s !== undefined && !_util.isBoolean(s)) {
                if ('op' in s && s.op === 'count') // let's make sure that if op is count, we don't use a field
                delete s.field;
                if (s.order === 'ascending') // drop order: ascending as it is the default
                delete s.order;
            }
            return s;
        }
        return undefined;
    }).filter((s)=>s !== undefined), _util.hash);
    if (uniqueDomains.length === 0) return undefined;
    else if (uniqueDomains.length === 1) {
        const domain = domains[0];
        if ((0, _vegaSchema.isDataRefDomain)(domain) && sorts.length > 0) {
            let sort = sorts[0];
            if (sorts.length > 1) {
                _log.warn(_log.message.MORE_THAN_ONE_SORT);
                // Get sorts with non-default ops
                const filteredSorts = sorts.filter((s)=>(0, _vegaUtil.isObject)(s) && 'op' in s && s.op !== 'min');
                if (sorts.every((s)=>(0, _vegaUtil.isObject)(s) && 'op' in s) && filteredSorts.length === 1) sort = filteredSorts[0];
                else sort = true;
            } else // Simplify domain sort by removing field and op when the field is the same as the domain field.
            if ((0, _vegaUtil.isObject)(sort) && 'field' in sort) {
                const sortField = sort.field;
                if (domain.field === sortField) sort = sort.order ? {
                    order: sort.order
                } : true;
            }
            return {
                ...domain,
                sort
            };
        }
        return domain;
    }
    // only keep sort properties that work with unioned domains
    const unionDomainSorts = _util.unique(sorts.map((s)=>{
        if (_util.isBoolean(s) || !('op' in s) || (0, _vegaUtil.isString)(s.op) && (0, _vegaUtil.hasOwnProperty)((0, _aggregate.MULTIDOMAIN_SORT_OP_INDEX), s.op)) return s;
        _log.warn(_log.message.domainSortDropped(s));
        return true;
    }), _util.hash);
    let sort;
    if (unionDomainSorts.length === 1) sort = unionDomainSorts[0];
    else if (unionDomainSorts.length > 1) {
        _log.warn(_log.message.MORE_THAN_ONE_SORT);
        sort = true;
    }
    const allData = _util.unique(domains.map((d)=>{
        if ((0, _vegaSchema.isDataRefDomain)(d)) return d.data;
        return null;
    }), (x)=>x);
    if (allData.length === 1 && allData[0] !== null) {
        // create a union domain of different fields with a single data source
        const domain = {
            data: allData[0],
            fields: uniqueDomains.map((d)=>d.field),
            ...sort ? {
                sort
            } : {}
        };
        return domain;
    }
    return {
        fields: uniqueDomains,
        ...sort ? {
            sort
        } : {}
    };
}
function getFieldFromDomain(domain) {
    if ((0, _vegaSchema.isDataRefDomain)(domain) && (0, _vegaUtil.isString)(domain.field)) return domain.field;
    else if ((0, _vegaSchema.isDataRefUnionedDomain)(domain)) {
        let field;
        for (const nonUnionDomain of domain.fields)if ((0, _vegaSchema.isDataRefDomain)(nonUnionDomain) && (0, _vegaUtil.isString)(nonUnionDomain.field)) {
            if (!field) field = nonUnionDomain.field;
            else if (field !== nonUnionDomain.field) {
                _log.warn(_log.message.FACETED_INDEPENDENT_DIFFERENT_SOURCES);
                return field;
            }
        }
        _log.warn(_log.message.FACETED_INDEPENDENT_SAME_FIELDS_DIFFERENT_SOURCES);
        return field;
    } else if ((0, _vegaSchema.isFieldRefUnionDomain)(domain)) {
        _log.warn(_log.message.FACETED_INDEPENDENT_SAME_SOURCE);
        const field = domain.fields[0];
        return (0, _vegaUtil.isString)(field) ? field : undefined;
    }
    return undefined;
}
function assembleDomain(model, channel) {
    const scaleComponent = model.component.scales[channel];
    const domains = scaleComponent.get('domains').map((domain)=>{
        // Correct references to data as the original domain's data was determined
        // in parseScale, which happens before parseData. Thus the original data
        // reference can be incorrect.
        if ((0, _vegaSchema.isDataRefDomain)(domain)) domain.data = model.lookupDataSource(domain.data);
        return domain;
    });
    // domains is an array that has to be merged into a single vega domain
    return mergeDomains(domains);
}

},{"vega-util":"7f6sQ","../../aggregate":"d7bUU","../../bin":"3cpW8","../../channel":"liLED","../../channeldef":"dsccb","../../data":"dILEy","../../log":"loqTw","../../mark":"3Z1xx","../../scale":"bdpXN","../../sort":"aWnXd","../../timeunit":"eky0T","../../util":"acUGA","../../vega.schema":"3mBOT","../common":"jegt8","../data/bin":"3xZkr","../data/calculate":"aCN2T","../data/optimize":"kc01N","../data/timeunit":"iPsUH","../invalid/datasources":"grpNH","../model":"hQHib","../signal":"4fHcn","../split":"eXS2w","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3xZkr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBinSignalName", ()=>getBinSignalName);
parcelHelpers.export(exports, "BinNode", ()=>BinNode);
var _vegaUtil = require("vega-util");
var _bin = require("../../bin");
var _channeldef = require("../../channeldef");
var _util = require("../../util");
var _format = require("../format");
var _model = require("../model");
var _parse = require("../selection/parse");
var _dataflow = require("./dataflow");
function rangeFormula(model, fieldDef, channel, config) {
    if ((0, _channeldef.binRequiresRange)(fieldDef, channel)) {
        // read format from axis or legend, if there is no format then use config.numberFormat
        const guide = (0, _model.isUnitModel)(model) ? model.axis(channel) ?? model.legend(channel) ?? {} : {};
        const startField = (0, _channeldef.vgField)(fieldDef, {
            expr: 'datum'
        });
        const endField = (0, _channeldef.vgField)(fieldDef, {
            expr: 'datum',
            binSuffix: 'end'
        });
        return {
            formulaAs: (0, _channeldef.vgField)(fieldDef, {
                binSuffix: 'range',
                forAs: true
            }),
            formula: (0, _format.binFormatExpression)(startField, endField, guide.format, guide.formatType, config)
        };
    }
    return {};
}
function binKey(bin, field) {
    return `${(0, _bin.binToString)(bin)}_${field}`;
}
function getSignalsFromModel(model, key) {
    return {
        signal: model.getName(`${key}_bins`),
        extentSignal: model.getName(`${key}_extent`)
    };
}
function getBinSignalName(model, field, bin) {
    const normalizedBin = (0, _channeldef.normalizeBin)(bin, undefined) ?? {};
    const key = binKey(normalizedBin, field);
    return model.getName(`${key}_bins`);
}
function isBinTransform(t) {
    return 'as' in t;
}
function createBinComponent(t, bin, model) {
    let as;
    let span;
    if (isBinTransform(t)) as = (0, _vegaUtil.isString)(t.as) ? [
        t.as,
        `${t.as}_end`
    ] : [
        t.as[0],
        t.as[1]
    ];
    else as = [
        (0, _channeldef.vgField)(t, {
            forAs: true
        }),
        (0, _channeldef.vgField)(t, {
            binSuffix: 'end',
            forAs: true
        })
    ];
    const normalizedBin = {
        ...(0, _channeldef.normalizeBin)(bin, undefined)
    };
    const key = binKey(normalizedBin, t.field);
    const { signal, extentSignal } = getSignalsFromModel(model, key);
    if ((0, _bin.isParameterExtent)(normalizedBin.extent)) {
        const ext = normalizedBin.extent;
        span = (0, _parse.parseSelectionExtent)(model, ext.param, ext);
        delete normalizedBin.extent; // Vega-Lite selection extent map to Vega's span property.
    }
    const binComponent = {
        bin: normalizedBin,
        field: t.field,
        as: [
            as
        ],
        ...signal ? {
            signal
        } : {},
        ...extentSignal ? {
            extentSignal
        } : {},
        ...span ? {
            span
        } : {}
    };
    return {
        key,
        binComponent
    };
}
class BinNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new BinNode(null, (0, _util.duplicate)(this.bins));
    }
    constructor(parent, bins){
        super(parent);
        this.bins = bins;
    }
    static makeFromEncoding(parent, model) {
        const bins = model.reduceFieldDef((binComponentIndex, fieldDef, channel)=>{
            if ((0, _channeldef.isTypedFieldDef)(fieldDef) && (0, _bin.isBinning)(fieldDef.bin)) {
                const { key, binComponent } = createBinComponent(fieldDef, fieldDef.bin, model);
                binComponentIndex[key] = {
                    ...binComponent,
                    ...binComponentIndex[key],
                    ...rangeFormula(model, fieldDef, channel, model.config)
                };
            }
            return binComponentIndex;
        }, {});
        if ((0, _util.isEmpty)(bins)) return null;
        return new BinNode(parent, bins);
    }
    /**
     * Creates a bin node from BinTransform.
     * The optional parameter should provide
     */ static makeFromTransform(parent, t, model) {
        const { key, binComponent } = createBinComponent(t, t.bin, model);
        return new BinNode(parent, {
            [key]: binComponent
        });
    }
    /**
     * Merge bin nodes. This method either integrates the bin config from the other node
     * or if this node already has a bin config, renames the corresponding signal in the model.
     */ merge(other, renameSignal) {
        for (const key of (0, _util.keys)(other.bins))if (key in this.bins) {
            renameSignal(other.bins[key].signal, this.bins[key].signal);
            // Ensure that we don't have duplicate names for signal pairs
            this.bins[key].as = (0, _util.unique)([
                ...this.bins[key].as,
                ...other.bins[key].as
            ], (0, _util.hash));
        } else this.bins[key] = other.bins[key];
        for (const child of other.children){
            other.removeChild(child);
            child.parent = this;
        }
        other.remove();
    }
    producedFields() {
        return new Set((0, _util.vals)(this.bins).map((c)=>c.as).flat(2));
    }
    dependentFields() {
        return new Set((0, _util.vals)(this.bins).map((c)=>c.field));
    }
    hash() {
        return `Bin ${(0, _util.hash)(this.bins)}`;
    }
    assemble() {
        return (0, _util.vals)(this.bins).flatMap((bin)=>{
            const transform = [];
            const [binAs, ...remainingAs] = bin.as;
            const { extent, ...params } = bin.bin;
            const binTrans = {
                type: 'bin',
                field: (0, _util.replacePathInField)(bin.field),
                as: binAs,
                signal: bin.signal,
                ...!(0, _bin.isParameterExtent)(extent) ? {
                    extent
                } : {
                    extent: null
                },
                ...bin.span ? {
                    span: {
                        signal: `span(${bin.span})`
                    }
                } : {},
                ...params
            };
            if (!extent && bin.extentSignal) {
                transform.push({
                    type: 'extent',
                    field: (0, _util.replacePathInField)(bin.field),
                    signal: bin.extentSignal
                });
                binTrans.extent = {
                    signal: bin.extentSignal
                };
            }
            transform.push(binTrans);
            for (const as of remainingAs)for(let i = 0; i < 2; i++)transform.push({
                type: 'formula',
                expr: (0, _channeldef.vgField)({
                    field: binAs[i]
                }, {
                    expr: 'datum'
                }),
                as: as[i]
            });
            if (bin.formula) transform.push({
                type: 'formula',
                expr: bin.formula,
                as: bin.formulaAs
            });
            return transform;
        });
    }
}

},{"vega-util":"7f6sQ","../../bin":"3cpW8","../../channeldef":"dsccb","../../util":"acUGA","../format":"79ccI","../model":"hQHib","../selection/parse":"bgKKc","./dataflow":"btJXI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"kc01N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FACET_SCALE_PREFIX", ()=>FACET_SCALE_PREFIX);
parcelHelpers.export(exports, "MAX_OPTIMIZATION_RUNS", ()=>MAX_OPTIMIZATION_RUNS);
/**
 * Iterates over a dataflow graph and checks whether all links are consistent.
 */ parcelHelpers.export(exports, "checkLinks", ()=>checkLinks);
/**
 * Optimizes the dataflow of the passed in data component.
 */ parcelHelpers.export(exports, "optimizeDataflow", ()=>optimizeDataflow);
var _log = require("../../log");
var _optimizers = require("./optimizers");
var _subtree = require("./subtree");
const FACET_SCALE_PREFIX = 'scale_';
const MAX_OPTIMIZATION_RUNS = 5;
function checkLinks(nodes) {
    for (const node of nodes){
        for (const child of node.children){
            if (child.parent !== node) // log.error('Dataflow graph is inconsistent.', node, child);
            return false;
        }
        if (!checkLinks(node.children)) return false;
    }
    return true;
}
/**
 * Run the specified optimizer on the provided nodes.
 *
 * @param optimizer The optimizer instance to run.
 * @param nodes A set of nodes to optimize.
 */ function runOptimizer(optimizer, nodes) {
    let modified = false;
    for (const node of nodes)modified = optimizer.optimize(node) || modified;
    return modified;
}
function optimizationDataflowHelper(dataComponent, model, firstPass) {
    let roots = dataComponent.sources;
    let modified = false;
    modified = runOptimizer(new _optimizers.RemoveUnnecessaryOutputNodes(), roots) || modified;
    modified = runOptimizer(new _optimizers.RemoveUnnecessaryIdentifierNodes(model), roots) || modified;
    // remove source nodes that don't have any children because they also don't have output nodes
    roots = roots.filter((r)=>r.numChildren() > 0);
    modified = runOptimizer(new _optimizers.RemoveUnusedSubtrees(), roots) || modified;
    roots = roots.filter((r)=>r.numChildren() > 0);
    if (!firstPass) {
        // Only run these optimizations after the optimizer has moved down the facet node.
        // With this change, we can be more aggressive in the optimizations.
        modified = runOptimizer(new _optimizers.MoveParseUp(), roots) || modified;
        modified = runOptimizer(new _optimizers.MergeBins(model), roots) || modified;
        modified = runOptimizer(new _optimizers.RemoveDuplicateTimeUnits(), roots) || modified;
        modified = runOptimizer(new _optimizers.MergeParse(), roots) || modified;
        modified = runOptimizer(new _optimizers.MergeAggregates(), roots) || modified;
        modified = runOptimizer(new _optimizers.MergeTimeUnits(), roots) || modified;
        modified = runOptimizer(new _optimizers.MergeIdenticalNodes(), roots) || modified;
        modified = runOptimizer(new _optimizers.MergeOutputs(), roots) || modified;
    }
    dataComponent.sources = roots;
    return modified;
}
function optimizeDataflow(data, model) {
    // check before optimizations
    checkLinks(data.sources);
    let firstPassCounter = 0;
    let secondPassCounter = 0;
    for(let i = 0; i < MAX_OPTIMIZATION_RUNS; i++){
        if (!optimizationDataflowHelper(data, model, true)) break;
        firstPassCounter++;
    }
    // move facets down and make a copy of the subtree so that we can have scales at the top level
    data.sources.map((0, _subtree.moveFacetDown));
    for(let i = 0; i < MAX_OPTIMIZATION_RUNS; i++){
        if (!optimizationDataflowHelper(data, model, false)) break;
        secondPassCounter++;
    }
    // check after optimizations
    checkLinks(data.sources);
    if (Math.max(firstPassCounter, secondPassCounter) === MAX_OPTIMIZATION_RUNS) _log.warn(`Maximum optimization runs(${MAX_OPTIMIZATION_RUNS}) reached.`);
}

},{"../../log":"loqTw","./optimizers":"5fLcM","./subtree":"ihCUR","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5fLcM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Merge identical nodes at forks by comparing hashes.
 *
 * Does not need to iterate from leaves so we implement this with recursion as it's a bit simpler.
 */ parcelHelpers.export(exports, "MergeIdenticalNodes", ()=>MergeIdenticalNodes);
/**
 * Optimizer that removes identifier nodes that are not needed for selections.
 */ parcelHelpers.export(exports, "RemoveUnnecessaryIdentifierNodes", ()=>RemoveUnnecessaryIdentifierNodes);
/**
 * Removes duplicate time unit nodes (as determined by the name of the output field) that may be generated due to
 * selections projected over time units. Only keeps the first time unit in any branch.
 *
 * This optimizer is a custom top down optimizer that keep track of produced fields in a branch.
 */ parcelHelpers.export(exports, "RemoveDuplicateTimeUnits", ()=>RemoveDuplicateTimeUnits);
/**
 * Remove output nodes that are not required.
 */ parcelHelpers.export(exports, "RemoveUnnecessaryOutputNodes", ()=>RemoveUnnecessaryOutputNodes);
/**
 * Move parse nodes up to forks and merges them if possible.
 */ parcelHelpers.export(exports, "MoveParseUp", ()=>MoveParseUp);
/**
 * Inserts an intermediate ParseNode containing all non-conflicting parse fields and removes the empty ParseNodes.
 *
 * We assume that dependent paths that do not have a parse node can be just merged.
 */ parcelHelpers.export(exports, "MergeParse", ()=>MergeParse);
/**
 * Repeatedly remove leaf nodes that are not output or facet nodes.
 * The reason is that we don't need subtrees that don't have any output nodes.
 * Facet nodes are needed for the row or column domains.
 */ parcelHelpers.export(exports, "RemoveUnusedSubtrees", ()=>RemoveUnusedSubtrees);
/**
 * Merge adjacent time unit nodes.
 */ parcelHelpers.export(exports, "MergeTimeUnits", ()=>MergeTimeUnits);
parcelHelpers.export(exports, "MergeAggregates", ()=>MergeAggregates);
/**
 * Merge bin nodes and move them up through forks. Stop at filters, parse, identifier as we want them to stay before the bin node.
 */ parcelHelpers.export(exports, "MergeBins", ()=>MergeBins);
/**
 * This optimizer takes output nodes that are at a fork and moves them before the fork.
 *
 * The algorithm iterates over the children and tries to find the last output node in a chain of output nodes.
 * It then moves all output nodes before that main output node. All other children (and the children of the output nodes)
 * are inserted after the main output node.
 */ parcelHelpers.export(exports, "MergeOutputs", ()=>MergeOutputs);
var _util = require("../../util");
var _selection = require("../selection");
var _aggregate = require("./aggregate");
var _bin = require("./bin");
var _dataflow = require("./dataflow");
var _facet = require("./facet");
var _filter = require("./filter");
var _formatparse = require("./formatparse");
var _identifier = require("./identifier");
var _optimizer = require("./optimizer");
var _source = require("./source");
var _timeunit = require("./timeunit");
class MergeIdenticalNodes extends (0, _optimizer.TopDownOptimizer) {
    mergeNodes(parent, nodes) {
        const mergedNode = nodes.shift();
        for (const node of nodes){
            parent.removeChild(node);
            node.parent = mergedNode;
            node.remove();
        }
    }
    run(node) {
        const hashes = node.children.map((x)=>x.hash());
        const buckets = {};
        for(let i = 0; i < hashes.length; i++)if (buckets[hashes[i]] === undefined) buckets[hashes[i]] = [
            node.children[i]
        ];
        else buckets[hashes[i]].push(node.children[i]);
        for (const k of (0, _util.keys)(buckets))if (buckets[k].length > 1) {
            this.setModified();
            this.mergeNodes(node, buckets[k]);
        }
    }
}
class RemoveUnnecessaryIdentifierNodes extends (0, _optimizer.TopDownOptimizer) {
    constructor(model){
        super();
        this.requiresSelectionId = model && (0, _selection.requiresSelectionId)(model);
    }
    run(node) {
        if (node instanceof (0, _identifier.IdentifierNode)) // Only preserve IdentifierNodes if we have default discrete selections
        // in our model tree, and if the nodes come after tuple producing nodes.
        {
            if (!(this.requiresSelectionId && ((0, _optimizer.isDataSourceNode)(node.parent) || node.parent instanceof (0, _aggregate.AggregateNode) || node.parent instanceof (0, _formatparse.ParseNode)))) {
                this.setModified();
                node.remove();
            }
        }
    }
}
class RemoveDuplicateTimeUnits extends (0, _optimizer.Optimizer) {
    optimize(node) {
        this.run(node, new Set());
        return this.modifiedFlag;
    }
    run(node, timeUnitFields) {
        let producedFields = new Set();
        if (node instanceof (0, _timeunit.TimeUnitNode)) {
            producedFields = node.producedFields();
            if ((0, _util.hasIntersection)(producedFields, timeUnitFields)) {
                this.setModified();
                node.removeFormulas(timeUnitFields);
                if (node.producedFields.length === 0) node.remove();
            }
        }
        for (const child of node.children)this.run(child, new Set([
            ...timeUnitFields,
            ...producedFields
        ]));
    }
}
class RemoveUnnecessaryOutputNodes extends (0, _optimizer.TopDownOptimizer) {
    constructor(){
        super();
    }
    run(node) {
        if (node instanceof (0, _dataflow.OutputNode) && !node.isRequired()) {
            this.setModified();
            node.remove();
        }
    }
}
class MoveParseUp extends (0, _optimizer.BottomUpOptimizer) {
    run(node) {
        if ((0, _optimizer.isDataSourceNode)(node)) return;
        if (node.numChildren() > 1) // Don't move parse further up but continue with parent.
        return;
        for (const child of node.children)if (child instanceof (0, _formatparse.ParseNode)) {
            if (node instanceof (0, _formatparse.ParseNode)) {
                this.setModified();
                node.merge(child);
            } else {
                // Don't swap with nodes that produce something that the parse node depends on (e.g. lookup).
                if ((0, _util.fieldIntersection)(node.producedFields(), child.dependentFields())) continue;
                this.setModified();
                child.swapWithParent();
            }
        }
        return;
    }
}
class MergeParse extends (0, _optimizer.BottomUpOptimizer) {
    run(node) {
        const originalChildren = [
            ...node.children
        ];
        const parseChildren = node.children.filter((child)=>child instanceof (0, _formatparse.ParseNode));
        if (node.numChildren() > 1 && parseChildren.length >= 1) {
            const commonParse = {};
            const conflictingParse = new Set();
            for (const parseNode of parseChildren){
                const parse = parseNode.parse;
                for (const k of (0, _util.keys)(parse)){
                    if (!(k in commonParse)) commonParse[k] = parse[k];
                    else if (commonParse[k] !== parse[k]) conflictingParse.add(k);
                }
            }
            for (const field of conflictingParse)delete commonParse[field];
            if (!(0, _util.isEmpty)(commonParse)) {
                this.setModified();
                const mergedParseNode = new (0, _formatparse.ParseNode)(node, commonParse);
                for (const childNode of originalChildren){
                    if (childNode instanceof (0, _formatparse.ParseNode)) for (const key of (0, _util.keys)(commonParse))delete childNode.parse[key];
                    node.removeChild(childNode);
                    childNode.parent = mergedParseNode;
                    // remove empty parse nodes
                    if (childNode instanceof (0, _formatparse.ParseNode) && (0, _util.keys)(childNode.parse).length === 0) childNode.remove();
                }
            }
        }
    }
}
class RemoveUnusedSubtrees extends (0, _optimizer.BottomUpOptimizer) {
    run(node) {
        if (node instanceof (0, _dataflow.OutputNode) || node.numChildren() > 0 || node instanceof (0, _facet.FacetNode)) ;
        else if (node instanceof (0, _source.SourceNode)) ;
        else {
            this.setModified();
            node.remove();
        }
    }
}
class MergeTimeUnits extends (0, _optimizer.BottomUpOptimizer) {
    run(node) {
        const timeUnitChildren = node.children.filter((x)=>x instanceof (0, _timeunit.TimeUnitNode));
        const combination = timeUnitChildren.pop();
        for (const timeUnit of timeUnitChildren){
            this.setModified();
            combination.merge(timeUnit);
        }
    }
}
class MergeAggregates extends (0, _optimizer.BottomUpOptimizer) {
    run(node) {
        const aggChildren = node.children.filter((child)=>child instanceof (0, _aggregate.AggregateNode));
        // Object which we'll use to map the fields which an aggregate is grouped by to
        // the set of aggregates with that grouping. This is useful as only aggregates
        // with the same group by can be merged
        const groupedAggregates = {};
        // Build groupedAggregates
        for (const agg of aggChildren){
            const groupBys = (0, _util.hash)(agg.groupBy);
            if (!(groupBys in groupedAggregates)) groupedAggregates[groupBys] = [];
            groupedAggregates[groupBys].push(agg);
        }
        // Merge aggregateNodes with same key in groupedAggregates
        for (const group of (0, _util.keys)(groupedAggregates)){
            const mergeableAggs = groupedAggregates[group];
            if (mergeableAggs.length > 1) {
                const mergedAggs = mergeableAggs.pop();
                for (const agg of mergeableAggs)if (mergedAggs.merge(agg)) {
                    node.removeChild(agg);
                    agg.parent = mergedAggs;
                    agg.remove();
                    this.setModified();
                }
            }
        }
    }
}
class MergeBins extends (0, _optimizer.BottomUpOptimizer) {
    constructor(model){
        super();
        this.model = model;
    }
    run(node) {
        const moveBinsUp = !((0, _optimizer.isDataSourceNode)(node) || node instanceof (0, _filter.FilterNode) || node instanceof (0, _formatparse.ParseNode) || node instanceof (0, _identifier.IdentifierNode));
        const promotableBins = [];
        const remainingBins = [];
        for (const child of node.children)if (child instanceof (0, _bin.BinNode)) {
            if (moveBinsUp && !(0, _util.fieldIntersection)(node.producedFields(), child.dependentFields())) promotableBins.push(child);
            else remainingBins.push(child);
        }
        if (promotableBins.length > 0) {
            const promotedBin = promotableBins.pop();
            for (const bin of promotableBins)promotedBin.merge(bin, this.model.renameSignal.bind(this.model));
            this.setModified();
            if (node instanceof (0, _bin.BinNode)) node.merge(promotedBin, this.model.renameSignal.bind(this.model));
            else promotedBin.swapWithParent();
        }
        if (remainingBins.length > 1) {
            const remainingBin = remainingBins.pop();
            for (const bin of remainingBins)remainingBin.merge(bin, this.model.renameSignal.bind(this.model));
            this.setModified();
        }
    }
}
class MergeOutputs extends (0, _optimizer.BottomUpOptimizer) {
    run(node) {
        const children = [
            ...node.children
        ];
        const hasOutputChild = (0, _util.some)(children, (child)=>child instanceof (0, _dataflow.OutputNode));
        if (!hasOutputChild || node.numChildren() <= 1) return;
        const otherChildren = [];
        // The output node we will connect all other nodes to.
        // Output nodes will be added before the new node, other nodes after.
        let mainOutput;
        for (const child of children)if (child instanceof (0, _dataflow.OutputNode)) {
            let lastOutput = child;
            while(lastOutput.numChildren() === 1){
                const [theChild] = lastOutput.children;
                if (theChild instanceof (0, _dataflow.OutputNode)) lastOutput = theChild;
                else break;
            }
            otherChildren.push(...lastOutput.children);
            if (mainOutput) {
                // Move the output nodes before the mainOutput. We do this by setting
                // the parent of the first not to the parent of the main output and
                // the main output's parent to the last output.
                // note: the child is the first output
                node.removeChild(child);
                child.parent = mainOutput.parent;
                mainOutput.parent.removeChild(mainOutput);
                mainOutput.parent = lastOutput;
                this.setModified();
            } else mainOutput = lastOutput;
        } else otherChildren.push(child);
        if (otherChildren.length) {
            this.setModified();
            for (const child of otherChildren){
                child.parent.removeChild(child);
                child.parent = mainOutput;
            }
        }
    }
}

},{"../../util":"acUGA","../selection":"7GXIu","./aggregate":"8WvlR","./bin":"3xZkr","./dataflow":"btJXI","./facet":"ce2Ry","./filter":"8Tzn7","./formatparse":"2mSh3","./identifier":"cuiH8","./optimizer":"b8isi","./source":"bhsCG","./timeunit":"iPsUH","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8WvlR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AggregateNode", ()=>AggregateNode);
var _aggregate = require("../../aggregate");
var _channel = require("../../channel");
var _channeldef = require("../../channeldef");
var _log = require("../../log");
var _scale = require("../../scale");
var _util = require("../../util");
var _model = require("../model");
var _dataflow = require("./dataflow");
var _mark = require("../../mark");
var _timeunit = require("./timeunit");
function addDimension(dims, channel, fieldDef, model) {
    const channelDef2 = (0, _model.isUnitModel)(model) ? model.encoding[(0, _channel.getSecondaryRangeChannel)(channel)] : undefined;
    if ((0, _channeldef.isTypedFieldDef)(fieldDef) && (0, _model.isUnitModel)(model) && (0, _channeldef.hasBandEnd)(fieldDef, channelDef2, model.markDef, model.config)) {
        dims.add((0, _channeldef.vgField)(fieldDef, {}));
        dims.add((0, _channeldef.vgField)(fieldDef, {
            suffix: 'end'
        }));
        const { mark, markDef, config } = model;
        const bandPosition = (0, _channeldef.getBandPosition)({
            fieldDef,
            markDef,
            config
        });
        if ((0, _mark.isRectBasedMark)(mark) && bandPosition !== 0.5 && (0, _channel.isXorY)(channel)) {
            dims.add((0, _channeldef.vgField)(fieldDef, {
                suffix: (0, _timeunit.OFFSETTED_RECT_START_SUFFIX)
            }));
            dims.add((0, _channeldef.vgField)(fieldDef, {
                suffix: (0, _timeunit.OFFSETTED_RECT_END_SUFFIX)
            }));
        }
        if (fieldDef.bin && (0, _channeldef.binRequiresRange)(fieldDef, channel)) dims.add((0, _channeldef.vgField)(fieldDef, {
            binSuffix: 'range'
        }));
    } else if ((0, _channel.isGeoPositionChannel)(channel)) {
        const posChannel = (0, _channel.getPositionChannelFromLatLong)(channel);
        dims.add(model.getName(posChannel));
    } else dims.add((0, _channeldef.vgField)(fieldDef));
    if ((0, _channeldef.isScaleFieldDef)(fieldDef) && (0, _scale.isFieldRange)(fieldDef.scale?.range)) dims.add(fieldDef.scale.range.field);
    return dims;
}
function mergeMeasures(parentMeasures, childMeasures) {
    for (const field of (0, _util.keys)(childMeasures)){
        // when we merge a measure, we either have to add an aggregation operator or even a new field
        const ops = childMeasures[field];
        for (const op of (0, _util.keys)(ops))if (field in parentMeasures) // add operator to existing measure field
        parentMeasures[field][op] = new Set([
            ...parentMeasures[field][op] ?? [],
            ...ops[op]
        ]);
        else parentMeasures[field] = {
            [op]: ops[op]
        };
    }
}
class AggregateNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new AggregateNode(null, new Set(this.dimensions), (0, _util.duplicate)(this.measures));
    }
    /**
     * @param dimensions string set for dimensions
     * @param measures dictionary mapping field name => dict of aggregation functions and names to use
     */ constructor(parent, dimensions, measures){
        super(parent);
        this.dimensions = dimensions;
        this.measures = measures;
    }
    get groupBy() {
        return this.dimensions;
    }
    static makeFromEncoding(parent, model) {
        let isAggregate = false;
        model.forEachFieldDef((fd)=>{
            if (fd.aggregate) isAggregate = true;
        });
        const meas = {};
        const dims = new Set();
        if (!isAggregate) // no need to create this node if the model has no aggregation
        return null;
        model.forEachFieldDef((fieldDef, channel)=>{
            const { aggregate, field } = fieldDef;
            if (aggregate) {
                if (aggregate === 'count') {
                    meas['*'] ?? (meas['*'] = {});
                    meas['*']['count'] = new Set([
                        (0, _channeldef.vgField)(fieldDef, {
                            forAs: true
                        })
                    ]);
                } else {
                    if ((0, _aggregate.isArgminDef)(aggregate) || (0, _aggregate.isArgmaxDef)(aggregate)) {
                        const op = (0, _aggregate.isArgminDef)(aggregate) ? 'argmin' : 'argmax';
                        const argField = aggregate[op];
                        meas[argField] ?? (meas[argField] = {});
                        meas[argField][op] = new Set([
                            (0, _channeldef.vgField)({
                                op,
                                field: argField
                            }, {
                                forAs: true
                            })
                        ]);
                    } else {
                        meas[field] ?? (meas[field] = {});
                        meas[field][aggregate] = new Set([
                            (0, _channeldef.vgField)(fieldDef, {
                                forAs: true
                            })
                        ]);
                    }
                    // For scale channel with domain === 'unaggregated', add min/max so we can use their union as unaggregated domain
                    if ((0, _channel.isScaleChannel)(channel) && model.scaleDomain(channel) === 'unaggregated') {
                        meas[field] ?? (meas[field] = {});
                        meas[field]['min'] = new Set([
                            (0, _channeldef.vgField)({
                                field,
                                aggregate: 'min'
                            }, {
                                forAs: true
                            })
                        ]);
                        meas[field]['max'] = new Set([
                            (0, _channeldef.vgField)({
                                field,
                                aggregate: 'max'
                            }, {
                                forAs: true
                            })
                        ]);
                    }
                }
            } else addDimension(dims, channel, fieldDef, model);
        });
        if (dims.size + (0, _util.keys)(meas).length === 0) return null;
        return new AggregateNode(parent, dims, meas);
    }
    static makeFromTransform(parent, t) {
        var _a;
        const dims = new Set();
        const meas = {};
        for (const s of t.aggregate){
            const { op, field, as } = s;
            if (op) {
                if (op === 'count') {
                    meas['*'] ?? (meas['*'] = {});
                    meas['*']['count'] = new Set([
                        as ? as : (0, _channeldef.vgField)(s, {
                            forAs: true
                        })
                    ]);
                } else {
                    meas[field] ?? (meas[field] = {});
                    (_a = meas[field])[op] ?? (_a[op] = new Set());
                    meas[field][op].add(as ? as : (0, _channeldef.vgField)(s, {
                        forAs: true
                    }));
                }
            }
        }
        for (const s of t.groupby ?? [])dims.add(s);
        if (dims.size + (0, _util.keys)(meas).length === 0) return null;
        return new AggregateNode(parent, dims, meas);
    }
    merge(other) {
        if ((0, _util.setEqual)(this.dimensions, other.dimensions)) {
            mergeMeasures(this.measures, other.measures);
            return true;
        }
        _log.debug('different dimensions, cannot merge');
        return false;
    }
    addDimensions(fields) {
        fields.forEach(this.dimensions.add, this.dimensions);
    }
    dependentFields() {
        return new Set([
            ...this.dimensions,
            ...(0, _util.keys)(this.measures)
        ]);
    }
    producedFields() {
        const out = new Set();
        for (const field of (0, _util.keys)(this.measures))for (const op of (0, _util.keys)(this.measures[field])){
            const m = this.measures[field][op];
            if (m.size === 0) out.add(`${op}_${field}`);
            else m.forEach(out.add, out);
        }
        return out;
    }
    hash() {
        return `Aggregate ${(0, _util.hash)({
            dimensions: this.dimensions,
            measures: this.measures
        })}`;
    }
    assemble() {
        const ops = [];
        const fields = [];
        const as = [];
        for (const field of (0, _util.keys)(this.measures)){
            for (const op of (0, _util.keys)(this.measures[field]))for (const alias of this.measures[field][op]){
                as.push(alias);
                ops.push(op);
                fields.push(field === '*' ? null : (0, _util.replacePathInField)(field));
            }
        }
        const result = {
            type: 'aggregate',
            groupby: [
                ...this.dimensions
            ].map((0, _util.replacePathInField)),
            ops,
            fields,
            as
        };
        return result;
    }
}

},{"../../aggregate":"d7bUU","../../channel":"liLED","../../channeldef":"dsccb","../../log":"loqTw","../../scale":"bdpXN","../../util":"acUGA","../model":"hQHib","./dataflow":"btJXI","../../mark":"3Z1xx","./timeunit":"iPsUH","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"ce2Ry":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A node that helps us track what fields we are faceting by.
 */ parcelHelpers.export(exports, "FacetNode", ()=>FacetNode);
var _vegaUtil = require("vega-util");
var _bin = require("../../bin");
var _channel = require("../../channel");
var _channeldef = require("../../channeldef");
var _log = require("../../log");
var _scale = require("../../scale");
var _sort = require("../../sort");
var _util = require("../../util");
var _vegaSchema = require("../../vega.schema");
var _component = require("../header/component");
var _domain = require("../scale/domain");
var _calculate = require("./calculate");
var _dataflow = require("./dataflow");
class FacetNode extends (0, _dataflow.DataFlowNode) {
    /**
     * @param model The facet model.
     * @param name The name that this facet source will have.
     * @param data The source data for this facet data.
     */ constructor(parent, model, name, data){
        super(parent);
        this.model = model;
        this.name = name;
        this.data = data;
        for (const channel of (0, _channel.FACET_CHANNELS)){
            const fieldDef = model.facet[channel];
            if (fieldDef) {
                const { bin, sort } = fieldDef;
                this[channel] = {
                    name: model.getName(`${channel}_domain`),
                    fields: [
                        (0, _channeldef.vgField)(fieldDef),
                        ...(0, _bin.isBinning)(bin) ? [
                            (0, _channeldef.vgField)(fieldDef, {
                                binSuffix: 'end'
                            })
                        ] : []
                    ],
                    ...(0, _sort.isSortField)(sort) ? {
                        sortField: sort
                    } : (0, _vegaUtil.isArray)(sort) ? {
                        sortIndexField: (0, _calculate.sortArrayIndexField)(fieldDef, channel)
                    } : {}
                };
            }
        }
        this.childModel = model.child;
    }
    hash() {
        let out = `Facet`;
        for (const channel of (0, _channel.FACET_CHANNELS))if (this[channel]) out += ` ${channel.charAt(0)}:${(0, _util.hash)(this[channel])}`;
        return out;
    }
    get fields() {
        const f = [];
        for (const channel of (0, _channel.FACET_CHANNELS))if (this[channel]?.fields) f.push(...this[channel].fields);
        return f;
    }
    dependentFields() {
        const depFields = new Set(this.fields);
        for (const channel of (0, _channel.FACET_CHANNELS))if (this[channel]) {
            if (this[channel].sortField) depFields.add(this[channel].sortField.field);
            if (this[channel].sortIndexField) depFields.add(this[channel].sortIndexField);
        }
        return depFields;
    }
    producedFields() {
        return new Set(); // facet does not produce any new fields
    }
    /**
     * The name to reference this source is its name.
     */ getSource() {
        return this.name;
    }
    getChildIndependentFieldsWithStep() {
        const childIndependentFieldsWithStep = {};
        for (const channel of (0, _channel.POSITION_SCALE_CHANNELS)){
            const childScaleComponent = this.childModel.component.scales[channel];
            if (childScaleComponent && !childScaleComponent.merged) {
                // independent scale
                const type = childScaleComponent.get('type');
                const range = childScaleComponent.get('range');
                if ((0, _scale.hasDiscreteDomain)(type) && (0, _vegaSchema.isVgRangeStep)(range)) {
                    const domain = (0, _domain.assembleDomain)(this.childModel, channel);
                    const field = (0, _domain.getFieldFromDomain)(domain);
                    if (field) childIndependentFieldsWithStep[channel] = field;
                    else _log.warn(_log.message.unknownField(channel));
                }
            }
        }
        return childIndependentFieldsWithStep;
    }
    assembleRowColumnHeaderData(channel, crossedDataName, childIndependentFieldsWithStep) {
        const childChannel = {
            row: 'y',
            column: 'x',
            facet: undefined
        }[channel];
        const fields = [];
        const ops = [];
        const as = [];
        if (childChannel && childIndependentFieldsWithStep && childIndependentFieldsWithStep[childChannel]) {
            if (crossedDataName) {
                // If there is a crossed data, calculate max
                fields.push(`distinct_${childIndependentFieldsWithStep[childChannel]}`);
                ops.push('max');
            } else {
                // If there is no crossed data, just calculate distinct
                fields.push(childIndependentFieldsWithStep[childChannel]);
                ops.push('distinct');
            }
            // Although it is technically a max, just name it distinct so it's easier to refer to it
            as.push(`distinct_${childIndependentFieldsWithStep[childChannel]}`);
        }
        const { sortField, sortIndexField } = this[channel];
        if (sortField) {
            const { op = (0, _sort.DEFAULT_SORT_OP), field } = sortField;
            fields.push(field);
            ops.push(op);
            as.push((0, _channeldef.vgField)(sortField, {
                forAs: true
            }));
        } else if (sortIndexField) {
            fields.push(sortIndexField);
            ops.push('max');
            as.push(sortIndexField);
        }
        return {
            name: this[channel].name,
            // Use data from the crossed one if it exist
            source: crossedDataName ?? this.data,
            transform: [
                {
                    type: 'aggregate',
                    groupby: this[channel].fields,
                    ...fields.length ? {
                        fields,
                        ops,
                        as
                    } : {}
                }
            ]
        };
    }
    assembleFacetHeaderData(childIndependentFieldsWithStep) {
        const { columns } = this.model.layout;
        const { layoutHeaders } = this.model.component;
        const data = [];
        const hasSharedAxis = {};
        for (const headerChannel of (0, _component.HEADER_CHANNELS)){
            for (const headerType of (0, _component.HEADER_TYPES)){
                const headers = (layoutHeaders[headerChannel] && layoutHeaders[headerChannel][headerType]) ?? [];
                for (const header of headers)if (header.axes?.length > 0) {
                    hasSharedAxis[headerChannel] = true;
                    break;
                }
            }
            if (hasSharedAxis[headerChannel]) {
                const cardinality = `length(data("${this.facet.name}"))`;
                const stop = headerChannel === 'row' ? columns ? {
                    signal: `ceil(${cardinality} / ${columns})`
                } : 1 : columns ? {
                    signal: `min(${cardinality}, ${columns})`
                } : {
                    signal: cardinality
                };
                data.push({
                    name: `${this.facet.name}_${headerChannel}`,
                    transform: [
                        {
                            type: 'sequence',
                            start: 0,
                            stop
                        }
                    ]
                });
            }
        }
        const { row, column } = hasSharedAxis;
        if (row || column) data.unshift(this.assembleRowColumnHeaderData('facet', null, childIndependentFieldsWithStep));
        return data;
    }
    assemble() {
        const data = [];
        let crossedDataName = null;
        const childIndependentFieldsWithStep = this.getChildIndependentFieldsWithStep();
        const { column, row, facet } = this;
        if (column && row && (childIndependentFieldsWithStep.x || childIndependentFieldsWithStep.y)) {
            // Need to create a cross dataset to correctly calculate cardinality
            crossedDataName = `cross_${this.column.name}_${this.row.name}`;
            const fields = [].concat(childIndependentFieldsWithStep.x ?? [], childIndependentFieldsWithStep.y ?? []);
            const ops = fields.map(()=>'distinct');
            data.push({
                name: crossedDataName,
                source: this.data,
                transform: [
                    {
                        type: 'aggregate',
                        groupby: this.fields,
                        fields,
                        ops
                    }
                ]
            });
        }
        for (const channel of [
            (0, _channel.COLUMN),
            (0, _channel.ROW)
        ])if (this[channel]) data.push(this.assembleRowColumnHeaderData(channel, crossedDataName, childIndependentFieldsWithStep));
        if (facet) {
            const facetData = this.assembleFacetHeaderData(childIndependentFieldsWithStep);
            if (facetData) data.push(...facetData);
        }
        return data;
    }
}

},{"vega-util":"7f6sQ","../../bin":"3cpW8","../../channel":"liLED","../../channeldef":"dsccb","../../log":"loqTw","../../scale":"bdpXN","../../sort":"aWnXd","../../util":"acUGA","../../vega.schema":"3mBOT","../header/component":"d5ljn","../scale/domain":"ebJoM","./calculate":"aCN2T","./dataflow":"btJXI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"2mSh3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getImplicitFromFilterTransform", ()=>getImplicitFromFilterTransform);
/**
 * Creates a parse node for implicit parsing from a model and updates ancestorParse.
 */ parcelHelpers.export(exports, "getImplicitFromEncoding", ()=>getImplicitFromEncoding);
/**
 * Creates a parse node for implicit parsing from a model and updates ancestorParse.
 */ parcelHelpers.export(exports, "getImplicitFromSelection", ()=>getImplicitFromSelection);
parcelHelpers.export(exports, "ParseNode", ()=>ParseNode);
var _vegaUtil = require("vega-util");
var _aggregate = require("../../aggregate");
var _channel = require("../../channel");
var _channeldef = require("../../channeldef");
var _data = require("../../data");
var _datetime = require("../../datetime");
var _log = require("../../log");
var _logical = require("../../logical");
var _mark = require("../../mark");
var _predicate = require("../../predicate");
var _sort = require("../../sort");
var _util = require("../../util");
var _common = require("../common");
var _model = require("../model");
var _split = require("../split");
var _dataflow = require("./dataflow");
/**
 * Remove quotes from a string.
 */ function unquote(pattern) {
    if (pattern.startsWith("'") && pattern.endsWith("'") || pattern.startsWith('"') && pattern.endsWith('"')) return pattern.slice(1, -1);
    return pattern;
}
/**
 * @param field The field.
 * @param parse What to parse the field as.
 */ function parseExpression(field, parse) {
    const f = (0, _util.accessPathWithDatum)(field);
    if (parse === 'number') return `toNumber(${f})`;
    else if (parse === 'boolean') return `toBoolean(${f})`;
    else if (parse === 'string') return `toString(${f})`;
    else if (parse === 'date') return `toDate(${f})`;
    else if (parse === 'flatten') return f;
    else if (parse.startsWith('date:')) {
        const specifier = unquote(parse.slice(5, parse.length));
        return `timeParse(${f},'${specifier}')`;
    } else if (parse.startsWith('utc:')) {
        const specifier = unquote(parse.slice(4, parse.length));
        return `utcParse(${f},'${specifier}')`;
    } else {
        _log.warn(_log.message.unrecognizedParse(parse));
        return null;
    }
}
function getImplicitFromFilterTransform(transform) {
    const implicit = {};
    (0, _logical.forEachLeaf)(transform.filter, (filter)=>{
        if ((0, _predicate.isFieldPredicate)(filter)) {
            // Automatically add a parse node for filters with filter objects
            let val = null;
            // For EqualFilter, just use the equal property.
            // For RangeFilter and OneOfFilter, all array members should have
            // the same type, so we only use the first one.
            if ((0, _predicate.isFieldEqualPredicate)(filter)) val = (0, _common.signalRefOrValue)(filter.equal);
            else if ((0, _predicate.isFieldLTEPredicate)(filter)) val = (0, _common.signalRefOrValue)(filter.lte);
            else if ((0, _predicate.isFieldLTPredicate)(filter)) val = (0, _common.signalRefOrValue)(filter.lt);
            else if ((0, _predicate.isFieldGTPredicate)(filter)) val = (0, _common.signalRefOrValue)(filter.gt);
            else if ((0, _predicate.isFieldGTEPredicate)(filter)) val = (0, _common.signalRefOrValue)(filter.gte);
            else if ((0, _predicate.isFieldRangePredicate)(filter)) // FIXME: remove as any
            val = filter.range[0];
            else if ((0, _predicate.isFieldOneOfPredicate)(filter)) val = (filter.oneOf ?? filter.in)[0];
             // else -- for filter expression, we can't infer anything
            if (val) {
                if ((0, _datetime.isDateTime)(val)) implicit[filter.field] = 'date';
                else if ((0, _vegaUtil.isNumber)(val)) implicit[filter.field] = 'number';
                else if ((0, _vegaUtil.isString)(val)) implicit[filter.field] = 'string';
            }
            if (filter.timeUnit) implicit[filter.field] = 'date';
        }
    });
    return implicit;
}
function getImplicitFromEncoding(model) {
    const implicit = {};
    function add(fieldDef) {
        if ((0, _channeldef.isFieldOrDatumDefForTimeFormat)(fieldDef)) implicit[fieldDef.field] = 'date';
        else if (fieldDef.type === 'quantitative' && (0, _aggregate.isMinMaxOp)(fieldDef.aggregate) // we need to parse numbers to support correct min and max
        ) implicit[fieldDef.field] = 'number';
        else if ((0, _util.accessPathDepth)(fieldDef.field) > 1) // For non-date/non-number (strings and booleans), derive a flattened field for a referenced nested field.
        // (Parsing numbers / dates already flattens numeric and temporal fields.)
        {
            if (!(fieldDef.field in implicit)) implicit[fieldDef.field] = 'flatten';
        } else if ((0, _channeldef.isScaleFieldDef)(fieldDef) && (0, _sort.isSortField)(fieldDef.sort) && (0, _util.accessPathDepth)(fieldDef.sort.field) > 1) // Flatten fields that we sort by but that are not otherwise flattened.
        {
            if (!(fieldDef.sort.field in implicit)) implicit[fieldDef.sort.field] = 'flatten';
        }
    }
    if ((0, _model.isUnitModel)(model) || (0, _model.isFacetModel)(model)) // Parse encoded fields
    model.forEachFieldDef((fieldDef, channel)=>{
        if ((0, _channeldef.isTypedFieldDef)(fieldDef)) add(fieldDef);
        else {
            const mainChannel = (0, _channel.getMainRangeChannel)(channel);
            const mainFieldDef = model.fieldDef(mainChannel);
            add({
                ...fieldDef,
                type: mainFieldDef.type
            });
        }
    });
    // Parse quantitative dimension fields of path marks as numbers so that we sort them correctly.
    if ((0, _model.isUnitModel)(model)) {
        const { mark, markDef, encoding } = model;
        if ((0, _mark.isPathMark)(mark) && // No need to sort by dimension if we have a connected scatterplot (order channel is present)
        !model.encoding.order) {
            const dimensionChannel = markDef.orient === 'horizontal' ? 'y' : 'x';
            const dimensionChannelDef = encoding[dimensionChannel];
            if ((0, _channeldef.isFieldDef)(dimensionChannelDef) && dimensionChannelDef.type === 'quantitative' && !(dimensionChannelDef.field in implicit)) implicit[dimensionChannelDef.field] = 'number';
        }
    }
    return implicit;
}
function getImplicitFromSelection(model) {
    const implicit = {};
    if ((0, _model.isUnitModel)(model) && model.component.selection) for (const name of (0, _util.keys)(model.component.selection)){
        const selCmpt = model.component.selection[name];
        for (const proj of selCmpt.project.items)if (!proj.channel && (0, _util.accessPathDepth)(proj.field) > 1) implicit[proj.field] = 'flatten';
    }
    return implicit;
}
class ParseNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new ParseNode(null, (0, _util.duplicate)(this._parse));
    }
    constructor(parent, parse){
        super(parent);
        this._parse = parse;
    }
    hash() {
        return `Parse ${(0, _util.hash)(this._parse)}`;
    }
    /**
     * Creates a parse node from a data.format.parse and updates ancestorParse.
     */ static makeExplicit(parent, model, ancestorParse) {
        // Custom parse
        let explicit = {};
        const data = model.data;
        if (!(0, _data.isGenerator)(data) && data?.format?.parse) explicit = data.format.parse;
        return this.makeWithAncestors(parent, explicit, {}, ancestorParse);
    }
    /**
     * Creates a parse node from "explicit" parse and "implicit" parse and updates ancestorParse.
     */ static makeWithAncestors(parent, explicit, implicit, ancestorParse) {
        // We should not parse what has already been parsed in a parent (explicitly or implicitly) or what has been derived (maked as "derived"). We also don't need to flatten a field that has already been parsed.
        for (const field of (0, _util.keys)(implicit)){
            const parsedAs = ancestorParse.getWithExplicit(field);
            if (parsedAs.value !== undefined) {
                // We always ignore derived fields even if they are implicitly defined because we expect users to create the right types.
                if (parsedAs.explicit || parsedAs.value === implicit[field] || parsedAs.value === 'derived' || implicit[field] === 'flatten') delete implicit[field];
                else _log.warn(_log.message.differentParse(field, implicit[field], parsedAs.value));
            }
        }
        for (const field of (0, _util.keys)(explicit)){
            const parsedAs = ancestorParse.get(field);
            if (parsedAs !== undefined) {
                // Don't parse a field again if it has been parsed with the same type already.
                if (parsedAs === explicit[field]) delete explicit[field];
                else _log.warn(_log.message.differentParse(field, explicit[field], parsedAs));
            }
        }
        const parse = new (0, _split.Split)(explicit, implicit);
        // add the format parse from this model so that children don't parse the same field again
        ancestorParse.copyAll(parse);
        // copy only non-null parses
        const p = {};
        for (const key of (0, _util.keys)(parse.combine())){
            const val = parse.get(key);
            if (val !== null) p[key] = val;
        }
        if ((0, _util.keys)(p).length === 0 || ancestorParse.parseNothing) return null;
        return new ParseNode(parent, p);
    }
    get parse() {
        return this._parse;
    }
    merge(other) {
        this._parse = {
            ...this._parse,
            ...other.parse
        };
        other.remove();
    }
    /**
     * Assemble an object for Vega's format.parse property.
     */ assembleFormatParse() {
        const formatParse = {};
        for (const field of (0, _util.keys)(this._parse)){
            const p = this._parse[field];
            if ((0, _util.accessPathDepth)(field) === 1) formatParse[field] = p;
        }
        return formatParse;
    }
    // format parse depends and produces all fields in its parse
    producedFields() {
        return new Set((0, _util.keys)(this._parse));
    }
    dependentFields() {
        return new Set((0, _util.keys)(this._parse));
    }
    assembleTransforms(onlyNested = false) {
        return (0, _util.keys)(this._parse).filter((field)=>onlyNested ? (0, _util.accessPathDepth)(field) > 1 : true).map((field)=>{
            const expr = parseExpression(field, this._parse[field]);
            if (!expr) return null;
            const formula = {
                type: 'formula',
                expr,
                as: (0, _util.removePathFromField)(field) // Vega output is always flattened
            };
            return formula;
        }).filter((t)=>t !== null);
    }
}

},{"vega-util":"7f6sQ","../../aggregate":"d7bUU","../../channel":"liLED","../../channeldef":"dsccb","../../data":"dILEy","../../datetime":"gp5cf","../../log":"loqTw","../../logical":"ksUsC","../../mark":"3Z1xx","../../predicate":"gynPW","../../sort":"aWnXd","../../util":"acUGA","../common":"jegt8","../model":"hQHib","../split":"eXS2w","./dataflow":"btJXI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cuiH8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IdentifierNode", ()=>IdentifierNode);
var _selection = require("../../selection");
var _dataflow = require("./dataflow");
class IdentifierNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new IdentifierNode(null);
    }
    constructor(parent){
        super(parent);
    }
    dependentFields() {
        return new Set();
    }
    producedFields() {
        return new Set([
            (0, _selection.SELECTION_ID)
        ]);
    }
    hash() {
        return 'Identifier';
    }
    assemble() {
        return {
            type: 'identifier',
            as: (0, _selection.SELECTION_ID)
        };
    }
}

},{"../../selection":"jtWSq","./dataflow":"btJXI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"b8isi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Whether this dataflow node is the source of the dataflow that produces data i.e. a source or a generator.
 */ parcelHelpers.export(exports, "isDataSourceNode", ()=>isDataSourceNode);
/**
 * Abstract base class for Dataflow optimizers.
 * Contains only mutation handling logic. Subclasses need to implement iteration logic.
 */ parcelHelpers.export(exports, "Optimizer", ()=>Optimizer);
/**
 * Starts from a node and runs the optimization function (the "run" method) upwards to the root,
 * depending on the continue and modified flag values returned by the optimization function.
 */ parcelHelpers.export(exports, "BottomUpOptimizer", ()=>BottomUpOptimizer);
/**
 * The optimizer function (the "run" method), is invoked on the given node and then continues recursively.
 */ parcelHelpers.export(exports, "TopDownOptimizer", ()=>TopDownOptimizer);
var _graticule = require("./graticule");
var _sequence = require("./sequence");
var _source = require("./source");
var __classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var __classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Optimizer_modified;
function isDataSourceNode(node) {
    return node instanceof (0, _source.SourceNode) || node instanceof (0, _graticule.GraticuleNode) || node instanceof (0, _sequence.SequenceNode);
}
class Optimizer {
    constructor(){
        _Optimizer_modified.set(this, void 0);
        __classPrivateFieldSet(this, _Optimizer_modified, false, "f");
    }
    // Once true, #modified is never set to false
    setModified() {
        __classPrivateFieldSet(this, _Optimizer_modified, true, "f");
    }
    get modifiedFlag() {
        return __classPrivateFieldGet(this, _Optimizer_modified, "f");
    }
}
_Optimizer_modified = new WeakMap();
class BottomUpOptimizer extends Optimizer {
    /**
     * Compute a map of node depths that we can use to determine a topological sort order.
     */ getNodeDepths(node, depth, depths) {
        depths.set(node, depth);
        for (const child of node.children)this.getNodeDepths(child, depth + 1, depths);
        return depths;
    }
    /**
     * Run the optimizer on all nodes starting from the leaves.
     */ optimize(node) {
        const depths = this.getNodeDepths(node, 0, new Map());
        const topologicalSort = [
            ...depths.entries()
        ].sort((a, b)=>b[1] - a[1]);
        for (const tuple of topologicalSort)this.run(tuple[0]);
        return this.modifiedFlag;
    }
}
class TopDownOptimizer extends Optimizer {
    /**
     * Run the optimizer depth first on all nodes starting from the roots.
     */ optimize(node) {
        this.run(node);
        for (const child of node.children)this.optimize(child);
        return this.modifiedFlag;
    }
}

},{"./graticule":"84yrw","./sequence":"jQuXh","./source":"bhsCG","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"84yrw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraticuleNode", ()=>GraticuleNode);
var _util = require("../../util");
var _dataflow = require("./dataflow");
class GraticuleNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new GraticuleNode(null, this.params);
    }
    constructor(parent, params){
        super(parent);
        this.params = params;
    }
    dependentFields() {
        return new Set();
    }
    producedFields() {
        return undefined; // there should never be a node before graticule
    }
    hash() {
        return `Graticule ${(0, _util.hash)(this.params)}`;
    }
    assemble() {
        return {
            type: 'graticule',
            ...this.params === true ? {} : this.params
        };
    }
}

},{"../../util":"acUGA","./dataflow":"btJXI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"jQuXh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SequenceNode", ()=>SequenceNode);
var _util = require("../../util");
var _dataflow = require("./dataflow");
class SequenceNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new SequenceNode(null, this.params);
    }
    constructor(parent, params){
        super(parent);
        this.params = params;
    }
    dependentFields() {
        return new Set();
    }
    producedFields() {
        return new Set([
            this.params.as ?? 'data'
        ]);
    }
    hash() {
        return `Hash ${(0, _util.hash)(this.params)}`;
    }
    assemble() {
        return {
            type: 'sequence',
            ...this.params
        };
    }
}

},{"../../util":"acUGA","./dataflow":"btJXI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bhsCG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SourceNode", ()=>SourceNode);
var _data = require("../../data");
var _util = require("../../util");
var _dataflow = require("./dataflow");
class SourceNode extends (0, _dataflow.DataFlowNode) {
    constructor(data){
        super(null); // source cannot have parent
        data ?? (data = {
            name: 'source'
        });
        let format;
        if (!(0, _data.isGenerator)(data)) format = data.format ? {
            ...(0, _util.omit)(data.format, [
                'parse'
            ])
        } : {};
        if ((0, _data.isInlineData)(data)) this._data = {
            values: data.values
        };
        else if ((0, _data.isUrlData)(data)) {
            this._data = {
                url: data.url
            };
            if (!format.type) {
                // Extract extension from URL using snippet from
                // http://stackoverflow.com/questions/680929/how-to-extract-extension-from-filename-string-in-javascript
                let defaultExtension = /(?:\.([^.]+))?$/.exec(data.url)[1];
                if (!(0, _util.contains)([
                    'json',
                    'csv',
                    'tsv',
                    'dsv',
                    'topojson'
                ], defaultExtension)) defaultExtension = 'json';
                // defaultExtension has type string but we ensure that it is DataFormatType above
                format.type = defaultExtension;
            }
        } else if ((0, _data.isSphereGenerator)(data)) // hardwire GeoJSON sphere data into output specification
        this._data = {
            values: [
                {
                    type: 'Sphere'
                }
            ]
        };
        else if ((0, _data.isNamedData)(data) || (0, _data.isGenerator)(data)) this._data = {};
        // set flag to check if generator
        this._generator = (0, _data.isGenerator)(data);
        // any dataset can be named
        if (data.name) this._name = data.name;
        if (format && !(0, _util.isEmpty)(format)) this._data.format = format;
    }
    dependentFields() {
        return new Set();
    }
    producedFields() {
        return undefined; // we don't know what this source produces
    }
    get data() {
        return this._data;
    }
    hasName() {
        return !!this._name;
    }
    get isGenerator() {
        return this._generator;
    }
    get dataName() {
        return this._name;
    }
    set dataName(name) {
        this._name = name;
    }
    set parent(parent) {
        throw new Error('Source nodes have to be roots.');
    }
    remove() {
        throw new Error('Source nodes are roots and cannot be removed.');
    }
    hash() {
        throw new Error('Cannot hash sources');
    }
    assemble() {
        return {
            name: this._name,
            ...this._data,
            transform: []
        };
    }
}

},{"../../data":"dILEy","../../util":"acUGA","./dataflow":"btJXI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"ihCUR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Move facet nodes down to the next fork or output node. Also pull the main output with the facet node.
 * After moving down the facet node, make a copy of the subtree and make it a child of the main output.
 */ parcelHelpers.export(exports, "moveFacetDown", ()=>moveFacetDown);
var _data = require("../../data");
var _aggregate = require("./aggregate");
var _dataflow = require("./dataflow");
var _facet = require("./facet");
var _joinaggregate = require("./joinaggregate");
var _optimize = require("./optimize");
var _stack = require("./stack");
var _window = require("./window");
/**
 * Clones the subtree and ignores output nodes except for the leaves, which are renamed.
 */ function cloneSubtree(facet) {
    function clone(node) {
        if (!(node instanceof (0, _facet.FacetNode))) {
            const copy = node.clone();
            if (copy instanceof (0, _dataflow.OutputNode)) {
                const newName = (0, _optimize.FACET_SCALE_PREFIX) + copy.getSource();
                copy.setSource(newName);
                facet.model.component.data.outputNodes[newName] = copy;
            } else if (copy instanceof (0, _aggregate.AggregateNode) || copy instanceof (0, _stack.StackNode) || copy instanceof (0, _window.WindowTransformNode) || copy instanceof (0, _joinaggregate.JoinAggregateTransformNode)) copy.addDimensions(facet.fields);
            for (const n of node.children.flatMap(clone))n.parent = copy;
            return [
                copy
            ];
        }
        return node.children.flatMap(clone);
    }
    return clone;
}
function moveFacetDown(node) {
    if (node instanceof (0, _facet.FacetNode)) {
        if (node.numChildren() === 1 && !(node.children[0] instanceof (0, _dataflow.OutputNode))) {
            // move down until we hit a fork or output node
            const child = node.children[0];
            if (child instanceof (0, _aggregate.AggregateNode) || child instanceof (0, _stack.StackNode) || child instanceof (0, _window.WindowTransformNode) || child instanceof (0, _joinaggregate.JoinAggregateTransformNode)) child.addDimensions(node.fields);
            child.swapWithParent();
            moveFacetDown(node);
        } else {
            // move main to facet
            const facetMain = node.model.component.data.main;
            moveMainDownToFacet(facetMain);
            // replicate the subtree and place it before the facet's main node
            const cloner = cloneSubtree(node);
            const copy = node.children.map(cloner).flat();
            for (const c of copy)c.parent = facetMain;
        }
    } else node.children.map(moveFacetDown);
}
function moveMainDownToFacet(node) {
    if (node instanceof (0, _dataflow.OutputNode) && node.type === (0, _data.DataSourceType).Main) {
        if (node.numChildren() === 1) {
            const child = node.children[0];
            if (!(child instanceof (0, _facet.FacetNode))) {
                child.swapWithParent();
                moveMainDownToFacet(node);
            }
        }
    }
}

},{"../../data":"dILEy","./aggregate":"8WvlR","./dataflow":"btJXI","./facet":"ce2Ry","./joinaggregate":"fFW6U","./optimize":"kc01N","./stack":"2WMdr","./window":"gHMn4","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"fFW6U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A class for the join aggregate transform nodes.
 */ parcelHelpers.export(exports, "JoinAggregateTransformNode", ()=>JoinAggregateTransformNode);
var _channeldef = require("../../channeldef");
var _util = require("../../util");
var _dataflow = require("./dataflow");
class JoinAggregateTransformNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new JoinAggregateTransformNode(null, (0, _util.duplicate)(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
    }
    addDimensions(fields) {
        this.transform.groupby = (0, _util.unique)(this.transform.groupby.concat(fields), (d)=>d);
    }
    dependentFields() {
        const out = new Set();
        if (this.transform.groupby) this.transform.groupby.forEach(out.add, out);
        this.transform.joinaggregate.map((w)=>w.field).filter((f)=>f !== undefined).forEach(out.add, out);
        return out;
    }
    producedFields() {
        return new Set(this.transform.joinaggregate.map(this.getDefaultName));
    }
    getDefaultName(joinAggregateFieldDef) {
        return joinAggregateFieldDef.as ?? (0, _channeldef.vgField)(joinAggregateFieldDef);
    }
    hash() {
        return `JoinAggregateTransform ${(0, _util.hash)(this.transform)}`;
    }
    assemble() {
        const fields = [];
        const ops = [];
        const as = [];
        for (const joinaggregate of this.transform.joinaggregate){
            ops.push(joinaggregate.op);
            as.push(this.getDefaultName(joinaggregate));
            fields.push(joinaggregate.field === undefined ? null : joinaggregate.field);
        }
        const groupby = this.transform.groupby;
        return {
            type: 'joinaggregate',
            as,
            ops,
            fields,
            ...groupby !== undefined ? {
                groupby
            } : {}
        };
    }
}

},{"../../channeldef":"dsccb","../../util":"acUGA","./dataflow":"btJXI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"2WMdr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StackNode", ()=>StackNode);
var _vegaUtil = require("vega-util");
var _channeldef = require("../../channeldef");
var _util = require("../../util");
var _common = require("../common");
var _dataflow = require("./dataflow");
var _filterinvalid = require("./filterinvalid");
function getStackByFields(model) {
    return model.stack.stackBy.reduce((fields, by)=>{
        const fieldDef = by.fieldDef;
        const _field = (0, _channeldef.vgField)(fieldDef);
        if (_field) fields.push(_field);
        return fields;
    }, []);
}
function isValidAsArray(as) {
    return (0, _vegaUtil.isArray)(as) && as.every((s)=>(0, _vegaUtil.isString)(s)) && as.length > 1;
}
class StackNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new StackNode(null, (0, _util.duplicate)(this._stack));
    }
    constructor(parent, stack){
        super(parent);
        this._stack = stack;
    }
    static makeFromTransform(parent, stackTransform) {
        const { stack, groupby, as, offset = 'zero' } = stackTransform;
        const sortFields = [];
        const sortOrder = [];
        if (stackTransform.sort !== undefined) for (const sortField of stackTransform.sort){
            sortFields.push(sortField.field);
            sortOrder.push((0, _util.getFirstDefined)(sortField.order, 'ascending'));
        }
        const sort = {
            field: sortFields,
            order: sortOrder
        };
        let normalizedAs;
        if (isValidAsArray(as)) normalizedAs = as;
        else if ((0, _vegaUtil.isString)(as)) normalizedAs = [
            as,
            `${as}_end`
        ];
        else normalizedAs = [
            `${stackTransform.stack}_start`,
            `${stackTransform.stack}_end`
        ];
        return new StackNode(parent, {
            dimensionFieldDefs: [],
            stackField: stack,
            groupby,
            offset,
            sort,
            facetby: [],
            as: normalizedAs
        });
    }
    static makeFromEncoding(parent, model) {
        const stackProperties = model.stack;
        const { encoding } = model;
        if (!stackProperties) return null;
        const { groupbyChannels, fieldChannel, offset, impute } = stackProperties;
        const dimensionFieldDefs = groupbyChannels.map((groupbyChannel)=>{
            const cDef = encoding[groupbyChannel];
            return (0, _channeldef.getFieldDef)(cDef);
        }).filter((def)=>!!def);
        const stackby = getStackByFields(model);
        const orderDef = model.encoding.order;
        let sort;
        if ((0, _vegaUtil.isArray)(orderDef) || (0, _channeldef.isFieldDef)(orderDef)) sort = (0, _common.sortParams)(orderDef);
        else {
            const sortOrder = (0, _channeldef.isOrderOnlyDef)(orderDef) ? orderDef.sort : fieldChannel === 'y' ? 'descending' : 'ascending';
            // default = descending by stackFields
            // FIXME is the default here correct for binned fields?
            sort = stackby.reduce((s, field)=>{
                if (!s.field.includes(field)) {
                    s.field.push(field);
                    s.order.push(sortOrder);
                }
                return s;
            }, {
                field: [],
                order: []
            });
        }
        return new StackNode(parent, {
            dimensionFieldDefs,
            stackField: model.vgField(fieldChannel),
            facetby: [],
            stackby,
            sort,
            offset,
            impute,
            as: [
                model.vgField(fieldChannel, {
                    suffix: 'start',
                    forAs: true
                }),
                model.vgField(fieldChannel, {
                    suffix: 'end',
                    forAs: true
                })
            ]
        });
    }
    get stack() {
        return this._stack;
    }
    addDimensions(fields) {
        this._stack.facetby.push(...fields);
    }
    dependentFields() {
        const out = new Set();
        out.add(this._stack.stackField);
        this.getGroupbyFields().forEach(out.add, out);
        this._stack.facetby.forEach(out.add, out);
        this._stack.sort.field.forEach(out.add, out);
        return out;
    }
    producedFields() {
        return new Set(this._stack.as);
    }
    hash() {
        return `Stack ${(0, _util.hash)(this._stack)}`;
    }
    getGroupbyFields() {
        const { dimensionFieldDefs, impute, groupby } = this._stack;
        if (dimensionFieldDefs.length > 0) return dimensionFieldDefs.map((dimensionFieldDef)=>{
            if (dimensionFieldDef.bin) {
                if (impute) // For binned group by field with impute, we calculate bin_mid
                // as we cannot impute two fields simultaneously
                return [
                    (0, _channeldef.vgField)(dimensionFieldDef, {
                        binSuffix: 'mid'
                    })
                ];
                return [
                    // For binned group by field without impute, we need both bin (start) and bin_end
                    (0, _channeldef.vgField)(dimensionFieldDef, {}),
                    (0, _channeldef.vgField)(dimensionFieldDef, {
                        binSuffix: 'end'
                    })
                ];
            }
            return [
                (0, _channeldef.vgField)(dimensionFieldDef)
            ];
        }).flat();
        return groupby ?? [];
    }
    assemble() {
        const transform = [];
        const { facetby, dimensionFieldDefs, stackField: field, stackby, sort, offset, impute, as } = this._stack;
        // Impute
        if (impute) for (const dimensionFieldDef of dimensionFieldDefs){
            const { bandPosition = 0.5, bin } = dimensionFieldDef;
            if (bin) {
                // As we can only impute one field at a time, we need to calculate
                // mid point for a binned field
                const binStart = (0, _channeldef.vgField)(dimensionFieldDef, {
                    expr: 'datum'
                });
                const binEnd = (0, _channeldef.vgField)(dimensionFieldDef, {
                    expr: 'datum',
                    binSuffix: 'end'
                });
                transform.push({
                    type: 'formula',
                    expr: `${(0, _filterinvalid.isValidFiniteNumberExpr)(binStart)} ? ${bandPosition}*${binStart}+${1 - bandPosition}*${binEnd} : ${binStart}`,
                    as: (0, _channeldef.vgField)(dimensionFieldDef, {
                        binSuffix: 'mid',
                        forAs: true
                    })
                });
            }
            transform.push({
                type: 'impute',
                field,
                groupby: [
                    ...stackby,
                    ...facetby
                ],
                key: (0, _channeldef.vgField)(dimensionFieldDef, {
                    binSuffix: 'mid'
                }),
                method: 'value',
                value: 0
            });
        }
        // Stack
        transform.push({
            type: 'stack',
            groupby: [
                ...this.getGroupbyFields(),
                ...facetby
            ],
            field,
            sort,
            as,
            offset
        });
        return transform;
    }
}

},{"vega-util":"7f6sQ","../../channeldef":"dsccb","../../util":"acUGA","../common":"jegt8","./dataflow":"btJXI","./filterinvalid":"2Zybg","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"2Zybg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterInvalidNode", ()=>FilterInvalidNode);
parcelHelpers.export(exports, "isValidFiniteNumberExpr", ()=>isValidFiniteNumberExpr);
var _channel = require("../../channel");
var _channeldef = require("../../channeldef");
var _util = require("../../util");
var _scaleInvalidDataMode = require("../invalid/ScaleInvalidDataMode");
var _dataflow = require("./dataflow");
var _aggregate = require("../../aggregate");
class FilterInvalidNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new FilterInvalidNode(null, {
            ...this.filter
        });
    }
    constructor(parent, filter){
        super(parent);
        this.filter = filter;
    }
    static make(parent, model, dataSourcesForHandlingInvalidValues) {
        const { config, markDef } = model;
        const { marks, scales } = dataSourcesForHandlingInvalidValues;
        if (marks === 'include-invalid-values' && scales === 'include-invalid-values') // If neither marks nor scale domains need data source to filter null values, then don't add the filter.
        return null;
        const filter = model.reduceFieldDef((aggregator, fieldDef, channel)=>{
            const scaleComponent = (0, _channel.isScaleChannel)(channel) && model.getScaleComponent(channel);
            if (scaleComponent) {
                const scaleType = scaleComponent.get('type');
                const { aggregate } = fieldDef;
                const invalidDataMode = (0, _scaleInvalidDataMode.getScaleInvalidDataMode)({
                    scaleChannel: channel,
                    markDef,
                    config,
                    scaleType,
                    isCountAggregate: (0, _aggregate.isCountingAggregateOp)(aggregate)
                });
                // If the invalid data mode is include or always-valid, we don't need to filter invalid values as the scale can handle invalid values.
                if (invalidDataMode !== 'show' && invalidDataMode !== 'always-valid') aggregator[fieldDef.field] = fieldDef; // we know that the fieldDef is a typed field def
            }
            return aggregator;
        }, {});
        if (!(0, _util.keys)(filter).length) return null;
        return new FilterInvalidNode(parent, filter);
    }
    dependentFields() {
        return new Set((0, _util.keys)(this.filter));
    }
    producedFields() {
        return new Set(); // filter does not produce any new fields
    }
    hash() {
        return `FilterInvalid ${(0, _util.hash)(this.filter)}`;
    }
    /**
     * Create the VgTransforms for each of the filtered fields.
     */ assemble() {
        const filters = (0, _util.keys)(this.filter).reduce((vegaFilters, field)=>{
            const fieldDef = this.filter[field];
            const ref = (0, _channeldef.vgField)(fieldDef, {
                expr: 'datum'
            });
            if (fieldDef !== null) {
                if (fieldDef.type === 'temporal') vegaFilters.push(`(isDate(${ref}) || (${isValidFiniteNumberExpr(ref)}))`);
                else if (fieldDef.type === 'quantitative') vegaFilters.push(isValidFiniteNumberExpr(ref));
            }
            return vegaFilters;
        }, []);
        return filters.length > 0 ? {
            type: 'filter',
            expr: filters.join(' && ')
        } : null;
    }
}
function isValidFiniteNumberExpr(ref) {
    return `isValid(${ref}) && isFinite(+${ref})`;
}

},{"../../channel":"liLED","../../channeldef":"dsccb","../../util":"acUGA","../invalid/ScaleInvalidDataMode":"1nWTz","./dataflow":"btJXI","../../aggregate":"d7bUU","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"gHMn4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A class for the window transform nodes
 */ parcelHelpers.export(exports, "WindowTransformNode", ()=>WindowTransformNode);
var _aggregate = require("../../aggregate");
var _channeldef = require("../../channeldef");
var _util = require("../../util");
var _dataflow = require("./dataflow");
class WindowTransformNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new WindowTransformNode(null, (0, _util.duplicate)(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
    }
    addDimensions(fields) {
        this.transform.groupby = (0, _util.unique)(this.transform.groupby.concat(fields), (d)=>d);
    }
    dependentFields() {
        const out = new Set();
        (this.transform.groupby ?? []).forEach(out.add, out);
        (this.transform.sort ?? []).forEach((m)=>out.add(m.field));
        this.transform.window.map((w)=>w.field).filter((f)=>f !== undefined).forEach(out.add, out);
        return out;
    }
    producedFields() {
        return new Set(this.transform.window.map(this.getDefaultName));
    }
    getDefaultName(windowFieldDef) {
        return windowFieldDef.as ?? (0, _channeldef.vgField)(windowFieldDef);
    }
    hash() {
        return `WindowTransform ${(0, _util.hash)(this.transform)}`;
    }
    assemble() {
        const fields = [];
        const ops = [];
        const as = [];
        const params = [];
        for (const window of this.transform.window){
            ops.push(window.op);
            as.push(this.getDefaultName(window));
            params.push(window.param === undefined ? null : window.param);
            fields.push(window.field === undefined ? null : window.field);
        }
        const frame = this.transform.frame;
        const groupby = this.transform.groupby;
        if (frame && frame[0] === null && frame[1] === null && ops.every((o)=>(0, _aggregate.isAggregateOp)(o))) // when the window does not rely on any particular window ops or frame, switch to a simpler and more efficient joinaggregate
        return {
            type: 'joinaggregate',
            as,
            ops: ops,
            fields,
            ...groupby !== undefined ? {
                groupby
            } : {}
        };
        const sortFields = [];
        const sortOrder = [];
        if (this.transform.sort !== undefined) for (const sortField of this.transform.sort){
            sortFields.push(sortField.field);
            sortOrder.push(sortField.order ?? 'ascending');
        }
        const sort = {
            field: sortFields,
            order: sortOrder
        };
        const ignorePeers = this.transform.ignorePeers;
        return {
            type: 'window',
            params,
            as,
            ops,
            fields,
            sort,
            ...ignorePeers !== undefined ? {
                ignorePeers
            } : {},
            ...groupby !== undefined ? {
                groupby
            } : {},
            ...frame !== undefined ? {
                frame
            } : {}
        };
    }
}

},{"../../aggregate":"d7bUU","../../channeldef":"dsccb","../../util":"acUGA","./dataflow":"btJXI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4fHcn":[function(require,module,exports,__globalThis) {
/**
 * A class that behaves like a SignalRef but lazily generates the signal.
 * The provided generator function should use `Model.getSignalName` to use the correct signal name.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SignalRefWrapper", ()=>SignalRefWrapper);
class SignalRefWrapper {
    constructor(exprGenerator){
        Object.defineProperty(this, 'signal', {
            enumerable: true,
            get: exprGenerator
        });
    }
    static fromName(rename, signalName) {
        return new SignalRefWrapper(()=>rename(signalName));
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3mgst":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseScales", ()=>parseScales);
parcelHelpers.export(exports, "parseScaleCore", ()=>parseScaleCore);
var _channel = require("../../channel");
var _channeldef = require("../../channeldef");
var _encoding = require("../../encoding");
var _mark = require("../../mark");
var _scale = require("../../scale");
var _type = require("../../type");
var _util = require("../../util");
var _model = require("../model");
var _resolve = require("../resolve");
var _split = require("../split");
var _component = require("./component");
var _domain = require("./domain");
var _properties = require("./properties");
var _type1 = require("./type");
function parseScales(model, { ignoreRange } = {}) {
    parseScaleCore(model);
    (0, _domain.parseScaleDomain)(model);
    for (const prop of (0, _scale.NON_TYPE_DOMAIN_RANGE_VEGA_SCALE_PROPERTIES))(0, _properties.parseScaleProperty)(model, prop);
    if (!ignoreRange) // range depends on zero
    (0, _properties.parseScaleRange)(model);
}
function parseScaleCore(model) {
    if ((0, _model.isUnitModel)(model)) model.component.scales = parseUnitScaleCore(model);
    else model.component.scales = parseNonUnitScaleCore(model);
}
/**
 * Parse scales for all channels of a model.
 */ function parseUnitScaleCore(model) {
    const { encoding, mark, markDef } = model;
    const scaleComponents = {};
    for (const channel of (0, _channel.SCALE_CHANNELS)){
        const fieldOrDatumDef = (0, _channeldef.getFieldOrDatumDef)(encoding[channel]); // must be typed def to have scale
        // Don't generate scale for shape of geoshape
        if (fieldOrDatumDef && mark === (0, _mark.GEOSHAPE) && channel === (0, _channel.SHAPE) && fieldOrDatumDef.type === (0, _type.GEOJSON)) continue;
        let specifiedScale = fieldOrDatumDef && fieldOrDatumDef.scale;
        if (fieldOrDatumDef && specifiedScale !== null && specifiedScale !== false) {
            specifiedScale ?? (specifiedScale = {});
            const hasNestedOffsetScale = (0, _encoding.channelHasNestedOffsetScale)(encoding, channel);
            const sType = (0, _type1.scaleType)(specifiedScale, channel, fieldOrDatumDef, markDef, hasNestedOffsetScale);
            scaleComponents[channel] = new (0, _component.ScaleComponent)(model.scaleName(`${channel}`, true), {
                value: sType,
                explicit: specifiedScale.type === sType
            });
        }
    }
    return scaleComponents;
}
const scaleTypeTieBreaker = (0, _split.tieBreakByComparing)((st1, st2)=>(0, _scale.scaleTypePrecedence)(st1) - (0, _scale.scaleTypePrecedence)(st2));
function parseNonUnitScaleCore(model) {
    var _a;
    const scaleComponents = model.component.scales = {};
    const scaleTypeWithExplicitIndex = {};
    const resolve = model.component.resolve;
    // Parse each child scale and determine if a particular channel can be merged.
    for (const child of model.children){
        parseScaleCore(child);
        // Instead of always merging right away -- check if it is compatible to merge first!
        for (const channel of (0, _util.keys)(child.component.scales)){
            // if resolve is undefined, set default first
            (_a = resolve.scale)[channel] ?? (_a[channel] = (0, _resolve.defaultScaleResolve)(channel, model));
            if (resolve.scale[channel] === 'shared') {
                const explicitScaleType = scaleTypeWithExplicitIndex[channel];
                const childScaleType = child.component.scales[channel].getWithExplicit('type');
                if (explicitScaleType) {
                    if ((0, _scale.scaleCompatible)(explicitScaleType.value, childScaleType.value)) // merge scale component if type are compatible
                    scaleTypeWithExplicitIndex[channel] = (0, _split.mergeValuesWithExplicit)(explicitScaleType, childScaleType, 'type', 'scale', scaleTypeTieBreaker);
                    else {
                        // Otherwise, update conflicting channel to be independent
                        resolve.scale[channel] = 'independent';
                        // Remove from the index so they don't get merged
                        delete scaleTypeWithExplicitIndex[channel];
                    }
                } else scaleTypeWithExplicitIndex[channel] = childScaleType;
            }
        }
    }
    // Merge each channel listed in the index
    for (const channel of (0, _util.keys)(scaleTypeWithExplicitIndex)){
        // Create new merged scale component
        const name = model.scaleName(channel, true);
        const typeWithExplicit = scaleTypeWithExplicitIndex[channel];
        scaleComponents[channel] = new (0, _component.ScaleComponent)(name, typeWithExplicit);
        // rename each child and mark them as merged
        for (const child of model.children){
            const childScale = child.component.scales[channel];
            if (childScale) {
                child.renameScale(childScale.get('name'), name);
                childScale.merged = true;
            }
        }
    }
    return scaleComponents;
}

},{"../../channel":"liLED","../../channeldef":"dsccb","../../encoding":"2Ohsj","../../mark":"3Z1xx","../../scale":"bdpXN","../../type":"cbWGP","../../util":"acUGA","../model":"hQHib","../resolve":"felCG","../split":"eXS2w","./component":"e46mO","./domain":"ebJoM","./properties":"iR6WX","./type":"jo2CZ","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"e46mO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScaleComponent", ()=>ScaleComponent);
var _vegaUtil = require("vega-util");
var _scale = require("../../scale");
var _util = require("../../util");
var _split = require("../split");
class ScaleComponent extends (0, _split.Split) {
    constructor(name, typeWithExplicit){
        super({}, {
            name
        } // name as initial implicit property
        );
        this.merged = false;
        this.setWithExplicit('type', typeWithExplicit);
    }
    /**
     * Whether the scale definitely includes or not include zero in the domain
     */ domainHasZero() {
        const scaleType = this.get('type');
        if ((0, _util.contains)([
            (0, _scale.ScaleType).LOG,
            (0, _scale.ScaleType).TIME,
            (0, _scale.ScaleType).UTC
        ], scaleType)) // Log scales cannot have zero.
        // Zero in time scale is arbitrary, and does not affect ratio.
        // (Time is an interval level of measurement, not ratio).
        // See https://en.wikipedia.org/wiki/Level_of_measurement for more info.
        return 'definitely-not';
        const scaleZero = this.get('zero');
        if (scaleZero === true || // If zero is undefined, linear/sqrt/pow scales have zero by default.
        scaleZero === undefined && (0, _util.contains)([
            (0, _scale.ScaleType).LINEAR,
            (0, _scale.ScaleType).SQRT,
            (0, _scale.ScaleType).POW
        ], scaleType)) return 'definitely';
        const domains = this.get('domains');
        if (domains.length > 0) {
            let hasExplicitDomainWithZero = false;
            let hasExplicitDomainWithoutZero = false;
            let hasDomainBasedOnField = false;
            for (const d of domains){
                if ((0, _vegaUtil.isArray)(d)) {
                    const first = d[0];
                    const last = d[d.length - 1];
                    if ((0, _vegaUtil.isNumber)(first) && (0, _vegaUtil.isNumber)(last)) {
                        if (first <= 0 && last >= 0) {
                            hasExplicitDomainWithZero = true;
                            continue;
                        } else {
                            hasExplicitDomainWithoutZero = true;
                            continue;
                        }
                    }
                }
                hasDomainBasedOnField = true;
            }
            if (hasExplicitDomainWithZero) return 'definitely';
            else if (hasExplicitDomainWithoutZero && !hasDomainBasedOnField) return 'definitely-not';
        }
        return 'maybe';
    }
}

},{"vega-util":"7f6sQ","../../scale":"bdpXN","../../util":"acUGA","../split":"eXS2w","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"iR6WX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseScaleProperty", ()=>parseScaleProperty);
parcelHelpers.export(exports, "scaleRules", ()=>scaleRules);
// This method is here rather than in range.ts to avoid circular dependency.
parcelHelpers.export(exports, "parseScaleRange", ()=>parseScaleRange);
parcelHelpers.export(exports, "parseNonUnitScaleProperty", ()=>parseNonUnitScaleProperty);
parcelHelpers.export(exports, "bins", ()=>bins);
parcelHelpers.export(exports, "interpolate", ()=>interpolate);
parcelHelpers.export(exports, "nice", ()=>nice);
parcelHelpers.export(exports, "padding", ()=>padding);
parcelHelpers.export(exports, "paddingInner", ()=>paddingInner);
parcelHelpers.export(exports, "paddingOuter", ()=>paddingOuter);
parcelHelpers.export(exports, "reverse", ()=>reverse);
parcelHelpers.export(exports, "zero", ()=>zero);
var _vegaUtil = require("vega-util");
var _bin = require("../../bin");
var _channel = require("../../channel");
var _channeldef = require("../../channeldef");
var _datetime = require("../../datetime");
var _encoding = require("../../encoding");
var _log = require("../../log");
var _scale = require("../../scale");
var _util = require("../../util");
var _vegaSchema = require("../../vega.schema");
var _bin1 = require("../data/bin");
var _model = require("../model");
var _signal = require("../signal");
var _split = require("../split");
var _range = require("./range");
function parseScaleProperty(model, property) {
    if ((0, _model.isUnitModel)(model)) parseUnitScaleProperty(model, property);
    else parseNonUnitScaleProperty(model, property);
}
function parseUnitScaleProperty(model, property) {
    const localScaleComponents = model.component.scales;
    const { config, encoding, markDef, specifiedScales } = model;
    for (const channel of (0, _util.keys)(localScaleComponents)){
        const specifiedScale = specifiedScales[channel];
        const localScaleCmpt = localScaleComponents[channel];
        const mergedScaleCmpt = model.getScaleComponent(channel);
        const fieldOrDatumDef = (0, _channeldef.getFieldOrDatumDef)(encoding[channel]);
        const specifiedValue = specifiedScale[property];
        const scaleType = mergedScaleCmpt.get('type');
        const scalePadding = mergedScaleCmpt.get('padding');
        const scalePaddingInner = mergedScaleCmpt.get('paddingInner');
        const supportedByScaleType = (0, _scale.scaleTypeSupportProperty)(scaleType, property);
        const channelIncompatability = (0, _scale.channelScalePropertyIncompatability)(channel, property);
        if (specifiedValue !== undefined) {
            // If there is a specified value, check if it is compatible with scale type and channel
            if (!supportedByScaleType) _log.warn(_log.message.scalePropertyNotWorkWithScaleType(scaleType, property, channel));
            else if (channelIncompatability) // channel
            _log.warn(channelIncompatability);
        }
        if (supportedByScaleType && channelIncompatability === undefined) {
            if (specifiedValue !== undefined) {
                const timeUnit = fieldOrDatumDef.timeUnit;
                const type = fieldOrDatumDef.type;
                switch(property){
                    // domainMax/Min to signal if the value is a datetime object
                    case 'domainMax':
                    case 'domainMin':
                        if ((0, _datetime.isDateTime)(specifiedScale[property]) || type === 'temporal' || timeUnit) localScaleCmpt.set(property, {
                            signal: (0, _channeldef.valueExpr)(specifiedScale[property], {
                                type,
                                timeUnit
                            })
                        }, true);
                        else localScaleCmpt.set(property, specifiedScale[property], true);
                        break;
                    default:
                        localScaleCmpt.copyKeyFromObject(property, specifiedScale);
                }
            } else {
                const value = _util.hasProperty(scaleRules, property) ? scaleRules[property]({
                    model,
                    channel,
                    fieldOrDatumDef,
                    scaleType,
                    scalePadding,
                    scalePaddingInner,
                    domain: specifiedScale.domain,
                    domainMin: specifiedScale.domainMin,
                    domainMax: specifiedScale.domainMax,
                    markDef,
                    config,
                    hasNestedOffsetScale: (0, _encoding.channelHasNestedOffsetScale)(encoding, channel),
                    hasSecondaryRangeChannel: !!encoding[(0, _channel.getSecondaryRangeChannel)(channel)]
                }) : config.scale[property];
                if (value !== undefined) localScaleCmpt.set(property, value, false);
            }
        }
    }
}
const scaleRules = {
    bins: ({ model, fieldOrDatumDef })=>(0, _channeldef.isFieldDef)(fieldOrDatumDef) ? bins(model, fieldOrDatumDef) : undefined,
    interpolate: ({ channel, fieldOrDatumDef })=>interpolate(channel, fieldOrDatumDef.type),
    nice: ({ scaleType, channel, domain, domainMin, domainMax, fieldOrDatumDef })=>nice(scaleType, channel, domain, domainMin, domainMax, fieldOrDatumDef),
    padding: ({ channel, scaleType, fieldOrDatumDef, markDef, config })=>padding(channel, scaleType, config.scale, fieldOrDatumDef, markDef, config.bar),
    paddingInner: ({ scalePadding, channel, markDef, scaleType, config, hasNestedOffsetScale })=>paddingInner(scalePadding, channel, markDef.type, scaleType, config.scale, hasNestedOffsetScale),
    paddingOuter: ({ scalePadding, channel, scaleType, scalePaddingInner, config, hasNestedOffsetScale })=>paddingOuter(scalePadding, channel, scaleType, scalePaddingInner, config.scale, hasNestedOffsetScale),
    reverse: ({ fieldOrDatumDef, scaleType, channel, config })=>{
        const sort = (0, _channeldef.isFieldDef)(fieldOrDatumDef) ? fieldOrDatumDef.sort : undefined;
        return reverse(scaleType, sort, channel, config.scale);
    },
    zero: ({ channel, fieldOrDatumDef, domain, markDef, scaleType, config, hasSecondaryRangeChannel })=>zero(channel, fieldOrDatumDef, domain, markDef, scaleType, config.scale, hasSecondaryRangeChannel)
};
function parseScaleRange(model) {
    if ((0, _model.isUnitModel)(model)) (0, _range.parseUnitScaleRange)(model);
    else parseNonUnitScaleProperty(model, 'range');
}
function parseNonUnitScaleProperty(model, property) {
    const localScaleComponents = model.component.scales;
    for (const child of model.children)if (property === 'range') parseScaleRange(child);
    else parseScaleProperty(child, property);
    for (const channel of (0, _util.keys)(localScaleComponents)){
        let valueWithExplicit;
        for (const child of model.children){
            const childComponent = child.component.scales[channel];
            if (childComponent) {
                const childValueWithExplicit = childComponent.getWithExplicit(property);
                valueWithExplicit = (0, _split.mergeValuesWithExplicit)(valueWithExplicit, childValueWithExplicit, property, 'scale', (0, _split.tieBreakByComparing)((v1, v2)=>{
                    switch(property){
                        case 'range':
                            // For step, prefer larger step
                            if (v1.step && v2.step) return v1.step - v2.step;
                            return 0;
                    }
                    return 0;
                }));
            }
        }
        localScaleComponents[channel].setWithExplicit(property, valueWithExplicit);
    }
}
function bins(model, fieldDef) {
    const bin = fieldDef.bin;
    if ((0, _bin.isBinning)(bin)) {
        const binSignal = (0, _bin1.getBinSignalName)(model, fieldDef.field, bin);
        return new (0, _signal.SignalRefWrapper)(()=>{
            return model.getSignalName(binSignal);
        });
    } else if ((0, _bin.isBinned)(bin) && (0, _bin.isBinParams)(bin) && bin.step !== undefined) // start and stop will be determined from the scale domain
    return {
        step: bin.step
    };
    return undefined;
}
function interpolate(channel, type) {
    if ((0, _util.contains)([
        (0, _channel.COLOR),
        (0, _channel.FILL),
        (0, _channel.STROKE)
    ], channel) && type !== 'nominal') return 'hcl';
    return undefined;
}
function nice(scaleType, channel, specifiedDomain, domainMin, domainMax, fieldOrDatumDef) {
    if ((0, _channeldef.getFieldDef)(fieldOrDatumDef)?.bin || (0, _vegaUtil.isArray)(specifiedDomain) || domainMax != null || domainMin != null || _util.contains([
        (0, _scale.ScaleType).TIME,
        (0, _scale.ScaleType).UTC
    ], scaleType)) return undefined;
    return (0, _channel.isXorY)(channel) ? true : undefined;
}
function padding(channel, scaleType, scaleConfig, fieldOrDatumDef, markDef, barConfig) {
    if ((0, _channel.isXorY)(channel)) {
        if ((0, _scale.isContinuousToContinuous)(scaleType)) {
            if (scaleConfig.continuousPadding !== undefined) return scaleConfig.continuousPadding;
            const { type, orient } = markDef;
            if (type === 'bar' && !((0, _channeldef.isFieldDef)(fieldOrDatumDef) && (fieldOrDatumDef.bin || fieldOrDatumDef.timeUnit))) {
                if (orient === 'vertical' && channel === 'x' || orient === 'horizontal' && channel === 'y') return barConfig.continuousBandSize;
            }
        }
        if (scaleType === (0, _scale.ScaleType).POINT) return scaleConfig.pointPadding;
    }
    return undefined;
}
function paddingInner(paddingValue, channel, mark, scaleType, scaleConfig, hasNestedOffsetScale = false) {
    if (paddingValue !== undefined) // If user has already manually specified "padding", no need to add default paddingInner.
    return undefined;
    if ((0, _channel.isXorY)(channel)) {
        // Padding is only set for X and Y by default.
        // Basically it doesn't make sense to add padding for color and size.
        // paddingOuter would only be called if it's a band scale, just return the default for bandScale.
        const { bandPaddingInner, barBandPaddingInner, rectBandPaddingInner, tickBandPaddingInner, bandWithNestedOffsetPaddingInner } = scaleConfig;
        if (hasNestedOffsetScale) return bandWithNestedOffsetPaddingInner;
        return (0, _util.getFirstDefined)(bandPaddingInner, mark === 'bar' ? barBandPaddingInner : mark === 'tick' ? tickBandPaddingInner : rectBandPaddingInner);
    } else if ((0, _channel.isXorYOffset)(channel)) {
        if (scaleType === (0, _scale.ScaleType).BAND) return scaleConfig.offsetBandPaddingInner;
    }
    return undefined;
}
function paddingOuter(paddingValue, channel, scaleType, paddingInnerValue, scaleConfig, hasNestedOffsetScale = false) {
    if (paddingValue !== undefined) // If user has already manually specified "padding", no need to add default paddingOuter.
    return undefined;
    if ((0, _channel.isXorY)(channel)) {
        const { bandPaddingOuter, bandWithNestedOffsetPaddingOuter } = scaleConfig;
        if (hasNestedOffsetScale) return bandWithNestedOffsetPaddingOuter;
        // Padding is only set for X and Y by default.
        // Basically it doesn't make sense to add padding for color and size.
        if (scaleType === (0, _scale.ScaleType).BAND) return (0, _util.getFirstDefined)(bandPaddingOuter, /* By default, paddingOuter is paddingInner / 2. The reason is that
              size (width/height) = step * (cardinality - paddingInner + 2 * paddingOuter).
              and we want the width/height to be integer by default.
              Note that step (by default) and cardinality are integers.) */ (0, _vegaSchema.isSignalRef)(paddingInnerValue) ? {
            signal: `${paddingInnerValue.signal}/2`
        } : paddingInnerValue / 2);
    } else if ((0, _channel.isXorYOffset)(channel)) {
        if (scaleType === (0, _scale.ScaleType).POINT) return 0.5; // so the point positions align with centers of band scales.
        else if (scaleType === (0, _scale.ScaleType).BAND) return scaleConfig.offsetBandPaddingOuter;
    }
    return undefined;
}
function reverse(scaleType, sort, channel, scaleConfig) {
    if (channel === 'x' && scaleConfig.xReverse !== undefined) {
        if ((0, _scale.hasContinuousDomain)(scaleType) && sort === 'descending') {
            if ((0, _vegaSchema.isSignalRef)(scaleConfig.xReverse)) return {
                signal: `!${scaleConfig.xReverse.signal}`
            };
            else return !scaleConfig.xReverse;
        }
        return scaleConfig.xReverse;
    }
    if ((0, _scale.hasContinuousDomain)(scaleType) && sort === 'descending') // For continuous domain scales, Vega does not support domain sort.
    // Thus, we reverse range instead if sort is descending
    return true;
    return undefined;
}
function zero(channel, fieldDef, specifiedDomain, markDef, scaleType, scaleConfig, hasSecondaryRangeChannel) {
    // If users explicitly provide a domain, we should not augment zero as that will be unexpected.
    const hasCustomDomain = !!specifiedDomain && specifiedDomain !== 'unaggregated';
    if (hasCustomDomain) {
        if ((0, _scale.hasContinuousDomain)(scaleType)) {
            if ((0, _vegaUtil.isArray)(specifiedDomain)) {
                const first = specifiedDomain[0];
                const last = specifiedDomain[specifiedDomain.length - 1];
                if ((0, _vegaUtil.isNumber)(first) && first <= 0 && (0, _vegaUtil.isNumber)(last) && last >= 0) // if the domain includes zero, make zero remain true
                return true;
            }
            return false;
        }
    }
    // If there is no custom domain, return configZero value (=`true` as default) only for the following cases:
    // 1) using quantitative field with size
    // While this can be either ratio or interval fields, our assumption is that
    // ratio are more common. However, if the scaleType is discretizing scale, we want to return
    // false so that range doesn't start at zero
    if (channel === 'size' && fieldDef.type === 'quantitative' && !(0, _scale.isContinuousToDiscrete)(scaleType)) return true;
    // 2) non-binned, quantitative x-scale or y-scale
    // (For binning, we should not include zero by default because binning are calculated without zero.)
    // (For area/bar charts with ratio scale chart, we should always include zero.)
    if (!((0, _channeldef.isFieldDef)(fieldDef) && fieldDef.bin) && _util.contains([
        ...(0, _channel.POSITION_SCALE_CHANNELS),
        ...(0, _channel.POLAR_POSITION_SCALE_CHANNELS)
    ], channel)) {
        const { orient, type } = markDef;
        if ((0, _util.contains)([
            'bar',
            'area',
            'line',
            'trail'
        ], type)) {
            if (orient === 'horizontal' && channel === 'y' || orient === 'vertical' && channel === 'x') return false;
        }
        if ((0, _util.contains)([
            'bar',
            'area'
        ], type) && !hasSecondaryRangeChannel) return true;
        return scaleConfig?.zero;
    }
    return false;
}

},{"vega-util":"7f6sQ","../../bin":"3cpW8","../../channel":"liLED","../../channeldef":"dsccb","../../datetime":"gp5cf","../../encoding":"2Ohsj","../../log":"loqTw","../../scale":"bdpXN","../../util":"acUGA","../../vega.schema":"3mBOT","../data/bin":"3xZkr","../model":"hQHib","../signal":"4fHcn","../split":"eXS2w","./range":"4jq9w","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4jq9w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RANGE_PROPERTIES", ()=>RANGE_PROPERTIES);
parcelHelpers.export(exports, "parseUnitScaleRange", ()=>parseUnitScaleRange);
/**
 * Return mixins that includes one of the Vega range types (explicit range, range.step, range.scheme).
 */ parcelHelpers.export(exports, "parseRangeForChannel", ()=>parseRangeForChannel);
parcelHelpers.export(exports, "defaultContinuousToDiscreteCount", ()=>defaultContinuousToDiscreteCount);
/**
 * Returns the linear interpolation of the range according to the cardinality
 *
 * @param rangeMin start of the range
 * @param rangeMax end of the range
 * @param cardinality number of values in the output range
 */ parcelHelpers.export(exports, "interpolateRange", ()=>interpolateRange);
parcelHelpers.export(exports, "MAX_SIZE_RANGE_STEP_RATIO", ()=>MAX_SIZE_RANGE_STEP_RATIO);
var _vegaUtil = require("vega-util");
var _bin = require("../../bin");
var _channel = require("../../channel");
var _channeldef = require("../../channeldef");
var _config = require("../../config");
var _data = require("../../data");
var _encoding = require("../../encoding");
var _log = require("../../log");
var _scale = require("../../scale");
var _base = require("../../spec/base");
var _type = require("../../type");
var _util = require("../../util");
var _vegaSchema = require("../../vega.schema");
var _common = require("../common");
var _bin1 = require("../data/bin");
var _signal = require("../signal");
var _split = require("../split");
var _timeunit = require("../../timeunit");
var _model = require("../model");
const RANGE_PROPERTIES = [
    'range',
    'scheme'
];
function parseUnitScaleRange(model) {
    const localScaleComponents = model.component.scales;
    // use SCALE_CHANNELS instead of scales[channel] to ensure that x, y come first!
    for (const channel of (0, _channel.SCALE_CHANNELS)){
        const localScaleCmpt = localScaleComponents[channel];
        if (!localScaleCmpt) continue;
        const rangeWithExplicit = parseRangeForChannel(channel, model);
        localScaleCmpt.setWithExplicit('range', rangeWithExplicit);
    }
}
function getBinStepSignal(model, channel) {
    const fieldDef = model.fieldDef(channel);
    if (fieldDef?.bin) {
        const { bin, field } = fieldDef;
        const sizeType = (0, _channel.getSizeChannel)(channel);
        const sizeSignal = model.getName(sizeType);
        if ((0, _vegaUtil.isObject)(bin) && bin.binned && bin.step !== undefined) return new (0, _signal.SignalRefWrapper)(()=>{
            const scaleName = model.scaleName(channel);
            const binCount = `(domain("${scaleName}")[1] - domain("${scaleName}")[0]) / ${bin.step}`;
            return `${model.getSignalName(sizeSignal)} / (${binCount})`;
        });
        else if ((0, _bin.isBinning)(bin)) {
            const binSignal = (0, _bin1.getBinSignalName)(model, field, bin);
            // TODO: extract this to be range step signal
            return new (0, _signal.SignalRefWrapper)(()=>{
                const updatedName = model.getSignalName(binSignal);
                const binCount = `(${updatedName}.stop - ${updatedName}.start) / ${updatedName}.step`;
                return `${model.getSignalName(sizeSignal)} / (${binCount})`;
            });
        }
    }
    return undefined;
}
function parseRangeForChannel(channel, model) {
    const specifiedScale = model.specifiedScales[channel];
    const { size } = model;
    const mergedScaleCmpt = model.getScaleComponent(channel);
    const scaleType = mergedScaleCmpt.get('type');
    // Check if any of the range properties is specified.
    // If so, check if it is compatible and make sure that we only output one of the properties
    for (const property of RANGE_PROPERTIES)if (specifiedScale[property] !== undefined) {
        const supportedByScaleType = (0, _scale.scaleTypeSupportProperty)(scaleType, property);
        const channelIncompatability = (0, _scale.channelScalePropertyIncompatability)(channel, property);
        if (!supportedByScaleType) _log.warn(_log.message.scalePropertyNotWorkWithScaleType(scaleType, property, channel));
        else if (channelIncompatability) // channel
        _log.warn(channelIncompatability);
        else switch(property){
            case 'range':
                {
                    const range = specifiedScale.range;
                    if ((0, _vegaUtil.isArray)(range)) {
                        if ((0, _channel.isXorY)(channel)) return (0, _split.makeExplicit)(range.map((v)=>{
                            if (v === 'width' || v === 'height') {
                                // get signal for width/height
                                // Just like default range logic below, we use SignalRefWrapper to account for potential merges and renames.
                                const sizeSignal = model.getName(v);
                                const getSignalName = model.getSignalName.bind(model);
                                return (0, _signal.SignalRefWrapper).fromName(getSignalName, sizeSignal);
                            }
                            return v;
                        }));
                    } else if ((0, _vegaUtil.isObject)(range)) return (0, _split.makeExplicit)({
                        data: model.requestDataName((0, _data.DataSourceType).Main),
                        field: range.field,
                        sort: {
                            op: 'min',
                            field: model.vgField(channel)
                        }
                    });
                    return (0, _split.makeExplicit)(range);
                }
            case 'scheme':
                return (0, _split.makeExplicit)(parseScheme(specifiedScale[property]));
        }
    }
    const sizeChannel = channel === (0, _channel.X) || channel === 'xOffset' ? 'width' : 'height';
    const sizeValue = size[sizeChannel];
    if ((0, _base.isStep)(sizeValue)) {
        if ((0, _channel.isXorY)(channel)) {
            if ((0, _scale.hasDiscreteDomain)(scaleType)) {
                const step = getPositionStep(sizeValue, model, channel);
                // Need to be explicit so layer with step wins over layer without step
                if (step) return (0, _split.makeExplicit)({
                    step
                });
            } else _log.warn(_log.message.stepDropped(sizeChannel));
        } else if ((0, _channel.isXorYOffset)(channel)) {
            const positionChannel = channel === (0, _channel.XOFFSET) ? 'x' : 'y';
            const positionScaleCmpt = model.getScaleComponent(positionChannel);
            const positionScaleType = positionScaleCmpt.get('type');
            if (positionScaleType === 'band') {
                const step = getOffsetStep(sizeValue, scaleType);
                if (step) return (0, _split.makeExplicit)(step);
            }
        }
    }
    const { rangeMin, rangeMax } = specifiedScale;
    const d = defaultRange(channel, model);
    if ((rangeMin !== undefined || rangeMax !== undefined) && // it's ok to check just rangeMin's compatibility since rangeMin/rangeMax are the same
    (0, _scale.scaleTypeSupportProperty)(scaleType, 'rangeMin') && (0, _vegaUtil.isArray)(d) && d.length === 2) return (0, _split.makeExplicit)([
        rangeMin ?? d[0],
        rangeMax ?? d[1]
    ]);
    return (0, _split.makeImplicit)(d);
}
function parseScheme(scheme) {
    if ((0, _scale.isExtendedScheme)(scheme)) return {
        scheme: scheme.name,
        ..._util.omit(scheme, [
            'name'
        ])
    };
    return {
        scheme
    };
}
function fullWidthOrHeightRange(channel, model, scaleType, { center } = {}) {
    // If step is null, use zero to width or height.
    // Note that we use SignalRefWrapper to account for potential merges and renames.
    const sizeType = (0, _channel.getSizeChannel)(channel);
    const sizeSignal = model.getName(sizeType);
    const getSignalName = model.getSignalName.bind(model);
    if (channel === (0, _channel.Y) && (0, _scale.hasContinuousDomain)(scaleType)) // For y continuous scale, we have to start from the height as the bottom part has the max value.
    return center ? [
        (0, _signal.SignalRefWrapper).fromName((name)=>`${getSignalName(name)}/2`, sizeSignal),
        (0, _signal.SignalRefWrapper).fromName((name)=>`-${getSignalName(name)}/2`, sizeSignal)
    ] : [
        (0, _signal.SignalRefWrapper).fromName(getSignalName, sizeSignal),
        0
    ];
    else return center ? [
        (0, _signal.SignalRefWrapper).fromName((name)=>`-${getSignalName(name)}/2`, sizeSignal),
        (0, _signal.SignalRefWrapper).fromName((name)=>`${getSignalName(name)}/2`, sizeSignal)
    ] : [
        0,
        (0, _signal.SignalRefWrapper).fromName(getSignalName, sizeSignal)
    ];
}
function defaultRange(channel, model) {
    const { size, config, mark, encoding } = model;
    const { type } = (0, _channeldef.getFieldOrDatumDef)(encoding[channel]);
    const mergedScaleCmpt = model.getScaleComponent(channel);
    const scaleType = mergedScaleCmpt.get('type');
    const { domain, domainMid } = model.specifiedScales[channel];
    switch(channel){
        case 0, _channel.X:
        case 0, _channel.Y:
            // If there is no explicit width/height for discrete x/y scales
            if (_util.contains([
                'point',
                'band'
            ], scaleType)) {
                const positionSize = getDiscretePositionSize(channel, size, config.view);
                if ((0, _base.isStep)(positionSize)) {
                    const step = getPositionStep(positionSize, model, channel);
                    return {
                        step
                    };
                }
            }
            return fullWidthOrHeightRange(channel, model, scaleType);
        case 0, _channel.XOFFSET:
        case 0, _channel.YOFFSET:
            return getOffsetRange(channel, model, scaleType);
        case 0, _channel.SIZE:
            {
                // TODO: support custom rangeMin, rangeMax
                const rangeMin = sizeRangeMin(mark, config);
                const rangeMax = sizeRangeMax(mark, size, model, config);
                if ((0, _scale.isContinuousToDiscrete)(scaleType)) return interpolateRange(rangeMin, rangeMax, defaultContinuousToDiscreteCount(scaleType, config, domain, channel));
                else return [
                    rangeMin,
                    rangeMax
                ];
            }
        case 0, _channel.THETA:
            return [
                0,
                Math.PI * 2
            ];
        case 0, _channel.ANGLE:
            // TODO: add config.scale.min/maxAngleDegree (for point and text) and config.scale.min/maxAngleRadian (for arc) once we add arc marks.
            // (It's weird to add just config.scale.min/maxAngleDegree for now)
            return [
                0,
                360
            ];
        case 0, _channel.RADIUS:
            // max radius = half od min(width,height)
            return [
                0,
                new (0, _signal.SignalRefWrapper)(()=>{
                    const w = model.getSignalName((0, _model.isFacetModel)(model.parent) ? 'child_width' : 'width');
                    const h = model.getSignalName((0, _model.isFacetModel)(model.parent) ? 'child_height' : 'height');
                    return `min(${w},${h})/2`;
                })
            ];
        case 0, _channel.TIME:
            // if (scaleType === 'band') {
            return {
                step: 1000 / config.scale.framesPerSecond
            };
        case 0, _channel.STROKEWIDTH:
            // TODO: support custom rangeMin, rangeMax
            return [
                config.scale.minStrokeWidth,
                config.scale.maxStrokeWidth
            ];
        case 0, _channel.STROKEDASH:
            return [
                // TODO: add this to Vega's config.range?
                [
                    1,
                    0
                ],
                [
                    4,
                    2
                ],
                [
                    2,
                    1
                ],
                [
                    1,
                    1
                ],
                [
                    1,
                    2,
                    4,
                    2
                ]
            ];
        case 0, _channel.SHAPE:
            return 'symbol';
        case 0, _channel.COLOR:
        case 0, _channel.FILL:
        case 0, _channel.STROKE:
            if (scaleType === 'ordinal') // Only nominal data uses ordinal scale by default
            return type === 'nominal' ? 'category' : 'ordinal';
            else {
                if (domainMid !== undefined) return 'diverging';
                else return mark === 'rect' || mark === 'geoshape' ? 'heatmap' : 'ramp';
            }
        case 0, _channel.OPACITY:
        case 0, _channel.FILLOPACITY:
        case 0, _channel.STROKEOPACITY:
            // TODO: support custom rangeMin, rangeMax
            return [
                config.scale.minOpacity,
                config.scale.maxOpacity
            ];
    }
}
function getPositionStep(step, model, channel) {
    const { encoding } = model;
    const mergedScaleCmpt = model.getScaleComponent(channel);
    const offsetChannel = (0, _channel.getOffsetScaleChannel)(channel);
    const offsetDef = encoding[offsetChannel];
    const stepFor = (0, _base.getStepFor)({
        step,
        offsetIsDiscrete: (0, _channeldef.isFieldOrDatumDef)(offsetDef) && (0, _type.isDiscrete)(offsetDef.type)
    });
    if (stepFor === 'offset' && (0, _encoding.channelHasFieldOrDatum)(encoding, offsetChannel)) {
        const offsetScaleCmpt = model.getScaleComponent(offsetChannel);
        const offsetScaleName = model.scaleName(offsetChannel);
        let stepCount = `domain('${offsetScaleName}').length`;
        if (offsetScaleCmpt.get('type') === 'band') {
            const offsetPaddingInner = offsetScaleCmpt.get('paddingInner') ?? offsetScaleCmpt.get('padding') ?? 0;
            const offsetPaddingOuter = offsetScaleCmpt.get('paddingOuter') ?? offsetScaleCmpt.get('padding') ?? 0;
            stepCount = `bandspace(${stepCount}, ${offsetPaddingInner}, ${offsetPaddingOuter})`;
        }
        const paddingInner = mergedScaleCmpt.get('paddingInner') ?? mergedScaleCmpt.get('padding');
        return {
            signal: `${step.step} * ${stepCount} / (1-${(0, _common.exprFromSignalRefOrValue)(paddingInner)})`
        };
    } else return step.step;
}
function getOffsetStep(step, offsetScaleType) {
    const stepFor = (0, _base.getStepFor)({
        step,
        offsetIsDiscrete: (0, _scale.hasDiscreteDomain)(offsetScaleType)
    });
    if (stepFor === 'offset') return {
        step: step.step
    };
    return undefined;
}
function getOffsetRange(channel, model, offsetScaleType) {
    const positionChannel = channel === (0, _channel.XOFFSET) ? 'x' : 'y';
    const positionScaleCmpt = model.getScaleComponent(positionChannel);
    if (!positionScaleCmpt) return fullWidthOrHeightRange(positionChannel, model, offsetScaleType, {
        center: true
    });
    const positionScaleType = positionScaleCmpt.get('type');
    const positionScaleName = model.scaleName(positionChannel);
    const { markDef, config } = model;
    if (positionScaleType === 'band') {
        const size = getDiscretePositionSize(positionChannel, model.size, model.config.view);
        if ((0, _base.isStep)(size)) {
            // step is for offset
            const step = getOffsetStep(size, offsetScaleType);
            if (step) return step;
        }
        // otherwise use the position
        return [
            0,
            {
                signal: `bandwidth('${positionScaleName}')`
            }
        ];
    } else {
        // continuous scale
        const positionDef = model.encoding[positionChannel];
        if ((0, _channeldef.isFieldDef)(positionDef) && positionDef.timeUnit) {
            const duration = (0, _timeunit.durationExpr)(positionDef.timeUnit, (expr)=>`scale('${positionScaleName}', ${expr})`);
            const padding = model.config.scale.bandWithNestedOffsetPaddingInner;
            const bandPositionOffset = (0, _channeldef.getBandPosition)({
                fieldDef: positionDef,
                markDef,
                config
            }) - 0.5;
            const bandPositionOffsetExpr = bandPositionOffset !== 0 ? ` + ${bandPositionOffset}` : '';
            if (padding) {
                const startRatio = (0, _vegaSchema.isSignalRef)(padding) ? `${padding.signal}/2` + bandPositionOffsetExpr : `${padding / 2 + bandPositionOffset}`;
                const endRatio = (0, _vegaSchema.isSignalRef)(padding) ? `(1 - ${padding.signal}/2)` + bandPositionOffsetExpr : `${1 - padding / 2 + bandPositionOffset}`;
                return [
                    {
                        signal: `${startRatio} * (${duration})`
                    },
                    {
                        signal: `${endRatio} * (${duration})`
                    }
                ];
            }
            return [
                0,
                {
                    signal: duration
                }
            ];
        }
        return _util.never(`Cannot use ${channel} scale if ${positionChannel} scale is not discrete.`);
    }
}
function getDiscretePositionSize(channel, size, viewConfig) {
    const sizeChannel = channel === (0, _channel.X) ? 'width' : 'height';
    const sizeValue = size[sizeChannel];
    if (sizeValue) return sizeValue;
    return (0, _config.getViewConfigDiscreteSize)(viewConfig, sizeChannel);
}
function defaultContinuousToDiscreteCount(scaleType, config, domain, channel) {
    switch(scaleType){
        case 'quantile':
            return config.scale.quantileCount;
        case 'quantize':
            return config.scale.quantizeCount;
        case 'threshold':
            if (domain !== undefined && (0, _vegaUtil.isArray)(domain)) return domain.length + 1;
            else {
                _log.warn(_log.message.domainRequiredForThresholdScale(channel));
                // default threshold boundaries for threshold scale since domain has cardinality of 2
                return 3;
            }
    }
}
function interpolateRange(rangeMin, rangeMax, cardinality) {
    // always return a signal since it's better to compute the sequence in Vega later
    const f = ()=>{
        const rMax = (0, _common.signalOrStringValue)(rangeMax);
        const rMin = (0, _common.signalOrStringValue)(rangeMin);
        const step = `(${rMax} - ${rMin}) / (${cardinality} - 1)`;
        return `sequence(${rMin}, ${rMax} + ${step}, ${step})`;
    };
    if ((0, _vegaSchema.isSignalRef)(rangeMax)) return new (0, _signal.SignalRefWrapper)(f);
    else return {
        signal: f()
    };
}
function sizeRangeMin(mark, config) {
    switch(mark){
        case 'bar':
        case 'tick':
            return config.scale.minBandSize;
        case 'line':
        case 'trail':
        case 'rule':
            return config.scale.minStrokeWidth;
        case 'text':
            return config.scale.minFontSize;
        case 'point':
        case 'square':
        case 'circle':
            return config.scale.minSize;
    }
    /* istanbul ignore next: should never reach here */ // sizeRangeMin not implemented for the mark
    throw new Error(_log.message.incompatibleChannel('size', mark));
}
const MAX_SIZE_RANGE_STEP_RATIO = 0.95;
function sizeRangeMax(mark, size, model, config) {
    const xyStepSignals = {
        x: getBinStepSignal(model, 'x'),
        y: getBinStepSignal(model, 'y')
    };
    switch(mark){
        case 'bar':
        case 'tick':
            {
                if (config.scale.maxBandSize !== undefined) return config.scale.maxBandSize;
                const min = minXYStep(size, xyStepSignals, config.view);
                if ((0, _vegaUtil.isNumber)(min)) return min - 1;
                else return new (0, _signal.SignalRefWrapper)(()=>`${min.signal} - 1`);
            }
        case 'line':
        case 'trail':
        case 'rule':
            return config.scale.maxStrokeWidth;
        case 'text':
            return config.scale.maxFontSize;
        case 'point':
        case 'square':
        case 'circle':
            {
                if (config.scale.maxSize) return config.scale.maxSize;
                const pointStep = minXYStep(size, xyStepSignals, config.view);
                if ((0, _vegaUtil.isNumber)(pointStep)) return Math.pow(MAX_SIZE_RANGE_STEP_RATIO * pointStep, 2);
                else return new (0, _signal.SignalRefWrapper)(()=>`pow(${MAX_SIZE_RANGE_STEP_RATIO} * ${pointStep.signal}, 2)`);
            }
    }
    /* istanbul ignore next: should never reach here */ // sizeRangeMax not implemented for the mark
    throw new Error(_log.message.incompatibleChannel('size', mark));
}
/**
 * @returns {number} Range step of x or y or minimum between the two if both are ordinal scale.
 */ function minXYStep(size, xyStepSignals, viewConfig) {
    const widthStep = (0, _base.isStep)(size.width) ? size.width.step : (0, _config.getViewConfigDiscreteStep)(viewConfig, 'width');
    const heightStep = (0, _base.isStep)(size.height) ? size.height.step : (0, _config.getViewConfigDiscreteStep)(viewConfig, 'height');
    if (xyStepSignals.x || xyStepSignals.y) return new (0, _signal.SignalRefWrapper)(()=>{
        const exprs = [
            xyStepSignals.x ? xyStepSignals.x.signal : widthStep,
            xyStepSignals.y ? xyStepSignals.y.signal : heightStep
        ];
        return `min(${exprs.join(', ')})`;
    });
    return Math.min(widthStep, heightStep);
}

},{"vega-util":"7f6sQ","../../bin":"3cpW8","../../channel":"liLED","../../channeldef":"dsccb","../../config":"8TUzf","../../data":"dILEy","../../encoding":"2Ohsj","../../log":"loqTw","../../scale":"bdpXN","../../spec/base":"5uH6T","../../type":"cbWGP","../../util":"acUGA","../../vega.schema":"3mBOT","../common":"jegt8","../data/bin":"3xZkr","../signal":"4fHcn","../split":"eXS2w","../../timeunit":"eky0T","../model":"hQHib","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"jo2CZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Determine if there is a specified scale type and if it is appropriate,
 * or determine default type if type is unspecified or inappropriate.
 */ // NOTE: CompassQL uses this method.
parcelHelpers.export(exports, "scaleType", ()=>scaleType);
var _bin = require("../../bin");
var _channel = require("../../channel");
var _channeldef = require("../../channeldef");
var _log = require("../../log");
var _mark = require("../../mark");
var _scale = require("../../scale");
var _timeunit = require("../../timeunit");
var _util = require("../../util");
var _channel1 = require("./../../channel");
function scaleType(specifiedScale, channel, fieldDef, mark, hasNestedOffsetScale = false) {
    const defaultScaleType = defaultType(channel, fieldDef, mark, hasNestedOffsetScale);
    const { type } = specifiedScale;
    if (!(0, _channel.isScaleChannel)(channel)) // There is no scale for these channels
    return null;
    if (type !== undefined) {
        // Check if explicitly specified scale type is supported by the channel
        if (!(0, _scale.channelSupportScaleType)(channel, type)) {
            _log.warn(_log.message.scaleTypeNotWorkWithChannel(channel, type, defaultScaleType));
            return defaultScaleType;
        }
        // Check if explicitly specified scale type is supported by the data type
        if ((0, _channeldef.isFieldDef)(fieldDef) && !(0, _scale.scaleTypeSupportDataType)(type, fieldDef.type)) {
            _log.warn(_log.message.scaleTypeNotWorkWithFieldDef(type, defaultScaleType));
            return defaultScaleType;
        }
        return type;
    }
    return defaultScaleType;
}
/**
 * Determine appropriate default scale type.
 */ // NOTE: Voyager uses this method.
function defaultType(channel, fieldDef, mark, hasNestedOffsetScale) {
    switch(fieldDef.type){
        case 'nominal':
        case 'ordinal':
            {
                if ((0, _channel.isColorChannel)(channel) || (0, _channel.rangeType)(channel) === 'discrete') {
                    if (channel === 'shape' && fieldDef.type === 'ordinal') _log.warn(_log.message.discreteChannelCannotEncode(channel, 'ordinal'));
                    return 'ordinal';
                }
                if ((0, _channel.isTime)(channel)) return 'band';
                if ((0, _channel.isXorY)(channel) || (0, _channel.isXorYOffset)(channel)) {
                    if (_util.contains([
                        'rect',
                        'bar',
                        'image',
                        'rule',
                        'tick'
                    ], mark.type)) // The rect/bar/tick mark should fit into a band.
                    // For rule, using band scale to make rule align with axis ticks better https://github.com/vega/vega-lite/issues/3429
                    return 'band';
                    if (hasNestedOffsetScale) // If there is a nested offset scale, then there is a "band" for the span of the nested scale.
                    return 'band';
                } else if (mark.type === 'arc' && channel in (0, _channel1.POLAR_POSITION_SCALE_CHANNEL_INDEX)) return 'band';
                const dimensionSize = mark[(0, _channel.getSizeChannel)(channel)];
                if ((0, _mark.isRelativeBandSize)(dimensionSize)) return 'band';
                if ((0, _channeldef.isPositionFieldOrDatumDef)(fieldDef) && fieldDef.axis?.tickBand) return 'band';
                // Otherwise, use ordinal point scale so we can easily get center positions of the marks.
                return 'point';
            }
        case 'temporal':
            if ((0, _channel.isColorChannel)(channel)) return 'time';
            else if ((0, _channel.rangeType)(channel) === 'discrete') {
                _log.warn(_log.message.discreteChannelCannotEncode(channel, 'temporal'));
                // TODO: consider using quantize (equivalent to binning) once we have it
                return 'ordinal';
            } else if ((0, _channeldef.isFieldDef)(fieldDef) && fieldDef.timeUnit && (0, _timeunit.normalizeTimeUnit)(fieldDef.timeUnit).utc) return 'utc';
            else if ((0, _channel.isTime)(channel)) // return 'linear';
            return 'band'; // TODO(jzong): when interpolation is implemented, this should be 'linear'
            return 'time';
        case 'quantitative':
            if ((0, _channel.isColorChannel)(channel)) {
                if ((0, _channeldef.isFieldDef)(fieldDef) && (0, _bin.isBinning)(fieldDef.bin)) return 'bin-ordinal';
                return 'linear';
            } else if ((0, _channel.rangeType)(channel) === 'discrete') {
                _log.warn(_log.message.discreteChannelCannotEncode(channel, 'quantitative'));
                // TODO: consider using quantize (equivalent to binning) once we have it
                return 'ordinal';
            } else if ((0, _channel.isTime)(channel)) // return 'linear';
            return 'band'; // TODO(jzong): when interpolation is implemented, this should be 'linear'
            return 'linear';
        case 'geojson':
            return undefined;
    }
    /* istanbul ignore next: should never reach this */ throw new Error(_log.message.invalidFieldType(fieldDef.type));
}

},{"../../bin":"3cpW8","../../channel":"liLED","../../channeldef":"dsccb","../../log":"loqTw","../../mark":"3Z1xx","../../scale":"bdpXN","../../timeunit":"eky0T","../../util":"acUGA","./../../channel":"liLED","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"aWjoR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A class for density transform nodes
 */ parcelHelpers.export(exports, "DensityTransformNode", ()=>DensityTransformNode);
var _util = require("../../util");
var _dataflow = require("./dataflow");
class DensityTransformNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new DensityTransformNode(null, (0, _util.duplicate)(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
        this.transform = (0, _util.duplicate)(transform); // duplicate to prevent side effects
        const specifiedAs = this.transform.as ?? [
            undefined,
            undefined
        ];
        this.transform.as = [
            specifiedAs[0] ?? 'value',
            specifiedAs[1] ?? 'density'
        ];
        const resolve = this.transform.resolve ?? 'shared';
        this.transform.resolve = resolve;
    }
    dependentFields() {
        return new Set([
            this.transform.density,
            ...this.transform.groupby ?? []
        ]);
    }
    producedFields() {
        return new Set(this.transform.as);
    }
    hash() {
        return `DensityTransform ${(0, _util.hash)(this.transform)}`;
    }
    assemble() {
        const { density, ...rest } = this.transform;
        const result = {
            type: 'kde',
            field: density,
            ...rest
        };
        result.resolve = this.transform.resolve;
        return result;
    }
}

},{"../../util":"acUGA","./dataflow":"btJXI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"4tyGU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A class for flatten transform nodes
 */ parcelHelpers.export(exports, "ExtentTransformNode", ()=>ExtentTransformNode);
var _util = require("../../util");
var _dataflow = require("./dataflow");
class ExtentTransformNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new ExtentTransformNode(null, (0, _util.duplicate)(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
        this.transform = (0, _util.duplicate)(transform);
    }
    dependentFields() {
        return new Set([
            this.transform.extent
        ]);
    }
    producedFields() {
        return new Set([]);
    }
    hash() {
        return `ExtentTransform ${(0, _util.hash)(this.transform)}`;
    }
    assemble() {
        const { extent, param } = this.transform;
        const result = {
            type: 'extent',
            field: extent,
            signal: param
        };
        return result;
    }
}

},{"../../util":"acUGA","./dataflow":"btJXI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"ceJ4t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A class for flatten transform nodes
 */ parcelHelpers.export(exports, "FlattenTransformNode", ()=>FlattenTransformNode);
var _util = require("../../util");
var _dataflow = require("./dataflow");
class FlattenTransformNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new FlattenTransformNode(this.parent, (0, _util.duplicate)(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
        this.transform = (0, _util.duplicate)(transform); // duplicate to prevent side effects
        const { flatten, as = [] } = this.transform;
        this.transform.as = flatten.map((f, i)=>as[i] ?? f);
    }
    dependentFields() {
        return new Set(this.transform.flatten);
    }
    producedFields() {
        return new Set(this.transform.as);
    }
    hash() {
        return `FlattenTransform ${(0, _util.hash)(this.transform)}`;
    }
    assemble() {
        const { flatten: fields, as } = this.transform;
        const result = {
            type: 'flatten',
            fields,
            as
        };
        return result;
    }
}

},{"../../util":"acUGA","./dataflow":"btJXI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"1zNXb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A class for flatten transform nodes
 */ parcelHelpers.export(exports, "FoldTransformNode", ()=>FoldTransformNode);
var _util = require("../../util");
var _dataflow = require("./dataflow");
class FoldTransformNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new FoldTransformNode(null, (0, _util.duplicate)(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
        this.transform = (0, _util.duplicate)(transform); // duplicate to prevent side effects
        const specifiedAs = this.transform.as ?? [
            undefined,
            undefined
        ];
        this.transform.as = [
            specifiedAs[0] ?? 'key',
            specifiedAs[1] ?? 'value'
        ];
    }
    dependentFields() {
        return new Set(this.transform.fold);
    }
    producedFields() {
        return new Set(this.transform.as);
    }
    hash() {
        return `FoldTransform ${(0, _util.hash)(this.transform)}`;
    }
    assemble() {
        const { fold, as } = this.transform;
        const result = {
            type: 'fold',
            fields: fold,
            as
        };
        return result;
    }
}

},{"../../util":"acUGA","./dataflow":"btJXI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"aXTII":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GeoJSONNode", ()=>GeoJSONNode);
var _vegaUtil = require("vega-util");
var _channel = require("../../channel");
var _channeldef = require("../../channeldef");
var _type = require("../../type");
var _util = require("../../util");
var _dataflow = require("./dataflow");
class GeoJSONNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new GeoJSONNode(null, (0, _util.duplicate)(this.fields), this.geojson, this.signal);
    }
    static parseAll(parent, model) {
        if (model.component.projection && !model.component.projection.isFit) return parent;
        let geoJsonCounter = 0;
        for (const coordinates of [
            [
                (0, _channel.LONGITUDE),
                (0, _channel.LATITUDE)
            ],
            [
                (0, _channel.LONGITUDE2),
                (0, _channel.LATITUDE2)
            ]
        ]){
            const pair = coordinates.map((channel)=>{
                const def = (0, _channeldef.getFieldOrDatumDef)(model.encoding[channel]);
                return (0, _channeldef.isFieldDef)(def) ? def.field : (0, _channeldef.isDatumDef)(def) ? {
                    expr: `${def.datum}`
                } : (0, _channeldef.isValueDef)(def) ? {
                    expr: `${def['value']}`
                } : undefined;
            });
            if (pair[0] || pair[1]) parent = new GeoJSONNode(parent, pair, null, model.getName(`geojson_${geoJsonCounter++}`));
        }
        if (model.channelHasField((0, _channel.SHAPE))) {
            const fieldDef = model.typedFieldDef((0, _channel.SHAPE));
            if (fieldDef.type === (0, _type.GEOJSON)) parent = new GeoJSONNode(parent, null, fieldDef.field, model.getName(`geojson_${geoJsonCounter++}`));
        }
        return parent;
    }
    constructor(parent, fields, geojson, signal){
        super(parent);
        this.fields = fields;
        this.geojson = geojson;
        this.signal = signal;
    }
    dependentFields() {
        const fields = (this.fields ?? []).filter((0, _vegaUtil.isString));
        return new Set([
            ...this.geojson ? [
                this.geojson
            ] : [],
            ...fields
        ]);
    }
    producedFields() {
        return new Set();
    }
    hash() {
        return `GeoJSON ${this.geojson} ${this.signal} ${(0, _util.hash)(this.fields)}`;
    }
    assemble() {
        return [
            ...this.geojson ? [
                {
                    type: 'filter',
                    expr: `isValid(datum["${this.geojson}"])`
                }
            ] : [],
            {
                type: 'geojson',
                ...this.fields ? {
                    fields: this.fields
                } : {},
                ...this.geojson ? {
                    geojson: this.geojson
                } : {},
                signal: this.signal
            }
        ];
    }
}

},{"vega-util":"7f6sQ","../../channel":"liLED","../../channeldef":"dsccb","../../type":"cbWGP","../../util":"acUGA","./dataflow":"btJXI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hJ38i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GeoPointNode", ()=>GeoPointNode);
var _vegaUtil = require("vega-util");
var _channel = require("../../channel");
var _channeldef = require("../../channeldef");
var _util = require("../../util");
var _dataflow = require("./dataflow");
class GeoPointNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new GeoPointNode(null, this.projection, (0, _util.duplicate)(this.fields), (0, _util.duplicate)(this.as));
    }
    constructor(parent, projection, fields, as){
        super(parent);
        this.projection = projection;
        this.fields = fields;
        this.as = as;
    }
    static parseAll(parent, model) {
        if (!model.projectionName()) return parent;
        for (const coordinates of [
            [
                (0, _channel.LONGITUDE),
                (0, _channel.LATITUDE)
            ],
            [
                (0, _channel.LONGITUDE2),
                (0, _channel.LATITUDE2)
            ]
        ]){
            const pair = coordinates.map((channel)=>{
                const def = (0, _channeldef.getFieldOrDatumDef)(model.encoding[channel]);
                return (0, _channeldef.isFieldDef)(def) ? def.field : (0, _channeldef.isDatumDef)(def) ? {
                    expr: `${def.datum}`
                } : (0, _channeldef.isValueDef)(def) ? {
                    expr: `${def['value']}`
                } : undefined;
            });
            const suffix = coordinates[0] === (0, _channel.LONGITUDE2) ? '2' : '';
            if (pair[0] || pair[1]) parent = new GeoPointNode(parent, model.projectionName(), pair, [
                model.getName(`x${suffix}`),
                model.getName(`y${suffix}`)
            ]);
        }
        return parent;
    }
    dependentFields() {
        return new Set(this.fields.filter((0, _vegaUtil.isString)));
    }
    producedFields() {
        return new Set(this.as);
    }
    hash() {
        return `Geopoint ${this.projection} ${(0, _util.hash)(this.fields)} ${(0, _util.hash)(this.as)}`;
    }
    assemble() {
        return {
            type: 'geopoint',
            projection: this.projection,
            fields: this.fields,
            as: this.as
        };
    }
}

},{"vega-util":"7f6sQ","../../channel":"liLED","../../channeldef":"dsccb","../../util":"acUGA","./dataflow":"btJXI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"7krbQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ImputeNode", ()=>ImputeNode);
var _channeldef = require("../../channeldef");
var _encoding = require("../../encoding");
var _transform = require("../../transform");
var _util = require("../../util");
var _dataflow = require("./dataflow");
class ImputeNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new ImputeNode(null, (0, _util.duplicate)(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
    }
    dependentFields() {
        return new Set([
            this.transform.impute,
            this.transform.key,
            ...this.transform.groupby ?? []
        ]);
    }
    producedFields() {
        return new Set([
            this.transform.impute
        ]);
    }
    processSequence(keyvals) {
        const { start = 0, stop, step } = keyvals;
        const result = [
            start,
            stop,
            ...step ? [
                step
            ] : []
        ].join(',');
        return {
            signal: `sequence(${result})`
        };
    }
    static makeFromTransform(parent, imputeTransform) {
        return new ImputeNode(parent, imputeTransform);
    }
    static makeFromEncoding(parent, model) {
        const encoding = model.encoding;
        const xDef = encoding.x;
        const yDef = encoding.y;
        if ((0, _channeldef.isFieldDef)(xDef) && (0, _channeldef.isFieldDef)(yDef)) {
            const imputedChannel = xDef.impute ? xDef : yDef.impute ? yDef : undefined;
            if (imputedChannel === undefined) return undefined;
            const keyChannel = xDef.impute ? yDef : yDef.impute ? xDef : undefined;
            const { method, value, frame, keyvals } = imputedChannel.impute;
            const groupbyFields = (0, _encoding.pathGroupingFields)(model.mark, encoding);
            return new ImputeNode(parent, {
                impute: imputedChannel.field,
                key: keyChannel.field,
                ...method ? {
                    method
                } : {},
                ...value !== undefined ? {
                    value
                } : {},
                ...frame ? {
                    frame
                } : {},
                ...keyvals !== undefined ? {
                    keyvals
                } : {},
                ...groupbyFields.length ? {
                    groupby: groupbyFields
                } : {}
            });
        }
        return null;
    }
    hash() {
        return `Impute ${(0, _util.hash)(this.transform)}`;
    }
    assemble() {
        const { impute, key, keyvals, method, groupby, value, frame = [
            null,
            null
        ] } = this.transform;
        const imputeTransform = {
            type: 'impute',
            field: impute,
            key,
            ...keyvals ? {
                keyvals: (0, _transform.isImputeSequence)(keyvals) ? this.processSequence(keyvals) : keyvals
            } : {},
            method: 'value',
            ...groupby ? {
                groupby
            } : {},
            value: !method || method === 'value' ? value : null
        };
        if (method && method !== 'value') {
            const deriveNewField = {
                type: 'window',
                as: [
                    `imputed_${impute}_value`
                ],
                ops: [
                    method
                ],
                fields: [
                    impute
                ],
                frame,
                ignorePeers: false,
                ...groupby ? {
                    groupby
                } : {}
            };
            const replaceOriginal = {
                type: 'formula',
                expr: `datum.${impute} === null ? datum.imputed_${impute}_value : datum.${impute}`,
                as: impute
            };
            return [
                imputeTransform,
                deriveNewField,
                replaceOriginal
            ];
        } else return [
            imputeTransform
        ];
    }
}

},{"../../channeldef":"dsccb","../../encoding":"2Ohsj","../../transform":"ld5WF","../../util":"acUGA","./dataflow":"btJXI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"eucfh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeJoinAggregateFromFacet", ()=>makeJoinAggregateFromFacet);
var _channeldef = require("../../channeldef");
var _sort = require("../../sort");
var _facet = require("../facet");
var _joinaggregate = require("./joinaggregate");
function makeJoinAggregateFromFacet(parent, facet) {
    const { row, column } = facet;
    if (row && column) {
        let newParent = null;
        // only need to make one for crossed facet
        for (const fieldDef of [
            row,
            column
        ])if ((0, _sort.isSortField)(fieldDef.sort)) {
            const { field, op = (0, _sort.DEFAULT_SORT_OP) } = fieldDef.sort;
            parent = newParent = new (0, _joinaggregate.JoinAggregateTransformNode)(parent, {
                joinaggregate: [
                    {
                        op,
                        field,
                        as: (0, _facet.facetSortFieldName)(fieldDef, fieldDef.sort, {
                            forAs: true
                        })
                    }
                ],
                groupby: [
                    (0, _channeldef.vgField)(fieldDef)
                ]
            });
        }
        return newParent;
    }
    return null;
}

},{"../../channeldef":"dsccb","../../sort":"aWnXd","../facet":"7tiXg","./joinaggregate":"fFW6U","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"7tiXg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "facetSortFieldName", ()=>facetSortFieldName);
parcelHelpers.export(exports, "FacetModel", ()=>FacetModel);
var _vegaUtil = require("vega-util");
var _bin = require("../bin");
var _channel = require("../channel");
var _channeldef = require("../channeldef");
var _expr = require("../expr");
var _log = require("../log");
var _scale = require("../scale");
var _sort = require("../sort");
var _facet = require("../spec/facet");
var _util = require("../util");
var _vegaSchema = require("../vega.schema");
var _buildmodel = require("./buildmodel");
var _assemble = require("./data/assemble");
var _calculate = require("./data/calculate");
var _parse = require("./data/parse");
var _assemble1 = require("./header/assemble");
var _common = require("./header/common");
var _component = require("./header/component");
var _parse1 = require("./header/parse");
var _parse2 = require("./layoutsize/parse");
var _model = require("./model");
var _domain = require("./scale/domain");
var _assemble2 = require("./selection/assemble");
var _selection = require("./selection");
var _message = require("../log/message");
function facetSortFieldName(fieldDef, sort, opt) {
    return (0, _channeldef.vgField)(sort, {
        suffix: `by_${(0, _channeldef.vgField)(fieldDef)}`,
        ...opt
    });
}
class FacetModel extends (0, _model.ModelWithField) {
    constructor(spec, parent, parentGivenName, config){
        super(spec, 'facet', parent, parentGivenName, config, spec.resolve);
        this.child = (0, _buildmodel.buildModel)(spec.spec, this, this.getName('child'), undefined, config);
        this.children = [
            this.child
        ];
        this.facet = this.initFacet(spec.facet);
    }
    initFacet(facet) {
        // clone to prevent side effect to the original spec
        if (!(0, _facet.isFacetMapping)(facet)) return {
            facet: this.initFacetFieldDef(facet, 'facet')
        };
        const channels = (0, _util.keys)(facet);
        const normalizedFacet = {};
        for (const channel of channels){
            if (![
                (0, _channel.ROW),
                (0, _channel.COLUMN)
            ].includes(channel)) {
                // Drop unsupported channel
                _log.warn(_log.message.incompatibleChannel(channel, 'facet'));
                break;
            }
            const fieldDef = facet[channel];
            if (fieldDef.field === undefined) {
                _log.warn(_log.message.emptyFieldDef(fieldDef, channel));
                break;
            }
            normalizedFacet[channel] = this.initFacetFieldDef(fieldDef, channel);
        }
        return normalizedFacet;
    }
    initFacetFieldDef(fieldDef, channel) {
        // Cast because we call initFieldDef, which assumes general FieldDef.
        // However, FacetFieldDef is a bit more constrained than the general FieldDef
        const facetFieldDef = (0, _channeldef.initFieldDef)(fieldDef, channel);
        if (facetFieldDef.header) facetFieldDef.header = (0, _expr.replaceExprRef)(facetFieldDef.header);
        else if (facetFieldDef.header === null) facetFieldDef.header = null;
        return facetFieldDef;
    }
    channelHasField(channel) {
        return (0, _util.hasProperty)(this.facet, channel);
    }
    fieldDef(channel) {
        return this.facet[channel];
    }
    parseData() {
        this.component.data = (0, _parse.parseData)(this);
        this.child.parseData();
    }
    parseLayoutSize() {
        (0, _parse2.parseChildrenLayoutSize)(this);
    }
    parseSelections() {
        // As a facet has a single child, the selection components are the same.
        // The child maintains its selections to assemble signals, which remain
        // within its unit.
        this.child.parseSelections();
        this.component.selection = this.child.component.selection;
        if (Object.values(this.component.selection).some((selCmpt)=>(0, _selection.isTimerSelection)(selCmpt))) _log.error((0, _message.MULTI_VIEW_ANIMATION_UNSUPPORTED));
    }
    parseMarkGroup() {
        this.child.parseMarkGroup();
    }
    parseAxesAndHeaders() {
        this.child.parseAxesAndHeaders();
        (0, _parse1.parseFacetHeaders)(this);
    }
    assembleSelectionTopLevelSignals(signals) {
        return this.child.assembleSelectionTopLevelSignals(signals);
    }
    assembleSignals() {
        this.child.assembleSignals();
        return [];
    }
    assembleSelectionData(data) {
        return this.child.assembleSelectionData(data);
    }
    getHeaderLayoutMixins() {
        const layoutMixins = {};
        for (const channel of (0, _channel.FACET_CHANNELS))for (const headerType of (0, _component.HEADER_TYPES)){
            const layoutHeaderComponent = this.component.layoutHeaders[channel];
            const headerComponent = layoutHeaderComponent[headerType];
            const { facetFieldDef } = layoutHeaderComponent;
            if (facetFieldDef) {
                const titleOrient = (0, _common.getHeaderProperty)('titleOrient', facetFieldDef.header, this.config, channel);
                if ([
                    'right',
                    'bottom'
                ].includes(titleOrient)) {
                    const headerChannel = (0, _common.getHeaderChannel)(channel, titleOrient);
                    layoutMixins.titleAnchor ?? (layoutMixins.titleAnchor = {});
                    layoutMixins.titleAnchor[headerChannel] = 'end';
                }
            }
            if (headerComponent?.[0]) {
                // set header/footerBand
                const sizeType = channel === 'row' ? 'height' : 'width';
                const bandType = headerType === 'header' ? 'headerBand' : 'footerBand';
                if (channel !== 'facet' && !this.child.component.layoutSize.get(sizeType)) {
                    // If facet child does not have size signal, then apply headerBand
                    layoutMixins[bandType] ?? (layoutMixins[bandType] = {});
                    layoutMixins[bandType][channel] = 0.5;
                }
                if (layoutHeaderComponent.title) {
                    layoutMixins.offset ?? (layoutMixins.offset = {});
                    layoutMixins.offset[channel === 'row' ? 'rowTitle' : 'columnTitle'] = 10;
                }
            }
        }
        return layoutMixins;
    }
    assembleDefaultLayout() {
        const { column, row } = this.facet;
        const columns = column ? this.columnDistinctSignal() : row ? 1 : undefined;
        let align = 'all';
        // Do not align the cells if the scale corresponding to the direction is indepent.
        // We always align when we facet into both row and column.
        if (!row && this.component.resolve.scale.x === 'independent') align = 'none';
        else if (!column && this.component.resolve.scale.y === 'independent') align = 'none';
        return {
            ...this.getHeaderLayoutMixins(),
            ...columns ? {
                columns
            } : {},
            bounds: 'full',
            align
        };
    }
    assembleLayoutSignals() {
        // FIXME(https://github.com/vega/vega-lite/issues/1193): this can be incorrect if we have independent scales.
        return this.child.assembleLayoutSignals();
    }
    columnDistinctSignal() {
        if (this.parent && this.parent instanceof FacetModel) // For nested facet, we will add columns to group mark instead
        // See discussion in https://github.com/vega/vega/issues/952
        // and https://github.com/vega/vega-view/releases/tag/v1.2.6
        return undefined;
        else {
            // In facetNode.assemble(), the name is always this.getName('column') + '_layout'.
            const facetLayoutDataName = this.getName('column_domain');
            return {
                signal: `length(data('${facetLayoutDataName}'))`
            };
        }
    }
    assembleGroupStyle() {
        return undefined;
    }
    assembleGroup(signals) {
        if (this.parent && this.parent instanceof FacetModel) // Provide number of columns for layout.
        // See discussion in https://github.com/vega/vega/issues/952
        // and https://github.com/vega/vega-view/releases/tag/v1.2.6
        return {
            ...this.channelHasField('column') ? {
                encode: {
                    update: {
                        // TODO(https://github.com/vega/vega-lite/issues/2759):
                        // Correct the signal for facet of concat of facet_column
                        columns: {
                            field: (0, _channeldef.vgField)(this.facet.column, {
                                prefix: 'distinct'
                            })
                        }
                    }
                }
            } : {},
            ...super.assembleGroup(signals)
        };
        return super.assembleGroup(signals);
    }
    /**
     * Aggregate cardinality for calculating size
     */ getCardinalityAggregateForChild() {
        const fields = [];
        const ops = [];
        const as = [];
        if (this.child instanceof FacetModel) {
            if (this.child.channelHasField('column')) {
                const field = (0, _channeldef.vgField)(this.child.facet.column);
                fields.push(field);
                ops.push('distinct');
                as.push(`distinct_${field}`);
            }
        } else for (const channel of (0, _channel.POSITION_SCALE_CHANNELS)){
            const childScaleComponent = this.child.component.scales[channel];
            if (childScaleComponent && !childScaleComponent.merged) {
                const type = childScaleComponent.get('type');
                const range = childScaleComponent.get('range');
                if ((0, _scale.hasDiscreteDomain)(type) && (0, _vegaSchema.isVgRangeStep)(range)) {
                    const domain = (0, _domain.assembleDomain)(this.child, channel);
                    const field = (0, _domain.getFieldFromDomain)(domain);
                    if (field) {
                        fields.push(field);
                        ops.push('distinct');
                        as.push(`distinct_${field}`);
                    } else _log.warn(_log.message.unknownField(channel));
                }
            }
        }
        return {
            fields,
            ops,
            as
        };
    }
    assembleFacet() {
        const { name, data } = this.component.data.facetRoot;
        const { row, column } = this.facet;
        const { fields, ops, as } = this.getCardinalityAggregateForChild();
        const groupby = [];
        for (const channel of (0, _channel.FACET_CHANNELS)){
            const fieldDef = this.facet[channel];
            if (fieldDef) {
                groupby.push((0, _channeldef.vgField)(fieldDef));
                const { bin, sort } = fieldDef;
                if ((0, _bin.isBinning)(bin)) groupby.push((0, _channeldef.vgField)(fieldDef, {
                    binSuffix: 'end'
                }));
                if ((0, _sort.isSortField)(sort)) {
                    const { field, op = (0, _sort.DEFAULT_SORT_OP) } = sort;
                    const outputName = facetSortFieldName(fieldDef, sort);
                    if (row && column) {
                        // For crossed facet, use pre-calculate field as it requires a different groupby
                        // For each calculated field, apply max and assign them to the same name as
                        // all values of the same group should be the same anyway.
                        fields.push(outputName);
                        ops.push('max');
                        as.push(outputName);
                    } else {
                        fields.push(field);
                        ops.push(op);
                        as.push(outputName);
                    }
                } else if ((0, _vegaUtil.isArray)(sort)) {
                    const outputName = (0, _calculate.sortArrayIndexField)(fieldDef, channel);
                    fields.push(outputName);
                    ops.push('max');
                    as.push(outputName);
                }
            }
        }
        const cross = !!row && !!column;
        return {
            name,
            data,
            groupby,
            ...cross || fields.length > 0 ? {
                aggregate: {
                    ...cross ? {
                        cross
                    } : {},
                    ...fields.length ? {
                        fields,
                        ops,
                        as
                    } : {}
                }
            } : {}
        };
    }
    facetSortFields(channel) {
        const { facet } = this;
        const fieldDef = facet[channel];
        if (fieldDef) {
            if ((0, _sort.isSortField)(fieldDef.sort)) return [
                facetSortFieldName(fieldDef, fieldDef.sort, {
                    expr: 'datum'
                })
            ];
            else if ((0, _vegaUtil.isArray)(fieldDef.sort)) return [
                (0, _calculate.sortArrayIndexField)(fieldDef, channel, {
                    expr: 'datum'
                })
            ];
            return [
                (0, _channeldef.vgField)(fieldDef, {
                    expr: 'datum'
                })
            ];
        }
        return [];
    }
    facetSortOrder(channel) {
        const { facet } = this;
        const fieldDef = facet[channel];
        if (fieldDef) {
            const { sort } = fieldDef;
            const order = ((0, _sort.isSortField)(sort) ? sort.order : !(0, _vegaUtil.isArray)(sort) && sort) || 'ascending';
            return [
                order
            ];
        }
        return [];
    }
    assembleLabelTitle() {
        const { facet, config } = this;
        if (facet.facet) // Facet always uses title to display labels
        return (0, _assemble1.assembleLabelTitle)(facet.facet, 'facet', config);
        const ORTHOGONAL_ORIENT = {
            row: [
                'top',
                'bottom'
            ],
            column: [
                'left',
                'right'
            ]
        };
        for (const channel of (0, _component.HEADER_CHANNELS))if (facet[channel]) {
            const labelOrient = (0, _common.getHeaderProperty)('labelOrient', facet[channel]?.header, config, channel);
            if (ORTHOGONAL_ORIENT[channel].includes(labelOrient)) // Row/Column with orthogonal labelOrient must use title to display labels
            return (0, _assemble1.assembleLabelTitle)(facet[channel], channel, config);
        }
        return undefined;
    }
    assembleMarks() {
        const { child } = this;
        // If we facet by two dimensions, we need to add a cross operator to the aggregation
        // so that we create all groups
        const facetRoot = this.component.data.facetRoot;
        const data = (0, _assemble.assembleFacetData)(facetRoot);
        const encodeEntry = child.assembleGroupEncodeEntry(false);
        const title = this.assembleLabelTitle() || child.assembleTitle();
        const style = child.assembleGroupStyle();
        const markGroup = {
            name: this.getName('cell'),
            type: 'group',
            ...title ? {
                title
            } : {},
            ...style ? {
                style
            } : {},
            from: {
                facet: this.assembleFacet()
            },
            // TODO: move this to after data
            sort: {
                field: (0, _channel.FACET_CHANNELS).map((c)=>this.facetSortFields(c)).flat(),
                order: (0, _channel.FACET_CHANNELS).map((c)=>this.facetSortOrder(c)).flat()
            },
            ...data.length > 0 ? {
                data
            } : {},
            ...encodeEntry ? {
                encode: {
                    update: encodeEntry
                }
            } : {},
            ...child.assembleGroup((0, _assemble2.assembleFacetSignals)(this, []))
        };
        return [
            markGroup
        ];
    }
    getMapping() {
        return this.facet;
    }
}

},{"vega-util":"7f6sQ","../bin":"3cpW8","../channel":"liLED","../channeldef":"dsccb","../expr":"ev4sO","../log":"loqTw","../scale":"bdpXN","../sort":"aWnXd","../spec/facet":"3pm05","../util":"acUGA","../vega.schema":"3mBOT","./buildmodel":"2GQcr","./data/assemble":"64EbN","./data/calculate":"aCN2T","./data/parse":"5V0Ly","./header/assemble":"kmU8z","./header/common":"aM8kl","./header/component":"d5ljn","./header/parse":"MxSNu","./layoutsize/parse":"84zTX","./model":"hQHib","./scale/domain":"ebJoM","./selection/assemble":"4YKkA","./selection":"7GXIu","../log/message":"fb2MK","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"64EbN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Assemble data sources that are derived from faceted data.
 */ parcelHelpers.export(exports, "assembleFacetData", ()=>assembleFacetData);
/**
 * Create Vega data array from a given compiled model and append all of them to the given array
 *
 * @param  model
 * @param  data array
 * @return modified data array
 */ parcelHelpers.export(exports, "assembleRootData", ()=>assembleRootData);
var _data = require("../../data");
var _aggregate = require("./aggregate");
var _bin = require("./bin");
var _calculate = require("./calculate");
var _dataflow = require("./dataflow");
var _density = require("./density");
var _extent = require("./extent");
var _facet = require("./facet");
var _filter = require("./filter");
var _filterinvalid = require("./filterinvalid");
var _flatten = require("./flatten");
var _fold = require("./fold");
var _formatparse = require("./formatparse");
var _geojson = require("./geojson");
var _geopoint = require("./geopoint");
var _graticule = require("./graticule");
var _identifier = require("./identifier");
var _impute = require("./impute");
var _joinaggregate = require("./joinaggregate");
var _loess = require("./loess");
var _lookup = require("./lookup");
var _quantile = require("./quantile");
var _regression = require("./regression");
var _pivot = require("./pivot");
var _sample = require("./sample");
var _sequence = require("./sequence");
var _source = require("./source");
var _stack = require("./stack");
var _timeunit = require("./timeunit");
var _window = require("./window");
function makeWalkTree(data) {
    // to name datasources
    let datasetIndex = 0;
    /**
     * Recursively walk down the tree.
     */ function walkTree(node, dataSource) {
        if (node instanceof (0, _source.SourceNode)) // If the source is a named data source or a data source with values, we need
        // to put it in a different data source. Otherwise, Vega may override the data.
        {
            if (!node.isGenerator && !(0, _data.isUrlData)(node.data)) {
                data.push(dataSource);
                const newData = {
                    name: null,
                    source: dataSource.name,
                    transform: []
                };
                dataSource = newData;
            }
        }
        if (node instanceof (0, _formatparse.ParseNode)) {
            if (node.parent instanceof (0, _source.SourceNode) && !dataSource.source) {
                // If node's parent is a root source and the data source does not refer to another data source, use normal format parse
                dataSource.format = {
                    ...dataSource.format,
                    parse: node.assembleFormatParse()
                };
                // add calculates for all nested fields
                dataSource.transform.push(...node.assembleTransforms(true));
            } else // Otherwise use Vega expression to parse
            dataSource.transform.push(...node.assembleTransforms());
        }
        if (node instanceof (0, _facet.FacetNode)) {
            if (!dataSource.name) dataSource.name = `data_${datasetIndex++}`;
            if (!dataSource.source || dataSource.transform.length > 0) {
                data.push(dataSource);
                node.data = dataSource.name;
            } else node.data = dataSource.source;
            data.push(...node.assemble());
            // break here because the rest of the tree has to be taken care of by the facet.
            return;
        }
        if (node instanceof (0, _graticule.GraticuleNode) || node instanceof (0, _sequence.SequenceNode) || node instanceof (0, _filterinvalid.FilterInvalidNode) || node instanceof (0, _filter.FilterNode) || node instanceof (0, _calculate.CalculateNode) || node instanceof (0, _geopoint.GeoPointNode) || node instanceof (0, _aggregate.AggregateNode) || node instanceof (0, _lookup.LookupNode) || node instanceof (0, _window.WindowTransformNode) || node instanceof (0, _joinaggregate.JoinAggregateTransformNode) || node instanceof (0, _fold.FoldTransformNode) || node instanceof (0, _flatten.FlattenTransformNode) || node instanceof (0, _density.DensityTransformNode) || node instanceof (0, _loess.LoessTransformNode) || node instanceof (0, _quantile.QuantileTransformNode) || node instanceof (0, _regression.RegressionTransformNode) || node instanceof (0, _identifier.IdentifierNode) || node instanceof (0, _sample.SampleTransformNode) || node instanceof (0, _pivot.PivotTransformNode) || node instanceof (0, _extent.ExtentTransformNode)) dataSource.transform.push(node.assemble());
        if (node instanceof (0, _bin.BinNode) || node instanceof (0, _timeunit.TimeUnitNode) || node instanceof (0, _impute.ImputeNode) || node instanceof (0, _stack.StackNode) || node instanceof (0, _geojson.GeoJSONNode)) dataSource.transform.push(...node.assemble());
        if (node instanceof (0, _dataflow.OutputNode)) {
            if (dataSource.source && dataSource.transform.length === 0) node.setSource(dataSource.source);
            else if (node.parent instanceof (0, _dataflow.OutputNode)) // Note that an output node may be required but we still do not assemble a
            // separate data source for it.
            node.setSource(dataSource.name);
            else {
                if (!dataSource.name) dataSource.name = `data_${datasetIndex++}`;
                // Here we set the name of the datasource we generated. From now on
                // other assemblers can use it.
                node.setSource(dataSource.name);
                // if this node has more than one child, we will add a datasource automatically
                if (node.numChildren() === 1) {
                    data.push(dataSource);
                    const newData = {
                        name: null,
                        source: dataSource.name,
                        transform: []
                    };
                    dataSource = newData;
                }
            }
        }
        switch(node.numChildren()){
            case 0:
                // done
                if (node instanceof (0, _dataflow.OutputNode) && (!dataSource.source || dataSource.transform.length > 0)) // do not push empty datasources that are simply references
                data.push(dataSource);
                break;
            case 1:
                walkTree(node.children[0], dataSource);
                break;
            default:
                {
                    if (!dataSource.name) dataSource.name = `data_${datasetIndex++}`;
                    let source = dataSource.name;
                    if (!dataSource.source || dataSource.transform.length > 0) data.push(dataSource);
                    else source = dataSource.source;
                    for (const child of node.children){
                        const newData = {
                            name: null,
                            source,
                            transform: []
                        };
                        walkTree(child, newData);
                    }
                    break;
                }
        }
    }
    return walkTree;
}
function assembleFacetData(root) {
    const data = [];
    const walkTree = makeWalkTree(data);
    for (const child of root.children)walkTree(child, {
        source: root.name,
        name: null,
        transform: []
    });
    return data;
}
function assembleRootData(dataComponent, datasets) {
    const data = [];
    // dataComponent.sources.forEach(debug);
    // draw(dataComponent.sources);
    const walkTree = makeWalkTree(data);
    let sourceIndex = 0;
    for (const root of dataComponent.sources){
        // assign a name if the source does not have a name yet
        if (!root.hasName()) root.dataName = `source_${sourceIndex++}`;
        const newData = root.assemble();
        walkTree(root, newData);
    }
    // remove empty transform arrays for cleaner output
    for (const d of data)if (d.transform.length === 0) delete d.transform;
    // move sources without transforms (the ones that are potentially used in lookups) to the beginning
    let whereTo = 0;
    for (const [i, d] of data.entries())if ((d.transform ?? []).length === 0 && !d.source) data.splice(whereTo++, 0, data.splice(i, 1)[0]);
    // now fix the from references in lookup transforms
    for (const d of data){
        for (const t of d.transform ?? [])if (t.type === 'lookup') t.from = dataComponent.outputNodes[t.from].getSource();
    }
    // inline values for datasets that are in the datastore
    for (const d of data)if (d.name in datasets) d.values = datasets[d.name];
    return data;
}

},{"../../data":"dILEy","./aggregate":"8WvlR","./bin":"3xZkr","./calculate":"aCN2T","./dataflow":"btJXI","./density":"aWjoR","./extent":"4tyGU","./facet":"ce2Ry","./filter":"8Tzn7","./filterinvalid":"2Zybg","./flatten":"ceJ4t","./fold":"1zNXb","./formatparse":"2mSh3","./geojson":"aXTII","./geopoint":"hJ38i","./graticule":"84yrw","./identifier":"cuiH8","./impute":"7krbQ","./joinaggregate":"fFW6U","./loess":"gMkGf","./lookup":"k5SyK","./quantile":"k1FJv","./regression":"a2AiO","./pivot":"7CfmC","./sample":"lElH5","./sequence":"jQuXh","./source":"bhsCG","./stack":"2WMdr","./timeunit":"iPsUH","./window":"gHMn4","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"gMkGf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A class for loess transform nodes
 */ parcelHelpers.export(exports, "LoessTransformNode", ()=>LoessTransformNode);
var _util = require("../../util");
var _dataflow = require("./dataflow");
class LoessTransformNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new LoessTransformNode(null, (0, _util.duplicate)(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
        this.transform = (0, _util.duplicate)(transform); // duplicate to prevent side effects
        const specifiedAs = this.transform.as ?? [
            undefined,
            undefined
        ];
        this.transform.as = [
            specifiedAs[0] ?? transform.on,
            specifiedAs[1] ?? transform.loess
        ];
    }
    dependentFields() {
        return new Set([
            this.transform.loess,
            this.transform.on,
            ...this.transform.groupby ?? []
        ]);
    }
    producedFields() {
        return new Set(this.transform.as);
    }
    hash() {
        return `LoessTransform ${(0, _util.hash)(this.transform)}`;
    }
    assemble() {
        const { loess, on, ...rest } = this.transform;
        const result = {
            type: 'loess',
            x: on,
            y: loess,
            ...rest
        };
        return result;
    }
}

},{"../../util":"acUGA","./dataflow":"btJXI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"k5SyK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LookupNode", ()=>LookupNode);
var _vegaUtil = require("vega-util");
var _log = require("../../log");
var _transform = require("../../transform");
var _util = require("../../util");
var _dataflow = require("./dataflow");
var _parse = require("./parse");
var _source = require("./source");
var _data = require("../../data");
class LookupNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new LookupNode(null, (0, _util.duplicate)(this.transform), this.secondary);
    }
    constructor(parent, transform, secondary){
        super(parent);
        this.transform = transform;
        this.secondary = secondary;
    }
    static make(parent, model, transform, counter) {
        const sources = model.component.data.sources;
        const { from } = transform;
        let fromOutputNode = null;
        if ((0, _transform.isLookupData)(from)) {
            let fromSource = (0, _parse.findSource)(from.data, sources);
            if (!fromSource) {
                fromSource = new (0, _source.SourceNode)(from.data);
                sources.push(fromSource);
            }
            const fromOutputName = model.getName(`lookup_${counter}`);
            fromOutputNode = new (0, _dataflow.OutputNode)(fromSource, fromOutputName, (0, _data.DataSourceType).Lookup, model.component.data.outputNodeRefCounts);
            model.component.data.outputNodes[fromOutputName] = fromOutputNode;
        } else if ((0, _transform.isLookupSelection)(from)) {
            const selName = from.param;
            transform = {
                as: selName,
                ...transform
            };
            let selCmpt;
            try {
                selCmpt = model.getSelectionComponent((0, _util.varName)(selName), selName);
            } catch (e) {
                throw new Error(_log.message.cannotLookupVariableParameter(selName));
            }
            fromOutputNode = selCmpt.materialized;
            if (!fromOutputNode) throw new Error(_log.message.noSameUnitLookup(selName));
        }
        return new LookupNode(parent, transform, fromOutputNode.getSource());
    }
    dependentFields() {
        return new Set([
            this.transform.lookup
        ]);
    }
    producedFields() {
        return new Set(this.transform.as ? (0, _vegaUtil.array)(this.transform.as) : this.transform.from.fields);
    }
    hash() {
        return `Lookup ${(0, _util.hash)({
            transform: this.transform,
            secondary: this.secondary
        })}`;
    }
    assemble() {
        let foreign;
        if (this.transform.from.fields) // lookup a few fields and add create a flat output
        foreign = {
            values: this.transform.from.fields,
            ...this.transform.as ? {
                as: (0, _vegaUtil.array)(this.transform.as)
            } : {}
        };
        else {
            // lookup full record and nest it
            let asName = this.transform.as;
            if (!(0, _vegaUtil.isString)(asName)) {
                _log.warn(_log.message.NO_FIELDS_NEEDS_AS);
                asName = '_lookup';
            }
            foreign = {
                as: [
                    asName
                ]
            };
        }
        return {
            type: 'lookup',
            from: this.secondary,
            key: this.transform.from.key,
            fields: [
                this.transform.lookup
            ],
            ...foreign,
            ...this.transform.default ? {
                default: this.transform.default
            } : {}
        };
    }
}

},{"vega-util":"7f6sQ","../../log":"loqTw","../../transform":"ld5WF","../../util":"acUGA","./dataflow":"btJXI","./parse":"5V0Ly","./source":"bhsCG","../../data":"dILEy","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"k1FJv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A class for quantile transform nodes
 */ parcelHelpers.export(exports, "QuantileTransformNode", ()=>QuantileTransformNode);
var _util = require("../../util");
var _dataflow = require("./dataflow");
class QuantileTransformNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new QuantileTransformNode(null, (0, _util.duplicate)(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
        this.transform = (0, _util.duplicate)(transform); // duplicate to prevent side effects
        const specifiedAs = this.transform.as ?? [
            undefined,
            undefined
        ];
        this.transform.as = [
            specifiedAs[0] ?? 'prob',
            specifiedAs[1] ?? 'value'
        ];
    }
    dependentFields() {
        return new Set([
            this.transform.quantile,
            ...this.transform.groupby ?? []
        ]);
    }
    producedFields() {
        return new Set(this.transform.as);
    }
    hash() {
        return `QuantileTransform ${(0, _util.hash)(this.transform)}`;
    }
    assemble() {
        const { quantile, ...rest } = this.transform;
        const result = {
            type: 'quantile',
            field: quantile,
            ...rest
        };
        return result;
    }
}

},{"../../util":"acUGA","./dataflow":"btJXI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"a2AiO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A class for regression transform nodes
 */ parcelHelpers.export(exports, "RegressionTransformNode", ()=>RegressionTransformNode);
var _util = require("../../util");
var _dataflow = require("./dataflow");
class RegressionTransformNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new RegressionTransformNode(null, (0, _util.duplicate)(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
        this.transform = (0, _util.duplicate)(transform); // duplicate to prevent side effects
        const specifiedAs = this.transform.as ?? [
            undefined,
            undefined
        ];
        this.transform.as = [
            specifiedAs[0] ?? transform.on,
            specifiedAs[1] ?? transform.regression
        ];
    }
    dependentFields() {
        return new Set([
            this.transform.regression,
            this.transform.on,
            ...this.transform.groupby ?? []
        ]);
    }
    producedFields() {
        return new Set(this.transform.as);
    }
    hash() {
        return `RegressionTransform ${(0, _util.hash)(this.transform)}`;
    }
    assemble() {
        const { regression, on, ...rest } = this.transform;
        const result = {
            type: 'regression',
            x: on,
            y: regression,
            ...rest
        };
        return result;
    }
}

},{"../../util":"acUGA","./dataflow":"btJXI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"7CfmC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A class for pivot transform nodes.
 */ parcelHelpers.export(exports, "PivotTransformNode", ()=>PivotTransformNode);
var _util = require("../../util");
var _dataflow = require("./dataflow");
class PivotTransformNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new PivotTransformNode(null, (0, _util.duplicate)(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
    }
    addDimensions(fields) {
        this.transform.groupby = (0, _util.unique)((this.transform.groupby ?? []).concat(fields), (d)=>d);
    }
    producedFields() {
        return undefined; // return undefined so that potentially everything can depend on the pivot
    }
    dependentFields() {
        return new Set([
            this.transform.pivot,
            this.transform.value,
            ...this.transform.groupby ?? []
        ]);
    }
    hash() {
        return `PivotTransform ${(0, _util.hash)(this.transform)}`;
    }
    assemble() {
        const { pivot, value, groupby, limit, op } = this.transform;
        return {
            type: 'pivot',
            field: pivot,
            value,
            ...limit !== undefined ? {
                limit
            } : {},
            ...op !== undefined ? {
                op
            } : {},
            ...groupby !== undefined ? {
                groupby
            } : {}
        };
    }
}

},{"../../util":"acUGA","./dataflow":"btJXI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"lElH5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A class for the sample transform nodes
 */ parcelHelpers.export(exports, "SampleTransformNode", ()=>SampleTransformNode);
var _util = require("../../util");
var _dataflow = require("./dataflow");
class SampleTransformNode extends (0, _dataflow.DataFlowNode) {
    clone() {
        return new SampleTransformNode(null, (0, _util.duplicate)(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
    }
    dependentFields() {
        return new Set();
    }
    producedFields() {
        return new Set();
    }
    hash() {
        return `SampleTransform ${(0, _util.hash)(this.transform)}`;
    }
    assemble() {
        return {
            type: 'sample',
            size: this.transform.sample
        };
    }
}

},{"../../util":"acUGA","./dataflow":"btJXI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"MxSNu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHeaderType", ()=>getHeaderType);
parcelHelpers.export(exports, "parseFacetHeaders", ()=>parseFacetHeaders);
var _vegaUtil = require("vega-util");
var _channel = require("../../channel");
var _channeldef = require("../../channeldef");
var _util = require("../../util");
var _vegaSchema = require("../../vega.schema");
var _assemble = require("../axis/assemble");
var _resolve = require("../resolve");
var _common = require("./common");
function getHeaderType(orient) {
    if (orient === 'top' || orient === 'left' || (0, _vegaSchema.isSignalRef)(orient)) // we always use header for orient signal since we can't dynamically make header becomes footer
    return 'header';
    return 'footer';
}
function parseFacetHeaders(model) {
    for (const channel of (0, _channel.FACET_CHANNELS))parseFacetHeader(model, channel);
    mergeChildAxis(model, 'x');
    mergeChildAxis(model, 'y');
}
function parseFacetHeader(model, channel) {
    const { facet, config, child, component } = model;
    if (model.channelHasField(channel)) {
        const fieldDef = facet[channel];
        const titleConfig = (0, _common.getHeaderProperty)('title', null, config, channel);
        let title = (0, _channeldef.title)(fieldDef, config, {
            allowDisabling: true,
            includeDefault: titleConfig === undefined || !!titleConfig
        });
        if (child.component.layoutHeaders[channel].title) {
            // TODO: better handle multiline titles
            title = (0, _vegaUtil.isArray)(title) ? title.join(', ') : title;
            // merge title with child to produce "Title / Subtitle / Sub-subtitle"
            title += ` / ${child.component.layoutHeaders[channel].title}`;
            child.component.layoutHeaders[channel].title = null;
        }
        const labelOrient = (0, _common.getHeaderProperty)('labelOrient', fieldDef.header, config, channel);
        const labels = fieldDef.header !== null ? (0, _util.getFirstDefined)(fieldDef.header?.labels, config.header.labels, true) : false;
        const headerType = (0, _util.contains)([
            'bottom',
            'right'
        ], labelOrient) ? 'footer' : 'header';
        component.layoutHeaders[channel] = {
            title: fieldDef.header !== null ? title : null,
            facetFieldDef: fieldDef,
            [headerType]: channel === 'facet' ? [] : [
                makeHeaderComponent(model, channel, labels)
            ]
        };
    }
}
function makeHeaderComponent(model, channel, labels) {
    const sizeType = channel === 'row' ? 'height' : 'width';
    return {
        labels,
        sizeSignal: model.child.component.layoutSize.get(sizeType) ? model.child.getSizeSignalRef(sizeType) : undefined,
        axes: []
    };
}
function mergeChildAxis(model, channel) {
    const { child } = model;
    if (child.component.axes[channel]) {
        const { layoutHeaders, resolve } = model.component;
        resolve.axis[channel] = (0, _resolve.parseGuideResolve)(resolve, channel);
        if (resolve.axis[channel] === 'shared') {
            // For shared axis, move the axes to facet's header or footer
            const headerChannel = channel === 'x' ? 'column' : 'row';
            const layoutHeader = layoutHeaders[headerChannel];
            for (const axisComponent of child.component.axes[channel]){
                const headerType = getHeaderType(axisComponent.get('orient'));
                layoutHeader[headerType] ?? (layoutHeader[headerType] = [
                    makeHeaderComponent(model, headerChannel, false)
                ]);
                // FIXME: assemble shouldn't be called here, but we do it this way so we only extract the main part of the axes
                const mainAxis = (0, _assemble.assembleAxis)(axisComponent, 'main', model.config, {
                    header: true
                });
                if (mainAxis) // LayoutHeader no longer keep track of property precedence, thus let's combine.
                layoutHeader[headerType][0].axes.push(mainAxis);
                axisComponent.mainExtracted = true;
            }
        }
    }
}

},{"vega-util":"7f6sQ","../../channel":"liLED","../../channeldef":"dsccb","../../util":"acUGA","../../vega.schema":"3mBOT","../axis/assemble":"jjOQk","../resolve":"felCG","./common":"aM8kl","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"84zTX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseLayerLayoutSize", ()=>parseLayerLayoutSize);
parcelHelpers.export(exports, "parseConcatLayoutSize", ()=>parseConcatLayoutSize);
parcelHelpers.export(exports, "parseChildrenLayoutSize", ()=>parseChildrenLayoutSize);
parcelHelpers.export(exports, "parseUnitLayoutSize", ()=>parseUnitLayoutSize);
var _channel = require("../../channel");
var _config = require("../../config");
var _scale = require("../../scale");
var _base = require("../../spec/base");
var _vegaSchema = require("../../vega.schema");
var _resolve = require("../resolve");
var _split = require("../split");
var _component = require("./component");
function parseLayerLayoutSize(model) {
    parseChildrenLayoutSize(model);
    parseNonUnitLayoutSizeForChannel(model, 'width');
    parseNonUnitLayoutSizeForChannel(model, 'height');
}
function parseConcatLayoutSize(model) {
    parseChildrenLayoutSize(model);
    // for columns === 1 (vconcat), we can completely merge width. Otherwise, we can treat merged width as childWidth.
    const widthType = model.layout.columns === 1 ? 'width' : 'childWidth';
    // for columns === undefined (hconcat), we can completely merge height. Otherwise, we can treat merged height as childHeight.
    const heightType = model.layout.columns === undefined ? 'height' : 'childHeight';
    parseNonUnitLayoutSizeForChannel(model, widthType);
    parseNonUnitLayoutSizeForChannel(model, heightType);
}
function parseChildrenLayoutSize(model) {
    for (const child of model.children)child.parseLayoutSize();
}
/**
 * Merge child layout size (width or height).
 */ function parseNonUnitLayoutSizeForChannel(model, layoutSizeType) {
    /*
     * For concat, the parent width or height might not be the same as the children's shared height.
     * For example, hconcat's subviews may share width, but the shared width is not the hconcat view's width.
     *
     * layoutSizeType represents the output of the view (could be childWidth/childHeight/width/height)
     * while the sizeType represents the properties of the child.
     */ const sizeType = (0, _component.getSizeTypeFromLayoutSizeType)(layoutSizeType);
    const channel = (0, _channel.getPositionScaleChannel)(sizeType);
    const resolve = model.component.resolve;
    const layoutSizeCmpt = model.component.layoutSize;
    let mergedSize;
    // Try to merge layout size
    for (const child of model.children){
        const childSize = child.component.layoutSize.getWithExplicit(sizeType);
        const scaleResolve = resolve.scale[channel] ?? (0, _resolve.defaultScaleResolve)(channel, model);
        if (scaleResolve === 'independent' && childSize.value === 'step') {
            // Do not merge independent scales with range-step as their size depends
            // on the scale domains, which can be different between scales.
            mergedSize = undefined;
            break;
        }
        if (mergedSize) {
            if (scaleResolve === 'independent' && mergedSize.value !== childSize.value) {
                // For independent scale, only merge if all the sizes are the same.
                // If the values are different, abandon the merge!
                mergedSize = undefined;
                break;
            }
            mergedSize = (0, _split.mergeValuesWithExplicit)(mergedSize, childSize, sizeType, '');
        } else mergedSize = childSize;
    }
    if (mergedSize) {
        // If merged, rename size and set size of all children.
        for (const child of model.children){
            model.renameSignal(child.getName(sizeType), model.getName(layoutSizeType));
            child.component.layoutSize.set(sizeType, 'merged', false);
        }
        layoutSizeCmpt.setWithExplicit(layoutSizeType, mergedSize);
    } else layoutSizeCmpt.setWithExplicit(layoutSizeType, {
        explicit: false,
        value: undefined
    });
}
function parseUnitLayoutSize(model) {
    const { size, component } = model;
    for (const channel of (0, _channel.POSITION_SCALE_CHANNELS)){
        const sizeType = (0, _channel.getSizeChannel)(channel);
        if (size[sizeType]) {
            const specifiedSize = size[sizeType];
            component.layoutSize.set(sizeType, (0, _base.isStep)(specifiedSize) ? 'step' : specifiedSize, true);
        } else {
            const defaultSize = defaultUnitSize(model, sizeType);
            component.layoutSize.set(sizeType, defaultSize, false);
        }
    }
}
function defaultUnitSize(model, sizeType) {
    const channel = sizeType === 'width' ? 'x' : 'y';
    const config = model.config;
    const scaleComponent = model.getScaleComponent(channel);
    if (scaleComponent) {
        const scaleType = scaleComponent.get('type');
        const range = scaleComponent.get('range');
        if ((0, _scale.hasDiscreteDomain)(scaleType)) {
            const size = (0, _config.getViewConfigDiscreteSize)(config.view, sizeType);
            if ((0, _vegaSchema.isVgRangeStep)(range) || (0, _base.isStep)(size)) // For discrete domain with range.step, use dynamic width/height
            return 'step';
            else return size;
        } else return (0, _config.getViewConfigContinuousSize)(config.view, sizeType);
    } else if (model.hasProjection || model.mark === 'arc') // arc should use continuous size by default otherwise the pie is extremely small
    return (0, _config.getViewConfigContinuousSize)(config.view, sizeType);
    else {
        const size = (0, _config.getViewConfigDiscreteSize)(config.view, sizeType);
        return (0, _base.isStep)(size) ? size.step : size;
    }
}

},{"../../channel":"liLED","../../config":"8TUzf","../../scale":"bdpXN","../../spec/base":"5uH6T","../../vega.schema":"3mBOT","../resolve":"felCG","../split":"eXS2w","./component":"dwyom","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"gdgrZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayerModel", ()=>LayerModel);
var _vegaUtil = require("vega-util");
var _log = require("../log");
var _spec = require("../spec");
var _util = require("../util");
var _assemble = require("./axis/assemble");
var _parse = require("./axis/parse");
var _parse1 = require("./data/parse");
var _assemble1 = require("./layoutsize/assemble");
var _parse2 = require("./layoutsize/parse");
var _assemble2 = require("./legend/assemble");
var _model = require("./model");
var _assemble3 = require("./selection/assemble");
var _unit = require("./unit");
var _selection = require("./selection");
var _message = require("../log/message");
class LayerModel extends (0, _model.Model) {
    constructor(spec, parent, parentGivenName, parentGivenSize, config){
        super(spec, 'layer', parent, parentGivenName, config, spec.resolve, spec.view);
        const layoutSize = {
            ...parentGivenSize,
            ...spec.width ? {
                width: spec.width
            } : {},
            ...spec.height ? {
                height: spec.height
            } : {}
        };
        this.children = spec.layer.map((layer, i)=>{
            if ((0, _spec.isLayerSpec)(layer)) return new LayerModel(layer, this, this.getName(`layer_${i}`), layoutSize, config);
            else if ((0, _spec.isUnitSpec)(layer)) return new (0, _unit.UnitModel)(layer, this, this.getName(`layer_${i}`), layoutSize, config);
            throw new Error(_log.message.invalidSpec(layer));
        });
    }
    parseData() {
        this.component.data = (0, _parse1.parseData)(this);
        for (const child of this.children)child.parseData();
    }
    parseLayoutSize() {
        (0, _parse2.parseLayerLayoutSize)(this);
    }
    parseSelections() {
        // Merge selections up the hierarchy so that they may be referenced
        // across unit specs. Persist their definitions within each child
        // to assemble signals which remain within output Vega unit groups.
        this.component.selection = {};
        for (const child of this.children){
            child.parseSelections();
            for (const key of (0, _util.keys)(child.component.selection))this.component.selection[key] = child.component.selection[key];
        }
        if (Object.values(this.component.selection).some((selCmpt)=>(0, _selection.isTimerSelection)(selCmpt))) _log.error((0, _message.MULTI_VIEW_ANIMATION_UNSUPPORTED));
    }
    parseMarkGroup() {
        for (const child of this.children)child.parseMarkGroup();
    }
    parseAxesAndHeaders() {
        (0, _parse.parseLayerAxes)(this);
    }
    assembleSelectionTopLevelSignals(signals) {
        return this.children.reduce((sg, child)=>child.assembleSelectionTopLevelSignals(sg), signals);
    }
    // TODO: Support same named selections across children.
    assembleSignals() {
        return this.children.reduce((signals, child)=>{
            return signals.concat(child.assembleSignals());
        }, (0, _assemble.assembleAxisSignals)(this));
    }
    assembleLayoutSignals() {
        return this.children.reduce((signals, child)=>{
            return signals.concat(child.assembleLayoutSignals());
        }, (0, _assemble1.assembleLayoutSignals)(this));
    }
    assembleSelectionData(data) {
        return this.children.reduce((db, child)=>child.assembleSelectionData(db), data);
    }
    assembleGroupStyle() {
        const uniqueStyles = new Set();
        for (const child of this.children)for (const style of (0, _vegaUtil.array)(child.assembleGroupStyle()))uniqueStyles.add(style);
        const styles = Array.from(uniqueStyles);
        return styles.length > 1 ? styles : styles.length === 1 ? styles[0] : undefined;
    }
    assembleTitle() {
        let title = super.assembleTitle();
        if (title) return title;
        // If title does not provide layer, look into children
        for (const child of this.children){
            title = child.assembleTitle();
            if (title) return title;
        }
        return undefined;
    }
    assembleLayout() {
        return null;
    }
    assembleMarks() {
        return (0, _assemble3.assembleLayerSelectionMarks)(this, this.children.flatMap((child)=>{
            return child.assembleMarks();
        }));
    }
    assembleLegends() {
        return this.children.reduce((legends, child)=>{
            return legends.concat(child.assembleLegends());
        }, (0, _assemble2.assembleLegends)(this));
    }
}

},{"vega-util":"7f6sQ","../log":"loqTw","../spec":"5gjAD","../util":"acUGA","./axis/assemble":"jjOQk","./axis/parse":"cJSx8","./data/parse":"5V0Ly","./layoutsize/assemble":"cyXx5","./layoutsize/parse":"84zTX","./legend/assemble":"fTNbV","./model":"hQHib","./selection/assemble":"4YKkA","./unit":"jvFxg","./selection":"7GXIu","../log/message":"fb2MK","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cJSx8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseUnitAxes", ()=>parseUnitAxes);
parcelHelpers.export(exports, "parseLayerAxes", ()=>parseLayerAxes);
var _axis = require("../../axis");
var _channel = require("../../channel");
var _channeldef = require("../../channeldef");
var _util = require("../../util");
var _vegaSchema = require("../../vega.schema");
var _common = require("../common");
var _guide = require("../guide");
var _resolve = require("../resolve");
var _split = require("../split");
var _component = require("./component");
var _config = require("./config");
var _encode = require("./encode");
var _properties = require("./properties");
var _format = require("../format");
function parseUnitAxes(model) {
    return (0, _channel.POSITION_SCALE_CHANNELS).reduce((axis, channel)=>{
        if (model.component.scales[channel]) axis[channel] = [
            parseAxis(channel, model)
        ];
        return axis;
    }, {});
}
const OPPOSITE_ORIENT = {
    bottom: 'top',
    top: 'bottom',
    left: 'right',
    right: 'left'
};
function parseLayerAxes(model) {
    const { axes, resolve } = model.component;
    const axisCount = {
        top: 0,
        bottom: 0,
        right: 0,
        left: 0
    };
    for (const child of model.children){
        child.parseAxesAndHeaders();
        for (const channel of (0, _util.keys)(child.component.axes)){
            resolve.axis[channel] = (0, _resolve.parseGuideResolve)(model.component.resolve, channel);
            if (resolve.axis[channel] === 'shared') {
                // If the resolve says shared (and has not been overridden)
                // We will try to merge and see if there is a conflict
                axes[channel] = mergeAxisComponents(axes[channel], child.component.axes[channel]);
                if (!axes[channel]) {
                    // If merge returns nothing, there is a conflict so we cannot make the axis shared.
                    // Thus, mark axis as independent and remove the axis component.
                    resolve.axis[channel] = 'independent';
                    delete axes[channel];
                }
            }
        }
    }
    // Move axes to layer's axis component and merge shared axes
    for (const channel of (0, _channel.POSITION_SCALE_CHANNELS)){
        for (const child of model.children){
            if (!child.component.axes[channel]) continue;
            if (resolve.axis[channel] === 'independent') {
                // If axes are independent, concat the axisComponent array.
                axes[channel] = (axes[channel] ?? []).concat(child.component.axes[channel]);
                // Automatically adjust orient
                for (const axisComponent of child.component.axes[channel]){
                    const { value: orient, explicit } = axisComponent.getWithExplicit('orient');
                    if ((0, _vegaSchema.isSignalRef)(orient)) continue;
                    if (axisCount[orient] > 0 && !explicit) {
                        // Change axis orient if the number do not match
                        const oppositeOrient = OPPOSITE_ORIENT[orient];
                        if (axisCount[orient] > axisCount[oppositeOrient]) axisComponent.set('orient', oppositeOrient, false);
                    }
                    axisCount[orient]++;
                // TODO(https://github.com/vega/vega-lite/issues/2634): automatically add extra offset?
                }
            }
            // After merging, make sure to remove axes from child
            delete child.component.axes[channel];
        }
        // Show gridlines for first axis only for dual-axis chart
        if (resolve.axis[channel] === 'independent' && axes[channel] && axes[channel].length > 1) {
            for (const [index, axisCmpt] of (axes[channel] || []).entries())if (index > 0 && !!axisCmpt.get('grid') && !axisCmpt.explicit.grid) axisCmpt.implicit.grid = false;
        }
    }
}
function mergeAxisComponents(mergedAxisCmpts, childAxisCmpts) {
    if (mergedAxisCmpts) {
        // FIXME: this is a bit wrong once we support multiple axes
        if (mergedAxisCmpts.length !== childAxisCmpts.length) return undefined; // Cannot merge axis component with different number of axes.
        const length = mergedAxisCmpts.length;
        for(let i = 0; i < length; i++){
            const merged = mergedAxisCmpts[i];
            const child = childAxisCmpts[i];
            if (!!merged !== !!child) return undefined;
            else if (merged && child) {
                const mergedOrient = merged.getWithExplicit('orient');
                const childOrient = child.getWithExplicit('orient');
                if (mergedOrient.explicit && childOrient.explicit && mergedOrient.value !== childOrient.value) // TODO: throw warning if resolve is explicit (We don't have info about explicit/implicit resolve yet.)
                // Cannot merge due to inconsistent orient
                return undefined;
                else mergedAxisCmpts[i] = mergeAxisComponent(merged, child);
            }
        }
    } else // For first one, return a copy of the child
    return childAxisCmpts.map((axisComponent)=>axisComponent.clone());
    return mergedAxisCmpts;
}
function mergeAxisComponent(merged, child) {
    for (const prop of (0, _component.AXIS_COMPONENT_PROPERTIES)){
        const mergedValueWithExplicit = (0, _split.mergeValuesWithExplicit)(merged.getWithExplicit(prop), child.getWithExplicit(prop), prop, 'axis', // Tie breaker function
        (v1, v2)=>{
            switch(prop){
                case 'title':
                    return (0, _common.mergeTitleComponent)(v1, v2);
                case 'gridScale':
                    return {
                        explicit: v1.explicit,
                        value: (0, _util.getFirstDefined)(v1.value, v2.value)
                    };
            }
            return (0, _split.defaultTieBreaker)(v1, v2, prop, 'axis');
        });
        merged.setWithExplicit(prop, mergedValueWithExplicit);
    }
    return merged;
}
function isExplicit(value, property, axis, model, channel) {
    if (property === 'disable') return axis !== undefined; // if axis is specified or null/false, then its enable/disable state is explicit
    axis = axis || {};
    switch(property){
        case 'titleAngle':
        case 'labelAngle':
            return value === ((0, _vegaSchema.isSignalRef)(axis.labelAngle) ? axis.labelAngle : (0, _util.normalizeAngle)(axis.labelAngle));
        case 'values':
            return !!axis.values;
        // specified axis.values is already respected, but may get transformed.
        case 'encode':
            // both VL axis.encoding and axis.labelAngle affect VG axis.encode
            return !!axis.encoding || !!axis.labelAngle;
        case 'title':
            // title can be explicit if fieldDef.title is set
            if (value === (0, _properties.getFieldDefTitle)(model, channel)) return true;
    }
    // Otherwise, things are explicit if the returned value matches the specified property
    return value === axis[property];
}
/**
 * Properties to always include values from config
 */ const propsToAlwaysIncludeConfig = new Set([
    'grid',
    'translate',
    // the rest are not axis configs in Vega, but are in VL, so we need to set too.
    'format',
    'formatType',
    'orient',
    'labelExpr',
    'tickCount',
    'position',
    'tickMinStep'
]);
function parseAxis(channel, model) {
    let axis = model.axis(channel);
    const axisComponent = new (0, _component.AxisComponent)();
    const fieldOrDatumDef = (0, _channeldef.getFieldOrDatumDef)(model.encoding[channel]);
    const { mark, config } = model;
    const orient = axis?.orient || config[channel === 'x' ? 'axisX' : 'axisY']?.orient || config.axis?.orient || (0, _properties.defaultOrient)(channel);
    const scaleType = model.getScaleComponent(channel).get('type');
    const axisConfigs = (0, _config.getAxisConfigs)(channel, scaleType, orient, model.config);
    const disable = axis !== undefined ? !axis : (0, _config.getAxisConfig)('disable', config.style, axis?.style, axisConfigs).configValue;
    axisComponent.set('disable', disable, axis !== undefined);
    if (disable) return axisComponent;
    axis = axis || {};
    const labelAngle = (0, _properties.getLabelAngle)(fieldOrDatumDef, axis, channel, config.style, axisConfigs);
    const formatType = (0, _format.guideFormatType)(axis.formatType, fieldOrDatumDef, scaleType);
    const format = (0, _format.guideFormat)(fieldOrDatumDef, fieldOrDatumDef.type, axis.format, axis.formatType, config, true);
    const ruleParams = {
        fieldOrDatumDef,
        axis,
        channel,
        model,
        scaleType,
        orient,
        labelAngle,
        format,
        formatType,
        mark,
        config
    };
    // 1.2. Add properties
    for (const property of (0, _component.AXIS_COMPONENT_PROPERTIES)){
        const value = property in (0, _properties.axisRules) ? (0, _properties.axisRules)[property](ruleParams) : (0, _axis.isAxisProperty)(property) ? axis[property] : undefined;
        const hasValue = value !== undefined;
        const explicit = isExplicit(value, property, axis, model, channel);
        if (hasValue && explicit) axisComponent.set(property, value, explicit);
        else {
            const { configValue, configFrom } = (0, _axis.isAxisProperty)(property) && property !== 'values' ? (0, _config.getAxisConfig)(property, config.style, axis.style, axisConfigs) : {};
            const hasConfigValue = configValue !== undefined;
            if (hasValue && !hasConfigValue) // only set property if it is explicitly set or has no config value (otherwise we will accidentally override config)
            axisComponent.set(property, value, explicit);
            else if (// Cases need implicit values
            // 1. Axis config that aren't available in Vega
            !(configFrom === 'vgAxisConfig') || // 2. Certain properties are always included (see `propsToAlwaysIncludeConfig`'s declaration for more details)
            propsToAlwaysIncludeConfig.has(property) && hasConfigValue || // 3. Conditional axis values and signals
            (0, _axis.isConditionalAxisValue)(configValue) || (0, _vegaSchema.isSignalRef)(configValue)) // If a config is specified and is conditional, copy conditional value from axis config
            axisComponent.set(property, configValue, false);
        }
    }
    // 2) Add guide encode definition groups
    const axisEncoding = axis.encoding ?? {};
    const axisEncode = (0, _axis.AXIS_PARTS).reduce((e, part)=>{
        if (!axisComponent.hasAxisPart(part)) // No need to create encode for a disabled part.
        return e;
        const axisEncodingPart = (0, _guide.guideEncodeEntry)(axisEncoding[part] ?? {}, model);
        const value = part === 'labels' ? _encode.labels(model, channel, axisEncodingPart) : axisEncodingPart;
        if (value !== undefined && !(0, _util.isEmpty)(value)) e[part] = {
            update: value
        };
        return e;
    }, {});
    // FIXME: By having encode as one property, we won't have fine grained encode merging.
    if (!(0, _util.isEmpty)(axisEncode)) axisComponent.set('encode', axisEncode, !!axis.encoding || axis.labelAngle !== undefined);
    return axisComponent;
}

},{"../../axis":"4nB06","../../channel":"liLED","../../channeldef":"dsccb","../../util":"acUGA","../../vega.schema":"3mBOT","../common":"jegt8","../guide":"kKC4h","../resolve":"felCG","../split":"eXS2w","./component":"dDZjW","./config":"34G7k","./encode":"hOhh0","./properties":"dkAYu","../format":"79ccI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dDZjW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AXIS_COMPONENT_PROPERTIES", ()=>AXIS_COMPONENT_PROPERTIES);
parcelHelpers.export(exports, "AxisComponent", ()=>AxisComponent);
var _axis = require("../../axis");
var _util = require("../../util");
var _vegaSchema = require("../../vega.schema");
var _split = require("../split");
function isFalseOrNull(v) {
    return v === false || v === null;
}
const AXIS_COMPONENT_PROPERTIES_INDEX = {
    disable: 1,
    gridScale: 1,
    scale: 1,
    ...(0, _axis.COMMON_AXIS_PROPERTIES_INDEX),
    labelExpr: 1,
    encode: 1
};
const AXIS_COMPONENT_PROPERTIES = (0, _util.keys)(AXIS_COMPONENT_PROPERTIES_INDEX);
class AxisComponent extends (0, _split.Split) {
    constructor(explicit = {}, implicit = {}, mainExtracted = false){
        super();
        this.explicit = explicit;
        this.implicit = implicit;
        this.mainExtracted = mainExtracted;
    }
    clone() {
        return new AxisComponent((0, _util.duplicate)(this.explicit), (0, _util.duplicate)(this.implicit), this.mainExtracted);
    }
    hasAxisPart(part) {
        // FIXME(https://github.com/vega/vega-lite/issues/2552) this method can be wrong if users use a Vega theme.
        if (part === 'axis') // always has the axis container part
        return true;
        if (part === 'grid' || part === 'title') return !!this.get(part);
        // Other parts are enabled by default, so they should not be false or null.
        return !isFalseOrNull(this.get(part));
    }
    hasOrientSignalRef() {
        return (0, _vegaSchema.isSignalRef)(this.explicit.orient);
    }
}

},{"../../axis":"4nB06","../../util":"acUGA","../../vega.schema":"3mBOT","../split":"eXS2w","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hOhh0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "labels", ()=>labels);
var _channel = require("../../channel");
var _channeldef = require("../../channeldef");
var _format = require("../format");
function labels(model, channel, specifiedLabelsSpec) {
    const { encoding, config } = model;
    const fieldOrDatumDef = (0, _channeldef.getFieldOrDatumDef)(encoding[channel]) ?? (0, _channeldef.getFieldOrDatumDef)(encoding[(0, _channel.getSecondaryRangeChannel)(channel)]);
    const axis = model.axis(channel) || {};
    const { format, formatType } = axis;
    if ((0, _format.isCustomFormatType)(formatType)) return {
        text: (0, _format.formatCustomType)({
            fieldOrDatumDef,
            field: 'datum.value',
            format,
            formatType,
            config
        }),
        ...specifiedLabelsSpec
    };
    else if (format === undefined && formatType === undefined && config.customFormatTypes) {
        if ((0, _channeldef.channelDefType)(fieldOrDatumDef) === 'quantitative') {
            if ((0, _channeldef.isPositionFieldOrDatumDef)(fieldOrDatumDef) && fieldOrDatumDef.stack === 'normalize' && config.normalizedNumberFormatType) return {
                text: (0, _format.formatCustomType)({
                    fieldOrDatumDef,
                    field: 'datum.value',
                    format: config.normalizedNumberFormat,
                    formatType: config.normalizedNumberFormatType,
                    config
                }),
                ...specifiedLabelsSpec
            };
            else if (config.numberFormatType) return {
                text: (0, _format.formatCustomType)({
                    fieldOrDatumDef,
                    field: 'datum.value',
                    format: config.numberFormat,
                    formatType: config.numberFormatType,
                    config
                }),
                ...specifiedLabelsSpec
            };
        }
        if ((0, _channeldef.channelDefType)(fieldOrDatumDef) === 'temporal' && config.timeFormatType && (0, _channeldef.isFieldDef)(fieldOrDatumDef) && !fieldOrDatumDef.timeUnit) return {
            text: (0, _format.formatCustomType)({
                fieldOrDatumDef,
                field: 'datum.value',
                format: config.timeFormat,
                formatType: config.timeFormatType,
                config
            }),
            ...specifiedLabelsSpec
        };
    }
    return specifiedLabelsSpec;
}

},{"../../channel":"liLED","../../channeldef":"dsccb","../format":"79ccI","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"jvFxg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Internal model of Vega-Lite specification for the compiler.
 */ parcelHelpers.export(exports, "UnitModel", ()=>UnitModel);
var _vegaUtil = require("vega-util");
var _axis = require("../axis");
var _channel = require("../channel");
var _channeldef = require("../channeldef");
var _data = require("../data");
var _encoding = require("../encoding");
var _expr = require("../expr");
var _mark = require("../mark");
var _selection = require("../selection");
var _base = require("../spec/base");
var _stack = require("../stack");
var _util = require("../util");
var _assemble = require("./axis/assemble");
var _parse = require("./axis/parse");
var _common = require("./common");
var _parse1 = require("./data/parse");
var _assemble1 = require("./layoutsize/assemble");
var _init = require("./layoutsize/init");
var _parse2 = require("./layoutsize/parse");
var _init1 = require("./mark/init");
var _mark1 = require("./mark/mark");
var _model = require("./model");
var _assemble2 = require("./selection/assemble");
var _parse3 = require("./selection/parse");
var _point = require("./selection/point");
class UnitModel extends (0, _model.ModelWithField) {
    constructor(spec, parent, parentGivenName, parentGivenSize = {}, config){
        super(spec, 'unit', parent, parentGivenName, config, undefined, (0, _base.isFrameMixins)(spec) ? spec.view : undefined);
        this.specifiedScales = {};
        this.specifiedAxes = {};
        this.specifiedLegends = {};
        this.specifiedProjection = {};
        this.selection = [];
        this.children = [];
        /**
         * Corrects the data references in marks after assemble.
         */ this.correctDataNames = (mark)=>{
            // for normal data references
            if (mark.from?.data) {
                mark.from.data = this.lookupDataSource(mark.from.data);
                if ('time' in this.encoding) mark.from.data = mark.from.data + (0, _point.CURR);
            }
            // for access to facet data
            if (mark.from?.facet?.data) mark.from.facet.data = this.lookupDataSource(mark.from.facet.data);
            return mark;
        };
        const markDef = (0, _mark.isMarkDef)(spec.mark) ? {
            ...spec.mark
        } : {
            type: spec.mark
        };
        const mark = markDef.type;
        // Need to init filled before other mark properties because encoding depends on filled but other mark properties depend on types inside encoding
        if (markDef.filled === undefined) markDef.filled = (0, _init1.defaultFilled)(markDef, config, {
            graticule: spec.data && (0, _data.isGraticuleGenerator)(spec.data)
        });
        const encoding = this.encoding = (0, _encoding.initEncoding)(spec.encoding || {}, mark, markDef.filled, config);
        this.markDef = (0, _init1.initMarkdef)(markDef, encoding, config);
        this.size = (0, _init.initLayoutSize)({
            encoding,
            size: (0, _base.isFrameMixins)(spec) ? {
                ...parentGivenSize,
                ...spec.width ? {
                    width: spec.width
                } : {},
                ...spec.height ? {
                    height: spec.height
                } : {}
            } : parentGivenSize
        });
        // calculate stack properties
        this.stack = (0, _stack.stack)(this.markDef, encoding);
        this.specifiedScales = this.initScales(mark, encoding);
        this.specifiedAxes = this.initAxes(encoding);
        this.specifiedLegends = this.initLegends(encoding);
        this.specifiedProjection = spec.projection;
        // Selections will be initialized upon parse.
        this.selection = (spec.params ?? []).filter((p)=>(0, _selection.isSelectionParameter)(p));
    }
    get hasProjection() {
        const { encoding } = this;
        const isGeoShapeMark = this.mark === (0, _mark.GEOSHAPE);
        const hasGeoPosition = encoding && (0, _channel.GEOPOSITION_CHANNELS).some((channel)=>(0, _channeldef.isFieldOrDatumDef)(encoding[channel]));
        return isGeoShapeMark || hasGeoPosition;
    }
    /**
     * Return specified Vega-Lite scale domain for a particular channel
     * @param channel
     */ scaleDomain(channel) {
        const scale = this.specifiedScales[channel];
        return scale ? scale.domain : undefined;
    }
    axis(channel) {
        return this.specifiedAxes[channel];
    }
    legend(channel) {
        return this.specifiedLegends[channel];
    }
    initScales(mark, encoding) {
        return (0, _channel.SCALE_CHANNELS).reduce((scales, channel)=>{
            const fieldOrDatumDef = (0, _channeldef.getFieldOrDatumDef)(encoding[channel]);
            if (fieldOrDatumDef) scales[channel] = this.initScale(fieldOrDatumDef.scale ?? {});
            return scales;
        }, {});
    }
    initScale(scale) {
        const { domain, range } = scale;
        // TODO: we could simplify this function if we had a recursive replace function
        const scaleInternal = (0, _expr.replaceExprRef)(scale);
        if ((0, _vegaUtil.isArray)(domain)) scaleInternal.domain = domain.map((0, _common.signalRefOrValue));
        if ((0, _vegaUtil.isArray)(range)) scaleInternal.range = range.map((0, _common.signalRefOrValue));
        return scaleInternal;
    }
    initAxes(encoding) {
        return (0, _channel.POSITION_SCALE_CHANNELS).reduce((_axis, channel)=>{
            // Position Axis
            // TODO: handle ConditionFieldDef
            const channelDef = encoding[channel];
            if ((0, _channeldef.isFieldOrDatumDef)(channelDef) || channel === (0, _channel.X) && (0, _channeldef.isFieldOrDatumDef)(encoding.x2) || channel === (0, _channel.Y) && (0, _channeldef.isFieldOrDatumDef)(encoding.y2)) {
                const axisSpec = (0, _channeldef.isFieldOrDatumDef)(channelDef) ? channelDef.axis : undefined;
                _axis[channel] = axisSpec ? this.initAxis({
                    ...axisSpec
                }) // convert truthy value to object
                 : axisSpec;
            }
            return _axis;
        }, {});
    }
    initAxis(axis) {
        const props = (0, _util.keys)(axis);
        const axisInternal = {};
        for (const prop of props){
            const val = axis[prop];
            axisInternal[prop] = (0, _axis.isConditionalAxisValue)(val) ? (0, _common.signalOrValueRefWithCondition)(val) : (0, _common.signalRefOrValue)(val);
        }
        return axisInternal;
    }
    initLegends(encoding) {
        return (0, _channel.NONPOSITION_SCALE_CHANNELS).reduce((_legend, channel)=>{
            const fieldOrDatumDef = (0, _channeldef.getFieldOrDatumDef)(encoding[channel]);
            if (fieldOrDatumDef && (0, _channel.supportLegend)(channel)) {
                const legend = fieldOrDatumDef.legend;
                _legend[channel] = legend ? (0, _expr.replaceExprRef)(legend) // convert truthy value to object
                 : legend;
            }
            return _legend;
        }, {});
    }
    parseData() {
        this.component.data = (0, _parse1.parseData)(this);
    }
    parseLayoutSize() {
        (0, _parse2.parseUnitLayoutSize)(this);
    }
    parseSelections() {
        this.component.selection = (0, _parse3.parseUnitSelection)(this, this.selection);
    }
    parseMarkGroup() {
        this.component.mark = (0, _mark1.parseMarkGroups)(this);
    }
    parseAxesAndHeaders() {
        this.component.axes = (0, _parse.parseUnitAxes)(this);
    }
    assembleSelectionTopLevelSignals(signals) {
        return (0, _assemble2.assembleTopLevelSignals)(this, signals);
    }
    assembleSignals() {
        return [
            ...(0, _assemble.assembleAxisSignals)(this),
            ...(0, _assemble2.assembleUnitSelectionSignals)(this, [])
        ];
    }
    assembleSelectionData(data) {
        return (0, _assemble2.assembleUnitSelectionData)(this, data);
    }
    assembleLayout() {
        return null;
    }
    assembleLayoutSignals() {
        return (0, _assemble1.assembleLayoutSignals)(this);
    }
    assembleMarks() {
        let marks = this.component.mark ?? [];
        // If this unit is part of a layer, selections should augment
        // all in concert rather than each unit individually. This
        // ensures correct interleaving of clipping and brushed marks.
        if (!this.parent || !(0, _model.isLayerModel)(this.parent)) marks = (0, _assemble2.assembleUnitSelectionMarks)(this, marks);
        return marks.map(this.correctDataNames);
    }
    assembleGroupStyle() {
        const { style } = this.view || {};
        if (style !== undefined) return style;
        if (this.encoding.x || this.encoding.y) return 'cell';
        else return 'view';
    }
    getMapping() {
        return this.encoding;
    }
    get mark() {
        return this.markDef.type;
    }
    channelHasField(channel) {
        return _encoding.channelHasField(this.encoding, channel);
    }
    fieldDef(channel) {
        const channelDef = this.encoding[channel];
        return (0, _channeldef.getFieldDef)(channelDef);
    }
    typedFieldDef(channel) {
        const fieldDef = this.fieldDef(channel);
        if ((0, _channeldef.isTypedFieldDef)(fieldDef)) return fieldDef;
        return null;
    }
}

},{"vega-util":"7f6sQ","../axis":"4nB06","../channel":"liLED","../channeldef":"dsccb","../data":"dILEy","../encoding":"2Ohsj","../expr":"ev4sO","../mark":"3Z1xx","../selection":"jtWSq","../spec/base":"5uH6T","../stack":"gEfq8","../util":"acUGA","./axis/assemble":"jjOQk","./axis/parse":"cJSx8","./common":"jegt8","./data/parse":"5V0Ly","./layoutsize/assemble":"cyXx5","./layoutsize/init":"v3F8l","./layoutsize/parse":"84zTX","./mark/init":"6MO2i","./mark/mark":"dJgU3","./model":"hQHib","./selection/assemble":"4YKkA","./selection/parse":"bgKKc","./selection/point":"2aEbF","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"v3F8l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initLayoutSize", ()=>initLayoutSize);
var _channel = require("../../channel");
var _channeldef = require("../../channeldef");
var _log = require("../../log");
var _base = require("../../spec/base");
function initLayoutSize({ encoding, size }) {
    for (const channel of (0, _channel.POSITION_SCALE_CHANNELS)){
        const sizeType = (0, _channel.getSizeChannel)(channel);
        if ((0, _base.isStep)(size[sizeType])) {
            if ((0, _channeldef.isContinuousFieldOrDatumDef)(encoding[channel])) {
                delete size[sizeType];
                _log.warn(_log.message.stepDropped(sizeType));
            }
        }
    }
    return size;
}

},{"../../channel":"liLED","../../channeldef":"dsccb","../../log":"loqTw","../../spec/base":"5uH6T","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dJgU3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseMarkGroups", ()=>parseMarkGroups);
parcelHelpers.export(exports, "getSort", ()=>getSort);
var _vegaUtil = require("vega-util");
var _channeldef = require("../../channeldef");
var _data = require("../../data");
var _encoding = require("../../encoding");
var _mark = require("../../mark");
var _util = require("../../util");
var _vegaSchema = require("../../vega.schema");
var _common = require("../common");
var _arc = require("./arc");
var _area = require("./area");
var _bar = require("./bar");
var _geoshape = require("./geoshape");
var _image = require("./image");
var _line = require("./line");
var _point = require("./point");
var _rect = require("./rect");
var _rule = require("./rule");
var _text = require("./text");
var _tick = require("./tick");
const markCompiler = {
    arc: (0, _arc.arc),
    area: (0, _area.area),
    bar: (0, _bar.bar),
    circle: (0, _point.circle),
    geoshape: (0, _geoshape.geoshape),
    image: (0, _image.image),
    line: (0, _line.line),
    point: (0, _point.point),
    rect: (0, _rect.rect),
    rule: (0, _rule.rule),
    square: (0, _point.square),
    text: (0, _text.text),
    tick: (0, _tick.tick),
    trail: (0, _line.trail)
};
function parseMarkGroups(model) {
    if ((0, _util.contains)([
        (0, _mark.LINE),
        (0, _mark.AREA),
        (0, _mark.TRAIL)
    ], model.mark)) {
        const details = (0, _encoding.pathGroupingFields)(model.mark, model.encoding);
        if (details.length > 0) return getPathGroups(model, details);
    // otherwise use standard mark groups
    } else if (model.mark === (0, _mark.BAR)) {
        const hasCornerRadius = (0, _vegaSchema.VG_CORNERRADIUS_CHANNELS).some((prop)=>(0, _common.getMarkPropOrConfig)(prop, model.markDef, model.config));
        if (model.stack && !model.fieldDef('size') && hasCornerRadius) return getGroupsForStackedBarWithCornerRadius(model);
    }
    return getMarkGroup(model);
}
const FACETED_PATH_PREFIX = 'faceted_path_';
function getPathGroups(model, details) {
    // TODO: for non-stacked plot, map order to zindex. (Maybe rename order for layer to zindex?)
    return [
        {
            name: model.getName('pathgroup'),
            type: 'group',
            from: {
                facet: {
                    name: FACETED_PATH_PREFIX + model.requestDataName((0, _data.DataSourceType).Main),
                    data: model.requestDataName((0, _data.DataSourceType).Main),
                    groupby: details
                }
            },
            encode: {
                update: {
                    width: {
                        field: {
                            group: 'width'
                        }
                    },
                    height: {
                        field: {
                            group: 'height'
                        }
                    }
                }
            },
            // With subfacet for line/area group, need to use faceted data from above.
            marks: getMarkGroup(model, {
                fromPrefix: FACETED_PATH_PREFIX
            })
        }
    ];
}
const STACK_GROUP_PREFIX = 'stack_group_';
/**
 * We need to put stacked bars into groups in order to enable cornerRadius for stacks.
 * If stack is used and the model doesn't have size encoding, we put the mark into groups,
 * and apply cornerRadius properties at the group.
 */ function getGroupsForStackedBarWithCornerRadius(model) {
    // Generate the mark
    const [mark] = getMarkGroup(model, {
        fromPrefix: STACK_GROUP_PREFIX
    });
    // Get the scale for the stacked field
    const fieldScale = model.scaleName(model.stack.fieldChannel);
    const stackField = (opt = {})=>model.vgField(model.stack.fieldChannel, opt);
    // Find the min/max of the pixel value on the stacked direction
    const stackFieldGroup = (func, expr)=>{
        const vgFieldMinMax = [
            stackField({
                prefix: 'min',
                suffix: 'start',
                expr
            }),
            stackField({
                prefix: 'max',
                suffix: 'start',
                expr
            }),
            stackField({
                prefix: 'min',
                suffix: 'end',
                expr
            }),
            stackField({
                prefix: 'max',
                suffix: 'end',
                expr
            })
        ];
        return `${func}(${vgFieldMinMax.map((field)=>`scale('${fieldScale}',${field})`).join(',')})`;
    };
    let groupUpdate;
    let innerGroupUpdate;
    // Build the encoding for group and an inner group
    if (model.stack.fieldChannel === 'x') {
        // Move cornerRadius, y/yc/y2/height properties to group
        // Group x/x2 should be the min/max of the marks within
        groupUpdate = {
            ...(0, _util.pick)(mark.encode.update, [
                'y',
                'yc',
                'y2',
                'height',
                ...(0, _vegaSchema.VG_CORNERRADIUS_CHANNELS)
            ]),
            x: {
                signal: stackFieldGroup('min', 'datum')
            },
            x2: {
                signal: stackFieldGroup('max', 'datum')
            },
            clip: {
                value: true
            }
        };
        // Inner group should revert the x translation, and pass height through
        innerGroupUpdate = {
            x: {
                field: {
                    group: 'x'
                },
                mult: -1
            },
            height: {
                field: {
                    group: 'height'
                }
            }
        };
        // The marks should use the same height as group, without y/yc/y2 properties (because it's already done by group)
        // This is why size encoding is not supported yet
        mark.encode.update = {
            ...(0, _util.omit)(mark.encode.update, [
                'y',
                'yc',
                'y2'
            ]),
            height: {
                field: {
                    group: 'height'
                }
            }
        };
    } else {
        groupUpdate = {
            ...(0, _util.pick)(mark.encode.update, [
                'x',
                'xc',
                'x2',
                'width'
            ]),
            y: {
                signal: stackFieldGroup('min', 'datum')
            },
            y2: {
                signal: stackFieldGroup('max', 'datum')
            },
            clip: {
                value: true
            }
        };
        innerGroupUpdate = {
            y: {
                field: {
                    group: 'y'
                },
                mult: -1
            },
            width: {
                field: {
                    group: 'width'
                }
            }
        };
        mark.encode.update = {
            ...(0, _util.omit)(mark.encode.update, [
                'x',
                'xc',
                'x2'
            ]),
            width: {
                field: {
                    group: 'width'
                }
            }
        };
    }
    // Deal with cornerRadius properties
    for (const key of (0, _vegaSchema.VG_CORNERRADIUS_CHANNELS)){
        const configValue = (0, _common.getMarkConfig)(key, model.markDef, model.config);
        // Move from mark to group
        if (mark.encode.update[key]) {
            groupUpdate[key] = mark.encode.update[key];
            delete mark.encode.update[key];
        } else if (configValue) groupUpdate[key] = (0, _common.signalOrValueRef)(configValue);
        // Overwrite any cornerRadius on mark set by config --- they are already moved to the group
        if (configValue) mark.encode.update[key] = {
            value: 0
        };
    }
    const groupby = [];
    if (model.stack.groupbyChannels?.length > 0) for (const groupbyChannel of model.stack.groupbyChannels){
        // For bin and time unit, we have to add bin/timeunit -end channels.
        const groupByField = model.fieldDef(groupbyChannel);
        const field = (0, _channeldef.vgField)(groupByField);
        if (field) groupby.push(field);
        if (groupByField?.bin || groupByField?.timeUnit) groupby.push((0, _channeldef.vgField)(groupByField, {
            binSuffix: 'end'
        }));
    }
    const strokeProperties = [
        'stroke',
        'strokeWidth',
        'strokeJoin',
        'strokeCap',
        'strokeDash',
        'strokeDashOffset',
        'strokeMiterLimit',
        'strokeOpacity'
    ];
    // Generate stroke properties for the group
    groupUpdate = strokeProperties.reduce((encode, prop)=>{
        if (mark.encode.update[prop]) return {
            ...encode,
            [prop]: mark.encode.update[prop]
        };
        else {
            const configValue = (0, _common.getMarkConfig)(prop, model.markDef, model.config);
            if (configValue !== undefined) return {
                ...encode,
                [prop]: (0, _common.signalOrValueRef)(configValue)
            };
            else return encode;
        }
    }, groupUpdate);
    // Apply strokeForeground and strokeOffset if stroke is used
    if (groupUpdate.stroke) {
        groupUpdate.strokeForeground = {
            value: true
        };
        groupUpdate.strokeOffset = {
            value: 0
        };
    }
    return [
        {
            type: 'group',
            from: {
                facet: {
                    data: model.requestDataName((0, _data.DataSourceType).Main),
                    name: STACK_GROUP_PREFIX + model.requestDataName((0, _data.DataSourceType).Main),
                    groupby,
                    aggregate: {
                        fields: [
                            stackField({
                                suffix: 'start'
                            }),
                            stackField({
                                suffix: 'start'
                            }),
                            stackField({
                                suffix: 'end'
                            }),
                            stackField({
                                suffix: 'end'
                            })
                        ],
                        ops: [
                            'min',
                            'max',
                            'min',
                            'max'
                        ]
                    }
                }
            },
            encode: {
                update: groupUpdate
            },
            marks: [
                {
                    type: 'group',
                    encode: {
                        update: innerGroupUpdate
                    },
                    marks: [
                        mark
                    ]
                }
            ]
        }
    ];
}
function getSort(model) {
    const { encoding, stack, mark, markDef, config } = model;
    const order = encoding.order;
    if (!(0, _vegaUtil.isArray)(order) && (0, _channeldef.isValueDef)(order) && (0, _util.isNullOrFalse)(order.value) || !order && (0, _util.isNullOrFalse)((0, _common.getMarkPropOrConfig)('order', markDef, config))) return undefined;
    else if (((0, _vegaUtil.isArray)(order) || (0, _channeldef.isFieldDef)(order)) && !stack) // Sort by the order field if it is specified and the field is not stacked. (For stacked field, order specify stack order.)
    return (0, _common.sortParams)(order, {
        expr: 'datum'
    });
    else if ((0, _mark.isPathMark)(mark)) {
        // For both line and area, we sort values based on dimension by default
        const dimensionChannel = markDef.orient === 'horizontal' ? 'y' : 'x';
        const dimensionChannelDef = encoding[dimensionChannel];
        if ((0, _channeldef.isFieldDef)(dimensionChannelDef)) return {
            field: dimensionChannel
        };
    }
    return undefined;
}
function getMarkGroup(model, opt = {
    fromPrefix: ''
}) {
    const { mark, markDef, encoding, config } = model;
    const clip = (0, _util.getFirstDefined)(markDef.clip, scaleClip(model), projectionClip(model));
    const style = (0, _common.getStyles)(markDef);
    const key = encoding.key;
    const sort = getSort(model);
    const interactive = interactiveFlag(model);
    const aria = (0, _common.getMarkPropOrConfig)('aria', markDef, config);
    const postEncodingTransform = markCompiler[mark].postEncodingTransform ? markCompiler[mark].postEncodingTransform(model) : null;
    return [
        {
            name: model.getName('marks'),
            type: markCompiler[mark].vgMark,
            ...clip ? {
                clip
            } : {},
            ...style ? {
                style
            } : {},
            ...key ? {
                key: key.field
            } : {},
            ...sort ? {
                sort
            } : {},
            ...interactive ? interactive : {},
            ...aria === false ? {
                aria
            } : {},
            from: {
                data: opt.fromPrefix + model.requestDataName((0, _data.DataSourceType).Main)
            },
            encode: {
                update: markCompiler[mark].encodeEntry(model)
            },
            ...postEncodingTransform ? {
                transform: postEncodingTransform
            } : {}
        }
    ];
}
/**
 * If scales are bound to interval selections, we want to automatically clip
 * marks to account for panning/zooming interactions. We identify bound scales
 * by the selectionExtent property, which gets added during scale parsing.
 */ function scaleClip(model) {
    const xScale = model.getScaleComponent('x');
    const yScale = model.getScaleComponent('y');
    return xScale?.get('selectionExtent') || yScale?.get('selectionExtent') ? true : undefined;
}
/**
 * If we use a custom projection with auto-fitting to the geodata extent,
 * we need to clip to ensure the chart size doesn't explode.
 */ function projectionClip(model) {
    const projection = model.component.projection;
    return projection && !projection.isFit ? true : undefined;
}
/**
 * Only output interactive flags if we have selections defined somewhere in our model hierarchy.
 */ function interactiveFlag(model) {
    if (!model.component.selection) return null;
    const unitCount = (0, _util.keys)(model.component.selection).length;
    let parentCount = unitCount;
    let parent = model.parent;
    while(parent && parentCount === 0){
        parentCount = (0, _util.keys)(parent.component.selection).length;
        parent = parent.parent;
    }
    return parentCount ? {
        interactive: unitCount > 0 || model.mark === 'geoshape' || !!model.encoding.tooltip || !!model.markDef.tooltip
    } : null;
}

},{"vega-util":"7f6sQ","../../channeldef":"dsccb","../../data":"dILEy","../../encoding":"2Ohsj","../../mark":"3Z1xx","../../util":"acUGA","../../vega.schema":"3mBOT","../common":"jegt8","./arc":"aOoGL","./area":"cmMbg","./bar":"dEc9g","./geoshape":"6se5K","./image":"6bh5z","./line":"kzYYo","./point":"gIxgE","./rect":"523LR","./rule":"cSCVg","./text":"2LvaE","./tick":"7CKGX","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"aOoGL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arc", ()=>arc);
var _encode = require("./encode");
const arc = {
    vgMark: 'arc',
    encodeEntry: (model)=>{
        return {
            ..._encode.baseEncodeEntry(model, {
                align: 'ignore',
                baseline: 'ignore',
                color: 'include',
                size: 'ignore',
                orient: 'ignore',
                theta: 'ignore'
            }),
            ..._encode.pointPosition('x', model, {
                defaultPos: 'mid'
            }),
            ..._encode.pointPosition('y', model, {
                defaultPos: 'mid'
            }),
            // arcs are rectangles in polar coordinates
            ..._encode.rectPosition(model, 'radius'),
            ..._encode.rectPosition(model, 'theta')
        };
    }
};

},{"./encode":"3WiQk","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cmMbg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "area", ()=>area);
var _encode = require("./encode");
const area = {
    vgMark: 'area',
    encodeEntry: (model)=>{
        return {
            ..._encode.baseEncodeEntry(model, {
                align: 'ignore',
                baseline: 'ignore',
                color: 'include',
                orient: 'include',
                size: 'ignore',
                theta: 'ignore'
            }),
            ..._encode.pointOrRangePosition('x', model, {
                defaultPos: 'zeroOrMin',
                defaultPos2: 'zeroOrMin',
                range: model.markDef.orient === 'horizontal'
            }),
            ..._encode.pointOrRangePosition('y', model, {
                defaultPos: 'zeroOrMin',
                defaultPos2: 'zeroOrMin',
                range: model.markDef.orient === 'vertical'
            }),
            ..._encode.defined(model)
        };
    }
};

},{"./encode":"3WiQk","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dEc9g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bar", ()=>bar);
var _encode = require("./encode");
const bar = {
    vgMark: 'rect',
    encodeEntry: (model)=>{
        return {
            ..._encode.baseEncodeEntry(model, {
                align: 'ignore',
                baseline: 'ignore',
                color: 'include',
                orient: 'ignore',
                size: 'ignore',
                theta: 'ignore'
            }),
            ..._encode.rectPosition(model, 'x'),
            ..._encode.rectPosition(model, 'y')
        };
    }
};

},{"./encode":"3WiQk","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"6se5K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "geoshape", ()=>geoshape);
var _channeldef = require("../../channeldef");
var _type = require("../../type");
var _encode = require("./encode");
const geoshape = {
    vgMark: 'shape',
    encodeEntry: (model)=>{
        return {
            ..._encode.baseEncodeEntry(model, {
                align: 'ignore',
                baseline: 'ignore',
                color: 'include',
                size: 'ignore',
                orient: 'ignore',
                theta: 'ignore'
            })
        };
    },
    postEncodingTransform: (model)=>{
        const { encoding } = model;
        const shapeDef = encoding.shape;
        const transform = {
            type: 'geoshape',
            projection: model.projectionName(),
            // as: 'shape',
            ...shapeDef && (0, _channeldef.isFieldDef)(shapeDef) && shapeDef.type === (0, _type.GEOJSON) ? {
                field: (0, _channeldef.vgField)(shapeDef, {
                    expr: 'datum'
                })
            } : {}
        };
        return [
            transform
        ];
    }
};

},{"../../channeldef":"dsccb","../../type":"cbWGP","./encode":"3WiQk","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"6bh5z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "image", ()=>image);
var _encode = require("./encode");
const image = {
    vgMark: 'image',
    encodeEntry: (model)=>{
        return {
            ..._encode.baseEncodeEntry(model, {
                align: 'ignore',
                baseline: 'ignore',
                color: 'ignore',
                orient: 'ignore',
                size: 'ignore',
                theta: 'ignore'
            }),
            ..._encode.rectPosition(model, 'x'),
            ..._encode.rectPosition(model, 'y'),
            ..._encode.text(model, 'url')
        };
    }
};

},{"./encode":"3WiQk","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"kzYYo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "line", ()=>line);
parcelHelpers.export(exports, "trail", ()=>trail);
var _encode = require("./encode");
const line = {
    vgMark: 'line',
    encodeEntry: (model)=>{
        return {
            ..._encode.baseEncodeEntry(model, {
                align: 'ignore',
                baseline: 'ignore',
                color: 'include',
                size: 'ignore',
                orient: 'ignore',
                theta: 'ignore'
            }),
            ..._encode.pointPosition('x', model, {
                defaultPos: 'mid'
            }),
            ..._encode.pointPosition('y', model, {
                defaultPos: 'mid'
            }),
            ..._encode.nonPosition('size', model, {
                vgChannel: 'strokeWidth' // VL's line size is strokeWidth
            }),
            ..._encode.defined(model)
        };
    }
};
const trail = {
    vgMark: 'trail',
    encodeEntry: (model)=>{
        return {
            ..._encode.baseEncodeEntry(model, {
                align: 'ignore',
                baseline: 'ignore',
                color: 'include',
                size: 'include',
                orient: 'ignore',
                theta: 'ignore'
            }),
            ..._encode.pointPosition('x', model, {
                defaultPos: 'mid'
            }),
            ..._encode.pointPosition('y', model, {
                defaultPos: 'mid'
            }),
            ..._encode.nonPosition('size', model),
            ..._encode.defined(model)
        };
    }
};

},{"./encode":"3WiQk","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"gIxgE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shapeMixins", ()=>shapeMixins);
parcelHelpers.export(exports, "point", ()=>point);
parcelHelpers.export(exports, "circle", ()=>circle);
parcelHelpers.export(exports, "square", ()=>square);
var _encode = require("./encode");
function encodeEntry(model, fixedShape) {
    const { config } = model;
    return {
        ..._encode.baseEncodeEntry(model, {
            align: 'ignore',
            baseline: 'ignore',
            color: 'include',
            size: 'include',
            orient: 'ignore',
            theta: 'ignore'
        }),
        ..._encode.pointPosition('x', model, {
            defaultPos: 'mid'
        }),
        ..._encode.pointPosition('y', model, {
            defaultPos: 'mid'
        }),
        ..._encode.nonPosition('size', model),
        ..._encode.nonPosition('angle', model),
        ...shapeMixins(model, config, fixedShape)
    };
}
function shapeMixins(model, config, fixedShape) {
    if (fixedShape) return {
        shape: {
            value: fixedShape
        }
    };
    return _encode.nonPosition('shape', model);
}
const point = {
    vgMark: 'symbol',
    encodeEntry: (model)=>{
        return encodeEntry(model);
    }
};
const circle = {
    vgMark: 'symbol',
    encodeEntry: (model)=>{
        return encodeEntry(model, 'circle');
    }
};
const square = {
    vgMark: 'symbol',
    encodeEntry: (model)=>{
        return encodeEntry(model, 'square');
    }
};

},{"./encode":"3WiQk","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"523LR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rect", ()=>rect);
var _encode = require("./encode");
const rect = {
    vgMark: 'rect',
    encodeEntry: (model)=>{
        return {
            ..._encode.baseEncodeEntry(model, {
                align: 'ignore',
                baseline: 'ignore',
                color: 'include',
                orient: 'ignore',
                size: 'ignore',
                theta: 'ignore'
            }),
            ..._encode.rectPosition(model, 'x'),
            ..._encode.rectPosition(model, 'y')
        };
    }
};

},{"./encode":"3WiQk","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"cSCVg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rule", ()=>rule);
var _encode = require("./encode");
const rule = {
    vgMark: 'rule',
    encodeEntry: (model)=>{
        const { markDef } = model;
        const orient = markDef.orient;
        if (!model.encoding.x && !model.encoding.y && !model.encoding.latitude && !model.encoding.longitude) // Show nothing if we have none of x, y, lat, and long.
        return {};
        return {
            ..._encode.baseEncodeEntry(model, {
                align: 'ignore',
                baseline: 'ignore',
                color: 'include',
                orient: 'ignore',
                size: 'ignore',
                theta: 'ignore'
            }),
            ..._encode.pointOrRangePosition('x', model, {
                defaultPos: orient === 'horizontal' ? 'zeroOrMax' : 'mid',
                defaultPos2: 'zeroOrMin',
                range: orient !== 'vertical' // include x2 for horizontal or line segment rule
            }),
            ..._encode.pointOrRangePosition('y', model, {
                defaultPos: orient === 'vertical' ? 'zeroOrMax' : 'mid',
                defaultPos2: 'zeroOrMin',
                range: orient !== 'horizontal' // include y2 for vertical or line segment rule
            }),
            ..._encode.nonPosition('size', model, {
                vgChannel: 'strokeWidth' // VL's rule size is strokeWidth
            })
        };
    }
};

},{"./encode":"3WiQk","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"2LvaE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "text", ()=>text);
var _common = require("../common");
var _encode = require("./encode");
const text = {
    vgMark: 'text',
    encodeEntry: (model)=>{
        const { config, encoding } = model;
        return {
            ..._encode.baseEncodeEntry(model, {
                align: 'include',
                baseline: 'include',
                color: 'include',
                size: 'ignore',
                orient: 'ignore',
                theta: 'include'
            }),
            ..._encode.pointPosition('x', model, {
                defaultPos: 'mid'
            }),
            ..._encode.pointPosition('y', model, {
                defaultPos: 'mid'
            }),
            ..._encode.text(model),
            ..._encode.nonPosition('size', model, {
                vgChannel: 'fontSize' // VL's text size is fontSize
            }),
            ..._encode.nonPosition('angle', model),
            ..._encode.valueIfDefined('align', align(model.markDef, encoding, config)),
            ..._encode.valueIfDefined('baseline', baseline(model.markDef, encoding, config)),
            ..._encode.pointPosition('radius', model, {
                defaultPos: null
            }),
            ..._encode.pointPosition('theta', model, {
                defaultPos: null
            })
        };
    }
};
function align(markDef, encoding, config) {
    const a = (0, _common.getMarkPropOrConfig)('align', markDef, config);
    if (a === undefined) return 'center';
    // If there is a config, Vega-parser will process this already.
    return undefined;
}
function baseline(markDef, encoding, config) {
    const b = (0, _common.getMarkPropOrConfig)('baseline', markDef, config);
    if (b === undefined) return 'middle';
    // If there is a config, Vega-parser will process this already.
    return undefined;
}

},{"../common":"jegt8","./encode":"3WiQk","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"7CKGX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tick", ()=>tick);
var _common = require("../common");
var _encode = require("./encode");
const tick = {
    vgMark: 'rect',
    encodeEntry: (model)=>{
        const { config, markDef } = model;
        const orient = markDef.orient;
        const vgSizeAxisChannel = orient === 'horizontal' ? 'x' : 'y';
        const vgThicknessAxisChannel = orient === 'horizontal' ? 'y' : 'x';
        const vgThicknessChannel = orient === 'horizontal' ? 'height' : 'width';
        return {
            ..._encode.baseEncodeEntry(model, {
                align: 'ignore',
                baseline: 'ignore',
                color: 'include',
                orient: 'ignore',
                size: 'ignore',
                theta: 'ignore'
            }),
            ..._encode.rectPosition(model, vgSizeAxisChannel),
            ..._encode.pointPosition(vgThicknessAxisChannel, model, {
                defaultPos: 'mid',
                vgChannel: vgThicknessAxisChannel === 'y' ? 'yc' : 'xc'
            }),
            [vgThicknessChannel]: (0, _common.signalOrValueRef)((0, _common.getMarkPropOrConfig)('thickness', markDef, config))
        };
    }
};

},{"../common":"jegt8","./encode":"3WiQk","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"9X7he":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Parse a vega schema url into library and version.
 */ function default_1(url) {
    var regex = /\/schema\/([\w-]+)\/([\w\.\-]+)\.json$/g;
    var _a = regex.exec(url).slice(1, 3), library = _a[0], version = _a[1];
    return {
        library: library,
        version: version
    };
}
exports.default = default_1;

},{}],"4U23m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "carbong10", ()=>carbong10);
parcelHelpers.export(exports, "carbong100", ()=>carbong100);
parcelHelpers.export(exports, "carbong90", ()=>carbong90);
parcelHelpers.export(exports, "carbonwhite", ()=>carbonwhite);
parcelHelpers.export(exports, "dark", ()=>darkTheme);
parcelHelpers.export(exports, "excel", ()=>excelTheme);
parcelHelpers.export(exports, "fivethirtyeight", ()=>fiveThirtyEightTheme);
parcelHelpers.export(exports, "ggplot2", ()=>ggplot2Theme);
parcelHelpers.export(exports, "googlecharts", ()=>googlechartsTheme);
parcelHelpers.export(exports, "latimes", ()=>latimesTheme);
parcelHelpers.export(exports, "powerbi", ()=>powerbiTheme);
parcelHelpers.export(exports, "quartz", ()=>quartzTheme);
parcelHelpers.export(exports, "urbaninstitute", ()=>urbanInstituteTheme);
parcelHelpers.export(exports, "version", ()=>version);
parcelHelpers.export(exports, "vox", ()=>voxTheme);
var name = "vega-themes";
var version$1 = "2.15.0";
var description = "Themes for stylized Vega and Vega-Lite visualizations.";
var keywords = [
    "vega",
    "vega-lite",
    "themes",
    "style"
];
var license = "BSD-3-Clause";
var author = {
    name: "UW Interactive Data Lab",
    url: "https://idl.cs.washington.edu"
};
var contributors = [
    {
        name: "Emily Gu",
        url: "https://github.com/emilygu"
    },
    {
        name: "Arvind Satyanarayan",
        url: "http://arvindsatya.com"
    },
    {
        name: "Jeffrey Heer",
        url: "https://idl.cs.washington.edu"
    },
    {
        name: "Dominik Moritz",
        url: "https://www.domoritz.de"
    }
];
var main = "build/vega-themes.js";
var module = "build/vega-themes.module.js";
var unpkg = "build/vega-themes.min.js";
var jsdelivr = "build/vega-themes.min.js";
var types = "build/vega-themes.module.d.ts";
var repository = {
    type: "git",
    url: "https://github.com/vega/vega-themes.git"
};
var files = [
    "src",
    "build"
];
var scripts = {
    prebuild: "yarn clean",
    build: "rollup -c",
    clean: "rimraf build && rimraf examples/build",
    "copy:data": "rsync -r node_modules/vega-datasets/data/* examples/data",
    "copy:build": "rsync -r build/* examples/build",
    "deploy:gh": "yarn build && mkdir -p examples/build && rsync -r build/* examples/build && gh-pages -d examples",
    preversion: "yarn lint",
    serve: "browser-sync start -s -f build examples --serveStatic examples",
    start: "yarn build && concurrently --kill-others -n Server,Rollup 'yarn serve' 'rollup -c -w'",
    format: "eslint . --fix",
    lint: "eslint .",
    release: "release-it"
};
var devDependencies = {
    "@babel/core": "^7.24.6",
    "@babel/plugin-transform-runtime": "^7.24.6",
    "@babel/preset-env": "^7.24.6",
    "@babel/preset-typescript": "^7.24.6",
    "@release-it/conventional-changelog": "^8.0.1",
    "@rollup/plugin-json": "^6.1.0",
    "@rollup/plugin-node-resolve": "^15.2.3",
    "@rollup/plugin-terser": "^0.4.4",
    "@typescript-eslint/eslint-plugin": "^7.11.0",
    "@typescript-eslint/parser": "^7.11.0",
    "browser-sync": "^3.0.2",
    concurrently: "^8.2.2",
    eslint: "^8.45.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-prettier": "^5.1.3",
    "gh-pages": "^6.1.1",
    prettier: "^3.2.5",
    "release-it": "^17.3.0",
    rollup: "^4.18.0",
    "rollup-plugin-bundle-size": "^1.0.3",
    "rollup-plugin-ts": "^3.4.5",
    typescript: "^5.4.5",
    vega: "^5.25.0",
    "vega-lite": "^5.9.3"
};
var peerDependencies = {
    vega: "*",
    "vega-lite": "*"
};
var dependencies = {};
var pkg = {
    name: name,
    version: version$1,
    description: description,
    keywords: keywords,
    license: license,
    author: author,
    contributors: contributors,
    main: main,
    module: module,
    unpkg: unpkg,
    jsdelivr: jsdelivr,
    types: types,
    repository: repository,
    files: files,
    scripts: scripts,
    devDependencies: devDependencies,
    peerDependencies: peerDependencies,
    dependencies: dependencies
};
const lightColor = '#fff';
const medColor = '#888';
const darkTheme = {
    background: '#333',
    view: {
        stroke: medColor
    },
    title: {
        color: lightColor,
        subtitleColor: lightColor
    },
    style: {
        'guide-label': {
            fill: lightColor
        },
        'guide-title': {
            fill: lightColor
        }
    },
    axis: {
        domainColor: lightColor,
        gridColor: medColor,
        tickColor: lightColor
    }
};
const markColor$7 = '#4572a7';
const excelTheme = {
    background: '#fff',
    arc: {
        fill: markColor$7
    },
    area: {
        fill: markColor$7
    },
    line: {
        stroke: markColor$7,
        strokeWidth: 2
    },
    path: {
        stroke: markColor$7
    },
    rect: {
        fill: markColor$7
    },
    shape: {
        stroke: markColor$7
    },
    symbol: {
        fill: markColor$7,
        strokeWidth: 1.5,
        size: 50
    },
    axis: {
        bandPosition: 0.5,
        grid: true,
        gridColor: '#000000',
        gridOpacity: 1,
        gridWidth: 0.5,
        labelPadding: 10,
        tickSize: 5,
        tickWidth: 0.5
    },
    axisBand: {
        grid: false,
        tickExtra: true
    },
    legend: {
        labelBaseline: 'middle',
        labelFontSize: 11,
        symbolSize: 50,
        symbolType: 'square'
    },
    range: {
        category: [
            '#4572a7',
            '#aa4643',
            '#8aa453',
            '#71598e',
            '#4598ae',
            '#d98445',
            '#94aace',
            '#d09393',
            '#b9cc98',
            '#a99cbc'
        ]
    }
};
const markColor$6 = '#30a2da';
const axisColor$2 = '#cbcbcb';
const guideLabelColor = '#999';
const guideTitleColor = '#333';
const backgroundColor$2 = '#f0f0f0';
const blackTitle = '#333';
const fiveThirtyEightTheme = {
    arc: {
        fill: markColor$6
    },
    area: {
        fill: markColor$6
    },
    axis: {
        domainColor: axisColor$2,
        grid: true,
        gridColor: axisColor$2,
        gridWidth: 1,
        labelColor: guideLabelColor,
        labelFontSize: 10,
        titleColor: guideTitleColor,
        tickColor: axisColor$2,
        tickSize: 10,
        titleFontSize: 14,
        titlePadding: 10,
        labelPadding: 4
    },
    axisBand: {
        grid: false
    },
    background: backgroundColor$2,
    group: {
        fill: backgroundColor$2
    },
    legend: {
        labelColor: blackTitle,
        labelFontSize: 11,
        padding: 1,
        symbolSize: 30,
        symbolType: 'square',
        titleColor: blackTitle,
        titleFontSize: 14,
        titlePadding: 10
    },
    line: {
        stroke: markColor$6,
        strokeWidth: 2
    },
    path: {
        stroke: markColor$6,
        strokeWidth: 0.5
    },
    rect: {
        fill: markColor$6
    },
    range: {
        category: [
            '#30a2da',
            '#fc4f30',
            '#e5ae38',
            '#6d904f',
            '#8b8b8b',
            '#b96db8',
            '#ff9e27',
            '#56cc60',
            '#52d2ca',
            '#52689e',
            '#545454',
            '#9fe4f8'
        ],
        diverging: [
            '#cc0020',
            '#e77866',
            '#f6e7e1',
            '#d6e8ed',
            '#91bfd9',
            '#1d78b5'
        ],
        heatmap: [
            '#d6e8ed',
            '#cee0e5',
            '#91bfd9',
            '#549cc6',
            '#1d78b5'
        ]
    },
    point: {
        filled: true,
        shape: 'circle'
    },
    shape: {
        stroke: markColor$6
    },
    bar: {
        binSpacing: 2,
        fill: markColor$6,
        stroke: null
    },
    title: {
        anchor: 'start',
        fontSize: 24,
        fontWeight: 600,
        offset: 20
    }
};
const markColor$5 = '#000';
const ggplot2Theme = {
    group: {
        fill: '#e5e5e5'
    },
    arc: {
        fill: markColor$5
    },
    area: {
        fill: markColor$5
    },
    line: {
        stroke: markColor$5
    },
    path: {
        stroke: markColor$5
    },
    rect: {
        fill: markColor$5
    },
    shape: {
        stroke: markColor$5
    },
    symbol: {
        fill: markColor$5,
        size: 40
    },
    axis: {
        domain: false,
        grid: true,
        gridColor: '#FFFFFF',
        gridOpacity: 1,
        labelColor: '#7F7F7F',
        labelPadding: 4,
        tickColor: '#7F7F7F',
        tickSize: 5.67,
        titleFontSize: 16,
        titleFontWeight: 'normal'
    },
    legend: {
        labelBaseline: 'middle',
        labelFontSize: 11,
        symbolSize: 40
    },
    range: {
        category: [
            '#000000',
            '#7F7F7F',
            '#1A1A1A',
            '#999999',
            '#333333',
            '#B0B0B0',
            '#4D4D4D',
            '#C9C9C9',
            '#666666',
            '#DCDCDC'
        ]
    }
};
const headlineFontSize = 22;
const headlineFontWeight = 'normal';
const labelFont$1 = 'Benton Gothic, sans-serif';
const labelFontSize = 11.5;
const labelFontWeight = 'normal';
const markColor$4 = '#82c6df';
// const markHighlight = '#006d8f';
// const markDemocrat = '#5789b8';
// const markRepublican = '#d94f54';
const titleFont = 'Benton Gothic Bold, sans-serif';
const titleFontWeight = 'normal';
const titleFontSize$1 = 13;
const colorSchemes$1 = {
    'category-6': [
        '#ec8431',
        '#829eb1',
        '#c89d29',
        '#3580b1',
        '#adc839',
        '#ab7fb4'
    ],
    'fire-7': [
        '#fbf2c7',
        '#f9e39c',
        '#f8d36e',
        '#f4bb6a',
        '#e68a4f',
        '#d15a40',
        '#ab4232'
    ],
    'fireandice-6': [
        '#e68a4f',
        '#f4bb6a',
        '#f9e39c',
        '#dadfe2',
        '#a6b7c6',
        '#849eae'
    ],
    'ice-7': [
        '#edefee',
        '#dadfe2',
        '#c4ccd2',
        '#a6b7c6',
        '#849eae',
        '#607785',
        '#47525d'
    ]
};
const latimesTheme = {
    background: '#ffffff',
    title: {
        anchor: 'start',
        color: '#000000',
        font: titleFont,
        fontSize: headlineFontSize,
        fontWeight: headlineFontWeight
    },
    arc: {
        fill: markColor$4
    },
    area: {
        fill: markColor$4
    },
    line: {
        stroke: markColor$4,
        strokeWidth: 2
    },
    path: {
        stroke: markColor$4
    },
    rect: {
        fill: markColor$4
    },
    shape: {
        stroke: markColor$4
    },
    symbol: {
        fill: markColor$4,
        size: 30
    },
    axis: {
        labelFont: labelFont$1,
        labelFontSize,
        labelFontWeight,
        titleFont,
        titleFontSize: titleFontSize$1,
        titleFontWeight
    },
    axisX: {
        labelAngle: 0,
        labelPadding: 4,
        tickSize: 3
    },
    axisY: {
        labelBaseline: 'middle',
        maxExtent: 45,
        minExtent: 45,
        tickSize: 2,
        titleAlign: 'left',
        titleAngle: 0,
        titleX: -45,
        titleY: -11
    },
    legend: {
        labelFont: labelFont$1,
        labelFontSize,
        symbolType: 'square',
        titleFont,
        titleFontSize: titleFontSize$1,
        titleFontWeight
    },
    range: {
        category: colorSchemes$1['category-6'],
        diverging: colorSchemes$1['fireandice-6'],
        heatmap: colorSchemes$1['fire-7'],
        ordinal: colorSchemes$1['fire-7'],
        ramp: colorSchemes$1['fire-7']
    }
};
const markColor$3 = '#ab5787';
const axisColor$1 = '#979797';
const quartzTheme = {
    background: '#f9f9f9',
    arc: {
        fill: markColor$3
    },
    area: {
        fill: markColor$3
    },
    line: {
        stroke: markColor$3
    },
    path: {
        stroke: markColor$3
    },
    rect: {
        fill: markColor$3
    },
    shape: {
        stroke: markColor$3
    },
    symbol: {
        fill: markColor$3,
        size: 30
    },
    axis: {
        domainColor: axisColor$1,
        domainWidth: 0.5,
        gridWidth: 0.2,
        labelColor: axisColor$1,
        tickColor: axisColor$1,
        tickWidth: 0.2,
        titleColor: axisColor$1
    },
    axisBand: {
        grid: false
    },
    axisX: {
        grid: true,
        tickSize: 10
    },
    axisY: {
        domain: false,
        grid: true,
        tickSize: 0
    },
    legend: {
        labelFontSize: 11,
        padding: 1,
        symbolSize: 30,
        symbolType: 'square'
    },
    range: {
        category: [
            '#ab5787',
            '#51b2e5',
            '#703c5c',
            '#168dd9',
            '#d190b6',
            '#00609f',
            '#d365ba',
            '#154866',
            '#666666',
            '#c4c4c4'
        ]
    }
};
const markColor$2 = '#3e5c69';
const voxTheme = {
    background: '#fff',
    arc: {
        fill: markColor$2
    },
    area: {
        fill: markColor$2
    },
    line: {
        stroke: markColor$2
    },
    path: {
        stroke: markColor$2
    },
    rect: {
        fill: markColor$2
    },
    shape: {
        stroke: markColor$2
    },
    symbol: {
        fill: markColor$2
    },
    axis: {
        domainWidth: 0.5,
        grid: true,
        labelPadding: 2,
        tickSize: 5,
        tickWidth: 0.5,
        titleFontWeight: 'normal'
    },
    axisBand: {
        grid: false
    },
    axisX: {
        gridWidth: 0.2
    },
    axisY: {
        gridDash: [
            3
        ],
        gridWidth: 0.4
    },
    legend: {
        labelFontSize: 11,
        padding: 1,
        symbolType: 'square'
    },
    range: {
        category: [
            '#3e5c69',
            '#6793a6',
            '#182429',
            '#0570b0',
            '#3690c0',
            '#74a9cf',
            '#a6bddb',
            '#e2ddf2'
        ]
    }
};
const markColor$1 = '#1696d2';
const axisColor = '#000000';
const backgroundColor$1 = '#FFFFFF';
const font = 'Lato';
const labelFont = 'Lato';
const sourceFont = 'Lato';
const gridColor$1 = '#DEDDDD';
const titleFontSize = 18;
const colorSchemes = {
    'main-colors': [
        '#1696d2',
        '#d2d2d2',
        '#000000',
        '#fdbf11',
        '#ec008b',
        '#55b748',
        '#5c5859',
        '#db2b27'
    ],
    'shades-blue': [
        '#CFE8F3',
        '#A2D4EC',
        '#73BFE2',
        '#46ABDB',
        '#1696D2',
        '#12719E',
        '#0A4C6A',
        '#062635'
    ],
    'shades-gray': [
        '#F5F5F5',
        '#ECECEC',
        '#E3E3E3',
        '#DCDBDB',
        '#D2D2D2',
        '#9D9D9D',
        '#696969',
        '#353535'
    ],
    'shades-yellow': [
        '#FFF2CF',
        '#FCE39E',
        '#FDD870',
        '#FCCB41',
        '#FDBF11',
        '#E88E2D',
        '#CA5800',
        '#843215'
    ],
    'shades-magenta': [
        '#F5CBDF',
        '#EB99C2',
        '#E46AA7',
        '#E54096',
        '#EC008B',
        '#AF1F6B',
        '#761548',
        '#351123'
    ],
    'shades-green': [
        '#DCEDD9',
        '#BCDEB4',
        '#98CF90',
        '#78C26D',
        '#55B748',
        '#408941',
        '#2C5C2D',
        '#1A2E19'
    ],
    'shades-black': [
        '#D5D5D4',
        '#ADABAC',
        '#848081',
        '#5C5859',
        '#332D2F',
        '#262223',
        '#1A1717',
        '#0E0C0D'
    ],
    'shades-red': [
        '#F8D5D4',
        '#F1AAA9',
        '#E9807D',
        '#E25552',
        '#DB2B27',
        '#A4201D',
        '#6E1614',
        '#370B0A'
    ],
    'one-group': [
        '#1696d2',
        '#000000'
    ],
    'two-groups-cat-1': [
        '#1696d2',
        '#000000'
    ],
    'two-groups-cat-2': [
        '#1696d2',
        '#fdbf11'
    ],
    'two-groups-cat-3': [
        '#1696d2',
        '#db2b27'
    ],
    'two-groups-seq': [
        '#a2d4ec',
        '#1696d2'
    ],
    'three-groups-cat': [
        '#1696d2',
        '#fdbf11',
        '#000000'
    ],
    'three-groups-seq': [
        '#a2d4ec',
        '#1696d2',
        '#0a4c6a'
    ],
    'four-groups-cat-1': [
        '#000000',
        '#d2d2d2',
        '#fdbf11',
        '#1696d2'
    ],
    'four-groups-cat-2': [
        '#1696d2',
        '#ec0008b',
        '#fdbf11',
        '#5c5859'
    ],
    'four-groups-seq': [
        '#cfe8f3',
        '#73bf42',
        '#1696d2',
        '#0a4c6a'
    ],
    'five-groups-cat-1': [
        '#1696d2',
        '#fdbf11',
        '#d2d2d2',
        '#ec008b',
        '#000000'
    ],
    'five-groups-cat-2': [
        '#1696d2',
        '#0a4c6a',
        '#d2d2d2',
        '#fdbf11',
        '#332d2f'
    ],
    'five-groups-seq': [
        '#cfe8f3',
        '#73bf42',
        '#1696d2',
        '#0a4c6a',
        '#000000'
    ],
    'six-groups-cat-1': [
        '#1696d2',
        '#ec008b',
        '#fdbf11',
        '#000000',
        '#d2d2d2',
        '#55b748'
    ],
    'six-groups-cat-2': [
        '#1696d2',
        '#d2d2d2',
        '#ec008b',
        '#fdbf11',
        '#332d2f',
        '#0a4c6a'
    ],
    'six-groups-seq': [
        '#cfe8f3',
        '#a2d4ec',
        '#73bfe2',
        '#46abdb',
        '#1696d2',
        '#12719e'
    ],
    'diverging-colors': [
        '#ca5800',
        '#fdbf11',
        '#fdd870',
        '#fff2cf',
        '#cfe8f3',
        '#73bfe2',
        '#1696d2',
        '#0a4c6a'
    ]
};
const urbanInstituteTheme = {
    background: backgroundColor$1,
    title: {
        anchor: 'start',
        fontSize: titleFontSize,
        font: font
    },
    axisX: {
        domain: true,
        domainColor: axisColor,
        domainWidth: 1,
        grid: false,
        labelFontSize: 12,
        labelFont: labelFont,
        labelAngle: 0,
        tickColor: axisColor,
        tickSize: 5,
        titleFontSize: 12,
        titlePadding: 10,
        titleFont: font
    },
    axisY: {
        domain: false,
        domainWidth: 1,
        grid: true,
        gridColor: gridColor$1,
        gridWidth: 1,
        labelFontSize: 12,
        labelFont: labelFont,
        labelPadding: 8,
        ticks: false,
        titleFontSize: 12,
        titlePadding: 10,
        titleFont: font,
        titleAngle: 0,
        titleY: -10,
        titleX: 18
    },
    legend: {
        labelFontSize: 12,
        labelFont: labelFont,
        symbolSize: 100,
        titleFontSize: 12,
        titlePadding: 10,
        titleFont: font,
        orient: 'right',
        offset: 10
    },
    view: {
        stroke: 'transparent'
    },
    range: {
        category: colorSchemes['six-groups-cat-1'],
        diverging: colorSchemes['diverging-colors'],
        heatmap: colorSchemes['diverging-colors'],
        ordinal: colorSchemes['six-groups-seq'],
        ramp: colorSchemes['shades-blue']
    },
    area: {
        fill: markColor$1
    },
    rect: {
        fill: markColor$1
    },
    line: {
        color: markColor$1,
        stroke: markColor$1,
        strokeWidth: 5
    },
    trail: {
        color: markColor$1,
        stroke: markColor$1,
        strokeWidth: 0,
        size: 1
    },
    path: {
        stroke: markColor$1,
        strokeWidth: 0.5
    },
    point: {
        filled: true
    },
    text: {
        font: sourceFont,
        color: markColor$1,
        fontSize: 11,
        align: 'center',
        fontWeight: 400,
        size: 11
    },
    style: {
        bar: {
            fill: markColor$1,
            stroke: null
        }
    },
    arc: {
        fill: markColor$1
    },
    shape: {
        stroke: markColor$1
    },
    symbol: {
        fill: markColor$1,
        size: 30
    }
};
/**
 * Copyright 2020 Google LLC.
 *
 * Use of this source code is governed by a BSD-style
 * license that can be found in the LICENSE file or at
 * https://developers.google.com/open-source/licenses/bsd
 */ const markColor = '#3366CC';
const gridColor = '#ccc';
const defaultFont$1 = 'Arial, sans-serif';
const googlechartsTheme = {
    arc: {
        fill: markColor
    },
    area: {
        fill: markColor
    },
    path: {
        stroke: markColor
    },
    rect: {
        fill: markColor
    },
    shape: {
        stroke: markColor
    },
    symbol: {
        stroke: markColor
    },
    circle: {
        fill: markColor
    },
    background: '#fff',
    padding: {
        top: 10,
        right: 10,
        bottom: 10,
        left: 10
    },
    style: {
        'guide-label': {
            font: defaultFont$1,
            fontSize: 12
        },
        'guide-title': {
            font: defaultFont$1,
            fontSize: 12
        },
        'group-title': {
            font: defaultFont$1,
            fontSize: 12
        }
    },
    title: {
        font: defaultFont$1,
        fontSize: 14,
        fontWeight: 'bold',
        dy: -3,
        anchor: 'start'
    },
    axis: {
        gridColor: gridColor,
        tickColor: gridColor,
        domain: false,
        grid: true
    },
    range: {
        category: [
            '#4285F4',
            '#DB4437',
            '#F4B400',
            '#0F9D58',
            '#AB47BC',
            '#00ACC1',
            '#FF7043',
            '#9E9D24',
            '#5C6BC0',
            '#F06292',
            '#00796B',
            '#C2185B'
        ],
        heatmap: [
            '#c6dafc',
            '#5e97f6',
            '#2a56c6'
        ]
    }
};
const ptToPx = (value)=>value * (1 / 3 + 1);
const fontSmallPx = ptToPx(9);
const legendFontPx = ptToPx(10);
const fontLargePx = ptToPx(12);
const fontStandard = 'Segoe UI';
const fontTitle = 'wf_standard-font, helvetica, arial, sans-serif';
const firstLevelElementColor = '#252423';
const secondLevelElementColor = '#605E5C';
const backgroundColor = 'transparent';
const backgroundSecondaryColor = '#C8C6C4';
const paletteColor1 = '#118DFF';
const paletteColor2 = '#12239E';
const paletteColor3 = '#E66C37';
const paletteColor4 = '#6B007B';
const paletteColor5 = '#E044A7';
const paletteColor6 = '#744EC2';
const paletteColor7 = '#D9B300';
const paletteColor8 = '#D64550';
const divergentColorMax = paletteColor1;
const divergentColorMin = '#DEEFFF';
const divergentPalette = [
    divergentColorMin,
    divergentColorMax
];
const ordinalPalette = [
    divergentColorMin,
    '#c7e4ff',
    '#b0d9ff',
    '#9aceff',
    '#83c3ff',
    '#6cb9ff',
    '#55aeff',
    '#3fa3ff',
    '#2898ff',
    divergentColorMax
];
const powerbiTheme = {
    view: {
        stroke: backgroundColor
    },
    background: backgroundColor,
    font: fontStandard,
    header: {
        titleFont: fontTitle,
        titleFontSize: fontLargePx,
        titleColor: firstLevelElementColor,
        labelFont: fontStandard,
        labelFontSize: legendFontPx,
        labelColor: secondLevelElementColor
    },
    axis: {
        ticks: false,
        grid: false,
        domain: false,
        labelColor: secondLevelElementColor,
        labelFontSize: fontSmallPx,
        titleFont: fontTitle,
        titleColor: firstLevelElementColor,
        titleFontSize: fontLargePx,
        titleFontWeight: 'normal'
    },
    axisQuantitative: {
        tickCount: 3,
        grid: true,
        gridColor: backgroundSecondaryColor,
        gridDash: [
            1,
            5
        ],
        labelFlush: false
    },
    axisBand: {
        tickExtra: true
    },
    axisX: {
        labelPadding: 5
    },
    axisY: {
        labelPadding: 10
    },
    bar: {
        fill: paletteColor1
    },
    line: {
        stroke: paletteColor1,
        strokeWidth: 3,
        strokeCap: 'round',
        strokeJoin: 'round'
    },
    text: {
        font: fontStandard,
        fontSize: fontSmallPx,
        fill: secondLevelElementColor
    },
    arc: {
        fill: paletteColor1
    },
    area: {
        fill: paletteColor1,
        line: true,
        opacity: 0.6
    },
    path: {
        stroke: paletteColor1
    },
    rect: {
        fill: paletteColor1
    },
    point: {
        fill: paletteColor1,
        filled: true,
        size: 75
    },
    shape: {
        stroke: paletteColor1
    },
    symbol: {
        fill: paletteColor1,
        strokeWidth: 1.5,
        size: 50
    },
    legend: {
        titleFont: fontStandard,
        titleFontWeight: 'bold',
        titleColor: secondLevelElementColor,
        labelFont: fontStandard,
        labelFontSize: legendFontPx,
        labelColor: secondLevelElementColor,
        symbolType: 'circle',
        symbolSize: 75
    },
    range: {
        category: [
            paletteColor1,
            paletteColor2,
            paletteColor3,
            paletteColor4,
            paletteColor5,
            paletteColor6,
            paletteColor7,
            paletteColor8
        ],
        diverging: divergentPalette,
        heatmap: divergentPalette,
        ordinal: ordinalPalette
    }
};
const defaultFont = 'IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,".sfnstext-regular",sans-serif';
const condensedFont = 'IBM Plex Sans Condensed, system-ui, -apple-system, BlinkMacSystemFont, ".SFNSText-Regular", sans-serif';
const fontWeight = 400;
const TOKENS = {
    textPrimary: {
        g90: '#f4f4f4',
        g100: '#f4f4f4',
        white: '#161616',
        g10: '#161616'
    },
    textSecondary: {
        g90: '#c6c6c6',
        g100: '#c6c6c6',
        white: '#525252',
        g10: '#525252'
    },
    // layer
    layerAccent01: {
        white: '#e0e0e0',
        g10: '#e0e0e0',
        g90: '#525252',
        g100: '#393939'
    },
    // grid
    gridBg: {
        white: '#ffffff',
        g10: '#ffffff',
        g90: '#161616',
        g100: '#161616'
    }
};
const darkCategories = [
    '#8a3ffc',
    '#33b1ff',
    '#007d79',
    '#ff7eb6',
    '#fa4d56',
    '#fff1f1',
    '#6fdc8c',
    '#4589ff',
    '#d12771',
    '#d2a106',
    '#08bdba',
    '#bae6ff',
    '#ba4e00',
    '#d4bbff'
];
const lightCategories = [
    '#6929c4',
    '#1192e8',
    '#005d5d',
    '#9f1853',
    '#fa4d56',
    '#570408',
    '#198038',
    '#002d9c',
    '#ee538b',
    '#b28600',
    '#009d9a',
    '#012749',
    '#8a3800',
    '#a56eff'
];
function genCarbonConfig({ theme, background }) {
    const type = [
        'white',
        'g10'
    ].includes(theme) ? 'light' : 'dark';
    const viewbg = TOKENS.gridBg[theme];
    const titleColor = TOKENS.textPrimary[theme];
    const textColor = TOKENS.textSecondary[theme];
    const category = type === 'dark' ? darkCategories : lightCategories;
    const markColor = type === 'dark' ? '#d4bbff' : '#6929c4';
    return {
        background,
        arc: {
            fill: markColor
        },
        area: {
            fill: markColor
        },
        path: {
            stroke: markColor
        },
        rect: {
            fill: markColor
        },
        shape: {
            stroke: markColor
        },
        symbol: {
            stroke: markColor
        },
        circle: {
            fill: markColor
        },
        view: {
            fill: viewbg,
            stroke: viewbg
        },
        group: {
            fill: viewbg
        },
        title: {
            color: titleColor,
            anchor: 'start',
            dy: -15,
            fontSize: 16,
            font: defaultFont,
            fontWeight: 600
        },
        axis: {
            // Axis labels
            labelColor: textColor,
            labelFontSize: 12,
            labelFont: condensedFont,
            labelFontWeight: fontWeight,
            // Axis titles
            titleColor: titleColor,
            titleFontWeight: 600,
            titleFontSize: 12,
            // MISC
            grid: true,
            gridColor: TOKENS.layerAccent01[theme],
            labelAngle: 0
        },
        axisX: {
            titlePadding: 10
        },
        axisY: {
            titlePadding: 2.5
        },
        style: {
            'guide-label': {
                font: defaultFont,
                fill: textColor,
                fontWeight: fontWeight
            },
            'guide-title': {
                font: defaultFont,
                fill: textColor,
                fontWeight: fontWeight
            }
        },
        range: {
            category,
            diverging: [
                '#750e13',
                '#a2191f',
                '#da1e28',
                '#fa4d56',
                '#ff8389',
                '#ffb3b8',
                '#ffd7d9',
                '#fff1f1',
                '#e5f6ff',
                '#bae6ff',
                '#82cfff',
                '#33b1ff',
                '#1192e8',
                '#0072c3',
                '#00539a',
                '#003a6d'
            ],
            heatmap: [
                '#f6f2ff',
                '#e8daff',
                '#d4bbff',
                '#be95ff',
                '#a56eff',
                '#8a3ffc',
                '#6929c4',
                '#491d8b',
                '#31135e',
                '#1c0f30'
            ]
        }
    };
}
const carbonwhite = genCarbonConfig({
    theme: 'white',
    background: '#ffffff'
});
const carbong10 = genCarbonConfig({
    theme: 'g10',
    background: '#f4f4f4'
});
const carbong90 = genCarbonConfig({
    theme: 'g90',
    background: '#262626'
});
const carbong100 = genCarbonConfig({
    theme: 'g100',
    background: '#161616'
});
const version = pkg.version;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"3nTGd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
/**
 * Create a tooltip handler and register it with the provided view.
 *
 * @param view The Vega view.
 * @param opt Tooltip options.
 */ parcelHelpers.export(exports, "default", ()=>function(view, opt) {
        const handler = new (0, _handler.Handler)(opt);
        view.tooltip(handler.call).run();
        return handler;
    });
var _packageJson = require("../package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
var _handler = require("./Handler");
var _defaults = require("./defaults");
parcelHelpers.exportAll(_defaults, exports);
var _formatValue = require("./formatValue");
parcelHelpers.exportAll(_formatValue, exports);
var _position = require("./position");
parcelHelpers.exportAll(_position, exports);
parcelHelpers.exportAll(_handler, exports);
const version = (0, _packageJsonDefault.default).version;

},{"../package.json":"bIZrd","./Handler":"bPwds","./defaults":"lKfM3","./formatValue":"1hkJ8","./position":"1DNnR","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bIZrd":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"name\":\"vega-tooltip\",\"version\":\"0.22.1\",\"description\":\"A tooltip plugin for Vega-Lite and Vega visualizations.\",\"main\":\"build/vega-tooltip.js\",\"module\":\"build/src/index.js\",\"unpkg\":\"build/vega-tooltip.min.js\",\"jsdelivr\":\"build/vega-tooltip.min.js\",\"typings\":\"build/src/index.d.ts\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/vega/vega-tooltip.git\"},\"keywords\":[\"vega-lite\",\"vega\",\"tooltip\"],\"author\":{\"name\":\"UW Interactive Data Lab\",\"url\":\"https://idl.cs.washington.edu\"},\"collaborators\":[\"Dominik Moritz\",\"Sira Horradarn\",\"Zening Qu\",\"Kanit Wongsuphasawat\",\"Yuri Astrakhan\",\"Jeffrey Heer\"],\"license\":\"BSD-3-Clause\",\"bugs\":{\"url\":\"https://github.com/vega/vega-tooltip/issues\"},\"homepage\":\"https://github.com/vega/vega-tooltip#readme\",\"scripts\":{\"prepare\":\"beemo create-config --silent\",\"tsc:src\":\"tsc -b tsconfig.src.json\",\"build\":\"yarn tsc:src && rollup -c\",\"clean\":\"rm -rf build examples/data && rm -f src/style.ts\",\"copy:data\":\"rsync -r node_modules/vega-datasets/data/* examples/data\",\"copy:build\":\"rsync -r build/* examples/build\",\"deploy:gh\":\"yarn build && yarn copy:build && gh-pages -d examples && yarn clean\",\"prettierbase\":\"beemo prettier 'examples/*.{html,scss,css}'\",\"eslintbase\":\"beemo eslint '{src,test,types}/**/*.ts'\",\"format\":\"yarn eslintbase --fix && yarn prettierbase --write\",\"lint\":\"yarn eslintbase && yarn prettierbase --check\",\"postbuild\":\"terser build/vega-tooltip.js -c -m -o build/vega-tooltip.min.js\",\"prebuild\":\"mkdir -p build && yarn copy:data && ./build-style.sh\",\"prepublishOnly\":\"yarn clean && yarn build\",\"preversion\":\"yarn lint\",\"start\":\"yarn build && concurrently --kill-others -n Server,Typescript,Rollup 'browser-sync start -s -f build examples --serveStatic examples' 'yarn tsc:src -w' 'rollup -c -w'\",\"pretest\":\"./build-style.sh\",\"test\":\"jest\"},\"devDependencies\":{\"@rollup/plugin-commonjs\":\"11.0.2\",\"@rollup/plugin-json\":\"^4.0.2\",\"@rollup/plugin-node-resolve\":\"^7.1.1\",\"@types/jest\":\"^25.1.4\",\"browser-sync\":\"^2.26.7\",\"concurrently\":\"^5.1.0\",\"gh-pages\":\"^2.2.0\",\"jest\":\"^25.1.0\",\"node-sass\":\"^4.13.1\",\"path\":\"^0.12.7\",\"rollup\":\"^2.1.0\",\"terser\":\"^4.6.7\",\"ts-jest\":\"^25.2.1\",\"typescript\":\"^3.8.3\",\"vega-datasets\":\"^1.30.2\",\"vega-lite-dev-config\":\"^0.5.0\",\"vega-typings\":\"^0.14.2\"},\"dependencies\":{\"vega-util\":\"^1.13.1\"},\"beemo\":{\"module\":\"vega-lite-dev-config\",\"drivers\":[\"prettier\",\"eslint\"]},\"jest\":{\"testURL\":\"http://localhost/\",\"transform\":{\"^.+\\\\.tsx?$\":\"ts-jest\"},\"testRegex\":\"(/__tests__/.*|(\\\\.|/)(test|spec))\\\\.(jsx?|tsx?)$\",\"moduleFileExtensions\":[\"ts\",\"tsx\",\"js\",\"jsx\",\"json\",\"node\"],\"testPathIgnorePatterns\":[\"node_modules\",\"<rootDir>/build\",\"src\"]}}");

},{}],"bPwds":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The tooltip handler class.
 */ parcelHelpers.export(exports, "Handler", ()=>Handler);
var _defaults = require("./defaults");
var _formatValue = require("./formatValue");
var _position = require("./position");
class Handler {
    /**
     * Create the tooltip handler and initialize the element and style.
     *
     * @param options Tooltip Options
     */ constructor(options){
        this.options = Object.assign(Object.assign({}, (0, _defaults.DEFAULT_OPTIONS)), options);
        const elementId = this.options.id;
        // bind this to call
        this.call = this.tooltipHandler.bind(this);
        // prepend a default stylesheet for tooltips to the head
        if (!this.options.disableDefaultStyle && !document.getElementById(this.options.styleId)) {
            const style = document.createElement('style');
            style.setAttribute('id', this.options.styleId);
            style.innerHTML = (0, _defaults.createDefaultStyle)(elementId);
            const head = document.head;
            if (head.childNodes.length > 0) head.insertBefore(style, head.childNodes[0]);
            else head.appendChild(style);
        }
        // append a div element that we use as a tooltip unless it already exists
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.el = document.getElementById(elementId);
        if (!this.el) {
            this.el = document.createElement('div');
            this.el.setAttribute('id', elementId);
            this.el.classList.add('vg-tooltip');
            document.body.appendChild(this.el);
        }
    }
    /**
     * The tooltip handler function.
     */ tooltipHandler(handler, event, item, value) {
        // console.log(handler, event, item, value);
        // hide tooltip for null, undefined, or empty string values
        if (value == null || value === '') {
            this.el.classList.remove('visible', `${this.options.theme}-theme`);
            return;
        }
        // set the tooltip content
        this.el.innerHTML = (0, _formatValue.formatValue)(value, this.options.sanitize, this.options.maxDepth);
        // make the tooltip visible
        this.el.classList.add('visible', `${this.options.theme}-theme`);
        const { x, y } = (0, _position.calculatePosition)(event, this.el.getBoundingClientRect(), this.options.offsetX, this.options.offsetY);
        this.el.setAttribute('style', `top: ${y}px; left: ${x}px`);
    }
}

},{"./defaults":"lKfM3","./formatValue":"1hkJ8","./position":"1DNnR","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"lKfM3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_OPTIONS", ()=>DEFAULT_OPTIONS);
/**
 * Escape special HTML characters.
 *
 * @param value A value to convert to string and HTML-escape.
 */ parcelHelpers.export(exports, "escapeHTML", ()=>escapeHTML);
parcelHelpers.export(exports, "createDefaultStyle", ()=>createDefaultStyle);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
const EL_ID = 'vg-tooltip-element';
const DEFAULT_OPTIONS = {
    /**
     * X offset.
     */ offsetX: 10,
    /**
     * Y offset.
     */ offsetY: 10,
    /**
     * ID of the tooltip element.
     */ id: EL_ID,
    /**
     * ID of the tooltip CSS style.
     */ styleId: 'vega-tooltip-style',
    /**
     * The name of the theme. You can use the CSS class called [THEME]-theme to style the tooltips.
     *
     * There are two predefined themes: "light" (default) and "dark".
     */ theme: 'light',
    /**
     * Do not use the default styles provided by Vega Tooltip. If you enable this option, you need to use your own styles. It is not necessary to disable the default style when using a custom theme.
     */ disableDefaultStyle: false,
    /**
     * HTML sanitizer function that removes dangerous HTML to prevent XSS.
     *
     * This should be a function from string to string. You may replace it with a formatter such as a markdown formatter.
     */ sanitize: escapeHTML,
    /**
     * The maximum recursion depth when printing objects in the tooltip.
     */ maxDepth: 2
};
function escapeHTML(value) {
    return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;');
}
function createDefaultStyle(id) {
    // Just in case this id comes from a user, ensure these is no security issues
    if (!/^[A-Za-z]+[-:.\w]*$/.test(id)) throw new Error('Invalid HTML ID');
    return (0, _styleDefault.default).toString().replace(EL_ID, id);
}

},{"./style":"lmBsl","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"lmBsl":[function(require,module,exports,__globalThis) {
// generated with build-style.sh
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = `#vg-tooltip-element {
  visibility: hidden;
  padding: 8px;
  position: fixed;
  z-index: 1000;
  font-family: sans-serif;
  font-size: 11px;
  border-radius: 3px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  /* The default theme is the light theme. */
  background-color: rgba(255, 255, 255, 0.95);
  border: 1px solid #d9d9d9;
  color: black; }
  #vg-tooltip-element.visible {
    visibility: visible; }
  #vg-tooltip-element h2 {
    margin-top: 0;
    margin-bottom: 10px;
    font-size: 13px; }
  #vg-tooltip-element table {
    border-spacing: 0; }
    #vg-tooltip-element table tr {
      border: none; }
      #vg-tooltip-element table tr td {
        overflow: hidden;
        text-overflow: ellipsis;
        padding-top: 2px;
        padding-bottom: 2px; }
        #vg-tooltip-element table tr td.key {
          color: #808080;
          max-width: 150px;
          text-align: right;
          padding-right: 4px; }
        #vg-tooltip-element table tr td.value {
          display: block;
          max-width: 300px;
          max-height: 7em;
          text-align: left; }
  #vg-tooltip-element.dark-theme {
    background-color: rgba(32, 32, 32, 0.9);
    border: 1px solid #f5f5f5;
    color: white; }
    #vg-tooltip-element.dark-theme td.key {
      color: #bfbfbf; }
`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"1hkJ8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Format the value to be shown in the toolip.
 *
 * @param value The value to show in the tooltip.
 * @param valueToHtml Function to convert a single cell value to an HTML string
 */ parcelHelpers.export(exports, "formatValue", ()=>formatValue);
parcelHelpers.export(exports, "replacer", ()=>replacer);
/**
 * Stringify any JS object to valid JSON
 */ parcelHelpers.export(exports, "stringify", ()=>stringify);
var _vegaUtil = require("vega-util");
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function formatValue(value, valueToHtml, maxDepth) {
    if ((0, _vegaUtil.isArray)(value)) return `[${value.map((v)=>valueToHtml((0, _vegaUtil.isString)(v) ? v : stringify(v, maxDepth))).join(', ')}]`;
    if ((0, _vegaUtil.isObject)(value)) {
        let content = '';
        const _a = value, { title } = _a, rest = __rest(_a, [
            "title"
        ]);
        if (title) content += `<h2>${valueToHtml(title)}</h2>`;
        const keys = Object.keys(rest);
        if (keys.length > 0) {
            content += '<table>';
            for (const key of keys){
                let val = rest[key];
                // ignore undefined properties
                if (val === undefined) continue;
                if ((0, _vegaUtil.isObject)(val)) val = stringify(val, maxDepth);
                content += `<tr><td class="key">${valueToHtml(key)}:</td><td class="value">${valueToHtml(val)}</td></tr>`;
            }
            content += `</table>`;
        }
        return content || '{}'; // show empty object if there are no properties
    }
    return valueToHtml(value);
}
function replacer(maxDepth) {
    const stack = [];
    return function(key, value) {
        if (typeof value !== 'object' || value === null) return value;
        const pos = stack.indexOf(this) + 1;
        stack.length = pos;
        if (stack.length > maxDepth) return '[Object]';
        if (stack.indexOf(value) >= 0) return '[Circular]';
        stack.push(value);
        return value;
    };
}
function stringify(obj, maxDepth) {
    return JSON.stringify(obj, replacer(maxDepth));
}

},{"vega-util":"7f6sQ","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"1DNnR":[function(require,module,exports,__globalThis) {
/**
 * Position the tooltip
 *
 * @param event The mouse event.
 * @param tooltipBox
 * @param offsetX Horizontal offset.
 * @param offsetY Vertical offset.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculatePosition", ()=>calculatePosition);
function calculatePosition(event, tooltipBox, offsetX, offsetY) {
    let x = event.clientX + offsetX;
    if (x + tooltipBox.width > window.innerWidth) x = +event.clientX - offsetX - tooltipBox.width;
    let y = event.clientY + offsetY;
    if (y + tooltipBox.height > window.innerHeight) y = +event.clientY - offsetY - tooltipBox.height;
    return {
        x,
        y
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"iJ7ZF":[function(require,module,exports,__globalThis) {
/**
 * Open editor url in a new window, and pass a message.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(window, url, data) {
        const editor = window.open(url);
        const wait = 10000;
        const step = 250;
        // eslint-disable-next-line no-bitwise
        let count = ~~(wait / step);
        function listen(evt) {
            if (evt.source === editor) {
                count = 0;
                window.removeEventListener('message', listen, false);
            }
        }
        window.addEventListener('message', listen, false);
        // send message
        // periodically resend until ack received or timeout
        function send() {
            if (count <= 0) return;
            editor.postMessage(data, '*');
            setTimeout(send, step);
            count -= 1;
        }
        setTimeout(send, step);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"6TpVF":[function(require,module,exports,__globalThis) {
// generated with build-style.sh
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = `.vega-embed {
  position: relative;
  display: inline-block; }
  .vega-embed.has-actions {
    padding-right: 38px; }
  .vega-embed details:not([open]) > :not(summary) {
    display: none !important; }
  .vega-embed summary {
    list-style: none;
    position: absolute;
    top: 0;
    right: 0;
    padding: 6px;
    z-index: 1000;
    background: white;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
    color: #1b1e23;
    border: 1px solid #aaa;
    border-radius: 999px;
    opacity: 0.2;
    transition: opacity 0.4s ease-in;
    outline: none;
    cursor: pointer;
    line-height: 0px; }
    .vega-embed summary::-webkit-details-marker {
      display: none; }
    .vega-embed summary:active {
      box-shadow: #aaa 0px 0px 0px 1px inset; }
    .vega-embed summary svg {
      width: 14px;
      height: 14px; }
  .vega-embed details[open] summary {
    opacity: 0.7; }
  .vega-embed:hover summary,
  .vega-embed:focus summary {
    opacity: 1 !important;
    transition: opacity 0.2s ease; }
  .vega-embed .vega-actions {
    position: absolute;
    z-index: 1001;
    top: 35px;
    right: -9px;
    display: flex;
    flex-direction: column;
    padding-bottom: 8px;
    padding-top: 8px;
    border-radius: 4px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
    border: 1px solid #d9d9d9;
    background: white;
    animation-duration: 0.15s;
    animation-name: scale-in;
    animation-timing-function: cubic-bezier(0.2, 0, 0.13, 1.5);
    text-align: left; }
    .vega-embed .vega-actions a {
      padding: 8px 16px;
      font-family: sans-serif;
      font-size: 14px;
      font-weight: 600;
      white-space: nowrap;
      color: #434a56;
      text-decoration: none; }
      .vega-embed .vega-actions a:hover {
        background-color: #f7f7f9;
        color: black; }
    .vega-embed .vega-actions::before, .vega-embed .vega-actions::after {
      content: "";
      display: inline-block;
      position: absolute; }
    .vega-embed .vega-actions::before {
      left: auto;
      right: 14px;
      top: -16px;
      border: 8px solid #0000;
      border-bottom-color: #d9d9d9; }
    .vega-embed .vega-actions::after {
      left: auto;
      right: 15px;
      top: -14px;
      border: 7px solid #0000;
      border-bottom-color: #fff; }

.vega-embed-wrapper {
  max-width: 100%;
  overflow: scroll;
  padding-right: 14px; }

@keyframes scale-in {
  from {
    opacity: 0;
    transform: scale(0.6); }
  to {
    opacity: 1;
    transform: scale(1); } }
`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bVMGP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isURL", ()=>isURL);
parcelHelpers.export(exports, "mergeDeep", ()=>mergeDeep);
var _vega = require("vega");
// polyfill for IE
if (!String.prototype.startsWith) // eslint-disable-next-line no-extend-native,func-names
String.prototype.startsWith = function(search, pos) {
    return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
};
function isURL(s) {
    return s.startsWith('http://') || s.startsWith('https://') || s.startsWith('//');
}
function mergeDeep(dest, ...src) {
    for (const s of src)deepMerge_(dest, s);
    return dest;
}
function deepMerge_(dest, src) {
    for (const property of Object.keys(src))(0, _vega.writeConfig)(dest, property, src[property], true);
}

},{"vega":"2Jj1D","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hdxEG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isFunction);
function isFunction(functionToCheck) {
    const getType = {};
    return !!functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hdxFq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _vegaEmbed = require("vega-embed");
var _vegaEmbedDefault = parcelHelpers.interopDefault(_vegaEmbed);
var _shallowEqual = require("./utils/shallowEqual");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);
var _getUniqueFieldNames = require("./utils/getUniqueFieldNames");
var _getUniqueFieldNamesDefault = parcelHelpers.interopDefault(_getUniqueFieldNames);
var _constants = require("./constants");
var _addSignalListenersToView = require("./utils/addSignalListenersToView");
var _addSignalListenersToViewDefault = parcelHelpers.interopDefault(_addSignalListenersToView);
var _computeSpecChanges = require("./utils/computeSpecChanges");
var _computeSpecChangesDefault = parcelHelpers.interopDefault(_computeSpecChanges);
var _removeSignalListenersFromView = require("./utils/removeSignalListenersFromView");
var _removeSignalListenersFromViewDefault = parcelHelpers.interopDefault(_removeSignalListenersFromView);
var _combineSpecWithDimension = require("./utils/combineSpecWithDimension");
var _combineSpecWithDimensionDefault = parcelHelpers.interopDefault(_combineSpecWithDimension);
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class VegaEmbed extends (0, _reactDefault.default).PureComponent {
    constructor(){
        super(...arguments);
        _defineProperty(this, "containerRef", /*#__PURE__*/ (0, _reactDefault.default).createRef());
        _defineProperty(this, "resultPromise", void 0);
        _defineProperty(this, "handleError", (error)=>{
            const { onError = (0, _constants.NOOP) } = this.props;
            onError(error, this.containerRef.current); // eslint-disable-next-line no-console
            console.warn(error);
            return undefined;
        });
        _defineProperty(this, "modifyView", (action)=>{
            if (this.resultPromise) this.resultPromise.then((result)=>{
                if (result) action(result.view);
                return true;
            }).catch(this.handleError);
        });
    }
    componentDidMount() {
        this.createView();
    }
    componentDidUpdate(prevProps) {
        const fieldSet = (0, _getUniqueFieldNamesDefault.default)([
            this.props,
            prevProps
        ]);
        fieldSet.delete('className');
        fieldSet.delete('signalListeners');
        fieldSet.delete('spec');
        fieldSet.delete('style');
        fieldSet.delete('width');
        fieldSet.delete('height'); // Only create a new view if necessary
        if (Array.from(fieldSet).some((f)=>this.props[f] !== prevProps[f])) {
            this.clearView();
            this.createView();
        } else {
            const specChanges = (0, _computeSpecChangesDefault.default)((0, _combineSpecWithDimensionDefault.default)(this.props), (0, _combineSpecWithDimensionDefault.default)(prevProps));
            const { signalListeners: newSignalListeners } = this.props;
            const { signalListeners: oldSignalListeners } = prevProps;
            if (specChanges) {
                if (specChanges.isExpensive) {
                    this.clearView();
                    this.createView();
                } else {
                    const areSignalListenersChanged = !(0, _shallowEqualDefault.default)(newSignalListeners, oldSignalListeners);
                    this.modifyView((view)=>{
                        if (specChanges.width !== false) view.width(specChanges.width);
                        if (specChanges.height !== false) view.height(specChanges.height);
                        if (areSignalListenersChanged) {
                            if (oldSignalListeners) (0, _removeSignalListenersFromViewDefault.default)(view, oldSignalListeners);
                            if (newSignalListeners) (0, _addSignalListenersToViewDefault.default)(view, newSignalListeners);
                        }
                        view.run();
                    });
                }
            } else if (!(0, _shallowEqualDefault.default)(newSignalListeners, oldSignalListeners)) this.modifyView((view)=>{
                if (oldSignalListeners) (0, _removeSignalListenersFromViewDefault.default)(view, oldSignalListeners);
                if (newSignalListeners) (0, _addSignalListenersToViewDefault.default)(view, newSignalListeners);
                view.run();
            });
        }
    }
    componentWillUnmount() {
        this.clearView();
    }
    createView() {
        const { spec, onNewView, signalListeners = {}, width, height, ...options } = this.props;
        if (this.containerRef.current) {
            const finalSpec = (0, _combineSpecWithDimensionDefault.default)(this.props);
            this.resultPromise = (0, _vegaEmbedDefault.default)(this.containerRef.current, finalSpec, options).then((result)=>{
                if (result) {
                    const { view } = result;
                    if ((0, _addSignalListenersToViewDefault.default)(view, signalListeners)) view.run();
                }
                return result;
            }).catch(this.handleError);
            if (onNewView) this.modifyView(onNewView);
        }
    }
    clearView() {
        if (this.resultPromise) this.resultPromise.then((result)=>{
            if (result) result.finalize();
        }).catch(this.handleError);
        this.resultPromise = undefined;
        return this;
    }
    render() {
        const { className, style } = this.props; // Create the container Vega draws inside
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            ref: this.containerRef,
            className: className,
            style: style
        });
    }
}
exports.default = VegaEmbed;
_defineProperty(VegaEmbed, "propTypes", {
    className: (0, _propTypesDefault.default).string,
    onError: (0, _propTypesDefault.default).func
});

},{"prop-types":"a6MND","react":"fiCYj","vega-embed":"8VkRm","./utils/shallowEqual":"3mYvm","./utils/getUniqueFieldNames":"bHLU5","./constants":"f1inr","./utils/addSignalListenersToView":"aB4ht","./utils/computeSpecChanges":"5xox5","./utils/removeSignalListenersFromView":"dMfNg","./utils/combineSpecWithDimension":"8bfmf","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"bHLU5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUniqueFieldNames);
function getUniqueFieldNames(objects) {
    const fields = new Set();
    objects.forEach((o)=>{
        Object.keys(o).forEach((field)=>{
            fields.add(field);
        });
    });
    return fields;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"f1inr":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line import/prefer-default-export
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NOOP", ()=>NOOP);
const NOOP = ()=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"aB4ht":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addSignalListenersToView);
function addSignalListenersToView(view, signalListeners) {
    const signalNames = Object.keys(signalListeners);
    signalNames.forEach((signalName)=>{
        try {
            view.addSignalListener(signalName, signalListeners[signalName]);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Cannot add invalid signal listener.', error);
        }
    });
    return signalNames.length > 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"5xox5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeSpecChanges);
var _fastDeepEqual = require("fast-deep-equal");
var _fastDeepEqualDefault = parcelHelpers.interopDefault(_fastDeepEqual);
var _getUniqueFieldNames = require("./getUniqueFieldNames");
var _getUniqueFieldNamesDefault = parcelHelpers.interopDefault(_getUniqueFieldNames);
function computeSpecChanges(newSpec, oldSpec) {
    if (newSpec === oldSpec) return false;
    const changes = {
        width: false,
        height: false,
        isExpensive: false
    };
    const fieldNames = (0, _getUniqueFieldNamesDefault.default)([
        newSpec,
        oldSpec
    ]);
    if (fieldNames.has('width') && (!('width' in newSpec) || !('width' in oldSpec) || newSpec.width !== oldSpec.width)) {
        if ('width' in newSpec && typeof newSpec.width === 'number') changes.width = newSpec.width;
        else changes.isExpensive = true;
    }
    if (fieldNames.has('height') && (!('height' in newSpec) || !('height' in oldSpec) || newSpec.height !== oldSpec.height)) {
        if ('height' in newSpec && typeof newSpec.height === 'number') changes.height = newSpec.height;
        else changes.isExpensive = true;
    } // Delete cheap fields
    fieldNames.delete('width');
    fieldNames.delete('height');
    if ([
        ...fieldNames
    ].some((field)=>!(field in newSpec) || !(field in oldSpec) || !(0, _fastDeepEqualDefault.default)(newSpec[field], oldSpec[field]))) changes.isExpensive = true;
    return changes.width !== false || changes.height !== false || changes.isExpensive ? changes : false;
}

},{"fast-deep-equal":"dE2nd","./getUniqueFieldNames":"bHLU5","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"dE2nd":[function(require,module,exports,__globalThis) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

},{}],"dMfNg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>removeSignalListenersFromView);
function removeSignalListenersFromView(view, signalListeners) {
    const signalNames = Object.keys(signalListeners);
    signalNames.forEach((signalName)=>{
        try {
            view.removeSignalListener(signalName, signalListeners[signalName]);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Cannot remove invalid signal listener.', error);
        }
    });
    return signalNames.length > 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"8bfmf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>combineSpecWithDimension);
function combineSpecWithDimension(props) {
    const { spec, width, height } = props;
    if (typeof width !== 'undefined' && typeof height !== 'undefined') return {
        ...spec,
        width,
        height
    };
    if (typeof width !== 'undefined') return {
        ...spec,
        width
    };
    if (typeof height !== 'undefined') return {
        ...spec,
        height
    };
    return spec;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"hCcdg":[function(require,module,exports,__globalThis) {
/**
 * A filter that skips values that are out of line. The Resource Certification
 * Statistics are append-only files where historically some days contain
 * incorrect values. Mainly these values are close to zero or even zero.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadSource", ()=>loadSource);
const filterAnomalies = (property)=>(records)=>{
        const [result, _] = records.reduce(([acc, last], x)=>{
            const current = x[property];
            if (last === -1) return [
                acc,
                current
            ];
            if (current > last * 2 || current < last * .5) return [
                acc,
                last
            ];
            else return [
                [
                    ...acc,
                    x
                ],
                current
            ];
        }, [
            [],
            -1
        ]);
        return result;
    };
// date certs roas roa-asn roa-v4 roa-v4u roa-v6 roa-v6u
const re = /(\d{4}-\d{2}-\d{2})\t(\d+)\t(\d+)\t(\d+)\t(\d+)\t(\d+)\t(\d+)\t(\d+)(?:\t\d+\t\d+)?/;
const parse = (source)=>(line)=>{
        const match = line.match(re);
        if (match == null) return [];
        return [
            {
                source,
                date: new Date(match[1]),
                certs: parseInt(match[2]),
                roas: parseInt(match[3]),
                "roa-asn": parseInt(match[4]),
                "roa-v4": parseInt(match[5]),
                "roa-v4u": parseInt(match[6]),
                "roa-v6": parseInt(match[7]),
                "roa-v6u": parseInt(match[8])
            }
        ];
    };
async function loadSource(source, url) {
    const response = await fetch(url);
    if (!response.ok) throw `Failed to fetch URL: ${url}`;
    const [_, ...data] = (await response.text()).split(/\r?\n/);
    const records = data.flatMap(parse(source));
    return filterAnomalies("certs")(records);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"27PUe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reduce", ()=>reduce);
parcelHelpers.export(exports, "initState", ()=>initState);
parcelHelpers.export(exports, "Actions", ()=>Actions);
var _supportJs = require("./support.js");
const reduce = (state, action)=>action(state);
const Source = (url)=>({
        url,
        enabled: true
    });
const initState = {
    sources: {
        "AfriNIC": Source("https://lirportal.ripe.net/certification/content/static/statistics/afrinic.tal.txt"),
        "APNIC": Source("https://lirportal.ripe.net/certification/content/static/statistics/apnic.tal.txt"),
        "ARIN": Source("https://lirportal.ripe.net/certification/content/static/statistics/arin.tal.txt"),
        "LACNIC": Source("https://lirportal.ripe.net/certification/content/static/statistics/lacnic.tal.txt"),
        "RIPE NCC": Source("https://lirportal.ripe.net/certification/content/static/statistics/ripencc.tal.txt")
    },
    period: {
        from: null,
        until: null
    },
    loading: false,
    sourceData: {},
    data: []
};
const constant = (x)=>()=>x;
const filterData = (sourceData, sources, { from, until })=>{
    const filters = [
        from != null ? ({ date })=>date >= from : constant(true),
        until != null ? ({ date })=>date <= until : constant(true)
    ];
    const predicate = filters.reduce((filter, acc)=>(x)=>acc(x) && filter(x), constant(true));
    return (0, _supportJs.concat)(Object.entries(sourceData).map(([source, data])=>sources[source].enabled ? data.filter(predicate) : []));
};
const initPeriod = (data)=>{
    return data.reduce((acc, { date })=>({
            from: acc.from < date ? acc.from : date,
            until: acc.until > date ? acc.until : date
        }), {
        from: new Date(),
        until: null
    });
};
const Actions = {
    // Data loading
    loading: (state)=>({
            ...state,
            loading: true
        }),
    sourceDataLoaded: (sourceData)=>(state)=>{
            const data = filterData(sourceData, state.sources, state.period);
            return {
                ...state,
                loading: false,
                sourceData,
                error: null,
                data,
                period: initPeriod(data)
            };
        },
    reportError: (error)=>(state)=>({
                ...state,
                loading: false,
                error
            }),
    toggleSource: (source, value)=>(state)=>{
            const sources = {
                ...state.sources,
                [source]: {
                    ...state.sources[source],
                    enabled: value
                }
            };
            return {
                ...state,
                sources,
                data: filterData(state.sourceData, sources, state.period)
            };
        },
    filterFrom: (from)=>(state)=>{
            const period = {
                ...state.period,
                from
            };
            return {
                ...state,
                period,
                data: filterData(state.sourceData, state.sources, period)
            };
        },
    filterUntil: (until)=>(state)=>{
            const period = {
                ...state.period,
                until
            };
            return {
                ...state,
                period,
                data: filterData(state.sourceData, state.sources, period)
            };
        }
};

},{"./support.js":"baiVm","@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"baiVm":[function(require,module,exports,__globalThis) {
/**
 * Provide some convenience functions.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "merge", ()=>merge);
parcelHelpers.export(exports, "concat", ()=>concat);
parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
const merge = (x, y)=>({
        ...x,
        ...y
    });
const concat = ([x, ...xs])=>x == null ? [] : x.concat(...xs);
const isEmpty = (o)=>{
    if (typeof o !== "object") throw TypeError(`not an object: ${o}`);
    return Object.keys(o).length === 0;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"31Xmp"}],"iQcr7":[function() {},{}]},["kczXu","joCWR"], "joCWR", "parcelRequirec327", {}, "./", "/")

//# sourceMappingURL=certification-stats.90d348dd.js.map
